webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */


/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);



var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

/*  */









// add a raw attr (use this in preTransforms)








// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.

/*  */

/**
 * Cross-platform code generation for component v-model
 */


/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38), __webpack_require__(200).setImmediate))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(34);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(84)('wks');
var uid = __webpack_require__(58);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(293);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(1);
var ctx = __webpack_require__(39);
var hide = __webpack_require__(31);
var has = __webpack_require__(32);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(242), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(158);
var isBuffer = __webpack_require__(334);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(444), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(16);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(446);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(450);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(16);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);


var Schema =
/**
 * Notice: `inTable` and `editable` is true by default
 * @param {object} options - Schema options
 */
function Schema() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$inTable = _ref.inTable,
      inTable = _ref$inTable === undefined ? true : _ref$inTable,
      _ref$editable = _ref.editable,
      editable = _ref$editable === undefined ? true : _ref$editable,
      _ref$asFilter = _ref.asFilter,
      asFilter = _ref$asFilter === undefined ? false : _ref$asFilter,
      _ref$asTabFilter = _ref.asTabFilter,
      asTabFilter = _ref$asTabFilter === undefined ? false : _ref$asTabFilter,
      _ref$sortable = _ref.sortable,
      sortable = _ref$sortable === undefined ? false : _ref$sortable,
      _ref$hide = _ref.hide,
      hide = _ref$hide === undefined ? false : _ref$hide,
      _ref$render = _ref.render,
      render = _ref$render === undefined ? null : _ref$render;

  __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, Schema);

  this.inTable = inTable;
  this.editable = editable;
  this.asFilter = asFilter;
  this.asTabFilter = asTabFilter;
  this.sortable = sortable;
  this.hide = hide;
  this.render = render;
};

/* harmony default export */ __webpack_exports__["a"] = (Schema);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(252);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(254);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(317);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Field;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validate__ = __webpack_require__(453);





/**
 * All we need to generate a form item in edit form
 * Note for param `rules`:
 * - Support boolean, string and custom validation method
 * - Custom validation method must be compatible with `async-validator` library
 * @param {string} label - Field label
 * @param {string} key - Key in resource object
 * @param {various} rules - Validation rules
 * @param {object} on - Event listeners
 * @param {object} options - Other options, please refer to the docs
 */
function Field(label, key, rules) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var on = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  this.label = label;
  this.key = key;

  if (typeof rules === 'boolean' && rules) {
    // required
    this.rule = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, key, [__WEBPACK_IMPORTED_MODULE_3__validate__["a" /* validate */].required(label)]);
  } else if (__WEBPACK_IMPORTED_MODULE_3__validate__["a" /* validate */][rules]) {
    // a validation method
    this.rule = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, key, [__WEBPACK_IMPORTED_MODULE_3__validate__["a" /* validate */][rules](label)]);
  } else if (Array.isArray(rules)) {
    // a set of validation methods
    this.rule = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, key, rules.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_3__validate__["a" /* validate */][item] ? __WEBPACK_IMPORTED_MODULE_3__validate__["a" /* validate */][item](label) : item;
    }));
  } else if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default()(rules)) === 'object') {
    this.rule = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, key, [rules]);
  }

  this.on = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, on);
  this.options = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, options);
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(330);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESOURCE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resourceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VIEW_MAP; });
var RESOURCE_TYPE = {
  MAIN: 'main',
  NESTED: 'nested',
  PARALLEL: 'parallel'

  // todo: rm the following line (compatible with old code)
};var resourceType = RESOURCE_TYPE;

var MODE = {
  EDIT_IN_DIALOG: 1,
  EDIT_IN_NEW_PAGE: 2,
  EDIT_IN_TABLE: 3
};

var VIEW_MAP = {
  LIST: 'list',
  ADD: 'add',
  EDIT: 'edit',
  DETAIL: 'detail'
};

/* harmony default export */ __webpack_exports__["c"] = ({
  RESOURCE_TYPE: RESOURCE_TYPE,
  MODE: MODE,
  VIEW_MAP: VIEW_MAP
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(165);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(219);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(76);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(124);
var toPrimitive = __webpack_require__(80);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentLocale; });
/* unused harmony export format */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return i18n; });
/* unused harmony export setI18nData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return subscribeDataChanging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return unsubscribeDataChanging; });
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__element_locales__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_index__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixin__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_array__ = __webpack_require__(316);












var langs = {};
var componentsCollection = [];
var _Vue = void 0;

var update = function update() {
  var len = componentsCollection.length;
  while (len--) {
    componentsCollection[len] && componentsCollection[len].$forceUpdate();
  }
};
var mergeLangs = function mergeLangs(data) {
  if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    var merged = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var key = _ref2[0];
        var lang = _ref2[1];

        merged[key] = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__lang_index__["a" /* default */][key], lang);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    langs = merged;
  }
};

var currentLocale = localStorage.getItem('sp-locale') || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default()(langs)[0];

var format = function format() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var index = 0;
  return str.replace(/%s/g, function () {
    return index >= params.length ? '%s' : params[index++];
  });
};

var i18n = function i18n(key) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // no json file
  if (langs === {}) {
    return key;
  }
  // assume the first lang is the default lang
  var defaultLangKey = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default()(langs)[0];
  var langKey = localStorage.getItem('sp-locale') || defaultLangKey;
  // missing json file
  if (!langs[langKey] || !langs[defaultLangKey]) {
    return key;
  }
  var defaultLangText = langs[defaultLangKey][key] || key;
  var langText = langs[langKey][key] || defaultLangText;
  return format(langText, params);
};

var setI18nData = function setI18nData(data) {
  mergeLangs(data);
  update();
};

var setLocale = function setLocale(l) {
  currentLocale = l;
  localStorage.setItem('sp-locale', l);
  Object(__WEBPACK_IMPORTED_MODULE_6_element_ui__["locale"])(__WEBPACK_IMPORTED_MODULE_7__element_locales__["a" /* default */][l]);

  var _document$title$split = document.title.split(' - '),
      _document$title$split2 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_document$title$split, 2),
      title = _document$title$split2[0],
      suffix = _document$title$split2[1];

  document.title = suffix || title;

  update();
};

var subscribeDataChanging = function subscribeDataChanging(vm) {
  return componentsCollection.push(vm);
};
var unsubscribeDataChanging = function unsubscribeDataChanging(vm) {
  return Object(__WEBPACK_IMPORTED_MODULE_10__utils_array__["a" /* remove */])(componentsCollection, vm);
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (install.installed) {
    console.warn('already installed.');
    return;
  }
  if (opts.i18n) {
    i18n = opts.i18n;
    return;
  }

  _Vue = Vue;
  install.installed = true;
  Vue.mixin(__WEBPACK_IMPORTED_MODULE_9__mixin__["a" /* default */]);

  mergeLangs(opts.locale);
  Vue.prototype.$i18n = i18n;
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["b"] = ({ install: install });

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(40)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(204).Buffer))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var createDesc = __webpack_require__(47);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(127);
var defined = __webpack_require__(78);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(249), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(372),
    getValue = __webpack_require__(377);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = generateFormItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = generateForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_i18n_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Forms_SpSelect_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_parseDependency__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_parseRules__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_parsePlaceholder__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Forms_SpTableSelect__ = __webpack_require__(433);















var defaultProps = {
  children: 'children',
  label: 'label'
};

function getProps(field, model, inTable, state, viewName) {
  /* TODO: finish this */
  switch (field.type) {
    case 'tree':
      {
        var data = typeof field.items === 'function' ? field.items(state) : field.items;
        if (field.subType === 'check-tree') {
          data = [{
            id: '@ALL',
            label: Object(__WEBPACK_IMPORTED_MODULE_8__helper_i18n_index__["c" /* i18n */])('Select / Unselect All'),
            children: data
          }];
        }
        return {
          data: data,
          multiple: field.multiple,
          expandOnClickNode: field.subType !== 'check-tree',
          showCheckbox: true,
          defaultExpandAll: true,
          nodeKey: 'id'
        };
      }
    default:
      // 支持计算属性
      var props = __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, field.options.props);
      for (var key in props) {
        if (typeof props[key] === 'function') {
          props[key] = props[key].call(model, viewName);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({
        items: field.items,
        multiple: field.multiple,
        value: model[field.key],
        type: field.subType,
        highlightCurrent: true,
        size: inTable ? 'medium' : 'mini'
      }, props || defaultProps, Object(__WEBPACK_IMPORTED_MODULE_12__utils_parsePlaceholder__["a" /* default */])(field.placeholder), {
        beforeCreateOptions: field.options.beforeCreateOptions,
        getTableList: field.options.getTableList,
        filterSelectable: field.options.filterSelectable
      });
  }
}

function generateFormItem(h, field, model) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var on = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var inTable = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var affected = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var schemaHash = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var viewName = arguments[8];

  var component = '';
  // special judge for sp-select
  // TODO: other HOCs
  if (field.type === 'select') {
    component = 'sp-' + field.type;
  } else if (field.type === 'tableSelect') {
    component = __WEBPACK_IMPORTED_MODULE_13__Forms_SpTableSelect__["a" /* default */];
  } else {
    component = 'el-' + field.type;
  }
  return h(
    'el-form-item',
    {
      attrs: { prop: field.key, label: inTable ? Object(__WEBPACK_IMPORTED_MODULE_8__helper_i18n_index__["c" /* i18n */])(field.label) : null }
    },
    [h(component, {
      ref: field.key,
      class: field.subType ? 'sp-' + field.subType : '',
      props: getProps(field, model, inTable, state, viewName),
      on: __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, on, {
        input: function input(val) {
          // change model
          model[field.key] = val;
          // original on
          if (typeof on.input === 'function') {
            on.input(val);
          }
          // dependency
          if (affected[field.key]) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(affected[field.key]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var d = _step.value;

                var deps = [].concat(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(schemaHash[d].options.deps));
                var handler = deps.pop();
                var values = deps.map(function (key) {
                  return model[key];
                });
                model[d] = handler.apply(schemaHash[d], values);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        },
        selectionChange: function selectionChange(val) {
          return on.selectionChange && on.selectionChange(val);
        },
        check: function check(node, _ref) {
          var checkedKeys = _ref.checkedKeys;
          return on.check && on.check(node, checkedKeys);
        }
      })
    })]
  );
}

function generateForm(h, options, model, rules) {
  var children = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var slots = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  return h('el-form', {
    ref: 'form',
    props: __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, options || {}, {
      model: model,
      rules: rules,
      inline: options ? Boolean(options.inline) : false,
      disabled: options ? Boolean(options.disabled) : false
    })
  }, [].concat(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(children), __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(slots)));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormTpl',
  components: { SpSelect: __WEBPACK_IMPORTED_MODULE_9__Forms_SpSelect_vue__["a" /* default */] },
  render: function render(h) {
    var _this = this;

    var nodes = this.fields.map(function (field) {
      return generateFormItem(h, field, _this.model, _this.$store.state, _this.parseEventListeners(field), true, _this.dependency, _this.schemaHash, _this.viewName);
    });
    var children = [];
    if (!this.options.noValidate && this.fields.some(function (field) {
      return field.options.group;
    })) {
      // TODO: group all schemas
      var groups = {};
      var defaultGroup = [];
      this.fields.forEach(function (field, index) {
        var node = nodes[index];
        var group = field.options.group;
        if (group) {
          if (groups[group]) {
            groups[group].push(node);
          } else {
            groups[group] = [node];
          }
        } else {
          defaultGroup.push(node);
        }
      });
      groups['Other'] = defaultGroup;
      children = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            label = _ref3[0],
            nodes = _ref3[1];

        return h('fieldset', [h('legend', [_this.$i18n(label)]), h(
          'div',
          { 'class': 'sp-form-table' },
          [nodes]
        )]);
      });
    } else {
      children = nodes;
    }
    return generateForm(h, this.options, this.model, this.parsedRules, children, this.$slots.default);
  },

  methods: {
    parseEventListeners: function parseEventListeners(_ref4) {
      var _this2 = this;

      var type = _ref4.type,
          key = _ref4.key,
          on = _ref4.on,
          options = _ref4.options;

      this.parsedOn[key] = this.parsedOn[key] || {};
      var parsedOn = this.parsedOn[key];
      // parse normal actions and bind `this`
      for (var listener in on) {
        if (on[listener] === 'submit') {
          // FIXME: nativeOn is not defined
          parsedOn[listener] = parsedOn[listener] || this.on.nativeOn.click.bind(this);
        } else if (typeof on[listener] === 'function') {
          parsedOn[listener] = parsedOn[listener] || on[listener].bind(this);
        }
      }
      // special judge for el-tree's onCheck
      if (type === 'tree') {
        var t = on.check;
        parsedOn.check = function (currentNode, checkedKeys) {
          t && t.call(_this2, currentNode, checkedKeys);
          _this2.model[key] = checkedKeys;
        };
      }
      // special judge for table's onCheck
      if (type === 'tableSelect') {
        var _t = on.selectionChange;
        parsedOn.selectionChange = function (rows) {
          _t && _t.call(_this2, rows);
          _this2.model[key] = rows;
        };
      }
      return this.parsedOn[key];
    }
  },
  props: {
    form: Object,
    // TODO: anyway to avoid changing props directly?
    model: {
      type: Object,
      required: true
    },
    fields: Array,
    rules: Object,
    options: Object
  },
  data: function data() {
    return {
      dependency: Object(__WEBPACK_IMPORTED_MODULE_10__utils_parseDependency__["a" /* default */])(this.fields),
      parsedRules: Object(__WEBPACK_IMPORTED_MODULE_11__utils_parseRules__["a" /* default */])(this),
      parsedOn: {}
    };
  },

  computed: {
    schemaHash: function schemaHash() {
      return this.fields.reduce(function (prev, cur) {
        return __WEBPACK_IMPORTED_MODULE_6__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, prev, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, cur.key, cur));
      }, {});
    },
    viewName: function viewName() {
      return this.$route.params.view || 'list';
    }
  },
  created: function created() {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(this.fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var field = _step2.value;

        if (typeof this.model[field.key] === 'undefined') {
          if (field.type === 'tree') {
            this.$set(this.model, field.key, []);
          } else {
            this.$set(this.model, field.key, field.options.defaultValue);
          }
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },

  watch: {
    // checked keys for el-tree is not responsive
    model: function model(val) {
      var _this3 = this;

      this.fields && this.fields.forEach(function (field) {
        if (field.type === 'tree') {
          _this3.$refs[field.key].setCheckedKeys(val[field.key] || []);
        }
      });
    }
  },
  mounted: function mounted() {
    this.form && __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()(this.form, this.$refs.form);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(57);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(126);
var enumBugKeys = __webpack_require__(85);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(str) {
  return str[0].toUpperCase() + str.substr(1);
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(222)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(123)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(78);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(239);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(10);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SchemaDatetime__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchemaTextarea__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchemaNumber__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SchemaSelect__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchemaMultiSelect__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SchemaInput__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchemaHidden__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SchemaDatetimeRange__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SchemaTree__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SchemaCheckTree__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SchemaTableSelect__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Datetime", function() { return __WEBPACK_IMPORTED_MODULE_0__SchemaDatetime__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Textarea", function() { return __WEBPACK_IMPORTED_MODULE_1__SchemaTextarea__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Number", function() { return __WEBPACK_IMPORTED_MODULE_2__SchemaNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_3__SchemaSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSelect", function() { return __WEBPACK_IMPORTED_MODULE_4__SchemaMultiSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_5__SchemaInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hidden", function() { return __WEBPACK_IMPORTED_MODULE_6__SchemaHidden__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatetimeRange", function() { return __WEBPACK_IMPORTED_MODULE_7__SchemaDatetimeRange__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tree", function() { return __WEBPACK_IMPORTED_MODULE_8__SchemaTree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CheckTree", function() { return __WEBPACK_IMPORTED_MODULE_9__SchemaCheckTree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableSelect", function() { return __WEBPACK_IMPORTED_MODULE_10__SchemaTableSelect__["a"]; });














/* harmony default export */ __webpack_exports__["default"] = ({
  Datetime: __WEBPACK_IMPORTED_MODULE_0__SchemaDatetime__["a" /* default */],
  Textarea: __WEBPACK_IMPORTED_MODULE_1__SchemaTextarea__["a" /* default */],
  Number: __WEBPACK_IMPORTED_MODULE_2__SchemaNumber__["a" /* default */],
  Select: __WEBPACK_IMPORTED_MODULE_3__SchemaSelect__["a" /* default */],
  MultiSelect: __WEBPACK_IMPORTED_MODULE_4__SchemaMultiSelect__["a" /* default */],
  Input: __WEBPACK_IMPORTED_MODULE_5__SchemaInput__["a" /* default */],
  Hidden: __WEBPACK_IMPORTED_MODULE_6__SchemaHidden__["a" /* default */],
  DatetimeRange: __WEBPACK_IMPORTED_MODULE_7__SchemaDatetimeRange__["a" /* default */],
  Tree: __WEBPACK_IMPORTED_MODULE_8__SchemaTree__["a" /* default */],
  CheckTree: __WEBPACK_IMPORTED_MODULE_9__SchemaCheckTree__["a" /* default */],
  TableSelect: __WEBPACK_IMPORTED_MODULE_10__SchemaTableSelect__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(32);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(227);
var global = __webpack_require__(8);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(41);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(247), __esModule: true };

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_string__ = __webpack_require__(44);






var Module = function Module(name, operations) {
  var _state, _mutations, _actions;

  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, Module);

  var resourceName = Object(__WEBPACK_IMPORTED_MODULE_4__utils_string__["a" /* capitalize */])(name);
  this.state = (_state = {}, __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_state, name + 'List', {
    data: [],
    total: 0
  }), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_state, '' + name, {}), _state);

  this.mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_mutations, 'set' + resourceName + 'List', function undefined(state, data) {
    state[name + 'List'] = data;
  }), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_mutations, 'set' + resourceName, function undefined(state, data) {
    state[name] = data;
  }), _mutations);

  this.actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_actions, 'load' + resourceName + 'List', function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, params) {
      var commit = _ref.commit;
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return operations.list(params);

            case 2:
              resp = _context.sent;

              commit('set' + resourceName + 'List', {
                data: resp.data.list ? resp.data.list : resp.data[name + '_list'],
                total: resp.data.total
              });
              return _context.abrupt('return', resp.data.list ? resp.data.list : resp.data[name + '_list']);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function undefined(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return undefined;
  }()), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_actions, 'add' + resourceName, function undefined(_ref3, data) {
    var commit = _ref3.commit;

    return operations.add(data);
  }), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_actions, 'load' + resourceName, function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, id) {
      var commit = _ref4.commit;
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return operations.one(id);

            case 2:
              resp = _context2.sent;

              // DEPRECATED: delete resp.data.list[0] after new API release
              commit('set' + resourceName, Array.isArray(resp.data.list) && resp.data.list.length > 0 ? resp.data.list[0] : resp.data);
              return _context2.abrupt('return', resp.data);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function undefined(_x3, _x4) {
      return _ref5.apply(this, arguments);
    }

    return undefined;
  }()), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_actions, 'update' + resourceName, function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, data) {
      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return operations.update(data);

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function undefined(_x5, _x6) {
      return _ref7.apply(this, arguments);
    }

    return undefined;
  }()), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_actions, 'delete' + resourceName, function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8, data) {
      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return operations.delete(data);

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function undefined(_x7, _x8) {
      return _ref9.apply(this, arguments);
    }

    return undefined;
  }()), _actions);
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);



/**
 * Created by fjywan on 2018/3/19.
 */
var Api = function Api(request) {
  var urls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, Api);

  this.list = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    params.count = params.count || 10;
    return request.get(urls.list, { params: params });
  };
  this.one = function (id) {
    var query = {
      params: {}
    };
    if (id && (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default()(id)) === 'object') {
      query.params = id;
    } else {
      query.params.id = id;
    }
    return request.get(urls.one, query);
  };
  this.add = function (data) {
    return request.post(urls.add, data);
  };
  this.update = function (data) {
    return request.post(urls.update, data);
  };
  this.delete = function (data) {
    return request.post(urls.delete, data);
  };
  this.export = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return request.post(urls.export, params);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseURL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);

/**
 * Created by fjywan on 2018/3/13.
 */



var baseURL = "https://spx.test.shopee.co.id";

var request = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: baseURL,
  withCredentials: true
});

request.interceptors.response.use(function (res) {
  if (res.data.retcode === -100) {
    location.href = baseURL + '/api/login/' + '?redirect=' + encodeURI(location.href);
  } else if (res.data.retcode) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message.error(res.data.message);
  }
  return res.data;
}, function (error) {
  if (error.request && error.request.status === 401) {
    location.href = baseURL + '/api/login/' + '?redirect=' + encodeURI(location.href);
    return;
  }
  return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ViewFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_mixins_matchedCompoents__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ParallelListView__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListView_index__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NestedListView__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_decorateViewConfigs__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Tabs__ = __webpack_require__(197);



/**
 * ListView 的对外函数
 *
 * 主资源交给 ListViewFactory
 * 嵌套资源交给 NestedListViewFactory
 * 平行资源交给 ParallelListViewFactory
 *
 * 三个类的返回值均为 key 到具体组件的映射关系
 * 组件的类型有：list、add、edit、detail
 * 对于主资源，组件的 key 为 list、add、edit、detail
 * 对于嵌套资源和平行资源，组件的 key 为 name、nameAdd、nameEdit、nameDetail
 *
 * 使用 matchedComponentsMixin 来根据路由向页面中推入各种组件
 *
 * @constructor
 * @param {object} configs - VM configs
 */









function ViewFactory(configs) {
  Object(__WEBPACK_IMPORTED_MODULE_7__utils_decorateViewConfigs__["a" /* default */])(configs);
  return {
    name: 'BaseView',
    data: function data() {
      return {
        viewInfo: {
          name: configs.data.name,
          hiddenKeys: [configs].concat(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(configs.nestedResource || []), __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(configs.parallelResource || [])).reduce(function (prev, cur) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(cur.schema), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var schema = _step.value;

                if (schema.type === 'hidden') {
                  //TODO: label 和 key 都要存下
                  if (prev[cur.data.name]) {
                    prev[cur.data.name].push(schema.key);
                  } else {
                    prev[cur.data.name] = [schema.key];
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            return prev;
          }, {})
        }
      };
    },

    methods: {
      switchViewMode: function switchViewMode(mode, data) {
        __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].current(this, mode, data, this.$router, this.$route);
      },
      openSubPage: function openSubPage(name, mode, data) {
        __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].into(this, name, mode, data, this.$router, this.$route);
      },
      closeSubPage: function closeSubPage() {
        __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].back(this, this.$router, this.$route);
      }
    },
    created: function created() {
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$on('switchViewMode', this.switchViewMode);
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$on('openSubPage', this.openSubPage);
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$on('closeSubPage', this.closeSubPage);
    },
    beforeDestroy: function beforeDestroy() {
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$off('switchViewMode', this.switchViewMode);
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$off('openSubPage', this.openSubPage);
      __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$off('closeSubPage', this.closeSubPage);
    },
    render: function render(h) {
      Object(__WEBPACK_IMPORTED_MODULE_3__common_mixins_matchedCompoents__["a" /* matchedComponentsMixin */])(this, configs);
      var allComponents = {};

      // fix error: check type before use length
      if (Array.isArray(configs.parallelResource) && configs.parallelResource.length) {
        allComponents = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, allComponents, Object(__WEBPACK_IMPORTED_MODULE_4__ParallelListView__["a" /* default */])(configs.parallelResource));
      }

      if (Array.isArray(configs.nestedResource) && configs.nestedResource.length) {
        allComponents = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, allComponents, Object(__WEBPACK_IMPORTED_MODULE_6__NestedListView__["a" /* default */])(configs.nestedResource));
      }

      var nestedViews = configs.nestedResource.map(function (r) {
        return allComponents[r.data.name];
      });
      allComponents = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, allComponents, Object(__WEBPACK_IMPORTED_MODULE_5__ListView_index__["a" /* default */])(configs, nestedViews));

      var tabsChildren = [];
      if (configs.tabs.length) {
        tabsChildren.push(h(__WEBPACK_IMPORTED_MODULE_10__components_Tabs__["a" /* default */], {
          attrs: { tabs: configs.tabs }
        }));
      }
      var children = this.matchedComponents.map(function (item) {
        return h(allComponents[item]);
      });
      return h('div', [tabsChildren.length > 0 ? h(
        'div',
        { 'class': 'sp-tabs' },
        [tabsChildren]
      ) : null, h('div', [children])]);
    }
  };
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(362),
    listCacheDelete = __webpack_require__(363),
    listCacheGet = __webpack_require__(364),
    listCacheHas = __webpack_require__(365),
    listCacheSet = __webpack_require__(366);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(163);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(104),
    getRawTag = __webpack_require__(373),
    objectToString = __webpack_require__(374);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(387);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(167),
    baseAssignValue = __webpack_require__(168);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    hiddenSchema: function hiddenSchema() {
      return this.schema.filter(function (item) {
        return item.type === 'hidden';
      });
    },
    tabSchema: function tabSchema() {
      return this.schema.filter(function (item) {
        return item.asTabFilter;
      });
    },
    editableSchema: function editableSchema() {
      var _this = this;

      return this.schema.filter(function (item) {
        if (item.editable) {
          if (item.hide) {
            if (typeof item.hide === 'boolean') {
              return !item.hide;
            }
            if (typeof item.hide === 'string' && item.hide === _this.searchFormData[_this.tableSchema[0].key]) {
              return false;
            }
            if (Array.isArray(item.hide) && typeof item.hide[0] === 'string' && _this.searchFformData[_this.tableSchema[0].key] in item.hide) {
              return false;
            }
            if (typeof item.hide === 'function') {
              return !item.hide(_this.appName);
            }
          }
          return true;
        }
        return false;
      });
    },
    filterSchema: function filterSchema() {
      var _this2 = this;

      return this.schema.filter(function (item) {
        if (item.asFilter && !item.asTabFilter) {
          if (item.hide) {
            if (typeof item.hide === 'boolean') {
              return !item.hide;
            }
            if (typeof item.hide === 'string' && item.hide === _this2.searchFormData[_this2.tableSchema[0].key]) {
              return false;
            }
            if (Array.isArray(item.hide) && typeof item.hide[0] === 'string' && _this2.searchFformData[_this2.tableSchema[0].key] in item.hide) {
              return false;
            }
            if (typeof item.hide === 'function') {
              return !item.hide(_this2.searchFormData);
            }
          }
          return true;
        }
        return false;
      });
    },
    tableSchema: function tableSchema() {
      var o = this.schema.filter(function (item) {
        return item.type !== 'hidden';
      }).reduce(function (prev, cur) {
        return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, prev, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, cur.key, cur));
      }, {});
      return this.pickedColumns.filter(function (t) {
        return t.visible;
      }).map(function (t) {
        return o[t.id];
      });
    }
  };
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__ = __webpack_require__(72);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditPage',
  render: function render(h) {
    var _this = this;

    return h(
      'div',
      { 'class': 'sp-card' },
      [h(__WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__["a" /* default */], {
        'class': 'sp-edit-page-form',
        style: { minWidth: 300 },
        attrs: { model: this.formData,
          fields: this.editableSchema,
          options: { disabled: this.isDetail }
        }
      }), this.nestedList && this.nestedList.map(function (v) {
        return h(v);
      }), this.isDetail ? h(
        'div',
        { style: { marginTop: 'var(--card-spacing)' } },
        [h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                _this.cancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Back')]
        )]
      ) : h(
        'div',
        { style: { marginTop: 'var(--card-spacing)' } },
        [h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                _this.cancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Cancel')]
        ), h(
          'el-button',
          __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { type: 'primary' }
          }, {
            on: {
              'click': function click($event) {
                for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  attrs[_key3 - 1] = arguments[_key3];
                }

                _this.confirm.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Confirm')]
        )]
      )]
    );
  },
  data: function data() {
    return {
      cancelText: this.$i18n('Confirm Cancel ?'),
      confirmText: this.$i18n('Confirm ?'),
      confirming: false,
      defaultFormData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__["a" /* default */])(), {
    formData: function formData() {
      return this.model || this.defaultFormData;
    }
  }),
  props: ['schema', 'data', 'model', 'isDetail', 'nestedList', 'close'],
  methods: {
    reset: function reset() {
      var _this2 = this;

      this.filterSchema.forEach(function (item) {
        _this2.defaultFormData[item.key] = item.options.defaultValue;
      });
    },
    cancel: function cancel() {
      var _this3 = this;

      this.$confirm(this.cancelText).then(function () {
        return _this3.close();
      }).catch(function () {});
    },
    confirm: function confirm() {
      var _this4 = this;

      if (this.confirming) return;
      this.confirming = true;
      var resourceName = this.data.resourceName.toLocaleLowerCase() + '_id';
      this.formData[resourceName] = this.formData[resourceName] || this.formData['id'];
      this.$confirm(this.confirmText).then(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this4.model) {
                  _context.next = 6;
                  break;
                }

                if (!(_this4.data && _this4.data.update)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this4.data.update(_this4.$store, _this4.formData);

              case 4:
                _context.next = 9;
                break;

              case 6:
                if (!(_this4.data && _this4.data.add)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this4.data.add(_this4.$store, _this4.formData);

              case 9:
                _this4.close();
                _this4.confirming = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))).catch(function () {
        return _this4.confirming = false;
      });
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Descriptor__ = __webpack_require__(465);






var CollectionDescriptor = function (_Descriptor) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(CollectionDescriptor, _Descriptor);

  /**
   * Define how to interact with backend and where to get local data
   * Local data must be set when performing actions.all or actions.one
   * @param {string} name - Resource name
   * @param {object} actions - Actions with backend
   * @param {object} local - Local data provider
   */
  function CollectionDescriptor(name, actions, local) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, CollectionDescriptor);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CollectionDescriptor.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(CollectionDescriptor)).call(this, name));

    if (actions) {
      _this.fetch.list = actions.list || _this.fetch.list;
      _this.fetch.one = actions.one || _this.fetch.one;
      _this.update = actions.update || _this.update;
      _this.add = actions.add || _this.add;
      _this.delete = actions.delete || _this.delete;
    }
    if (local) {
      _this.provider.list = local.list || _this.provider.list;
      _this.provider.one = local.one || _this.provider.one;
    }
    return _this;
  }

  return CollectionDescriptor;
}(__WEBPACK_IMPORTED_MODULE_4__Descriptor__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CollectionDescriptor);

/***/ }),
/* 75 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(19);
var dPs = __webpack_require__(224);
var enumBugKeys = __webpack_require__(85);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(79)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(128).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(77);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(84)('keys');
var uid = __webpack_require__(58);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(48);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(86);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(41);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(57);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(56);
var wksExt = __webpack_require__(90);
var defineProperty = __webpack_require__(25).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;

var _zhCN = __webpack_require__(143);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _deepmerge = __webpack_require__(263);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _format = __webpack_require__(264);

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 112);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(113);


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _input = __webpack_require__(114);

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_input2.default.install = function (Vue) {
  Vue.component(_input2.default.name, _input2.default);
};

exports.default = _input2.default;

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddb4a56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__(117);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddb4a56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(8);

var _migrating2 = _interopRequireDefault(_migrating);

var _calcTextareaHeight = __webpack_require__(116);

var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);

var _merge = __webpack_require__(9);

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [_emitter2.default, _migrating2.default],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
      textareaCalcStyle: {},
      prefixOffset: null,
      suffixOffset: null,
      hovering: false,
      focused: false,
      isOnComposition: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return (0, _merge2.default)({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    isGroup: function isGroup() {
      return this.$slots.prepend || this.$slots.append;
    },
    showClear: function showClear() {
      return this.clearable && !this.disabled && this.currentValue !== '' && (this.focused || this.hovering);
    }
  },

  watch: {
    'value': function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },

  methods: {
    focus: function focus() {
      (this.$refs.input || this.$refs.textarea).focus();
    },
    blur: function blur() {
      (this.$refs.input || this.$refs.textarea).blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    select: function select() {
      (this.$refs.input || this.$refs.textarea).select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: (0, _calcTextareaHeight2.default)(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleComposition: function handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleInput(event);
      } else {
        var text = event.target.value;
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);
      }
    },
    handleInput: function handleInput(event) {
      if (this.isOnComposition) return;
      var value = event.target.value;
      this.$emit('input', value);
      this.setCurrentValue(value);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;
      this.$nextTick(function (_) {
        _this.resizeTextarea();
      });
      this.currentValue = value;
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    },
    calcIconOffset: function calcIconOffset(place) {
      var pendantMap = {
        'suf': 'append',
        'pre': 'prepend'
      };

      var pendant = pendantMap[place];

      if (this.$slots[pendant]) {
        return { transform: 'translateX(' + (place === 'suf' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)' };
      }
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
      this.setCurrentValue('');
      this.focus();
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.resizeTextarea();
    if (this.isGroup) {
      this.prefixOffset = this.calcIconOffset('pre');
      this.suffixOffset = this.calcIconOffset('suf');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calcTextareaHeight;
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
};

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
  _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
  {
    'is-disabled': _vm.inputDisabled,
    'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
    'el-input-group--append': _vm.$slots.append,
    'el-input-group--prepend': _vm.$slots.prepend,
    'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
    'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon
  }
  ],on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[(_vm.type !== 'textarea')?[(_vm.$slots.prepend)?_c('div',{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"disabled":_vm.inputDisabled,"autocomplete":_vm.autoComplete,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'input',_vm.$attrs,false)):_vm._e(),(_vm.$slots.prefix || _vm.prefixIcon)?_c('span',{staticClass:"el-input__prefix",style:(_vm.prefixOffset)},[_vm._t("prefix"),(_vm.prefixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),(_vm.$slots.suffix || _vm.suffixIcon || _vm.showClear || _vm.validateState && _vm.needStatusIcon)?_c('span',{staticClass:"el-input__suffix",style:(_vm.suffixOffset)},[_c('span',{staticClass:"el-input__suffix-inner"},[(!_vm.showClear)?[_vm._t("suffix"),(_vm.suffixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_c('i',{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{"click":_vm.clear}})],2),(_vm.validateState)?_c('i',{staticClass:"el-input__icon",class:['el-input__validateIcon', _vm.validateIcon]}):_vm._e()]):_vm._e(),(_vm.$slots.append)?_c('div',{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),attrs:{"tabindex":_vm.tabindex,"disabled":_vm.inputDisabled,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'textarea',_vm.$attrs,false))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = __webpack_require__(94);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(144);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(95);

/***/ })

/******/ });

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _popup = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(266);
var stop = function stop(e) {
  return e.stopPropagation();
};

/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */
exports.default = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    transition: String,
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },

  data: function data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },


  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },

    showPopper: function showPopper(val) {
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },

  methods: {
    createPopper: function createPopper() {
      var _this = this;

      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      var options = this.popperOptions;
      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(function (_) {
        _this.$emit('created', _this);
        _this.resetTransformOrigin();
        _this.$nextTick(_this.updatePopper);
      });
      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }
      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },
    updatePopper: function updatePopper() {
      var popperJS = this.popperJS;
      if (popperJS) {
        popperJS.update();
        if (popperJS._popper) {
          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
        }
      } else {
        this.createPopper();
      }
    },
    doDestroy: function doDestroy(forceDestroy) {
      /* istanbul ignore if */
      if (!this.popperJS || this.showPopper && !forceDestroy) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },
    destroyPopper: function destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },
    resetTransformOrigin: function resetTransformOrigin() {
      if (!this.transformOrigin) return;
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
    },
    appendArrow: function appendArrow(element) {
      var hash = void 0;
      if (this.appended) {
        return;
      }

      this.appended = true;

      for (var item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      var arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }
      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.doDestroy(true);
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },


  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollBarWidth = void 0;

;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(147);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  atBegin       Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function ( delay, atBegin, callback ) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.removeResizeListener = exports.addResizeListener = undefined;

var _resizeObserverPolyfill = __webpack_require__(269);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var resizeHandler = function resizeHandler(entries) {
  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var entry = _ref;

    var listeners = entry.target.__resizeListeners__ || [];
    if (listeners.length) {
      listeners.forEach(function (fn) {
        fn();
      });
    }
  }
};

/* istanbul ignore next */
var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn);
};

/* istanbul ignore next */
var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(11);
var normalizeHeaderName = __webpack_require__(336);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(159);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(159);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)))

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormTpl__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_parseRules__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__column_edit_modal__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FormTpl_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__add_embedAdd__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_mapSchemas__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_params__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_vnode__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_dataParse__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helper_permission__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Forms_SpSelect_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_eventHub__ = __webpack_require__(45);























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'List',
  components: { SpSelect: __WEBPACK_IMPORTED_MODULE_19__components_Forms_SpSelect_vue__["a" /* default */] },
  render: function render(h) {
    var _this = this;

    var searchChildren = [];
    if (this.tabSchema.length === 1) {
      var items = this.tabSchema[0].items;

      if (typeof items === 'function') {
        items = items(this.$store.state);
      }
      searchChildren.push(h(
        'el-tabs',
        __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
          attrs: {
            value: this.searchFormData[this.tabSchema[0].key]
          }
        }, {
          on: {
            'input': function input($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              (function (val) {
                return _this.searchFormData[_this.tabSchema[0].key] = val;
              }).apply(undefined, [$event].concat(attrs));
            },
            'tab-click': function tabClick($event) {
              for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                attrs[_key2 - 1] = arguments[_key2];
              }

              _this.onTabSwitch.apply(_this, [$event].concat(attrs));
            }
          }
        }]),
        [items.map(function (option) {
          return h('el-tab-pane', {
            attrs: {
              label: _this.$i18n(option.label),
              name: String(option.value)
            }
          });
        })]
      ));
    }
    if (this.filterSchema.length) {
      searchChildren.push(h(
        __WEBPACK_IMPORTED_MODULE_11__components_FormTpl_index__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
          attrs: {
            model: this.searchFormData,
            fields: this.filterSchema,
            options: { inline: true, noValidate: true }
          }
        }, {
          on: {
            'searchForm': function searchForm($event) {
              for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                attrs[_key3 - 1] = arguments[_key3];
              }

              _this.onSearch.apply(_this, [$event].concat(attrs));
            }
          }
        }]),
        [h('el-form-item', [h(
          'el-button',
          __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              nativeType: 'reset'
            }
          }, {
            on: {
              'click': function click($event) {
                for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                  attrs[_key4 - 1] = arguments[_key4];
                }

                _this.onReset.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Reset')]
        ), h(
          'el-button',
          __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              type: 'primary',
              nativeType: 'submit'
            }
          }, {
            on: {
              'click': function click($event) {
                for (var _len5 = arguments.length, attrs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  attrs[_key5 - 1] = arguments[_key5];
                }

                _this.onSearch.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Search')]
        )])]
      ));
    }
    if (this.$slots.customForm) {
      searchChildren.push.apply(searchChildren, __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.$slots.customForm));
    }

    var btnsChildren = [];
    if (!this.options || !this.options.hideCreateButton) {
      btnsChildren.push(h(
        'el-button',
        __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
          attrs: { type: 'primary' }
        }, {
          on: {
            'click': function click($event) {
              for (var _len6 = arguments.length, attrs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                attrs[_key6 - 1] = arguments[_key6];
              }

              _this.addHandler.apply(_this, [$event].concat(attrs));
            }
          }
        }]),
        [this.$i18n('Create ' + this.data.resourceName)]
      ));
    }
    if (this.hooks && Array.isArray(this.hooks)) {
      btnsChildren.push.apply(btnsChildren, __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.hooks.map(function (hook) {
        var options = hook.options || {};
        if (options.checkPerm && !Object(__WEBPACK_IMPORTED_MODULE_17__helper_permission__["a" /* checkPerm */])(_this.$store, options.checkPerm)) {
          return null;
        }
        // TODO: re-design this hook
        var handler = hook.handler;
        if (hook.type === 'export' && options.editColumn) {
          handler = function handler() {
            return _this.openedModal = 'export';
          };
          _this.exportHandler = hook.handler;
        }
        return h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len7 = arguments.length, attrs = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                  attrs[_key7 - 1] = arguments[_key7];
                }

                (function () {
                  return handler.call(_this);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          },
          [_this.$i18n(hook.label)]
        );
      })));
    }

    var table = this.tableVisible ? Object(__WEBPACK_IMPORTED_MODULE_15__common_vnode__["b" /* getTableVNode */])(this, h) : null;

    var columnEditButton = h(
      'el-button',
      __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
        'class': 'sp-column-edit-button',
        attrs: { type: 'info',
          size: 'mini',
          plain: true
        }
      }, {
        on: {
          'click': function click($event) {
            for (var _len8 = arguments.length, attrs = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
              attrs[_key8 - 1] = arguments[_key8];
            }

            (function () {
              return _this.openedModal = 'table-column-edit';
            }).apply(undefined, [$event].concat(attrs));
          }
        }
      }]),
      [h('i', { 'class': 'el-icon-sort' })]
    );

    var dataDisplayArea = Object(__WEBPACK_IMPORTED_MODULE_8__components_FormTpl__["b" /* generateForm */])(h, {}, this.inTableEditData[this.inTableEditRowId] || {}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_parseRules__["a" /* default */])({ fields: this.tableSchema }), [h(
      'div',
      { style: { position: 'relative' } },
      [table, this.options && this.options.columnEditable ? columnEditButton : null]
    )]);

    return h('div', [h(
      'div',
      { 'class': 'sp-card core-container' },
      [searchChildren]
    ), h(
      'div',
      { 'class': 'sp-card main-container' },
      [h(
        'div',
        { 'class': 'sp-hooks' },
        [btnsChildren]
      ), h('el-collapse-transition', [this.renderEmbedAdd(h)]), dataDisplayArea, Object(__WEBPACK_IMPORTED_MODULE_15__common_vnode__["a" /* getPaginationVNode */])(this, h)]
    ), this.renderModal(h, this.openedModal)]);
  },

  props: ['mode', 'data', 'schema', 'actions', 'hooks', 'options', 'resourceType'],
  data: function data() {
    return {
      searchFormData: {},
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      parsedActions: [],
      inTableAdd: false,
      inTableEditMode: {},
      inTableEditData: {},
      inTableEditRowId: 0,
      openedModal: null,
      pickedColumns: [],
      tempSchema: 'sku_location',
      tableVisible: true,
      exportHandler: function exportHandler() {},
      confirmText: this.$i18n('Confirm ?')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_13__utils_mapSchemas__["a" /* default */])(), {
    tableData: function tableData() {
      return this.data.provider.list(this.$store.state);
    }
  }),
  created: function created() {
    var _this2 = this;

    if (this.tabSchema.length === 1) {
      var items = this.tabSchema[0].items;

      if (typeof items === 'function') {
        items = items(this.$store.state);
      }
      if (items && items.length) {
        this.searchFormData[this.tabSchema[0].key] = String(items[0].value);
      }
    }
    if (this.resourceType !== 'main') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(this.hiddenSchema), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var schema = _step.value;

          this.searchFormData[schema.key] = this.$route.query[schema.key];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    this.pickedColumns = this.schema.filter(function (item) {
      return item.inTable;
    }).map(function (t) {
      return {
        id: t.key,
        label: _this2.$i18n(t.label),
        visible: true
      };
    });
    if (this.$route.params.view === 'edit' || this.$route.params.view === 'detail') {
      this.$emit('triggerFetchOne', this.$route.query);
    }
    this.parsedActions = Object(__WEBPACK_IMPORTED_MODULE_16__common_dataParse__["a" /* parseActions */])(this, this.actions);
    this.onSearch();
    __WEBPACK_IMPORTED_MODULE_20__utils_eventHub__["a" /* default */].$on(this.data.name + 'listOnSearch', this.onSearch);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_20__utils_eventHub__["a" /* default */].$off(this.data.name + 'listOnSearch', this.onSearch);
  },

  methods: {
    onSearch: function onSearch(event) {
      var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.currentPage = 1;
      event && (typeof event === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default()(event)) === 'object' && event.preventDefault();
      var params = Object(__WEBPACK_IMPORTED_MODULE_14__utils_params__["a" /* formatParams */])(this.searchFormData, extraParams);
      this.$emit('triggerSearch', params);
    },
    onReset: function onReset() {
      var _this3 = this;

      this.filterSchema.forEach(function (item) {
        _this3.searchFormData[item.key] = item.options.defaultValue;
      });
    },
    onTabSwitch: function onTabSwitch(tab) {
      this.onReset();
      this.onSearch();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.$emit('triggerSearch', __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_params__["a" /* formatParams */])(this.searchFormData), {
        // DEPRECATED: remove a key
        page: this.currentPage,
        pageno: this.currentPage,
        count: this.pageSize
      }));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.$emit('triggerSearch', __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_params__["a" /* formatParams */])(this.searchFormData), {
        // DEPRECATED: remove a key
        page: this.currentPage,
        pageno: this.currentPage,
        count: this.pageSize
      }));
    },
    addHandler: function addHandler() {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_18__constant__["a" /* MODE */].EDIT_IN_TABLE) {
        this.inTableAdd = true;
      } else {
        this.$emit('addHandle');
      }
    },
    deleteHandler: function deleteHandler(index, row) {
      var _this4 = this;

      this.$confirm(this.confirmText).then(function () {
        return _this4.$emit('triggerDelete', {
          data: {
            id: row.id
          },
          // TODO: move 'fetch' action to store
          cb: function cb() {
            return _this4.onSearch();
          }
        });
      });
    },
    editHandler: function editHandler(index, row) {
      switch (this.$props.mode) {
        case __WEBPACK_IMPORTED_MODULE_18__constant__["a" /* MODE */].EDIT_IN_TABLE:
          this.$set(this.inTableEditData, row.id, {});
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(this.tableSchema), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var schema = _step2.value;

              if (schema.editable) {
                this.inTableEditRowId = row.id;
                this.$set(this.inTableEditData[row.id], schema.key, __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(row[schema.key]));
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          this.$set(this.inTableEditMode, row.id, !this.inTableEditMode[row.id]);
          break;
        case __WEBPACK_IMPORTED_MODULE_18__constant__["a" /* MODE */].EDIT_IN_DIALOG:
          {
            var params = this.hiddenSchema.reduce(function (obj, schema) {
              return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, obj, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, schema.key, row[schema.key]));
            }, {});
            this.$emit('triggerFetchOne', params);
            this.$emit('editHandle', params);
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_18__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE:
          {
            var _params = this.hiddenSchema.reduce(function (obj, schema) {
              return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, obj, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, schema.key, row[schema.key]));
            }, {});
            this.$emit('editHandle', _params);
            break;
          }
      }
    },
    detailHandler: function detailHandler(index, row) {
      var params = this.hiddenSchema.reduce(function (obj, schema) {
        return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, obj, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, schema.key, row[schema.key]));
      }, {});
      this.$emit('triggerFetchOne', params);
      this.$emit('detailHandle', params);
    },
    renderModal: function renderModal(h, openedModal) {
      var _this5 = this;

      switch (openedModal) {
        case 'table-column-edit':
          return h(__WEBPACK_IMPORTED_MODULE_10__column_edit_modal__["a" /* default */], {
            attrs: {
              schema: this.pickedColumns,
              handleConfirm: function handleConfirm(columns) {
                _this5.pickedColumns = columns;
                // due to element's table bug, we must re-render
                _this5.tableVisible = false;
                _this5.$nextTick(function () {
                  return _this5.tableVisible = true;
                });
              },
              handleCancel: function handleCancel() {
                return _this5.openedModal = null;
              }
            }
          });
        case 'export':
          // DEPRECATED: finish this!
          return h(__WEBPACK_IMPORTED_MODULE_10__column_edit_modal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: this.tempSchema === 'uid' ? [] : this.pickedColumns,
              tempSchema: this.tempSchema,
              handleConfirm: function handleConfirm(columns) {
                _this5.exportHandler(columns, Object(__WEBPACK_IMPORTED_MODULE_14__utils_params__["a" /* formatParams */])(_this5.searchFormData));
              },
              handleCancel: function handleCancel() {
                return _this5.openedModal = null;
              }
            }
          }, {
            on: {
              'updateTempSchema': function updateTempSchema($event) {
                for (var _len9 = arguments.length, attrs = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
                  attrs[_key9 - 1] = arguments[_key9];
                }

                (function (value) {
                  return _this5.tempSchema = value;
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
      }
      return null;
    },
    renderEmbedAdd: function renderEmbedAdd(h) {
      var _this6 = this;

      if (this.mode === __WEBPACK_IMPORTED_MODULE_18__constant__["a" /* MODE */].EDIT_IN_TABLE && this.inTableAdd) {
        return h(__WEBPACK_IMPORTED_MODULE_12__add_embedAdd__["a" /* default */], {
          attrs: {
            schema: this.schema,
            data: this.data,
            close: function close() {
              return _this6.inTableAdd = false;
            }
          }
        });
      }
      return null;
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(169),
    baseKeys = __webpack_require__(401),
    isArrayLike = __webpack_require__(173);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(165);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 110 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(409),
    stubArray = __webpack_require__(175);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(413),
    Map = __webpack_require__(103),
    Promise = __webpack_require__(414),
    Set = __webpack_require__(415),
    WeakMap = __webpack_require__(416),
    baseGetTag = __webpack_require__(68),
    toSource = __webpack_require__(166);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(419);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeGet; });
var safeGet = function safeGet(data, path) {
    if (!path) return undefined;
    var paths = path.split('.');
    var res = data;
    while (paths.length) {
        res = res[paths.shift()];
        if (!res) return undefined;
    }
    return res;
};



/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__ = __webpack_require__(72);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditPage',
  render: function render(h) {
    var _this = this;

    return h(
      'div',
      { 'class': 'sp-card' },
      [h('h1', [this.$i18n(this.appName + ' ' + this.data.resourceName)]), h(__WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__["a" /* default */], {
        'class': 'sp-edit-page-form',
        style: { minWidth: 300 },
        attrs: { model: this.formData,
          fields: this.editableSchema,
          options: { disabled: this.isDetail }
        }
      }), this.nestedList && this.nestedList.map(function (v) {
        return h(v);
      }), this.isDetail ? h(
        'div',
        { style: { marginTop: 'var(--card-spacing)' } },
        [h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                _this.cancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Back')]
        )]
      ) : h(
        'div',
        { style: { marginTop: 'var(--card-spacing)' } },
        [h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                _this.cancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Cancel')]
        ), h(
          'el-button',
          __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { type: 'primary' }
          }, {
            on: {
              'click': function click($event) {
                for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  attrs[_key3 - 1] = arguments[_key3];
                }

                _this.confirm.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Confirm')]
        )]
      )]
    );
  },
  data: function data() {
    return {
      cancelText: this.$i18n('Confirm Cancel ?'),
      confirmText: this.$i18n('Confirm ?'),
      confirming: false,
      defaultFormData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__["a" /* default */])(), {
    formData: function formData() {
      return this.model || this.defaultFormData;
    },
    appName: function appName() {
      if (this.model && this.isDetail) {
        return 'Detail';
      }
      if (this.model) {
        return 'Edit';
      }

      return 'Add';
    }
  }),
  props: ['schema', 'data', 'model', 'isDetail', 'nestedList'],
  created: function created() {
    if (this.appName !== 'Add') {
      this.$emit('triggerFetchOne', this.$route.query);
    }
  },

  methods: {
    reset: function reset() {
      var _this2 = this;

      this.filterSchema.forEach(function (item) {
        _this2.defaultFormData[item.key] = item.options.defaultValue;
      });
    },
    cancel: function cancel() {
      this.$confirm(this.cancelText).then(function () {
        return __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__["a" /* default */].$emit('closeSubPage');
      }).catch(function () {});
    },
    confirm: function confirm() {
      var _this3 = this;

      if (this.confirming) return;
      this.confirming = true;
      var resourceName = this.data.resourceName.toLocaleLowerCase() + '_id';
      this.formData[resourceName] = this.formData[resourceName] || this.formData['id'];
      this.$confirm(this.confirmText).then(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.model) {
                  _context.next = 6;
                  break;
                }

                if (!(_this3.data && _this3.data.update)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this3.data.update(_this3.$store, _this3.formData);

              case 4:
                _context.next = 9;
                break;

              case 6:
                if (!(_this3.data && _this3.data.add)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this3.data.add(_this3.$store, _this3.formData);

              case 9:
                __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__["a" /* default */].$emit('closeSubPage');
                _this3.confirming = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))).catch(function () {
        return _this3.confirming = false;
      });
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__(44);





function toURL(params) {
  params = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(params).map(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    return key + '=' + value;
  }).join('&');
  return params ? '?' + params : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  // TODO: need unit test
  parse: function parse(path) {
    // remove leading slash
    path = path.substr(1).split('/');
    if (path.length === 1) {
      // e.g. /name
      return {
        prefix: '',
        viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */].LIST,
        name: path
      };
    } else if (path.length === 2) {
      if (['add', 'edit', 'detail'].includes(path[1])) {
        // e.g. /name/add
        return {
          prefix: '',
          viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */][path[1].toUpperCase()],
          name: path[0]
        };
      } else {
        // e.g. /prefix/name
        return {
          prefix: '' + path[0],
          viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */].LIST,
          name: path[1]
        };
      }
    } else if (path.length === 3) {
      if (['add', 'edit', 'detail'].includes(path[2])) {
        if (/Add$/.test(path[1]) || /Edit$/.test(path[1]) || /Detail$/.test(path[1])) {
          // e.g. /name/subAdd/add
          return {
            prefix: '',
            viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */][path[1].match(/(Add|Edit|Detail)$/)[1].toUpperCase()],
            name: path[0],
            subName: path[1].replace(/(Add|Edit|Detail)$/, ''),
            from: path[2]
          };
        } else {
          // e.g. /prefix/name/add
          return {
            prefix: '' + path[0],
            viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */][path[2].toUpperCase()],
            name: path[1]
          };
        }
      } else {
        // e.g. /prefix1/prefix2/name
        return {
          prefix: path[0] + '/' + path[1],
          viewMode: __WEBPACK_IMPORTED_MODULE_2__constant_index__["b" /* VIEW_MAP */].LIST,
          name: path[2]
        };
      }
    }
  },
  current: function current(vm, viewMode, row, router, route) {
    var name = vm.viewInfo.name;
    var re = new RegExp('(.*)/(?=' + name + ')');
    var prefix = (route.path.match(re) || [])[1] || '';
    var keys = vm.viewInfo.hiddenKeys[name];
    var params = {};
    keys.forEach(function (key) {
      return params[key] = row[key];
    });
    router.push(prefix + '/' + name + '/' + viewMode + toURL(params));
  },
  into: function into(vm, subName, viewMode, row, router, route) {
    var name = vm.viewInfo.name;
    var re = new RegExp('(.*)/(?=' + name + ')');
    var prefix = (route.path.match(re) || [])[1] || '';
    var currentViewMode = route.params.view || 'list';
    var keys = vm.viewInfo.hiddenKeys[subName];
    var params = {};
    keys.forEach(function (key) {
      return params[key] = row[key];
    });
    router.push(prefix + '/' + name + '/' + subName + Object(__WEBPACK_IMPORTED_MODULE_3__string__["a" /* capitalize */])(viewMode) + '/' + currentViewMode + toURL(params));
  },
  back: function back(vm, router, route) {
    var name = vm.viewInfo.name;
    var re = new RegExp('(.*)/(?=' + name + ')');
    var prefix = (route.path.match(re) || [])[1] || '';
    var viewMode = route.params.from;
    router.push(prefix + '/' + name + (viewMode && viewMode !== 'list' ? '/' + viewMode : ''));
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VEHICLE */
/* unused harmony export STATION */
/* unused harmony export FLEET_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROLE; });
/* unused harmony export DRIVER */
/* unused harmony export RECEIVE */
/* unused harmony export ON_HOLD_REASON */

var VEHICLE = {
  TYPES: ['Motorbike', 'Van', 'Truck', 'Others'],
  OWNERS: ['Shopee', 'Lease', 'Driver'],
  STATUS: ['Available', 'Unavailable'],
  STATUS_CLASS: ['success', 'disabled']
};

var STATION = {
  STATUS: ['In Operation', 'Not In Operation'],
  STATUS_CLASS: ['success', 'disabled'],
  TYPES: ['Sortation Centre', 'Self Pickup', 'Distribution Point']
};

var FLEET_ORDER = {
  STATUS: ['Created', 'Pending', 'Assigned', 'Canceled', 'Delivered', 'On Hold', 'Returned', 'Pending Receive'],
  STATUS_CLASS: ['disabled', 'warning', 'warning', 'danger', 'success', 'warning', 'disabled', 'warning']
};

var ON_HOLD_REASON = ['Normal', 'Incomplete Address', 'Address does not match', 'Inaccessible Location', 'Buyer not on Location', 'No payment receive(COD)', 'Misroute', 'Insufficient Time', 'Item lost', 'Damaged item', 'Disaster', 'Rejected by buyer', 'Buyer Re-Schedule'];

var USER = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
};

var USER_FLAG = {
  STATUS: ['Normal', 'Admin'],
  STATUS_CLASS: ['success', 'danger']
};

var ROLE = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
};

var DRIVER = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
};

var RECEIVE = {
  STATUS: ['Created', 'Pending Receive', 'Received'],
  STATUS_CLASS: ['disabled', 'warning', 'success']
};



/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var type = _ref.type,
      content = _ref.content;

  return "<span class=\"sp-tag sp-bg-" + type + "\">" + content + "</span>";
});

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_components_Header_index__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_components_Menu_index_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_components_Breadcrumb_index_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_index__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mock_menu__ = __webpack_require__(325);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      locales: __WEBPACK_IMPORTED_MODULE_5__lang_index__["a" /* default */],
      display: true,
      userInfo: {
        email: 'jon.doe@examples.com'
      },
      menuData: __WEBPACK_IMPORTED_MODULE_6__mock_menu__["a" /* default */]
    };
  },

  components: {
    spHeader: __WEBPACK_IMPORTED_MODULE_2__packages_components_Header_index__["a" /* default */],
    spMenu: __WEBPACK_IMPORTED_MODULE_3__packages_components_Menu_index_js__["a" /* default */],
    spBreadcrumb: __WEBPACK_IMPORTED_MODULE_4__packages_components_Breadcrumb_index_js__["a" /* default */]
  },
  methods: {
    logout: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$message('logout clicked');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logout() {
        return _ref.apply(this, arguments);
      }

      return logout;
    }()
  }
});

/***/ }),
/* 122 */
/***/ (function(module, exports) {



/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(125);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(41);
var $iterCreate = __webpack_require__(223);
var setToStringTag = __webpack_require__(59);
var getPrototypeOf = __webpack_require__(129);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(40)(function () {
  return Object.defineProperty(__webpack_require__(79)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(31);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(32);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(225)(false);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(48);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(32);
var toObject = __webpack_require__(49);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(19);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(41);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(19);
var aFunction = __webpack_require__(57);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(39);
var invoke = __webpack_require__(233);
var html = __webpack_require__(128);
var cel = __webpack_require__(79);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(48)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isObject = __webpack_require__(28);
var newPromiseCapability = __webpack_require__(88);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_i18n_index__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    var _this = this;

    return h(
      "div",
      { "class": "sp-header" },
      [this.$slots.logo, h(
        "span",
        { "class": "sp-header-col sp-cursor-pointer" },
        [h(
          "el-dropdown",
          __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { trigger: "click" }
          }, {
            on: {
              "command": function command($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                _this.onUserDropdownCommand.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [h("div", [h("icon", {
            attrs: { name: "user-circle" }
          })]), h(
            "el-dropdown-menu",
            { slot: "dropdown" },
            [h(
              "el-dropdown-item",
              {
                attrs: { disabled: true }
              },
              [this.user.email]
            ), h(
              "el-dropdown-item",
              {
                attrs: { divided: true, command: "logout" }
              },
              [this.$i18n('Logout')]
            )]
          )]
        )]
      ), h(
        "span",
        { "class": "sp-header-col sp-cursor-pointer" },
        [h(
          "el-dropdown",
          __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { trigger: "click" }
          }, {
            on: {
              "command": function command($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                _this.onSetLocale.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [h("div", [h("icon", {
            attrs: { name: "language" }
          })]), h(
            "el-dropdown-menu",
            { slot: "dropdown" },
            [__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(this.locales).map(function (_ref) {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                  locale = _ref2[0],
                  _name = _ref2[1]._name;

              return h(
                "el-dropdown-item",
                {
                  attrs: { command: locale }
                },
                [_name]
              );
            })]
          )]
        )]
      ), h(
        "span",
        { "class": "sp-header-col" },
        [this.$slots.default]
      )]
    );
  },

  props: ['user', 'locales', 'logout'],
  methods: {
    onUserDropdownCommand: function onUserDropdownCommand(command) {
      if (command === 'logout') {
        this.logout();
      }
    },
    onSetLocale: function onSetLocale(locale) {
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_i18n_index__["d" /* setLocale */])(locale);
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9);
var core = __webpack_require__(1);
var fails = __webpack_require__(40);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(126);
var hiddenKeys = __webpack_require__(85).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(52);
var createDesc = __webpack_require__(47);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(80);
var has = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(124);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 46);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(142);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(93);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(144);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(96);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(146);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(95);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithDefaultTime = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = undefined;

var _date = __webpack_require__(175);

var _date2 = _interopRequireDefault(_date);

var _locale = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
var getI18nSettings = function getI18nSettings() {
  return {
    dayNamesShort: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    dayNames: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    monthNamesShort: months.map(function (month) {
      return (0, _locale.t)('el.datepicker.months.' + month);
    }),
    monthNames: months.map(function (month, index) {
      return (0, _locale.t)('el.datepicker.month' + (index + 1));
    }),
    amPm: ['am', 'pm']
  };
};

var newArray = function newArray(start, end) {
  var result = [];
  for (var i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
};

var toDate = exports.toDate = function toDate(date) {
  return isDate(date) ? new Date(date) : null;
};

var isDate = exports.isDate = function isDate(date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  return true;
};

var isDateObject = exports.isDateObject = function isDateObject(val) {
  return val instanceof Date;
};

var formatDate = exports.formatDate = function formatDate(date, format) {
  date = toDate(date);
  if (!date) return '';
  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
};

var parseDate = exports.parseDate = function parseDate(string, format) {
  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
};

var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};

var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
  return isLeapYear ? 366 : 365;
};

var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
};

// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
// {prev, next} Date should work for Daylight Saving Time
// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
var prevDate = exports.prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

var nextDate = exports.nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();

  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};

var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
  if (!isDate(src)) return null;
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
  var hours = [];
  var disabledHours = [];

  (ranges || []).forEach(function (range) {
    var value = range.map(function (date) {
      return date.getHours();
    });

    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
  });

  if (disabledHours.length) {
    for (var i = 0; i < 24; i++) {
      hours[i] = disabledHours.indexOf(i) === -1;
    }
  } else {
    for (var _i = 0; _i < 24; _i++) {
      hours[_i] = false;
    }
  }

  return hours;
};

var range = exports.range = function range(n) {
  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
  return Array.apply(null, { length: n }).map(function (_, n) {
    return n;
  });
};

var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
};

var modifyWithDefaultTime = exports.modifyWithDefaultTime = function modifyWithDefaultTime(date, time) {
  if (date == null || !time) {
    return date;
  }
  time = parseDate(time, 'HH:mm:ss');
  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
};

var clearTime = exports.clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
};

var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';

  // TODO: refactory a more elegant solution
  if (ranges.length === 0) return date;
  var normalizeDate = function normalizeDate(date) {
    return _date2.default.parse(_date2.default.format(date, format), format);
  };
  var ndate = normalizeDate(date);
  var nranges = ranges.map(function (range) {
    return range.map(normalizeDate);
  });
  if (nranges.some(function (nrange) {
    return ndate >= nrange[0] && ndate <= nrange[1];
  })) return date;

  var minDate = nranges[0][0];
  var maxDate = nranges[0][0];

  nranges.forEach(function (nrange) {
    minDate = new Date(Math.min(nrange[0], minDate));
    maxDate = new Date(Math.max(nrange[1], minDate));
  });

  var ret = ndate < minDate ? minDate : maxDate;
  // preserve Year/Month/Date
  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
};

var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
  var limitedDate = limitTimeRange(date, selectableRange, format);
  return limitedDate.getTime() === date.getTime();
};

var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

var prevMonth = exports.prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};

var nextMonth = exports.nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};

var prevYear = exports.prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};

var nextYear = exports.nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};

var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
};

var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(145);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(268);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(92);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(270);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var NODE_KEY = exports.NODE_KEY = '$treeNodeId';

var markNodeData = exports.markNodeData = function markNodeData(node, data) {
  if (data[NODE_KEY]) return;
  Object.defineProperty(data, NODE_KEY, {
    value: node.id,
    enumerable: false,
    configurable: false,
    writable: false
  });
};

var getNodeKey = exports.getNodeKey = function getNodeKey(key, data) {
  if (!key) return data[NODE_KEY];
  return data[key];
};

var findNearestComponent = exports.findNearestComponent = function findNearestComponent(element, componentName) {
  var target = element;
  while (target && target.tagName !== 'BODY') {
    if (target.__vue__ && target.__vue__.$options.name === componentName) {
      return target.__vue__;
    }
    target = target.parentNode;
  }
  return null;
};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(271);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(94);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(150);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(151);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  created: function created() {
    this.tableLayout.addObserver(this);
  },
  destroyed: function destroyed() {
    this.tableLayout.removeObserver(this);
  },


  computed: {
    tableLayout: function tableLayout() {
      var layout = this.layout;
      if (!layout && this.table) {
        layout = this.table.layout;
      }
      if (!layout) {
        throw new Error('Can not find table layout.');
      }
      return layout;
    }
  },

  mounted: function mounted() {
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
  },
  updated: function updated() {
    if (this.__updated__) return;
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
    this.__updated__ = true;
  },


  methods: {
    onColumnsChange: function onColumnsChange() {
      var cols = this.$el.querySelectorAll('colgroup > col');
      if (!cols.length) return;
      var flattenColumns = this.tableLayout.getFlattenColumns();
      var columnsMap = {};
      flattenColumns.forEach(function (column) {
        columnsMap[column.id] = column;
      });
      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        var name = col.getAttribute('name');
        var column = columnsMap[name];
        if (column) {
          col.setAttribute('width', column.realWidth || column.width);
        }
      }
    },
    onScrollableChange: function onScrollableChange(layout) {
      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
      }
      var ths = this.$el.querySelectorAll('th.gutter');
      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
        var th = ths[_i];
        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
        th.style.display = layout.scrollY ? '' : 'none';
      }
    }
  }
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b32bdda0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_vue__ = __webpack_require__(176);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b32bdda0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4135ea9a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_vue__ = __webpack_require__(182);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4135ea9a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (element, options) {
  if (_vue2.default.prototype.$isServer) return;
  var moveFn = function moveFn(event) {
    if (options.drag) {
      options.drag(event);
    }
  };
  var upFn = function upFn(event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;

    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };
  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;
    document.onselectstart = function () {
      return false;
    };
    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
};

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDragging = false;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};

exports.default = aria.Utils;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  inject: ['rootMenu'],
  computed: {
    indexPath: function indexPath() {
      var path = [this.index];
      var parent = this.$parent;
      while (parent.$options.componentName !== 'ElMenu') {
        if (parent.index) {
          path.unshift(parent.index);
        }
        parent = parent.$parent;
      }
      return path;
    },
    parentMenu: function parentMenu() {
      var parent = this.$parent;
      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
        parent = parent.$parent;
      }
      return parent;
    },
    paddingStyle: function paddingStyle() {
      if (this.rootMenu.mode !== 'vertical') return {};

      var padding = 20;
      var parent = this.$parent;

      if (this.rootMenu.collapse) {
        padding = 20;
      } else {
        while (parent && parent.$options.componentName !== 'ElMenu') {
          if (parent.$options.componentName === 'ElSubmenu') {
            padding += 20;
          }
          parent = parent.$parent;
        }
      }
      return { paddingLeft: padding + 'px' };
    }
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(3);

exports.default = {
  bind: function bind(el, binding, vnode) {
    var interval = null;
    var startTime = void 0;
    var handler = function handler() {
      return vnode.context[binding.expression].apply();
    };
    var clear = function clear() {
      if (new Date() - startTime < 100) {
        handler();
      }
      clearInterval(interval);
      interval = null;
    };

    (0, _dom.on)(el, 'mousedown', function (e) {
      if (e.button !== 0) return;
      startTime = new Date();
      (0, _dom.once)(document, 'mouseup', clear);
      clearInterval(interval);
      interval = setInterval(handler, 100);
    });
  }
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__ = __webpack_require__(139);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getRowIdentity = exports.getColumnByCell = exports.getColumnById = exports.orderBy = exports.getCell = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(4);

var getCell = exports.getCell = function getCell(event) {
  var cell = event.target;

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell;
    }
    cell = cell.parentNode;
  }

  return null;
};

var isObject = function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
};

var orderBy = exports.orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
    return array;
  }
  if (typeof reverse === 'string') {
    reverse = reverse === 'descending' ? -1 : 1;
  } else {
    reverse = reverse && reverse < 0 ? -1 : 1;
  }
  var getKey = sortMethod ? null : function (value, index) {
    if (sortBy) {
      if (!Array.isArray(sortBy)) {
        sortBy = [sortBy];
      }
      return sortBy.map(function (by) {
        if (typeof by === 'string') {
          return (0, _util.getValueByPath)(value, by);
        } else {
          return by(value, index, array);
        }
      });
    }
    if (sortKey !== '$key') {
      if (isObject(value) && '$value' in value) value = value.$value;
    }
    return [isObject(value) ? (0, _util.getValueByPath)(value, sortKey) : value];
  };
  var compare = function compare(a, b) {
    if (sortMethod) {
      return sortMethod(a.value, b.value);
    }
    for (var i = 0, len = a.key.length; i < len; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  };
  return array.map(function (value, index) {
    return {
      value: value,
      index: index,
      key: getKey ? getKey(value, index) : null
    };
  }).sort(function (a, b) {
    var order = compare(a, b);
    if (!order) {
      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
      order = a.index - b.index;
    }
    return order * reverse;
  }).map(function (item) {
    return item.value;
  });
};

var getColumnById = exports.getColumnById = function getColumnById(table, columnId) {
  var column = null;
  table.columns.forEach(function (item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};

var getColumnByCell = exports.getColumnByCell = function getColumnByCell(table, cell) {
  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
  if (matches) {
    return getColumnById(table, matches[0]);
  }
  return null;
};

var getRowIdentity = exports.getRowIdentity = function getRowIdentity(row, rowKey) {
  if (!row) throw new Error('row is required when get row identity');
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey];
    }
    var key = rowKey.split('.');
    var current = row;
    for (var i = 0; i < key.length; i++) {
      current = current[key[i]];
    }
    return current;
  } else if (typeof rowKey === 'function') {
    return rowKey.call(null, row);
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(272);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_spinner_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e066fc_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_spinner_vue__ = __webpack_require__(181);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_spinner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e066fc_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_table_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135ffc92_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_table_vue__ = __webpack_require__(190);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135ffc92_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d8d1339_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__(280);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d8d1339_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(273);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(274);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d91e8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d91e8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var hsv2hsl = function hsv2hsl(hue, sat, val) {
  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
};

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
var isOnePointZero = function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
};

var isPercentage = function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
};

// Take input from [0, n] and return it as [0, 1]
var bound01 = function bound01(value, max) {
  if (isOnePointZero(value)) value = '100%';

  var processPercent = isPercentage(value);
  value = Math.min(max, Math.max(0, parseFloat(value)));

  // Automatically convert percentage into number
  if (processPercent) {
    value = parseInt(value * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(value - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return value % max / parseFloat(max);
};

var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };

var toHex = function toHex(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;

  var hexOne = function hexOne(value) {
    value = Math.min(Math.round(value), 255);
    var high = Math.floor(value / 16);
    var low = value % 16;
    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
  };

  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';

  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
};

var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };

var parseHexChannel = function parseHexChannel(hex) {
  if (hex.length === 2) {
    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
  }

  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
};

var hsl2hsv = function hsl2hsv(hue, sat, light) {
  sat = sat / 100;
  light = light / 100;
  var smin = sat;
  var lmin = Math.max(light, 0.01);
  var sv = void 0;
  var v = void 0;

  light *= 2;
  sat *= light <= 1 ? light : 2 - light;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  v = (light + sat) / 2;
  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);

  return {
    h: hue,
    s: sv * 100,
    v: v * 100
  };
};

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
var rgb2hsv = function rgb2hsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);

  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = void 0,
      s = void 0;
  var v = max;

  var d = max - min;
  s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return { h: h * 360, s: s * 100, v: v * 100 };
};

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
var hsv2rgb = function hsv2rgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);

  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
};

var Color = function () {
  function Color(options) {
    _classCallCheck(this, Color);

    this._hue = 0;
    this._saturation = 100;
    this._value = 100;
    this._alpha = 100;

    this.enableAlpha = false;
    this.format = 'hex';
    this.value = '';

    options = options || {};

    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }

    this.doOnChange();
  }

  Color.prototype.set = function set(prop, value) {
    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
      for (var p in prop) {
        if (prop.hasOwnProperty(p)) {
          this.set(p, prop[p]);
        }
      }

      return;
    }

    this['_' + prop] = value;
    this.doOnChange();
  };

  Color.prototype.get = function get(prop) {
    return this['_' + prop];
  };

  Color.prototype.toRgb = function toRgb() {
    return hsv2rgb(this._hue, this._saturation, this._value);
  };

  Color.prototype.fromString = function fromString(value) {
    var _this = this;

    if (!value) {
      this._hue = 0;
      this._saturation = 100;
      this._value = 100;

      this.doOnChange();
      return;
    }

    var fromHSV = function fromHSV(h, s, v) {
      _this._hue = Math.max(0, Math.min(360, h));
      _this._saturation = Math.max(0, Math.min(100, s));
      _this._value = Math.max(0, Math.min(100, v));

      _this.doOnChange();
    };

    if (value.indexOf('hsl') !== -1) {
      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (parts.length === 4) {
        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
      } else if (parts.length === 3) {
        this._alpha = 100;
      }
      if (parts.length >= 3) {
        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
            h = _hsl2hsv.h,
            s = _hsl2hsv.s,
            v = _hsl2hsv.v;

        fromHSV(h, s, v);
      }
    } else if (value.indexOf('hsv') !== -1) {
      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (_parts.length === 4) {
        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
      } else if (_parts.length === 3) {
        this._alpha = 100;
      }
      if (_parts.length >= 3) {
        fromHSV(_parts[0], _parts[1], _parts[2]);
      }
    } else if (value.indexOf('rgb') !== -1) {
      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (_parts2.length === 4) {
        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
      } else if (_parts2.length === 3) {
        this._alpha = 100;
      }
      if (_parts2.length >= 3) {
        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
            _h = _rgb2hsv.h,
            _s = _rgb2hsv.s,
            _v = _rgb2hsv.v;

        fromHSV(_h, _s, _v);
      }
    } else if (value.indexOf('#') !== -1) {
      var hex = value.replace('#', '').trim();
      var r = void 0,
          g = void 0,
          b = void 0;

      if (hex.length === 3) {
        r = parseHexChannel(hex[0] + hex[0]);
        g = parseHexChannel(hex[1] + hex[1]);
        b = parseHexChannel(hex[2] + hex[2]);
      } else if (hex.length === 6 || hex.length === 8) {
        r = parseHexChannel(hex.substring(0, 2));
        g = parseHexChannel(hex.substring(2, 4));
        b = parseHexChannel(hex.substring(4, 6));
      }

      if (hex.length === 8) {
        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
      } else if (hex.length === 3 || hex.length === 6) {
        this._alpha = 100;
      }

      var _rgb2hsv2 = rgb2hsv(r, g, b),
          _h2 = _rgb2hsv2.h,
          _s2 = _rgb2hsv2.s,
          _v2 = _rgb2hsv2.v;

      fromHSV(_h2, _s2, _v2);
    }
  };

  Color.prototype.compare = function compare(color) {
    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
  };

  Color.prototype.doOnChange = function doOnChange() {
    var _hue = this._hue,
        _saturation = this._saturation,
        _value = this._value,
        _alpha = this._alpha,
        format = this.format;


    if (this.enableAlpha) {
      switch (format) {
        case 'hsl':
          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
          break;
        case 'hsv':
          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
          break;
        default:
          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
              r = _hsv2rgb.r,
              g = _hsv2rgb.g,
              b = _hsv2rgb.b;

          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
      }
    } else {
      switch (format) {
        case 'hsl':
          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
          break;
        case 'hsv':
          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
          break;
        case 'rgb':
          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
              _r = _hsv2rgb2.r,
              _g = _hsv2rgb2.g,
              _b = _hsv2rgb2.b;

          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
          break;
        default:
          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
      }
    }
  };

  return Color;
}();

exports.default = Color;
;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(47);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(55);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(59);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(66);

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(70);

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__(74);

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__(78);

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__(84);

var _index16 = _interopRequireDefault(_index15);

var _index17 = __webpack_require__(87);

var _index18 = _interopRequireDefault(_index17);

var _index19 = __webpack_require__(91);

var _index20 = _interopRequireDefault(_index19);

var _index21 = __webpack_require__(95);

var _index22 = _interopRequireDefault(_index21);

var _index23 = __webpack_require__(100);

var _index24 = _interopRequireDefault(_index23);

var _index25 = __webpack_require__(104);

var _index26 = _interopRequireDefault(_index25);

var _index27 = __webpack_require__(108);

var _index28 = _interopRequireDefault(_index27);

var _index29 = __webpack_require__(112);

var _index30 = _interopRequireDefault(_index29);

var _index31 = __webpack_require__(116);

var _index32 = _interopRequireDefault(_index31);

var _index33 = __webpack_require__(120);

var _index34 = _interopRequireDefault(_index33);

var _index35 = __webpack_require__(124);

var _index36 = _interopRequireDefault(_index35);

var _index37 = __webpack_require__(128);

var _index38 = _interopRequireDefault(_index37);

var _index39 = __webpack_require__(132);

var _index40 = _interopRequireDefault(_index39);

var _index41 = __webpack_require__(142);

var _index42 = _interopRequireDefault(_index41);

var _index43 = __webpack_require__(143);

var _index44 = _interopRequireDefault(_index43);

var _index45 = __webpack_require__(147);

var _index46 = _interopRequireDefault(_index45);

var _index47 = __webpack_require__(151);

var _index48 = _interopRequireDefault(_index47);

var _index49 = __webpack_require__(155);

var _index50 = _interopRequireDefault(_index49);

var _index51 = __webpack_require__(170);

var _index52 = _interopRequireDefault(_index51);

var _index53 = __webpack_require__(172);

var _index54 = _interopRequireDefault(_index53);

var _index55 = __webpack_require__(195);

var _index56 = _interopRequireDefault(_index55);

var _index57 = __webpack_require__(200);

var _index58 = _interopRequireDefault(_index57);

var _index59 = __webpack_require__(205);

var _index60 = _interopRequireDefault(_index59);

var _index61 = __webpack_require__(210);

var _index62 = _interopRequireDefault(_index61);

var _index63 = __webpack_require__(212);

var _index64 = _interopRequireDefault(_index63);

var _index65 = __webpack_require__(218);

var _index66 = _interopRequireDefault(_index65);

var _index67 = __webpack_require__(222);

var _index68 = _interopRequireDefault(_index67);

var _index69 = __webpack_require__(226);

var _index70 = _interopRequireDefault(_index69);

var _index71 = __webpack_require__(230);

var _index72 = _interopRequireDefault(_index71);

var _index73 = __webpack_require__(235);

var _index74 = _interopRequireDefault(_index73);

var _index75 = __webpack_require__(243);

var _index76 = _interopRequireDefault(_index75);

var _index77 = __webpack_require__(247);

var _index78 = _interopRequireDefault(_index77);

var _index79 = __webpack_require__(251);

var _index80 = _interopRequireDefault(_index79);

var _index81 = __webpack_require__(260);

var _index82 = _interopRequireDefault(_index81);

var _index83 = __webpack_require__(264);

var _index84 = _interopRequireDefault(_index83);

var _index85 = __webpack_require__(269);

var _index86 = _interopRequireDefault(_index85);

var _index87 = __webpack_require__(277);

var _index88 = _interopRequireDefault(_index87);

var _index89 = __webpack_require__(282);

var _index90 = _interopRequireDefault(_index89);

var _index91 = __webpack_require__(286);

var _index92 = _interopRequireDefault(_index91);

var _index93 = __webpack_require__(288);

var _index94 = _interopRequireDefault(_index93);

var _index95 = __webpack_require__(290);

var _index96 = _interopRequireDefault(_index95);

var _index97 = __webpack_require__(303);

var _index98 = _interopRequireDefault(_index97);

var _index99 = __webpack_require__(307);

var _index100 = _interopRequireDefault(_index99);

var _index101 = __webpack_require__(311);

var _index102 = _interopRequireDefault(_index101);

var _index103 = __webpack_require__(316);

var _index104 = _interopRequireDefault(_index103);

var _index105 = __webpack_require__(320);

var _index106 = _interopRequireDefault(_index105);

var _index107 = __webpack_require__(324);

var _index108 = _interopRequireDefault(_index107);

var _index109 = __webpack_require__(328);

var _index110 = _interopRequireDefault(_index109);

var _index111 = __webpack_require__(332);

var _index112 = _interopRequireDefault(_index111);

var _index113 = __webpack_require__(336);

var _index114 = _interopRequireDefault(_index113);

var _index115 = __webpack_require__(341);

var _index116 = _interopRequireDefault(_index115);

var _index117 = __webpack_require__(345);

var _index118 = _interopRequireDefault(_index117);

var _index119 = __webpack_require__(349);

var _index120 = _interopRequireDefault(_index119);

var _index121 = __webpack_require__(353);

var _index122 = _interopRequireDefault(_index121);

var _index123 = __webpack_require__(357);

var _index124 = _interopRequireDefault(_index123);

var _index125 = __webpack_require__(363);

var _index126 = _interopRequireDefault(_index125);

var _index127 = __webpack_require__(382);

var _index128 = _interopRequireDefault(_index127);

var _index129 = __webpack_require__(389);

var _index130 = _interopRequireDefault(_index129);

var _index131 = __webpack_require__(393);

var _index132 = _interopRequireDefault(_index131);

var _index133 = __webpack_require__(397);

var _index134 = _interopRequireDefault(_index133);

var _index135 = __webpack_require__(401);

var _index136 = _interopRequireDefault(_index135);

var _index137 = __webpack_require__(405);

var _index138 = _interopRequireDefault(_index137);

var _locale = __webpack_require__(16);

var _locale2 = _interopRequireDefault(_locale);

var _collapseTransition = __webpack_require__(20);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = [_index2.default, _index4.default, _index6.default, _index8.default, _index10.default, _index12.default, _index14.default, _index16.default, _index18.default, _index20.default, _index22.default, _index24.default, _index26.default, _index28.default, _index30.default, _index32.default, _index34.default, _index36.default, _index38.default, _index40.default, _index42.default, _index44.default, _index46.default, _index48.default, _index50.default, _index52.default, _index54.default, _index56.default, _index58.default, _index60.default, _index62.default, _index66.default, _index68.default, _index70.default, _index72.default, _index74.default, _index76.default, _index78.default, _index80.default, _index82.default, _index86.default, _index90.default, _index92.default, _index94.default, _index96.default, _index98.default, _index100.default, _index104.default, _index106.default, _index108.default, _index110.default, _index112.default, _index114.default, _index116.default, _index118.default, _index120.default, _index122.default, _index124.default, _index126.default, _index128.default, _index130.default, _index132.default, _index134.default, _index136.default, _index138.default, _collapseTransition2.default]; /* Automatically generated by './build/bin/build-entry.js' */

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _locale2.default.use(opts.locale);
  _locale2.default.i18n(opts.i18n);

  components.map(function (component) {
    Vue.component(component.name, component);
  });

  Vue.use(_index88.default.directive);

  var ELEMENT = {};
  ELEMENT.size = opts.size || '';

  Vue.prototype.$loading = _index88.default.service;
  Vue.prototype.$msgbox = _index64.default;
  Vue.prototype.$alert = _index64.default.alert;
  Vue.prototype.$confirm = _index64.default.confirm;
  Vue.prototype.$prompt = _index64.default.prompt;
  Vue.prototype.$notify = _index84.default;
  Vue.prototype.$message = _index102.default;

  Vue.prototype.$ELEMENT = ELEMENT;
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

module.exports = {
  version: '2.3.7',
  locale: _locale2.default.use,
  i18n: _locale2.default.i18n,
  install: install,
  CollapseTransition: _collapseTransition2.default,
  Loading: _index88.default,
  Pagination: _index2.default,
  Dialog: _index4.default,
  Autocomplete: _index6.default,
  Dropdown: _index8.default,
  DropdownMenu: _index10.default,
  DropdownItem: _index12.default,
  Menu: _index14.default,
  Submenu: _index16.default,
  MenuItem: _index18.default,
  MenuItemGroup: _index20.default,
  Input: _index22.default,
  InputNumber: _index24.default,
  Radio: _index26.default,
  RadioGroup: _index28.default,
  RadioButton: _index30.default,
  Checkbox: _index32.default,
  CheckboxButton: _index34.default,
  CheckboxGroup: _index36.default,
  Switch: _index38.default,
  Select: _index40.default,
  Option: _index42.default,
  OptionGroup: _index44.default,
  Button: _index46.default,
  ButtonGroup: _index48.default,
  Table: _index50.default,
  TableColumn: _index52.default,
  DatePicker: _index54.default,
  TimeSelect: _index56.default,
  TimePicker: _index58.default,
  Popover: _index60.default,
  Tooltip: _index62.default,
  MessageBox: _index64.default,
  Breadcrumb: _index66.default,
  BreadcrumbItem: _index68.default,
  Form: _index70.default,
  FormItem: _index72.default,
  Tabs: _index74.default,
  TabPane: _index76.default,
  Tag: _index78.default,
  Tree: _index80.default,
  Alert: _index82.default,
  Notification: _index84.default,
  Slider: _index86.default,
  Icon: _index90.default,
  Row: _index92.default,
  Col: _index94.default,
  Upload: _index96.default,
  Progress: _index98.default,
  Spinner: _index100.default,
  Message: _index102.default,
  Badge: _index104.default,
  Card: _index106.default,
  Rate: _index108.default,
  Steps: _index110.default,
  Step: _index112.default,
  Carousel: _index114.default,
  Scrollbar: _index116.default,
  CarouselItem: _index118.default,
  Collapse: _index120.default,
  CollapseItem: _index122.default,
  Cascader: _index124.default,
  ColorPicker: _index126.default,
  Transfer: _index128.default,
  Container: _index130.default,
  Header: _index132.default,
  Aside: _index134.default,
  Main: _index136.default,
  Footer: _index138.default
};

module.exports.default = module.exports;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pagination = __webpack_require__(49);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_pagination2.default.install = function (Vue) {
  Vue.component(_pagination2.default.name, _pagination2.default);
};

exports.default = _pagination2.default;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pager = __webpack_require__(50);

var _pager2 = _interopRequireDefault(_pager);

var _select = __webpack_require__(53);

var _select2 = _interopRequireDefault(_select);

var _option = __webpack_require__(54);

var _option2 = _interopRequireDefault(_option);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElPagination',

  props: {
    pageSize: {
      type: Number,
      default: 10
    },

    small: Boolean,

    total: Number,

    pageCount: Number,

    pagerCount: {
      type: Number,
      validator: function validator(value) {
        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
      },

      default: 7
    },

    currentPage: {
      type: Number,
      default: 1
    },

    layout: {
      default: 'prev, pager, next, jumper, ->, total'
    },

    pageSizes: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },

    popperClass: String,

    prevText: String,

    nextText: String,

    background: Boolean,

    disabled: Boolean
  },

  data: function data() {
    return {
      internalCurrentPage: 1,
      internalPageSize: 0,
      lastEmittedPage: -1,
      userChangePageSize: false
    };
  },
  render: function render(h) {
    var template = h(
      'div',
      { 'class': ['el-pagination', {
          'is-background': this.background,
          'el-pagination--small': this.small
        }] },
      []
    );
    var layout = this.layout || '';
    if (!layout) return;
    var TEMPLATE_MAP = {
      prev: h(
        'prev',
        null,
        []
      ),
      jumper: h(
        'jumper',
        null,
        []
      ),
      pager: h(
        'pager',
        {
          attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
          on: {
            'change': this.handleCurrentChange
          }
        },
        []
      ),
      next: h(
        'next',
        null,
        []
      ),
      sizes: h(
        'sizes',
        {
          attrs: { pageSizes: this.pageSizes }
        },
        []
      ),
      slot: h(
        'my-slot',
        null,
        []
      ),
      total: h(
        'total',
        null,
        []
      )
    };
    var components = layout.split(',').map(function (item) {
      return item.trim();
    });
    var rightWrapper = h(
      'div',
      { 'class': 'el-pagination__rightwrapper' },
      []
    );
    var haveRightWrapper = false;

    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(function (compo) {
      if (compo === '->') {
        haveRightWrapper = true;
        return;
      }

      if (!haveRightWrapper) {
        template.children.push(TEMPLATE_MAP[compo]);
      } else {
        rightWrapper.children.push(TEMPLATE_MAP[compo]);
      }
    });

    if (haveRightWrapper) {
      template.children.unshift(rightWrapper);
    }

    return template;
  },


  components: {
    MySlot: {
      render: function render(h) {
        return this.$parent.$slots.default ? this.$parent.$slots.default[0] : '';
      }
    },
    Prev: {
      render: function render(h) {
        return h(
          'button',
          {
            attrs: {
              type: 'button',

              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
            },
            'class': 'btn-prev', on: {
              'click': this.$parent.prev
            }
          },
          [this.$parent.prevText ? h(
            'span',
            null,
            [this.$parent.prevText]
          ) : h(
            'i',
            { 'class': 'el-icon el-icon-arrow-left' },
            []
          )]
        );
      }
    },

    Next: {
      render: function render(h) {
        return h(
          'button',
          {
            attrs: {
              type: 'button',

              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
            },
            'class': 'btn-next', on: {
              'click': this.$parent.next
            }
          },
          [this.$parent.nextText ? h(
            'span',
            null,
            [this.$parent.nextText]
          ) : h(
            'i',
            { 'class': 'el-icon el-icon-arrow-right' },
            []
          )]
        );
      }
    },

    Sizes: {
      mixins: [_locale2.default],

      props: {
        pageSizes: Array
      },

      watch: {
        pageSizes: {
          immediate: true,
          handler: function handler(newVal, oldVal) {
            if ((0, _util.valueEquals)(newVal, oldVal)) return;
            if (Array.isArray(newVal)) {
              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
            }
          }
        }
      },

      render: function render(h) {
        var _this = this;

        return h(
          'span',
          { 'class': 'el-pagination__sizes' },
          [h(
            'el-select',
            {
              attrs: {
                value: this.$parent.internalPageSize,
                popperClass: this.$parent.popperClass || '',

                disabled: this.$parent.disabled },
              on: {
                'input': this.handleChange
              }
            },
            [this.pageSizes.map(function (item) {
              return h(
                'el-option',
                {
                  attrs: {
                    value: item,
                    label: item + _this.t('el.pagination.pagesize') }
                },
                []
              );
            })]
          )]
        );
      },


      components: {
        ElSelect: _select2.default,
        ElOption: _option2.default
      },

      methods: {
        handleChange: function handleChange(val) {
          if (val !== this.$parent.internalPageSize) {
            this.$parent.internalPageSize = val = parseInt(val, 10);
            this.$parent.userChangePageSize = true;
            this.$parent.$emit('size-change', val);
          }
        }
      }
    },

    Jumper: {
      mixins: [_locale2.default],

      data: function data() {
        return {
          oldValue: null
        };
      },


      components: { ElInput: _input2.default },

      watch: {
        '$parent.internalPageSize': function $parentInternalPageSize() {
          var _this2 = this;

          this.$nextTick(function () {
            _this2.$refs.input.$el.querySelector('input').value = _this2.$parent.internalCurrentPage;
          });
        }
      },

      methods: {
        handleFocus: function handleFocus(event) {
          this.oldValue = event.target.value;
        },
        handleBlur: function handleBlur(_ref) {
          var target = _ref.target;

          this.resetValueIfNeed(target.value);
          this.reassignMaxValue(target.value);
        },
        handleKeyup: function handleKeyup(_ref2) {
          var keyCode = _ref2.keyCode,
              target = _ref2.target;

          if (keyCode === 13 && this.oldValue && target.value !== this.oldValue) {
            this.handleChange(target.value);
          }
        },
        handleChange: function handleChange(value) {
          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
          this.$parent.emitChange();
          this.oldValue = null;
          this.resetValueIfNeed(value);
        },
        resetValueIfNeed: function resetValueIfNeed(value) {
          var num = parseInt(value, 10);
          if (!isNaN(num)) {
            if (num < 1) {
              this.$refs.input.$el.querySelector('input').value = 1;
            } else {
              this.reassignMaxValue(value);
            }
          }
        },
        reassignMaxValue: function reassignMaxValue(value) {
          if (+value > this.$parent.internalPageCount) {
            this.$refs.input.$el.querySelector('input').value = this.$parent.internalPageCount;
          }
        }
      },

      render: function render(h) {
        return h(
          'span',
          { 'class': 'el-pagination__jump' },
          [this.t('el.pagination.goto'), h(
            'el-input',
            {
              'class': 'el-pagination__editor is-in-pagination',
              attrs: { min: 1,
                max: this.$parent.internalPageCount,
                value: this.$parent.internalCurrentPage,

                type: 'number',

                disabled: this.$parent.disabled
              },
              domProps: {
                'value': this.$parent.internalCurrentPage
              },
              ref: 'input', nativeOn: {
                'keyup': this.handleKeyup
              },
              on: {
                'change': this.handleChange,
                'focus': this.handleFocus,
                'blur': this.handleBlur
              }
            },
            []
          ), this.t('el.pagination.pageClassifier')]
        );
      }
    },

    Total: {
      mixins: [_locale2.default],

      render: function render(h) {
        return typeof this.$parent.total === 'number' ? h(
          'span',
          { 'class': 'el-pagination__total' },
          [this.t('el.pagination.total', { total: this.$parent.total })]
        ) : '';
      }
    },

    Pager: _pager2.default
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.internalCurrentPage = this.getValidCurrentPage(val);
      this.userChangePageSize = true;
      this.emitChange();
    },
    prev: function prev() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage - 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('prev-click', this.internalCurrentPage);
      this.emitChange();
    },
    next: function next() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage + 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    getValidCurrentPage: function getValidCurrentPage(value) {
      value = parseInt(value, 10);

      var havePageCount = typeof this.internalPageCount === 'number';

      var resetValue = void 0;
      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if (resetValue === undefined && isNaN(value)) {
        resetValue = 1;
      } else if (resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    },
    emitChange: function emitChange() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.internalCurrentPage !== _this3.lastEmittedPage || _this3.userChangePageSize) {
          _this3.$emit('current-change', _this3.internalCurrentPage);
          _this3.lastEmittedPage = _this3.internalCurrentPage;
          _this3.userChangePageSize = false;
        }
      });
    }
  },

  computed: {
    internalPageCount: function internalPageCount() {
      if (typeof this.total === 'number') {
        return Math.ceil(this.total / this.internalPageSize);
      } else if (typeof this.pageCount === 'number') {
        return this.pageCount;
      }
      return null;
    }
  },

  watch: {
    currentPage: {
      immediate: true,
      handler: function handler(val) {
        this.internalCurrentPage = val;
      }
    },

    pageSize: {
      immediate: true,
      handler: function handler(val) {
        this.internalPageSize = isNaN(val) ? 10 : val;
      }
    },

    internalCurrentPage: {
      immediate: true,
      handler: function handler(newVal, oldVal) {
        newVal = parseInt(newVal, 10);

        /* istanbul ignore if */
        if (isNaN(newVal)) {
          newVal = oldVal || 1;
        } else {
          newVal = this.getValidCurrentPage(newVal);
        }

        if (newVal !== undefined) {
          this.internalCurrentPage = newVal;
          if (oldVal !== newVal) {
            this.$emit('update:currentPage', newVal);
          }
        } else {
          this.$emit('update:currentPage', newVal);
        }
      }
    },

    internalPageCount: function internalPageCount(newVal) {
      /* istanbul ignore if */
      var oldPage = this.internalCurrentPage;
      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
        this.userChangePageSize && this.emitChange();
      }
      this.userChangePageSize = false;
    }
  }
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b72590_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pager_vue__ = __webpack_require__(52);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b72590_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElPager',

  props: {
    currentPage: Number,

    pageCount: Number,

    pagerCount: Number,

    disabled: Boolean
  },

  watch: {
    showPrevMore: function showPrevMore(val) {
      if (!val) this.quickprevIconClass = 'el-icon-more';
    },
    showNextMore: function showNextMore(val) {
      if (!val) this.quicknextIconClass = 'el-icon-more';
    }
  },

  methods: {
    onPagerClick: function onPagerClick(event) {
      var target = event.target;
      if (target.tagName === 'UL' || this.disabled) {
        return;
      }

      var newPage = Number(event.target.textContent);
      var pageCount = this.pageCount;
      var currentPage = this.currentPage;
      var pagerCountOffset = this.pagerCount - 2;

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - pagerCountOffset;
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + pagerCountOffset;
        }
      }

      /* istanbul ignore if */
      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1;
        }

        if (newPage > pageCount) {
          newPage = pageCount;
        }
      }

      if (newPage !== currentPage) {
        this.$emit('change', newPage);
      }
    },
    onMouseenter: function onMouseenter(direction) {
      if (this.disabled) return;
      if (direction === 'left') {
        this.quickprevIconClass = 'el-icon-d-arrow-left';
      } else {
        this.quicknextIconClass = 'el-icon-d-arrow-right';
      }
    }
  },

  computed: {
    pagers: function pagers() {
      var pagerCount = this.pagerCount;
      var halfPagerCount = (pagerCount - 1) / 2;

      var currentPage = Number(this.currentPage);
      var pageCount = Number(this.pageCount);

      var showPrevMore = false;
      var showNextMore = false;

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      var array = [];

      if (showPrevMore && !showNextMore) {
        var startPage = pageCount - (pagerCount - 2);
        for (var i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (var _i = 2; _i < pagerCount; _i++) {
          array.push(_i);
        }
      } else if (showPrevMore && showNextMore) {
        var offset = Math.floor(pagerCount / 2) - 1;
        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
          array.push(_i2);
        }
      } else {
        for (var _i3 = 2; _i3 < pageCount; _i3++) {
          array.push(_i3);
        }
      }

      this.showPrevMore = showPrevMore;
      this.showNextMore = showNextMore;

      return array;
    }
  },

  data: function data() {
    return {
      current: null,
      showPrevMore: false,
      showNextMore: false,
      quicknextIconClass: 'el-icon-more',
      quickprevIconClass: 'el-icon-more'
    };
  }
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"el-pager",on:{"click":_vm.onPagerClick}},[(_vm.pageCount > 0)?_c('li',{staticClass:"number",class:{ active: _vm.currentPage === 1, disabled: _vm.disabled }},[_vm._v("1")]):_vm._e(),(_vm.showPrevMore)?_c('li',{staticClass:"el-icon more btn-quickprev",class:[_vm.quickprevIconClass, { disabled: _vm.disabled }],on:{"mouseenter":function($event){_vm.onMouseenter('left')},"mouseleave":function($event){_vm.quickprevIconClass = 'el-icon-more'}}}):_vm._e(),_vm._l((_vm.pagers),function(pager){return _c('li',{key:pager,staticClass:"number",class:{ active: _vm.currentPage === pager, disabled: _vm.disabled }},[_vm._v(_vm._s(pager))])}),(_vm.showNextMore)?_c('li',{staticClass:"el-icon more btn-quicknext",class:[_vm.quicknextIconClass, { disabled: _vm.disabled }],on:{"mouseenter":function($event){_vm.onMouseenter('right')},"mouseleave":function($event){_vm.quicknextIconClass = 'el-icon-more'}}}):_vm._e(),(_vm.pageCount > 1)?_c('li',{staticClass:"number",class:{ active: _vm.currentPage === _vm.pageCount, disabled: _vm.disabled }},[_vm._v(_vm._s(_vm.pageCount))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(275);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(276);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _component = __webpack_require__(56);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_component2.default.install = function (Vue) {
  Vue.component(_component2.default.name, _component2.default);
};

exports.default = _component2.default;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab518c0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__ = __webpack_require__(58);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab518c0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _popup = __webpack_require__(12);

var _popup2 = _interopRequireDefault(_popup);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElDialog',

  mixins: [_popup2.default, _emitter2.default, _migrating2.default],

  props: {
    title: {
      type: String,
      default: ''
    },

    modal: {
      type: Boolean,
      default: true
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: false
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: true
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    width: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ''
    },

    top: {
      type: String,
      default: '15vh'
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      closed: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(function () {
          _this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
      }
    }
  },

  computed: {
    style: function style() {
      var style = {};
      if (this.width) {
        style.width = this.width;
      }
      if (!this.fullscreen) {
        style.marginTop = this.top;
      }
      return style;
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'size': 'size is removed.'
        }
      };
    },
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-dialog__wrapper",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleWrapperClick($event)}}},[_c('div',{ref:"dialog",staticClass:"el-dialog",class:[{ 'is-fullscreen': _vm.fullscreen, 'el-dialog--center': _vm.center }, _vm.customClass],style:(_vm.style)},[_c('div',{staticClass:"el-dialog__header"},[_vm._t("title",[_c('span',{staticClass:"el-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),(_vm.showClose)?_c('button',{staticClass:"el-dialog__headerbtn",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"el-dialog__close el-icon el-icon-close"})]):_vm._e()],2),(_vm.rendered)?_c('div',{staticClass:"el-dialog__body"},[_vm._t("default")],2):_vm._e(),(_vm.$slots.footer)?_c('div',{staticClass:"el-dialog__footer"},[_vm._t("footer")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _autocomplete = __webpack_require__(60);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_autocomplete2.default.install = function (Vue) {
  Vue.component(_autocomplete2.default.name, _autocomplete2.default);
};

exports.default = _autocomplete2.default;

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01836196_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(65);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01836196_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _autocompleteSuggestions = __webpack_require__(62);

var _autocompleteSuggestions2 = _interopRequireDefault(_autocompleteSuggestions);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _util = __webpack_require__(4);

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElAutocomplete',

  mixins: [_emitter2.default, (0, _focus2.default)('input'), _migrating2.default],

  componentName: 'ElAutocomplete',

  components: {
    ElInput: _input2.default,
    ElAutocompleteSuggestions: _autocompleteSuggestions2.default
  },

  directives: { Clickoutside: _clickoutside2.default },

  props: {
    valueKey: {
      type: String,
      default: 'value'
    },
    popperClass: String,
    popperOptions: Object,
    placeholder: String,
    disabled: Boolean,
    name: String,
    size: String,
    value: String,
    maxlength: Number,
    minlength: Number,
    autofocus: Boolean,
    fetchSuggestions: Function,
    triggerOnFocus: {
      type: Boolean,
      default: true
    },
    customItem: String,
    selectWhenUnmatched: {
      type: Boolean,
      default: false
    },
    prefixIcon: String,
    suffixIcon: String,
    label: String,
    debounce: {
      type: Number,
      default: 300
    },
    placement: {
      type: String,
      default: 'bottom-start'
    }
  },
  data: function data() {
    return {
      activated: false,
      isOnComposition: false,
      suggestions: [],
      loading: false,
      highlightedIndex: -1
    };
  },

  computed: {
    suggestionVisible: function suggestionVisible() {
      var suggestions = this.suggestions;
      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
      return (isValidData || this.loading) && this.activated;
    },
    id: function id() {
      return 'el-autocomplete-' + (0, _util.generateId)();
    }
  },
  watch: {
    suggestionVisible: function suggestionVisible(val) {
      this.broadcast('ElAutocompleteSuggestions', 'visible', [val, this.$refs.input.$refs.input.offsetWidth]);
    }
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'custom-item': 'custom-item is removed, use scoped slot instead.',
          'props': 'props is removed, use value-key instead.'
        }
      };
    },
    getData: function getData(queryString) {
      var _this = this;

      this.loading = true;
      this.fetchSuggestions(queryString, function (suggestions) {
        _this.loading = false;
        if (Array.isArray(suggestions)) {
          _this.suggestions = suggestions;
        } else {
          console.error('autocomplete suggestions must be an array');
        }
      });
    },
    handleComposition: function handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleChange(event.target.value);
      } else {
        this.isOnComposition = true;
      }
    },
    handleChange: function handleChange(value) {
      this.$emit('input', value);
      if (this.isOnComposition || !this.triggerOnFocus && !value) {
        this.suggestions = [];
        return;
      }
      this.debouncedGetData(value);
    },
    handleFocus: function handleFocus(event) {
      this.activated = true;
      this.$emit('focus', event);
      if (this.triggerOnFocus) {
        this.debouncedGetData(this.value);
      }
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    close: function close(e) {
      this.activated = false;
    },
    handleKeyEnter: function handleKeyEnter(e) {
      var _this2 = this;

      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
        e.preventDefault();
        this.select(this.suggestions[this.highlightedIndex]);
      } else if (this.selectWhenUnmatched) {
        this.$emit('select', { value: this.value });
        this.$nextTick(function (_) {
          _this2.suggestions = [];
          _this2.highlightedIndex = -1;
        });
      }
    },
    select: function select(item) {
      var _this3 = this;

      this.$emit('input', item[this.valueKey]);
      this.$emit('select', item);
      this.$nextTick(function (_) {
        _this3.suggestions = [];
        _this3.highlightedIndex = -1;
      });
    },
    highlight: function highlight(index) {
      if (!this.suggestionVisible || this.loading) {
        return;
      }
      if (index < 0) {
        this.highlightedIndex = -1;
        return;
      }
      if (index >= this.suggestions.length) {
        index = this.suggestions.length - 1;
      }
      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');

      var highlightItem = suggestionList[index];
      var scrollTop = suggestion.scrollTop;
      var offsetTop = highlightItem.offsetTop;

      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
        suggestion.scrollTop += highlightItem.scrollHeight;
      }
      if (offsetTop < scrollTop) {
        suggestion.scrollTop -= highlightItem.scrollHeight;
      }
      this.highlightedIndex = index;
      this.$el.querySelector('.el-input__inner').setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.debouncedGetData = (0, _debounce2.default)(this.debounce, function (val) {
      _this4.getData(val);
    });
    this.$on('item-click', function (item) {
      _this4.select(item);
    });
    var $input = this.$el.querySelector('.el-input__inner');
    $input.setAttribute('role', 'textbox');
    $input.setAttribute('aria-autocomplete', 'list');
    $input.setAttribute('aria-controls', 'id');
    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.suggestions.$destroy();
  }
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_suggestions_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_suggestions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_suggestions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f749952_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocomplete_suggestions_vue__ = __webpack_require__(64);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autocomplete_suggestions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f749952_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_autocomplete_suggestions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _scrollbar = __webpack_require__(18);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ElScrollbar: _scrollbar2.default },
  mixins: [_vuePopper2.default, _emitter2.default],

  componentName: 'ElAutocompleteSuggestions',

  data: function data() {
    return {
      parent: this.$parent,
      dropdownWidth: ''
    };
  },


  props: {
    options: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },
    id: String
  },

  methods: {
    select: function select(item) {
      this.dispatch('ElAutocomplete', 'item-click', item);
    }
  },

  updated: function updated() {
    var _this = this;

    this.$nextTick(function (_) {
      _this.updatePopper();
    });
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$refs.input.$refs.input;
    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
    this.referenceList.setAttribute('role', 'listbox');
    this.referenceList.setAttribute('id', this.id);
  },
  created: function created() {
    var _this2 = this;

    this.$on('visible', function (val, inputWidth) {
      _this2.dropdownWidth = inputWidth + 'px';
      _this2.showPopper = val;
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-autocomplete-suggestion el-popper",class:{ 'is-loading': _vm.parent.loading },style:({ width: _vm.dropdownWidth }),attrs:{"role":"region"}},[_c('el-scrollbar',{attrs:{"tag":"ul","wrap-class":"el-autocomplete-suggestion__wrap","view-class":"el-autocomplete-suggestion__list"}},[(_vm.parent.loading)?_c('li',[_c('i',{staticClass:"el-icon-loading"})]):_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.close),expression:"close"}],staticClass:"el-autocomplete",attrs:{"aria-haspopup":"listbox","role":"combobox","aria-expanded":_vm.suggestionVisible,"aria-owns":_vm.id}},[_c('el-input',_vm._b({ref:"input",attrs:{"label":_vm.label},on:{"input":_vm.handleChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur},nativeOn:{"compositionstart":function($event){_vm.handleComposition($event)},"compositionupdate":function($event){_vm.handleComposition($event)},"compositionend":function($event){_vm.handleComposition($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.highlight(_vm.highlightedIndex - 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.highlight(_vm.highlightedIndex + 1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleKeyEnter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.close($event)}]}},'el-input',_vm.$props,false),[(_vm.$slots.prepend)?_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.$slots.append)?_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._t("append")],2):_vm._e(),(_vm.$slots.prefix)?_c('template',{attrs:{"slot":"prefix"},slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),(_vm.$slots.suffix)?_c('template',{attrs:{"slot":"suffix"},slot:"suffix"},[_vm._t("suffix")],2):_vm._e()],2),_c('el-autocomplete-suggestions',{ref:"suggestions",class:[_vm.popperClass ? _vm.popperClass : ''],attrs:{"visible-arrow":"","popper-options":_vm.popperOptions,"placement":_vm.placement,"id":_vm.id}},_vm._l((_vm.suggestions),function(item,index){return _c('li',{key:index,class:{'highlighted': _vm.highlightedIndex === index},attrs:{"id":(_vm.id + "-item-" + index),"role":"option","aria-selected":_vm.highlightedIndex === index},on:{"click":function($event){_vm.select(item)}}},[_vm._t("default",[_vm._v("\n        "+_vm._s(item[_vm.valueKey])+"\n      ")],{item:item})],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dropdown = __webpack_require__(67);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_dropdown2.default.install = function (Vue) {
  Vue.component(_dropdown2.default.name, _dropdown2.default);
};

exports.default = _dropdown2.default;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

var _buttonGroup = __webpack_require__(69);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElDropdown',

  componentName: 'ElDropdown',

  mixins: [_emitter2.default, _migrating2.default],

  directives: { Clickoutside: _clickoutside2.default },

  components: {
    ElButton: _button2.default,
    ElButtonGroup: _buttonGroup2.default
  },

  provide: function provide() {
    return {
      dropdown: this
    };
  },


  props: {
    trigger: {
      type: String,
      default: 'hover'
    },
    type: String,
    size: {
      type: String,
      default: ''
    },
    splitButton: Boolean,
    hideOnClick: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'bottom-end'
    },
    visibleArrow: {
      default: true
    },
    showTimeout: {
      type: Number,
      default: 250
    },
    hideTimeout: {
      type: Number,
      default: 150
    }
  },

  data: function data() {
    return {
      timeout: null,
      visible: false,
      triggerElm: null,
      menuItems: null,
      menuItemsArray: null,
      dropdownElm: null,
      focusing: false
    };
  },


  computed: {
    dropdownSize: function dropdownSize() {
      return this.size || (this.$ELEMENT || {}).size;
    },
    listId: function listId() {
      return 'dropdown-menu-' + (0, _util.generateId)();
    }
  },

  mounted: function mounted() {
    this.$on('menu-item-click', this.handleMenuItemClick);
    this.initEvent();
    this.initAria();
  },


  watch: {
    visible: function visible(val) {
      this.broadcast('ElDropdownMenu', 'visible', val);
      this.$emit('visible-change', val);
    },
    focusing: function focusing(val) {
      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
      if (selfDefine) {
        // 自定义
        if (val) {
          selfDefine.className += ' focusing';
        } else {
          selfDefine.className = selfDefine.className.replace('focusing', '');
        }
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'menu-align': 'menu-align is renamed to placement.'
        }
      };
    },
    show: function show() {
      var _this = this;

      if (this.triggerElm.disabled) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.visible = true;
      }, this.trigger === 'click' ? 0 : this.showTimeout);
    },
    hide: function hide() {
      var _this2 = this;

      if (this.triggerElm.disabled) return;
      this.removeTabindex();
      this.resetTabindex(this.triggerElm);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.visible = false;
      }, this.trigger === 'click' ? 0 : this.hideTimeout);
    },
    handleClick: function handleClick() {
      if (this.triggerElm.disabled) return;
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    },
    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
      var keyCode = ev.keyCode;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        this.removeTabindex();
        this.resetTabindex(this.menuItems[0]);
        this.menuItems[0].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // space enter选中
        this.handleClick();
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab || esc
        this.hide();
      }
      return;
    },
    handleItemKeyDown: function handleItemKeyDown(ev) {
      var keyCode = ev.keyCode;
      var target = ev.target;
      var currentIndex = this.menuItemsArray.indexOf(target);
      var max = this.menuItemsArray.length - 1;
      var nextIndex = void 0;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        if (keyCode === 38) {
          // up
          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
        } else {
          // down
          nextIndex = currentIndex < max ? currentIndex + 1 : max;
        }
        this.removeTabindex();
        this.resetTabindex(this.menuItems[nextIndex]);
        this.menuItems[nextIndex].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // enter选中
        this.triggerElm.focus();
        target.click();
        if (!this.hideOnClick) {
          // click关闭
          this.visible = false;
        }
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab // esc
        this.hide();
        this.triggerElm.focus();
      }
      return;
    },
    resetTabindex: function resetTabindex(ele) {
      // 下次tab时组件聚焦元素
      this.removeTabindex();
      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
    },
    removeTabindex: function removeTabindex() {
      this.triggerElm.setAttribute('tabindex', '-1');
      this.menuItemsArray.forEach(function (item) {
        item.setAttribute('tabindex', '-1');
      });
    },
    initAria: function initAria() {
      this.dropdownElm.setAttribute('id', this.listId);
      this.triggerElm.setAttribute('aria-haspopup', 'list');
      this.triggerElm.setAttribute('aria-controls', this.listId);
      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
      this.menuItemsArray = Array.prototype.slice.call(this.menuItems);

      if (!this.splitButton) {
        // 自定义
        this.triggerElm.setAttribute('role', 'button');
        this.triggerElm.setAttribute('tabindex', '0');
        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
      }
    },
    initEvent: function initEvent() {
      var _this3 = this;

      var trigger = this.trigger,
          show = this.show,
          hide = this.hide,
          handleClick = this.handleClick,
          splitButton = this.splitButton,
          handleTriggerKeyDown = this.handleTriggerKeyDown,
          handleItemKeyDown = this.handleItemKeyDown;

      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;

      var dropdownElm = this.dropdownElm = this.$slots.dropdown[0].elm;

      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
      // 控制自定义元素的样式
      if (!splitButton) {
        this.triggerElm.addEventListener('focus', function () {
          _this3.focusing = true;
        });
        this.triggerElm.addEventListener('blur', function () {
          _this3.focusing = false;
        });
        this.triggerElm.addEventListener('click', function () {
          _this3.focusing = false;
        });
      }
      if (trigger === 'hover') {
        this.triggerElm.addEventListener('mouseenter', show);
        this.triggerElm.addEventListener('mouseleave', hide);
        dropdownElm.addEventListener('mouseenter', show);
        dropdownElm.addEventListener('mouseleave', hide);
      } else if (trigger === 'click') {
        this.triggerElm.addEventListener('click', handleClick);
      }
    },
    handleMenuItemClick: function handleMenuItemClick(command, instance) {
      if (this.hideOnClick) {
        this.visible = false;
      }
      this.$emit('command', command, instance);
    },
    focus: function focus() {
      this.triggerElm.focus && this.triggerElm.focus();
    }
  },

  render: function render(h) {
    var _this4 = this;

    var hide = this.hide,
        splitButton = this.splitButton,
        type = this.type,
        dropdownSize = this.dropdownSize;


    var handleMainButtonClick = function handleMainButtonClick(event) {
      _this4.$emit('click', event);
      hide();
    };

    var triggerElm = !splitButton ? this.$slots.default : h(
      'el-button-group',
      null,
      [h(
        'el-button',
        {
          attrs: { type: type, size: dropdownSize },
          nativeOn: {
            'click': handleMainButtonClick
          }
        },
        [this.$slots.default]
      ), h(
        'el-button',
        { ref: 'trigger', attrs: { type: type, size: dropdownSize },
          'class': 'el-dropdown__caret-button' },
        [h(
          'i',
          { 'class': 'el-dropdown__icon el-icon-arrow-down' },
          []
        )]
      )]
    );

    return h(
      'div',
      { 'class': 'el-dropdown', directives: [{
          name: 'clickoutside',
          value: hide
        }]
      },
      [triggerElm, this.$slots.dropdown]
    );
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(277);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dropdownMenu = __webpack_require__(71);

var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_dropdownMenu2.default.install = function (Vue) {
  Vue.component(_dropdownMenu2.default.name, _dropdownMenu2.default);
};

exports.default = _dropdownMenu2.default;

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_menu_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066202f2_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_menu_vue__ = __webpack_require__(73);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_menu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066202f2_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElDropdownMenu',

  componentName: 'ElDropdownMenu',

  mixins: [_vuePopper2.default],

  props: {
    visibleArrow: {
      type: Boolean,
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      size: this.dropdown.dropdownSize
    };
  },


  inject: ['dropdown'],

  created: function created() {
    var _this = this;

    this.$on('updatePopper', function () {
      if (_this.showPopper) _this.updatePopper();
    });
    this.$on('visible', function (val) {
      _this.showPopper = val;
    });
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },


  watch: {
    'dropdown.placement': {
      immediate: true,
      handler: function handler(val) {
        this.currentPlacement = val;
      }
    }
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-dropdown-menu el-popper",class:[_vm.size && ("el-dropdown-menu--" + _vm.size)]},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dropdownItem = __webpack_require__(75);

var _dropdownItem2 = _interopRequireDefault(_dropdownItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_dropdownItem2.default.install = function (Vue) {
  Vue.component(_dropdownItem2.default.name, _dropdownItem2.default);
};

exports.default = _dropdownItem2.default;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_item_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fb6a3b_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_item_vue__ = __webpack_require__(77);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dropdown_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66fb6a3b_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dropdown_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElDropdownItem',

  mixins: [_emitter2.default],

  props: {
    command: {},
    disabled: Boolean,
    divided: Boolean
  },

  methods: {
    handleClick: function handleClick(e) {
      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-dropdown-menu__item",class:{
    'is-disabled': _vm.disabled,
    'el-dropdown-menu__item--divided': _vm.divided
  },attrs:{"aria-disabled":_vm.disabled,"tabindex":_vm.disabled ? null : -1},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _menu = __webpack_require__(79);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_menu2.default.install = function (Vue) {
  Vue.component(_menu2.default.name, _menu2.default);
};

exports.default = _menu2.default;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _ariaMenubar = __webpack_require__(81);

var _ariaMenubar2 = _interopRequireDefault(_ariaMenubar);

var _dom = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElMenu',

  render: function render(h) {
    var component = h(
      'ul',
      {
        attrs: {
          role: 'menubar'
        },
        key: +this.collapse,
        style: { backgroundColor: this.backgroundColor || '' },
        'class': {
          'el-menu--horizontal': this.mode === 'horizontal',
          'el-menu--collapse': this.collapse,
          "el-menu": true
        }
      },
      [this.$slots.default]
    );

    if (this.collapseTransition) {
      return h(
        'el-menu-collapse-transition',
        null,
        [component]
      );
    } else {
      return component;
    }
  },


  componentName: 'ElMenu',

  mixins: [_emitter2.default, _migrating2.default],

  provide: function provide() {
    return {
      rootMenu: this
    };
  },


  components: {
    'el-menu-collapse-transition': {
      functional: true,
      render: function render(createElement, context) {
        var data = {
          props: {
            mode: 'out-in'
          },
          on: {
            beforeEnter: function beforeEnter(el) {
              el.style.opacity = 0.2;
            },
            enter: function enter(el) {
              (0, _dom.addClass)(el, 'el-opacity-transition');
              el.style.opacity = 1;
            },
            afterEnter: function afterEnter(el) {
              (0, _dom.removeClass)(el, 'el-opacity-transition');
              el.style.opacity = '';
            },
            beforeLeave: function beforeLeave(el) {
              if (!el.dataset) el.dataset = {};

              if ((0, _dom.hasClass)(el, 'el-menu--collapse')) {
                (0, _dom.removeClass)(el, 'el-menu--collapse');
                el.dataset.oldOverflow = el.style.overflow;
                el.dataset.scrollWidth = el.clientWidth;
                (0, _dom.addClass)(el, 'el-menu--collapse');
              } else {
                (0, _dom.addClass)(el, 'el-menu--collapse');
                el.dataset.oldOverflow = el.style.overflow;
                el.dataset.scrollWidth = el.clientWidth;
                (0, _dom.removeClass)(el, 'el-menu--collapse');
              }

              el.style.width = el.scrollWidth + 'px';
              el.style.overflow = 'hidden';
            },
            leave: function leave(el) {
              (0, _dom.addClass)(el, 'horizontal-collapse-transition');
              el.style.width = el.dataset.scrollWidth + 'px';
            }
          }
        };
        return createElement('transition', data, context.children);
      }
    }
  },

  props: {
    mode: {
      type: String,
      default: 'vertical'
    },
    defaultActive: {
      type: String,
      default: ''
    },
    defaultOpeneds: Array,
    uniqueOpened: Boolean,
    router: Boolean,
    menuTrigger: {
      type: String,
      default: 'hover'
    },
    collapse: Boolean,
    backgroundColor: String,
    textColor: String,
    activeTextColor: String,
    collapseTransition: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      activeIndex: this.defaultActive,
      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
      items: {},
      submenus: {}
    };
  },

  computed: {
    hoverBackground: function hoverBackground() {
      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
    },
    isMenuPopup: function isMenuPopup() {
      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
    }
  },
  watch: {
    defaultActive: 'updateActiveIndex',

    defaultOpeneds: function defaultOpeneds(value) {
      if (!this.collapse) {
        this.openedMenus = value;
      }
    },
    collapse: function collapse(value) {
      if (value) this.openedMenus = [];
      this.broadcast('ElSubmenu', 'toggle-collapse', value);
    }
  },
  methods: {
    updateActiveIndex: function updateActiveIndex() {
      var item = this.items[this.defaultActive];
      if (item) {
        this.activeIndex = item.index;
        this.initOpenedMenu();
      } else {
        this.activeIndex = null;
      }
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'theme': 'theme is removed.'
        }
      };
    },
    getColorChannels: function getColorChannels(color) {
      color = color.replace('#', '');
      if (/^[0-9a-fA-F]{3}$/.test(color)) {
        color = color.split('');
        for (var i = 2; i >= 0; i--) {
          color.splice(i, 0, color[i]);
        }
        color = color.join('');
      }
      if (/^[0-9a-fA-F]{6}$/.test(color)) {
        return {
          red: parseInt(color.slice(0, 2), 16),
          green: parseInt(color.slice(2, 4), 16),
          blue: parseInt(color.slice(4, 6), 16)
        };
      } else {
        return {
          red: 255,
          green: 255,
          blue: 255
        };
      }
    },
    mixColor: function mixColor(color, percent) {
      var _getColorChannels = this.getColorChannels(color),
          red = _getColorChannels.red,
          green = _getColorChannels.green,
          blue = _getColorChannels.blue;

      if (percent > 0) {
        // shade given color
        red *= 1 - percent;
        green *= 1 - percent;
        blue *= 1 - percent;
      } else {
        // tint given color
        red += (255 - red) * percent;
        green += (255 - green) * percent;
        blue += (255 - blue) * percent;
      }
      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
    },
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    openMenu: function openMenu(index, indexPath) {
      var openedMenus = this.openedMenus;
      if (openedMenus.indexOf(index) !== -1) return;
      // 将不在该菜单路径下的其余菜单收起
      // collapse all menu that are not under current menu item
      if (this.uniqueOpened) {
        this.openedMenus = openedMenus.filter(function (index) {
          return indexPath.indexOf(index) !== -1;
        });
      }
      this.openedMenus.push(index);
    },
    closeMenu: function closeMenu(index) {
      var i = this.openedMenus.indexOf(index);
      if (i !== -1) {
        this.openedMenus.splice(i, 1);
      }
    },
    handleSubmenuClick: function handleSubmenuClick(submenu) {
      var index = submenu.index,
          indexPath = submenu.indexPath;

      var isOpened = this.openedMenus.indexOf(index) !== -1;

      if (isOpened) {
        this.closeMenu(index);
        this.$emit('close', index, indexPath);
      } else {
        this.openMenu(index, indexPath);
        this.$emit('open', index, indexPath);
      }
    },
    handleItemClick: function handleItemClick(item) {
      var _this = this;

      var index = item.index,
          indexPath = item.indexPath;

      var oldActiveIndex = this.activeIndex;

      this.activeIndex = item.index;
      this.$emit('select', index, indexPath, item);

      if (this.mode === 'horizontal' || this.collapse) {
        this.openedMenus = [];
      }

      if (this.router) {
        this.routeToItem(item, function (error) {
          _this.activeIndex = oldActiveIndex;
          if (error) console.error(error);
        });
      }
    },

    // 初始化展开菜单
    // initialize opened menu
    initOpenedMenu: function initOpenedMenu() {
      var _this2 = this;

      var index = this.activeIndex;
      var activeItem = this.items[index];
      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;

      var indexPath = activeItem.indexPath;

      // 展开该菜单项的路径上所有子菜单
      // expand all submenus of the menu item
      indexPath.forEach(function (index) {
        var submenu = _this2.submenus[index];
        submenu && _this2.openMenu(index, submenu.indexPath);
      });
    },
    routeToItem: function routeToItem(item, onError) {
      var route = item.route || item.index;
      try {
        this.$router.push(route, function () {}, onError);
      } catch (e) {
        console.error(e);
      }
    },
    open: function open(index) {
      var _this3 = this;

      var indexPath = this.submenus[index.toString()].indexPath;

      indexPath.forEach(function (i) {
        return _this3.openMenu(i, indexPath);
      });
    },
    close: function close(index) {
      this.closeMenu(index);
    }
  },
  mounted: function mounted() {
    this.initOpenedMenu();
    this.$on('item-click', this.handleItemClick);
    this.$on('submenu-click', this.handleSubmenuClick);
    if (this.mode === 'horizontal') {
      new _ariaMenubar2.default(this.$el); // eslint-disable-line
    }
    this.$watch('items', this.updateActiveIndex);
  }
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ariaMenuitem = __webpack_require__(82);

var _ariaMenuitem2 = _interopRequireDefault(_ariaMenuitem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(domNode) {
  this.domNode = domNode;
  this.init();
};

Menu.prototype.init = function () {
  var menuChildren = this.domNode.childNodes;
  [].filter.call(menuChildren, function (child) {
    return child.nodeType === 1;
  }).forEach(function (child) {
    new _ariaMenuitem2.default(child); // eslint-disable-line
  });
};
exports.default = Menu;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ariaUtils = __webpack_require__(31);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

var _ariaSubmenu = __webpack_require__(83);

var _ariaSubmenu2 = _interopRequireDefault(_ariaSubmenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItem = function MenuItem(domNode) {
  this.domNode = domNode;
  this.submenu = null;
  this.init();
};

MenuItem.prototype.init = function () {
  this.domNode.setAttribute('tabindex', '0');
  var menuChild = this.domNode.querySelector('.el-menu');
  if (menuChild) {
    this.submenu = new _ariaSubmenu2.default(this, menuChild);
  }
  this.addListeners();
};

MenuItem.prototype.addListeners = function () {
  var _this = this;

  var keys = _ariaUtils2.default.keys;
  this.domNode.addEventListener('keydown', function (event) {
    var prevDef = false;
    switch (event.keyCode) {
      case keys.down:
        _ariaUtils2.default.triggerEvent(event.currentTarget, 'mouseenter');
        _this.submenu && _this.submenu.gotoSubIndex(0);
        prevDef = true;
        break;
      case keys.up:
        _ariaUtils2.default.triggerEvent(event.currentTarget, 'mouseenter');
        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
        prevDef = true;
        break;
      case keys.tab:
        _ariaUtils2.default.triggerEvent(event.currentTarget, 'mouseleave');
        break;
      case keys.enter:
      case keys.space:
        prevDef = true;
        event.currentTarget.click();
        break;
    }
    if (prevDef) {
      event.preventDefault();
    }
  });
};

exports.default = MenuItem;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ariaUtils = __webpack_require__(31);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubMenu = function SubMenu(parent, domNode) {
  this.domNode = domNode;
  this.parent = parent;
  this.subMenuItems = [];
  this.subIndex = 0;
  this.init();
};

SubMenu.prototype.init = function () {
  this.subMenuItems = this.domNode.querySelectorAll('li');
  this.addListeners();
};

SubMenu.prototype.gotoSubIndex = function (idx) {
  if (idx === this.subMenuItems.length) {
    idx = 0;
  } else if (idx < 0) {
    idx = this.subMenuItems.length - 1;
  }
  this.subMenuItems[idx].focus();
  this.subIndex = idx;
};

SubMenu.prototype.addListeners = function () {
  var _this = this;

  var keys = _ariaUtils2.default.keys;
  var parentNode = this.parent.domNode;
  Array.prototype.forEach.call(this.subMenuItems, function (el) {
    el.addEventListener('keydown', function (event) {
      var prevDef = false;
      switch (event.keyCode) {
        case keys.down:
          _this.gotoSubIndex(_this.subIndex + 1);
          prevDef = true;
          break;
        case keys.up:
          _this.gotoSubIndex(_this.subIndex - 1);
          prevDef = true;
          break;
        case keys.tab:
          _ariaUtils2.default.triggerEvent(parentNode, 'mouseleave');
          break;
        case keys.enter:
        case keys.space:
          prevDef = true;
          event.currentTarget.click();
          break;
      }
      if (prevDef) {
        event.preventDefault();
        event.stopPropagation();
      }
      return false;
    });
  });
};

exports.default = SubMenu;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _submenu = __webpack_require__(85);

var _submenu2 = _interopRequireDefault(_submenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_submenu2.default.install = function (Vue) {
  Vue.component(_submenu2.default.name, _submenu2.default);
};

exports.default = _submenu2.default;

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_submenu_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _collapseTransition = __webpack_require__(20);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

var _menuMixin = __webpack_require__(32);

var _menuMixin2 = _interopRequireDefault(_menuMixin);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var poperMixins = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: false
    },
    offset: _vuePopper2.default.props.offset,
    boundariesPadding: _vuePopper2.default.props.boundariesPadding,
    popperOptions: _vuePopper2.default.props.popperOptions
  },
  data: _vuePopper2.default.data,
  methods: _vuePopper2.default.methods,
  beforeDestroy: _vuePopper2.default.beforeDestroy,
  deactivated: _vuePopper2.default.deactivated
};

exports.default = {
  name: 'ElSubmenu',

  componentName: 'ElSubmenu',

  mixins: [_menuMixin2.default, _emitter2.default, poperMixins],

  components: { ElCollapseTransition: _collapseTransition2.default },

  props: {
    index: {
      type: String,
      required: true
    },
    showTimeout: {
      type: Number,
      default: 300
    },
    hideTimeout: {
      type: Number,
      default: 300
    },
    popperClass: String,
    disabled: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: undefined
    }
  },

  data: function data() {
    return {
      popperJS: null,
      timeout: null,
      items: {},
      submenus: {},
      mouseInChild: false
    };
  },

  watch: {
    opened: function opened(val) {
      var _this = this;

      if (this.isMenuPopup) {
        this.$nextTick(function (_) {
          _this.updatePopper();
        });
      }
    }
  },
  computed: {
    // popper option
    appendToBody: function appendToBody() {
      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
    },
    menuTransitionName: function menuTransitionName() {
      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
    },
    opened: function opened() {
      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
    },
    active: function active() {
      var isActive = false;
      var submenus = this.submenus;
      var items = this.items;

      Object.keys(items).forEach(function (index) {
        if (items[index].active) {
          isActive = true;
        }
      });

      Object.keys(submenus).forEach(function (index) {
        if (submenus[index].active) {
          isActive = true;
        }
      });

      return isActive;
    },
    hoverBackground: function hoverBackground() {
      return this.rootMenu.hoverBackground;
    },
    backgroundColor: function backgroundColor() {
      return this.rootMenu.backgroundColor || '';
    },
    activeTextColor: function activeTextColor() {
      return this.rootMenu.activeTextColor || '';
    },
    textColor: function textColor() {
      return this.rootMenu.textColor || '';
    },
    mode: function mode() {
      return this.rootMenu.mode;
    },
    isMenuPopup: function isMenuPopup() {
      return this.rootMenu.isMenuPopup;
    },
    titleStyle: function titleStyle() {
      if (this.mode !== 'horizontal') {
        return {
          color: this.textColor
        };
      }
      return {
        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
        color: this.active ? this.activeTextColor : this.textColor
      };
    },
    isFirstLevel: function isFirstLevel() {
      var isFirstLevel = true;
      var parent = this.$parent;
      while (parent && parent !== this.rootMenu) {
        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
          isFirstLevel = false;
          break;
        } else {
          parent = parent.$parent;
        }
      }
      return isFirstLevel;
    }
  },
  methods: {
    handleCollapseToggle: function handleCollapseToggle(value) {
      if (value) {
        this.initPopper();
      } else {
        this.doDestroy();
      }
    },
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    handleClick: function handleClick() {
      var rootMenu = this.rootMenu,
          disabled = this.disabled;

      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
        return;
      }
      this.dispatch('ElMenu', 'submenu-click', this);
    },
    handleMouseenter: function handleMouseenter() {
      var _this2 = this;

      var rootMenu = this.rootMenu,
          disabled = this.disabled;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
        return;
      }
      this.dispatch('ElSubmenu', 'mouse-enter-child');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
      }, this.showTimeout);
    },
    handleMouseleave: function handleMouseleave() {
      var _this3 = this;

      var rootMenu = this.rootMenu;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
        return;
      }
      this.dispatch('ElSubmenu', 'mouse-leave-child');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
      }, this.hideTimeout);
    },
    handleTitleMouseenter: function handleTitleMouseenter() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      var title = this.$refs['submenu-title'];
      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
    },
    handleTitleMouseleave: function handleTitleMouseleave() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      var title = this.$refs['submenu-title'];
      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
    },
    updatePlacement: function updatePlacement() {
      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
    },
    initPopper: function initPopper() {
      this.referenceElm = this.$el;
      this.popperElm = this.$refs.menu;
      this.updatePlacement();
    }
  },
  created: function created() {
    var _this4 = this;

    this.parentMenu.addSubmenu(this);
    this.rootMenu.addSubmenu(this);
    this.$on('toggle-collapse', this.handleCollapseToggle);
    this.$on('mouse-enter-child', function () {
      _this4.mouseInChild = true;
      clearTimeout(_this4.timeout);
    });
    this.$on('mouse-leave-child', function () {
      _this4.mouseInChild = false;
      clearTimeout(_this4.timeout);
    });
  },
  mounted: function mounted() {
    this.initPopper();
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeSubmenu(this);
    this.rootMenu.removeSubmenu(this);
  },
  render: function render(h) {
    var active = this.active,
        opened = this.opened,
        paddingStyle = this.paddingStyle,
        titleStyle = this.titleStyle,
        backgroundColor = this.backgroundColor,
        rootMenu = this.rootMenu,
        currentPlacement = this.currentPlacement,
        menuTransitionName = this.menuTransitionName,
        mode = this.mode,
        disabled = this.disabled,
        popperClass = this.popperClass,
        $slots = this.$slots,
        isFirstLevel = this.isFirstLevel;


    var popupMenu = h(
      'transition',
      {
        attrs: { name: menuTransitionName }
      },
      [h(
        'div',
        {
          ref: 'menu',
          directives: [{
            name: 'show',
            value: opened
          }],

          'class': ['el-menu--' + mode, popperClass],
          on: {
            'mouseenter': this.handleMouseenter,
            'mouseleave': this.handleMouseleave,
            'focus': this.handleMouseenter
          }
        },
        [h(
          'ul',
          {
            attrs: {
              role: 'menu'
            },
            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
            style: { backgroundColor: rootMenu.backgroundColor || '' } },
          [$slots.default]
        )]
      )]
    );

    var inlineMenu = h(
      'el-collapse-transition',
      null,
      [h(
        'ul',
        {
          attrs: {
            role: 'menu'
          },
          'class': 'el-menu el-menu--inline',
          directives: [{
            name: 'show',
            value: opened
          }],

          style: { backgroundColor: rootMenu.backgroundColor || '' } },
        [$slots.default]
      )]
    );

    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';

    return h(
      'li',
      {
        'class': {
          'el-submenu': true,
          'is-active': active,
          'is-opened': opened,
          'is-disabled': disabled
        },
        attrs: { role: 'menuitem',
          'aria-haspopup': 'true',
          'aria-expanded': opened
        },
        on: {
          'mouseenter': this.handleMouseenter,
          'mouseleave': this.handleMouseleave,
          'focus': this.handleMouseenter
        }
      },
      [h(
        'div',
        {
          'class': 'el-submenu__title',
          ref: 'submenu-title',
          on: {
            'click': this.handleClick,
            'mouseenter': this.handleTitleMouseenter,
            'mouseleave': this.handleTitleMouseleave
          },

          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
        },
        [$slots.title, h(
          'i',
          { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] },
          []
        )]
      ), this.isMenuPopup ? popupMenu : inlineMenu]
    );
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _menuItem = __webpack_require__(88);

var _menuItem2 = _interopRequireDefault(_menuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_menuItem2.default.install = function (Vue) {
  Vue.component(_menuItem2.default.name, _menuItem2.default);
};

exports.default = _menuItem2.default;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9fbafb_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_vue__ = __webpack_require__(90);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9fbafb_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _menuMixin = __webpack_require__(32);

var _menuMixin2 = _interopRequireDefault(_menuMixin);

var _tooltip = __webpack_require__(23);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElMenuItem',

  componentName: 'ElMenuItem',

  mixins: [_menuMixin2.default, _emitter2.default],

  components: { ElTooltip: _tooltip2.default },

  props: {
    index: {
      type: String,
      required: true
    },
    route: [String, Object],
    disabled: Boolean
  },
  computed: {
    active: function active() {
      return this.index === this.rootMenu.activeIndex;
    },
    hoverBackground: function hoverBackground() {
      return this.rootMenu.hoverBackground;
    },
    backgroundColor: function backgroundColor() {
      return this.rootMenu.backgroundColor || '';
    },
    activeTextColor: function activeTextColor() {
      return this.rootMenu.activeTextColor || '';
    },
    textColor: function textColor() {
      return this.rootMenu.textColor || '';
    },
    mode: function mode() {
      return this.rootMenu.mode;
    },
    itemStyle: function itemStyle() {
      var style = {
        color: this.active ? this.activeTextColor : this.textColor
      };
      if (this.mode === 'horizontal' && !this.isNested) {
        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
      }
      return style;
    },
    isNested: function isNested() {
      return this.parentMenu !== this.rootMenu;
    }
  },
  methods: {
    onMouseEnter: function onMouseEnter() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      this.$el.style.backgroundColor = this.hoverBackground;
    },
    onMouseLeave: function onMouseLeave() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      this.$el.style.backgroundColor = this.backgroundColor;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.dispatch('ElMenu', 'item-click', this);
        this.$emit('click', this);
      };
    }
  },
  created: function created() {
    this.parentMenu.addItem(this);
    this.rootMenu.addItem(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeItem(this);
    this.rootMenu.removeItem(this);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-menu-item",class:{
    'is-active': _vm.active,
    'is-disabled': _vm.disabled
  },style:([_vm.paddingStyle, _vm.itemStyle, { backgroundColor: _vm.backgroundColor }]),attrs:{"role":"menuitem","tabindex":"-1"},on:{"click":_vm.handleClick,"mouseenter":_vm.onMouseEnter,"focus":_vm.onMouseEnter,"blur":_vm.onMouseLeave,"mouseleave":_vm.onMouseLeave}},[(_vm.parentMenu.$options.componentName === 'ElMenu' && _vm.rootMenu.collapse && _vm.$slots.title)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"right"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("title")],2),_c('div',{staticStyle:{"position":"absolute","left":"0","top":"0","height":"100%","width":"100%","display":"inline-block","box-sizing":"border-box","padding":"0 20px"}},[_vm._t("default")],2)]):[_vm._t("default"),_vm._t("title")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _menuItemGroup = __webpack_require__(92);

var _menuItemGroup2 = _interopRequireDefault(_menuItemGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_menuItemGroup2.default.install = function (Vue) {
  Vue.component(_menuItemGroup2.default.name, _menuItemGroup2.default);
};

exports.default = _menuItemGroup2.default;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_group_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f262d_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_group_vue__ = __webpack_require__(94);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f262d_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElMenuItemGroup',

  componentName: 'ElMenuItemGroup',

  inject: ['rootMenu'],
  props: {
    title: {
      type: String
    }
  },
  data: function data() {
    return {
      paddingLeft: 20
    };
  },

  computed: {
    levelPadding: function levelPadding() {
      var padding = 20;
      var parent = this.$parent;
      if (this.rootMenu.collapse) return 20;
      while (parent && parent.$options.componentName !== 'ElMenu') {
        if (parent.$options.componentName === 'ElSubmenu') {
          padding += 20;
        }
        parent = parent.$parent;
      }
      return padding;
    }
  }
};

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-menu-item-group"},[_c('div',{staticClass:"el-menu-item-group__title",style:({paddingLeft: _vm.levelPadding + 'px'})},[(!_vm.$slots.title)?[_vm._v(_vm._s(_vm.title))]:_vm._t("title")],2),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _input = __webpack_require__(96);

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_input2.default.install = function (Vue) {
  Vue.component(_input2.default.name, _input2.default);
};

exports.default = _input2.default;

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddb4a56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__(99);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddb4a56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _calcTextareaHeight = __webpack_require__(98);

var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [_emitter2.default, _migrating2.default],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
      textareaCalcStyle: {},
      prefixOffset: null,
      suffixOffset: null,
      hovering: false,
      focused: false,
      isOnComposition: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return (0, _merge2.default)({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    isGroup: function isGroup() {
      return this.$slots.prepend || this.$slots.append;
    },
    showClear: function showClear() {
      return this.clearable && !this.disabled && this.currentValue !== '' && (this.focused || this.hovering);
    }
  },

  watch: {
    'value': function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },

  methods: {
    focus: function focus() {
      (this.$refs.input || this.$refs.textarea).focus();
    },
    blur: function blur() {
      (this.$refs.input || this.$refs.textarea).blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    select: function select() {
      (this.$refs.input || this.$refs.textarea).select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: (0, _calcTextareaHeight2.default)(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleComposition: function handleComposition(event) {
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleInput(event);
      } else {
        var text = event.target.value;
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);
      }
    },
    handleInput: function handleInput(event) {
      if (this.isOnComposition) return;
      var value = event.target.value;
      this.$emit('input', value);
      this.setCurrentValue(value);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;
      this.$nextTick(function (_) {
        _this.resizeTextarea();
      });
      this.currentValue = value;
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    },
    calcIconOffset: function calcIconOffset(place) {
      var pendantMap = {
        'suf': 'append',
        'pre': 'prepend'
      };

      var pendant = pendantMap[place];

      if (this.$slots[pendant]) {
        return { transform: 'translateX(' + (place === 'suf' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)' };
      }
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
      this.setCurrentValue('');
      this.focus();
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.resizeTextarea();
    if (this.isGroup) {
      this.prefixOffset = this.calcIconOffset('pre');
      this.suffixOffset = this.calcIconOffset('suf');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calcTextareaHeight;
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
  _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
  {
    'is-disabled': _vm.inputDisabled,
    'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
    'el-input-group--append': _vm.$slots.append,
    'el-input-group--prepend': _vm.$slots.prepend,
    'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
    'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon
  }
  ],on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[(_vm.type !== 'textarea')?[(_vm.$slots.prepend)?_c('div',{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{"tabindex":_vm.tabindex,"type":_vm.type,"disabled":_vm.inputDisabled,"autocomplete":_vm.autoComplete,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'input',_vm.$attrs,false)):_vm._e(),(_vm.$slots.prefix || _vm.prefixIcon)?_c('span',{staticClass:"el-input__prefix",style:(_vm.prefixOffset)},[_vm._t("prefix"),(_vm.prefixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),(_vm.$slots.suffix || _vm.suffixIcon || _vm.showClear || _vm.validateState && _vm.needStatusIcon)?_c('span',{staticClass:"el-input__suffix",style:(_vm.suffixOffset)},[_c('span',{staticClass:"el-input__suffix-inner"},[(!_vm.showClear)?[_vm._t("suffix"),(_vm.suffixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_c('i',{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{"click":_vm.clear}})],2),(_vm.validateState)?_c('i',{staticClass:"el-input__icon",class:['el-input__validateIcon', _vm.validateIcon]}):_vm._e()]):_vm._e(),(_vm.$slots.append)?_c('div',{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),attrs:{"tabindex":_vm.tabindex,"disabled":_vm.inputDisabled,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'textarea',_vm.$attrs,false))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _inputNumber = __webpack_require__(101);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_inputNumber2.default.install = function (Vue) {
  Vue.component(_inputNumber2.default.name, _inputNumber2.default);
};

exports.default = _inputNumber2.default;

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d07efb5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__ = __webpack_require__(103);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d07efb5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

var _repeatClick = __webpack_require__(33);

var _repeatClick2 = _interopRequireDefault(_repeatClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInputNumber',
  mixins: [(0, _focus2.default)('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: _repeatClick2.default
  },
  components: {
    ElInput: _input2.default
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined && isNaN(newVal)) return;
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    precision: function precision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision;

      return Math.max(getPrecision(value), getPrecision(step));
    },
    controlsAtRight: function controlsAtRight() {
      return this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.precision;
      return parseFloat(parseFloat(Number(num).toFixed(precision)));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.precision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.precision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
      this.$refs.input.setCurrentValue(this.currentValue);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) {
        this.$refs.input.setCurrentValue(this.currentValue);
        return;
      }
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'el-input-number',
    _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
    { 'is-disabled': _vm.inputNumberDisabled },
    { 'is-without-controls': !_vm.controls },
    { 'is-controls-right': _vm.controlsAtRight }
  ],on:{"dragstart":function($event){$event.preventDefault();}}},[(_vm.controls)?_c('span',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-input-number__decrease",class:{'is-disabled': _vm.minDisabled},attrs:{"role":"button"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.decrease($event)}}},[_c('i',{class:("el-icon-" + (_vm.controlsAtRight ? 'arrow-down' : 'minus'))})]):_vm._e(),(_vm.controls)?_c('span',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-input-number__increase",class:{'is-disabled': _vm.maxDisabled},attrs:{"role":"button"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.increase($event)}}},[_c('i',{class:("el-icon-" + (_vm.controlsAtRight ? 'arrow-up' : 'plus'))})]):_vm._e(),_c('el-input',{ref:"input",attrs:{"value":_vm.currentValue,"disabled":_vm.inputNumberDisabled,"size":_vm.inputNumberSize,"max":_vm.max,"min":_vm.min,"name":_vm.name,"label":_vm.label},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"change":_vm.handleInputChange},nativeOn:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.increase($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.decrease($event)}]}},[(_vm.$slots.prepend)?_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.$slots.append)?_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._t("append")],2):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _radio = __webpack_require__(105);

var _radio2 = _interopRequireDefault(_radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_radio2.default.install = function (Vue) {
  Vue.component('el-radio', _radio2.default);
};

exports.default = _radio2.default;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfea8f7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__ = __webpack_require__(107);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfea8f7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElRadio',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElRadio',

  props: {
    value: {},
    label: {},
    disabled: Boolean,
    name: String,
    border: Boolean,
    size: String
  },

  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          this._radioGroup = parent;
          return true;
        }
      }
      return false;
    },

    model: {
      get: function get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('ElRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize: function radioSize() {
      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return !this.isDisabled ? this.isGroup ? this.model === this.label ? 0 : -1 : 0 : -1;
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change', _this.model);
        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-radio",class:[
    _vm.border && _vm.radioSize ? 'el-radio--' + _vm.radioSize : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-focus': _vm.focus },
    { 'is-bordered': _vm.border },
    { 'is-checked': _vm.model === _vm.label }
  ],attrs:{"role":"radio","aria-checked":_vm.model === _vm.label,"aria-disabled":_vm.isDisabled,"tabindex":_vm.tabIndex},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.model = _vm.label}}},[_c('span',{staticClass:"el-radio__input",class:{
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.model === _vm.label
    }},[_c('span',{staticClass:"el-radio__inner"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-radio__original",attrs:{"type":"radio","aria-hidden":"true","name":_vm.name,"disabled":_vm.isDisabled,"tabindex":"-1"},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false},"change":[function($event){_vm.model=_vm.label},_vm.handleChange]}})]),_c('span',{staticClass:"el-radio__label"},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _radioGroup = __webpack_require__(109);

var _radioGroup2 = _interopRequireDefault(_radioGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_radioGroup2.default.install = function (Vue) {
  Vue.component(_radioGroup2.default.name, _radioGroup2.default);
};

exports.default = _radioGroup2.default;

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_group_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0ab1ae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_group_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0ab1ae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyCode = Object.freeze({
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
}); //
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElRadioGroup',

  componentName: 'ElRadioGroup',

  inject: {
    elFormItem: {
      default: ''
    }
  },

  mixins: [_emitter2.default],

  props: {
    value: {},
    size: String,
    fill: String,
    textColor: String,
    disabled: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioGroupSize: function radioGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  created: function created() {
    var _this = this;

    this.$on('handleChange', function (value) {
      _this.$emit('change', value);
    });
  },
  mounted: function mounted() {
    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
    var radios = this.$el.querySelectorAll('[type=radio]');
    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
    if (![].some.call(radios, function (radio) {
      return radio.checked;
    }) && firstLabel) {
      firstLabel.tabIndex = 0;
    }
  },

  methods: {
    handleKeydown: function handleKeydown(e) {
      // 左右上下按键 可以在radio组内切换不同选项
      var target = e.target;
      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
      var radios = this.$el.querySelectorAll(className);
      var length = radios.length;
      var index = [].indexOf.call(radios, target);
      var roleRadios = this.$el.querySelectorAll('[role=radio]');
      switch (e.keyCode) {
        case keyCode.LEFT:
        case keyCode.UP:
          e.stopPropagation();
          e.preventDefault();
          if (index === 0) {
            roleRadios[length - 1].click();
          } else {
            roleRadios[index - 1].click();
          }
          break;
        case keyCode.RIGHT:
        case keyCode.DOWN:
          if (index === length - 1) {
            e.stopPropagation();
            e.preventDefault();
            roleRadios[0].click();
          } else {
            roleRadios[index + 1].click();
          }
          break;
        default:
          break;
      }
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-radio-group",attrs:{"role":"radiogroup"},on:{"keydown":_vm.handleKeydown}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _radioButton = __webpack_require__(113);

var _radioButton2 = _interopRequireDefault(_radioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_radioButton2.default.install = function (Vue) {
  Vue.component(_radioButton2.default.name, _radioButton2.default);
};

exports.default = _radioButton2.default;

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_button_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20684d78_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_button_vue__ = __webpack_require__(115);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radio_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20684d78_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_radio_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElRadioButton',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    label: {},
    disabled: Boolean,
    name: String
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    value: {
      get: function get() {
        return this._radioGroup.value;
      },
      set: function set(value) {
        this._radioGroup.$emit('input', value);
      }
    },
    _radioGroup: function _radioGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._radioGroup.fill || '',
        borderColor: this._radioGroup.fill || '',
        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
        color: this._radioGroup.textColor || ''
      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    size: function size() {
      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    isDisabled: function isDisabled() {
      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return !this.isDisabled ? this._radioGroup ? this.value === this.label ? 0 : -1 : 0 : -1;
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-radio-button",class:[
    _vm.size ? 'el-radio-button--' + _vm.size : '',
    { 'is-active': _vm.value === _vm.label },
    { 'is-disabled': _vm.isDisabled },
    { 'is-focus': _vm.focus }
  ],attrs:{"role":"radio","aria-checked":_vm.value === _vm.label,"aria-disabled":_vm.isDisabled,"tabindex":_vm.tabIndex},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.value = _vm.label}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"el-radio-button__orig-radio",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.isDisabled,"tabindex":"-1"},domProps:{"value":_vm.label,"checked":_vm._q(_vm.value,_vm.label)},on:{"change":[function($event){_vm.value=_vm.label},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}),_c('span',{staticClass:"el-radio-button__inner",style:(_vm.value === _vm.label ? _vm.activeStyle : null)},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(117);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_checkbox2.default.install = function (Vue) {
  Vue.component(_checkbox2.default.name, _checkbox2.default);
};

exports.default = _checkbox2.default;

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8b1d6_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__(119);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8b1d6_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCheckbox',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElCheckbox',

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent;
          return true;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    }
  },

  props: {
    value: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    border: Boolean,
    size: String
  },

  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-checkbox",class:[
    _vm.border && _vm.checkboxSize ? 'el-checkbox--' + _vm.checkboxSize : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-bordered': _vm.border },
    { 'is-checked': _vm.isChecked }
  ],attrs:{"role":"checkbox","aria-checked":_vm.indeterminate ? 'mixed': _vm.isChecked,"aria-disabled":_vm.isDisabled,"id":_vm.id}},[_c('span',{staticClass:"el-checkbox__input",class:{
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.isChecked,
      'is-indeterminate': _vm.indeterminate,
      'is-focus': _vm.focus
    },attrs:{"aria-checked":"mixed"}},[_c('span',{staticClass:"el-checkbox__inner"}),(_vm.trueLabel || _vm.falseLabel)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"type":"checkbox","aria-hidden":"true","name":_vm.name,"disabled":_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(_vm.trueLabel):(_vm.falseLabel);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"type":"checkbox","aria-hidden":"true","disabled":_vm.isDisabled,"name":_vm.name},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}})]),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"el-checkbox__label"},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkboxButton = __webpack_require__(121);

var _checkboxButton2 = _interopRequireDefault(_checkboxButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_checkboxButton2.default.install = function (Vue) {
  Vue.component(_checkboxButton2.default.name, _checkboxButton2.default);
};

exports.default = _checkboxButton2.default;

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_button_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea65ccc_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_button_vue__ = __webpack_require__(123);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea65ccc_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCheckboxButton',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  props: {
    value: {},
    label: {},
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number]
  },
  computed: {
    model: {
      get: function get() {
        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this._checkboxGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else if (this.value !== undefined) {
          this.$emit('input', val);
        } else {
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    _checkboxGroup: function _checkboxGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._checkboxGroup.fill || '',
        borderColor: this._checkboxGroup.fill || '',
        color: this._checkboxGroup.textColor || '',
        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill

      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    size: function size() {
      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    isDisabled: function isDisabled() {
      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this._checkboxGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-checkbox-button",class:[
      _vm.size ? 'el-checkbox-button--' + _vm.size : '',
      { 'is-disabled': _vm.isDisabled },
      { 'is-checked': _vm.isChecked },
      { 'is-focus': _vm.focus } ],attrs:{"role":"checkbox","aria-checked":_vm.isChecked,"aria-disabled":_vm.isDisabled}},[(_vm.trueLabel || _vm.falseLabel)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{"type":"checkbox","name":_vm.name,"disabled":_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(_vm.trueLabel):(_vm.falseLabel);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{"type":"checkbox","name":_vm.name,"disabled":_vm.isDisabled},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"el-checkbox-button__inner",style:(_vm.isChecked ? _vm.activeStyle : null)},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkboxGroup = __webpack_require__(125);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_checkboxGroup2.default.install = function (Vue) {
  Vue.component(_checkboxGroup2.default.name, _checkboxGroup2.default);
};

exports.default = _checkboxGroup2.default;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376416c7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_group_vue__ = __webpack_require__(127);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376416c7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCheckboxGroup',

  componentName: 'ElCheckboxGroup',

  mixins: [_emitter2.default],

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    value: {},
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-checkbox-group",attrs:{"role":"group","aria-label":"checkbox-group"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _component = __webpack_require__(129);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_component2.default.install = function (Vue) {
  Vue.component(_component2.default.name, _component2.default);
};

exports.default = _component2.default;

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_487d0a8c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__ = __webpack_require__(131);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_487d0a8c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElSwitch',
  mixins: [(0, _focus2.default)('input'), _migrating2.default],
  inject: {
    elForm: {
      default: ''
    }
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 40
    },
    activeIconClass: {
      type: String,
      default: ''
    },
    inactiveIconClass: {
      type: String,
      default: ''
    },
    activeText: String,
    inactiveText: String,
    activeColor: {
      type: String,
      default: ''
    },
    inactiveColor: {
      type: String,
      default: ''
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: true
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    id: String
  },
  data: function data() {
    return {
      coreWidth: this.width
    };
  },
  created: function created() {
    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
      this.$emit('input', this.inactiveValue);
    }
  },

  computed: {
    checked: function checked() {
      return this.value === this.activeValue;
    },
    switchDisabled: function switchDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  watch: {
    checked: function checked() {
      this.$refs.input.checked = this.checked;
      if (this.activeColor || this.inactiveColor) {
        this.setBackgroundColor();
      }
    }
  },
  methods: {
    handleChange: function handleChange(event) {
      var _this = this;

      this.$emit('input', !this.checked ? this.activeValue : this.inactiveValue);
      this.$emit('change', !this.checked ? this.activeValue : this.inactiveValue);
      this.$nextTick(function () {
        // set input's checked property
        // in case parent refuses to change component's value
        _this.$refs.input.checked = _this.checked;
      });
    },
    setBackgroundColor: function setBackgroundColor() {
      var newColor = this.checked ? this.activeColor : this.inactiveColor;
      this.$refs.core.style.borderColor = newColor;
      this.$refs.core.style.backgroundColor = newColor;
    },
    switchValue: function switchValue() {
      !this.switchDisabled && this.handleChange();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'on-color': 'on-color is renamed to active-color.',
          'off-color': 'off-color is renamed to inactive-color.',
          'on-text': 'on-text is renamed to active-text.',
          'off-text': 'off-text is renamed to inactive-text.',
          'on-value': 'on-value is renamed to active-value.',
          'off-value': 'off-value is renamed to inactive-value.',
          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
        }
      };
    }
  },
  mounted: function mounted() {
    /* istanbul ignore if */
    this.coreWidth = this.width || 40;
    if (this.activeColor || this.inactiveColor) {
      this.setBackgroundColor();
    }
    this.$refs.input.checked = this.checked;
  }
};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-switch",class:{ 'is-disabled': _vm.switchDisabled, 'is-checked': _vm.checked },attrs:{"role":"switch","aria-checked":_vm.checked,"aria-disabled":_vm.switchDisabled},on:{"click":_vm.switchValue}},[_c('input',{ref:"input",staticClass:"el-switch__input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"true-value":_vm.activeValue,"false-value":_vm.inactiveValue,"disabled":_vm.switchDisabled},on:{"change":_vm.handleChange,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.switchValue($event)}}}),(_vm.inactiveIconClass || _vm.inactiveText)?_c('span',{class:['el-switch__label', 'el-switch__label--left', !_vm.checked ? 'is-active' : '']},[(_vm.inactiveIconClass)?_c('i',{class:[_vm.inactiveIconClass]}):_vm._e(),(!_vm.inactiveIconClass && _vm.inactiveText)?_c('span',{attrs:{"aria-hidden":_vm.checked}},[_vm._v(_vm._s(_vm.inactiveText))]):_vm._e()]):_vm._e(),_c('span',{ref:"core",staticClass:"el-switch__core",style:({ 'width': _vm.coreWidth + 'px' })}),(_vm.activeIconClass || _vm.activeText)?_c('span',{class:['el-switch__label', 'el-switch__label--right', _vm.checked ? 'is-active' : '']},[(_vm.activeIconClass)?_c('i',{class:[_vm.activeIconClass]}):_vm._e(),(!_vm.activeIconClass && _vm.activeText)?_c('span',{attrs:{"aria-hidden":!_vm.checked}},[_vm._v(_vm._s(_vm.activeText))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _select = __webpack_require__(133);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_select2.default.install = function (Vue) {
  Vue.component(_select2.default.name, _select2.default);
};

exports.default = _select2.default;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab76e696_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__ = __webpack_require__(141);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab76e696_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _selectDropdown = __webpack_require__(135);

var _selectDropdown2 = _interopRequireDefault(_selectDropdown);

var _option = __webpack_require__(34);

var _option2 = _interopRequireDefault(_option);

var _tag = __webpack_require__(25);

var _tag2 = _interopRequireDefault(_tag);

var _scrollbar = __webpack_require__(18);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _dom = __webpack_require__(3);

var _resizeEvent = __webpack_require__(17);

var _locale3 = __webpack_require__(16);

var _scrollIntoView = __webpack_require__(26);

var _scrollIntoView2 = _interopRequireDefault(_scrollIntoView);

var _util = __webpack_require__(4);

var _navigationMixin = __webpack_require__(140);

var _navigationMixin2 = _interopRequireDefault(_navigationMixin);

var _shared = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  'medium': 36,
  'small': 32,
  'mini': 28
};

exports.default = {
  mixins: [_emitter2.default, _locale2.default, (0, _focus2.default)('reference'), _navigationMixin2.default],

  name: 'ElSelect',

  componentName: 'ElSelect',

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  provide: function provide() {
    return {
      'select': this
    };
  },


  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly: function readonly() {
      // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
      var isIE = !this.$isServer && !isNaN(Number(document.documentMode));
      return !this.filterable || this.multiple || !isIE && !this.visible;
    },
    iconClass: function iconClass() {
      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && !this.multiple && this.value !== undefined && this.value !== '';
      return criteria ? 'circle-close is-show-close' : this.remote && this.filterable ? '' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) return false;
        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('el.select.noMatch');
        }
        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
    }
  },

  components: {
    ElInput: _input2.default,
    ElSelectMenu: _selectDropdown2.default,
    ElOption: _option2.default,
    ElTag: _tag2.default,
    ElScrollbar: _scrollbar2.default
  },

  directives: { Clickoutside: _clickoutside2.default },

  props: {
    name: String,
    id: String,
    value: {
      required: true
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: function _default() {
        return (0, _locale3.t)('el.select.placeholder');
      }
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      menuVisibleOnFocus: false,
      isOnComposition: false,
      isSilentBlur: false
    };
  },


  watch: {
    selectDisabled: function selectDisabled() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.resetInputHeight();
      });
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val) {
      if (this.multiple) {
        this.resetInputHeight();
        if (val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
        if (this.filterable && !this.reserveKeyword) {
          this.query = '';
          this.handleQueryChange(this.query);
        }
      }
      this.setSelected();
      if (this.filterable && !this.multiple) {
        this.inputLength = 20;
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.handleIconHide();
        this.broadcast('ElSelectDropdown', 'destroyPopper');
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
        this.query = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.inputLength = 20;
        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });
        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }
            if (this.filterable) this.query = this.selectedLabel;
          }
        }
      } else {
        this.handleIconShow();
        this.broadcast('ElSelectDropdown', 'updatePopper');
        if (this.filterable) {
          this.query = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.query);
          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }
            this.broadcast('ElInput', 'inputSelect');
          }
        }
      }
      this.$emit('visible-change', val);
    },
    options: function options() {
      var _this4 = this;

      if (this.$isServer) return;
      this.$nextTick(function () {
        _this4.broadcast('ElSelectDropdown', 'updatePopper');
      });
      if (this.multiple) {
        this.resetInputHeight();
      }
      var inputs = this.$el.querySelectorAll('input');
      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },

  methods: {
    handleComposition: function handleComposition(event) {
      var text = event.target.value;
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleQueryChange(text);
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this5 = this;

      if (this.previousQuery === val || this.isOnComposition) return;
      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
        this.previousQuery = val;
        return;
      }
      this.previousQuery = val;
      this.$nextTick(function () {
        if (_this5.visible) _this5.broadcast('ElSelectDropdown', 'updatePopper');
      });
      this.hoverIndex = -1;
      if (this.multiple && this.filterable) {
        var length = this.$refs.input.value.length * 15 + 20;
        this.inputLength = this.collapseTags ? Math.min(50, length) : length;
        this.managePlaceholder();
        this.resetInputHeight();
      }
      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    handleIconHide: function handleIconHide() {
      var icon = this.$el.querySelector('.el-input__icon');
      if (icon) {
        (0, _dom.removeClass)(icon, 'is-reverse');
      }
    },
    handleIconShow: function handleIconShow() {
      var icon = this.$el.querySelector('.el-input__icon');
      if (icon && !(0, _dom.hasClass)(icon, 'el-icon-circle-close')) {
        (0, _dom.addClass)(icon, 'is-reverse');
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        (0, _scrollIntoView2.default)(menu, target);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this6 = this;

      this.$nextTick(function () {
        return _this6.scrollToOption(_this6.selected);
      });
    },
    emitChange: function emitChange(val) {
      if (!(0, _util.valueEquals)(this.value, val)) {
        this.$emit('change', val);
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    },
    getOption: function getOption(value) {
      var option = void 0;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? (0, _util.getValueByPath)(cachedOption.value, this.valueKey) === (0, _util.getValueByPath)(value, this.valueKey) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var label = !isObject ? value : '';
      var newOption = {
        value: value,
        currentLabel: label
      };
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    setSelected: function setSelected() {
      var _this7 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this7.getOption(value));
        });
      }
      this.selected = result;
      this.$nextTick(function () {
        _this7.resetInputHeight();
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          this.visible = true;
          this.menuVisibleOnFocus = true;
        }
        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    blur: function blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },
    handleBlur: function handleBlur(event) {
      var _this8 = this;

      setTimeout(function () {
        if (_this8.isSilentBlur) {
          _this8.isSilentBlur = false;
        } else {
          _this8.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleIconClick: function handleIconClick(event) {
      if (this.iconClass.indexOf('circle-close') > -1) {
        this.deleteSelected(event);
      }
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
        this.emitChange(value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
      this.inputLength = this.$refs.input.value.length * 15 + 20;
      this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this9 = this;

      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(function () {
        if (!_this9.$refs.reference) return;
        var inputChildNodes = _this9.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this9.$refs.tags;
        var sizeInMap = sizeMap[_this9.selectSize] || 40;
        input.style.height = _this9.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
        if (_this9.visible && _this9.emptyText !== false) {
          _this9.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this10 = this;

      setTimeout(function () {
        if (!_this10.multiple) {
          _this10.hoverIndex = _this10.options.indexOf(_this10.selected);
        } else {
          if (_this10.selected.length > 0) {
            _this10.hoverIndex = Math.min.apply(null, _this10.selected.map(function (item) {
              return _this10.options.indexOf(item);
            }));
          } else {
            _this10.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      var _this11 = this;

      if (this.multiple) {
        var value = this.value.slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }
        this.$emit('input', value);
        this.emitChange(value);
        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }
        if (this.filterable) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
      this.isSilentBlur = byClick;
      this.setSoftFocus();
      if (this.visible) return;
      this.$nextTick(function () {
        _this11.scrollToOption(option);
      });
    },
    setSoftFocus: function setSoftFocus() {
      this.softFocus = true;
      var input = this.$refs.input || this.$refs.reference;
      if (input) {
        input.focus();
      }
    },
    getValueIndex: function getValueIndex() {
      var _this12 = this;

      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments[1];

      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var _ret = function () {
          var valueKey = _this12.valueKey;
          var index = -1;
          arr.some(function (item, i) {
            if ((0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(value, valueKey)) {
              index = i;
              return true;
            }
            return false;
          });
          return {
            v: index
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    },
    toggleMenu: function toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
    selectOption: function selectOption() {
      if (!this.visible) {
        this.toggleMenu();
      } else {
        if (this.options[this.hoverIndex]) {
          this.handleOptionSelect(this.options[this.hoverIndex]);
        }
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      this.$emit('input', '');
      this.emitChange('');
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable && this.query !== this.selectedLabel) {
        this.query = this.selectedLabel;
        this.handleQueryChange(this.query);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1;
      // highlight the created option
      var hasCreated = false;
      for (var i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].created) {
          hasCreated = true;
          this.hoverIndex = i;
          break;
        }
      }
      if (hasCreated) return;
      for (var _i = 0; _i !== this.options.length; ++_i) {
        var option = this.options[_i];
        if (this.query) {
          // highlight first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = _i;
            break;
          }
        } else {
          // highlight currently selected option
          if (option.itemSelected) {
            this.hoverIndex = _i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return (0, _util.getValueByPath)(item.value, this.valueKey);
      }
    }
  },

  created: function created() {
    var _this13 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }
    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.debouncedOnInputChange = (0, _debounce2.default)(this.debounce, function () {
      _this13.onInputChange();
    });

    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
    this.$on('fieldReset', function () {
      _this13.dispatch('ElFormItem', 'el.form.change');
    });
  },
  mounted: function mounted() {
    var _this14 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }
    (0, _resizeEvent.addResizeListener)(this.$el, this.handleResize);
    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }
    this.$nextTick(function () {
      if (_this14.$refs.reference && _this14.$refs.reference.$el) {
        _this14.inputWidth = _this14.$refs.reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) (0, _resizeEvent.removeResizeListener)(this.$el, this.handleResize);
  }
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a24e159_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_dropdown_vue__ = __webpack_require__(137);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a24e159_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSelectDropdown',

  componentName: 'ElSelectDropdown',

  mixins: [_vuePopper2.default],

  props: {
    placement: {
      default: 'bottom-start'
    },

    boundariesPadding: {
      default: 0
    },

    popperOptions: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      minWidth: ''
    };
  },


  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },

  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-select-dropdown el-popper",class:[{ 'is-multiple': _vm.$parent.multiple }, _vm.popperClass],style:({ minWidth: _vm.minWidth })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return (0, _util.getValueByPath)(a, valueKey) === (0, _util.getValueByPath)(b, valueKey);
      }
    },
    contains: function contains() {
      var _this = this;

      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr.indexOf(target) > -1;
      } else {
        var _ret = function () {
          var valueKey = _this.select.valueKey;
          return {
            v: arr.some(function (item) {
              return (0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(target, valueKey);
            })
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      // query 里如果有正则中的特殊字符，需要先将这些字符转义
      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-select-dropdown__item",class:{
    'selected': _vm.itemSelected,
    'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
    'hover': _vm.hover
  },on:{"mouseenter":_vm.hoverItem,"click":function($event){$event.stopPropagation();_vm.selectOptionClick($event)}}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.currentLabel))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  data: function data() {
    return {
      hoverOption: -1
    };
  },


  computed: {
    optionsAllDisabled: function optionsAllDisabled() {
      return this.options.filter(function (option) {
        return option.visible;
      }).every(function (option) {
        return option.disabled;
      });
    }
  },

  watch: {
    hoverIndex: function hoverIndex(val) {
      var _this = this;

      if (typeof val === 'number' && val > -1) {
        this.hoverOption = this.options[val] || {};
      }
      this.options.forEach(function (option) {
        option.hover = _this.hoverOption === option;
      });
    }
  },

  methods: {
    navigateOptions: function navigateOptions(direction) {
      var _this2 = this;

      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;
          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }
        } else if (direction === 'prev') {
          this.hoverIndex--;
          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }
        }
        var option = this.options[this.hoverIndex];
        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
          this.navigateOptions(direction);
        }
        this.$nextTick(function () {
          return _this2.scrollToOption(_this2.hoverOption);
        });
      }
    }
  }
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],staticClass:"el-select",class:[_vm.selectSize ? 'el-select--' + _vm.selectSize : ''],on:{"click":function($event){$event.stopPropagation();_vm.toggleMenu($event)}}},[(_vm.multiple)?_c('div',{ref:"tags",staticClass:"el-select__tags",style:({ 'max-width': _vm.inputWidth - 32 + 'px' })},[(_vm.collapseTags && _vm.selected.length)?_c('span',[_c('el-tag',{attrs:{"closable":!_vm.selectDisabled,"size":_vm.collapseTagSize,"hit":_vm.selected[0].hitState,"type":"info","disable-transitions":""},on:{"close":function($event){_vm.deleteTag($event, _vm.selected[0])}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(_vm.selected[0].currentLabel))])]),(_vm.selected.length > 1)?_c('el-tag',{attrs:{"closable":false,"size":_vm.collapseTagSize,"type":"info","disable-transitions":""}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v("+ "+_vm._s(_vm.selected.length - 1))])]):_vm._e()],1):_vm._e(),(!_vm.collapseTags)?_c('transition-group',{on:{"after-leave":_vm.resetInputHeight}},_vm._l((_vm.selected),function(item){return _c('el-tag',{key:_vm.getValueKey(item),attrs:{"closable":!_vm.selectDisabled,"size":_vm.collapseTagSize,"hit":item.hitState,"type":"info","disable-transitions":""},on:{"close":function($event){_vm.deleteTag($event, item)}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(item.currentLabel))])])})):_vm._e(),(_vm.filterable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"el-select__input",class:[_vm.selectSize ? ("is-" + _vm.selectSize) : ''],style:({ width: _vm.inputLength + 'px', 'max-width': _vm.inputWidth - 42 + 'px' }),attrs:{"type":"text","disabled":_vm.selectDisabled,"autocomplete":_vm.autoComplete,"debounce":_vm.remote ? 300 : 0},domProps:{"value":(_vm.query)},on:{"focus":_vm.handleFocus,"blur":function($event){_vm.softFocus = false},"click":function($event){$event.stopPropagation();},"keyup":_vm.managePlaceholder,"keydown":[_vm.resetInputState,function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.navigateOptions('next')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.navigateOptions('prev')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.selectOption($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.deletePrevTag($event)}],"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":[function($event){if($event.target.composing){ return; }_vm.query=$event.target.value},function (e) { return _vm.handleQueryChange(e.target.value); }]}}):_vm._e()],1):_vm._e(),_c('el-input',{ref:"reference",class:{ 'is-focus': _vm.visible },attrs:{"type":"text","placeholder":_vm.currentPlaceholder,"name":_vm.name,"id":_vm.id,"auto-complete":_vm.autoComplete,"size":_vm.selectSize,"disabled":_vm.selectDisabled,"readonly":_vm.readonly,"validate-event":false},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur},nativeOn:{"keyup":function($event){_vm.debouncedOnInputChange($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.navigateOptions('next')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.navigateOptions('prev')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.selectOption($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.visible = false}],"paste":function($event){_vm.debouncedOnInputChange($event)},"mouseenter":function($event){_vm.inputHovering = true},"mouseleave":function($event){_vm.inputHovering = false}},model:{value:(_vm.selectedLabel),callback:function ($$v) {_vm.selectedLabel=$$v},expression:"selectedLabel"}},[_c('i',{class:['el-select__caret', 'el-input__icon', 'el-icon-' + _vm.iconClass],attrs:{"slot":"suffix"},on:{"click":_vm.handleIconClick},slot:"suffix"})]),_c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":_vm.doDestroy}},[_c('el-select-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible && _vm.emptyText !== false),expression:"visible && emptyText !== false"}],ref:"popper",attrs:{"append-to-body":_vm.popperAppendToBody}},[_c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.length > 0 && !_vm.loading),expression:"options.length > 0 && !loading"}],ref:"scrollbar",class:{ 'is-empty': !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0 },attrs:{"tag":"ul","wrap-class":"el-select-dropdown__wrap","view-class":"el-select-dropdown__list"}},[(_vm.showNewOption)?_c('el-option',{attrs:{"value":_vm.query,"created":""}}):_vm._e(),_vm._t("default")],2),(_vm.emptyText &&
          (!_vm.allowCreate || _vm.loading || (_vm.allowCreate && _vm.options.length === 0 )))?_c('p',{staticClass:"el-select-dropdown__empty"},[_vm._v("\n        "+_vm._s(_vm.emptyText)+"\n      ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _option = __webpack_require__(34);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_option2.default.install = function (Vue) {
  Vue.component(_option2.default.name, _option2.default);
};

exports.default = _option2.default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _optionGroup = __webpack_require__(144);

var _optionGroup2 = _interopRequireDefault(_optionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_optionGroup2.default.install = function (Vue) {
  Vue.component(_optionGroup2.default.name, _optionGroup2.default);
};

exports.default = _optionGroup2.default;

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_group_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378254a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_group_vue__ = __webpack_require__(146);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378254a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOptionGroup',

  componentName: 'ElOptionGroup',

  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      visible: true
    };
  },


  watch: {
    disabled: function disabled(val) {
      this.broadcast('ElOption', 'handleGroupDisabled', val);
    }
  },

  methods: {
    queryChange: function queryChange() {
      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
        return option.visible === true;
      });
    }
  },

  created: function created() {
    this.$on('queryChange', this.queryChange);
  },
  mounted: function mounted() {
    if (this.disabled) {
      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-select-group__wrap"},[_c('li',{staticClass:"el-select-group__title"},[_vm._v(_vm._s(_vm.label))]),_c('li',[_c('ul',{staticClass:"el-select-group"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _button = __webpack_require__(148);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_button2.default.install = function (Vue) {
  Vue.component(_button2.default.name, _button2.default);
};

exports.default = _button2.default;

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b70ef5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(150);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b70ef5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round,
      'is-circle': _vm.circle
    }
  ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _buttonGroup = __webpack_require__(152);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_buttonGroup2.default.install = function (Vue) {
  Vue.component(_buttonGroup2.default.name, _buttonGroup2.default);
};

exports.default = _buttonGroup2.default;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0216a7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_group_vue__ = __webpack_require__(154);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0216a7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//

exports.default = {
  name: 'ElButtonGroup'
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-button-group"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _table = __webpack_require__(156);

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_table2.default.install = function (Vue) {
  Vue.component(_table2.default.name, _table2.default);
};

exports.default = _table2.default;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271dac46_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__(169);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271dac46_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _resizeEvent = __webpack_require__(17);

var _mousewheel = __webpack_require__(158);

var _mousewheel2 = _interopRequireDefault(_mousewheel);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _tableStore = __webpack_require__(160);

var _tableStore2 = _interopRequireDefault(_tableStore);

var _tableLayout = __webpack_require__(161);

var _tableLayout2 = _interopRequireDefault(_tableLayout);

var _tableBody = __webpack_require__(162);

var _tableBody2 = _interopRequireDefault(_tableBody);

var _tableHeader = __webpack_require__(163);

var _tableHeader2 = _interopRequireDefault(_tableHeader);

var _tableFooter = __webpack_require__(168);

var _tableFooter2 = _interopRequireDefault(_tableFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableIdSeed = 1; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTable',

  mixins: [_locale2.default, _migrating2.default],

  directives: {
    Mousewheel: _mousewheel2.default
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    size: String,

    width: [String, Number],

    height: [String, Number],

    maxHeight: [String, Number],

    fit: {
      type: Boolean,
      default: true
    },

    stripe: Boolean,

    border: Boolean,

    rowKey: [String, Function],

    context: {},

    showHeader: {
      type: Boolean,
      default: true
    },

    showSummary: Boolean,

    sumText: String,

    summaryMethod: Function,

    rowClassName: [String, Function],

    rowStyle: [Object, Function],

    cellClassName: [String, Function],

    cellStyle: [Object, Function],

    headerRowClassName: [String, Function],

    headerRowStyle: [Object, Function],

    headerCellClassName: [String, Function],

    headerCellStyle: [Object, Function],

    highlightCurrentRow: Boolean,

    currentRowKey: [String, Number],

    emptyText: String,

    expandRowKeys: Array,

    defaultExpandAll: Boolean,

    defaultSort: Object,

    tooltipEffect: String,

    spanMethod: Function,

    selectOnIndeterminate: {
      type: Boolean,
      default: true
    }
  },

  components: {
    TableHeader: _tableHeader2.default,
    TableFooter: _tableFooter2.default,
    TableBody: _tableBody2.default,
    ElCheckbox: _checkbox2.default
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        events: {
          expand: 'expand is renamed to expand-change'
        }
      };
    },
    setCurrentRow: function setCurrentRow(row) {
      this.store.commit('setCurrentRow', row);
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.store.toggleRowSelection(row, selected);
      this.store.updateAllSelected();
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      this.store.toggleRowExpansion(row, expanded);
    },
    clearSelection: function clearSelection() {
      this.store.clearSelection();
    },
    clearFilter: function clearFilter() {
      this.store.clearFilter();
    },
    clearSort: function clearSort() {
      this.store.clearSort();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    updateScrollY: function updateScrollY() {
      this.layout.updateScrollY();
      this.layout.updateColumnsWidth();
    },
    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
      var bodyWrapper = this.bodyWrapper;
      if (Math.abs(data.spinY) > 0) {
        var currentScrollTop = bodyWrapper.scrollTop;
        if (data.pixelY < 0 && currentScrollTop !== 0) {
          event.preventDefault();
        }
        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
          event.preventDefault();
        }
        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
      } else {
        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
      }
    },
    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
      var pixelX = data.pixelX,
          pixelY = data.pixelY;

      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
        event.preventDefault();
        this.bodyWrapper.scrollLeft += data.pixelX / 5;
      }
    },
    bindEvents: function bindEvents() {
      var _$refs = this.$refs,
          headerWrapper = _$refs.headerWrapper,
          footerWrapper = _$refs.footerWrapper;

      var refs = this.$refs;
      var self = this;

      this.bodyWrapper.addEventListener('scroll', function () {
        if (headerWrapper) headerWrapper.scrollLeft = this.scrollLeft;
        if (footerWrapper) footerWrapper.scrollLeft = this.scrollLeft;
        if (refs.fixedBodyWrapper) refs.fixedBodyWrapper.scrollTop = this.scrollTop;
        if (refs.rightFixedBodyWrapper) refs.rightFixedBodyWrapper.scrollTop = this.scrollTop;
        var maxScrollLeftPosition = this.scrollWidth - this.offsetWidth - 1;
        var scrollLeft = this.scrollLeft;
        if (scrollLeft >= maxScrollLeftPosition) {
          self.scrollPosition = 'right';
        } else if (scrollLeft === 0) {
          self.scrollPosition = 'left';
        } else {
          self.scrollPosition = 'middle';
        }
      });

      if (this.fit) {
        (0, _resizeEvent.addResizeListener)(this.$el, this.resizeListener);
      }
    },
    resizeListener: function resizeListener() {
      if (!this.$ready) return;
      var shouldUpdateLayout = false;
      var el = this.$el;
      var _resizeState = this.resizeState,
          oldWidth = _resizeState.width,
          oldHeight = _resizeState.height;


      var width = el.offsetWidth;
      if (oldWidth !== width) {
        shouldUpdateLayout = true;
      }

      var height = el.offsetHeight;
      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
        shouldUpdateLayout = true;
      }

      if (shouldUpdateLayout) {
        this.resizeState.width = width;
        this.resizeState.height = height;
        this.doLayout();
      }
    },
    doLayout: function doLayout() {
      this.layout.updateColumnsWidth();
      if (this.shouldUpdateHeight) {
        this.layout.updateElsHeight();
      }
    }
  },

  created: function created() {
    var _this = this;

    this.tableId = 'el-table_' + tableIdSeed++;
    this.debouncedUpdateLayout = (0, _debounce2.default)(50, function () {
      return _this.doLayout();
    });
  },


  computed: {
    tableSize: function tableSize() {
      return this.size || (this.$ELEMENT || {}).size;
    },
    bodyWrapper: function bodyWrapper() {
      return this.$refs.bodyWrapper;
    },
    shouldUpdateHeight: function shouldUpdateHeight() {
      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
    },
    selection: function selection() {
      return this.store.states.selection;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    tableData: function tableData() {
      return this.store.states.data;
    },
    fixedColumns: function fixedColumns() {
      return this.store.states.fixedColumns;
    },
    rightFixedColumns: function rightFixedColumns() {
      return this.store.states.rightFixedColumns;
    },
    bodyWidth: function bodyWidth() {
      var _layout = this.layout,
          bodyWidth = _layout.bodyWidth,
          scrollY = _layout.scrollY,
          gutterWidth = _layout.gutterWidth;

      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
    },
    bodyHeight: function bodyHeight() {
      if (this.height) {
        return {
          height: this.layout.bodyHeight ? this.layout.bodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        return {
          'max-height': (this.showHeader ? this.maxHeight - this.layout.headerHeight - this.layout.footerHeight : this.maxHeight - this.layout.footerHeight) + 'px'
        };
      }
      return {};
    },
    fixedBodyHeight: function fixedBodyHeight() {
      if (this.height) {
        return {
          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var maxHeight = this.layout.scrollX ? this.maxHeight - this.layout.gutterWidth : this.maxHeight;

        if (this.showHeader) {
          maxHeight -= this.layout.headerHeight;
        }

        maxHeight -= this.layout.footerHeight;

        return {
          'max-height': maxHeight + 'px'
        };
      }

      return {};
    },
    fixedHeight: function fixedHeight() {
      if (this.maxHeight) {
        if (this.showSummary) {
          return {
            bottom: 0
          };
        }
        return {
          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
        };
      } else {
        if (this.showSummary) {
          return {
            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
          };
        }
        return {
          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
        };
      }
    }
  },

  watch: {
    height: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setHeight(value);
      }
    },

    maxHeight: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setMaxHeight(value);
      }
    },

    currentRowKey: function currentRowKey(newVal) {
      this.store.setCurrentRowKey(newVal);
    },


    data: {
      immediate: true,
      handler: function handler(value) {
        var _this2 = this;

        this.store.commit('setData', value);
        if (this.$ready) {
          this.$nextTick(function () {
            _this2.doLayout();
          });
        }
      }
    },

    expandRowKeys: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.store.setExpandRowKeys(newVal);
        }
      }
    }
  },

  destroyed: function destroyed() {
    if (this.resizeListener) (0, _resizeEvent.removeResizeListener)(this.$el, this.resizeListener);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.bindEvents();
    this.store.updateColumns();
    this.doLayout();

    this.resizeState = {
      width: this.$el.offsetWidth,
      height: this.$el.offsetHeight
    };

    // init filters
    this.store.states.columns.forEach(function (column) {
      if (column.filteredValue && column.filteredValue.length) {
        _this3.store.commit('filterChange', {
          column: column,
          values: column.filteredValue,
          silent: true
        });
      }
    });

    this.$ready = true;
  },
  data: function data() {
    var store = new _tableStore2.default(this, {
      rowKey: this.rowKey,
      defaultExpandAll: this.defaultExpandAll,
      selectOnIndeterminate: this.selectOnIndeterminate
    });
    var layout = new _tableLayout2.default({
      store: store,
      table: this,
      fit: this.fit,
      showHeader: this.showHeader
    });
    return {
      layout: layout,
      store: store,
      isHidden: false,
      renderExpanded: null,
      resizeProxyVisible: false,
      resizeState: {
        width: null,
        height: null
      },
      // 是否拥有多级表头
      isGroup: false,
      scrollPosition: 'left'
    };
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _normalizeWheel = __webpack_require__(159);

var _normalizeWheel2 = _interopRequireDefault(_normalizeWheel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

var mousewheel = function mousewheel(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
      var normalized = (0, _normalizeWheel2.default)(event);
      callback && callback.apply(this, [event, normalized]);
    });
  }
};

exports.default = {
  bind: function bind(el, binding) {
    mousewheel(el, binding.value);
  }
};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(278);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortData = function sortData(data, states) {
  var sortingColumn = states.sortingColumn;
  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
    return data;
  }
  return (0, _util.orderBy)(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
};

var getKeysMap = function getKeysMap(array, rowKey) {
  var arrayMap = {};
  (array || []).forEach(function (row, index) {
    arrayMap[(0, _util.getRowIdentity)(row, rowKey)] = { row: row, index: index };
  });
  return arrayMap;
};

var toggleRowSelection = function toggleRowSelection(states, row, selected) {
  var changed = false;
  var selection = states.selection;
  var index = selection.indexOf(row);
  if (typeof selected === 'undefined') {
    if (index === -1) {
      selection.push(row);
      changed = true;
    } else {
      selection.splice(index, 1);
      changed = true;
    }
  } else {
    if (selected && index === -1) {
      selection.push(row);
      changed = true;
    } else if (!selected && index > -1) {
      selection.splice(index, 1);
      changed = true;
    }
  }

  return changed;
};

var toggleRowExpansion = function toggleRowExpansion(states, row, expanded) {
  var changed = false;
  var expandRows = states.expandRows;
  if (typeof expanded !== 'undefined') {
    var index = expandRows.indexOf(row);
    if (expanded) {
      if (index === -1) {
        expandRows.push(row);
        changed = true;
      }
    } else {
      if (index !== -1) {
        expandRows.splice(index, 1);
        changed = true;
      }
    }
  } else {
    var _index = expandRows.indexOf(row);
    if (_index === -1) {
      expandRows.push(row);
      changed = true;
    } else {
      expandRows.splice(_index, 1);
      changed = true;
    }
  }

  return changed;
};

var TableStore = function TableStore(table) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!table) {
    throw new Error('Table is required.');
  }
  this.table = table;

  this.states = {
    rowKey: null,
    _columns: [],
    originColumns: [],
    columns: [],
    fixedColumns: [],
    rightFixedColumns: [],
    leafColumns: [],
    fixedLeafColumns: [],
    rightFixedLeafColumns: [],
    leafColumnsLength: 0,
    fixedLeafColumnsLength: 0,
    rightFixedLeafColumnsLength: 0,
    isComplex: false,
    filteredData: null,
    data: null,
    sortingColumn: null,
    sortProp: null,
    sortOrder: null,
    isAllSelected: false,
    selection: [],
    reserveSelection: false,
    selectable: null,
    currentRow: null,
    hoverRow: null,
    filters: {},
    expandRows: [],
    defaultExpandAll: false,
    selectOnIndeterminate: false
  };

  for (var prop in initialState) {
    if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
      this.states[prop] = initialState[prop];
    }
  }
};

TableStore.prototype.mutations = {
  setData: function setData(states, data) {
    var _this = this;

    var dataInstanceChanged = states._data !== data;
    states._data = data;

    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = (0, _util.getColumnById)(_this.states, columnId);
      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row, column);
          });
        });
      }
    });

    states.filteredData = data;
    states.data = sortData(data || [], states);

    this.updateCurrentRow();

    if (!states.reserveSelection) {
      if (dataInstanceChanged) {
        this.clearSelection();
      } else {
        this.cleanSelection();
      }
      this.updateAllSelected();
    } else {
      (function () {
        var rowKey = states.rowKey;
        if (rowKey) {
          (function () {
            var selection = states.selection;
            var selectedMap = getKeysMap(selection, rowKey);

            states.data.forEach(function (row) {
              var rowId = (0, _util.getRowIdentity)(row, rowKey);
              var rowInfo = selectedMap[rowId];
              if (rowInfo) {
                selection[rowInfo.index] = row;
              }
            });

            _this.updateAllSelected();
          })();
        } else {
          console.warn('WARN: rowKey is required when reserve-selection is enabled.');
        }
      })();
    }

    var defaultExpandAll = states.defaultExpandAll;
    if (defaultExpandAll) {
      this.states.expandRows = (states.data || []).slice(0);
    }

    _vue2.default.nextTick(function () {
      return _this.table.updateScrollY();
    });
  },
  changeSortCondition: function changeSortCondition(states, options) {
    var _this2 = this;

    states.data = sortData(states.filteredData || states._data || [], states);

    if (!options || !options.silent) {
      this.table.$emit('sort-change', {
        column: this.states.sortingColumn,
        prop: this.states.sortProp,
        order: this.states.sortOrder
      });
    }

    _vue2.default.nextTick(function () {
      return _this2.table.updateScrollY();
    });
  },
  filterChange: function filterChange(states, options) {
    var _this3 = this;

    var column = options.column,
        values = options.values,
        silent = options.silent;

    if (values && !Array.isArray(values)) {
      values = [values];
    }

    var prop = column.property;
    var filters = {};

    if (prop) {
      states.filters[column.id] = values;
      filters[column.columnKey || column.id] = values;
    }

    var data = states._data;

    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = (0, _util.getColumnById)(_this3.states, columnId);
      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row, column);
          });
        });
      }
    });

    states.filteredData = data;
    states.data = sortData(data, states);

    if (!silent) {
      this.table.$emit('filter-change', filters);
    }

    _vue2.default.nextTick(function () {
      return _this3.table.updateScrollY();
    });
  },
  insertColumn: function insertColumn(states, column, index, parent) {
    var array = states._columns;
    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }

    if (typeof index !== 'undefined') {
      array.splice(index, 0, column);
    } else {
      array.push(column);
    }

    if (column.type === 'selection') {
      states.selectable = column.selectable;
      states.reserveSelection = column.reserveSelection;
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics insert column
      this.scheduleLayout();
    }
  },
  removeColumn: function removeColumn(states, column, parent) {
    var array = states._columns;
    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }
    if (array) {
      array.splice(array.indexOf(column), 1);
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics remove column
      this.scheduleLayout();
    }
  },
  setHoverRow: function setHoverRow(states, row) {
    states.hoverRow = row;
  },
  setCurrentRow: function setCurrentRow(states, row) {
    var oldCurrentRow = states.currentRow;
    states.currentRow = row;

    if (oldCurrentRow !== row) {
      this.table.$emit('current-change', row, oldCurrentRow);
    }
  },
  rowSelectedChanged: function rowSelectedChanged(states, row) {
    var changed = toggleRowSelection(states, row);
    var selection = states.selection;

    if (changed) {
      var table = this.table;
      table.$emit('selection-change', selection ? selection.slice() : []);
      table.$emit('select', selection, row);
    }

    this.updateAllSelected();
  },


  toggleAllSelection: (0, _debounce2.default)(10, function (states) {
    var data = states.data || [];
    if (data.length === 0) return;
    var selection = this.states.selection;
    // when only some rows are selected (but not all), select or deselect all of them
    // depending on the value of selectOnIndeterminate
    var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
    var selectionChanged = false;

    data.forEach(function (item, index) {
      if (states.selectable) {
        if (states.selectable.call(null, item, index) && toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      } else {
        if (toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      }
    });

    var table = this.table;
    if (selectionChanged) {
      table.$emit('selection-change', selection ? selection.slice() : []);
    }
    table.$emit('select-all', selection);
    states.isAllSelected = value;
  })
};

var doFlattenColumns = function doFlattenColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push.apply(result, doFlattenColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

TableStore.prototype.updateColumns = function () {
  var states = this.states;
  var _columns = states._columns || [];
  states.fixedColumns = _columns.filter(function (column) {
    return column.fixed === true || column.fixed === 'left';
  });
  states.rightFixedColumns = _columns.filter(function (column) {
    return column.fixed === 'right';
  });

  if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
    _columns[0].fixed = true;
    states.fixedColumns.unshift(_columns[0]);
  }

  var notFixedColumns = _columns.filter(function (column) {
    return !column.fixed;
  });
  states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);

  var leafColumns = doFlattenColumns(notFixedColumns);
  var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
  var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);

  states.leafColumnsLength = leafColumns.length;
  states.fixedLeafColumnsLength = fixedLeafColumns.length;
  states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;

  states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
  states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
};

TableStore.prototype.isSelected = function (row) {
  return (this.states.selection || []).indexOf(row) > -1;
};

TableStore.prototype.clearSelection = function () {
  var states = this.states;
  states.isAllSelected = false;
  var oldSelection = states.selection;
  if (states.selection.length) {
    states.selection = [];
  }
  if (oldSelection.length > 0) {
    this.table.$emit('selection-change', states.selection ? states.selection.slice() : []);
  }
};

TableStore.prototype.setExpandRowKeys = function (rowKeys) {
  var expandRows = [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  if (!rowKey) throw new Error('[Table] prop row-key should not be empty.');
  var keysMap = getKeysMap(data, rowKey);
  rowKeys.forEach(function (key) {
    var info = keysMap[key];
    if (info) {
      expandRows.push(info.row);
    }
  });

  this.states.expandRows = expandRows;
};

TableStore.prototype.toggleRowSelection = function (row, selected) {
  var changed = toggleRowSelection(this.states, row, selected);
  if (changed) {
    this.table.$emit('selection-change', this.states.selection ? this.states.selection.slice() : []);
  }
};

TableStore.prototype.toggleRowExpansion = function (row, expanded) {
  var changed = toggleRowExpansion(this.states, row, expanded);
  if (changed) {
    this.table.$emit('expand-change', row, this.states.expandRows);
    this.scheduleLayout();
  }
};

TableStore.prototype.isRowExpanded = function (row) {
  var _states = this.states,
      _states$expandRows = _states.expandRows,
      expandRows = _states$expandRows === undefined ? [] : _states$expandRows,
      rowKey = _states.rowKey;

  if (rowKey) {
    var expandMap = getKeysMap(expandRows, rowKey);
    return !!expandMap[(0, _util.getRowIdentity)(row, rowKey)];
  }
  return expandRows.indexOf(row) !== -1;
};

TableStore.prototype.cleanSelection = function () {
  var selection = this.states.selection || [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  var deleted = void 0;
  if (rowKey) {
    deleted = [];
    var selectedMap = getKeysMap(selection, rowKey);
    var dataMap = getKeysMap(data, rowKey);
    for (var key in selectedMap) {
      if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
        deleted.push(selectedMap[key].row);
      }
    }
  } else {
    deleted = selection.filter(function (item) {
      return data.indexOf(item) === -1;
    });
  }

  deleted.forEach(function (deletedItem) {
    selection.splice(selection.indexOf(deletedItem), 1);
  });

  if (deleted.length) {
    this.table.$emit('selection-change', selection ? selection.slice() : []);
  }
};

TableStore.prototype.clearFilter = function () {
  var states = this.states;
  var _table$$refs = this.table.$refs,
      tableHeader = _table$$refs.tableHeader,
      fixedTableHeader = _table$$refs.fixedTableHeader,
      rightFixedTableHeader = _table$$refs.rightFixedTableHeader;

  var panels = {};

  if (tableHeader) panels = (0, _merge2.default)(panels, tableHeader.filterPanels);
  if (fixedTableHeader) panels = (0, _merge2.default)(panels, fixedTableHeader.filterPanels);
  if (rightFixedTableHeader) panels = (0, _merge2.default)(panels, rightFixedTableHeader.filterPanels);

  var keys = Object.keys(panels);
  if (!keys.length) return;

  keys.forEach(function (key) {
    panels[key].filteredValue = [];
  });

  states.filters = {};

  this.commit('filterChange', {
    column: {},
    values: [],
    silent: true
  });
};

TableStore.prototype.clearSort = function () {
  var states = this.states;
  if (!states.sortingColumn) return;
  states.sortingColumn.order = null;
  states.sortProp = null;
  states.sortOrder = null;

  this.commit('changeSortCondition', {
    silent: true
  });
};

TableStore.prototype.updateAllSelected = function () {
  var states = this.states;
  var selection = states.selection,
      rowKey = states.rowKey,
      selectable = states.selectable,
      data = states.data;

  if (!data || data.length === 0) {
    states.isAllSelected = false;
    return;
  }

  var selectedMap = void 0;
  if (rowKey) {
    selectedMap = getKeysMap(states.selection, rowKey);
  }

  var isSelected = function isSelected(row) {
    if (selectedMap) {
      return !!selectedMap[(0, _util.getRowIdentity)(row, rowKey)];
    } else {
      return selection.indexOf(row) !== -1;
    }
  };

  var isAllSelected = true;
  var selectedCount = 0;
  for (var i = 0, j = data.length; i < j; i++) {
    var item = data[i];
    var isRowSelectable = selectable && selectable.call(null, item, i);
    if (!isSelected(item)) {
      if (!selectable || isRowSelectable) {
        isAllSelected = false;
        break;
      }
    } else {
      selectedCount++;
    }
  }

  if (selectedCount === 0) isAllSelected = false;

  states.isAllSelected = isAllSelected;
};

TableStore.prototype.scheduleLayout = function (updateColumns) {
  if (updateColumns) {
    this.updateColumns();
  }
  this.table.debouncedUpdateLayout();
};

TableStore.prototype.setCurrentRowKey = function (key) {
  var states = this.states;
  var rowKey = states.rowKey;
  if (!rowKey) throw new Error('[Table] row-key should not be empty.');
  var data = states.data || [];
  var keysMap = getKeysMap(data, rowKey);
  var info = keysMap[key];
  if (info) {
    states.currentRow = info.row;
  }
};

TableStore.prototype.updateCurrentRow = function () {
  var states = this.states;
  var table = this.table;
  var data = states.data || [];
  var oldCurrentRow = states.currentRow;

  if (data.indexOf(oldCurrentRow) === -1) {
    states.currentRow = null;

    if (states.currentRow !== oldCurrentRow) {
      table.$emit('current-change', null, oldCurrentRow);
    }
  }
};

TableStore.prototype.commit = function (name) {
  var mutations = this.mutations;
  if (mutations[name]) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    mutations[name].apply(this, [this.states].concat(args));
  } else {
    throw new Error('Action not found: ' + name);
  }
};

exports.default = TableStore;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _scrollbarWidth = __webpack_require__(36);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableLayout = function () {
  function TableLayout(options) {
    _classCallCheck(this, TableLayout);

    this.observers = [];
    this.table = null;
    this.store = null;
    this.columns = null;
    this.fit = true;
    this.showHeader = true;

    this.height = null;
    this.scrollX = false;
    this.scrollY = false;
    this.bodyWidth = null;
    this.fixedWidth = null;
    this.rightFixedWidth = null;
    this.tableHeight = null;
    this.headerHeight = 44; // Table Header Height
    this.appendHeight = 0; // Append Slot Height
    this.footerHeight = 44; // Table Footer Height
    this.viewportHeight = null; // Table Height - Scroll Bar Height
    this.bodyHeight = null; // Table Height - Table Header Height
    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
    this.gutterWidth = (0, _scrollbarWidth2.default)();

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    if (!this.table) {
      throw new Error('table is required for Table Layout');
    }
    if (!this.store) {
      throw new Error('store is required for Table Layout');
    }
  }

  TableLayout.prototype.updateScrollY = function updateScrollY() {
    var height = this.height;
    if (typeof height !== 'string' && typeof height !== 'number') return;
    var bodyWrapper = this.table.bodyWrapper;
    if (this.table.$el && bodyWrapper) {
      var body = bodyWrapper.querySelector('.el-table__body');
      this.scrollY = body.offsetHeight > this.bodyHeight;
    }
  };

  TableLayout.prototype.setHeight = function setHeight(value) {
    var _this = this;

    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';

    if (_vue2.default.prototype.$isServer) return;
    var el = this.table.$el;
    if (typeof value === 'string' && /^\d+$/.test(value)) {
      value = Number(value);
    }
    this.height = value;

    if (!el && (value || value === 0)) return _vue2.default.nextTick(function () {
      return _this.setHeight(value, prop);
    });

    if (typeof value === 'number') {
      el.style[prop] = value + 'px';

      this.updateElsHeight();
    } else if (typeof value === 'string') {
      el.style[prop] = value;
      this.updateElsHeight();
    }
  };

  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
    return this.setHeight(value, 'max-height');
  };

  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
    var _this2 = this;

    if (!this.table.$ready) return _vue2.default.nextTick(function () {
      return _this2.updateElsHeight();
    });
    var _table$$refs = this.table.$refs,
        headerWrapper = _table$$refs.headerWrapper,
        appendWrapper = _table$$refs.appendWrapper,
        footerWrapper = _table$$refs.footerWrapper;

    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;

    if (this.showHeader && !headerWrapper) return;
    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
    if (this.showHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
      return _vue2.default.nextTick(function () {
        return _this2.updateElsHeight();
      });
    }
    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
    if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
      var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
    }
    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;

    var noData = !this.table.data || this.table.data.length === 0;
    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;

    this.updateScrollY();
    this.notifyObservers('scrollable');
  };

  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
    var flattenColumns = [];
    var columns = this.table.columns;
    columns.forEach(function (column) {
      if (column.isColumnGroup) {
        flattenColumns.push.apply(flattenColumns, column.columns);
      } else {
        flattenColumns.push(column);
      }
    });

    return flattenColumns;
  };

  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
    var fit = this.fit;
    var bodyWidth = this.table.$el.clientWidth;
    var bodyMinWidth = 0;

    var flattenColumns = this.getFlattenColumns();
    var flexColumns = flattenColumns.filter(function (column) {
      return typeof column.width !== 'number';
    });

    flattenColumns.forEach(function (column) {
      // Clean those columns whose width changed from flex to unflex
      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
    });

    if (flexColumns.length > 0 && fit) {
      flattenColumns.forEach(function (column) {
        bodyMinWidth += column.width || column.minWidth || 80;
      });

      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;

      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
        // DON'T HAVE SCROLL BAR
        this.scrollX = false;

        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;

        if (flexColumns.length === 1) {
          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
        } else {
          (function () {
            var allColumnsWidth = flexColumns.reduce(function (prev, column) {
              return prev + (column.minWidth || 80);
            }, 0);
            var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
            var noneFirstWidth = 0;

            flexColumns.forEach(function (column, index) {
              if (index === 0) return;
              var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
              noneFirstWidth += flexWidth;
              column.realWidth = (column.minWidth || 80) + flexWidth;
            });

            flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
          })();
        }
      } else {
        // HAVE HORIZONTAL SCROLL BAR
        this.scrollX = true;
        flexColumns.forEach(function (column) {
          column.realWidth = column.minWidth;
        });
      }

      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
      this.table.resizeState.width = this.bodyWidth;
    } else {
      flattenColumns.forEach(function (column) {
        if (!column.width && !column.minWidth) {
          column.realWidth = 80;
        } else {
          column.realWidth = column.width || column.minWidth;
        }

        bodyMinWidth += column.realWidth;
      });
      this.scrollX = bodyMinWidth > bodyWidth;

      this.bodyWidth = bodyMinWidth;
    }

    var fixedColumns = this.store.states.fixedColumns;

    if (fixedColumns.length > 0) {
      var fixedWidth = 0;
      fixedColumns.forEach(function (column) {
        fixedWidth += column.realWidth || column.width;
      });

      this.fixedWidth = fixedWidth;
    }

    var rightFixedColumns = this.store.states.rightFixedColumns;
    if (rightFixedColumns.length > 0) {
      var rightFixedWidth = 0;
      rightFixedColumns.forEach(function (column) {
        rightFixedWidth += column.realWidth || column.width;
      });

      this.rightFixedWidth = rightFixedWidth;
    }

    this.notifyObservers('columns');
  };

  TableLayout.prototype.addObserver = function addObserver(observer) {
    this.observers.push(observer);
  };

  TableLayout.prototype.removeObserver = function removeObserver(observer) {
    var index = this.observers.indexOf(observer);
    if (index !== -1) {
      this.observers.splice(index, 1);
    }
  };

  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
    var _this3 = this;

    var observers = this.observers;
    observers.forEach(function (observer) {
      switch (event) {
        case 'columns':
          observer.onColumnsChange(_this3);
          break;
        case 'scrollable':
          observer.onScrollableChange(_this3);
          break;
        default:
          throw new Error('Table Layout don\'t have event ' + event + '.');
      }
    });
  };

  return TableLayout;
}();

exports.default = TableLayout;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(35);

var _dom = __webpack_require__(3);

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tooltip = __webpack_require__(23);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _layoutObserver = __webpack_require__(27);

var _layoutObserver2 = _interopRequireDefault(_layoutObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTableBody',

  mixins: [_layoutObserver2.default],

  components: {
    ElCheckbox: _checkbox2.default,
    ElTooltip: _tooltip2.default
  },

  props: {
    store: {
      required: true
    },
    stripe: Boolean,
    context: {},
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: Boolean
  },

  render: function render(h) {
    var _this = this;

    var columnsHidden = this.columns.map(function (column, index) {
      return _this.isColumnHidden(index);
    });
    return h(
      'table',
      {
        'class': 'el-table__body',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: { name: column.id }
            },
            []
          );
        })]
      ), h(
        'tbody',
        null,
        [this._l(this.data, function (row, $index) {
          return [h(
            'tr',
            {
              style: _this.rowStyle ? _this.getRowStyle(row, $index) : null,
              key: _this.table.rowKey ? _this.getKeyOfRow(row, $index) : $index,
              on: {
                'dblclick': function dblclick($event) {
                  return _this.handleDoubleClick($event, row);
                },
                'click': function click($event) {
                  return _this.handleClick($event, row);
                },
                'contextmenu': function contextmenu($event) {
                  return _this.handleContextMenu($event, row);
                },
                'mouseenter': function mouseenter(_) {
                  return _this.handleMouseEnter($index);
                },
                'mouseleave': function mouseleave(_) {
                  return _this.handleMouseLeave();
                }
              },

              'class': [_this.getRowClass(row, $index)] },
            [_this._l(_this.columns, function (column, cellIndex) {
              var _getSpan = _this.getSpan(row, column, $index, cellIndex),
                  rowspan = _getSpan.rowspan,
                  colspan = _getSpan.colspan;

              if (!rowspan || !colspan) {
                return '';
              } else {
                if (rowspan === 1 && colspan === 1) {
                  return h(
                    'td',
                    {
                      style: _this.getCellStyle($index, cellIndex, row, column),
                      'class': _this.getCellClass($index, cellIndex, row, column),
                      on: {
                        'mouseenter': function mouseenter($event) {
                          return _this.handleCellMouseEnter($event, row);
                        },
                        'mouseleave': _this.handleCellMouseLeave
                      }
                    },
                    [column.renderCell.call(_this._renderProxy, h, {
                      row: row,
                      column: column,
                      $index: $index,
                      store: _this.store,
                      _self: _this.context || _this.table.$vnode.context
                    }, columnsHidden[cellIndex])]
                  );
                } else {
                  return h(
                    'td',
                    {
                      style: _this.getCellStyle($index, cellIndex, row, column),
                      'class': _this.getCellClass($index, cellIndex, row, column),
                      attrs: { rowspan: rowspan,
                        colspan: colspan
                      },
                      on: {
                        'mouseenter': function mouseenter($event) {
                          return _this.handleCellMouseEnter($event, row);
                        },
                        'mouseleave': _this.handleCellMouseLeave
                      }
                    },
                    [column.renderCell.call(_this._renderProxy, h, {
                      row: row,
                      column: column,
                      $index: $index,
                      store: _this.store,
                      _self: _this.context || _this.table.$vnode.context
                    }, columnsHidden[cellIndex])]
                  );
                }
              }
            })]
          ), _this.store.isRowExpanded(row) ? h(
            'tr',
            null,
            [h(
              'td',
              {
                attrs: { colspan: _this.columns.length },
                'class': 'el-table__expanded-cell' },
              [_this.table.renderExpanded ? _this.table.renderExpanded(h, { row: row, $index: $index, store: _this.store }) : '']
            )]
          ) : ''];
        }).concat(h(
          'el-tooltip',
          {
            attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
            ref: 'tooltip' },
          []
        ))]
      )]
    );
  },


  watch: {
    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
      if (!this.store.states.isComplex) return;
      var el = this.$el;
      if (!el) return;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[oldVal];
      var newRow = rows[newVal];
      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'hover-row');
      }
      if (newRow) {
        (0, _dom.addClass)(newRow, 'hover-row');
      }
    },
    'store.states.currentRow': function storeStatesCurrentRow(newVal, oldVal) {
      if (!this.highlight) return;
      var el = this.$el;
      if (!el) return;
      var data = this.store.states.data;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[data.indexOf(oldVal)];
      var newRow = rows[data.indexOf(newVal)];
      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'current-row');
      } else {
        [].forEach.call(rows, function (row) {
          return (0, _dom.removeClass)(row, 'current-row');
        });
      }
      if (newRow) {
        (0, _dom.addClass)(newRow, 'current-row');
      }
    }
  },

  computed: {
    table: function table() {
      return this.$parent;
    },
    data: function data() {
      return this.store.states.data;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    }
  },

  data: function data() {
    return {
      tooltipContent: ''
    };
  },
  created: function created() {
    this.activateTooltip = (0, _debounce2.default)(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },


  methods: {
    getKeyOfRow: function getKeyOfRow(row, index) {
      var rowKey = this.table.rowKey;
      if (rowKey) {
        return (0, _util.getRowIdentity)(row, rowKey);
      }
      return index;
    },
    isColumnHidden: function isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
      var rowspan = 1;
      var colspan = 1;

      var fn = this.table.spanMethod;
      if (typeof fn === 'function') {
        var result = fn({
          row: row,
          column: column,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });

        if (Array.isArray(result)) {
          rowspan = result[0];
          colspan = result[1];
        } else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
          rowspan = result.rowspan;
          colspan = result.colspan;
        }
      }

      return {
        rowspan: rowspan,
        colspan: colspan
      };
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      var rowStyle = this.table.rowStyle;
      if (typeof rowStyle === 'function') {
        return rowStyle.call(null, {
          row: row,
          rowIndex: rowIndex
        });
      }
      return rowStyle;
    },
    getRowClass: function getRowClass(row, rowIndex) {
      var classes = ['el-table__row'];

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped');
      }
      var rowClassName = this.table.rowClassName;
      if (typeof rowClassName === 'string') {
        classes.push(rowClassName);
      } else if (typeof rowClassName === 'function') {
        classes.push(rowClassName.call(null, {
          row: row,
          rowIndex: rowIndex
        }));
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded');
      }

      return classes.join(' ');
    },
    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
      var cellStyle = this.table.cellStyle;
      if (typeof cellStyle === 'function') {
        return cellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return cellStyle;
    },
    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.align, column.className];

      if (this.isColumnHidden(columnIndex)) {
        classes.push('is-hidden');
      }

      var cellClassName = this.table.cellClassName;
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        classes.push(cellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);

      if (cell) {
        var column = (0, _util.getColumnByCell)(table, cell);
        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
      }

      // 判断是否text-overflow, 如果是就显示tooltip
      var cellChild = event.target.querySelector('.cell');

      if ((0, _dom.hasClass)(cellChild, 'el-tooltip') && cellChild.scrollWidth > cellChild.offsetWidth && this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip;
        // TODO 会引起整个 Table 的重新渲染，需要优化
        this.tooltipContent = cell.textContent || cell.innerText;
        tooltip.referenceElm = cell;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var tooltip = this.$refs.tooltip;
      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
      var cell = (0, _util.getCell)(event);
      if (!cell) return;

      var oldHoverState = this.table.hoverState || {};
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
    },
    handleMouseEnter: function handleMouseEnter(index) {
      this.store.commit('setHoverRow', index);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
    },
    handleContextMenu: function handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu');
    },
    handleDoubleClick: function handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick');
    },
    handleClick: function handleClick(event, row) {
      this.store.commit('setCurrentRow', row);
      this.handleEvent(event, row, 'click');
    },
    handleEvent: function handleEvent(event, row, name) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);
      var column = void 0;
      if (cell) {
        column = (0, _util.getColumnByCell)(table, cell);
        if (column) {
          table.$emit('cell-' + name, row, column, cell, event);
        }
      }
      table.$emit('row-' + name, row, event, column);
    },
    handleExpandClick: function handleExpandClick(row, e) {
      e.stopPropagation();
      this.store.toggleRowExpansion(row);
    }
  }
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(3);

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tag = __webpack_require__(25);

var _tag2 = _interopRequireDefault(_tag);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _filterPanel = __webpack_require__(164);

var _filterPanel2 = _interopRequireDefault(_filterPanel);

var _layoutObserver = __webpack_require__(27);

var _layoutObserver2 = _interopRequireDefault(_layoutObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllColumns = function getAllColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

var convertToRows = function convertToRows(originColumns) {
  var maxLevel = 1;
  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (column.children) {
      var colSpan = 0;
      column.children.forEach(function (subColumn) {
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });

  var rows = [];
  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns);

  allColumns.forEach(function (column) {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }
    rows[column.level - 1].push(column);
  });

  return rows;
};

exports.default = {
  name: 'ElTableHeader',

  mixins: [_layoutObserver2.default],

  render: function render(h) {
    var _this = this;

    var originColumns = this.store.states.originColumns;
    var columnRows = convertToRows(originColumns, this.columns);
    // 是否拥有多级表头
    var isGroup = columnRows.length > 1;
    if (isGroup) this.$parent.isGroup = true;
    return h(
      'table',
      {
        'class': 'el-table__header',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: { name: column.id }
            },
            []
          );
        }), this.hasGutter ? h(
          'col',
          {
            attrs: { name: 'gutter' }
          },
          []
        ) : '']
      ), h(
        'thead',
        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
        [this._l(columnRows, function (columns, rowIndex) {
          return h(
            'tr',
            {
              style: _this.getHeaderRowStyle(rowIndex),
              'class': _this.getHeaderRowClass(rowIndex)
            },
            [_this._l(columns, function (column, cellIndex) {
              return h(
                'th',
                {
                  attrs: {
                    colspan: column.colSpan,
                    rowspan: column.rowSpan
                  },
                  on: {
                    'mousemove': function mousemove($event) {
                      return _this.handleMouseMove($event, column);
                    },
                    'mouseout': _this.handleMouseOut,
                    'mousedown': function mousedown($event) {
                      return _this.handleMouseDown($event, column);
                    },
                    'click': function click($event) {
                      return _this.handleHeaderClick($event, column);
                    },
                    'contextmenu': function contextmenu($event) {
                      return _this.handleHeaderContextMenu($event, column);
                    }
                  },

                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column) },
                [h(
                  'div',
                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
                    'span',
                    { 'class': 'caret-wrapper', on: {
                        'click': function click($event) {
                          return _this.handleSortClick($event, column);
                        }
                      }
                    },
                    [h(
                      'i',
                      { 'class': 'sort-caret ascending', on: {
                          'click': function click($event) {
                            return _this.handleSortClick($event, column, 'ascending');
                          }
                        }
                      },
                      []
                    ), h(
                      'i',
                      { 'class': 'sort-caret descending', on: {
                          'click': function click($event) {
                            return _this.handleSortClick($event, column, 'descending');
                          }
                        }
                      },
                      []
                    )]
                  ) : '', column.filterable ? h(
                    'span',
                    { 'class': 'el-table__column-filter-trigger', on: {
                        'click': function click($event) {
                          return _this.handleFilterClick($event, column);
                        }
                      }
                    },
                    [h(
                      'i',
                      { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] },
                      []
                    )]
                  ) : '']
                )]
              );
            }), _this.hasGutter ? h(
              'th',
              { 'class': 'gutter' },
              []
            ) : '']
          );
        })]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  components: {
    ElCheckbox: _checkbox2.default,
    ElTag: _tag2.default
  },

  computed: {
    table: function table() {
      return this.$parent;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.tableLayout.gutterWidth;
    }
  },

  created: function created() {
    this.filterPanels = {};
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.defaultSort.prop) {
      (function () {
        var states = _this2.store.states;
        states.sortProp = _this2.defaultSort.prop;
        states.sortOrder = _this2.defaultSort.order || 'ascending';
        _this2.$nextTick(function (_) {
          for (var i = 0, length = _this2.columns.length; i < length; i++) {
            var column = _this2.columns[i];
            if (column.property === states.sortProp) {
              column.order = states.sortOrder;
              states.sortingColumn = column;
              break;
            }
          }

          if (states.sortingColumn) {
            _this2.store.commit('changeSortCondition');
          }
        });
      })();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var panels = this.filterPanels;
    for (var prop in panels) {
      if (panels.hasOwnProperty(prop) && panels[prop]) {
        panels[prop].$destroy(true);
      }
    }
  },


  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      var start = 0;
      for (var i = 0; i < index; i++) {
        start += columns[i].colSpan;
      }
      var after = start + columns[index].colSpan - 1;
      if (this.fixed === true || this.fixed === 'left') {
        return after >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return start < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
      var headerRowStyle = this.table.headerRowStyle;
      if (typeof headerRowStyle === 'function') {
        return headerRowStyle.call(null, { rowIndex: rowIndex });
      }
      return headerRowStyle;
    },
    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
      var classes = [];

      var headerRowClassName = this.table.headerRowClassName;
      if (typeof headerRowClassName === 'string') {
        classes.push(headerRowClassName);
      } else if (typeof headerRowClassName === 'function') {
        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
      }

      return classes.join(' ');
    },
    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
      var headerCellStyle = this.table.headerCellStyle;
      if (typeof headerCellStyle === 'function') {
        return headerCellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return headerCellStyle;
    },
    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];

      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
        classes.push('is-hidden');
      }

      if (!column.children) {
        classes.push('is-leaf');
      }

      if (column.sortable) {
        classes.push('is-sortable');
      }

      var headerCellClassName = this.table.headerCellClassName;
      if (typeof headerCellClassName === 'string') {
        classes.push(headerCellClassName);
      } else if (typeof headerCellClassName === 'function') {
        classes.push(headerCellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    },
    handleFilterClick: function handleFilterClick(event, column) {
      event.stopPropagation();
      var target = event.target;
      var cell = target.tagName === 'TH' ? target : target.parentNode;
      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
      var table = this.$parent;

      var filterPanel = this.filterPanels[column.id];

      if (filterPanel && column.filterOpened) {
        filterPanel.showPopper = false;
        return;
      }

      if (!filterPanel) {
        filterPanel = new _vue2.default(_filterPanel2.default);
        this.filterPanels[column.id] = filterPanel;
        if (column.filterPlacement) {
          filterPanel.placement = column.filterPlacement;
        }
        filterPanel.table = table;
        filterPanel.cell = cell;
        filterPanel.column = column;
        !this.$isServer && filterPanel.$mount(document.createElement('div'));
      }

      setTimeout(function () {
        filterPanel.showPopper = true;
      }, 16);
    },
    handleHeaderClick: function handleHeaderClick(event, column) {
      if (!column.filters && column.sortable) {
        this.handleSortClick(event, column);
      } else if (column.filters && !column.sortable) {
        this.handleFilterClick(event, column);
      }

      this.$parent.$emit('header-click', column, event);
    },
    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
      this.$parent.$emit('header-contextmenu', column, event);
    },
    handleMouseDown: function handleMouseDown(event, column) {
      var _this3 = this;

      if (this.$isServer) return;
      if (column.children && column.children.length > 0) return;
      /* istanbul ignore if */
      if (this.draggingColumn && this.border) {
        (function () {
          _this3.dragging = true;

          _this3.$parent.resizeProxyVisible = true;

          var table = _this3.$parent;
          var tableEl = table.$el;
          var tableLeft = tableEl.getBoundingClientRect().left;
          var columnEl = _this3.$el.querySelector('th.' + column.id);
          var columnRect = columnEl.getBoundingClientRect();
          var minLeft = columnRect.left - tableLeft + 30;

          (0, _dom.addClass)(columnEl, 'noclick');

          _this3.dragState = {
            startMouseLeft: event.clientX,
            startLeft: columnRect.right - tableLeft,
            startColumnLeft: columnRect.left - tableLeft,
            tableLeft: tableLeft
          };

          var resizeProxy = table.$refs.resizeProxy;
          resizeProxy.style.left = _this3.dragState.startLeft + 'px';

          document.onselectstart = function () {
            return false;
          };
          document.ondragstart = function () {
            return false;
          };

          var handleMouseMove = function handleMouseMove(event) {
            var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
            var proxyLeft = _this3.dragState.startLeft + deltaLeft;

            resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
          };

          var handleMouseUp = function handleMouseUp() {
            if (_this3.dragging) {
              var _dragState = _this3.dragState,
                  startColumnLeft = _dragState.startColumnLeft,
                  startLeft = _dragState.startLeft;

              var finalLeft = parseInt(resizeProxy.style.left, 10);
              var columnWidth = finalLeft - startColumnLeft;
              column.width = column.realWidth = columnWidth;
              table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

              _this3.store.scheduleLayout();

              document.body.style.cursor = '';
              _this3.dragging = false;
              _this3.draggingColumn = null;
              _this3.dragState = {};

              table.resizeProxyVisible = false;
            }

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.onselectstart = null;
            document.ondragstart = null;

            setTimeout(function () {
              (0, _dom.removeClass)(columnEl, 'noclick');
            }, 0);
          };

          document.addEventListener('mousemove', handleMouseMove);
          document.addEventListener('mouseup', handleMouseUp);
        })();
      }
    },
    handleMouseMove: function handleMouseMove(event, column) {
      if (column.children && column.children.length > 0) return;
      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (!column || !column.resizable) return;

      if (!this.dragging && this.border) {
        var rect = target.getBoundingClientRect();

        var bodyStyle = document.body.style;
        if (rect.width > 12 && rect.right - event.pageX < 8) {
          bodyStyle.cursor = 'col-resize';
          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'col-resize';
          }
          this.draggingColumn = column;
        } else if (!this.dragging) {
          bodyStyle.cursor = '';
          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'pointer';
          }
          this.draggingColumn = null;
        }
      }
    },
    handleMouseOut: function handleMouseOut() {
      if (this.$isServer) return;
      document.body.style.cursor = '';
    },
    toggleOrder: function toggleOrder(order) {
      return !order ? 'ascending' : order === 'ascending' ? 'descending' : null;
    },
    handleSortClick: function handleSortClick(event, column, givenOrder) {
      event.stopPropagation();
      var order = givenOrder || this.toggleOrder(column.order);

      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (target && target.tagName === 'TH') {
        if ((0, _dom.hasClass)(target, 'noclick')) {
          (0, _dom.removeClass)(target, 'noclick');
          return;
        }
      }

      if (!column.sortable) return;

      var states = this.store.states;
      var sortProp = states.sortProp;
      var sortOrder = void 0;
      var sortingColumn = states.sortingColumn;

      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
        if (sortingColumn) {
          sortingColumn.order = null;
        }
        states.sortingColumn = column;
        sortProp = column.property;
      }

      if (!order) {
        sortOrder = column.order = null;
        states.sortingColumn = null;
        sortProp = null;
      } else {
        sortOrder = column.order = order;
      }

      states.sortProp = sortProp;
      states.sortOrder = sortOrder;

      this.store.commit('changeSortCondition');
    }
  },

  data: function data() {
    return {
      draggingColumn: null,
      dragging: false,
      dragState: {}
    };
  }
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a82ec7a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_panel_vue__ = __webpack_require__(167);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a82ec7a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _popup = __webpack_require__(12);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _dropdown = __webpack_require__(166);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _checkboxGroup = __webpack_require__(37);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTableFilterPanel',

  mixins: [_vuePopper2.default, _locale2.default],

  directives: {
    Clickoutside: _clickoutside2.default
  },

  components: {
    ElCheckbox: _checkbox2.default,
    ElCheckboxGroup: _checkboxGroup2.default
  },

  props: {
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },

  customRender: function customRender(h) {
    return h(
      'div',
      { 'class': 'el-table-filter' },
      [h(
        'div',
        { 'class': 'el-table-filter__content' },
        []
      ), h(
        'div',
        { 'class': 'el-table-filter__bottom' },
        [h(
          'button',
          {
            on: {
              'click': this.handleConfirm
            }
          },
          [this.t('el.table.confirmFilter')]
        ), h(
          'button',
          {
            on: {
              'click': this.handleReset
            }
          },
          [this.t('el.table.resetFilter')]
        )]
      )]
    );
  },


  methods: {
    isActive: function isActive(filter) {
      return filter.value === this.filterValue;
    },
    handleOutsideClick: function handleOutsideClick() {
      var _this = this;

      setTimeout(function () {
        _this.showPopper = false;
      }, 16);
    },
    handleConfirm: function handleConfirm() {
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleReset: function handleReset() {
      this.filteredValue = [];
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleSelect: function handleSelect(filterValue) {
      this.filterValue = filterValue;

      if (typeof filterValue !== 'undefined' && filterValue !== null) {
        this.confirmFilter(this.filteredValue);
      } else {
        this.confirmFilter([]);
      }

      this.handleOutsideClick();
    },
    confirmFilter: function confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      });
      this.table.store.updateAllSelected();
    }
  },

  data: function data() {
    return {
      table: null,
      cell: null,
      column: null
    };
  },


  computed: {
    filters: function filters() {
      return this.column && this.column.filters;
    },


    filterValue: {
      get: function get() {
        return (this.column.filteredValue || [])[0];
      },
      set: function set(value) {
        if (this.filteredValue) {
          if (typeof value !== 'undefined' && value !== null) {
            this.filteredValue.splice(0, 1, value);
          } else {
            this.filteredValue.splice(0, 1);
          }
        }
      }
    },

    filteredValue: {
      get: function get() {
        if (this.column) {
          return this.column.filteredValue || [];
        }
        return [];
      },
      set: function set(value) {
        if (this.column) {
          this.column.filteredValue = value;
        }
      }
    },

    multiple: function multiple() {
      if (this.column) {
        return this.column.filterMultiple;
      }
      return true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.popperElm = this.$el;
    this.referenceElm = this.cell;
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this2.updatePopper();
    });

    this.$watch('showPopper', function (value) {
      if (_this2.column) _this2.column.filterOpened = value;
      if (value) {
        _dropdown2.default.open(_this2);
      } else {
        _dropdown2.default.close(_this2);
      }
    });
  },

  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < _popup.PopupManager.zIndex) {
        this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdowns = [];

!_vue2.default.prototype.$isServer && document.addEventListener('click', function (event) {
  dropdowns.forEach(function (dropdown) {
    var target = event.target;
    if (!dropdown || !dropdown.$el) return;
    if (target === dropdown.$el || dropdown.$el.contains(target)) {
      return;
    }
    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
  });
});

exports.default = {
  open: function open(instance) {
    if (instance) {
      dropdowns.push(instance);
    }
  },
  close: function close(instance) {
    var index = dropdowns.indexOf(instance);
    if (index !== -1) {
      dropdowns.splice(instance, 1);
    }
  }
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.multiple)?_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleOutsideClick),expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter"},[_c('div',{staticClass:"el-table-filter__content"},[_c('el-checkbox-group',{staticClass:"el-table-filter__checkbox-group",model:{value:(_vm.filteredValue),callback:function ($$v) {_vm.filteredValue=$$v},expression:"filteredValue"}},_vm._l((_vm.filters),function(filter){return _c('el-checkbox',{key:filter.value,attrs:{"label":filter.value}},[_vm._v(_vm._s(filter.text))])}))],1),_c('div',{staticClass:"el-table-filter__bottom"},[_c('button',{class:{ 'is-disabled': _vm.filteredValue.length === 0 },attrs:{"disabled":_vm.filteredValue.length === 0},on:{"click":_vm.handleConfirm}},[_vm._v(_vm._s(_vm.t('el.table.confirmFilter')))]),_c('button',{on:{"click":_vm.handleReset}},[_vm._v(_vm._s(_vm.t('el.table.resetFilter')))])])]):_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleOutsideClick),expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter"},[_c('ul',{staticClass:"el-table-filter__list"},[_c('li',{staticClass:"el-table-filter__list-item",class:{ 'is-active': _vm.filterValue === undefined || _vm.filterValue === null },on:{"click":function($event){_vm.handleSelect(null)}}},[_vm._v(_vm._s(_vm.t('el.table.clearFilter')))]),_vm._l((_vm.filters),function(filter){return _c('li',{key:filter.value,staticClass:"el-table-filter__list-item",class:{ 'is-active': _vm.isActive(filter) },attrs:{"label":filter.value},on:{"click":function($event){_vm.handleSelect(filter.value)}}},[_vm._v(_vm._s(filter.text))])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _layoutObserver = __webpack_require__(27);

var _layoutObserver2 = _interopRequireDefault(_layoutObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTableFooter',

  mixins: [_layoutObserver2.default],

  render: function render(h) {
    var _this = this;

    var sums = [];
    this.columns.forEach(function (column, index) {
      if (index === 0) {
        sums[index] = _this.sumText;
        return;
      }
      var values = _this.store.states.data.map(function (item) {
        return Number(item[column.property]);
      });
      var precisions = [];
      var notNumber = true;
      values.forEach(function (value) {
        if (!isNaN(value)) {
          notNumber = false;
          var decimal = ('' + value).split('.')[1];
          precisions.push(decimal ? decimal.length : 0);
        }
      });
      var precision = Math.max.apply(null, precisions);
      if (!notNumber) {
        sums[index] = values.reduce(function (prev, curr) {
          var value = Number(curr);
          if (!isNaN(value)) {
            return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
          } else {
            return prev;
          }
        }, 0);
      } else {
        sums[index] = '';
      }
    });

    return h(
      'table',
      {
        'class': 'el-table__footer',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: { name: column.id }
            },
            []
          );
        }), this.hasGutter ? h(
          'col',
          {
            attrs: { name: 'gutter' }
          },
          []
        ) : '']
      ), h(
        'tbody',
        { 'class': [{ 'has-gutter': this.hasGutter }] },
        [h(
          'tr',
          null,
          [this._l(this.columns, function (column, cellIndex) {
            return h(
              'td',
              {
                attrs: {
                  colspan: column.colSpan,
                  rowspan: column.rowSpan
                },
                'class': [column.id, column.headerAlign, column.className || '', _this.isCellHidden(cellIndex, _this.columns) ? 'is-hidden' : '', !column.children ? 'is-leaf' : '', column.labelClassName] },
              [h(
                'div',
                { 'class': ['cell', column.labelClassName] },
                [_this.summaryMethod ? _this.summaryMethod({ columns: _this.columns, data: _this.store.states.data })[cellIndex] : sums[cellIndex]]
              )]
            );
          }), this.hasGutter ? h(
            'th',
            { 'class': 'gutter' },
            []
          ) : '']
        )]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    summaryMethod: Function,
    sumText: String,
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  computed: {
    table: function table() {
      return this.$parent;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.tableLayout.gutterWidth;
    }
  },

  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedCount;
      } else if (this.fixed === 'right') {
        var before = 0;
        for (var i = 0; i < index; i++) {
          before += columns[i].colSpan;
        }
        return before < this.columnsCount - this.rightFixedCount;
      } else {
        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
      }
    }
  }
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-table",class:[{
    'el-table--fit': _vm.fit,
    'el-table--striped': _vm.stripe,
    'el-table--border': _vm.border || _vm.isGroup,
    'el-table--hidden': _vm.isHidden,
    'el-table--group': _vm.isGroup,
    'el-table--fluid-height': _vm.maxHeight,
    'el-table--scrollable-x': _vm.layout.scrollX,
    'el-table--scrollable-y': _vm.layout.scrollY,
    'el-table--enable-row-hover': !_vm.store.states.isComplex,
    'el-table--enable-row-transition': (_vm.store.states.data || []).length !== 0 && (_vm.store.states.data || []).length < 100
  }, _vm.tableSize ? ("el-table--" + _vm.tableSize) : ''],on:{"mouseleave":function($event){_vm.handleMouseLeave($event)}}},[_c('div',{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),(_vm.showHeader)?_c('div',{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:(_vm.handleHeaderFooterMousewheel),expression:"handleHeaderFooterMousewheel"}],ref:"headerWrapper",staticClass:"el-table__header-wrapper"},[_c('table-header',{ref:"tableHeader",style:({
        width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + 'px' : ''
      }),attrs:{"store":_vm.store,"border":_vm.border,"default-sort":_vm.defaultSort}})],1):_vm._e(),_c('div',{ref:"bodyWrapper",staticClass:"el-table__body-wrapper",class:[_vm.layout.scrollX ? ("is-scrolling-" + _vm.scrollPosition) : 'is-scrolling-none'],style:([_vm.bodyHeight])},[_c('table-body',{style:({
         width: _vm.bodyWidth
      }),attrs:{"context":_vm.context,"store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}}),(!_vm.data || _vm.data.length === 0)?_c('div',{ref:"emptyBlock",staticClass:"el-table__empty-block",style:({
        width: _vm.bodyWidth
      })},[_c('span',{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(_vm._s(_vm.emptyText || _vm.t('el.table.emptyText')))])],2)]):_vm._e(),(_vm.$slots.append)?_c('div',{ref:"appendWrapper",staticClass:"el-table__append-wrapper"},[_vm._t("append")],2):_vm._e()],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"},{name:"mousewheel",rawName:"v-mousewheel",value:(_vm.handleHeaderFooterMousewheel),expression:"handleHeaderFooterMousewheel"}],ref:"footerWrapper",staticClass:"el-table__footer-wrapper"},[_c('table-footer',{style:({
        width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + 'px' : ''
      }),attrs:{"store":_vm.store,"border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"default-sort":_vm.defaultSort}})],1):_vm._e(),(_vm.fixedColumns.length > 0)?_c('div',{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:(_vm.handleFixedMousewheel),expression:"handleFixedMousewheel"}],ref:"fixedWrapper",staticClass:"el-table__fixed",style:([{
      width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : ''
    },
    _vm.fixedHeight])},[(_vm.showHeader)?_c('div',{ref:"fixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{ref:"fixedTableHeader",style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"left","border":_vm.border,"store":_vm.store}})],1):_vm._e(),_c('div',{ref:"fixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([{
        top: _vm.layout.headerHeight + 'px'
      },
      _vm.fixedBodyHeight])},[_c('table-body',{style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"left","store":_vm.store,"stripe":_vm.stripe,"highlight":_vm.highlightCurrentRow,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle}}),(_vm.$slots.append)?_c('div',{staticClass:"el-table__append-gutter",style:({
          height: _vm.layout.appendHeight + 'px'
        })}):_vm._e()],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"fixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"left","border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store}})],1):_vm._e()]):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:(_vm.handleFixedMousewheel),expression:"handleFixedMousewheel"}],ref:"rightFixedWrapper",staticClass:"el-table__fixed-right",style:([{
      width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : '',
      right: _vm.layout.scrollY ? (_vm.border ? _vm.layout.gutterWidth : (_vm.layout.gutterWidth || 0)) + 'px' : ''
    },
    _vm.fixedHeight])},[(_vm.showHeader)?_c('div',{ref:"rightFixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{ref:"rightFixedTableHeader",style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"right","border":_vm.border,"store":_vm.store}})],1):_vm._e(),_c('div',{ref:"rightFixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([{
        top: _vm.layout.headerHeight + 'px'
      },
      _vm.fixedBodyHeight])},[_c('table-body',{style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"right","store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}})],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"rightFixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({
          width: _vm.bodyWidth
        }),attrs:{"fixed":"right","border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store}})],1):_vm._e()]):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{ref:"rightFixedPatch",staticClass:"el-table__fixed-right-patch",style:({
      width: _vm.layout.scrollY ? _vm.layout.gutterWidth + 'px' : '0',
      height: _vm.layout.headerHeight + 'px'
    })}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resizeProxyVisible),expression:"resizeProxyVisible"}],ref:"resizeProxy",staticClass:"el-table__column-resize-proxy"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tableColumn = __webpack_require__(171);

var _tableColumn2 = _interopRequireDefault(_tableColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tableColumn2.default.install = function (Vue) {
  Vue.component(_tableColumn2.default.name, _tableColumn2.default);
};

exports.default = _tableColumn2.default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tag = __webpack_require__(25);

var _tag2 = _interopRequireDefault(_tag);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnIdSeed = 1;

var defaults = {
  default: {
    order: ''
  },
  selection: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: '',
    className: 'el-table-column--selection'
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  }
};

var forced = {
  selection: {
    renderHeader: function renderHeader(h, _ref) {
      var store = _ref.store;

      return h(
        'el-checkbox',
        {
          attrs: {
            disabled: store.states.data && store.states.data.length === 0,
            indeterminate: store.states.selection.length > 0 && !this.isAllSelected,

            value: this.isAllSelected },
          nativeOn: {
            'click': this.toggleAllSelection
          }
        },
        []
      );
    },
    renderCell: function renderCell(h, _ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          store = _ref2.store,
          $index = _ref2.$index;

      return h(
        'el-checkbox',
        {
          nativeOn: {
            'click': function click(event) {
              return event.stopPropagation();
            }
          },
          attrs: {
            value: store.isSelected(row),
            disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
          },
          on: {
            'input': function input() {
              store.commit('rowSelectedChanged', row);
            }
          }
        },
        []
      );
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function renderHeader(h, _ref3) {
      var column = _ref3.column;

      return column.label || '#';
    },
    renderCell: function renderCell(h, _ref4) {
      var $index = _ref4.$index,
          column = _ref4.column;

      var i = $index + 1;
      var index = column.index;

      if (typeof index === 'number') {
        i = $index + index;
      } else if (typeof index === 'function') {
        i = index($index);
      }

      return h(
        'div',
        null,
        [i]
      );
    },
    sortable: false
  },
  expand: {
    renderHeader: function renderHeader(h, _ref5) {
      var column = _ref5.column;

      return column.label || '';
    },
    renderCell: function renderCell(h, _ref6, proxy) {
      var row = _ref6.row,
          store = _ref6.store;

      var expanded = store.states.expandRows.indexOf(row) > -1;
      return h(
        'div',
        { 'class': 'el-table__expand-icon ' + (expanded ? 'el-table__expand-icon--expanded' : ''),
          on: {
            'click': function click(e) {
              return proxy.handleExpandClick(row, e);
            }
          }
        },
        [h(
          'i',
          { 'class': 'el-icon el-icon-arrow-right' },
          []
        )]
      );
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  }
};

var getDefaultColumn = function getDefaultColumn(type, options) {
  var column = {};

  (0, _merge2.default)(column, defaults[type || 'default']);

  for (var name in options) {
    if (options.hasOwnProperty(name)) {
      var value = options[name];
      if (typeof value !== 'undefined') {
        column[name] = value;
      }
    }
  }

  if (!column.minWidth) {
    column.minWidth = 80;
  }

  column.realWidth = column.width === undefined ? column.minWidth : column.width;

  return column;
};

var DEFAULT_RENDER_CELL = function DEFAULT_RENDER_CELL(h, _ref7) {
  var row = _ref7.row,
      column = _ref7.column,
      $index = _ref7.$index;

  var property = column.property;
  var value = property && (0, _util.getPropByPath)(row, property).v;
  if (column && column.formatter) {
    return column.formatter(row, column, value, $index);
  }
  return value;
};

var parseWidth = function parseWidth(width) {
  if (width !== undefined) {
    width = parseInt(width, 10);
    if (isNaN(width)) {
      width = null;
    }
  }
  return width;
};

var parseMinWidth = function parseMinWidth(minWidth) {
  if (minWidth !== undefined) {
    minWidth = parseInt(minWidth, 10);
    if (isNaN(minWidth)) {
      minWidth = 80;
    }
  }
  return minWidth;
};

exports.default = {
  name: 'ElTableColumn',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    label: String,
    className: String,
    labelClassName: String,
    property: String,
    prop: String,
    width: {},
    minWidth: {},
    renderHeader: Function,
    sortable: {
      type: [String, Boolean],
      default: false
    },
    sortMethod: Function,
    sortBy: [String, Function, Array],
    resizable: {
      type: Boolean,
      default: true
    },
    context: {},
    columnKey: String,
    align: String,
    headerAlign: String,
    showTooltipWhenOverflow: Boolean,
    showOverflowTooltip: Boolean,
    fixed: [Boolean, String],
    formatter: Function,
    selectable: Function,
    reserveSelection: Boolean,
    filterMethod: Function,
    filteredValue: Array,
    filters: Array,
    filterPlacement: String,
    filterMultiple: {
      type: Boolean,
      default: true
    },
    index: [Number, Function]
  },

  data: function data() {
    return {
      isSubColumn: false,
      columns: []
    };
  },
  beforeCreate: function beforeCreate() {
    this.row = {};
    this.column = {};
    this.$index = 0;
  },


  components: {
    ElCheckbox: _checkbox2.default,
    ElTag: _tag2.default
  },

  computed: {
    owner: function owner() {
      var parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent;
    },
    columnOrTableParent: function columnOrTableParent() {
      var parent = this.$parent;
      while (parent && !parent.tableId && !parent.columnId) {
        parent = parent.$parent;
      }
      return parent;
    }
  },

  created: function created() {
    var _this = this;

    this.customRender = this.$options.render;
    this.$options.render = function (h) {
      return h('div', _this.$slots.default);
    };

    var parent = this.columnOrTableParent;
    var owner = this.owner;
    this.isSubColumn = owner !== parent;
    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;

    var type = this.type;

    var width = parseWidth(this.width);
    var minWidth = parseMinWidth(this.minWidth);

    var isColumnGroup = false;

    var column = getDefaultColumn(type, {
      id: this.columnId,
      columnKey: this.columnKey,
      label: this.label,
      className: this.className,
      labelClassName: this.labelClassName,
      property: this.prop || this.property,
      type: type,
      renderCell: null,
      renderHeader: this.renderHeader,
      minWidth: minWidth,
      width: width,
      isColumnGroup: isColumnGroup,
      context: this.context,
      align: this.align ? 'is-' + this.align : null,
      headerAlign: this.headerAlign ? 'is-' + this.headerAlign : this.align ? 'is-' + this.align : null,
      sortable: this.sortable === '' ? true : this.sortable,
      sortMethod: this.sortMethod,
      sortBy: this.sortBy,
      resizable: this.resizable,
      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
      formatter: this.formatter,
      selectable: this.selectable,
      reserveSelection: this.reserveSelection,
      fixed: this.fixed === '' ? true : this.fixed,
      filterMethod: this.filterMethod,
      filters: this.filters,
      filterable: this.filters || this.filterMethod,
      filterMultiple: this.filterMultiple,
      filterOpened: false,
      filteredValue: this.filteredValue || [],
      filterPlacement: this.filterPlacement || '',
      index: this.index
    });

    (0, _merge2.default)(column, forced[type] || {});

    this.columnConfig = column;

    var renderCell = column.renderCell;
    var _self = this;

    if (type === 'expand') {
      owner.renderExpanded = function (h, data) {
        return _self.$scopedSlots.default ? _self.$scopedSlots.default(data) : _self.$slots.default;
      };

      column.renderCell = function (h, data) {
        return h(
          'div',
          { 'class': 'cell' },
          [renderCell(h, data, this._renderProxy)]
        );
      };

      return;
    }

    column.renderCell = function (h, data) {
      if (_self.$scopedSlots.default) {
        renderCell = function renderCell() {
          return _self.$scopedSlots.default(data);
        };
      }

      if (!renderCell) {
        renderCell = DEFAULT_RENDER_CELL;
      }

      return _self.showOverflowTooltip || _self.showTooltipWhenOverflow ? h(
        'div',
        { 'class': 'cell el-tooltip', style: { width: (data.column.realWidth || data.column.width) - 1 + 'px' } },
        [renderCell(h, data)]
      ) : h(
        'div',
        { 'class': 'cell' },
        [renderCell(h, data)]
      );
    };
  },
  destroyed: function destroyed() {
    if (!this.$parent) return;
    var parent = this.$parent;
    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
  },


  watch: {
    label: function label(newVal) {
      if (this.columnConfig) {
        this.columnConfig.label = newVal;
      }
    },
    prop: function prop(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    property: function property(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    filters: function filters(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filters = newVal;
      }
    },
    filterMultiple: function filterMultiple(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filterMultiple = newVal;
      }
    },
    align: function align(newVal) {
      if (this.columnConfig) {
        this.columnConfig.align = newVal ? 'is-' + newVal : null;

        if (!this.headerAlign) {
          this.columnConfig.headerAlign = newVal ? 'is-' + newVal : null;
        }
      }
    },
    headerAlign: function headerAlign(newVal) {
      if (this.columnConfig) {
        this.columnConfig.headerAlign = 'is-' + (newVal ? newVal : this.align);
      }
    },
    width: function width(newVal) {
      if (this.columnConfig) {
        this.columnConfig.width = parseWidth(newVal);
        this.owner.store.scheduleLayout();
      }
    },
    minWidth: function minWidth(newVal) {
      if (this.columnConfig) {
        this.columnConfig.minWidth = parseMinWidth(newVal);
        this.owner.store.scheduleLayout();
      }
    },
    fixed: function fixed(newVal) {
      if (this.columnConfig) {
        this.columnConfig.fixed = newVal;
        this.owner.store.scheduleLayout(true);
      }
    },
    sortable: function sortable(newVal) {
      if (this.columnConfig) {
        this.columnConfig.sortable = newVal;
      }
    },
    index: function index(newVal) {
      if (this.columnConfig) {
        this.columnConfig.index = newVal;
      }
    },
    formatter: function formatter(newVal) {
      if (this.columnConfig) {
        this.columnConfig.formatter = newVal;
      }
    }
  },

  mounted: function mounted() {
    var owner = this.owner;
    var parent = this.columnOrTableParent;
    var columnIndex = void 0;

    if (!this.isSubColumn) {
      columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
    } else {
      columnIndex = [].indexOf.call(parent.$el.children, this.$el);
    }

    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
  }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _datePicker = __webpack_require__(173);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_datePicker2.default.install = function install(Vue) {
  Vue.component(_datePicker2.default.name, _datePicker2.default);
};

exports.default = _datePicker2.default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _date = __webpack_require__(177);

var _date2 = _interopRequireDefault(_date);

var _dateRange = __webpack_require__(192);

var _dateRange2 = _interopRequireDefault(_dateRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPanel = function getPanel(type) {
  if (type === 'daterange' || type === 'datetimerange') {
    return _dateRange2.default;
  }
  return _date2.default;
};

exports.default = {
  mixins: [_picker2.default],

  name: 'ElDatePicker',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean
  },

  watch: {
    type: function type(_type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = getPanel(_type);
        this.mountPicker();
      } else {
        this.panel = getPanel(_type);
      }
    }
  },

  created: function created() {
    this.panel = getPanel(this.type);
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _util = __webpack_require__(11);

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewPopper = {
  props: {
    appendToBody: _vuePopper2.default.props.appendToBody,
    offset: _vuePopper2.default.props.offset,
    boundariesPadding: _vuePopper2.default.props.boundariesPadding,
    arrowOffset: _vuePopper2.default.props.arrowOffset
  },
  methods: _vuePopper2.default.methods,
  data: function data() {
    return (0, _merge2.default)({ visibleArrow: true }, _vuePopper2.default.data);
  },

  beforeDestroy: _vuePopper2.default.beforeDestroy
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_FORMATS = {
  date: 'yyyy-MM-dd',
  month: 'yyyy-MM',
  datetime: 'yyyy-MM-dd HH:mm:ss',
  time: 'HH:mm:ss',
  week: 'yyyywWW',
  timerange: 'HH:mm:ss',
  daterange: 'yyyy-MM-dd',
  datetimerange: 'yyyy-MM-dd HH:mm:ss',
  year: 'yyyy'
};
var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'timerange', 'datetimerange', 'dates'];
var DATE_FORMATTER = function DATE_FORMATTER(value, format) {
  if (format === 'timestamp') return value.getTime();
  return (0, _util.formatDate)(value, format);
};
var DATE_PARSER = function DATE_PARSER(text, format) {
  if (format === 'timestamp') return new Date(Number(text));
  return (0, _util.parseDate)(text, format);
};
var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
  if (Array.isArray(value) && value.length === 2) {
    var start = value[0];
    var end = value[1];

    if (start && end) {
      return [DATE_FORMATTER(start, format), DATE_FORMATTER(end, format)];
    }
  }
  return '';
};
var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
  if (!Array.isArray(array)) {
    array = array.split(separator);
  }
  if (array.length === 2) {
    var range1 = array[0];
    var range2 = array[1];

    return [DATE_PARSER(range1, format), DATE_PARSER(range2, format)];
  }
  return [];
};
var TYPE_VALUE_RESOLVER_MAP = {
  default: {
    formatter: function formatter(value) {
      if (!value) return '';
      return '' + value;
    },
    parser: function parser(text) {
      if (text === undefined || text === '') return null;
      return text;
    }
  },
  week: {
    formatter: function formatter(value, format) {
      var week = (0, _util.getWeekNumber)(value);
      var month = value.getMonth();
      var trueDate = new Date(value);
      if (week === 1 && month === 11) {
        trueDate.setHours(0, 0, 0, 0);
        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
      }
      var date = (0, _util.formatDate)(trueDate, format);

      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
      return date;
    },
    parser: function parser(text) {
      var array = (text || '').split('w');
      if (array.length === 2) {
        var year = Number(array[0]);
        var month = Number(array[1]);

        if (!isNaN(year) && !isNaN(month) && month < 54) {
          return text;
        }
      }
      return null;
    }
  },
  date: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  datetime: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  daterange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  datetimerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  timerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  time: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  month: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  year: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  number: {
    formatter: function formatter(value) {
      if (!value) return '';
      return '' + value;
    },
    parser: function parser(text) {
      var result = Number(text);

      if (!isNaN(text)) {
        return result;
      } else {
        return null;
      }
    }
  },
  dates: {
    formatter: function formatter(value, format) {
      return value.map(function (date) {
        return DATE_FORMATTER(date, format);
      });
    },
    parser: function parser(value, format) {
      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
        return date instanceof Date ? date : DATE_PARSER(date, format);
      });
    }
  }
};
var PLACEMENT_MAP = {
  left: 'bottom-start',
  center: 'bottom',
  right: 'bottom-end'
};

var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';

  if (!value) return null;
  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
  var format = customFormat || DEFAULT_FORMATS[type];
  return parser(value, format, rangeSeparator);
};

var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
  if (!value) return null;
  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
  var format = customFormat || DEFAULT_FORMATS[type];
  return formatter(value, format);
};

// only considers date-picker's value: Date or [Date, Date]
var valueEquals = function valueEquals(a, b) {
  var aIsArray = a instanceof Array;
  var bIsArray = b instanceof Array;
  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every(function (item, index) {
      return new Date(item).getTime() === new Date(b[index]).getTime();
    });
  }
  if (!aIsArray && !bIsArray) {
    return new Date(a).getTime() === new Date(b).getTime();
  }
  return false;
};

var isString = function isString(val) {
  return typeof val === 'string' || val instanceof String;
};

var validator = function validator(val) {
  // either: String, Array of String, null / undefined
  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
};

exports.default = {
  mixins: [_emitter2.default, NewPopper],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    size: String,
    format: String,
    valueFormat: String,
    readonly: Boolean,
    placeholder: String,
    startPlaceholder: String,
    endPlaceholder: String,
    prefixIcon: String,
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    name: {
      default: '',
      validator: validator
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    id: {
      default: '',
      validator: validator
    },
    popperClass: String,
    editable: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'left'
    },
    value: {},
    defaultValue: {},
    defaultTime: {},
    rangeSeparator: {
      default: '-'
    },
    pickerOptions: {},
    unlinkPanels: Boolean
  },

  components: { ElInput: _input2.default },

  directives: { Clickoutside: _clickoutside2.default },

  data: function data() {
    return {
      pickerVisible: false,
      showClose: false,
      userInput: null,
      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
      unwatchPickerOptions: null
    };
  },


  watch: {
    pickerVisible: function pickerVisible(val) {
      if (this.readonly || this.pickerDisabled) return;
      if (val) {
        this.showPicker();
        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
      } else {
        this.hidePicker();
        this.emitChange(this.value);
        this.userInput = null;
        this.dispatch('ElFormItem', 'el.form.blur');
        this.$emit('blur', this);
        this.blur();
      }
    },

    parsedValue: {
      immediate: true,
      handler: function handler(val) {
        if (this.picker) {
          this.picker.value = val;
          this.picker.selectedDate = Array.isArray(val) ? val : [];
        }
      }
    },
    defaultValue: function defaultValue(val) {
      // NOTE: should eventually move to jsx style picker + panel ?
      if (this.picker) {
        this.picker.defaultValue = val;
      }
    }
  },

  computed: {
    ranged: function ranged() {
      return this.type.indexOf('range') > -1;
    },
    reference: function reference() {
      var reference = this.$refs.reference;
      return reference.$el || reference;
    },
    refInput: function refInput() {
      if (this.reference) {
        return [].slice.call(this.reference.querySelectorAll('input'));
      }
      return [];
    },
    valueIsEmpty: function valueIsEmpty() {
      var val = this.value;
      if (Array.isArray(val)) {
        for (var i = 0, len = val.length; i < len; i++) {
          if (val[i]) {
            return false;
          }
        }
      } else {
        if (val) {
          return false;
        }
      }
      return true;
    },
    triggerClass: function triggerClass() {
      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
    },
    selectionMode: function selectionMode() {
      if (this.type === 'week') {
        return 'week';
      } else if (this.type === 'month') {
        return 'month';
      } else if (this.type === 'year') {
        return 'year';
      } else if (this.type === 'dates') {
        return 'dates';
      }

      return 'day';
    },
    haveTrigger: function haveTrigger() {
      if (typeof this.showTrigger !== 'undefined') {
        return this.showTrigger;
      }
      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
    },
    displayValue: function displayValue() {
      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
      if (Array.isArray(this.userInput)) {
        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
      } else if (this.userInput !== null) {
        return this.userInput;
      } else if (formattedValue) {
        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
      } else {
        return '';
      }
    },
    parsedValue: function parsedValue() {
      var isParsed = (0, _util.isDateObject)(this.value) || Array.isArray(this.value) && this.value.every(_util.isDateObject);
      if (this.valueFormat && !isParsed) {
        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
      } else {
        return this.value;
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    pickerSize: function pickerSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    pickerDisabled: function pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    firstInputId: function firstInputId() {
      var obj = {};
      var id = void 0;
      if (this.ranged) {
        id = this.id && this.id[0];
      } else {
        id = this.id;
      }
      if (id) obj.id = id;
      return obj;
    },
    secondInputId: function secondInputId() {
      var obj = {};
      var id = void 0;
      if (this.ranged) {
        id = this.id && this.id[1];
      }
      if (id) obj.id = id;
      return obj;
    }
  },

  created: function created() {
    // vue-popper
    this.popperOptions = {
      boundariesPadding: 0,
      gpuAcceleration: false
    };
    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;

    this.$on('fieldReset', this.handleFieldReset);
  },


  methods: {
    focus: function focus() {
      if (!this.ranged) {
        this.$refs.reference.focus();
      } else {
        this.handleFocus();
      }
    },
    blur: function blur() {
      this.refInput.forEach(function (input) {
        return input.blur();
      });
    },


    // {parse, formatTo} Value deals maps component value with internal Date
    parseValue: function parseValue(value) {
      var isParsed = (0, _util.isDateObject)(value) || Array.isArray(value) && value.every(_util.isDateObject);
      if (this.valueFormat && !isParsed) {
        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
      } else {
        return value;
      }
    },
    formatToValue: function formatToValue(date) {
      var isFormattable = (0, _util.isDateObject)(date) || Array.isArray(date) && date.every(_util.isDateObject);
      if (this.valueFormat && isFormattable) {
        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
      } else {
        return date;
      }
    },


    // {parse, formatTo} String deals with user input
    parseString: function parseString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return parseAsFormatAndType(value, this.format, type);
    },
    formatToString: function formatToString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return formatAsFormatAndType(value, this.format, type);
    },
    handleMouseEnter: function handleMouseEnter() {
      if (this.readonly || this.pickerDisabled) return;
      if (!this.valueIsEmpty && this.clearable) {
        this.showClose = true;
      }
    },
    handleChange: function handleChange() {
      if (this.userInput) {
        var value = this.parseString(this.displayValue);
        if (value) {
          this.picker.value = value;
          if (this.isValidValue(value)) {
            this.emitInput(value);
            this.userInput = null;
          }
        }
      }
      if (this.userInput === '') {
        this.emitInput(null);
        this.emitChange(null);
        this.userInput = null;
      }
    },
    handleStartInput: function handleStartInput(event) {
      if (this.userInput) {
        this.userInput = [event.target.value, this.userInput[1]];
      } else {
        this.userInput = [event.target.value, null];
      }
    },
    handleEndInput: function handleEndInput(event) {
      if (this.userInput) {
        this.userInput = [this.userInput[0], event.target.value];
      } else {
        this.userInput = [null, event.target.value];
      }
    },
    handleStartChange: function handleStartChange(event) {
      var value = this.parseString(this.userInput && this.userInput[0]);
      if (value) {
        this.userInput = [this.formatToString(value), this.displayValue[1]];
        var newValue = [value, this.picker.value && this.picker.value[1]];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    },
    handleEndChange: function handleEndChange(event) {
      var value = this.parseString(this.userInput && this.userInput[1]);
      if (value) {
        this.userInput = [this.displayValue[0], this.formatToString(value)];
        var newValue = [this.picker.value && this.picker.value[0], value];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    },
    handleClickIcon: function handleClickIcon(event) {
      if (this.readonly || this.pickerDisabled) return;
      if (this.showClose) {
        this.valueOnOpen = this.value;
        event.stopPropagation();
        this.emitInput(null);
        this.emitChange(null);
        this.showClose = false;
        if (this.picker && typeof this.picker.handleClear === 'function') {
          this.picker.handleClear();
        }
      } else {
        this.pickerVisible = !this.pickerVisible;
      }
    },
    handleClose: function handleClose() {
      if (!this.pickerVisible) return;
      this.pickerVisible = false;
      var type = this.type,
          valueOnOpen = this.valueOnOpen,
          valueFormat = this.valueFormat,
          rangeSeparator = this.rangeSeparator;

      if (type === 'dates' && this.picker) {
        this.picker.selectedDate = parseAsFormatAndType(valueOnOpen, valueFormat, type, rangeSeparator) || valueOnOpen;
        this.emitInput(this.picker.selectedDate);
      }
    },
    handleFieldReset: function handleFieldReset(initialValue) {
      this.userInput = initialValue;
    },
    handleFocus: function handleFocus() {
      var type = this.type;

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true;
      }
      this.$emit('focus', this);
    },
    handleKeydown: function handleKeydown(event) {
      var _this = this;

      var keyCode = event.keyCode;

      // ESC
      if (keyCode === 27) {
        this.pickerVisible = false;
        event.stopPropagation();
        return;
      }

      // Tab
      if (keyCode === 9) {
        if (!this.ranged) {
          this.handleChange();
          this.pickerVisible = this.picker.visible = false;
          this.blur();
          event.stopPropagation();
        } else {
          // user may change focus between two input
          setTimeout(function () {
            if (_this.refInput.indexOf(document.activeElement) === -1) {
              _this.pickerVisible = false;
              _this.blur();
              event.stopPropagation();
            }
          }, 0);
        }
        return;
      }

      // Enter
      if (keyCode === 13) {
        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
          this.handleChange();
          this.pickerVisible = this.picker.visible = false;
          this.blur();
        }
        event.stopPropagation();
        return;
      }

      // if user is typing, do not let picker handle key input
      if (this.userInput) {
        event.stopPropagation();
        return;
      }

      // delegate other keys to panel
      if (this.picker && this.picker.handleKeydown) {
        this.picker.handleKeydown(event);
      }
    },
    handleRangeClick: function handleRangeClick() {
      var type = this.type;

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true;
      }
      this.$emit('focus', this);
    },
    hidePicker: function hidePicker() {
      if (this.picker) {
        this.picker.resetView && this.picker.resetView();
        this.pickerVisible = this.picker.visible = false;
        this.destroyPopper();
      }
    },
    showPicker: function showPicker() {
      var _this2 = this;

      if (this.$isServer) return;
      if (!this.picker) {
        this.mountPicker();
      }
      this.pickerVisible = this.picker.visible = true;

      this.updatePopper();

      this.picker.value = this.parsedValue;
      this.picker.resetView && this.picker.resetView();

      this.$nextTick(function () {
        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
      });
    },
    mountPicker: function mountPicker() {
      var _this3 = this;

      this.picker = new _vue2.default(this.panel).$mount();
      this.picker.defaultValue = this.defaultValue;
      this.picker.defaultTime = this.defaultTime;
      this.picker.popperClass = this.popperClass;
      this.popperElm = this.picker.$el;
      this.picker.width = this.reference.getBoundingClientRect().width;
      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
      this.picker.selectionMode = this.selectionMode;
      this.picker.unlinkPanels = this.unlinkPanels;
      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
      this.picker.selectedDate = Array.isArray(this.value) && this.value || [];
      this.$watch('format', function (format) {
        _this3.picker.format = format;
      });

      var updateOptions = function updateOptions() {
        var options = _this3.pickerOptions;

        if (options && options.selectableRange) {
          (function () {
            var ranges = options.selectableRange;
            var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
            var format = DEFAULT_FORMATS.timerange;

            ranges = Array.isArray(ranges) ? ranges : [ranges];
            _this3.picker.selectableRange = ranges.map(function (range) {
              return parser(range, format, _this3.rangeSeparator);
            });
          })();
        }

        for (var option in options) {
          if (options.hasOwnProperty(option) &&
          // 忽略 time-picker 的该配置项
          option !== 'selectableRange') {
            _this3.picker[option] = options[option];
          }
        }

        // main format must prevail over undocumented pickerOptions.format
        if (_this3.format) {
          _this3.picker.format = _this3.format;
        }
      };
      updateOptions();
      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
        return updateOptions();
      }, { deep: true });

      this.$el.appendChild(this.picker.$el);
      this.picker.resetView && this.picker.resetView();

      this.picker.$on('dodestroy', this.doDestroy);
      this.picker.$on('pick', function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this3.userInput = null;
        _this3.pickerVisible = _this3.picker.visible = visible;
        _this3.emitInput(date);
        _this3.picker.resetView && _this3.picker.resetView();
      });

      this.picker.$on('select-range', function (start, end, pos) {
        if (_this3.refInput.length === 0) return;
        if (!pos || pos === 'min') {
          _this3.refInput[0].setSelectionRange(start, end);
          _this3.refInput[0].focus();
        } else if (pos === 'max') {
          _this3.refInput[1].setSelectionRange(start, end);
          _this3.refInput[1].focus();
        }
      });
    },
    unmountPicker: function unmountPicker() {
      if (this.picker) {
        this.picker.$destroy();
        this.picker.$off();
        if (typeof this.unwatchPickerOptions === 'function') {
          this.unwatchPickerOptions();
        }
        this.picker.$el.parentNode.removeChild(this.picker.$el);
      }
    },
    emitChange: function emitChange(val) {
      // determine user real change only
      if (val !== this.valueOnOpen) {
        this.$emit('change', val);
        this.dispatch('ElFormItem', 'el.form.change', val);
        this.valueOnOpen = val;
      }
    },
    emitInput: function emitInput(val) {
      var formatted = this.formatToValue(val);
      if (!valueEquals(this.value, formatted) || this.type === 'dates') {
        this.$emit('input', formatted);
      }
    },
    isValidValue: function isValidValue(value) {
      if (!this.picker) {
        this.mountPicker();
      }
      if (this.picker.isValidValue) {
        return value && this.picker.isValidValue(value);
      } else {
        return true;
      }
    }
  }
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(283);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.ranged)?_c('el-input',_vm._b({directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor",class:'el-date-editor--' + _vm.type,attrs:{"readonly":!_vm.editable || _vm.readonly || _vm.type === 'dates',"disabled":_vm.pickerDisabled,"size":_vm.pickerSize,"name":_vm.name,"placeholder":_vm.placeholder,"value":_vm.displayValue,"validateEvent":false},on:{"focus":_vm.handleFocus,"input":function (value) { return _vm.userInput = value; },"change":_vm.handleChange},nativeOn:{"keydown":function($event){_vm.handleKeydown($event)},"mouseenter":function($event){_vm.handleMouseEnter($event)},"mouseleave":function($event){_vm.showClose = false}}},'el-input',_vm.firstInputId,false),[_c('i',{staticClass:"el-input__icon",class:_vm.triggerClass,attrs:{"slot":"prefix"},on:{"click":_vm.handleFocus},slot:"prefix"}),(_vm.haveTrigger)?_c('i',{staticClass:"el-input__icon",class:[_vm.showClose ? '' + _vm.clearIcon : ''],attrs:{"slot":"suffix"},on:{"click":_vm.handleClickIcon},slot:"suffix"}):_vm._e()]):_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor el-range-editor el-input__inner",class:[
    'el-date-editor--' + _vm.type,
    _vm.pickerSize ? ("el-range-editor--" + _vm.pickerSize) : '',
    _vm.pickerDisabled ? 'is-disabled' : '',
    _vm.pickerVisible ? 'is-active' : ''
  ],on:{"click":_vm.handleRangeClick,"mouseenter":_vm.handleMouseEnter,"mouseleave":function($event){_vm.showClose = false},"keydown":_vm.handleKeydown}},[_c('i',{class:['el-input__icon', 'el-range__icon', _vm.triggerClass]}),_c('input',_vm._b({staticClass:"el-range-input",attrs:{"placeholder":_vm.startPlaceholder,"disabled":_vm.pickerDisabled,"readonly":!_vm.editable || _vm.readonly,"name":_vm.name && _vm.name[0]},domProps:{"value":_vm.displayValue && _vm.displayValue[0]},on:{"input":_vm.handleStartInput,"change":_vm.handleStartChange,"focus":_vm.handleFocus}},'input',_vm.firstInputId,false)),_c('span',{staticClass:"el-range-separator"},[_vm._v(_vm._s(_vm.rangeSeparator))]),_c('input',_vm._b({staticClass:"el-range-input",attrs:{"placeholder":_vm.endPlaceholder,"disabled":_vm.pickerDisabled,"readonly":!_vm.editable || _vm.readonly,"name":_vm.name && _vm.name[1]},domProps:{"value":_vm.displayValue && _vm.displayValue[1]},on:{"input":_vm.handleEndInput,"change":_vm.handleEndChange,"focus":_vm.handleFocus}},'input',_vm.secondInputId,false)),(_vm.haveTrigger)?_c('i',{staticClass:"el-input__icon el-range__close-icon",class:[_vm.showClose ? '' + _vm.clearIcon : ''],on:{"click":_vm.handleClickIcon}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e32efb_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__ = __webpack_require__(191);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e32efb_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

var _time = __webpack_require__(29);

var _time2 = _interopRequireDefault(_time);

var _yearTable = __webpack_require__(183);

var _yearTable2 = _interopRequireDefault(_yearTable);

var _monthTable = __webpack_require__(186);

var _monthTable2 = _interopRequireDefault(_monthTable);

var _dateTable = __webpack_require__(39);

var _dateTable2 = _interopRequireDefault(_dateTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_locale2.default],

  directives: { Clickoutside: _clickoutside2.default },

  watch: {
    showTime: function showTime(val) {
      var _this = this;

      /* istanbul ignore if */
      if (!val) return;
      this.$nextTick(function (_) {
        var inputElm = _this.$refs.input.$el;
        if (inputElm) {
          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
        }
      });
    },
    value: function value(val) {
      if ((0, _util.isDate)(val)) {
        this.date = new Date(val);
      } else {
        this.date = this.defaultValue ? new Date(this.defaultValue) : new Date();
      }
    },
    defaultValue: function defaultValue(val) {
      if (!(0, _util.isDate)(this.value)) {
        this.date = val ? new Date(val) : new Date();
      }
    },
    timePickerVisible: function timePickerVisible(val) {
      var _this2 = this;

      if (val) this.$nextTick(function () {
        return _this2.$refs.timepicker.adjustSpinners();
      });
    },
    selectionMode: function selectionMode(newVal) {
      if (newVal === 'month') {
        /* istanbul ignore next */
        if (this.currentView !== 'year' || this.currentView !== 'month') {
          this.currentView = 'month';
        }
      } else if (newVal === 'dates') {
        this.currentView = 'date';
      }
    }
  },

  methods: {
    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
      var _this3 = this;

      var format = function format(timeFormat) {
        _this3.$refs.timepicker.format = timeFormat;
      };
      var value = function value(_value) {
        _this3.$refs.timepicker.value = _value;
      };
      var date = function date(_date) {
        _this3.$refs.timepicker.date = _date;
      };

      this.$watch('value', value);
      this.$watch('date', date);

      format(this.timeFormat);
      value(this.value);
      date(this.date);
    },
    handleClear: function handleClear() {
      this.date = this.defaultValue ? new Date(this.defaultValue) : new Date();
      this.$emit('pick', null);
    },
    emit: function emit(value) {
      var _this4 = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!value) {
        this.$emit.apply(this, ['pick', value].concat(args));
      } else if (Array.isArray(value)) {
        var dates = value.map(function (date) {
          return _this4.showTime ? (0, _util.clearMilliseconds)(date) : (0, _util.clearTime)(date);
        });
        this.$emit.apply(this, ['pick', dates].concat(args));
      } else {
        this.$emit.apply(this, ['pick', this.showTime ? (0, _util.clearMilliseconds)(value) : (0, _util.clearTime)(value)].concat(args));
      }
      this.userInputDate = null;
      this.userInputTime = null;
    },


    // resetDate() {
    //   this.date = new Date(this.date);
    // },

    showMonthPicker: function showMonthPicker() {
      this.currentView = 'month';
    },
    showYearPicker: function showYearPicker() {
      this.currentView = 'year';
    },


    // XXX: 没用到
    // handleLabelClick() {
    //   if (this.currentView === 'date') {
    //     this.showMonthPicker();
    //   } else if (this.currentView === 'month') {
    //     this.showYearPicker();
    //   }
    // },

    prevMonth: function prevMonth() {
      this.date = (0, _util.prevMonth)(this.date);
    },
    nextMonth: function nextMonth() {
      this.date = (0, _util.nextMonth)(this.date);
    },
    prevYear: function prevYear() {
      if (this.currentView === 'year') {
        this.date = (0, _util.prevYear)(this.date, 10);
      } else {
        this.date = (0, _util.prevYear)(this.date);
      }
    },
    nextYear: function nextYear() {
      if (this.currentView === 'year') {
        this.date = (0, _util.nextYear)(this.date, 10);
      } else {
        this.date = (0, _util.nextYear)(this.date);
      }
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    handleTimePick: function handleTimePick(value, visible, first) {
      if ((0, _util.isDate)(value)) {
        var newDate = this.value ? (0, _util.modifyTime)(this.date, value.getHours(), value.getMinutes(), value.getSeconds()) : (0, _util.modifyWithDefaultTime)(value, this.defaultTime);
        this.date = newDate;
        this.emit(this.date, true);
      } else {
        this.emit(value, true);
      }
      if (!first) {
        this.timePickerVisible = visible;
      }
    },
    handleMonthPick: function handleMonthPick(month) {
      if (this.selectionMode === 'month') {
        this.date = (0, _util.modifyDate)(this.date, this.year, month, 1);
        this.emit(this.date);
      } else {
        this.date = (0, _util.changeYearMonthAndClampDate)(this.date, this.year, month);
        // TODO: should emit intermediate value ??
        // this.emit(this.date);
        this.currentView = 'date';
      }
    },
    handleDateSelect: function handleDateSelect(value) {
      if (this.selectionMode === 'dates') {
        this.selectedDate = value;
      }
    },
    handleDatePick: function handleDatePick(value) {
      if (this.selectionMode === 'day') {
        this.date = this.value ? (0, _util.modifyDate)(this.date, value.getFullYear(), value.getMonth(), value.getDate()) : (0, _util.modifyWithDefaultTime)(value, this.defaultTime);
        this.emit(this.date, this.showTime);
      } else if (this.selectionMode === 'week') {
        this.emit(value.date);
      }
    },
    handleYearPick: function handleYearPick(year) {
      if (this.selectionMode === 'year') {
        this.date = (0, _util.modifyDate)(this.date, year, 0, 1);
        this.emit(this.date);
      } else {
        this.date = (0, _util.changeYearMonthAndClampDate)(this.date, year, this.month);
        // TODO: should emit intermediate value ??
        // this.emit(this.date, true);
        this.currentView = 'month';
      }
    },
    changeToNow: function changeToNow() {
      // NOTE: not a permanent solution
      //       consider disable "now" button in the future
      if (!this.disabledDate || !this.disabledDate(new Date())) {
        this.date = new Date();
        this.emit(this.date);
      }
    },
    confirm: function confirm() {
      if (this.selectionMode === 'dates') {
        this.emit(this.selectedDate);
      } else {
        var date = this.value ? this.date : (0, _util.modifyWithDefaultTime)(this.date, this.defaultTime);
        this.emit(date);
      }
    },
    resetView: function resetView() {
      if (this.selectionMode === 'month') {
        this.currentView = 'month';
      } else if (this.selectionMode === 'year') {
        this.currentView = 'year';
      } else {
        this.currentView = 'date';
      }
    },
    handleEnter: function handleEnter() {
      document.body.addEventListener('keydown', this.handleKeydown);
    },
    handleLeave: function handleLeave() {
      this.$emit('dodestroy');
      document.body.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var list = [38, 40, 37, 39];
      if (this.visible && !this.timePickerVisible) {
        if (list.indexOf(keyCode) !== -1) {
          this.handleKeyControl(keyCode);
          event.stopPropagation();
          event.preventDefault();
        }
        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
          // Enter
          this.emit(this.date, false);
        }
      }
    },
    handleKeyControl: function handleKeyControl(keyCode) {
      var mapping = {
        'year': {
          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setFullYear(date.getFullYear() + step);
          }
        },
        'month': {
          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setMonth(date.getMonth() + step);
          }
        },
        'week': {
          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setDate(date.getDate() + step * 7);
          }
        },
        'day': {
          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setDate(date.getDate() + step);
          }
        }
      };
      var mode = this.selectionMode;
      var year = 3.1536e10;
      var now = this.date.getTime();
      var newDate = new Date(this.date.getTime());
      while (Math.abs(now - newDate.getTime()) <= year) {
        var map = mapping[mode];
        map.offset(newDate, map[keyCode]);
        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
          continue;
        }
        this.date = newDate;
        this.$emit('pick', newDate, true);
        break;
      }
    },
    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
      var time = (0, _util.parseDate)(value, this.timeFormat);
      if (time) {
        this.date = (0, _util.modifyDate)(time, this.year, this.month, this.monthDate);
        this.userInputTime = null;
        this.$refs.timepicker.value = this.date;
        this.timePickerVisible = false;
        this.emit(this.date, true);
      }
    },
    handleVisibleDateChange: function handleVisibleDateChange(value) {
      var date = (0, _util.parseDate)(value, this.dateFormat);
      if (date) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
          return;
        }
        this.date = (0, _util.modifyTime)(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
        this.userInputDate = null;
        this.resetView();
        this.emit(this.date, true);
      }
    },
    isValidValue: function isValidValue(value) {
      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true);
    }
  },

  components: {
    TimePicker: _time2.default, YearTable: _yearTable2.default, MonthTable: _monthTable2.default, DateTable: _dateTable2.default, ElInput: _input2.default, ElButton: _button2.default
  },

  data: function data() {
    return {
      popperClass: '',
      date: new Date(),
      value: '',
      defaultValue: null,
      defaultTime: null,
      showTime: false,
      selectionMode: 'day',
      shortcuts: '',
      visible: false,
      currentView: 'date',
      disabledDate: '',
      selectedDate: [],
      firstDayOfWeek: 7,
      showWeekNumber: false,
      timePickerVisible: false,
      format: '',
      arrowControl: false,
      userInputDate: null,
      userInputTime: null
    };
  },


  computed: {
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    week: function week() {
      return (0, _util.getWeekNumber)(this.date);
    },
    monthDate: function monthDate() {
      return this.date.getDate();
    },
    footerVisible: function footerVisible() {
      return this.showTime || this.selectionMode === 'dates';
    },
    visibleTime: function visibleTime() {
      if (this.userInputTime !== null) {
        return this.userInputTime;
      } else {
        return (0, _util.formatDate)(this.value || this.defaultValue, this.timeFormat);
      }
    },
    visibleDate: function visibleDate() {
      if (this.userInputDate !== null) {
        return this.userInputDate;
      } else {
        return (0, _util.formatDate)(this.value || this.defaultValue, this.dateFormat);
      }
    },
    yearLabel: function yearLabel() {
      var yearTranslation = this.t('el.datepicker.year');
      if (this.currentView === 'year') {
        var startYear = Math.floor(this.year / 10) * 10;
        if (yearTranslation) {
          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
        }
        return startYear + ' - ' + (startYear + 9);
      }
      return this.year + ' ' + yearTranslation;
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return (0, _util.extractTimeFormat)(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return (0, _util.extractDateFormat)(this.format);
      } else {
        return 'yyyy-MM-dd';
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _timeSpinner = __webpack_require__(38);

var _timeSpinner2 = _interopRequireDefault(_timeSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_locale2.default],

  components: {
    TimeSpinner: _timeSpinner2.default
  },

  props: {
    visible: Boolean,
    timeArrowControl: Boolean
  },

  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.oldValue = this.value;
        this.$nextTick(function () {
          return _this.$refs.spinner.emitSelectRange('hours');
        });
      } else {
        this.needInitAdjust = true;
      }
    },
    value: function value(newVal) {
      var _this2 = this;

      var date = void 0;
      if (newVal instanceof Date) {
        date = (0, _util.limitTimeRange)(newVal, this.selectableRange, this.format);
      } else if (!newVal) {
        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
      }

      this.date = date;
      if (this.visible && this.needInitAdjust) {
        this.$nextTick(function (_) {
          return _this2.adjustSpinners();
        });
        this.needInitAdjust = false;
      }
    },
    selectableRange: function selectableRange(val) {
      this.$refs.spinner.selectableRange = val;
    },
    defaultValue: function defaultValue(val) {
      if (!(0, _util.isDate)(this.value)) {
        this.date = val ? new Date(val) : new Date();
      }
    }
  },

  data: function data() {
    return {
      popperClass: '',
      format: 'HH:mm:ss',
      value: '',
      defaultValue: null,
      date: new Date(),
      oldValue: new Date(),
      selectableRange: [],
      selectionRange: [0, 2],
      disabled: false,
      arrowControl: false,
      needInitAdjust: true
    };
  },


  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    useArrow: function useArrow() {
      return this.arrowControl || this.timeArrowControl || false;
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    }
  },

  methods: {
    handleCancel: function handleCancel() {
      this.$emit('pick', this.oldValue, false);
    },
    handleChange: function handleChange(date) {
      // this.visible avoids edge cases, when use scrolls during panel closing animation
      if (this.visible) {
        this.date = (0, _util.clearMilliseconds)(date);
        // if date is out of range, do not emit
        if (this.isValidValue(this.date)) {
          this.$emit('pick', this.date, true);
        }
      }
    },
    setSelectionRange: function setSelectionRange(start, end) {
      this.$emit('select-range', start, end);
      this.selectionRange = [start, end];
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var first = arguments[1];

      if (first) return;
      var date = (0, _util.clearMilliseconds)((0, _util.limitTimeRange)(this.date, this.selectableRange, this.format));
      this.$emit('pick', date, visible, first);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };

      // Left or Right
      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      }

      // Up or Down
      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.$refs.spinner.scrollDown(_step);
        event.preventDefault();
        return;
      }
    },
    isValidValue: function isValidValue(date) {
      return (0, _util.timeWithinRange)(date, this.selectableRange, this.format);
    },
    adjustSpinners: function adjustSpinners() {
      return this.$refs.spinner.adjustSpinners();
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = [0, 3].concat(this.showSeconds ? [6] : []);
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      this.$refs.spinner.emitSelectRange(mapping[next]);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      return _this3.handleConfirm(true, true);
    });
    this.$emit('mounted');
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _scrollbar = __webpack_require__(18);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _repeatClick = __webpack_require__(33);

var _repeatClick2 = _interopRequireDefault(_repeatClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ElScrollbar: _scrollbar2.default },

  directives: {
    repeatClick: _repeatClick2.default
  },

  props: {
    date: {},
    defaultValue: {}, // reserved for future use
    showSeconds: {
      type: Boolean,
      default: true
    },
    arrowControl: Boolean,
    amPmMode: {
      type: String,
      default: '' // 'a': am/pm; 'A': AM/PM
    }
  },

  computed: {
    hours: function hours() {
      return this.date.getHours();
    },
    minutes: function minutes() {
      return this.date.getMinutes();
    },
    seconds: function seconds() {
      return this.date.getSeconds();
    },
    hoursList: function hoursList() {
      return (0, _util.getRangeHours)(this.selectableRange);
    },
    arrowHourList: function arrowHourList() {
      var hours = this.hours;
      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
    },
    arrowMinuteList: function arrowMinuteList() {
      var minutes = this.minutes;
      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
    },
    arrowSecondList: function arrowSecondList() {
      var seconds = this.seconds;
      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
    }
  },

  data: function data() {
    return {
      selectableRange: [],
      currentScrollbar: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      !_this.arrowControl && _this.bindScrollEvent();
    });
  },


  methods: {
    increase: function increase() {
      this.scrollDown(1);
    },
    decrease: function decrease() {
      this.scrollDown(-1);
    },
    modifyDateField: function modifyDateField(type, value) {
      switch (type) {
        case 'hours':
          this.$emit('change', (0, _util.modifyTime)(this.date, value, this.minutes, this.seconds));break;
        case 'minutes':
          this.$emit('change', (0, _util.modifyTime)(this.date, this.hours, value, this.seconds));break;
        case 'seconds':
          this.$emit('change', (0, _util.modifyTime)(this.date, this.hours, this.minutes, value));break;
      }
    },
    handleClick: function handleClick(type, _ref) {
      var value = _ref.value,
          disabled = _ref.disabled;

      if (!disabled) {
        this.modifyDateField(type, value);
        this.emitSelectRange(type);
        this.adjustSpinner(type, value);
      }
    },
    emitSelectRange: function emitSelectRange(type) {
      if (type === 'hours') {
        this.$emit('select-range', 0, 2);
      } else if (type === 'minutes') {
        this.$emit('select-range', 3, 5);
      } else if (type === 'seconds') {
        this.$emit('select-range', 6, 8);
      }
      this.currentScrollbar = type;
    },
    bindScrollEvent: function bindScrollEvent() {
      var _this2 = this;

      var bindFuntion = function bindFuntion(type) {
        _this2.$refs[type].wrap.onscroll = function (e) {
          // TODO: scroll is emitted when set scrollTop programatically
          // should find better solutions in the future!
          _this2.handleScroll(type, e);
        };
      };
      bindFuntion('hours');
      bindFuntion('minutes');
      bindFuntion('seconds');
    },
    handleScroll: function handleScroll(type) {
      var value = Math.min(Math.floor((this.$refs[type].wrap.scrollTop - 80) / 32 + 3), type === 'hours' ? 23 : 59);
      this.modifyDateField(type, value);
    },


    // NOTE: used by datetime / date-range panel
    //       renamed from adjustScrollTop
    //       should try to refactory it
    adjustSpinners: function adjustSpinners() {
      this.adjustSpinner('hours', this.hours);
      this.adjustSpinner('minutes', this.minutes);
      this.adjustSpinner('seconds', this.seconds);
    },
    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
      this.adjustSpinner(type, this[type]);
    },
    adjustSpinner: function adjustSpinner(type, value) {
      if (this.arrowControl) return;
      var el = this.$refs[type].wrap;
      if (el) {
        el.scrollTop = Math.max(0, (value - 2.5) * 32 + 80);
      }
    },
    scrollDown: function scrollDown(step) {
      if (!this.currentScrollbar) {
        this.emitSelectRange('hours');
      }

      var label = this.currentScrollbar;
      var hoursList = this.hoursList;
      var now = this[label];

      if (this.currentScrollbar === 'hours') {
        var total = Math.abs(step);
        step = step > 0 ? 1 : -1;
        var length = hoursList.length;
        while (length-- && total) {
          now = (now + step + hoursList.length) % hoursList.length;
          if (hoursList[now]) {
            continue;
          }
          total--;
        }
        if (hoursList[now]) return;
      } else {
        now = (now + step + 60) % 60;
      }

      this.modifyDateField(label, now);
      this.adjustSpinner(label, now);
    },
    amPm: function amPm(hour) {
      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
      if (!shouldShowAmPm) return '';
      var isCapital = this.amPmMode === 'A';
      var content = hour < 12 ? ' am' : ' pm';
      if (isCapital) content = content.toUpperCase();
      return content;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-time-spinner",class:{ 'has-seconds': _vm.showSeconds }},[(!_vm.arrowControl)?[_c('el-scrollbar',{ref:"hours",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","noresize":"","tag":"ul"},nativeOn:{"mouseenter":function($event){_vm.emitSelectRange('hours')},"mousemove":function($event){_vm.adjustCurrentSpinner('hours')}}},_vm._l((_vm.hoursList),function(disabled,hour){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': hour === _vm.hours, 'disabled': disabled },on:{"click":function($event){_vm.handleClick('hours', { value: hour, disabled: disabled })}}},[_vm._v(_vm._s(('0' + (_vm.amPmMode ? (hour % 12 || 12) : hour )).slice(-2))+_vm._s(_vm.amPm(hour)))])})),_c('el-scrollbar',{ref:"minutes",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","noresize":"","tag":"ul"},nativeOn:{"mouseenter":function($event){_vm.emitSelectRange('minutes')},"mousemove":function($event){_vm.adjustCurrentSpinner('minutes')}}},_vm._l((60),function(minute,key){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': key === _vm.minutes },on:{"click":function($event){_vm.handleClick('minutes', { value: key, disabled: false })}}},[_vm._v(_vm._s(('0' + key).slice(-2)))])})),_c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSeconds),expression:"showSeconds"}],ref:"seconds",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list","noresize":"","tag":"ul"},nativeOn:{"mouseenter":function($event){_vm.emitSelectRange('seconds')},"mousemove":function($event){_vm.adjustCurrentSpinner('seconds')}}},_vm._l((60),function(second,key){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': key === _vm.seconds },on:{"click":function($event){_vm.handleClick('seconds', { value: key, disabled: false })}}},[_vm._v(_vm._s(('0' + key).slice(-2)))])}))]:_vm._e(),(_vm.arrowControl)?[_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){_vm.emitSelectRange('hours')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c('ul',{ref:"hours",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowHourList),function(hour){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': hour === _vm.hours, 'disabled': _vm.hoursList[hour] }},[_vm._v(_vm._s(hour === undefined ? '' : ('0' + (_vm.amPmMode ? (hour % 12 || 12) : hour )).slice(-2) + _vm.amPm(hour)))])}))]),_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){_vm.emitSelectRange('minutes')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c('ul',{ref:"minutes",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowMinuteList),function(minute){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': minute === _vm.minutes }},[_vm._v("\n          "+_vm._s(minute === undefined ? '' : ('0' + minute).slice(-2))+"\n        ")])}))]),(_vm.showSeconds)?_c('div',{staticClass:"el-time-spinner__wrapper is-arrow",on:{"mouseenter":function($event){_vm.emitSelectRange('seconds')}}},[_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c('i',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c('ul',{ref:"seconds",staticClass:"el-time-spinner__list"},_vm._l((_vm.arrowSecondList),function(second){return _c('li',{staticClass:"el-time-spinner__item",class:{ 'active': second === _vm.seconds }},[_vm._v("\n          "+_vm._s(second === undefined ? '' : ('0' + second).slice(-2))+"\n        ")])}))]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":function($event){_vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-time-panel el-popper",class:_vm.popperClass},[_c('div',{staticClass:"el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds }},[_c('time-spinner',{ref:"spinner",attrs:{"arrow-control":_vm.useArrow,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"date":_vm.date},on:{"change":_vm.handleChange,"select-range":_vm.setSelectionRange}})],1),_c('div',{staticClass:"el-time-panel__footer"},[_c('button',{staticClass:"el-time-panel__btn cancel",attrs:{"type":"button"},on:{"click":_vm.handleCancel}},[_vm._v(_vm._s(_vm.t('el.datepicker.cancel')))]),_c('button',{staticClass:"el-time-panel__btn",class:{confirm: !_vm.disabled},attrs:{"type":"button"},on:{"click":function($event){_vm.handleConfirm()}}},[_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_table_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_520b6e61_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_year_table_vue__ = __webpack_require__(185);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_520b6e61_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_year_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(3);

var _util = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var datesInYear = function datesInYear(year) {
  var numOfDays = (0, _util.getDayCountOfYear)(year);
  var firstDay = new Date(year, 0, 1);
  return (0, _util.range)(numOfDays).map(function (n) {
    return (0, _util.nextDate)(firstDay, n);
  });
};

exports.default = {
  props: {
    disabledDate: {},
    value: {},
    defaultValue: {
      validator: function validator(val) {
        // null or valid Date Object
        return val === null || val instanceof Date && (0, _util.isDate)(val);
      }
    },
    date: {}
  },

  computed: {
    startYear: function startYear() {
      return Math.floor(this.date.getFullYear() / 10) * 10;
    }
  },

  methods: {
    getCellStyle: function getCellStyle(year) {
      var style = {};
      var today = new Date();

      style.disabled = typeof this.disabledDate === 'function' ? datesInYear(year).every(this.disabledDate) : false;
      style.current = this.value.getFullYear() === year;
      style.today = today.getFullYear() === year;
      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;

      return style;
    },
    handleYearTableClick: function handleYearTableClick(event) {
      var target = event.target;
      if (target.tagName === 'A') {
        if ((0, _dom.hasClass)(target.parentNode, 'disabled')) return;
        var year = target.textContent || target.innerText;
        this.$emit('pick', Number(year));
      }
    }
  }
};

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"el-year-table",on:{"click":_vm.handleYearTableClick}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 0)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 1)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 1))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 2)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 2))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 3)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 3))])])]),_c('tr',[_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 4)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 4))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 5)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 5))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 6)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 6))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 7)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 7))])])]),_c('tr',[_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 8)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 8))])]),_c('td',{staticClass:"available",class:_vm.getCellStyle(_vm.startYear + 9)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear + 9))])]),_c('td'),_c('td')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_table_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419c8da4_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_month_table_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419c8da4_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_month_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _util = __webpack_require__(11);

var _dom = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datesInMonth = function datesInMonth(year, month) {
  var numOfDays = (0, _util.getDayCountOfMonth)(year, month);
  var firstDay = new Date(year, month, 1);
  return (0, _util.range)(numOfDays).map(function (n) {
    return (0, _util.nextDate)(firstDay, n);
  });
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    disabledDate: {},
    value: {},
    defaultValue: {
      validator: function validator(val) {
        // null or valid Date Object
        return val === null || val instanceof Date && (0, _util.isDate)(val);
      }
    },
    date: {}
  },
  mixins: [_locale2.default],
  methods: {
    getCellStyle: function getCellStyle(month) {
      var style = {};
      var year = this.date.getFullYear();
      var today = new Date();

      style.disabled = typeof this.disabledDate === 'function' ? datesInMonth(year, month).every(this.disabledDate) : false;
      style.current = this.value.getFullYear() === year && this.value.getMonth() === month;
      style.today = today.getFullYear() === year && today.getMonth() === month;
      style.default = this.defaultValue && this.defaultValue.getFullYear() === year && this.defaultValue.getMonth() === month;

      return style;
    },
    handleMonthTableClick: function handleMonthTableClick(event) {
      var target = event.target;
      if (target.tagName !== 'A') return;
      if ((0, _dom.hasClass)(target.parentNode, 'disabled')) return;
      var column = target.parentNode.cellIndex;
      var row = target.parentNode.parentNode.rowIndex;
      var month = row * 4 + column;

      this.$emit('pick', month);
    }
  }
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"el-month-table",on:{"click":_vm.handleMonthTableClick}},[_c('tbody',[_c('tr',[_c('td',{class:_vm.getCellStyle(0)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.jan')))])]),_c('td',{class:_vm.getCellStyle(1)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.feb')))])]),_c('td',{class:_vm.getCellStyle(2)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.mar')))])]),_c('td',{class:_vm.getCellStyle(3)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.apr')))])])]),_c('tr',[_c('td',{class:_vm.getCellStyle(4)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.may')))])]),_c('td',{class:_vm.getCellStyle(5)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.jun')))])]),_c('td',{class:_vm.getCellStyle(6)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.jul')))])]),_c('td',{class:_vm.getCellStyle(7)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.aug')))])])]),_c('tr',[_c('td',{class:_vm.getCellStyle(8)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.sep')))])]),_c('td',{class:_vm.getCellStyle(9)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.oct')))])]),_c('td',{class:_vm.getCellStyle(10)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.nov')))])]),_c('td',{class:_vm.getCellStyle(11)},[_c('a',{staticClass:"cell"},[_vm._v(_vm._s(_vm.t('el.datepicker.months.dec')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _dom = __webpack_require__(3);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var clearHours = function clearHours(time) {
  var cloneDate = new Date(time);
  cloneDate.setHours(0, 0, 0, 0);
  return cloneDate.getTime();
};

exports.default = {
  mixins: [_locale2.default],

  props: {
    firstDayOfWeek: {
      default: 7,
      type: Number,
      validator: function validator(val) {
        return val >= 1 && val <= 7;
      }
    },

    value: {},

    defaultValue: {
      validator: function validator(val) {
        // either: null, valid Date object, Array of valid Date objects
        return val === null || (0, _util.isDate)(val) || Array.isArray(val) && val.every(_util.isDate);
      }
    },

    date: {},

    selectionMode: {
      default: 'day'
    },

    showWeekNumber: {
      type: Boolean,
      default: false
    },

    disabledDate: {},

    selectedDate: {
      type: Array
    },

    minDate: {},

    maxDate: {},

    rangeState: {
      default: function _default() {
        return {
          endDate: null,
          selecting: false,
          row: null,
          column: null
        };
      }
    }
  },

  computed: {
    offsetDay: function offsetDay() {
      var week = this.firstDayOfWeek;
      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
      return week > 3 ? 7 - week : -week;
    },
    WEEKS: function WEEKS() {
      var week = this.firstDayOfWeek;
      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    startDate: function startDate() {
      return (0, _util.getStartDateOfMonth)(this.year, this.month);
    },
    rows: function rows() {
      var _this = this;

      // TODO: refactory rows / getCellClasses
      var date = new Date(this.year, this.month, 1);
      var day = (0, _util.getFirstDayOfMonth)(date); // day of first day
      var dateCountOfMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth());
      var dateCountOfLastMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);

      day = day === 0 ? 7 : day;

      var offset = this.offsetDay;
      var rows = this.tableRows;
      var count = 1;
      var firstDayPosition = void 0;

      var startDate = this.startDate;
      var disabledDate = this.disabledDate;
      var selectedDate = this.selectedDate || this.value;
      var now = clearHours(new Date());

      for (var i = 0; i < 6; i++) {
        var row = rows[i];

        if (this.showWeekNumber) {
          if (!row[0]) {
            row[0] = { type: 'week', text: (0, _util.getWeekNumber)((0, _util.nextDate)(startDate, i * 7 + 1)) };
          }
        }

        var _loop = function _loop(j) {
          var cell = row[_this.showWeekNumber ? j + 1 : j];
          if (!cell) {
            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
          }

          cell.type = 'normal';

          var index = i * 7 + j;
          var time = (0, _util.nextDate)(startDate, index - offset).getTime();
          cell.inRange = time >= clearHours(_this.minDate) && time <= clearHours(_this.maxDate);
          cell.start = _this.minDate && time === clearHours(_this.minDate);
          cell.end = _this.maxDate && time === clearHours(_this.maxDate);
          var isToday = time === now;

          if (isToday) {
            cell.type = 'today';
          }

          if (i >= 0 && i <= 1) {
            if (j + i * 7 >= day + offset) {
              cell.text = count++;
              if (count === 2) {
                firstDayPosition = i * 7 + j;
              }
            } else {
              cell.text = dateCountOfLastMonth - (day + offset - j % 7) + 1 + i * 7;
              cell.type = 'prev-month';
            }
          } else {
            if (count <= dateCountOfMonth) {
              cell.text = count++;
              if (count === 2) {
                firstDayPosition = i * 7 + j;
              }
            } else {
              cell.text = count++ - dateCountOfMonth;
              cell.type = 'next-month';
            }
          }

          var newDate = new Date(time);
          cell.disabled = typeof disabledDate === 'function' && disabledDate(newDate);
          cell.selected = Array.isArray(selectedDate) && selectedDate.filter(function (date) {
            return date.toString() === newDate.toString();
          })[0];

          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
        };

        for (var j = 0; j < 7; j++) {
          _loop(j);
        }

        if (this.selectionMode === 'week') {
          var start = this.showWeekNumber ? 1 : 0;
          var end = this.showWeekNumber ? 7 : 6;
          var isWeekActive = this.isWeekActive(row[start + 1]);

          row[start].inRange = isWeekActive;
          row[start].start = isWeekActive;
          row[end].inRange = isWeekActive;
          row[end].end = isWeekActive;
        }
      }

      rows.firstDayPosition = firstDayPosition;

      return rows;
    }
  },

  watch: {
    'rangeState.endDate': function rangeStateEndDate(newVal) {
      this.markRange(newVal);
    },
    minDate: function minDate(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.rangeState.selecting = true;
        this.markRange(newVal);
      } else if (!newVal) {
        this.rangeState.selecting = false;
        this.markRange(newVal);
      } else {
        this.markRange();
      }
    },
    maxDate: function maxDate(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.rangeState.selecting = false;
        this.markRange(newVal);
        this.$emit('pick', {
          minDate: this.minDate,
          maxDate: this.maxDate
        });
      }
    }
  },

  data: function data() {
    return {
      tableRows: [[], [], [], [], [], []]
    };
  },


  methods: {
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
    },
    getCellClasses: function getCellClasses(cell) {
      var _this2 = this;

      var selectionMode = this.selectionMode;
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];

      var classes = [];
      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
        classes.push('available');
        if (cell.type === 'today') {
          classes.push('today');
        }
      } else {
        classes.push(cell.type);
      }

      if (cell.type === 'normal' && defaultValue.some(function (date) {
        return _this2.cellMatchesDate(cell, date);
      })) {
        classes.push('default');
      }

      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
        classes.push('current');
      }

      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
        classes.push('in-range');

        if (cell.start) {
          classes.push('start-date');
        }

        if (cell.end) {
          classes.push('end-date');
        }
      }

      if (cell.disabled) {
        classes.push('disabled');
      }

      if (cell.selected) {
        classes.push('selected');
      }

      return classes.join(' ');
    },
    getDateOfCell: function getDateOfCell(row, column) {
      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
      return (0, _util.nextDate)(this.startDate, offsetFromStart);
    },
    isWeekActive: function isWeekActive(cell) {
      if (this.selectionMode !== 'week') return false;
      var newDate = new Date(this.year, this.month, 1);
      var year = newDate.getFullYear();
      var month = newDate.getMonth();

      if (cell.type === 'prev-month') {
        newDate.setMonth(month === 0 ? 11 : month - 1);
        newDate.setFullYear(month === 0 ? year - 1 : year);
      }

      if (cell.type === 'next-month') {
        newDate.setMonth(month === 11 ? 0 : month + 1);
        newDate.setFullYear(month === 11 ? year + 1 : year);
      }

      newDate.setDate(parseInt(cell.text, 10));

      var valueYear = (0, _util.isDate)(this.value) ? this.value.getFullYear() : null;
      return year === valueYear && (0, _util.getWeekNumber)(newDate) === (0, _util.getWeekNumber)(this.value);
    },
    markRange: function markRange(maxDate) {
      var startDate = this.startDate;
      if (!maxDate) {
        maxDate = this.maxDate;
      }

      var rows = this.rows;
      var minDate = this.minDate;
      for (var i = 0, k = rows.length; i < k; i++) {
        var row = rows[i];
        for (var j = 0, l = row.length; j < l; j++) {
          if (this.showWeekNumber && j === 0) continue;

          var _cell = row[j];
          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
          var time = (0, _util.nextDate)(startDate, index - this.offsetDay).getTime();

          if (maxDate && maxDate < minDate) {
            _cell.inRange = minDate && time >= clearHours(maxDate) && time <= clearHours(minDate);
            _cell.start = maxDate && time === clearHours(maxDate.getTime());
            _cell.end = minDate && time === clearHours(minDate.getTime());
          } else {
            _cell.inRange = minDate && time >= clearHours(minDate) && time <= clearHours(maxDate);
            _cell.start = minDate && time === clearHours(minDate.getTime());
            _cell.end = maxDate && time === clearHours(maxDate.getTime());
          }
        }
      }
    },
    handleMouseMove: function handleMouseMove(event) {
      if (!this.rangeState.selecting) return;

      this.$emit('changerange', {
        minDate: this.minDate,
        maxDate: this.maxDate,
        rangeState: this.rangeState
      });

      var target = event.target;
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }
      if (target.tagName !== 'TD') return;

      var column = target.cellIndex;
      var row = target.parentNode.rowIndex - 1;
      var _rangeState = this.rangeState,
          oldRow = _rangeState.row,
          oldColumn = _rangeState.column;


      if (oldRow !== row || oldColumn !== column) {
        this.rangeState.row = row;
        this.rangeState.column = column;

        this.rangeState.endDate = this.getDateOfCell(row, column);
      }
    },
    handleClick: function handleClick(event) {
      var _this3 = this;

      var target = event.target;
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }

      if (target.tagName !== 'TD') return;
      if ((0, _dom.hasClass)(target, 'disabled') || (0, _dom.hasClass)(target, 'week')) return;

      var selectionMode = this.selectionMode;

      if (selectionMode === 'week') {
        target = target.parentNode.cells[1];
      }

      var year = Number(this.year);
      var month = Number(this.month);

      var cellIndex = target.cellIndex;
      var rowIndex = target.parentNode.rowIndex;

      var cell = this.rows[rowIndex - 1][cellIndex];
      var text = cell.text;
      var className = target.className;

      var newDate = new Date(year, month, 1);

      if (className.indexOf('prev') !== -1) {
        if (month === 0) {
          year = year - 1;
          month = 11;
        } else {
          month = month - 1;
        }
        newDate.setFullYear(year);
        newDate.setMonth(month);
      } else if (className.indexOf('next') !== -1) {
        if (month === 11) {
          year = year + 1;
          month = 0;
        } else {
          month = month + 1;
        }
        newDate.setFullYear(year);
        newDate.setMonth(month);
      }

      newDate.setDate(parseInt(text, 10));

      if (this.selectionMode === 'range') {
        if (this.minDate && this.maxDate) {
          var minDate = new Date(newDate.getTime());
          var maxDate = null;

          this.$emit('pick', { minDate: minDate, maxDate: maxDate }, false);
          this.rangeState.selecting = true;
          this.markRange(this.minDate);
          this.$nextTick(function () {
            _this3.handleMouseMove(event);
          });
        } else if (this.minDate && !this.maxDate) {
          if (newDate >= this.minDate) {
            var _maxDate = new Date(newDate.getTime());
            this.rangeState.selecting = false;

            this.$emit('pick', {
              minDate: this.minDate,
              maxDate: _maxDate
            });
          } else {
            var _minDate = new Date(newDate.getTime());
            this.rangeState.selecting = false;

            this.$emit('pick', { minDate: _minDate, maxDate: this.minDate });
          }
        } else if (!this.minDate) {
          var _minDate2 = new Date(newDate.getTime());

          this.$emit('pick', { minDate: _minDate2, maxDate: this.maxDate }, false);
          this.rangeState.selecting = true;
          this.markRange(this.minDate);
        }
      } else if (selectionMode === 'day') {
        this.$emit('pick', newDate);
      } else if (selectionMode === 'week') {
        var weekNumber = (0, _util.getWeekNumber)(newDate);

        var value = newDate.getFullYear() + 'w' + weekNumber;
        this.$emit('pick', {
          year: newDate.getFullYear(),
          week: weekNumber,
          value: value,
          date: newDate
        });
      } else if (selectionMode === 'dates') {
        (function () {
          var selectedDate = _this3.selectedDate;

          if (!cell.selected) {
            selectedDate.push(newDate);
          } else {
            selectedDate.forEach(function (date, index) {
              if (date.toString() === newDate.toString()) {
                selectedDate.splice(index, 1);
              }
            });
          }

          _this3.$emit('select', selectedDate);
        })();
      }
    }
  }
};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"el-date-table",class:{ 'is-week-mode': _vm.selectionMode === 'week' },attrs:{"cellspacing":"0","cellpadding":"0"},on:{"click":_vm.handleClick,"mousemove":_vm.handleMouseMove}},[_c('tbody',[_c('tr',[(_vm.showWeekNumber)?_c('th',[_vm._v(_vm._s(_vm.t('el.datepicker.week')))]):_vm._e(),_vm._l((_vm.WEEKS),function(week){return _c('th',[_vm._v(_vm._s(_vm.t('el.datepicker.weeks.' + week)))])})],2),_vm._l((_vm.rows),function(row){return _c('tr',{staticClass:"el-date-table__row",class:{ current: _vm.isWeekActive(row[1]) }},_vm._l((row),function(cell){return _c('td',{class:_vm.getCellClasses(cell)},[_c('div',[_c('span',[_vm._v("\n          "+_vm._s(cell.text)+"\n        ")])])])}))})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-enter":_vm.handleEnter,"after-leave":_vm.handleLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-picker-panel el-date-picker el-popper",class:[{
      'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts,
      'has-time': _vm.showTime
    }, _vm.popperClass]},[_c('div',{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),(_vm.shortcuts)?_c('div',{staticClass:"el-picker-panel__sidebar"},_vm._l((_vm.shortcuts),function(shortcut){return _c('button',{staticClass:"el-picker-panel__shortcut",attrs:{"type":"button"},on:{"click":function($event){_vm.handleShortcutClick(shortcut)}}},[_vm._v(_vm._s(shortcut.text))])})):_vm._e(),_c('div',{staticClass:"el-picker-panel__body"},[(_vm.showTime)?_c('div',{staticClass:"el-date-picker__time-header"},[_c('span',{staticClass:"el-date-picker__editor-wrap"},[_c('el-input',{attrs:{"placeholder":_vm.t('el.datepicker.selectDate'),"value":_vm.visibleDate,"size":"small"},on:{"input":function (val) { return _vm.userInputDate = val; },"change":_vm.handleVisibleDateChange}})],1),_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(function () { return _vm.timePickerVisible = false; }),expression:"() => timePickerVisible = false"}],staticClass:"el-date-picker__editor-wrap"},[_c('el-input',{ref:"input",attrs:{"placeholder":_vm.t('el.datepicker.selectTime'),"value":_vm.visibleTime,"size":"small"},on:{"focus":function($event){_vm.timePickerVisible = true},"input":function (val) { return _vm.userInputTime = val; },"change":_vm.handleVisibleTimeChange}}),_c('time-picker',{ref:"timepicker",attrs:{"time-arrow-control":_vm.arrowControl,"visible":_vm.timePickerVisible},on:{"pick":_vm.handleTimePick,"mounted":_vm.proxyTimePickerDataProperties}})],1)]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView !== 'time'),expression:"currentView !== 'time'"}],staticClass:"el-date-picker__header",class:{ 'el-date-picker__header--bordered': _vm.currentView === 'year' || _vm.currentView === 'month' }},[_c('button',{staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",attrs:{"type":"button","aria-label":_vm.t("el.datepicker.prevYear")},on:{"click":_vm.prevYear}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date'),expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",attrs:{"type":"button","aria-label":_vm.t("el.datepicker.prevMonth")},on:{"click":_vm.prevMonth}}),_c('span',{staticClass:"el-date-picker__header-label",attrs:{"role":"button"},on:{"click":_vm.showYearPicker}},[_vm._v(_vm._s(_vm.yearLabel))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date'),expression:"currentView === 'date'"}],staticClass:"el-date-picker__header-label",class:{ active: _vm.currentView === 'month' },attrs:{"role":"button"},on:{"click":_vm.showMonthPicker}},[_vm._v(_vm._s(_vm.t(("el.datepicker.month" + (_vm.month + 1)))))]),_c('button',{staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",attrs:{"type":"button","aria-label":_vm.t("el.datepicker.nextYear")},on:{"click":_vm.nextYear}}),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date'),expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",attrs:{"type":"button","aria-label":_vm.t("el.datepicker.nextMonth")},on:{"click":_vm.nextMonth}})]),_c('div',{staticClass:"el-picker-panel__content"},[_c('date-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'date'),expression:"currentView === 'date'"}],attrs:{"selection-mode":_vm.selectionMode,"first-day-of-week":_vm.firstDayOfWeek,"value":new Date(_vm.value),"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate,"selected-date":_vm.selectedDate},on:{"pick":_vm.handleDatePick,"select":_vm.handleDateSelect}}),_c('year-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'year'),expression:"currentView === 'year'"}],attrs:{"value":new Date(_vm.value),"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleYearPick}}),_c('month-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentView === 'month'),expression:"currentView === 'month'"}],attrs:{"value":new Date(_vm.value),"default-value":_vm.defaultValue ? new Date(_vm.defaultValue) : null,"date":_vm.date,"disabled-date":_vm.disabledDate},on:{"pick":_vm.handleMonthPick}})],1)])],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.footerVisible && _vm.currentView === 'date'),expression:"footerVisible && currentView === 'date'"}],staticClass:"el-picker-panel__footer"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectionMode !== 'dates'),expression:"selectionMode !== 'dates'"}],staticClass:"el-picker-panel__link-btn",attrs:{"size":"mini","type":"text"},on:{"click":_vm.changeToNow}},[_vm._v("\n        "+_vm._s(_vm.t('el.datepicker.now'))+"\n      ")]),_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"plain":"","size":"mini"},on:{"click":_vm.confirm}},[_vm._v("\n        "+_vm._s(_vm.t('el.datepicker.confirm'))+"\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_range_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_range_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_range_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d9642a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_range_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_range_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d9642a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _time = __webpack_require__(29);

var _time2 = _interopRequireDefault(_time);

var _dateTable = __webpack_require__(39);

var _dateTable2 = _interopRequireDefault(_dateTable);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var advanceDate = function advanceDate(date, amount) {
  return new Date(new Date(date).getTime() + amount);
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var calcDefaultValue = function calcDefaultValue(defaultValue) {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
  } else if (defaultValue) {
    return [new Date(defaultValue), advanceDate(defaultValue, 24 * 60 * 60 * 1000)];
  } else {
    return [new Date(), advanceDate(Date.now(), 24 * 60 * 60 * 1000)];
  }
};

exports.default = {
  mixins: [_locale2.default],

  directives: { Clickoutside: _clickoutside2.default },

  computed: {
    btnDisabled: function btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting);
    },
    leftLabel: function leftLabel() {
      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
    },
    rightLabel: function rightLabel() {
      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
    },
    leftYear: function leftYear() {
      return this.leftDate.getFullYear();
    },
    leftMonth: function leftMonth() {
      return this.leftDate.getMonth();
    },
    leftMonthDate: function leftMonthDate() {
      return this.leftDate.getDate();
    },
    rightYear: function rightYear() {
      return this.rightDate.getFullYear();
    },
    rightMonth: function rightMonth() {
      return this.rightDate.getMonth();
    },
    rightMonthDate: function rightMonthDate() {
      return this.rightDate.getDate();
    },
    minVisibleDate: function minVisibleDate() {
      return this.minDate ? (0, _util.formatDate)(this.minDate, this.dateFormat) : '';
    },
    maxVisibleDate: function maxVisibleDate() {
      return this.maxDate || this.minDate ? (0, _util.formatDate)(this.maxDate || this.minDate, this.dateFormat) : '';
    },
    minVisibleTime: function minVisibleTime() {
      return this.minDate ? (0, _util.formatDate)(this.minDate, this.timeFormat) : '';
    },
    maxVisibleTime: function maxVisibleTime() {
      return this.maxDate || this.minDate ? (0, _util.formatDate)(this.maxDate || this.minDate, this.timeFormat) : '';
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return (0, _util.extractTimeFormat)(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return (0, _util.extractDateFormat)(this.format);
      } else {
        return 'yyyy-MM-dd';
      }
    },
    enableMonthArrow: function enableMonthArrow() {
      var nextMonth = (this.leftMonth + 1) % 12;
      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
    },
    enableYearArrow: function enableYearArrow() {
      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
    }
  },

  data: function data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: (0, _util.nextMonth)(new Date()),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      showTime: false,
      shortcuts: '',
      visible: '',
      disabledDate: '',
      firstDayOfWeek: 7,
      minTimePickerVisible: false,
      maxTimePickerVisible: false,
      format: '',
      arrowControl: false,
      unlinkPanels: false
    };
  },


  watch: {
    minDate: function minDate(val) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
          var format = 'HH:mm:ss';
          _this.$refs.maxTimePicker.selectableRange = [[(0, _util.parseDate)((0, _util.formatDate)(_this.minDate, format), format), (0, _util.parseDate)('23:59:59', format)]];
        }
      });
      if (val && this.$refs.minTimePicker) {
        this.$refs.minTimePicker.date = val;
        this.$refs.minTimePicker.value = val;
      }
    },
    maxDate: function maxDate(val) {
      if (val && this.$refs.maxTimePicker) {
        this.$refs.maxTimePicker.date = val;
        this.$refs.maxTimePicker.value = val;
      }
    },
    minTimePickerVisible: function minTimePickerVisible(val) {
      var _this2 = this;

      if (val) {
        this.$nextTick(function () {
          _this2.$refs.minTimePicker.date = _this2.minDate;
          _this2.$refs.minTimePicker.value = _this2.minDate;
          _this2.$refs.minTimePicker.adjustSpinners();
        });
      }
    },
    maxTimePickerVisible: function maxTimePickerVisible(val) {
      var _this3 = this;

      if (val) {
        this.$nextTick(function () {
          _this3.$refs.maxTimePicker.date = _this3.maxDate;
          _this3.$refs.maxTimePicker.value = _this3.maxDate;
          _this3.$refs.maxTimePicker.adjustSpinners();
        });
      }
    },
    value: function value(newVal) {
      if (!newVal) {
        this.minDate = null;
        this.maxDate = null;
      } else if (Array.isArray(newVal)) {
        this.minDate = (0, _util.isDate)(newVal[0]) ? new Date(newVal[0]) : null;
        this.maxDate = (0, _util.isDate)(newVal[1]) ? new Date(newVal[1]) : null;
        // NOTE: currently, maxDate = minDate + 1 month
        //       should allow them to be set individually in the future
        if (this.minDate) {
          this.leftDate = this.minDate;
          if (this.unlinkPanels && this.maxDate) {
            var minDateYear = this.minDate.getFullYear();
            var minDateMonth = this.minDate.getMonth();
            var maxDateYear = this.maxDate.getFullYear();
            var maxDateMonth = this.maxDate.getMonth();
            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? (0, _util.nextMonth)(this.maxDate) : this.maxDate;
          } else {
            this.rightDate = (0, _util.nextMonth)(this.leftDate);
          }
        } else {
          this.leftDate = calcDefaultValue(this.defaultValue)[0];
          this.rightDate = (0, _util.nextMonth)(this.leftDate);
        }
      }
    },
    defaultValue: function defaultValue(val) {
      if (!Array.isArray(this.value)) {
        var _calcDefaultValue = calcDefaultValue(val),
            left = _calcDefaultValue[0],
            right = _calcDefaultValue[1];

        this.leftDate = left;
        this.rightDate = val && val[1] && this.unlinkPanels ? right : (0, _util.nextMonth)(this.leftDate);
      }
    }
  },

  methods: {
    handleClear: function handleClear() {
      this.minDate = null;
      this.maxDate = null;
      this.leftDate = calcDefaultValue(this.defaultValue)[0];
      this.rightDate = (0, _util.nextMonth)(this.leftDate);
      this.$emit('pick', null);
    },
    handleChangeRange: function handleChangeRange(val) {
      this.minDate = val.minDate;
      this.maxDate = val.maxDate;
      this.rangeState = val.rangeState;
    },
    handleDateInput: function handleDateInput(event, type) {
      var value = event.target.value;
      if (value.length !== this.dateFormat.length) return;
      var parsedValue = (0, _util.parseDate)(value, this.dateFormat);

      if (parsedValue) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
          return;
        }
        if (type === 'min') {
          this.minDate = new Date(parsedValue);
          this.leftDate = new Date(parsedValue);
          this.rightDate = (0, _util.nextMonth)(this.leftDate);
        } else {
          this.maxDate = new Date(parsedValue);
          this.leftDate = (0, _util.prevMonth)(parsedValue);
          this.rightDate = new Date(parsedValue);
        }
      }
    },
    handleDateChange: function handleDateChange(event, type) {
      var value = event.target.value;
      var parsedValue = (0, _util.parseDate)(value, this.dateFormat);
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = (0, _util.modifyDate)(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate;
          }
        } else {
          this.maxDate = (0, _util.modifyDate)(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate;
          }
        }
      }
    },
    handleTimeChange: function handleTimeChange(event, type) {
      var value = event.target.value;
      var parsedValue = (0, _util.parseDate)(value, this.timeFormat);
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = (0, _util.modifyTime)(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate;
          }
          this.$refs.minTimePicker.value = this.minDate;
          this.minTimePickerVisible = false;
        } else {
          this.maxDate = (0, _util.modifyTime)(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate;
          }
          this.$refs.maxTimePicker.value = this.minDate;
          this.maxTimePickerVisible = false;
        }
      }
    },
    handleRangePick: function handleRangePick(val) {
      var _this4 = this;

      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var defaultTime = this.defaultTime || [];
      var minDate = (0, _util.modifyWithDefaultTime)(val.minDate, defaultTime[0]);
      var maxDate = (0, _util.modifyWithDefaultTime)(val.maxDate, defaultTime[1]);

      if (this.maxDate === maxDate && this.minDate === minDate) {
        return;
      }
      this.onPick && this.onPick(val);
      this.maxDate = maxDate;
      this.minDate = minDate;

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(function () {
        _this4.maxDate = maxDate;
        _this4.minDate = minDate;
      }, 10);
      if (!close || this.showTime) return;
      this.handleConfirm();
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    handleMinTimePick: function handleMinTimePick(value, visible, first) {
      this.minDate = this.minDate || new Date();
      if (value) {
        this.minDate = (0, _util.modifyTime)(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
      }

      if (!first) {
        this.minTimePickerVisible = visible;
      }

      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
        this.maxDate = new Date(this.minDate);
      }
    },
    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
      if (this.maxDate && value) {
        this.maxDate = (0, _util.modifyTime)(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
      }

      if (!first) {
        this.maxTimePickerVisible = visible;
      }

      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
        this.minDate = new Date(this.maxDate);
      }
    },


    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear: function leftPrevYear() {
      this.leftDate = (0, _util.prevYear)(this.leftDate);
      if (!this.unlinkPanels) {
        this.rightDate = (0, _util.nextMonth)(this.leftDate);
      }
    },
    leftPrevMonth: function leftPrevMonth() {
      this.leftDate = (0, _util.prevMonth)(this.leftDate);
      if (!this.unlinkPanels) {
        this.rightDate = (0, _util.nextMonth)(this.leftDate);
      }
    },
    rightNextYear: function rightNextYear() {
      if (!this.unlinkPanels) {
        this.leftDate = (0, _util.nextYear)(this.leftDate);
        this.rightDate = (0, _util.nextMonth)(this.leftDate);
      } else {
        this.rightDate = (0, _util.nextYear)(this.rightDate);
      }
    },
    rightNextMonth: function rightNextMonth() {
      if (!this.unlinkPanels) {
        this.leftDate = (0, _util.nextMonth)(this.leftDate);
        this.rightDate = (0, _util.nextMonth)(this.leftDate);
      } else {
        this.rightDate = (0, _util.nextMonth)(this.rightDate);
      }
    },


    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear: function leftNextYear() {
      this.leftDate = (0, _util.nextYear)(this.leftDate);
    },
    leftNextMonth: function leftNextMonth() {
      this.leftDate = (0, _util.nextMonth)(this.leftDate);
    },
    rightPrevYear: function rightPrevYear() {
      this.rightDate = (0, _util.prevYear)(this.rightDate);
    },
    rightPrevMonth: function rightPrevMonth() {
      this.rightDate = (0, _util.prevMonth)(this.rightDate);
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$emit('pick', [this.minDate, this.maxDate], visible);
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && value && value[0] && value[1] && (0, _util.isDate)(value[0]) && (0, _util.isDate)(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
    }
  },

  components: { TimePicker: _time2.default, DateTable: _dateTable2.default, ElInput: _input2.default, ElButton: _button2.default }
};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":function($event){_vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[{
      'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts,
      'has-time': _vm.showTime
    }, _vm.popperClass]},[_c('div',{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),(_vm.shortcuts)?_c('div',{staticClass:"el-picker-panel__sidebar"},_vm._l((_vm.shortcuts),function(shortcut){return _c('button',{staticClass:"el-picker-panel__shortcut",attrs:{"type":"button"},on:{"click":function($event){_vm.handleShortcutClick(shortcut)}}},[_vm._v(_vm._s(shortcut.text))])})):_vm._e(),_c('div',{staticClass:"el-picker-panel__body"},[(_vm.showTime)?_c('div',{staticClass:"el-date-range-picker__time-header"},[_c('span',{staticClass:"el-date-range-picker__editors-wrap"},[_c('span',{staticClass:"el-date-range-picker__time-picker-wrap"},[_c('el-input',{ref:"minInput",staticClass:"el-date-range-picker__editor",attrs:{"size":"small","disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.startDate'),"value":_vm.minVisibleDate},nativeOn:{"input":function($event){_vm.handleDateInput($event, 'min')},"change":function($event){_vm.handleDateChange($event, 'min')}}})],1),_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(function () { return _vm.minTimePickerVisible = false; }),expression:"() => minTimePickerVisible = false"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c('el-input',{staticClass:"el-date-range-picker__editor",attrs:{"size":"small","disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.startTime'),"value":_vm.minVisibleTime},on:{"focus":function($event){_vm.minTimePickerVisible = true}},nativeOn:{"change":function($event){_vm.handleTimeChange($event, 'min')}}}),_c('time-picker',{ref:"minTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,"visible":_vm.minTimePickerVisible},on:{"pick":_vm.handleMinTimePick,"mounted":function($event){_vm.$refs.minTimePicker.format=_vm.timeFormat}}})],1)]),_c('span',{staticClass:"el-icon-arrow-right"}),_c('span',{staticClass:"el-date-range-picker__editors-wrap is-right"},[_c('span',{staticClass:"el-date-range-picker__time-picker-wrap"},[_c('el-input',{staticClass:"el-date-range-picker__editor",attrs:{"size":"small","disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.endDate'),"value":_vm.maxVisibleDate,"readonly":!_vm.minDate},nativeOn:{"input":function($event){_vm.handleDateInput($event, 'max')},"change":function($event){_vm.handleDateChange($event, 'max')}}})],1),_c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(function () { return _vm.maxTimePickerVisible = false; }),expression:"() => maxTimePickerVisible = false"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c('el-input',{ref:"maxInput",staticClass:"el-date-range-picker__editor",attrs:{"size":"small","disabled":_vm.rangeState.selecting,"placeholder":_vm.t('el.datepicker.endTime'),"value":_vm.maxVisibleTime,"readonly":!_vm.minDate},on:{"focus":function($event){_vm.minDate && (_vm.maxTimePickerVisible = true)}},nativeOn:{"change":function($event){_vm.handleTimeChange($event, 'max')}}}),_c('time-picker',{ref:"maxTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,"visible":_vm.maxTimePickerVisible},on:{"pick":_vm.handleMaxTimePick,"mounted":function($event){_vm.$refs.maxTimePicker.format=_vm.timeFormat}}})],1)])]):_vm._e(),_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c('div',{staticClass:"el-date-range-picker__header"},[_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",attrs:{"type":"button"},on:{"click":_vm.leftPrevYear}}),_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",attrs:{"type":"button"},on:{"click":_vm.leftPrevMonth}}),(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",class:{ 'is-disabled': !_vm.enableYearArrow },attrs:{"type":"button","disabled":!_vm.enableYearArrow},on:{"click":_vm.leftNextYear}}):_vm._e(),(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",class:{ 'is-disabled': !_vm.enableMonthArrow },attrs:{"type":"button","disabled":!_vm.enableMonthArrow},on:{"click":_vm.leftNextMonth}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.leftLabel))])]),_c('date-table',{attrs:{"selection-mode":"range","date":_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"first-day-of-week":_vm.firstDayOfWeek},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick}})],1),_c('div',{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c('div',{staticClass:"el-date-range-picker__header"},[(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",class:{ 'is-disabled': !_vm.enableYearArrow },attrs:{"type":"button","disabled":!_vm.enableYearArrow},on:{"click":_vm.rightPrevYear}}):_vm._e(),(_vm.unlinkPanels)?_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",class:{ 'is-disabled': !_vm.enableMonthArrow },attrs:{"type":"button","disabled":!_vm.enableMonthArrow},on:{"click":_vm.rightPrevMonth}}):_vm._e(),_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",attrs:{"type":"button"},on:{"click":_vm.rightNextYear}}),_c('button',{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",attrs:{"type":"button"},on:{"click":_vm.rightNextMonth}}),_c('div',[_vm._v(_vm._s(_vm.rightLabel))])]),_c('date-table',{attrs:{"selection-mode":"range","date":_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"first-day-of-week":_vm.firstDayOfWeek},on:{"changerange":_vm.handleChangeRange,"pick":_vm.handleRangePick}})],1)])],2),(_vm.showTime)?_c('div',{staticClass:"el-picker-panel__footer"},[_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"size":"mini","type":"text"},on:{"click":_vm.handleClear}},[_vm._v("\n        "+_vm._s(_vm.t('el.datepicker.clear'))+"\n      ")]),_c('el-button',{staticClass:"el-picker-panel__link-btn",attrs:{"plain":"","size":"mini","disabled":_vm.btnDisabled},on:{"click":function($event){_vm.handleConfirm()}}},[_vm._v("\n        "+_vm._s(_vm.t('el.datepicker.confirm'))+"\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _timeSelect = __webpack_require__(196);

var _timeSelect2 = _interopRequireDefault(_timeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_timeSelect2.default.install = function (Vue) {
  Vue.component(_timeSelect2.default.name, _timeSelect2.default);
};

exports.default = _timeSelect2.default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _timeSelect = __webpack_require__(197);

var _timeSelect2 = _interopRequireDefault(_timeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_picker2.default],

  name: 'ElTimeSelect',

  componentName: 'ElTimeSelect',

  props: {
    type: {
      type: String,
      default: 'time-select'
    }
  },

  beforeCreate: function beforeCreate() {
    this.panel = _timeSelect2.default;
  }
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_select_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfad182_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_select_vue__ = __webpack_require__(199);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfad182_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _scrollbar = __webpack_require__(18);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _scrollIntoView = __webpack_require__(26);

var _scrollIntoView2 = _interopRequireDefault(_scrollIntoView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var parseTime = function parseTime(time) {
  var values = (time || '').split(':');
  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);

    return {
      hours: hours,
      minutes: minutes
    };
  }
  /* istanbul ignore next */
  return null;
};

var compareTime = function compareTime(time1, time2) {
  var value1 = parseTime(time1);
  var value2 = parseTime(time2);

  var minutes1 = value1.minutes + value1.hours * 60;
  var minutes2 = value2.minutes + value2.hours * 60;

  if (minutes1 === minutes2) {
    return 0;
  }

  return minutes1 > minutes2 ? 1 : -1;
};

var formatTime = function formatTime(time) {
  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
};

var nextTime = function nextTime(time, step) {
  var timeValue = parseTime(time);
  var stepValue = parseTime(step);

  var next = {
    hours: timeValue.hours,
    minutes: timeValue.minutes
  };

  next.minutes += stepValue.minutes;
  next.hours += stepValue.hours;

  next.hours += Math.floor(next.minutes / 60);
  next.minutes = next.minutes % 60;

  return formatTime(next);
};

exports.default = {
  components: { ElScrollbar: _scrollbar2.default },

  watch: {
    value: function value(val) {
      var _this = this;

      if (!val) return;
      this.$nextTick(function () {
        return _this.scrollToOption();
      });
    }
  },

  methods: {
    handleClick: function handleClick(item) {
      if (!item.disabled) {
        this.$emit('pick', item.value);
      }
    },
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    scrollToOption: function scrollToOption() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';

      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
      (0, _scrollIntoView2.default)(menu, menu.querySelector(selector));
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this2 = this;

      var selected = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.value) !== -1;
      var hasDefault = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.defaultValue) !== -1;
      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
      this.$nextTick(function () {
        return _this2.scrollToOption(option);
      });
    },
    scrollDown: function scrollDown(step) {
      var items = this.items;
      var length = items.length;
      var total = items.length;
      var index = items.map(function (item) {
        return item.value;
      }).indexOf(this.value);
      while (total--) {
        index = (index + step + length) % length;
        if (!items[index].disabled) {
          this.$emit('pick', items[index].value, true);
          return;
        }
      }
    },
    isValidValue: function isValidValue(date) {
      return this.items.filter(function (item) {
        return !item.disabled;
      }).map(function (item) {
        return item.value;
      }).indexOf(date) !== -1;
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      if (keyCode === 38 || keyCode === 40) {
        var mapping = { 40: 1, 38: -1 };
        var offset = mapping[keyCode.toString()];
        this.scrollDown(offset);
        event.stopPropagation();
        return;
      }
    }
  },

  data: function data() {
    return {
      popperClass: '',
      start: '09:00',
      end: '18:00',
      step: '00:30',
      value: '',
      defaultValue: '',
      visible: false,
      minTime: '',
      maxTime: '',
      width: 0
    };
  },


  computed: {
    items: function items() {
      var start = this.start;
      var end = this.end;
      var step = this.step;

      var result = [];

      if (start && end && step) {
        var current = start;
        while (compareTime(current, end) <= 0) {
          result.push({
            value: current,
            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
          });
          current = nextTime(current, step);
        }
      }

      return result;
    }
  }
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":function($event){_vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"popper",staticClass:"el-picker-panel time-select el-popper",class:_vm.popperClass,style:({ width: _vm.width + 'px' })},[_c('el-scrollbar',{attrs:{"noresize":"","wrap-class":"el-picker-panel__content"}},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"time-select-item",class:{ selected: _vm.value === item.value, disabled: item.disabled, default: item.value === _vm.defaultValue },attrs:{"disabled":item.disabled},on:{"click":function($event){_vm.handleClick(item)}}},[_vm._v(_vm._s(item.value))])}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _timePicker = __webpack_require__(201);

var _timePicker2 = _interopRequireDefault(_timePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_timePicker2.default.install = function (Vue) {
  Vue.component(_timePicker2.default.name, _timePicker2.default);
};

exports.default = _timePicker2.default;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _time = __webpack_require__(29);

var _time2 = _interopRequireDefault(_time);

var _timeRange = __webpack_require__(202);

var _timeRange2 = _interopRequireDefault(_timeRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_picker2.default],

  name: 'ElTimePicker',

  props: {
    isRange: Boolean,
    arrowControl: Boolean
  },

  data: function data() {
    return {
      type: ''
    };
  },


  watch: {
    isRange: function isRange(_isRange) {
      if (this.picker) {
        this.unmountPicker();
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? _timeRange2.default : _time2.default;
        this.mountPicker();
      } else {
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? _timeRange2.default : _time2.default;
      }
    }
  },

  created: function created() {
    this.type = this.isRange ? 'timerange' : 'time';
    this.panel = this.isRange ? _timeRange2.default : _time2.default;
  }
};

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_range_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_range_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_range_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ac964a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_range_vue__ = __webpack_require__(204);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_range_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38ac964a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(11);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _timeSpinner = __webpack_require__(38);

var _timeSpinner2 = _interopRequireDefault(_timeSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_TIME = (0, _util.parseDate)('00:00:00', 'HH:mm:ss'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MAX_TIME = (0, _util.parseDate)('23:59:59', 'HH:mm:ss');

var minTimeOfDay = function minTimeOfDay(date) {
  return (0, _util.modifyDate)(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
};

var maxTimeOfDay = function maxTimeOfDay(date) {
  return (0, _util.modifyDate)(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
};

// increase time by amount of milliseconds, but within the range of day
var advanceTime = function advanceTime(date, amount) {
  return new Date(Math.min(date.getTime() + amount, maxTimeOfDay(date).getTime()));
};

exports.default = {
  mixins: [_locale2.default],

  components: { TimeSpinner: _timeSpinner2.default },

  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    offset: function offset() {
      return this.showSeconds ? 11 : 8;
    },
    spinner: function spinner() {
      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
    },
    btnDisabled: function btnDisabled() {
      return this.minDate.getTime() > this.maxDate.getTime();
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    }
  },

  data: function data() {
    return {
      popperClass: '',
      minDate: new Date(),
      maxDate: new Date(),
      value: [],
      oldValue: [new Date(), new Date()],
      defaultValue: null,
      format: 'HH:mm:ss',
      visible: false,
      selectionRange: [0, 2],
      arrowControl: false
    };
  },


  watch: {
    value: function value(_value) {
      if (Array.isArray(_value)) {
        this.minDate = new Date(_value[0]);
        this.maxDate = new Date(_value[1]);
      } else {
        if (Array.isArray(this.defaultValue)) {
          this.minDate = new Date(this.defaultValue[0]);
          this.maxDate = new Date(this.defaultValue[1]);
        } else if (this.defaultValue) {
          this.minDate = new Date(this.defaultValue);
          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
        } else {
          this.minDate = new Date();
          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
        }
      }
    },
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.oldValue = this.value;
        this.$nextTick(function () {
          return _this.$refs.minSpinner.emitSelectRange('hours');
        });
      }
    }
  },

  methods: {
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    handleCancel: function handleCancel() {
      this.$emit('pick', this.oldValue);
    },
    handleMinChange: function handleMinChange(date) {
      this.minDate = (0, _util.clearMilliseconds)(date);
      this.handleChange();
    },
    handleMaxChange: function handleMaxChange(date) {
      this.maxDate = (0, _util.clearMilliseconds)(date);
      this.handleChange();
    },
    handleChange: function handleChange() {
      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$refs.minSpinner.selectableRange = [[minTimeOfDay(this.minDate), this.maxDate]];
        this.$refs.maxSpinner.selectableRange = [[this.minDate, maxTimeOfDay(this.maxDate)]];
        this.$emit('pick', [this.minDate, this.maxDate], true);
      }
    },
    setMinSelectionRange: function setMinSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'min');
      this.selectionRange = [start, end];
    },
    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'max');
      this.selectionRange = [start + this.offset, end + this.offset];
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var minSelectableRange = this.$refs.minSpinner.selectableRange;
      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;

      this.minDate = (0, _util.limitTimeRange)(this.minDate, minSelectableRange, this.format);
      this.maxDate = (0, _util.limitTimeRange)(this.maxDate, maxSelectableRange, this.format);

      this.$emit('pick', [this.minDate, this.maxDate], visible);
    },
    adjustSpinners: function adjustSpinners() {
      this.$refs.minSpinner.adjustSpinners();
      this.$refs.maxSpinner.adjustSpinners();
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      var half = list.length / 2;
      if (next < half) {
        this.$refs.minSpinner.emitSelectRange(mapping[next]);
      } else {
        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
      }
    },
    isValidValue: function isValidValue(date) {
      return Array.isArray(date) && (0, _util.timeWithinRange)(this.minDate, this.$refs.minSpinner.selectableRange) && (0, _util.timeWithinRange)(this.maxDate, this.$refs.maxSpinner.selectableRange);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };

      // Left or Right
      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      }

      // Up or Down
      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.spinner.scrollDown(_step);
        event.preventDefault();
        return;
      }
    }
  }
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":function($event){_vm.$emit('dodestroy')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-time-range-picker el-picker-panel el-popper",class:_vm.popperClass},[_c('div',{staticClass:"el-time-range-picker__content"},[_c('div',{staticClass:"el-time-range-picker__cell"},[_c('div',{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t('el.datepicker.startTime')))]),_c('div',{staticClass:"el-time-range-picker__body el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds, 'is-arrow': _vm.arrowControl }},[_c('time-spinner',{ref:"minSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,"date":_vm.minDate},on:{"change":_vm.handleMinChange,"select-range":_vm.setMinSelectionRange}})],1)]),_c('div',{staticClass:"el-time-range-picker__cell"},[_c('div',{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t('el.datepicker.endTime')))]),_c('div',{staticClass:"el-time-range-picker__body el-time-panel__content",class:{ 'has-seconds': _vm.showSeconds, 'is-arrow': _vm.arrowControl }},[_c('time-spinner',{ref:"maxSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,"date":_vm.maxDate},on:{"change":_vm.handleMaxChange,"select-range":_vm.setMaxSelectionRange}})],1)])]),_c('div',{staticClass:"el-time-panel__footer"},[_c('button',{staticClass:"el-time-panel__btn cancel",attrs:{"type":"button"},on:{"click":function($event){_vm.handleCancel()}}},[_vm._v(_vm._s(_vm.t('el.datepicker.cancel')))]),_c('button',{staticClass:"el-time-panel__btn confirm",attrs:{"type":"button","disabled":_vm.btnDisabled},on:{"click":function($event){_vm.handleConfirm()}}},[_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(206);

var _main2 = _interopRequireDefault(_main);

var _directive = __webpack_require__(209);

var _directive2 = _interopRequireDefault(_directive);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('popover', _directive2.default);

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.directive('popover', _directive2.default);
  Vue.component(_main2.default.name, _main2.default);
};
_main2.default.directive = _directive2.default;

exports.default = _main2.default;

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fd8dc3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(208);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fd8dc3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _dom = __webpack_require__(3);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElPopover',

  mixins: [_vuePopper2.default],

  props: {
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(value) {
        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
      }
    },
    openDelay: {
      type: Number,
      default: 0
    },
    title: String,
    disabled: Boolean,
    content: String,
    reference: {},
    popperClass: String,
    width: {},
    visibleArrow: {
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    transition: {
      type: String,
      default: 'fade-in-linear'
    }
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'el-popover-' + (0, _util.generateId)();
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      val ? this.$emit('show') : this.$emit('hide');
    }
  },

  mounted: function mounted() {
    var _this = this;

    var reference = this.referenceElm = this.reference || this.$refs.reference;
    var popper = this.popper || this.$refs.popper;

    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
      reference = this.referenceElm = this.$slots.reference[0].elm;
    }
    // 可访问性
    if (reference) {
      (0, _dom.addClass)(reference, 'el-popover__reference');
      reference.setAttribute('aria-describedby', this.tooltipId);
      reference.setAttribute('tabindex', 0); // tab序列
      popper.setAttribute('tabindex', 0);

      if (this.trigger !== 'click') {
        (0, _dom.on)(reference, 'focusin', function () {
          _this.handleFocus();
          var instance = reference.__vue__;
          if (instance && instance.focus) {
            instance.focus();
          }
        });
        (0, _dom.on)(popper, 'focusin', this.handleFocus);
        (0, _dom.on)(reference, 'focusout', this.handleBlur);
        (0, _dom.on)(popper, 'focusout', this.handleBlur);
      }
      (0, _dom.on)(reference, 'keydown', this.handleKeydown);
      (0, _dom.on)(reference, 'click', this.handleClick);
    }
    if (this.trigger === 'click') {
      (0, _dom.on)(reference, 'click', this.doToggle);
      (0, _dom.on)(document, 'click', this.handleDocumentClick);
    } else if (this.trigger === 'hover') {
      (0, _dom.on)(reference, 'mouseenter', this.handleMouseEnter);
      (0, _dom.on)(popper, 'mouseenter', this.handleMouseEnter);
      (0, _dom.on)(reference, 'mouseleave', this.handleMouseLeave);
      (0, _dom.on)(popper, 'mouseleave', this.handleMouseLeave);
    } else if (this.trigger === 'focus') {
      var found = false;

      if ([].slice.call(reference.children).length) {
        var children = reference.childNodes;
        var len = children.length;
        for (var i = 0; i < len; i++) {
          if (children[i].nodeName === 'INPUT' || children[i].nodeName === 'TEXTAREA') {
            (0, _dom.on)(children[i], 'focusin', this.doShow);
            (0, _dom.on)(children[i], 'focusout', this.doClose);
            found = true;
            break;
          }
        }
      }
      if (found) return;
      if (reference.nodeName === 'INPUT' || reference.nodeName === 'TEXTAREA') {
        (0, _dom.on)(reference, 'focusin', this.doShow);
        (0, _dom.on)(reference, 'focusout', this.doClose);
      } else {
        (0, _dom.on)(reference, 'mousedown', this.doShow);
        (0, _dom.on)(reference, 'mouseup', this.doClose);
      }
    }
  },


  methods: {
    doToggle: function doToggle() {
      this.showPopper = !this.showPopper;
    },
    doShow: function doShow() {
      this.showPopper = true;
    },
    doClose: function doClose() {
      this.showPopper = false;
    },
    handleFocus: function handleFocus() {
      (0, _dom.addClass)(this.referenceElm, 'focusing');
      if (this.trigger !== 'manual') this.showPopper = true;
    },
    handleClick: function handleClick() {
      (0, _dom.removeClass)(this.referenceElm, 'focusing');
    },
    handleBlur: function handleBlur() {
      (0, _dom.removeClass)(this.referenceElm, 'focusing');
      if (this.trigger !== 'manual') this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this2 = this;

      clearTimeout(this._timer);
      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.showPopper = true;
        }, this.openDelay);
      } else {
        this.showPopper = true;
      }
    },
    handleKeydown: function handleKeydown(ev) {
      if (ev.keyCode === 27 && this.trigger !== 'manual') {
        // esc
        this.doClose();
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this3 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this3.showPopper = false;
      }, 200);
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }
      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
      this.showPopper = false;
    },
    handleAfterEnter: function handleAfterEnter() {
      this.$emit('after-enter');
    },
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
      this.doDestroy();
    }
  },

  destroyed: function destroyed() {
    var reference = this.reference;

    (0, _dom.off)(reference, 'click', this.doToggle);
    (0, _dom.off)(reference, 'mouseup', this.doClose);
    (0, _dom.off)(reference, 'mousedown', this.doShow);
    (0, _dom.off)(reference, 'focusin', this.doShow);
    (0, _dom.off)(reference, 'focusout', this.doClose);
    (0, _dom.off)(reference, 'mouseleave', this.handleMouseLeave);
    (0, _dom.off)(reference, 'mouseenter', this.handleMouseEnter);
    (0, _dom.off)(document, 'click', this.handleDocumentClick);
  }
};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('transition',{attrs:{"name":_vm.transition},on:{"after-enter":_vm.handleAfterEnter,"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled && _vm.showPopper),expression:"!disabled && showPopper"}],ref:"popper",staticClass:"el-popover el-popper",class:[_vm.popperClass, _vm.content && 'el-popover--plain'],style:({ width: _vm.width + 'px' }),attrs:{"role":"tooltip","id":_vm.tooltipId,"aria-hidden":(_vm.disabled || !_vm.showPopper) ? 'true' : 'false'}},[(_vm.title)?_c('div',{staticClass:"el-popover__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2)]),_vm._t("reference")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getReference = function getReference(el, binding, vnode) {
  var _ref = binding.expression ? binding.value : binding.arg;
  var popper = vnode.context.$refs[_ref];
  if (popper) {
    popper.$refs.reference = el;
  }
};

exports.default = {
  bind: function bind(el, binding, vnode) {
    getReference(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    getReference(el, binding, vnode);
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(211);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _dom = __webpack_require__(3);

var _vdom = __webpack_require__(21);

var _util = __webpack_require__(4);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTooltip',

  mixins: [_vuePopper2.default],

  props: {
    openDelay: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    manual: Boolean,
    effect: {
      type: String,
      default: 'dark'
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    popperClass: String,
    content: String,
    visibleArrow: {
      default: true
    },
    transition: {
      type: String,
      default: 'el-fade-in-linear'
    },
    popperOptions: {
      default: function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      default: true
    },
    hideAfter: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      timeoutPending: null,
      focusing: false
    };
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'el-tooltip-' + (0, _util.generateId)();
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;

    this.popperVM = new _vue2.default({
      data: { node: '' },
      render: function render(h) {
        return this.node;
      }
    }).$mount();

    this.debounceClose = (0, _debounce2.default)(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render(h) {
    var _this2 = this;

    if (this.popperVM) {
      this.popperVM.node = h(
        'transition',
        {
          attrs: {
            name: this.transition
          },
          on: {
            'afterLeave': this.doDestroy
          }
        },
        [h(
          'div',
          {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
          [this.$slots.content || this.content]
        )]
      );
    }

    if (!this.$slots.default || !this.$slots.default.length) return this.$slots.default;

    var vnode = (0, _vdom.getFirstComponentChild)(this.$slots.default);

    if (!vnode) return vnode;

    var data = vnode.data = vnode.data || {};
    data.staticClass = this.concatClass(data.staticClass, 'el-tooltip');

    return vnode;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;
    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', 0);
      (0, _dom.on)(this.referenceElm, 'mouseenter', this.show);
      (0, _dom.on)(this.referenceElm, 'mouseleave', this.hide);
      (0, _dom.on)(this.referenceElm, 'focus', function () {
        if (!_this3.$slots.default || !_this3.$slots.default.length) {
          _this3.handleFocus();
          return;
        }
        var instance = _this3.$slots.default[0].componentInstance;
        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      (0, _dom.on)(this.referenceElm, 'blur', this.handleBlur);
      (0, _dom.on)(this.referenceElm, 'click', this.removeFocusing);
    }
  },

  watch: {
    focusing: function focusing(val) {
      if (val) {
        (0, _dom.addClass)(this.referenceElm, 'focusing');
      } else {
        (0, _dom.removeClass)(this.referenceElm, 'focusing');
      }
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    concatClass: function concatClass(a, b) {
      if (a && a.indexOf(b) > -1) return a;
      return a ? b ? a + ' ' + b : a : b || '';
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);

      if (this.hideAfter > 0) {
        this.timeoutPending = setTimeout(function () {
          _this4.showPopper = false;
        }, this.hideAfter);
      }
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);

      if (this.timeoutPending) {
        clearTimeout(this.timeoutPending);
      }
      this.showPopper = false;

      if (this.disabled) {
        this.doDestroy();
      }
    },
    setExpectedState: function setExpectedState(expectedState) {
      if (expectedState === false) {
        clearTimeout(this.timeoutPending);
      }
      this.expectedState = expectedState;
    }
  },

  destroyed: function destroyed() {
    var reference = this.referenceElm;
    (0, _dom.off)(reference, 'mouseenter', this.show);
    (0, _dom.off)(reference, 'mouseleave', this.hide);
    (0, _dom.off)(reference, 'focus', this.handleFocus);
    (0, _dom.off)(reference, 'blur', this.handleBlur);
    (0, _dom.off)(reference, 'click', this.removeFocusing);
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(213);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _main2.default;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MessageBox = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _main = __webpack_require__(214);

var _main2 = _interopRequireDefault(_main);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _vdom = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  title: null,
  message: '',
  type: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  closeOnHashChange: true,
  inputValue: null,
  inputPlaceholder: '',
  inputType: 'text',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: '',
  cancelButtonText: '',
  confirmButtonClass: '',
  cancelButtonClass: '',
  customClass: '',
  beforeClose: null,
  dangerouslyUseHTMLString: false,
  center: false,
  roundButton: false
};

var MessageBoxConstructor = _vue2.default.extend(_main2.default);

var currentMsg = void 0,
    instance = void 0;
var msgQueue = [];

var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var callback = currentMsg.callback;
    if (typeof callback === 'function') {
      if (instance.showInput) {
        callback(instance.inputValue, action);
      } else {
        callback(action);
      }
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        if (instance.showInput) {
          currentMsg.resolve({ value: instance.inputValue, action: action });
        } else {
          currentMsg.resolve(action);
        }
      } else if (action === 'cancel' && currentMsg.reject) {
        currentMsg.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  });

  instance.callback = defaultCallback;
};

var showNextMsg = function showNextMsg() {
  if (!instance) {
    initInstance();
  }
  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      (function () {
        currentMsg = msgQueue.shift();

        var options = currentMsg.options;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            instance[prop] = options[prop];
          }
        }
        if (options.callback === undefined) {
          instance.callback = defaultCallback;
        }

        var oldCb = instance.callback;
        instance.callback = function (action, instance) {
          oldCb(action, instance);
          showNextMsg();
        };
        if ((0, _vdom.isVNode)(instance.message)) {
          instance.$slots.default = [instance.message];
          instance.message = null;
        } else {
          delete instance.$slots.default;
        }
        ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
          if (instance[prop] === undefined) {
            instance[prop] = true;
          }
        });
        document.body.appendChild(instance.$el);

        _vue2.default.nextTick(function () {
          instance.visible = true;
        });
      })();
    }
  }
};

var MessageBox = function MessageBox(options, callback) {
  if (_vue2.default.prototype.$isServer) return;
  if (typeof options === 'string' || (0, _vdom.isVNode)(options)) {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: (0, _merge2.default)({}, defaults, MessageBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });

      showNextMsg();
    });
  } else {
    msgQueue.push({
      options: (0, _merge2.default)({}, defaults, MessageBox.defaults, options),
      callback: callback
    });

    showNextMsg();
  }
};

MessageBox.setDefaults = function (defaults) {
  MessageBox.defaults = defaults;
};

MessageBox.alert = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return MessageBox((0, _merge2.default)({
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false
  }, options));
};

MessageBox.confirm = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return MessageBox((0, _merge2.default)({
    title: title,
    message: message,
    $type: 'confirm',
    showCancelButton: true
  }, options));
};

MessageBox.prompt = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return MessageBox((0, _merge2.default)({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt'
  }, options));
};

MessageBox.close = function () {
  instance.doClose();
  instance.visible = false;
  msgQueue = [];
  currentMsg = null;
};

exports.default = MessageBox;
exports.MessageBox = MessageBox;

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44daa3a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(217);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44daa3a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _popup = __webpack_require__(12);

var _popup2 = _interopRequireDefault(_popup);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

var _dom = __webpack_require__(3);

var _locale3 = __webpack_require__(16);

var _ariaDialog = __webpack_require__(216);

var _ariaDialog2 = _interopRequireDefault(_ariaDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageBox = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

exports.default = {
  mixins: [_popup2.default, _locale2.default],

  props: {
    modal: {
      default: true
    },
    lockScroll: {
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: true
    },
    closeOnPressEscape: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      default: false,
      type: Boolean
    },
    roundButton: {
      default: false,
      type: Boolean
    }
  },

  components: {
    ElInput: _input2.default,
    ElButton: _button2.default
  },

  computed: {
    typeClass: function typeClass() {
      return this.type && typeMap[this.type] ? 'el-icon-' + typeMap[this.type] : '';
    },
    confirmButtonClasses: function confirmButtonClasses() {
      return 'el-button--primary ' + this.confirmButtonClass;
    },
    cancelButtonClasses: function cancelButtonClasses() {
      return '' + this.cancelButtonClass;
    }
  },

  methods: {
    getSafeClose: function getSafeClose() {
      var _this = this;

      var currentId = this.uid;
      return function () {
        _this.$nextTick(function () {
          if (currentId === _this.uid) _this.doClose();
        });
      };
    },
    doClose: function doClose() {
      var _this2 = this;

      if (!this.visible) return;
      this.visible = false;
      this._closing = true;

      this.onClose && this.onClose();
      messageBox.closeDialog(); // 解绑
      if (this.lockScroll) {
        setTimeout(function () {
          if (_this2.modal && _this2.bodyOverflow !== 'hidden') {
            document.body.style.overflow = _this2.bodyOverflow;
            document.body.style.paddingRight = _this2.bodyPaddingRight;
          }
          _this2.bodyOverflow = null;
          _this2.bodyPaddingRight = null;
        }, 200);
      }
      this.opened = false;

      if (!this.transition) {
        this.doAfterClose();
      }
      setTimeout(function () {
        if (_this2.action) _this2.callback(_this2.action, _this2);
      });
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction('cancel');
      }
    },
    handleInputEnter: function handleInputEnter() {
      if (this.inputType !== 'textarea') {
        return this.handleAction('confirm');
      }
    },
    handleAction: function handleAction(action) {
      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }
      this.action = action;
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose();
      }
    },
    validate: function validate() {
      if (this.$type === 'prompt') {
        var inputPattern = this.inputPattern;
        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || (0, _locale3.t)('el.messagebox.error');
          (0, _dom.addClass)(this.getInputElement(), 'invalid');
          return false;
        }
        var inputValidator = this.inputValidator;
        if (typeof inputValidator === 'function') {
          var validateResult = inputValidator(this.inputValue);
          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || (0, _locale3.t)('el.messagebox.error');
            (0, _dom.addClass)(this.getInputElement(), 'invalid');
            return false;
          }
          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            (0, _dom.addClass)(this.getInputElement(), 'invalid');
            return false;
          }
        }
      }
      this.editorErrorMessage = '';
      (0, _dom.removeClass)(this.getInputElement(), 'invalid');
      return true;
    },
    getFistFocus: function getFistFocus() {
      var $btns = this.$el.querySelector('.el-message-box__btns .el-button');
      var $title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
      return $btns && $btns[0] || $title;
    },
    getInputElement: function getInputElement() {
      var inputRefs = this.$refs.input.$refs;
      return inputRefs.input || inputRefs.textarea;
    }
  },

  watch: {
    inputValue: {
      immediate: true,
      handler: function handler(val) {
        var _this3 = this;

        this.$nextTick(function (_) {
          if (_this3.$type === 'prompt' && val !== null) {
            _this3.validate();
          }
        });
      }
    },

    visible: function visible(val) {
      var _this4 = this;

      if (val) {
        this.uid++;
        if (this.$type === 'alert' || this.$type === 'confirm') {
          this.$nextTick(function () {
            _this4.$refs.confirm.$el.focus();
          });
        }
        this.focusAfterClosed = document.activeElement;
        messageBox = new _ariaDialog2.default(this.$el, this.focusAfterClosed, this.getFistFocus());
      }

      // prompt
      if (this.$type !== 'prompt') return;
      if (val) {
        setTimeout(function () {
          if (_this4.$refs.input && _this4.$refs.input.$el) {
            _this4.getInputElement().focus();
          }
        }, 500);
      } else {
        this.editorErrorMessage = '';
        (0, _dom.removeClass)(this.getInputElement(), 'invalid');
      }
    }
  },

  mounted: function mounted() {
    if (this.closeOnHashChange) {
      window.addEventListener('hashchange', this.close);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close);
    }
    setTimeout(function () {
      messageBox.closeDialog();
    });
  },
  data: function data() {
    return {
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      customClass: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputType: 'text',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      dangerouslyUseHTMLString: false,
      focusAfterClosed: null,
      isOnComposition: false
    };
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(284);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"msgbox-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-message-box__wrapper",attrs:{"tabindex":"-1","role":"dialog","aria-modal":"true","aria-label":_vm.title || 'dialog'},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.handleWrapperClick($event)}}},[_c('div',{staticClass:"el-message-box",class:[_vm.customClass, _vm.center && 'el-message-box--center']},[(_vm.title !== null)?_c('div',{staticClass:"el-message-box__header"},[_c('div',{staticClass:"el-message-box__title"},[(_vm.typeClass && _vm.center)?_c('div',{class:['el-message-box__status', _vm.typeClass]}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),(_vm.showClose)?_c('button',{staticClass:"el-message-box__headerbtn",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.handleAction('cancel')},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleAction('cancel')}}},[_c('i',{staticClass:"el-message-box__close el-icon-close"})]):_vm._e()]):_vm._e(),_c('div',{staticClass:"el-message-box__content"},[(_vm.typeClass && !_vm.center && _vm.message !== '')?_c('div',{class:['el-message-box__status', _vm.typeClass]}):_vm._e(),(_vm.message !== '')?_c('div',{staticClass:"el-message-box__message"},[_vm._t("default",[(!_vm.dangerouslyUseHTMLString)?_c('p',[_vm._v(_vm._s(_vm.message))]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],2):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],staticClass:"el-message-box__input"},[_c('el-input',{ref:"input",attrs:{"type":_vm.inputType,"placeholder":_vm.inputPlaceholder},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleInputEnter($event)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('div',{staticClass:"el-message-box__errormsg",style:({ visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden' })},[_vm._v(_vm._s(_vm.editorErrorMessage))])],1)]),_c('div',{staticClass:"el-message-box__btns"},[(_vm.showCancelButton)?_c('el-button',{class:[ _vm.cancelButtonClasses ],attrs:{"loading":_vm.cancelButtonLoading,"round":_vm.roundButton,"size":"small"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleAction('cancel')}},nativeOn:{"click":function($event){_vm.handleAction('cancel')}}},[_vm._v("\n          "+_vm._s(_vm.cancelButtonText || _vm.t('el.messagebox.cancel'))+"\n        ")]):_vm._e(),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConfirmButton),expression:"showConfirmButton"}],ref:"confirm",class:[ _vm.confirmButtonClasses ],attrs:{"loading":_vm.confirmButtonLoading,"round":_vm.roundButton,"size":"small"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleAction('confirm')}},nativeOn:{"click":function($event){_vm.handleAction('confirm')}}},[_vm._v("\n          "+_vm._s(_vm.confirmButtonText || _vm.t('el.messagebox.confirm'))+"\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _breadcrumb = __webpack_require__(219);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_breadcrumb2.default.install = function (Vue) {
  Vue.component(_breadcrumb2.default.name, _breadcrumb2.default);
};

exports.default = _breadcrumb2.default;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d7ebd5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(221);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d7ebd5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//

exports.default = {
  name: 'ElBreadcrumb',

  props: {
    separator: {
      type: String,
      default: '/'
    },
    separatorClass: {
      type: String,
      default: ''
    }
  },

  provide: function provide() {
    return {
      elBreadcrumb: this
    };
  },
  mounted: function mounted() {
    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
    if (items.length) {
      items[items.length - 1].setAttribute('aria-current', 'page');
    }
  }
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-breadcrumb",attrs:{"aria-label":"Breadcrumb","role":"navigation"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _breadcrumbItem = __webpack_require__(223);

var _breadcrumbItem2 = _interopRequireDefault(_breadcrumbItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_breadcrumbItem2.default.install = function (Vue) {
  Vue.component(_breadcrumbItem2.default.name, _breadcrumbItem2.default);
};

exports.default = _breadcrumbItem2.default;

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_item_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d50178a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_item_vue__ = __webpack_require__(225);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d50178a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElBreadcrumbItem',
  props: {
    to: {},
    replace: Boolean
  },
  data: function data() {
    return {
      separator: '',
      separatorClass: ''
    };
  },


  inject: ['elBreadcrumb'],

  mounted: function mounted() {
    var _this = this;

    this.separator = this.elBreadcrumb.separator;
    this.separatorClass = this.elBreadcrumb.separatorClass;
    if (this.to) {
      (function () {
        var link = _this.$refs.link;
        var to = _this.to;
        link.setAttribute('role', 'link');
        link.addEventListener('click', function (_) {
          _this.replace ? _this.$router.replace(to) : _this.$router.push(to);
        });
      })();
    }
  }
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"el-breadcrumb__item"},[_c('span',{ref:"link",class:['el-breadcrumb__inner', _vm.to ? 'is-link' : ''],attrs:{"role":"link"}},[_vm._t("default")],2),(_vm.separatorClass)?_c('i',{staticClass:"el-breadcrumb__separator",class:_vm.separatorClass}):_c('span',{staticClass:"el-breadcrumb__separator",attrs:{"role":"presentation"}},[_vm._v(_vm._s(_vm.separator))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _form = __webpack_require__(227);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_form2.default.install = function (Vue) {
  Vue.component(_form2.default.name, _form2.default);
};

exports.default = _form2.default;

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0876c296_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(229);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0876c296_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElForm',

  componentName: 'ElForm',

  provide: function provide() {
    return {
      elForm: this
    };
  },


  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: String,
    labelSuffix: {
      type: String,
      default: ''
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    rules: function rules() {
      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */
    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },

  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        "production" !== 'production' && console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }
      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      this.fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for validate to work!');
        return;
      }

      var promise = void 0;
      // if no callback, return promise
      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0;
      // 如果需要验证的fields为空，调用验证时立刻返回callback
      if (this.fields.length === 0 && callback) {
        callback(true);
      }
      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }
          invalidFields = (0, _merge2.default)({}, invalidFields, field);
          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(prop, cb) {
      var field = this.fields.filter(function (field) {
        return field.prop === prop;
      })[0];
      if (!field) {
        throw new Error('must call validateField with valid prop string!');
      }

      field.validate('', cb);
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"el-form",class:[
  _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
  { 'el-form--inline': _vm.inline }
]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _formItem = __webpack_require__(231);

var _formItem2 = _interopRequireDefault(_formItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_formItem2.default.install = function (Vue) {
  Vue.component(_formItem2.default.name, _formItem2.default);
};

exports.default = _formItem2.default;

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06fe54a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__ = __webpack_require__(234);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f06fe54a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _asyncValidator = __webpack_require__(233);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElFormItem',

  componentName: 'ElFormItem',

  mixins: [_emitter2.default],

  provide: function provide() {
    return {
      elFormItem: this
    };
  },


  inject: ['elForm'],

  props: {
    label: String,
    labelWidth: String,
    prop: String,
    required: {
      type: Boolean,
      default: undefined
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    for: String,
    inlineMessage: {
      type: [String, Boolean],
      default: ''
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String
  },
  watch: {
    error: {
      immediate: true,
      handler: function handler(value) {
        this.validateMessage = value;
        this.validateState = value ? 'error' : '';
      }
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    labelFor: function labelFor() {
      return this.for || this.prop;
    },
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.form.labelPosition === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.width = labelWidth;
      }
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.marginLeft = labelWidth;
      }
      return ret;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }
      return parent;
    },

    fieldValue: {
      cache: false,
      get: function get() {
        var model = this.form.model;
        if (!model || !this.prop) {
          return;
        }

        var path = this.prop;
        if (path.indexOf(':') !== -1) {
          path = path.replace(/:/, '.');
        }

        return (0, _util.getPropByPath)(model, path, true).v;
      }
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }
          return true;
        });
      }
      return isRequired;
    },
    _formSize: function _formSize() {
      return this.elForm.size;
    },
    elFormItemSize: function elFormItemSize() {
      return this.size || this._formSize;
    },
    sizeClass: function sizeClass() {
      return (this.$ELEMENT || {}).size || this.elFormItemSize;
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false
    };
  },

  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.noop;

      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      this.validateState = 'validating';

      var descriptor = {};
      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }
      descriptor[this.prop] = rules;

      var validator = new _asyncValidator2.default(descriptor);
      var model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';

        callback(_this.validateMessage, invalidFields);
        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors);
      });
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      this.validateState = '';
      this.validateMessage = '';

      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = (0, _util.getPropByPath)(model, path, true);

      this.validateDisabled = true;
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      }
      /* Select 的值被代码改变时不会触发校验，
         这里需要强行触发一次，刷新 validateDisabled 的值，
         确保 Select 下一次值改变时能正确触发校验 */
      this.broadcast('ElSelect', 'fieldReset');

      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];

      var prop = (0, _util.getPropByPath)(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();

      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return (0, _merge2.default)({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);

      var initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });

      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(286);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-form-item",class:[{
    'el-form-item--feedback': _vm.elForm && _vm.elForm.statusIcon,
    'is-error': _vm.validateState === 'error',
    'is-validating': _vm.validateState === 'validating',
    'is-success': _vm.validateState === 'success',
    'is-required': _vm.isRequired || _vm.required
  },
  _vm.sizeClass ? 'el-form-item--' + _vm.sizeClass : ''
]},[(_vm.label || _vm.$slots.label)?_c('label',{staticClass:"el-form-item__label",style:(_vm.labelStyle),attrs:{"for":_vm.labelFor}},[_vm._t("label",[_vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))])],2):_vm._e(),_c('div',{staticClass:"el-form-item__content",style:(_vm.contentStyle)},[_vm._t("default"),_c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage)?_c('div',{staticClass:"el-form-item__error",class:{
          'el-form-item__error--inline': typeof _vm.inlineMessage === 'boolean'
            ? _vm.inlineMessage
            : (_vm.elForm && _vm.elForm.inlineMessage || false)
        }},[_vm._v("\n        "+_vm._s(_vm.validateMessage)+"\n      ")]):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tabs = __webpack_require__(236);

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tabs2.default.install = function (Vue) {
  Vue.component(_tabs2.default.name, _tabs2.default);
};

exports.default = _tabs2.default;

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabs_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tabNav = __webpack_require__(238);

var _tabNav2 = _interopRequireDefault(_tabNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTabs',

  components: {
    TabNav: _tabNav2.default
  },

  props: {
    type: String,
    activeName: String,
    closable: Boolean,
    addable: Boolean,
    value: {},
    editable: Boolean,
    tabPosition: {
      type: String,
      default: 'top'
    }
  },

  provide: function provide() {
    return {
      rootTabs: this
    };
  },
  data: function data() {
    return {
      currentName: this.value || this.activeName,
      panes: []
    };
  },


  watch: {
    activeName: function activeName(value) {
      this.setCurrentName(value);
    },
    value: function value(_value) {
      this.setCurrentName(_value);
    },
    currentName: function currentName(value) {
      var _this = this;

      if (this.$refs.nav) {
        this.$nextTick(function (_) {
          _this.$refs.nav.scrollToActiveTab();
        });
      }
    }
  },

  methods: {
    handleTabClick: function handleTabClick(tab, tabName, event) {
      if (tab.disabled) return;
      this.setCurrentName(tabName);
      this.$emit('tab-click', tab, event);
    },
    handleTabRemove: function handleTabRemove(pane, ev) {
      if (pane.disabled) return;
      ev.stopPropagation();
      this.$emit('edit', pane.name, 'remove');
      this.$emit('tab-remove', pane.name);
    },
    handleTabAdd: function handleTabAdd() {
      this.$emit('edit', null, 'add');
      this.$emit('tab-add');
    },
    setCurrentName: function setCurrentName(value) {
      this.currentName = value;
      this.$emit('input', value);
    },
    addPanes: function addPanes(item) {
      var index = this.$slots.default.filter(function (item) {
        return item.elm.nodeType === 1 && /\bel-tab-pane\b/.test(item.elm.className);
      }).indexOf(item.$vnode);
      this.panes.splice(index, 0, item);
    },
    removePanes: function removePanes(item) {
      var panes = this.panes;
      var index = panes.indexOf(item);
      if (index > -1) {
        panes.splice(index, 1);
      }
    }
  },
  render: function render(h) {
    var _ref;

    var type = this.type,
        handleTabClick = this.handleTabClick,
        handleTabRemove = this.handleTabRemove,
        handleTabAdd = this.handleTabAdd,
        currentName = this.currentName,
        panes = this.panes,
        editable = this.editable,
        addable = this.addable,
        tabPosition = this.tabPosition;


    var newButton = editable || addable ? h(
      'span',
      {
        'class': 'el-tabs__new-tab',
        on: {
          'click': handleTabAdd,
          'keydown': function keydown(ev) {
            if (ev.keyCode === 13) {
              handleTabAdd();
            }
          }
        },
        attrs: {
          tabindex: '0'
        }
      },
      [h(
        'i',
        { 'class': 'el-icon-plus' },
        []
      )]
    ) : null;

    var navData = {
      props: {
        currentName: currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        editable: editable,
        type: type,
        panes: panes
      },
      ref: 'nav'
    };
    var header = h(
      'div',
      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
      [newButton, h(
        'tab-nav',
        navData,
        []
      )]
    );
    var panels = h(
      'div',
      { 'class': 'el-tabs__content' },
      [this.$slots.default]
    );

    return h(
      'div',
      { 'class': (_ref = {
          'el-tabs': true,
          'el-tabs--card': type === 'card'
        }, _ref['el-tabs--' + tabPosition] = true, _ref['el-tabs--border-card'] = type === 'border-card', _ref) },
      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
    );
  },
  created: function created() {
    if (!this.currentName) {
      this.setCurrentName('0');
    }
  }
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_nav_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_nav_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_nav_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tabBar = __webpack_require__(240);

var _tabBar2 = _interopRequireDefault(_tabBar);

var _resizeEvent = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}
var firstUpperCase = function firstUpperCase(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
    return L.toUpperCase();
  });
};

exports.default = {
  name: 'TabNav',

  components: {
    TabBar: _tabBar2.default
  },

  inject: ['rootTabs'],

  props: {
    panes: Array,
    currentName: String,
    editable: Boolean,
    onTabClick: {
      type: Function,
      default: noop
    },
    onTabRemove: {
      type: Function,
      default: noop
    },
    type: String
  },

  data: function data() {
    return {
      scrollable: false,
      navOffset: 0,
      isFocus: false,
      focusable: true
    };
  },


  computed: {
    navStyle: function navStyle() {
      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
      return {
        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
      };
    },
    sizeName: function sizeName() {
      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
    }
  },

  methods: {
    scrollPrev: function scrollPrev() {
      var containerSize = this.$refs.navScroll['offset' + firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset;

      if (!currentOffset) return;

      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;

      this.navOffset = newOffset;
    },
    scrollNext: function scrollNext() {
      var navSize = this.$refs.nav['offset' + firstUpperCase(this.sizeName)];
      var containerSize = this.$refs.navScroll['offset' + firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;

      this.navOffset = newOffset;
    },
    scrollToActiveTab: function scrollToActiveTab() {
      if (!this.scrollable) return;
      var nav = this.$refs.nav;
      var activeTab = this.$el.querySelector('.is-active');
      if (!activeTab) return;
      var navScroll = this.$refs.navScroll;
      var activeTabBounding = activeTab.getBoundingClientRect();
      var navScrollBounding = navScroll.getBoundingClientRect();
      var navBounding = nav.getBoundingClientRect();
      var currentOffset = this.navOffset;
      var newOffset = currentOffset;

      if (activeTabBounding.left < navScrollBounding.left) {
        newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
      }
      if (activeTabBounding.right > navScrollBounding.right) {
        newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
      }
      if (navBounding.right < navScrollBounding.right) {
        newOffset = nav.offsetWidth - navScrollBounding.width;
      }
      this.navOffset = Math.max(newOffset, 0);
    },
    update: function update() {
      if (!this.$refs.nav) return;
      var sizeName = this.sizeName;
      var navSize = this.$refs.nav['offset' + firstUpperCase(sizeName)];
      var containerSize = this.$refs.navScroll['offset' + firstUpperCase(sizeName)];
      var currentOffset = this.navOffset;

      if (containerSize < navSize) {
        var _currentOffset = this.navOffset;
        this.scrollable = this.scrollable || {};
        this.scrollable.prev = _currentOffset;
        this.scrollable.next = _currentOffset + containerSize < navSize;
        if (navSize - _currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
        }
      } else {
        this.scrollable = false;
        if (currentOffset > 0) {
          this.navOffset = 0;
        }
      }
    },
    changeTab: function changeTab(e) {
      var keyCode = e.keyCode;
      var nextIndex = void 0;
      var currentIndex = void 0,
          tabList = void 0;
      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
        // 左右上下键更换tab
        tabList = e.currentTarget.querySelectorAll('[role=tab]');
        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
      } else {
        return;
      }
      if (keyCode === 37 || keyCode === 38) {
        // left
        if (currentIndex === 0) {
          // first
          nextIndex = tabList.length - 1;
        } else {
          nextIndex = currentIndex - 1;
        }
      } else {
        // right
        if (currentIndex < tabList.length - 1) {
          // not last
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = 0;
        }
      }
      tabList[nextIndex].focus(); // 改变焦点元素
      tabList[nextIndex].click(); // 选中下一个tab
      this.setFocus();
    },
    setFocus: function setFocus() {
      if (this.focusable) {
        this.isFocus = true;
      }
    },
    removeFocus: function removeFocus() {
      this.isFocus = false;
    },
    visibilityChangeHandler: function visibilityChangeHandler() {
      var _this = this;

      var visibility = document.visibilityState;
      if (visibility === 'hidden') {
        this.focusable = false;
      } else if (visibility === 'visible') {
        setTimeout(function () {
          _this.focusable = true;
        }, 50);
      }
    },
    windowBlurHandler: function windowBlurHandler() {
      this.focusable = false;
    },
    windowFocusHandler: function windowFocusHandler() {
      var _this2 = this;

      setTimeout(function () {
        _this2.focusable = true;
      }, 50);
    }
  },

  updated: function updated() {
    this.update();
  },
  render: function render(h) {
    var _this3 = this;

    var type = this.type,
        panes = this.panes,
        editable = this.editable,
        onTabClick = this.onTabClick,
        onTabRemove = this.onTabRemove,
        navStyle = this.navStyle,
        scrollable = this.scrollable,
        scrollNext = this.scrollNext,
        scrollPrev = this.scrollPrev,
        changeTab = this.changeTab,
        setFocus = this.setFocus,
        removeFocus = this.removeFocus;

    var scrollBtn = scrollable ? [h(
      'span',
      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
          'click': scrollPrev
        }
      },
      [h(
        'i',
        { 'class': 'el-icon-arrow-left' },
        []
      )]
    ), h(
      'span',
      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
          'click': scrollNext
        }
      },
      [h(
        'i',
        { 'class': 'el-icon-arrow-right' },
        []
      )]
    )] : null;

    var tabs = this._l(panes, function (pane, index) {
      var _ref;

      var tabName = pane.name || pane.index || index;
      var closable = pane.isClosable || editable;

      pane.index = '' + index;

      var btnClose = closable ? h(
        'span',
        { 'class': 'el-icon-close', on: {
            'click': function click(ev) {
              onTabRemove(pane, ev);
            }
          }
        },
        []
      ) : null;

      var tabLabelContent = pane.$slots.label || pane.label;
      var tabindex = pane.active ? 0 : -1;
      return h(
        'div',
        {
          'class': (_ref = {
            'el-tabs__item': true
          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
          attrs: { id: 'tab-' + tabName,
            'aria-controls': 'pane-' + tabName,
            role: 'tab',
            'aria-selected': pane.active,

            tabindex: tabindex
          },
          ref: 'tabs', refInFor: true,
          on: {
            'focus': function focus() {
              setFocus();
            },
            'blur': function blur() {
              removeFocus();
            },
            'click': function click(ev) {
              removeFocus();onTabClick(pane, tabName, ev);
            },
            'keydown': function keydown(ev) {
              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
                onTabRemove(pane, ev);
              }
            }
          }
        },
        [tabLabelContent, btnClose]
      );
    });
    return h(
      'div',
      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
      [scrollBtn, h(
        'div',
        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
        [h(
          'div',
          { 'class': 'el-tabs__nav', ref: 'nav', style: navStyle, attrs: { role: 'tablist' },
            on: {
              'keydown': changeTab
            }
          },
          [!type ? h(
            'tab-bar',
            {
              attrs: { tabs: panes }
            },
            []
          ) : null, tabs]
        )]
      )]
    );
  },
  mounted: function mounted() {
    (0, _resizeEvent.addResizeListener)(this.$el, this.update);
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    window.addEventListener('blur', this.windowBlurHandler);
    window.addEventListener('focus', this.windowFocusHandler);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.update) (0, _resizeEvent.removeResizeListener)(this.$el, this.update);
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    window.removeEventListener('blur', this.windowBlurHandler);
    window.removeEventListener('focus', this.windowFocusHandler);
  }
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_bar_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a42dc98_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_bar_vue__ = __webpack_require__(242);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_bar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a42dc98_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//

exports.default = {
  name: 'TabBar',

  props: {
    tabs: Array
  },

  inject: ['rootTabs'],

  computed: {
    barStyle: {
      cache: false,
      get: function get() {
        var _this = this;

        if (!this.$parent.$refs.tabs) return {};
        var style = {};
        var offset = 0;
        var tabSize = 0;
        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
        var sizeDir = sizeName === 'width' ? 'x' : 'y';
        var firstUpperCase = function firstUpperCase(str) {
          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
            return L.toUpperCase();
          });
        };
        this.tabs.every(function (tab, index) {
          var $el = _this.$parent.$refs.tabs[index];
          if (!$el) {
            return false;
          }

          if (!tab.active) {
            offset += $el['client' + firstUpperCase(sizeName)];
            return true;
          } else {
            tabSize = $el['client' + firstUpperCase(sizeName)];
            if (sizeName === 'width' && _this.tabs.length > 1) {
              tabSize -= index === 0 || index === _this.tabs.length - 1 ? 20 : 40;
            }
            return false;
          }
        });

        if (sizeName === 'width' && offset !== 0) {
          offset += 20;
        }
        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
        style[sizeName] = tabSize + 'px';
        style.transform = transform;
        style.msTransform = transform;
        style.webkitTransform = transform;

        return style;
      }
    }
  }
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-tabs__active-bar",class:("is-" + (_vm.rootTabs.tabPosition)),style:(_vm.barStyle)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tabPane = __webpack_require__(244);

var _tabPane2 = _interopRequireDefault(_tabPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tabPane2.default.install = function (Vue) {
  Vue.component(_tabPane2.default.name, _tabPane2.default);
};

exports.default = _tabPane2.default;

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_pane_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_pane_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_pane_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53570e97_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_pane_vue__ = __webpack_require__(246);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_pane_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53570e97_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_pane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTabPane',

  componentName: 'ElTabPane',

  props: {
    label: String,
    labelContent: Function,
    name: String,
    closable: Boolean,
    disabled: Boolean
  },

  data: function data() {
    return {
      index: null
    };
  },


  computed: {
    isClosable: function isClosable() {
      return this.closable || this.$parent.closable;
    },
    active: function active() {
      return this.$parent.currentName === (this.name || this.index);
    },
    paneName: function paneName() {
      return this.name || this.index;
    }
  },

  mounted: function mounted() {
    this.$parent.addPanes(this);
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.$parent.removePanes(this);
  },


  watch: {
    label: function label() {
      this.$parent.$forceUpdate();
    }
  }
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"el-tab-pane",attrs:{"role":"tabpanel","aria-hidden":!_vm.active,"id":("pane-" + _vm.paneName),"aria-labelledby":("tab-" + _vm.paneName)}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tag = __webpack_require__(248);

var _tag2 = _interopRequireDefault(_tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tag2.default.install = function (Vue) {
  Vue.component(_tag2.default.name, _tag2.default);
};

exports.default = _tag2.default;

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466877f5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tag_vue__ = __webpack_require__(250);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466877f5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTag',
  props: {
    text: String,
    closable: Boolean,
    type: String,
    hit: Boolean,
    disableTransitions: Boolean,
    color: String,
    size: String
  },
  methods: {
    handleClose: function handleClose(event) {
      this.$emit('close', event);
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  }
};

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.disableTransitions ? '' : 'el-zoom-in-center'}},[_c('span',{staticClass:"el-tag",class:[
      _vm.type ? 'el-tag--' + _vm.type : '',
      _vm.tagSize && ("el-tag--" + _vm.tagSize),
      {'is-hit': _vm.hit}
    ],style:({backgroundColor: _vm.color})},[_vm._t("default"),(_vm.closable)?_c('i',{staticClass:"el-tag__close el-icon-close",on:{"click":function($event){$event.stopPropagation();_vm.handleClose($event)}}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tree = __webpack_require__(252);

var _tree2 = _interopRequireDefault(_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tree2.default.install = function (Vue) {
  Vue.component(_tree2.default.name, _tree2.default);
};

exports.default = _tree2.default;

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd5d816_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_vue__ = __webpack_require__(259);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd5d816_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _treeStore = __webpack_require__(254);

var _treeStore2 = _interopRequireDefault(_treeStore);

var _util = __webpack_require__(22);

var _treeNode = __webpack_require__(256);

var _treeNode2 = _interopRequireDefault(_treeNode);

var _locale = __webpack_require__(16);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _dom = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTree',

  mixins: [_emitter2.default],

  components: {
    ElTreeNode: _treeNode2.default
  },

  data: function data() {
    return {
      store: null,
      root: null,
      currentNode: null,
      treeItems: null,
      checkboxItems: [],
      dragState: {
        showDropIndicator: false,
        draggingNode: null,
        dropNode: null,
        allowDrop: true
      }
    };
  },


  props: {
    data: {
      type: Array
    },
    emptyText: {
      type: String,
      default: function _default() {
        return (0, _locale.t)('el.tree.emptyText');
      }
    },
    renderAfterExpand: {
      type: Boolean,
      default: true
    },
    nodeKey: String,
    checkStrictly: Boolean,
    defaultExpandAll: Boolean,
    expandOnClickNode: {
      type: Boolean,
      default: true
    },
    checkDescendants: {
      type: Boolean,
      default: false
    },
    autoExpandParent: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: Array,
    defaultExpandedKeys: Array,
    renderContent: Function,
    showCheckbox: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    allowDrag: Function,
    allowDrop: Function,
    props: {
      default: function _default() {
        return {
          children: 'children',
          label: 'label',
          icon: 'icon',
          disabled: 'disabled'
        };
      }
    },
    lazy: {
      type: Boolean,
      default: false
    },
    highlightCurrent: Boolean,
    load: Function,
    filterNodeMethod: Function,
    accordion: Boolean,
    indent: {
      type: Number,
      default: 18
    }
  },

  computed: {
    children: {
      set: function set(value) {
        this.data = value;
      },
      get: function get() {
        return this.data;
      }
    },

    treeItemArray: function treeItemArray() {
      return Array.prototype.slice.call(this.treeItems);
    }
  },

  watch: {
    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
      this.store.defaultCheckedKeys = newVal;
      this.store.setDefaultCheckedKey(newVal);
    },
    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
      this.store.defaultExpandedKeys = newVal;
      this.store.setDefaultExpandedKeys(newVal);
    },
    data: function data(newVal) {
      this.store.setData(newVal);
    },
    checkboxItems: function checkboxItems(val) {
      Array.prototype.forEach.call(val, function (checkbox) {
        checkbox.setAttribute('tabindex', -1);
      });
    },
    checkStrictly: function checkStrictly(newVal) {
      this.store.checkStrictly = newVal;
    }
  },

  methods: {
    filter: function filter(value) {
      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
      this.store.filter(value);
    },
    getNodeKey: function getNodeKey(node) {
      return (0, _util.getNodeKey)(this.nodeKey, node.data);
    },
    getNodePath: function getNodePath(data) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
      var node = this.store.getNode(data);
      if (!node) return [];
      var path = [node.data];
      var parent = node.parent;
      while (parent && parent !== this.root) {
        path.push(parent.data);
        parent = parent.parent;
      }
      return path.reverse();
    },
    getCheckedNodes: function getCheckedNodes(leafOnly) {
      return this.store.getCheckedNodes(leafOnly);
    },
    getCheckedKeys: function getCheckedKeys(leafOnly) {
      return this.store.getCheckedKeys(leafOnly);
    },
    getCurrentNode: function getCurrentNode() {
      var currentNode = this.store.getCurrentNode();
      return currentNode ? currentNode.data : null;
    },
    getCurrentKey: function getCurrentKey() {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
      var currentNode = this.getCurrentNode();
      return currentNode ? currentNode[this.nodeKey] : null;
    },
    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
      this.store.setCheckedNodes(nodes, leafOnly);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
      this.store.setCheckedKeys(keys, leafOnly);
    },
    setChecked: function setChecked(data, checked, deep) {
      this.store.setChecked(data, checked, deep);
    },
    getHalfCheckedNodes: function getHalfCheckedNodes() {
      return this.store.getHalfCheckedNodes();
    },
    getHalfCheckedKeys: function getHalfCheckedKeys() {
      return this.store.getHalfCheckedKeys();
    },
    setCurrentNode: function setCurrentNode(node) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
      this.store.setUserCurrentNode(node);
    },
    setCurrentKey: function setCurrentKey(key) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
      this.store.setCurrentNodeKey(key);
    },
    getNode: function getNode(data) {
      return this.store.getNode(data);
    },
    remove: function remove(data) {
      this.store.remove(data);
    },
    append: function append(data, parentNode) {
      this.store.append(data, parentNode);
    },
    insertBefore: function insertBefore(data, refNode) {
      this.store.insertBefore(data, refNode);
    },
    insertAfter: function insertAfter(data, refNode) {
      this.store.insertAfter(data, refNode);
    },
    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.$emit('node-expand', nodeData, node, instance);
    },
    updateKeyChildren: function updateKeyChildren(key, data) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
      this.store.updateChildren(key, data);
    },
    initTabIndex: function initTabIndex() {
      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
      if (checkedItem.length) {
        checkedItem[0].setAttribute('tabindex', 0);
        return;
      }
      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
    },
    handelKeydown: function handelKeydown(ev) {
      var currentItem = ev.target;
      if (currentItem.className.indexOf('el-tree-node') === -1) return;
      ev.preventDefault();
      var keyCode = ev.keyCode;
      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
      var currentIndex = this.treeItemArray.indexOf(currentItem);
      var nextIndex = void 0;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up、down
        if (keyCode === 38) {
          // up
          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
        } else {
          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
        }
        this.treeItemArray[nextIndex].focus(); // 选中
      }
      if ([37, 39].indexOf(keyCode) > -1) {
        // left、right 展开
        currentItem.click(); // 选中
      }
      var hasInput = currentItem.querySelector('[type="checkbox"]');
      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
        // space enter选中checkbox
        hasInput.click();
      }
    }
  },

  created: function created() {
    var _this = this;

    this.isTree = true;

    this.store = new _treeStore2.default({
      key: this.nodeKey,
      data: this.data,
      lazy: this.lazy,
      props: this.props,
      load: this.load,
      currentNodeKey: this.currentNodeKey,
      checkStrictly: this.checkStrictly,
      checkDescendants: this.checkDescendants,
      defaultCheckedKeys: this.defaultCheckedKeys,
      defaultExpandedKeys: this.defaultExpandedKeys,
      autoExpandParent: this.autoExpandParent,
      defaultExpandAll: this.defaultExpandAll,
      filterNodeMethod: this.filterNodeMethod
    });

    this.root = this.store.root;

    var dragState = this.dragState;
    this.$on('tree-node-drag-start', function (event, treeNode) {
      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
        event.preventDefault();
        return false;
      }
      event.dataTransfer.effectAllowed = 'move';

      // wrap in try catch to address IE's error when first param is 'text/plain'
      try {
        // setData is required for draggable to work in FireFox
        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
        event.dataTransfer.setData('text/plain', '');
      } catch (e) {}
      dragState.draggingNode = treeNode;
      _this.$emit('node-drag-start', treeNode.node, event);
    });

    this.$on('tree-node-drag-over', function (event, treeNode) {
      var dropNode = (0, _util.findNearestComponent)(event.target, 'ElTreeNode');
      var oldDropNode = dragState.dropNode;
      if (oldDropNode && oldDropNode !== dropNode) {
        (0, _dom.removeClass)(oldDropNode.$el, 'is-drop-inner');
      }
      var draggingNode = dragState.draggingNode;
      if (!draggingNode || !dropNode) return;

      var dropPrev = true;
      var dropInner = true;
      var dropNext = true;
      if (typeof _this.allowDrop === 'function') {
        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
        dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
      }
      dragState.allowDrop = dropInner;
      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
        if (oldDropNode) {
          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
        }
        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
      }

      if (dropPrev || dropInner || dropNext) {
        dragState.dropNode = dropNode;
      }

      if (dropNode.node.nextSibling === draggingNode.node) {
        dropNext = false;
      }
      if (dropNode.node.previousSibling === draggingNode.node) {
        dropPrev = false;
      }
      if (dropNode.node.contains(draggingNode.node, false)) {
        dropInner = false;
      }
      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
        dropPrev = false;
        dropInner = false;
        dropNext = false;
      }

      var targetPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
      var treePosition = _this.$el.getBoundingClientRect();

      var dropType = void 0;
      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.5 : 1 : -1;
      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.5 : 0 : 1;

      var indicatorTop = -9999;
      var distance = event.clientY - targetPosition.top;
      if (distance < targetPosition.height * prevPercent) {
        dropType = 'before';
      } else if (distance > targetPosition.height * nextPercent) {
        dropType = 'after';
      } else if (dropInner) {
        dropType = 'inner';
      } else {
        dropType = 'none';
      }

      var dropIndicator = _this.$refs.dropIndicator;
      if (dropType === 'before') {
        indicatorTop = targetPosition.top - treePosition.top;
      } else if (dropType === 'after') {
        indicatorTop = targetPosition.bottom - treePosition.top;
      }
      dropIndicator.style.top = indicatorTop + 'px';
      dropIndicator.style.left = targetPosition.right - treePosition.left + 'px';

      if (dropType === 'inner') {
        (0, _dom.addClass)(dropNode.$el, 'is-drop-inner');
      } else {
        (0, _dom.removeClass)(dropNode.$el, 'is-drop-inner');
      }

      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
      dragState.dropType = dropType;
      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
    });

    this.$on('tree-node-drag-end', function (event) {
      var draggingNode = dragState.draggingNode,
          dropType = dragState.dropType,
          dropNode = dragState.dropNode;

      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';

      if (draggingNode && dropNode) {
        var data = draggingNode.node.data;
        if (dropType === 'before') {
          draggingNode.node.remove();
          dropNode.node.parent.insertBefore({ data: data }, dropNode.node);
        } else if (dropType === 'after') {
          draggingNode.node.remove();
          dropNode.node.parent.insertAfter({ data: data }, dropNode.node);
        } else if (dropType === 'inner') {
          dropNode.node.insertChild({ data: data });
          draggingNode.node.remove();
        }
        (0, _dom.removeClass)(dropNode.$el, 'is-drop-inner');

        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
        if (dropType !== 'none') {
          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
        }
      }
      if (draggingNode && !dropNode) {
        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
      }

      dragState.showDropIndicator = false;
      dragState.draggingNode = null;
      dragState.dropNode = null;
      dragState.allowDrop = true;
    });
  },
  mounted: function mounted() {
    this.initTabIndex();
    this.$el.addEventListener('keydown', this.handelKeydown);
  },
  updated: function updated() {
    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _node = __webpack_require__(255);

var _node2 = _interopRequireDefault(_node);

var _util = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeStore = function () {
  function TreeStore(options) {
    var _this = this;

    _classCallCheck(this, TreeStore);

    this.currentNode = null;
    this.currentNodeKey = null;

    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }

    this.nodesMap = {};

    this.root = new _node2.default({
      data: this.data,
      store: this
    });

    if (this.lazy && this.load) {
      var loadFn = this.load;
      loadFn(this.root, function (data) {
        _this.root.doCreateChildren(data);
        _this._initDefaultCheckedNodes();
      });
    } else {
      this._initDefaultCheckedNodes();
    }
  }

  TreeStore.prototype.filter = function filter(value) {
    var filterNodeMethod = this.filterNodeMethod;
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        child.visible = filterNodeMethod.call(child, value, child.data, child);

        traverse(child);
      });

      if (!node.visible && childNodes.length) {
        var allHidden = true;

        childNodes.forEach(function (child) {
          if (child.visible) allHidden = false;
        });

        if (node.root) {
          node.root.visible = allHidden === false;
        } else {
          node.visible = allHidden === false;
        }
      }
      if (!value) return;

      if (node.visible && !node.isLeaf) node.expand();
    };

    traverse(this);
  };

  TreeStore.prototype.setData = function setData(newVal) {
    var instanceChanged = newVal !== this.root.data;
    if (instanceChanged) {
      this.root.setData(newVal);
      this._initDefaultCheckedNodes();
    } else {
      this.root.updateChildren();
    }
  };

  TreeStore.prototype.getNode = function getNode(data) {
    if (data instanceof _node2.default) return data;
    var key = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' ? data : (0, _util.getNodeKey)(this.key, data);
    return this.nodesMap[key] || null;
  };

  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
    var refNode = this.getNode(refData);
    refNode.parent.insertBefore({ data: data }, refNode);
  };

  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
    var refNode = this.getNode(refData);
    refNode.parent.insertAfter({ data: data }, refNode);
  };

  TreeStore.prototype.remove = function remove(data) {
    var node = this.getNode(data);
    if (node) {
      node.parent.removeChild(node);
    }
  };

  TreeStore.prototype.append = function append(data, parentData) {
    var parentNode = parentData ? this.getNode(parentData) : this.root;

    if (parentNode) {
      parentNode.insertChild({ data: data });
    }
  };

  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
    var _this2 = this;

    var defaultCheckedKeys = this.defaultCheckedKeys || [];
    var nodesMap = this.nodesMap;

    defaultCheckedKeys.forEach(function (checkedKey) {
      var node = nodesMap[checkedKey];

      if (node) {
        node.setChecked(true, !_this2.checkStrictly);
      }
    });
  };

  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
    var defaultCheckedKeys = this.defaultCheckedKeys || [];

    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
      node.setChecked(true, !this.checkStrictly);
    }
  };

  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
    if (newVal !== this.defaultCheckedKeys) {
      this.defaultCheckedKeys = newVal;
      this._initDefaultCheckedNodes();
    }
  };

  TreeStore.prototype.registerNode = function registerNode(node) {
    var key = this.key;
    if (!key || !node || !node.data) return;

    var nodeKey = node.key;
    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
  };

  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
    var key = this.key;
    if (!key || !node || !node.data) return;

    var childNodes = node.childNodes;
    for (var i = 0, j = childNodes.length; i < j; i++) {
      var child = childNodes[i];
      this.deregisterNode(child);
    }

    delete this.nodesMap[node.key];
  };

  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var checkedNodes = [];
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        if (child.checked && (!leafOnly || leafOnly && child.isLeaf)) {
          checkedNodes.push(child.data);
        }

        traverse(child);
      });
    };

    traverse(this);

    return checkedNodes;
  };

  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
    var _this3 = this;

    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return this.getCheckedNodes(leafOnly).map(function (data) {
      return (data || {})[_this3.key];
    });
  };

  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
    var nodes = [];
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        if (child.indeterminate) {
          nodes.push(child.data);
        }

        traverse(child);
      });
    };

    traverse(this);

    return nodes;
  };

  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
    var _this4 = this;

    return this.getHalfCheckedNodes().map(function (data) {
      return (data || {})[_this4.key];
    });
  };

  TreeStore.prototype._getAllNodes = function _getAllNodes() {
    var allNodes = [];
    var nodesMap = this.nodesMap;
    for (var nodeKey in nodesMap) {
      if (nodesMap.hasOwnProperty(nodeKey)) {
        allNodes.push(nodesMap[nodeKey]);
      }
    }

    return allNodes;
  };

  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
    var node = this.nodesMap[key];
    if (!node) return;
    var childNodes = node.childNodes;
    for (var i = childNodes.length - 1; i >= 0; i--) {
      var child = childNodes[i];
      this.remove(child.data);
    }
    for (var _i = 0, j = data.length; _i < j; _i++) {
      var _child = data[_i];
      this.append(_child, node.data);
    }
  };

  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var checkedKeys = arguments[2];

    var allNodes = this._getAllNodes().sort(function (a, b) {
      return b.level - a.level;
    });
    var cache = Object.create(null);
    var keys = Object.keys(checkedKeys);
    allNodes.forEach(function (node) {
      return node.setChecked(false, false);
    });
    for (var i = 0, j = allNodes.length; i < j; i++) {
      var node = allNodes[i];
      var nodeKey = node.data[key].toString();
      var checked = keys.indexOf(nodeKey) > -1;
      if (!checked) {
        if (node.checked && !cache[nodeKey]) {
          node.setChecked(false, false);
        }
        continue;
      }

      var parent = node.parent;
      while (parent && parent.level > 0) {
        cache[parent.data[key]] = true;
        parent = parent.parent;
      }

      if (node.isLeaf || this.checkStrictly) {
        node.setChecked(true, false);
        continue;
      }
      node.setChecked(true, true);

      if (leafOnly) {
        (function () {
          node.setChecked(false, false);
          var traverse = function traverse(node) {
            var childNodes = node.childNodes;
            childNodes.forEach(function (child) {
              if (!child.isLeaf) {
                child.setChecked(false, false);
              }
              traverse(child);
            });
          };
          traverse(node);
        })();
      }
    }
  };

  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var key = this.key;
    var checkedKeys = {};
    array.forEach(function (item) {
      checkedKeys[(item || {})[key]] = true;
    });

    this._setCheckedKeys(key, leafOnly, checkedKeys);
  };

  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    this.defaultCheckedKeys = keys;
    var key = this.key;
    var checkedKeys = {};
    keys.forEach(function (key) {
      checkedKeys[key] = true;
    });

    this._setCheckedKeys(key, leafOnly, checkedKeys);
  };

  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
    var _this5 = this;

    keys = keys || [];
    this.defaultExpandedKeys = keys;

    keys.forEach(function (key) {
      var node = _this5.getNode(key);
      if (node) node.expand(null, _this5.autoExpandParent);
    });
  };

  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
    var node = this.getNode(data);

    if (node) {
      node.setChecked(!!checked, deep);
    }
  };

  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
    return this.currentNode;
  };

  TreeStore.prototype.setCurrentNode = function setCurrentNode(node) {
    this.currentNode = node;
  };

  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
    var key = node[this.key];
    var currNode = this.nodesMap[key];
    this.setCurrentNode(currNode);
  };

  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
    var node = this.getNode(key);
    if (node) {
      this.currentNode = node;
    }
  };

  return TreeStore;
}();

exports.default = TreeStore;
;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildState = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getChildState = exports.getChildState = function getChildState(node) {
  var all = true;
  var none = true;
  var allWithoutDisable = true;
  for (var i = 0, j = node.length; i < j; i++) {
    var n = node[i];
    if (n.checked !== true || n.indeterminate) {
      all = false;
      if (!n.disabled) {
        allWithoutDisable = false;
      }
    }
    if (n.checked !== false || n.indeterminate) {
      none = false;
    }
  }

  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
};

var reInitChecked = function reInitChecked(node) {
  if (node.childNodes.length === 0) return;

  var _getChildState = getChildState(node.childNodes),
      all = _getChildState.all,
      none = _getChildState.none,
      half = _getChildState.half;

  if (all) {
    node.checked = true;
    node.indeterminate = false;
  } else if (half) {
    node.checked = false;
    node.indeterminate = true;
  } else if (none) {
    node.checked = false;
    node.indeterminate = false;
  }

  var parent = node.parent;
  if (!parent || parent.level === 0) return;

  if (!node.store.checkStrictly) {
    reInitChecked(parent);
  }
};

var getPropertyFromData = function getPropertyFromData(node, prop) {
  var props = node.store.props;
  var data = node.data || {};
  var config = props[prop];

  if (typeof config === 'function') {
    return config(data, node);
  } else if (typeof config === 'string') {
    return data[config];
  } else if (typeof config === 'undefined') {
    var dataProp = data[prop];
    return dataProp === undefined ? '' : dataProp;
  }
};

var nodeIdSeed = 0;

var Node = function () {
  function Node(options) {
    _classCallCheck(this, Node);

    this.id = nodeIdSeed++;
    this.text = null;
    this.checked = false;
    this.indeterminate = false;
    this.data = null;
    this.expanded = false;
    this.parent = null;
    this.visible = true;

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    // internal
    this.level = 0;
    this.loaded = false;
    this.childNodes = [];
    this.loading = false;

    if (this.parent) {
      this.level = this.parent.level + 1;
    }

    var store = this.store;
    if (!store) {
      throw new Error('[Node]store is required!');
    }
    store.registerNode(this);

    var props = store.props;
    if (props && typeof props.isLeaf !== 'undefined') {
      var isLeaf = getPropertyFromData(this, 'isLeaf');
      if (typeof isLeaf === 'boolean') {
        this.isLeafByUser = isLeaf;
      }
    }

    if (store.lazy !== true && this.data) {
      this.setData(this.data);

      if (store.defaultExpandAll) {
        this.expanded = true;
      }
    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
      this.expand();
    }

    if (!this.data) return;
    var defaultExpandedKeys = store.defaultExpandedKeys;
    var key = store.key;
    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
      this.expand(null, store.autoExpandParent);
    }

    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
      store.currentNode = this;
    }

    if (store.lazy) {
      store._initDefaultCheckedNode(this);
    }

    this.updateLeafState();
  }

  Node.prototype.setData = function setData(data) {
    if (!Array.isArray(data)) {
      (0, _util.markNodeData)(this, data);
    }

    this.data = data;
    this.childNodes = [];

    var children = void 0;
    if (this.level === 0 && this.data instanceof Array) {
      children = this.data;
    } else {
      children = getPropertyFromData(this, 'children') || [];
    }

    for (var i = 0, j = children.length; i < j; i++) {
      this.insertChild({ data: children[i] });
    }
  };

  Node.prototype.contains = function contains(target) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var walk = function walk(parent) {
      var children = parent.childNodes || [];
      var result = false;
      for (var i = 0, j = children.length; i < j; i++) {
        var child = children[i];
        if (child === target || deep && walk(child)) {
          result = true;
          break;
        }
      }
      return result;
    };

    return walk(this);
  };

  Node.prototype.remove = function remove() {
    var parent = this.parent;
    if (parent) {
      parent.removeChild(this);
    }
  };

  Node.prototype.insertChild = function insertChild(child, index, batch) {
    if (!child) throw new Error('insertChild error: child is required.');

    if (!(child instanceof Node)) {
      if (!batch) {
        var children = this.getChildren(true);
        if (children.indexOf(child.data) === -1) {
          if (typeof index === 'undefined' || index < 0) {
            children.push(child.data);
          } else {
            children.splice(index, 0, child.data);
          }
        }
      }
      (0, _merge2.default)(child, {
        parent: this,
        store: this.store
      });
      child = new Node(child);
    }

    child.level = this.level + 1;

    if (typeof index === 'undefined' || index < 0) {
      this.childNodes.push(child);
    } else {
      this.childNodes.splice(index, 0, child);
    }

    this.updateLeafState();
  };

  Node.prototype.insertBefore = function insertBefore(child, ref) {
    var index = void 0;
    if (ref) {
      index = this.childNodes.indexOf(ref);
    }
    this.insertChild(child, index);
  };

  Node.prototype.insertAfter = function insertAfter(child, ref) {
    var index = void 0;
    if (ref) {
      index = this.childNodes.indexOf(ref);
      if (index !== -1) index += 1;
    }
    this.insertChild(child, index);
  };

  Node.prototype.removeChild = function removeChild(child) {
    var children = this.getChildren() || [];
    var dataIndex = children.indexOf(child.data);
    if (dataIndex > -1) {
      children.splice(dataIndex, 1);
    }

    var index = this.childNodes.indexOf(child);

    if (index > -1) {
      this.store && this.store.deregisterNode(child);
      child.parent = null;
      this.childNodes.splice(index, 1);
    }

    this.updateLeafState();
  };

  Node.prototype.removeChildByData = function removeChildByData(data) {
    var targetNode = null;
    this.childNodes.forEach(function (node) {
      if (node.data === data) {
        targetNode = node;
      }
    });

    if (targetNode) {
      this.removeChild(targetNode);
    }
  };

  Node.prototype.expand = function expand(callback, expandParent) {
    var _this = this;

    var done = function done() {
      if (expandParent) {
        var parent = _this.parent;
        while (parent.level > 0) {
          parent.expanded = true;
          parent = parent.parent;
        }
      }
      _this.expanded = true;
      if (callback) callback();
    };

    if (this.shouldLoadData()) {
      this.loadData(function (data) {
        if (data instanceof Array) {
          if (_this.checked) {
            _this.setChecked(true, true);
          } else {
            reInitChecked(_this);
          }
          done();
        }
      });
    } else {
      done();
    }
  };

  Node.prototype.doCreateChildren = function doCreateChildren(array) {
    var _this2 = this;

    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    array.forEach(function (item) {
      _this2.insertChild((0, _merge2.default)({ data: item }, defaultProps), undefined, true);
    });
  };

  Node.prototype.collapse = function collapse() {
    this.expanded = false;
  };

  Node.prototype.shouldLoadData = function shouldLoadData() {
    return this.store.lazy === true && this.store.load && !this.loaded;
  };

  Node.prototype.updateLeafState = function updateLeafState() {
    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
      this.isLeaf = this.isLeafByUser;
      return;
    }
    var childNodes = this.childNodes;
    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
      this.isLeaf = !childNodes || childNodes.length === 0;
      return;
    }
    this.isLeaf = false;
  };

  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
    var _this3 = this;

    this.indeterminate = value === 'half';
    this.checked = value === true;

    if (this.store.checkStrictly) return;

    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
      var _ret = function () {
        var _getChildState2 = getChildState(_this3.childNodes),
            all = _getChildState2.all,
            allWithoutDisable = _getChildState2.allWithoutDisable;

        if (!_this3.isLeaf && !all && allWithoutDisable) {
          _this3.checked = false;
          value = false;
        }

        var handleDescendants = function handleDescendants() {
          if (deep) {
            var childNodes = _this3.childNodes;
            for (var i = 0, j = childNodes.length; i < j; i++) {
              var child = childNodes[i];
              passValue = passValue || value !== false;
              var isCheck = child.disabled ? child.checked : passValue;
              child.setChecked(isCheck, deep, true, passValue);
            }

            var _getChildState3 = getChildState(childNodes),
                half = _getChildState3.half,
                _all = _getChildState3.all;

            if (!_all) {
              _this3.checked = _all;
              _this3.indeterminate = half;
            }
          }
        };

        if (_this3.shouldLoadData()) {
          // Only work on lazy load data.
          _this3.loadData(function () {
            handleDescendants();
            reInitChecked(_this3);
          }, {
            checked: value !== false
          });
          return {
            v: void 0
          };
        } else {
          handleDescendants();
        }
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }

    var parent = this.parent;
    if (!parent || parent.level === 0) return;

    if (!recursion) {
      reInitChecked(parent);
    }
  };

  Node.prototype.getChildren = function getChildren() {
    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // this is data
    if (this.level === 0) return this.data;
    var data = this.data;
    if (!data) return null;

    var props = this.store.props;
    var children = 'children';
    if (props) {
      children = props.children || 'children';
    }

    if (data[children] === undefined) {
      data[children] = null;
    }

    if (forceInit && !data[children]) {
      data[children] = [];
    }

    return data[children];
  };

  Node.prototype.updateChildren = function updateChildren() {
    var _this4 = this;

    var newData = this.getChildren() || [];
    var oldData = this.childNodes.map(function (node) {
      return node.data;
    });

    var newDataMap = {};
    var newNodes = [];

    newData.forEach(function (item, index) {
      if (item[_util.NODE_KEY]) {
        newDataMap[item[_util.NODE_KEY]] = { index: index, data: item };
      } else {
        newNodes.push({ index: index, data: item });
      }
    });

    oldData.forEach(function (item) {
      if (!newDataMap[item[_util.NODE_KEY]]) _this4.removeChildByData(item);
    });

    newNodes.forEach(function (_ref) {
      var index = _ref.index,
          data = _ref.data;

      _this4.insertChild({ data: data }, index);
    });

    this.updateLeafState();
  };

  Node.prototype.loadData = function loadData(callback) {
    var _this5 = this;

    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
      this.loading = true;

      var resolve = function resolve(children) {
        _this5.loaded = true;
        _this5.loading = false;
        _this5.childNodes = [];

        _this5.doCreateChildren(children, defaultProps);

        _this5.updateLeafState();
        if (callback) {
          callback.call(_this5, children);
        }
      };

      this.store.load(this, resolve);
    } else {
      if (callback) {
        callback.call(this);
      }
    }
  };

  _createClass(Node, [{
    key: 'label',
    get: function get() {
      return getPropertyFromData(this, 'label');
    }
  }, {
    key: 'icon',
    get: function get() {
      return getPropertyFromData(this, 'icon');
    }
  }, {
    key: 'key',
    get: function get() {
      var nodeKey = this.store.key;
      if (this.data) return this.data[nodeKey];
      return null;
    }
  }, {
    key: 'disabled',
    get: function get() {
      return getPropertyFromData(this, 'disabled');
    }
  }, {
    key: 'nextSibling',
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var index = parent.childNodes.indexOf(this);
        if (index > -1) {
          return parent.childNodes[index + 1];
        }
      }
      return null;
    }
  }, {
    key: 'previousSibling',
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var index = parent.childNodes.indexOf(this);
        if (index > -1) {
          return index > 0 ? parent.childNodes[index - 1] : null;
        }
      }
      return null;
    }
  }]);

  return Node;
}();

exports.default = Node;

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_node_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_node_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_node_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751ff8ec_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_node_vue__ = __webpack_require__(258);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tree_node_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751ff8ec_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tree_node_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _collapseTransition = __webpack_require__(20);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTreeNode',

  componentName: 'ElTreeNode',

  mixins: [_emitter2.default],

  props: {
    node: {
      default: function _default() {
        return {};
      }
    },
    props: {},
    renderContent: Function,
    renderAfterExpand: {
      type: Boolean,
      default: true
    }
  },

  components: {
    ElCollapseTransition: _collapseTransition2.default,
    ElCheckbox: _checkbox2.default,
    NodeContent: {
      props: {
        node: {
          required: true
        }
      },
      render: function render(h) {
        var parent = this.$parent;
        var tree = parent.tree;
        var node = this.node;
        var data = node.data,
            store = node.store;

        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
          'span',
          { 'class': 'el-tree-node__label' },
          [node.label]
        );
      }
    }
  },

  data: function data() {
    return {
      tree: null,
      expanded: false,
      childNodeRendered: false,
      showCheckbox: false,
      oldChecked: null,
      oldIndeterminate: null
    };
  },


  watch: {
    'node.indeterminate': function nodeIndeterminate(val) {
      this.handleSelectChange(this.node.checked, val);
    },
    'node.checked': function nodeChecked(val) {
      this.handleSelectChange(val, this.node.indeterminate);
    },
    'node.expanded': function nodeExpanded(val) {
      var _this = this;

      this.$nextTick(function () {
        return _this.expanded = val;
      });
      if (val) {
        this.childNodeRendered = true;
      }
    }
  },

  methods: {
    getNodeKey: function getNodeKey(node) {
      return (0, _util.getNodeKey)(this.tree.nodeKey, node.data);
    },
    handleSelectChange: function handleSelectChange(checked, indeterminate) {
      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
      }
      this.oldChecked = checked;
      this.indeterminate = indeterminate;
    },
    handleClick: function handleClick() {
      var store = this.tree.store;
      store.setCurrentNode(this.node);
      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
      this.tree.currentNode = this;
      if (this.tree.expandOnClickNode) {
        this.handleExpandIconClick();
      }
      this.tree.$emit('node-click', this.node.data, this.node, this);
    },
    handleContextMenu: function handleContextMenu(event) {
      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
    },
    handleExpandIconClick: function handleExpandIconClick() {
      if (this.node.isLeaf) return;
      if (this.expanded) {
        this.tree.$emit('node-collapse', this.node.data, this.node, this);
        this.node.collapse();
      } else {
        this.node.expand();
        this.$emit('node-expand', this.node.data, this.node, this);
      }
    },
    handleCheckChange: function handleCheckChange(value, ev) {
      var _this2 = this;

      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
      this.$nextTick(function () {
        var store = _this2.tree.store;
        _this2.tree.$emit('check', _this2.node.data, {
          checkedNodes: store.getCheckedNodes(),
          checkedKeys: store.getCheckedKeys(),
          halfCheckedNodes: store.getHalfCheckedNodes(),
          halfCheckedKeys: store.getHalfCheckedKeys()
        });
      });
    },
    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.tree.$emit('node-expand', nodeData, node, instance);
    },
    handleDragStart: function handleDragStart(event) {
      this.tree.$emit('tree-node-drag-start', event, this);
    },
    handleDragOver: function handleDragOver(event) {
      this.tree.$emit('tree-node-drag-over', event, this);
      event.preventDefault();
    },
    handleDrop: function handleDrop(event) {
      event.preventDefault();
    },
    handleDragEnd: function handleDragEnd(event) {
      this.tree.$emit('tree-node-drag-end', event, this);
    }
  },

  created: function created() {
    var _this3 = this;

    var parent = this.$parent;

    if (parent.isTree) {
      this.tree = parent;
    } else {
      this.tree = parent.tree;
    }

    var tree = this.tree;
    if (!tree) {
      console.warn('Can not find node\'s tree.');
    }

    var props = tree.props || {};
    var childrenKey = props['children'] || 'children';

    this.$watch('node.data.' + childrenKey, function () {
      _this3.node.updateChildren();
    });

    this.showCheckbox = tree.showCheckbox;

    if (this.node.expanded) {
      this.expanded = true;
      this.childNodeRendered = true;
    }

    if (this.tree.accordion) {
      this.$on('tree-node-expand', function (node) {
        if (_this3.node !== node) {
          _this3.node.collapse();
        }
      });
    }
  }
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.node.visible),expression:"node.visible"}],ref:"node",staticClass:"el-tree-node",class:{
    'is-expanded': _vm.expanded,
    'is-current': _vm.tree.store.currentNode === _vm.node,
    'is-hidden': !_vm.node.visible,
    'is-focusable': !_vm.node.disabled,
    'is-checked': !_vm.node.disabled && _vm.node.checked
  },attrs:{"role":"treeitem","tabindex":"-1","aria-expanded":_vm.expanded,"aria-disabled":_vm.node.disabled,"aria-checked":_vm.node.checked,"draggable":_vm.tree.draggable},on:{"click":function($event){$event.stopPropagation();_vm.handleClick($event)},"contextmenu":function ($event) { return this$1.handleContextMenu($event); },"dragstart":function($event){$event.stopPropagation();_vm.handleDragStart($event)},"dragover":function($event){$event.stopPropagation();_vm.handleDragOver($event)},"dragend":function($event){$event.stopPropagation();_vm.handleDragEnd($event)},"drop":function($event){$event.stopPropagation();_vm.handleDrop($event)}}},[_c('div',{staticClass:"el-tree-node__content",style:({ 'padding-left': (_vm.node.level - 1) * _vm.tree.indent + 'px' })},[_c('span',{staticClass:"el-tree-node__expand-icon el-icon-caret-right",class:{ 'is-leaf': _vm.node.isLeaf, expanded: !_vm.node.isLeaf && _vm.expanded },on:{"click":function($event){$event.stopPropagation();_vm.handleExpandIconClick($event)}}}),(_vm.showCheckbox)?_c('el-checkbox',{attrs:{"indeterminate":_vm.node.indeterminate,"disabled":!!_vm.node.disabled},on:{"change":_vm.handleCheckChange},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.node.checked),callback:function ($$v) {_vm.$set(_vm.node, "checked", $$v)},expression:"node.checked"}}):_vm._e(),(_vm.node.loading)?_c('span',{staticClass:"el-tree-node__loading-icon el-icon-loading"}):_vm._e(),_c('node-content',{attrs:{"node":_vm.node}})],1),_c('el-collapse-transition',[(!_vm.renderAfterExpand || _vm.childNodeRendered)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}],staticClass:"el-tree-node__children",attrs:{"role":"group","aria-expanded":_vm.expanded}},_vm._l((_vm.node.childNodes),function(child){return _c('el-tree-node',{key:_vm.getNodeKey(child),attrs:{"render-content":_vm.renderContent,"render-after-expand":_vm.renderAfterExpand,"node":child},on:{"node-expand":_vm.handleChildNodeExpand}})})):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-tree",class:{
    'el-tree--highlight-current': _vm.highlightCurrent,
    'is-dragging': !!_vm.dragState.draggingNode,
    'is-drop-not-allow': !_vm.dragState.allowDrop,
    'is-drop-inner': _vm.dragState.dropType === 'inner'
  },attrs:{"role":"tree"}},[_vm._l((_vm.root.childNodes),function(child){return _c('el-tree-node',{key:_vm.getNodeKey(child),attrs:{"node":child,"props":_vm.props,"render-after-expand":_vm.renderAfterExpand,"render-content":_vm.renderContent},on:{"node-expand":_vm.handleNodeExpand}})}),(!_vm.root.childNodes || _vm.root.childNodes.length === 0)?_c('div',{staticClass:"el-tree__empty-block"},[_c('span',{staticClass:"el-tree__empty-text"},[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dragState.showDropIndicator),expression:"dragState.showDropIndicator"}],ref:"dropIndicator",staticClass:"el-tree__drop-indicator"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(261);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b140a8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94b140a8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TYPE_CLASSES_MAP = {
  'success': 'el-icon-success',
  'warning': 'el-icon-warning',
  'error': 'el-icon-error'
};
exports.default = {
  name: 'ElAlert',

  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeText: {
      type: String,
      default: ''
    },
    showIcon: Boolean,
    center: Boolean
  },

  data: function data() {
    return {
      visible: true
    };
  },


  methods: {
    close: function close() {
      this.visible = false;
      this.$emit('close');
    }
  },

  computed: {
    typeClass: function typeClass() {
      return 'el-alert--' + this.type;
    },
    iconClass: function iconClass() {
      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
    },
    isBigIcon: function isBigIcon() {
      return this.description || this.$slots.default ? 'is-big' : '';
    },
    isBoldTitle: function isBoldTitle() {
      return this.description || this.$slots.default ? 'is-bold' : '';
    }
  }
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-alert-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-alert",class:[_vm.typeClass, _vm.center ? 'is-center' : ''],attrs:{"role":"alert"}},[(_vm.showIcon)?_c('i',{staticClass:"el-alert__icon",class:[ _vm.iconClass, _vm.isBigIcon ]}):_vm._e(),_c('div',{staticClass:"el-alert__content"},[(_vm.title)?_c('span',{staticClass:"el-alert__title",class:[ _vm.isBoldTitle ]},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default",[(_vm.description)?_c('p',{staticClass:"el-alert__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.closable),expression:"closable"}],staticClass:"el-alert__closebtn",class:{ 'is-customed': _vm.closeText !== '', 'el-icon-close': _vm.closeText === '' },on:{"click":function($event){_vm.close()}}},[_vm._v(_vm._s(_vm.closeText))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(265);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _main2.default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _main = __webpack_require__(266);

var _main2 = _interopRequireDefault(_main);

var _popup = __webpack_require__(12);

var _vdom = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationConstructor = _vue2.default.extend(_main2.default);

var instance = void 0;
var instances = [];
var seed = 1;

var Notification = function Notification(options) {
  if (_vue2.default.prototype.$isServer) return;
  options = options || {};
  var userOnClose = options.onClose;
  var id = 'notification_' + seed++;
  var position = options.position || 'top-right';

  options.onClose = function () {
    Notification.close(id, userOnClose);
  };

  instance = new NotificationConstructor({
    data: options
  });

  if ((0, _vdom.isVNode)(options.message)) {
    instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = _popup.PopupManager.nextZIndex();

  var verticalOffset = options.offset || 0;
  instances.filter(function (item) {
    return item.position === position;
  }).forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;
  instances.push(instance);
  return instance.vm;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  Notification[type] = function (options) {
    if (typeof options === 'string' || (0, _vdom.isVNode)(options)) {
      options = {
        message: options
      };
    }
    options.type = type;
    return Notification(options);
  };
});

Notification.close = function (id, userOnClose) {
  var index = -1;
  var len = instances.length;
  var instance = instances.filter(function (instance, i) {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  var position = instance.position;
  var removedHeight = instance.dom.offsetHeight;
  for (var i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
    }
  }
};

Notification.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

exports.default = Notification;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1951fd63_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(268);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1951fd63_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

exports.default = {
  data: function data() {
    return {
      visible: false,
      title: '',
      message: '',
      duration: 4500,
      type: '',
      showClose: true,
      customClass: '',
      iconClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      timer: null,
      dangerouslyUseHTMLString: false,
      position: 'top-right'
    };
  },


  computed: {
    typeClass: function typeClass() {
      return this.type && typeMap[this.type] ? 'el-icon-' + typeMap[this.type] : '';
    },
    horizontalClass: function horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },
    verticalProperty: function verticalProperty() {
      return (/^top-/.test(this.position) ? 'top' : 'bottom'
      );
    },
    positionStyle: function positionStyle() {
      var _ref;

      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },

  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    click: function click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 46 || e.keyCode === 8) {
        this.clearTimer(); // detele 取消倒计时
      } else if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      } else {
        this.startTimer(); // 恢复倒计时
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        if (!_this2.closed) {
          _this2.close();
        }
      }, this.duration);
    }
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-notification-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:['el-notification', _vm.customClass, _vm.horizontalClass],style:(_vm.positionStyle),attrs:{"role":"alert"},on:{"mouseenter":function($event){_vm.clearTimer()},"mouseleave":function($event){_vm.startTimer()},"click":_vm.click}},[(_vm.type || _vm.iconClass)?_c('i',{staticClass:"el-notification__icon",class:[ _vm.typeClass, _vm.iconClass ]}):_vm._e(),_c('div',{staticClass:"el-notification__group",class:{ 'is-with-icon': _vm.typeClass || _vm.iconClass }},[_c('h2',{staticClass:"el-notification__title",domProps:{"textContent":_vm._s(_vm.title)}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}],staticClass:"el-notification__content"},[_vm._t("default",[(!_vm.dangerouslyUseHTMLString)?_c('p',[_vm._v(_vm._s(_vm.message))]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],2),(_vm.showClose)?_c('div',{staticClass:"el-notification__closeBtn el-icon-close",on:{"click":function($event){$event.stopPropagation();_vm.close($event)}}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(270);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0df926_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0df926_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _inputNumber = __webpack_require__(272);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _button = __webpack_require__(273);

var _button2 = _interopRequireDefault(_button);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSlider',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    }
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, Array],
      default: 0
    },
    showInput: {
      type: Boolean,
      default: false
    },
    showInputControls: {
      type: Boolean,
      default: true
    },
    inputSize: {
      type: String,
      default: 'small'
    },
    showStops: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    formatTooltip: Function,
    disabled: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    height: {
      type: String
    },
    debounce: {
      type: Number,
      default: 300
    },
    label: {
      type: String
    },
    tooltipClass: String
  },

  components: {
    ElInputNumber: _inputNumber2.default,
    SliderButton: _button2.default
  },

  data: function data() {
    return {
      firstValue: null,
      secondValue: null,
      oldValue: null,
      dragging: false,
      sliderSize: 1
    };
  },


  watch: {
    value: function value(val, oldVal) {
      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
        return item === oldVal[index];
      })) {
        return;
      }
      this.setValues();
    },
    dragging: function dragging(val) {
      if (!val) {
        this.setValues();
      }
    },
    firstValue: function firstValue(val) {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      } else {
        this.$emit('input', val);
      }
    },
    secondValue: function secondValue() {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      }
    },
    min: function min() {
      this.setValues();
    },
    max: function max() {
      this.setValues();
    }
  },

  methods: {
    valueChanged: function valueChanged() {
      var _this = this;

      if (this.range) {
        return ![this.minValue, this.maxValue].every(function (item, index) {
          return item === _this.oldValue[index];
        });
      } else {
        return this.value !== this.oldValue;
      }
    },
    setValues: function setValues() {
      if (this.min > this.max) {
        console.error('[Element Error][Slider]min should not be greater than max.');
        return;
      }
      var val = this.value;
      if (this.range && Array.isArray(val)) {
        if (val[1] < this.min) {
          this.$emit('input', [this.min, this.min]);
        } else if (val[0] > this.max) {
          this.$emit('input', [this.max, this.max]);
        } else if (val[0] < this.min) {
          this.$emit('input', [this.min, val[1]]);
        } else if (val[1] > this.max) {
          this.$emit('input', [val[0], this.max]);
        } else {
          this.firstValue = val[0];
          this.secondValue = val[1];
          if (this.valueChanged()) {
            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
            this.oldValue = val.slice();
          }
        }
      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
        if (val < this.min) {
          this.$emit('input', this.min);
        } else if (val > this.max) {
          this.$emit('input', this.max);
        } else {
          this.firstValue = val;
          if (this.valueChanged()) {
            this.dispatch('ElFormItem', 'el.form.change', val);
            this.oldValue = val;
          }
        }
      }
    },
    setPosition: function setPosition(percent) {
      var targetValue = this.min + percent * (this.max - this.min) / 100;
      if (!this.range) {
        this.$refs.button1.setPosition(percent);
        return;
      }
      var button = void 0;
      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
      } else {
        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
      }
      this.$refs[button].setPosition(percent);
    },
    onSliderClick: function onSliderClick(event) {
      if (this.sliderDisabled || this.dragging) return;
      this.resetSize();
      if (this.vertical) {
        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
      } else {
        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
      }
      this.emitChange();
    },
    resetSize: function resetSize() {
      if (this.$refs.slider) {
        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
      }
    },
    emitChange: function emitChange() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
      });
    }
  },

  computed: {
    stops: function stops() {
      var _this3 = this;

      if (!this.showStops || this.min > this.max) return [];
      if (this.step === 0) {
        "production" !== 'production' && console.warn('[Element Warn][Slider]step should not be 0.');
        return [];
      }
      var stopCount = (this.max - this.min) / this.step;
      var stepWidth = 100 * this.step / (this.max - this.min);
      var result = [];
      for (var i = 1; i < stopCount; i++) {
        result.push(i * stepWidth);
      }
      if (this.range) {
        return result.filter(function (step) {
          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
        });
      } else {
        return result.filter(function (step) {
          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
        });
      }
    },
    minValue: function minValue() {
      return Math.min(this.firstValue, this.secondValue);
    },
    maxValue: function maxValue() {
      return Math.max(this.firstValue, this.secondValue);
    },
    barSize: function barSize() {
      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
    },
    barStart: function barStart() {
      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
    },
    precision: function precision() {
      var precisions = [this.min, this.max, this.step].map(function (item) {
        var decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(null, precisions);
    },
    runwayStyle: function runwayStyle() {
      return this.vertical ? { height: this.height } : {};
    },
    barStyle: function barStyle() {
      return this.vertical ? {
        height: this.barSize,
        bottom: this.barStart
      } : {
        width: this.barSize,
        left: this.barStart
      };
    },
    sliderDisabled: function sliderDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  mounted: function mounted() {
    var valuetext = void 0;
    if (this.range) {
      if (Array.isArray(this.value)) {
        this.firstValue = Math.max(this.min, this.value[0]);
        this.secondValue = Math.min(this.max, this.value[1]);
      } else {
        this.firstValue = this.min;
        this.secondValue = this.max;
      }
      this.oldValue = [this.firstValue, this.secondValue];
      valuetext = this.firstValue + '-' + this.secondValue;
    } else {
      if (typeof this.value !== 'number' || isNaN(this.value)) {
        this.firstValue = this.min;
      } else {
        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
      }
      this.oldValue = this.firstValue;
      valuetext = this.firstValue;
    }
    this.$el.setAttribute('aria-valuetext', valuetext);

    // label screen reader
    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);

    this.resetSize();
    window.addEventListener('resize', this.resetSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resetSize);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(308);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28634966_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(275);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28634966_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tooltip = __webpack_require__(23);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSliderButton',

  components: {
    ElTooltip: _tooltip2.default
  },

  props: {
    value: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    tooltipClass: String
  },

  data: function data() {
    return {
      hovering: false,
      dragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },


  computed: {
    disabled: function disabled() {
      return this.$parent.sliderDisabled;
    },
    max: function max() {
      return this.$parent.max;
    },
    min: function min() {
      return this.$parent.min;
    },
    step: function step() {
      return this.$parent.step;
    },
    showTooltip: function showTooltip() {
      return this.$parent.showTooltip;
    },
    precision: function precision() {
      return this.$parent.precision;
    },
    currentPosition: function currentPosition() {
      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
    },
    enableFormat: function enableFormat() {
      return this.$parent.formatTooltip instanceof Function;
    },
    formatValue: function formatValue() {
      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
    },
    wrapperStyle: function wrapperStyle() {
      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
    }
  },

  watch: {
    dragging: function dragging(val) {
      this.$parent.dragging = val;
    }
  },

  methods: {
    displayTooltip: function displayTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
    },
    hideTooltip: function hideTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
    },
    handleMouseEnter: function handleMouseEnter() {
      this.hovering = true;
      this.displayTooltip();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hovering = false;
      this.hideTooltip();
    },
    onButtonDown: function onButtonDown(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging);
      window.addEventListener('touchmove', this.onDragging);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('touchend', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    onLeftKeyDown: function onLeftKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
    },
    onRightKeyDown: function onRightKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
    },
    onDragStart: function onDragStart(event) {
      this.dragging = true;
      this.isClick = true;
      if (event.type === 'touchstart') {
        event.clientY = event.touches[0].clientY;
        event.clientX = event.touches[0].clientX;
      }
      if (this.vertical) {
        this.startY = event.clientY;
      } else {
        this.startX = event.clientX;
      }
      this.startPosition = parseFloat(this.currentPosition);
      this.newPosition = this.startPosition;
    },
    onDragging: function onDragging(event) {
      if (this.dragging) {
        this.isClick = false;
        this.displayTooltip();
        this.$parent.resetSize();
        var diff = 0;
        if (event.type === 'touchmove') {
          event.clientY = event.touches[0].clientY;
          event.clientX = event.touches[0].clientX;
        }
        if (this.vertical) {
          this.currentY = event.clientY;
          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
        } else {
          this.currentX = event.clientX;
          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
        }
        this.newPosition = this.startPosition + diff;
        this.setPosition(this.newPosition);
      }
    },
    onDragEnd: function onDragEnd() {
      var _this = this;

      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(function () {
          _this.dragging = false;
          _this.hideTooltip();
          if (!_this.isClick) {
            _this.setPosition(_this.newPosition);
            _this.$parent.emitChange();
          }
        }, 0);
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('touchmove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    setPosition: function setPosition(newPosition) {
      var _this2 = this;

      if (newPosition === null) return;
      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > 100) {
        newPosition = 100;
      }
      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
      var steps = Math.round(newPosition / lengthPerStep);
      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.$emit('input', value);
      this.$nextTick(function () {
        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
      });
      if (!this.dragging && this.value !== this.oldValue) {
        this.oldValue = this.value;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button",staticClass:"el-slider__button-wrapper",class:{ 'hover': _vm.hovering, 'dragging': _vm.dragging },style:(_vm.wrapperStyle),attrs:{"tabindex":"0"},on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"mousedown":_vm.onButtonDown,"touchstart":_vm.onButtonDown,"focus":_vm.handleMouseEnter,"blur":_vm.handleMouseLeave,"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.onLeftKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.onRightKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.onLeftKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.onRightKeyDown($event)}]}},[_c('el-tooltip',{ref:"tooltip",attrs:{"placement":"top","popper-class":_vm.tooltipClass,"disabled":!_vm.showTooltip}},[_c('span',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.formatValue))]),_c('div',{staticClass:"el-slider__button",class:{ 'hover': _vm.hovering, 'dragging': _vm.dragging }})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-slider",class:{ 'is-vertical': _vm.vertical, 'el-slider--with-input': _vm.showInput },attrs:{"role":"slider","aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-orientation":_vm.vertical ? 'vertical': 'horizontal',"aria-disabled":_vm.sliderDisabled}},[(_vm.showInput && !_vm.range)?_c('el-input-number',{ref:"input",staticClass:"el-slider__input",attrs:{"step":_vm.step,"disabled":_vm.sliderDisabled,"controls":_vm.showInputControls,"min":_vm.min,"max":_vm.max,"debounce":_vm.debounce,"size":_vm.inputSize},on:{"change":function($event){_vm.$nextTick(_vm.emitChange)}},model:{value:(_vm.firstValue),callback:function ($$v) {_vm.firstValue=$$v},expression:"firstValue"}}):_vm._e(),_c('div',{ref:"slider",staticClass:"el-slider__runway",class:{ 'show-input': _vm.showInput, 'disabled': _vm.sliderDisabled },style:(_vm.runwayStyle),on:{"click":_vm.onSliderClick}},[_c('div',{staticClass:"el-slider__bar",style:(_vm.barStyle)}),_c('slider-button',{ref:"button1",attrs:{"vertical":_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:(_vm.firstValue),callback:function ($$v) {_vm.firstValue=$$v},expression:"firstValue"}}),(_vm.range)?_c('slider-button',{ref:"button2",attrs:{"vertical":_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:(_vm.secondValue),callback:function ($$v) {_vm.secondValue=$$v},expression:"secondValue"}}):_vm._e(),_vm._l((_vm.stops),function(item){return (_vm.showStops)?_c('div',{staticClass:"el-slider__stop",style:(_vm.vertical ? { 'bottom': item + '%' } : { 'left': item + '%' })}):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _directive = __webpack_require__(278);

var _directive2 = _interopRequireDefault(_directive);

var _index = __webpack_require__(281);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    Vue.use(_directive2.default);
    Vue.prototype.$loading = _index2.default;
  },

  directive: _directive2.default,
  service: _index2.default
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _loading = __webpack_require__(40);

var _loading2 = _interopRequireDefault(_loading);

var _dom = __webpack_require__(3);

var _popup = __webpack_require__(12);

var _afterLeave = __webpack_require__(41);

var _afterLeave2 = _interopRequireDefault(_afterLeave);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mask = _vue2.default.extend(_loading2.default);

var loadingDirective = {};
loadingDirective.install = function (Vue) {
  if (Vue.prototype.$isServer) return;
  var toggleLoading = function toggleLoading(el, binding) {
    if (binding.value) {
      Vue.nextTick(function () {
        if (binding.modifiers.fullscreen) {
          el.originalPosition = (0, _dom.getStyle)(document.body, 'position');
          el.originalOverflow = (0, _dom.getStyle)(document.body, 'overflow');
          el.maskStyle.zIndex = _popup.PopupManager.nextZIndex();

          (0, _dom.addClass)(el.mask, 'is-fullscreen');
          insertDom(document.body, el, binding);
        } else {
          (0, _dom.removeClass)(el.mask, 'is-fullscreen');

          if (binding.modifiers.body) {
            el.originalPosition = (0, _dom.getStyle)(document.body, 'position');

            ['top', 'left'].forEach(function (property) {
              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt((0, _dom.getStyle)(document.body, 'margin-' + property), 10) + 'px';
            });
            ['height', 'width'].forEach(function (property) {
              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
            });

            insertDom(document.body, el, binding);
          } else {
            el.originalPosition = (0, _dom.getStyle)(el, 'position');
            insertDom(el, el, binding);
          }
        }
      });
    } else {
      (0, _afterLeave2.default)(el.instance, function (_) {
        el.domVisible = false;
        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
        (0, _dom.removeClass)(target, 'el-loading-parent--relative');
        (0, _dom.removeClass)(target, 'el-loading-parent--hidden');
        el.instance.hiding = false;
      }, 300, true);
      el.instance.visible = false;
      el.instance.hiding = true;
    }
  };
  var insertDom = function insertDom(parent, el, binding) {
    if (!el.domVisible && (0, _dom.getStyle)(el, 'display') !== 'none' && (0, _dom.getStyle)(el, 'visibility') !== 'hidden') {
      Object.keys(el.maskStyle).forEach(function (property) {
        el.mask.style[property] = el.maskStyle[property];
      });

      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        (0, _dom.addClass)(parent, 'el-loading-parent--relative');
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        (0, _dom.addClass)(parent, 'el-loading-parent--hidden');
      }
      el.domVisible = true;

      parent.appendChild(el.mask);
      Vue.nextTick(function () {
        if (el.instance.hiding) {
          el.instance.$emit('after-leave');
        } else {
          el.instance.visible = true;
        }
      });
      el.domInserted = true;
    }
  };

  Vue.directive('loading', {
    bind: function bind(el, binding, vnode) {
      var textExr = el.getAttribute('element-loading-text');
      var spinnerExr = el.getAttribute('element-loading-spinner');
      var backgroundExr = el.getAttribute('element-loading-background');
      var customClassExr = el.getAttribute('element-loading-custom-class');
      var vm = vnode.context;
      var mask = new Mask({
        el: document.createElement('div'),
        data: {
          text: vm && vm[textExr] || textExr,
          spinner: vm && vm[spinnerExr] || spinnerExr,
          background: vm && vm[backgroundExr] || backgroundExr,
          customClass: vm && vm[customClassExr] || customClassExr,
          fullscreen: !!binding.modifiers.fullscreen
        }
      });
      el.instance = mask;
      el.mask = mask.$el;
      el.maskStyle = {};

      binding.value && toggleLoading(el, binding);
    },

    update: function update(el, binding) {
      el.instance.setText(el.getAttribute('element-loading-text'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },

    unbind: function unbind(el, binding) {
      if (el.domInserted) {
        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
    }
  });
};

exports.default = loadingDirective;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },


  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-loading-mask",class:[_vm.customClass, { 'is-fullscreen': _vm.fullscreen }],style:({ backgroundColor: _vm.background || '' })},[_c('div',{staticClass:"el-loading-spinner"},[(!_vm.spinner)?_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})]):_c('i',{class:_vm.spinner}),(_vm.text)?_c('p',{staticClass:"el-loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _loading = __webpack_require__(40);

var _loading2 = _interopRequireDefault(_loading);

var _dom = __webpack_require__(3);

var _popup = __webpack_require__(12);

var _afterLeave = __webpack_require__(41);

var _afterLeave2 = _interopRequireDefault(_afterLeave);

var _merge = __webpack_require__(10);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingConstructor = _vue2.default.extend(_loading2.default);

var defaults = {
  text: null,
  fullscreen: true,
  body: false,
  lock: false,
  customClass: ''
};

var fullscreenLoading = void 0;

LoadingConstructor.prototype.originalPosition = '';
LoadingConstructor.prototype.originalOverflow = '';

LoadingConstructor.prototype.close = function () {
  var _this = this;

  if (this.fullscreen) {
    fullscreenLoading = undefined;
  }
  (0, _afterLeave2.default)(this, function (_) {
    var target = _this.fullscreen || _this.body ? document.body : _this.target;
    (0, _dom.removeClass)(target, 'el-loading-parent--relative');
    (0, _dom.removeClass)(target, 'el-loading-parent--hidden');
    if (_this.$el && _this.$el.parentNode) {
      _this.$el.parentNode.removeChild(_this.$el);
    }
    _this.$destroy();
  }, 300);
  this.visible = false;
};

var addStyle = function addStyle(options, parent, instance) {
  var maskStyle = {};
  if (options.fullscreen) {
    instance.originalPosition = (0, _dom.getStyle)(document.body, 'position');
    instance.originalOverflow = (0, _dom.getStyle)(document.body, 'overflow');
    maskStyle.zIndex = _popup.PopupManager.nextZIndex();
  } else if (options.body) {
    instance.originalPosition = (0, _dom.getStyle)(document.body, 'position');
    ['top', 'left'].forEach(function (property) {
      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
    });
    ['height', 'width'].forEach(function (property) {
      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
    });
  } else {
    instance.originalPosition = (0, _dom.getStyle)(parent, 'position');
  }
  Object.keys(maskStyle).forEach(function (property) {
    instance.$el.style[property] = maskStyle[property];
  });
};

var Loading = function Loading() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (_vue2.default.prototype.$isServer) return;
  options = (0, _merge2.default)({}, defaults, options);
  if (typeof options.target === 'string') {
    options.target = document.querySelector(options.target);
  }
  options.target = options.target || document.body;
  if (options.target !== document.body) {
    options.fullscreen = false;
  } else {
    options.body = true;
  }
  if (options.fullscreen && fullscreenLoading) {
    return fullscreenLoading;
  }

  var parent = options.body ? document.body : options.target;
  var instance = new LoadingConstructor({
    el: document.createElement('div'),
    data: options
  });

  addStyle(options, parent, instance);
  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
    (0, _dom.addClass)(parent, 'el-loading-parent--relative');
  }
  if (options.fullscreen && options.lock) {
    (0, _dom.addClass)(parent, 'el-loading-parent--hidden');
  }
  parent.appendChild(instance.$el);
  _vue2.default.nextTick(function () {
    instance.visible = true;
  });
  if (options.fullscreen) {
    fullscreenLoading = instance;
  }
  return instance;
};

exports.default = Loading;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _icon = __webpack_require__(283);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_icon2.default.install = function (Vue) {
  Vue.component(_icon2.default.name, _icon2.default);
};

exports.default = _icon2.default;

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3200ab56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_icon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3200ab56_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//

exports.default = {
  name: 'ElIcon',

  props: {
    name: String
  }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:'el-icon-' + _vm.name})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _row = __webpack_require__(287);

var _row2 = _interopRequireDefault(_row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_row2.default.install = function (Vue) {
  Vue.component(_row2.default.name, _row2.default);
};

exports.default = _row2.default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  name: 'ElRow',

  componentName: 'ElRow',

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
      default: 'start'
    },
    align: {
      type: String,
      default: 'top'
    }
  },

  computed: {
    style: function style() {
      var ret = {};

      if (this.gutter) {
        ret.marginLeft = '-' + this.gutter / 2 + 'px';
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },

  render: function render(h) {
    return h(this.tag, {
      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
      style: this.style
    }, this.$slots.default);
  }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _col = __webpack_require__(289);

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_col2.default.install = function (Vue) {
  Vue.component(_col2.default.name, _col2.default);
};

exports.default = _col2.default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = {
  name: 'ElCol',

  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: 'div'
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  },

  computed: {
    gutter: function gutter() {
      var parent = this.$parent;
      while (parent && parent.$options.componentName !== 'ElRow') {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    }
  },
  render: function render(h) {
    var _this = this;

    var classList = [];
    var style = {};

    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px';
      style.paddingRight = style.paddingLeft;
    }

    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
      if (_this[prop] || _this[prop] === 0) {
        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
      }
    });

    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
      if (typeof _this[size] === 'number') {
        classList.push('el-col-' + size + '-' + _this[size]);
      } else if (_typeof(_this[size]) === 'object') {
        (function () {
          var props = _this[size];
          Object.keys(props).forEach(function (prop) {
            classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
          });
        })();
      }
    });

    return h(this.tag, {
      class: ['el-col', classList],
      style: style
    }, this.$slots.default);
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _src = __webpack_require__(291);

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_src2.default.install = function (Vue) {
  Vue.component(_src2.default.name, _src2.default);
};

exports.default = _src2.default;

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uploadList = __webpack_require__(293);

var _uploadList2 = _interopRequireDefault(_uploadList);

var _upload = __webpack_require__(296);

var _upload2 = _interopRequireDefault(_upload);

var _iframeUpload = __webpack_require__(301);

var _iframeUpload2 = _interopRequireDefault(_iframeUpload);

var _progress = __webpack_require__(42);

var _progress2 = _interopRequireDefault(_progress);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}

exports.default = {
  name: 'ElUpload',

  mixins: [_migrating2.default],

  components: {
    ElProgress: _progress2.default,
    UploadList: _uploadList2.default,
    Upload: _upload2.default,
    IframeUpload: _iframeUpload2.default
  },

  provide: function provide() {
    return {
      uploader: this
    };
  },


  inject: {
    elForm: {
      default: ''
    }
  },

  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: 'file'
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true
    },
    accept: String,
    type: {
      type: String,
      default: 'select'
    },
    beforeUpload: Function,
    beforeRemove: Function,
    onRemove: {
      type: Function,
      default: noop
    },
    onChange: {
      type: Function,
      default: noop
    },
    onPreview: {
      type: Function
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    onProgress: {
      type: Function,
      default: noop
    },
    onError: {
      type: Function,
      default: noop
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text' // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    limit: Number,
    onExceed: {
      type: Function,
      default: noop
    }
  },

  data: function data() {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },


  computed: {
    uploadDisabled: function uploadDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    fileList: {
      immediate: true,
      handler: function handler(fileList) {
        var _this = this;

        this.uploadFiles = fileList.map(function (item) {
          item.uid = item.uid || Date.now() + _this.tempIndex++;
          item.status = item.status || 'success';
          return item;
        });
      }
    }
  },

  methods: {
    handleStart: function handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      var file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      try {
        file.url = URL.createObjectURL(rawFile);
      } catch (err) {
        console.error(err);
        return;
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress: function handleProgress(ev, rawFile) {
      var file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess: function handleSuccess(res, rawFile) {
      var file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;

        this.onSuccess(res, file, this.uploadFiles);
        this.onChange(file, this.uploadFiles);
      }
    },
    handleError: function handleError(err, rawFile) {
      var file = this.getFile(rawFile);
      var fileList = this.uploadFiles;

      file.status = 'fail';

      fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove: function handleRemove(file, raw) {
      var _this2 = this;

      if (raw) {
        file = this.getFile(raw);
      }
      var doRemove = function doRemove() {
        _this2.abort(file);
        var fileList = _this2.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);
        _this2.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === 'function') {
        var before = this.beforeRemove(file, this.uploadFiles);
        if (before && before.then) {
          before.then(function () {
            doRemove();
          }, noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile: function getFile(rawFile) {
      var fileList = this.uploadFiles;
      var target = void 0;
      fileList.every(function (item) {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort: function abort(file) {
      this.$refs['upload-inner'].abort(file);
    },
    clearFiles: function clearFiles() {
      this.uploadFiles = [];
    },
    submit: function submit() {
      var _this3 = this;

      this.uploadFiles.filter(function (file) {
        return file.status === 'ready';
      }).forEach(function (file) {
        _this3.$refs['upload-inner'].upload(file.raw);
      });
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },

  render: function render(h) {
    var uploadList = void 0;

    if (this.showFileList) {
      uploadList = h(
        _uploadList2.default,
        {
          attrs: {
            disabled: this.uploadDisabled,
            listType: this.listType,
            files: this.uploadFiles,

            handlePreview: this.onPreview },
          on: {
            'remove': this.handleRemove
          }
        },
        []
      );
    }

    var uploadData = {
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.uploadDisabled,
        limit: this.limit,
        'on-exceed': this.onExceed,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest
      },
      ref: 'upload-inner'
    };

    var trigger = this.$slots.trigger || this.$slots.default;
    var uploadComponent = typeof FormData !== 'undefined' || this.$isServer ? h(
      'upload',
      uploadData,
      [trigger]
    ) : h(
      'iframeUpload',
      uploadData,
      [trigger]
    );

    return h(
      'div',
      null,
      [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']
    );
  }
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fbf886_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__ = __webpack_require__(295);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fbf886_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _progress = __webpack_require__(42);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_locale2.default],

  data: function data() {
    return {
      focusing: false
    };
  },

  components: { ElProgress: _progress2.default },

  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    listType: String
  },
  methods: {
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:[
    'el-upload-list',
    'el-upload-list--' + _vm.listType,
    { 'is-disabled': _vm.disabled }
  ],attrs:{"tag":"ul","name":"el-list"}},_vm._l((_vm.files),function(file,index){return _c('li',{key:index,class:['el-upload-list__item', 'is-' + file.status, _vm.focusing ? 'focusing' : ''],attrs:{"tabindex":"0"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }!_vm.disabled && _vm.$emit('remove', file)},"focus":function($event){_vm.focusing = true},"blur":function($event){_vm.focusing = false},"click":function($event){_vm.focusing = false}}},[(file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(_vm.listType) > -1)?_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}):_vm._e(),_c('a',{staticClass:"el-upload-list__item-name",on:{"click":function($event){_vm.handleClick(file)}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v(_vm._s(file.name)+"\n    ")]),_c('label',{staticClass:"el-upload-list__item-status-label"},[_c('i',{class:{
        'el-icon-upload-success': true,
        'el-icon-circle-check': _vm.listType === 'text',
        'el-icon-check': ['picture-card', 'picture'].indexOf(_vm.listType) > -1
      }})]),(!_vm.disabled)?_c('i',{staticClass:"el-icon-close",on:{"click":function($event){_vm.$emit('remove', file)}}}):_vm._e(),(!_vm.disabled)?_c('i',{staticClass:"el-icon-close-tip"},[_vm._v(_vm._s(_vm.t('el.upload.deleteTip')))]):_vm._e(),(file.status === 'uploading')?_c('el-progress',{attrs:{"type":_vm.listType === 'picture-card' ? 'circle' : 'line',"stroke-width":_vm.listType === 'picture-card' ? 6 : 2,"percentage":_vm.parsePercentage(file.percentage)}}):_vm._e(),(_vm.listType === 'picture-card')?_c('span',{staticClass:"el-upload-list__item-actions"},[(_vm.handlePreview && _vm.listType === 'picture-card')?_c('span',{staticClass:"el-upload-list__item-preview",on:{"click":function($event){_vm.handlePreview(file)}}},[_c('i',{staticClass:"el-icon-zoom-in"})]):_vm._e(),(!_vm.disabled)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function($event){_vm.$emit('remove', file)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]):_vm._e()],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _babelHelperVueJsxMergeProps = __webpack_require__(43);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _ajax = __webpack_require__(298);

var _ajax2 = _interopRequireDefault(_ajax);

var _uploadDragger = __webpack_require__(44);

var _uploadDragger2 = _interopRequireDefault(_uploadDragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['uploader'],
  components: {
    UploadDragger: _uploadDragger2.default
  },
  props: {
    type: String,
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    headers: Object,
    withCredentials: Boolean,
    multiple: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    drag: Boolean,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    fileList: Array,
    autoUpload: Boolean,
    listType: String,
    httpRequest: {
      type: Function,
      default: _ajax2.default
    },
    disabled: Boolean,
    limit: Number,
    onExceed: Function
  },

  data: function data() {
    return {
      mouseover: false,
      reqs: {}
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleChange: function handleChange(ev) {
      var files = ev.target.files;

      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles: function uploadFiles(files) {
      var _this = this;

      if (this.limit && this.fileList.length + files.length > this.limit) {
        this.onExceed && this.onExceed(files, this.fileList);
        return;
      }

      var postFiles = Array.prototype.slice.call(files);
      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      }

      if (postFiles.length === 0) {
        return;
      }

      postFiles.forEach(function (rawFile) {
        _this.onStart(rawFile);
        if (_this.autoUpload) _this.upload(rawFile);
      });
    },
    upload: function upload(rawFile, file) {
      var _this2 = this;

      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      var before = this.beforeUpload(rawFile);
      if (before && before.then) {
        before.then(function (processedFile) {
          var fileType = Object.prototype.toString.call(processedFile);
          if (fileType === '[object File]' || fileType === '[object Blob]') {
            _this2.post(processedFile);
          } else {
            _this2.post(rawFile);
          }
        }, function () {
          _this2.onRemove(null, rawFile);
        });
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file.uid) uid = file.uid;
        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post: function post(rawFile) {
      var _this3 = this;

      var uid = rawFile.uid;

      var options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: function onProgress(e) {
          _this3.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          _this3.onSuccess(res, rawFile);
          delete _this3.reqs[uid];
        },
        onError: function onError(err) {
          _this3.onError(err, rawFile);
          delete _this3.reqs[uid];
        }
      };
      var req = this.httpRequest(options);
      this.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleKeydown: function handleKeydown(e) {
      if (e.target !== e.currentTarget) return;
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.handleClick();
      }
    }
  },

  render: function render(h) {
    var handleClick = this.handleClick,
        drag = this.drag,
        name = this.name,
        handleChange = this.handleChange,
        multiple = this.multiple,
        accept = this.accept,
        listType = this.listType,
        uploadFiles = this.uploadFiles,
        disabled = this.disabled,
        handleKeydown = this.handleKeydown;

    var data = {
      class: {
        'el-upload': true
      },
      on: {
        click: handleClick,
        keydown: handleKeydown
      }
    };
    data.class['el-upload--' + listType] = true;
    return h(
      'div',
      (0, _babelHelperVueJsxMergeProps2.default)([data, {
        attrs: { tabindex: '0' }
      }]),
      [drag ? h(
        'upload-dragger',
        {
          attrs: { disabled: disabled },
          on: {
            'file': uploadFiles
          }
        },
        [this.$slots.default]
      ) : this.$slots.default, h(
        'input',
        { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
          ref: 'input', on: {
            'change': handleChange
          }
        },
        []
      )]
    );
  }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = upload;
function getError(action, option, xhr) {
  var msg = void 0;
  if (xhr.response) {
    msg = '' + (xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = '' + xhr.responseText;
  } else {
    msg = 'fail to post ' + action + ' ' + xhr.status;
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function upload(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var xhr = new XMLHttpRequest();
  var action = option.action;

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }

    option.onSuccess(getBody(xhr));
  };

  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  for (var item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.send(formData);
  return xhr;
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  inject: {
    uploader: {
      default: ''
    }
  },
  data: function data() {
    return {
      dragover: false
    };
  },

  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (this.disabled || !this.uploader) return;
      var accept = this.uploader.accept;
      this.dragover = false;
      if (!accept) {
        this.$emit('file', e.dataTransfer.files);
        return;
      }
      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
        var type = file.type,
            name = file.name;

        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
        var baseType = type.replace(/\/.*$/, '');
        return accept.split(',').map(function (type) {
          return type.trim();
        }).filter(function (type) {
          return type;
        }).some(function (acceptedType) {
          if (/\..+$/.test(acceptedType)) {
            return extension === acceptedType;
          }
          if (/\/\*$/.test(acceptedType)) {
            return baseType === acceptedType.replace(/\/\*$/, '');
          }
          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
            return type === acceptedType;
          }
          return false;
        });
      }));
    }
  }
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-upload-dragger",class:{
    'is-dragover': _vm.dragover
  },on:{"drop":function($event){$event.preventDefault();_vm.onDrop($event)},"dragover":function($event){$event.preventDefault();_vm.onDragover($event)},"dragleave":function($event){$event.preventDefault();_vm.dragover = false}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uploadDragger = __webpack_require__(44);

var _uploadDragger2 = _interopRequireDefault(_uploadDragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadDragger: _uploadDragger2.default
  },
  props: {
    type: String,
    data: {},
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    withCredentials: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    drag: Boolean,
    listType: String,
    disabled: Boolean,
    limit: Number,
    onExceed: Function
  },

  data: function data() {
    return {
      mouseover: false,
      domain: '',
      file: null,
      submitting: false
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    handleChange: function handleChange(ev) {
      var file = ev.target.value;
      if (file) {
        this.uploadFiles(file);
      }
    },
    uploadFiles: function uploadFiles(file) {
      if (this.limit && this.$parent.uploadFiles.length + file.length > this.limit) {
        this.onExceed && this.onExceed(this.fileList);
        return;
      }

      if (this.submitting) return;
      this.submitting = true;
      this.file = file;
      this.onStart(file);

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.data;
      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = [];
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          inputs.push('<input name="' + key + '" value="' + data[key] + '"/>');
        }
      }
      dataSpan.innerHTML = inputs.join('');
      formNode.submit();
      dataSpan.innerHTML = '';
    },
    getFormNode: function getFormNode() {
      return this.$refs.form;
    },
    getFormDataNode: function getFormDataNode() {
      return this.$refs.data;
    }
  },

  created: function created() {
    this.frameName = 'frame-' + Date.now();
  },
  mounted: function mounted() {
    var self = this;
    !this.$isServer && window.addEventListener('message', function (event) {
      if (!self.file) return;
      var targetOrigin = new URL(self.action).origin;
      if (event.origin !== targetOrigin) return;
      var response = event.data;
      if (response.result === 'success') {
        self.onSuccess(response, self.file);
      } else if (response.result === 'failed') {
        self.onError(response, self.file);
      }
      self.submitting = false;
      self.file = null;
    }, false);
  },
  render: function render(h) {
    var drag = this.drag,
        uploadFiles = this.uploadFiles,
        listType = this.listType,
        frameName = this.frameName,
        disabled = this.disabled;

    var oClass = { 'el-upload': true };
    oClass['el-upload--' + listType] = true;

    return h(
      'div',
      {
        'class': oClass,
        on: {
          'click': this.handleClick
        },
        nativeOn: {
          'drop': this.onDrop,
          'dragover': this.handleDragover,
          'dragleave': this.handleDragleave
        }
      },
      [h(
        'iframe',
        {
          on: {
            'load': this.onload
          },

          ref: 'iframe',
          attrs: { name: frameName
          }
        },
        []
      ), h(
        'form',
        { ref: 'form', attrs: { action: this.action, target: frameName, enctype: 'multipart/form-data', method: 'POST' }
        },
        [h(
          'input',
          {
            'class': 'el-upload__input',
            attrs: { type: 'file',

              name: 'file',

              accept: this.accept },
            ref: 'input', on: {
              'change': this.handleChange
            }
          },
          []
        ), h(
          'input',
          {
            attrs: { type: 'hidden', name: 'documentDomain', value: this.$isServer ? '' : document.domain }
          },
          []
        ), h(
          'span',
          { ref: 'data' },
          []
        )]
      ), drag ? h(
        'upload-dragger',
        {
          on: {
            'file': uploadFiles
          },
          attrs: { disabled: disabled }
        },
        [this.$slots.default]
      ) : this.$slots.default]
    );
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _progress = __webpack_require__(304);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_progress2.default.install = function (Vue) {
  Vue.component(_progress2.default.name, _progress2.default);
};

exports.default = _progress2.default;

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddec355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__ = __webpack_require__(306);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddec355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 126
    },
    showText: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      style.backgroundColor = this.color;
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    trackPath: function trackPath() {
      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);

      return 'M 50 50 m 0 -' + radius + ' a ' + radius + ' ' + radius + ' 0 1 1 0 ' + radius * 2 + ' a ' + radius + ' ' + radius + ' 0 1 1 0 -' + radius * 2;
    },
    perimeter: function perimeter() {
      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle: function circlePathStyle() {
      var perimeter = this.perimeter;
      return {
        strokeDasharray: perimeter + 'px,' + perimeter + 'px',
        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret = void 0;
      if (this.color) {
        ret = this.color;
      } else {
        switch (this.status) {
          case 'success':
            ret = '#13ce66';
            break;
          case 'exception':
            ret = '#ff4949';
            break;
          default:
            ret = '#20a0ff';
        }
      }
      return ret;
    },
    iconClass: function iconClass() {
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-cross';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    }
  }
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': !_vm.showText,
      'el-progress--text-inside': _vm.textInside,
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px'})},[_c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle)},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(_vm.percentage)+"%")]):_vm._e()])])]):_c('div',{staticClass:"el-progress-circle",style:({height: _vm.width + 'px', width: _vm.width + 'px'})},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('path',{staticClass:"el-progress-circle__track",attrs:{"d":_vm.trackPath,"stroke":"#e5e9f2","stroke-width":_vm.relativeStrokeWidth,"fill":"none"}}),_c('path',{staticClass:"el-progress-circle__path",style:(_vm.circlePathStyle),attrs:{"d":_vm.trackPath,"stroke-linecap":"round","stroke":_vm.stroke,"stroke-width":_vm.relativeStrokeWidth,"fill":"none"}})])]),(_vm.showText && !_vm.textInside)?_c('div',{staticClass:"el-progress__text",style:({fontSize: _vm.progressTextSize + 'px'})},[(!_vm.status)?[_vm._v(_vm._s(_vm.percentage)+"%")]:_c('i',{class:_vm.iconClass})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _spinner = __webpack_require__(308);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_spinner2.default.install = function (Vue) {
  Vue.component(_spinner2.default.name, _spinner2.default);
};

exports.default = _spinner2.default;

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503fa473_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503fa473_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//

exports.default = {
  name: 'ElSpinner',
  props: {
    type: String,
    radius: {
      type: Number,
      default: 100
    },
    strokeWidth: {
      type: Number,
      default: 5
    },
    strokeColor: {
      type: String,
      default: '#efefef'
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"el-spinner"},[_c('svg',{staticClass:"el-spinner-inner",style:({ width: _vm.radius/2 + 'px', height: _vm.radius/2 + 'px' }),attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke":_vm.strokeColor,"stroke-width":_vm.strokeWidth}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(312);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _main2.default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _main = __webpack_require__(313);

var _main2 = _interopRequireDefault(_main);

var _popup = __webpack_require__(12);

var _vdom = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageConstructor = _vue2.default.extend(_main2.default);

var instance = void 0;
var instances = [];
var seed = 1;

var Message = function Message(options) {
  if (_vue2.default.prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  var userOnClose = options.onClose;
  var id = 'message_' + seed++;

  options.onClose = function () {
    Message.close(id, userOnClose);
  };
  instance = new MessageConstructor({
    data: options
  });
  instance.id = id;
  if ((0, _vdom.isVNode)(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  }
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = _popup.PopupManager.nextZIndex();
  instances.push(instance);
  return instance.vm;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  Message[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return Message(options);
  };
});

Message.close = function (id, userOnClose) {
  for (var i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
};

Message.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

exports.default = Message;

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf6c88be_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf6c88be_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

exports.default = {
  data: function data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false
    };
  },


  computed: {
    iconWrapClass: function iconWrapClass() {
      var classes = ['el-message__icon'];
      if (this.type && !this.iconClass) {
        classes.push('el-message__icon--' + this.type);
      }
      return classes;
    },
    typeClass: function typeClass() {
      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + typeMap[this.type] : '';
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },

  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-message-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:[
      'el-message',
      _vm.type && !_vm.iconClass ? ("el-message--" + _vm.type) : '',
      _vm.center ? 'is-center' : '',
      _vm.showClose ? 'is-closable' : '',
      _vm.customClass],attrs:{"role":"alert"},on:{"mouseenter":_vm.clearTimer,"mouseleave":_vm.startTimer}},[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_c('i',{class:_vm.typeClass}),_vm._t("default",[(!_vm.dangerouslyUseHTMLString)?_c('p',{staticClass:"el-message__content"},[_vm._v(_vm._s(_vm.message))]):_c('p',{staticClass:"el-message__content",domProps:{"innerHTML":_vm._s(_vm.message)}})]),(_vm.showClose)?_c('i',{staticClass:"el-message__closeBtn el-icon-close",on:{"click":_vm.close}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(317);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ee78c5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(319);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ee78c5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElBadge',

  props: {
    value: {},
    max: Number,
    isDot: Boolean,
    hidden: Boolean
  },

  computed: {
    content: function content() {
      if (this.isDot) return;

      var value = this.value;
      var max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? max + '+' : value;
      }

      return value;
    }
  }
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-badge"},[_vm._t("default"),_c('transition',{attrs:{"name":"el-zoom-in-center"}},[_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot)),expression:"!hidden && (content || content === 0 || isDot)"}],staticClass:"el-badge__content",class:{ 'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot },domProps:{"textContent":_vm._s(_vm.content)}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(321);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3777b44_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(323);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3777b44_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElCard',
  props: {
    header: {},
    bodyStyle: {},
    shadow: {
      type: String
    }
  }
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-card",class:_vm.shadow ? 'is-' + _vm.shadow + '-shadow' : 'is-always-shadow'},[(_vm.$slots.header || _vm.header)?_c('div',{staticClass:"el-card__header"},[_vm._t("header",[_vm._v(_vm._s(_vm.header))])],2):_vm._e(),_c('div',{staticClass:"el-card__body",style:(_vm.bodyStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(325);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14663ae4_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(327);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14663ae4_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(3);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElRate',

  mixins: [_migrating2.default],

  inject: {
    elForm: {
      default: ''
    }
  },

  data: function data() {
    return {
      pointerAtLeftHalf: true,
      currentValue: this.value,
      hoverIndex: -1
    };
  },


  props: {
    value: {
      type: Number,
      default: 0
    },
    lowThreshold: {
      type: Number,
      default: 2
    },
    highThreshold: {
      type: Number,
      default: 4
    },
    max: {
      type: Number,
      default: 5
    },
    colors: {
      type: Array,
      default: function _default() {
        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
      }
    },
    voidColor: {
      type: String,
      default: '#C6D1DE'
    },
    disabledVoidColor: {
      type: String,
      default: '#EFF2F7'
    },
    iconClasses: {
      type: Array,
      default: function _default() {
        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
      }
    },
    voidIconClass: {
      type: String,
      default: 'el-icon-star-off'
    },
    disabledVoidIconClass: {
      type: String,
      default: 'el-icon-star-on'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowHalf: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: '#1f2d3d'
    },
    texts: {
      type: Array,
      default: function _default() {
        return ['极差', '失望', '一般', '满意', '惊喜'];
      }
    },
    scoreTemplate: {
      type: String,
      default: '{value}'
    }
  },

  computed: {
    text: function text() {
      var result = '';
      if (this.showScore) {
        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
      } else if (this.showText) {
        result = this.texts[Math.ceil(this.currentValue) - 1];
      }
      return result;
    },
    decimalStyle: function decimalStyle() {
      var width = '';
      if (this.rateDisabled) {
        width = (this.valueDecimal < 50 ? 0 : 50) + '%';
      }
      if (this.allowHalf) {
        width = '50%';
      }
      return {
        color: this.activeColor,
        width: width
      };
    },
    valueDecimal: function valueDecimal() {
      return this.value * 100 - Math.floor(this.value) * 100;
    },
    decimalIconClass: function decimalIconClass() {
      return this.getValueFromMap(this.value, this.classMap);
    },
    voidClass: function voidClass() {
      return this.rateDisabled ? this.classMap.disabledVoidClass : this.classMap.voidClass;
    },
    activeClass: function activeClass() {
      return this.getValueFromMap(this.currentValue, this.classMap);
    },
    colorMap: function colorMap() {
      return {
        lowColor: this.colors[0],
        mediumColor: this.colors[1],
        highColor: this.colors[2],
        voidColor: this.voidColor,
        disabledVoidColor: this.disabledVoidColor
      };
    },
    activeColor: function activeColor() {
      return this.getValueFromMap(this.currentValue, this.colorMap);
    },
    classes: function classes() {
      var result = [];
      var i = 0;
      var threshold = this.currentValue;
      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
        threshold--;
      }
      for (; i < threshold; i++) {
        result.push(this.activeClass);
      }
      for (; i < this.max; i++) {
        result.push(this.voidClass);
      }
      return result;
    },
    classMap: function classMap() {
      return {
        lowClass: this.iconClasses[0],
        mediumClass: this.iconClasses[1],
        highClass: this.iconClasses[2],
        voidClass: this.voidIconClass,
        disabledVoidClass: this.disabledVoidIconClass
      };
    },
    rateDisabled: function rateDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    value: function value(val) {
      this.currentValue = val;
      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'text-template': 'text-template is renamed to score-template.'
        }
      };
    },
    getValueFromMap: function getValueFromMap(value, map) {
      var result = '';
      if (value <= this.lowThreshold) {
        result = map.lowColor || map.lowClass;
      } else if (value >= this.highThreshold) {
        result = map.highColor || map.highClass;
      } else {
        result = map.mediumColor || map.mediumClass;
      }
      return result;
    },
    showDecimalIcon: function showDecimalIcon(item) {
      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
      /* istanbul ignore next */
      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
      return showWhenDisabled || showWhenAllowHalf;
    },
    getIconStyle: function getIconStyle(item) {
      var voidColor = this.rateDisabled ? this.colorMap.disabledVoidColor : this.colorMap.voidColor;
      return {
        color: item <= this.currentValue ? this.activeColor : voidColor
      };
    },
    selectValue: function selectValue(value) {
      if (this.rateDisabled) {
        return;
      }
      if (this.allowHalf && this.pointerAtLeftHalf) {
        this.$emit('input', this.currentValue);
        this.$emit('change', this.currentValue);
      } else {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    },
    handleKey: function handleKey(e) {
      if (this.rateDisabled) {
        return;
      }
      var currentValue = this.currentValue;
      var keyCode = e.keyCode;
      if (keyCode === 38 || keyCode === 39) {
        // left / down
        if (this.allowHalf) {
          currentValue += 0.5;
        } else {
          currentValue += 1;
        }
        e.stopPropagation();
        e.preventDefault();
      } else if (keyCode === 37 || keyCode === 40) {
        if (this.allowHalf) {
          currentValue -= 0.5;
        } else {
          currentValue -= 1;
        }
        e.stopPropagation();
        e.preventDefault();
      }
      currentValue = currentValue < 0 ? 0 : currentValue;
      currentValue = currentValue > this.max ? this.max : currentValue;

      this.$emit('input', currentValue);
      this.$emit('change', currentValue);
    },
    setCurrentValue: function setCurrentValue(value, event) {
      if (this.rateDisabled) {
        return;
      }
      /* istanbul ignore if */
      if (this.allowHalf) {
        var target = event.target;
        if ((0, _dom.hasClass)(target, 'el-rate__item')) {
          target = target.querySelector('.el-rate__icon');
        }
        if ((0, _dom.hasClass)(target, 'el-rate__decimal')) {
          target = target.parentNode;
        }
        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
      } else {
        this.currentValue = value;
      }
      this.hoverIndex = value;
    },
    resetCurrentValue: function resetCurrentValue() {
      if (this.rateDisabled) {
        return;
      }
      if (this.allowHalf) {
        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
      }
      this.currentValue = this.value;
      this.hoverIndex = -1;
    }
  },

  created: function created() {
    if (!this.value) {
      this.$emit('input', 0);
    }
  }
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-rate",attrs:{"role":"slider","aria-valuenow":_vm.currentValue,"aria-valuetext":_vm.text,"aria-valuemin":"0","aria-valuemax":_vm.max,"tabindex":"0"},on:{"keydown":_vm.handleKey}},[_vm._l((_vm.max),function(item){return _c('span',{staticClass:"el-rate__item",style:({ cursor: _vm.rateDisabled ? 'auto' : 'pointer' }),on:{"mousemove":function($event){_vm.setCurrentValue(item, $event)},"mouseleave":_vm.resetCurrentValue,"click":function($event){_vm.selectValue(item)}}},[_c('i',{staticClass:"el-rate__icon",class:[_vm.classes[item - 1], { 'hover': _vm.hoverIndex === item }],style:(_vm.getIconStyle(item))},[(_vm.showDecimalIcon(item))?_c('i',{staticClass:"el-rate__decimal",class:_vm.decimalIconClass,style:(_vm.decimalStyle)}):_vm._e()])])}),(_vm.showText || _vm.showScore)?_c('span',{staticClass:"el-rate__text",style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _steps = __webpack_require__(329);

var _steps2 = _interopRequireDefault(_steps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_steps2.default.install = function (Vue) {
  Vue.component(_steps2.default.name, _steps2.default);
};

exports.default = _steps2.default;

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c69762_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__ = __webpack_require__(331);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c69762_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSteps',

  mixins: [_migrating2.default],

  props: {
    space: [Number, String],
    active: Number,
    direction: {
      type: String,
      default: 'horizontal'
    },
    alignCenter: Boolean,
    simple: Boolean,
    finishStatus: {
      type: String,
      default: 'finish'
    },
    processStatus: {
      type: String,
      default: 'process'
    }
  },

  data: function data() {
    return {
      steps: [],
      stepOffset: 0
    };
  },


  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'center': 'center is removed.'
        }
      };
    }
  },

  watch: {
    active: function active(newVal, oldVal) {
      this.$emit('change', newVal, oldVal);
    },
    steps: function steps(_steps) {
      _steps.forEach(function (child, index) {
        child.index = index;
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-steps",class:[
     !_vm.simple && 'el-steps--' + _vm.direction,
     _vm.simple && 'el-steps--simple'
   ]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _step = __webpack_require__(333);

var _step2 = _interopRequireDefault(_step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_step2.default.install = function (Vue) {
  Vue.component(_step2.default.name, _step2.default);
};

exports.default = _step2.default;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c5158_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_vue__ = __webpack_require__(335);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c5158_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElStep',

  props: {
    title: String,
    icon: String,
    description: String,
    status: String
  },

  data: function data() {
    return {
      index: -1,
      lineStyle: {},
      internalStatus: ''
    };
  },
  beforeCreate: function beforeCreate() {
    this.$parent.steps.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var steps = this.$parent.steps;
    var index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },


  computed: {
    currentStatus: function currentStatus() {
      return this.status || this.internalStatus;
    },
    prevStatus: function prevStatus() {
      var prevStep = this.$parent.steps[this.index - 1];
      return prevStep ? prevStep.currentStatus : 'wait';
    },
    isCenter: function isCenter() {
      return this.$parent.alignCenter;
    },
    isVertical: function isVertical() {
      return this.$parent.direction === 'vertical';
    },
    isSimple: function isSimple() {
      return this.$parent.simple;
    },
    isLast: function isLast() {
      var parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    },
    stepsCount: function stepsCount() {
      return this.$parent.steps.length;
    },
    space: function space() {
      var isSimple = this.isSimple,
          space = this.$parent.space;

      return isSimple ? '' : space;
    },

    style: function style() {
      var style = {};
      var parent = this.$parent;
      var len = parent.steps.length;

      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
      style.flexBasis = space;
      if (this.isVertical) return style;
      if (this.isLast) {
        style.maxWidth = 100 / this.stepsCount + '%';
      } else {
        style.marginRight = -this.$parent.stepOffset + 'px';
      }

      return style;
    }
  },

  methods: {
    updateStatus: function updateStatus(val) {
      var prevChild = this.$parent.$children[this.index - 1];

      if (val > this.index) {
        this.internalStatus = this.$parent.finishStatus;
      } else if (val === this.index && this.prevStatus !== 'error') {
        this.internalStatus = this.$parent.processStatus;
      } else {
        this.internalStatus = 'wait';
      }

      if (prevChild) prevChild.calcProgress(this.internalStatus);
    },
    calcProgress: function calcProgress(status) {
      var step = 100;
      var style = {};

      style.transitionDelay = 150 * this.index + 'ms';
      if (status === this.$parent.processStatus) {
        step = this.currentStatus !== 'error' ? 0 : 0;
      } else if (status === 'wait') {
        step = 0;
        style.transitionDelay = -150 * this.index + 'ms';
      }

      style.borderWidth = step ? '1px' : 0;
      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';

      this.lineStyle = style;
    }
  },

  mounted: function mounted() {
    var _this = this;

    var unwatch = this.$watch('index', function (val) {
      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
      unwatch();
    });
  }
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-step",class:[
    !_vm.isSimple && ("is-" + (_vm.$parent.direction)),
    _vm.isSimple && 'is-simple',
    _vm.isLast && !_vm.space && !_vm.isCenter && 'is-flex',
    _vm.isCenter && !_vm.isVertical && !_vm.isSimple && 'is-center'
   ],style:(_vm.style)},[_c('div',{staticClass:"el-step__head",class:("is-" + _vm.currentStatus)},[_c('div',{staticClass:"el-step__line",style:(_vm.isLast ? '' : { marginRight: _vm.$parent.stepOffset + 'px' })},[_c('i',{staticClass:"el-step__line-inner",style:(_vm.lineStyle)})]),_c('div',{staticClass:"el-step__icon",class:("is-" + (_vm.icon ? 'icon' : 'text'))},[(_vm.currentStatus !== 'success' && _vm.currentStatus !== 'error')?_vm._t("icon",[(_vm.icon)?_c('i',{staticClass:"el-step__icon-inner",class:[_vm.icon]}):_vm._e(),(!_vm.icon && !_vm.isSimple)?_c('div',{staticClass:"el-step__icon-inner"},[_vm._v(_vm._s(_vm.index + 1))]):_vm._e()]):_c('i',{staticClass:"el-step__icon-inner is-status",class:['el-icon-' + (_vm.currentStatus === 'success' ? 'check' : 'close')]})],2)]),_c('div',{staticClass:"el-step__main"},[_c('div',{ref:"title",staticClass:"el-step__title",class:['is-' + _vm.currentStatus]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),(_vm.isSimple)?_c('div',{staticClass:"el-step__arrow"}):_c('div',{staticClass:"el-step__description",class:['is-' + _vm.currentStatus]},[_vm._t("description",[_vm._v(_vm._s(_vm.description))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(337);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4b548e_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(340);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4b548e_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _throttle = __webpack_require__(339);

var _throttle2 = _interopRequireDefault(_throttle);

var _resizeEvent = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElCarousel',

  props: {
    initialIndex: {
      type: Number,
      default: 0
    },
    height: String,
    trigger: {
      type: String,
      default: 'hover'
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 3000
    },
    indicatorPosition: String,
    indicator: {
      type: Boolean,
      default: true
    },
    arrow: {
      type: String,
      default: 'hover'
    },
    type: String
  },

  data: function data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      hover: false
    };
  },


  computed: {
    hasLabel: function hasLabel() {
      return this.items.some(function (item) {
        return item.label.toString().length > 0;
      });
    }
  },

  watch: {
    items: function items(val) {
      if (val.length > 0) this.setActiveItem(this.initialIndex);
    },
    activeIndex: function activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal);
      this.$emit('change', val, oldVal);
    },
    autoplay: function autoplay(val) {
      val ? this.startTimer() : this.pauseTimer();
    }
  },

  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.hover = true;
      this.pauseTimer();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hover = false;
      this.startTimer();
    },
    itemInStage: function itemInStage(item, index) {
      var length = this.items.length;
      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
        return 'left';
      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
        return 'right';
      }
      return false;
    },
    handleButtonEnter: function handleButtonEnter(arrow) {
      var _this = this;

      this.items.forEach(function (item, index) {
        if (arrow === _this.itemInStage(item, index)) {
          item.hover = true;
        }
      });
    },
    handleButtonLeave: function handleButtonLeave() {
      this.items.forEach(function (item) {
        item.hover = false;
      });
    },
    updateItems: function updateItems() {
      this.items = this.$children.filter(function (child) {
        return child.$options.name === 'ElCarouselItem';
      });
    },
    resetItemPosition: function resetItemPosition(oldIndex) {
      var _this2 = this;

      this.items.forEach(function (item, index) {
        item.translateItem(index, _this2.activeIndex, oldIndex);
      });
    },
    playSlides: function playSlides() {
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    pauseTimer: function pauseTimer() {
      clearInterval(this.timer);
    },
    startTimer: function startTimer() {
      if (this.interval <= 0 || !this.autoplay) return;
      this.timer = setInterval(this.playSlides, this.interval);
    },
    setActiveItem: function setActiveItem(index) {
      if (typeof index === 'string') {
        var filteredItems = this.items.filter(function (item) {
          return item.name === index;
        });
        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0]);
        }
      }
      index = Number(index);
      if (isNaN(index) || index !== Math.floor(index)) {
        "production" !== 'production' && console.warn('[Element Warn][Carousel]index must be an integer.');
        return;
      }
      var length = this.items.length;
      var oldIndex = this.activeIndex;
      if (index < 0) {
        this.activeIndex = length - 1;
      } else if (index >= length) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = index;
      }
      if (oldIndex === this.activeIndex) {
        this.resetItemPosition(oldIndex);
      }
    },
    prev: function prev() {
      this.setActiveItem(this.activeIndex - 1);
    },
    next: function next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    handleIndicatorClick: function handleIndicatorClick(index) {
      this.activeIndex = index;
    },
    handleIndicatorHover: function handleIndicatorHover(index) {
      if (this.trigger === 'hover' && index !== this.activeIndex) {
        this.activeIndex = index;
      }
    }
  },

  created: function created() {
    var _this3 = this;

    this.throttledArrowClick = (0, _throttle2.default)(300, true, function (index) {
      _this3.setActiveItem(index);
    });
    this.throttledIndicatorHover = (0, _throttle2.default)(300, function (index) {
      _this3.handleIndicatorHover(index);
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    this.updateItems();
    this.$nextTick(function () {
      (0, _resizeEvent.addResizeListener)(_this4.$el, _this4.resetItemPosition);
      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
        _this4.activeIndex = _this4.initialIndex;
      }
      _this4.startTimer();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el) (0, _resizeEvent.removeResizeListener)(this.$el, this.resetItemPosition);
  }
};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(147);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel",class:{ 'el-carousel--card': _vm.type === 'card' },on:{"mouseenter":function($event){$event.stopPropagation();_vm.handleMouseEnter($event)},"mouseleave":function($event){$event.stopPropagation();_vm.handleMouseLeave($event)}}},[_c('div',{staticClass:"el-carousel__container",style:({ height: _vm.height })},[_c('transition',{attrs:{"name":"carousel-arrow-left"}},[(_vm.arrow !== 'never')?_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow === 'always' || _vm.hover),expression:"arrow === 'always' || hover"}],staticClass:"el-carousel__arrow el-carousel__arrow--left",attrs:{"type":"button"},on:{"mouseenter":function($event){_vm.handleButtonEnter('left')},"mouseleave":_vm.handleButtonLeave,"click":function($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex - 1)}}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e()]),_c('transition',{attrs:{"name":"carousel-arrow-right"}},[(_vm.arrow !== 'never')?_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow === 'always' || _vm.hover),expression:"arrow === 'always' || hover"}],staticClass:"el-carousel__arrow el-carousel__arrow--right",attrs:{"type":"button"},on:{"mouseenter":function($event){_vm.handleButtonEnter('right')},"mouseleave":_vm.handleButtonLeave,"click":function($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex + 1)}}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()]),_vm._t("default")],2),(_vm.indicatorPosition !== 'none')?_c('ul',{staticClass:"el-carousel__indicators",class:{ 'el-carousel__indicators--labels': _vm.hasLabel, 'el-carousel__indicators--outside': _vm.indicatorPosition === 'outside' || _vm.type === 'card' }},_vm._l((_vm.items),function(item,index){return _c('li',{staticClass:"el-carousel__indicator",class:{ 'is-active': index === _vm.activeIndex },on:{"mouseenter":function($event){_vm.throttledIndicatorHover(index)},"click":function($event){$event.stopPropagation();_vm.handleIndicatorClick(index)}}},[_c('button',{staticClass:"el-carousel__button"},[(_vm.hasLabel)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()])])})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(342);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _resizeEvent = __webpack_require__(17);

var _scrollbarWidth = __webpack_require__(36);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _util = __webpack_require__(4);

var _bar = __webpack_require__(343);

var _bar2 = _interopRequireDefault(_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js

exports.default = {
  name: 'ElScrollbar',

  components: { Bar: _bar2.default },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },

  render: function render(h) {
    var gutter = (0, _scrollbarWidth2.default)();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = '-' + gutter + 'px';
      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

      if (Array.isArray(this.wrapStyle)) {
        style = (0, _util.toObject)(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll
        },

        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      nodes = [wrap, h(
        _bar2.default,
        {
          attrs: {
            move: this.moveX,
            size: this.sizeWidth }
        },
        []
      ), h(
        _bar2.default,
        {
          attrs: {
            vertical: true,
            move: this.moveY,
            size: this.sizeHeight }
        },
        []
      )];
    } else {
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'el-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'el-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;

      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
    },
    update: function update() {
      var heightPercentage = void 0,
          widthPercentage = void 0;
      var wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$refs.resize, this.update);
  }
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(3);

var _util = __webpack_require__(344);

/* istanbul ignore next */
exports.default = {
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number
  },

  computed: {
    bar: function bar() {
      return _util.BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar;


    return h(
      'div',
      {
        'class': ['el-scrollbar__bar', 'is-' + bar.key],
        on: {
          'mousedown': this.clickTrackHandler
        }
      },
      [h(
        'div',
        {
          ref: 'thumb',
          'class': 'el-scrollbar__thumb',
          on: {
            'mousedown': this.clickThumbHandler
          },

          style: (0, _util.renderThumbStyle)({ size: size, move: move, bar: bar }) },
        []
      )]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      (0, _dom.on)(document, 'mousemove', this.mouseMoveDocumentHandler);
      (0, _dom.on)(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      (0, _dom.off)(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    (0, _dom.off)(document, 'mouseup', this.mouseUpDocumentHandler);
  }
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.renderThumbStyle = renderThumbStyle;
var BAR_MAP = exports.BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};

function renderThumbStyle(_ref) {
  var move = _ref.move,
      size = _ref.size,
      bar = _ref.bar;

  var style = {};
  var translate = 'translate' + bar.axis + '(' + move + '%)';

  style[bar.size] = size;
  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;

  return style;
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _item = __webpack_require__(346);

var _item2 = _interopRequireDefault(_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_item2.default.install = function (Vue) {
  Vue.component(_item2.default.name, _item2.default);
};

exports.default = _item2.default;

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9808e630_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__(348);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9808e630_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CARD_SCALE = 0.83;
exports.default = {
  name: 'ElCarouselItem',

  props: {
    name: String,
    label: {
      type: [String, Number],
      default: ''
    }
  },

  data: function data() {
    return {
      hover: false,
      translate: 0,
      scale: 1,
      active: false,
      ready: false,
      inStage: false,
      animating: false
    };
  },


  methods: {
    processIndex: function processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1;
      } else if (activeIndex === length - 1 && index === 0) {
        return length;
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1;
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2;
      }
      return index;
    },
    calculateTranslate: function calculateTranslate(index, activeIndex, parentWidth) {
      if (this.inStage) {
        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
      } else if (index < activeIndex) {
        return -(1 + CARD_SCALE) * parentWidth / 4;
      } else {
        return (3 + CARD_SCALE) * parentWidth / 4;
      }
    },
    translateItem: function translateItem(index, activeIndex, oldIndex) {
      var parentWidth = this.$parent.$el.offsetWidth;
      var length = this.$parent.items.length;
      if (this.$parent.type !== 'card' && oldIndex !== undefined) {
        this.animating = index === activeIndex || index === oldIndex;
      }
      if (index !== activeIndex && length > 2) {
        index = this.processIndex(index, activeIndex, length);
      }
      if (this.$parent.type === 'card') {
        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
        this.active = index === activeIndex;
        this.translate = this.calculateTranslate(index, activeIndex, parentWidth);
        this.scale = this.active ? 1 : CARD_SCALE;
      } else {
        this.active = index === activeIndex;
        this.translate = parentWidth * (index - activeIndex);
      }
      this.ready = true;
    },
    handleItemClick: function handleItemClick() {
      var parent = this.$parent;
      if (parent && parent.type === 'card') {
        var index = parent.items.indexOf(this);
        parent.setActiveItem(index);
      }
    }
  },

  created: function created() {
    this.$parent && this.$parent.updateItems();
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.updateItems();
  }
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],staticClass:"el-carousel__item",class:{
    'is-active': _vm.active,
    'el-carousel__item--card': _vm.$parent.type === 'card',
    'is-in-stage': _vm.inStage,
    'is-hover': _vm.hover,
    'is-animating': _vm.animating
  },style:({
    msTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
    webkitTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
    transform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")")
  }),on:{"click":_vm.handleItemClick}},[(_vm.$parent.type === 'card')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.active),expression:"!active"}],staticClass:"el-carousel__mask"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _collapse = __webpack_require__(350);

var _collapse2 = _interopRequireDefault(_collapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_collapse2.default.install = function (Vue) {
  Vue.component(_collapse2.default.name, _collapse2.default);
};

exports.default = _collapse2.default;

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18313355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18313355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//

exports.default = {
  name: 'ElCollapse',

  componentName: 'ElCollapse',

  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      activeNames: [].concat(this.value)
    };
  },
  provide: function provide() {
    return {
      collapse: this
    };
  },


  watch: {
    value: function value(_value) {
      this.activeNames = [].concat(_value);
    }
  },

  methods: {
    setActiveNames: function setActiveNames(activeNames) {
      activeNames = [].concat(activeNames);
      var value = this.accordion ? activeNames[0] : activeNames;
      this.activeNames = activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    handleItemClick: function handleItemClick(item) {
      if (this.accordion) {
        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
      } else {
        var activeNames = this.activeNames.slice(0);
        var index = activeNames.indexOf(item.name);

        if (index > -1) {
          activeNames.splice(index, 1);
        } else {
          activeNames.push(item.name);
        }
        this.setActiveNames(activeNames);
      }
    }
  },

  created: function created() {
    this.$on('item-click', this.handleItemClick);
  }
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-collapse",attrs:{"role":"tablist","aria-multiselectable":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _collapseItem = __webpack_require__(354);

var _collapseItem2 = _interopRequireDefault(_collapseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_collapseItem2.default.install = function (Vue) {
  Vue.component(_collapseItem2.default.name, _collapseItem2.default);
};

exports.default = _collapseItem2.default;

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_item_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c1468a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_item_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c1468a_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _collapseTransition = __webpack_require__(20);

var _collapseTransition2 = _interopRequireDefault(_collapseTransition);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCollapseItem',

  componentName: 'ElCollapseItem',

  mixins: [_emitter2.default],

  components: { ElCollapseTransition: _collapseTransition2.default },

  data: function data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block'
      },
      contentHeight: 0,
      focusing: false,
      isClick: false
    };
  },


  inject: ['collapse'],

  props: {
    title: String,
    name: {
      type: [String, Number],
      default: function _default() {
        return this._uid;
      }
    }
  },

  computed: {
    isActive: function isActive() {
      return this.collapse.activeNames.indexOf(this.name) > -1;
    },
    id: function id() {
      return (0, _util.generateId)();
    }
  },

  methods: {
    handleFocus: function handleFocus() {
      var _this = this;

      setTimeout(function () {
        if (!_this.isClick) {
          _this.focusing = true;
        } else {
          _this.isClick = false;
        }
      }, 50);
    },
    handleHeaderClick: function handleHeaderClick() {
      this.dispatch('ElCollapse', 'item-click', this);
      this.focusing = false;
      this.isClick = true;
    },
    handleEnterClick: function handleEnterClick() {
      this.dispatch('ElCollapse', 'item-click', this);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-collapse-item",class:{'is-active': _vm.isActive}},[_c('div',{attrs:{"role":"tab","aria-expanded":_vm.isActive,"aria-controls":("el-collapse-content-" + _vm.id),"aria-describedby":("el-collapse-content-" + _vm.id)}},[_c('div',{staticClass:"el-collapse-item__header",class:{
        'focusing': _vm.focusing,
        'is-active': _vm.isActive
      },attrs:{"role":"button","id":("el-collapse-head-" + _vm.id),"tabindex":"0"},on:{"click":_vm.handleHeaderClick,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.stopPropagation();_vm.handleEnterClick($event)},"focus":_vm.handleFocus,"blur":function($event){_vm.focusing = false}}},[_c('i',{staticClass:"el-collapse-item__arrow el-icon-arrow-right",class:{'is-active': _vm.isActive}}),_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)]),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"el-collapse-item__wrap",attrs:{"role":"tabpanel","aria-hidden":!_vm.isActive,"aria-labelledby":("el-collapse-head-" + _vm.id),"id":("el-collapse-content-" + _vm.id)}},[_c('div',{staticClass:"el-collapse-item__content"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(358);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aff0320_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(362);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aff0320_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _menu = __webpack_require__(360);

var _menu2 = _interopRequireDefault(_menu);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _locale3 = __webpack_require__(16);

var _debounce = __webpack_require__(13);

var _debounce2 = _interopRequireDefault(_debounce);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var popperMixin = {
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    appendToBody: _vuePopper2.default.props.appendToBody,
    arrowOffset: _vuePopper2.default.props.arrowOffset,
    offset: _vuePopper2.default.props.offset,
    boundariesPadding: _vuePopper2.default.props.boundariesPadding,
    popperOptions: _vuePopper2.default.props.popperOptions
  },
  methods: _vuePopper2.default.methods,
  data: _vuePopper2.default.data,
  beforeDestroy: _vuePopper2.default.beforeDestroy
};

exports.default = {
  name: 'ElCascader',

  directives: { Clickoutside: _clickoutside2.default },

  mixins: [popperMixin, _emitter2.default, _locale2.default],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  components: {
    ElInput: _input2.default
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          children: 'children',
          label: 'label',
          value: 'value',
          disabled: 'disabled'
        };
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    separator: {
      type: String,
      default: '/'
    },
    placeholder: {
      type: String,
      default: function _default() {
        return (0, _locale3.t)('el.cascader.placeholder');
      }
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: false
    },
    changeOnSelect: Boolean,
    popperClass: String,
    expandTrigger: {
      type: String,
      default: 'click'
    },
    filterable: Boolean,
    size: String,
    showAllLevels: {
      type: Boolean,
      default: true
    },
    debounce: {
      type: Number,
      default: 300
    },
    beforeFilter: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    hoverThreshold: {
      type: Number,
      default: 500
    }
  },

  data: function data() {
    return {
      currentValue: this.value || [],
      menu: null,
      debouncedInputChange: function debouncedInputChange() {},

      menuVisible: false,
      inputHover: false,
      inputValue: '',
      flatOptions: null
    };
  },


  computed: {
    labelKey: function labelKey() {
      return this.props.label || 'label';
    },
    valueKey: function valueKey() {
      return this.props.value || 'value';
    },
    childrenKey: function childrenKey() {
      return this.props.children || 'children';
    },
    currentLabels: function currentLabels() {
      var _this = this;

      var options = this.options;
      var labels = [];
      this.currentValue.forEach(function (value) {
        var targetOption = options && options.filter(function (option) {
          return option[_this.valueKey] === value;
        })[0];
        if (targetOption) {
          labels.push(targetOption[_this.labelKey]);
          options = targetOption[_this.childrenKey];
        }
      });
      return labels;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    cascaderSize: function cascaderSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    cascaderDisabled: function cascaderDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    id: function id() {
      return (0, _util.generateId)();
    }
  },

  watch: {
    menuVisible: function menuVisible(value) {
      this.$refs.input.$refs.input.setAttribute('aria-expanded', value);
      value ? this.showMenu() : this.hideMenu();
    },
    value: function value(_value) {
      this.currentValue = _value;
    },
    currentValue: function currentValue(value) {
      this.dispatch('ElFormItem', 'el.form.change', [value]);
    },
    currentLabels: function currentLabels(value) {
      var inputLabel = this.showAllLevels ? value.join('/') : value[value.length - 1];
      this.$refs.input.$refs.input.setAttribute('value', inputLabel);
    },

    options: {
      deep: true,
      handler: function handler(value) {
        if (!this.menu) {
          this.initMenu();
        }
        this.flatOptions = this.flattenOptions(this.options);
        this.menu.options = value;
      }
    }
  },

  methods: {
    initMenu: function initMenu() {
      this.menu = new _vue2.default(_menu2.default).$mount();
      this.menu.options = this.options;
      this.menu.props = this.props;
      this.menu.expandTrigger = this.expandTrigger;
      this.menu.changeOnSelect = this.changeOnSelect;
      this.menu.popperClass = this.popperClass;
      this.menu.hoverThreshold = this.hoverThreshold;
      this.popperElm = this.menu.$el;
      this.menu.$refs.menus[0].setAttribute('id', 'cascader-menu-' + this.id);
      this.menu.$on('pick', this.handlePick);
      this.menu.$on('activeItemChange', this.handleActiveItemChange);
      this.menu.$on('menuLeave', this.doDestroy);
      this.menu.$on('closeInside', this.handleClickoutside);
    },
    showMenu: function showMenu() {
      var _this2 = this;

      if (!this.menu) {
        this.initMenu();
      }

      this.menu.value = this.currentValue.slice(0);
      this.menu.visible = true;
      this.menu.options = this.options;
      this.$nextTick(function (_) {
        _this2.updatePopper();
        _this2.menu.inputWidth = _this2.$refs.input.$el.offsetWidth - 2;
      });
    },
    hideMenu: function hideMenu() {
      this.inputValue = '';
      this.menu.visible = false;
      this.$refs.input.focus();
    },
    handleActiveItemChange: function handleActiveItemChange(value) {
      var _this3 = this;

      this.$nextTick(function (_) {
        _this3.updatePopper();
      });
      this.$emit('active-item-change', value);
    },
    handleKeydown: function handleKeydown(e) {
      var _this4 = this;

      var keyCode = e.keyCode;
      if (keyCode === 13) {
        this.handleClick();
      } else if (keyCode === 40) {
        // down
        this.menuVisible = true; // 打开
        setTimeout(function () {
          var firstMenu = _this4.popperElm.querySelectorAll('.el-cascader-menu')[0];
          firstMenu.querySelectorAll("[tabindex='-1']")[0].focus();
        });
        e.stopPropagation();
        e.preventDefault();
      } else if (keyCode === 27 || keyCode === 9) {
        // esc  tab
        this.inputValue = '';
        if (this.menu) this.menu.visible = false;
      }
    },
    handlePick: function handlePick(value) {
      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.currentValue = value;
      this.$emit('input', value);
      this.$emit('change', value);

      if (close) {
        this.menuVisible = false;
      } else {
        this.$nextTick(this.updatePopper);
      }
    },
    handleInputChange: function handleInputChange(value) {
      var _this5 = this;

      if (!this.menuVisible) return;
      var flatOptions = this.flatOptions;

      if (!value) {
        this.menu.options = this.options;
        this.$nextTick(this.updatePopper);
        return;
      }

      var filteredFlatOptions = flatOptions.filter(function (optionsStack) {
        return optionsStack.some(function (option) {
          return new RegExp(value, 'i').test(option[_this5.labelKey]);
        });
      });

      if (filteredFlatOptions.length > 0) {
        filteredFlatOptions = filteredFlatOptions.map(function (optionStack) {
          return {
            __IS__FLAT__OPTIONS: true,
            value: optionStack.map(function (item) {
              return item[_this5.valueKey];
            }),
            label: _this5.renderFilteredOptionLabel(value, optionStack)
          };
        });
      } else {
        filteredFlatOptions = [{
          __IS__FLAT__OPTIONS: true,
          label: this.t('el.cascader.noMatch'),
          value: '',
          disabled: true
        }];
      }
      this.menu.options = filteredFlatOptions;
      this.$nextTick(this.updatePopper);
    },
    renderFilteredOptionLabel: function renderFilteredOptionLabel(inputValue, optionsStack) {
      var _this6 = this;

      return optionsStack.map(function (option, index) {
        var label = option[_this6.labelKey];
        var keywordIndex = label.toLowerCase().indexOf(inputValue.toLowerCase());
        var labelPart = label.slice(keywordIndex, inputValue.length + keywordIndex);
        var node = keywordIndex > -1 ? _this6.highlightKeyword(label, labelPart) : label;
        return index === 0 ? node : [' / ', node];
      });
    },
    highlightKeyword: function highlightKeyword(label, keyword) {
      var _this7 = this;

      var h = this._c;
      return label.split(keyword).map(function (node, index) {
        return index === 0 ? node : [h('span', { class: { 'el-cascader-menu__item__keyword': true } }, [_this7._v(keyword)]), node];
      });
    },
    flattenOptions: function flattenOptions(options) {
      var _this8 = this;

      var ancestor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var flatOptions = [];
      options.forEach(function (option) {
        var optionsStack = ancestor.concat(option);
        if (!option[_this8.childrenKey]) {
          flatOptions.push(optionsStack);
        } else {
          if (_this8.changeOnSelect) {
            flatOptions.push(optionsStack);
          }
          flatOptions = flatOptions.concat(_this8.flattenOptions(option[_this8.childrenKey], optionsStack));
        }
      });
      return flatOptions;
    },
    clearValue: function clearValue(ev) {
      ev.stopPropagation();
      this.handlePick([], true);
    },
    handleClickoutside: function handleClickoutside() {
      this.menuVisible = false;
    },
    handleClick: function handleClick() {
      if (this.cascaderDisabled) return;
      this.$refs.input.focus();
      if (this.filterable) {
        this.menuVisible = true;
        return;
      }
      this.menuVisible = !this.menuVisible;
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    }
  },

  created: function created() {
    var _this9 = this;

    this.debouncedInputChange = (0, _debounce2.default)(this.debounce, function (value) {
      var before = _this9.beforeFilter(value);

      if (before && before.then) {
        _this9.menu.options = [{
          __IS__FLAT__OPTIONS: true,
          label: _this9.t('el.cascader.loading'),
          value: '',
          disabled: true
        }];
        before.then(function () {
          _this9.$nextTick(function () {
            _this9.handleInputChange(value);
          });
        });
      } else if (before !== false) {
        _this9.$nextTick(function () {
          _this9.handleInputChange(value);
        });
      }
    });
  },
  mounted: function mounted() {
    this.flatOptions = this.flattenOptions(this.options);
  }
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _babelHelperVueJsxMergeProps = __webpack_require__(43);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _shared = __webpack_require__(24);

var _scrollIntoView = __webpack_require__(26);

var _scrollIntoView2 = _interopRequireDefault(_scrollIntoView);

var _util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyArray = function copyArray(arr, props) {
  if (!arr || !Array.isArray(arr) || !props) return arr;
  var result = [];
  var configurableProps = ['__IS__FLAT__OPTIONS', 'label', 'value', 'disabled'];
  var childrenProp = props.children || 'children';
  arr.forEach(function (item) {
    var itemCopy = {};
    configurableProps.forEach(function (prop) {
      var name = props[prop];
      var value = item[name];
      if (value === undefined) {
        name = prop;
        value = item[name];
      }
      if (value !== undefined) itemCopy[name] = value;
    });
    if (Array.isArray(item[childrenProp])) {
      itemCopy[childrenProp] = copyArray(item[childrenProp], props);
    }
    result.push(itemCopy);
  });
  return result;
};

exports.default = {
  name: 'ElCascaderMenu',

  data: function data() {
    return {
      inputWidth: 0,
      options: [],
      props: {},
      visible: false,
      activeValue: [],
      value: [],
      expandTrigger: 'click',
      changeOnSelect: false,
      popperClass: '',
      hoverTimer: 0,
      clicking: false
    };
  },


  watch: {
    visible: function visible(value) {
      if (value) {
        this.activeValue = this.value;
      }
    },

    value: {
      immediate: true,
      handler: function handler(value) {
        this.activeValue = value;
      }
    }
  },

  computed: {
    activeOptions: {
      cache: false,
      get: function get() {
        var _this = this;

        var activeValue = this.activeValue;
        var configurableProps = ['label', 'value', 'children', 'disabled'];

        var formatOptions = function formatOptions(options) {
          options.forEach(function (option) {
            if (option.__IS__FLAT__OPTIONS) return;
            configurableProps.forEach(function (prop) {
              var value = option[_this.props[prop] || prop];
              if (value !== undefined) option[prop] = value;
            });
            if (Array.isArray(option.children)) {
              formatOptions(option.children);
            }
          });
        };

        var loadActiveOptions = function loadActiveOptions(options) {
          var activeOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var level = activeOptions.length;
          activeOptions[level] = options;
          var active = activeValue[level];
          if ((0, _shared.isDef)(active)) {
            options = options.filter(function (option) {
              return option.value === active;
            })[0];
            if (options && options.children) {
              loadActiveOptions(options.children, activeOptions);
            }
          }
          return activeOptions;
        };

        var optionsCopy = copyArray(this.options, this.props);
        formatOptions(optionsCopy);
        return loadActiveOptions(optionsCopy);
      }
    },
    id: function id() {
      return (0, _util.generateId)();
    }
  },

  methods: {
    select: function select(item, menuIndex) {
      if (item.__IS__FLAT__OPTIONS) {
        this.activeValue = item.value;
      } else if (menuIndex) {
        this.activeValue.splice(menuIndex, this.activeValue.length - 1, item.value);
      } else {
        this.activeValue = [item.value];
      }
      this.$emit('pick', this.activeValue.slice());
    },
    handleMenuLeave: function handleMenuLeave() {
      this.$emit('menuLeave');
    },
    activeItem: function activeItem(item, menuIndex) {
      var len = this.activeOptions.length;
      this.activeValue.splice(menuIndex, len, item.value);
      this.activeOptions.splice(menuIndex + 1, len, item.children);
      if (this.changeOnSelect) {
        this.$emit('pick', this.activeValue.slice(), false);
      } else {
        this.$emit('activeItemChange', this.activeValue);
      }
    },
    scrollMenu: function scrollMenu(menu) {
      (0, _scrollIntoView2.default)(menu, menu.getElementsByClassName('is-active')[0]);
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.$refs.menus.forEach(function (menu) {
          return _this2.scrollMenu(menu);
        });
      });
    }
  },

  render: function render(h) {
    var _this3 = this;

    var activeValue = this.activeValue,
        activeOptions = this.activeOptions,
        visible = this.visible,
        expandTrigger = this.expandTrigger,
        popperClass = this.popperClass,
        hoverThreshold = this.hoverThreshold;

    var itemId = null;
    var itemIndex = 0;

    var hoverMenuRefs = {};
    var hoverMenuHandler = function hoverMenuHandler(e) {
      var activeMenu = hoverMenuRefs.activeMenu;
      if (!activeMenu) return;
      var offsetX = e.offsetX;
      var width = activeMenu.offsetWidth;
      var height = activeMenu.offsetHeight;

      if (e.target === hoverMenuRefs.activeItem) {
        clearTimeout(_this3.hoverTimer);
        var _hoverMenuRefs = hoverMenuRefs,
            activeItem = _hoverMenuRefs.activeItem;

        var offsetY_top = activeItem.offsetTop;
        var offsetY_Bottom = offsetY_top + activeItem.offsetHeight;

        hoverMenuRefs.hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + offsetX + ' ' + offsetY_top + ' L' + width + ' 0 V' + offsetY_top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + offsetX + ' ' + offsetY_Bottom + ' L' + width + ' ' + height + ' V' + offsetY_Bottom + ' Z" />\n        ';
      } else {
        if (!_this3.hoverTimer) {
          _this3.hoverTimer = setTimeout(function () {
            hoverMenuRefs.hoverZone.innerHTML = '';
          }, hoverThreshold);
        }
      }
    };

    var menus = this._l(activeOptions, function (menu, menuIndex) {
      var isFlat = false;
      var menuId = 'menu-' + _this3.id + '-' + menuIndex;
      var ownsId = 'menu-' + _this3.id + '-' + (menuIndex + 1);
      var items = _this3._l(menu, function (item) {
        var events = {
          on: {}
        };

        if (item.__IS__FLAT__OPTIONS) isFlat = true;

        if (!item.disabled) {
          // keydown up/down/left/right/enter
          events.on.keydown = function (ev) {
            var keyCode = ev.keyCode;
            if ([37, 38, 39, 40, 13, 9, 27].indexOf(keyCode) < 0) {
              return;
            }
            var currentEle = ev.target;
            var parentEle = _this3.$refs.menus[menuIndex];
            var menuItemList = parentEle.querySelectorAll("[tabindex='-1']");
            var currentIndex = Array.prototype.indexOf.call(menuItemList, currentEle); // 当前索引
            var nextIndex = void 0,
                nextMenu = void 0;
            if ([38, 40].indexOf(keyCode) > -1) {
              if (keyCode === 38) {
                // up键
                nextIndex = currentIndex !== 0 ? currentIndex - 1 : currentIndex;
              } else if (keyCode === 40) {
                // down
                nextIndex = currentIndex !== menuItemList.length - 1 ? currentIndex + 1 : currentIndex;
              }
              menuItemList[nextIndex].focus();
            } else if (keyCode === 37) {
              // left键
              if (menuIndex !== 0) {
                var previousMenu = _this3.$refs.menus[menuIndex - 1];
                previousMenu.querySelector('[aria-expanded=true]').focus();
              }
            } else if (keyCode === 39) {
              // right
              if (item.children) {
                // 有子menu 选择子menu的第一个menuitem
                nextMenu = _this3.$refs.menus[menuIndex + 1];
                nextMenu.querySelectorAll("[tabindex='-1']")[0].focus();
              }
            } else if (keyCode === 13) {
              if (!item.children) {
                var id = currentEle.getAttribute('id');
                parentEle.setAttribute('aria-activedescendant', id);
                _this3.select(item, menuIndex);
                _this3.$nextTick(function () {
                  return _this3.scrollMenu(_this3.$refs.menus[menuIndex]);
                });
              }
            } else if (keyCode === 9 || keyCode === 27) {
              // esc tab
              _this3.$emit('closeInside');
            }
          };
          if (item.children) {
            (function () {
              var triggerEvent = {
                click: 'click',
                hover: 'mouseenter'
              }[expandTrigger];
              var triggerHandler = function triggerHandler() {
                _this3.activeItem(item, menuIndex);
                _this3.$nextTick(function () {
                  // adjust self and next level
                  _this3.scrollMenu(_this3.$refs.menus[menuIndex]);
                  _this3.scrollMenu(_this3.$refs.menus[menuIndex + 1]);
                });
              };
              events.on[triggerEvent] = triggerHandler;
              events.on['mousedown'] = function () {
                _this3.clicking = true;
              };
              events.on['focus'] = function () {
                // focus 选中
                if (_this3.clicking) {
                  _this3.clicking = false;
                  return;
                }
                triggerHandler();
              };
            })();
          } else {
            events.on.click = function () {
              _this3.select(item, menuIndex);
              _this3.$nextTick(function () {
                return _this3.scrollMenu(_this3.$refs.menus[menuIndex]);
              });
            };
          }
        }
        if (!item.disabled && !item.children) {
          // no children set id
          itemId = menuId + '-' + itemIndex;
          itemIndex++;
        }
        return h(
          'li',
          (0, _babelHelperVueJsxMergeProps2.default)([{
            'class': {
              'el-cascader-menu__item': true,
              'el-cascader-menu__item--extensible': item.children,
              'is-active': item.value === activeValue[menuIndex],
              'is-disabled': item.disabled
            },
            ref: item.value === activeValue[menuIndex] ? 'activeItem' : null
          }, events, {
            attrs: {
              tabindex: item.disabled ? null : -1,
              role: 'menuitem',
              'aria-haspopup': !!item.children,
              'aria-expanded': item.value === activeValue[menuIndex],
              id: itemId,
              'aria-owns': !item.children ? null : ownsId
            }
          }]),
          [item.label]
        );
      });
      var menuStyle = {};
      if (isFlat) {
        menuStyle.minWidth = _this3.inputWidth + 'px';
      }

      var isHoveredMenu = expandTrigger === 'hover' && activeValue.length - 1 === menuIndex;
      var hoverMenuEvent = {
        on: {}
      };

      if (isHoveredMenu) {
        hoverMenuEvent.on.mousemove = hoverMenuHandler;
        menuStyle.position = 'relative';
      }

      return h(
        'ul',
        (0, _babelHelperVueJsxMergeProps2.default)([{
          'class': {
            'el-cascader-menu': true,
            'el-cascader-menu--flexible': isFlat
          }
        }, hoverMenuEvent, {
          style: menuStyle,
          refInFor: true,
          ref: 'menus',
          attrs: { role: 'menu',
            id: menuId
          }
        }]),
        [items, isHoveredMenu ? h(
          'svg',
          {
            ref: 'hoverZone',
            style: {
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%',
              left: 0,
              pointerEvents: 'none'
            }
          },
          []
        ) : null]
      );
    });

    if (expandTrigger === 'hover') {
      this.$nextTick(function () {
        var activeItem = _this3.$refs.activeItem;

        if (activeItem) {
          var activeMenu = activeItem.parentElement;
          var hoverZone = _this3.$refs.hoverZone;

          hoverMenuRefs = {
            activeMenu: activeMenu,
            activeItem: activeItem,
            hoverZone: hoverZone
          };
        } else {
          hoverMenuRefs = {};
        }
      });
    }

    return h(
      'transition',
      {
        attrs: { name: 'el-zoom-in-top' },
        on: {
          'before-enter': this.handleMenuEnter,
          'after-leave': this.handleMenuLeave
        }
      },
      [h(
        'div',
        {
          directives: [{
            name: 'show',
            value: visible
          }],

          'class': ['el-cascader-menus el-popper', popperClass],
          ref: 'wrapper'
        },
        [h(
          'div',
          {
            attrs: { 'x-arrow': true },
            'class': 'popper__arrow' },
          []
        ), menus]
      )]
    );
  }
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClickoutside),expression:"handleClickoutside"}],ref:"reference",staticClass:"el-cascader",class:[
    {
      'is-opened': _vm.menuVisible,
      'is-disabled': _vm.cascaderDisabled
    },
    _vm.cascaderSize ? 'el-cascader--' + _vm.cascaderSize : ''
  ],on:{"click":_vm.handleClick,"mouseenter":function($event){_vm.inputHover = true},"focus":function($event){_vm.inputHover = true},"mouseleave":function($event){_vm.inputHover = false},"blur":function($event){_vm.inputHover = false},"keydown":_vm.handleKeydown}},[_c('el-input',{ref:"input",attrs:{"readonly":!_vm.filterable,"placeholder":_vm.currentLabels.length ? undefined : _vm.placeholder,"validate-event":false,"size":_vm.size,"disabled":_vm.cascaderDisabled},on:{"input":_vm.debouncedInputChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('template',{attrs:{"slot":"suffix"},slot:"suffix"},[(_vm.clearable && _vm.inputHover && _vm.currentLabels.length)?_c('i',{key:"1",staticClass:"el-input__icon el-icon-circle-close el-cascader__clearIcon",on:{"click":_vm.clearValue}}):_c('i',{key:"2",staticClass:"el-input__icon el-icon-arrow-down",class:{ 'is-reverse': _vm.menuVisible }})])],2),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputValue === ''),expression:"inputValue === ''"}],staticClass:"el-cascader__label"},[(_vm.showAllLevels)?[_vm._l((_vm.currentLabels),function(label,index){return [_vm._v("\n        "+_vm._s(label)+"\n        "),(index < _vm.currentLabels.length - 1)?_c('span',[_vm._v(" "+_vm._s(_vm.separator)+" ")]):_vm._e()]})]:[_vm._v("\n      "+_vm._s(_vm.currentLabels[_vm.currentLabels.length - 1])+"\n    ")]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(364);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddeee594_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddeee594_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _color = __webpack_require__(45);

var _color2 = _interopRequireDefault(_color);

var _pickerDropdown = __webpack_require__(366);

var _pickerDropdown2 = _interopRequireDefault(_pickerDropdown);

var _clickoutside = __webpack_require__(9);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElColorPicker',

  props: {
    value: String,
    showAlpha: Boolean,
    colorFormat: String,
    disabled: Boolean,
    size: String,
    popperClass: String,
    predefine: Array
  },

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  directives: { Clickoutside: _clickoutside2.default },

  computed: {
    displayedColor: function displayedColor() {
      if (!this.value && !this.showPanelColor) {
        return 'transparent';
      }

      return this.displayedRgb(this.color, this.showAlpha);
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    colorSize: function colorSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    colorDisabled: function colorDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    value: function value(val) {
      if (!val) {
        this.showPanelColor = false;
      } else if (val && val !== this.color.value) {
        this.color.fromString(val);
      }
    },

    color: {
      deep: true,
      handler: function handler() {
        this.showPanelColor = true;
      }
    },
    displayedColor: function displayedColor(val) {
      var currentValueColor = new _color2.default({
        enableAlpha: this.showAlpha,
        format: this.colorFormat
      });
      currentValueColor.fromString(this.value);

      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
      if (val !== currentValueColorRgb) {
        this.$emit('active-change', val);
      }
    }
  },

  methods: {
    handleTrigger: function handleTrigger() {
      if (this.colorDisabled) return;
      this.showPicker = !this.showPicker;
    },
    confirmValue: function confirmValue(value) {
      this.$emit('input', this.color.value);
      this.$emit('change', this.color.value);
      this.showPicker = false;
    },
    clearValue: function clearValue() {
      this.$emit('input', null);
      this.$emit('change', null);
      this.showPanelColor = false;
      this.showPicker = false;
      this.resetColor();
    },
    hide: function hide() {
      this.showPicker = false;
      this.resetColor();
    },
    resetColor: function resetColor() {
      var _this = this;

      this.$nextTick(function (_) {
        if (_this.value) {
          _this.color.fromString(_this.value);
        } else {
          _this.showPanelColor = false;
        }
      });
    },
    displayedRgb: function displayedRgb(color, showAlpha) {
      if (!(color instanceof _color2.default)) {
        throw Error('color should be instance of Color Class');
      }

      var _color$toRgb = color.toRgb(),
          r = _color$toRgb.r,
          g = _color$toRgb.g,
          b = _color$toRgb.b;

      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  },

  mounted: function mounted() {
    var value = this.value;
    if (value) {
      this.color.fromString(value);
    }
    this.popperElm = this.$refs.dropdown.$el;
  },
  data: function data() {
    var color = new _color2.default({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });
    return {
      color: color,
      showPicker: false,
      showPanelColor: false
    };
  },


  components: {
    PickerDropdown: _pickerDropdown2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_dropdown_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba5ff98_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_dropdown_vue__ = __webpack_require__(380);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_dropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba5ff98_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _svPanel = __webpack_require__(368);

var _svPanel2 = _interopRequireDefault(_svPanel);

var _hueSlider = __webpack_require__(371);

var _hueSlider2 = _interopRequireDefault(_hueSlider);

var _alphaSlider = __webpack_require__(374);

var _alphaSlider2 = _interopRequireDefault(_alphaSlider);

var _predefine = __webpack_require__(377);

var _predefine2 = _interopRequireDefault(_predefine);

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'el-color-picker-dropdown',

  mixins: [_vuePopper2.default, _locale2.default],

  components: {
    SvPanel: _svPanel2.default,
    HueSlider: _hueSlider2.default,
    AlphaSlider: _alphaSlider2.default,
    ElInput: _input2.default,
    ElButton: _button2.default,
    Predefine: _predefine2.default
  },

  props: {
    color: {
      required: true
    },
    showAlpha: Boolean,
    predefine: Array
  },

  data: function data() {
    return {
      customInput: ''
    };
  },


  computed: {
    currentColor: function currentColor() {
      var parent = this.$parent;
      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
    }
  },

  methods: {
    confirmValue: function confirmValue() {
      this.$emit('pick');
    },
    handleConfirm: function handleConfirm() {
      this.color.fromString(this.customInput);
    }
  },

  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },


  watch: {
    showPopper: function showPopper(val) {
      var _this = this;

      if (val === true) {
        this.$nextTick(function () {
          var _$refs = _this.$refs,
              sl = _$refs.sl,
              hue = _$refs.hue,
              alpha = _$refs.alpha;

          sl && sl.update();
          hue && hue.update();
          alpha && alpha.update();
        });
      }
    },
    currentColor: function currentColor(val) {
      this.customInput = val;
    }
  }
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sv_panel_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sv_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sv_panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efd9e06_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sv_panel_vue__ = __webpack_require__(370);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sv_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efd9e06_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sv_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _draggable = __webpack_require__(30);

var _draggable2 = _interopRequireDefault(_draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'el-sl-panel',

  props: {
    color: {
      required: true
    }
  },

  computed: {
    colorValue: function colorValue() {
      var hue = this.color.get('hue');
      var value = this.color.get('value');
      return { hue: hue, value: value };
    }
  },

  watch: {
    colorValue: function colorValue() {
      this.update();
    }
  },

  methods: {
    update: function update() {
      var saturation = this.color.get('saturation');
      var value = this.color.get('value');

      var el = this.$el;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          width = _el$getBoundingClient.width,
          height = _el$getBoundingClient.height;

      if (!height) height = width * 3 / 4;

      this.cursorLeft = saturation * width / 100;
      this.cursorTop = (100 - value) * height / 100;

      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
    },
    handleDrag: function handleDrag(event) {
      var el = this.$el;
      var rect = el.getBoundingClientRect();

      var left = event.clientX - rect.left;
      var top = event.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);

      top = Math.max(0, top);
      top = Math.min(top, rect.height);

      this.cursorLeft = left;
      this.cursorTop = top;
      this.color.set({
        saturation: left / rect.width * 100,
        value: 100 - top / rect.height * 100
      });
    }
  },

  mounted: function mounted() {
    var _this = this;

    (0, _draggable2.default)(this.$el, {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    });

    this.update();
  },
  data: function data() {
    return {
      cursorTop: 0,
      cursorLeft: 0,
      background: 'hsl(0, 100%, 50%)'
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-color-svpanel",style:({
      backgroundColor: _vm.background
    })},[_c('div',{staticClass:"el-color-svpanel__white"}),_c('div',{staticClass:"el-color-svpanel__black"}),_c('div',{staticClass:"el-color-svpanel__cursor",style:({
      top: _vm.cursorTop + 'px',
      left: _vm.cursorLeft + 'px'
    })},[_c('div')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hue_slider_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hue_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hue_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3709e77c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hue_slider_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hue_slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3709e77c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hue_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _draggable = __webpack_require__(30);

var _draggable2 = _interopRequireDefault(_draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'el-color-hue-slider',

  props: {
    color: {
      required: true
    },

    vertical: Boolean
  },

  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0
    };
  },


  computed: {
    hueValue: function hueValue() {
      var hue = this.color.get('hue');
      return hue;
    }
  },

  watch: {
    hueValue: function hueValue() {
      this.update();
    }
  },

  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;

      var hue = void 0;

      if (!this.vertical) {
        var left = event.clientX - rect.left;
        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
        left = Math.max(thumb.offsetWidth / 2, left);

        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
      } else {
        var top = event.clientY - rect.top;
        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
        top = Math.max(thumb.offsetHeight / 2, top);

        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
      }

      this.color.set('hue', hue);
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
    },
    update: function update() {
      this.thumbLeft = this.getThumbLeft();
      this.thumbTop = this.getThumbTop();
    }
  },

  mounted: function mounted() {
    var _this = this;

    var _$refs = this.$refs,
        bar = _$refs.bar,
        thumb = _$refs.thumb;


    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };

    (0, _draggable2.default)(bar, dragConfig);
    (0, _draggable2.default)(thumb, dragConfig);
    this.update();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-color-hue-slider",class:{ 'is-vertical': _vm.vertical }},[_c('div',{ref:"bar",staticClass:"el-color-hue-slider__bar",on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"el-color-hue-slider__thumb",style:({
         left: _vm.thumbLeft + 'px',
         top: _vm.thumbTop + 'px'
       })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alpha_slider_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alpha_slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alpha_slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219b4f1c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alpha_slider_vue__ = __webpack_require__(376);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alpha_slider_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219b4f1c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alpha_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _draggable = __webpack_require__(30);

var _draggable2 = _interopRequireDefault(_draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'el-color-alpha-slider',

  props: {
    color: {
      required: true
    },
    vertical: Boolean
  },

  watch: {
    'color._alpha': function color_alpha() {
      this.update();
    },
    'color.value': function colorValue() {
      this.update();
    }
  },

  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;


      if (!this.vertical) {
        var left = event.clientX - rect.left;
        left = Math.max(thumb.offsetWidth / 2, left);
        left = Math.min(left, rect.width - thumb.offsetWidth / 2);

        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
      } else {
        var top = event.clientY - rect.top;
        top = Math.max(thumb.offsetHeight / 2, top);
        top = Math.min(top, rect.height - thumb.offsetHeight / 2);

        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
      }
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
    },
    getBackground: function getBackground() {
      if (this.color && this.color.value) {
        var _color$toRgb = this.color.toRgb(),
            r = _color$toRgb.r,
            g = _color$toRgb.g,
            b = _color$toRgb.b;

        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
      }
      return null;
    },
    update: function update() {
      this.thumbLeft = this.getThumbLeft();
      this.thumbTop = this.getThumbTop();
      this.background = this.getBackground();
    }
  },

  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0,
      background: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var _$refs = this.$refs,
        bar = _$refs.bar,
        thumb = _$refs.thumb;


    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };

    (0, _draggable2.default)(bar, dragConfig);
    (0, _draggable2.default)(thumb, dragConfig);
    this.update();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-color-alpha-slider",class:{ 'is-vertical': _vm.vertical }},[_c('div',{ref:"bar",staticClass:"el-color-alpha-slider__bar",style:({
         background: _vm.background
       }),on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"el-color-alpha-slider__thumb",style:({
         left: _vm.thumbLeft + 'px',
         top: _vm.thumbTop + 'px'
       })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_predefine_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_predefine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_predefine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e24dc3c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_predefine_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_predefine_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e24dc3c_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_predefine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _color = __webpack_require__(45);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    colors: { type: Array, required: true },
    color: { required: true }
  },
  data: function data() {
    return {
      rgbaColors: this.parseColors(this.colors, this.color)
    };
  },

  methods: {
    handleSelect: function handleSelect(index) {
      this.color.fromString(this.colors[index]);
    },
    parseColors: function parseColors(colors, color) {
      return colors.map(function (value) {
        var c = new _color2.default();
        c.enableAlpha = true;
        c.format = 'rgba';
        c.fromString(value);
        c.selected = c.value === color.value;
        return c;
      });
    }
  },
  watch: {
    '$parent.currentColor': function $parentCurrentColor(val) {
      var color = new _color2.default();
      color.fromString(val);

      this.rgbaColors.forEach(function (item) {
        item.selected = color.compare(item);
      });
    },
    colors: function colors(newVal) {
      this.rgbaColors = this.parseColors(newVal, this.color);
    },
    color: function color(newVal) {
      this.rgbaColors = this.parseColors(this.colors, newVal);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-color-predefine"},[_c('div',{staticClass:"el-color-predefine__colors"},_vm._l((_vm.rgbaColors),function(item,index){return _c('div',{key:_vm.colors[index],staticClass:"el-color-predefine__color-selector",class:{selected: item.selected, 'is-alpha': item._alpha < 100},on:{"click":function($event){_vm.handleSelect(index)}}},[_c('div',{style:({'background-color': item.value})})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-color-dropdown"},[_c('div',{staticClass:"el-color-dropdown__main-wrapper"},[_c('hue-slider',{ref:"hue",staticStyle:{"float":"right"},attrs:{"color":_vm.color,"vertical":""}}),_c('sv-panel',{ref:"sl",attrs:{"color":_vm.color}})],1),(_vm.showAlpha)?_c('alpha-slider',{ref:"alpha",attrs:{"color":_vm.color}}):_vm._e(),(_vm.predefine)?_c('predefine',{attrs:{"color":_vm.color,"colors":_vm.predefine}}):_vm._e(),_c('div',{staticClass:"el-color-dropdown__btns"},[_c('span',{staticClass:"el-color-dropdown__value"},[_c('el-input',{attrs:{"size":"mini"},on:{"blur":_vm.handleConfirm},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleConfirm($event)}},model:{value:(_vm.customInput),callback:function ($$v) {_vm.customInput=$$v},expression:"customInput"}})],1),_c('el-button',{staticClass:"el-color-dropdown__link-btn",attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.$emit('clear')}}},[_vm._v("\n        "+_vm._s(_vm.t('el.colorpicker.clear'))+"\n      ")]),_c('el-button',{staticClass:"el-color-dropdown__btn",attrs:{"plain":"","size":"mini"},on:{"click":_vm.confirmValue}},[_vm._v("\n        "+_vm._s(_vm.t('el.colorpicker.confirm'))+"\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.hide),expression:"hide"}],class:[
    'el-color-picker',
    _vm.colorDisabled ? 'is-disabled' : '',
    _vm.colorSize ? ("el-color-picker--" + _vm.colorSize) : ''
  ]},[(_vm.colorDisabled)?_c('div',{staticClass:"el-color-picker__mask"}):_vm._e(),_c('div',{staticClass:"el-color-picker__trigger",on:{"click":_vm.handleTrigger}},[_c('span',{staticClass:"el-color-picker__color",class:{ 'is-alpha': _vm.showAlpha }},[_c('span',{staticClass:"el-color-picker__color-inner",style:({
          backgroundColor: _vm.displayedColor
        })}),(!_vm.value && !_vm.showPanelColor)?_c('span',{staticClass:"el-color-picker__empty el-icon-close"}):_vm._e()]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.value || _vm.showPanelColor),expression:"value || showPanelColor"}],staticClass:"el-color-picker__icon el-icon-arrow-down"})]),_c('picker-dropdown',{ref:"dropdown",class:['el-color-picker__panel', _vm.popperClass || ''],attrs:{"color":_vm.color,"show-alpha":_vm.showAlpha,"predefine":_vm.predefine},on:{"pick":_vm.confirmValue,"clear":_vm.clearValue},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(383);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc737e3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(388);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc737e3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _button = __webpack_require__(15);

var _button2 = _interopRequireDefault(_button);

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

var _transferPanel = __webpack_require__(385);

var _transferPanel2 = _interopRequireDefault(_transferPanel);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTransfer',

  mixins: [_emitter2.default, _locale2.default, _migrating2.default],

  components: {
    TransferPanel: _transferPanel2.default,
    ElButton: _button2.default
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    buttonTexts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    filterMethod: Function,
    leftDefaultChecked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rightDefaultChecked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderContent: Function,
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    format: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterable: Boolean,
    props: {
      type: Object,
      default: function _default() {
        return {
          label: 'label',
          key: 'key',
          disabled: 'disabled'
        };
      }
    },
    targetOrder: {
      type: String,
      default: 'original'
    }
  },

  data: function data() {
    return {
      leftChecked: [],
      rightChecked: []
    };
  },


  computed: {
    dataObj: function dataObj() {
      var key = this.props.key;
      return this.data.reduce(function (o, cur) {
        return (o[cur[key]] = cur) && o;
      }, {});
    },
    sourceData: function sourceData() {
      var _this = this;

      return this.data.filter(function (item) {
        return _this.value.indexOf(item[_this.props.key]) === -1;
      });
    },
    targetData: function targetData() {
      var _this2 = this;

      return this.targetOrder === 'original' ? this.data.filter(function (item) {
        return _this2.value.indexOf(item[_this2.props.key]) > -1;
      }) : this.value.map(function (key) {
        return _this2.dataObj[key];
      });
    },
    hasButtonTexts: function hasButtonTexts() {
      return this.buttonTexts.length === 2;
    }
  },

  watch: {
    value: function value(val) {
      this.dispatch('ElFormItem', 'el.form.change', val);
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'footer-format': 'footer-format is renamed to format.'
        }
      };
    },
    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
      this.leftChecked = val;
      if (movedKeys === undefined) return;
      this.$emit('left-check-change', val, movedKeys);
    },
    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
      this.rightChecked = val;
      if (movedKeys === undefined) return;
      this.$emit('right-check-change', val, movedKeys);
    },
    addToLeft: function addToLeft() {
      var currentValue = this.value.slice();
      this.rightChecked.forEach(function (item) {
        var index = currentValue.indexOf(item);
        if (index > -1) {
          currentValue.splice(index, 1);
        }
      });
      this.$emit('input', currentValue);
      this.$emit('change', currentValue, 'left', this.rightChecked);
    },
    addToRight: function addToRight() {
      var _this3 = this;

      var currentValue = this.value.slice();
      var itemsToBeMoved = [];
      var key = this.props.key;
      this.data.forEach(function (item) {
        var itemKey = item[key];
        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
          itemsToBeMoved.push(itemKey);
        }
      });
      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
      this.$emit('input', currentValue);
      this.$emit('change', currentValue, 'right', this.leftChecked);
    },
    clearQuery: function clearQuery(which) {
      if (which === 'left') {
        this.$refs.leftPanel.query = '';
      } else if (which === 'right') {
        this.$refs.rightPanel.query = '';
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_panel_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f8be68_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_panel_vue__ = __webpack_require__(387);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f8be68_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkboxGroup = __webpack_require__(37);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

var _checkbox = __webpack_require__(14);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _locale = __webpack_require__(2);

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_locale2.default],

  name: 'ElTransferPanel',

  componentName: 'ElTransferPanel',

  components: {
    ElCheckboxGroup: _checkboxGroup2.default,
    ElCheckbox: _checkbox2.default,
    ElInput: _input2.default,
    OptionContent: {
      props: {
        option: Object
      },
      render: function render(h) {
        var getParent = function getParent(vm) {
          if (vm.$options.componentName === 'ElTransferPanel') {
            return vm;
          } else if (vm.$parent) {
            return getParent(vm.$parent);
          } else {
            return vm;
          }
        };
        var panel = getParent(this);
        var transfer = panel.$parent || panel;
        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h(
          'span',
          null,
          [this.option[panel.labelProp] || this.option[panel.keyProp]]
        );
      }
    }
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderContent: Function,
    placeholder: String,
    title: String,
    filterable: Boolean,
    format: Object,
    filterMethod: Function,
    defaultChecked: Array,
    props: Object
  },

  data: function data() {
    return {
      checked: [],
      allChecked: false,
      query: '',
      inputHover: false,
      checkChangeByUser: true
    };
  },


  watch: {
    checked: function checked(val, oldVal) {
      this.updateAllChecked();
      if (this.checkChangeByUser) {
        var movedKeys = val.concat(oldVal).filter(function (v) {
          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
        });
        this.$emit('checked-change', val, movedKeys);
      } else {
        this.$emit('checked-change', val);
        this.checkChangeByUser = true;
      }
    },
    data: function data() {
      var _this = this;

      var checked = [];
      var filteredDataKeys = this.filteredData.map(function (item) {
        return item[_this.keyProp];
      });
      this.checked.forEach(function (item) {
        if (filteredDataKeys.indexOf(item) > -1) {
          checked.push(item);
        }
      });
      this.checkChangeByUser = false;
      this.checked = checked;
    },
    checkableData: function checkableData() {
      this.updateAllChecked();
    },


    defaultChecked: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var _this2 = this;

        if (oldVal && val.length === oldVal.length && val.every(function (item) {
          return oldVal.indexOf(item) > -1;
        })) return;
        var checked = [];
        var checkableDataKeys = this.checkableData.map(function (item) {
          return item[_this2.keyProp];
        });
        val.forEach(function (item) {
          if (checkableDataKeys.indexOf(item) > -1) {
            checked.push(item);
          }
        });
        this.checkChangeByUser = false;
        this.checked = checked;
      }
    }
  },

  computed: {
    filteredData: function filteredData() {
      var _this3 = this;

      return this.data.filter(function (item) {
        if (typeof _this3.filterMethod === 'function') {
          return _this3.filterMethod(_this3.query, item);
        } else {
          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
        }
      });
    },
    checkableData: function checkableData() {
      var _this4 = this;

      return this.filteredData.filter(function (item) {
        return !item[_this4.disabledProp];
      });
    },
    checkedSummary: function checkedSummary() {
      var checkedLength = this.checked.length;
      var dataLength = this.data.length;
      var _format = this.format,
          noChecked = _format.noChecked,
          hasChecked = _format.hasChecked;

      if (noChecked && hasChecked) {
        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
      } else {
        return checkedLength + '/' + dataLength;
      }
    },
    isIndeterminate: function isIndeterminate() {
      var checkedLength = this.checked.length;
      return checkedLength > 0 && checkedLength < this.checkableData.length;
    },
    hasNoMatch: function hasNoMatch() {
      return this.query.length > 0 && this.filteredData.length === 0;
    },
    inputIcon: function inputIcon() {
      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
    },
    labelProp: function labelProp() {
      return this.props.label || 'label';
    },
    keyProp: function keyProp() {
      return this.props.key || 'key';
    },
    disabledProp: function disabledProp() {
      return this.props.disabled || 'disabled';
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.default;
    }
  },

  methods: {
    updateAllChecked: function updateAllChecked() {
      var _this5 = this;

      var checkableDataKeys = this.checkableData.map(function (item) {
        return item[_this5.keyProp];
      });
      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
        return _this5.checked.indexOf(item) > -1;
      });
    },
    handleAllCheckedChange: function handleAllCheckedChange(value) {
      var _this6 = this;

      this.checked = value ? this.checkableData.map(function (item) {
        return item[_this6.keyProp];
      }) : [];
    },
    clearQuery: function clearQuery() {
      if (this.inputIcon === 'circle-close') {
        this.query = '';
      }
    }
  }
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-transfer-panel"},[_c('p',{staticClass:"el-transfer-panel__header"},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleAllCheckedChange},model:{value:(_vm.allChecked),callback:function ($$v) {_vm.allChecked=$$v},expression:"allChecked"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',[_vm._v(_vm._s(_vm.checkedSummary))])])],1),_c('div',{class:['el-transfer-panel__body', _vm.hasFooter ? 'is-with-footer' : '']},[(_vm.filterable)?_c('el-input',{staticClass:"el-transfer-panel__filter",attrs:{"size":"small","placeholder":_vm.placeholder},nativeOn:{"mouseenter":function($event){_vm.inputHover = true},"mouseleave":function($event){_vm.inputHover = false}},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}},[_c('i',{class:['el-input__icon', 'el-icon-' + _vm.inputIcon],attrs:{"slot":"prefix"},on:{"click":_vm.clearQuery},slot:"prefix"})]):_vm._e(),_c('el-checkbox-group',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasNoMatch && _vm.data.length > 0),expression:"!hasNoMatch && data.length > 0"}],staticClass:"el-transfer-panel__list",class:{ 'is-filterable': _vm.filterable },model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},_vm._l((_vm.filteredData),function(item){return _c('el-checkbox',{key:item[_vm.keyProp],staticClass:"el-transfer-panel__item",attrs:{"label":item[_vm.keyProp],"disabled":item[_vm.disabledProp]}},[_c('option-content',{attrs:{"option":item}})],1)})),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoMatch),expression:"hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t('el.transfer.noMatch')))]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length === 0 && !_vm.hasNoMatch),expression:"data.length === 0 && !hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t('el.transfer.noData')))])],1),(_vm.hasFooter)?_c('p',{staticClass:"el-transfer-panel__footer"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-transfer"},[_c('transfer-panel',_vm._b({ref:"leftPanel",attrs:{"data":_vm.sourceData,"title":_vm.titles[0] || _vm.t('el.transfer.titles.0'),"default-checked":_vm.leftDefaultChecked,"placeholder":_vm.filterPlaceholder || _vm.t('el.transfer.filterPlaceholder')},on:{"checked-change":_vm.onSourceCheckedChange}},'transfer-panel',_vm.$props,false),[_vm._t("left-footer")],2),_c('div',{staticClass:"el-transfer__buttons"},[_c('el-button',{class:['el-transfer__button', _vm.hasButtonTexts ? 'is-with-texts' : ''],attrs:{"type":"primary","disabled":_vm.rightChecked.length === 0},nativeOn:{"click":function($event){_vm.addToLeft($event)}}},[_c('i',{staticClass:"el-icon-arrow-left"}),(_vm.buttonTexts[0] !== undefined)?_c('span',[_vm._v(_vm._s(_vm.buttonTexts[0]))]):_vm._e()]),_c('el-button',{class:['el-transfer__button', _vm.hasButtonTexts ? 'is-with-texts' : ''],attrs:{"type":"primary","disabled":_vm.leftChecked.length === 0},nativeOn:{"click":function($event){_vm.addToRight($event)}}},[(_vm.buttonTexts[1] !== undefined)?_c('span',[_vm._v(_vm._s(_vm.buttonTexts[1]))]):_vm._e(),_c('i',{staticClass:"el-icon-arrow-right"})])],1),_c('transfer-panel',_vm._b({ref:"rightPanel",attrs:{"data":_vm.targetData,"title":_vm.titles[1] || _vm.t('el.transfer.titles.1'),"default-checked":_vm.rightDefaultChecked,"placeholder":_vm.filterPlaceholder || _vm.t('el.transfer.filterPlaceholder')},on:{"checked-change":_vm.onTargetCheckedChange}},'transfer-panel',_vm.$props,false),[_vm._t("right-footer")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(390);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_956d8bb2_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(392);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_956d8bb2_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//

exports.default = {
  name: 'ElContainer',

  componentName: 'ElContainer',

  props: {
    direction: String
  },

  computed: {
    isVertical: function isVertical() {
      if (this.direction === 'vertical') {
        return true;
      } else if (this.direction === 'horizontal') {
        return false;
      }
      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
        var tag = vnode.componentOptions && vnode.componentOptions.tag;
        return tag === 'el-header' || tag === 'el-footer';
      }) : false;
    }
  }
};

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"el-container",class:{ 'is-vertical': _vm.isVertical }},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(394);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634a9d7e_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(396);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634a9d7e_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//

exports.default = {
  name: 'ElHeader',

  componentName: 'ElHeader',

  props: {
    height: {
      type: String,
      default: '60px'
    }
  }
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"el-header",style:({ height: _vm.height })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(398);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a954950_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(400);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a954950_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//

exports.default = {
  name: 'ElAside',

  componentName: 'ElAside',

  props: {
    width: {
      type: String,
      default: '300px'
    }
  }
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"el-aside",style:({ width: _vm.width })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(402);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76da1255_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(404);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76da1255_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//

exports.default = {
  name: 'ElMain',
  componentName: 'ElMain'
};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"el-main"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(406);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6320c4f3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(408);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6320c4f3_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//

exports.default = {
  name: 'ElFooter',

  componentName: 'ElFooter',

  props: {
    height: {
      type: String,
      default: '60px'
    }
  }
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"el-footer",style:({ height: _vm.height })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(92);

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    }
  }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
exports.default = {
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      if (definedProps.hasOwnProperty(propName) && props[propName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      if (definedEvents.hasOwnProperty(eventName) && events[eventName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__(95);

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__(265);

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__(97);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idSeed = 1;
var transitions = [];

var hookTransition = function hookTransition(transition) {
  if (transitions.indexOf(transition) !== -1) return;

  var getVueInstance = function getVueInstance(element) {
    var instance = element.__vue__;
    if (!instance) {
      var textNode = element.previousSibling;
      if (textNode.__vue__) {
        instance = textNode.__vue__;
      }
    }
    return instance;
  };

  _vue2.default.transition(transition, {
    afterEnter: function afterEnter(el) {
      var instance = getVueInstance(el);

      if (instance) {
        instance.doAfterOpen && instance.doAfterOpen();
      }
    },
    afterLeave: function afterLeave(el) {
      var instance = getVueInstance(el);

      if (instance) {
        instance.doAfterClose && instance.doAfterClose();
      }
    }
  });
};

var scrollBarWidth = void 0;

var getDOM = function getDOM(dom) {
  if (dom.nodeType === 3) {
    dom = dom.nextElementSibling || dom.nextSibling;
    getDOM(dom);
  }
  return dom;
};

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: ''
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  created: function created() {
    if (this.transition) {
      hookTransition(this.transition);
    }
  },
  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);
    if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
      document.body.style.overflow = this.bodyOverflow;
      document.body.style.paddingRight = this.bodyPaddingRight;
    }
    this.bodyOverflow = null;
    this.bodyPaddingRight = null;
  },
  data: function data() {
    return {
      opened: false,
      bodyOverflow: null,
      bodyPaddingRight: null,
      rendered: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = getDOM(this.$el);

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          if (!this.bodyOverflow) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.bodyOverflow = document.body.style.overflow;
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll')) {
            document.body.style.paddingRight = scrollBarWidth + 'px';
          }
          document.body.style.overflow = 'hidden';
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      if (!this.transition) {
        this.doAfterOpen();
      }
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      var _this4 = this;

      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(function () {
          if (_this4.modal && _this4.bodyOverflow !== 'hidden') {
            document.body.style.overflow = _this4.bodyOverflow;
            document.body.style.paddingRight = _this4.bodyPaddingRight;
          }
          _this4.bodyOverflow = null;
          _this4.bodyPaddingRight = null;
        }, 200);
      }

      this.opened = false;

      if (!this.transition) {
        this.doAfterClose();
      }
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  return startClick = e;
});

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports.default = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   noTrailing     Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   debounceMode   If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function ( delay, noTrailing, callback, debounceMode ) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if ( typeof noTrailing !== 'boolean' ) {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper () {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec () {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear () {
			timeoutID = undefined;
		}

		if ( debounceMode && !timeoutID ) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if ( timeoutID ) {
			clearTimeout(timeoutID);
		}

		if ( debounceMode === undefined && elapsed > delay ) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();

		} else if ( noTrailing !== true ) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}

	}

	// Return the wrapper function.
	return wrapper;

};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 396);
/******/ })
/************************************************************************/
/******/ ({

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(397);


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(398);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _resizeEvent = __webpack_require__(18);

var _scrollbarWidth = __webpack_require__(38);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _util = __webpack_require__(3);

var _bar = __webpack_require__(399);

var _bar2 = _interopRequireDefault(_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js

exports.default = {
  name: 'ElScrollbar',

  components: { Bar: _bar2.default },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },

  render: function render(h) {
    var gutter = (0, _scrollbarWidth2.default)();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = '-' + gutter + 'px';
      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

      if (Array.isArray(this.wrapStyle)) {
        style = (0, _util.toObject)(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll
        },

        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      nodes = [wrap, h(
        _bar2.default,
        {
          attrs: {
            move: this.moveX,
            size: this.sizeWidth }
        },
        []
      ), h(
        _bar2.default,
        {
          attrs: {
            vertical: true,
            move: this.moveY,
            size: this.sizeHeight }
        },
        []
      )];
    } else {
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'el-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'el-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;

      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
    },
    update: function update() {
      var heightPercentage = void 0,
          widthPercentage = void 0;
      var wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$refs.resize, this.update);
  }
};

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(2);

var _util = __webpack_require__(400);

/* istanbul ignore next */
exports.default = {
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number
  },

  computed: {
    bar: function bar() {
      return _util.BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar;


    return h(
      'div',
      {
        'class': ['el-scrollbar__bar', 'is-' + bar.key],
        on: {
          'mousedown': this.clickTrackHandler
        }
      },
      [h(
        'div',
        {
          ref: 'thumb',
          'class': 'el-scrollbar__thumb',
          on: {
            'mousedown': this.clickThumbHandler
          },

          style: (0, _util.renderThumbStyle)({ size: size, move: move, bar: bar }) },
        []
      )]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      (0, _dom.on)(document, 'mousemove', this.mouseMoveDocumentHandler);
      (0, _dom.on)(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      (0, _dom.off)(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    (0, _dom.off)(document, 'mouseup', this.mouseUpDocumentHandler);
  }
};

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.renderThumbStyle = renderThumbStyle;
var BAR_MAP = exports.BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};

function renderThumbStyle(_ref) {
  var move = _ref.move,
      size = _ref.size,
      bar = _ref.bar;

  var style = {};
  var translate = 'translate' + bar.axis + '(' + move + '%)';

  style[bar.size] = size;
  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;

  return style;
};

/***/ })

/******/ });

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isVNode = isVNode;
exports.getFirstComponentChild = getFirstComponentChild;

var _util = __webpack_require__(35);

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

function getFirstComponentChild(children) {
  return children && children.filter(function (c) {
    return c && c.tag;
  })[0];
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 283);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(284);


/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tag = __webpack_require__(285);

var _tag2 = _interopRequireDefault(_tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tag2.default.install = function (Vue) {
  Vue.component(_tag2.default.name, _tag2.default);
};

exports.default = _tag2.default;

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466877f5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tag_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tag_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466877f5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElTag',
  props: {
    text: String,
    closable: Boolean,
    type: String,
    hit: Boolean,
    disableTransitions: Boolean,
    color: String,
    size: String
  },
  methods: {
    handleClose: function handleClose(event) {
      this.$emit('close', event);
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  }
};

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.disableTransitions ? '' : 'el-zoom-in-center'}},[_c('span',{staticClass:"el-tag",class:[
      _vm.type ? 'el-tag--' + _vm.type : '',
      _vm.tagSize && ("el-tag--" + _vm.tagSize),
      {'is-hit': _vm.hit}
    ],style:({backgroundColor: _vm.color})},[_vm._t("default"),(_vm.closable)?_c('i',{staticClass:"el-tag__close el-icon-close",on:{"click":function($event){$event.stopPropagation();_vm.handleClose($event)}}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = scrollIntoView;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollIntoView(container, selected) {
  if (_vue2.default.prototype.$isServer) return;

  if (!selected) {
    container.scrollTop = 0;
    return;
  }

  var top = selected.offsetTop;
  var bottom = selected.offsetTop + selected.offsetHeight;
  var viewRectTop = container.scrollTop;
  var viewRectBottom = viewRectTop + container.clientHeight;

  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_en__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW__);




/* harmony default export */ __webpack_exports__["a"] = ({
  'en': __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_en___default.a,
  'zh-CN': __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_zh_CN___default.a,
  'zh-TW': __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_zh_TW___default.a
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tree__ = __webpack_require__(155);



/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    var _this = this;

    return h(
      'div',
      { 'class': this.showMenu ? 'show' : '' },
      [h(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
          'class': 'close sp-hidden-pc'
        }, {
          on: {
            'click': function click($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              (function () {
                _this.showMenuFlag = !_this.showMenuFlag;
                document.body.style.overflow = _this.showMenuFlag ? 'hidden' : 'visible';
              }).apply(undefined, [$event].concat(attrs));
            }
          }
        }]),
        [h('i', { 'class': 'el-icon-more' })]
      ), this.$slots.default, h(
        'el-menu',
        {
          attrs: {
            defaultActive: this.isMobile ? null : this.getActiveMenu(),
            uniqueOpened: true,
            backgroundColor: 'var(--bg-color)',
            textColor: 'var(--text-color-light)',
            activeTextColor: 'var(--text-color-light)'
          }
        },
        [this.getChildren(this.data)]
      )]
    );
  },

  props: {
    data: Array
  },
  data: function data() {
    return {
      showMenuFlag: false
    };
  },

  computed: {
    isMobile: function isMobile() {
      return (/(android|ios|phone|mobile)/i.test(navigator.userAgent)
      );
    },
    showMenu: function showMenu() {
      return !this.isMobile || this.showMenuFlag;
    }
  },
  methods: {
    getActiveMenu: function getActiveMenu() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_tree__["a" /* findLeafNode */])(this.data, this.$route.path);
    },
    getMenuContent: function getMenuContent(item) {
      var h = this.$createElement;

      return [h(
        'div',
        { slot: 'title' },
        [h('icon', {
          'class': 'title-icon',
          attrs: { name: item['fa-icon'] && item['fa-icon'].indexOf('fa') !== -1 ? item['fa-icon'].split('fa-')[1] : item['fa-icon']
          }
        }), h('span', [this.$i18n(item.title)])]
      )];
    },
    getChildren: function getChildren(arr) {
      var _this2 = this;

      var h = this.$createElement;

      var children = [];
      if (arr && arr.length) {
        arr.forEach(function (item) {
          if (item.children && item.children.length) {
            children.push(h(
              'el-submenu',
              {
                attrs: { index: item.id.toString() }
              },
              [_this2.getMenuContent(item), _this2.getChildren(item.children)]
            ));
          } else {
            children.push(h(
              'el-menu-item',
              __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
                attrs: {
                  index: item.id.toString()
                }
              }, {
                on: {
                  'click': function click($event) {
                    for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                      attrs[_key2 - 1] = arguments[_key2];
                    }

                    (function () {
                      location.href = item.url;
                      _this2.showMenuFlag = false;
                    }).apply(undefined, [$event].concat(attrs));
                  }
                }
              }]),
              [_this2.getMenuContent(item), _this2.getChildren(item.children)]
            ));
          }
        });
      }
      return children;
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = travel;
/* harmony export (immutable) */ __webpack_exports__["a"] = findLeafNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);


function travel(data, path) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.children && item.children.length) {
        var result = travel(item.children, path);
        if (result.length) {
          return [item.title].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(result));
        }
      } else {
        if (item.url && path === item.url.replace('/ui/#', '')) {
          return [item.title];
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [];
}

function findLeafNode(data, path) {
  for (var i = 0, len = data.length; i < len; i++) {
    var item = data[i];
    if (item.children && item.children.length) {
      var result = findLeafNode(item.children, path);
      if (result) {
        return result;
      }
    } else {
      if (item.url && path === item.url.replace('/ui/#', '')) {
        return item.id.toString();
      }
    }
  }
  return '';
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tree__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_i18n_index__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    return h(
      'div',
      { 'class': 'sp-breadcrumb-container' },
      [h('i', { 'class': 'el-icon-location-outline' }), h(
        'el-breadcrumb',
        {
          attrs: { separatorClass: 'el-icon-arrow-right' }
        },
        [this.arr.map(function (item) {
          return h('el-breadcrumb-item', [Object(__WEBPACK_IMPORTED_MODULE_2__helper_i18n_index__["c" /* i18n */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["a" /* capitalize */])(item))]);
        })]
      )]
    );
  },

  props: {
    data: Array
  },
  data: function data() {
    return {
      arr: Object(__WEBPACK_IMPORTED_MODULE_0__utils_tree__["b" /* travel */])(this.data, this.$route.path)
    };
  },

  watch: {
    '$route': function $route(newRoute) {
      this.arr = Object(__WEBPACK_IMPORTED_MODULE_0__utils_tree__["b" /* travel */])(this.data, newRoute.path);
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(333);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var settle = __webpack_require__(337);
var buildURL = __webpack_require__(339);
var parseHeaders = __webpack_require__(340);
var isURLSameOrigin = __webpack_require__(341);
var createError = __webpack_require__(160);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(342);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(343);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(338);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isObject = __webpack_require__(53);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(168),
    eq = __webpack_require__(163);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(392);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(394),
    isArguments = __webpack_require__(395),
    isArray = __webpack_require__(106),
    isBuffer = __webpack_require__(170),
    isIndex = __webpack_require__(398),
    isTypedArray = __webpack_require__(399);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(22),
    stubFalse = __webpack_require__(397);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 171 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(164),
    isLength = __webpack_require__(171);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(169),
    baseKeysIn = __webpack_require__(404),
    isArrayLike = __webpack_require__(173);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(177),
    getPrototype = __webpack_require__(178),
    getSymbols = __webpack_require__(111),
    stubArray = __webpack_require__(175);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(172);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(177),
    isArray = __webpack_require__(106);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateComponent */
/* harmony export (immutable) */ __webpack_exports__["a"] = ListViewFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add_modalAdd__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__add_pageAdd__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__add_embedAdd__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__ = __webpack_require__(116);











var cache = {};

function generateComponent(type, configs) {
  var nestedList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var cacheKey = configs.name + '-' + type;
  return cache[cacheKey] || (cache[cacheKey] = {
    name: 'MainListView',
    render: function render(h) {
      var _this = this;

      var resChild = null;
      var Add = null;
      switch (configs.mode) {
        case __WEBPACK_IMPORTED_MODULE_8__constant__["a" /* MODE */].EDIT_IN_DIALOG:
          Add = __WEBPACK_IMPORTED_MODULE_5__add_modalAdd__["a" /* default */];
          break;
        case __WEBPACK_IMPORTED_MODULE_8__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE:
          Add = __WEBPACK_IMPORTED_MODULE_6__add_pageAdd__["a" /* default */];
          break;
        case __WEBPACK_IMPORTED_MODULE_8__constant__["a" /* MODE */].EDIT_IN_TABLE:
          Add = __WEBPACK_IMPORTED_MODULE_7__add_embedAdd__["a" /* default */];
          break;
      }
      switch (type) {
        case 'list':
          resChild = h(__WEBPACK_IMPORTED_MODULE_4__list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default()([{
            'class': 'list-wrapper',
            attrs: { resourceType: 'main',
              mode: configs.mode,
              data: configs.data,
              schema: configs.schema,
              actions: configs.actions,
              hooks: configs.hooks,
              options: configs.options
            }
          }, {
            on: {
              'triggerSearch': function triggerSearch($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                (function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(params) {
                    var loadingInstance;
                    return __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            loadingInstance = _this.$loading({ target: '.list-wrapper' });
                            _context.next = 3;
                            return configs.data.fetch.list(_this.$store, params);

                          case 3:
                            loadingInstance.close();

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              },
              'triggerUpdate': function triggerUpdate($event) {
                for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  attrs[_key3 - 1] = arguments[_key3];
                }

                (function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
                    return __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return configs.data.update(_this.$store, params.data);

                          case 2:
                            params.cb && params.cb();

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'triggerDelete': function triggerDelete($event) {
                for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                  attrs[_key4 - 1] = arguments[_key4];
                }

                (function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
                    return __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return configs.data.delete(_this.$store, params.data);

                          case 2:
                            params.cb && params.cb();

                          case 3:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'addHandle': function addHandle($event) {
                for (var _len5 = arguments.length, attrs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  attrs[_key5 - 1] = arguments[_key5];
                }

                _this.addHandler.apply(_this, [$event].concat(attrs));
              },
              'editHandle': function editHandle($event) {
                for (var _len6 = arguments.length, attrs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                  attrs[_key6 - 1] = arguments[_key6];
                }

                _this.editHandler.apply(_this, [$event].concat(attrs));
              },
              'detailHandle': function detailHandle($event) {
                for (var _len7 = arguments.length, attrs = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                  attrs[_key7 - 1] = arguments[_key7];
                }

                _this.detailHandler.apply(_this, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'add':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: configs.schema,
              data: configs.data,
              nestedList: nestedList
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len8 = arguments.length, attrs = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
                  attrs[_key8 - 1] = arguments[_key8];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'edit':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: configs.schema,
              data: configs.data,
              model: configs.data.provider.one(this.$store.state),
              nestedList: nestedList
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len9 = arguments.length, attrs = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
                  attrs[_key9 - 1] = arguments[_key9];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'detail':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: configs.schema,
              data: configs.data,
              model: configs.data.provider.one(this.$store.state),
              isDetail: true,
              nestedList: nestedList
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len10 = arguments.length, attrs = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
                  attrs[_key10 - 1] = arguments[_key10];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
      }
      return h('div', [resChild]);
    },

    methods: {
      addHandler: function addHandler() {
        this.$router.push(this.$route.path + '/add');
      },
      editHandler: function editHandler(query) {
        this.$router.push({
          path: this.$route.path + '/edit',
          query: query
        });
      },
      detailHandler: function detailHandler(query) {
        this.$router.push({
          path: this.$route.path + '/detail',
          query: query
        });
      }
    }
  });
}

function ListViewFactory() {
  var _ref4;

  var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nestedList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return _ref4 = {}, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref4, 'list', generateComponent('list', configs)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref4, 'add', generateComponent('add', configs, nestedList)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref4, 'edit', generateComponent('edit', configs, nestedList)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref4, 'detail', generateComponent('detail', configs, nestedList)), _ref4;
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__ = __webpack_require__(72);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditDialog',
  render: function render(h) {
    var _this = this;

    return h(
      'el-dialog',
      __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default()([{
        'class': 'sp-' + this.data.name + '-dialog',
        attrs: { title: this.$i18n(this.appName + ' ' + this.data.resourceName),
          width: '80%',
          visible: true,
          beforeClose: this.cancel
        }
      }, {
        on: {
          'before-close': function beforeClose($event) {
            for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              attrs[_key - 1] = arguments[_key];
            }

            (function (val) {
              return _this.formData[_this.tabSchema[0].key] = val;
            }).apply(undefined, [$event].concat(attrs));
          }
        }
      }]),
      [h(__WEBPACK_IMPORTED_MODULE_4__components_FormTpl_index__["a" /* default */], {
        'class': 'sp-edit-page-form',
        attrs: { model: this.formData,
          fields: this.editableSchema,
          options: { disabled: this.isDetail }
        }
      }), this.nestedList && this.nestedList.map(function (v) {
        return h(v);
      }), !this.isDetail && h(
        'span',
        { slot: 'footer' },
        [h(
          'el-button',
          {
            on: {
              'click': function click($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                _this.cancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Cancel')]
        ), h(
          'el-button',
          __WEBPACK_IMPORTED_MODULE_3_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { type: 'primary' }
          }, {
            on: {
              'click': function click($event) {
                for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  attrs[_key3 - 1] = arguments[_key3];
                }

                _this.confirm.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Confirm')]
        )]
      )]
    );
  },
  data: function data() {
    return {
      cancelText: this.$i18n('Confirm Cancel ?'),
      confirmText: this.$i18n('Confirm ?'),
      confirming: false,
      defaultFormData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_mapSchemas__["a" /* default */])(), {
    formData: function formData() {
      return this.model || this.defaultFormData;
    },
    appName: function appName() {
      if (this.model && this.isDetail) {
        return 'Detail';
      }
      if (this.model) {
        return 'Edit';
      }

      return 'Add';
    }
  }),
  props: ['schema', 'data', 'model', 'isDetail', 'nestedList'],
  methods: {
    cancel: function cancel() {
      this.$confirm(this.cancelText).then(function () {
        return __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__["a" /* default */].$emit('closeSubPage');
      }).catch(function () {});
    },
    confirm: function confirm() {
      var _this2 = this;

      if (this.confirming) return;
      this.confirming = true;
      var resourceName = this.data.resourceName.toLocaleLowerCase() + '_id';
      this.formData[resourceName] = this.formData[resourceName] || this.formData['id'];
      this.$confirm(this.confirmText).then(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.model) {
                  _context.next = 6;
                  break;
                }

                if (!(_this2.data && _this2.data.update)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this2.data.update(_this2.$store, _this2.formData);

              case 4:
                _context.next = 9;
                break;

              case 6:
                if (!(_this2.data && _this2.data.add)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this2.data.add(_this2.$store, _this2.formData);

              case 9:
                __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__["a" /* default */].$emit(_this2.data.name + 'listOnSearch');
                __WEBPACK_IMPORTED_MODULE_5__utils_eventHub__["a" /* default */].$emit('closeSubPage');
                _this2.confirming = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))).catch(function () {
        return _this2.confirming = false;
      });
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpSelect_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ea6fe6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpSelect_vue__ = __webpack_require__(430);
var normalizeComponent = __webpack_require__(75)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ea6fe6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_safeGet__ = __webpack_require__(114);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpSelect',
  props: ['items', 'clearable', 'value', 'size', 'multiple', 'filterable', 'disabled', 'beforeCreateOptions'],
  data: function data() {
    return {
      actualValue: undefined,
      actualItems: [],
      placeholder: undefined
    };
  },

  watch: {
    items: function items(_items) {
      this.updateItems(_items);
    },
    value: function value(_value) {
      this.updateValue(_value);
    }
  },
  created: function created() {
    var _this = this;

    if (typeof this.items === 'string') {
      try {
        this.$watch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_0__utils_safeGet__["a" /* safeGet */])(_this.$store.state, _this.items);
        }, function (val) {
          var options = _this.beforeCreateOptions && typeof _this.beforeCreateOptions === 'function' ? _this.beforeCreateOptions(val) : val;
          _this.updateItems(options);
        }, {
          immediate: true
        });
      } catch (e) {
        console.log(e);
        throw new Error('bad select options');
      }
    } else {
      this.updateItems(this.items);
    }
    this.updateValue(this.value);
  },

  methods: {
    updateItems: function updateItems(items) {
      var _this2 = this;

      // console.log('updateItems', items)
      if (Object.prototype.toString.call(items) === '[object Promise]') {
        this.actualItems = [{
          label: this.$i18n('loading'),
          value: null,
          disabled: true
        }];
        this.placeholder = this.$i18n('loading');
        items.then(function (data) {
          _this2.actualItems = data;
          _this2.placeholder = undefined;
        }).catch(function () {});
      } else if (typeof items === 'function') {
        this.actualItems = items(this.$store.state);
      } else {
        this.actualItems = items;
      }
    },
    updateValue: function updateValue(value) {
      this.actualValue = value;
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options,
      fields = _ref.fields,
      _ref$rules = _ref.rules,
      rules = _ref$rules === undefined ? {} : _ref$rules;

  if (options.noValidate === true) {
    return {};
  }
  var extraRules = fields.reduce(function (previousValue, currentValue) {
    return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, previousValue, currentValue.rule || {});
  }, {});
  return __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, rules, extraRules);
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateTableColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormTpl_index__ = __webpack_require__(37);




var calcWidth = function calcWidth(options) {
  if (options.cellWidth) {
    var cellWidth = options.cellWidth;
    if (typeof cellWidth === 'string') {
      if (cellWidth === 'shorttext') {
        return 64;
      }
      if (cellWidth === 'longtext') {
        return 200;
      }
      if (cellWidth === 'datetime') {
        return 95;
      }
    }
    return cellWidth || 'auto';
  }
  return 'auto';
};
var defaultRender = function defaultRender(content) {
  if (Array.isArray(content)) {
    return content.length ? content.join(', ') : '/';
  }
  return content;
};

var generateTableColumn = function generateTableColumn(self, h) {
  var tableChildren = self.tableSchema.map(function (cell) {
    return h('el-table-column', {
      props: {
        key: cell.key,
        prop: cell.key,
        label: self.$i18n(cell.label),
        width: calcWidth(cell.options || {}),
        className: cell.key
      },
      scopedSlots: {
        default: function _default(props) {
          if (cell.editable && self.inTableEditMode[props.row.id]) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__components_FormTpl_index__["c" /* generateFormItem */])(h, cell, self.inTableEditData[props.row.id]);
          } else {
            return h('span', {
              domProps: {
                innerHTML: cell.render ? cell.render.call(self, props.row[cell.key], props.row) : defaultRender(props.row[cell.key])
              }
            });
          }
        }
      }
    });
  });
  if (self.parsedActions && Array.isArray(self.parsedActions) && self.parsedActions.length) {
    tableChildren.push(h('el-table-column', {
      props: {
        label: self.$i18n('Action')
      },
      scopedSlots: {
        default: function _default(props) {
          var actionNodes = [];
          if (self.inTableEditMode[props.row.id]) {
            actionNodes = [h('el-button', {
              props: {
                size: 'mini',
                type: 'success'
              },
              on: {
                click: function click() {
                  self.$refs.form.validate(function (valid) {
                    if (!valid) {
                      self.$message({ type: 'error', message: self.$i18n('Form validate error !') });
                      return;
                    }
                    self.$emit('triggerUpdate', {
                      data: __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, self.inTableEditData[props.row.id], __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({
                        id: props.row.id
                      }, self.tableSchema[0].key, props.row.id)),
                      // TODO: move 'fetch' action to store
                      cb: function cb() {
                        return self.onSearch();
                      }
                    });
                    self.inTableEditMode[props.row.id] = false;
                  });
                }
              }
            }, [self.$i18n('OK')]), h('el-button', {
              props: { size: 'mini' },
              on: { click: function click() {
                  return self.inTableEditMode[props.row.id] = false;
                } }
            }, [self.$i18n('Cancel')])];
          } else {
            self.parsedActions.forEach(function (action) {
              if (action.hide) {
                if (typeof action.hide === 'boolean') {
                  return;
                } else if (action.hide(props.row, self.$store.state)) {
                  return;
                }
              }
              actionNodes.push(h('el-button', {
                props: { size: 'mini' },
                on: {
                  click: function click() {
                    return action.click.call(self, props.$index, props.row);
                  }
                }
              }, [self.$i18n(action.label)]));
            });
          }
          return actionNodes.length === 0 ? null : h('el-button-group', {}, actionNodes);
        }
      }
    }));
  }
  return tableChildren;
};

/* harmony default export */ __webpack_exports__["a"] = (function (self, h) {
  var tableChildren = generateTableColumn(self, h);
  return h('el-table', {
    props: {
      data: self.tableData.data,
      headerCellStyle: { background: '#f0f2f5' },
      style: {
        width: '100%'
      },
      border: true,
      stripe: true
    },
    on: {
      click: self.onSearch
    }
  }, tableChildren);
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);

/* harmony default export */ __webpack_exports__["a"] = (function (self, h) {
  var isMobile = /(android|ios|phone|mobile)/i.test(navigator.userAgent);
  return h('el-pagination', __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
    'class': 'pagination',
    attrs: { layout: isMobile ? 'pager' : self.paginationLayout || 'total, sizes, prev, pager, next',
      small: isMobile,
      total: self.tableData.total,
      pageSize: self.pageSize,
      pageSizes: self.pageSizes,
      currentPage: self.currentPage
    }
  }, {
    on: {
      'size-change': function sizeChange($event) {
        for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          attrs[_key - 1] = arguments[_key];
        }

        self.handleSizeChange.apply(self, [$event].concat(attrs));
      },
      'current-change': function currentChange($event) {
        for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          attrs[_key2 - 1] = arguments[_key2];
        }

        self.handleCurrentChange.apply(self, [$event].concat(attrs));
      }
    }
  }]));
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldDatetime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldDatetime(label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'date-picker';
  this.subType = 'datetime';
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldTextarea;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldTextarea(label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'input';
  this.subType = 'textarea';
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldNumber(label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'input-number';
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldSelect(label, key, items, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'select';
  this.items = items;
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldMultiSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldMultiSelect(label, key, items, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'select';
  this.multiple = true;
  this.items = items;
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldInput(label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'input';
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


/* harmony default export */ __webpack_exports__["a"] = (function (label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'date-picker';
  this.subType = 'datetimerange';
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldTree(label, key, items, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'tree';
  this.items = items;
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldCheckTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(26);



function FieldCheckTree(label, key, items, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'tree';
  this.subType = 'check-tree';
  this.items = items;
}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldTableSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldTableSelect(label, key, items, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'tableSelect';
  this.items = items;
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_i18n_index__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    var _this = this;

    var children = [];
    if (this.tabs && this.tabs.length) {
      children.push(h(
        'el-tabs',
        __WEBPACK_IMPORTED_MODULE_1_babel_helper_vue_jsx_merge_props___default()([{
          attrs: {
            value: this.activeTab
          }
        }, {
          on: {
            'tab-click': function tabClick($event) {
              for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                attrs[_key - 1] = arguments[_key];
              }

              _this.onTabLinkSwitch.apply(_this, [$event].concat(attrs));
            }
          }
        }]),
        [this.tabs.map(function (option) {
          return h('el-tab-pane', {
            attrs: {
              label: Object(__WEBPACK_IMPORTED_MODULE_2__helper_i18n_index__["c" /* i18n */])(option.label),
              name: String(option.url)
            }
          });
        })]
      ));
    }
    return h(
      'div',
      { 'class': 'sp-tabs' },
      [children]
    );
  },

  props: {
    tabs: Array
  },
  methods: {
    onTabLinkSwitch: function onTabLinkSwitch(tab) {
      var url = this.tabs[tab.index].url;
      this.$router.push(url);
    }
  },
  computed: {
    activeTab: function activeTab() {
      var activeTab = void 0;
      if (Array.isArray(this.tabs) && this.tabs.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(this.tabs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tab = _step.value;

            if (this.$route.path.includes(tab.url)) {
              activeTab = tab.url;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return activeTab;
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(479);
var isArguments = __webpack_require__(480);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shopee_theme_dist_shopee_index_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shopee_theme_dist_shopee_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shopee_theme_dist_shopee_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_index__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mock_index__ = __webpack_require__(477);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__src_index__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router_index_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(201);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(119)))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(203);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(120)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports
exports.i(__webpack_require__(208), "");
exports.i(__webpack_require__(211), "");
exports.i(__webpack_require__(212), "");
exports.i(__webpack_require__(213), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(205)
var ieee754 = __webpack_require__(206)
var isArray = __webpack_require__(207)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 206 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 207 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:element-icons;src:url(" + __webpack_require__(209) + ") format(\"woff\"),url(" + __webpack_require__(210) + ") format(\"truetype\");font-weight:400;font-style:normal}[class*=\" el-icon-\"],[class^=el-icon-]{font-family:element-icons!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;vertical-align:baseline;display:inline-block;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.el-icon-info:before{content:\"\\E61A\"}.el-icon-error:before{content:\"\\E62C\"}.el-icon-success:before{content:\"\\E62D\"}.el-icon-warning:before{content:\"\\E62E\"}.el-icon-question:before{content:\"\\E634\"}.el-icon-back:before{content:\"\\E606\"}.el-icon-arrow-left:before{content:\"\\E600\"}.el-icon-arrow-down:before{content:\"\\E603\"}.el-icon-arrow-right:before{content:\"\\E604\"}.el-icon-arrow-up:before{content:\"\\E605\"}.el-icon-caret-left:before{content:\"\\E60A\"}.el-icon-caret-bottom:before{content:\"\\E60B\"}.el-icon-caret-top:before{content:\"\\E60C\"}.el-icon-caret-right:before{content:\"\\E60E\"}.el-icon-d-arrow-left:before{content:\"\\E610\"}.el-icon-d-arrow-right:before{content:\"\\E613\"}.el-icon-minus:before{content:\"\\E621\"}.el-icon-plus:before{content:\"\\E62B\"}.el-icon-remove:before{content:\"\\E635\"}.el-icon-circle-plus:before{content:\"\\E601\"}.el-icon-remove-outline:before{content:\"\\E63C\"}.el-icon-circle-plus-outline:before{content:\"\\E602\"}.el-icon-close:before{content:\"\\E60F\"}.el-icon-check:before{content:\"\\E611\"}.el-icon-circle-close:before{content:\"\\E607\"}.el-icon-circle-check:before{content:\"\\E639\"}.el-icon-circle-close-outline:before{content:\"\\E609\"}.el-icon-circle-check-outline:before{content:\"\\E63E\"}.el-icon-zoom-out:before{content:\"\\E645\"}.el-icon-zoom-in:before{content:\"\\E641\"}.el-icon-d-caret:before{content:\"\\E615\"}.el-icon-sort:before{content:\"\\E640\"}.el-icon-sort-down:before{content:\"\\E630\"}.el-icon-sort-up:before{content:\"\\E631\"}.el-icon-tickets:before{content:\"\\E63F\"}.el-icon-document:before{content:\"\\E614\"}.el-icon-goods:before{content:\"\\E618\"}.el-icon-sold-out:before{content:\"\\E63B\"}.el-icon-news:before{content:\"\\E625\"}.el-icon-message:before{content:\"\\E61B\"}.el-icon-date:before{content:\"\\E608\"}.el-icon-printer:before{content:\"\\E62F\"}.el-icon-time:before{content:\"\\E642\"}.el-icon-bell:before{content:\"\\E622\"}.el-icon-mobile-phone:before{content:\"\\E624\"}.el-icon-service:before{content:\"\\E63A\"}.el-icon-view:before{content:\"\\E643\"}.el-icon-menu:before{content:\"\\E620\"}.el-icon-more:before{content:\"\\E646\"}.el-icon-more-outline:before{content:\"\\E626\"}.el-icon-star-on:before{content:\"\\E637\"}.el-icon-star-off:before{content:\"\\E63D\"}.el-icon-location:before{content:\"\\E61D\"}.el-icon-location-outline:before{content:\"\\E61F\"}.el-icon-phone:before{content:\"\\E627\"}.el-icon-phone-outline:before{content:\"\\E628\"}.el-icon-picture:before{content:\"\\E629\"}.el-icon-picture-outline:before{content:\"\\E62A\"}.el-icon-delete:before{content:\"\\E612\"}.el-icon-search:before{content:\"\\E619\"}.el-icon-edit:before{content:\"\\E61C\"}.el-icon-edit-outline:before{content:\"\\E616\"}.el-icon-rank:before{content:\"\\E632\"}.el-icon-refresh:before{content:\"\\E633\"}.el-icon-share:before{content:\"\\E636\"}.el-icon-setting:before{content:\"\\E638\"}.el-icon-upload:before{content:\"\\E60D\"}.el-icon-upload2:before{content:\"\\E644\"}.el-icon-download:before{content:\"\\E617\"}.el-icon-loading:before{content:\"\\E61E\"}.el-icon-loading{-webkit-animation:rotating 2s linear infinite;animation:rotating 2s linear infinite}.el-icon--right{margin-left:5px}.el-icon--left{margin-right:5px}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.el-pagination{white-space:nowrap;padding:2px 5px;color:#676a6c;font-weight:700}.el-pagination:after,.el-pagination:before{display:table;content:\"\"}.el-pagination:after{clear:both}.el-pagination button,.el-pagination span:not([class*=suffix]){display:inline-block;font-size:13px;min-width:35.5px;height:28px;line-height:28px;vertical-align:top;-webkit-box-sizing:border-box;box-sizing:border-box}.el-pagination .el-input__inner{text-align:center;-moz-appearance:textfield;line-height:normal}.el-pagination .el-input__suffix{right:0;-webkit-transform:scale(.8);transform:scale(.8)}.el-pagination .el-select .el-input{width:100px;margin:0 5px}.el-pagination .el-select .el-input .el-input__inner{padding-right:25px;border-radius:3px;height:28px}.el-pagination button{border:none;padding:0 6px;background:transparent}.el-pagination button:focus{outline:none}.el-pagination button:hover{color:#1c84c6}.el-pagination button.disabled{color:#ddd;background-color:#fff;cursor:not-allowed}.el-pagination .btn-next,.el-pagination .btn-prev{background:50% no-repeat;background-size:16px;background-color:#fff;cursor:pointer;margin:0;color:#676a6c}.el-pagination .btn-next .el-icon,.el-pagination .btn-prev .el-icon{display:block;font-size:12px;font-weight:700}.el-pagination .btn-prev{padding-right:12px}.el-pagination .btn-next{padding-left:12px}.el-pagination .el-pager li.disabled{color:#ddd;cursor:not-allowed}.el-pagination--small .btn-next,.el-pagination--small .btn-prev,.el-pagination--small .el-pager li,.el-pagination--small .el-pager li:last-child{border-color:transparent;font-size:12px;line-height:22px;height:22px;min-width:22px}.el-pagination--small .arrow.disabled{visibility:hidden}.el-pagination__sizes{margin:0 10px 0 0;font-weight:400;color:#676a6c}.el-pagination__sizes .el-input .el-input__inner{font-size:13px;padding-left:8px}.el-pagination__sizes .el-input .el-input__inner:hover{border-color:#1c84c6}.el-pagination__total{margin-right:10px;font-weight:400;color:#676a6c}.el-pagination__jump{margin-left:24px;font-weight:400;color:#676a6c}.el-pagination__jump .el-input__inner{padding:0 3px}.el-pagination__rightwrapper{float:right}.el-pagination__editor{line-height:18px;padding:0 2px;height:28px;text-align:center;margin:0 2px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:3px}.el-pagination__editor.el-input{width:50px}.el-pagination__editor.el-input .el-input__inner{height:28px}.el-pagination__editor .el-input__inner::-webkit-inner-spin-button,.el-pagination__editor .el-input__inner::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.el-pagination.is-background .btn-next,.el-pagination.is-background .btn-prev,.el-pagination.is-background .el-pager li{margin:0 5px;background-color:#eceeef;color:#676a6c;min-width:30px;border-radius:2px}.el-pagination.is-background .btn-next.disabled,.el-pagination.is-background .btn-prev.disabled,.el-pagination.is-background .el-pager li.disabled{color:#ddd}.el-pagination.is-background .btn-next,.el-pagination.is-background .btn-prev{padding:0}.el-pagination.is-background .btn-next.disabled,.el-pagination.is-background .btn-prev.disabled{color:#ddd}.el-pagination.is-background .el-pager li:not(.disabled):hover{color:#1c84c6}.el-pagination.is-background .el-pager li:not(.disabled).active{background-color:#1c84c6;color:#fff}.el-pagination.is-background.el-pagination--small .btn-next,.el-pagination.is-background.el-pagination--small .btn-prev,.el-pagination.is-background.el-pagination--small .el-pager li{margin:0 3px;min-width:22px}.el-pager{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;list-style:none;display:inline-block;vertical-align:top;font-size:0;padding:0;margin:0}.el-pager .more:before{line-height:30px}.el-pager li{padding:0 4px;background:#fff;vertical-align:top;display:inline-block;font-size:13px;min-width:35.5px;height:28px;line-height:28px;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center;margin:0}.el-pager li.btn-quicknext,.el-pager li.btn-quickprev{line-height:28px;color:#676a6c}.el-pager li.btn-quicknext.disabled,.el-pager li.btn-quickprev.disabled{color:#ddd}.el-pager li.btn-quicknext:hover,.el-pager li.btn-quickprev:hover{cursor:pointer}.el-pager li.active+li{border-left:0}.el-pager li:hover{color:#1c84c6}.el-pager li.active{color:#1c84c6;cursor:default}@-webkit-keyframes v-modal-in{0%{opacity:0}}@-webkit-keyframes v-modal-out{to{opacity:0}}.el-dialog{position:relative;margin:0 auto 50px;background:#fff;border-radius:2px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.3);box-shadow:0 1px 3px rgba(0,0,0,.3);-webkit-box-sizing:border-box;box-sizing:border-box;width:50%}.el-dialog.is-fullscreen{width:100%;margin-top:0;margin-bottom:0;height:100%;overflow:auto}.el-dialog__wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;margin:0}.el-dialog__header{padding:20px;padding-bottom:10px}.el-dialog__headerbtn{position:absolute;top:20px;right:20px;padding:0;background:transparent;border:none;outline:none;cursor:pointer;font-size:16px}.el-dialog__headerbtn .el-dialog__close{color:#3f5060}.el-dialog__headerbtn:focus .el-dialog__close,.el-dialog__headerbtn:hover .el-dialog__close{color:#1c84c6}.el-dialog__title{line-height:24px;font-size:18px;color:#676a6c}.el-dialog__body{padding:30px 20px;color:#676a6c;line-height:24px;font-size:14px}.el-dialog__footer{padding:20px;padding-top:10px;text-align:right;-webkit-box-sizing:border-box;box-sizing:border-box}.el-dialog--center{text-align:center}.el-dialog--center .el-dialog__body{text-align:initial;padding:25px 25px 30px}.el-dialog--center .el-dialog__footer{text-align:inherit}.dialog-fade-enter-active{-webkit-animation:dialog-fade-in .3s;animation:dialog-fade-in .3s}.dialog-fade-leave-active{-webkit-animation:dialog-fade-out .3s;animation:dialog-fade-out .3s}@-webkit-keyframes dialog-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes dialog-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@-webkit-keyframes dialog-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}@keyframes dialog-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}.el-autocomplete{position:relative;display:inline-block}.el-autocomplete-suggestion{margin:5px 0;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);border-radius:4px}.el-autocomplete-suggestion__wrap{max-height:280px;padding:10px 0;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:auto;background-color:#fff;border:1px solid #e4e7ed;border-radius:4px}.el-autocomplete-suggestion__list{margin:0;padding:0}.el-autocomplete-suggestion li{padding:0 20px;margin:0;line-height:34px;cursor:pointer;color:#676a6c;font-size:14px;list-style:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.el-autocomplete-suggestion li.highlighted,.el-autocomplete-suggestion li:hover{background-color:#f3f3f4}.el-autocomplete-suggestion li.divider{margin-top:6px;border-top:1px solid #000}.el-autocomplete-suggestion li.divider:last-child{margin-bottom:-6px}.el-autocomplete-suggestion.is-loading li{text-align:center;height:100px;line-height:100px;font-size:20px;color:#999}.el-autocomplete-suggestion.is-loading li:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-autocomplete-suggestion.is-loading li:hover{background-color:#fff}.el-autocomplete-suggestion.is-loading .el-icon-loading{vertical-align:middle}.el-dropdown{display:inline-block;position:relative;color:#676a6c;font-size:14px}.el-dropdown .el-button-group{display:block}.el-dropdown .el-button-group .el-button{float:none}.el-dropdown .el-dropdown__caret-button{padding-left:5px;padding-right:5px;position:relative;border-left:none}.el-dropdown .el-dropdown__caret-button:before{content:\"\";position:absolute;display:block;width:1px;top:5px;bottom:5px;left:0;background:hsla(0,0%,100%,.5)}.el-dropdown .el-dropdown__caret-button:hover:before{top:0;bottom:0}.el-dropdown .el-dropdown__caret-button .el-dropdown__icon{padding-left:0}.el-dropdown__icon{font-size:12px;margin:0 3px}.el-dropdown .el-dropdown-selfdefine:focus:active,.el-dropdown .el-dropdown-selfdefine:focus:not(.focusing){outline-width:0}.el-dropdown-menu{position:absolute;top:0;left:0;z-index:10;padding:10px 0;margin:5px 0;background-color:#fff;border:1px solid #ebeef5;border-radius:4px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-dropdown-menu__item{list-style:none;line-height:36px;padding:0 20px;margin:0;font-size:14px;color:#676a6c;cursor:pointer;outline:none}.el-dropdown-menu__item:focus,.el-dropdown-menu__item:not(.is-disabled):hover{background-color:#e8f3f9;color:#499dd1}.el-dropdown-menu__item--divided{position:relative;margin-top:6px;border-top:1px solid #ebeef5}.el-dropdown-menu__item--divided:before{content:\"\";height:6px;display:block;margin:0 -20px;background-color:#fff}.el-dropdown-menu__item.is-disabled{cursor:default;color:#bbb;pointer-events:none}.el-dropdown-menu--medium{padding:6px 0}.el-dropdown-menu--medium .el-dropdown-menu__item{line-height:30px;padding:0 17px;font-size:14px}.el-dropdown-menu--medium .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:6px}.el-dropdown-menu--medium .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:6px;margin:0 -17px}.el-dropdown-menu--small{padding:6px 0}.el-dropdown-menu--small .el-dropdown-menu__item{line-height:27px;padding:0 15px;font-size:13px}.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:4px}.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:4px;margin:0 -15px}.el-dropdown-menu--mini{padding:3px 0}.el-dropdown-menu--mini .el-dropdown-menu__item{line-height:24px;padding:0 10px;font-size:12px}.el-dropdown-menu--mini .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:3px}.el-dropdown-menu--mini .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:3px;margin:0 -10px}.el-menu{border-right:1px solid #e6e6e6;list-style:none;position:relative;margin:0;padding-left:0;background-color:#fff}.el-menu:after,.el-menu:before{display:table;content:\"\"}.el-menu:after{clear:both}.el-menu--horizontal{border-right:none;border-bottom:1px solid #e6e6e6}.el-menu--horizontal>.el-menu-item{float:left;height:60px;line-height:60px;margin:0;border-bottom:2px solid transparent;color:#999}.el-menu--horizontal>.el-menu-item a,.el-menu--horizontal>.el-menu-item a:hover{color:inherit}.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover{background-color:#fff}.el-menu--horizontal>.el-submenu{float:left}.el-menu--horizontal>.el-submenu:focus,.el-menu--horizontal>.el-submenu:hover{outline:none}.el-menu--horizontal>.el-submenu:focus .el-submenu__title,.el-menu--horizontal>.el-submenu:hover .el-submenu__title{color:#676a6c}.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border-bottom:2px solid #1c84c6;color:#676a6c}.el-menu--horizontal>.el-submenu .el-submenu__title{height:60px;line-height:60px;border-bottom:2px solid transparent;color:#999}.el-menu--horizontal>.el-submenu .el-submenu__title:hover{background-color:#fff}.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{position:static;vertical-align:middle;margin-left:8px;margin-top:-3px}.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title{background-color:#fff;float:none;height:36px;line-height:36px;padding:0 10px;color:#999}.el-menu--horizontal .el-menu .el-menu-item.is-active,.el-menu--horizontal .el-menu .el-submenu__title.is-active{color:#676a6c}.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{outline:none;color:#676a6c}.el-menu--horizontal>.el-menu-item.is-active{border-bottom:2px solid #1c84c6;color:#676a6c}.el-menu--collapse{width:64px}.el-menu--collapse>.el-menu-item [class^=el-icon-],.el-menu--collapse>.el-submenu>.el-submenu__title [class^=el-icon-]{margin:0;vertical-align:middle;width:24px;text-align:center}.el-menu--collapse>.el-menu-item .el-submenu__icon-arrow,.el-menu--collapse>.el-submenu>.el-submenu__title .el-submenu__icon-arrow{display:none}.el-menu--collapse>.el-menu-item span,.el-menu--collapse>.el-submenu>.el-submenu__title span{height:0;width:0;overflow:hidden;visibility:hidden;display:inline-block}.el-menu--collapse>.el-menu-item.is-active i{color:inherit}.el-menu--collapse .el-menu .el-submenu{min-width:200px}.el-menu--collapse .el-submenu{position:relative}.el-menu--collapse .el-submenu .el-menu{position:absolute;margin-left:5px;top:0;left:100%;z-index:10;border:1px solid #e4e7ed;border-radius:2px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-menu--collapse .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{-webkit-transform:none;transform:none}.el-menu--popup{z-index:100;min-width:200px;border:none;padding:5px 0;border-radius:2px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-menu--popup-bottom-start{margin-top:5px}.el-menu--popup-right-start{margin-left:5px;margin-right:5px}.el-menu-item{height:56px;line-height:56px;font-size:14px;color:#676a6c;padding:0 20px;list-style:none;cursor:pointer;position:relative;-webkit-transition:border-color .3s,background-color .3s,color .3s;transition:border-color .3s,background-color .3s,color .3s;-webkit-box-sizing:border-box;box-sizing:border-box;white-space:nowrap}.el-menu-item *{vertical-align:middle}.el-menu-item i{color:#999}.el-menu-item:focus,.el-menu-item:hover{outline:none;background-color:#e8f3f9}.el-menu-item.is-disabled{opacity:.25;cursor:not-allowed;background:none!important}.el-menu-item [class^=el-icon-]{margin-right:5px;width:24px;text-align:center;font-size:18px;vertical-align:middle}.el-menu-item.is-active{color:#1c84c6}.el-menu-item.is-active i{color:inherit}.el-submenu{list-style:none;margin:0;padding-left:0}.el-submenu__title{height:56px;line-height:56px;font-size:14px;color:#676a6c;padding:0 20px;list-style:none;cursor:pointer;position:relative;-webkit-transition:border-color .3s,background-color .3s,color .3s;transition:border-color .3s,background-color .3s,color .3s;-webkit-box-sizing:border-box;box-sizing:border-box;white-space:nowrap}.el-submenu__title *{vertical-align:middle}.el-submenu__title i{color:#999}.el-submenu__title:focus,.el-submenu__title:hover{outline:none;background-color:#e8f3f9}.el-submenu__title.is-disabled{opacity:.25;cursor:not-allowed;background:none!important}.el-submenu__title:hover{background-color:#e8f3f9}.el-submenu .el-menu{border:none}.el-submenu .el-menu-item{height:50px;line-height:50px;padding:0 45px;min-width:200px}.el-submenu__icon-arrow{position:absolute;top:50%;right:20px;margin-top:-7px;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;font-size:12px}.el-submenu.is-active .el-submenu__title{border-bottom-color:#1c84c6}.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.el-submenu.is-disabled .el-menu-item,.el-submenu.is-disabled .el-submenu__title{opacity:.25;cursor:not-allowed;background:none!important}.el-submenu [class^=el-icon-]{vertical-align:middle;margin-right:5px;width:24px;text-align:center;font-size:18px}.el-menu-item-group>ul{padding:0}.el-menu-item-group__title{padding:7px 0 7px 20px;line-height:normal;font-size:12px;color:#999}.horizontal-collapse-transition .el-submenu__title .el-submenu__icon-arrow{-webkit-transition:.2s;transition:.2s;opacity:0}.el-radio{color:#676a6c;font-weight:500;line-height:1;position:relative;cursor:pointer;display:inline-block;white-space:nowrap;outline:none;font-size:14px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.el-radio.is-bordered{padding:12px 20px 0 10px;border-radius:4px;border:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box;height:40px}.el-radio.is-bordered.is-checked{border-color:#1c84c6}.el-radio.is-bordered.is-disabled{cursor:not-allowed;border-color:#ebeef5}.el-radio.is-bordered+.el-radio.is-bordered{margin-left:10px}.el-radio--medium.is-bordered{padding:10px 20px 0 10px;border-radius:4px;height:36px}.el-radio--medium.is-bordered .el-radio__label{font-size:14px}.el-radio--medium.is-bordered .el-radio__inner{height:14px;width:14px}.el-radio--small.is-bordered{padding:8px 15px 0 10px;border-radius:3px;height:32px}.el-radio--small.is-bordered .el-radio__label{font-size:12px}.el-radio--small.is-bordered .el-radio__inner{height:12px;width:12px}.el-radio--mini.is-bordered{padding:6px 15px 0 10px;border-radius:3px;height:28px}.el-radio--mini.is-bordered .el-radio__label{font-size:12px}.el-radio--mini.is-bordered .el-radio__inner{height:12px;width:12px}.el-radio+.el-radio{margin-left:30px}.el-radio__input{white-space:nowrap;cursor:pointer;outline:none;display:inline-block;line-height:1;position:relative;vertical-align:middle}.el-radio__input.is-disabled .el-radio__inner{background-color:#f3f3f4;border-color:#e4e7ed;cursor:not-allowed}.el-radio__input.is-disabled .el-radio__inner:after{cursor:not-allowed;background-color:#f3f3f4}.el-radio__input.is-disabled .el-radio__inner+.el-radio__label{cursor:not-allowed}.el-radio__input.is-disabled.is-checked .el-radio__inner{background-color:#f3f3f4;border-color:#e4e7ed}.el-radio__input.is-disabled.is-checked .el-radio__inner:after{background-color:#ddd}.el-radio__input.is-disabled+span.el-radio__label{color:#ddd;cursor:not-allowed}.el-radio__input.is-checked .el-radio__inner{border-color:#1c84c6;background:#1c84c6}.el-radio__input.is-checked .el-radio__inner:after{-webkit-transform:translate(-50%,-50%) scale(1);transform:translate(-50%,-50%) scale(1)}.el-radio__input.is-checked+.el-radio__label{color:#1c84c6}.el-radio__input.is-focus .el-radio__inner{border-color:#1c84c6}.el-radio__inner{border:1px solid #dcdfe6;border-radius:100%;width:14px;height:14px;background-color:#fff;position:relative;cursor:pointer;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box}.el-radio__inner:hover{border-color:#1c84c6}.el-radio__inner:after{width:4px;height:4px;border-radius:100%;background-color:#fff;content:\"\";position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%) scale(0);transform:translate(-50%,-50%) scale(0);-webkit-transition:-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6);transition:-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6);transition:transform .15s cubic-bezier(.71,-.46,.88,.6);transition:transform .15s cubic-bezier(.71,-.46,.88,.6),-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6)}.el-radio__original{opacity:0;outline:none;position:absolute;z-index:-1;top:0;left:0;right:0;bottom:0;margin:0}.el-radio:focus:not(.is-focus):not(:active) .el-radio__inner{-webkit-box-shadow:0 0 2px 2px #1c84c6;box-shadow:0 0 2px 2px #1c84c6}.el-radio__label{font-size:14px;padding-left:10px}.el-radio-group{display:inline-block;line-height:1;vertical-align:middle;font-size:0}.el-radio-button,.el-radio-button__inner{position:relative;display:inline-block;outline:none}.el-radio-button__inner{line-height:1;white-space:nowrap;vertical-align:middle;background:#fff;border:1px solid #dcdfe6;font-weight:500;border-left:0;color:#676a6c;-webkit-appearance:none;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;cursor:pointer;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);padding:12px 20px;font-size:14px;border-radius:0}.el-radio-button__inner.is-round{padding:12px 20px}.el-radio-button__inner:hover{color:#1c84c6}.el-radio-button__inner [class*=el-icon-]{line-height:.9}.el-radio-button__inner [class*=el-icon-]+span{margin-left:5px}.el-radio-button:first-child .el-radio-button__inner{border-left:1px solid #dcdfe6;border-radius:4px 0 0 4px;-webkit-box-shadow:none!important;box-shadow:none!important}.el-radio-button__orig-radio{opacity:0;outline:none;position:absolute;z-index:-1;left:-999px}.el-radio-button__orig-radio:checked+.el-radio-button__inner{color:#fff;background-color:#1c84c6;border-color:#1c84c6;-webkit-box-shadow:-1px 0 0 0 #1c84c6;box-shadow:-1px 0 0 0 #1c84c6}.el-radio-button__orig-radio:disabled+.el-radio-button__inner{color:#ddd;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5;-webkit-box-shadow:none;box-shadow:none}.el-radio-button__orig-radio:disabled:checked+.el-radio-button__inner{background-color:#f2f6fc}.el-radio-button:last-child .el-radio-button__inner{border-radius:0 4px 4px 0}.el-radio-button:first-child:last-child .el-radio-button__inner{border-radius:4px}.el-radio-button--medium .el-radio-button__inner{padding:10px 20px;font-size:14px;border-radius:0}.el-radio-button--medium .el-radio-button__inner.is-round{padding:10px 20px}.el-radio-button--small .el-radio-button__inner{padding:9px 15px;font-size:12px;border-radius:0}.el-radio-button--small .el-radio-button__inner.is-round{padding:9px 15px}.el-radio-button--mini .el-radio-button__inner{padding:7px 15px;font-size:12px;border-radius:0}.el-radio-button--mini .el-radio-button__inner.is-round{padding:7px 15px}.el-radio-button:focus:not(.is-focus):not(:active){-webkit-box-shadow:0 0 2px 2px #1c84c6;box-shadow:0 0 2px 2px #1c84c6}.el-switch{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;font-size:14px;line-height:20px;height:20px;vertical-align:middle}.el-switch.is-disabled .el-switch__core,.el-switch.is-disabled .el-switch__label{cursor:not-allowed}.el-switch__label{-webkit-transition:.2s;transition:.2s;height:20px;display:inline-block;font-size:14px;font-weight:500;cursor:pointer;vertical-align:middle;color:#676a6c}.el-switch__label.is-active{color:#1c84c6}.el-switch__label--left{margin-right:10px}.el-switch__label--right{margin-left:10px}.el-switch__label *{line-height:1;font-size:14px;display:inline-block}.el-switch__input{position:absolute;width:0;height:0;opacity:0;margin:0}.el-switch__input:focus~.el-switch__core{outline:1px solid #1c84c6}.el-switch__core{margin:0;display:inline-block;position:relative;width:40px;height:20px;border:1px solid #dcdfe6;outline:none;border-radius:10px;-webkit-box-sizing:border-box;box-sizing:border-box;background:#dcdfe6;cursor:pointer;-webkit-transition:border-color .3s,background-color .3s;transition:border-color .3s,background-color .3s;vertical-align:middle}.el-switch__core .el-switch__button{position:absolute;top:1px;left:1px;border-radius:100%;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;width:16px;height:16px;background-color:#fff}.el-switch.is-checked .el-switch__core{border-color:#1c84c6;background-color:#1c84c6}.el-switch.is-disabled{opacity:.6}.el-switch--wide .el-switch__label.el-switch__label--left span{left:10px}.el-switch--wide .el-switch__label.el-switch__label--right span{right:10px}.el-switch .label-fade-enter,.el-switch .label-fade-leave-active{opacity:0}.el-select-dropdown{position:absolute;z-index:1001;border:1px solid #e4e7ed;border-radius:4px;background-color:#fff;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);-webkit-box-sizing:border-box;box-sizing:border-box;margin:5px 0}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected{color:#1c84c6;background-color:#fff}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover{background-color:#f3f3f4}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after{position:absolute;right:20px;font-family:element-icons;content:\"\\E611\";font-size:12px;font-weight:700;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.el-select-dropdown .el-scrollbar.is-empty .el-select-dropdown__list{padding:0}.el-select-dropdown__empty{padding:10px 0;margin:0;text-align:center;color:#999;font-size:14px}.el-select-dropdown__wrap{max-height:274px}.el-select-dropdown__list{list-style:none;padding:6px 0;margin:0;-webkit-box-sizing:border-box;box-sizing:border-box}.el-select-dropdown__item{font-size:14px;padding:0 20px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#676a6c;height:34px;line-height:34px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer}.el-select-dropdown__item.is-disabled{color:#ddd;cursor:not-allowed}.el-select-dropdown__item.is-disabled:hover{background-color:#fff}.el-select-dropdown__item.hover,.el-select-dropdown__item:hover{background-color:#f3f3f4}.el-select-dropdown__item.selected{color:#1c84c6;font-weight:700}.el-select-dropdown__item span{line-height:34px!important}.el-select-group{margin:0;padding:0}.el-select-group__wrap{position:relative;list-style:none;margin:0;padding:0}.el-select-group__wrap:not(:last-of-type){padding-bottom:24px}.el-select-group__wrap:not(:last-of-type):after{content:\"\";position:absolute;display:block;left:20px;right:20px;bottom:12px;height:1px;background:#e4e7ed}.el-select-group__title{padding-left:20px;font-size:12px;color:#3f5060;line-height:30px}.el-select-group .el-select-dropdown__item{padding-left:20px}.el-select{display:inline-block;position:relative}.el-select:hover .el-input__inner{border-color:#ddd}.el-select .el-input__inner{cursor:pointer;padding-right:35px}.el-select .el-input__inner:focus{border-color:#1c84c6}.el-select .el-input .el-select__caret{color:#ddd;font-size:14px;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;-webkit-transform:rotate(180deg);transform:rotate(180deg);line-height:16px;cursor:pointer}.el-select .el-input .el-select__caret.is-reverse{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.el-select .el-input .el-select__caret.is-show-close{font-size:14px;text-align:center;-webkit-transform:rotate(180deg);transform:rotate(180deg);border-radius:100%;color:#ddd;-webkit-transition:color .2s cubic-bezier(.645,.045,.355,1);transition:color .2s cubic-bezier(.645,.045,.355,1)}.el-select .el-input .el-select__caret.is-show-close:hover{color:#999}.el-select .el-input.is-disabled .el-input__inner{cursor:not-allowed}.el-select .el-input.is-disabled .el-input__inner:hover{border-color:#e4e7ed}.el-select .el-input.is-focus .el-input__inner{border-color:#1c84c6}.el-select>.el-input{display:block}.el-select__input{border:none;outline:none;padding:0;margin-left:15px;color:#666;font-size:14px;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;background-color:transparent}.el-select__input.is-mini{height:14px}.el-select__close{cursor:pointer;position:absolute;top:8px;z-index:1000;right:25px;color:#ddd;line-height:18px;font-size:14px}.el-select__close:hover{color:#999}.el-select__tags{position:absolute;line-height:normal;white-space:normal;z-index:1;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.el-select .el-tag__close{margin-top:-2px}.el-select .el-tag{-webkit-box-sizing:border-box;box-sizing:border-box;border-color:transparent;margin:2px 0 2px 6px;background-color:#f0f2f5}.el-select .el-tag__close.el-icon-close{background-color:#ddd;right:-7px;top:0;color:#fff}.el-select .el-tag__close.el-icon-close:hover{background-color:#999}.el-select .el-tag__close.el-icon-close:before{display:block;-webkit-transform:translateY(.5px);transform:translateY(.5px)}.el-table{position:relative;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-flex:1;-ms-flex:1;flex:1;width:100%;max-width:100%;background-color:#fff;font-size:14px;color:#676a6c}.el-table__empty-block{position:relative;min-height:60px;text-align:center;width:100%;height:100%}.el-table__empty-text{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);color:#999}.el-table__expand-column .cell{padding:0;text-align:center}.el-table__expand-icon{position:relative;cursor:pointer;color:#666;font-size:12px;-webkit-transition:-webkit-transform .2s ease-in-out;transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out;height:20px}.el-table__expand-icon--expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-table__expand-icon>.el-icon{position:absolute;left:50%;top:50%;margin-left:-5px;margin-top:-5px}.el-table__expanded-cell{background-color:#fff}.el-table__expanded-cell[class*=cell]{padding:20px 50px}.el-table__expanded-cell:hover{background-color:transparent!important}.el-table--fit{border-right:0;border-bottom:0}.el-table--fit td.gutter,.el-table--fit th.gutter{border-right-width:1px}.el-table--scrollable-x .el-table__body-wrapper{overflow-x:auto}.el-table--scrollable-y .el-table__body-wrapper{overflow-y:auto}.el-table thead{color:#999;font-weight:500}.el-table thead.is-group th{background:#f3f3f4}.el-table td,.el-table th{padding:12px 0;min-width:0;-webkit-box-sizing:border-box;box-sizing:border-box;text-overflow:ellipsis;vertical-align:middle;position:relative}.el-table td.is-center,.el-table th.is-center{text-align:center}.el-table td.is-left,.el-table th.is-left{text-align:left}.el-table td.is-right,.el-table th.is-right{text-align:right}.el-table td.gutter,.el-table th.gutter{width:15px;border-right-width:0;border-bottom-width:0;padding:0}.el-table td.is-hidden>*,.el-table th.is-hidden>*{visibility:hidden}.el-table--medium td,.el-table--medium th{padding:10px 0}.el-table--small{font-size:12px}.el-table--small td,.el-table--small th{padding:8px 0}.el-table--mini{font-size:12px}.el-table--mini td,.el-table--mini th{padding:6px 0}.el-table tr{background-color:#fff}.el-table tr input[type=checkbox]{margin:0}.el-table td,.el-table th.is-leaf{border-bottom:1px solid #ebeef5}.el-table th.is-sortable{cursor:pointer}.el-table th{white-space:nowrap;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-align:left;background-color:#fff}.el-table th div{padding-left:10px;padding-right:10px;line-height:40px;overflow:hidden;white-space:nowrap}.el-table th>.cell,.el-table th div{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;text-overflow:ellipsis}.el-table th>.cell{position:relative;word-wrap:normal;vertical-align:middle;width:100%}.el-table th>.cell.highlight{color:#1c84c6}.el-table th.required>div:before{display:inline-block;content:\"\";width:8px;height:8px;border-radius:50%;background:#ff4d51;margin-right:5px;vertical-align:middle}.el-table td div{-webkit-box-sizing:border-box;box-sizing:border-box}.el-table td.gutter{width:0}.el-table .cell{-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;white-space:normal;word-break:break-all;line-height:23px;padding-left:10px;padding-right:10px}.el-table .cell.el-tooltip{white-space:nowrap;min-width:50px}.el-table--border,.el-table--group{border:1px solid #ebeef5}.el-table--border:after,.el-table--group:after,.el-table:before{content:\"\";position:absolute;background-color:#ebeef5;z-index:1}.el-table--border:after,.el-table--group:after{top:0;right:0;width:1px;height:100%}.el-table:before{left:0;bottom:0;width:100%;height:1px}.el-table--border{border-right:none;border-bottom:none}.el-table--border.el-loading-parent--relative{border-color:transparent}.el-table--border td,.el-table--border th{border-right:1px solid #ebeef5}.el-table--border td:first-child .cell,.el-table--border th:first-child .cell{padding-left:10px}.el-table--border th.gutter:last-of-type{border-bottom:1px solid #ebeef5;border-bottom-width:1px}.el-table--border th{border-bottom:1px solid #ebeef5}.el-table--hidden{visibility:hidden}.el-table__fixed,.el-table__fixed-right{position:absolute;top:0;left:0;overflow-x:hidden;overflow-y:hidden;-webkit-box-shadow:0 0 10px rgba(0,0,0,.12);box-shadow:0 0 10px rgba(0,0,0,.12)}.el-table__fixed-right:before,.el-table__fixed:before{content:\"\";position:absolute;left:0;bottom:0;width:100%;height:1px;background-color:#ebeef5;z-index:4}.el-table__fixed-right-patch{position:absolute;top:-1px;right:0;background-color:#fff;border-bottom:1px solid #ebeef5}.el-table__fixed-right{top:0;left:auto;right:0}.el-table__fixed-right .el-table__fixed-body-wrapper,.el-table__fixed-right .el-table__fixed-footer-wrapper,.el-table__fixed-right .el-table__fixed-header-wrapper{left:auto;right:0}.el-table__fixed-header-wrapper{position:absolute;left:0;top:0;z-index:3}.el-table__fixed-footer-wrapper{position:absolute;left:0;bottom:0;z-index:3}.el-table__fixed-footer-wrapper tbody td{border-top:1px solid #ebeef5;background-color:#f3f3f4;color:#676a6c}.el-table__fixed-body-wrapper{position:absolute;left:0;top:37px;overflow:hidden;z-index:3}.el-table__body-wrapper,.el-table__footer-wrapper,.el-table__header-wrapper{width:100%}.el-table__footer-wrapper{margin-top:-1px}.el-table__footer-wrapper td{border-top:1px solid #ebeef5}.el-table__body,.el-table__footer,.el-table__header{table-layout:fixed;border-collapse:separate}.el-table__footer-wrapper,.el-table__header-wrapper{overflow:hidden}.el-table__footer-wrapper tbody td,.el-table__header-wrapper tbody td{background-color:#f3f3f4;color:#676a6c}.el-table__body-wrapper{overflow:hidden;position:relative}.el-table__body-wrapper.is-scrolling-left~.el-table__fixed,.el-table__body-wrapper.is-scrolling-none~.el-table__fixed,.el-table__body-wrapper.is-scrolling-none~.el-table__fixed-right,.el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right{-webkit-box-shadow:none;box-shadow:none}.el-table__body-wrapper .el-table--border.is-scrolling-right~.el-table__fixed-right{border-left:1px solid #ebeef5}.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{border-right:1px solid #ebeef5}.el-table .caret-wrapper{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:34px;width:24px;vertical-align:middle;cursor:pointer;overflow:initial;position:relative}.el-table .sort-caret{width:0;height:0;border:5px solid transparent;position:absolute;left:7px}.el-table .sort-caret.ascending{border-bottom-color:#ddd;top:5px}.el-table .sort-caret.descending{border-top-color:#ddd;bottom:7px}.el-table .ascending .sort-caret.ascending{border-bottom-color:#1c84c6}.el-table .descending .sort-caret.descending{border-top-color:#1c84c6}.el-table .hidden-columns{visibility:hidden;position:absolute;z-index:-1}.el-table--striped .el-table__body tr.el-table__row--striped td{background:#fafafa}.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,.el-table__body tr.current-row>td,.el-table__body tr.hover-row.current-row>td,.el-table__body tr.hover-row.el-table__row--striped.current-row>td,.el-table__body tr.hover-row.el-table__row--striped>td,.el-table__body tr.hover-row>td{background-color:#e8f3f9}.el-table__column-resize-proxy{position:absolute;left:200px;top:0;bottom:0;width:0;border-left:1px solid #ebeef5;z-index:10}.el-table__column-filter-trigger{display:inline-block;line-height:34px;cursor:pointer}.el-table__column-filter-trigger i{color:#3f5060;font-size:12px;-webkit-transform:scale(.75);transform:scale(.75)}.el-table--enable-row-transition .el-table__body td{-webkit-transition:background-color .25s ease;transition:background-color .25s ease}.el-table--enable-row-hover .el-table__body tr:hover>td{background-color:#f3f3f4}.el-table--fluid-height .el-table__fixed,.el-table--fluid-height .el-table__fixed-right{bottom:0;overflow:hidden}.el-table-column--selection .cell{padding-left:14px;padding-right:14px}.el-table-filter{border:1px solid #ebeef5;border-radius:2px;background-color:#fff;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);-webkit-box-sizing:border-box;box-sizing:border-box;margin:2px 0}.el-table-filter__list{padding:5px 0;margin:0;list-style:none;min-width:100px}.el-table-filter__list-item{line-height:36px;padding:0 10px;cursor:pointer;font-size:14px}.el-table-filter__list-item:hover{background-color:#e8f3f9;color:#499dd1}.el-table-filter__list-item.is-active{background-color:#1c84c6;color:#fff}.el-table-filter__content{min-width:100px}.el-table-filter__bottom{border-top:1px solid #ebeef5;padding:8px}.el-table-filter__bottom button{background:transparent;border:none;color:#676a6c;cursor:pointer;font-size:13px;padding:0 3px}.el-table-filter__bottom button:hover{color:#1c84c6}.el-table-filter__bottom button:focus{outline:none}.el-table-filter__bottom button.is-disabled{color:#ddd;cursor:not-allowed}.el-table-filter__checkbox-group{padding:10px}.el-table-filter__checkbox-group label.el-checkbox{display:block;margin-bottom:8px;margin-left:5px}.el-table-filter__checkbox-group .el-checkbox:last-child{margin-bottom:0}.el-date-table{font-size:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-date-table.is-week-mode .el-date-table__row:hover div{background-color:#f2f6fc}.el-date-table.is-week-mode .el-date-table__row:hover td.available:hover{color:#676a6c}.el-date-table.is-week-mode .el-date-table__row:hover td:first-child div{margin-left:5px;border-top-left-radius:15px;border-bottom-left-radius:15px}.el-date-table.is-week-mode .el-date-table__row:hover td:last-child div{margin-right:5px;border-top-right-radius:15px;border-bottom-right-radius:15px}.el-date-table.is-week-mode .el-date-table__row.current div{background-color:#f2f6fc}.el-date-table td{width:32px;padding:4px 0;text-align:center;cursor:pointer;position:relative}.el-date-table td,.el-date-table td div{height:30px;-webkit-box-sizing:border-box;box-sizing:border-box}.el-date-table td div{padding:3px 0}.el-date-table td span{width:24px;height:24px;display:block;margin:0 auto;line-height:24px;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-radius:50%}.el-date-table td.next-month,.el-date-table td.prev-month{color:#ddd}.el-date-table td.today{position:relative}.el-date-table td.today span{color:#1c84c6;font-weight:700}.el-date-table td.today.end-date span,.el-date-table td.today.start-date span{color:#fff}.el-date-table td.available:hover{color:#1c84c6}.el-date-table td.in-range div,.el-date-table td.in-range div:hover{background-color:#f2f6fc}.el-date-table td.current:not(.disabled) span{color:#fff;background-color:#1c84c6}.el-date-table td.end-date div,.el-date-table td.start-date div{color:#fff}.el-date-table td.end-date span,.el-date-table td.start-date span{background-color:#1c84c6}.el-date-table td.start-date div{margin-left:5px;border-top-left-radius:15px;border-bottom-left-radius:15px}.el-date-table td.end-date div{margin-right:5px;border-top-right-radius:15px;border-bottom-right-radius:15px}.el-date-table td.disabled div{background-color:#f3f3f4;opacity:1;cursor:not-allowed;color:#ddd}.el-date-table td.week{font-size:80%;color:#676a6c}.el-date-table th{padding:5px;color:#676a6c;font-weight:400;border-bottom:1px solid #ebeef5}.el-month-table{font-size:12px;margin:-1px;border-collapse:collapse}.el-month-table td{text-align:center;padding:20px 3px;cursor:pointer}.el-month-table td.disabled .cell{background-color:#f3f3f4;cursor:not-allowed;color:#ddd}.el-month-table td.disabled .cell:hover{color:#ddd}.el-month-table td .cell{width:48px;height:32px;display:block;line-height:32px;color:#676a6c;margin:0 auto}.el-month-table td .cell:hover,.el-month-table td.current:not(.disabled) .cell{color:#1c84c6}.el-year-table{font-size:12px;margin:-1px;border-collapse:collapse}.el-year-table .el-icon{color:#676a6c}.el-year-table td{text-align:center;padding:20px 3px;cursor:pointer}.el-year-table td.disabled .cell{background-color:#f3f3f4;cursor:not-allowed;color:#ddd}.el-year-table td.disabled .cell:hover{color:#ddd}.el-year-table td .cell{width:48px;height:32px;display:block;line-height:32px;color:#676a6c;margin:0 auto}.el-year-table td .cell:hover,.el-year-table td.current:not(.disabled) .cell{color:#1c84c6}.el-date-range-picker{width:646px}.el-date-range-picker.has-sidebar{width:756px}.el-date-range-picker table{table-layout:fixed;width:100%}.el-date-range-picker .el-picker-panel__body{min-width:513px}.el-date-range-picker .el-picker-panel__content{margin:0}.el-date-range-picker__header{position:relative;text-align:center;height:28px}.el-date-range-picker__header [class*=arrow-left]{float:left}.el-date-range-picker__header [class*=arrow-right]{float:right}.el-date-range-picker__header div{font-size:16px;font-weight:500;margin-right:50px}.el-date-range-picker__content{float:left;width:50%;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:16px}.el-date-range-picker__content.is-left{border-right:1px solid #e4e4e4}.el-date-range-picker__content.is-right .el-date-range-picker__header div{margin-left:50px;margin-right:50px}.el-date-range-picker__editors-wrap{-webkit-box-sizing:border-box;box-sizing:border-box;display:table-cell}.el-date-range-picker__editors-wrap.is-right{text-align:right}.el-date-range-picker__time-header{position:relative;border-bottom:1px solid #e4e4e4;font-size:12px;padding:8px 5px 5px;display:table;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.el-date-range-picker__time-header>.el-icon-arrow-right{font-size:20px;vertical-align:middle;display:table-cell;color:#676a6c}.el-date-range-picker__time-picker-wrap{position:relative;display:table-cell;padding:0 5px}.el-date-range-picker__time-picker-wrap .el-picker-panel{position:absolute;top:13px;right:0;z-index:1;background:#fff}.el-date-picker{width:322px}.el-date-picker.has-sidebar.has-time{width:434px}.el-date-picker.has-sidebar{width:438px}.el-date-picker.has-time .el-picker-panel__body-wrapper{position:relative}.el-date-picker .el-picker-panel__content{width:292px}.el-date-picker table{table-layout:fixed;width:100%}.el-date-picker__editor-wrap{position:relative;display:table-cell;padding:0 5px}.el-date-picker__time-header{position:relative;border-bottom:1px solid #e4e4e4;font-size:12px;padding:8px 5px 5px;display:table;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.el-date-picker__header{margin:12px;text-align:center}.el-date-picker__header--bordered{margin-bottom:0;padding-bottom:12px;border-bottom:1px solid #ebeef5}.el-date-picker__header--bordered+.el-picker-panel__content{margin-top:0}.el-date-picker__header-label{font-size:16px;font-weight:500;padding:0 5px;line-height:22px;text-align:center;cursor:pointer;color:#676a6c}.el-date-picker__header-label.active,.el-date-picker__header-label:hover{color:#1c84c6}.el-date-picker__prev-btn{float:left}.el-date-picker__next-btn{float:right}.el-date-picker__time-wrap{padding:10px;text-align:center}.el-date-picker__time-label{float:left;cursor:pointer;line-height:30px;margin-left:10px}.time-select{margin:5px 0;min-width:0}.time-select .el-picker-panel__content{max-height:200px;margin:0}.time-select-item{padding:8px 10px;font-size:14px;line-height:20px}.time-select-item.selected:not(.disabled){color:#1c84c6;font-weight:700}.time-select-item.disabled{color:#e4e7ed;cursor:not-allowed}.time-select-item:hover{background-color:#f3f3f4;font-weight:700;cursor:pointer}.fade-in-linear-enter-active,.fade-in-linear-leave-active{-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.fade-in-linear-enter,.fade-in-linear-leave,.fade-in-linear-leave-active{opacity:0}.el-fade-in-linear-enter-active,.el-fade-in-linear-leave-active{-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.el-fade-in-linear-enter,.el-fade-in-linear-leave,.el-fade-in-linear-leave-active{opacity:0}.el-fade-in-enter-active,.el-fade-in-leave-active{-webkit-transition:all .3s cubic-bezier(.55,0,.1,1);transition:all .3s cubic-bezier(.55,0,.1,1)}.el-fade-in-enter,.el-fade-in-leave-active{opacity:0}.el-zoom-in-center-enter-active,.el-zoom-in-center-leave-active{-webkit-transition:all .3s cubic-bezier(.55,0,.1,1);transition:all .3s cubic-bezier(.55,0,.1,1)}.el-zoom-in-center-enter,.el-zoom-in-center-leave-active{opacity:0;-webkit-transform:scaleX(0);transform:scaleX(0)}.el-zoom-in-top-enter-active,.el-zoom-in-top-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center top;transform-origin:center top}.el-zoom-in-top-enter,.el-zoom-in-top-leave-active{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.el-zoom-in-bottom-enter-active,.el-zoom-in-bottom-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center bottom;transform-origin:center bottom}.el-zoom-in-bottom-enter,.el-zoom-in-bottom-leave-active{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.el-zoom-in-left-enter-active,.el-zoom-in-left-leave-active{opacity:1;-webkit-transform:scale(1);transform:scale(1);-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:top left;transform-origin:top left}.el-zoom-in-left-enter,.el-zoom-in-left-leave-active{opacity:0;-webkit-transform:scale(.45);transform:scale(.45)}.collapse-transition{-webkit-transition:height .3s ease-in-out,padding-top .3s ease-in-out,padding-bottom .3s ease-in-out;transition:height .3s ease-in-out,padding-top .3s ease-in-out,padding-bottom .3s ease-in-out}.horizontal-collapse-transition{-webkit-transition:width .3s ease-in-out,padding-left .3s ease-in-out,padding-right .3s ease-in-out;transition:width .3s ease-in-out,padding-left .3s ease-in-out,padding-right .3s ease-in-out}.el-list-enter-active,.el-list-leave-active{-webkit-transition:all 1s;transition:all 1s}.el-list-enter,.el-list-leave-active{opacity:0;-webkit-transform:translateY(-30px);transform:translateY(-30px)}.el-opacity-transition{-webkit-transition:opacity .3s cubic-bezier(.55,0,.1,1);transition:opacity .3s cubic-bezier(.55,0,.1,1)}.el-date-editor{position:relative;display:inline-block;text-align:left}.el-date-editor.el-input,.el-date-editor.el-input__inner{width:220px}.el-date-editor--daterange.el-input,.el-date-editor--daterange.el-input__inner,.el-date-editor--timerange.el-input,.el-date-editor--timerange.el-input__inner{width:350px}.el-date-editor--datetimerange.el-input,.el-date-editor--datetimerange.el-input__inner{width:400px}.el-date-editor .el-icon-circle-close{cursor:pointer}.el-date-editor .el-range__icon{font-size:14px;margin-left:-5px;color:#ddd;float:left;line-height:32px}.el-date-editor .el-range-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:none;display:inline-block;height:100%;margin:0;padding:0;width:39%;text-align:center;font-size:14px;color:#676a6c}.el-date-editor .el-range-input::-webkit-input-placeholder{color:#ddd}.el-date-editor .el-range-input:-ms-input-placeholder,.el-date-editor .el-range-input::-ms-input-placeholder{color:#ddd}.el-date-editor .el-range-input::placeholder{color:#ddd}.el-date-editor .el-range-separator{display:inline-block;height:100%;padding:0 5px;margin:0;text-align:center;line-height:32px;font-size:14px;width:5%;color:#676a6c}.el-date-editor .el-range__close-icon{font-size:14px;color:#ddd;width:25px;display:inline-block;float:right;line-height:32px}.el-range-editor.el-input__inner{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:3px 10px}.el-range-editor .el-range-input{line-height:1}.el-range-editor.is-active,.el-range-editor.is-active:hover{border-color:#1c84c6}.el-range-editor--medium.el-input__inner{height:36px}.el-range-editor--medium .el-range-separator{line-height:28px;font-size:14px}.el-range-editor--medium .el-range-input{font-size:14px}.el-range-editor--medium .el-range__close-icon,.el-range-editor--medium .el-range__icon{line-height:28px}.el-range-editor--small.el-input__inner{height:32px}.el-range-editor--small .el-range-separator{line-height:24px;font-size:13px}.el-range-editor--small .el-range-input{font-size:13px}.el-range-editor--small .el-range__close-icon,.el-range-editor--small .el-range__icon{line-height:24px}.el-range-editor--mini.el-input__inner{height:28px}.el-range-editor--mini .el-range-separator{line-height:20px;font-size:12px}.el-range-editor--mini .el-range-input{font-size:12px}.el-range-editor--mini .el-range__close-icon,.el-range-editor--mini .el-range__icon{line-height:20px}.el-range-editor.is-disabled{background-color:#f3f3f4;border-color:#e4e7ed;color:#ddd;cursor:not-allowed}.el-range-editor.is-disabled:focus,.el-range-editor.is-disabled:hover{border-color:#e4e7ed}.el-range-editor.is-disabled input{background-color:#f3f3f4;color:#ddd;cursor:not-allowed}.el-range-editor.is-disabled input::-webkit-input-placeholder{color:#ddd}.el-range-editor.is-disabled input:-ms-input-placeholder,.el-range-editor.is-disabled input::-ms-input-placeholder{color:#ddd}.el-range-editor.is-disabled input::placeholder{color:#ddd}.el-range-editor.is-disabled .el-range-separator{color:#ddd}.el-picker-panel{color:#676a6c;border:1px solid #e4e7ed;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);background:#fff;border-radius:4px;line-height:30px;margin:5px 0}.el-picker-panel__body-wrapper:after,.el-picker-panel__body:after{content:\"\";display:table;clear:both}.el-picker-panel__content{position:relative;margin:15px}.el-picker-panel__footer{border-top:1px solid #e4e4e4;padding:4px;text-align:right;background-color:#fff;position:relative;font-size:0}.el-picker-panel__shortcut{display:block;width:100%;border:0;background-color:transparent;line-height:28px;font-size:14px;color:#676a6c;padding-left:12px;text-align:left;outline:none;cursor:pointer}.el-picker-panel__shortcut:hover{color:#1c84c6}.el-picker-panel__shortcut.active{background-color:#e6f1fe;color:#1c84c6}.el-picker-panel__btn{border:1px solid #dcdcdc;color:#333;line-height:24px;border-radius:2px;padding:0 20px;cursor:pointer;background-color:transparent;outline:none;font-size:12px}.el-picker-panel__btn[disabled]{color:#ccc;cursor:not-allowed}.el-picker-panel__icon-btn{font-size:12px;color:#676a6c;border:0;background:transparent;cursor:pointer;outline:none;margin-top:8px}.el-picker-panel__icon-btn:hover{color:#1c84c6}.el-picker-panel__icon-btn.is-disabled{color:#bbb}.el-picker-panel__icon-btn.is-disabled:hover{cursor:not-allowed}.el-picker-panel__link-btn{vertical-align:middle}.el-picker-panel [slot=sidebar],.el-picker-panel__sidebar{position:absolute;top:0;bottom:0;width:110px;border-right:1px solid #e4e4e4;-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:6px;background-color:#fff;overflow:auto}.el-picker-panel [slot=sidebar]+.el-picker-panel__body,.el-picker-panel__sidebar+.el-picker-panel__body{margin-left:110px}.el-time-spinner.has-seconds .el-time-spinner__wrapper{width:33.3%}.el-time-spinner__wrapper{max-height:190px;overflow:auto;display:inline-block;width:50%;vertical-align:top;position:relative}.el-time-spinner__wrapper .el-scrollbar__wrap:not(.el-scrollbar__wrap--hidden-default){padding-bottom:15px}.el-time-spinner__wrapper.is-arrow{-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center;overflow:hidden}.el-time-spinner__wrapper.is-arrow .el-time-spinner__list{-webkit-transform:translateY(-32px);transform:translateY(-32px)}.el-time-spinner__wrapper.is-arrow .el-time-spinner__item:hover:not(.disabled):not(.active){background:#fff;cursor:default}.el-time-spinner__arrow{font-size:12px;color:#999;position:absolute;left:0;width:100%;z-index:1;text-align:center;height:30px;line-height:30px;cursor:pointer}.el-time-spinner__arrow:hover{color:#1c84c6}.el-time-spinner__arrow.el-icon-arrow-up{top:10px}.el-time-spinner__arrow.el-icon-arrow-down{bottom:10px}.el-time-spinner__input.el-input{width:70%}.el-time-spinner__input.el-input .el-input__inner,.el-time-spinner__list{padding:0;text-align:center}.el-time-spinner__list{margin:0;list-style:none}.el-time-spinner__list:after,.el-time-spinner__list:before{content:\"\";display:block;width:100%;height:80px}.el-time-spinner__item{height:32px;line-height:32px;font-size:12px;color:#676a6c}.el-time-spinner__item:hover:not(.disabled):not(.active){background:#f3f3f4;cursor:pointer}.el-time-spinner__item.active:not(.disabled){color:#676a6c;font-weight:700}.el-time-spinner__item.disabled{color:#ddd;cursor:not-allowed}.el-time-panel{margin:5px 0;border:1px solid #e4e7ed;background-color:#fff;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);border-radius:2px;position:absolute;width:180px;left:0;z-index:1000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-time-panel__content{font-size:0;position:relative;overflow:hidden}.el-time-panel__content:after,.el-time-panel__content:before{content:\"\";top:50%;position:absolute;margin-top:-15px;height:32px;z-index:-1;left:0;right:0;-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:6px;text-align:left;border-top:1px solid #e4e7ed;border-bottom:1px solid #e4e7ed}.el-time-panel__content:after{left:50%;margin-left:12%;margin-right:12%}.el-time-panel__content:before{padding-left:50%;margin-right:12%;margin-left:12%}.el-time-panel__content.has-seconds:after{left:66.66667%}.el-time-panel__content.has-seconds:before{padding-left:33.33333%}.el-time-panel__footer{border-top:1px solid #e4e4e4;padding:4px;height:36px;line-height:25px;text-align:right;-webkit-box-sizing:border-box;box-sizing:border-box}.el-time-panel__btn{border:none;line-height:28px;padding:0 5px;margin:0 5px;cursor:pointer;background-color:transparent;outline:none;font-size:12px;color:#676a6c}.el-time-panel__btn.confirm{font-weight:800;color:#1c84c6}.el-time-range-picker{width:354px;overflow:visible}.el-time-range-picker__content{position:relative;text-align:center;padding:10px}.el-time-range-picker__cell{-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:4px 7px 7px;width:50%;display:inline-block}.el-time-range-picker__header{margin-bottom:5px;text-align:center;font-size:14px}.el-time-range-picker__body{border-radius:2px;border:1px solid #e4e7ed}.el-popover{position:absolute;background:#fff;min-width:150px;border-radius:4px;border:1px solid #ebeef5;padding:12px;z-index:2000;color:#676a6c;line-height:1.4;text-align:justify;font-size:14px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-popover--plain{padding:18px 20px}.el-popover__title{color:#676a6c;font-size:16px;line-height:1;margin-bottom:12px}.el-popover:focus,.el-popover:focus:active,.el-popover__reference:focus:hover,.el-popover__reference:focus:not(.focusing){outline-width:0}.v-modal-enter{-webkit-animation:v-modal-in .2s ease;animation:v-modal-in .2s ease}.v-modal-leave{-webkit-animation:v-modal-out .2s ease forwards;animation:v-modal-out .2s ease forwards}@keyframes v-modal-in{0%{opacity:0}}@keyframes v-modal-out{to{opacity:0}}.v-modal{position:fixed;left:0;top:0;width:100%;height:100%;opacity:.5;background:#000}.el-message-box{display:inline-block;width:420px;padding-bottom:10px;vertical-align:middle;background-color:#fff;border-radius:4px;border:1px solid #ebeef5;font-size:18px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);text-align:left;overflow:hidden;-webkit-backface-visibility:hidden;backface-visibility:hidden}.el-message-box__wrapper{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center}.el-message-box__wrapper:after{content:\"\";display:inline-block;height:100%;width:0;vertical-align:middle}.el-message-box__header{position:relative;padding:15px;padding-bottom:10px}.el-message-box__title{padding-left:0;margin-bottom:0;font-size:18px;line-height:1;color:#676a6c}.el-message-box__headerbtn{position:absolute;top:15px;right:15px;padding:0;border:none;outline:none;background:transparent;font-size:16px;cursor:pointer}.el-message-box__headerbtn .el-message-box__close{color:#3f5060}.el-message-box__headerbtn:focus .el-message-box__close,.el-message-box__headerbtn:hover .el-message-box__close{color:#1c84c6}.el-message-box__content{position:relative;padding:10px 15px;color:#676a6c;font-size:14px}.el-message-box__input{padding-top:15px}.el-message-box__input input.invalid,.el-message-box__input input.invalid:focus{border-color:#ed5565}.el-message-box__status{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:24px!important}.el-message-box__status:before{padding-left:1px}.el-message-box__status+.el-message-box__message{padding-left:36px;padding-right:12px}.el-message-box__status.el-icon-success{color:#1ab394}.el-message-box__status.el-icon-info{color:#3f5060}.el-message-box__status.el-icon-warning{color:#f8ac59}.el-message-box__status.el-icon-error{color:#ed5565}.el-message-box__message{margin:0}.el-message-box__message p{margin:0;line-height:24px}.el-message-box__errormsg{color:#ed5565;font-size:12px;min-height:18px;margin-top:2px}.el-message-box__btns{padding:5px 15px 0;text-align:right}.el-message-box__btns button:nth-child(2){margin-left:10px}.el-message-box__btns-reverse{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.el-message-box--center{padding-bottom:30px}.el-message-box--center .el-message-box__header{padding-top:30px}.el-message-box--center .el-message-box__title{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-message-box--center .el-message-box__status{position:relative;top:auto;padding-right:5px;text-align:center;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.el-message-box--center .el-message-box__message{margin-left:0}.el-message-box--center .el-message-box__btns,.el-message-box--center .el-message-box__content{text-align:center}.el-message-box--center .el-message-box__content{padding-left:27px;padding-right:27px}.msgbox-fade-enter-active{-webkit-animation:msgbox-fade-in .3s;animation:msgbox-fade-in .3s}.msgbox-fade-leave-active{-webkit-animation:msgbox-fade-out .3s;animation:msgbox-fade-out .3s}@-webkit-keyframes msgbox-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes msgbox-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@-webkit-keyframes msgbox-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}@keyframes msgbox-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}.el-breadcrumb{font-size:14px;line-height:1}.el-breadcrumb:after,.el-breadcrumb:before{display:table;content:\"\"}.el-breadcrumb:after{clear:both}.el-breadcrumb__separator{margin:0 9px;font-weight:700;color:#ddd}.el-breadcrumb__separator[class*=icon]{margin:0 6px;font-weight:400}.el-breadcrumb__item{float:left}.el-breadcrumb__inner{color:#676a6c}.el-breadcrumb__inner.is-link,.el-breadcrumb__inner a{font-weight:700;text-decoration:none;-webkit-transition:color .2s cubic-bezier(.645,.045,.355,1);transition:color .2s cubic-bezier(.645,.045,.355,1);color:#676a6c}.el-breadcrumb__inner.is-link:hover,.el-breadcrumb__inner a:hover{color:#1c84c6;cursor:pointer}.el-breadcrumb__item:last-child .el-breadcrumb__inner,.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,.el-breadcrumb__item:last-child .el-breadcrumb__inner a,.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover{font-weight:400;color:#676a6c;cursor:text}.el-breadcrumb__item:last-child .el-breadcrumb__separator{display:none}.el-form--label-left .el-form-item__label{text-align:left}.el-form--label-top .el-form-item__label{float:none;display:inline-block;text-align:left;padding:0 0 10px}.el-form--inline .el-form-item{display:inline-block;margin-right:10px;vertical-align:top}.el-form--inline .el-form-item__label{float:none;display:inline-block}.el-form--inline .el-form-item__content{display:inline-block;vertical-align:top}.el-form--inline.el-form--label-top .el-form-item__content{display:block}.el-form-item{margin-bottom:22px}.el-form-item:after,.el-form-item:before{display:table;content:\"\"}.el-form-item:after{clear:both}.el-form-item .el-form-item{margin-bottom:0}.el-form-item .el-input__validateIcon{display:none}.el-form-item--medium .el-form-item__content,.el-form-item--medium .el-form-item__label{line-height:36px}.el-form-item--small .el-form-item__content,.el-form-item--small .el-form-item__label{line-height:32px}.el-form-item--small.el-form-item{margin-bottom:18px}.el-form-item--small .el-form-item__error{padding-top:2px}.el-form-item--mini .el-form-item__content,.el-form-item--mini .el-form-item__label{line-height:28px}.el-form-item--mini.el-form-item{margin-bottom:18px}.el-form-item--mini .el-form-item__error{padding-top:1px}.el-form-item__label{text-align:right;vertical-align:middle;float:left;font-size:14px;color:#676a6c;line-height:40px;padding:0 12px 0 0;-webkit-box-sizing:border-box;box-sizing:border-box}.el-form-item__content{line-height:40px;position:relative;font-size:14px}.el-form-item__content:after,.el-form-item__content:before{display:table;content:\"\"}.el-form-item__content:after{clear:both}.el-form-item__content .el-input-group{vertical-align:middle}.el-form-item__error{color:#ed5565;font-size:12px;line-height:1;padding-top:4px;position:absolute;top:100%;left:0}.el-form-item__error--inline{position:relative;top:auto;left:auto;display:inline-block;margin-left:10px}.el-form-item.is-required .el-form-item__label:before{content:\"*\";color:#ed5565;margin-right:4px}.el-form-item.is-error .el-input__inner,.el-form-item.is-error .el-input__inner:focus,.el-form-item.is-error .el-textarea__inner,.el-form-item.is-error .el-textarea__inner:focus{border-color:#ed5565}.el-form-item.is-error .el-input-group__append .el-input__inner,.el-form-item.is-error .el-input-group__prepend .el-input__inner{border-color:transparent}.el-form-item.is-error .el-input__validateIcon{color:#ed5565}.el-form-item.is-success .el-input__inner,.el-form-item.is-success .el-input__inner:focus,.el-form-item.is-success .el-textarea__inner,.el-form-item.is-success .el-textarea__inner:focus{border-color:#1ab394}.el-form-item.is-success .el-input-group__append .el-input__inner,.el-form-item.is-success .el-input-group__prepend .el-input__inner{border-color:transparent}.el-form-item.is-success .el-input__validateIcon{color:#1ab394}.el-form-item--feedback .el-input__validateIcon{display:inline-block}.el-tabs__header{padding:0;position:relative;margin:0 0 15px}.el-tabs__active-bar{position:absolute;bottom:0;left:0;height:2px;background-color:#1c84c6;z-index:1;-webkit-transition:-webkit-transform .3s cubic-bezier(.645,.045,.355,1);transition:-webkit-transform .3s cubic-bezier(.645,.045,.355,1);transition:transform .3s cubic-bezier(.645,.045,.355,1);transition:transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);list-style:none}.el-tabs__new-tab{float:right;border:1px solid #d3dce6;height:18px;width:18px;line-height:18px;margin:12px 0 9px 10px;border-radius:3px;text-align:center;font-size:12px;color:#d3dce6;cursor:pointer;-webkit-transition:all .15s;transition:all .15s}.el-tabs__new-tab .el-icon-plus{-webkit-transform:scale(.8);transform:scale(.8)}.el-tabs__new-tab:hover{color:#1c84c6}.el-tabs__nav-wrap{overflow:hidden;margin-bottom:-1px;position:relative}.el-tabs__nav-wrap:after{content:\"\";position:absolute;left:0;bottom:0;width:100%;height:2px;background-color:#e4e7ed;z-index:1}.el-tabs__nav-wrap.is-scrollable{padding:0 20px;-webkit-box-sizing:border-box;box-sizing:border-box}.el-tabs__nav-scroll{overflow:hidden}.el-tabs__nav-next,.el-tabs__nav-prev{position:absolute;cursor:pointer;line-height:44px;font-size:12px;color:#999}.el-tabs__nav-next{right:0}.el-tabs__nav-prev{left:0}.el-tabs__nav{white-space:nowrap;position:relative;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;float:left;z-index:2}.el-tabs__item{padding:0 20px;height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;line-height:40px;display:inline-block;list-style:none;font-size:14px;font-weight:500;color:#676a6c;position:relative}.el-tabs__item:focus,.el-tabs__item:focus:active{outline:none}.el-tabs__item:focus.is-active.is-focus:not(:active){-webkit-box-shadow:0 0 2px 2px #409eff inset;box-shadow:inset 0 0 2px 2px #409eff;border-radius:3px}.el-tabs__item .el-icon-close{border-radius:50%;text-align:center;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);margin-left:5px}.el-tabs__item .el-icon-close:before{-webkit-transform:scale(.9);transform:scale(.9);display:inline-block}.el-tabs__item .el-icon-close:hover{background-color:#ddd;color:#fff}.el-tabs__item.is-active{color:#1c84c6}.el-tabs__item:hover{color:#1c84c6;cursor:pointer}.el-tabs__item.is-disabled{color:#ddd;cursor:default}.el-tabs__content{overflow:hidden;position:relative}.el-tabs--card>.el-tabs__header{border-bottom:1px solid #e4e7ed}.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap:after{content:none}.el-tabs--card>.el-tabs__header .el-tabs__nav{border:1px solid #e4e7ed;border-bottom:none;border-radius:4px 4px 0 0}.el-tabs--card>.el-tabs__header .el-tabs__active-bar{display:none}.el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close{position:relative;font-size:12px;width:0;height:14px;vertical-align:middle;line-height:15px;overflow:hidden;top:-1px;right:-2px;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.el-tabs--card>.el-tabs__header .el-tabs__item{border-bottom:1px solid transparent;border-left:1px solid #e4e7ed;-webkit-transition:color .3s cubic-bezier(.645,.045,.355,1),padding .3s cubic-bezier(.645,.045,.355,1);transition:color .3s cubic-bezier(.645,.045,.355,1),padding .3s cubic-bezier(.645,.045,.355,1)}.el-tabs--card>.el-tabs__header .el-tabs__item:first-child{border-left:none}.el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover{padding-left:13px;padding-right:13px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover .el-icon-close{width:14px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{border-bottom-color:#fff}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{padding-left:20px;padding-right:20px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close{width:14px}.el-tabs--border-card{background:#fff;border:1px solid #dcdfe6;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);box-shadow:0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04)}.el-tabs--border-card>.el-tabs__content{padding:15px}.el-tabs--border-card>.el-tabs__header{background-color:#f3f3f4;border-bottom:1px solid #e4e7ed;margin:0}.el-tabs--border-card>.el-tabs__header .el-tabs__nav-wrap:after{content:none}.el-tabs--border-card>.el-tabs__header .el-tabs__item{-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);border:1px solid transparent;margin:-1px -1px 0;color:#999}.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color:#1c84c6;background-color:#fff;border-right-color:#dcdfe6;border-left-color:#dcdfe6}.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{color:#1c84c6}.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),.el-tabs--bottom .el-tabs__item.is-top:nth-child(2),.el-tabs--top .el-tabs__item.is-bottom:nth-child(2),.el-tabs--top .el-tabs__item.is-top:nth-child(2){padding-left:0}.el-tabs--bottom .el-tabs__item.is-bottom:last-child,.el-tabs--bottom .el-tabs__item.is-top:last-child,.el-tabs--top .el-tabs__item.is-bottom:last-child,.el-tabs--top .el-tabs__item.is-top:last-child{padding-right:0}.el-tabs--bottom.el-tabs--border-card .el-tabs__item:nth-child(2),.el-tabs--bottom.el-tabs--card .el-tabs__item:nth-child(2),.el-tabs--bottom .el-tabs--left .el-tabs__item:nth-child(2),.el-tabs--bottom .el-tabs--right .el-tabs__item:nth-child(2),.el-tabs--top.el-tabs--border-card .el-tabs__item:nth-child(2),.el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2),.el-tabs--top .el-tabs--left .el-tabs__item:nth-child(2),.el-tabs--top .el-tabs--right .el-tabs__item:nth-child(2){padding-left:20px}.el-tabs--bottom.el-tabs--border-card .el-tabs__item:last-child,.el-tabs--bottom.el-tabs--card .el-tabs__item:last-child,.el-tabs--bottom .el-tabs--left .el-tabs__item:last-child,.el-tabs--bottom .el-tabs--right .el-tabs__item:last-child,.el-tabs--top.el-tabs--border-card .el-tabs__item:last-child,.el-tabs--top.el-tabs--card .el-tabs__item:last-child,.el-tabs--top .el-tabs--left .el-tabs__item:last-child,.el-tabs--top .el-tabs--right .el-tabs__item:last-child{padding-right:20px}.el-tabs--bottom .el-tabs__header.is-bottom{margin-bottom:0;margin-top:10px}.el-tabs--bottom.el-tabs--border-card .el-tabs__header.is-bottom{border-bottom:0;border-top:1px solid #dcdfe6}.el-tabs--bottom.el-tabs--border-card .el-tabs__nav-wrap.is-bottom{margin-top:-1px;margin-bottom:0}.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom:not(.is-active){border:1px solid transparent}.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom{margin:0 -1px -1px}.el-tabs--left,.el-tabs--right{overflow:hidden}.el-tabs--left .el-tabs__header.is-left,.el-tabs--left .el-tabs__header.is-right,.el-tabs--left .el-tabs__nav-scroll,.el-tabs--left .el-tabs__nav-wrap.is-left,.el-tabs--left .el-tabs__nav-wrap.is-right,.el-tabs--right .el-tabs__header.is-left,.el-tabs--right .el-tabs__header.is-right,.el-tabs--right .el-tabs__nav-scroll,.el-tabs--right .el-tabs__nav-wrap.is-left,.el-tabs--right .el-tabs__nav-wrap.is-right{height:100%}.el-tabs--left .el-tabs__active-bar.is-left,.el-tabs--left .el-tabs__active-bar.is-right,.el-tabs--right .el-tabs__active-bar.is-left,.el-tabs--right .el-tabs__active-bar.is-right{top:0;bottom:auto;width:2px;height:auto}.el-tabs--left .el-tabs__nav-wrap.is-left,.el-tabs--left .el-tabs__nav-wrap.is-right,.el-tabs--right .el-tabs__nav-wrap.is-left,.el-tabs--right .el-tabs__nav-wrap.is-right{margin-bottom:0}.el-tabs--left .el-tabs__nav-wrap.is-left.is-scrollable,.el-tabs--left .el-tabs__nav-wrap.is-right.is-scrollable,.el-tabs--right .el-tabs__nav-wrap.is-left.is-scrollable,.el-tabs--right .el-tabs__nav-wrap.is-right.is-scrollable{padding:30px 0}.el-tabs--left .el-tabs__nav-wrap.is-left:after,.el-tabs--left .el-tabs__nav-wrap.is-right:after,.el-tabs--right .el-tabs__nav-wrap.is-left:after,.el-tabs--right .el-tabs__nav-wrap.is-right:after{height:100%;width:2px;bottom:auto;top:0}.el-tabs--left .el-tabs__nav,.el-tabs--right .el-tabs__nav{float:none}.el-tabs--left .el-tabs__item.is-left,.el-tabs--left .el-tabs__item.is-right,.el-tabs--right .el-tabs__item.is-left,.el-tabs--right .el-tabs__item.is-right{display:block}.el-tabs--left .el-tabs__nav-next,.el-tabs--left .el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-next,.el-tabs--right .el-tabs__nav-prev{height:30px;line-height:30px;width:100%;text-align:center;cursor:pointer}.el-tabs--left .el-tabs__nav-next i,.el-tabs--left .el-tabs__nav-prev i,.el-tabs--right .el-tabs__nav-next i,.el-tabs--right .el-tabs__nav-prev i{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-tabs--left .el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-prev{left:auto;top:0}.el-tabs--left .el-tabs__nav-next,.el-tabs--right .el-tabs__nav-next{right:auto;bottom:0}.el-tabs--left .el-tabs__header.is-left{float:left;margin-bottom:0;margin-right:10px}.el-tabs--left .el-tabs__nav-wrap.is-left{margin-right:-1px}.el-tabs--left .el-tabs__active-bar.is-left,.el-tabs--left .el-tabs__nav-wrap.is-left:after{left:auto;right:0}.el-tabs--left .el-tabs__item.is-left{text-align:right}.el-tabs--left.el-tabs--card .el-tabs__active-bar.is-left{display:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left{border-left:none;border-right:1px solid #e4e7ed;border-bottom:none;border-top:1px solid #e4e7ed}.el-tabs--left.el-tabs--card .el-tabs__item.is-left:first-child{border-right:1px solid #e4e7ed;border-top:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active{border:1px solid #e4e7ed;border-right-color:#fff;border-left:none;border-bottom:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:first-child{border-top:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:last-child{border-bottom:none}.el-tabs--left.el-tabs--card .el-tabs__nav{border-radius:4px 0 0 4px;border-bottom:1px solid #e4e7ed;border-right:none}.el-tabs--left.el-tabs--card .el-tabs__new-tab{float:none}.el-tabs--left.el-tabs--border-card .el-tabs__header.is-left{border-right:1px solid #dfe4ed}.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left{border:1px solid transparent;margin:-1px 0 -1px -1px}.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active{border-color:transparent;border-top-color:#d1dbe5;border-bottom-color:#d1dbe5}.el-tabs--right .el-tabs__header.is-right{float:right;margin-bottom:0;margin-left:10px}.el-tabs--right .el-tabs__nav-wrap.is-right{margin-left:-1px}.el-tabs--right .el-tabs__nav-wrap.is-right:after{left:0;right:auto}.el-tabs--right .el-tabs__active-bar.is-right{left:0}.el-tabs--right.el-tabs--card .el-tabs__active-bar.is-right{display:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right{border-bottom:none;border-top:1px solid #e4e7ed}.el-tabs--right.el-tabs--card .el-tabs__item.is-right:first-child{border-left:1px solid #e4e7ed;border-top:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active{border:1px solid #e4e7ed;border-left-color:#fff;border-right:none;border-bottom:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:first-child{border-top:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:last-child{border-bottom:none}.el-tabs--right.el-tabs--card .el-tabs__nav{border-radius:0 4px 4px 0;border-bottom:1px solid #e4e7ed;border-left:none}.el-tabs--right.el-tabs--border-card .el-tabs__header.is-right{border-left:1px solid #dfe4ed}.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right{border:1px solid transparent;margin:-1px -1px -1px 0}.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right.is-active{border-color:transparent;border-top-color:#d1dbe5;border-bottom-color:#d1dbe5}.slideInLeft-transition,.slideInRight-transition{display:inline-block}.slideInRight-enter{-webkit-animation:slideInRight-enter .3s;animation:slideInRight-enter .3s}.slideInRight-leave{position:absolute;left:0;right:0;-webkit-animation:slideInRight-leave .3s;animation:slideInRight-leave .3s}.slideInLeft-enter{-webkit-animation:slideInLeft-enter .3s;animation:slideInLeft-enter .3s}.slideInLeft-leave{position:absolute;left:0;right:0;-webkit-animation:slideInLeft-leave .3s;animation:slideInLeft-leave .3s}@-webkit-keyframes slideInRight-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInRight-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInRight-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0}}@keyframes slideInRight-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0}}@-webkit-keyframes slideInLeft-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInLeft-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInLeft-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%);opacity:0}}@keyframes slideInLeft-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%);opacity:0}}.el-tag{background-color:rgba(28,132,198,.1);display:inline-block;padding:0 10px;height:32px;line-height:30px;font-size:12px;color:#1c84c6;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid rgba(28,132,198,.2);white-space:nowrap}.el-tag .el-icon-close{border-radius:50%;text-align:center;position:relative;cursor:pointer;font-size:12px;height:16px;width:16px;line-height:16px;vertical-align:middle;top:-1px;right:-5px;color:#1c84c6}.el-tag .el-icon-close:before{display:block}.el-tag .el-icon-close:hover{background-color:#1c84c6;color:#fff}.el-tag--info{background-color:rgba(63,80,96,.1);border-color:rgba(63,80,96,.2);color:#3f5060}.el-tag--info.is-hit{border-color:#3f5060}.el-tag--info .el-tag__close{color:#3f5060}.el-tag--info .el-tag__close:hover{background-color:#3f5060;color:#fff}.el-tag--success{background-color:rgba(26,179,148,.1);border-color:rgba(26,179,148,.2);color:#1ab394}.el-tag--success.is-hit{border-color:#1ab394}.el-tag--success .el-tag__close{color:#1ab394}.el-tag--success .el-tag__close:hover{background-color:#1ab394;color:#fff}.el-tag--warning{background-color:rgba(248,172,89,.1);border-color:rgba(248,172,89,.2);color:#f8ac59}.el-tag--warning.is-hit{border-color:#f8ac59}.el-tag--warning .el-tag__close{color:#f8ac59}.el-tag--warning .el-tag__close:hover{background-color:#f8ac59;color:#fff}.el-tag--danger{background-color:rgba(237,85,101,.1);border-color:rgba(237,85,101,.2);color:#ed5565}.el-tag--danger.is-hit{border-color:#ed5565}.el-tag--danger .el-tag__close{color:#ed5565}.el-tag--danger .el-tag__close:hover{background-color:#ed5565;color:#fff}.el-tag--medium{height:28px;line-height:26px}.el-tag--medium .el-icon-close{-webkit-transform:scale(.8);transform:scale(.8)}.el-tag--small{height:24px;padding:0 8px;line-height:22px}.el-tag--small .el-icon-close{-webkit-transform:scale(.8);transform:scale(.8)}.el-tag--mini{height:20px;padding:0 5px;line-height:19px}.el-tag--mini .el-icon-close{margin-left:-3px;-webkit-transform:scale(.7);transform:scale(.7)}.el-tree{position:relative;cursor:default;background:#fff;color:#676a6c}.el-tree__empty-block{position:relative;min-height:60px;text-align:center;width:100%;height:100%}.el-tree__empty-text{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);color:#5d6463}.el-tree__drop-indicator{position:absolute;left:0;right:0;height:1px;background-color:#1c84c6}.el-tree-node{white-space:nowrap;outline:none}.el-tree-node:focus>.el-tree-node__content{background-color:#f3f3f4}.el-tree-node.is-drop-inner>.el-tree-node__content .el-tree-node__label{background-color:#1c84c6;color:#fff}.el-tree-node__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:26px;cursor:pointer}.el-tree-node__content>.el-tree-node__expand-icon{padding:6px}.el-tree-node__content>.el-checkbox{margin-right:8px}.el-tree-node__content:hover{background-color:#f3f3f4}.el-tree.is-dragging .el-tree-node__content{cursor:move}.el-tree.is-dragging .el-tree-node__content *{pointer-events:none}.el-tree.is-dragging.is-drop-not-allow .el-tree-node__content{cursor:not-allowed}.el-tree-node__expand-icon{cursor:pointer;color:#ddd;font-size:12px;-webkit-transform:rotate(0deg);transform:rotate(0deg);-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.el-tree-node__expand-icon.expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-tree-node__expand-icon.is-leaf{color:transparent;cursor:default}.el-tree-node__label{font-size:14px}.el-tree-node__loading-icon{margin-right:8px;font-size:14px;color:#ddd}.el-tree-node>.el-tree-node__children{overflow:hidden;background-color:transparent}.el-tree-node.is-expanded>.el-tree-node__children{display:block}.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{background-color:#edf5fa}.el-alert{width:100%;padding:8px 16px;margin:0;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;position:relative;background-color:#fff;overflow:hidden;opacity:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition:opacity .2s;transition:opacity .2s}.el-alert.is-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-alert--success{background-color:#e8f7f4;color:#1ab394}.el-alert--success .el-alert__description{color:#1ab394}.el-alert--info{background-color:#eceeef;color:#3f5060}.el-alert--info .el-alert__description{color:#3f5060}.el-alert--warning{background-color:#fef7ee;color:#f8ac59}.el-alert--warning .el-alert__description{color:#f8ac59}.el-alert--error{background-color:#fdeef0;color:#ed5565}.el-alert--error .el-alert__description{color:#ed5565}.el-alert__content{display:table-cell;padding:0 8px}.el-alert__icon{font-size:16px;width:16px}.el-alert__icon.is-big{font-size:28px;width:28px}.el-alert__title{font-size:13px;line-height:18px}.el-alert__title.is-bold{font-weight:700}.el-alert .el-alert__description{font-size:12px;margin:5px 0 0}.el-alert__closebtn{font-size:12px;color:#ddd;opacity:1;position:absolute;top:12px;right:15px;cursor:pointer}.el-alert__closebtn.is-customed{font-style:normal;font-size:13px;top:9px}.el-alert-fade-enter,.el-alert-fade-leave-active{opacity:0}.el-notification{display:-webkit-box;display:-ms-flexbox;display:flex;width:330px;padding:14px 26px 14px 13px;border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #ebeef5;position:fixed;background-color:#fff;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1);-webkit-transition:opacity .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;transition:opacity .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;transition:opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;transition:opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;overflow:hidden}.el-notification.right{right:16px}.el-notification.left{left:16px}.el-notification__group{margin-left:13px}.el-notification__title{font-weight:700;font-size:16px;color:#676a6c;margin:0}.el-notification__content{font-size:14px;line-height:21px;margin:6px 0 0;color:#676a6c;text-align:justify}.el-notification__content p{margin:0}.el-notification__icon{height:24px;width:24px;font-size:24px}.el-notification__closeBtn{position:absolute;top:18px;right:15px;cursor:pointer;color:#999;font-size:16px}.el-notification__closeBtn:hover{color:#676a6c}.el-notification .el-icon-success{color:#1ab394}.el-notification .el-icon-error{color:#ed5565}.el-notification .el-icon-info{color:#3f5060}.el-notification .el-icon-warning{color:#f8ac59}.el-notification-fade-enter.right{right:0;-webkit-transform:translateX(100%);transform:translateX(100%)}.el-notification-fade-enter.left{left:0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.el-notification-fade-leave-active{opacity:0}.el-input-number{position:relative;display:inline-block;width:180px;line-height:38px}.el-input-number .el-input{display:block}.el-input-number .el-input__inner{-webkit-appearance:none;padding-left:50px;padding-right:50px;text-align:center}.el-input-number__decrease,.el-input-number__increase{position:absolute;z-index:1;top:1px;width:40px;height:auto;text-align:center;background:#f3f3f4;color:#676a6c;cursor:pointer;font-size:13px}.el-input-number__decrease:hover,.el-input-number__increase:hover{color:#1c84c6}.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled){border-color:#1c84c6}.el-input-number__decrease.is-disabled,.el-input-number__increase.is-disabled{color:#ddd;cursor:not-allowed}.el-input-number__increase{right:1px;border-radius:0 4px 4px 0;border-left:1px solid #dcdfe6}.el-input-number__decrease{left:1px;border-radius:4px 0 0 4px;border-right:1px solid #dcdfe6}.el-input-number.is-disabled .el-input-number__decrease,.el-input-number.is-disabled .el-input-number__increase{border-color:#e4e7ed;color:#e4e7ed}.el-input-number.is-disabled .el-input-number__decrease:hover,.el-input-number.is-disabled .el-input-number__increase:hover{color:#e4e7ed;cursor:not-allowed}.el-input-number--medium{width:200px;line-height:34px}.el-input-number--medium .el-input-number__decrease,.el-input-number--medium .el-input-number__increase{width:36px;font-size:14px}.el-input-number--medium .el-input__inner{padding-left:43px;padding-right:43px}.el-input-number--small{width:130px;line-height:30px}.el-input-number--small .el-input-number__decrease,.el-input-number--small .el-input-number__increase{width:32px;font-size:13px}.el-input-number--small .el-input-number__decrease [class*=el-icon],.el-input-number--small .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.9);transform:scale(.9)}.el-input-number--small .el-input__inner{padding-left:39px;padding-right:39px}.el-input-number--mini{width:130px;line-height:26px}.el-input-number--mini .el-input-number__decrease,.el-input-number--mini .el-input-number__increase{width:28px;font-size:12px}.el-input-number--mini .el-input-number__decrease [class*=el-icon],.el-input-number--mini .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.8);transform:scale(.8)}.el-input-number--mini .el-input__inner{padding-left:35px;padding-right:35px}.el-input-number.is-without-controls .el-input__inner{padding-left:15px;padding-right:15px}.el-input-number.is-controls-right .el-input__inner{padding-left:15px;padding-right:50px}.el-input-number.is-controls-right .el-input-number__decrease,.el-input-number.is-controls-right .el-input-number__increase{height:auto;line-height:19px}.el-input-number.is-controls-right .el-input-number__decrease [class*=el-icon],.el-input-number.is-controls-right .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.8);transform:scale(.8)}.el-input-number.is-controls-right .el-input-number__increase{border-radius:0 4px 0 0;border-bottom:1px solid #dcdfe6}.el-input-number.is-controls-right .el-input-number__decrease{right:1px;bottom:1px;top:auto;left:auto;border-right:none;border-left:1px solid #dcdfe6;border-radius:0 0 4px 0}.el-input-number.is-controls-right[class*=medium] [class*=decrease],.el-input-number.is-controls-right[class*=medium] [class*=increase]{line-height:17px}.el-input-number.is-controls-right[class*=small] [class*=decrease],.el-input-number.is-controls-right[class*=small] [class*=increase]{line-height:15px}.el-input-number.is-controls-right[class*=mini] [class*=decrease],.el-input-number.is-controls-right[class*=mini] [class*=increase]{line-height:13px}.el-tooltip:focus:hover,.el-tooltip:focus:not(.focusing){outline-width:0}.el-tooltip__popper{position:absolute;border-radius:4px;padding:10px;z-index:2000;font-size:12px;line-height:1.2}.el-tooltip__popper .popper__arrow,.el-tooltip__popper .popper__arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.el-tooltip__popper .popper__arrow{border-width:6px}.el-tooltip__popper .popper__arrow:after{content:\" \";border-width:5px}.el-tooltip__popper[x-placement^=top]{margin-bottom:12px}.el-tooltip__popper[x-placement^=top] .popper__arrow{bottom:-6px;border-top-color:#676a6c;border-bottom-width:0}.el-tooltip__popper[x-placement^=top] .popper__arrow:after{bottom:1px;margin-left:-5px;border-top-color:#676a6c;border-bottom-width:0}.el-tooltip__popper[x-placement^=bottom]{margin-top:12px}.el-tooltip__popper[x-placement^=bottom] .popper__arrow{top:-6px;border-top-width:0;border-bottom-color:#676a6c}.el-tooltip__popper[x-placement^=bottom] .popper__arrow:after{top:1px;margin-left:-5px;border-top-width:0;border-bottom-color:#676a6c}.el-tooltip__popper[x-placement^=right]{margin-left:12px}.el-tooltip__popper[x-placement^=right] .popper__arrow{left:-6px;border-right-color:#676a6c;border-left-width:0}.el-tooltip__popper[x-placement^=right] .popper__arrow:after{bottom:-5px;left:1px;border-right-color:#676a6c;border-left-width:0}.el-tooltip__popper[x-placement^=left]{margin-right:12px}.el-tooltip__popper[x-placement^=left] .popper__arrow{right:-6px;border-right-width:0;border-left-color:#676a6c}.el-tooltip__popper[x-placement^=left] .popper__arrow:after{right:1px;bottom:-5px;margin-left:-5px;border-right-width:0;border-left-color:#676a6c}.el-tooltip__popper.is-dark{background:#676a6c;color:#fff}.el-tooltip__popper.is-light{background:#fff;border:1px solid #676a6c}.el-tooltip__popper.is-light[x-placement^=top] .popper__arrow{border-top-color:#676a6c}.el-tooltip__popper.is-light[x-placement^=top] .popper__arrow:after{border-top-color:#fff}.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow{border-bottom-color:#676a6c}.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow:after{border-bottom-color:#fff}.el-tooltip__popper.is-light[x-placement^=left] .popper__arrow{border-left-color:#676a6c}.el-tooltip__popper.is-light[x-placement^=left] .popper__arrow:after{border-left-color:#fff}.el-tooltip__popper.is-light[x-placement^=right] .popper__arrow{border-right-color:#676a6c}.el-tooltip__popper.is-light[x-placement^=right] .popper__arrow:after{border-right-color:#fff}.el-slider:after,.el-slider:before{display:table;content:\"\"}.el-slider:after{clear:both}.el-slider__runway{width:100%;height:6px;margin:16px 0;background-color:#e4e7ed;border-radius:3px;position:relative;cursor:pointer;vertical-align:middle}.el-slider__runway.show-input{margin-right:160px;width:auto}.el-slider__runway.disabled{cursor:default}.el-slider__runway.disabled .el-slider__bar{background-color:#ddd}.el-slider__runway.disabled .el-slider__button{border-color:#ddd}.el-slider__runway.disabled .el-slider__button-wrapper.dragging,.el-slider__runway.disabled .el-slider__button-wrapper.hover,.el-slider__runway.disabled .el-slider__button-wrapper:hover{cursor:not-allowed}.el-slider__runway.disabled .el-slider__button.dragging,.el-slider__runway.disabled .el-slider__button.hover,.el-slider__runway.disabled .el-slider__button:hover{-webkit-transform:scale(1);transform:scale(1)}.el-slider__runway.disabled .el-slider__button.dragging,.el-slider__runway.disabled .el-slider__button.hover,.el-slider__runway.disabled .el-slider__button:hover{cursor:not-allowed}.el-slider__input{float:right;margin-top:3px;width:130px}.el-slider__input.el-input-number--mini{margin-top:5px}.el-slider__input.el-input-number--medium{margin-top:0}.el-slider__input.el-input-number--large{margin-top:-2px}.el-slider__bar{height:6px;background-color:#1c84c6;border-top-left-radius:3px;border-bottom-left-radius:3px;position:absolute}.el-slider__button-wrapper{height:36px;width:36px;position:absolute;z-index:1001;top:-15px;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:transparent;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:normal}.el-slider__button-wrapper:after{content:\"\";height:100%}.el-slider__button-wrapper .el-tooltip,.el-slider__button-wrapper:after{display:inline-block;vertical-align:middle}.el-slider__button-wrapper.hover,.el-slider__button-wrapper:hover{cursor:-webkit-grab;cursor:grab}.el-slider__button-wrapper.dragging{cursor:-webkit-grabbing;cursor:grabbing}.el-slider__button{width:16px;height:16px;border:2px solid #1c84c6;background-color:#fff;border-radius:50%;-webkit-transition:.2s;transition:.2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-slider__button.dragging,.el-slider__button.hover,.el-slider__button:hover{-webkit-transform:scale(1.2);transform:scale(1.2)}.el-slider__button.hover,.el-slider__button:hover{cursor:-webkit-grab;cursor:grab}.el-slider__button.dragging{cursor:-webkit-grabbing;cursor:grabbing}.el-slider__stop{position:absolute;height:6px;width:6px;border-radius:100%;background-color:#fff;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.el-slider.is-vertical{position:relative}.el-slider.is-vertical .el-slider__runway{width:6px;height:100%;margin:0 16px}.el-slider.is-vertical .el-slider__bar{width:6px;height:auto;border-radius:0 0 3px 3px}.el-slider.is-vertical .el-slider__button-wrapper{top:auto;left:-15px}.el-slider.is-vertical .el-slider__button-wrapper,.el-slider.is-vertical .el-slider__stop{-webkit-transform:translateY(50%);transform:translateY(50%)}.el-slider.is-vertical.el-slider--with-input{padding-bottom:58px}.el-slider.is-vertical.el-slider--with-input .el-slider__input{overflow:visible;float:none;position:absolute;bottom:22px;width:36px;margin-top:15px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input__inner{text-align:center;padding-left:5px;padding-right:5px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase{top:32px;margin-top:-1px;border:1px solid #dcdfe6;line-height:20px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1)}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__decrease{width:18px;right:18px;border-bottom-left-radius:4px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase{width:19px;border-bottom-right-radius:4px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase~.el-input .el-input__inner{border-bottom-left-radius:0;border-bottom-right-radius:0}.el-slider.is-vertical.el-slider--with-input .el-slider__input:hover .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input:hover .el-input-number__increase{border-color:#ddd}.el-slider.is-vertical.el-slider--with-input .el-slider__input:active .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input:active .el-input-number__increase{border-color:#1c84c6}.el-loading-parent--relative{position:relative!important}.el-loading-parent--hidden{overflow:hidden!important}.el-loading-mask{position:absolute;z-index:2000;background-color:hsla(0,0%,100%,.9);margin:0;top:0;right:0;bottom:0;left:0;-webkit-transition:opacity .3s;transition:opacity .3s}.el-loading-mask.is-fullscreen{position:fixed}.el-loading-mask.is-fullscreen .el-loading-spinner{margin-top:-25px}.el-loading-mask.is-fullscreen .el-loading-spinner .circular{height:50px;width:50px}.el-loading-spinner{top:50%;margin-top:-21px;width:100%;text-align:center;position:absolute}.el-loading-spinner .el-loading-text{color:#1c84c6;margin:3px 0;font-size:14px}.el-loading-spinner .circular{height:42px;width:42px;-webkit-animation:loading-rotate 2s linear infinite;animation:loading-rotate 2s linear infinite}.el-loading-spinner .path{-webkit-animation:loading-dash 1.5s ease-in-out infinite;animation:loading-dash 1.5s ease-in-out infinite;stroke-dasharray:90,150;stroke-dashoffset:0;stroke-width:2;stroke:#1c84c6;stroke-linecap:round}.el-loading-spinner i{color:#1c84c6}.el-loading-fade-enter,.el-loading-fade-leave-active{opacity:0}@-webkit-keyframes loading-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes loading-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40px}to{stroke-dasharray:90,150;stroke-dashoffset:-120px}}@keyframes loading-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40px}to{stroke-dasharray:90,150;stroke-dashoffset:-120px}}.el-row{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box}.el-row:after,.el-row:before{display:table;content:\"\"}.el-row:after{clear:both}.el-row--flex{display:-webkit-box;display:-ms-flexbox;display:flex}.el-row--flex:after,.el-row--flex:before{display:none}.el-row--flex.is-justify-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-row--flex.is-justify-end{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.el-row--flex.is-justify-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.el-row--flex.is-justify-space-around{-ms-flex-pack:distribute;justify-content:space-around}.el-row--flex.is-align-middle{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-row--flex.is-align-bottom{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[class*=el-col-]{float:left;-webkit-box-sizing:border-box;box-sizing:border-box}.el-col-0{display:none;width:0}.el-col-offset-0{margin-left:0}.el-col-pull-0{position:relative;right:0}.el-col-push-0{position:relative;left:0}.el-col-1{width:4.16667%}.el-col-offset-1{margin-left:4.16667%}.el-col-pull-1{position:relative;right:4.16667%}.el-col-push-1{position:relative;left:4.16667%}.el-col-2{width:8.33333%}.el-col-offset-2{margin-left:8.33333%}.el-col-pull-2{position:relative;right:8.33333%}.el-col-push-2{position:relative;left:8.33333%}.el-col-3{width:12.5%}.el-col-offset-3{margin-left:12.5%}.el-col-pull-3{position:relative;right:12.5%}.el-col-push-3{position:relative;left:12.5%}.el-col-4{width:16.66667%}.el-col-offset-4{margin-left:16.66667%}.el-col-pull-4{position:relative;right:16.66667%}.el-col-push-4{position:relative;left:16.66667%}.el-col-5{width:20.83333%}.el-col-offset-5{margin-left:20.83333%}.el-col-pull-5{position:relative;right:20.83333%}.el-col-push-5{position:relative;left:20.83333%}.el-col-6{width:25%}.el-col-offset-6{margin-left:25%}.el-col-pull-6{position:relative;right:25%}.el-col-push-6{position:relative;left:25%}.el-col-7{width:29.16667%}.el-col-offset-7{margin-left:29.16667%}.el-col-pull-7{position:relative;right:29.16667%}.el-col-push-7{position:relative;left:29.16667%}.el-col-8{width:33.33333%}.el-col-offset-8{margin-left:33.33333%}.el-col-pull-8{position:relative;right:33.33333%}.el-col-push-8{position:relative;left:33.33333%}.el-col-9{width:37.5%}.el-col-offset-9{margin-left:37.5%}.el-col-pull-9{position:relative;right:37.5%}.el-col-push-9{position:relative;left:37.5%}.el-col-10{width:41.66667%}.el-col-offset-10{margin-left:41.66667%}.el-col-pull-10{position:relative;right:41.66667%}.el-col-push-10{position:relative;left:41.66667%}.el-col-11{width:45.83333%}.el-col-offset-11{margin-left:45.83333%}.el-col-pull-11{position:relative;right:45.83333%}.el-col-push-11{position:relative;left:45.83333%}.el-col-12{width:50%}.el-col-offset-12{margin-left:50%}.el-col-pull-12{position:relative;right:50%}.el-col-push-12{position:relative;left:50%}.el-col-13{width:54.16667%}.el-col-offset-13{margin-left:54.16667%}.el-col-pull-13{position:relative;right:54.16667%}.el-col-push-13{position:relative;left:54.16667%}.el-col-14{width:58.33333%}.el-col-offset-14{margin-left:58.33333%}.el-col-pull-14{position:relative;right:58.33333%}.el-col-push-14{position:relative;left:58.33333%}.el-col-15{width:62.5%}.el-col-offset-15{margin-left:62.5%}.el-col-pull-15{position:relative;right:62.5%}.el-col-push-15{position:relative;left:62.5%}.el-col-16{width:66.66667%}.el-col-offset-16{margin-left:66.66667%}.el-col-pull-16{position:relative;right:66.66667%}.el-col-push-16{position:relative;left:66.66667%}.el-col-17{width:70.83333%}.el-col-offset-17{margin-left:70.83333%}.el-col-pull-17{position:relative;right:70.83333%}.el-col-push-17{position:relative;left:70.83333%}.el-col-18{width:75%}.el-col-offset-18{margin-left:75%}.el-col-pull-18{position:relative;right:75%}.el-col-push-18{position:relative;left:75%}.el-col-19{width:79.16667%}.el-col-offset-19{margin-left:79.16667%}.el-col-pull-19{position:relative;right:79.16667%}.el-col-push-19{position:relative;left:79.16667%}.el-col-20{width:83.33333%}.el-col-offset-20{margin-left:83.33333%}.el-col-pull-20{position:relative;right:83.33333%}.el-col-push-20{position:relative;left:83.33333%}.el-col-21{width:87.5%}.el-col-offset-21{margin-left:87.5%}.el-col-pull-21{position:relative;right:87.5%}.el-col-push-21{position:relative;left:87.5%}.el-col-22{width:91.66667%}.el-col-offset-22{margin-left:91.66667%}.el-col-pull-22{position:relative;right:91.66667%}.el-col-push-22{position:relative;left:91.66667%}.el-col-23{width:95.83333%}.el-col-offset-23{margin-left:95.83333%}.el-col-pull-23{position:relative;right:95.83333%}.el-col-push-23{position:relative;left:95.83333%}.el-col-24{width:100%}.el-col-offset-24{margin-left:100%}.el-col-pull-24{position:relative;right:100%}.el-col-push-24{position:relative;left:100%}@media only screen and (max-width:768px){.el-col-xs-0{display:none;width:0}.el-col-xs-offset-0{margin-left:0}.el-col-xs-pull-0{position:relative;right:0}.el-col-xs-push-0{position:relative;left:0}.el-col-xs-1{width:4.16667%}.el-col-xs-offset-1{margin-left:4.16667%}.el-col-xs-pull-1{position:relative;right:4.16667%}.el-col-xs-push-1{position:relative;left:4.16667%}.el-col-xs-2{width:8.33333%}.el-col-xs-offset-2{margin-left:8.33333%}.el-col-xs-pull-2{position:relative;right:8.33333%}.el-col-xs-push-2{position:relative;left:8.33333%}.el-col-xs-3{width:12.5%}.el-col-xs-offset-3{margin-left:12.5%}.el-col-xs-pull-3{position:relative;right:12.5%}.el-col-xs-push-3{position:relative;left:12.5%}.el-col-xs-4{width:16.66667%}.el-col-xs-offset-4{margin-left:16.66667%}.el-col-xs-pull-4{position:relative;right:16.66667%}.el-col-xs-push-4{position:relative;left:16.66667%}.el-col-xs-5{width:20.83333%}.el-col-xs-offset-5{margin-left:20.83333%}.el-col-xs-pull-5{position:relative;right:20.83333%}.el-col-xs-push-5{position:relative;left:20.83333%}.el-col-xs-6{width:25%}.el-col-xs-offset-6{margin-left:25%}.el-col-xs-pull-6{position:relative;right:25%}.el-col-xs-push-6{position:relative;left:25%}.el-col-xs-7{width:29.16667%}.el-col-xs-offset-7{margin-left:29.16667%}.el-col-xs-pull-7{position:relative;right:29.16667%}.el-col-xs-push-7{position:relative;left:29.16667%}.el-col-xs-8{width:33.33333%}.el-col-xs-offset-8{margin-left:33.33333%}.el-col-xs-pull-8{position:relative;right:33.33333%}.el-col-xs-push-8{position:relative;left:33.33333%}.el-col-xs-9{width:37.5%}.el-col-xs-offset-9{margin-left:37.5%}.el-col-xs-pull-9{position:relative;right:37.5%}.el-col-xs-push-9{position:relative;left:37.5%}.el-col-xs-10{width:41.66667%}.el-col-xs-offset-10{margin-left:41.66667%}.el-col-xs-pull-10{position:relative;right:41.66667%}.el-col-xs-push-10{position:relative;left:41.66667%}.el-col-xs-11{width:45.83333%}.el-col-xs-offset-11{margin-left:45.83333%}.el-col-xs-pull-11{position:relative;right:45.83333%}.el-col-xs-push-11{position:relative;left:45.83333%}.el-col-xs-12{width:50%}.el-col-xs-offset-12{margin-left:50%}.el-col-xs-pull-12{position:relative;right:50%}.el-col-xs-push-12{position:relative;left:50%}.el-col-xs-13{width:54.16667%}.el-col-xs-offset-13{margin-left:54.16667%}.el-col-xs-pull-13{position:relative;right:54.16667%}.el-col-xs-push-13{position:relative;left:54.16667%}.el-col-xs-14{width:58.33333%}.el-col-xs-offset-14{margin-left:58.33333%}.el-col-xs-pull-14{position:relative;right:58.33333%}.el-col-xs-push-14{position:relative;left:58.33333%}.el-col-xs-15{width:62.5%}.el-col-xs-offset-15{margin-left:62.5%}.el-col-xs-pull-15{position:relative;right:62.5%}.el-col-xs-push-15{position:relative;left:62.5%}.el-col-xs-16{width:66.66667%}.el-col-xs-offset-16{margin-left:66.66667%}.el-col-xs-pull-16{position:relative;right:66.66667%}.el-col-xs-push-16{position:relative;left:66.66667%}.el-col-xs-17{width:70.83333%}.el-col-xs-offset-17{margin-left:70.83333%}.el-col-xs-pull-17{position:relative;right:70.83333%}.el-col-xs-push-17{position:relative;left:70.83333%}.el-col-xs-18{width:75%}.el-col-xs-offset-18{margin-left:75%}.el-col-xs-pull-18{position:relative;right:75%}.el-col-xs-push-18{position:relative;left:75%}.el-col-xs-19{width:79.16667%}.el-col-xs-offset-19{margin-left:79.16667%}.el-col-xs-pull-19{position:relative;right:79.16667%}.el-col-xs-push-19{position:relative;left:79.16667%}.el-col-xs-20{width:83.33333%}.el-col-xs-offset-20{margin-left:83.33333%}.el-col-xs-pull-20{position:relative;right:83.33333%}.el-col-xs-push-20{position:relative;left:83.33333%}.el-col-xs-21{width:87.5%}.el-col-xs-offset-21{margin-left:87.5%}.el-col-xs-pull-21{position:relative;right:87.5%}.el-col-xs-push-21{position:relative;left:87.5%}.el-col-xs-22{width:91.66667%}.el-col-xs-offset-22{margin-left:91.66667%}.el-col-xs-pull-22{position:relative;right:91.66667%}.el-col-xs-push-22{position:relative;left:91.66667%}.el-col-xs-23{width:95.83333%}.el-col-xs-offset-23{margin-left:95.83333%}.el-col-xs-pull-23{position:relative;right:95.83333%}.el-col-xs-push-23{position:relative;left:95.83333%}.el-col-xs-24{width:100%}.el-col-xs-offset-24{margin-left:100%}.el-col-xs-pull-24{position:relative;right:100%}.el-col-xs-push-24{position:relative;left:100%}}@media only screen and (min-width:768px){.el-col-sm-0{display:none;width:0}.el-col-sm-offset-0{margin-left:0}.el-col-sm-pull-0{position:relative;right:0}.el-col-sm-push-0{position:relative;left:0}.el-col-sm-1{width:4.16667%}.el-col-sm-offset-1{margin-left:4.16667%}.el-col-sm-pull-1{position:relative;right:4.16667%}.el-col-sm-push-1{position:relative;left:4.16667%}.el-col-sm-2{width:8.33333%}.el-col-sm-offset-2{margin-left:8.33333%}.el-col-sm-pull-2{position:relative;right:8.33333%}.el-col-sm-push-2{position:relative;left:8.33333%}.el-col-sm-3{width:12.5%}.el-col-sm-offset-3{margin-left:12.5%}.el-col-sm-pull-3{position:relative;right:12.5%}.el-col-sm-push-3{position:relative;left:12.5%}.el-col-sm-4{width:16.66667%}.el-col-sm-offset-4{margin-left:16.66667%}.el-col-sm-pull-4{position:relative;right:16.66667%}.el-col-sm-push-4{position:relative;left:16.66667%}.el-col-sm-5{width:20.83333%}.el-col-sm-offset-5{margin-left:20.83333%}.el-col-sm-pull-5{position:relative;right:20.83333%}.el-col-sm-push-5{position:relative;left:20.83333%}.el-col-sm-6{width:25%}.el-col-sm-offset-6{margin-left:25%}.el-col-sm-pull-6{position:relative;right:25%}.el-col-sm-push-6{position:relative;left:25%}.el-col-sm-7{width:29.16667%}.el-col-sm-offset-7{margin-left:29.16667%}.el-col-sm-pull-7{position:relative;right:29.16667%}.el-col-sm-push-7{position:relative;left:29.16667%}.el-col-sm-8{width:33.33333%}.el-col-sm-offset-8{margin-left:33.33333%}.el-col-sm-pull-8{position:relative;right:33.33333%}.el-col-sm-push-8{position:relative;left:33.33333%}.el-col-sm-9{width:37.5%}.el-col-sm-offset-9{margin-left:37.5%}.el-col-sm-pull-9{position:relative;right:37.5%}.el-col-sm-push-9{position:relative;left:37.5%}.el-col-sm-10{width:41.66667%}.el-col-sm-offset-10{margin-left:41.66667%}.el-col-sm-pull-10{position:relative;right:41.66667%}.el-col-sm-push-10{position:relative;left:41.66667%}.el-col-sm-11{width:45.83333%}.el-col-sm-offset-11{margin-left:45.83333%}.el-col-sm-pull-11{position:relative;right:45.83333%}.el-col-sm-push-11{position:relative;left:45.83333%}.el-col-sm-12{width:50%}.el-col-sm-offset-12{margin-left:50%}.el-col-sm-pull-12{position:relative;right:50%}.el-col-sm-push-12{position:relative;left:50%}.el-col-sm-13{width:54.16667%}.el-col-sm-offset-13{margin-left:54.16667%}.el-col-sm-pull-13{position:relative;right:54.16667%}.el-col-sm-push-13{position:relative;left:54.16667%}.el-col-sm-14{width:58.33333%}.el-col-sm-offset-14{margin-left:58.33333%}.el-col-sm-pull-14{position:relative;right:58.33333%}.el-col-sm-push-14{position:relative;left:58.33333%}.el-col-sm-15{width:62.5%}.el-col-sm-offset-15{margin-left:62.5%}.el-col-sm-pull-15{position:relative;right:62.5%}.el-col-sm-push-15{position:relative;left:62.5%}.el-col-sm-16{width:66.66667%}.el-col-sm-offset-16{margin-left:66.66667%}.el-col-sm-pull-16{position:relative;right:66.66667%}.el-col-sm-push-16{position:relative;left:66.66667%}.el-col-sm-17{width:70.83333%}.el-col-sm-offset-17{margin-left:70.83333%}.el-col-sm-pull-17{position:relative;right:70.83333%}.el-col-sm-push-17{position:relative;left:70.83333%}.el-col-sm-18{width:75%}.el-col-sm-offset-18{margin-left:75%}.el-col-sm-pull-18{position:relative;right:75%}.el-col-sm-push-18{position:relative;left:75%}.el-col-sm-19{width:79.16667%}.el-col-sm-offset-19{margin-left:79.16667%}.el-col-sm-pull-19{position:relative;right:79.16667%}.el-col-sm-push-19{position:relative;left:79.16667%}.el-col-sm-20{width:83.33333%}.el-col-sm-offset-20{margin-left:83.33333%}.el-col-sm-pull-20{position:relative;right:83.33333%}.el-col-sm-push-20{position:relative;left:83.33333%}.el-col-sm-21{width:87.5%}.el-col-sm-offset-21{margin-left:87.5%}.el-col-sm-pull-21{position:relative;right:87.5%}.el-col-sm-push-21{position:relative;left:87.5%}.el-col-sm-22{width:91.66667%}.el-col-sm-offset-22{margin-left:91.66667%}.el-col-sm-pull-22{position:relative;right:91.66667%}.el-col-sm-push-22{position:relative;left:91.66667%}.el-col-sm-23{width:95.83333%}.el-col-sm-offset-23{margin-left:95.83333%}.el-col-sm-pull-23{position:relative;right:95.83333%}.el-col-sm-push-23{position:relative;left:95.83333%}.el-col-sm-24{width:100%}.el-col-sm-offset-24{margin-left:100%}.el-col-sm-pull-24{position:relative;right:100%}.el-col-sm-push-24{position:relative;left:100%}}@media only screen and (min-width:992px){.el-col-md-0{display:none;width:0}.el-col-md-offset-0{margin-left:0}.el-col-md-pull-0{position:relative;right:0}.el-col-md-push-0{position:relative;left:0}.el-col-md-1{width:4.16667%}.el-col-md-offset-1{margin-left:4.16667%}.el-col-md-pull-1{position:relative;right:4.16667%}.el-col-md-push-1{position:relative;left:4.16667%}.el-col-md-2{width:8.33333%}.el-col-md-offset-2{margin-left:8.33333%}.el-col-md-pull-2{position:relative;right:8.33333%}.el-col-md-push-2{position:relative;left:8.33333%}.el-col-md-3{width:12.5%}.el-col-md-offset-3{margin-left:12.5%}.el-col-md-pull-3{position:relative;right:12.5%}.el-col-md-push-3{position:relative;left:12.5%}.el-col-md-4{width:16.66667%}.el-col-md-offset-4{margin-left:16.66667%}.el-col-md-pull-4{position:relative;right:16.66667%}.el-col-md-push-4{position:relative;left:16.66667%}.el-col-md-5{width:20.83333%}.el-col-md-offset-5{margin-left:20.83333%}.el-col-md-pull-5{position:relative;right:20.83333%}.el-col-md-push-5{position:relative;left:20.83333%}.el-col-md-6{width:25%}.el-col-md-offset-6{margin-left:25%}.el-col-md-pull-6{position:relative;right:25%}.el-col-md-push-6{position:relative;left:25%}.el-col-md-7{width:29.16667%}.el-col-md-offset-7{margin-left:29.16667%}.el-col-md-pull-7{position:relative;right:29.16667%}.el-col-md-push-7{position:relative;left:29.16667%}.el-col-md-8{width:33.33333%}.el-col-md-offset-8{margin-left:33.33333%}.el-col-md-pull-8{position:relative;right:33.33333%}.el-col-md-push-8{position:relative;left:33.33333%}.el-col-md-9{width:37.5%}.el-col-md-offset-9{margin-left:37.5%}.el-col-md-pull-9{position:relative;right:37.5%}.el-col-md-push-9{position:relative;left:37.5%}.el-col-md-10{width:41.66667%}.el-col-md-offset-10{margin-left:41.66667%}.el-col-md-pull-10{position:relative;right:41.66667%}.el-col-md-push-10{position:relative;left:41.66667%}.el-col-md-11{width:45.83333%}.el-col-md-offset-11{margin-left:45.83333%}.el-col-md-pull-11{position:relative;right:45.83333%}.el-col-md-push-11{position:relative;left:45.83333%}.el-col-md-12{width:50%}.el-col-md-offset-12{margin-left:50%}.el-col-md-pull-12{position:relative;right:50%}.el-col-md-push-12{position:relative;left:50%}.el-col-md-13{width:54.16667%}.el-col-md-offset-13{margin-left:54.16667%}.el-col-md-pull-13{position:relative;right:54.16667%}.el-col-md-push-13{position:relative;left:54.16667%}.el-col-md-14{width:58.33333%}.el-col-md-offset-14{margin-left:58.33333%}.el-col-md-pull-14{position:relative;right:58.33333%}.el-col-md-push-14{position:relative;left:58.33333%}.el-col-md-15{width:62.5%}.el-col-md-offset-15{margin-left:62.5%}.el-col-md-pull-15{position:relative;right:62.5%}.el-col-md-push-15{position:relative;left:62.5%}.el-col-md-16{width:66.66667%}.el-col-md-offset-16{margin-left:66.66667%}.el-col-md-pull-16{position:relative;right:66.66667%}.el-col-md-push-16{position:relative;left:66.66667%}.el-col-md-17{width:70.83333%}.el-col-md-offset-17{margin-left:70.83333%}.el-col-md-pull-17{position:relative;right:70.83333%}.el-col-md-push-17{position:relative;left:70.83333%}.el-col-md-18{width:75%}.el-col-md-offset-18{margin-left:75%}.el-col-md-pull-18{position:relative;right:75%}.el-col-md-push-18{position:relative;left:75%}.el-col-md-19{width:79.16667%}.el-col-md-offset-19{margin-left:79.16667%}.el-col-md-pull-19{position:relative;right:79.16667%}.el-col-md-push-19{position:relative;left:79.16667%}.el-col-md-20{width:83.33333%}.el-col-md-offset-20{margin-left:83.33333%}.el-col-md-pull-20{position:relative;right:83.33333%}.el-col-md-push-20{position:relative;left:83.33333%}.el-col-md-21{width:87.5%}.el-col-md-offset-21{margin-left:87.5%}.el-col-md-pull-21{position:relative;right:87.5%}.el-col-md-push-21{position:relative;left:87.5%}.el-col-md-22{width:91.66667%}.el-col-md-offset-22{margin-left:91.66667%}.el-col-md-pull-22{position:relative;right:91.66667%}.el-col-md-push-22{position:relative;left:91.66667%}.el-col-md-23{width:95.83333%}.el-col-md-offset-23{margin-left:95.83333%}.el-col-md-pull-23{position:relative;right:95.83333%}.el-col-md-push-23{position:relative;left:95.83333%}.el-col-md-24{width:100%}.el-col-md-offset-24{margin-left:100%}.el-col-md-pull-24{position:relative;right:100%}.el-col-md-push-24{position:relative;left:100%}}@media only screen and (min-width:1200px){.el-col-lg-0{display:none;width:0}.el-col-lg-offset-0{margin-left:0}.el-col-lg-pull-0{position:relative;right:0}.el-col-lg-push-0{position:relative;left:0}.el-col-lg-1{width:4.16667%}.el-col-lg-offset-1{margin-left:4.16667%}.el-col-lg-pull-1{position:relative;right:4.16667%}.el-col-lg-push-1{position:relative;left:4.16667%}.el-col-lg-2{width:8.33333%}.el-col-lg-offset-2{margin-left:8.33333%}.el-col-lg-pull-2{position:relative;right:8.33333%}.el-col-lg-push-2{position:relative;left:8.33333%}.el-col-lg-3{width:12.5%}.el-col-lg-offset-3{margin-left:12.5%}.el-col-lg-pull-3{position:relative;right:12.5%}.el-col-lg-push-3{position:relative;left:12.5%}.el-col-lg-4{width:16.66667%}.el-col-lg-offset-4{margin-left:16.66667%}.el-col-lg-pull-4{position:relative;right:16.66667%}.el-col-lg-push-4{position:relative;left:16.66667%}.el-col-lg-5{width:20.83333%}.el-col-lg-offset-5{margin-left:20.83333%}.el-col-lg-pull-5{position:relative;right:20.83333%}.el-col-lg-push-5{position:relative;left:20.83333%}.el-col-lg-6{width:25%}.el-col-lg-offset-6{margin-left:25%}.el-col-lg-pull-6{position:relative;right:25%}.el-col-lg-push-6{position:relative;left:25%}.el-col-lg-7{width:29.16667%}.el-col-lg-offset-7{margin-left:29.16667%}.el-col-lg-pull-7{position:relative;right:29.16667%}.el-col-lg-push-7{position:relative;left:29.16667%}.el-col-lg-8{width:33.33333%}.el-col-lg-offset-8{margin-left:33.33333%}.el-col-lg-pull-8{position:relative;right:33.33333%}.el-col-lg-push-8{position:relative;left:33.33333%}.el-col-lg-9{width:37.5%}.el-col-lg-offset-9{margin-left:37.5%}.el-col-lg-pull-9{position:relative;right:37.5%}.el-col-lg-push-9{position:relative;left:37.5%}.el-col-lg-10{width:41.66667%}.el-col-lg-offset-10{margin-left:41.66667%}.el-col-lg-pull-10{position:relative;right:41.66667%}.el-col-lg-push-10{position:relative;left:41.66667%}.el-col-lg-11{width:45.83333%}.el-col-lg-offset-11{margin-left:45.83333%}.el-col-lg-pull-11{position:relative;right:45.83333%}.el-col-lg-push-11{position:relative;left:45.83333%}.el-col-lg-12{width:50%}.el-col-lg-offset-12{margin-left:50%}.el-col-lg-pull-12{position:relative;right:50%}.el-col-lg-push-12{position:relative;left:50%}.el-col-lg-13{width:54.16667%}.el-col-lg-offset-13{margin-left:54.16667%}.el-col-lg-pull-13{position:relative;right:54.16667%}.el-col-lg-push-13{position:relative;left:54.16667%}.el-col-lg-14{width:58.33333%}.el-col-lg-offset-14{margin-left:58.33333%}.el-col-lg-pull-14{position:relative;right:58.33333%}.el-col-lg-push-14{position:relative;left:58.33333%}.el-col-lg-15{width:62.5%}.el-col-lg-offset-15{margin-left:62.5%}.el-col-lg-pull-15{position:relative;right:62.5%}.el-col-lg-push-15{position:relative;left:62.5%}.el-col-lg-16{width:66.66667%}.el-col-lg-offset-16{margin-left:66.66667%}.el-col-lg-pull-16{position:relative;right:66.66667%}.el-col-lg-push-16{position:relative;left:66.66667%}.el-col-lg-17{width:70.83333%}.el-col-lg-offset-17{margin-left:70.83333%}.el-col-lg-pull-17{position:relative;right:70.83333%}.el-col-lg-push-17{position:relative;left:70.83333%}.el-col-lg-18{width:75%}.el-col-lg-offset-18{margin-left:75%}.el-col-lg-pull-18{position:relative;right:75%}.el-col-lg-push-18{position:relative;left:75%}.el-col-lg-19{width:79.16667%}.el-col-lg-offset-19{margin-left:79.16667%}.el-col-lg-pull-19{position:relative;right:79.16667%}.el-col-lg-push-19{position:relative;left:79.16667%}.el-col-lg-20{width:83.33333%}.el-col-lg-offset-20{margin-left:83.33333%}.el-col-lg-pull-20{position:relative;right:83.33333%}.el-col-lg-push-20{position:relative;left:83.33333%}.el-col-lg-21{width:87.5%}.el-col-lg-offset-21{margin-left:87.5%}.el-col-lg-pull-21{position:relative;right:87.5%}.el-col-lg-push-21{position:relative;left:87.5%}.el-col-lg-22{width:91.66667%}.el-col-lg-offset-22{margin-left:91.66667%}.el-col-lg-pull-22{position:relative;right:91.66667%}.el-col-lg-push-22{position:relative;left:91.66667%}.el-col-lg-23{width:95.83333%}.el-col-lg-offset-23{margin-left:95.83333%}.el-col-lg-pull-23{position:relative;right:95.83333%}.el-col-lg-push-23{position:relative;left:95.83333%}.el-col-lg-24{width:100%}.el-col-lg-offset-24{margin-left:100%}.el-col-lg-pull-24{position:relative;right:100%}.el-col-lg-push-24{position:relative;left:100%}}@media only screen and (min-width:1920px){.el-col-xl-0{display:none;width:0}.el-col-xl-offset-0{margin-left:0}.el-col-xl-pull-0{position:relative;right:0}.el-col-xl-push-0{position:relative;left:0}.el-col-xl-1{width:4.16667%}.el-col-xl-offset-1{margin-left:4.16667%}.el-col-xl-pull-1{position:relative;right:4.16667%}.el-col-xl-push-1{position:relative;left:4.16667%}.el-col-xl-2{width:8.33333%}.el-col-xl-offset-2{margin-left:8.33333%}.el-col-xl-pull-2{position:relative;right:8.33333%}.el-col-xl-push-2{position:relative;left:8.33333%}.el-col-xl-3{width:12.5%}.el-col-xl-offset-3{margin-left:12.5%}.el-col-xl-pull-3{position:relative;right:12.5%}.el-col-xl-push-3{position:relative;left:12.5%}.el-col-xl-4{width:16.66667%}.el-col-xl-offset-4{margin-left:16.66667%}.el-col-xl-pull-4{position:relative;right:16.66667%}.el-col-xl-push-4{position:relative;left:16.66667%}.el-col-xl-5{width:20.83333%}.el-col-xl-offset-5{margin-left:20.83333%}.el-col-xl-pull-5{position:relative;right:20.83333%}.el-col-xl-push-5{position:relative;left:20.83333%}.el-col-xl-6{width:25%}.el-col-xl-offset-6{margin-left:25%}.el-col-xl-pull-6{position:relative;right:25%}.el-col-xl-push-6{position:relative;left:25%}.el-col-xl-7{width:29.16667%}.el-col-xl-offset-7{margin-left:29.16667%}.el-col-xl-pull-7{position:relative;right:29.16667%}.el-col-xl-push-7{position:relative;left:29.16667%}.el-col-xl-8{width:33.33333%}.el-col-xl-offset-8{margin-left:33.33333%}.el-col-xl-pull-8{position:relative;right:33.33333%}.el-col-xl-push-8{position:relative;left:33.33333%}.el-col-xl-9{width:37.5%}.el-col-xl-offset-9{margin-left:37.5%}.el-col-xl-pull-9{position:relative;right:37.5%}.el-col-xl-push-9{position:relative;left:37.5%}.el-col-xl-10{width:41.66667%}.el-col-xl-offset-10{margin-left:41.66667%}.el-col-xl-pull-10{position:relative;right:41.66667%}.el-col-xl-push-10{position:relative;left:41.66667%}.el-col-xl-11{width:45.83333%}.el-col-xl-offset-11{margin-left:45.83333%}.el-col-xl-pull-11{position:relative;right:45.83333%}.el-col-xl-push-11{position:relative;left:45.83333%}.el-col-xl-12{width:50%}.el-col-xl-offset-12{margin-left:50%}.el-col-xl-pull-12{position:relative;right:50%}.el-col-xl-push-12{position:relative;left:50%}.el-col-xl-13{width:54.16667%}.el-col-xl-offset-13{margin-left:54.16667%}.el-col-xl-pull-13{position:relative;right:54.16667%}.el-col-xl-push-13{position:relative;left:54.16667%}.el-col-xl-14{width:58.33333%}.el-col-xl-offset-14{margin-left:58.33333%}.el-col-xl-pull-14{position:relative;right:58.33333%}.el-col-xl-push-14{position:relative;left:58.33333%}.el-col-xl-15{width:62.5%}.el-col-xl-offset-15{margin-left:62.5%}.el-col-xl-pull-15{position:relative;right:62.5%}.el-col-xl-push-15{position:relative;left:62.5%}.el-col-xl-16{width:66.66667%}.el-col-xl-offset-16{margin-left:66.66667%}.el-col-xl-pull-16{position:relative;right:66.66667%}.el-col-xl-push-16{position:relative;left:66.66667%}.el-col-xl-17{width:70.83333%}.el-col-xl-offset-17{margin-left:70.83333%}.el-col-xl-pull-17{position:relative;right:70.83333%}.el-col-xl-push-17{position:relative;left:70.83333%}.el-col-xl-18{width:75%}.el-col-xl-offset-18{margin-left:75%}.el-col-xl-pull-18{position:relative;right:75%}.el-col-xl-push-18{position:relative;left:75%}.el-col-xl-19{width:79.16667%}.el-col-xl-offset-19{margin-left:79.16667%}.el-col-xl-pull-19{position:relative;right:79.16667%}.el-col-xl-push-19{position:relative;left:79.16667%}.el-col-xl-20{width:83.33333%}.el-col-xl-offset-20{margin-left:83.33333%}.el-col-xl-pull-20{position:relative;right:83.33333%}.el-col-xl-push-20{position:relative;left:83.33333%}.el-col-xl-21{width:87.5%}.el-col-xl-offset-21{margin-left:87.5%}.el-col-xl-pull-21{position:relative;right:87.5%}.el-col-xl-push-21{position:relative;left:87.5%}.el-col-xl-22{width:91.66667%}.el-col-xl-offset-22{margin-left:91.66667%}.el-col-xl-pull-22{position:relative;right:91.66667%}.el-col-xl-push-22{position:relative;left:91.66667%}.el-col-xl-23{width:95.83333%}.el-col-xl-offset-23{margin-left:95.83333%}.el-col-xl-pull-23{position:relative;right:95.83333%}.el-col-xl-push-23{position:relative;left:95.83333%}.el-col-xl-24{width:100%}.el-col-xl-offset-24{margin-left:100%}.el-col-xl-pull-24{position:relative;right:100%}.el-col-xl-push-24{position:relative;left:100%}}@-webkit-keyframes progress{0%{background-position:0 0}to{background-position:32px 0}}.el-upload{display:inline-block;text-align:center;cursor:pointer;outline:none}.el-upload__input{display:none}.el-upload__tip{font-size:12px;color:#676a6c;margin-top:7px}.el-upload iframe{position:absolute;z-index:-1;top:0;left:0;opacity:0;filter:alpha(opacity=0)}.el-upload--picture-card{background-color:#fbfdff;border:1px dashed #c0ccda;border-radius:6px;-webkit-box-sizing:border-box;box-sizing:border-box;width:148px;height:148px;cursor:pointer;line-height:146px;vertical-align:top}.el-upload--picture-card i{font-size:28px;color:#8c939d}.el-upload--picture-card:hover,.el-upload:focus{border-color:#1c84c6;color:#1c84c6}.el-upload:focus .el-upload-dragger{border-color:#1c84c6}.el-upload-dragger{background-color:#fff;border:1px dashed #d9d9d9;border-radius:6px;-webkit-box-sizing:border-box;box-sizing:border-box;width:360px;height:180px;text-align:center;cursor:pointer;position:relative;overflow:hidden}.el-upload-dragger .el-icon-upload{font-size:67px;color:#ddd;margin:40px 0 16px;line-height:50px}.el-upload-dragger+.el-upload__tip{text-align:center}.el-upload-dragger~.el-upload__files{border-top:1px solid #dcdfe6;margin-top:7px;padding-top:5px}.el-upload-dragger .el-upload__text{color:#676a6c;font-size:14px;text-align:center}.el-upload-dragger .el-upload__text em{color:#1c84c6;font-style:normal}.el-upload-dragger:hover{border-color:#1c84c6}.el-upload-dragger.is-dragover{background-color:rgba(32,159,255,.06);border:2px dashed #1c84c6}.el-upload-list{margin:0;padding:0;list-style:none}.el-upload-list__item{-webkit-transition:all .5s cubic-bezier(.55,0,.1,1);transition:all .5s cubic-bezier(.55,0,.1,1);font-size:14px;color:#676a6c;line-height:1.8;margin-top:5px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;width:100%}.el-upload-list__item .el-progress{position:absolute;top:20px;width:100%}.el-upload-list__item .el-progress__text{position:absolute;right:0;top:-13px}.el-upload-list__item .el-progress-bar{margin-right:0;padding-right:0}.el-upload-list__item:first-child{margin-top:10px}.el-upload-list__item .el-icon-upload-success{color:#1ab394}.el-upload-list__item .el-icon-close{display:none;position:absolute;top:5px;right:5px;cursor:pointer;opacity:.75;color:#676a6c}.el-upload-list__item .el-icon-close:hover{opacity:1}.el-upload-list__item .el-icon-close-tip{display:none;position:absolute;top:5px;right:5px;font-size:12px;cursor:pointer;opacity:1;color:#1c84c6}.el-upload-list__item:hover{background-color:#f3f3f4}.el-upload-list__item:hover .el-icon-close{display:inline-block}.el-upload-list__item:hover .el-progress__text{display:none}.el-upload-list__item.is-success .el-upload-list__item-status-label{display:block}.el-upload-list__item.is-success .el-upload-list__item-name:focus,.el-upload-list__item.is-success .el-upload-list__item-name:hover{color:#1c84c6;cursor:pointer}.el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip{display:inline-block}.el-upload-list__item.is-success:active,.el-upload-list__item.is-success:not(.focusing):focus{outline-width:0}.el-upload-list__item.is-success:active .el-icon-close-tip,.el-upload-list__item.is-success:focus .el-upload-list__item-status-label,.el-upload-list__item.is-success:hover .el-upload-list__item-status-label,.el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip{display:none}.el-upload-list.is-disabled .el-upload-list__item:hover .el-upload-list__item-status-label{display:block}.el-upload-list__item-name{color:#676a6c;display:block;margin-right:40px;overflow:hidden;padding-left:4px;text-overflow:ellipsis;-webkit-transition:color .3s;transition:color .3s;white-space:nowrap}.el-upload-list__item-name [class^=el-icon]{height:100%;margin-right:7px;color:#999;line-height:inherit}.el-upload-list__item-status-label{position:absolute;right:5px;top:0;line-height:inherit;display:none}.el-upload-list__item-delete{position:absolute;right:10px;top:0;font-size:12px;color:#676a6c;display:none}.el-upload-list__item-delete:hover{color:#1c84c6}.el-upload-list--picture-card{margin:0;display:inline;vertical-align:top}.el-upload-list--picture-card .el-upload-list__item{overflow:hidden;background-color:#fff;border:1px solid #c0ccda;border-radius:6px;-webkit-box-sizing:border-box;box-sizing:border-box;width:148px;height:148px;margin:0 8px 8px 0;display:inline-block}.el-upload-list--picture-card .el-upload-list__item .el-icon-check,.el-upload-list--picture-card .el-upload-list__item .el-icon-circle-check{color:#fff}.el-upload-list--picture-card .el-upload-list__item .el-icon-close,.el-upload-list--picture-card .el-upload-list__item:hover .el-upload-list__item-status-label{display:none}.el-upload-list--picture-card .el-upload-list__item:hover .el-progress__text{display:block}.el-upload-list--picture-card .el-upload-list__item-name{display:none}.el-upload-list--picture-card .el-upload-list__item-thumbnail{width:100%;height:100%}.el-upload-list--picture-card .el-upload-list__item-status-label{position:absolute;right:-15px;top:-6px;width:40px;height:24px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-box-shadow:0 0 1pc 1px rgba(0,0,0,.2);box-shadow:0 0 1pc 1px rgba(0,0,0,.2)}.el-upload-list--picture-card .el-upload-list__item-status-label i{font-size:12px;margin-top:11px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.el-upload-list--picture-card .el-upload-list__item-actions{position:absolute;width:100%;height:100%;left:0;top:0;cursor:default;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,.5);-webkit-transition:opacity .3s;transition:opacity .3s}.el-upload-list--picture-card .el-upload-list__item-actions:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-upload-list--picture-card .el-upload-list__item-actions span{display:none;cursor:pointer}.el-upload-list--picture-card .el-upload-list__item-actions span+span{margin-left:15px}.el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete{position:static;font-size:inherit;color:inherit}.el-upload-list--picture-card .el-upload-list__item-actions:hover{opacity:1}.el-upload-list--picture-card .el-upload-list__item-actions:hover span{display:inline-block}.el-upload-list--picture-card .el-progress{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);bottom:auto;width:126px}.el-upload-list--picture-card .el-progress .el-progress__text{top:50%}.el-upload-list--picture .el-upload-list__item{overflow:hidden;z-index:0;background-color:#fff;border:1px solid #c0ccda;border-radius:6px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:10px;padding:10px 10px 10px 90px;height:92px}.el-upload-list--picture .el-upload-list__item .el-icon-check,.el-upload-list--picture .el-upload-list__item .el-icon-circle-check{color:#fff}.el-upload-list--picture .el-upload-list__item:hover .el-upload-list__item-status-label{background:transparent;-webkit-box-shadow:none;box-shadow:none;top:-2px;right:-12px}.el-upload-list--picture .el-upload-list__item:hover .el-progress__text{display:block}.el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name{line-height:70px;margin-top:0}.el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name i{display:none}.el-upload-list--picture .el-upload-list__item-thumbnail{vertical-align:middle;display:inline-block;width:70px;height:70px;float:left;position:relative;z-index:1;margin-left:-80px}.el-upload-list--picture .el-upload-list__item-name{display:block;margin-top:20px}.el-upload-list--picture .el-upload-list__item-name i{font-size:70px;line-height:1;position:absolute;left:9px;top:10px}.el-upload-list--picture .el-upload-list__item-status-label{position:absolute;right:-17px;top:-7px;width:46px;height:26px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-box-shadow:0 1px 1px #ccc;box-shadow:0 1px 1px #ccc}.el-upload-list--picture .el-upload-list__item-status-label i{font-size:12px;margin-top:12px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.el-upload-list--picture .el-progress{position:relative;top:-7px}.el-upload-cover{position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden;z-index:10;cursor:default}.el-upload-cover:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-upload-cover img{display:block;width:100%;height:100%}.el-upload-cover__label{position:absolute;right:-15px;top:-6px;width:40px;height:24px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-box-shadow:0 0 1pc 1px rgba(0,0,0,.2);box-shadow:0 0 1pc 1px rgba(0,0,0,.2)}.el-upload-cover__label i{font-size:12px;margin-top:11px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);color:#fff}.el-upload-cover__progress{display:inline-block;vertical-align:middle;position:static;width:243px}.el-upload-cover__progress+.el-upload__inner{opacity:0}.el-upload-cover__content{position:absolute;top:0;left:0;width:100%;height:100%}.el-upload-cover__interact{position:absolute;bottom:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.72);text-align:center}.el-upload-cover__interact .btn{display:inline-block;color:#fff;font-size:14px;cursor:pointer;vertical-align:middle;-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);margin-top:60px}.el-upload-cover__interact .btn i{margin-top:0}.el-upload-cover__interact .btn span{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.el-upload-cover__interact .btn:not(:first-child){margin-left:35px}.el-upload-cover__interact .btn:hover{-webkit-transform:translateY(-13px);transform:translateY(-13px)}.el-upload-cover__interact .btn:hover span{opacity:1}.el-upload-cover__interact .btn i{color:#fff;display:block;font-size:24px;line-height:inherit;margin:0 auto 5px}.el-upload-cover__title{position:absolute;bottom:0;left:0;background-color:#fff;height:36px;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400;text-align:left;padding:0 10px;margin:0;line-height:36px;font-size:14px;color:#676a6c}.el-upload-cover+.el-upload__inner{opacity:0;position:relative;z-index:1}.el-progress{position:relative;line-height:1}.el-progress__text{font-size:14px;color:#676a6c;display:inline-block;vertical-align:middle;margin-left:10px;line-height:1}.el-progress__text i{vertical-align:middle;display:block}.el-progress--circle{display:inline-block}.el-progress--circle .el-progress__text{position:absolute;top:50%;left:0;width:100%;text-align:center;margin:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-progress--circle .el-progress__text i{vertical-align:middle;display:inline-block}.el-progress--without-text .el-progress__text{display:none}.el-progress--without-text .el-progress-bar{padding-right:0;margin-right:0;display:block}.el-progress--text-inside .el-progress-bar{padding-right:0;margin-right:0}.el-progress.is-success .el-progress-bar__inner{background-color:#1ab394}.el-progress.is-success .el-progress__text{color:#1ab394}.el-progress.is-exception .el-progress-bar__inner{background-color:#ed5565}.el-progress.is-exception .el-progress__text{color:#ed5565}.el-progress-bar{padding-right:50px;display:inline-block;vertical-align:middle;width:100%;margin-right:-55px;-webkit-box-sizing:border-box;box-sizing:border-box}.el-progress-bar__outer{height:6px;border-radius:100px;background-color:#ebeef5;overflow:hidden;position:relative;vertical-align:middle}.el-progress-bar__inner{position:absolute;left:0;top:0;height:100%;background-color:#1c84c6;text-align:right;border-radius:100px;line-height:1;white-space:nowrap}.el-progress-bar__inner:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-progress-bar__innerText{display:inline-block;vertical-align:middle;color:#fff;font-size:12px;margin:0 5px}@keyframes progress{0%{background-position:0 0}to{background-position:32px 0}}.el-time-spinner{width:100%;white-space:nowrap}.el-spinner{display:inline-block;vertical-align:middle}.el-spinner-inner{-webkit-animation:rotate 2s linear infinite;animation:rotate 2s linear infinite;width:50px;height:50px}.el-spinner-inner .path{stroke:#ececec;stroke-linecap:round;-webkit-animation:dash 1.5s ease-in-out infinite;animation:dash 1.5s ease-in-out infinite}@-webkit-keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.el-message{min-width:380px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;border:1px solid #ebeef5;position:fixed;left:50%;top:20px;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:#edf2fc;-webkit-transition:opacity .3s,-webkit-transform .4s;transition:opacity .3s,-webkit-transform .4s;transition:opacity .3s,transform .4s;transition:opacity .3s,transform .4s,-webkit-transform .4s;overflow:hidden;padding:15px 15px 15px 20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-message.is-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-message.is-closable .el-message__content{padding-right:16px}.el-message p{margin:0}.el-message--info .el-message__content{color:#3f5060}.el-message--success{background-color:#e8f7f4;border-color:#d1f0ea}.el-message--success .el-message__content{color:#1ab394}.el-message--warning{background-color:#fef7ee;border-color:#feeede}.el-message--warning .el-message__content{color:#f8ac59}.el-message--error{background-color:#fdeef0;border-color:#fbdde0}.el-message--error .el-message__content{color:#ed5565}.el-message__icon{margin-right:10px}.el-message__content{padding:0;font-size:14px;line-height:1}.el-message__content:focus{outline-width:0}.el-message__closeBtn{position:absolute;top:50%;right:15px;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;color:#ddd;font-size:16px}.el-message__closeBtn:focus{outline-width:0}.el-message__closeBtn:hover{color:#999}.el-message .el-icon-success{color:#1ab394}.el-message .el-icon-error{color:#ed5565}.el-message .el-icon-info{color:#3f5060}.el-message .el-icon-warning{color:#f8ac59}.el-message-fade-enter,.el-message-fade-leave-active{opacity:0;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.el-badge{position:relative;vertical-align:middle;display:inline-block}.el-badge__content{background-color:#ed5565;border-radius:10px;color:#fff;display:inline-block;font-size:12px;height:18px;line-height:18px;padding:0 6px;text-align:center;white-space:nowrap;border:1px solid #fff}.el-badge__content.is-fixed{position:absolute;top:0;right:10px;-webkit-transform:translateY(-50%) translateX(100%);transform:translateY(-50%) translateX(100%)}.el-badge__content.is-fixed.is-dot{right:5px}.el-badge__content.is-dot{height:8px;width:8px;padding:0;right:0;border-radius:50%}.el-card{border-radius:4px;border:1px solid #ebeef5;background-color:#fff;overflow:hidden;color:#676a6c;-webkit-transition:.3s;transition:.3s}.el-card.is-always-shadow,.el-card.is-hover-shadow:focus,.el-card.is-hover-shadow:hover{-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-card__header{padding:18px 20px;border-bottom:1px solid #ebeef5;-webkit-box-sizing:border-box;box-sizing:border-box}.el-card__body{padding:20px}.el-rate{height:20px;line-height:1}.el-rate:active,.el-rate:focus{outline-width:0}.el-rate__item{font-size:0;vertical-align:middle}.el-rate__icon,.el-rate__item{display:inline-block;position:relative}.el-rate__icon{font-size:18px;margin-right:6px;color:#ddd;-webkit-transition:.3s;transition:.3s}.el-rate__icon.hover{-webkit-transform:scale(1.15);transform:scale(1.15)}.el-rate__decimal,.el-rate__icon .path2{position:absolute;left:0;top:0}.el-rate__decimal{display:inline-block;overflow:hidden}.el-rate__text{font-size:14px;vertical-align:middle}.el-steps{display:-webkit-box;display:-ms-flexbox;display:flex}.el-steps--simple{padding:13px 8%;border-radius:4px;background:#f3f3f4}.el-steps--horizontal{white-space:nowrap}.el-steps--vertical{height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}.el-step{position:relative;-ms-flex-negative:1;flex-shrink:1}.el-step:last-of-type .el-step__line{display:none}.el-step:last-of-type.is-flex{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.el-step:last-of-type .el-step__description,.el-step:last-of-type .el-step__main{padding-right:0}.el-step__head{position:relative;width:100%}.el-step__head.is-process{color:#676a6c;border-color:#676a6c}.el-step__head.is-wait{color:#ddd;border-color:#ddd}.el-step__head.is-success{color:#1ab394;border-color:#1ab394}.el-step__head.is-error{color:#ed5565;border-color:#ed5565}.el-step__head.is-finish{color:#1c84c6;border-color:#1c84c6}.el-step__icon{position:relative;z-index:1;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:24px;height:24px;font-size:14px;-webkit-box-sizing:border-box;box-sizing:border-box;background:#fff;-webkit-transition:.15s ease-out;transition:.15s ease-out}.el-step__icon.is-text{border-radius:50%;border:2px solid;border-color:inherit}.el-step__icon.is-icon{width:40px}.el-step__icon-inner{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-align:center;font-weight:700;line-height:1;color:inherit}.el-step__icon-inner[class*=el-icon]:not(.is-status){font-size:25px;font-weight:400}.el-step__icon-inner.is-status{-webkit-transform:translateY(1px);transform:translateY(1px)}.el-step__line{position:absolute;border-color:inherit;background-color:#ddd}.el-step__line-inner{display:block;border-width:1px;border-style:solid;border-color:inherit;-webkit-transition:.15s ease-out;transition:.15s ease-out;-webkit-box-sizing:border-box;box-sizing:border-box;width:0;height:0}.el-step__main{white-space:normal;text-align:left}.el-step__title{font-size:16px;line-height:38px}.el-step__title.is-process{font-weight:700;color:#676a6c}.el-step__title.is-wait{color:#ddd}.el-step__title.is-success{color:#1ab394}.el-step__title.is-error{color:#ed5565}.el-step__title.is-finish{color:#1c84c6}.el-step__description{padding-right:10%;margin-top:-5px;font-size:12px;line-height:20px;font-weight:400}.el-step__description.is-process{color:#676a6c}.el-step__description.is-wait{color:#ddd}.el-step__description.is-success{color:#1ab394}.el-step__description.is-error{color:#ed5565}.el-step__description.is-finish{color:#1c84c6}.el-step.is-horizontal{display:inline-block}.el-step.is-horizontal .el-step__line{height:2px;top:11px;left:0;right:0}.el-step.is-vertical{display:-webkit-box;display:-ms-flexbox;display:flex}.el-step.is-vertical .el-step__head{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;width:24px}.el-step.is-vertical .el-step__main{padding-left:10px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.el-step.is-vertical .el-step__title{line-height:24px;padding-bottom:8px}.el-step.is-vertical .el-step__line{width:2px;top:0;bottom:0;left:11px}.el-step.is-vertical .el-step__icon.is-icon{width:24px}.el-step.is-center .el-step__head,.el-step.is-center .el-step__main{text-align:center}.el-step.is-center .el-step__description{padding-left:20%;padding-right:20%}.el-step.is-center .el-step__line{left:50%;right:-50%}.el-step.is-simple{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-step.is-simple .el-step__head{width:auto;font-size:0;padding-right:10px}.el-step.is-simple .el-step__icon{background:transparent;width:16px;height:16px;font-size:12px}.el-step.is-simple .el-step__icon-inner[class*=el-icon]:not(.is-status){font-size:18px}.el-step.is-simple .el-step__icon-inner.is-status{-webkit-transform:scale(.8) translateY(1px);transform:scale(.8) translateY(1px)}.el-step.is-simple .el-step__main{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.el-step.is-simple .el-step__title{font-size:16px;line-height:20px}.el-step.is-simple:not(:last-of-type) .el-step__title{max-width:50%;word-break:break-all}.el-step.is-simple .el-step__arrow{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-step.is-simple .el-step__arrow:after,.el-step.is-simple .el-step__arrow:before{content:\"\";display:inline-block;position:absolute;height:15px;width:1px;background:#ddd}.el-step.is-simple .el-step__arrow:before{-webkit-transform:rotate(-45deg) translateY(-4px);transform:rotate(-45deg) translateY(-4px);-webkit-transform-origin:0 0;transform-origin:0 0}.el-step.is-simple .el-step__arrow:after{-webkit-transform:rotate(45deg) translateY(4px);transform:rotate(45deg) translateY(4px);-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.el-step.is-simple:last-of-type .el-step__arrow{display:none}.el-carousel{overflow-x:hidden;position:relative}.el-carousel__container{position:relative;height:300px}.el-carousel__arrow{border:none;outline:none;padding:0;margin:0;height:36px;width:36px;cursor:pointer;-webkit-transition:.3s;transition:.3s;border-radius:50%;background-color:rgba(31,45,61,.11);color:#fff;position:absolute;top:50%;z-index:10;-webkit-transform:translateY(-50%);transform:translateY(-50%);text-align:center;font-size:12px}.el-carousel__arrow--left{left:16px}.el-carousel__arrow--right{right:16px}.el-carousel__arrow:hover{background-color:rgba(31,45,61,.23)}.el-carousel__arrow i{cursor:pointer}.el-carousel__indicators{position:absolute;list-style:none;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);margin:0;padding:0;z-index:2}.el-carousel__indicators--outside{bottom:26px;text-align:center;position:static;-webkit-transform:none;transform:none}.el-carousel__indicators--outside .el-carousel__indicator:hover button{opacity:.64}.el-carousel__indicators--outside button{background-color:#ddd;opacity:.24}.el-carousel__indicators--labels{left:0;right:0;-webkit-transform:none;transform:none;text-align:center}.el-carousel__indicators--labels .el-carousel__button{height:auto;width:auto;padding:2px 18px;font-size:12px}.el-carousel__indicators--labels .el-carousel__indicator{padding:6px 4px}.el-carousel__indicator{display:inline-block;background-color:transparent;padding:12px 4px;cursor:pointer}.el-carousel__indicator:hover button{opacity:.72}.el-carousel__indicator.is-active button{opacity:1}.el-carousel__button{display:block;opacity:.48;width:30px;height:2px;background-color:#fff;border:none;outline:none;padding:0;margin:0;cursor:pointer;-webkit-transition:.3s;transition:.3s}.carousel-arrow-left-enter,.carousel-arrow-left-leave-active{-webkit-transform:translateY(-50%) translateX(-10px);transform:translateY(-50%) translateX(-10px);opacity:0}.carousel-arrow-right-enter,.carousel-arrow-right-leave-active{-webkit-transform:translateY(-50%) translateX(10px);transform:translateY(-50%) translateX(10px);opacity:0}.el-scrollbar{overflow:hidden;position:relative}.el-scrollbar:active>.el-scrollbar__bar,.el-scrollbar:focus>.el-scrollbar__bar,.el-scrollbar:hover>.el-scrollbar__bar{opacity:1;-webkit-transition:opacity .34s ease-out;transition:opacity .34s ease-out}.el-scrollbar__wrap{overflow:scroll;height:100%}.el-scrollbar__wrap--hidden-default::-webkit-scrollbar{width:0;height:0}.el-scrollbar__thumb{position:relative;display:block;width:0;height:0;cursor:pointer;border-radius:inherit;background-color:hsla(0,0%,60%,.3);-webkit-transition:background-color .3s;transition:background-color .3s}.el-scrollbar__thumb:hover{background-color:hsla(0,0%,60%,.5)}.el-scrollbar__bar{position:absolute;right:2px;bottom:2px;z-index:1;border-radius:4px;opacity:0;-webkit-transition:opacity .12s ease-out;transition:opacity .12s ease-out}.el-scrollbar__bar.is-vertical{width:6px;top:2px}.el-scrollbar__bar.is-vertical>div{width:100%}.el-scrollbar__bar.is-horizontal{height:6px;left:2px}.el-scrollbar__bar.is-horizontal>div{height:100%}.el-carousel__item{position:absolute;top:0;left:0;width:100%;height:100%;display:inline-block;overflow:hidden;z-index:0}.el-carousel__item.is-active{z-index:2}.el-carousel__item--card,.el-carousel__item.is-animating{-webkit-transition:-webkit-transform .4s ease-in-out;transition:-webkit-transform .4s ease-in-out;transition:transform .4s ease-in-out;transition:transform .4s ease-in-out,-webkit-transform .4s ease-in-out}.el-carousel__item--card{width:50%}.el-carousel__item--card.is-in-stage{cursor:pointer;z-index:1}.el-carousel__item--card.is-in-stage.is-hover .el-carousel__mask,.el-carousel__item--card.is-in-stage:hover .el-carousel__mask{opacity:.12}.el-carousel__item--card.is-active{z-index:2}.el-carousel__mask{position:absolute;width:100%;height:100%;top:0;left:0;background-color:#fff;opacity:.24;-webkit-transition:.2s;transition:.2s}.el-collapse{border-top:1px solid #ebeef5;border-bottom:1px solid #ebeef5}.el-collapse-item__header{height:48px;line-height:48px;background-color:#fff;color:#676a6c;cursor:pointer;border-bottom:1px solid #ebeef5;font-size:13px;font-weight:500;-webkit-transition:border-bottom-color .3s;transition:border-bottom-color .3s;outline:none}.el-collapse-item__arrow{margin-right:8px;-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;float:right;line-height:48px;font-weight:300}.el-collapse-item__arrow.is-active{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-collapse-item__header.focusing:focus:not(:hover){color:#1c84c6}.el-collapse-item__header.is-active{border-bottom-color:transparent}.el-collapse-item__wrap{will-change:height;background-color:#fff;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;border-bottom:1px solid #ebeef5}.el-collapse-item__content{padding-bottom:25px;font-size:13px;color:#676a6c;line-height:1.769230769230769}.el-collapse-item:last-child{margin-bottom:-1px}.el-popper .popper__arrow,.el-popper .popper__arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.el-popper .popper__arrow{border-width:6px;-webkit-filter:drop-shadow(0 2px 12px rgba(0,0,0,.03));filter:drop-shadow(0 2px 12px rgba(0,0,0,.03))}.el-popper .popper__arrow:after{content:\" \";border-width:6px}.el-popper[x-placement^=top]{margin-bottom:12px}.el-popper[x-placement^=top] .popper__arrow{bottom:-6px;left:50%;margin-right:3px;border-top-color:#ebeef5;border-bottom-width:0}.el-popper[x-placement^=top] .popper__arrow:after{bottom:1px;margin-left:-6px;border-top-color:#fff;border-bottom-width:0}.el-popper[x-placement^=bottom]{margin-top:12px}.el-popper[x-placement^=bottom] .popper__arrow{top:-6px;left:50%;margin-right:3px;border-top-width:0;border-bottom-color:#ebeef5}.el-popper[x-placement^=bottom] .popper__arrow:after{top:1px;margin-left:-6px;border-top-width:0;border-bottom-color:#fff}.el-popper[x-placement^=right]{margin-left:12px}.el-popper[x-placement^=right] .popper__arrow{top:50%;left:-6px;margin-bottom:3px;border-right-color:#ebeef5;border-left-width:0}.el-popper[x-placement^=right] .popper__arrow:after{bottom:-6px;left:1px;border-right-color:#fff;border-left-width:0}.el-popper[x-placement^=left]{margin-right:12px}.el-popper[x-placement^=left] .popper__arrow{top:50%;right:-6px;margin-bottom:3px;border-right-width:0;border-left-color:#ebeef5}.el-popper[x-placement^=left] .popper__arrow:after{right:1px;bottom:-6px;margin-left:-6px;border-right-width:0;border-left-color:#fff}.el-cascader{display:inline-block;position:relative;font-size:14px;line-height:40px}.el-cascader .el-input,.el-cascader .el-input__inner{cursor:pointer}.el-cascader .el-input__icon{-webkit-transition:none;transition:none}.el-cascader .el-icon-arrow-down{-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;font-size:14px}.el-cascader .el-icon-arrow-down.is-reverse{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.el-cascader .el-icon-circle-close{z-index:2;-webkit-transition:color .2s cubic-bezier(.645,.045,.355,1);transition:color .2s cubic-bezier(.645,.045,.355,1)}.el-cascader .el-icon-circle-close:hover{color:#999}.el-cascader__clearIcon{z-index:2;position:relative}.el-cascader__label{position:absolute;left:0;top:0;height:100%;padding:0 25px 0 15px;color:#676a6c;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;text-align:left;font-size:inherit}.el-cascader__label span{color:#000}.el-cascader--medium{font-size:14px;line-height:36px}.el-cascader--small{font-size:13px;line-height:32px}.el-cascader--mini{font-size:12px;line-height:28px}.el-cascader.is-disabled .el-cascader__label{z-index:2;color:#ddd}.el-cascader-menus{white-space:nowrap;background:#fff;position:absolute;margin:5px 0;z-index:2;border:1px solid #e4e7ed;border-radius:2px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-cascader-menu{display:inline-block;vertical-align:top;height:204px;overflow:auto;border-right:1px solid #e4e7ed;background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:6px 0;min-width:160px}.el-cascader-menu:last-child{border-right:0}.el-cascader-menu__item{font-size:14px;padding:8px 20px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#676a6c;height:34px;line-height:1.5;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;outline:none}.el-cascader-menu__item--extensible:after{font-family:element-icons;content:\"\\E604\";font-size:14px;color:#bfcbd9;position:absolute;right:15px}.el-cascader-menu__item.is-disabled{color:#ddd;background-color:#fff;cursor:not-allowed}.el-cascader-menu__item.is-disabled:hover{background-color:#fff}.el-cascader-menu__item.is-active{color:#1c84c6}.el-cascader-menu__item:focus:not(:active),.el-cascader-menu__item:hover{background-color:#f3f3f4}.el-cascader-menu__item.selected{color:#fff;background-color:#f3f3f4}.el-cascader-menu__item__keyword{font-weight:700}.el-cascader-menu--flexible{height:auto;max-height:180px;overflow:auto}.el-cascader-menu--flexible .el-cascader-menu__item{overflow:visible}.el-color-predefine{font-size:12px;margin-top:8px;width:280px}.el-color-predefine,.el-color-predefine__colors{display:-webkit-box;display:-ms-flexbox;display:flex}.el-color-predefine__colors{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-wrap:wrap;flex-wrap:wrap}.el-color-predefine__color-selector{margin:0 0 8px 8px;width:20px;height:20px;border-radius:4px;cursor:pointer}.el-color-predefine__color-selector:nth-child(10n+1){margin-left:0}.el-color-predefine__color-selector.selected{-webkit-box-shadow:0 0 3px 2px #1c84c6;box-shadow:0 0 3px 2px #1c84c6}.el-color-predefine__color-selector>div{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;border-radius:3px}.el-color-predefine__color-selector.is-alpha{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-hue-slider{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;width:280px;height:12px;background-color:red;padding:0 2px}.el-color-hue-slider__bar{position:relative;background:-webkit-gradient(linear,left top,right top,from(red),color-stop(17%,#ff0),color-stop(33%,#0f0),color-stop(50%,#0ff),color-stop(67%,#00f),color-stop(83%,#f0f),to(red));background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);height:100%}.el-color-hue-slider__thumb{position:absolute;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;left:0;top:0;width:4px;height:100%;border-radius:1px;background:#fff;border:1px solid #f0f0f0;-webkit-box-shadow:0 0 2px rgba(0,0,0,.6);box-shadow:0 0 2px rgba(0,0,0,.6);z-index:1}.el-color-hue-slider.is-vertical{width:12px;height:180px;padding:2px 0}.el-color-hue-slider.is-vertical .el-color-hue-slider__bar{background:-webkit-gradient(linear,left top,left bottom,from(red),color-stop(17%,#ff0),color-stop(33%,#0f0),color-stop(50%,#0ff),color-stop(67%,#00f),color-stop(83%,#f0f),to(red));background:linear-gradient(180deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.el-color-hue-slider.is-vertical .el-color-hue-slider__thumb{left:0;top:0;width:100%;height:4px}.el-color-svpanel{position:relative;width:280px;height:180px}.el-color-svpanel__black,.el-color-svpanel__white{position:absolute;top:0;left:0;right:0;bottom:0}.el-color-svpanel__white{background:-webkit-gradient(linear,left top,right top,from(#fff),to(hsla(0,0%,100%,0)));background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.el-color-svpanel__black{background:-webkit-gradient(linear,left bottom,left top,from(#000),to(transparent));background:linear-gradient(0deg,#000,transparent)}.el-color-svpanel__cursor{position:absolute}.el-color-svpanel__cursor>div{cursor:head;width:4px;height:4px;-webkit-box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);border-radius:50%;-webkit-transform:translate(-2px,-2px);transform:translate(-2px,-2px)}.el-color-alpha-slider{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;width:280px;height:12px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-alpha-slider__bar{position:relative;background:-webkit-gradient(linear,left top,right top,from(hsla(0,0%,100%,0)),to(#fff));background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,#fff);height:100%}.el-color-alpha-slider__thumb{position:absolute;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;left:0;top:0;width:4px;height:100%;border-radius:1px;background:#fff;border:1px solid #f0f0f0;-webkit-box-shadow:0 0 2px rgba(0,0,0,.6);box-shadow:0 0 2px rgba(0,0,0,.6);z-index:1}.el-color-alpha-slider.is-vertical{width:20px;height:180px}.el-color-alpha-slider.is-vertical .el-color-alpha-slider__bar{background:-webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),to(#fff));background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff)}.el-color-alpha-slider.is-vertical .el-color-alpha-slider__thumb{left:0;top:0;width:100%;height:4px}.el-color-dropdown{width:300px}.el-color-dropdown__main-wrapper{margin-bottom:6px}.el-color-dropdown__main-wrapper:after{content:\"\";display:table;clear:both}.el-color-dropdown__btns{margin-top:6px;text-align:right}.el-color-dropdown__value{float:left;line-height:26px;font-size:12px;color:#000;width:160px}.el-color-dropdown__btn{border:1px solid #dcdcdc;color:#333;line-height:24px;border-radius:2px;padding:0 20px;cursor:pointer;background-color:transparent;outline:none;font-size:12px}.el-color-dropdown__btn[disabled]{color:#ccc;cursor:not-allowed}.el-color-dropdown__btn:hover{color:#1c84c6;border-color:#1c84c6}.el-color-dropdown__link-btn{cursor:pointer;color:#1c84c6;text-decoration:none;padding:15px;font-size:12px}.el-color-dropdown__link-btn:hover{color:tint(#1c84c6,20%)}.el-color-picker{display:inline-block;position:relative;line-height:normal;height:40px}.el-color-picker.is-disabled .el-color-picker__trigger{cursor:not-allowed}.el-color-picker--medium{height:36px}.el-color-picker--medium .el-color-picker__trigger{height:36px;width:36px}.el-color-picker--medium .el-color-picker__mask{height:34px;width:34px}.el-color-picker--small{height:32px}.el-color-picker--small .el-color-picker__trigger{height:32px;width:32px}.el-color-picker--small .el-color-picker__mask{height:30px;width:30px}.el-color-picker--small .el-color-picker__empty,.el-color-picker--small .el-color-picker__icon{-webkit-transform:translate3d(-50%,-50%,0) scale(.8);transform:translate3d(-50%,-50%,0) scale(.8)}.el-color-picker--mini{height:28px}.el-color-picker--mini .el-color-picker__trigger{height:28px;width:28px}.el-color-picker--mini .el-color-picker__mask{height:26px;width:26px}.el-color-picker--mini .el-color-picker__empty,.el-color-picker--mini .el-color-picker__icon{-webkit-transform:translate3d(-50%,-50%,0) scale(.8);transform:translate3d(-50%,-50%,0) scale(.8)}.el-color-picker__mask{height:38px;width:38px;border-radius:4px;position:absolute;top:1px;left:1px;z-index:1;cursor:not-allowed;background-color:hsla(0,0%,100%,.7)}.el-color-picker__trigger{display:inline-block;height:40px;width:40px;padding:4px;border:1px solid #e6e6e6;border-radius:4px;font-size:0;cursor:pointer}.el-color-picker__color,.el-color-picker__trigger{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative}.el-color-picker__color{display:block;border:1px solid #999;border-radius:2px;width:100%;height:100%;text-align:center}.el-color-picker__color.is-alpha{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-picker__color-inner{position:absolute;left:0;top:0;right:0;bottom:0}.el-color-picker__empty{color:#999}.el-color-picker__empty,.el-color-picker__icon{font-size:12px;position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.el-color-picker__icon{display:inline-block;width:100%;color:#fff;text-align:center}.el-color-picker__panel{position:absolute;z-index:10;padding:6px;-webkit-box-sizing:content-box;box-sizing:content-box;background-color:#fff;border:1px solid #ebeef5;border-radius:4px;-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-textarea{display:inline-block;width:100%;vertical-align:bottom;font-size:14px}.el-textarea__inner{display:block;resize:vertical;padding:5px 15px;line-height:1.5;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:inherit;color:#676a6c;background-color:#fff;background-image:none;border:1px solid #dcdfe6;border-radius:4px;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1)}.el-textarea__inner::-webkit-input-placeholder{color:#ddd}.el-textarea__inner:-ms-input-placeholder,.el-textarea__inner::-ms-input-placeholder{color:#ddd}.el-textarea__inner::placeholder{color:#ddd}.el-textarea__inner:hover{border-color:#ddd}.el-textarea__inner:focus{outline:none;border-color:#1c84c6}.el-textarea.is-disabled .el-textarea__inner{background-color:#f3f3f4;border-color:#e4e7ed;color:#ddd;cursor:not-allowed}.el-textarea.is-disabled .el-textarea__inner::-webkit-input-placeholder{color:#ddd}.el-textarea.is-disabled .el-textarea__inner:-ms-input-placeholder,.el-textarea.is-disabled .el-textarea__inner::-ms-input-placeholder{color:#ddd}.el-textarea.is-disabled .el-textarea__inner::placeholder{color:#ddd}.el-input{position:relative;font-size:14px;display:inline-block;width:100%}.el-input::-webkit-scrollbar{z-index:11;width:6px}.el-input::-webkit-scrollbar:horizontal{height:6px}.el-input::-webkit-scrollbar-thumb{border-radius:5px;width:6px;background:#b4bccc}.el-input::-webkit-scrollbar-corner,.el-input::-webkit-scrollbar-track{background:#fff}.el-input::-webkit-scrollbar-track-piece{background:#fff;width:6px}.el-input .el-input__clear{color:#ddd;font-size:14px;line-height:16px;cursor:pointer;-webkit-transition:color .2s cubic-bezier(.645,.045,.355,1);transition:color .2s cubic-bezier(.645,.045,.355,1)}.el-input .el-input__clear:hover{color:#999}.el-input__inner{-webkit-appearance:none;background-color:#fff;background-image:none;border-radius:4px;border:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box;color:#676a6c;display:inline-block;font-size:inherit;height:40px;line-height:40px;outline:none;padding:0 15px;-webkit-transition:border-color .2s cubic-bezier(.645,.045,.355,1);transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%}.el-input__inner::-webkit-input-placeholder{color:#ddd}.el-input__inner:-ms-input-placeholder,.el-input__inner::-ms-input-placeholder{color:#ddd}.el-input__inner::placeholder{color:#ddd}.el-input__inner:hover{border-color:#ddd}.el-input__inner:focus{outline:none;border-color:#1c84c6}.el-input__suffix{position:absolute;height:100%;right:5px;top:0;text-align:center;color:#ddd;-webkit-transition:all .3s;transition:all .3s;pointer-events:none}.el-input__suffix-inner{pointer-events:all}.el-input__prefix{position:absolute;left:5px;top:0;color:#ddd}.el-input__icon,.el-input__prefix{height:100%;text-align:center;-webkit-transition:all .3s;transition:all .3s}.el-input__icon{width:25px;line-height:40px}.el-input__icon:after{content:\"\";height:100%;width:0;display:inline-block;vertical-align:middle}.el-input__validateIcon{pointer-events:none}.el-input.is-active .el-input__inner{outline:none;border-color:#1c84c6}.el-input.is-disabled .el-input__inner{background-color:#f3f3f4;border-color:#e4e7ed;color:#ddd;cursor:not-allowed}.el-input.is-disabled .el-input__inner::-webkit-input-placeholder{color:#ddd}.el-input.is-disabled .el-input__inner:-ms-input-placeholder,.el-input.is-disabled .el-input__inner::-ms-input-placeholder{color:#ddd}.el-input.is-disabled .el-input__inner::placeholder{color:#ddd}.el-input.is-disabled .el-input__icon{cursor:not-allowed}.el-input--suffix .el-input__inner{padding-right:30px}.el-input--prefix .el-input__inner{padding-left:30px}.el-input--medium{font-size:14px}.el-input--medium .el-input__inner{height:36px;line-height:36px}.el-input--medium .el-input__icon{line-height:36px}.el-input--small{font-size:13px}.el-input--small .el-input__inner{height:32px;line-height:32px}.el-input--small .el-input__icon{line-height:32px}.el-input--mini{font-size:12px}.el-input--mini .el-input__inner{height:28px;line-height:28px}.el-input--mini .el-input__icon{line-height:28px}.el-input-group{line-height:normal;display:inline-table;width:100%;border-collapse:separate}.el-input-group>.el-input__inner{vertical-align:middle;display:table-cell}.el-input-group__append,.el-input-group__prepend{background-color:#f3f3f4;color:#3f5060;vertical-align:middle;display:table-cell;position:relative;border:1px solid #dcdfe6;border-radius:4px;padding:0 20px;width:1px;white-space:nowrap}.el-input-group__append:focus,.el-input-group__prepend:focus{outline:none}.el-input-group__append .el-button,.el-input-group__append .el-select,.el-input-group__prepend .el-button,.el-input-group__prepend .el-select{display:inline-block;margin:-10px -20px}.el-input-group__append button.el-button,.el-input-group__append div.el-select .el-input__inner,.el-input-group__append div.el-select:hover .el-input__inner,.el-input-group__prepend button.el-button,.el-input-group__prepend div.el-select .el-input__inner,.el-input-group__prepend div.el-select:hover .el-input__inner{border-color:transparent;background-color:transparent;color:inherit;border-top:0;border-bottom:0}.el-input-group__append .el-button,.el-input-group__append .el-input,.el-input-group__prepend .el-button,.el-input-group__prepend .el-input{font-size:inherit}.el-input-group__prepend{border-right:0;border-top-right-radius:0;border-bottom-right-radius:0}.el-input-group__append{border-left:0}.el-input-group--prepend .el-input__inner,.el-input-group__append{border-top-left-radius:0;border-bottom-left-radius:0}.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner{border-color:transparent}.el-input-group--append .el-input__inner{border-top-right-radius:0;border-bottom-right-radius:0}.el-input-group--append .el-select .el-input.is-focus .el-input__inner{border-color:transparent}.el-input__inner::-ms-clear{display:none;width:0;height:0}.el-button{display:inline-block;line-height:1;white-space:nowrap;cursor:pointer;background:#fff;border:1px solid #dcdfe6;border-color:#dcdfe6;color:#676a6c;-webkit-appearance:none;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;margin:0;-webkit-transition:.1s;transition:.1s;font-weight:500;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;padding:12px 20px;font-size:14px;border-radius:4px}.el-button+.el-button{margin-left:10px}.el-button.is-round{padding:12px 20px}.el-button:focus,.el-button:hover{color:#1c84c6;border-color:#bbdaee;background-color:#e8f3f9}.el-button:active{color:#1977b2;border-color:#1977b2;outline:none}.el-button::-moz-focus-inner{border:0}.el-button [class*=el-icon-]+span{margin-left:5px}.el-button.is-plain:focus,.el-button.is-plain:hover{background:#fff;border-color:#1c84c6;color:#1c84c6}.el-button.is-plain:active{background:#fff;outline:none}.el-button.is-active,.el-button.is-plain:active{border-color:#1977b2;color:#1977b2}.el-button.is-disabled,.el-button.is-disabled:focus,.el-button.is-disabled:hover{color:#ddd;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5}.el-button.is-disabled.el-button--text{background-color:transparent}.el-button.is-disabled.is-plain,.el-button.is-disabled.is-plain:focus,.el-button.is-disabled.is-plain:hover{background-color:#fff;border-color:#ebeef5;color:#ddd}.el-button.is-loading{position:relative;pointer-events:none}.el-button.is-loading:before{pointer-events:none;content:\"\";position:absolute;left:-1px;top:-1px;right:-1px;bottom:-1px;border-radius:inherit;background-color:hsla(0,0%,100%,.35)}.el-button.is-round{border-radius:20px;padding:12px 23px}.el-button.is-circle{border-radius:50%;padding:12px}.el-button--primary{color:#fff;background-color:#1c84c6;border-color:#1c84c6}.el-button--primary:focus,.el-button--primary:hover{background:#499dd1;border-color:#499dd1;color:#fff}.el-button--primary:active{outline:none}.el-button--primary.is-active,.el-button--primary:active{background:#1977b2;border-color:#1977b2;color:#fff}.el-button--primary.is-disabled,.el-button--primary.is-disabled:active,.el-button--primary.is-disabled:focus,.el-button--primary.is-disabled:hover{color:#fff;background-color:#8ec2e3;border-color:#8ec2e3}.el-button--primary.is-plain{color:#1c84c6;background:#e8f3f9;border-color:#a4cee8}.el-button--primary.is-plain:focus,.el-button--primary.is-plain:hover{background:#1c84c6;border-color:#1c84c6;color:#fff}.el-button--primary.is-plain:active{background:#1977b2;border-color:#1977b2;color:#fff;outline:none}.el-button--primary.is-plain.is-disabled,.el-button--primary.is-plain.is-disabled:active,.el-button--primary.is-plain.is-disabled:focus,.el-button--primary.is-plain.is-disabled:hover{color:#77b5dd;background-color:#e8f3f9;border-color:#d2e6f4}.el-button--success{color:#fff;background-color:#1ab394;border-color:#1ab394}.el-button--success:focus,.el-button--success:hover{background:#48c2a9;border-color:#48c2a9;color:#fff}.el-button--success:active{outline:none}.el-button--success.is-active,.el-button--success:active{background:#17a185;border-color:#17a185;color:#fff}.el-button--success.is-disabled,.el-button--success.is-disabled:active,.el-button--success.is-disabled:focus,.el-button--success.is-disabled:hover{color:#fff;background-color:#8dd9ca;border-color:#8dd9ca}.el-button--success.is-plain{color:#1ab394;background:#e8f7f4;border-color:#a3e1d4}.el-button--success.is-plain:focus,.el-button--success.is-plain:hover{background:#1ab394;border-color:#1ab394;color:#fff}.el-button--success.is-plain:active{background:#17a185;border-color:#17a185;color:#fff;outline:none}.el-button--success.is-plain.is-disabled,.el-button--success.is-plain.is-disabled:active,.el-button--success.is-plain.is-disabled:focus,.el-button--success.is-plain.is-disabled:hover{color:#76d1bf;background-color:#e8f7f4;border-color:#d1f0ea}.el-button--warning{color:#fff;background-color:#f8ac59;border-color:#f8ac59}.el-button--warning:focus,.el-button--warning:hover{background:#f9bd7a;border-color:#f9bd7a;color:#fff}.el-button--warning:active{outline:none}.el-button--warning.is-active,.el-button--warning:active{background:#df9b50;border-color:#df9b50;color:#fff}.el-button--warning.is-disabled,.el-button--warning.is-disabled:active,.el-button--warning.is-disabled:focus,.el-button--warning.is-disabled:hover{color:#fff;background-color:#fcd6ac;border-color:#fcd6ac}.el-button--warning.is-plain{color:#f8ac59;background:#fef7ee;border-color:#fcdebd}.el-button--warning.is-plain:focus,.el-button--warning.is-plain:hover{background:#f8ac59;border-color:#f8ac59;color:#fff}.el-button--warning.is-plain:active{background:#df9b50;border-color:#df9b50;color:#fff;outline:none}.el-button--warning.is-plain.is-disabled,.el-button--warning.is-plain.is-disabled:active,.el-button--warning.is-plain.is-disabled:focus,.el-button--warning.is-plain.is-disabled:hover{color:#fbcd9b;background-color:#fef7ee;border-color:#feeede}.el-button--danger{color:#fff;background-color:#ed5565;border-color:#ed5565}.el-button--danger:focus,.el-button--danger:hover{background:#f17784;border-color:#f17784;color:#fff}.el-button--danger:active{outline:none}.el-button--danger.is-active,.el-button--danger:active{background:#d54d5b;border-color:#d54d5b;color:#fff}.el-button--danger.is-disabled,.el-button--danger.is-disabled:active,.el-button--danger.is-disabled:focus,.el-button--danger.is-disabled:hover{color:#fff;background-color:#f6aab2;border-color:#f6aab2}.el-button--danger.is-plain{color:#ed5565;background:#fdeef0;border-color:#f8bbc1}.el-button--danger.is-plain:focus,.el-button--danger.is-plain:hover{background:#ed5565;border-color:#ed5565;color:#fff}.el-button--danger.is-plain:active{background:#d54d5b;border-color:#d54d5b;color:#fff;outline:none}.el-button--danger.is-plain.is-disabled,.el-button--danger.is-plain.is-disabled:active,.el-button--danger.is-plain.is-disabled:focus,.el-button--danger.is-plain.is-disabled:hover{color:#f499a3;background-color:#fdeef0;border-color:#fbdde0}.el-button--info{color:#fff;background-color:#3f5060;border-color:#3f5060}.el-button--info:focus,.el-button--info:hover{background:#657380;border-color:#657380;color:#fff}.el-button--info:active{outline:none}.el-button--info.is-active,.el-button--info:active{background:#394856;border-color:#394856;color:#fff}.el-button--info.is-disabled,.el-button--info.is-disabled:active,.el-button--info.is-disabled:focus,.el-button--info.is-disabled:hover{color:#fff;background-color:#9fa8b0;border-color:#9fa8b0}.el-button--info.is-plain{color:#3f5060;background:#eceeef;border-color:#b2b9bf}.el-button--info.is-plain:focus,.el-button--info.is-plain:hover{background:#3f5060;border-color:#3f5060;color:#fff}.el-button--info.is-plain:active{background:#394856;border-color:#394856;color:#fff;outline:none}.el-button--info.is-plain.is-disabled,.el-button--info.is-plain.is-disabled:active,.el-button--info.is-plain.is-disabled:focus,.el-button--info.is-plain.is-disabled:hover{color:#8c96a0;background-color:#eceeef;border-color:#d9dcdf}.el-button--medium{padding:10px 20px;font-size:14px;border-radius:4px}.el-button--medium.is-round{padding:10px 20px}.el-button--small{padding:9px 15px;font-size:12px;border-radius:3px}.el-button--small.is-round{padding:9px 15px}.el-button--mini{padding:7px 15px;font-size:12px;border-radius:3px}.el-button--mini.is-round{padding:7px 15px}.el-button--text{border-color:transparent;color:#1c84c6;background:transparent;padding-left:0;padding-right:0}.el-button--text:focus,.el-button--text:hover{color:#499dd1;border-color:transparent;background-color:transparent}.el-button--text:active{color:#1977b2;background-color:transparent}.el-button--text.is-disabled,.el-button--text.is-disabled:focus,.el-button--text.is-disabled:hover,.el-button--text:active{border-color:transparent}.el-button-group{display:inline-block;vertical-align:middle}.el-button-group:after,.el-button-group:before{display:table;content:\"\"}.el-button-group:after{clear:both}.el-button-group .el-button{float:left;position:relative}.el-button-group .el-button+.el-button{margin-left:0}.el-button-group .el-button:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.el-button-group .el-button:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.el-button-group .el-button:first-child:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-bottom-left-radius:4px}.el-button-group .el-button:not(:first-child):not(:last-child){border-radius:0}.el-button-group .el-button:not(:last-child){margin-right:-1px}.el-button-group .el-button.is-active,.el-button-group .el-button:active,.el-button-group .el-button:focus,.el-button-group .el-button:hover{z-index:1}.el-button-group .el-button--primary:first-child{border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--primary:last-child{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--primary:not(:first-child):not(:last-child){border-left-color:hsla(0,0%,100%,.5);border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--success:first-child{border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--success:last-child{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--success:not(:first-child):not(:last-child){border-left-color:hsla(0,0%,100%,.5);border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--warning:first-child{border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--warning:last-child{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--warning:not(:first-child):not(:last-child){border-left-color:hsla(0,0%,100%,.5);border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--danger:first-child{border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--danger:last-child{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--danger:not(:first-child):not(:last-child){border-left-color:hsla(0,0%,100%,.5);border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--info:first-child{border-right-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--info:last-child{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--info:not(:first-child):not(:last-child){border-left-color:hsla(0,0%,100%,.5);border-right-color:hsla(0,0%,100%,.5)}.el-checkbox{color:#676a6c;font-weight:500;font-size:14px;position:relative;cursor:pointer;display:inline-block;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-checkbox.is-bordered{padding:9px 20px 9px 10px;border-radius:4px;border:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box;line-height:normal;height:40px}.el-checkbox.is-bordered.is-checked{border-color:#1c84c6}.el-checkbox.is-bordered.is-disabled{border-color:#ebeef5;cursor:not-allowed}.el-checkbox.is-bordered+.el-checkbox.is-bordered{margin-left:10px}.el-checkbox.is-bordered.el-checkbox--medium{padding:7px 20px 7px 10px;border-radius:4px;height:36px}.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label{line-height:17px;font-size:14px}.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__inner{height:14px;width:14px}.el-checkbox.is-bordered.el-checkbox--small{padding:5px 15px 5px 10px;border-radius:3px;height:32px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{line-height:15px;font-size:12px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner{height:12px;width:12px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner:after{height:6px;width:2px}.el-checkbox.is-bordered.el-checkbox--mini{padding:3px 15px 3px 10px;border-radius:3px;height:28px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__label{line-height:12px;font-size:12px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner{height:12px;width:12px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner:after{height:6px;width:2px}.el-checkbox__input{white-space:nowrap;cursor:pointer;outline:none;display:inline-block;line-height:1;position:relative;vertical-align:middle}.el-checkbox__input.is-disabled .el-checkbox__inner{background-color:#edf2fc;border-color:#dcdfe6;cursor:not-allowed}.el-checkbox__input.is-disabled .el-checkbox__inner:after{cursor:not-allowed;border-color:#ddd}.el-checkbox__input.is-disabled .el-checkbox__inner+.el-checkbox__label{cursor:not-allowed}.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{background-color:#f2f6fc;border-color:#dcdfe6}.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after{border-color:#ddd}.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner{background-color:#f2f6fc;border-color:#dcdfe6}.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner:before{background-color:#ddd;border-color:#ddd}.el-checkbox__input.is-disabled+span.el-checkbox__label{color:#ddd;cursor:not-allowed}.el-checkbox__input.is-checked .el-checkbox__inner{background-color:#1c84c6;border-color:#1c84c6}.el-checkbox__input.is-checked .el-checkbox__inner:after{-webkit-transform:rotate(45deg) scaleY(1);transform:rotate(45deg) scaleY(1)}.el-checkbox__input.is-checked+.el-checkbox__label{color:#1c84c6}.el-checkbox__input.is-focus .el-checkbox__inner{border-color:#1c84c6}.el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color:#1c84c6;border-color:#1c84c6}.el-checkbox__input.is-indeterminate .el-checkbox__inner:before{content:\"\";position:absolute;display:block;background-color:#fff;height:2px;-webkit-transform:scale(.5);transform:scale(.5);left:0;right:0;top:5px}.el-checkbox__input.is-indeterminate .el-checkbox__inner:after{display:none}.el-checkbox__inner{display:inline-block;position:relative;border:1px solid #dcdfe6;border-radius:2px;-webkit-box-sizing:border-box;box-sizing:border-box;width:14px;height:14px;background-color:#fff;z-index:1;-webkit-transition:border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);transition:border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46)}.el-checkbox__inner:hover{border-color:#1c84c6}.el-checkbox__inner:after{-webkit-box-sizing:content-box;box-sizing:content-box;content:\"\";border:1px solid #fff;border-left:0;border-top:0;height:7px;left:4px;position:absolute;top:1px;-webkit-transform:rotate(45deg) scaleY(0);transform:rotate(45deg) scaleY(0);width:3px;-webkit-transition:-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;transition:-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;transition:transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;transition:transform .15s cubic-bezier(.71,-.46,.88,.6) .05s,-webkit-transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;-webkit-transform-origin:center;transform-origin:center}.el-checkbox__original{opacity:0;outline:none;position:absolute;margin:0;width:0;height:0;z-index:-1}.el-checkbox__label{display:inline-block;padding-left:10px;line-height:19px;font-size:14px}.el-checkbox+.el-checkbox{margin-left:30px}.el-checkbox-button,.el-checkbox-button__inner{position:relative;display:inline-block}.el-checkbox-button__inner{line-height:1;font-weight:500;white-space:nowrap;vertical-align:middle;cursor:pointer;background:#fff;border:1px solid #dcdfe6;border-left:0;color:#676a6c;-webkit-appearance:none;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;margin:0;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;padding:12px 20px;font-size:14px;border-radius:0}.el-checkbox-button__inner.is-round{padding:12px 20px}.el-checkbox-button__inner:hover{color:#1c84c6}.el-checkbox-button__inner [class*=el-icon-]{line-height:.9}.el-checkbox-button__inner [class*=el-icon-]+span{margin-left:5px}.el-checkbox-button__original{opacity:0;outline:none;position:absolute;margin:0;z-index:-1}.el-checkbox-button.is-checked .el-checkbox-button__inner{color:#fff;background-color:#1c84c6;border-color:#1c84c6;-webkit-box-shadow:-1px 0 0 0 #77b5dd;box-shadow:-1px 0 0 0 #77b5dd}.el-checkbox-button.is-checked:first-child .el-checkbox-button__inner{border-left-color:#1c84c6}.el-checkbox-button.is-disabled .el-checkbox-button__inner{color:#ddd;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5;-webkit-box-shadow:none;box-shadow:none}.el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner{border-left-color:#ebeef5}.el-checkbox-button:first-child .el-checkbox-button__inner{border-left:1px solid #dcdfe6;border-radius:4px 0 0 4px;-webkit-box-shadow:none!important;box-shadow:none!important}.el-checkbox-button.is-focus .el-checkbox-button__inner{border-color:#1c84c6}.el-checkbox-button:last-child .el-checkbox-button__inner{border-radius:0 4px 4px 0}.el-checkbox-button--medium .el-checkbox-button__inner{padding:10px 20px;font-size:14px;border-radius:0}.el-checkbox-button--medium .el-checkbox-button__inner.is-round{padding:10px 20px}.el-checkbox-button--small .el-checkbox-button__inner{padding:9px 15px;font-size:12px;border-radius:0}.el-checkbox-button--small .el-checkbox-button__inner.is-round{padding:9px 15px}.el-checkbox-button--mini .el-checkbox-button__inner{padding:7px 15px;font-size:12px;border-radius:0}.el-checkbox-button--mini .el-checkbox-button__inner.is-round{padding:7px 15px}.el-checkbox-group{font-size:0}.el-transfer{font-size:14px}.el-transfer__buttons{display:inline-block;vertical-align:middle;padding:0 30px}.el-transfer__button{display:block;margin:0 auto;padding:10px;border-radius:50%;color:#fff;background-color:#1c84c6;font-size:0}.el-transfer__button.is-with-texts{border-radius:4px}.el-transfer__button.is-disabled,.el-transfer__button.is-disabled:hover{border:1px solid #dcdfe6;background-color:#f3f3f4;color:#ddd}.el-transfer__button:first-child{margin-bottom:10px}.el-transfer__button:nth-child(2){margin:0}.el-transfer__button i,.el-transfer__button span{font-size:14px}.el-transfer__button [class*=el-icon-]+span{margin-left:0}.el-transfer-panel{border:1px solid #ebeef5;border-radius:4px;overflow:hidden;background:#fff;display:inline-block;vertical-align:middle;width:200px;max-height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative}.el-transfer-panel__body{height:246px}.el-transfer-panel__body.is-with-footer{padding-bottom:40px}.el-transfer-panel__list{margin:0;padding:6px 0;list-style:none;height:246px;overflow:auto;-webkit-box-sizing:border-box;box-sizing:border-box}.el-transfer-panel__list.is-filterable{height:194px;padding-top:0}.el-transfer-panel__item{height:30px;line-height:30px;padding-left:15px;display:block}.el-transfer-panel__item+.el-transfer-panel__item{margin-left:0}.el-transfer-panel__item.el-checkbox{color:#676a6c}.el-transfer-panel__item:hover{color:#1c84c6}.el-transfer-panel__item.el-checkbox .el-checkbox__label{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding-left:24px;line-height:30px}.el-transfer-panel__item .el-checkbox__input{position:absolute;top:8px}.el-transfer-panel__filter{text-align:center;margin:15px;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;width:auto}.el-transfer-panel__filter .el-input__inner{height:32px;width:100%;font-size:12px;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:16px;padding-right:10px;padding-left:30px}.el-transfer-panel__filter .el-input__icon{margin-left:5px}.el-transfer-panel__filter .el-icon-circle-close{cursor:pointer}.el-transfer-panel .el-transfer-panel__header{height:40px;line-height:40px;background:#f3f3f4;margin:0;padding-left:15px;border-bottom:1px solid #ebeef5;-webkit-box-sizing:border-box;box-sizing:border-box;color:#000}.el-transfer-panel .el-transfer-panel__header .el-checkbox{display:block;line-height:40px}.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{font-size:16px;color:#676a6c;font-weight:400}.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span{position:absolute;right:15px;color:#999;font-size:12px;font-weight:400}.el-transfer-panel .el-transfer-panel__footer{height:40px;background:#fff;margin:0;padding:0;border-top:1px solid #ebeef5;position:absolute;bottom:0;left:0;width:100%;z-index:1}.el-transfer-panel .el-transfer-panel__footer:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-transfer-panel .el-transfer-panel__footer .el-checkbox{padding-left:20px;color:#676a6c}.el-transfer-panel .el-transfer-panel__empty{margin:0;height:30px;line-height:30px;padding:6px 15px 0;color:#999;text-align:center}.el-transfer-panel .el-checkbox__label{padding-left:8px}.el-transfer-panel .el-checkbox__inner{height:14px;width:14px;border-radius:3px}.el-transfer-panel .el-checkbox__inner:after{height:6px;width:3px;left:4px}.el-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;-webkit-box-sizing:border-box;box-sizing:border-box;min-width:0}.el-container.is-vertical{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.el-header{padding:0 20px}.el-aside,.el-header{-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}.el-aside{overflow:auto}.el-main{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;overflow:auto;padding:20px}.el-footer,.el-main{-webkit-box-sizing:border-box;box-sizing:border-box}.el-footer{padding:0 20px;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6f0a76321d30f3c8120915e57f7bd77e.ttf";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, ":root{--font-size:14px;--header-height:60px;--logo-height:60px;--left-side-width:250px;--breadcrumb-height:20px;--card-border-radius:5px;--card-spacing:16px;--tag-border-radius:5px;--tag-font-size:12px;--uploader-size:178px;--uploader-border-radius:5px}", ""]);

// exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, ".clearfix{display:inline-block}.clearfix:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}a{text-decoration:none;color:inherit}svg,svg+*{vertical-align:middle}.fa-icon{width:auto;height:1em;max-width:100%;max-height:100%}.el-table th .cell{word-break:break-word}.single-display-page{text-align:center}.single-display-page table{border-collapse:collapse;text-align:left}.single-display-page .key-value tr td:nth-child(odd){text-align:right;font-weight:700;width:200px;padding-right:20px}.single-display-page .key-value tr td:nth-child(2n){text-align:left}.el-menu{border-right:none}.el-menu-item,.el-submenu.is-opened>.el-submenu__title{background-color:var(--bg-color-dark)!important}.el-menu-item{border-left:4px solid transparent;box-sizing:border-box}.el-menu-item.is-active{border-left-color:var(--color-primary)}.el-submenu__title:hover{background-color:var(--bg-color-dark)!important}.el-submenu__title>i{color:#ddd;width:14px!important;height:14px;font-size:14px!important}.sp-left-side .title-icon{width:14px;height:14px;margin-right:5px}.el-submenu__title>svg{color:#ddd;margin-right:5px;width:14px!important;height:14px;font-size:14px!important}.el-dropdown>span{display:inline-block;padding:0 var(--card-spacing)}.el-table .cell .el-button,.el-table .cell .el-form-item{margin-bottom:0}.el-table .cell .el-form-item__content{line-height:normal}.sp-card .el-form{margin-bottom:calc(1px - var(--card-spacing) - 1px)}.sp-card .el-form+.el-pagination{margin-top:calc(2 * var(--card-spacing))}.el-form{display:table}.el-form fieldset{width:100%;display:table-row;margin:0 0 1rem;padding:1rem 1rem .5rem;border:1px solid #dcdfe6;border-radius:4px}.sp-form-table{display:table;width:100%}.sp-hooks+.el-form,.sp-hooks+.sp-card+.el-form{display:block}.el-form-item{display:table-row;width:100%}.el-form-item__content,.el-form-item__label{display:table-cell;float:none;padding-bottom:var(--card-spacing);vertical-align:top}.el-form--inline{display:block;margin-bottom:var(--card-spacing)}.el-form--inline .el-form-item{display:inline-flex;width:auto}.el-form--inline .el-form-item__content,.el-form--inline .el-form-item__label,.sp-hooks+.el-form .el-form-item__content,.sp-hooks+.el-form .el-form-item__label{padding-bottom:0}.el-form-item__content>.el-input,.el-form-item__content>.el-select{width:100%}.el-form-item__content>.el-tree{border:1px solid #dcdfe6;border-radius:4px;padding:1em;max-height:20em;overflow:auto}.el-form-item__error{top:auto;padding-top:0;padding-left:4px}.el-tabs__header{margin-bottom:var(--card-spacing)}.el-input-group{vertical-align:middle}.el-menu-item a{display:block}.el-input input[type=number]::-webkit-inner-spin-button{display:none}input:disabled,select:disabled,textarea:disabled{color:var(--text-color-dark)!important}.el-dialog__body{padding:20px!important}.el-notification__content{text-align:left}.el-upload{border:1px dashed var(--bg-color);border-radius:var(--uploader-border-radius);cursor:pointer;position:relative;overflow:hidden}.el-upload:hover{border-color:var(--color-primary)}.el-upload i{font-size:28px;color:var(--text-color);width:var(--uploader-size);height:var(--uploader-size);line-height:var(--uploader-size);text-align:center}*{box-sizing:border-box}body,html{margin:0;padding:0;font-size:var(--font-size)}#app,.el-container,body,html{height:100%}#app{font-family:Roboto,Helvetica Neue,Helvetica,Arial,sans-serif;color:var(--text-color-dark);overflow:hidden}.sp-cursor-pointer{cursor:pointer;user-select:none}.sp-breadcrumb-container{margin-bottom:var(--card-spacing);text-align:left}.sp-breadcrumb-container>*{display:inline-block;margin-right:5px;height:var(--breadcrumb-height);line-height:var(--breadcrumb-height);vertical-align:middle}.sp-header{background:var(--bg-color);color:var(--text-color-light);height:var(--header-height);line-height:var(--header-height)}.sp-header-col{float:right;margin-left:var(--card-spacing);vertical-align:top}.sp-header-col:hover{background:var(--bg-color)}.sp-header .el-select input{background:transparent;color:var(--text-color-light);border:none}.sp-logo{background-color:var(--bg-color-darker);background-position:50%;background-repeat:no-repeat;background-size:auto calc(var(--header-height) / 2);display:inline-block;width:var(--left-side-width);height:var(--logo-height)}.sp-left-side,.sp-right-side{background:var(--bg-color);color:var(--text-color-light);overflow:auto}.sp-left-side{float:left;width:var(--left-side-width);height:calc(100% - var(--logo-height));margin-top:calc(var(--logo-height) - var(--header-height))}.sp-right-side{width:calc(100% - var(--left-side-width));height:calc(100% - var(--header-height));float:left}.sp-right-side article{background:var(--bg-color-light);color:var(--text-color-dark);padding:var(--card-spacing);overflow:auto;height:100%}.sp-card{background:var(--bg-card);border-radius:var(--card-border-radius);overflow:hidden;padding:var(--card-spacing);margin-bottom:var(--card-spacing)}.sp-card:empty{display:none}.sp-card h1{margin:0 0 1rem;font-size:20px;font-weight:400}.sp-card .el-tabs__header{margin-bottom:0}.el-dialog .sp-card{padding:0}.sp-tag{display:inline-block;padding:0 .5rem;height:23px;line-height:23px;border-radius:var(--tag-border-radius);font-size:var(--tag-font-size);color:var(--text-color-light);vertical-align:middle}.sp-bg-primary{background-color:var(--color-primary)}.sp-bg-success{background-color:var(--color-success)}.sp-bg-warning{background-color:var(--color-warning)}.sp-bg-danger{background-color:var(--color-danger)}.sp-bg-info{background-color:var(--color-info)}.sp-bg-disabled{background-color:var(--color-disabled)}.sp-color-primary{color:var(--color-primary)}.sp-color-success{color:var(--color-success)}.sp-color-warning{color:var(--color-warning)}.sp-color-danger{color:var(--color-danger)}.sp-color-info{color:var(--color-info)}.sp-color-disabled{color:var(--color-disabled)}.sp-hooks button{margin-bottom:var(--card-spacing)}.sp-column-edit-button{position:absolute;top:1px;right:-40px;padding:0;width:40px;height:28px;line-height:28px;text-align:center;border-top:none;border-right:none;border-radius:0;border-bottom-left-radius:5px;opacity:0;transform:translateX(0);transition:opacity .3s,transform,.3s}.el-table:hover+.sp-column-edit-button,.sp-column-edit-button:hover{opacity:1;transform:translateX(-40px)}.sp-check-tree .el-tree-node__content{padding-left:.5em!important;padding-right:.5em}.sp-check-tree .el-tree-node__content>.el-tree-node__expand-icon{display:none}.sp-nested-view h1,.sp-parallel-view h1{margin:1rem 0;font-size:20px;font-weight:400}.el-form+.sp-nested-view h1,.el-form+.sp-parallel-view h1{margin-top:0}.sp-edit-page-form:not(:empty)+.sp-nested-view:before,.sp-edit-page-form:not(:empty)+.sp-parallel-view:before{content:\"\";display:block;border-top:1px dashed var(--bg-color);margin:2rem 0;opacity:.3}.sp-nested-view .sp-card{padding:0}", ""]);

// exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, ":root{--color-primary:#1c84c6;--color-success:#1ab394;--color-warning:#f8ac59;--color-danger:#ed5565;--color-info:#3f5060;--color-disabled:#9099a0;--text-color-light:#fff;--text-color:#999;--text-color-dark:#676a6c;--bg-color-lighter:#fff;--bg-color-light:#f3f3f4;--bg-color:#3f5060;--bg-color-dark:#2f4050;--bg-color-darker:#293846;--bg-card:#fff}", ""]);

// exports


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1885698e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var normalizeComponent = __webpack_require__(75)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1885698e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(216);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(217)("78cbb563", content, true, {});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, ".sp-logo{font-size:24px;text-align:center}", ""]);

// exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(218)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(220);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(122);
__webpack_require__(46);
__webpack_require__(60);
__webpack_require__(230);
__webpack_require__(237);
__webpack_require__(238);
module.exports = __webpack_require__(1).Promise;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var defined = __webpack_require__(78);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(81);
var descriptor = __webpack_require__(47);
var setToStringTag = __webpack_require__(59);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(31)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(19);
var getKeys = __webpack_require__(42);

module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(82);
var toAbsoluteIndex = __webpack_require__(226);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(228);
var step = __webpack_require__(229);
var Iterators = __webpack_require__(41);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(123)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(56);
var global = __webpack_require__(8);
var ctx = __webpack_require__(39);
var classof = __webpack_require__(86);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(28);
var aFunction = __webpack_require__(57);
var anInstance = __webpack_require__(231);
var forOf = __webpack_require__(232);
var speciesConstructor = __webpack_require__(132);
var task = __webpack_require__(133).set;
var microtask = __webpack_require__(234)();
var newPromiseCapabilityModule = __webpack_require__(88);
var perform = __webpack_require__(134);
var promiseResolve = __webpack_require__(135);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(235)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(59)($Promise, PROMISE);
__webpack_require__(236)(PROMISE);
Wrapper = __webpack_require__(1)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(136)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(39);
var call = __webpack_require__(130);
var isArrayIter = __webpack_require__(131);
var anObject = __webpack_require__(19);
var toLength = __webpack_require__(82);
var getIterFn = __webpack_require__(87);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(133).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(48)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(31);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var core = __webpack_require__(1);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(29);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(9);
var core = __webpack_require__(1);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(132);
var promiseResolve = __webpack_require__(135);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(88);
var perform = __webpack_require__(134);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(240), __esModule: true };

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60);
__webpack_require__(46);
module.exports = __webpack_require__(241);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(86);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(41);
module.exports = __webpack_require__(1).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60);
__webpack_require__(46);
module.exports = __webpack_require__(243);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var get = __webpack_require__(87);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(245);
module.exports = __webpack_require__(1).Object.entries;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $entries = __webpack_require__(246)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(42);
var toIObject = __webpack_require__(33);
var isEnum = __webpack_require__(52).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(248);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(49);
var $keys = __webpack_require__(42);

__webpack_require__(138)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(250);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(251) });


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(42);
var gOPS = __webpack_require__(89);
var pIE = __webpack_require__(52);
var toObject = __webpack_require__(49);
var IObject = __webpack_require__(127);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(40)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(253), __esModule: true };

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(60);
module.exports = __webpack_require__(90).f('iterator');


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(255), __esModule: true };

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(256);
__webpack_require__(122);
__webpack_require__(261);
__webpack_require__(262);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(32);
var DESCRIPTORS = __webpack_require__(29);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(125);
var META = __webpack_require__(257).KEY;
var $fails = __webpack_require__(40);
var shared = __webpack_require__(84);
var setToStringTag = __webpack_require__(59);
var uid = __webpack_require__(58);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(90);
var wksDefine = __webpack_require__(91);
var enumKeys = __webpack_require__(258);
var isArray = __webpack_require__(259);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(28);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(80);
var createDesc = __webpack_require__(47);
var _create = __webpack_require__(81);
var gOPNExt = __webpack_require__(260);
var $GOPD = __webpack_require__(140);
var $DP = __webpack_require__(25);
var $keys = __webpack_require__(42);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(139).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(52).f = $propertyIsEnumerable;
  __webpack_require__(89).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(56)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(58)('meta');
var isObject = __webpack_require__(28);
var has = __webpack_require__(32);
var setDesc = __webpack_require__(25).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(40)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(42);
var gOPS = __webpack_require__(89);
var pIE = __webpack_require__(52);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(48);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(33);
var gOPN = __webpack_require__(139).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('asyncIterator');


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('observable');


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};

var _util = __webpack_require__(35);

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasModal = false;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  zIndex: 2000,

  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.Popper = factory();
    }
})(undefined, function () {

    'use strict';

    var root = window;

    // default options
    var DEFAULTS = {
        // placement of the popper
        placement: 'bottom',

        gpuAcceleration: true,

        // shift popper from its origin by the given amount of pixels (can be negative)
        offset: 0,

        // the element which will act as boundary of the popper
        boundariesElement: 'viewport',

        // amount of pixel used to define a minimum distance between the boundaries and the popper
        boundariesPadding: 5,

        // popper will try to prevent overflow following this order,
        // by default, then, it could overflow on the left and on top of the boundariesElement
        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],

        // the behavior used by flip to change the placement of the popper
        flipBehavior: 'flip',

        arrowElement: '[x-arrow]',

        arrowOffset: 0,

        // list of functions used to modify the offsets before they are applied to the popper
        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],

        modifiersIgnored: [],

        forceAbsolute: false
    };

    /**
     * Create a new Popper.js instance
     * @constructor Popper
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement|Object} popper
     *      The HTML element used as popper, or a configuration used to generate the popper.
     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
     * @param {Object} options
     * @param {String} [options.placement=bottom]
     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
     *      left(-start, -end)`
     *
     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
     *      reference element.
     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
     *
     * @param {Boolean} [options.gpuAcceleration=true]
     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
     *      browser to use the GPU to accelerate the rendering.
     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
     *
     * @param {Number} [options.offset=0]
     *      Amount of pixels the popper will be shifted (can be negative).
     *
     * @param {String|Element} [options.boundariesElement='viewport']
     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
     *      of the defined boundaries (except if `keepTogether` is enabled)
     *
     * @param {Number} [options.boundariesPadding=5]
     *      Additional padding for the boundaries
     *
     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
     *      this means that the last ones will never overflow
     *
     * @param {String|Array} [options.flipBehavior='flip']
     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
     *      its axis (`right - left`, `top - bottom`).
     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
     *
     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
     *      to this array to edit the offsets and placement.
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Array} [options.modifiersIgnored=[]]
     *      Put here any built-in modifier name you want to exclude from the modifiers list
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Boolean} [options.removeOnDestroy=false]
     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
     */
    function Popper(reference, popper, options) {
        this._reference = reference.jquery ? reference[0] : reference;
        this.state = {};

        // if the popper variable is a configuration object, parse it to generate an HTMLElement
        // generate a default popper if is not defined
        var isNotDefined = typeof popper === 'undefined' || popper === null;
        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
        if (isNotDefined || isConfig) {
            this._popper = this.parse(isConfig ? popper : {});
        }
        // otherwise, use the given HTMLElement as popper
        else {
                this._popper = popper.jquery ? popper[0] : popper;
            }

        // with {} we create a new object with the options inside it
        this._options = Object.assign({}, DEFAULTS, options);

        // refactoring modifiers' list
        this._options.modifiers = this._options.modifiers.map(function (modifier) {
            // remove ignored modifiers
            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;

            // set the x-placement attribute before everything else because it could be used to add margins to the popper
            // margins needs to be calculated to get the correct popper offsets
            if (modifier === 'applyStyle') {
                this._popper.setAttribute('x-placement', this._options.placement);
            }

            // return predefined modifier identified by string or keep the custom one
            return this.modifiers[modifier] || modifier;
        }.bind(this));

        // make sure to apply the popper position before any computation
        this.state.position = this._getPosition(this._popper, this._reference);
        setStyle(this._popper, { position: this.state.position, top: 0 });

        // fire the first update to position the popper in the right place
        this.update();

        // setup event listeners, they will take care of update the position in specific situations
        this._setupEventListeners();
        return this;
    }

    //
    // Methods
    //
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */
    Popper.prototype.destroy = function () {
        this._popper.removeAttribute('x-placement');
        this._popper.style.left = '';
        this._popper.style.position = '';
        this._popper.style.top = '';
        this._popper.style[getSupportedPropertyName('transform')] = '';
        this._removeEventListeners();

        // remove the popper if user explicity asked for the deletion on destroy
        if (this._options.removeOnDestroy) {
            this._popper.remove();
        }
        return this;
    };

    /**
     * Updates the position of the popper, computing the new offsets and applying the new style
     * @method
     * @memberof Popper
     */
    Popper.prototype.update = function () {
        var data = { instance: this, styles: {} };

        // store placement inside the data object, modifiers will be able to edit `placement` if needed
        // and refer to _originalPlacement to know the original value
        data.placement = this._options.placement;
        data._originalPlacement = this._options.placement;

        // compute the popper and reference offsets and put them inside data.offsets
        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);

        // get boundaries
        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);

        data = this.runModifiers(data, this._options.modifiers);

        if (typeof this.state.updateCallback === 'function') {
            this.state.updateCallback(data);
        }
    };

    /**
     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onCreate = function (callback) {
        // the createCallbacks return as first argument the popper instance
        callback(this);
        return this;
    };

    /**
     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
     * used to style popper and its arrow.
     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onUpdate = function (callback) {
        this.state.updateCallback = callback;
        return this;
    };

    /**
     * Helper used to generate poppers from a configuration file
     * @method
     * @memberof Popper
     * @param config {Object} configuration
     * @returns {HTMLElement} popper
     */
    Popper.prototype.parse = function (config) {
        var defaultConfig = {
            tagName: 'div',
            classNames: ['popper'],
            attributes: [],
            parent: root.document.body,
            content: '',
            contentType: 'text',
            arrowTagName: 'div',
            arrowClassNames: ['popper__arrow'],
            arrowAttributes: ['x-arrow']
        };
        config = Object.assign({}, defaultConfig, config);

        var d = root.document;

        var popper = d.createElement(config.tagName);
        addClassNames(popper, config.classNames);
        addAttributes(popper, config.attributes);
        if (config.contentType === 'node') {
            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
        } else if (config.contentType === 'html') {
            popper.innerHTML = config.content;
        } else {
            popper.textContent = config.content;
        }

        if (config.arrowTagName) {
            var arrow = d.createElement(config.arrowTagName);
            addClassNames(arrow, config.arrowClassNames);
            addAttributes(arrow, config.arrowAttributes);
            popper.appendChild(arrow);
        }

        var parent = config.parent.jquery ? config.parent[0] : config.parent;

        // if the given parent is a string, use it to match an element
        // if more than one element is matched, the first one will be used as parent
        // if no elements are matched, the script will throw an error
        if (typeof parent === 'string') {
            parent = d.querySelectorAll(config.parent);
            if (parent.length > 1) {
                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
            }
            if (parent.length === 0) {
                throw 'ERROR: the given `parent` doesn\'t exists!';
            }
            parent = parent[0];
        }
        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
        // the first one will be used as parent
        if (parent.length > 1 && parent instanceof Element === false) {
            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
            parent = parent[0];
        }

        // append the generated popper to its parent
        parent.appendChild(popper);

        return popper;

        /**
         * Adds class names to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} classes
         */
        function addClassNames(element, classNames) {
            classNames.forEach(function (className) {
                element.classList.add(className);
            });
        }

        /**
         * Adds attributes to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} attributes
         * @example
         * addAttributes(element, [ 'data-info:foobar' ]);
         */
        function addAttributes(element, attributes) {
            attributes.forEach(function (attribute) {
                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
            });
        }
    };

    /**
     * Helper used to get the position which will be applied to the popper
     * @method
     * @memberof Popper
     * @param config {HTMLElement} popper element
     * @param reference {HTMLElement} reference element
     * @returns {String} position
     */
    Popper.prototype._getPosition = function (popper, reference) {
        var container = getOffsetParent(reference);

        if (this._options.forceAbsolute) {
            return 'absolute';
        }

        // Decide if the popper will be fixed
        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
        var isParentFixed = isFixed(reference, container);
        return isParentFixed ? 'fixed' : 'absolute';
    };

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper
     * @access private
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    Popper.prototype._getOffsets = function (popper, reference, placement) {
        placement = placement.split('-')[0];
        var popperOffsets = {};

        popperOffsets.position = this.state.position;
        var isParentFixed = popperOffsets.position === 'fixed';

        //
        // Get reference element position
        //
        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);

        //
        // Get popper sizes
        //
        var popperRect = getOuterSizes(popper);

        //
        // Compute offsets of popper
        //

        // depending by the popper placement we have to compute its offsets slightly differently
        if (['right', 'left'].indexOf(placement) !== -1) {
            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
            if (placement === 'left') {
                popperOffsets.left = referenceOffsets.left - popperRect.width;
            } else {
                popperOffsets.left = referenceOffsets.right;
            }
        } else {
            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
            if (placement === 'top') {
                popperOffsets.top = referenceOffsets.top - popperRect.height;
            } else {
                popperOffsets.top = referenceOffsets.bottom;
            }
        }

        // Add width and height to our offsets object
        popperOffsets.width = popperRect.width;
        popperOffsets.height = popperRect.height;

        return {
            popper: popperOffsets,
            reference: referenceOffsets
        };
    };

    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._setupEventListeners = function () {
        // NOTE: 1 DOM access here
        this.state.updateBound = this.update.bind(this);
        root.addEventListener('resize', this.state.updateBound);
        // if the boundariesElement is window we don't need to listen for the scroll event
        if (this._options.boundariesElement !== 'window') {
            var target = getScrollParent(this._reference);
            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
            if (target === root.document.body || target === root.document.documentElement) {
                target = root;
            }
            target.addEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = target;
        }
    };

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._removeEventListeners = function () {
        // NOTE: 1 DOM access here
        root.removeEventListener('resize', this.state.updateBound);
        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = null;
        }
        this.state.updateBound = null;
    };

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper
     * @access private
     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
     * @param {Number} padding - Boundaries padding
     * @param {Element} boundariesElement - Element used to define the boundaries
     * @returns {Object} Coordinates of the boundaries
     */
    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
        // NOTE: 1 DOM access here
        var boundaries = {};
        var width, height;
        if (boundariesElement === 'window') {
            var body = root.document.body,
                html = root.document.documentElement;

            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);

            boundaries = {
                top: 0,
                right: width,
                bottom: height,
                left: 0
            };
        } else if (boundariesElement === 'viewport') {
            var offsetParent = getOffsetParent(this._popper);
            var scrollParent = getScrollParent(this._popper);
            var offsetParentRect = getOffsetRect(offsetParent);

            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
            var getScrollTopValue = function getScrollTopValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
            };
            var getScrollLeftValue = function getScrollLeftValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
            };

            // if the popper is fixed we don't have to substract scrolling from the boundaries
            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);

            boundaries = {
                top: 0 - (offsetParentRect.top - scrollTop),
                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
                left: 0 - (offsetParentRect.left - scrollLeft)
            };
        } else {
            if (getOffsetParent(this._popper) === boundariesElement) {
                boundaries = {
                    top: 0,
                    left: 0,
                    right: boundariesElement.clientWidth,
                    bottom: boundariesElement.clientHeight
                };
            } else {
                boundaries = getOffsetRect(boundariesElement);
            }
        }
        boundaries.left += padding;
        boundaries.right -= padding;
        boundaries.top = boundaries.top + padding;
        boundaries.bottom = boundaries.bottom - padding;
        return boundaries;
    };

    /**
     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
     * @method
     * @memberof Popper
     * @access public
     * @param {Object} data
     * @param {Array} modifiers
     * @param {Function} ends
     */
    Popper.prototype.runModifiers = function (data, modifiers, ends) {
        var modifiersToRun = modifiers.slice();
        if (ends !== undefined) {
            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
        }

        modifiersToRun.forEach(function (modifier) {
            if (isFunction(modifier)) {
                data = modifier.call(this, data);
            }
        }.bind(this));

        return data;
    };

    /**
     * Helper used to know if the given modifier depends from another one.
     * @method
     * @memberof Popper
     * @param {String} requesting - name of requesting modifier
     * @param {String} requested - name of requested modifier
     * @returns {Boolean}
     */
    Popper.prototype.isModifierRequired = function (requesting, requested) {
        var index = getArrayKeyIndex(this._options.modifiers, requesting);
        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
            return modifier === requested;
        }).length;
    };

    //
    // Modifiers
    //

    /**
     * Modifiers list
     * @namespace Popper.modifiers
     * @memberof Popper
     * @type {Object}
     */
    Popper.prototype.modifiers = {};

    /**
     * Apply the computed styles to the popper element
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The same data object
     */
    Popper.prototype.modifiers.applyStyle = function (data) {
        // apply the final offsets to the popper
        // NOTE: 1 DOM access here
        var styles = {
            position: data.offsets.popper.position
        };

        // round top and left to avoid blurry text
        var left = Math.round(data.offsets.popper.left);
        var top = Math.round(data.offsets.popper.top);

        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
        // we automatically use the supported prefixed version if needed
        var prefixedProperty;
        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles.top = 0;
            styles.left = 0;
        }
        // othwerise, we use the standard `left` and `top` properties
        else {
                styles.left = left;
                styles.top = top;
            }

        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        Object.assign(styles, data.styles);

        setStyle(this._popper, styles);

        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
        // NOTE: 1 DOM access here
        this._popper.setAttribute('x-placement', data.placement);

        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
            setStyle(data.arrowElement, data.offsets.arrow);
        }

        return data;
    };

    /**
     * Modifier used to shift the popper on the start or end of its reference element side
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.shift = function (data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftVariation = placement.split('-')[1];

        // if shift shiftVariation is specified, run the modifier
        if (shiftVariation) {
            var reference = data.offsets.reference;
            var popper = getPopperClientRect(data.offsets.popper);

            var shiftOffsets = {
                y: {
                    start: { top: reference.top },
                    end: { top: reference.top + reference.height - popper.height }
                },
                x: {
                    start: { left: reference.left },
                    end: { left: reference.left + reference.width - popper.width }
                }
            };

            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';

            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
        }

        return data;
    };

    /**
     * Modifier used to make sure the popper does not overflows from it's boundaries
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.preventOverflow = function (data) {
        var order = this._options.preventOverflowOrder;
        var popper = getPopperClientRect(data.offsets.popper);

        var check = {
            left: function left() {
                var left = popper.left;
                if (popper.left < data.boundaries.left) {
                    left = Math.max(popper.left, data.boundaries.left);
                }
                return { left: left };
            },
            right: function right() {
                var left = popper.left;
                if (popper.right > data.boundaries.right) {
                    left = Math.min(popper.left, data.boundaries.right - popper.width);
                }
                return { left: left };
            },
            top: function top() {
                var top = popper.top;
                if (popper.top < data.boundaries.top) {
                    top = Math.max(popper.top, data.boundaries.top);
                }
                return { top: top };
            },
            bottom: function bottom() {
                var top = popper.top;
                if (popper.bottom > data.boundaries.bottom) {
                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
                }
                return { top: top };
            }
        };

        order.forEach(function (direction) {
            data.offsets.popper = Object.assign(popper, check[direction]());
        });

        return data;
    };

    /**
     * Modifier used to make sure the popper is always near its reference
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.keepTogether = function (data) {
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var f = Math.floor;

        if (popper.right < f(reference.left)) {
            data.offsets.popper.left = f(reference.left) - popper.width;
        }
        if (popper.left > f(reference.right)) {
            data.offsets.popper.left = f(reference.right);
        }
        if (popper.bottom < f(reference.top)) {
            data.offsets.popper.top = f(reference.top) - popper.height;
        }
        if (popper.top > f(reference.bottom)) {
            data.offsets.popper.top = f(reference.bottom);
        }

        return data;
    };

    /**
     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
     * Requires the `preventOverflow` modifier before it in order to work.
     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.flip = function (data) {
        // check if preventOverflow is in the list of modifiers before the flip modifier.
        // otherwise flip would not work as expected.
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
            return data;
        }

        if (data.flipped && data.placement === data._originalPlacement) {
            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
            return data;
        }

        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';

        var flipOrder = [];
        if (this._options.flipBehavior === 'flip') {
            flipOrder = [placement, placementOpposite];
        } else {
            flipOrder = this._options.flipBehavior;
        }

        flipOrder.forEach(function (step, index) {
            if (placement !== step || flipOrder.length === index + 1) {
                return;
            }

            placement = data.placement.split('-')[0];
            placementOpposite = getOppositePlacement(placement);

            var popperOffsets = getPopperClientRect(data.offsets.popper);

            // this boolean is used to distinguish right and bottom from top and left
            // they need different computations to get flipped
            var a = ['right', 'bottom'].indexOf(placement) !== -1;

            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
                // we'll use this boolean to detect any flip loop
                data.flipped = true;
                data.placement = flipOrder[index + 1];
                if (variation) {
                    data.placement += '-' + variation;
                }
                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;

                data = this.runModifiers(data, this._options.modifiers, this._flip);
            }
        }.bind(this));
        return data;
    };

    /**
     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
     * The offsets will shift the popper on the side of its reference element.
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.offset = function (data) {
        var offset = this._options.offset;
        var popper = data.offsets.popper;

        if (data.placement.indexOf('left') !== -1) {
            popper.top -= offset;
        } else if (data.placement.indexOf('right') !== -1) {
            popper.top += offset;
        } else if (data.placement.indexOf('top') !== -1) {
            popper.left -= offset;
        } else if (data.placement.indexOf('bottom') !== -1) {
            popper.left += offset;
        }
        return data;
    };

    /**
     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.arrow = function (data) {
        var arrow = this._options.arrowElement;
        var arrowOffset = this._options.arrowOffset;

        // if the arrowElement is a string, suppose it's a CSS selector
        if (typeof arrow === 'string') {
            arrow = this._popper.querySelector(arrow);
        }

        // if arrow element is not found, don't run the modifier
        if (!arrow) {
            return data;
        }

        // the arrow element must be child of its popper
        if (!this._popper.contains(arrow)) {
            console.warn('WARNING: `arrowElement` must be child of its popper element!');
            return data;
        }

        // arrow depends on keepTogether in order to work
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
            return data;
        }

        var arrowStyle = {};
        var placement = data.placement.split('-')[0];
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var isVertical = ['left', 'right'].indexOf(placement) !== -1;

        var len = isVertical ? 'height' : 'width';
        var side = isVertical ? 'top' : 'left';
        var translate = isVertical ? 'translateY' : 'translateX';
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowSize = getOuterSizes(arrow)[len];

        //
        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
        //

        // top/left side
        if (reference[opSide] - arrowSize < popper[side]) {
            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
        }
        // bottom/right side
        if (reference[side] + arrowSize > popper[opSide]) {
            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
        }

        // compute center of the popper
        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);

        var sideValue = center - popper[side];

        // prevent arrow from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
        arrowStyle[side] = sideValue;
        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

        data.offsets.arrow = arrowStyle;
        data.arrowElement = arrow;

        return data;
    };

    //
    // Helpers
    //

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
        // NOTE: 1 DOM access here
        var _display = element.style.display,
            _visibility = element.style.visibility;
        element.style.display = 'block';element.style.visibility = 'hidden';
        var calcWidthToForceRepaint = element.offsetWidth;

        // original method
        var styles = root.getComputedStyle(element);
        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };

        // reset element styles
        element.style.display = _display;element.style.visibility = _visibility;
        return result;
    }

    /**
     * Get the opposite placement of the given one/
     * @function
     * @ignore
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
        return placement.replace(/left|right|bottom|top/g, function (matched) {
            return hash[matched];
        });
    }

    /**
     * Given the popper offsets, generate an output similar to getBoundingClientRect
     * @function
     * @ignore
     * @argument {Object} popperOffsets
     * @returns {Object} ClientRect like output
     */
    function getPopperClientRect(popperOffsets) {
        var offsets = Object.assign({}, popperOffsets);
        offsets.right = offsets.left + offsets.width;
        offsets.bottom = offsets.top + offsets.height;
        return offsets;
    }

    /**
     * Given an array and the key to find, returns its index
     * @function
     * @ignore
     * @argument {Array} arr
     * @argument keyToFind
     * @returns index or null
     */
    function getArrayKeyIndex(arr, keyToFind) {
        var i = 0,
            key;
        for (key in arr) {
            if (arr[key] === keyToFind) {
                return i;
            }
            i++;
        }
        return null;
    }

    /**
     * Get CSS computed property of the given element
     * @function
     * @ignore
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
        // NOTE: 1 DOM access here
        var css = root.getComputedStyle(element, null);
        return css[property];
    }

    /**
     * Returns the offset parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent;
        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
    }

    /**
     * Returns the scrolling parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {
            return element;
        }

        if (parent === root.document) {
            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
            // greater than 0 and return the proper element
            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
                return root.document.body;
            } else {
                return root.document.documentElement;
            }
        }

        // Firefox want us to check `-x` and `-y` variations as well
        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
            // If the detected scrollParent is body, we perform an additional check on its parentNode
            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
            // fixes issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @function
     * @ignore
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
        if (element === root.document.body) {
            return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
            return true;
        }
        return element.parentNode ? isFixed(element.parentNode) : element;
    }

    /**
     * Set the style to the given popper
     * @function
     * @ignore
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
     */
    function setStyle(element, styles) {
        function is_numeric(n) {
            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
        }
        Object.keys(styles).forEach(function (prop) {
            var unit = '';
            // add unit if the value is numeric and is one of the following
            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
                unit = 'px';
            }
            element.style[prop] = styles[prop] + unit;
        });
    }

    /**
     * Check if the given variable is a function
     * @function
     * @ignore
     * @argument {*} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get the position of the given element, relative to its offset parent
     * @function
     * @ignore
     * @param {Element} element
     * @return {Object} position - Coordinates of the element and its `scrollTop`
     */
    function getOffsetRect(element) {
        var elementRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
            left: element.offsetLeft,
            top: element.offsetTop
        };

        elementRect.right = elementRect.left + elementRect.width;
        elementRect.bottom = elementRect.top + elementRect.height;

        // position
        return elementRect;
    }

    /**
     * Get bounding client rect of given element
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
        var rect = element.getBoundingClientRect();

        // whether the IE version is lower than 11
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;

        // fix ie document bounding top always 0 bug
        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;

        return {
            left: rect.left,
            top: rectTop,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.right - rect.left,
            height: rect.bottom - rectTop
        };
    }

    /**
     * Given an element and one of its parents, return the offset
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @return {Object} rect
     */
    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
        var elementRect = getBoundingClientRect(element);
        var parentRect = getBoundingClientRect(parent);

        if (fixed) {
            var scrollParent = getScrollParent(parent);
            parentRect.top += scrollParent.scrollTop;
            parentRect.bottom += scrollParent.scrollTop;
            parentRect.left += scrollParent.scrollLeft;
            parentRect.right += scrollParent.scrollLeft;
        }

        var rect = {
            top: elementRect.top - parentRect.top,
            left: elementRect.left - parentRect.left,
            bottom: elementRect.top - parentRect.top + elementRect.height,
            right: elementRect.left - parentRect.left + elementRect.width,
            width: elementRect.width,
            height: elementRect.height
        };
        return rect;
    }

    /**
     * Get the prefixed supported property name
     * @function
     * @ignore
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase)
     */
    function getSupportedPropertyName(property) {
        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
            if (typeof root.document.body.style[toCheck] !== 'undefined') {
                return toCheck;
            }
        }
        return null;
    }

    /**
     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
     * objects to a target object. It will return the target object.
     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
     * @function
     * @ignore
     */
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function value(target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }

    return Popper;
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 138);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(139);


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(140);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_checkbox2.default.install = function (Vue) {
  Vue.component(_checkbox2.default.name, _checkbox2.default);
};

exports.default = _checkbox2.default;

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8b1d6_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__ = __webpack_require__(142);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8b1d6_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCheckbox',

  mixins: [_emitter2.default],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElCheckbox',

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent;
          return true;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    }
  },

  props: {
    value: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    border: Boolean,
    size: String
  },

  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-checkbox",class:[
    _vm.border && _vm.checkboxSize ? 'el-checkbox--' + _vm.checkboxSize : '',
    { 'is-disabled': _vm.isDisabled },
    { 'is-bordered': _vm.border },
    { 'is-checked': _vm.isChecked }
  ],attrs:{"role":"checkbox","aria-checked":_vm.indeterminate ? 'mixed': _vm.isChecked,"aria-disabled":_vm.isDisabled,"id":_vm.id}},[_c('span',{staticClass:"el-checkbox__input",class:{
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.isChecked,
      'is-indeterminate': _vm.indeterminate,
      'is-focus': _vm.focus
    },attrs:{"aria-checked":"mixed"}},[_c('span',{staticClass:"el-checkbox__inner"}),(_vm.trueLabel || _vm.falseLabel)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"type":"checkbox","aria-hidden":"true","name":_vm.name,"disabled":_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(_vm.trueLabel):(_vm.falseLabel);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"el-checkbox__original",attrs:{"type":"checkbox","aria-hidden":"true","disabled":_vm.isDisabled,"name":_vm.name},domProps:{"value":_vm.label,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.handleChange],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}})]),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"el-checkbox__label"},[_vm._t("default"),(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 174);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _button = __webpack_require__(176);

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_button2.default.install = function (Vue) {
  Vue.component(_button2.default.name, _button2.default);
};

exports.default = _button2.default;

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b70ef5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(178);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b70ef5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round,
      'is-circle': _vm.circle
    }
  ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(27);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transition = function () {
  function Transition() {
    _classCallCheck(this, Transition);
  }

  Transition.prototype.beforeEnter = function beforeEnter(el) {
    (0, _dom.addClass)(el, 'collapse-transition');
    if (!el.dataset) el.dataset = {};

    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;

    el.style.height = '0';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  };

  Transition.prototype.enter = function enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = '';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }

    el.style.overflow = 'hidden';
  };

  Transition.prototype.afterEnter = function afterEnter(el) {
    // for safari: remove class then reset height is necessary
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
  };

  Transition.prototype.beforeLeave = function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  };

  Transition.prototype.leave = function leave(el) {
    if (el.scrollHeight !== 0) {
      // for safari: add class after set height, or it will jump to zero height suddenly, weired
      (0, _dom.addClass)(el, 'collapse-transition');
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  };

  Transition.prototype.afterLeave = function afterLeave(el) {
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  };

  return Transition;
}();

exports.default = {
  name: 'ElCollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;

    var data = {
      on: new Transition()
    };

    return h('transition', data, children);
  }
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 238);
/******/ })
/************************************************************************/
/******/ ({

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(239);


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _main = __webpack_require__(240);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_main2.default.install = function (Vue) {
  Vue.component(_main2.default.name, _main2.default);
};

exports.default = _main2.default;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(7);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _debounce = __webpack_require__(14);

var _debounce2 = _interopRequireDefault(_debounce);

var _dom = __webpack_require__(2);

var _vdom = __webpack_require__(20);

var _util = __webpack_require__(3);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTooltip',

  mixins: [_vuePopper2.default],

  props: {
    openDelay: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    manual: Boolean,
    effect: {
      type: String,
      default: 'dark'
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    popperClass: String,
    content: String,
    visibleArrow: {
      default: true
    },
    transition: {
      type: String,
      default: 'el-fade-in-linear'
    },
    popperOptions: {
      default: function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      default: true
    },
    hideAfter: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      timeoutPending: null,
      focusing: false
    };
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'el-tooltip-' + (0, _util.generateId)();
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;

    this.popperVM = new _vue2.default({
      data: { node: '' },
      render: function render(h) {
        return this.node;
      }
    }).$mount();

    this.debounceClose = (0, _debounce2.default)(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render(h) {
    var _this2 = this;

    if (this.popperVM) {
      this.popperVM.node = h(
        'transition',
        {
          attrs: {
            name: this.transition
          },
          on: {
            'afterLeave': this.doDestroy
          }
        },
        [h(
          'div',
          {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
          [this.$slots.content || this.content]
        )]
      );
    }

    if (!this.$slots.default || !this.$slots.default.length) return this.$slots.default;

    var vnode = (0, _vdom.getFirstComponentChild)(this.$slots.default);

    if (!vnode) return vnode;

    var data = vnode.data = vnode.data || {};
    data.staticClass = this.concatClass(data.staticClass, 'el-tooltip');

    return vnode;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;
    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', 0);
      (0, _dom.on)(this.referenceElm, 'mouseenter', this.show);
      (0, _dom.on)(this.referenceElm, 'mouseleave', this.hide);
      (0, _dom.on)(this.referenceElm, 'focus', function () {
        if (!_this3.$slots.default || !_this3.$slots.default.length) {
          _this3.handleFocus();
          return;
        }
        var instance = _this3.$slots.default[0].componentInstance;
        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      (0, _dom.on)(this.referenceElm, 'blur', this.handleBlur);
      (0, _dom.on)(this.referenceElm, 'click', this.removeFocusing);
    }
  },

  watch: {
    focusing: function focusing(val) {
      if (val) {
        (0, _dom.addClass)(this.referenceElm, 'focusing');
      } else {
        (0, _dom.removeClass)(this.referenceElm, 'focusing');
      }
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    concatClass: function concatClass(a, b) {
      if (a && a.indexOf(b) > -1) return a;
      return a ? b ? a + ' ' + b : a : b || '';
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);

      if (this.hideAfter > 0) {
        this.timeoutPending = setTimeout(function () {
          _this4.showPopper = false;
        }, this.hideAfter);
      }
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);

      if (this.timeoutPending) {
        clearTimeout(this.timeoutPending);
      }
      this.showPopper = false;

      if (this.disabled) {
        this.doDestroy();
      }
    },
    setExpectedState: function setExpectedState(expectedState) {
      if (expectedState === false) {
        clearTimeout(this.timeoutPending);
      }
      this.expectedState = expectedState;
    }
  },

  destroyed: function destroyed() {
    var reference = this.referenceElm;
    (0, _dom.off)(reference, 'mouseenter', this.show);
    (0, _dom.off)(reference, 'mouseleave', this.hide);
    (0, _dom.off)(reference, 'focus', this.handleFocus);
    (0, _dom.off)(reference, 'blur', this.handleBlur);
    (0, _dom.off)(reference, 'click', this.removeFocusing);
  }
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(96);

/***/ })

/******/ });

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 148);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(149);


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkboxGroup = __webpack_require__(150);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_checkboxGroup2.default.install = function (Vue) {
  Vue.component(_checkboxGroup2.default.name, _checkboxGroup2.default);
};

exports.default = _checkboxGroup2.default;

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376416c7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_group_vue__ = __webpack_require__(152);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376416c7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElCheckboxGroup',

  componentName: 'ElCheckboxGroup',

  mixins: [_emitter2.default],

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    value: {},
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
};

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-checkbox-group",attrs:{"role":"group","aria-label":"checkbox-group"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;
    if (callback) {
      callback.apply(null, arguments);
    }
  };
  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }
  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
};

; /**
   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
   *
   * @param {Vue} instance Vue instance.
   * @param {Function} callback callback of after-leave event
   * @param {Number} speed the speed of transition, default value is 300ms
   * @param {Boolean} once weather bind after-leave once. default value is false.
   */

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 349);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(350);


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _progress = __webpack_require__(351);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_progress2.default.install = function (Vue) {
  Vue.component(_progress2.default.name, _progress2.default);
};

exports.default = _progress2.default;

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddec355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progress_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddec355_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 126
    },
    showText: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      style.backgroundColor = this.color;
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    trackPath: function trackPath() {
      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);

      return 'M 50 50 m 0 -' + radius + ' a ' + radius + ' ' + radius + ' 0 1 1 0 ' + radius * 2 + ' a ' + radius + ' ' + radius + ' 0 1 1 0 -' + radius * 2;
    },
    perimeter: function perimeter() {
      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle: function circlePathStyle() {
      var perimeter = this.perimeter;
      return {
        strokeDasharray: perimeter + 'px,' + perimeter + 'px',
        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret = void 0;
      if (this.color) {
        ret = this.color;
      } else {
        switch (this.status) {
          case 'success':
            ret = '#13ce66';
            break;
          case 'exception':
            ret = '#ff4949';
            break;
          default:
            ret = '#20a0ff';
        }
      }
      return ret;
    },
    iconClass: function iconClass() {
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-cross';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    }
  }
};

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': !_vm.showText,
      'el-progress--text-inside': _vm.textInside,
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px'})},[_c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle)},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(_vm.percentage)+"%")]):_vm._e()])])]):_c('div',{staticClass:"el-progress-circle",style:({height: _vm.width + 'px', width: _vm.width + 'px'})},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('path',{staticClass:"el-progress-circle__track",attrs:{"d":_vm.trackPath,"stroke":"#e5e9f2","stroke-width":_vm.relativeStrokeWidth,"fill":"none"}}),_c('path',{staticClass:"el-progress-circle__path",style:(_vm.circlePathStyle),attrs:{"d":_vm.trackPath,"stroke-linecap":"round","stroke":_vm.stroke,"stroke-width":_vm.relativeStrokeWidth,"fill":"none"}})])]),(_vm.showText && !_vm.textInside)?_c('div',{staticClass:"el-progress__text",style:({fontSize: _vm.progressTextSize + 'px'})},[(!_vm.status)?[_vm._v(_vm._s(_vm.percentage)+"%")]:_c('i',{class:_vm.iconClass})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 158);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(146);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __webpack_require__(92);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159);


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _select = __webpack_require__(160);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_select2.default.install = function (Vue) {
  Vue.component(_select2.default.name, _select2.default);
};

exports.default = _select2.default;

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab76e696_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__ = __webpack_require__(166);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab76e696_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

var _locale = __webpack_require__(5);

var _locale2 = _interopRequireDefault(_locale);

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _selectDropdown = __webpack_require__(162);

var _selectDropdown2 = _interopRequireDefault(_selectDropdown);

var _option = __webpack_require__(35);

var _option2 = _interopRequireDefault(_option);

var _tag = __webpack_require__(25);

var _tag2 = _interopRequireDefault(_tag);

var _scrollbar = __webpack_require__(17);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

var _debounce = __webpack_require__(14);

var _debounce2 = _interopRequireDefault(_debounce);

var _clickoutside = __webpack_require__(10);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _dom = __webpack_require__(2);

var _resizeEvent = __webpack_require__(18);

var _locale3 = __webpack_require__(12);

var _scrollIntoView = __webpack_require__(26);

var _scrollIntoView2 = _interopRequireDefault(_scrollIntoView);

var _util = __webpack_require__(3);

var _navigationMixin = __webpack_require__(165);

var _navigationMixin2 = _interopRequireDefault(_navigationMixin);

var _shared = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  'medium': 36,
  'small': 32,
  'mini': 28
};

exports.default = {
  mixins: [_emitter2.default, _locale2.default, (0, _focus2.default)('reference'), _navigationMixin2.default],

  name: 'ElSelect',

  componentName: 'ElSelect',

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  provide: function provide() {
    return {
      'select': this
    };
  },


  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly: function readonly() {
      // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
      var isIE = !this.$isServer && !isNaN(Number(document.documentMode));
      return !this.filterable || this.multiple || !isIE && !this.visible;
    },
    iconClass: function iconClass() {
      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && !this.multiple && this.value !== undefined && this.value !== '';
      return criteria ? 'circle-close is-show-close' : this.remote && this.filterable ? '' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) return false;
        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('el.select.noMatch');
        }
        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
    }
  },

  components: {
    ElInput: _input2.default,
    ElSelectMenu: _selectDropdown2.default,
    ElOption: _option2.default,
    ElTag: _tag2.default,
    ElScrollbar: _scrollbar2.default
  },

  directives: { Clickoutside: _clickoutside2.default },

  props: {
    name: String,
    id: String,
    value: {
      required: true
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: function _default() {
        return (0, _locale3.t)('el.select.placeholder');
      }
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      menuVisibleOnFocus: false,
      isOnComposition: false,
      isSilentBlur: false
    };
  },


  watch: {
    selectDisabled: function selectDisabled() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.resetInputHeight();
      });
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val) {
      if (this.multiple) {
        this.resetInputHeight();
        if (val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
        if (this.filterable && !this.reserveKeyword) {
          this.query = '';
          this.handleQueryChange(this.query);
        }
      }
      this.setSelected();
      if (this.filterable && !this.multiple) {
        this.inputLength = 20;
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.handleIconHide();
        this.broadcast('ElSelectDropdown', 'destroyPopper');
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
        this.query = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.inputLength = 20;
        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });
        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }
            if (this.filterable) this.query = this.selectedLabel;
          }
        }
      } else {
        this.handleIconShow();
        this.broadcast('ElSelectDropdown', 'updatePopper');
        if (this.filterable) {
          this.query = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.query);
          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }
            this.broadcast('ElInput', 'inputSelect');
          }
        }
      }
      this.$emit('visible-change', val);
    },
    options: function options() {
      var _this4 = this;

      if (this.$isServer) return;
      this.$nextTick(function () {
        _this4.broadcast('ElSelectDropdown', 'updatePopper');
      });
      if (this.multiple) {
        this.resetInputHeight();
      }
      var inputs = this.$el.querySelectorAll('input');
      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },

  methods: {
    handleComposition: function handleComposition(event) {
      var text = event.target.value;
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.handleQueryChange(text);
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !(0, _shared.isKorean)(lastCharacter);
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this5 = this;

      if (this.previousQuery === val || this.isOnComposition) return;
      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
        this.previousQuery = val;
        return;
      }
      this.previousQuery = val;
      this.$nextTick(function () {
        if (_this5.visible) _this5.broadcast('ElSelectDropdown', 'updatePopper');
      });
      this.hoverIndex = -1;
      if (this.multiple && this.filterable) {
        var length = this.$refs.input.value.length * 15 + 20;
        this.inputLength = this.collapseTags ? Math.min(50, length) : length;
        this.managePlaceholder();
        this.resetInputHeight();
      }
      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    handleIconHide: function handleIconHide() {
      var icon = this.$el.querySelector('.el-input__icon');
      if (icon) {
        (0, _dom.removeClass)(icon, 'is-reverse');
      }
    },
    handleIconShow: function handleIconShow() {
      var icon = this.$el.querySelector('.el-input__icon');
      if (icon && !(0, _dom.hasClass)(icon, 'el-icon-circle-close')) {
        (0, _dom.addClass)(icon, 'is-reverse');
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        (0, _scrollIntoView2.default)(menu, target);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this6 = this;

      this.$nextTick(function () {
        return _this6.scrollToOption(_this6.selected);
      });
    },
    emitChange: function emitChange(val) {
      if (!(0, _util.valueEquals)(this.value, val)) {
        this.$emit('change', val);
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    },
    getOption: function getOption(value) {
      var option = void 0;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? (0, _util.getValueByPath)(cachedOption.value, this.valueKey) === (0, _util.getValueByPath)(value, this.valueKey) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var label = !isObject ? value : '';
      var newOption = {
        value: value,
        currentLabel: label
      };
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    setSelected: function setSelected() {
      var _this7 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this7.getOption(value));
        });
      }
      this.selected = result;
      this.$nextTick(function () {
        _this7.resetInputHeight();
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          this.visible = true;
          this.menuVisibleOnFocus = true;
        }
        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    blur: function blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },
    handleBlur: function handleBlur(event) {
      var _this8 = this;

      setTimeout(function () {
        if (_this8.isSilentBlur) {
          _this8.isSilentBlur = false;
        } else {
          _this8.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleIconClick: function handleIconClick(event) {
      if (this.iconClass.indexOf('circle-close') > -1) {
        this.deleteSelected(event);
      }
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
        this.emitChange(value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
      this.inputLength = this.$refs.input.value.length * 15 + 20;
      this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this9 = this;

      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(function () {
        if (!_this9.$refs.reference) return;
        var inputChildNodes = _this9.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this9.$refs.tags;
        var sizeInMap = sizeMap[_this9.selectSize] || 40;
        input.style.height = _this9.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
        if (_this9.visible && _this9.emptyText !== false) {
          _this9.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this10 = this;

      setTimeout(function () {
        if (!_this10.multiple) {
          _this10.hoverIndex = _this10.options.indexOf(_this10.selected);
        } else {
          if (_this10.selected.length > 0) {
            _this10.hoverIndex = Math.min.apply(null, _this10.selected.map(function (item) {
              return _this10.options.indexOf(item);
            }));
          } else {
            _this10.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      var _this11 = this;

      if (this.multiple) {
        var value = this.value.slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }
        this.$emit('input', value);
        this.emitChange(value);
        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }
        if (this.filterable) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
      this.isSilentBlur = byClick;
      this.setSoftFocus();
      if (this.visible) return;
      this.$nextTick(function () {
        _this11.scrollToOption(option);
      });
    },
    setSoftFocus: function setSoftFocus() {
      this.softFocus = true;
      var input = this.$refs.input || this.$refs.reference;
      if (input) {
        input.focus();
      }
    },
    getValueIndex: function getValueIndex() {
      var _this12 = this;

      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments[1];

      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var _ret = function () {
          var valueKey = _this12.valueKey;
          var index = -1;
          arr.some(function (item, i) {
            if ((0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(value, valueKey)) {
              index = i;
              return true;
            }
            return false;
          });
          return {
            v: index
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    },
    toggleMenu: function toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
    selectOption: function selectOption() {
      if (!this.visible) {
        this.toggleMenu();
      } else {
        if (this.options[this.hoverIndex]) {
          this.handleOptionSelect(this.options[this.hoverIndex]);
        }
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      this.$emit('input', '');
      this.emitChange('');
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable && this.query !== this.selectedLabel) {
        this.query = this.selectedLabel;
        this.handleQueryChange(this.query);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1;
      // highlight the created option
      var hasCreated = false;
      for (var i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].created) {
          hasCreated = true;
          this.hoverIndex = i;
          break;
        }
      }
      if (hasCreated) return;
      for (var _i = 0; _i !== this.options.length; ++_i) {
        var option = this.options[_i];
        if (this.query) {
          // highlight first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = _i;
            break;
          }
        } else {
          // highlight currently selected option
          if (option.itemSelected) {
            this.hoverIndex = _i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return (0, _util.getValueByPath)(item.value, this.valueKey);
      }
    }
  },

  created: function created() {
    var _this13 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }
    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.debouncedOnInputChange = (0, _debounce2.default)(this.debounce, function () {
      _this13.onInputChange();
    });

    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
    this.$on('fieldReset', function () {
      _this13.dispatch('ElFormItem', 'el.form.change');
    });
  },
  mounted: function mounted() {
    var _this14 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }
    (0, _resizeEvent.addResizeListener)(this.$el, this.handleResize);
    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }
    this.$nextTick(function () {
      if (_this14.$refs.reference && _this14.$refs.reference.$el) {
        _this14.inputWidth = _this14.$refs.reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) (0, _resizeEvent.removeResizeListener)(this.$el, this.handleResize);
  }
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a24e159_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_dropdown_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a24e159_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_select_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(7);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElSelectDropdown',

  componentName: 'ElSelectDropdown',

  mixins: [_vuePopper2.default],

  props: {
    placement: {
      default: 'bottom-start'
    },

    boundariesPadding: {
      default: 0
    },

    popperOptions: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      minWidth: ''
    };
  },


  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },

  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-select-dropdown el-popper",class:[{ 'is-multiple': _vm.$parent.multiple }, _vm.popperClass],style:({ minWidth: _vm.minWidth })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  data: function data() {
    return {
      hoverOption: -1
    };
  },


  computed: {
    optionsAllDisabled: function optionsAllDisabled() {
      return this.options.filter(function (option) {
        return option.visible;
      }).every(function (option) {
        return option.disabled;
      });
    }
  },

  watch: {
    hoverIndex: function hoverIndex(val) {
      var _this = this;

      if (typeof val === 'number' && val > -1) {
        this.hoverOption = this.options[val] || {};
      }
      this.options.forEach(function (option) {
        option.hover = _this.hoverOption === option;
      });
    }
  },

  methods: {
    navigateOptions: function navigateOptions(direction) {
      var _this2 = this;

      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;
          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }
        } else if (direction === 'prev') {
          this.hoverIndex--;
          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }
        }
        var option = this.options[this.hoverIndex];
        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
          this.navigateOptions(direction);
        }
        this.$nextTick(function () {
          return _this2.scrollToOption(_this2.hoverOption);
        });
      }
    }
  }
};

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleClose),expression:"handleClose"}],staticClass:"el-select",class:[_vm.selectSize ? 'el-select--' + _vm.selectSize : ''],on:{"click":function($event){$event.stopPropagation();_vm.toggleMenu($event)}}},[(_vm.multiple)?_c('div',{ref:"tags",staticClass:"el-select__tags",style:({ 'max-width': _vm.inputWidth - 32 + 'px' })},[(_vm.collapseTags && _vm.selected.length)?_c('span',[_c('el-tag',{attrs:{"closable":!_vm.selectDisabled,"size":_vm.collapseTagSize,"hit":_vm.selected[0].hitState,"type":"info","disable-transitions":""},on:{"close":function($event){_vm.deleteTag($event, _vm.selected[0])}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(_vm.selected[0].currentLabel))])]),(_vm.selected.length > 1)?_c('el-tag',{attrs:{"closable":false,"size":_vm.collapseTagSize,"type":"info","disable-transitions":""}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v("+ "+_vm._s(_vm.selected.length - 1))])]):_vm._e()],1):_vm._e(),(!_vm.collapseTags)?_c('transition-group',{on:{"after-leave":_vm.resetInputHeight}},_vm._l((_vm.selected),function(item){return _c('el-tag',{key:_vm.getValueKey(item),attrs:{"closable":!_vm.selectDisabled,"size":_vm.collapseTagSize,"hit":item.hitState,"type":"info","disable-transitions":""},on:{"close":function($event){_vm.deleteTag($event, item)}}},[_c('span',{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(item.currentLabel))])])})):_vm._e(),(_vm.filterable)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"el-select__input",class:[_vm.selectSize ? ("is-" + _vm.selectSize) : ''],style:({ width: _vm.inputLength + 'px', 'max-width': _vm.inputWidth - 42 + 'px' }),attrs:{"type":"text","disabled":_vm.selectDisabled,"autocomplete":_vm.autoComplete,"debounce":_vm.remote ? 300 : 0},domProps:{"value":(_vm.query)},on:{"focus":_vm.handleFocus,"blur":function($event){_vm.softFocus = false},"click":function($event){$event.stopPropagation();},"keyup":_vm.managePlaceholder,"keydown":[_vm.resetInputState,function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.navigateOptions('next')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.navigateOptions('prev')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.selectOption($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.deletePrevTag($event)}],"compositionstart":_vm.handleComposition,"compositionupdate":_vm.handleComposition,"compositionend":_vm.handleComposition,"input":[function($event){if($event.target.composing){ return; }_vm.query=$event.target.value},function (e) { return _vm.handleQueryChange(e.target.value); }]}}):_vm._e()],1):_vm._e(),_c('el-input',{ref:"reference",class:{ 'is-focus': _vm.visible },attrs:{"type":"text","placeholder":_vm.currentPlaceholder,"name":_vm.name,"id":_vm.id,"auto-complete":_vm.autoComplete,"size":_vm.selectSize,"disabled":_vm.selectDisabled,"readonly":_vm.readonly,"validate-event":false},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur},nativeOn:{"keyup":function($event){_vm.debouncedOnInputChange($event)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.navigateOptions('next')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.navigateOptions('prev')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.selectOption($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm.visible = false},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.visible = false}],"paste":function($event){_vm.debouncedOnInputChange($event)},"mouseenter":function($event){_vm.inputHovering = true},"mouseleave":function($event){_vm.inputHovering = false}},model:{value:(_vm.selectedLabel),callback:function ($$v) {_vm.selectedLabel=$$v},expression:"selectedLabel"}},[_c('i',{class:['el-select__caret', 'el-input__icon', 'el-icon-' + _vm.iconClass],attrs:{"slot":"suffix"},on:{"click":_vm.handleIconClick},slot:"suffix"})]),_c('transition',{attrs:{"name":"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":_vm.doDestroy}},[_c('el-select-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible && _vm.emptyText !== false),expression:"visible && emptyText !== false"}],ref:"popper",attrs:{"append-to-body":_vm.popperAppendToBody}},[_c('el-scrollbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.length > 0 && !_vm.loading),expression:"options.length > 0 && !loading"}],ref:"scrollbar",class:{ 'is-empty': !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0 },attrs:{"tag":"ul","wrap-class":"el-select-dropdown__wrap","view-class":"el-select-dropdown__list"}},[(_vm.showNewOption)?_c('el-option',{attrs:{"value":_vm.query,"created":""}}):_vm._e(),_vm._t("default")],2),(_vm.emptyText &&
          (!_vm.allowCreate || _vm.loading || (_vm.allowCreate && _vm.options.length === 0 )))?_c('p',{staticClass:"el-select-dropdown__empty"},[_vm._v("\n        "+_vm._s(_vm.emptyText)+"\n      ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = __webpack_require__(94);

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __webpack_require__(150);

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = __webpack_require__(151);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__ = __webpack_require__(37);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return (0, _util.getValueByPath)(a, valueKey) === (0, _util.getValueByPath)(b, valueKey);
      }
    },
    contains: function contains() {
      var _this = this;

      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr.indexOf(target) > -1;
      } else {
        var _ret = function () {
          var valueKey = _this.select.valueKey;
          return {
            v: arr.some(function (item) {
              return (0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(target, valueKey);
            })
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      // query 里如果有正则中的特殊字符，需要先将这些字符转义
      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-select-dropdown__item",class:{
    'selected': _vm.itemSelected,
    'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
    'hover': _vm.hover
  },on:{"mouseenter":_vm.hoverItem,"click":function($event){$event.stopPropagation();_vm.selectOptionClick($event)}}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.currentLabel))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(142);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(93);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(96);

/***/ })

/******/ });

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 167);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(168);


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _option = __webpack_require__(35);

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_option2.default.install = function (Vue) {
  Vue.component(_option2.default.name, _option2.default);
};

exports.default = _option2.default;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(35);

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__ = __webpack_require__(37);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_option_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed77bae_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _emitter = __webpack_require__(1);

var _emitter2 = _interopRequireDefault(_emitter);

var _util = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_emitter2.default],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return (0, _util.getValueByPath)(a, valueKey) === (0, _util.getValueByPath)(b, valueKey);
      }
    },
    contains: function contains() {
      var _this = this;

      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr.indexOf(target) > -1;
      } else {
        var _ret = function () {
          var valueKey = _this.select.valueKey;
          return {
            v: arr.some(function (item) {
              return (0, _util.getValueByPath)(item, valueKey) === (0, _util.getValueByPath)(target, valueKey);
            })
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      // query 里如果有正则中的特殊字符，需要先将这些字符转义
      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"el-select-dropdown__item",class:{
    'selected': _vm.itemSelected,
    'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
    'hover': _vm.hover
  },on:{"mouseenter":_vm.hoverItem,"click":function($event){$event.stopPropagation();_vm.selectOptionClick($event)}}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.currentLabel))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 179);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180);


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _buttonGroup = __webpack_require__(181);

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_buttonGroup2.default.install = function (Vue) {
  Vue.component(_buttonGroup2.default.name, _buttonGroup2.default);
};

exports.default = _buttonGroup2.default;

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0216a7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_group_vue__ = __webpack_require__(183);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0216a7_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//

exports.default = {
  name: 'ElButtonGroup'
};

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-button-group"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

/******/ });

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(279);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */



var UserAgent_DEPRECATED = __webpack_require__(280);

var isEventSupported = __webpack_require__(281);


// Reasonable defaults
var PIXEL_STEP  = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel(/*object*/ event) /*object*/ {
  var sX = 0, sY = 0,       // spinX, spinY
      pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail'      in event) { sY = event.detail; }
  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return { spinX  : sX,
           spinY  : sY,
           pixelX : pX,
           pixelY : pY };
}


/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel.getEventType = function() /*string*/ {
  return (UserAgent_DEPRECATED.firefox())
           ? 'DOMMouseScroll'
           : (isEventSupported('wheel'))
               ? 'wheel'
               : 'mousewheel';
};

module.exports = normalizeWheel;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!(/Win64/.exec(uas));

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : (
          agent[5] ? parseFloat(agent[5]) : NaN);
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux   = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function() {
    return _populate() || (_ie_real_version > _ie);
  },


  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function() {
    return _populate() || _firefox;
  },


  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function() {
    return _populate() || _opera;
  },


  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome : function() {
    return _populate() || _chrome;
  },


  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function() {
    return _populate() || _windows;
  },


  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function() {
    return _populate() || _iphone;
  },

  mobile: function() {
    return _populate() || (_iphone || _ipad || _android || _mobile);
  },

  nativeApp: function() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function() {
    return _populate() || _android;
  },

  ipad: function() {
    return _populate() || _ipad;
  }
};

module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(282);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature =
    document.implementation &&
    document.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM ||
      capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

/*jslint evil: true */



var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners:
    canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* Modified from https://github.com/taylorhakes/fecha
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Taylor Hakes
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
(function (main) {
  'use strict';

  /**
   * Parse or format dates
   * @class fecha
   */

  var fecha = {};
  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
  var twoDigits = /\d\d?/;
  var threeDigits = /\d{3}/;
  var fourDigits = /\d{4}/;
  var word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
  var noop = function noop() {};

  function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
  }

  function monthUpdate(arrName) {
    return function (d, v, i18n) {
      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
      if (~index) {
        d.month = index;
      }
    };
  }

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthNamesShort = shorten(monthNames, 3);
  var dayNamesShort = shorten(dayNames, 3);
  fecha.i18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ['am', 'pm'],
    DoFn: function DoFn(D) {
      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
  };

  var formatFlags = {
    D: function D(dateObj) {
      return dateObj.getDay();
    },
    DD: function DD(dateObj) {
      return pad(dateObj.getDay());
    },
    Do: function Do(dateObj, i18n) {
      return i18n.DoFn(dateObj.getDate());
    },
    d: function d(dateObj) {
      return dateObj.getDate();
    },
    dd: function dd(dateObj) {
      return pad(dateObj.getDate());
    },
    ddd: function ddd(dateObj, i18n) {
      return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function dddd(dateObj, i18n) {
      return i18n.dayNames[dateObj.getDay()];
    },
    M: function M(dateObj) {
      return dateObj.getMonth() + 1;
    },
    MM: function MM(dateObj) {
      return pad(dateObj.getMonth() + 1);
    },
    MMM: function MMM(dateObj, i18n) {
      return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function MMMM(dateObj, i18n) {
      return i18n.monthNames[dateObj.getMonth()];
    },
    yy: function yy(dateObj) {
      return String(dateObj.getFullYear()).substr(2);
    },
    yyyy: function yyyy(dateObj) {
      return dateObj.getFullYear();
    },
    h: function h(dateObj) {
      return dateObj.getHours() % 12 || 12;
    },
    hh: function hh(dateObj) {
      return pad(dateObj.getHours() % 12 || 12);
    },
    H: function H(dateObj) {
      return dateObj.getHours();
    },
    HH: function HH(dateObj) {
      return pad(dateObj.getHours());
    },
    m: function m(dateObj) {
      return dateObj.getMinutes();
    },
    mm: function mm(dateObj) {
      return pad(dateObj.getMinutes());
    },
    s: function s(dateObj) {
      return dateObj.getSeconds();
    },
    ss: function ss(dateObj) {
      return pad(dateObj.getSeconds());
    },
    S: function S(dateObj) {
      return Math.round(dateObj.getMilliseconds() / 100);
    },
    SS: function SS(dateObj) {
      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function SSS(dateObj) {
      return pad(dateObj.getMilliseconds(), 3);
    },
    a: function a(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function A(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
    },
    ZZ: function ZZ(dateObj) {
      var o = dateObj.getTimezoneOffset();
      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
  };

  var parseFlags = {
    d: [twoDigits, function (d, v) {
      d.day = v;
    }],
    M: [twoDigits, function (d, v) {
      d.month = v - 1;
    }],
    yy: [twoDigits, function (d, v) {
      var da = new Date(),
          cent = +('' + da.getFullYear()).substr(0, 2);
      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, function (d, v) {
      d.hour = v;
    }],
    m: [twoDigits, function (d, v) {
      d.minute = v;
    }],
    s: [twoDigits, function (d, v) {
      d.second = v;
    }],
    yyyy: [fourDigits, function (d, v) {
      d.year = v;
    }],
    S: [/\d/, function (d, v) {
      d.millisecond = v * 100;
    }],
    SS: [/\d{2}/, function (d, v) {
      d.millisecond = v * 10;
    }],
    SSS: [threeDigits, function (d, v) {
      d.millisecond = v;
    }],
    D: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, function (d, v, i18n) {
      var val = v.toLowerCase();
      if (val === i18n.amPm[0]) {
        d.isPm = false;
      } else if (val === i18n.amPm[1]) {
        d.isPm = true;
      }
    }],
    ZZ: [/[\+\-]\d\d:?\d\d/, function (d, v) {
      var parts = (v + '').match(/([\+\-]|\d\d)/gi),
          minutes;

      if (parts) {
        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    }]
  };
  parseFlags.DD = parseFlags.D;
  parseFlags.dddd = parseFlags.ddd;
  parseFlags.Do = parseFlags.dd = parseFlags.d;
  parseFlags.mm = parseFlags.m;
  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
  parseFlags.MM = parseFlags.M;
  parseFlags.ss = parseFlags.s;
  parseFlags.A = parseFlags.a;

  // Some common format strings
  fecha.masks = {
    'default': 'ddd MMM dd yyyy HH:mm:ss',
    shortDate: 'M/D/yy',
    mediumDate: 'MMM d, yyyy',
    longDate: 'MMMM d, yyyy',
    fullDate: 'dddd, MMMM d, yyyy',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
  };

  /***
   * Format a date
   * @method format
   * @param {Date|number} dateObj
   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
   */
  fecha.format = function (dateObj, mask, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof dateObj === 'number') {
      dateObj = new Date(dateObj);
    }

    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
      throw new Error('Invalid Date in fecha.format');
    }

    mask = fecha.masks[mask] || mask || fecha.masks['default'];

    return mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
    });
  };

  /**
   * Parse a date string into an object, changes - into /
   * @method parse
   * @param {string} dateStr Date string
   * @param {string} format Date parse format
   * @returns {Date|boolean}
   */
  fecha.parse = function (dateStr, format, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof format !== 'string') {
      throw new Error('Invalid format in fecha.parse');
    }

    format = fecha.masks[format] || format;

    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
      return false;
    }

    var isValid = true;
    var dateInfo = {};
    format.replace(token, function ($0) {
      if (parseFlags[$0]) {
        var info = parseFlags[$0];
        var index = dateStr.search(info[0]);
        if (!~index) {
          isValid = false;
        } else {
          dateStr.replace(info[0], function (result) {
            info[1](dateInfo, result, i18n);
            dateStr = dateStr.substr(index + result.length);
            return result;
          });
        }
      }

      return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
    });

    if (!isValid) {
      return false;
    }

    var today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
      dateInfo.hour = +dateInfo.hour + 12;
    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
      dateInfo.hour = 0;
    }

    var date;
    if (dateInfo.timezoneOffset != null) {
      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
    } else {
      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
    }
    return date;
  };

  /* istanbul ignore next */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fecha;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fecha;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    main.fecha = fecha;
  }
})(undefined);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ariaUtils = __webpack_require__(285);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constructor
 * @desc Dialog object providing modal focus management.
 *
 * Assumptions: The element serving as the dialog container is present in the
 * DOM and hidden. The dialog container has role='dialog'.
 *
 * @param dialogId
 *          The ID of the element serving as the dialog container.
 * @param focusAfterClosed
 *          Either the DOM node or the ID of the DOM node to focus when the
 *          dialog closes.
 * @param focusFirst
 *          Optional parameter containing either the DOM node or the ID of the
 *          DOM node to focus when the dialog opens. If not specified, the
 *          first focusable element in the dialog will receive focus.
 */
var aria = aria || {};
var tabEvent;

aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
  var _this = this;

  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
  }

  if (typeof focusAfterClosed === 'string') {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }

  if (typeof focusFirst === 'string') {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }

  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }

  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};

aria.Dialog.prototype.addListeners = function () {
  document.addEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.removeListeners = function () {
  document.removeEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.closeDialog = function () {
  var _this2 = this;

  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function () {
      _this2.focusAfterClosed.focus();
    });
  }
};

aria.Dialog.prototype.trapFocus = function (event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};

exports.default = aria.Dialog;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};

exports.default = aria.Utils;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(307);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(306);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(152);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (str || arr) {
    val = value.length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(7);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      if (value) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(7);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(0);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 118);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(119);


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _inputNumber = __webpack_require__(120);

var _inputNumber2 = _interopRequireDefault(_inputNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_inputNumber2.default.install = function (Vue) {
  Vue.component(_inputNumber2.default.name, _inputNumber2.default);
};

exports.default = _inputNumber2.default;

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d07efb5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__ = __webpack_require__(122);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_number_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d07efb5_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _input = __webpack_require__(6);

var _input2 = _interopRequireDefault(_input);

var _focus = __webpack_require__(19);

var _focus2 = _interopRequireDefault(_focus);

var _repeatClick = __webpack_require__(24);

var _repeatClick2 = _interopRequireDefault(_repeatClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElInputNumber',
  mixins: [(0, _focus2.default)('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: _repeatClick2.default
  },
  components: {
    ElInput: _input2.default
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined && isNaN(newVal)) return;
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    precision: function precision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision;

      return Math.max(getPrecision(value), getPrecision(step));
    },
    controlsAtRight: function controlsAtRight() {
      return this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.precision;
      return parseFloat(parseFloat(Number(num).toFixed(precision)));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.precision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.precision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
      this.$refs.input.setCurrentValue(this.currentValue);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) {
        this.$refs.input.setCurrentValue(this.currentValue);
        return;
      }
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'el-input-number',
    _vm.inputNumberSize ? 'el-input-number--' + _vm.inputNumberSize : '',
    { 'is-disabled': _vm.inputNumberDisabled },
    { 'is-without-controls': !_vm.controls },
    { 'is-controls-right': _vm.controlsAtRight }
  ],on:{"dragstart":function($event){$event.preventDefault();}}},[(_vm.controls)?_c('span',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.decrease),expression:"decrease"}],staticClass:"el-input-number__decrease",class:{'is-disabled': _vm.minDisabled},attrs:{"role":"button"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.decrease($event)}}},[_c('i',{class:("el-icon-" + (_vm.controlsAtRight ? 'arrow-down' : 'minus'))})]):_vm._e(),(_vm.controls)?_c('span',{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:(_vm.increase),expression:"increase"}],staticClass:"el-input-number__increase",class:{'is-disabled': _vm.maxDisabled},attrs:{"role":"button"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.increase($event)}}},[_c('i',{class:("el-icon-" + (_vm.controlsAtRight ? 'arrow-up' : 'plus'))})]):_vm._e(),_c('el-input',{ref:"input",attrs:{"value":_vm.currentValue,"disabled":_vm.inputNumberDisabled,"size":_vm.inputNumberSize,"max":_vm.max,"min":_vm.min,"name":_vm.name,"label":_vm.label},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"change":_vm.handleInputChange},nativeOn:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.increase($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.decrease($event)}]}},[(_vm.$slots.prepend)?_c('template',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),(_vm.$slots.append)?_c('template',{attrs:{"slot":"append"},slot:"append"},[_vm._t("append")],2):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(2);

exports.default = {
  bind: function bind(el, binding, vnode) {
    var interval = null;
    var startTime = void 0;
    var handler = function handler() {
      return vnode.context[binding.expression].apply();
    };
    var clear = function clear() {
      if (new Date() - startTime < 100) {
        handler();
      }
      clearInterval(interval);
      interval = null;
    };

    (0, _dom.on)(el, 'mousedown', function (e) {
      if (e.button !== 0) return;
      startTime = new Date();
      (0, _dom.once)(document, 'mouseup', clear);
      clearInterval(interval);
      interval = setInterval(handler, 100);
    });
  }
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(93);

/***/ })

/******/ });

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      // week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    }
  }
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '確認',
      clear: '清空'
    },
    datepicker: {
      now: '現在',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '確認',
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      startDate: '開始日期',
      startTime: '開始時間',
      endDate: '結束日期',
      endTime: '結束時間',
      prevYear: '前一年',
      nextYear: '後一年',
      prevMonth: '上個月',
      nextMonth: '下個月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加載中',
      noMatch: '無匹配資料',
      noData: '無資料',
      placeholder: '請選擇'
    },
    cascader: {
      noMatch: '無匹配資料',
      loading: '加載中',
      placeholder: '請選擇'
    },
    pagination: {
      goto: '前往',
      pagesize: '項/頁',
      total: '共 {total} 項',
      pageClassifier: '頁'
    },
    messagebox: {
      title: '提示',
      confirm: '確定',
      cancel: '取消',
      error: '輸入的資料不符規定!'
    },
    upload: {
      deleteTip: '按 delete 鍵可刪除',
      delete: '刪除',
      preview: '查看圖片',
      continue: '繼續上傳'
    },
    table: {
      emptyText: '暫無資料',
      confirmFilter: '篩選',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: 'Sum' // to be translated
    },
    tree: {
      emptyText: '暫無資料'
    },
    transfer: {
      noMatch: '無匹配資料',
      noData: '無資料',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    }
  }
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_en_json__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__test_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json__);





/* harmony default export */ __webpack_exports__["a"] = ({
  'en': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__test_en_json___default.a, { _name: 'English' }),
  'zh-CN': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json___default.a, { _name: '简体中文' }),
  'zh-TW': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json___default.a, { _name: '繁體中文' })
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = {"loading":"Loading...","Reset":"Reset","Search":"Search","Confirm Cancel ?":"Confirm Cancel ?","Confirm ?":"Confirm ?","Table display settings":"Table display settings","Check / uncheck to change visibility, drag to change order:":"Check / uncheck to change visibility, drag to change order:","Edit":"Edit","Detail":"Detail","Delete":"Delete","Confirm":"Confirm","Cancel":"Cancel","Select / Unselect All":"Select / Unselect All"}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = {"loading":"加载中...","Reset":"重置","Search":"搜索","Confirm Cancel ?":"要取消吗？","Confirm ?":"确定继续？","Table display settings":"表格显示设置","Check / uncheck to change visibility, drag to change order:":"只有选中的字段可见，拖拽来排列显示顺序：","Edit":"编辑","Detail":"详情","Delete":"删除","Confirm":"确认","Cancel":"取消","Select / Unselect All":"全选 / 取消全选"}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = {"loading":"載入中...","Reset":"重置","Search":"搜尋","Confirm Cancel ?":"要取消嗎？","Confirm ?":"確定繼續？","Table display settings":"表格顯示設置","Check / uncheck to change visibility, drag to change order:":"只有選中的字段可見，拖拽來排列顯示順序：","Edit":"編輯","Detail":"詳情","Delete":"刪除","Confirm":"確認","Cancel":"取消","Select / Unselect All":"全選 / 取消全選"}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(26);


/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    Object(__WEBPACK_IMPORTED_MODULE_0__index__["e" /* subscribeDataChanging */])(this);
    this._subscribing = true;
  },
  beforeDestroy: function beforeDestroy() {
    if (this._subscribing) {
      Object(__WEBPACK_IMPORTED_MODULE_0__index__["f" /* unsubscribeDataChanging */])(this);
      delete this._subscribing;
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remove; });
var remove = function remove(arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(318), __esModule: true };

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(319);
module.exports = __webpack_require__(1).Array.from;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(39);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(49);
var call = __webpack_require__(130);
var isArrayIter = __webpack_require__(131);
var toLength = __webpack_require__(82);
var createProperty = __webpack_require__(320);
var getIterFn = __webpack_require__(87);

$export($export.S + $export.F * !__webpack_require__(136)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(25);
var createDesc = __webpack_require__(47);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_en_json__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__test_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__test_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json__);





/* harmony default export */ __webpack_exports__["a"] = ({
  'en': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__test_en_json___default.a, { _name: 'English' }),
  'zh-CN': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__test_zh_Hans_json___default.a, { _name: '简体中文' }),
  'zh-TW': __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__test_zh_Hant_json___default.a, { _name: '繁體中文' })
});

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {"Create Role":"Create Role","Create User":"Create User","Lists":"Lists","Normal View":"Normal View","Nested View":"Nested View","Parallel View":"Parallel View"}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = {"Create Role":"创建身份","Create User":"创建用户","Lists":"列表视图","Normal View":"普通模式","Nested View":"嵌套资源","Parallel View":"平行资源"}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = {"Create Role":"创建身份","Create User":"創建用戶","Lists":"列表視圖","Normal View":"普通模式","Nested View":"嵌套資源","Parallel View":"平行資源"}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 120,
  title: 'Lists',
  'fa-icon': 'fa-folder',
  children: [{
    id: 121,
    title: 'Normal View',
    url: '/#/role',
    perm_id: 'lists.normal',
    'fa-icon': 'fa-file'
  }, {
    id: 122,
    title: 'Nested View',
    url: '/#/user',
    perm_id: 'lists.nested',
    'fa-icon': 'fa-file'
  }, {
    id: 123,
    title: 'Parallel View',
    url: '/#/item',
    perm_id: 'lists.parallel',
    'fa-icon': 'fa-file'
  }]
}]);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{attrs:{"id":"app"}},[_c('sp-header',{attrs:{"user":_vm.userInfo,"locales":_vm.locales,"logout":_vm.logout}},[_c('span',{staticClass:"sp-logo",attrs:{"slot":"logo"},slot:"logo"},[_c('div',[_vm._v(_vm._s(_vm.$i18n('Acribus')))])])]),_vm._v(" "),_c('sp-menu',{staticClass:"sp-left-side",attrs:{"data":_vm.menuData}}),_vm._v(" "),_c('div',{staticClass:"sp-right-side"},[_c('article',[_c('sp-breadcrumb',{attrs:{"data":_vm.menuData}}),_vm._v(" "),_c('router-view')],1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_role__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_item__ = __webpack_require__(352);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    role: __WEBPACK_IMPORTED_MODULE_3__modules_role__["a" /* default */],
    item: __WEBPACK_IMPORTED_MODULE_4__modules_item__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_request__ = __webpack_require__(64);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__["a" /* default */]('user', new __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__api_request__["a" /* default */], {
  list: '/api/user/list',
  one: '/api/user/details',
  add: '/api/user/add',
  update: '/api/user/modify'
})));

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(331), __esModule: true };

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(332);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperty: __webpack_require__(25).f });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var bind = __webpack_require__(158);
var Axios = __webpack_require__(335);
var defaults = __webpack_require__(101);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(162);
axios.CancelToken = __webpack_require__(349);
axios.isCancel = __webpack_require__(161);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(350);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(101);
var utils = __webpack_require__(11);
var InterceptorManager = __webpack_require__(344);
var dispatchRequest = __webpack_require__(345);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(160);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var transformData = __webpack_require__(346);
var isCancel = __webpack_require__(161);
var defaults = __webpack_require__(101);
var isAbsoluteURL = __webpack_require__(347);
var combineURLs = __webpack_require__(348);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(162);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_request__ = __webpack_require__(64);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__["a" /* default */]('role', new __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__api_request__["a" /* default */], {
  list: '/api/role/list',
  one: '/api/role/details',
  add: '/api/role/add',
  update: '/api/role/modify'
})));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_request__ = __webpack_require__(64);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__packages_helper_module_index__["a" /* default */]('item', new __WEBPACK_IMPORTED_MODULE_1__packages_helper_api_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__api_request__["a" /* default */], {
  list: '/api/item/list',
  one: '/api/item/details',
  add: '/api/item/add',
  update: '/api/item/modify'
})));

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lists__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__404__ = __webpack_require__(469);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__lists__["a" /* default */].routes), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__404__["a" /* default */].routes));
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ routes: routes });

router.afterEach(function (to, from) {
  var title = to.meta.title;
  document.title = title;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_lists_normal_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_lists_nested_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_lists_parallel_js__ = __webpack_require__(468);
/**
 * Created by fjywan on 2018/3/16.
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  routes: [{
    path: '/role/:view?/:from?',
    component: __WEBPACK_IMPORTED_MODULE_0__views_lists_normal_js__["a" /* default */],
    meta: {
      title: 'Normal View'
    }
  }, {
    path: '/user/:view?/:from?',
    component: __WEBPACK_IMPORTED_MODULE_1__views_lists_nested_js__["a" /* default */],
    meta: {
      title: 'Nested View'
    }
  }, {
    path: '/item/:view?/:from?',
    component: __WEBPACK_IMPORTED_MODULE_2__views_lists_parallel_js__["a" /* default */],
    meta: {
      title: 'Parallel View'
    }
  }]
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_creator_index__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_valueMap__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_renderStatus__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_helper_resource__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_constant__ = __webpack_require__(21);








/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__packages_creator_index__["a" /* default */])({
  name: 'Normal View',
  mode: __WEBPACK_IMPORTED_MODULE_6__packages_constant__["a" /* MODE */].EDIT_IN_TABLE,
  data: new __WEBPACK_IMPORTED_MODULE_5__packages_helper_resource__["a" /* default */]('role'),
  schema: [new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Role ID', 'role_id', false, {
    editable: false,
    asFilter: true,
    render: function render(value, row) {
      return row['id'];
    }
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Role Name', 'name', true), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Select('Status', 'status', [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__helper_valueMap__["a" /* ROLE */].STATUS.map(function (item, index) {
    return {
      label: item,
      value: index
    };
  }))), true, {
    asFilter: true,
    render: function render(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helper_renderStatus__["a" /* default */])({
        type: __WEBPACK_IMPORTED_MODULE_3__helper_valueMap__["a" /* ROLE */].STATUS_CLASS[value],
        content: __WEBPACK_IMPORTED_MODULE_3__helper_valueMap__["a" /* ROLE */].STATUS[value]
      });
    }
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Datetime('Create Time', 'ctime', false, {
    editable: false
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Tree('Permission', 'permission_list', function (state) {
    return state.user.permissionTree;
  }, true, {
    editable: true,
    inTable: false,
    asFilter: false
  })],
  actions: ['edit'],
  hooks: [{
    label: 'test',
    handler: function handler($router, $route) {}
  }],
  options: {
    columnEditable: true
  }
}));

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchedComponentsMixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(21);




var defaultViewKey = 'view';
var defaultFromKey = 'from';
/**
 * 为 self 附加属性 matchedComponents{array} 包含根据路由参数匹配到的当前页面应该渲染的 components
 *
 * 默认路由配置为：{ path: '/params/:view?' }
 * 如果嵌套资源 默认路由配置为：{ path: '/params/:view?/:from?' }
 * @param self
 * @param options
 */
function matchedComponentsMixin(self, options) {
  var matchedView = void 0;
  var viewKey = options.route && options.route.key ? options.route.key : defaultViewKey;
  var routeViewParam = self.$route.params[viewKey];

  //默认主资源dialog模式
  !options.mode && (options.mode = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG);

  if (!routeViewParam) {
    self.matchedComponents = ['list'];
    return;
  }

  // viewMap: 路由参数映射到一个具体的component （对于具体返回的components还要根据mode 和 resourceType具体决定）
  var viewMap = generateDefaultResourceViewMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN, '', options.mode);

  if (options.route && options.route.map) {
    viewMap = mergeRouteMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN, viewMap, options.route.map);
  }

  // 构建viewMap根据声明的嵌套资源和平行资源 补充defaultViewMap
  // 嵌套资源
  if (options.nestedResource && Array.isArray(options.nestedResource)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(options.nestedResource), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var resource = _step.value;

        //默认嵌套资源in table模式
        !resource.mode && (resource.mode = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_TABLE);
        var name = resource.data.name;
        var resourceViewMap = generateDefaultResourceViewMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].NESTED, name, resource.mode);

        if (resource.route && resource.route.map) {
          resourceViewMap = mergeRouteMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].NESTED, resourceViewMap, resource.route.map, name);
        }

        viewMap = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, viewMap, resourceViewMap);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  // 平行资源
  if (options.parallelResource && Array.isArray(options.parallelResource)) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(options.parallelResource), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _resource = _step2.value;

        //默认平行资源资源dialog模式
        !_resource.mode && (_resource.mode = __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_TABLE);
        var _name = _resource.data.name;
        var _resourceViewMap = generateDefaultResourceViewMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].PARALLEL, _name, _resource.mode);

        if (_resource.route && _resource.route.map) {
          _resourceViewMap = mergeRouteMap(__WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].PARALLEL, _resourceViewMap, _resource.route.map, _name);
        }

        viewMap = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, viewMap, _resourceViewMap);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  matchedView = viewMap[routeViewParam];

  // 根据mode 和 资源种类 来决定渲染哪些组件
  // 如果没有匹配到 直接返回主资源list
  if (!matchedView) {
    self.matchedComponents = ['list'];
    return;
  }

  if (matchedView.type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN) {
    switch (matchedView.mode) {
      case __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG:
        self.matchedComponents = ['list', matchedView.name];
        return;
      case __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE:
        self.matchedComponents = [matchedView.name];
        return;
      default:
        self.matchedComponents = ['list'];
        return;
    }
  }

  if (matchedView.type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].NESTED) {
    // 如果存在嵌套资源，父资源无法使用 EDIT_IN_TABLE
    if (options.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_TABLE) {
      throw new Error('mode error: not support MODE:EDIT_IN_TABLE for parent resource while nested resource exist');
    }

    //子资源无法使用 EDIT_IN_NEW_PAGE（会失去页面状态）
    if (matchedView.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE) {
      throw new Error('mode error: not support MODE:EDIT_IN_NEW_PAGE for nested resource');
    }

    //主、子资源不能同时为 EDIT_IN_DIALOG（不能嵌套弹窗）
    if (options.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG && matchedView.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG) {
      throw new Error('mode error: parent and children resource can\'t be EDIT_IN_DIALOG at the same time');
    }

    var from = self.$route.params[defaultFromKey];

    // 如果来自主资源详情、匹配到的嵌套资源无效，直接返回主资源detail
    if (from === 'detail') {
      self.matchedComponents = ['detail'];
      return;
    }

    if (matchedView.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_TABLE) {
      self.matchedComponents = [from];
      return;
    }

    if (['add', 'edit', 'list'].includes(from)) {
      self.matchedComponents = [from, matchedView.name];
      return;
    }

    // 如果没有来自主资源信息、匹配到的嵌套资源无效，直接返回主资源list
    if (!from) {
      console.warn(matchedView.name + ' not validate while from is null');
    }
    self.matchedComponents = ['list'];
    return;
  }

  if (matchedView.type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].PARALLEL) {
    if (matchedView.mode === __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG) {
      throw new Error('mode error: not support MODE:EDIT_IN_DIALOG for parallel resource');
    }
    self.matchedComponents = ['list', matchedView.name];
    return;
  }
}

function generateDefaultResourceViewMap(type, name, mode) {
  var _ref2;

  if (type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN) {
    return {
      detail: {
        type: __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN,
        name: 'detail',
        mode: mode || __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG
      },
      edit: {
        type: __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN,
        name: 'edit',
        mode: mode || __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG
      },
      add: {
        type: __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN,
        name: 'add',
        mode: mode || __WEBPACK_IMPORTED_MODULE_3__constant__["a" /* MODE */].EDIT_IN_DIALOG
      }
    };
  }

  if (type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].PARALLEL) {
    var _ref;

    return _ref = {}, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref, '' + name, {
      type: type,
      name: '' + name,
      mode: mode
    }), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref, name + 'Edit', {
      type: type,
      name: name + 'Edit',
      mode: mode
    }), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref, name + 'Add', {
      type: type,
      name: name + 'Add',
      mode: mode
    }), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref, name + 'Detail', {
      type: type,
      name: name + 'Detail',
      mode: mode
    }), _ref;
  }

  // 嵌套资源没有列表，列表放在主资源的添加或编辑页面
  return _ref2 = {}, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref2, name + 'Edit', {
    type: type,
    name: name + 'Edit',
    mode: mode
  }), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref2, name + 'Add', {
    type: type,
    name: name + 'Add',
    mode: mode
  }), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_ref2, name + 'Detail', {
    type: type,
    name: name + 'Detail',
    mode: mode
  }), _ref2;
}

function mergeRouteMap(type, viewMap, routeMap, name) {
  if (type === __WEBPACK_IMPORTED_MODULE_3__constant__["d" /* resourceType */].MAIN) {
    routeMap.detail && (viewMap[routeMap.detail] = viewMap.detail);
    routeMap.edit && (viewMap[routeMap.edit] = viewMap.edit);
    routeMap.add && (viewMap[routeMap.add] = viewMap.add);
  } else {
    routeMap[name] && (viewMap[routeMap[name]] = viewMap[name]);
    routeMap[name + 'Edit'] && (viewMap[routeMap[name + 'Edit']] = viewMap[name + 'Edit']);
    routeMap[name + 'Add'] && (viewMap[routeMap[name + 'Add']] = viewMap[name + 'Add']);
    routeMap[name + 'Detail'] && (viewMap[routeMap[name + 'Detail']] = viewMap[name + 'Detail']);
  }
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateComponent */
/* harmony export (immutable) */ __webpack_exports__["a"] = ParallelListViewFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListView_list__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListView_add_pageAdd__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListView_add_embedAdd__ = __webpack_require__(73);






/***
 * ParallelListFactory 接受的 option 为 parallelResource
 * {
 *  route: {
 *    map: {
 *      路由到资源名的映射  如果路由和资源名相同可不写
 *    }
 *  }
 *  ... 和ListViewFactory相同的字段
 *
 *  parallelResource: [
 *    {
 *      ParallelListFactory负责这部分字段的处理
 *    }
 *  ...
 *  ]
 * }
 * @param option: parallelResource
 * @returns {*}
 * @constructor
 */





function generateComponent(type, option) {
  return {
    name: 'ParallelListView',
    render: function render(h) {
      var _this = this;

      var resChild = null;
      var Add = null;
      switch (option.mode) {
        case __WEBPACK_IMPORTED_MODULE_6__constant__["a" /* MODE */].EDIT_IN_DIALOG:
          throw new Error('mode error: not support MODE:EDIT_IN_DIALOG for parallel resource');
          break;
        case __WEBPACK_IMPORTED_MODULE_6__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE:
          Add = __WEBPACK_IMPORTED_MODULE_7__ListView_add_pageAdd__["a" /* default */];
          break;
        case __WEBPACK_IMPORTED_MODULE_6__constant__["a" /* MODE */].EDIT_IN_TABLE:
          Add = __WEBPACK_IMPORTED_MODULE_8__ListView_add_embedAdd__["a" /* default */];
          break;
      }
      switch (type) {
        case 'list':
          resChild = h(__WEBPACK_IMPORTED_MODULE_5__ListView_list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            'class': 'list-wrapper',
            attrs: { resourceType: 'parallel',
              mode: option.mode,
              data: option.data,
              schema: option.schema,
              actions: option.actions,
              hooks: option.hooks,
              options: option.options
            }
          }, {
            on: {
              'triggerSearch': function triggerSearch($event) {
                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  attrs[_key - 1] = arguments[_key];
                }

                (function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(params) {
                    var loadingInstance;
                    return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            loadingInstance = _this.$loading({ target: '.list-wrapper' });
                            _context.next = 3;
                            return option.data.fetch.list(_this.$store, params);

                          case 3:
                            loadingInstance.close();

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  attrs[_key2 - 1] = arguments[_key2];
                }

                (function (id) {
                  return option.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              },
              'triggerUpdate': function triggerUpdate($event) {
                for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                  attrs[_key3 - 1] = arguments[_key3];
                }

                (function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
                    return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return option.data.update(_this.$store, params.data);

                          case 2:
                            params.cb && params.cb();

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'triggerDelete': function triggerDelete($event) {
                for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                  attrs[_key4 - 1] = arguments[_key4];
                }

                (function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
                    return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return configs.data.delete(_this.$store, params.data);

                          case 2:
                            params.cb && params.cb();

                          case 3:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                })().apply(undefined, [$event].concat(attrs));
              },
              'addHandle': function addHandle($event) {
                for (var _len5 = arguments.length, attrs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  attrs[_key5 - 1] = arguments[_key5];
                }

                _this.addHandler.apply(_this, [$event].concat(attrs));
              },
              'editHandle': function editHandle($event) {
                for (var _len6 = arguments.length, attrs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                  attrs[_key6 - 1] = arguments[_key6];
                }

                _this.editHandler.apply(_this, [$event].concat(attrs));
              },
              'detailHandle': function detailHandle($event) {
                for (var _len7 = arguments.length, attrs = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                  attrs[_key7 - 1] = arguments[_key7];
                }

                _this.detailHandler.apply(_this, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'add':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: option.schema,
              data: option.data
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len8 = arguments.length, attrs = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
                  attrs[_key8 - 1] = arguments[_key8];
                }

                (function (id) {
                  return option.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'edit':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: option.schema,
              data: option.data,
              model: option.data.provider.one(this.$store.state)
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len9 = arguments.length, attrs = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
                  attrs[_key9 - 1] = arguments[_key9];
                }

                (function (id) {
                  return option.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'detail':
          resChild = h(Add, __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: {
              schema: option.schema,
              data: option.data,
              model: option.data.provider.one(this.$store.state),
              isDetail: true
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len10 = arguments.length, attrs = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
                  attrs[_key10 - 1] = arguments[_key10];
                }

                (function (id) {
                  return option.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
      }
      return h(
        'el-dialog',
        __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
          attrs: {
            title: this.$i18n(option.data.resourceName),
            width: '80%',
            visible: true,
            beforeClose: this.cancel
          }
        }, {
          on: {
            'before-close': function beforeClose($event) {
              for (var _len11 = arguments.length, attrs = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
                attrs[_key11 - 1] = arguments[_key11];
              }

              (function (val) {
                return console.log('before-close', val);
              }).apply(undefined, [$event].concat(attrs));
            }
          }
        }]),
        [resChild]
      );
    },

    data: function data() {
      return {
        cancelText: this.$i18n('Confirm Cancel ?'),
        confirmText: this.$i18n('Confirm ?'),
        confirming: false
      };
    },
    methods: {
      cancel: function cancel() {
        var _this2 = this;

        this.$confirm(this.cancelText).then(function () {
          return _this2.$router.push(_this2.$route.path.replace(/\/[^/]*?$/, ''));
        }).catch(function () {});
      },
      addHandler: function addHandler() {
        this.$router.push(this.$route.path + 'Add');
      },
      editHandler: function editHandler(query) {
        this.$router.push({
          path: this.$route.path + 'Edit',
          query: query
        });
      },
      detailHandler: function detailHandler(query) {
        this.$router.push({
          path: this.$route.path + 'Detail',
          query: query
        });
      }
    },
    created: function created() {
      this.$emit('triggerSearch');
    }
  };
}

function ParallelListViewFactory(resource) {
  var parallelResource = Array.isArray(resource) ? resource : [];
  var parallelComponents = {};
  parallelResource.forEach(function (item) {
    var _Object$assign2;

    parallelComponents = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, parallelComponents, (_Object$assign2 = {}, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_Object$assign2, '' + item.data.name, generateComponent('list', item)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_Object$assign2, item.data.name + 'Add', generateComponent('add', item)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_Object$assign2, item.data.name + 'Edit', generateComponent('edit', item)), __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()(_Object$assign2, item.data.name + 'Detail', generateComponent('detail', item)), _Object$assign2));
  });
  return parallelComponents;
}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(360);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(361),
    arrayEach = __webpack_require__(391),
    assignValue = __webpack_require__(167),
    baseAssign = __webpack_require__(393),
    baseAssignIn = __webpack_require__(403),
    cloneBuffer = __webpack_require__(406),
    copyArray = __webpack_require__(407),
    copySymbols = __webpack_require__(408),
    copySymbolsIn = __webpack_require__(410),
    getAllKeys = __webpack_require__(411),
    getAllKeysIn = __webpack_require__(412),
    getTag = __webpack_require__(112),
    initCloneArray = __webpack_require__(417),
    initCloneByTag = __webpack_require__(418),
    initCloneObject = __webpack_require__(424),
    isArray = __webpack_require__(106),
    isBuffer = __webpack_require__(170),
    isMap = __webpack_require__(426),
    isObject = __webpack_require__(53),
    isSet = __webpack_require__(428),
    keys = __webpack_require__(105);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66),
    stackClear = __webpack_require__(367),
    stackDelete = __webpack_require__(368),
    stackGet = __webpack_require__(369),
    stackHas = __webpack_require__(370),
    stackSet = __webpack_require__(371);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(67);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(66),
    Map = __webpack_require__(103),
    MapCache = __webpack_require__(378);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(164),
    isMasked = __webpack_require__(375),
    isObject = __webpack_require__(53),
    toSource = __webpack_require__(166);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(376);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(379),
    mapCacheDelete = __webpack_require__(386),
    mapCacheGet = __webpack_require__(388),
    mapCacheHas = __webpack_require__(389),
    mapCacheSet = __webpack_require__(390);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(380),
    ListCache = __webpack_require__(66),
    Map = __webpack_require__(103);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(381),
    hashDelete = __webpack_require__(382),
    hashGet = __webpack_require__(383),
    hashHas = __webpack_require__(384),
    hashSet = __webpack_require__(385);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(70);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(70);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(70);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(70);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(71),
    keys = __webpack_require__(105);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(396),
    isObjectLike = __webpack_require__(54);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(400),
    baseUnary = __webpack_require__(108),
    nodeUtil = __webpack_require__(109);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(68),
    isLength = __webpack_require__(171),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(110),
    nativeKeys = __webpack_require__(402);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(172);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(71),
    keysIn = __webpack_require__(174);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53),
    isPrototype = __webpack_require__(110),
    nativeKeysIn = __webpack_require__(405);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 405 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(22);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(71),
    getSymbols = __webpack_require__(111);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(71),
    getSymbolsIn = __webpack_require__(176);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(179),
    getSymbols = __webpack_require__(111),
    keys = __webpack_require__(105);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(179),
    getSymbolsIn = __webpack_require__(176),
    keysIn = __webpack_require__(174);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(36),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(113),
    cloneDataView = __webpack_require__(420),
    cloneRegExp = __webpack_require__(421),
    cloneSymbol = __webpack_require__(422),
    cloneTypedArray = __webpack_require__(423);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(113);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(104);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(113);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(425),
    getPrototype = __webpack_require__(178),
    isPrototype = __webpack_require__(110);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(427),
    baseUnary = __webpack_require__(108),
    nodeUtil = __webpack_require__(109);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(429),
    baseUnary = __webpack_require__(108),
    nodeUtil = __webpack_require__(109);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(112),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"placeholder":_vm.placeholder,"size":_vm.size,"clearable":_vm.clearable,"multiple":_vm.multiple,"disabled":_vm.disabled,"filterable":_vm.filterable},on:{"remove-tag":function (tag) { return _vm.$emit('removeTag', tag); },"change":function($event){_vm.$emit('input', _vm.actualValue)}},model:{value:(_vm.actualValue),callback:function ($$v) {_vm.actualValue=$$v},expression:"actualValue"}},_vm._l((_vm.actualItems),function(item){return _c('el-option',{key:item.value,ref:item.label,refInFor:true,attrs:{"label":_vm.$i18n(item.label),"value":item.value,"disabled":item.disabled}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);


function buildGraph(fields) {
  var g = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;

      var deps = [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(field.options.deps || [null]));
      deps.pop();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(deps), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var dep = _step2.value;

          if (g[dep]) {
            g[dep].push(field.key);
          } else {
            g[dep] = [field.key];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return g;
}

function getInDegree(g, start) {
  var q = [start];
  var v = {};
  var result = {};
  while (q.length) {
    var head = q.shift();
    if (g[head]) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(g[head]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var t = _step3.value;

          result[t] = (result[t] || 0) + 1;
          if (!v[t]) {
            q.push(t);
            v[t] = true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }
  return result;
}

function topSort(g, inDegree, start) {
  var q = [start];
  var v = {};
  var result = [];
  while (q.length) {
    var head = q.shift();
    if (g[head]) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(g[head]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var t = _step4.value;

          if (!v[t]) {
            if (inDegree[t] > 0) {
              --inDegree[t];
            }
            if (!inDegree[t]) {
              result.push(t);
              q.push(t);
              v[t] = true;
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (function (fields) {
  var g = buildGraph(fields);
  var result = {};
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(fields), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var field = _step5.value;

      var inDegree = getInDegree(g, field.key);
      result[field.key] = topSort(g, inDegree, field.key);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return result;
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  if (data && typeof data === 'string') {
    return {
      placeholder: i18n(data)
    };
  }
  if (Array.isArray(data) && data.length === 2) {
    return {
      startPlaceholder: i18n(data[0]),
      endPlaceholder: i18n(data[1])
    };
  }
  return {};
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_safeGet__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__creator_common_vnode_table__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__creator_common_vnode_pagination_js__ = __webpack_require__(186);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpTableSelect',
  render: function render(h) {
    var _this = this;

    var tableChildren = [];
    if (!this.hideSelection) {
      tableChildren.push(h('el-table-column', {
        props: {
          type: 'selection',
          width: '55',
          'reserve-selection': true,
          selectable: this.filterSelectable
        }
      }));
    }
    tableChildren.push(Object(__WEBPACK_IMPORTED_MODULE_2__creator_common_vnode_table__["b" /* generateTableColumn */])(this, h));
    var paginationChild = this.hidePagination ? null : Object(__WEBPACK_IMPORTED_MODULE_3__creator_common_vnode_pagination_js__["a" /* default */])(this, h);
    return h('div', [h(
      'el-table',
      __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
        attrs: {
          data: this.tableData.data,

          rowKey: function rowKey(row) {
            return row[_this.tableSelectKey];
          },

          border: true,
          stripe: true
        },
        ref: 'multipleTable' }, {
        on: {
          'selection-change': function selectionChange($event) {
            for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              attrs[_key - 1] = arguments[_key];
            }

            _this.handleSelectionChange.apply(_this, [$event].concat(attrs));
          }
        }
      }]),
      [tableChildren]
    ), paginationChild]);
  },

  props: {
    'items': {
      required: true
    },
    'tableSchema': {
      type: Array
    },
    'tableSelectKey': {
      default: 'id'
    },
    'beforeCreateOptions': {
      type: Function
    },
    'hidePagination': {
      type: Boolean,
      default: false
    },
    'getTableList': {
      type: Function
    },
    'filterSelectable': {
      type: Function
    },
    'hideSelection': {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      pageSize: 10,
      pageSizes: [10, 20],
      paginationLayout: 'total, sizes, prev, pager, next',
      currentPage: 1
    };
  },

  watch: {
    items: function items(_items) {
      this.updateItems(_items);
    }
  },
  created: function created() {
    var _this2 = this;

    if (typeof this.items === 'string') {
      try {
        this.$watch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_1__utils_safeGet__["a" /* safeGet */])(_this2.$store.state, _this2.items);
        }, function (val) {
          var options = _this2.getTableList && typeof _this2.getTableList === 'function' ? _this2.getTableList(val, _this2.pageSize, _this2.currentPage) : val;
          _this2.updateItems(options);
        }, {
          immediate: true
        });
      } catch (e) {
        console.log(e);
        throw new Error('bad select options');
      }
    } else {
      this.updateItems(this.items);
    }
  },

  methods: {
    updateItems: function updateItems(items) {
      var _this3 = this;

      // console.log('updateItems', items)
      if (Object.prototype.toString.call(items) === '[object Promise]') {
        this.tableData = {
          data: [],
          totel: 0
        };
        items.then(function (data) {
          _this3.tableData = data;
        }).catch(function () {});
      } else if (typeof items === 'function') {
        this.tableData = items(this.$store.state);
      } else {
        this.tableData = items;
      }
    },
    handleSizeChange: function handleSizeChange(size) {
      this.getTableList(Object(__WEBPACK_IMPORTED_MODULE_1__utils_safeGet__["a" /* safeGet */])(this.$store.state, this.items), size, 1);
      this.currentPage = 1;
      this.pageSize = size;
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.getTableList(Object(__WEBPACK_IMPORTED_MODULE_1__utils_safeGet__["a" /* safeGet */])(this.$store.state, this.items), this.pageSize, page);
      this.currentPage = page;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.$emit('selectionChange', val);
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props__);



/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    var _this = this;

    return h(
      "el-dialog",
      {
        attrs: {
          title: this.$i18n('Table display settings'),
          visible: true,
          width: "80%",
          beforeClose: this.handleCancel
        }
      },
      [this.tempSchema ? h("div", [h("el-radio", __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
        attrs: {
          label: "sku_location",
          value: this.tempSchema
        }
      }, {
        on: {
          "input": function input($event) {
            for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              attrs[_key - 1] = arguments[_key];
            }

            (function (value) {
              return _this.$emit('updateTempSchema', value);
            }).apply(undefined, [$event].concat(attrs));
          }
        }
      }])), h("el-radio", __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
        attrs: {
          label: "uid",
          value: this.tempSchema
        }
      }, {
        on: {
          "input": function input($event) {
            for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              attrs[_key2 - 1] = arguments[_key2];
            }

            (function (value) {
              return _this.$emit('updateTempSchema', value);
            }).apply(undefined, [$event].concat(attrs));
          }
        }
      }]))]) : null, h(
        "p",
        { style: { marginTop: 0 } },
        [this.$i18n('Check / uncheck to change visibility, drag to change order:')]
      ), h("el-tree", __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
        ref: "tree",
        attrs: { data: [].concat(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.schema)),
          nodeKey: "id",
          defaultCheckedKeys: this.schema.filter(function (t) {
            return t.visible;
          }).map(function (t) {
            return t.id;
          }),
          defaultExpandAll: true,
          draggable: true,
          showCheckbox: true
        }
      }, {
        on: {
          "node-drop": function nodeDrop($event) {
            for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              attrs[_key3 - 1] = arguments[_key3];
            }

            _this.handleDrop.apply(_this, [$event].concat(attrs));
          }
        }
      }])), h(
        "div",
        { slot: "footer" },
        [h(
          "el-button",
          __WEBPACK_IMPORTED_MODULE_2_babel_helper_vue_jsx_merge_props___default()([{
            attrs: { type: "primary" }
          }, {
            on: {
              "click": function click($event) {
                for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                  attrs[_key4 - 1] = arguments[_key4];
                }

                _this.confirm.apply(_this, [$event].concat(attrs));
              }
            }
          }]),
          [this.$i18n('Confirm')]
        ), h(
          "el-button",
          {
            on: {
              "click": function click($event) {
                for (var _len5 = arguments.length, attrs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                  attrs[_key5 - 1] = arguments[_key5];
                }

                _this.handleCancel.apply(_this, [$event].concat(attrs));
              }
            }
          },
          [this.$i18n('Cancel')]
        )]
      )]
    );
  },
  props: ['schema', 'handleConfirm', 'handleCancel', 'tempSchema'],
  methods: {
    handleDrop: function handleDrop(draggingNode, droppedNode, position) {
      var checked = draggingNode.checked;
      if (position === 'inner' && droppedNode) {
        this.$refs.tree.remove(droppedNode.childNodes[0]);
        this.$refs.tree.insertAfter(draggingNode.data, droppedNode);
      }
      if (checked) {
        this.$refs.tree.setChecked(draggingNode.data, true);
      }
    },
    confirm: function confirm() {
      var _this2 = this;

      var o = {};
      var checkedKeys = this.$refs.tree.getCheckedKeys();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(checkedKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var t = _step.value;

          o[t] = true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var keys = this.$refs.tree.data.map(function (t) {
        return {
          id: t.id,
          label: _this2.$i18n(t.label),
          visible: o[t.id]
        };
      });
      if (this.tempSchema) {
        keys.push({
          id: 'level',
          level: this.tempSchema
        });
      }
      this.handleConfirm(keys);
      this.handleCancel();
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date__ = __webpack_require__(436);



var formatParams = function formatParams() {
  var searchFormData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var params = {};
  var keys = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default()(searchFormData);

  keys.forEach(function (key) {
    var value = searchFormData[key];

    if (typeof value === 'string') value = value.trim();
    if (value !== undefined && value !== '' && value !== null) {
      params[key] = value;
    }
    if (value instanceof Date) {
      params[key] = Object(__WEBPACK_IMPORTED_MODULE_1__date__["a" /* date2ts */])(value);
    }
    if (Array.isArray(value) && value.reduce(function (prev, cur) {
      return prev && cur instanceof Date;
    }, true)) {
      params[key] = Object(__WEBPACK_IMPORTED_MODULE_1__date__["a" /* date2ts */])(value[0]) + ',' + Object(__WEBPACK_IMPORTED_MODULE_1__date__["a" /* date2ts */])(value[1]);
    }
  });

  if (extraParams.page) {
    params.page = extraParams.page;
  }
  if (extraParams.size) {
    params.count = extraParams.size;
  }
  return params;
};

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return date2ts; });
var date2ts = function date2ts(date) {
  return Math.ceil(date.valueOf() / 1000);
};

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagination__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__pagination__["a"]; });




/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["a"]; });




/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_i18n__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string__ = __webpack_require__(44);




function parseActions(self) {
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return actions.map(function (action) {
    if (typeof action === 'string') {
      var label = Object(__WEBPACK_IMPORTED_MODULE_1__helper_i18n__["c" /* i18n */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_string__["a" /* capitalize */])(action));
      if (action === 'edit') {
        return {
          label: label,
          click: self.editHandler.bind(self),
          hide: action.hide
        };
      } else if (action === 'detail') {
        return {
          label: label,
          click: self.detailHandler.bind(self),
          hide: action.hide
        };
      } else if (action === 'delete') {
        return {
          label: label,
          click: self.deleteHandler.bind(self),
          hide: action.hide
        };
      }
    } else if ((typeof action === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_typeof___default()(action)) === 'object') {
      // no need i18n here, let users do their own
      if (action.click === 'edit') {
        return {
          label: action.label,
          click: self.editHandler.bind(self),
          hide: action.hide
        };
      } else if (action.click === 'detail') {
        return {
          label: action.label,
          click: self.detailHandler.bind(self),
          hide: action.hide
        };
      } else if (action.click === 'delete') {
        return {
          label: action.label,
          click: self.deleteHandler.bind(self),
          hide: action.hide
        };
      }
      return {
        label: action.label,
        click: action.click.bind(self),
        hide: action.hide
      };
    }
  });
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkPerm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_safeGet__ = __webpack_require__(114);






var requesting = false;

/**
 * 检查用户是否拥有此权限
 * @param {object} store - Vuex store
 * @param {string} perm - Permission needs to check
 * @param {string} dataPath - Data path in store
 * @param {string} actionName - Load permission async
 * @param {object} actionParams - Load permission async
 * @returns {boolean} - Whether logged user has this permission
*/
var checkPerm = function checkPerm(store, perm) {
  var dataPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perm.api_perms';
  var actionName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'loadUserPerms';
  var actionParmas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var list = Object(__WEBPACK_IMPORTED_MODULE_4__utils_safeGet__["a" /* safeGet */])(store.state, dataPath);
  var result = false;
  if (!Array.isArray(list)) {
    var load = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.dispatch(actionName, actionParmas);

              case 2:
                requesting = false;
                list = Object(__WEBPACK_IMPORTED_MODULE_4__utils_safeGet__["a" /* safeGet */])(store.state, dataPath) || [];
                result = list.includes(perm);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!requesting) {
      requesting = !requesting;
      load();
    }
    return result;
  } else {
    return list.includes(perm);
  }
};

var UserPerms = function UserPerms(operations) {
  __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, UserPerms);

  this.state = {};

  this.mutations = {
    setUserPerms: function setUserPerms(state, data) {
      __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default()(data).forEach(function (item) {
        state[item] = data[item];
      });
    }
  };

  this.actions = {
    loadUserPerms: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2, parmas) {
        var commit = _ref2.commit;
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return operations.getPerms(parmas);

              case 2:
                resp = _context2.sent;

                commit('setUserPerms', resp.data);
                return _context2.abrupt('return', resp.data);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadUserPerms(_x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return loadUserPerms;
    }()
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (UserPerms);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateComponent */
/* harmony export (immutable) */ __webpack_exports__["a"] = NestedListViewFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListView_list__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListView_add_pageAdd__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListView_add_embedAdd__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListView_add_modalAdd__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__ = __webpack_require__(116);











function generateComponent(type, configs) {
  return {
    name: 'NestedListView',
    render: function render(h) {
      var _this = this;

      var resChild = null;
      var Add = null;
      switch (configs.mode) {
        case __WEBPACK_IMPORTED_MODULE_4__constant__["a" /* MODE */].EDIT_IN_DIALOG:
          Add = __WEBPACK_IMPORTED_MODULE_7__ListView_add_modalAdd__["a" /* default */];
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constant__["a" /* MODE */].EDIT_IN_NEW_PAGE:
          Add = __WEBPACK_IMPORTED_MODULE_5__ListView_add_pageAdd__["a" /* default */];
          break;
        case __WEBPACK_IMPORTED_MODULE_4__constant__["a" /* MODE */].EDIT_IN_TABLE:
          Add = __WEBPACK_IMPORTED_MODULE_6__ListView_add_embedAdd__["a" /* default */];
          break;
      }
      switch (type) {
        case 'list':
          return h(
            'div',
            { 'class': 'sp-nested-view' },
            [h('h1', [this.$i18n(configs.data.resourceName + ' List')]), h(__WEBPACK_IMPORTED_MODULE_3__ListView_list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
              'class': 'list-wrapper sp-' + configs.data.name + '-list',
              attrs: { resourceType: 'nested',
                mode: configs.mode,
                data: configs.data,
                schema: configs.schema,
                actions: configs.actions,
                hooks: configs.hooks,
                options: configs.options
              }
            }, {
              on: {
                'triggerSearch': function triggerSearch($event) {
                  for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    attrs[_key - 1] = arguments[_key];
                  }

                  (function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(params) {
                      var loadingInstance;
                      return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              loadingInstance = _this.$loading({ target: '.list-wrapper' });
                              _context.next = 3;
                              return configs.data.fetch.list(_this.$store, params);

                            case 3:
                              loadingInstance.close();

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  })().apply(undefined, [$event].concat(attrs));
                },
                'triggerFetchOne': function triggerFetchOne($event) {
                  for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    attrs[_key2 - 1] = arguments[_key2];
                  }

                  (function (id) {
                    return configs.data.fetch.one(_this.$store, id);
                  }).apply(undefined, [$event].concat(attrs));
                },
                'triggerUpdate': function triggerUpdate($event) {
                  for (var _len3 = arguments.length, attrs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                    attrs[_key3 - 1] = arguments[_key3];
                  }

                  (function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(params) {
                      return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return configs.data.update(_this.$store, params.data);

                            case 2:
                              params.cb && params.cb();

                            case 3:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  })().apply(undefined, [$event].concat(attrs));
                },
                'triggerDelete': function triggerDelete($event) {
                  for (var _len4 = arguments.length, attrs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                    attrs[_key4 - 1] = arguments[_key4];
                  }

                  (function () {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
                      return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return configs.data.delete(_this.$store, params.data);

                            case 2:
                              params.cb && params.cb();

                            case 3:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  })().apply(undefined, [$event].concat(attrs));
                },
                'addHandle': function addHandle($event) {
                  for (var _len5 = arguments.length, attrs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                    attrs[_key5 - 1] = arguments[_key5];
                  }

                  _this.addHandler.apply(_this, [$event].concat(attrs));
                },
                'editHandle': function editHandle($event) {
                  for (var _len6 = arguments.length, attrs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                    attrs[_key6 - 1] = arguments[_key6];
                  }

                  _this.editHandler.apply(_this, [$event].concat(attrs));
                },
                'detailHandle': function detailHandle($event) {
                  for (var _len7 = arguments.length, attrs = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                    attrs[_key7 - 1] = arguments[_key7];
                  }

                  _this.detailHandler.apply(_this, [$event].concat(attrs));
                }
              }
            }]))]
          );
        case 'add':
          return h(Add, __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
            'class': 'sp-' + configs.data.name,
            attrs: { schema: configs.schema,
              data: configs.data
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len8 = arguments.length, attrs = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
                  attrs[_key8 - 1] = arguments[_key8];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'edit':
          return h(Add, __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
            'class': 'sp-' + configs.data.name,
            attrs: { schema: configs.schema,
              data: configs.data,
              model: configs.data.provider.one(this.$store.state)
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len9 = arguments.length, attrs = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
                  attrs[_key9 - 1] = arguments[_key9];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        case 'detail':
          return h(Add, __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([{
            'class': 'sp-' + configs.data.name,
            attrs: { schema: configs.schema,
              data: configs.data,
              model: configs.data.provider.one(this.$store.state),
              isDetail: true
            }
          }, {
            on: {
              'triggerFetchOne': function triggerFetchOne($event) {
                for (var _len10 = arguments.length, attrs = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
                  attrs[_key10 - 1] = arguments[_key10];
                }

                (function (id) {
                  return configs.data.fetch.one(_this.$store, id);
                }).apply(undefined, [$event].concat(attrs));
              }
            }
          }]));
          break;
        default:
          return h('div');
      }
    },
    data: function data() {
      return {
        cancelText: this.$i18n('Confirm Cancel ?'),
        confirmText: this.$i18n('Confirm ?'),
        confirming: false,
        defaultFormData: {}
      };
    },

    methods: {
      confirm: function confirm() {
        var _this2 = this;

        if (this.confirming) return;
        this.confirming = true;
        var resourceName = configs.data.resourceName.toLocaleLowerCase() + '_id';
        this.formData[resourceName] = this.formData[resourceName] || this.formData['id'];
        this.$confirm(this.confirmText).then(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
          return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!_this2.model) {
                    _context4.next = 6;
                    break;
                  }

                  if (!(_this2.data && _this2.data.update)) {
                    _context4.next = 4;
                    break;
                  }

                  _context4.next = 4;
                  return _this2.data.update(_this2.$store, _this2.formData);

                case 4:
                  _context4.next = 9;
                  break;

                case 6:
                  if (!(_this2.data && _this2.data.add)) {
                    _context4.next = 9;
                    break;
                  }

                  _context4.next = 9;
                  return _this2.data.add(_this2.$store, _this2.formData);

                case 9:
                  __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$emit('closeSubPage');
                  _this2.confirming = false;

                case 11:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this2);
        }))).catch(function () {
          return _this2.confirming = false;
        });
      },
      cancel: function cancel() {
        this.$confirm(this.cancelText).then(function () {
          return __WEBPACK_IMPORTED_MODULE_8__utils_eventHub__["a" /* default */].$emit('closeSubPage');
        }).catch(function () {});
      },
      addHandler: function addHandler() {
        var _routerKit$parse = __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].parse(this.$route.path),
            prefix = _routerKit$parse.prefix,
            name = _routerKit$parse.name,
            viewMode = _routerKit$parse.viewMode;

        this.$router.push(prefix + '/' + name + '/' + configs.data.name + 'Add/' + viewMode);
      },
      editHandler: function editHandler(query) {
        var _routerKit$parse2 = __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].parse(this.$route.path),
            prefix = _routerKit$parse2.prefix,
            name = _routerKit$parse2.name,
            viewMode = _routerKit$parse2.viewMode;

        this.$router.push({
          path: prefix + '/' + name + '/' + configs.data.name + 'Edit/' + viewMode,
          query: query
        });
      },
      detailHandler: function detailHandler(query) {
        var _routerKit$parse3 = __WEBPACK_IMPORTED_MODULE_9__utils_routerKit__["a" /* default */].parse(this.$route.path),
            prefix = _routerKit$parse3.prefix,
            name = _routerKit$parse3.name,
            viewMode = _routerKit$parse3.viewMode;

        this.$router.push({
          path: prefix + '/' + name + '/' + configs.data.name + 'Detail/' + viewMode,
          query: query
        });
      }
    },
    created: function created() {
      this.$emit('triggerSearch');
    }
  };
}

function NestedListViewFactory(resource) {
  var components = {};
  resource.forEach(function (item) {
    components['' + item.data.name] = generateComponent('list', item);
    components[item.data.name + 'Add'] = generateComponent('add', item);
    components[item.data.name + 'Edit'] = generateComponent('edit', item);
    components[item.data.name + 'Detail'] = generateComponent('detail', item);
  });
  return components;
}

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_schema_index__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_schema_Schema__ = __webpack_require__(15);




/**
 * [Disabled in production and test environment]
 * Check and decorate the vm configs
 * All error found in configs will be thrown
 * @param {object} configs - Mutable VM configs
 */
/* harmony default export */ __webpack_exports__["a"] = (function (configs) {
  mode(configs);
  data(configs);
  name(configs);
  schemas(configs);
  actions(configs);
  hooks(configs);
  options(configs);
  nestedResource(configs);
  parallelResource(configs);
  tabs(configs);
});

function mode(configs) {
  if (!configs.mode) {
    throw 'View must have `mode`!';
  }
}

function data(configs) {
  if (!configs.data) {
    throw 'View must have `data`!';
  }
  var data = configs.data;
  var required = ['name', 'resourceName', 'provider', 'add', 'fetch', 'update'];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(required), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (!data.hasOwnProperty(key)) {
        throw 'Data descriptor must have `' + key + '`!';
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function name(configs) {
  if (!configs.name) {
    configs.name = configs.data.resourceName;
  }
}

function schemas(configs) {
  if (!configs.schema) {
    throw 'View must have `schema`!';
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(configs.schema), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var schema = _step2.value;

      if (!schema instanceof __WEBPACK_IMPORTED_MODULE_2__helper_schema_Schema__["a" /* default */]) {
        throw 'Schema must be constructed by a schema class!';
      }
      if ((schema instanceof __WEBPACK_IMPORTED_MODULE_1__helper_schema_index__["default"].Select || schema instanceof __WEBPACK_IMPORTED_MODULE_1__helper_schema_index__["default"].MultiSelect || schema instanceof __WEBPACK_IMPORTED_MODULE_1__helper_schema_index__["default"].Tree || schema instanceof __WEBPACK_IMPORTED_MODULE_1__helper_schema_index__["default"].CheckTree) && !schema.items) {
        throw 'Missing items for Select or Tree!';
      }
      if (!schema.options) {
        schema.options = {};
      }
      if (!schema.on) {
        schema.on = {};
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function actions(configs) {
  if (!configs.actions) {
    configs.actions = [];
  }
}

function hooks(configs) {
  if (!configs.hooks) {
    configs.hooks = [];
  }
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(configs.hooks), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var hook = _step3.value;

      if (!hook.options) {
        hook.options = {};
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}

function options(configs) {
  if (!configs.options) {
    configs.options = [];
  }
}

function nestedResource(configs) {
  if (!configs.nestedResource) {
    configs.nestedResource = [];
  }
}

function parallelResource(configs) {
  if (!configs.parallelResource) {
    configs.parallelResource = [];
  }
}

function tabs(configs) {
  if (!configs.tabs) {
    configs.tabs = [];
  }
}

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldDatetime__ = __webpack_require__(187);







var ts2date = function ts2date(ts) {
  return new Date(ts * 1000);
};
var addLeadingZero = function addLeadingZero(t) {
  return (t < 10 ? '0' : '') + t.toString();
};

var SchemaDatetime = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaDatetime, _Schema);

  function SchemaDatetime(label, key, rules) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var on = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaDatetime);

    options.render = options.render || function (date) {
      if (!date) {
        return '/';
      }
      if (typeof date === 'number') {
        date = ts2date(date);
      }
      var year = addLeadingZero(date.getYear() + 1900);
      var month = addLeadingZero(date.getMonth() + 1);
      var day = addLeadingZero(date.getDate());
      var hour = addLeadingZero(date.getHours());
      var minute = addLeadingZero(date.getMinutes());
      var second = addLeadingZero(date.getSeconds());
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    };

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaDatetime.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaDatetime)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldDatetime__["a" /* default */].call(_this, label, key, rules, options, on);
    return _this;
  }

  return SchemaDatetime;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaDatetime);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
module.exports = __webpack_require__(1).Object.getPrototypeOf;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(49);
var $getPrototypeOf = __webpack_require__(129);

__webpack_require__(138)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(447), __esModule: true };

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(448);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(9);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(449).set });


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(28);
var anObject = __webpack_require__(19);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(39)(Function.call, __webpack_require__(140).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(451), __esModule: true };

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(452);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(81) });


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validate; });
/* unused harmony export keywords */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys__);



var validate = {
  required: function required(key) {
    return {
      required: true,
      message: key + ' should not be empty !'
    };
  },
  number: function number(key) {
    return {
      type: 'number',
      message: key + ' should be a number !'
    };
  },
  email: function email(key) {
    return {
      type: 'email',
      message: key + ' should be an email address !'
    };
  }
};

var keywords = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_keys___default()(validate).reduce(function (previousValue, currentValue) {
  return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, previousValue, __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_defineProperty___default()({}, currentValue.toUpperCase(), currentValue));
}, {});



/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldTextarea__ = __webpack_require__(188);







var SchemaTextarea = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaTextarea, _Schema);

  function SchemaTextarea(label, key, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaTextarea);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaTextarea.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaTextarea)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldTextarea__["a" /* default */].call(_this, label, key, rules, options, on);
    return _this;
  }

  return SchemaTextarea;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaTextarea);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldNumber__ = __webpack_require__(189);







var SchemaNumber = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaNumber, _Schema);

  function SchemaNumber(label, key, items, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaNumber);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaNumber.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaNumber)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldNumber__["a" /* default */].call(_this, label, key, items, options, on);
    return _this;
  }

  return SchemaNumber;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaNumber);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldSelect__ = __webpack_require__(190);







var SchemaSelect = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaSelect, _Schema);

  function SchemaSelect(label, key, items, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaSelect);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaSelect)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldSelect__["a" /* default */].call(_this, label, key, items, rules, options, on);
    return _this;
  }

  return SchemaSelect;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaSelect);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldMultiSelect__ = __webpack_require__(191);







var SchemaInput = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaInput, _Schema);

  function SchemaInput(label, key, items, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaInput);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaInput.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaInput)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldMultiSelect__["a" /* default */].call(_this, label, key, items, rules, options, on);
    return _this;
  }

  return SchemaInput;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaInput);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldInput__ = __webpack_require__(192);







var SchemaInput = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaInput, _Schema);

  function SchemaInput(label, key, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaInput);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaInput.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaInput)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldInput__["a" /* default */].call(_this, label, key, rules, options, on);
    return _this;
  }

  return SchemaInput;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaInput);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldHidden__ = __webpack_require__(460);







var SchemaHidden = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaHidden, _Schema);

  function SchemaHidden(label, key, rules) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var on = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaHidden);

    options.hide = true;
    options.inTable = false;
    options.editable = false;
    options.asFilter = true;
    options.asTabFilter = false;

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaHidden.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaHidden)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldHidden__["a" /* default */].call(_this, label, key, rules, options, on);
    return _this;
  }

  return SchemaHidden;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaHidden);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldHidden;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Field__ = __webpack_require__(18);


function FieldHidden(label, key, rules, options, on) {
  __WEBPACK_IMPORTED_MODULE_0__Field__["a" /* default */].call(this, label, key, rules, options, on);
  this.type = 'hidden';
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldDatetimeRange__ = __webpack_require__(193);







var SchemaDatetimeRange = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaDatetimeRange, _Schema);

  function SchemaDatetimeRange(label, key, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaDatetimeRange);

    options.inTable = false;
    options.asTabFilter = false;
    options.asFilter = true;
    options.editable = false;
    options.sortable = false;
    options.render = function () {
      return null;
    };

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaDatetimeRange.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaDatetimeRange)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldDatetimeRange__["a" /* default */].call(_this, label, key, rules, on, rules);
    return _this;
  }

  return SchemaDatetimeRange;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaDatetimeRange);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldTree__ = __webpack_require__(194);







var SchemaTree = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaTree, _Schema);

  function SchemaTree(label, key, items, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaTree);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaTree.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaTree)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldTree__["a" /* default */].call(_this, label, key, items, rules, options, on);
    return _this;
  }

  return SchemaTree;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaTree);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldCheckTree__ = __webpack_require__(195);







var SchemaCheckbox = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaCheckbox, _Schema);

  function SchemaCheckbox(label, key, items, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaCheckbox);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaCheckbox.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaCheckbox)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldCheckTree__["a" /* default */].call(_this, label, key, items, rules, options, on);
    return _this;
  }

  return SchemaCheckbox;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaCheckbox);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Schema__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_FieldTableSelect__ = __webpack_require__(196);







var SchemaInput = function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_inherits___default()(SchemaInput, _Schema);

  function SchemaInput(label, key, items, rules, options, on) {
    __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, SchemaInput);

    var _this = __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchemaInput.__proto__ || __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_get_prototype_of___default()(SchemaInput)).call(this, options));

    __WEBPACK_IMPORTED_MODULE_5__fields_FieldTableSelect__["a" /* default */].call(_this, label, key, items, rules, options, on);
    return _this;
  }

  return SchemaInput;
}(__WEBPACK_IMPORTED_MODULE_4__Schema__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchemaInput);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(44);



var Descriptor =
/**
 * Conventions
 * - name is in lower case
 * - local data is in store with specific keys
 * - action names are as follows
 * @param {string} name - Resource name
 */
function Descriptor(name) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_classCallCheck___default()(this, Descriptor);

  this.name = name;
  this.resourceName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["a" /* capitalize */])(name);
  this.provider = {
    list: function list(state) {
      return state[name][name + 'List'];
    },
    one: function one(state) {
      return state[name][name];
    }
  };
  this.fetch = {
    list: function list($store, params) {
      $store.dispatch('load' + _this.resourceName + 'List', params);
    },
    one: function one($store, id) {
      $store.dispatch('load' + _this.resourceName, id);
    }
  };
  this.update = function ($store, params) {
    return $store.dispatch('update' + _this.resourceName, params);
  };
  this.add = function ($store, params) {
    return $store.dispatch('add' + _this.resourceName, params);
  };
  this.delete = function ($store, params) {
    return $store.dispatch('delete' + _this.resourceName, params);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Descriptor);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_creator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_renderStatus__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_helper_resource__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_ts__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_constant__ = __webpack_require__(21);










var stationRequest = false;
var roleRequest = false;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__packages_creator__["a" /* default */])({
  name: 'Nested View',
  mode: __WEBPACK_IMPORTED_MODULE_8__packages_constant__["a" /* MODE */].EDIT_IN_NEW_PAGE,
  data: new __WEBPACK_IMPORTED_MODULE_6__packages_helper_resource__["a" /* default */]('user'),
  schema: [new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Hidden('User ID', 'id', false), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('User ID', 'id', false, '', {
    editable: false
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Email', 'email', false, {
    asFilter: true,
    inTable: false,
    editable: false
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].CheckTree('Role', 'role_list', function (state) {
    return [{ id: 1, label: Object(__WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__["c" /* i18n */])('a') }, { id: 2, label: Object(__WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__["c" /* i18n */])('b') }, { id: 3, label: Object(__WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__["c" /* i18n */])('c') }, { id: 4, label: Object(__WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__["c" /* i18n */])('d') }];
  }, false, {
    asFilter: true,
    inTable: false,
    editable: false
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Email', 'email', true), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Phone', 'phone', true, { group: 'Numbers only' }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Select('Status', 'status', [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["b" /* USER */].STATUS.map(function (item, index) {
    return {
      label: item,
      value: index
    };
  }))), true, {
    asFilter: true,
    inTable: true,
    render: function render(value, row) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__helper_renderStatus__["a" /* default */])({
        type: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["b" /* USER */].STATUS_CLASS[value],
        content: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["b" /* USER */].STATUS[value]
      });
    },
    group: 'Selections'
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Select('Flag', 'flag', [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["c" /* USER_FLAG */].STATUS.map(function (item, index) {
    return {
      label: item,
      value: index
    };
  }))), true, {
    asFilter: false,
    inTable: true,
    render: function render(value, row) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__helper_renderStatus__["a" /* default */])({
        type: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["c" /* USER_FLAG */].STATUS_CLASS[value],
        content: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["c" /* USER_FLAG */].STATUS[value]
      });
    },
    group: 'Selections'
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].MultiSelect('Role', 'role_name_list', [], true, {
    asFilter: false,
    inTable: true,
    editable: false
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Datetime('Create Time', 'ctime', false, {
    editable: false,
    render: function render(date, row) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__helper_ts__["a" /* format */])(date);
    }
  }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Datetime('Last Login', 'last_login', false, {
    editable: false,
    render: function render(date, row) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__helper_ts__["a" /* format */])(date);
    }
  })],
  options: {
    tabs: [{
      label: 'a',
      url: 'a'
    }, {
      label: 'b',
      url: 'b'
    }, {
      label: 'c',
      url: 'c'
    }]
  },
  actions: ['edit', 'detail'],
  hooks: [{
    label: Object(__WEBPACK_IMPORTED_MODULE_3__packages_helper_i18n__["c" /* i18n */])('parallel'),
    handler: function handler(router, route) {
      router.push(route.path + '/user');
    }
  }],
  parallelResource: [{
    mode: __WEBPACK_IMPORTED_MODULE_8__packages_constant__["a" /* MODE */].EDIT_IN_NEW_PAGE,
    data: new __WEBPACK_IMPORTED_MODULE_6__packages_helper_resource__["a" /* default */]('role'),
    schema: [new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Role ID', 'role_id', false, {
      editable: false,
      asFilter: true,
      render: function render(value, row) {
        return row['id'];
      }
    }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Input('Role Name', 'name', true), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Select('Status', 'status', [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["a" /* ROLE */].STATUS.map(function (item, index) {
      return {
        label: item,
        value: index
      };
    }))), true, {
      asFilter: true,
      render: function render(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__helper_renderStatus__["a" /* default */])({
          type: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["a" /* ROLE */].STATUS_CLASS[value],
          content: __WEBPACK_IMPORTED_MODULE_4__helper_valueMap__["a" /* ROLE */].STATUS[value]
        });
      }
    }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Datetime('Create Time', 'ctime', false, {
      editable: false
    }), new __WEBPACK_IMPORTED_MODULE_2__packages_helper_schema__["default"].Tree('Permission', 'permission_list', function (state) {
      return state.user.permissionTree;
    }, true, {
      editable: true,
      inTable: false,
      asFilter: false
    })],
    actions: ['edit', 'detail'],
    hooks: []
  }]
}));

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ts2date */
/* unused harmony export date2ts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
var ts2date = function ts2date(ts) {
  return new Date(ts * 1000);
};
var date2ts = function date2ts(date) {
  return Math.ceil(date.valueOf() / 1000);
};

var addLeadingZero = function addLeadingZero(t) {
  return (t < 10 ? '0' : '') + t.toString();
};

var format = function format(date) {
  if (!date) {
    return '/';
  }
  if (typeof date === 'number') {
    date = ts2date(date);
  }
  var year = addLeadingZero(date.getYear() + 1900);
  var month = addLeadingZero(date.getMonth() + 1);
  var day = addLeadingZero(date.getDate());
  var hour = addLeadingZero(date.getHours());
  var minute = addLeadingZero(date.getMinutes());
  var second = addLeadingZero(date.getSeconds());
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
};



/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_creator_index__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_valueMap__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_renderStatus__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_helper_resource__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_utils_string__ = __webpack_require__(44);












var cities = [['china', 'guangdong', 'shenzhen'], ['china', 'guangdong', 'guangzhou'], ['china', 'shandong', 'jinan'], ['china', 'shandong', 'qingdao'], ['japan', 'fukushima', 'fukushima-shi'], ['japan', 'fukushima', 'shilakawa-shi'], ['japan', 'kumamoto', 'kumamoto-shi'], ['japan', 'kumamoto', 'yatsushiro-shi']];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__packages_creator_index__["a" /* default */])({
  name: 'Parallel View',
  mode: __WEBPACK_IMPORTED_MODULE_8__packages_constant__["a" /* MODE */].EDIT_IN_DIALOG,
  data: new __WEBPACK_IMPORTED_MODULE_7__packages_helper_resource__["a" /* default */]('item'),
  schema: [new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Hidden('Item ID', 'id', false),
  // 联动控件：a+b
  new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Input('A', 'a', true, { asFilter: true }), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Input('B', 'b', true, { asFilter: true }),
  // deps 中 handler 的返回值的意义是，当依赖改变之后，这个 Schema 的值是多少
  new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Input('A+B', 'c', false, {
    asFilter: true,
    deps: ['a', 'b', function (a, b) {
      return (a | 0) + (b | 0);
    }]
  }),
  // 联动控件：国家、省市选择
  // items 使用 Promise 获取数据
  new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Select('Country', 'country', new __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      return resolve([{ label: 'China', value: 'china' }, { label: 'Japan', value: 'japan' }]);
    }, 3000);
  }), false, {
    asFilter: true,
    render: function render(country) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__packages_utils_string__["a" /* capitalize */])(country);
    }
  }),
  // deps 的 handler 是一个函数，其中 this 是 new 生成的 Schema
  new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Select('Province', 'province', [], false, {
    asFilter: true,
    deps: ['country', function (country) {
      if (country === 'china') {
        this.items = [{ label: 'Guangdong', value: 'guangdong' }, { label: 'Shandong', value: 'shandong' }];
      } else {
        this.items = [{ label: 'Fukushima', value: 'fukushima' }, { label: 'Kumamoto', value: 'kumamoto' }];
      }
    }],
    render: function render(province) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__packages_utils_string__["a" /* capitalize */])(province);
    }
  }), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Select('City', 'city', [], false, {
    asFilter: true,
    deps: ['country', 'province', function (country, province) {
      this.items = new __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          return resolve(cities.filter(function (city) {
            return city[0] === country && city[1] === province;
          }).map(function (city) {
            return {
              label: city[2][0].toUpperCase() + city[2].substr(1),
              value: city[2]
            };
          }));
        }, 1000);
      });
    }],
    render: function render(city) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__packages_utils_string__["a" /* capitalize */])(city);
    }
  })],
  actions: ['edit'],
  hooks: [{
    label: 'Show route',
    handler: function handler(router, route) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message('Route path is: ' + route.path);
    }
  }],
  options: {
    columnEditable: true
  },
  parallelResource: [{
    data: new __WEBPACK_IMPORTED_MODULE_7__packages_helper_resource__["a" /* default */]('role'),
    schema: [new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Input('Role ID', 'role_id', false, {
      editable: false,
      asFilter: true,
      render: function render(value, row) {
        return row['id'];
      }
    }), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Input('Role Name', 'name', true), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Select('Status', 'status', [].concat(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__helper_valueMap__["a" /* ROLE */].STATUS.map(function (item, index) {
      return {
        label: item,
        value: index
      };
    }))), true, {
      asFilter: true,
      render: function render(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__helper_renderStatus__["a" /* default */])({
          type: __WEBPACK_IMPORTED_MODULE_5__helper_valueMap__["a" /* ROLE */].STATUS_CLASS[value],
          content: __WEBPACK_IMPORTED_MODULE_5__helper_valueMap__["a" /* ROLE */].STATUS[value]
        });
      }
    }), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Datetime('Create Time', 'ctime', false, {
      editable: false
    }), new __WEBPACK_IMPORTED_MODULE_4__packages_helper_schema__["default"].Tree('Permission', 'permission_list', function (state) {
      return state.user.permissionTree;
    }, true, {
      editable: true,
      inTable: false,
      asFilter: false
    })],
    actions: ['edit']
  }]
}));

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_404_404_vue__ = __webpack_require__(470);


/* harmony default export */ __webpack_exports__["a"] = ({
  routes: [{
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_0__views_404_404_vue__["a" /* default */],
    meta: {
      title: '404 Not Found'
    }
  }]
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d825bb68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(75)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d825bb68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{attrs:{"title":"404 NOT FOUND","type":"warning","description":"所访问的页面不存在","show-icon":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_creator___ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_components_Breadcrumb___ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_components_FormTpl___ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_components_Header___ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_components_Menu___ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_components_Tabs___ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_constant__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_helper_resource__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_helper_schema__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_helper_fields__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_helper_module__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_helper_api__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_helper_i18n_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_helper_i18n_element_locales__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_awesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_normalize_css__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_normalize_css__);
/* unused harmony reexport ViewFactory */
/* unused harmony reexport spBreadcrumb */
/* unused harmony reexport formTpl */
/* unused harmony reexport spHeader */
/* unused harmony reexport spMenu */
/* unused harmony reexport spTabs */
/* unused harmony reexport constant */
/* unused harmony reexport CollectionDescriptor */
/* unused harmony reexport schema */
/* unused harmony reexport fields */
/* unused harmony reexport Module */
/* unused harmony reexport Api */
/* unused harmony reexport I18n */
/* unused harmony reexport setLocale */
/* unused harmony reexport setI18nData */
// package 内所有helper/components/creator 的向外出口






















var components = {
  formTpl: __WEBPACK_IMPORTED_MODULE_2__packages_components_FormTpl___["a" /* default */],
  spBreadcrumb: __WEBPACK_IMPORTED_MODULE_1__packages_components_Breadcrumb___["a" /* default */],
  spHeader: __WEBPACK_IMPORTED_MODULE_3__packages_components_Header___["a" /* default */],
  spMenu: __WEBPACK_IMPORTED_MODULE_4__packages_components_Menu___["a" /* default */],
  spTabs: __WEBPACK_IMPORTED_MODULE_5__packages_components_Tabs___["a" /* default */]
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.use(__WEBPACK_IMPORTED_MODULE_12__packages_helper_i18n_index__["b" /* default */], opts);
  Vue.use(__WEBPACK_IMPORTED_MODULE_14_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_13__packages_helper_i18n_element_locales__["a" /* default */][__WEBPACK_IMPORTED_MODULE_12__packages_helper_i18n_index__["a" /* currentLocale */]] });
  for (var name in components) {
    Vue.component(name, components[name]);
  }

  Vue.component('icon', __WEBPACK_IMPORTED_MODULE_15_vue_awesome___default.a);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install,
  components: components,
  ViewFactory: __WEBPACK_IMPORTED_MODULE_0__packages_creator___["a" /* default */],
  helper: {
    CollectionDescriptor: __WEBPACK_IMPORTED_MODULE_7__packages_helper_resource__["a" /* default */],
    schema: __WEBPACK_IMPORTED_MODULE_8__packages_helper_schema__,
    fields: __WEBPACK_IMPORTED_MODULE_9__packages_helper_fields__,
    Module: __WEBPACK_IMPORTED_MODULE_10__packages_helper_module__["a" /* default */],
    Api: __WEBPACK_IMPORTED_MODULE_11__packages_helper_api__["a" /* default */]
  },
  I18n: __WEBPACK_IMPORTED_MODULE_12__packages_helper_i18n_index__["b" /* default */],
  constant: __WEBPACK_IMPORTED_MODULE_6__packages_constant__["c" /* default */]
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldDatetime__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldTextarea__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldNumber__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldSelect__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FieldMultiSelect__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FieldInput__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldDatetimeRange__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldTree__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldCheckTree__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldTableSelect__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldDatetime", function() { return __WEBPACK_IMPORTED_MODULE_0__FieldDatetime__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldTextarea", function() { return __WEBPACK_IMPORTED_MODULE_1__FieldTextarea__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldNumber", function() { return __WEBPACK_IMPORTED_MODULE_2__FieldNumber__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldSelect", function() { return __WEBPACK_IMPORTED_MODULE_3__FieldSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldMultiSelect", function() { return __WEBPACK_IMPORTED_MODULE_4__FieldMultiSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldInput", function() { return __WEBPACK_IMPORTED_MODULE_5__FieldInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldDatetimeRange", function() { return __WEBPACK_IMPORTED_MODULE_6__FieldDatetimeRange__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldTree", function() { return __WEBPACK_IMPORTED_MODULE_7__FieldTree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldCheckTree", function() { return __WEBPACK_IMPORTED_MODULE_8__FieldCheckTree__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldTableSelect", function() { return __WEBPACK_IMPORTED_MODULE_9__FieldTableSelect__["a"]; });













/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

!function(C,H){ true?module.exports=H():"function"==typeof define&&define.amd?define(H):C.VueAwesome=H()}(this,function(){"use strict";!function(){if("undefined"!=typeof document){var C=document.head||document.getElementsByTagName("head")[0],H=document.createElement("style"),V=" .fa-icon { display: inline-block; fill: currentColor; } .fa-flip-horizontal { transform: scale(-1, 1); } .fa-flip-vertical { transform: scale(1, -1); } .fa-spin { animation: fa-spin 1s 0s infinite linear; } .fa-inverse { color: #fff; } .fa-pulse { animation: fa-spin 1s infinite steps(8); } @keyframes fa-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } } ";H.type="text/css",H.styleSheet?H.styleSheet.cssText=V:H.appendChild(document.createTextNode(V)),C.appendChild(H)}}();var C={},H={render:function(){var C=this,H=C.$createElement,V=C._self._c||H;return V("svg",{class:C.klass,style:C.style,attrs:{version:"1.1",role:C.label?"img":"presentation","aria-label":C.label,x:C.x,y:C.y,width:C.width,height:C.height,viewBox:C.box}},[C._t("default",[C.icon&&C.icon.paths?C._l(C.icon.paths,function(H,t){return V("path",C._b({key:"path-"+t},"path",H,!1))}):C._e(),C._v(" "),C.icon&&C.icon.polygons?C._l(C.icon.polygons,function(H,t){return V("polygon",C._b({key:"polygon-"+t},"polygon",H,!1))}):C._e(),C._v(" "),C.icon&&C.icon.raw?[V("g",{domProps:{innerHTML:C._s(C.raw)}})]:C._e()])],2)},staticRenderFns:[],name:"icon",props:{name:{type:String,validator:function(H){return H?H in C||(console.warn('Invalid prop: prop "name" is referring to an unregistered icon "'+H+'".\nPlease make sure you have imported this icon before using it.'),!1):(console.warn('Invalid prop: prop "name" is required.'),!1)}},scale:[Number,String],spin:Boolean,inverse:Boolean,pulse:Boolean,flip:{validator:function(C){return"horizontal"===C||"vertical"===C}},label:String},data:function(){return{x:!1,y:!1,childrenWidth:0,childrenHeight:0,outerScale:1}},computed:{normalizedScale:function(){var C=this.scale;return C=void 0===C?1:Number(C),isNaN(C)||C<=0?(console.warn('Invalid prop: prop "scale" should be a number over 0.',this),this.outerScale):C*this.outerScale},klass:function(){return{"fa-icon":!0,"fa-spin":this.spin,"fa-flip-horizontal":"horizontal"===this.flip,"fa-flip-vertical":"vertical"===this.flip,"fa-inverse":this.inverse,"fa-pulse":this.pulse}},icon:function(){return this.name?C[this.name]:null},box:function(){return this.icon?"0 0 "+this.icon.width+" "+this.icon.height:"0 0 "+this.width+" "+this.height},ratio:function(){if(!this.icon)return 1;var C=this.icon,H=C.width,V=C.height;return Math.max(H,V)/16},width:function(){return this.childrenWidth||this.icon&&this.icon.width/this.ratio*this.normalizedScale||0},height:function(){return this.childrenHeight||this.icon&&this.icon.height/this.ratio*this.normalizedScale||0},style:function(){return 1!==this.normalizedScale&&{fontSize:this.normalizedScale+"em"}},raw:function(){if(!this.icon||!this.icon.raw)return null;var C=this.icon.raw,H={};return C=C.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g,function(C,t,h){var e="fa-"+(V++).toString(16);return H[h]=e,' id="'+e+'"'}),C=C.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g,function(C,V,t,h){var e=V||h;return e&&H[e]?"#"+H[e]:C}),C}},mounted:function(){var C=this;if(!this.icon){this.$children.forEach(function(H){H.outerScale=C.normalizedScale});var H=0,V=0;this.$children.forEach(function(C){H=Math.max(H,C.width),V=Math.max(V,C.height)}),this.childrenWidth=H,this.childrenHeight=V,this.$children.forEach(function(C){C.x=(H-C.width)/2,C.y=(V-C.height)/2})}},register:function(H){for(var V in H){var t=H[V];t.paths||(t.paths=[]),t.d&&t.paths.push({d:t.d}),t.polygons||(t.polygons=[]),t.points&&t.polygons.push({points:t.points}),C[V]=t}},icons:C},V=870711;return H.register({"regular/address-book":{width:448,height:512,paths:[{d:"M436 160C442.6 160 448 154.6 448 148V108C448 101.4 442.6 96 436 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H436C442.6 416 448 410.6 448 404V364C448 357.4 442.6 352 436 352H416V288H436C442.6 288 448 282.6 448 276V236C448 229.4 442.6 224 436 224H416V160H436zM362 464H54A6-6 0 0 0 48 458V54A6-6 0 0 0 54 48H362A6-6 0 0 0 368 54V458A6-6 0 0 0 362 464zM128 208C128 163.8 163.8 128 208 128S288 163.8 288 208 252.2 288 208 288 128 252.2 128 208zM336 341.5V360C336 373.3 325.3 384 312 384H104C90.7 384 80 373.3 80 360V341.5C80 319.5 95 300.3 116.4 294.9L152 286C181.1 306.9 226.5 312.9 264 286L299.6 294.9C321 300.3 336 319.5 336 341.5z"}]}}),H.register({"regular/address-card":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM458 400H54A6-6 0 0 0 48 394V118A6-6 0 0 0 54 112H458A6-6 0 0 0 464 118V394A6-6 0 0 0 458 400zM404 224H300C293.4 224 288 218.6 288 212V196C288 189.4 293.4 184 300 184H404C410.6 184 416 189.4 416 196V212C416 218.6 410.6 224 404 224zM404 296H300C293.4 296 288 290.6 288 284V268C288 261.4 293.4 256 300 256H404C410.6 256 416 261.4 416 268V284C416 290.6 410.6 296 404 296zM176 160C209.1 160 236 186.9 236 220S209.1 280 176 280 116 253.1 116 220 142.9 160 176 160zM244.7 285.2L218 278.5C189.9 298.7 155.8 294.2 134 278.5L107.3 285.2C91.2 289.2 80 303.6 80 320.1V334C80 343.9 88.1 352 98 352H254C263.9 352 272 343.9 272 334V320.1C272 303.6 260.8 289.2 244.7 285.2z"}]}}),H.register({"regular/arrow-alt-circle-down":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM224 140V256H157C146.3 256 141 268.9 148.5 276.5L247.5 375.5C252.2 380.2 259.8 380.2 264.5 375.5L363.5 276.5C371.1 268.9 365.7 256 355 256H288V140C288 133.4 282.6 128 276 128H236C229.4 128 224 133.4 224 140z"}]}}),H.register({"regular/arrow-alt-circle-left":{width:512,height:512,paths:[{d:"M8 256C8 393 119 504 256 504S504 393 504 256 393 8 256 8 8 119 8 256zM456 256C456 366.5 366.5 456 256 456S56 366.5 56 256 145.5 56 256 56 456 145.5 456 256zM384 236V276C384 282.6 378.6 288 372 288H256V355C256 365.7 243.1 371 235.5 363.5L136.5 264.5C131.8 259.8 131.8 252.2 136.5 247.5L235.5 148.5C243.1 140.9 256 146.3 256 157V224H372C378.6 224 384 229.4 384 236z"}]}}),H.register({"regular/arrow-alt-circle-right":{width:512,height:512,paths:[{d:"M504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256zM128 276V236C128 229.4 133.4 224 140 224H256V157C256 146.3 268.9 141 276.5 148.5L375.5 247.5C380.2 252.2 380.2 259.8 375.5 264.5L276.5 363.5C268.9 371.1 256 365.7 256 355V288H140C133.4 288 128 282.6 128 276z"}]}}),H.register({"regular/arrow-alt-circle-up":{width:512,height:512,paths:[{d:"M256 504C393 504 504 393 504 256S393 8 256 8 8 119 8 256 119 504 256 504zM256 56C366.5 56 456 145.5 456 256S366.5 456 256 456 56 366.5 56 256 145.5 56 256 56zM276 384H236C229.4 384 224 378.6 224 372V256H157C146.3 256 141 243.1 148.5 235.5L247.5 136.5C252.2 131.8 259.8 131.8 264.5 136.5L363.5 235.5C371.1 243.1 365.7 256 355 256H288V372C288 378.6 282.6 384 276 384z"}]}}),H.register({"regular/bell-slash":{width:576,height:512,paths:[{d:"M130.9 400C114.1 400 105.8 379.6 117.6 367.8 142.8 342.6 163.7 318.5 168.2 246.3L121.4 205.1A168.5-168.5 0 0 1 121.1 214.9C121.1 296.8 103.6 314.1 86.6 330.9 38.5 378.4 73.7 448 130.9 448H224C224 483.3 252.7 512 288 512S352 483.3 352 448H396.8L342.4 400H130.9zM288 472C274.8 472 264 461.2 264 448H312C312 461.2 301.2 472 288 472zM571.9 472.6L503.9 413C517 388.9 515.5 356.7 489.4 330.9 472.4 314.2 454.9 296.8 454.9 214.9 454.9 131.8 393.9 62.8 314.4 50.1A31.8-31.8 0 0 1 320 32C320 14.3 305.7 0 288 0S256 14.3 256 32A31.8-31.8 0 0 1 261.6 50.1C220.1 56.7 183.7 78.7 158.4 109.9L36.5 3C31.4-1.4 23.7-0.9 19.2 4.1L3.1 22.3C-1.4 27.3-0.9 35 4.1 39.4L539.5 509C544.6 513.4 552.3 512.9 556.8 507.9L572.9 489.7C577.4 484.7 576.9 477 571.9 472.6zM288 96C353.5 96 406.9 149.3 406.9 214.9 406.9 312.5 430.1 339.4 458.4 367.8 461.3 370.7 463 374.1 463.6 377.6L194.5 141.6C216.3 113.9 250.1 96 288 96z"}]}}),H.register({"regular/bell":{width:448,height:512,paths:[{d:"M425.4 330.9C408.4 314.2 390.9 296.8 390.9 214.9 390.9 131.8 329.9 62.8 250.4 50.1A31.8-31.8 0 0 1 256 32C256 14.3 241.7 0 224 0S192 14.3 192 32A31.8-31.8 0 0 1 197.6 50.1C118.1 62.8 57.1 131.8 57.1 214.9 57.1 296.8 39.6 314.1 22.6 330.9-25.5 378.4 9.7 448 66.9 448H160C160 483.3 188.7 512 224 512 259.3 512 288 483.3 288 448H381.1C438.3 448 473.5 378.4 425.4 330.9zM224 472C210.8 472 200 461.2 200 448H248C248 461.2 237.2 472 224 472zM381.1 400H66.9C50.1 400 41.8 379.6 53.6 367.8 82.2 339.2 105.1 312.1 105.1 214.9 105.1 149.3 158.5 96 224 96S342.9 149.3 342.9 214.9C342.9 312.5 366.1 339.4 394.4 367.8 406.3 379.7 397.8 400 381.1 400z"}]}}),H.register({"regular/bookmark":{width:384,height:512,paths:[{d:"M336 0H48C21.5 0 0 21.5 0 48V512L192 400 384 512V48C384 21.5 362.5 0 336 0zM336 428.4L192 344.4 48 428.4V54A6-6 0 0 0 54 48H330C333.3 48 336 50.7 336 54V428.4z"}]}}),H.register({"regular/building":{width:448,height:512,paths:[{d:"M128 148V108C128 101.4 133.4 96 140 96H180C186.6 96 192 101.4 192 108V148C192 154.6 186.6 160 180 160H140C133.4 160 128 154.6 128 148zM268 160H308C314.6 160 320 154.6 320 148V108C320 101.4 314.6 96 308 96H268C261.4 96 256 101.4 256 108V148C256 154.6 261.4 160 268 160zM140 256H180C186.6 256 192 250.6 192 244V204C192 197.4 186.6 192 180 192H140C133.4 192 128 197.4 128 204V244C128 250.6 133.4 256 140 256zM268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256zM192 340V300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352zM448 476V512H0V476C0 469.4 5.4 464 12 464H31.5V24C31.5 10.7 42.2 0 55.5 0H392.5C405.8 0 416.5 10.7 416.5 24V464H436C442.6 464 448 469.4 448 476zM79.5 463H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V463H368.5V49L80 48 79.5 463z"}]}}),H.register({"regular/calendar-alt":{width:448,height:512,paths:[{d:"M148 288H108C101.4 288 96 282.6 96 276V236C96 229.4 101.4 224 108 224H148C154.6 224 160 229.4 160 236V276C160 282.6 154.6 288 148 288zM256 276V236C256 229.4 250.6 224 244 224H204C197.4 224 192 229.4 192 236V276C192 282.6 197.4 288 204 288H244C250.6 288 256 282.6 256 276zM352 276V236C352 229.4 346.6 224 340 224H300C293.4 224 288 229.4 288 236V276C288 282.6 293.4 288 300 288H340C346.6 288 352 282.6 352 276zM256 372V332C256 325.4 250.6 320 244 320H204C197.4 320 192 325.4 192 332V372C192 378.6 197.4 384 204 384H244C250.6 384 256 378.6 256 372zM160 372V332C160 325.4 154.6 320 148 320H108C101.4 320 96 325.4 96 332V372C96 378.6 101.4 384 108 384H148C154.6 384 160 378.6 160 372zM352 372V332C352 325.4 346.6 320 340 320H300C293.4 320 288 325.4 288 332V372C288 378.6 293.4 384 300 384H340C346.6 384 352 378.6 352 372zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z"}]}}),H.register({"regular/calendar-check":{width:448,height:512,paths:[{d:"M400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V112C448 85.5 426.5 64 400 64zM394 464H54A6-6 0 0 0 48 458V160H400V458A6-6 0 0 0 394 464zM341.2 263.4L198.8 404.5C194.1 409.2 186.5 409.2 181.9 404.5L106.8 328.8C102.1 324 102.1 316.4 106.8 311.8L129.6 289.2C134.3 284.6 141.9 284.6 146.5 289.3L190.6 333.8 301.7 223.6C306.4 218.9 314 219 318.7 223.7L341.2 246.4C345.9 251.1 345.9 258.7 341.2 263.4z"}]}}),H.register({"regular/calendar-minus":{width:448,height:512,paths:[{d:"M124 328C117.4 328 112 322.6 112 316V292C112 285.4 117.4 280 124 280H324C330.6 280 336 285.4 336 292V316C336 322.6 330.6 328 324 328H124zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z"}]}}),H.register({"regular/calendar-plus":{width:448,height:512,paths:[{d:"M336 292V316C336 322.6 330.6 328 324 328H248V404C248 410.6 242.6 416 236 416H212C205.4 416 200 410.6 200 404V328H124C117.4 328 112 322.6 112 316V292C112 285.4 117.4 280 124 280H200V204C200 197.4 205.4 192 212 192H236C242.6 192 248 197.4 248 204V280H324C330.6 280 336 285.4 336 292zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z"}]}}),H.register({"regular/calendar-times":{width:448,height:512,paths:[{d:"M311.7 374.7L294.7 391.7C290 396.4 282.4 396.4 277.7 391.7L224 337.9 170.3 391.6C165.6 396.3 158 396.3 153.3 391.6L136.3 374.6C131.6 369.9 131.6 362.3 136.3 357.6L190 303.9 136.3 250.2C131.6 245.5 131.6 237.9 136.3 233.2L153.3 216.2C158 211.5 165.6 211.5 170.3 216.2L224 269.9 277.7 216.2C282.4 211.5 290 211.5 294.7 216.2L311.7 233.2C316.4 237.9 316.4 245.5 311.7 250.2L257.9 304 311.6 357.7C316.4 362.4 316.4 370 311.7 374.7zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z"}]}}),H.register({"regular/calendar":{width:448,height:512,paths:[{d:"M400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V112C448 85.5 426.5 64 400 64zM394 464H54C50.7 464 48 461.3 48 458V160H400V458C400 461.3 397.3 464 394 464z"}]}}),H.register({"regular/caret-square-down":{width:448,height:512,paths:[{d:"M125.1 208H322.9C333.6 208 339 221 331.4 228.5L232.5 326.8C227.8 331.5 220.3 331.5 215.6 326.8L116.7 228.5C109 221 114.4 208 125.1 208zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/caret-square-left":{width:448,height:512,paths:[{d:"M272 157.1V354.9C272 365.6 259 371 251.5 363.4L153.2 264.5C148.5 259.8 148.5 252.3 153.2 247.6L251.5 148.7C259 141 272 146.4 272 157.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/caret-square-right":{width:448,height:512,paths:[{d:"M176 354.9V157.1C176 146.4 189 141 196.5 148.6L294.8 247.5C299.5 252.2 299.5 259.7 294.8 264.4L196.5 363.3C189 371 176 365.6 176 354.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/caret-square-up":{width:448,height:512,paths:[{d:"M322.9 304H125.1C114.4 304 109 291 116.6 283.5L215.5 185.2C220.2 180.5 227.7 180.5 232.4 185.2L331.3 283.5C339 291 333.6 304 322.9 304zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/chart-bar":{width:512,height:512,paths:[{d:"M500 400C506.6 400 512 405.4 512 412V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H36C42.6 64 48 69.4 48 76V400H500zM144 340V268C144 261.4 138.6 256 132 256H108C101.4 256 96 261.4 96 268V340C96 346.6 101.4 352 108 352H132C138.6 352 144 346.6 144 340zM240 340V140C240 133.4 234.6 128 228 128H204C197.4 128 192 133.4 192 140V340C192 346.6 197.4 352 204 352H228C234.6 352 240 346.6 240 340zM336 340V204C336 197.4 330.6 192 324 192H300C293.4 192 288 197.4 288 204V340C288 346.6 293.4 352 300 352H324C330.6 352 336 346.6 336 340zM432 340V108C432 101.4 426.6 96 420 96H396C389.4 96 384 101.4 384 108V340C384 346.6 389.4 352 396 352H420C426.6 352 432 346.6 432 340z"}]}}),H.register({"regular/check-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 56C366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456 145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56M396.2 186.3L373.7 163.5C369 158.8 361.4 158.8 356.7 163.5L215.3 303.7 155.6 243.4C150.9 238.7 143.3 238.7 138.6 243.4L115.9 265.9C111.2 270.6 111.1 278.2 115.8 282.9L206.6 374.4C211.2 379.1 218.8 379.1 223.5 374.4L396.1 203.2C400.8 198.6 400.9 191 396.2 186.3z"}]}}),H.register({"regular/check-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM400 432H48V80H400V432zM364.1 190.3L191.5 361.5C186.8 366.1 179.2 366.1 174.6 361.4L83.8 269.9C79.1 265.2 79.2 257.6 83.9 252.9L106.6 230.4C111.3 225.7 118.9 225.8 123.6 230.5L183.3 290.7 324.7 150.5C329.4 145.9 337 145.9 341.7 150.6L364.2 173.3C368.9 178 368.8 185.6 364.1 190.3z"}]}}),H.register({"regular/circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456z"}]}}),H.register({"regular/clipboard":{width:384,height:512,paths:[{d:"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM330 464H54A6-6 0 0 0 48 458V118A6-6 0 0 0 54 112H96V148C96 154.6 101.4 160 108 160H276C282.6 160 288 154.6 288 148V112H330A6-6 0 0 0 336 118V458A6-6 0 0 0 330 464zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40"}]}}),H.register({"regular/clock":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM317.8 351.6L232.9 289.9C229.8 287.6 228 284 228 280.2V116C228 109.4 233.4 104 240 104H272C278.6 104 284 109.4 284 116V257.7L350.8 306.3C356.2 310.2 357.3 317.7 353.4 323.1L334.6 349C330.7 354.3 323.2 355.5 317.8 351.6z"}]}}),H.register({"regular/clone":{width:512,height:512,paths:[{d:"M464 0H144C117.5 0 96 21.5 96 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H464C490.5 416 512 394.5 512 368V48C512 21.5 490.5 0 464 0zM362 464H54A6-6 0 0 0 48 458V150A6-6 0 0 0 54 144H96V368C96 394.5 117.5 416 144 416H368V458A6-6 0 0 0 362 464zM458 368H150A6-6 0 0 0 144 362V54A6-6 0 0 0 150 48H458A6-6 0 0 0 464 54V362A6-6 0 0 0 458 368z"}]}}),H.register({"regular/closed-captioning":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM458 400H54C50.7 400 48 397.3 48 394V118C48 114.7 50.7 112 54 112H458C461.3 112 464 114.7 464 118V394C464 397.3 461.3 400 458 400zM246.9 314.3C248.6 316.7 248.4 319.9 246.4 322 192.8 378.8 73.6 354.1 73.6 254.1 73.6 156.8 195.3 134.6 246.1 184 248.2 186 248.6 187.2 247.1 189.7L229.6 220.2C227.7 223.3 223.4 224.2 220.5 221.9 179.7 189.9 125.9 207 125.9 253.1 125.9 301.1 176.9 323.6 218.1 285.7 220.9 283.2 225.2 283.6 227.3 286.6L246.9 314.3zM437.3 314.3C439 316.7 438.8 319.9 436.8 322 383.2 378.9 264 354.1 264 254.1 264 156.8 385.7 134.6 436.5 184 438.6 186 439 187.2 437.5 189.7L420 220.2C418.1 223.3 413.8 224.2 410.9 221.9 370.1 189.9 316.3 207 316.3 253.1 316.3 301.1 367.3 323.6 408.5 285.7 411.3 283.2 415.6 283.6 417.7 286.6L437.3 314.3z"}]}}),H.register({"regular/comment-alt":{width:512,height:512,paths:[{d:"M448 0H64C28.7 0 0 28.7 0 64V352C0 387.3 28.7 416 64 416H160V500C160 507.1 165.8 512 172 512 174.4 512 176.9 511.3 179.1 509.6L304 416H448C483.3 416 512 387.3 512 352V64C512 28.7 483.3 0 448 0zM464 352C464 360.8 456.8 368 448 368H288L275.2 377.6 208 428V368H64C55.2 368 48 360.8 48 352V64C48 55.2 55.2 48 64 48H448C456.8 48 464 55.2 464 64V352z"}]}}),H.register({"regular/comment":{width:512,height:512,paths:[{d:"M256 32C114.6 32 0 125.1 0 240 0 287.6 19.9 331.2 52.9 366.3 38 405.7 7 439.1 6.5 439.5-0.1 446.5-1.9 456.7 1.9 465.5S14.4 480 24 480C85.5 480 134 454.3 163.1 433.7 192 442.8 223.2 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM256 400C229.3 400 202.9 395.9 177.6 387.9L154.9 380.7 135.4 394.5C121.1 404.6 101.5 415.9 77.9 423.5 85.2 411.4 92.3 397.8 97.8 383.3L108.4 355.2 87.8 333.4C69.7 314.1 48 282.2 48 240 48 151.8 141.3 80 256 80S464 151.8 464 240 370.7 400 256 400z"}]}}),H.register({"regular/comments":{width:576,height:512,paths:[{d:"M532 386.2C559.5 359.1 576 325.1 576 288 576 208 499.5 141.9 399.8 130.1 368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192 0 229 16.5 263 44 290.2 28.7 320.9 6.7 344.7 6.3 345.1 0 351.8-1.8 361.6 1.9 370.1 5.5 378.6 13.9 384.1 23.1 384.1 76.6 384.1 119.8 363.9 148.3 345.3 157.5 347.4 167 349 176.7 350.2 208.1 407.6 281.8 448 368 448 388.8 448 408.8 445.6 427.8 441.2 456.3 459.7 499.4 480 553 480 562.2 480 570.5 474.5 574.2 466 577.8 457.5 576.1 447.7 569.8 441 569.4 440.7 547.3 416.9 532 386.2zM139.2 293.9L122.1 305C108 314.1 93.6 321.3 79 326.4 81.7 321.7 84.4 316.7 87 311.6L102.5 280.5 77.7 256C64.2 242.6 48 220.7 48 192 48 131.3 121.3 80 208 80S368 131.3 368 192 294.7 304 208 304C191.5 304 175 302.1 159 298.4L139.2 293.9zM498.3 352L473.6 376.4 489.1 407.5C491.7 412.6 494.4 417.6 497.1 422.3 482.5 417.2 468.1 410 454 400.9L436.9 389.8 417 394.4C401 398.1 384.5 400 368 400 314 400 265.8 379.9 236.7 350.3 338 339.5 416 272.9 416 192 416 188.6 415.6 185.3 415.3 182 479.7 196.5 528 238.8 528 288 528 316.7 511.8 338.6 498.3 352z"}]}}),H.register({"regular/compass":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM347.3 143.9L314 281.6A24-24 0 0 0 307.2 293.4L204.6 391.2C187.5 407.4 159 391.6 164.7 368.1L198 230.4A24-24 0 0 0 204.8 218.6L307.4 120.8C324.7 104.4 352.9 120.7 347.3 143.9zM256 224C238.3 224 224 238.3 224 256S238.3 288 256 288 288 273.7 288 256 273.7 224 256 224z"}]}}),H.register({"regular/copy":{width:448,height:512,paths:[{d:"M433.9 65.9L382.1 14.1A48-48 0 0 1 348.1 0H176C149.5 0 128 21.5 128 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V416H400C426.5 416 448 394.5 448 368V99.9A48-48 0 0 1 433.9 65.9zM266 464H54A6-6 0 0 0 48 458V150A6-6 0 0 0 54 144H128V368C128 394.5 149.5 416 176 416H272V458A6-6 0 0 0 266 464zM394 368H182A6-6 0 0 0 176 362V54A6-6 0 0 0 182 48H288V136C288 149.3 298.7 160 312 160H400V362A6-6 0 0 0 394 368zM400 112H336V48H345.6C347.2 48 348.7 48.6 349.9 49.8L398.2 98.1A6-6 0 0 0 400 102.4V112z"}]}}),H.register({"regular/copyright":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM363.4 354.9C353.7 364.6 317.8 396.3 259.3 396.3 176.9 396.3 118.8 334.9 118.8 254.8 118.8 175.6 179.1 115.4 258.6 115.4 314.1 115.4 347.3 142 356.2 150.1A12-12 0 0 0 358.1 165.5L339.9 193.6C336.1 199.5 328 200.9 322.4 196.5 313.8 189.7 290.6 174 260.7 174 212.4 174 182.8 209.3 182.8 254 182.8 295.6 209.7 337.7 261.1 337.7 293.7 337.7 317.9 318.7 326.8 310.5 332.1 305.7 340.4 306.5 344.6 312.2L364.5 339.4A11.9-11.9 0 0 0 363.4 354.9z"}]}}),H.register({"regular/credit-card":{width:576,height:512,paths:[{d:"M527.9 32H48.1C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48.1 480H527.9C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 527.9 32zM54.1 80H521.9C525.2 80 527.9 82.7 527.9 86V128H48.1V86C48.1 82.7 50.8 80 54.1 80zM521.9 432H54.1C50.8 432 48.1 429.3 48.1 426V256H527.9V426C527.9 429.3 525.2 432 521.9 432zM192 332V372C192 378.6 186.6 384 180 384H108C101.4 384 96 378.6 96 372V332C96 325.4 101.4 320 108 320H180C186.6 320 192 325.4 192 332zM384 332V372C384 378.6 378.6 384 372 384H236C229.4 384 224 378.6 224 372V332C224 325.4 229.4 320 236 320H372C378.6 320 384 325.4 384 332z"}]}}),H.register({"regular/dot-circle":{width:512,height:512,paths:[{d:"M256 56C366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456 145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 176C211.8 176 176 211.8 176 256S211.8 336 256 336 336 300.2 336 256 300.2 176 256 176z"}]}}),H.register({"regular/edit":{width:576,height:512,paths:[{d:"M402.3 344.9L434.3 312.9C439.3 307.9 448 311.4 448 318.6V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H321.5C328.6 64 332.2 72.6 327.2 77.7L295.2 109.7C293.7 111.2 291.7 112 289.5 112H48V464H400V350.5C400 348.4 400.8 346.4 402.3 344.9zM558.9 143.1L296.3 405.7 205.9 415.7C179.7 418.6 157.4 396.5 160.3 370.1L170.3 279.7 432.9 17.1C455.8-5.8 492.8-5.8 515.6 17.1L558.8 60.3C581.7 83.2 581.7 120.3 558.9 143.1zM460.1 174L402 115.9 216.2 301.8 208.9 367.1 274.2 359.8 460.1 174zM524.9 94.3L481.7 51.1C477.6 47 470.9 47 466.9 51.1L436 82 494.1 140.1 525 109.2C529 105 529 98.4 524.9 94.3z"}]}}),H.register({"regular/envelope-open":{width:512,height:512,paths:[{d:"M494.6 164.5C489.9 160.6 382.9 74.6 359.3 55.9 337.2 38.2 299.4 0 256 0 212.8 0 175.4 37.7 152.7 55.9 128.2 75.3 21.6 161.1 17.5 164.4A48-48 0 0 1 0 201.5V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V201.5A48-48 0 0 1 494.6 164.5zM464 458A6-6 0 0 0 458 464H54A6-6 0 0 0 48 458V204.3C48 202.5 48.8 200.8 50.2 199.7 66.1 186.9 159 112.1 182.6 93.4 200.8 78.9 232.4 48 256 48 279.7 48 311.9 79.4 329.4 93.4 353 112.1 445.9 186.9 461.8 199.7A6-6 0 0 0 464 204.4V458zM432 270.3C436.3 275.5 435.5 283.1 430.3 287.3 401.3 310.6 371 334.9 359.3 344.1 336.6 362.3 299.2 400 256 400 212.5 400 174.7 361.8 152.7 344.1 141.4 335.2 110.9 310.7 81.7 287.3 76.5 283.1 75.7 275.5 80 270.3L95.3 251.8C99.4 246.7 106.9 245.9 112 250 140.6 273 170.6 297.1 182.6 306.6 200.1 320.6 232.3 352 256 352 279.6 352 311.2 321.1 329.4 306.6 341.4 297.1 371.4 273 400 250 405.1 245.9 412.6 246.7 416.8 251.8L432 270.3z"}]}}),H.register({"regular/envelope":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM464 112V152.8C441.6 171.1 405.8 199.5 329.4 259.3 312.6 272.5 279.2 304.4 256 304 232.8 304.4 199.4 272.5 182.6 259.3 106.2 199.5 70.4 171.1 48 152.8V112H464zM48 400V214.4C70.9 232.6 103.4 258.3 152.9 297 174.8 314.2 213.1 352.2 256 352 298.7 352.2 336.5 314.8 359.1 297.1 408.6 258.3 441.1 232.7 464 214.4V400H48z"}]}}),H.register({"regular/eye-slash":{width:576,height:512,paths:[{d:"M272.7 359.1C192.2 350.1 136.5 272.3 155.8 192.1L272.7 359.1zM288 392C185.4 392 95.9 337.3 48 256 69.8 219.1 100.1 187.7 136.3 164.3L108.8 125C67 152.2 31.9 188.7 6.6 231.6A48-48 0 0 1 6.6 280.4C63 376 168.1 440 288 440A332.9-332.9 0 0 1 327.6 437.6L295.6 391.9A284.2-284.2 0 0 0 288 392zM569.4 280.4C536.1 336.8 485.9 382.1 425.8 409.9L473.9 478.6C477.7 484 476.4 491.5 471 495.3L450.2 509.8C444.8 513.6 437.3 512.3 433.5 506.9L102.1 33.4C98.3 28 99.6 20.5 105 16.7L125.8 2.2C131.2-1.6 138.7-0.3 142.5 5.1L198 84.4C226.6 76.3 256.8 72 288 72 407.9 72 513 136 569.4 231.6A48-48 0 0 0 569.4 280.4zM528 256C483.8 181.1 404.3 128.7 311.8 121 302 131.1 296 144.8 296 160 296 190.9 321.1 216 352 216S408 190.9 408 160L408 160C438.6 217.2 424.7 290.2 371.1 331.7L397.8 369.8C452.6 346.6 498.3 306.4 528 256z"}]}}),H.register({"regular/file-alt":{width:384,height:512,paths:[{d:"M288 248V276C288 282.6 282.6 288 276 288H108C101.4 288 96 282.6 96 276V248C96 241.4 101.4 236 108 236H276C282.6 236 288 241.4 288 248zM276 320H108C101.4 320 96 325.4 96 332V360C96 366.6 101.4 372 108 372H276C282.6 372 288 366.6 288 360V332C288 325.4 282.6 320 276 320zM384 131.9V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V48C0 21.5 21.5 0 48 0H252.1C264.8 0 277 5.1 286 14.1L369.9 98C378.9 106.9 384 119.2 384 131.9zM256 51.9V128H332.1L256 51.9zM336 464V176H232C218.7 176 208 165.3 208 152V48H48V464H336z"}]}}),H.register({"regular/file-archive":{width:384,height:512,paths:[{d:"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM256 51.9L332.1 128H256V51.9zM336 464H48V48H127.7V64H159.7V48H208V152C208 165.3 218.7 176 232 176H336V464zM192.3 96H160.3V64H192.3V96zM160.3 96V128H128.3V96H160.3zM160.3 160V192H128.3V160H160.3zM192.3 160H160.3V128H192.3V160zM194.2 265.7A12-12 0 0 1 182.4 256H160.3V224H128.3V256L108.6 353.1C102 385.6 126.8 416 160 416 193.1 416 217.9 385.8 211.5 353.4L194.2 265.7zM160.3 390.1C142.4 390.1 127.8 378 127.8 363 127.8 348.1 142.4 336 160.3 336S192.7 348.1 192.7 363C192.7 378 178.2 390.1 160.3 390.1zM192.3 224H160.3V192H192.3V224z"}]}}),H.register({"regular/file-audio":{width:384,height:512,paths:[{d:"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM192 388C192 398.7 179.1 404 171.5 396.5L136 360.5H108C101.4 360.5 96 355.1 96 348.5V292.5C96 285.9 101.4 280.5 108 280.5H136L171.5 243.5C179.1 236 192 241.3 192 252V388zM233.2 340.8C242.3 331.5 242.3 316.7 233.2 307.4 211.1 284.7 245.4 251.2 267.6 273.9 294.8 301.9 294.8 346.4 267.6 374.3 245.8 396.7 210.7 364 233.2 340.8z"}]}}),H.register({"regular/file-code":{width:384,height:512,paths:[{d:"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM149.7 348.9L116.9 320 149.7 291.1A8.8-8.8 0 0 1 150.3 278.5L132.9 259.9C129.5 256.3 123.9 256.3 120.4 259.5L62.8 313.6C59.1 317.1 59.1 322.9 62.8 326.4L120.4 380.5A8.7-8.7 0 0 1 126.5 382.9 8.7-8.7 0 0 1 132.9 380.1L150.3 361.5A8.8-8.8 0 0 1 149.7 348.9zM234 221L209.6 214A8.8-8.8 0 0 1 198.7 219.9L144 408.1C142.7 412.7 145.4 417.6 150 419L174.4 426.1C179.1 427.4 184 424.7 185.3 420.1L240 231.9C241.3 227.3 238.6 222.4 234 221zM321.2 313.6L263.6 259.5C260 256.2 254.5 256.4 251.1 259.9L233.7 278.5A8.8-8.8 0 0 1 234.3 291.1L267.1 320 234.3 348.9A8.8-8.8 0 0 1 233.7 361.5L251.1 380.1A8.8-8.8 0 0 1 263.6 380.5H263.6L321.2 326.4C324.9 322.9 324.9 317.1 321.2 313.6z"}]}}),H.register({"regular/file-excel":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM260 224H231.2C226.8 224 222.8 226.4 220.7 230.3 202.7 263.4 198.5 272.7 192.1 288 178.2 258.9 185.2 270.7 163.5 230.3 161.4 226.4 157.3 224 152.9 224H124C114.7 224 109 234 113.6 242L159.9 320 113.6 398C108.9 406 114.7 416 124 416H152.9C157.3 416 161.3 413.6 163.4 409.7 185.1 369.7 186.4 364.7 192 352 206.9 382.2 197.9 367.9 220.6 409.7 222.7 413.6 226.8 416 231.2 416H260C269.3 416 275 406 270.4 398L224 320C224.7 318.9 254.3 269.5 270.3 242 275 234 269.2 224 260 224z"}]}}),H.register({"regular/file-image":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM80 416H304V288L280.5 264.5C275.8 259.8 268.2 259.8 263.5 264.5L176 352 136.5 312.5C131.8 307.8 124.2 307.8 119.5 312.5L80 352V416zM128 176C101.5 176 80 197.5 80 224S101.5 272 128 272 176 250.5 176 224 154.5 176 128 176z"}]}}),H.register({"regular/file-pdf":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM298.2 320.3C286 308.3 251.2 311.6 233.8 313.8 216.6 303.3 205.1 288.8 197 267.5 200.9 251.4 207.1 226.9 202.4 211.5 198.2 185.3 164.6 187.9 159.8 205.6 155.4 221.7 159.4 244.1 166.8 272.7 156.8 296.6 141.9 328.7 131.4 347.1 111.4 357.4 84.4 373.3 80.4 393.3 77.1 409.1 106.4 448.5 156.5 362.1 178.9 354.7 203.3 345.6 224.9 342 243.8 352.2 265.9 359 280.7 359 306.2 359 308.7 330.8 298.2 320.3zM100.1 398.1C105.2 384.4 124.6 368.6 130.5 363.1 111.5 393.4 100.1 398.8 100.1 398.1zM181.7 207.5C189.1 207.5 188.4 239.6 183.5 248.3 179.1 234.4 179.2 207.5 181.7 207.5zM157.3 344.1C167 327.2 175.3 307.1 182 289.4 190.3 304.5 200.9 316.6 212.1 324.9 191.3 329.2 173.2 338 157.3 344.1zM288.9 339.1S283.9 345.1 251.6 331.3C286.7 328.7 292.5 336.7 288.9 339.1z"}]}}),H.register({"regular/file-powerpoint":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM120 404V236C120 229.4 125.4 224 132 224H201.2C237.9 224 264 251 264 290.3 264 364.6 195.3 356.8 168.5 356.8V404C168.5 410.6 163.1 416 156.5 416H132C125.4 416 120 410.6 120 404zM168.5 316.6H191.5C199.4 316.6 205.4 314.2 209.6 309.4 218.1 299.6 218 280.9 209.7 271.6 205.6 267 199.8 264.6 192.3 264.6H168.4V316.6z"}]}}),H.register({"regular/file-video":{width:384,height:512,paths:[{d:"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM276.7 252.7L224 305.4V268C224 257 215 248 204 248H100C89 248 80 257 80 268V372C80 383 89 392 100 392H204C215 392 224 383 224 372V334.6L276.7 387.3C286.7 397.3 304 390.3 304 376V264C304 249.7 286.7 242.7 276.7 252.7z"}]}}),H.register({"regular/file-word":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM268.1 256C262.4 256 257.5 260 256.4 265.5 235.8 363.2 236 360.9 235.4 369 235.2 367.8 235 366.4 234.7 364.7 233.9 359.6 235 364.9 211.1 265.2 209.8 259.8 205 256 199.4 256H186.1C180.6 256 175.8 259.8 174.4 265.1 150 364.1 150.4 361.3 149.6 368.8 149.5 367.7 149.4 366.3 149.1 364.6 148.4 359.4 135 291.3 130 265.6 128.9 260 124 255.9 118.2 255.9H101.4C93.6 255.9 87.9 263.2 89.7 270.7 97.7 303.3 116.4 380.2 122.9 406.7 124.2 412.1 129 415.8 134.6 415.8H159.8C165.3 415.8 170.1 412.1 171.4 406.7L189.3 335.3C190.8 329.1 191.8 323.3 192.3 318L195.2 335.3C195.3 335.7 207.8 385.8 213.1 406.7 214.4 412 219.2 415.8 224.7 415.8H249.4C254.9 415.8 259.7 412.1 261 406.7 281.8 324.8 291.2 287.7 295.5 270.7 297.4 263.1 291.7 255.8 283.9 255.8H268.1z"}]}}),H.register({"regular/file":{width:384,height:512,paths:[{d:"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48z"}]}}),H.register({"regular/flag":{width:512,height:512,paths:[{d:"M336.2 80C287 80 242.9 48 174.3 48 143 48 116 54.5 93.5 63.2A48-48 0 0 1 95.7 42.4C93.1 19.6 74.2 1.6 51.2 0.1 23.2-1.7 0 20.4 0 48 0 65.8 9.7 81.3 24 89.6V496C24 504.8 31.2 512 40 512H56C64.8 512 72 504.8 72 496V412.6C109.9 395.3 143.3 384 199.8 384 249 384 293.1 416 361.7 416 420.2 416 463.7 393.4 490.3 376 503.8 367.2 512 352.1 512 335.9V95.9C512 61.5 476.7 38.2 445.1 51.8 409.2 67.3 371.6 80 336.2 80zM464 336C442.2 351.4 403.2 368 361.7 368 301.8 368 259.7 336 199.8 336 156.5 336 103.4 345.4 72 360V128C93.8 112.6 132.8 96 174.3 96 234.2 96 276.3 128 336.2 128 379.4 128 432.5 110.6 464 96V336z"}]}}),H.register({"regular/folder-open":{width:576,height:512,paths:[{d:"M527.9 224H480V176C480 149.5 458.5 128 432 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H448A48-48 0 0 1 488.7 425.4L568.6 297.4C588.6 265.5 565.6 224 527.9 224zM54 112H188.1L252.1 176H426A6-6 0 0 0 432 182V224H152A48-48 0 0 1 110.9 247.2L48 351.4V118A6-6 0 0 0 54 112zM448 400H72L149.2 272H528L448 400z"}]}}),H.register({"regular/folder":{width:512,height:512,paths:[{d:"M464 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128zM458 400H54C50.7 400 48 397.3 48 394V118A6-6 0 0 0 54 112H188.1L252.1 176H458A6-6 0 0 0 464 182V394A6-6 0 0 0 458 400z"}]}}),H.register({"regular/frown":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176zM248 304C207.8 304 170 321.7 144.2 352.6 135.7 362.8 137.1 377.9 147.3 386.4 157.5 394.9 172.6 393.5 181.1 383.3 197.7 363.4 222.1 351.9 248 351.9S298.3 363.3 314.9 383.3C319.7 389 326.5 391.9 333.4 391.9 338.8 391.9 344.3 390.1 348.8 386.3 359 377.8 360.3 362.7 351.9 352.5 326 321.7 288.2 304 248 304z"}]}}),H.register({"regular/futbol":{width:496,height:512,paths:[{d:"M483.8 179.4C449.8 74.6 352.6 8 248.1 8 222.7 8 196.9 11.9 171.4 20.2 41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504 273.3 504 299.1 500.1 324.6 491.8 454.8 449.5 526.1 309.6 483.8 179.4zM409.3 373.1L357.1 379.5 313.4 318.6 337.8 243.4 408.9 221.3 447.8 257.7C447.6 288.4 440.4 318.8 426.1 346.9 421.4 356.2 415.4 364.7 409.3 373.1zM409.3 137.7L398.9 190.8 328.2 212.8 264 166.3V92.5L311.4 66.3C350.6 79.3 384.8 104.3 409.3 137.7zM184.9 66.4L232 92.5V166.3L167.8 212.8 97.2 190.8 87.1 138.3C111.4 104.9 145 79.7 184.9 66.4zM139 379.5L85.9 373C71.5 352.9 48.6 313.4 48.1 257.7L87.1 221.3 158.2 243.5 182.5 317.8 139 379.5zM187.2 446.5L164.8 398.4 208.4 336.7H287L331.3 398.4 308.9 446.5C302.7 448.3 251.3 466.9 187.2 446.5z"}]}}),H.register({"regular/gem":{width:576,height:512,paths:[{d:"M464 0H112C108 0 104.2 2 102 5.4L2 152.6C-0.9 157-0.6 162.8 2.7 166.8L278.7 507.6C283.5 513.5 292.5 513.5 297.3 507.6L573.3 166.8C576.6 162.7 576.9 157 574 152.6L474.1 5.4C471.8 2 468.1 0 464 0zM444.7 48L508 144H439.6L387.9 48H444.7zM242.6 48H333.3L385 144H191L242.6 48zM131.3 48H188.1L136.4 144H68L131.3 48zM88.3 192H139.7L208 352 88.3 192zM191.2 192H384.8L288 435.3 191.2 192zM368 352L436.2 192H487.6L368 352z"}]}}),H.register({"regular/hand-lizard":{width:576,height:512,paths:[{d:"M556.7 290.5L410.3 64.8C397 44.3 374.4 32 349.9 32H56C25.1 32 0 57.1 0 88V96C0 140.1 35.9 176 80 176H276L257.7 224H144C95.5 224 56 263.5 56 312 56 342.9 81.1 368 112 368H243.6C246.5 368 249.5 368.5 252.2 369.6L352 408.4V480H576V355.8C576 332.6 569.3 310 556.7 290.5zM528 432H400V408.4C400 388.5 388 370.9 369.4 363.7L269.6 324.9A71.7-71.7 0 0 1 243.6 320H112C107.6 320 104 316.4 104 312 104 289.9 121.9 272 144 272H257.7C277.5 272 295.5 259.6 302.5 241.1L327.1 176.8C336.1 153.3 318.7 128 293.5 128H80C62.4 128 48 113.6 48 96V88C48 83.6 51.6 80 56 80H349.9C358.1 80 365.6 84.1 370.1 90.9L516.4 316.7A71.8-71.8 0 0 0 528 355.8V432z"}]}}),H.register({"regular/hand-paper":{width:448,height:512,paths:[{d:"M372.6 112.6V101.8C372.6 58.2 332.1 25.1 289.5 36.3 263.9-13.2 195.4-11.2 171.5 37 130.3 26.5 89.1 57.9 89.1 102V228.1C69.2 220.7 45.8 223.1 27.1 237-2.3 258.8-8.7 300.3 12.5 330.2L132.5 498.6A32-32 0 0 1 158.5 512H381.4C396.3 512 409.3 501.7 412.6 487.2L442.8 356.2A203.6-203.6 0 0 1 448 310.6V179C448 138.4 412.5 107 372.6 112.6zM400 310.6C400 322.3 398.7 334 396 345.4L368.7 464H166.8L51.6 302.3C37.2 282 66.6 259.5 81 279.7L108.1 317.8C117.1 330.4 137.1 324.1 137.1 308.5V102C137.1 76.4 173.7 77.2 173.7 102.7V256C173.7 264.8 180.9 272 189.7 272H196.6C205.4 272 212.6 264.8 212.6 256V67C212.6 41.3 249.1 42.2 249.1 67.7V256C249.1 264.8 256.3 272 265.1 272H272C280.8 272 288 264.8 288 256V101.1C288 75.5 324.6 76.3 324.6 101.8V256C324.6 264.8 331.7 272 340.6 272H347.4C356.3 272 363.4 264.8 363.4 256V179.7C363.4 153.4 400 154.1 400 179V310.6z"}]}}),H.register({"regular/hand-peace":{width:448,height:512,paths:[{d:"M362.1 192C348.4 170.3 323.4 158 297.1 161.6V74C297.1 33.2 264.3 0 224 0 183.7 0 150.9 33.2 150.9 74L160 168 141.3 89.1C126.6 50.8 83.8 32.1 46.2 47.2 8.7 62.2-9.6 105 5 142.9L60.8 287.8C30.2 312.7 16.8 345.6 36 380L90.9 478C102.6 499 124.7 512 148.6 512H354.3C385 512 411.8 490.6 418.8 460.2L446.3 341.2A67.8-67.8 0 0 1 448 326L448 256C448 211 404.7 178.7 362.1 192zM400 326C400 327.5 399.8 329 399.5 330.4L372.1 449.4C370.1 458 362.8 464 354.3 464H148.6C142.1 464 136 460.4 132.8 454.6L77.9 356.6C73.4 348.4 75.3 337.9 82.4 332.1L109.1 310.3A16-16 0 0 1 113.9 292.2L49.8 125.6C37.2 93 84.4 74.8 96.5 106.4L156.3 261.7A16-16 0 0 1 171.2 272H182.9C191.7 272 198.9 264.8 198.9 256V74C198.9 39.6 249.1 39.6 249.1 74V256C249.1 264.8 256.3 272 265.1 272H272C280.8 272 288 264.8 288 256V228C288 202.9 324.6 202.8 324.6 228V256C324.6 264.8 331.7 272 340.6 272H347.4C356.3 272 363.4 264.8 363.4 256 363.4 230.9 400 230.8 400 256V326z"}]}}),H.register({"regular/hand-point-down":{width:448,height:512,paths:[{d:"M188.8 512C234.4 512 272 474.2 272 428.8V393.2A93.1-93.1 0 0 1 294.1 385.2C316.1 387.7 339 381.7 356.9 369.2 409.3 368.1 448 331.8 448 269.3V248C448 187.9 408 149.5 408 120.8V118.1C413 112.4 416 104.6 416 96V32C416 14.3 403.1 0 387.2 0H156.8C140.9 0 128 14.3 128 32V96C128 104.6 131 112.4 136 118.1V120.8C136 127.8 129.8 135.7 112.3 151L112.2 151.1 112 151.2C102.1 160.1 91.2 169.4 78.8 177.1 48.5 195.8 0 207.5 0 252.8 0 309.7 35.3 344.8 83.2 344.8 91.2 344.8 98.7 344 105.6 342.6V428.8C105.6 473.9 143.7 512 188.8 512zM188.8 464C170.1 464 153.6 447.2 153.6 428.8V270.4C136.3 270.4 118.4 296.8 83.2 296.8 56.8 296.8 48 276.2 48 252.8 48 244 80.7 232.4 104.1 217.9 118.7 208.8 131.3 198.3 144 187.1 162.3 171 180.6 153.2 183.6 128H360.3C364.1 170.8 400 202.5 400 248V269.3C400 309.8 377.8 326.4 338.7 319.9 330.7 334.5 304.7 344.1 285.1 332.8 266.8 352.2 238.7 350.6 224 337.8V428.8C224 447.8 207.8 464 188.8 464zM328 64C328 50.7 338.7 40 352 40S376 50.7 376 64 365.3 88 352 88 328 77.3 328 64z"}]}}),H.register({"regular/hand-point-left":{width:512,height:512,paths:[{d:"M0 220.8C0 266.4 37.8 304 83.2 304H118.8A93.1-93.1 0 0 1 126.8 326.1C124.3 348.1 130.3 371 142.8 388.9 143.9 441.3 180.2 480 242.7 480H264C324.1 480 362.5 440 391.2 440H393.9C399.6 445 407.4 448 416 448H480C497.7 448 512 435.1 512 419.2V188.8C512 172.9 497.7 160 480 160H416C407.4 160 399.6 163 393.9 168H391.2C384.2 168 376.3 161.8 361 144.3L360.9 144.2 360.8 144C351.9 134.1 342.6 123.2 334.9 110.8 316.2 80.5 304.5 32 259.2 32 202.3 32 167.2 67.3 167.2 115.2 167.2 123.2 168 130.7 169.4 137.6H83.2C38.1 137.6 0 175.7 0 220.8zM48 220.8C48 202.1 64.8 185.6 83.2 185.6H241.6C241.6 168.3 215.2 150.4 215.2 115.2 215.2 88.8 235.8 80 259.2 80 268 80 279.6 112.7 294.1 136.1 303.2 150.7 313.7 163.3 324.9 176 341 194.3 358.8 212.6 384 215.6V392.3C341.2 396.1 309.5 432 264 432H242.7C202.2 432 185.6 409.8 192.1 370.7 177.5 362.7 167.9 336.7 179.2 317.1 159.8 298.8 161.4 270.7 174.2 256H83.2C64.2 256 48 239.8 48 220.8zM448 360C461.3 360 472 370.7 472 384S461.3 408 448 408 424 397.3 424 384 434.7 360 448 360z"}]}}),H.register({"regular/hand-point-right":{width:512,height:512,paths:[{d:"M428.8 137.6H342.6A115.5-115.5 0 0 1 344.8 115.2C344.8 67.3 309.7 32 252.8 32 207.5 32 195.8 80.5 177.1 110.8 169.4 123.2 160.1 134.1 151.2 144L151.1 144.2 151 144.3C135.7 161.8 127.8 168 120.8 168H118.1C112.4 163 104.6 160 96 160H32C14.3 160 0 172.9 0 188.8V419.2C0 435.1 14.3 448 32 448H96C104.6 448 112.4 445 118.1 440H120.8C149.5 440 187.9 480 248 480H269.3C331.8 480 368.1 441.3 369.2 388.9 381.7 371 387.7 348.1 385.2 326.1A93.1-93.1 0 0 1 393.2 304H428.8C474.2 304 512 266.4 512 220.8 512 175.7 473.9 137.6 428.8 137.6zM428.8 256H337.8C350.6 270.7 352.2 298.8 332.8 317.1 344.1 336.7 334.5 362.7 319.9 370.7 326.4 409.8 309.8 432 269.3 432H248C202.5 432 170.8 396.1 128 392.3V215.6C153.2 212.6 171 194.3 187.1 176 198.3 163.3 208.8 150.7 217.9 136.1 232.4 112.7 244 80 252.8 80 276.2 80 296.8 88.8 296.8 115.2 296.8 150.4 270.4 168.3 270.4 185.6H428.8C447.2 185.6 464 202.1 464 220.8 464 239.8 447.8 256 428.8 256zM88 384C88 397.3 77.3 408 64 408S40 397.3 40 384 50.7 360 64 360 88 370.7 88 384z"}]}}),H.register({"regular/hand-point-up":{width:448,height:512,paths:[{d:"M105.6 83.2V169.4A115.5-115.5 0 0 1 83.2 167.2C35.3 167.2 0 202.3 0 259.2 0 304.5 48.5 316.2 78.8 334.9 91.2 342.6 102.1 351.9 112 360.8L112.2 360.9 112.3 361C129.8 376.3 136 384.2 136 391.2V393.9C131 399.6 128 407.4 128 416V480C128 497.7 140.9 512 156.8 512H387.2C403.1 512 416 497.7 416 480V416C416 407.4 413 399.6 408 393.9V391.2C408 362.5 448 324.1 448 264V242.7C448 180.2 409.3 143.9 356.9 142.8 339 130.3 316.1 124.3 294.1 126.8A93.1-93.1 0 0 1 272 118.8V83.2C272 37.8 234.4 0 188.8 0 143.7 0 105.6 38.1 105.6 83.2zM224 83.2V174.2C238.7 161.4 266.8 159.8 285.1 179.2 304.7 167.9 330.7 177.5 338.7 192.1 377.8 185.6 400 202.2 400 242.7V264C400 309.5 364.1 341.2 360.3 384H183.6C180.6 358.8 162.3 341 144 324.9 131.3 313.6 118.7 303.2 104.1 294.1 80.7 279.6 48 268 48 259.2 48 235.8 56.8 215.2 83.2 215.2 118.4 215.2 136.3 241.6 153.6 241.6V83.2C153.6 64.8 170.1 48 188.8 48 207.8 48 224 64.2 224 83.2zM352 424C365.3 424 376 434.7 376 448S365.3 472 352 472 328 461.3 328 448 338.7 424 352 424z"}]}}),H.register({"regular/hand-pointer":{width:448,height:512,paths:[{d:"M358.2 179.4C338.7 154.6 305.5 147.4 278.3 160.3 263.2 144.6 242.1 137.8 221.7 140.6V67C221.7 30.1 192 0 155.4 0S89.1 30.1 89.1 67V228.1C69.2 220.7 45.9 223 27.1 237-2.3 258.8-8.7 300.3 12.5 330.2L122.2 484.2C134.6 501.6 154.7 512 176 512H354.3C385.1 512 411.9 490.5 418.8 460.2L446.3 341.2A67.9-67.9 0 0 1 448 326V242C448 195.2 401.4 162.7 358.2 179.4zM81 279.7L108.1 317.8C117.1 330.4 137.1 324.1 137.1 308.5V67C137.1 41.9 173.7 41.8 173.7 67V242C173.7 250.8 180.9 258 189.7 258H196.6C205.4 258 212.6 250.8 212.6 242V207C212.6 181.9 249.1 181.8 249.1 207V242C249.1 250.8 256.3 258 265.1 258H272C280.8 258 288 250.8 288 242V221C288 195.9 324.6 195.8 324.6 221V242C324.6 250.8 331.7 258 340.6 258H347.4C356.3 258 363.4 250.8 363.4 242 363.4 216.9 400 216.8 400 242V326C400 327.5 399.8 329 399.5 330.4L372.1 449.4C370.1 458 362.8 464 354.3 464H176C170.2 464 164.7 461.1 161.3 456.3L51.6 302.3C37.2 282.1 66.6 259.5 81 279.7zM176.1 400V304C176.1 295.2 182.4 288 190.1 288H196.1C203.9 288 210.1 295.2 210.1 304V400C210.1 408.8 203.9 416 196.1 416H190.1C182.4 416 176.1 408.8 176.1 400zM251.6 400V304C251.6 295.2 257.8 288 265.6 288H271.6C279.3 288 285.6 295.2 285.6 304V400C285.6 408.8 279.3 416 271.6 416H265.6C257.8 416 251.6 408.8 251.6 400zM327 400V304C327 295.2 333.3 288 341 288H347C354.7 288 361 295.2 361 304V400C361 408.8 354.7 416 347 416H341C333.3 416 327 408.8 327 400z"}]}}),H.register({"regular/hand-rock":{width:512,height:512,paths:[{d:"M408.9 79.1C386.5 45.2 342.8 36.8 310.1 55.5 280.6 24 230.9 24.4 201.7 55.4 154.6 28.4 93 60.5 91 116.2 44.8 105.4 0 140 0 187.4V244.4C0 277.1 14.3 308.3 39.2 330L136.9 415.1C141.1 418.8 140 420.7 140 448 140 465.7 154.3 480 172 480H424C441.7 480 456 465.7 456 448 456 424.5 455 417.3 460 405.6L502.8 306C508.9 291.8 512 276.8 512 261.4V147C512 94.1 457.7 58.3 408.9 79.1zM464 261.4A64.5-64.5 0 0 0 458.7 287L415.9 386.7C410.7 398.8 408 411.7 408 424.9V432H188V421.7C188 405.3 180.9 389.7 168.4 378.9L70.7 293.8C56.3 281.3 48 263.2 48 244.4V187.4C48 154.2 100 153.9 100 188.1V229.3A16-16 0 0 1 105.5 241.4L112.5 247.5A16-16 0 0 1 139 235.4V118.9C139 85.8 191 85.1 191 119.5V146.3C191 155.1 198.2 162.3 207 162.3H214C222.8 162.3 230 155.1 230 146.3V105.1C230 72 282 71.5 282 105.8V146.3C282 155.1 289.2 162.3 298 162.3H305C313.8 162.3 321 155.1 321 146.3V118.9C321 85.8 373 85.1 373 119.5V146.3C373 155.1 380.2 162.3 389 162.3H396C404.8 162.3 412 155.1 412 146.3 412 113.1 464 112.7 464 147V261.4z"}]}}),H.register({"regular/hand-scissors":{width:512,height:512,paths:[{d:"M256 480L326 480C331.1 480 336.2 479.4 341.2 478.3L460.2 450.8C490.6 443.8 512 417 512 386.3V180.6C512 156.7 499 134.6 478 122.9L380 68C345.6 48.8 312.7 62.2 287.8 92.8L142.8 37C105 22.4 62.2 40.7 47.2 78.2 32.1 115.9 50.8 158.6 89.2 173.3L168 192 74 182.9C33.2 182.9 0 215.7 0 256 0 296.3 33.2 329.1 74 329.1H161.6C158 355.4 170.3 380.4 192 394.1 178.7 436.7 211 480 256 480zM256 432C230.8 432 230.9 395.4 256 395.4 264.8 395.4 272 388.3 272 379.4V372.6C272 363.7 264.8 356.6 256 356.6H228C202.8 356.6 202.9 320 228 320H256C264.8 320 272 312.8 272 304V297.1C272 288.3 264.8 281.1 256 281.1H74C39.6 281.1 39.6 230.9 74 230.9H256C264.8 230.9 272 223.7 272 214.9V203.2A16-16 0 0 1 261.7 188.3L106.4 128.5C74.8 116.4 93 69.2 125.6 81.8L292.2 145.9A16-16 0 0 1 310.3 141.1L332.1 114.4C337.9 107.3 348.4 105.4 356.6 109.9L454.6 164.8C460.4 168 464 174.1 464 180.6V386.3C464 394.8 458 402.1 449.4 404.1L330.4 431.5A19.7-19.7 0 0 0 326 432H256z"}]}}),H.register({"regular/hand-spock":{width:512,height:512,paths:[{d:"M21.1 381.8L150.2 503.3A32-32 0 0 1 172.1 512H409.7C423.9 512 436.4 502.7 440.4 489.1L472.2 381.8A116-116 0 0 1 477 348.8V312C477 307.9 477.5 303.9 478.4 299.9L510.1 166.5C520.2 124.1 487.8 83.8 444.6 84 440.5 59.1 422.1 36.8 394.8 30 358.9 21 322.5 42.7 313.5 78.8L296.6 184 274.9 52C266.6 15.9 230.6-6.6 194.6 1.7 165 8.5 144.5 34.1 142.7 63 100.1 63.8 69.3 103.6 78.7 144.9L109.7 281.4C82.5 258.8 42.4 261.4 18.2 287.1-7.2 314-5.9 356.4 21.1 381.8zM53.2 320L53.2 320C60.4 312.3 72.4 312 80 319.2L133 369.1C143.2 378.6 160 371.4 160 357.4V287.9C160 286.7 159.9 285.5 159.6 284.4L125.5 134.2C119.9 109.6 157 101.3 162.5 125.8L192.9 259.5A16-16 0 0 1 208.5 272H217.1C227.4 272 235 262.4 232.7 252.4L191.1 71.3C185.5 46.8 222.5 38.2 228.1 62.8L273.4 259.6A16-16 0 0 1 289 272H302.2A16-16 0 0 1 317.7 259.9L360.1 90.4C366.2 66 403 75.2 396.9 99.6L358.8 252.1C356.3 262.2 363.9 272 374.3 272H384A16-16 0 0 1 399.6 259.7L426.5 146.6C432.3 122.2 469.3 130.9 463.5 155.4L431.7 288.8A100.1-100.1 0 0 1 429 312V348.8C429 355.4 428.1 361.9 426.2 368.1L397.8 464H178.5L54 346.8C46.3 339.7 46 327.6 53.2 320z"}]}}),H.register({"regular/handshake":{width:640,height:512,paths:[{d:"M519.2 127.9L471.6 80.3A56.3-56.3 0 0 1 432 64H205.2C190.4 64 176.1 69.9 165.6 80.3L118 127.9H0V383.6H64C81.6 383.6 95.8 369.4 95.9 351.9H105L189.6 428.3C220.5 453.4 263.4 454 295.2 432.1 307.7 442.9 321.2 448 336.3 448 354.5 448 371.6 440.6 385.1 424 407.2 432.7 433.3 426.6 449.1 407.2L475.3 374.9C480.9 368 484.4 360.1 486.2 351.9H544.1C544.2 369.4 558.5 383.6 576 383.6H640V127.9H519.2zM48 351.6C39.2 351.6 32 344.4 32 335.6S39.2 319.6 48 319.6 64 326.8 64 335.6C64 344.5 56.8 351.6 48 351.6zM438 344.7L411.9 376.9C409.1 380.3 404.1 380.9 400.6 378.1L376.7 358.7 346.7 395.2C340.7 402.5 331.7 400 328.7 397.6L291.9 366.1 276.3 385.3C262.4 402.4 237.1 405 221 391.9L123.7 303.9H96V175.8H137.9L199.6 114.2C201.6 113.4 203.3 112.7 205.3 111.9H262L223.3 147.4C193.9 174.3 192.2 219.7 218.9 248.7 233.7 264.9 280.1 289.9 320.4 253.1L328.6 245.6 436.8 333.4C440.2 336.2 440.7 341.3 438 344.7zM544 303.9H474.8C472.5 301.1 469.9 298.5 467.1 296.2L364.4 212.8 376.9 201.4C383.4 195.4 383.9 185.3 377.9 178.8L367 167.1C361 160.6 350.9 160.2 344.4 166.1L289.2 216.7C279.7 225.4 263.5 226.1 254.6 216.7 245.3 206.8 246.1 191.6 255.8 182.8L321.4 122.7C328.8 115.9 338.4 112.2 348.4 112.2L432.1 112C434.2 112 436.2 112.8 437.6 114.3L499.3 175.9H544V303.9zM592 351.6C583.2 351.6 576 344.4 576 335.6S583.2 319.6 592 319.6 608 326.8 608 335.6C608 344.5 600.8 351.6 592 351.6z"}]}}),H.register({"regular/hdd":{width:576,height:512,paths:[{d:"M567.4 235.6L462.3 84.6A48-48 0 0 1 422.9 64H153.1A48-48 0 0 1 113.7 84.6L8.6 235.6A48-48 0 0 1 0 263.1V400C0 426.5 21.5 448 48 448H528C554.5 448 576 426.5 576 400V263.1C576 253.3 573 243.7 567.4 235.6zM153.1 112H422.9L500.8 224H75.2L153.1 112zM528 400H48V272H528V400zM496 336C496 353.7 481.7 368 464 368S432 353.7 432 336 446.3 304 464 304 496 318.3 496 336zM400 336C400 353.7 385.7 368 368 368S336 353.7 336 336 350.3 304 368 304 400 318.3 400 336z"}]}}),H.register({"regular/heart":{width:512,height:512,paths:[{d:"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5L218.4 464.2C228.4 474.4 241.8 480.1 256 480.1 270.3 480.1 283.6 474.5 293.6 464.3L469 285.6C522.5 230.9 533.7 127.7 458.4 64.3zM434.8 251.8L259.4 430.5C257 432.9 255 432.9 252.6 430.5L77.2 251.8C40.7 214.6 33.3 144.2 84.5 101.1 123.4 68.4 183.4 73.3 221 111.6L256 147.3 291 111.6C328.8 73.1 388.8 68.4 427.5 101 478.6 144.1 471 214.9 434.8 251.8z"}]}}),H.register({"regular/hospital":{width:448,height:512,paths:[{d:"M128 244V204C128 197.4 133.4 192 140 192H180C186.6 192 192 197.4 192 204V244C192 250.6 186.6 256 180 256H140C133.4 256 128 250.6 128 244zM268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256zM192 340V300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352zM448 476V512H0V476C0 469.4 5.4 464 12 464H31.5V85C31.5 73.4 42.2 64 55.5 64H144V24C144 10.7 154.7 0 168 0H280C293.3 0 304 10.7 304 24V64H392.5C405.8 64 416.5 73.4 416.5 85V464H436C442.6 464 448 469.4 448 476zM79.5 463H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V463H368.5V112H304V136C304 149.3 293.3 160 280 160H168C154.7 160 144 149.3 144 136V112H79.5V463zM266 64H240V38A6-6 0 0 1 234 32H214A6-6 0 0 1 208 38V64H182A6-6 0 0 1 176 70V90A6-6 0 0 1 182 96H208V122A6-6 0 0 1 214 128H234A6-6 0 0 1 240 122V96H266A6-6 0 0 1 272 90V70A6-6 0 0 1 266 64z"}]}}),H.register({"regular/hourglass":{width:384,height:512,paths:[{d:"M368 48H372C378.6 48 384 42.6 384 36V12C384 5.4 378.6 0 372 0H12C5.4 0 0 5.4 0 12V36C0 42.6 5.4 48 12 48H16C16 128.6 48.2 213.8 113.2 256 47.9 298.4 16 383.9 16 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H372C378.6 512 384 506.6 384 500V476C384 469.4 378.6 464 372 464H368C368 383.4 335.8 298.2 270.8 256 336.1 213.6 368 128.1 368 48zM64 48H320C320 149.6 262.7 232 192 232S64 149.6 64 48zM320 464H64C64 362.4 121.3 280 192 280S320 362.4 320 464z"}]}}),H.register({"regular/id-badge":{width:384,height:512,paths:[{d:"M0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0H48C21.5 0 0 21.5 0 48zM336 80V458A6-6 0 0 0 330 464H54A6-6 0 0 0 48 458V80H336zM192 160C230.7 160 262 191.3 262 230S230.7 300 192 300 122 268.7 122 230 153.3 160 192 160zM272.2 306L241 298.2C208.2 321.8 168.5 316.6 143 298.2L111.8 306C93.1 310.7 80 327.5 80 346.8V363C80 374.6 89.4 384 101 384H283C294.6 384 304 374.6 304 363V346.8C304 327.5 290.9 310.7 272.2 306z"}]}}),H.register({"regular/id-card":{width:512,height:512,paths:[{d:"M404 256H300C293.4 256 288 250.6 288 244V228C288 221.4 293.4 216 300 216H404C410.6 216 416 221.4 416 228V244C416 250.6 410.6 256 404 256zM416 316V300C416 293.4 410.6 288 404 288H300C293.4 288 288 293.4 288 300V316C288 322.6 293.4 328 300 328H404C410.6 328 416 322.6 416 316zM512 112V400C512 426.5 490.5 448 464 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H464C490.5 64 512 85.5 512 112zM464 394V144H48V394A6-6 0 0 1 54 400H458A6-6 0 0 1 464 394zM176 192C203.6 192 226 214.4 226 242S203.6 292 176 292 126 269.6 126 242 148.4 192 176 192zM233.3 296.3L211 290.7C187.6 307.6 159.2 303.8 141 290.7L118.7 296.3C105.4 299.7 96 311.7 96 325.4V337C96 345.3 102.7 352 111 352H241C249.3 352 256 345.3 256 337V325.4C256 311.7 246.6 299.7 233.3 296.3z"}]}}),H.register({"regular/image":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM458 400H54A6-6 0 0 0 48 394V118A6-6 0 0 0 54 112H458A6-6 0 0 0 464 118V394A6-6 0 0 0 458 400zM128 152C105.9 152 88 169.9 88 192S105.9 232 128 232 168 214.1 168 192 150.1 152 128 152zM96 352H416V272L328.5 184.5C323.8 179.8 316.2 179.8 311.5 184.5L192 304 152.5 264.5C147.8 259.8 140.2 259.8 135.5 264.5L96 304V352z"}]}}),H.register({"regular/images":{width:576,height:512,paths:[{d:"M480 416V432C480 458.5 458.5 480 432 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H64V176H54A6-6 0 0 1 48 182V426A6-6 0 0 1 54 432H426A6-6 0 0 1 432 426V416H480zM522 80H150A6-6 0 0 1 144 86V330A6-6 0 0 1 150 336H522A6-6 0 0 1 528 330V86A6-6 0 0 1 522 80zM528 32C554.5 32 576 53.5 576 80V336C576 362.5 554.5 384 528 384H144C117.5 384 96 362.5 96 336V80C96 53.5 117.5 32 144 32H528zM264 144C264 166.1 246.1 184 224 184S184 166.1 184 144 201.9 104 224 104 264 121.9 264 144zM192 240L231.5 200.5C236.2 195.8 243.8 195.8 248.5 200.5L288 240 391.5 136.5C396.2 131.8 403.8 131.8 408.5 136.5L480 208V288H192V240z"}]}}),H.register({"regular/keyboard":{width:576,height:512,paths:[{d:"M528 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H528C554.5 448 576 426.5 576 400V112C576 85.5 554.5 64 528 64zM536 400C536 404.4 532.4 408 528 408H48C43.6 408 40 404.4 40 400V112C40 107.6 43.6 104 48 104H528C532.4 104 536 107.6 536 112V400zM170 270V242C170 235.4 164.6 230 158 230H130C123.4 230 118 235.4 118 242V270C118 276.6 123.4 282 130 282H158C164.6 282 170 276.6 170 270zM266 270V242C266 235.4 260.6 230 254 230H226C219.4 230 214 235.4 214 242V270C214 276.6 219.4 282 226 282H254C260.6 282 266 276.6 266 270zM362 270V242C362 235.4 356.6 230 350 230H322C315.4 230 310 235.4 310 242V270C310 276.6 315.4 282 322 282H350C356.6 282 362 276.6 362 270zM458 270V242C458 235.4 452.6 230 446 230H418C411.4 230 406 235.4 406 242V270C406 276.6 411.4 282 418 282H446C452.6 282 458 276.6 458 270zM122 352V324C122 317.4 116.6 312 110 312H82C75.4 312 70 317.4 70 324V352C70 358.6 75.4 364 82 364H110C116.6 364 122 358.6 122 352zM506 352V324C506 317.4 500.6 312 494 312H466C459.4 312 454 317.4 454 324V352C454 358.6 459.4 364 466 364H494C500.6 364 506 358.6 506 352zM122 188V160C122 153.4 116.6 148 110 148H82C75.4 148 70 153.4 70 160V188C70 194.6 75.4 200 82 200H110C116.6 200 122 194.6 122 188zM218 188V160C218 153.4 212.6 148 206 148H178C171.4 148 166 153.4 166 160V188C166 194.6 171.4 200 178 200H206C212.6 200 218 194.6 218 188zM314 188V160C314 153.4 308.6 148 302 148H274C267.4 148 262 153.4 262 160V188C262 194.6 267.4 200 274 200H302C308.6 200 314 194.6 314 188zM410 188V160C410 153.4 404.6 148 398 148H370C363.4 148 358 153.4 358 160V188C358 194.6 363.4 200 370 200H398C404.6 200 410 194.6 410 188zM506 188V160C506 153.4 500.6 148 494 148H466C459.4 148 454 153.4 454 160V188C454 194.6 459.4 200 466 200H494C500.6 200 506 194.6 506 188zM408 346V330C408 323.4 402.6 318 396 318H180C173.4 318 168 323.4 168 330V346C168 352.6 173.4 358 180 358H396C402.6 358 408 352.6 408 346z"}]}}),H.register({"regular/lemon":{width:512,height:512,paths:[{d:"M484.1 27.9C456-0.2 416.1-8.1 387.1 8.9 347.6 31.8 223.5-41.1 91.2 91.2-41.3 223.7 31.9 347.5 8.9 387.1-8.1 416.1-0.2 456 27.9 484.1 56 512.2 95.9 520 124.9 503.1 164.4 480.2 288.5 553.1 420.8 420.8 553.3 288.3 480.1 164.5 503.1 124.9 520.1 95.9 512.2 56 484.1 27.9zM461.7 100.8C422.9 167.4 507.3 266.4 386.9 386.9 266.4 507.3 167.4 422.9 100.8 461.7 78.1 474.9 36.8 434.5 50.3 411.2 89.1 344.6 4.7 245.6 125.1 125.1 245.6 4.7 344.6 89.1 411.2 50.3 433.9 37.1 475.2 77.6 461.7 100.8zM291.8 109.5C293.2 120.5 285.4 130.5 274.5 131.8 219.6 138.7 138.7 219.6 131.8 274.5 130.5 285.5 120.4 293.2 109.5 291.8 98.6 290.5 90.8 280.5 92.2 269.5 101.3 196.2 196.3 101.3 269.5 92.2 280.5 90.8 290.5 98.6 291.8 109.5z"}]}}),H.register({"regular/life-ring":{width:512,height:512,paths:[{d:"M256 504C393 504 504 393 504 256S393 8 256 8 8 119 8 256 119 504 256 504zM152.6 427.3L206 373.9C237.8 387.4 274.1 387.4 306 373.9L359.4 427.3C296.2 465.6 215.8 465.6 152.6 427.3zM336 256C336 300.1 300.1 336 256 336S176 300.1 176 256 211.9 176 256 176 336 211.9 336 256zM427.3 359.4L373.9 306C387.4 274.2 387.4 237.9 373.9 206L427.3 152.6C465.6 215.8 465.6 296.2 427.3 359.4zM359.4 84.7L306 138.1C274.2 124.6 237.9 124.6 206 138.1L152.6 84.7C215.8 46.4 296.2 46.4 359.4 84.7zM84.7 152.6L138.1 206C124.6 237.8 124.6 274.1 138.1 306L84.7 359.4C46.4 296.2 46.4 215.8 84.7 152.6z"}]}}),H.register({"regular/lightbulb":{width:384,height:512,paths:[{d:"M272 428V456C272 466.4 265.3 475.3 256 478.6V488C256 501.3 245.3 512 232 512H152C138.7 512 128 501.3 128 488V478.6C118.7 475.3 112 466.4 112 456V428C112 421.4 117.4 416 124 416H260C266.6 416 272 421.4 272 428zM128 176C128 140.7 156.7 112 192 112 200.8 112 208 104.8 208 96S200.8 80 192 80C139.1 80 96 123.1 96 176 96 184.8 103.2 192 112 192S128 184.8 128 176zM192 48C262.7 48 320 105.3 320 176 320 253.6 282.6 236.5 239 336H145C101.3 236.3 64 253.9 64 176 64 105.3 121.3 48 192 48M192 0C94.8 0 16 78.8 16 176 16 277.7 67.7 267.5 106.5 368.7 110.1 377.9 119 384 128.9 384H255.1C265 384 273.9 377.9 277.5 368.7 316.3 267.5 368 277.7 368 176 368 78.8 289.2 0 192 0z"}]}}),H.register({"regular/list-alt":{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM458 432H54A6-6 0 0 0 48 426V86A6-6 0 0 0 54 80H458A6-6 0 0 0 464 86V426A6-6 0 0 0 458 432zM416 340V364C416 370.6 410.6 376 404 376H204C197.4 376 192 370.6 192 364V340C192 333.4 197.4 328 204 328H404C410.6 328 416 333.4 416 340zM416 244V268C416 274.6 410.6 280 404 280H204C197.4 280 192 274.6 192 268V244C192 237.4 197.4 232 204 232H404C410.6 232 416 237.4 416 244zM416 148V172C416 178.6 410.6 184 404 184H204C197.4 184 192 178.6 192 172V148C192 141.4 197.4 136 204 136H404C410.6 136 416 141.4 416 148zM164 160C164 179.9 147.9 196 128 196S92 179.9 92 160 108.1 124 128 124 164 140.1 164 160zM164 256C164 275.9 147.9 292 128 292S92 275.9 92 256 108.1 220 128 220 164 236.1 164 256zM164 352C164 371.9 147.9 388 128 388S92 371.9 92 352 108.1 316 128 316 164 332.1 164 352z"}]}}),H.register({"regular/map":{width:576,height:512,paths:[{d:"M508.5 36.2L381.5 92.6 207.2 34.5A48-48 0 0 1 172.5 36.1L28.5 100.1A48-48 0 0 1 0 144V432C0 466.9 36 489.8 67.5 475.8L194.5 419.4 368.8 477.5A48-48 0 0 1 403.5 475.9L547.5 411.9A48-48 0 0 1 576 368V80C576 45.1 540 22.2 508.5 36.2zM360 424L216 376V88L360 136V424zM48 432V144L168 90.7V378.7L48 432zM528 368L408 421.3V133.3L528 80V368z"}]}}),H.register({"regular/meh":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176zM336 320H160C146.8 320 136 330.8 136 344S146.8 368 160 368H336C349.2 368 360 357.2 360 344S349.2 320 336 320z"}]}}),H.register({"regular/minus-square":{width:448,height:512,paths:[{d:"M108 284C101.4 284 96 278.6 96 272V240C96 233.4 101.4 228 108 228H340C346.6 228 352 233.4 352 240V272C352 278.6 346.6 284 340 284H108zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/money-bill-alt":{width:640,height:512,paths:[{d:"M320 144C267 144 224 194.1 224 256 224 317.8 267 368 320 368 373 368 416 317.9 416 256 416 194.1 373 144 320 144zM368 308.4C368 315.9 364.1 320 356.4 320H289.1C281.5 320 277.6 315.9 277.6 308.4V299.5C277.6 292.1 281.5 288 289.1 288H304.3V248.1C304.3 242.9 304.8 237.6 304.8 237.6H304.4S302.7 240.2 301.6 241.3C297.1 245.6 291.1 245.8 285.9 240.2L280.4 234C275.1 228.7 275.4 222.8 280.9 217.6L302.7 197.7C307.1 193.6 311 192 317.1 192H329.2C336.8 192 340.9 195.9 340.9 203.6V288H356.4C364.1 288 368 292 368 299.5V308.4zM616 64H24C10.7 64 0 74.7 0 88V423C0 436.3 10.7 447 24 447H616C629.3 447 640 436.3 640 423V88C640 74.7 629.3 64 616 64zM512 400H128C128 355.8 92.2 320 48 320V192C92.2 192 128 156.2 128 112H512C512 156.2 547.8 192 592 192V320C547.8 320 512 355.8 512 400z"}]}}),H.register({"regular/moon":{width:512,height:512,paths:[{d:"M279.1 512C357.9 512 430.1 476.2 478 417.2 506.2 382.4 475.4 331.5 431.7 339.8 349.4 355.5 273.5 292.6 273.5 209 273.5 160.6 299.5 116.7 340.9 93.2 379.6 71.1 369.9 12.4 325.9 4.3A257.9-257.9 0 0 1 279.1 0C137.8 0 23.1 114.6 23.1 256 23.1 397.4 137.7 512 279.1 512zM279.1 48C292.1 48 304.8 49.2 317.2 51.5 262.4 82.6 225.5 141.5 225.5 209 225.5 322.9 329.1 408.2 440.7 387 402.6 434 344.4 464 279.1 464 164.3 464 71.1 370.9 71.1 256S164.3 48 279.1 48z"}]}}),H.register({"regular/newspaper":{width:576,height:512,paths:[{d:"M552 64H112C91.1 64 73.4 77.4 66.8 96H24C10.7 96 0 106.7 0 120V392C0 422.9 25.1 448 56 448H552C565.3 448 576 437.3 576 424V88C576 74.7 565.3 64 552 64zM48 392V144H64V392C64 396.4 60.4 400 56 400S48 396.4 48 392zM528 400H111.4C111.8 397.4 112 394.7 112 392V112H528V400zM172 280H308C314.6 280 320 274.6 320 268V172C320 165.4 314.6 160 308 160H172C165.4 160 160 165.4 160 172V268C160 274.6 165.4 280 172 280zM200 200H280V240H200V200zM160 340V316C160 309.4 165.4 304 172 304H308C314.6 304 320 309.4 320 316V340C320 346.6 314.6 352 308 352H172C165.4 352 160 346.6 160 340zM352 340V316C352 309.4 357.4 304 364 304H468C474.6 304 480 309.4 480 316V340C480 346.6 474.6 352 468 352H364C357.4 352 352 346.6 352 340zM352 196V172C352 165.4 357.4 160 364 160H468C474.6 160 480 165.4 480 172V196C480 202.6 474.6 208 468 208H364C357.4 208 352 202.6 352 196zM352 268V244C352 237.4 357.4 232 364 232H468C474.6 232 480 237.4 480 244V268C480 274.6 474.6 280 468 280H364C357.4 280 352 274.6 352 268z"}]}}),H.register({"regular/object-group":{width:512,height:512,paths:[{d:"M500 128C506.6 128 512 122.6 512 116V44C512 37.4 506.6 32 500 32H428C421.4 32 416 37.4 416 44V56H96V44C96 37.4 90.6 32 84 32H12C5.4 32 0 37.4 0 44V116C0 122.6 5.4 128 12 128H24V384H12C5.4 384 0 389.4 0 396V468C0 474.6 5.4 480 12 480H84C90.6 480 96 474.6 96 468V456H416V468C416 474.6 421.4 480 428 480H500C506.6 480 512 474.6 512 468V396C512 389.4 506.6 384 500 384H488V128H500zM448 64H480V96H448V64zM32 64H64V96H32V64zM64 448H32V416H64V448zM480 448H448V416H480V448zM440 384H428C421.4 384 416 389.4 416 396V408H96V396C96 389.4 90.6 384 84 384H72V128H84C90.6 128 96 122.6 96 116V104H416V116C416 122.6 421.4 128 428 128H440V384zM404 192H320V140C320 133.4 314.6 128 308 128H108C101.4 128 96 133.4 96 140V308C96 314.6 101.4 320 108 320H192V372C192 378.6 197.4 384 204 384H404C410.6 384 416 378.6 416 372V204C416 197.4 410.6 192 404 192zM136 168H280V280H136V168zM376 344H232V320H308C314.6 320 320 314.6 320 308V232H376V344z"}]}}),H.register({"regular/object-ungroup":{width:576,height:512,paths:[{d:"M564 224C570.6 224 576 218.6 576 212V140C576 133.4 570.6 128 564 128H492C485.4 128 480 133.4 480 140V152H392V128H404C410.6 128 416 122.6 416 116V44C416 37.4 410.6 32 404 32H332C325.4 32 320 37.4 320 44V56H96V44C96 37.4 90.6 32 84 32H12C5.4 32 0 37.4 0 44V116C0 122.6 5.4 128 12 128H24V288H12C5.4 288 0 293.4 0 300V372C0 378.6 5.4 384 12 384H84C90.6 384 96 378.6 96 372V360H184V384H172C165.4 384 160 389.4 160 396V468C160 474.6 165.4 480 172 480H244C250.6 480 256 474.6 256 468V456H480V468C480 474.6 485.4 480 492 480H564C570.6 480 576 474.6 576 468V396C576 389.4 570.6 384 564 384H552V224H564zM352 64H384V96H352V64zM352 320H384V352H352V320zM64 352H32V320H64V352zM64 96H32V64H64V96zM96 312V300C96 293.4 90.6 288 84 288H72V128H84C90.6 128 96 122.6 96 116V104H320V116C320 122.6 325.4 128 332 128H344V288H332C325.4 288 320 293.4 320 300V312H96zM224 448H192V416H224V448zM504 384H492C485.4 384 480 389.4 480 396V408H256V396C256 389.4 250.6 384 244 384H232V360H320V372C320 378.6 325.4 384 332 384H404C410.6 384 416 378.6 416 372V300C416 293.4 410.6 288 404 288H392V200H480V212C480 218.6 485.4 224 492 224H504V384zM544 448H512V416H544V448zM544 192H512V160H544V192z"}]}}),H.register({"regular/paper-plane":{width:512,height:512,paths:[{d:"M440 6.5L24 246.4C-10.4 266.3-7.1 317.2 29.7 332.3L144 379.6V464C144 510.4 203.2 529.5 230.6 492.6L274.4 433.5 386.3 479.7C392.2 482.1 398.4 483.3 404.6 483.3 412.8 483.3 420.9 481.2 428.2 477.1 441 469.9 449.8 457.1 452.1 442.6L511.5 55.4C517.6 15.3 474.6-13.4 440 6.5zM192 464V399.4L228.6 414.5 192 464zM404.6 435.3L250.8 371.8 391 169.5C401.7 154 381.5 136 367.3 148.3L155.8 332.6 48 288 464 48 404.6 435.3z"}]}}),H.register({"regular/pause-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM352 176V336C352 344.8 344.8 352 336 352H288C279.2 352 272 344.8 272 336V176C272 167.2 279.2 160 288 160H336C344.8 160 352 167.2 352 176zM240 176V336C240 344.8 232.8 352 224 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H224C232.8 160 240 167.2 240 176z"}]}}),H.register({"regular/play-circle":{width:512,height:512,paths:[{d:"M371.7 238L195.7 131C179.9 122.2 160 133.5 160 152V360C160 378.4 179.8 389.8 195.7 381L371.7 280C388.1 270.9 388.1 247.2 371.7 238zM504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256z"}]}}),H.register({"regular/plus-square":{width:448,height:512,paths:[{d:"M352 240V272C352 278.6 346.6 284 340 284H252V372C252 378.6 246.6 384 240 384H208C201.4 384 196 378.6 196 372V284H108C101.4 284 96 278.6 96 272V240C96 233.4 101.4 228 108 228H196V140C196 133.4 201.4 128 208 128H240C246.6 128 252 133.4 252 140V228H340C346.6 228 352 233.4 352 240zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z"}]}}),H.register({"regular/question-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119.1 8 256 8 393 119 504 256 504S504 393 504 256C504 119.1 393 8 256 8zM256 456C145.5 456 56 366.6 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.6 456 256 456zM363.2 200.8C363.2 267.9 290.8 268.9 290.8 293.7V300C290.8 306.6 285.5 312 278.8 312H233.2C226.5 312 221.2 306.6 221.2 300V291.3C221.2 255.6 248.3 241.3 268.8 229.8 286.3 220 297.1 213.3 297.1 200.2 297.1 183 275.1 171.6 257.3 171.6 234.1 171.6 223.4 182.5 208.4 201.5 204.3 206.6 196.9 207.6 191.7 203.6L163.9 182.5C158.8 178.7 157.6 171.5 161.2 166.2 184.8 131.5 214.9 112 261.8 112 310.9 112 363.2 150.3 363.2 200.8zM298 368C298 391.2 279.2 410 256 410S214 391.2 214 368 232.8 326 256 326 298 344.8 298 368z"}]}}),H.register({"regular/registered":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM366.4 374.2C313.4 277.9 316.2 282.7 313.2 278.1 337.4 264.2 352.7 236.6 352.7 204.9 352.7 152.4 322.4 119.7 251.2 119.7H172.5C165.9 119.7 160.5 125.1 160.5 131.7V380C160.5 386.6 165.9 392 172.5 392H211.1C217.7 392 223.1 386.6 223.1 380V296.3H255L302.5 385.6A12-12 0 0 1 313.1 392H355.9C365.1 392 370.8 382.2 366.4 374.2zM256.9 239.9H223.1V175.8H250.4C282.9 175.8 289.4 187.9 289.4 207.5 289.4 228.4 277.8 239.9 256.9 239.9z"}]}}),H.register({"regular/save":{width:448,height:512,paths:[{d:"M433.9 129.9L350.1 46.1A48-48 0 0 1 316.1 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V163.9A48-48 0 0 1 433.9 129.9zM272 80V160H144V80H272zM394 432H54A6-6 0 0 0 48 426V86A6-6 0 0 0 54 80H96V184C96 197.3 106.7 208 120 208H296C309.3 208 320 197.3 320 184V83.9L398.2 162.1A6-6 0 0 0 400 166.4V426A6-6 0 0 0 394 432zM224 232C175.5 232 136 271.5 136 320S175.5 408 224 408 312 368.5 312 320 272.5 232 224 232zM224 360C201.9 360 184 342.1 184 320S201.9 280 224 280 264 297.9 264 320 246.1 360 224 360z"}]}}),H.register({"regular/share-square":{width:576,height:512,paths:[{d:"M561.9 158.1L417.9 14.1C387.9-15.9 336 5.1 336 48V105.2C293.6 107.1 252 111.8 215.2 123.2 180.1 134.2 152.2 150.8 132.3 172.6 108.2 199.2 96 232.6 96 271.9 96 333.6 129.2 384.4 180.9 416.7 218.4 440.2 266.1 404 251.9 361 236.4 313.8 234.7 290 336 282.2V336C336 379 388 399.9 417.9 369.9L561.9 225.9C580.7 207.2 580.7 176.8 561.9 158.1zM384 336V232.2C255.3 234.1 166.5 255.3 206.3 376 176.8 357.6 144 324.1 144 271.9 144 162.6 273.1 153 384 152.1V48L528 192 384 336zM408.7 420.5A82.7-82.7 0 0 1 429.7 411.2C437.7 406.2 448 412 448 421.4V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H180C186.6 64 192 69.4 192 76V80.5C192 85.4 189 89.9 184.4 91.6 170.7 97 158 103.2 146.4 110.2A12.1-12.1 0 0 0 140.1 112H54A6-6 0 0 1 48 118V458A6-6 0 0 1 54 464H394A6-6 0 0 1 400 458V432C400 426.7 403.6 422 408.7 420.5z"}]}}),H.register({"regular/smile":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM332 312.6C311.2 337.6 280.5 352 248 352S184.8 337.7 164 312.6C155.5 302.4 140.4 301.1 130.2 309.5 120 318 118.7 333.1 127.1 343.3 157.1 379.3 201.2 399.9 248 399.9S338.9 379.3 368.9 343.3C377.4 333.1 376 318 365.8 309.5 355.6 301.1 340.5 302.4 332 312.6zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 240C345.7 240 360 225.7 360 208S345.7 176 328 176 296 190.3 296 208 310.3 240 328 240z"}]}}),H.register({"regular/snowflake":{width:448,height:512,paths:[{d:"M438.2 355.9L371.7 317.4 431.1 307.1C437 305.7 441.7 301.9 444.6 296.9 447 292.6 448.1 287.5 447.1 282.3 445 271.2 434.4 264.2 423.5 266.8L338 297.9 255.9 256 338.1 214.1 423.5 245.2C434.4 247.8 445 240.8 447.1 229.7 449.2 218.6 442 207.5 431.1 204.9L371.7 194.6 438.2 156.1C447.8 150.6 450.9 138 445.1 128 439.4 118 427 114.4 417.4 119.9L350.9 158.5 371.7 101.7C374.9 90.9 368.9 79.1 358.2 75.4 347.6 71.7 336.3 77.4 333.1 88.2L317.2 177.9 244.8 219.9V136L314.4 77.4C322.1 69.2 321.4 56.5 312.9 49.1 304.3 41.7 291.1 42.4 283.5 50.6L244.8 97.1V20C244.8 9 235.5 0 224 0S203.2 9 203.2 20V97.1L164.5 50.6C156.9 42.4 143.7 41.7 135.1 49.1 126.6 56.5 125.9 69.2 133.6 77.4L203.2 136V219.9L130.8 177.9 114.9 88.2C111.7 77.4 100.4 71.7 89.8 75.4 79.1 79.1 73.1 90.9 76.3 101.7L97.1 158.5 30.6 119.9C21 114.4 8.6 118 2.9 128S0.2 150.6 9.8 156.1L76.3 194.6 16.9 204.9C6 207.5-1.2 218.6 0.9 229.7 3 240.8 13.6 247.8 24.5 245.2L110 214.1 192.1 256 110 297.9 24.5 266.8C13.6 264.2 3 271.2 0.9 282.3-1.2 293.4 6 304.5 16.9 307.1L76.3 317.4 9.8 355.9C0.2 361.4-2.9 374 2.9 384S21 397.6 30.6 392.1L97.2 353.5 76.3 410.3C74.6 416.1 75.5 422.1 78.4 427.1 80.8 431.4 84.8 434.9 89.8 436.6 100.4 440.3 111.7 434.6 114.9 423.8L130.8 334.1 203.2 292.1V376L133.6 434.6C125.9 442.8 126.6 455.5 135.1 462.9 143.7 470.3 156.9 469.6 164.5 461.4L203.2 414.9V492C203.2 503 212.5 512 224 512S244.8 503 244.8 492V414.9L283.5 461.4C287.6 465.8 293.2 468 298.9 468 303.9 468 308.9 466.3 312.9 462.9 321.4 455.5 322.1 442.8 314.4 434.6L244.8 376V292.1L317.2 334.1 333.1 423.8C336.3 434.6 347.6 440.3 358.2 436.6 368.9 432.9 374.9 421.1 371.7 410.3L350.8 353.5 417.4 392.1C427 397.6 439.4 394 445.1 384 450.9 374 447.8 361.4 438.2 355.9z"}]}}),H.register({"regular/square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM394 432H54C50.7 432 48 429.3 48 426V86C48 82.7 50.7 80 54 80H394C397.3 80 400 82.7 400 86V426C400 429.3 397.3 432 394 432z"}]}}),H.register({"regular/star-half":{width:576,height:512,paths:[{d:"M288 385.3L163.7 450.7 187.4 312.3 86.8 214.3 225.8 194.1 288 68.1V0C276.6 0 265.2 5.9 259.3 17.8L194 150.2 47.9 171.4C21.7 175.2 11.2 207.5 30.2 226L135.9 329 110.9 474.5C106.4 500.6 133.9 520.5 157.3 508.2L288 439.6V385.3z"}]}}),H.register({"regular/star":{width:576,height:512,paths:[{d:"M528.1 171.5L382 150.2 316.7 17.8C305-5.8 271.1-6.1 259.3 17.8L194 150.2 47.9 171.5C21.7 175.3 11.2 207.6 30.2 226.1L135.9 329.1 110.9 474.6C106.4 500.9 134.1 520.6 157.3 508.3L288 439.6 418.7 508.3C441.9 520.5 469.6 500.9 465.1 474.6L440.1 329.1 545.8 226.1C564.8 207.6 554.3 175.3 528.1 171.5zM388.6 312.3L412.3 450.7 288 385.4 163.7 450.7 187.4 312.3 86.8 214.3 225.8 194.1 288 68.1 350.2 194.1 489.2 214.3 388.6 312.3z"}]}}),H.register({"regular/sticky-note":{width:448,height:512,paths:[{d:"M448 348.1V80C448 53.5 426.5 32 400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H316.1A48-48 0 0 1 350.1 465.9L433.9 382A48-48 0 0 1 448 348.1zM320 428.1V352H396.1L320 428.1zM400 80V304H296C282.7 304 272 314.7 272 328V432H48V80H400z"}]}}),H.register({"regular/stop-circle":{width:512,height:512,paths:[{d:"M504 256C504 119 393 8 256 8S8 119 8 256 119 504 256 504 504 393 504 256zM56 256C56 145.5 145.5 56 256 56S456 145.5 456 256 366.5 456 256 456 56 366.5 56 256zM352 176V336C352 344.8 344.8 352 336 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H336C344.8 160 352 167.2 352 176z"}]}}),H.register({"regular/sun":{width:512,height:512,paths:[{d:"M220.1 487.9L199.9 438.5A4-4 0 0 1 194.1 436.6L148.7 464.7C119.2 483 82.4 456.2 90.6 422.6L103.3 370.7A4-4 0 0 1 99.7 365.7L46.5 361.8C11.9 359.2-2.1 315.9 24.3 293.5L65.1 259.1A4-4 0 0 1 65.1 252.9L24.3 218.4C-2.1 196.1 11.9 152.8 46.5 150.2L99.7 146.3A4-4 0 0 1 103.3 141.3L90.6 89.4C82.4 55.8 119.2 29 148.7 47.3L194.1 75.4A4-4 0 0 1 199.9 73.5L220.1 24.1C233.2-8 278.8-8 291.9 24.1L312.1 73.5A4-4 0 0 1 317.9 75.4L363.3 47.3C392.8 29 429.6 55.8 421.4 89.4L408.7 141.3A4-4 0 0 1 412.2 146.2L465.5 150.2C500 152.8 514.1 196.1 487.7 218.4L446.9 252.9A4-4 0 0 1 446.9 259L487.7 293.5C514.2 316 500 359.2 465.5 361.8L412.2 365.7A4-4 0 0 1 408.7 370.7L421.4 422.5C429.6 456.2 392.8 483 363.3 464.7L317.9 436.6A4-4 0 0 1 312.1 438.5L291.9 487.9C278.7 520.1 233.2 519.9 220.1 487.9zM236.9 423.4L256 470 275.1 423.4C285.4 398.2 315.8 388.3 338.9 402.6L381.8 429.1 369.8 380.2C363.3 353.8 382.2 327.9 409.3 325.8L459.5 322.1 421.1 289.6C400.3 272 400.3 240 421.1 222.4L459.5 189.9 409.3 186.1C382.1 184.1 363.3 158.2 369.8 131.8L381.8 82.9 338.9 109.4C315.8 123.7 285.3 113.8 275.1 88.6L256 42 236.9 88.6C226.6 113.8 196.2 123.7 173 109.4L130.2 82.9 142.2 131.8C148.7 158.2 129.8 184.1 102.7 186.1L52.5 189.9 90.9 222.4C111.7 240 111.7 272 90.9 289.6L52.5 322.1 102.7 325.8C129.9 327.9 148.7 353.8 142.2 380.2L130.2 429.1 173 402.6C196.2 388.3 226.7 398.3 236.9 423.4zM256 384C185.4 384 128 326.6 128 256 128 185.4 185.4 128 256 128 326.6 128 384 185.4 384 256 384 326.6 326.6 384 256 384zM256 176C211.9 176 176 211.9 176 256S211.9 336 256 336 336 300.1 336 256 300.1 176 256 176z"}]}}),H.register({"regular/thumbs-down":{width:512,height:512,paths:[{d:"M466.3 225.3C470.9 202.7 467.1 180.8 457.3 162.3 460.2 138.5 453.3 113.8 439.9 95.3 439 39.4 404.1 0 327 0 320 0 312 0 304.8 0 201.2 0 169 40 128 40H117.2C111.5 35 104.1 32 96 32H32C14.3 32 0 46.3 0 64V304C0 321.7 14.3 336 32 336H96C107.8 336 118.2 329.6 123.7 320H130.8C149.9 337 176.8 380.7 199.5 403.4 213.2 417.1 209.7 512 271.3 512 328.9 512 366.6 480.1 366.6 407.3 366.6 388.9 362.6 373.5 357.7 360.7H394.2C442.8 360.7 480 319.2 480 275.1 480 256 475 240.2 466.3 225.3zM64 296C50.7 296 40 285.3 40 272S50.7 248 64 248 88 258.7 88 272 77.3 296 64 296zM394.2 312.7H290.2C290.2 350.6 318.6 368.1 318.6 407.3 318.6 431 318.6 464 271.3 464 252.4 445.1 261.8 397.8 233.5 369.5 206.9 342.9 167.3 272 138.9 272H128V85.8C181.6 85.8 228 48 299.6 48H337.5C373 48 398.3 65.1 390.6 113.9 405.8 122.1 417.1 150.4 404.5 171.5 426.1 191.9 423.2 222.5 409.7 237.1 419.2 237.1 432.1 256 432 274.9 431.9 293.8 415.3 312.7 394.2 312.7z"}]}}),H.register({"regular/thumbs-up":{width:512,height:512,paths:[{d:"M466.3 286.7C475 271.8 480 256 480 236.8 480 192.8 442.8 151.3 394.2 151.3H357.7C362.6 138.5 366.6 123.1 366.6 104.7 366.6 31.9 328.9 0 271.3 0 209.7 0 213.2 94.9 199.5 108.6 176.8 131.3 149.9 175 130.8 192H32C14.3 192 0 206.3 0 224V464C0 481.7 14.3 496 32 496H96C110.9 496 123.4 485.8 127 472.1 171.5 473.1 202 512 304.8 512 312 512 320 512 327 512 404.1 512 439 472.6 439.9 416.7 453.3 398.2 460.2 373.5 457.3 349.7 467.1 331.2 470.9 309.3 466.3 286.7zM404.5 340.5C417.1 361.6 405.8 389.9 390.6 398.1 398.3 446.9 373 464 337.5 464H299.6C228 464 181.6 426.2 128 426.2V240H138.9C167.3 240 206.9 169.1 233.5 142.5 261.8 114.2 252.4 66.9 271.3 48 318.6 48 318.6 81 318.6 104.7 318.6 143.9 290.2 161.4 290.2 199.3H394.2C415.3 199.3 431.9 218.2 432 237.1 432.1 256 419.2 274.9 409.7 274.9 423.2 289.5 426.1 320.1 404.5 340.5zM88 432C88 445.3 77.3 456 64 456S40 445.3 40 432 50.7 408 64 408 88 418.7 88 432z"}]}}),H.register({"regular/times-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM357.8 193.8L295.6 256 357.8 318.2C362.5 322.9 362.5 330.5 357.8 335.2L335.2 357.8C330.5 362.5 322.9 362.5 318.2 357.8L256 295.6 193.8 357.8C189.1 362.5 181.5 362.5 176.8 357.8L154.2 335.2C149.5 330.5 149.5 322.9 154.2 318.2L216.4 256 154.2 193.8C149.5 189.1 149.5 181.5 154.2 176.8L176.8 154.2C181.5 149.5 189.1 149.5 193.8 154.2L256 216.4 318.2 154.2C322.9 149.5 330.5 149.5 335.2 154.2L357.8 176.8C362.5 181.5 362.5 189.1 357.8 193.8z"}]}}),H.register({"regular/trash-alt":{width:448,height:512,paths:[{d:"M192 188V404C192 410.6 186.6 416 180 416H156C149.4 416 144 410.6 144 404V188C144 181.4 149.4 176 156 176H180C186.6 176 192 181.4 192 188zM292 176H268C261.4 176 256 181.4 256 188V404C256 410.6 261.4 416 268 416H292C298.6 416 304 410.6 304 404V188C304 181.4 298.6 176 292 176zM424 80C437.3 80 448 90.7 448 104V116C448 122.6 442.6 128 436 128H416V464C416 490.5 394.5 512 368 512H80C53.5 512 32 490.5 32 464V128H12C5.4 128 0 122.6 0 116V104C0 90.7 10.7 80 24 80H98.4L132.4 23.3A48-48 0 0 0 173.6 0H274.4A48-48 0 0 0 315.6 23.3L349.6 80H424zM154.4 80H293.6L276.2 50.9A6-6 0 0 1 271 48H177A6-6 0 0 1 171.8 50.9L154.4 80zM368 128H80V458A6-6 0 0 1 86 464H362A6-6 0 0 1 368 458V128z"}]}}),H.register({"regular/user-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 56C366.5 56 456 145.5 456 256 456 293 446 327.6 428.5 357.3 421.4 331.9 402.8 303.1 364.5 292 377.2 271.8 384 248.4 384 224 384 153.3 326.8 96 256 96 185.3 96 128 153.2 128 224 128 248.4 134.8 271.8 147.5 292 109.2 303.1 90.6 331.9 83.5 357.3 66 327.6 56 293 56 256 56 145.5 145.5 56 256 56zM336 224C336 268.2 300.2 304 256 304S176 268.2 176 224 211.8 144 256 144 336 179.8 336 224zM128 409.7V381.9C128 361.5 141.5 343.6 161.2 338L185.6 331C206.3 344.6 230.6 352 256 352S305.7 344.6 326.4 331L350.8 338C370.5 343.6 384 361.5 384 381.9V409.7C349.3 438.6 304.7 456 256 456S162.7 438.6 128 409.7z"}]}}),H.register({"regular/user":{width:512,height:512,paths:[{d:"M423.3 291L402.2 285C431.8 243.9 436 202.3 436 180 436 80.6 355.5 0 256 0 156.6 0 76 80.5 76 180 76 202.3 80.2 243.9 109.8 285L88.7 291C21.3 310.3 0 371.6 0 408.6V434.3C0 477.1 34.9 512 77.7 512H434.3C477.1 512 512 477.1 512 434.3V408.6C512 372.4 491.3 310.4 423.3 291zM256 48C328.9 48 388 107.1 388 180S328.9 312 256 312 124 252.9 124 180 183.1 48 256 48zM464 434.3C464 450.7 450.7 464 434.3 464H77.7C61.3 464 48 450.7 48 434.3V408.6C48 375.4 70 346.3 101.9 337.2L148 324C162.7 335.1 200.4 360 256 360S349.3 335.1 364 324L410.1 337.2C442 346.3 464 375.4 464 408.6V434.3z"}]}}),H.register({"regular/window-close":{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM464 426C464 429.3 461.3 432 458 432H54C50.7 432 48 429.3 48 426V86C48 82.7 50.7 80 54 80H458C461.3 80 464 82.7 464 86V426zM356.5 194.6L295.1 256 356.5 317.4C361.1 322 361.1 329.5 356.5 334.2L334.2 356.5C329.6 361.1 322.1 361.1 317.4 356.5L256 295.1 194.6 356.5C190 361.1 182.5 361.1 177.8 356.5L155.5 334.2C150.9 329.6 150.9 322.1 155.5 317.4L216.9 256 155.5 194.6C150.9 190 150.9 182.5 155.5 177.8L177.8 155.5C182.4 150.9 189.9 150.9 194.6 155.5L256 216.9 317.4 155.5C322 150.9 329.5 150.9 334.2 155.5L356.5 177.8C361.2 182.4 361.2 189.9 356.5 194.6z"}]}}),H.register({"regular/window-maximize":{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM464 426C464 429.3 461.3 432 458 432H54C50.7 432 48 429.3 48 426V192H464V426z"}]}}),H.register({"regular/window-minimize":{width:512,height:512,paths:[{d:"M480 480H32C14.3 480 0 465.7 0 448S14.3 416 32 416H480C497.7 416 512 430.3 512 448S497.7 480 480 480z"}]}}),H.register({"regular/window-restore":{width:512,height:512,paths:[{d:"M464 0H144C117.5 0 96 21.5 96 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H464C490.5 416 512 394.5 512 368V48C512 21.5 490.5 0 464 0zM368 464H48V256H368V464zM464 368H416V144C416 117.5 394.5 96 368 96H144V48H464V368z"}]}}),H.register({"brands/500px":{width:448,height:512,paths:[{d:"M103.3 344.3C96.8 330.1 96.4 326 110.7 321.2 136.3 313.2 118.7 330.4 153.9 370.4H154.2V276.5C155.4 226.3 198.2 184.3 251.9 184.3 305.8 184.3 349.6 227.8 349.6 281.1 349.6 344.5 288.8 394.3 221.1 374.4 210.6 370.2 219 342.7 229.6 345.8 282.6 345.8 319 335.7 319 281.4 319 220.4 241.9 191.8 202.1 236.8 178.6 263.2 184.5 278.9 184.5 394.4 235.2 425.4 302.8 416.4 344.9 374.3 369.7 349.5 383.4 316.3 383.4 281.3 383.4 246.1 369.6 213.1 344.6 188 319.8 163.2 286.8 149.5 251.3 149.5S182.5 163.3 157.8 188C157.5 188.3 141.8 204.5 136.6 211.9L136.1 212.5C132.8 217.2 129.8 221.6 116 218.6 109.1 216.9 101.7 212.8 101.7 206.8V20C101.7 15 105.6 9.5 112.2 9.5H353.5C361.8 9.5 361.8 21.1 361.8 24.6 361.8 28.5 361.8 39.7 353.5 39.7H130.3V172.6H130.6C234.8 62.8 413.4 136.6 413.4 281.5 413.4 459.6 168.6 501.8 103.3 344.3zM166.6 83.5C166.1 87.7 171.2 108 181.2 104.1 306 56.6 384 144.5 390.6 144.5 395.4 144.5 413.4 129.2 404.9 121.7 311.7 32.7 170.4 64.7 166.6 83.5zM393 414.7C283 524.6 94 475.5 61 310.5 61 298.3 30.6 303.1 32.1 313.8 56.1 487.2 278.1 570.7 413.7 435.1 420.6 427.3 401.1 406.7 393 414.7zM213.6 306.6C213.6 310.6 217.9 313.9 219.1 315.1 222.1 318.1 225.2 319.5 227.6 319.5 231.4 319.5 230.2 319.7 249.9 300 269.5 319.3 269 319.5 272.2 319.5 277.6 319.5 290.7 309.1 282.9 301.3L265.6 284 283.8 265.8C290.1 259 273.7 244 267.6 250.1L249.7 268C231.1 249.2 231.3 248.5 228.2 248.5 223.2 248.5 210.2 260.2 215.8 265.8L234 284C215.9 301.9 213.6 303.2 213.6 306.6z"}]}}),H.register({"brands/accessible-icon":{width:448,height:512,paths:[{d:"M423.9 255.8L411 413.1C407.7 453.8 347.1 448.2 350.4 408.2L360.4 285.7 319.3 288C329.4 308.7 335.1 331.9 335.1 356.5 335.1 397.7 319 435.2 292.8 463L253.5 423.7C311.4 360 266.6 256.5 179.5 256.5 153.6 256.5 130 266.4 112.3 282.5L73 243.2C95 222.5 123.1 208.1 154.4 203L229.7 117.3 187.1 92.5 135.5 138.5C105.5 165.3 64.9 120 95 93.1L163 32.4C172.8 23.6 187.1 22.2 198.5 28.8 198.5 28.8 337.8 109.7 338 109.9 354.2 120 358.7 145.9 344.1 162.5L285.7 229 391.8 223.1C410.3 222 425.4 237.5 423.9 255.8zM359 101.8C387.1 101.8 409.9 79 409.9 50.9 409.9 22.8 387.1 0 359 0 330.9 0 308.1 22.8 308.1 50.9 308.1 79 330.9 101.8 359 101.8zM179.6 456.5C99 456.5 52.2 365.9 96.9 300.4L57.2 260.7C36.4 287 24 320.3 24 356.4 24 487.1 174.7 557.8 275.4 478.9L235.7 439.2C219.7 450.1 200.4 456.5 179.6 456.5z"}]}}),H.register({"brands/accusoft":{width:640,height:512,paths:[{d:"M482.2 372.1C476.5 365.2 250 75 242.3 65.5 228.6 48.3 242.3 48.7 261.5 48.6 271.2 48.5 367.8 48 378 48 402.1 47.9 406.7 48.6 416.4 60.8 418.5 63.5 621.5 306.6 623.6 309.1 629.1 315.8 638.8 328.2 630.8 332.5 628.4 333.8 516.2 380.2 513 381.4 502.9 385.4 495.5 388.2 482.2 372.1M596.9 366.5S481.9 416.9 479.4 418.1C463.4 425.4 452.5 414.9 442.7 403.5L385.6 329.5C380.2 328.6 325.2 319.9 320.3 320.2 317.2 320.4 310.7 321 305.9 323.1 301 325.2 160.7 375.9 155.7 377.8 150.6 379.8 144.3 381.4 144.6 385.4 144.8 387.9 146.6 388 149.2 388.9 151.9 389.7 450.1 456.5 457.2 458 472.8 461.3 495.7 468.5 510.8 459.7 512.9 458.5 634.6 383.3 636.6 381.9 642 377.9 640.9 375.1 634.9 373.7 632.6 373.4 610.3 369 596.9 366.5M270.9 185.2S258.9 186.8 245.9 200.3C236.9 209.6 3.8 439.4 2.5 441.2-4.5 451.2 4.1 448 18.2 442.9 19 442.9 132.7 406.3 132.7 406.3 133.2 405.7 132.6 406.2 133.3 405.7 132.9 400.6 132.5 379.5 132.3 378 131.7 372.8 134.5 371.1 139.3 369.1L231.9 335.3C232.5 334.5 320.4 253.6 322.1 252V251L270.9 185.2"}]}}),H.register({"brands/adn":{width:496,height:512,paths:[{d:"M248 167.5L312.9 266.3H183.1L248 167.5zM496 256C496 392.9 384.9 504 248 504S0 392.9 0 256 111.1 8 248 8 496 119.1 496 256zM396.2 338.7L248 115.5 99.8 338.7H130.2L163.8 287H332.4L366 338.7H396.2z"}]}}),H.register({"brands/adversal":{width:512,height:512,paths:[{d:"M482.1 32H28.7C5.8 32 0 37.9 0 60.9V451.1C0 474.4 5.8 480 28.7 480H482.1C506.5 480 512 474.8 512 450.3V62.2C512 37.6 506.6 32 482.1 32zM178.4 220.3C150.9 200.1 106.3 211.6 94.2 243.7 89.9 254.8 84.9 253.2 76.7 252 67 250.5 59.5 248.8 54.2 246.5 25.4 235.1 62.8 191.2 79.1 182.2 120.2 160.8 162.5 160 204.4 177.4 245.3 194.2 238.9 236.6 238.9 305.9 241.6 331.7 234.6 364.2 248.2 394.7 250.1 399.1 248.6 402.6 245.5 405.4 237.1 412.1 206.2 407.6 198.9 398 197 395.8 197.1 394.4 195 391.8 191.4 387.9 187.7 389.6 183.1 392.8 125.7 429.2 42.8 414.2 36.1 349.5 33 320.2 48.5 292.4 75.7 278.5 113.9 259 187.9 266.7 189.7 247.6 190.8 237.4 187.8 227.5 178.4 220.3zM465.1 442.3C465.1 457.4 454 452.2 447.3 452.2H52.4C45 452.2 34.2 457 34.6 441.5 35 427.6 45.1 432.4 51.7 432.4 184 432 316.2 432 448.5 432.4 455.3 432.4 465.1 428 465.1 442.3zM468.9 101.8V392.8C468.9 398.5 468.2 406.7 460.8 406.7 448.4 406.3 433.3 413.8 424.7 401.1 418.9 392.4 416.9 397.1 412.3 399.9 358.9 429.6 284.2 407 267.9 314.7 261.8 281.3 267.2 247.6 283.6 214.7 295.4 190.8 340.5 138.6 419.7 184.2V113.2C419.7 87 419.6 87 445.7 87 448.8 87 452.3 87.4 455.4 87 465.5 86.2 469 91.4 469 101.3 468.9 101.5 468.9 101.6 468.9 101.8zM417.4 334.1C397.9 381.7 344.5 377.4 327.4 339.3 312.3 306 311.9 271.1 327.8 237.8 344.1 203.7 387.5 202.1 409.3 233 429.9 261.8 424.2 317.6 417.4 334.1zM122.6 369.4C115.1 368.1 89.6 366.1 88.9 341.6 88.5 327.7 96.7 318.6 108.7 315.8 133.1 309.9 158 305.9 182.4 301.1 191.3 299.1 189.8 305.5 190.2 310.6 191.6 343.6 164.1 369.8 122.6 369.4z"}]}}),H.register({"brands/affiliatetheme":{width:512,height:512,paths:[{d:"M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1 105.5 88.2 170.8 48.3 199.9 69.9 229 91.5 211 166.5 159.7 237.4zM510.9 180.1C437.1 303.5 319 367.8 246.4 323.7 221.4 308.5 205.1 282.5 197.4 249.9 163.8 314.7 104.6 363.7 33.3 383.1 83.1 442.4 157.4 480 240.3 480 390.3 480 511.9 356.9 511.9 205.1 512 196.6 511.6 188.3 510.9 180.1z"}]}}),H.register({"brands/algolia":{width:448,height:512,paths:[{d:"M229.3 182.6C180 182.6 140.1 222.5 140.1 271.8 140.1 321.1 180 361 229.3 361S318.5 321.1 318.5 271.8C318.5 222.5 278.5 182.6 229.3 182.6zM292 239.2L233.1 269.8C231.3 270.7 229.3 269.4 229.3 267.5V201C229.3 199.5 230.6 198.3 232 198.4 258.2 199.4 280.9 214.1 293.1 235.5 293.8 236.8 293.3 238.5 292 239.2zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421C0 453.6 26.4 480 58.9 480H389C421.6 480 447.9 453.6 447.9 421.1V90.9C448 58.4 421.6 32 389.1 32zM186.5 116.7C186.5 105.9 195.2 97.2 206 97.2H251.3C262.1 97.2 270.8 105.9 270.8 116.7V132.1C270.8 133.9 269.1 135.1 267.5 134.6 255.2 131.2 242.4 129.5 229.4 129.5 215.9 129.5 202.7 131.3 190 135 188.3 135.5 186.6 134.2 186.6 132.5V116.7zM102.1 153.7L111.3 144.5C118.9 136.9 131.2 136.9 138.8 144.5L146.5 152.2C147.6 153.3 147.5 155.2 146.2 156.2 140 160.7 134.1 165.6 128.6 171.1 123.2 176.5 118.2 182.4 113.8 188.5 112.8 189.8 110.9 190 109.8 188.8L102.1 181.1C94.5 173.6 94.5 161.3 102.1 153.7zM229.3 398.5C159.3 398.5 102.7 341.8 102.7 271.9S159.4 145.3 229.3 145.3C299.3 145.3 355.9 201.9 355.9 271.9 355.9 341.7 299.2 398.5 229.3 398.5z"}]}}),H.register({"brands/amazon-pay":{width:611,height:512,paths:[{d:"M0 325.2C2.3 321 5.2 320.3 9.7 322.7 20.1 328.3 30.3 334.1 40.9 339.4 81.6 359.8 124.1 375 168.3 385.7 189.2 390.7 210.2 394.7 231.5 397.5 263 401.7 294.7 403.5 326.5 402.7 343.9 402.3 361.3 400.9 378.6 398.9 435 392.2 489.5 378.1 541.9 356.1 544.8 354.9 547.8 354.1 551 354.9 557.7 356.7 560 363.9 555.1 368.8 552.3 371.6 548.8 373.9 545.5 376.2 514.8 397.3 481.3 412.6 445.9 424.1 421.3 432 396.3 437.9 370.8 441.7 353.2 444.3 335.4 446.1 317.6 446.5 316.8 446.5 315.9 446.7 315.1 446.8H294C293.2 446.7 292.3 446.5 291.5 446.5 287.9 446.3 284.3 446.2 280.8 446.1 263.9 445.4 247.1 443.5 230.4 440.8 203 436.3 176.2 429.4 150 419.9 95.9 400.3 47.4 371.3 4.4 332.9 2.6 331.3 1.4 329.1 0 327.2V325.2zM158 65C156.6 65.2 155.1 65.4 153.7 65.6 139.7 67.3 127.1 72.5 115.7 80.7 113.3 82.4 111.1 84.2 108.6 86.1 108.4 85.6 108.2 85.1 108.2 84.7 107.8 82 107.4 79.2 106.9 76.5 106.2 71.9 103.9 69.9 99.3 69.9H87.8C80.9 69.9 79.6 71.2 79.6 78.1V287.4C79.6 288.4 79.6 289.4 79.7 290.4 79.9 293.4 81.7 295.3 84.6 295.4 91.6 295.5 98.7 295.5 105.7 295.4 108.6 295.4 110.4 293.4 110.7 290.4 110.8 289.4 110.8 288.4 110.8 287.4V215C111.9 215.9 112.5 216.4 113 216.9 130.9 231.8 151.5 236.7 174 232.3 194.4 228.3 208.6 215.8 217.8 197.4 224.8 183.5 227.7 168.7 228.1 153.3 228.6 136.2 226.9 119.4 220 103.5 211.5 83.9 197.4 71 176.1 66.6 172.9 65.9 169.6 65.6 166.3 65.1 163.5 65 160.8 65 158 65zM110.6 106.9C110.6 105.4 111 104.5 112.3 103.6 126 94.1 141.1 89.1 157.9 90.4 172.8 91.5 185 98.8 191.4 116.3 195.3 127 196.3 138.1 196.3 149.3 196.3 159.7 195.5 169.9 192.3 179.9 185.5 201.2 169.9 209.3 149.7 208.4 135.7 207.8 123.5 202.4 112.3 194.5 111.1 193.6 110.6 192.8 110.6 191.2 110.7 177.1 110.6 163.1 110.6 149 110.6 135 110.7 121 110.6 106.9zM316.3 65C315.3 65.1 314.3 65.3 313.4 65.4 303.6 65.9 294 67.1 284.5 69.5 278.4 71.1 272.5 73.3 266.6 75.3 263 76.5 261.2 79.1 261.3 83 261.4 86.3 261.2 89.6 261.3 92.9 261.4 97.7 263.4 99 268.1 97.8 275.9 95.8 283.7 93.6 291.6 92.1 303.9 89.8 316.3 88.8 328.8 90.7 335.3 91.7 341.4 93.6 345.6 99.1 349.3 103.9 350.7 109.6 350.9 115.5 351.2 123.8 351.1 132.1 351.2 140.4 351.2 140.8 351.1 141.3 351 141.8 350.5 141.7 350.1 141.8 349.7 141.7 339.2 139.2 328.6 137.4 317.7 136.8 306.4 136.2 295.2 136.9 284.4 140.7 271.5 145.2 261.1 153 255 165.6 250.3 175.4 249.6 185.8 251.1 196.3 253.1 210.3 260.1 221.1 272.5 228 284.4 234.6 297.3 235.4 310.4 233.4 325.5 231.1 338.9 224.7 350.7 215 351.1 214.6 351.6 214.3 352.3 213.9 352.9 217.7 353.4 221.3 354.1 224.9 354.7 228 356.6 230 359.5 230.1 364.9 230.2 370.4 230.2 375.8 230.1 378.5 230 380.3 228.2 380.6 225.4 380.7 224.5 380.7 223.5 380.7 222.6V116.6C380.7 112.3 380.5 108 379.8 103.7 377.9 90.8 372.4 80.2 360.8 73.3 354.1 69.3 346.7 67.3 339 66.2 335.4 65.7 331.8 65.4 328.2 64.9 324.3 65 320.3 65 316.3 65zM351.3 192.7C351.3 194 350.9 194.9 349.8 195.7 338.6 203.8 326.3 209.2 312.4 210.6 306.7 211.2 301 211 295.6 208.8 289.3 206.3 285.2 201.9 283.2 195.5S281.2 182.5 283.1 176.1C285.6 167.8 291.5 163.1 299.5 160.5 307.6 157.9 316 157.5 324.3 158.3 332.7 159 340.9 160.6 349.3 161.7 350.9 161.9 351.4 162.7 351.4 164.3 351.3 169.1 351.4 173.8 351.4 178.6 351.3 183.3 351.2 188 351.3 192.7zM611.2 322.1C610.2 317.1 606.4 315.2 602.1 313.8 595.3 311.5 588.2 310.5 581.1 309.9 568 308.8 554.9 309.4 541.9 311.8 527.6 314.5 514 319.1 501.9 327.4 500.5 328.4 499.1 329.5 498.2 330.9 497.5 332 497.3 333.7 497.7 334.9 498.1 336.4 499.8 336.8 501.3 336.7 502 336.7 502.8 336.7 503.5 336.6 511.3 335.8 519 334.9 526.8 334.1 538.2 333 549.7 332.3 561.1 333.2 565.9 333.5 570.8 334.6 575.5 335.9 580.6 337.3 582.9 341.1 583.1 346.3 583.5 354.3 581.7 362 579.6 369.6 575.5 385 569.6 399.9 563.8 414.7 563.4 415.7 563 416.7 562.8 417.7 562.3 420.6 564 422.5 566.9 421.8 568.6 421.4 570.5 420.5 571.7 419.3 576.1 415 580.6 410.7 584.4 405.9 597.2 389.5 604.7 370.6 609.1 350.3 609.9 346.7 610.5 343 611.2 339.4V322.1zM479.1 198.9C466.2 163.2 453.3 127.4 440.4 91.7 438.4 86 436.2 80.4 434.1 74.8 433 71.9 430.9 70 427.7 70 420.1 69.9 412.5 69.8 404.8 69.9 402.3 69.9 401.1 71.9 401.6 74.4 402.1 76.5 402.7 78.5 403.5 80.5 423.1 129 442.8 177.6 462.6 226 464.3 230.1 464.7 233.6 462.8 237.8 459.5 245.1 456.9 252.8 453.5 260.1 450.5 266.6 445.5 271.5 438.3 273.4 433.2 274.8 428.1 275 422.9 274.5 420.4 274.3 417.9 273.7 415.4 273.5 412 273.3 410.3 274.8 410.2 278.3 410.1 281.6 410.1 284.9 410.2 288.2 410.3 293.7 412.2 296.2 417.6 297.1 423.2 298.1 428.9 299 434.5 299.1 451.6 299.5 465.2 292.6 474 277.7 477.5 271.8 480.7 265.6 483.2 259.3 506.9 199.5 530.3 139.6 553.8 79.7 554.5 77.9 555.1 76.1 555.4 74.2 555.8 71.4 554.5 69.8 551.7 69.8 545.1 69.7 538.4 69.8 531.8 69.8 528.1 69.8 525.5 71.4 524.1 75 523.6 76.4 523 77.7 522.5 79.1 510.9 112.4 499.3 145.7 487.7 179.1 485.2 186.3 482.6 193.6 480 201.3 479.6 200.2 479.4 199.6 479.1 198.9z"}]}}),H.register({"brands/amazon":{width:448,height:512,paths:[{d:"M257.2 162.7C208.5 164.5 87.7 178.2 87.7 280.2 87.7 389.7 226 394.2 271.2 323.4 277.7 333.6 306.6 360.9 316.5 370.2L373.3 314.2S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3L167.5 143.1C183.8 93.6 221.7 93.6 221.7 93.6 262.4 93.5 257.2 123.4 257.2 162.7zM257.2 249.5C257.2 329.5 173 317.5 173 266.7 173 219.5 223.5 210 257.2 208.9V249.5zM393.2 413C385.5 423 323.2 480 218.7 480S34.2 408.5 9.7 379C2.9 371.3 10.7 367.7 15.2 370.7 88.5 415.2 203 488.5 387.7 401 395.2 397.3 401 403 393.2 413zM433 415.2C426.5 431 417 442 411.8 446.2 406.3 450.7 402.3 448.9 405.3 442.4S424.6 395.9 418 387.4C411.5 379.1 381 383.1 370 384.2 359.2 385.2 357 386.2 356 383.9 353.7 378.2 377.7 368.4 393.5 366.4 409.2 364.6 434.5 365.6 439.5 372.1 443.2 377.2 439.5 399.2 433 415.2z"}]}}),H.register({"brands/amilia":{width:448,height:512,paths:[{d:"M240.1 32C178.2 32 108.6 48.9 55.9 87.4 50.8 90.5 46.8 96.6 48.7 106.8 49.8 111.9 53.8 134.2 58.9 146.4 63 156.6 73.1 156.6 79.2 152.5 111.7 130.2 175.7 104.8 231.5 104.8 289.4 104.8 290.4 133.2 290.4 177.9V216.4C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376S31.5 480 141.2 480C189 480 254.9 459.3 294.5 437.9V463.3C294.5 466.3 296.6 471.5 300.6 472.4 303.7 473.4 351.3 474.4 360.5 474.4S423 474.7 427 473.7C431.1 472.7 432.1 467.6 432.1 464.6V168C432 87.7 374.2 32 240.1 32zM152.2 359.7C152.2 347.5 149.2 317 170.5 306.8 194.8 293.6 245.6 277.4 290.3 273.3V380C268.9 393.2 241.6 404.4 211.2 404.4 158.4 404.4 152.3 370.9 152.2 359.7"}]}}),H.register({"brands/android":{width:448,height:512,paths:[{d:"M89.6 204.5V320.3C89.6 335.7 77.5 348 62.1 348 46.8 348 32 335.6 32 320.3V204.5C32 189.4 46.8 177 62.1 177 77.2 177 89.6 189.4 89.6 204.5zM100.4 361.5C100.4 377.9 113.6 391.1 130 391.1H149.9L150.2 452.2C150.2 489.1 205.4 488.8 205.4 452.2V391.1H242.6V452.2C242.6 488.9 298.1 489 298.1 452.2V391.1H318.3C334.5 391.1 347.7 377.9 347.7 361.5V182.1H100.4V361.5zM348.4 172.4H99.3C99.3 129.6 124.9 92.4 162.9 73L143.8 37.7C141 32.8 148.1 29.7 150.5 33.9L169.9 69.5C204.8 54 244.9 54.8 278.2 69.5L297.5 34C300 29.7 307 32.9 304.2 37.8L285.1 73C322.8 92.4 348.4 129.6 348.4 172.4zM177.7 116.9C177.7 111.2 173.1 106.4 167.2 106.4 161.5 106.4 157 111.2 157 116.9S161.6 127.4 167.2 127.4C173.1 127.4 177.7 122.6 177.7 116.9zM291.1 116.9C291.1 111.2 286.5 106.4 280.9 106.4 275 106.4 270.4 111.2 270.4 116.9S275 127.4 280.9 127.4C286.5 127.4 291.1 122.6 291.1 116.9zM385.9 177C370.8 177 358.4 189.1 358.4 204.5V320.3C358.4 335.7 370.8 348 385.9 348 401.3 348 416 335.6 416 320.3V204.5C416 189.1 401.2 177 385.9 177z"}]}}),H.register({"brands/angellist":{width:448,height:512,paths:[{d:"M347.1 215.4C358.8 182.8 392.5 88.5 392.5 58.3 392.5 31.7 376.8 9.4 348.8 9.4 304.2 9.4 264.2 141.1 251.7 172.5 242 144 196.6 0 156.6 0 125.5 0 110.9 22.9 110.9 51.7 110.9 87 145.1 178.5 157.5 213.7 151.2 211.4 144.4 209.4 137.5 209.4 114.1 209.4 89.2 238.5 89.2 262 89.2 270.9 94.1 283.4 97.2 291.7 60.3 301.7 46.1 326.3 46.1 363.4 46 435.6 114.4 512 210.6 512 328.6 512 402 423.4 402 309.1 402 266 395.1 227.1 347.1 215.4zM311.7 108C315.7 95.7 332.8 43.7 348.8 43.7 357.4 43.7 359.7 52.6 359.7 59.7 359.7 78.8 321.1 184.3 312.6 207.7L278.6 201.7 311.7 108zM142.3 48.3C142.3 36.4 156.8 2.6 188.6 95.4L223.2 195.7C207.6 194.4 195.5 192.7 187.8 197.1 176.9 168.3 142.3 77.4 142.3 48.3zM140 244C169.3 244 207.1 338.6 207.1 351.4 207.1 356.5 202.2 362.8 196.5 362.8 175.6 362.8 119.6 285.9 119.6 265.1 119.7 257.4 132.3 244 140 244zM324.3 430.3C295.2 462.3 258 478.9 214.6 478.9 155.2 478.9 108.3 446.3 85.7 390.6 68.6 347.2 89.5 322.3 106.3 322.3 117.7 322.3 160.6 382.6 160.6 395.4 160.6 400.3 152.9 403.7 148.9 403.7 132.8 403.7 126.5 388.2 97.8 352.3 68.1 382 118.3 439.2 156.1 439.2 182.2 439.2 199.2 415 194.1 397.2 197.8 397.2 202.4 397.5 205.8 396.6 206.9 423.7 214.9 456 247.5 458.3 247.5 457.4 249.5 451.2 249.5 450.9 249.5 433.5 238.9 418.3 238.9 400.6 238.9 372.3 260.6 344.9 282.6 328.9 290.6 322.9 300.3 319.2 309.7 315.8 319.4 312.1 329.7 307.8 337.1 300.4 336 289.2 331.4 279.3 320.2 279.3 292.5 279.3 199.6 283.3 199.6 239.6 199.6 232.9 199.7 226.5 217 226.5 249.3 226.5 331.3 234.5 355.3 255.6 373.4 271.7 379.6 368.8 324.3 430.3zM225.7 304.3C235.4 307.4 245.4 308.3 255.4 310.3 248 315.7 241.4 322.3 235.1 329.4 232.3 320.9 228.9 312.6 225.7 304.3z"}]}}),H.register({"brands/angrycreative":{width:640,height:512,paths:[{d:"M640 238.2L636.8 266.4 602.3 268.7 600.3 286.8 634.8 284.5 631.6 312.7 597.2 314.9 594.9 335 629.3 332.8 626.3 358.9 561.6 363 574.3 249.8 527 365.2 495.1 367.2 471.3 249.4 501.6 247.4 515.2 326.8 546.9 244.4 640 238.2zM426.8 371.5L455.1 369.7 468 249.6 439.6 251.5 426.8 371.5zM162 388.1L142.6 352.1 139.1 389.5 110.9 391.2 113.6 362.1C102.6 380.1 81.6 396.4 56.7 397.9 23.9 399.9-3 377 0.3 339.7 2.9 310.4 27 276.9 67.8 274.3 105.5 271.9 115.4 297.5 119.1 303.1L121.9 272.3 160.8 269.8C180.9 268.5 199.5 273.5 203.3 293.5L205.9 266.9 270.7 262.7 268 290.6 231.6 293 229.9 310.9 266.3 308.6 263.6 336.5 227.2 338.8 225.3 358.7 261.6 356.4 259.5 377.2 314.5 260 338.3 258.4 370.4 369 379.3 283.4 357 284.8 359.9 256.9 434.9 252 431.9 280 407.6 281.6 397.9 373.5 339.9 377.2 335.6 361.6 296.2 364.1 288.2 380.4 162 388.1zM117.7 317.9L91.3 319.6C84.6 307.2 76.9 303 65 303.8 46 305 31.7 321.3 30.4 337.1 29 353.1 37.7 369.6 59.1 368.3 71.9 367.5 80.4 359.7 88 349.4L115 347.7 117.7 317.9zM173.8 310.2C175 297.3 166.2 296.6 147.7 297.8L145 326.3C159.2 325.4 172.5 324.2 173.8 310.2zM194.9 381L200.7 321C195.7 334.5 186 342.1 172.8 347.6L194.9 381zM330.3 336L322.4 298.2 306.6 337.5 330.3 336zM160.2 261.4L155.9 243.9 116.3 246.5 108.2 264.7 76.3 266.8 133.3 144.9 157.2 143.3 187.9 245.3 197.8 140.6 224.8 138.8 262.6 202.4 269.1 135.8 297.6 133.9 293.6 175.1C301 161.6 316.5 130.4 357.2 127.6 397.7 124.8 409.6 156.9 410.6 157.9L413.9 125.9 453.2 123.2C465.9 122.3 481 123.5 489.5 132.9L485.1 121 517.3 118.8 530.2 162 553.2 116.3 584.2 114.1 540.6 192.5 535.8 236.8 507.4 238.7 512.2 194.4 496.4 151.4C497.4 173.7 487.2 191.5 464.4 201L489.6 239.8 453.2 242.2 434 205.4 430 243.7 401.6 245.6 404.9 214.1C398.2 223.4 385.2 249.5 345.3 252.1 319.1 253.8 299.7 241.8 289.9 212.9L285.9 253.2 260.9 254.8 223.3 191.5 217 257.7 160.2 261.4zM436.8 179.3C447 178.6 454.3 177.2 458.4 175 462.9 172.6 465.4 168.6 466 162.9 466.6 157.6 465.4 154.1 462.6 152.5 459 150.4 452 149.7 439.7 150.5L436.8 179.3zM327.7 214C333.3 219.9 340.4 222.5 349 221.9 353.7 221.6 358.1 220.1 362.3 217.8 367.8 214.8 372.9 209.8 377.4 203.5L343.2 205.8 345.6 181.9 408.7 177.6 409.9 165.6 378.7 167.7C374.6 164 370.9 161.1 367.6 159.6 363.6 157.9 359.5 156.8 355.4 157.1 347.4 157.6 340.1 160.7 333.4 166.3 325.7 172.7 321.4 180.8 320.5 190.7 319.4 200.3 321.9 208 327.7 214zM126.4 222.2L150.2 220.6 141.9 183 126.4 222.2z"}]}}),H.register({"brands/angular":{width:415,height:512,paths:[{d:"M169.7 268.1H245.9L207.8 176.5 169.7 268.1zM207.8 32L0 106.4 31.8 382.1 207.8 480 383.8 382.1 415.6 106.4 207.8 32zM338 373.8H289.4L263.2 308.4H152.6L126.4 373.8H77.7L207.8 81.5 338 373.8z"}]}}),H.register({"brands/app-store-ios":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM127 384.5C121.5 394.1 109.2 397.3 99.7 391.8 90.1 386.3 86.9 374 92.4 364.5L106.7 339.8C122.8 334.9 136 338.7 146.3 351.2L127 384.5zM265.9 330.6H84C73 330.6 64 321.6 64 310.6S73 290.6 84 290.6H135L200.4 177.4 179.9 142C174.4 132.4 177.7 120.2 187.2 114.7 196.8 109.2 209 112.5 214.5 122L223.4 137.4 232.3 122C237.8 112.4 250.1 109.2 259.6 114.7 269.2 120.2 272.4 132.5 266.9 142L181.1 290.6H243.2C263.4 290.6 274.7 314.3 265.9 330.6zM364 330.6H335L354.6 364.5C360.1 374.1 356.8 386.3 347.3 391.8 337.7 397.3 325.5 394 320 384.5 287.1 327.6 262.5 284.8 246 256.4 229.3 227.4 241.2 198.4 253.1 188.6 266.2 211.3 285.8 245.3 312 290.6H364C375 290.6 384 299.6 384 310.6 384 321.7 375 330.6 364 330.6z"}]}}),H.register({"brands/app-store":{width:512,height:512,paths:[{d:"M255.9 120.9L265 105.2C270.6 95.4 283.1 92.1 292.9 97.7 302.7 103.3 306 115.8 300.4 125.6L212.9 277.1H276.2C296.7 277.1 308.2 301.2 299.3 317.9H113.8C102.5 317.9 93.4 308.8 93.4 297.5 93.4 286.2 102.5 277.1 113.8 277.1H165.8L232.4 161.7 211.6 125.6C206 115.8 209.3 103.4 219.1 97.7 228.9 92.1 241.3 95.4 247 105.2L255.9 120.9zM177.2 338.9L157.6 372.9C152 382.7 139.5 386 129.7 380.4 119.9 374.8 116.6 362.3 122.2 352.5L136.8 327.3C153.2 322.2 166.6 326.1 177.2 338.9zM346.1 277.2H399.2C410.5 277.2 419.6 286.3 419.6 297.6 419.6 308.9 410.5 318 399.2 318H369.7L389.6 352.5C395.2 362.3 391.9 374.7 382.1 380.4 372.3 386 359.9 382.7 354.2 372.9 320.7 314.8 295.5 271.3 278.8 242.3 261.7 212.8 273.9 183.2 286 173.2 299.4 196.2 319.4 230.9 346.1 277.2zM256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM472 256C472 374.7 375.9 472 256 472 137.3 472 40 375.9 40 256 40 137.3 136.1 40 256 40 374.7 40 472 136.1 472 256z"}]}}),H.register({"brands/apper":{width:640,height:512,paths:[{d:"M42.1 239.1C64.3 239.1 71.1 241.9 75.6 253.7H76.4V230.8C76.4 219.5 71.6 215.4 58.5 215.4 47.2 215.4 44.1 217.9 43.4 228.2H4.8C5.1 214.3 6.3 209.1 10.6 203.8 17.9 195 29.5 192 56.7 192 89.7 192 103.8 197 110.6 210.9 112.6 215.2 114.6 226.5 114.6 234.6V310.9H76.3L77.6 291.8H76.6C71.3 307.4 63 312.2 41.1 312.2 10.8 312.2 0 302.1 0 274.9 0 249.7 12.3 239.1 42.1 239.1zM59.2 287.2C72.3 287.2 76.1 284.2 76.1 273.8 76.1 264.7 71.8 262.2 56.5 262.2 43.4 262.2 38.6 265.2 38.6 274.3 38.5 284.7 42.3 287.2 59.2 287.2zM137 192.3H175.3L173.8 212.9H174.6C183.7 195.8 190.5 192 212.1 192 226.5 192 236.8 195 243.6 201.1 253.4 209.7 256.4 221.5 256.4 249.2 256.4 279.2 253.4 292.3 244.3 302.1 237.5 309.4 227.9 312.2 211.1 312.2 190.7 312.2 181.9 306.7 177.3 291H176.5V361.3H137V192.3zM217.9 253C217.9 225.5 214.6 220.5 197.2 220.5 180.3 220.5 176.5 225.5 176.5 249.2 176.5 277.2 180 282.7 197.7 282.7 214.1 282.7 217.9 277.1 217.9 253zM275.8 192.3H314.1L312.6 212.9H313.4C322.5 195.8 329.3 192 350.9 192 365.3 192 375.6 195 382.4 201.1 392.2 209.7 395.2 221.5 395.2 249.2 395.2 279.2 392.2 292.3 383.1 302.1 376.3 309.4 366.7 312.2 349.8 312.2 329.4 312.2 320.6 306.7 316 291H315.2V361.3H275.7V192.3zM356.7 253C356.7 225.5 353.4 220.5 336 220.5 319.1 220.5 315.3 225.5 315.3 249.2 315.3 277.2 318.8 282.7 336.5 282.7 352.9 282.7 356.7 277.1 356.7 253zM410.5 249.2C410.5 223.8 413.8 211.4 422.8 203.4 431.6 195.3 445 192.1 467.9 192.1 510.7 192.1 523.6 204.9 523.6 247.8V258.9H448.3C448 260.9 448 262.9 448 263.7 448 280.6 452.5 285.6 468.1 285.6 482 285.6 486 282.6 486 271.7H523.5V274C523.5 283.8 521 292.9 516.7 298.7 509.4 308.5 497.1 312.3 472.4 312.3 444.9 312.3 430.8 309 421.8 300 413.3 291.5 410.5 278.7 410.5 249.2zM486.9 237.6C486.6 235.8 486.6 234.3 486.6 233.8 486.6 221.5 483.3 219.2 467 219.2 452.6 219.2 449.9 222.2 448.9 234.3L448.6 237.6H486.9zM542.5 192.3H580.8L579 212.2H579.7C586.5 197.3 594.1 192 609.4 192 620.2 192 628.5 195.3 632.8 201.3 638.1 208.6 639.6 215.7 639.6 235.3 639.6 236.8 639.6 240.3 639.8 244.6H604.8C605.1 242.8 605.1 241.3 605.1 240.6 605.1 225.2 603.1 221.2 594.8 221.2 588.5 221.2 584 224.5 581.7 230.5 580.7 233.5 580.7 234.8 580.7 242.8V310.8H542.4V192.3z"}]}}),H.register({"brands/apple-pay":{width:640,height:512,paths:[{d:"M116.9 158.5C109.4 167.4 97.4 174.4 85.4 173.4 83.9 161.4 89.8 148.6 96.7 140.8 104.2 131.7 117.3 125.2 128 124.7 129.2 137.1 124.3 149.4 116.9 158.5M127.8 175.7C110.4 174.7 95.5 185.6 87.3 185.6 78.9 185.6 66.3 176.2 52.5 176.5 34.6 176.8 18 186.9 8.9 203-9.9 235.3 4 283 22.2 309.3 31.1 322.3 41.7 336.6 55.7 336.1 69 335.6 74.2 327.5 90.2 327.5 106.3 327.5 111 336.1 125 335.9 139.5 335.6 148.6 322.9 157.5 309.9 167.6 295.1 171.8 280.8 172 280 171.7 279.7 144 269.1 143.7 237.1 143.4 210.3 165.6 197.6 166.6 196.8 154.1 178.2 134.6 176.2 127.8 175.7M228.2 139.5V334.4H258.5V267.8H300.4C338.7 267.8 365.5 241.5 365.5 203.5S339.1 139.5 301.4 139.5H228.2zM258.5 165H293.4C319.7 165 334.7 179 334.7 203.6S319.7 242.4 293.3 242.4H258.5V165zM420.7 335.9C439.7 335.9 457.3 326.3 465.3 311H465.9V334.4H493.9V237.4C493.9 209.3 471.4 191.1 436.8 191.1 404.7 191.1 380.9 209.5 380 234.7H407.3C409.6 222.7 420.7 214.8 435.9 214.8 454.4 214.8 464.8 223.4 464.8 239.3V250.1L427 252.4C391.9 254.5 372.9 268.9 372.9 293.9 373 319.1 392.6 335.9 420.7 335.9zM428.9 312.8C412.8 312.8 402.5 305 402.5 293.2 402.5 280.9 412.4 273.8 431.3 272.7L464.9 270.6V281.6C464.9 299.8 449.4 312.8 428.9 312.8zM531.4 387.4C560.9 387.4 574.8 376.1 586.9 342L640 193H609.2L573.6 308.1H573L537.4 193H505.8L557 334.9 554.2 343.5C549.6 358.1 542.1 363.8 528.7 363.8 526.3 363.8 521.7 363.5 519.8 363.3V386.7C521.6 387.1 529.1 387.4 531.4 387.4z"}]}}),H.register({"brands/apple":{width:376,height:512,paths:[{d:"M314.7 268.7C314.5 232 331.1 204.3 364.7 183.9 345.9 157 317.5 142.2 280 139.3 244.5 136.5 205.7 160 191.5 160 176.5 160 142.1 140.3 115.1 140.3 59.3 141.2 0 184.8 0 273.5 0 299.7 4.8 326.8 14.4 354.7 27.2 391.4 73.4 481.4 121.6 479.9 146.8 479.3 164.6 462 197.4 462 229.2 462 245.7 479.9 273.8 479.9 322.4 479.2 364.2 397.4 376.4 360.6 311.2 329.9 314.7 270.6 314.7 268.7zM258.1 104.5C285.4 72.1 282.9 42.6 282.1 32 258 33.4 230.1 48.4 214.2 66.9 196.7 86.7 186.4 111.2 188.6 138.8 214.7 140.8 238.5 127.4 258.1 104.5z"}]}}),H.register({"brands/asymmetrik":{width:576,height:512,paths:[{d:"M517.5 309.2C556.3 269.2 575.6 229.2 576 193.1 576.8 127.6 516.6 74.9 406.6 58.1 277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3 245.2 61.8 323.7 56.9 392 67.5 544.5 91.3 588.8 195 490.8 299.2 480.6 310 468.8 320.3 455.8 329.8L304.9 103.4 114.7 388.9C49.1 359.5 38.2 298.7 95.6 237.7 116.4 215.5 143.9 195.8 175.1 179.6 195.1 167.4 214.8 157 237.1 148.9 172 169.2 114.4 201.8 75.5 241.8 47.8 270.4 34.1 298.9 33.8 324.7 33.3 359.8 57.2 389.8 102.2 407.7L67.7 459.4H169.3L191.3 425C213.5 426 236.6 425 259.9 422.3L237.1 459.4H372.6L340 406.3C358.6 401 376.9 394.8 394.5 387.6L440.4 459.4H542L468.6 349C487.1 336.9 503.6 323.5 517.5 309.2zM329.9 389.7L304.9 349.1 272.2 402.4C248.8 405.9 225.5 407.5 203 406.8L304.9 247.5 383.6 370.5C366.4 377.9 348.3 384.4 329.9 389.7z"}]}}),H.register({"brands/audible":{width:640,height:512,paths:[{d:"M640 199.9V253.9L320 453.9 0 254V200L320 400 640 199.9zM445.5 271.9L492.6 242.5C455.4 186.7 391.9 149.9 319.9 149.9 247.9 149.9 184.4 186.6 147.3 242.3H147.6C150.1 240 152.7 237.8 155.3 235.6 245 161.2 374.7 177.5 445.5 271.9zM225.4 290.7C242.3 278.8 261.9 272 282.8 272 317.2 272 348 290.4 369.2 319.6L414.6 291.2C393.7 261.3 359 241.7 319.8 241.7 280.9 241.7 246.4 261.1 225.4 290.7zM103.6 161.1C235.4 56.8 421.8 84.7 521.1 223.2L521.8 224.2 570.6 193.8C517.1 112.1 424.8 58.1 319.9 58.1 216.4 58.1 123.3 111.6 69.4 193.7 79.3 183.2 92.1 170.2 103.6 161.1zM570.6 193.8z"}]}}),H.register({"brands/autoprefixer":{width:640,height:512,paths:[{d:"M318.4 16L157.4 496H234.9L260.3 414.6H379.8L405 496H482.5L318.4 16zM278.1 357.9L319.3 227.5H320.8L361.7 357.9H278.1zM640 405L630 373.6 462.1 358 481.5 414.5 640 405zM177.9 358L10 373.7 0 405 158.5 414.4 177.9 358z"}]}}),H.register({"brands/avianex":{width:512,height:512,paths:[{d:"M453.1 32H141.1C102.2 32 64.9 63.2 57.8 101.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480H370.9C409.8 480 447.1 448.8 454.2 410.3L510.9 101.8C517.9 63.2 492.1 32 453.1 32zM394.9 379.3L362.9 392.8 247.5 282.8C232.8 292.8 218.3 302.3 205.8 309.9L227.9 374.1 210 386.8 169.4 325.8 117 277.7 132.7 262.3 190.7 293.4C200 282.9 211.5 270.8 223.5 258.5L203 228.9 134.2 129.1 153 100.2 161.9 95.4 265 207.8 269.9 212.3C289.3 193.5 303.7 179.9 303.7 179.9 311.4 173.4 325.2 177 334.4 187.8 343.4 198.3 345 212.5 337.1 219.1 335.3 220.4 321.6 230.5 301.8 244.7L306.3 252 401.2 371.4 394.9 379.3z"}]}}),H.register({"brands/aviato":{width:640,height:512,paths:[{d:"M107.2 283.5L88.2 241.7H36.1L17.1 283.5H0L62.2 152.1 124.4 283.5H107.2zM62.2 185.4L42.6 227.9H81.8L62.2 185.4zM174.9 287.8L112.7 156.4H129.8L174.9 252.4 220 156.4H237L174.9 287.8zM255.5 283.5V156.4H271V283.5H255.5zM464.6 167.9V283.5H447.3V167.9H406.1V156.4H505.7V167.9H464.6zM640 218.8C640 228 638.3 236.6 634.9 244.6 631.5 252.6 626.7 259.7 620.7 265.7 614.7 271.7 607.6 276.5 599.6 279.9 591.6 283.3 583 285 573.8 285S556 283.3 548 279.9C540 276.5 532.9 271.7 526.9 265.7 520.9 259.7 516.1 252.7 512.7 244.6 509.3 236.6 507.6 228 507.6 218.8S509.3 201 512.7 193C516.1 185 520.9 177.9 526.9 171.9 532.9 165.9 539.9 163.5 548 160 556 156.6 564.6 154.9 573.8 154.9S591.6 156.6 599.6 160C607.6 163.4 614.7 165.8 620.7 171.9 626.7 177.9 631.4 185 634.9 193 638.3 201 640 209.6 640 218.8zM624.5 218.8C624.5 211.5 623.2 204.8 620.6 198.5 618 192.2 614.4 186.8 609.8 182.2 605.2 177.6 599.8 174 593.6 171.3 587.4 168.6 580.8 167.3 573.8 167.3S560.2 168.6 554 171.3C547.8 174 542.4 177.6 537.8 182.2 533.2 186.8 529.6 192.2 527 198.5 524.4 204.8 523.1 211.6 523.1 218.8 523.1 226.1 524.4 232.8 527 239.1 529.6 245.4 533.2 250.8 537.8 255.4 542.4 260 547.8 263.6 554 266.3 560.2 269 566.8 270.3 573.8 270.3S587.4 269 593.6 266.3C599.8 263.6 605.2 260 609.8 255.4 614.4 250.8 618 245.4 620.6 239.1 623.2 232.8 624.5 226 624.5 218.8zM529.7 315.5V309.2L618.6 299.2 375.7 312.6C376.3 310.4 376.8 308 377.1 305.4 377.4 303.4 377.6 301.2 377.7 298.9L442.5 290.8 377.6 292.7C377.6 292.3 377.5 292 377.5 291.6 374.7 274.4 352 267.9 352 267.9L350.9 241.6H374.7L393.7 283.4H410.8L348.6 152 286.4 283.4H303.5L322.5 241.6H346.1L345 268S322.3 274.5 319.5 291.7C319.4 292 319.4 292.4 319.4 292.8L254.5 290.9 319.3 299C319.4 301.3 319.6 303.4 319.9 305.5 320.2 308.1 320.7 310.5 321.3 312.7L78.4 299.2 167.3 309.2V315.5C161.4 316.4 156.8 321.5 156.8 327.7 156.8 334.5 162.4 340.1 169.2 340.1 176 340.1 181.6 334.5 181.6 327.7 181.6 321.5 177 316.4 171.1 315.5V309.7L251.4 318.7V324.1C245.7 325.2 241.5 330.3 241.5 336.2 241.5 343 247.1 346.4 253.9 346.4 260.7 346.4 266.3 343 266.3 336.2 266.3 330.2 262 325.2 256.4 324.1V319.2L284.8 322.4V346.1H278.9V360H284.8V353.4H289.8V360H295.7V346.2H289.8V323L328.1 327.3C336.2 338.7 347.1 340.9 347.1 340.9L347 347.6 341.9 347.8 341.8 359.9H345.9L346 354.9H351.2L351.3 359.9H355.4L355.3 347.8 350.2 347.6 350.1 340.9S361 338.8 369.1 327.3L407.4 323V346.2H401.5V360H407.4V353.4H412.4V360H418.3V346.2H412.4V322.5L440.8 319.3V324.2C435.1 325.3 430.9 330.4 430.9 336.3 430.9 343.1 436.5 346.5 443.3 346.5 450.1 346.5 455.7 343.1 455.7 336.3 455.7 330.3 451.4 325.3 445.8 324.2V318.8L526.1 309.8V315.6C520.2 316.5 515.6 321.6 515.6 327.8 515.6 334.6 521.2 340.2 528 340.2 534.8 340.2 540.4 334.6 540.4 327.8 540.2 321.5 535.7 316.4 529.7 315.5zM328.9 227.9L348.5 185.4 368.1 227.9H350.2L348.5 187.6 346.8 227.9H328.9z"}]}}),H.register({"brands/aws":{width:512,height:512,paths:[{d:"M261.2 136.1C247.2 193.6 248.1 190.5 235.4 243.1 233.8 249.6 231.3 251.5 224.7 251.6H210.3C204.5 251.5 202.1 250 200.4 244.3 188.1 204.9 171.6 150.2 160.5 113.6 156.4 100.1 159.1 100.4 169.8 100.7 173.5 100.8 177.1 100.7 180.8 100.7 185.9 100.8 188.5 102.7 189.9 107.8 193.5 120.7 195.9 130.6 216.5 211.9 216.9 213.5 217.4 215 217.9 216.5H219C219.5 214.5 220.1 212.6 220.6 210.6 228.4 177.7 236.1 144.7 243.9 111.8 246.3 101.6 250.6 100.6 260.9 100.6H268.5C275.4 100.7 277.5 102.1 279.2 108.9 285.2 132.3 302.7 210.7 305.9 219.3 311 201 304.1 227.2 334.4 110.3 336.5 102.2 338.5 100.6 346.7 100.6H359.4C364.8 100.7 366.4 102.4 365.1 107.7 362.7 117.2 362.2 117.6 323.8 240.6 320.7 250.5 319.6 251.4 309.2 251.4H298.6C291.3 251.4 289.4 250.1 287.6 243 283.3 226.8 264.3 147.3 261.2 136.1zM125.4 247.3C129.6 253.1 133.5 253.6 139.5 249.7L145.8 245.5C152.6 241 153.1 239.2 149.4 232 145.1 223.6 143 214.7 143.1 205.1 143.1 202 143.7 149.4 142.2 138.3 139.5 119 129.7 105.5 110.5 99.6 99.8 96.2 88.8 96.3 77.8 96.6 62.7 97 48.4 101.2 35 108 33.2 108.9 31.3 111.1 30.9 112.9 30.1 116.8 29.8 121 30.2 125 30.8 130.9 32.8 132 38.4 130.1 43.5 128.4 48.4 126.2 53.5 124.7 68 120.3 82.7 118.3 97.6 123 104.7 125.2 109.3 129.9 111.9 136.8 114.9 144.7 114.3 152.9 114.3 161 114.3 166.5 114.2 166.5 108.8 165.5 94.9 162.9 81.1 160.5 66.9 162.4 51.7 164.5 38.3 169.7 28.7 182.4 19.6 194.4 18.7 208 21.3 221.9 24.1 236.9 33.1 247.6 47.7 252.3 68.3 259 87.8 255.6 105.4 242.8 109.2 240 112.6 236.6 116.5 233.3 119.6 238.3 122.3 243 125.4 247.3zM110.1 185.7C113.1 186.1 114.6 187.6 114.4 190.8 114.2 194.6 114.5 198.4 114.1 202.2 112.9 213.9 106.4 221.9 96.2 227.1 88 231.3 79.3 232.9 70.1 232.1 54.9 230.8 49.1 219 50.5 205.8 51.8 193.2 59 186.2 72 184 85.8 181.6 88 182.9 110.1 185.7zM458.9 250.8C480.2 242.2 491.8 224.6 488.1 200.8 485.9 186.2 476.3 176.6 462.9 171.3 448.2 165.4 429.1 161 414.8 153.1 410.4 150.7 407.4 146.8 407.2 141.2 406.8 130.1 411.4 124 422.6 121.4 431.9 119.3 441.4 119.2 450.7 121 458 122.4 465 125.2 472.1 127.3 474.9 128.2 478 129.4 479.9 125.7 483.7 118.4 480.3 107 472.6 103.9 450.1 94.9 427.1 92.3 404.4 102.3 389.8 108.7 379.8 119.7 378.4 136.5 376.8 155.8 385.3 169.9 402.5 178.2 410.2 181.9 418.6 184.1 426.7 187.1 434.8 190.1 442.9 192.9 450.8 196.2 463.1 201.5 462.4 220.4 452 226.2 424.3 241.5 387.1 223.8 382.8 222.4 379.5 221.3 377.5 222.6 376.5 226.1 373.5 237.4 377.2 244.9 388.1 248.8 409.8 256.7 437.7 259.3 458.9 250.8zM296 413.5C346.8 407.7 394.7 392.7 438.7 366.5 446.7 361.8 454.2 356.2 461.8 350.8 469.1 345.6 465 332.4 450.5 338.6 396.1 361.8 339.3 374.7 280.3 377.5 249.8 379 219.5 377.2 189.2 372.8 126.1 363.6 66.8 343.6 11.6 311.6 9.5 310.4 7.4 309.1 5.1 308.6 0.2 307.5-2.6 313.3 2.7 318.3 26.7 340.4 53 359.1 81.8 374 135.5 401.7 192.3 416.7 253 416 267.4 415.2 281.8 415.1 296 413.5zM470.7 321.3C485.5 322.1 490.1 327.2 486.4 341.5 482.6 356.3 477.1 370.7 472.5 385.3 471.6 388.2 468.3 391.6 471.7 394.1 475.4 396.7 478.2 393.1 480.7 390.8 490.9 381.3 498.1 369.8 503.2 357 508.6 343.6 512.5 329.8 511.9 315.1 511.7 308.9 510.1 306.3 504.1 304.6 498.7 303.1 493.1 301.8 487.6 301.4 466 299.6 445.1 301.9 425.6 312 422.5 313.6 419.6 315.7 416.9 317.9 415.8 318.8 413.7 323.2 419.3 324 421.2 324.3 423.2 323.9 425.2 323.7 442.1 322.1 453.8 320.4 470.7 321.3z"}]}}),H.register({"brands/bandcamp":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM296.2 334.1H115.2L199.9 178H380.9L296.2 334.1z"}]}}),H.register({"brands/behance-square":{width:448,height:512,paths:[{d:"M186.5 293C186.5 312.3 172.5 318.4 155.3 318.4H110.2V265.5H156.2C174.8 265.6 186.5 273.3 186.5 293zM178.8 210.7C178.8 193 165.1 188.8 149.9 188.8H110.3V233.6H153C168.1 233.6 178.8 227 178.8 210.7zM311.1 233.9C292.8 233.9 280.6 245.3 279.4 263.6H341.6C339.9 245.1 330.3 233.9 311.1 233.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM271.7 185H349.5V166.1H271.7V185zM228.7 295.3C228.7 271.2 217.3 250.4 193.7 243.7 210.9 235.5 219.9 226 219.9 206.7 219.9 168.5 191.4 159.2 158.5 159.2H68V351.2H161.1C196 351 228.7 334.3 228.7 295.3zM380 280.5C380 239.4 355.9 205.1 312.4 205.1 270 205.1 241.3 236.9 241.3 278.7 241.3 322 268.6 351.7 312.4 351.7 345.6 351.7 367.1 336.8 377.5 304.9H343.8C340.1 316.8 325.2 323 313.6 323 291.2 323 279.5 309.9 279.5 287.7H379.7C379.8 285.4 380 282.9 380 280.5z"}]}}),H.register({"brands/behance":{width:576,height:512,paths:[{d:"M232 237.2C263.8 222 280.4 199 280.4 163.2 280.4 92.6 227.8 75.4 167.1 75.4H0V429.8H171.8C236.2 429.8 296.7 398.9 296.7 326.9 296.7 282.4 275.6 249.5 232 237.2zM77.9 135.9H151C179.1 135.9 204.4 143.8 204.4 176.4 204.4 206.5 184.7 218.6 156.9 218.6H77.9V135.9zM161.2 369.6H77.9V272H162.8C197.1 272 218.8 286.3 218.8 322.6 218.8 358.4 192.9 369.6 161.2 369.6zM519.7 128.9H376V94H519.7V128.9zM576 305.2C576 229.3 531.6 166 451.1 166 372.9 166 319.8 224.8 319.8 301.8 319.8 381.7 370.1 436.5 451.1 436.5 512.4 436.5 552.1 408.9 571.2 350.2H509C502.3 372.1 474.7 383.7 453.3 383.7 412 383.7 390.3 359.5 390.3 318.4H575.4C575.7 314.2 576 309.7 576 305.2zM390.4 274C392.7 240.3 415.1 219.2 448.9 219.2 484.3 219.2 502.1 240 505.1 274H390.4z"}]}}),H.register({"brands/bimobject":{width:448,height:512,paths:[{d:"M416 32H32C14.4 32 0 46.4 0 64V448C0 465.6 14.4 480 32 480H416C433.6 480 448 465.6 448 448V64C448 46.4 433.6 32 416 32zM352 289.4C352 338.8 340.6 372 248.2 372H231.3C187.2 372 168.9 357.1 160.9 333.2H160V368H96V136H160V210.7H161.1C165.7 180.2 200.8 171.9 230.8 171.9H248.1C340.5 171.9 351.9 205 351.9 254.4V289.4zM288 260.5V283.4C288 305.1 284.6 317.2 249.6 317.2H204.3C175.4 317.2 160.2 310.7 160.2 281.5V262.5C160.2 233.2 175.4 226.8 204.3 226.8H249.6C284.6 226.6 288 238.8 288 260.5z"}]}}),H.register({"brands/bitbucket":{width:512,height:512,paths:[{d:"M23.1 32C14.2 31.9 7 38.9 6.9 47.8 6.9 48.7 7 49.6 7.1 50.6L74.9 462C76.6 472.4 85.6 480 96.1 480.1H421.2C429.1 480.2 435.9 474.5 437.2 466.7L505 50.7C506.4 42 500.5 33.8 491.8 32.4 490.9 32.3 490 32.2 489 32.2L23.1 32zM308.4 329.3H204.6L176.5 182.5H333.5L308.4 329.3z"}]}}),H.register({"brands/bitcoin":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM362.3 220.7C367.3 187.7 342.2 169.9 307.8 158.1L318.9 113.4 291.7 106.6 280.9 150.1C273.7 148.4 266.4 146.7 259.1 145L270 101.2 242.8 94.4 231.7 139.1C225.7 137.8 219.9 136.4 214.3 135L214.3 134.9 176.8 125.5 169.5 154.6S189.7 159.2 189.3 159.5C200.3 162.2 202.3 169.5 202 175.3L189.3 226.2C190 226.4 191 226.7 192.1 227.1 191.2 226.9 190.2 226.7 189.2 226.4L171.4 297.8C170.1 301.1 166.7 306.1 159 304.2 159.2 304.6 139.2 299.3 139.2 299.3L125.7 330.4 161.1 339.3C167.7 340.9 174.1 342.6 180.5 344.3L169.2 389.5 196.4 396.3 207.6 351.5A1038.2-1038.2 0 0 1 229.3 357.2L218.1 401.7 245.4 408.5 256.6 363.3C303 372.1 337.9 368.6 352.6 326.6 364.4 292.8 352 273.3 327.6 260.6 345.4 256.5 358.8 244.8 362.3 220.7zM300.2 307.8C291.8 341.6 234.9 323.4 216.4 318.8L231.4 258.9C249.8 263.5 309 272.6 300.2 307.8zM308.6 220.2C300.9 250.9 253.6 235.3 238.2 231.5L251.7 177.1C267.1 181 316.6 188.1 308.6 220.2z"}]}}),H.register({"brands/bity":{width:496,height:512,paths:[{d:"M78.4 67.2C173.8-22 324.5-24 421.5 71 435.8 85.1 415.1 108.1 399.1 92.5 314.3 10.1 183.3 12.2 100.2 89.3 83.9 104.4 63.7 81 78.4 67.2zM177.3 485.8C196.6 491.5 206.6 462.2 185.2 455.8 73 421.9 9.4 306.1 37.7 194.8 42.7 175.2 12.8 166.7 7.5 187.7-24.6 315.1 48.6 447.5 177.3 485.8zM325.4 483.8C447.3 443.6 518.3 316.9 489.8 192.8 485.3 173.1 454.9 179 459.8 200.7 484 308.4 422.7 418.6 316.6 454.1 295.4 461.1 306.2 490.1 325.4 483.8zM262.5 404.8L262.7 333C262.7 324.8 256.1 318.2 247.9 318.2 239.7 318.2 233.1 324.9 233.1 333L232.9 404.8C232.9 413 239.5 419.6 247.7 419.6S262.5 413 262.5 404.8zM333.5 135.8C335.6 226.7 338.2 267.7 248 268.3 155.5 267.6 161.1 224 162.5 135.8 162.5 114 130 116.2 130 135.8V207.4C130 276.7 190.7 298.3 248 297.5 305.3 298.3 366 276.7 366 207.4V135.8C366 116.2 333.5 114 333.5 135.8z"}]}}),H.register({"brands/black-tie":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM316.5 357.2L224 445.9 131.5 357.2 196 173.2 131.5 86.6H316.4L252 173.2 316.5 357.2z"}]}}),H.register({"brands/blackberry":{width:512,height:512,paths:[{d:"M166 116.9C166 140.3 149.6 166 93.5 166H23.4L44.4 77.2H112.2C154.3 77.2 166 100.5 166 116.9zM292.2 77.2H224.4L205.7 166H275.8C329.6 166 345.9 140.3 345.9 116.9 346 100.5 334.3 77.2 292.2 77.2zM88.8 208.1H21L0 296.9H70.1C126.2 296.9 142.6 273.5 142.6 247.8 142.6 231.5 130.9 208.1 88.8 208.1zM268.9 208.1H201.1L182.4 296.9H252.5C306.3 296.9 322.6 273.5 322.6 247.8 322.6 231.5 310.9 208.1 268.9 208.1zM458.2 154.3H390.4L371.7 243.1H441.8C495.6 243.1 511.9 219.7 511.9 194 512 177.7 500.3 154.3 458.2 154.3zM430.2 292.2H362.4L343.7 381H413.8C469.9 381 483.9 357.6 483.9 331.9 483.9 315.6 472.3 292.2 430.2 292.2zM240.8 346H173L154.3 434.8H224.4C280.5 434.8 294.5 409.1 294.5 385.7 294.6 369.4 282.9 346 240.8 346z"}]}}),H.register({"brands/blogger-b":{width:448,height:512,paths:[{d:"M446.6 222.7C444.8 214.7 439.8 207.3 434.1 204.2 432.3 203.2 421.1 202 409.1 201.5 389 200.6 386.8 200.2 380.4 196.5 370.3 190.6 367.6 184.2 367.5 167 367.4 134 353.7 103.3 326.6 75.7 307.3 56 285.7 42.7 261.1 35.2 255.2 33.4 242 32.8 197.8 32.3 128.4 31.5 113 32.9 89.4 42.3 45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7 0.7 165.8 0.2 246.8-0.4 348.3 0.3 363.2 6.6 383.3 22.2 432.9 66.5 469.6 111 477.6 125.8 480.3 308.3 480.9 327 478.4 359.5 474 385 460.9 408.9 436.5 426.2 418.8 437 399.7 444.1 374.4 449 356.8 448.6 231.6 446.6 222.7zM124.5 159.1C132.3 151.2 134.5 150.9 183.3 150.9 227.2 150.9 228.7 151 235.1 154.3 244.4 159 248.5 165.6 248.5 176.2 248.5 185.7 244.7 192.4 236.2 197.8 231.6 200.7 228.9 200.9 185.9 201.1 159.4 201.3 138.2 200.7 135.1 199.9 118.5 195.2 112.3 171.4 124.5 159.1zM316.3 358.9L301.4 361.3 223.9 362.2C155.8 363 136.6 361.8 133 360.2 125.9 357.1 119.2 348.5 118.1 340.8 117 333.5 120.7 323.5 126.3 318.4 133.4 312 136.5 311.8 223.6 311.7 313.2 311.6 312.7 311.6 321.2 319.5 333.3 330.8 330.7 350.7 316.3 358.9z"}]}}),H.register({"brands/blogger":{width:448,height:512,paths:[{d:"M162.4 196C167.2 191.1 168.6 190.9 198.8 190.9 226 190.9 226.9 191 230.9 193 236.7 195.9 239.2 200 239.2 206.6 239.2 212.5 236.8 216.6 231.6 220 228.8 221.8 227.1 221.9 200.5 222.1 184.1 222.2 171 221.9 169 221.3 158.7 218.4 154.9 203.6 162.4 196zM223.8 290.5C169.9 290.5 168 290.7 163.6 294.6 160.1 297.7 157.9 304 158.5 308.5 159.2 313.2 163.3 318.6 167.7 320.5 169.9 321.5 181.8 322.2 224 321.7L271.9 321.1 281.1 319.6C290.1 314.5 291.6 302.2 284.2 295.2 278.9 290.5 279.2 290.5 223.8 290.5zM447.2 420.6C443.7 449 424.2 471 396.1 478.1 388.9 479.9 386.4 480 223.2 479.9 65.4 479.9 57.3 479.8 51.2 478.1 42.8 475.9 35.6 472.6 28.9 468.1 23.3 464.3 15 456.3 11.9 451.7 8.1 446.1 3.7 436.4 1.9 429.7 0.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4 60.3 31.8 385.1 31.5 393 33.1 414.2 37.4 430.9 50.2 440.6 69.5 448.3 84.8 447.6 68 447.9 250.1 448.1 365.9 447.9 414.6 447.2 420.6zM361.8 235.4C360.7 230.4 357.6 225.8 354.1 223.9 353 223.3 346.1 222.6 338.6 222.2 326.2 221.6 324.8 221.4 320.8 219.1 314.6 215.5 312.9 211.5 312.8 200.8 312.8 180.4 304.3 161.4 287.5 144.3 275.5 132.1 262.2 123.8 246.9 119.2 243.3 118.1 235.1 117.7 207.7 117.4 164.8 116.9 155.2 117.8 140.6 123.6 113.6 134.3 94.3 157 87.2 186 85.9 191.4 85.6 200.2 85.3 250.3 84.9 313.1 85.3 322.4 89.3 334.8 99 365.5 126.4 388.2 153.9 393.2 163.1 394.9 276.1 395.3 287.6 393.7 307.7 391 323.5 382.9 338.3 367.8 349 356.9 355.7 345 360.1 329.3 363.3 318.4 363 240.9 361.8 235.4z"}]}}),H.register({"brands/bluetooth-b":{width:320,height:512,paths:[{d:"M196.5 260L289.1 156.7 143.1 0V206.3L57 120.2 25.6 151.6 133.7 260 25.6 368.4 57 399.8 143.1 313.7 145.8 512 294.4 363.4 196.5 260zM237.3 157L187.4 207 187 106.7 237.3 157zM187.4 313L237.3 363 187 413.3 187.4 313z"}]}}),H.register({"brands/bluetooth":{width:448,height:512,paths:[{d:"M292.6 171.1L249.7 214 249.4 128 292.6 171.1M249.4 390.9L292.5 347.8 249.6 304.9 249.4 390.9zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zM257.5 259.4L336.9 170.8 211.8 36.5V213.4L138 139.6 111 166.5 203.7 259.5 111 352.5 137.9 379.4 211.7 305.6 214 475.6 341.4 348.1 257.5 259.4z"}]}}),H.register({"brands/btc":{width:384,height:512,paths:[{d:"M310.2 242.6C337.9 228.5 355.6 203.2 351.5 161.3 346.1 104 299 84.8 236.6 79.4V0H188.1V77.2C175.5 77.2 162.6 77.5 149.7 77.8V0H101.1V79.4C83.3 79.9 62.5 79.7 3.8 79.4V131.1C42.1 130.4 62.2 127.9 66.8 152.5V369.9C63.9 389.4 48.3 386.6 13.5 386L3.8 443.7C92.2 443.7 101.1 444 101.1 444V512H149.7V444.9C162.9 445.3 175.8 445.3 188.1 445.3V512H236.6V444C317.9 439.6 372.3 419.1 379.5 342.5 385.2 281.1 356.2 253.7 310.2 242.6zM150.6 134.6C178 134.6 263.7 126 263.7 183.1 263.7 237.6 178 231.3 150.6 231.3V134.6zM150.6 386.3V279.8C183.4 279.8 283.7 270.7 283.7 333.1 283.7 393.3 183.4 386.3 150.6 386.3z"}]}}),H.register({"brands/buromobelexperte":{width:448,height:512,paths:[{d:"M0 32V160H128V32H0zM120 152H8V40H120V152zM160 32V160H288V32H160zM280 152H168V40H280V152zM320 32V160H448V32H320zM440 152H328V40H440V152zM0 192V320H128V192H0zM120 312H8V200H120V312zM160 192V320H288V192H160zM280 312H168V200H280V312zM320 192V320H448V192H320zM440 312H328V200H440V312zM0 352V480H128V352H0zM120 472H8V360H120V472zM160 352V480H288V352H160zM280 472H168V360H280V472zM320 352V480H448V352H320z"}]}}),H.register({"brands/buysellads":{width:448,height:512,paths:[{d:"M224 150.7L266.9 311.4H181.1L224 150.7zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM382.7 405.3L288.2 106.6H159.8L65.3 405.3H156L267.7 313.7 291.9 405.3H382.7z"}]}}),H.register({"brands/cc-amazon-pay":{width:576,height:512,paths:[{d:"M124.7 201.8C124.8 190 124.7 178.3 124.7 166.5V131.2C124.7 129.9 125.1 129.2 126.1 128.5 137.6 120.5 150.2 116.4 164.3 117.4 176.8 118.3 187 124.4 192.4 139.1 195.7 148 196.5 157.3 196.5 166.8 196.5 175.5 195.8 184.1 193.1 192.4 187.4 210.2 174.4 217.1 157.4 216.3 145.7 215.8 135.5 211.3 126 204.6 125.1 203.8 124.6 203 124.7 201.8zM279.6 216.4C284.2 218.2 288.9 218.4 293.7 217.9 305.3 216.7 315.6 212.2 325 205.4 325.9 204.8 326.3 204.1 326.3 202.9 326.2 199 326.3 195 326.3 191.1 326.3 187.1 326.2 183.1 326.3 179.1 326.3 177.7 325.9 177.1 324.5 176.9 317.5 176 310.6 174.7 303.6 174 296.6 173.4 289.6 173.7 282.8 175.9 276.1 178.1 271.1 182.1 269.1 189 267.5 194.4 267.5 199.8 269.2 205.2 270.8 210.7 274.4 214.4 279.6 216.4zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM368.5 103.9C368.9 105.6 369.4 107.3 370.1 109 386.6 149.6 403 190.3 419.6 230.9 421 234.4 421.3 237.3 419.8 240.8 417 247 414.9 253.4 412 259.5 409.4 265 405.3 269 399.3 270.7 395.1 271.8 390.8 272 386.4 271.6 384.3 271.4 382.2 270.9 380.1 270.8 377.3 270.6 375.9 271.9 375.8 274.8 375.7 277.6 375.7 280.4 375.8 283.1 375.9 287.7 377.4 289.8 382 290.6 386.7 291.4 391.4 292.2 396.2 292.3 410.5 292.6 421.9 286.9 429.3 274.4 432.2 269.5 434.9 264.3 437 259 456.8 208.9 476.5 158.7 496.2 108.5 496.8 107 497.3 105.5 497.5 103.9 497.9 101.5 496.8 100.3 494.4 100.2 488.8 100.1 483.3 100.2 477.7 100.2 474.6 100.2 472.4 101.6 471.3 104.5 470.9 105.6 470.4 106.8 470 107.9L440.9 191.6C438.8 197.7 436.7 203.7 434.4 210.2 434 209.3 433.8 208.8 433.6 208.3 422.8 178.4 412 148.4 401.2 118.5 399.5 113.8 397.7 109 395.9 104.3 395 101.8 393.2 100.3 390.5 100.3 384.1 100.2 377.7 100.1 371.3 100.2 369.1 100.2 368 101.8 368.5 103.9zM242.4 206C244.1 217.7 250 226.8 260.4 232.6 270.3 238.1 281.1 238.8 292.1 237.2 304.8 235.3 316 229.9 325.9 221.7 326.3 221.4 326.7 221.1 327.3 220.7 327.8 223.9 328.2 226.9 328.8 229.9 329.3 232.5 330.9 234.2 333.3 234.3 337.9 234.4 342.4 234.4 347 234.3 349.3 234.2 350.8 232.7 351 230.4 351.1 229.6 351.1 228.8 351.1 228.1V139.3C351.1 135.7 350.9 132.1 350.4 128.5 348.8 117.7 344.2 108.8 334.5 103.1 328.9 99.8 322.7 98.1 316.3 97.2 313.3 96.8 310.3 96.5 307.2 96.1H297.2C296.4 96.2 295.6 96.4 294.7 96.4 286.5 96.8 278.4 97.8 270.5 99.9 265.4 101.2 260.5 103.1 255.5 104.8 252.5 105.8 251 108 251.1 111.3 251.2 114.1 251 116.9 251.1 119.6 251.2 123.7 252.9 124.8 256.8 123.7 263.3 122 269.9 120.2 276.5 118.9 286.8 117 297.2 116.2 307.6 117.7 313 118.5 318.1 120.1 321.7 124.7 324.8 128.7 325.9 133.5 326.1 138.4 326.4 145.3 326.3 152.3 326.4 159.2 326.4 159.6 326.3 159.9 326.2 160.4 325.8 160.4 325.4 160.4 325.1 160.3 316.3 158.2 307.4 156.7 298.3 156.2 288.8 155.7 279.4 156.3 270.4 159.4 259.6 163.2 250.9 169.7 245.8 180.2 241.7 188.5 241.2 197.2 242.4 206zM98.7 106.9V282.2C98.7 283 98.7 283.9 98.8 284.7 99 287.2 100.5 288.8 102.9 288.9 108.8 289 114.7 289 120.6 288.9 123.1 288.9 124.6 287.2 124.7 284.8 124.8 284 124.8 283.1 124.8 282.3V221.6C125.7 222.3 126.2 222.8 126.7 223.2 141.7 235.7 158.9 239.8 177.8 236.1 194.9 232.7 206.7 222.2 214.5 206.9 220.3 195.3 222.8 182.8 223.2 169.9 223.7 155.6 222.2 141.5 216.4 128.2 209.3 111.8 197.5 100.9 179.7 97.3 177 96.7 174.2 96.5 171.5 96.1H164.5C163.3 96.3 162.1 96.4 160.9 96.6 149.2 98 138.6 102.4 129.1 109.3 127.1 110.7 125.2 112.3 123.2 113.8 123.1 113.3 122.9 113 122.8 112.6 122.4 110.3 122.1 108 121.7 105.7 121.1 101.8 119.2 100.2 115.3 100.1H105.6C99.7 100 98.7 101.1 98.7 106.9zM493.6 339C490.9 338.3 488.5 339 486 340 442.1 358.4 396.5 370.2 349.2 375.8 334.7 377.5 320.1 378.6 305.5 379 278.9 379.7 252.3 378.2 225.9 374.7 208.1 372.3 190.4 369 172.9 364.8 135.9 355.9 100.2 343.1 66.2 326 57.4 321.6 48.8 316.7 40.1 312 36.3 309.9 33.9 310.5 31.9 314.1V315.8C33.1 317.4 34.1 319.2 35.6 320.6 71.6 352.8 112.2 377.1 157.6 393.5 179.5 401.4 202 407.2 224.9 411 238.9 413.3 252.9 414.8 267.1 415.5 270.1 415.6 273.1 415.7 276.1 415.9 276.8 415.9 277.5 416.1 278.2 416.2H295.9C296.6 416.1 297.3 415.9 298 415.9 312.9 415.5 327.8 414.1 342.6 411.9 364 408.7 385 403.8 405.5 397.2 435.1 387.6 463.2 374.8 488.9 357.1 491.7 355.2 494.6 353.3 496.9 350.9 501.2 346.5 499.2 340.5 493.6 339zM544 311.3C543.2 307.1 540 305.5 536.4 304.3 530.7 302.4 524.8 301.5 518.8 301 507.8 300.1 496.8 300.6 486 302.6 474 304.8 462.6 308.7 452.5 315.7 451.3 316.5 450.1 317.5 449.4 318.7 448.8 319.6 448.7 321 448.9 322.1 449.2 323.4 450.6 323.7 451.9 323.6 452.5 323.6 453.1 323.6 453.7 323.5L473.2 321.4C482.8 320.5 492.4 319.9 502 320.6 506.1 320.9 510.1 321.8 514 322.8 518.3 323.9 520.2 327.2 520.4 331.5 520.7 338.2 519.2 344.6 517.5 351 514 363.9 509.2 376.4 504.2 388.8 503.9 389.6 503.5 390.5 503.4 391.3 503 393.8 504.4 395.3 506.8 394.8 508.2 394.5 509.8 393.7 510.8 392.7 514.5 389.1 518.3 385.5 521.4 381.5 532.1 367.7 538.4 351.9 542.1 334.9 542.8 331.9 543.3 328.8 543.8 325.8 544 321.1 544 316.2 544 311.3z"}]}}),H.register({"brands/cc-amex":{width:576,height:512,paths:[{d:"M576 255.4C538.1 255.2 531.8 254.5 521.5 260.4V255.4C476.2 255.4 468 253.7 456.6 260.6V255.4H378.4V260.5C367 254 357 255.4 302.7 255.4V261C296.4 257.3 288.2 255.4 278.4 255.4H220.4C216.9 259.2 207.9 269.1 204.7 272.6 192 258.5 194.2 261 189.2 255.4H106.1V347.7H188.1C191.4 344.2 201 333.8 204.2 330.3 216.9 344.6 214.5 342 219.6 347.7H268.5C268.5 333 268.6 339.4 268.6 324.7 280.1 324.9 292.9 324.5 302.9 318.5 302.9 332.4 302.8 335.6 302.8 347.7H342.4C342.4 329.2 342.5 340.3 342.5 322.4 348.7 322.4 350.2 322.4 351.9 322.5 352 323.8 351.9 322.5 351.9 347.7 504.7 347.7 497.8 348.8 508.6 343.2V347.7C543.4 347.7 563.4 349.9 576.1 341.6V432C576.1 458.5 554.6 480 528.1 480H48C21.5 480 0 458.5 0 432V228.3H26.6C30.8 218.2 28.8 223 33 213H52.2C56.4 223 54.4 218.2 58.6 228.3H111.5V216.9C113.7 221.9 112.6 219.4 116.6 228.3H146.1C148.5 222.8 148.7 222.5 151.2 216.9V228.3H286.7V203.2C293.1 203.2 294.7 203.1 296.5 203.4 296.5 203.4 296.3 214.3 296.6 228.2H363.1V219.3C370.5 225.2 380.5 228.2 392.8 228.2H419.6C423.8 218.1 421.8 222.9 426 212.9H445C451.5 227.9 445.2 213.4 451.6 228.2H504.4V206.3C516.2 226 512.2 219.2 517.6 228.2H559.2V136.2H519.3V154.6C507.1 134.4 513 144.2 508.1 136.2H464.8V156.8C458.6 142.2 460.2 146 456 136.2H423.6C423.2 136.2 421.3 136.4 421.3 135.9H393.7C380.9 135.9 370.6 139.1 363 145.2V135.9H323.1V141.2C312.3 135.1 302.4 136.1 258.7 135.9 258.6 135.9 247.1 135.8 247.1 135.9H144.1C141.6 142 137.3 152.3 131.5 165.9 128.7 159.9 120.5 142.1 117.6 135.9H71.6V157C64.2 139.6 66.9 146 62.6 135.9H22.9C19.5 143.8 9.2 167.9-0.2 189.8V80C-0.2 53.5 21.3 32 47.8 32H527.8C554.3 32 575.8 53.5 575.8 80V255.4zM389.4 174.8C389.1 175 388 177 388 182.4 388 188.4 388.9 190.1 389.1 190.3 389.3 190.4 390.2 190.8 392.5 190.8L399.8 173.9C398.7 173.9 397.7 173.8 396.7 173.8 391.1 173.8 389.7 174.5 389.4 174.8zM369.5 305.7C378.7 309 380.5 315.2 380.5 324.1L380.4 337.9H363.8L363.9 326.4C363.9 314.6 360.1 312.6 349.1 312.6H331.5L331.4 337.9H314.8L314.9 268.6H354.3C367.3 268.6 381.4 270.9 381.4 287.3 381.3 294.9 377.2 302.6 369.5 305.7zM363.2 290.3C363.2 283.9 357.6 282.9 352.5 282.9H331.5V298.5H352.2C357.8 298.5 363.2 297.2 363.2 290.3zM544.9 283.2H575V268.6H542.1C529.3 268.6 518.3 275.2 518.3 289.3 518.3 322.3 561 302.1 561 316.7 561 321.8 556.7 323.1 552.6 323.1H520.6L520.5 337.9H552.5C560.9 337.9 570.1 336.1 575 329V303.2C564.5 289.4 535.7 301.9 535.7 289.7 535.7 283.9 540.3 283.2 544.9 283.2zM445.7 282.9V268.6H390.5L390.4 337.9H445.6L445.7 323.6 407.1 323.3V309.5H445V295.4H407.2V282.9H445.7zM487.9 323H455.7L455.6 337.8H487.8C502.6 337.8 514 332.2 514 315.8 514 282.6 471.1 304.6 471.1 289.5 471.1 283.9 476 283.1 480.3 283.1H510.7V268.5H477.5C464.7 268.5 454 275.1 454 289.2 454 322.2 496.7 301.7 496.7 316.6 496.6 322 492 323 487.9 323zM409.8 164.3C392.4 164 376.6 160.2 376.6 184 376.6 195.8 379.4 203.9 392.7 203.9H400.1L423.6 149.4H448.4L476.3 214.8V149.4H501.6L530.7 197.5V149.4H547.6V218.4H524L492.8 166.5V218.4H459.1L452.5 203.1H418.2L411.8 218.4H392.6C369.8 218.4 359.6 206.6 359.6 184.4 359.6 161.1 370.1 149.1 393.6 149.1H409.7V164.3zM424.1 188.8H446.9L435.7 161.2 424.1 188.8zM351.5 149.2H334.6V218.5H351.5V149.2zM313.4 186.5C322.9 189.8 324.4 195.7 324.4 204.9V218.4H307.8C307.5 203.6 311.4 193.3 293 193.3H275V218.4H258.6V149.1L297.7 149.4C311 149.4 325.1 151.4 325.1 167.8 325.2 175.8 320.8 183.5 313.4 186.5zM306.7 171.2C306.7 164.8 301.1 163.8 296 163.8H275V179.1H295.7C301.4 179.1 306.7 177.8 306.7 171.2zM247.2 163.8V149.2H191.7V218.5H247.2V204.2H208.3V190.4H246.1V176.3H208.3V163.8H247.2zM162.6 218.5V164.3L138.6 218.5H124L100 164.3V218.5H66.2L59.8 203.2H25.3L18.9 218.5H1L30.7 149.2H55.2L83.3 214.9V149.2H110.4L132.1 196.2 151.8 149.2H179.4V218.5H162.6zM53.9 188.8L42.4 161.2 31.2 188.8H53.9zM306.9 291.3C306.9 319.2 276.5 314.6 257.6 314.6L257.5 337.9H225.3L204.9 314.9 183.6 337.9H118.2L118.3 268.6H184.8L205.3 291.4 226.3 268.6H279C294.6 268.6 306.9 274 306.9 291.3zM194.2 303.1L176.3 282.9H134.6V295.4H170.9V309.5H134.6V323.3H175.2L194.2 303.1zM241 276L215.7 303.4 241 331.5V276zM289.3 291.3C289.3 285.2 284.7 282.9 279.1 282.9H257.6V300.5H278.8C284.7 300.5 289.3 297.7 289.3 291.3z"}]}}),H.register({"brands/cc-apple-pay":{width:576,height:512,paths:[{d:"M302.2 218.4C302.2 235.6 291.7 245.5 273.2 245.5H248.9V191.3H273.3C291.7 191.3 302.2 201.1 302.2 218.4zM349.7 281C349.7 289.3 356.9 294.7 368.2 294.7 382.6 294.7 393.4 285.6 393.4 272.8V265.1L369.9 266.6C356.6 267.5 349.7 272.4 349.7 281zM576 79V431C576 457.5 554.5 479 528 479H48C21.5 479 0 457.5 0 431V79C0 52.5 21.5 31 48 31H528C554.5 31 576 52.5 576 79zM127.8 197.2C136.2 197.9 144.6 193 149.9 186.8 155.1 180.4 158.5 171.8 157.6 163.1 150.2 163.4 141 168 135.7 174.4 130.9 179.9 126.8 188.8 127.8 197.2zM188.4 271.7C188.2 271.5 168.8 264.1 168.6 241.7 168.4 223 183.9 214 184.6 213.5 175.8 200.5 162.2 199.1 157.5 198.8 145.3 198.1 134.9 205.7 129.1 205.7 123.2 205.7 114.4 199.1 104.8 199.3 92.3 199.5 80.6 206.6 74.3 217.9 61.2 240.5 70.9 273.9 83.6 292.3 89.8 301.4 97.3 311.4 107.1 311 116.4 310.6 120.1 305 131.3 305 142.6 305 145.8 311 155.6 310.9 165.8 310.7 172.1 301.8 178.4 292.7 185.3 282.3 188.2 272.3 188.4 271.7zM323.8 218.3C323.8 191.7 305.3 173.5 278.9 173.5H227.7V309.9H248.9V263.3H278.2C305 263.3 323.8 244.9 323.8 218.3zM413.8 242C413.8 222.3 398 209.6 373.8 209.6 351.3 209.6 334.7 222.5 334.1 240.1H353.2C354.8 231.7 362.6 226.2 373.2 226.2 386.2 226.2 393.4 232.2 393.4 243.4V250.9L367 252.5C342.4 254 329.1 264.1 329.1 281.6 329.1 299.3 342.8 311 362.5 311 375.8 311 388.1 304.3 393.7 293.6H394.1V310H413.7V242zM516 210.9H494.5L469.6 291.5H469.2L444.3 210.9H422L457.9 310.2 456 316.2C452.8 326.4 447.5 330.4 438.1 330.4 436.4 330.4 433.2 330.2 431.9 330.1V346.5C433.1 346.9 438.4 347 440 347 460.7 347 470.4 339.1 478.9 315.2L516 210.9z"}]}}),H.register({"brands/cc-diners-club":{width:576,height:512,paths:[{d:"M239.7 79.9C142.8 79.9 63.9 158.5 63.9 255.7 63.9 352.6 142.8 431.5 239.7 431.5 336.9 431.5 415.5 352.6 415.5 255.7 415.5 158.5 336.9 79.9 239.7 79.9zM199.8 359.5C158.1 343.6 128.4 303.1 128.4 255.7S158.1 167.8 199.8 151.6V359.5zM279.6 359.8V151.6C321.3 167.8 351 208.3 351 255.7S321.3 343.6 279.6 359.8zM528 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32zM329.7 448H239.4C133.2 448 45.6 362.5 45.6 257.8 45.6 143.2 133.2 64 239.4 64H329.7C434.7 64 530.4 143.2 530.4 257.8 530.4 362.5 434.7 448 329.7 448z"}]}}),H.register({"brands/cc-discover":{width:576,height:512,paths:[{d:"M83 212.1C83 220 79.8 227.6 74.1 232.8 69.2 237.2 62.5 239.2 52.2 239.2H48V185H52.2C62.5 185 68.9 186.7 74.1 191.6 79.8 196.6 83 204.2 83 212.1zM504.8 184H499.9V208.9H504.6C514.9 208.9 520.4 204.5 520.4 196.1 520.4 188.2 514.9 184 504.8 184zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM428 253H473.3V239.2H444V217H472.3V203.2H444V185H473.3V171H428V253zM341.8 171L376.8 255.2H385.4L420.9 171H403.4L381.2 226.2 359.3 171H341.8zM258.8 212.6C258.8 237.2 278.7 257.2 303.4 257.2 328 257.2 348 237.3 348 212.6 348 188 328.1 168 303.4 168 278.8 168 258.8 187.9 258.8 212.6zM190.8 212.1C190.8 244.6 224.4 264.6 254.1 250.3V231.3C234.8 250.6 207.3 237.1 207.3 212.1 207.3 188.4 234 173 254.1 193.1V174.1C223.9 159.1 190.8 180.9 190.8 212.1zM156.9 240.4C149.3 240.4 143.1 236.7 139.4 229.6L129.1 239.5C146.9 265.6 185.7 257.7 185.7 228.2 185.7 215.1 180.3 209.2 162.1 202.6 152.5 199.2 149.8 196.7 149.8 192.3 149.8 183.6 164.3 178.2 174.7 189.8L183.1 179C164 161.9 133.4 170.1 133.4 193.3 133.4 204.6 138.6 210.5 153.6 216 179.3 225.1 168.3 240.4 156.9 240.4zM99.5 212.1C99.5 188 81.5 171 55.4 171H32V253H55.4C86.3 253 99.5 230.6 99.5 212.1zM122.9 171H106.9V253H122.9V171zM544 288C510.7 308.8 317.6 412.4 128 448H529C537.2 448 544 441.2 544 433V288zM544 253L518.1 218.5C530.2 216 536.8 207.9 536.8 195.3 536.8 166.8 506.5 170.9 483.9 170.9V252.9H499.9V220.1H502.1L524.3 252.9H544z"}]}}),H.register({"brands/cc-jcb":{width:576,height:512,paths:[{d:"M431.5 244.3V212C472.7 212 470 212.2 470 212.2 477.3 213.5 483.3 219.5 483.3 228.2 483.3 237 477.3 242.7 470 244 468.8 244.4 466.7 244.3 431.5 244.3zM474.3 264.5C471.5 263.8 471 264 431.5 264V299C471.1 299 471.5 299.2 474.3 298.5 481.8 297 487.8 290.5 487.8 281.5 487.8 272.8 481.8 266 474.3 264.5zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM182 192.3H125C125 259.4 135.7 302 89.2 302 69.7 302 50.4 296.3 32 287.2V315.2C62 323.5 100 323.5 100 323.5 197.9 323.5 182 275.8 182 192.3zM360.5 196.8C297.1 180.8 195.5 181.9 195.5 256.1 195.5 333.2 303.7 329.7 360.5 315.3V287C312.9 311.7 253 309 253 256S312.8 200.4 360.5 224.8V196.8zM544 286.5C544 268 527.5 256 506 254.5V253.7C525.5 251 536.3 238.2 536.3 223.5 536.3 204.5 520.6 193.5 499.3 192.5 499.3 192.5 505.6 192.2 379 192.2V319.7H501.7C526 319.8 544 306.8 544 286.5z"}]}}),H.register({"brands/cc-mastercard":{width:576,height:512,paths:[{d:"M482.9 410.3C482.9 417.1 478.3 422 471.7 422 464.9 422 460.5 416.8 460.5 410.3 460.5 403.8 464.9 398.6 471.7 398.6 478.3 398.6 482.9 403.8 482.9 410.3zM172.1 398.6C165 398.6 160.9 403.8 160.9 410.3 160.9 416.8 165 422 172.1 422 178.6 422 183 417.1 183 410.3 182.9 403.8 178.6 398.6 172.1 398.6zM289.6 398.3C284.2 398.3 280.9 401.8 280.1 407H299.2C298.3 401.3 294.8 398.3 289.6 398.3zM397.4 398.6C390.6 398.6 386.5 403.8 386.5 410.3 386.5 416.8 390.6 422 397.4 422 404.2 422 408.6 417.1 408.6 410.3 408.6 403.8 404.2 398.6 397.4 398.6zM503.3 424.7C503.3 425 503.6 425.2 503.6 425.8 503.6 426.1 503.3 426.3 503.3 426.9 503 427.2 503 427.4 502.8 427.7 502.5 428 502.3 428.2 501.7 428.2 501.4 428.5 501.2 428.5 500.6 428.5 500.3 428.5 500.1 428.5 499.5 428.2 499.2 428.2 499 427.9 498.7 427.7 498.4 427.4 498.2 427.2 498.2 426.9 497.9 426.4 497.9 426.1 497.9 425.8 497.9 425.3 497.9 425 498.2 424.7 498.2 424.2 498.5 423.9 498.7 423.6 499 423.3 499.2 423.3 499.5 423.1 500 422.8 500.3 422.8 500.6 422.8 501.1 422.8 501.4 422.8 501.7 423.1 502.2 423.4 502.5 423.4 502.8 423.6S503 424.2 503.3 424.7zM501.1 426.1C501.6 426.1 501.6 425.8 501.9 425.8 502.2 425.5 502.2 425.3 502.2 425 502.2 424.7 502.2 424.5 501.9 424.2 501.6 424.2 501.4 423.9 500.8 423.9H499.2V427.4H500V426H500.3L501.4 427.4H502.2L501.1 426.1zM576 81V433C576 459.5 554.5 481 528 481H48C21.5 481 0 459.5 0 433V81C0 54.5 21.5 33 48 33H528C554.5 33 576 54.5 576 81zM64 220.6C64 297.1 126.1 359.1 202.5 359.1 229.7 359.1 256.4 350.9 279 336 206.1 276.7 206.6 164.8 279 105.5 256.4 90.5 229.7 82.4 202.5 82.4 126.1 82.3 64 144.4 64 220.6zM288 329.4C358.5 274.4 358.2 167.2 288 111.9 217.8 167.2 217.5 274.5 288 329.4zM145.7 405.7C145.7 397 140 391.3 131 391 126.4 391 121.5 392.4 118.2 397.5 115.8 393.4 111.7 391 106 391 102.2 391 98.4 392.4 95.4 396.4V392H87.2V428.7H95.4C95.4 409.8 92.9 398.5 104.4 398.5 114.6 398.5 112.6 408.7 112.6 428.7H120.5C120.5 410.4 118 398.5 129.5 398.5 139.7 398.5 137.7 408.5 137.7 428.7H145.9V405.7zM190.6 392H182.7V396.4C180 393.1 176.2 391 171 391 160.7 391 152.8 399.2 152.8 410.3 152.8 421.5 160.7 429.6 171 429.6 176.2 429.6 180 427.7 182.7 424.2V428.8H190.6V392zM231.1 417.6C231.1 402.6 208.2 409.4 208.2 402.4 208.2 396.7 220.1 397.6 226.7 401.3L230 394.8C220.6 388.7 199.8 388.8 199.8 403 199.8 417.3 222.7 411.3 222.7 418 222.7 424.3 209.2 423.8 202 418.8L198.5 425.1C209.7 432.7 231.1 431.1 231.1 417.6zM266.5 426.9L264.3 420.1C260.5 422.2 252.1 424.5 252.1 416V399.4H265.2V392H252.1V380.8H243.9V392H236.3V399.3H243.9V416C243.9 433.6 261.2 430.4 266.5 426.9zM279.8 413.5H307.3C307.3 397.3 299.9 390.9 289.9 390.9 279.3 390.9 271.7 398.8 271.7 410.2 271.7 430.7 294.3 434.1 305.5 424.4L301.7 418.4C293.9 424.8 282.1 424.2 279.8 413.5zM338.9 392C334.3 390 327.3 390.2 323.7 396.4V392H315.5V428.7H323.7V408C323.7 396.4 333.2 397.9 336.5 399.6L338.9 392zM349.5 410.3C349.5 398.9 361.1 395.2 370.2 401.9L374 395.4C362.4 386.3 341.3 391.3 341.3 410.4 341.3 430.2 363.7 434.2 374 425.4L370.2 418.9C361 425.4 349.5 421.5 349.5 410.3zM416.2 392H408V396.4C399.7 385.4 378.1 391.6 378.1 410.3 378.1 429.5 400.5 435 408 424.2V428.8H416.2V392zM449.9 392C447.5 390.8 438.9 389.1 434.7 396.4V392H426.8V428.7H434.7V408C434.7 397 443.7 397.7 447.5 399.6L449.9 392zM490.2 377.1H482.3V396.4C474.1 385.5 452.4 391.3 452.4 410.3 452.4 429.7 474.9 434.9 482.3 424.2V428.8H490.2V377.1zM497.8 302V306.6H498.6V302H500.5V301.2H495.9V302H497.8zM504.4 425.8C504.4 425.3 504.4 424.7 504.1 424.2 503.8 423.9 503.6 423.4 503.3 423.1 503 422.8 502.5 422.6 502.2 422.3 501.7 422.3 501.1 422 500.6 422 500.3 422 499.8 422.3 499.2 422.3 498.7 422.6 498.4 422.8 498.1 423.1 497.6 423.4 497.3 423.9 497.3 424.2 497 424.7 497 425.3 497 425.8 497 426.1 497 426.6 497.3 427.2 497.3 427.5 497.6 428 498.1 428.3 498.4 428.6 498.6 428.8 499.2 429.1 499.7 429.4 500.3 429.4 500.6 429.4 501.1 429.4 501.7 429.4 502.2 429.1 502.5 428.8 503 428.6 503.3 428.3 503.6 428 503.8 427.5 504.1 427.2 504.4 426.6 504.4 426.1 504.4 425.8zM507.6 301.1H506.2L504.6 304.6 503 301.1H501.6V306.5H502.4V302.4L504 305.9H505.1L506.5 302.4V306.5H507.6V301.1zM512 220.6C512 144.4 449.9 82.3 373.5 82.3 346.3 82.3 319.6 90.5 297 105.4 369.1 164.7 370.2 276.9 297 335.9 319.6 350.9 346.5 359 373.5 359 449.9 359.1 512 297.1 512 220.6z"}]}}),H.register({"brands/cc-paypal":{width:576,height:512,paths:[{d:"M186.3 258.2C186.3 270.4 176.6 279.7 164.3 279.7 155.1 279.7 148.3 274.5 148.3 264.7 148.3 252.5 157.8 242.7 170 242.7 179.3 242.7 186.3 248.4 186.3 258.2zM80.5 209.7H75.8C74.3 209.7 72.8 210.7 72.6 212.4L68.3 239.1 76.5 238.8C87.5 238.8 96 237.3 98 224.6 100.3 211.2 91.8 209.7 80.5 209.7zM364.5 209.7H360C358.2 209.7 357 210.7 356.8 212.4L352.6 239.1 360.6 238.8C373.6 238.8 382.6 235.8 382.6 220.8 382.5 210.2 373 209.7 364.5 209.7zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM128.3 215.4C128.3 194.4 112.1 187.4 93.6 187.4H53.6C51.1 187.4 48.6 189.4 48.4 192.1L32 294.2C31.7 296.2 33.2 298.2 35.2 298.2H54.2C56.9 298.2 59.4 295.3 59.7 292.5L64.2 265.9C65.2 258.7 77.4 261.2 82.2 261.2 110.8 261.2 128.3 244.2 128.3 215.4zM212.5 224.2H193.5C189.7 224.2 189.5 229.7 189.3 232.4 183.5 223.9 175.1 222.4 165.6 222.4 141.1 222.4 122.4 243.9 122.4 267.6 122.4 287.1 134.6 299.8 154.1 299.8 163.1 299.8 174.3 294.9 180.6 287.9 180.1 289.4 179.6 292.6 179.6 294.1 179.6 296.4 180.6 298.1 182.8 298.1H200C202.7 298.1 205 295.2 205.5 292.4L215.7 228.1C216 226.2 214.5 224.2 212.5 224.2zM253 322.1L316.7 229.5C317.2 229 317.2 228.5 317.2 227.8 317.2 226.1 315.7 224.3 314 224.3H294.8C293.1 224.3 291.3 225.3 290.3 226.8L263.8 265.8 252.8 228.3C252 226.1 249.8 224.3 247.3 224.3H228.6C226.9 224.3 225.4 226.1 225.4 227.8 225.4 229 244.9 284.6 246.6 289.9 243.9 293.7 226.1 318.5 226.1 321.5 226.1 323.3 227.6 324.7 229.3 324.7H248.5C250.3 324.6 252 323.6 253 322.1zM412.3 215.4C412.3 194.4 396.1 187.4 377.6 187.4H337.9C335.2 187.4 332.7 189.4 332.4 192.1L316.2 294.1C316 296.1 317.5 298.1 319.4 298.1H339.9C341.9 298.1 343.4 296.6 343.9 294.9L348.4 265.9C349.4 258.7 361.6 261.2 366.4 261.2 394.8 261.2 412.3 244.2 412.3 215.4zM496.5 224.2H477.5C473.7 224.2 473.5 229.7 473.2 232.4 467.7 223.9 459.2 222.4 449.5 222.4 425 222.4 406.3 243.9 406.3 267.6 406.3 287.1 418.5 299.8 438 299.8 447.3 299.8 458.5 294.9 464.5 287.9 464.2 289.4 463.5 292.6 463.5 294.1 463.5 296.4 464.5 298.1 466.7 298.1H484C486.7 298.1 489 295.2 489.5 292.4L499.7 228.1C500 226.2 498.5 224.2 496.5 224.2zM544 190.9C544 188.9 542.5 187.4 540.8 187.4H522.3C520.8 187.4 519.3 188.6 519.1 190.1L502.9 294.1 502.6 294.6C502.6 296.4 504.1 298.1 506.1 298.1H522.6C525.1 298.1 527.6 295.2 527.8 292.4L544 191.2V190.9zM454 242.7C441.8 242.7 432.3 252.4 432.3 264.7 432.3 274.4 439.3 279.7 448.5 279.7 460.5 279.7 470.2 270.5 470.2 258.2 470.3 248.4 463.3 242.7 454 242.7z"}]}}),H.register({"brands/cc-stripe":{width:576,height:512,paths:[{d:"M396.9 256.5C396.9 275.6 388.1 289.9 375 289.9 366.7 289.9 361.7 286.9 358.2 283.2L358 230.4C361.7 226.3 366.8 223.4 375 223.4 387.9 223.3 396.9 237.9 396.9 256.5zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM122.2 281.1C122.2 238.8 67.9 246.4 67.9 230.4 67.9 224.9 72.5 222.7 80 222.7 90.8 222.7 104.5 226 115.3 231.8V198.4C103.5 193.7 91.8 191.9 80 191.9 51.2 191.9 32 206.9 32 232.1 32 271.4 86 265 86 282 86 288.6 80.3 290.7 72.4 290.7 60.6 290.7 45.5 285.8 33.5 279.4V313.3C46.7 319 60.1 321.4 72.3 321.4 101.9 321.2 122.2 306.7 122.2 281.1zM191.1 194.2H164.1V163.4L129.4 170.8 129.2 284.7C129.2 305.7 145 321.2 166.1 321.2 177.7 321.2 186.3 319.1 191 316.5V287.6C186.5 289.4 164 295.9 164 275V224.5H191V194.2zM264.9 194.2C260.2 192.5 243.6 189.4 235.3 204.7L233.1 194.2H202.4V318.7H237.9V234.3C246.3 223.3 260.5 225.4 265 226.9V194.2zM309.1 194.2H273.4V318.7H309.1V194.2zM309.1 146.9L273.4 154.5V183.4L309.1 175.8V146.9zM431.8 255.7C431.8 214.4 408.3 191.9 383.4 191.9 369.5 191.9 360.5 198.5 355.6 203L353.8 194.2H322.5V360L358 352.5 358.1 312.3C363.2 316 370.8 321.3 383.2 321.3 408.6 321.2 431.8 300.8 431.8 255.7zM544 256.9C544 220.5 526.4 191.8 492.7 191.8 458.9 191.8 438.4 220.5 438.4 256.7 438.4 299.5 462.6 321.2 497.2 321.2 514.2 321.2 526.9 317.3 536.6 312V283.4C526.9 288.3 515.8 291.3 501.7 291.3 487.9 291.3 475.7 286.4 474.1 269.8H543.6C543.7 267.8 544 260.4 544 256.9zM492.4 220.8C483.5 220.8 473.7 227.5 473.7 243.5H510.4C510.4 227.5 501.1 220.8 492.4 220.8z"}]}}),H.register({"brands/cc-visa":{width:576,height:512,paths:[{d:"M470.1 231.3S477.7 268.5 479.4 276.3H446C449.3 267.4 462 232.8 462 232.8 461.8 233.1 465.3 223.7 467.3 217.9L470.1 231.3zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM152.5 331.2L215.7 176H173.2L133.9 282 129.6 260.5 115.6 189.1C113.3 179.2 106.2 176.4 97.4 176H32.7L32 179.1C47.8 183.1 61.9 188.9 74.2 196.2L110 331.2H152.5zM246.9 331.4L272.1 176H231.9L206.8 331.4H246.9zM386.8 280.6C387 262.9 376.2 249.4 353.1 238.3 339 231.2 330.4 226.4 330.4 219.1 330.6 212.5 337.7 205.7 353.5 205.7 366.6 205.4 376.2 208.5 383.4 211.6L387 213.3 392.5 179.7C384.6 176.6 372 173.1 356.5 173.1 316.8 173.1 288.9 194.3 288.7 224.5 288.4 246.8 308.7 259.2 323.9 266.7 339.4 274.3 344.7 279.3 344.7 286 344.5 296.4 332.1 301.2 320.6 301.2 304.6 301.2 296 298.7 282.9 292.9L277.6 290.4 272 325.3C281.4 329.6 298.8 333.4 316.8 333.6 359 333.7 386.5 312.8 386.8 280.6zM528 331.4L495.6 176H464.5C454.9 176 447.6 178.8 443.5 188.9L383.8 331.4H426S432.9 312.2 434.4 308.1H486C487.2 313.6 490.8 331.4 490.8 331.4H528z"}]}}),H.register({"brands/centercode":{width:512,height:512,paths:[{d:"M329.2 268.6C325.4 303.8 293.8 329.2 258.6 325.4 223.4 321.6 198 290 201.8 254.8 205.6 219.6 237.2 194.2 272.4 198 307.5 201.8 333 233.4 329.2 268.6zM243.4 503.7C96.7 496-8.2 365.5 10.1 224.3 21.3 137.7 75.9 67.4 149.2 32.3 310.2-44.8 498.9 69.7 503.9 248.9 508 395.9 385.5 511.1 243.4 503.7zM423.3 323.7C451.2 205.7 262.8 117.8 186.1 89.5 128.6 145.8 117 278.1 152.3 433.9 221.1 449.7 321.4 407.5 423.3 323.7z"}]}}),H.register({"brands/chrome":{width:496,height:512,paths:[{d:"M131.5 217.5L55.1 100.1C102.7 40.9 174.1 8.3 247.1 8 289.4 7.7 332.6 18.5 371.9 41.2 415.3 66.4 448.3 102.6 469.3 144.2L264 133.4C205.9 130 150.6 162.7 131.5 217.5zM164.4 256C164.4 302.2 201.8 339.6 248 339.6S331.6 302.2 331.6 256 294.2 172.4 248 172.4 164.4 209.7 164.4 256zM479.3 166.8L339.6 174C377.5 218.3 378.1 282.2 346.2 331.2L234.1 503.6C280.6 506.1 328.5 495.9 371.9 470.7 479.3 408.7 522.8 278.7 479.3 166.8zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256 0 380 90.8 482.7 209.5 500.9L273.2 376.1C215.6 386.9 160 355.3 133.7 303.6z"}]}}),H.register({"brands/cloudscale":{width:448,height:512,paths:[{d:"M318.1 154L308.7 161.6C286.2 142.3 257.2 128 225.4 128 153.8 128 96 188.8 96 260.3 96 266.9 96.4 273.4 97.4 279.7 95.4 223.7 139.2 182.3 190 182.3 214.2 182.3 236.2 191.7 252.6 207L227.4 227.4C219.1 226.5 210.6 229.2 204.3 235.5 193.2 246.5 193.2 264.4 204.3 275.5 215.4 286.5 233.2 286.5 244.3 275.5 250.6 269.2 253.3 260.6 252.4 252.4L327.6 163.6C333.9 157.1 324.3 147.7 318.1 154zM234.3 265.5C228.7 271 219.7 271 214.1 265.5 208.5 259.9 208.5 250.9 214.1 245.3S228.7 239.7 234.3 245.3 239.9 260 234.3 265.5zM224 32C100.5 32 0 132.5 0 256S100.5 480 224 480 448 379.5 448 256 347.5 32 224 32zM224 416C135.8 416 64 344.2 64 256S135.8 96 224 96 384 167.8 384 256 312.2 416 224 416z"}]}}),H.register({"brands/cloudsmith":{width:332,height:512,paths:[{d:"M332.5 419.9C332.5 466.3 294.9 504 248.5 504S164.5 466.3 164.5 419.9 202.1 335.9 248.5 335.9 332.5 373.5 332.5 419.9zM248.5 176C294.9 176 328.5 138.4 328.5 92S294.9 8 248.5 8 160.5 45.6 160.5 92 130.9 168 84.5 168 0.5 209.6 0.5 256 38.1 336 84.5 336 168.5 302.4 168.5 256 202.1 176 248.5 176z"}]}}),H.register({"brands/cloudversify":{width:616,height:512,paths:[{d:"M148.6 304C156.8 372.5 216 419.5 294.6 415.3 345.8 458.6 431.4 461.1 481 409.7 550.2 410.8 599.5 365.1 612.5 310.2 627.3 247.7 594.3 177.7 520.4 155.1 487.4 67 389 53.6 333.9 70.1 276.6 87.4 249.6 123.3 234.6 179.8 226.8 182.5 208.1 188.7 189.6 203.9 201.3 203.9 204.8 212.8 204.8 223.4V243.8C204.8 254.5 196.1 263.3 185.3 263.3H165.1C154.4 263.3 145.6 257.3 145.6 246.6V240H98.8C95 240 88 244.3 88 251.9V292.3C88 298.7 93.3 304.1 99.7 304.1H148.6zM376 312C365.3 358.3 397.7 384.4 431.3 398.8 324.1 432.6 259.7 348 296 288 262.8 309.6 262.3 359.2 266.8 380.9 248.9 368.5 213 348.5 209.4 301.1 206.4 261.2 230.9 225.4 266.4 207.2 297 191.4 369.9 198.7 400 248 385.9 200 346.2 177.9 298.2 173.2 329.1 142.5 362.6 122.9 412.4 129.5 482.2 138.8 545.6 212.3 480.1 280 515.1 263.7 528.8 225.6 527.6 203.1L538.1 222.7C549.9 244.7 553.3 270.3 547.5 294.7 538.3 333.7 506.9 363.5 467.8 371.2 435.7 377.5 384.7 366.1 376 312zM128 208H88.2C79.3 208 72 200.7 72 191.8V152.2C72 143.3 79.3 136 88.2 136H128C136.9 136 144.2 143.3 144.2 152.2V191.8C144.2 200.7 136.9 208 128 208zM10.1 168C4.5 168 0 163.5 0 157.9V130.1C0 124.5 4.5 120 10.1 120H37.8C43.3 120 47.9 124.5 47.9 130.1V157.9C47.9 163.5 43.4 168 37.8 168H10.1zM168 142.7V121.3C168 116.2 172.2 112 177.3 112H198.7C203.8 112 208 116.2 208 121.3V142.7C208 147.8 203.8 152 198.7 152H177.3C172.2 152 168 147.8 168 142.7zM56 235.5V260.5C56 266.8 50.9 272 44.6 272H19.4C13.1 272 8 266.8 8 260.5V235.5C8 229.2 13.1 224 19.4 224H44.5C50.9 224 56 229.2 56 235.5z"}]}}),H.register({"brands/codepen":{width:512,height:512,paths:[{d:"M502.3 159.7L268.3 3.7C260.3-1.2 251.8-1.3 243.7 3.7L9.7 159.7C3.7 163.7 0 170.8 0 178V334C0 341.1 3.7 348.3 9.7 352.3L243.7 508.3C251.7 513.2 260.2 513.3 268.3 508.3L502.3 352.3C508.3 348.3 512 341.1 512 334V178C512 170.8 508.3 163.7 502.3 159.7zM278 63.1L450.3 178 373.4 229.4 278 165.7V63.1zM234 63.1V165.7L138.6 229.4 61.7 178 234 63.1zM44 219.1L99.1 256 44 292.8V219.1zM234 448.8L61.7 334 138.6 282.6 234 346.3V448.8zM256 308L178.3 256 256 204 333.7 256 256 308zM278 448.8V346.3L373.4 282.6 450.3 334 278 448.8zM468 292.8L412.9 256 468 219.1V292.8z"}]}}),H.register({"brands/codiepie":{width:472,height:512,paths:[{d:"M422.5 202.9C453.2 202.9 456 256 422.2 256H411.4V300.3H384.8V202.9H422.5zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8C345.4 8 420.8 61.7 466.2 146.4L280.2 255.2 472 352.6zM433.5 365.1L373.2 334.4C346.1 378.7 302.8 405.8 250.8 405.8 168.3 405.8 101.6 339.1 101.6 256.9 101.6 174.4 168.3 107.7 250.8 107.7 299.2 107.7 339.7 131.2 367.7 171.1L427.2 136.5C386.5 73.9 322.5 36.5 248 36.5 126.8 36.5 28.5 134.8 28.5 256S126.8 475.5 248 475.5C326.6 475.5 394.5 433.4 433.5 365.1z"}]}}),H.register({"brands/connectdevelop":{width:576,height:512,paths:[{d:"M550.5 241L500.4 154.2C501.5 152.1 502.3 149.7 502.3 147 502.3 138.9 495.6 132.2 487.6 132L432.1 36.1C432.6 34.5 433.2 32.9 433.2 31.3 433.2 22.7 426.2 16 417.9 16 413.1 16 409.1 18.1 406.1 21.6H299.5C296.8 18.1 292.8 16 288 16S279.2 18.1 276.5 21.6H170.4C167.5 18.1 163.4 16 158.6 16 150.3 16 143.4 22.7 143.4 31.3 143.4 32.9 143.9 34.8 144.4 36.1L88.4 133.3C83.1 135.7 79.3 140.8 79.3 147 79.3 147.5 79.6 148.1 79.6 148.6L26.3 240.7C19.1 242.1 13.7 248.2 13.7 255.7 13.7 263 18.8 269.1 25.8 270.7L80.9 366.1C80.4 367.7 80.1 369 80.1 370.9 80.1 378.1 85.2 384.3 92.2 385.6L143.9 475.4C143.4 477 142.8 478.9 142.8 480.7 142.8 489.3 149.8 496 158.1 496 162.9 496 166.9 493.9 169.6 490.6H276.5C279.2 493.9 283.4 496 288 496S296.8 493.9 299.5 490.6H406.7C409.3 493.6 413.4 495.5 417.6 495.5 426.2 495.5 432.9 488.5 432.9 480.2 432.9 478.6 432.6 477.3 432.1 475.9L483.8 385.6C490.8 384.3 495.9 378.1 495.9 370.9 495.9 369.3 495.6 367.7 495.1 366.1L550 270.7C556.9 269.4 562.3 263.2 562.3 255.7 562.3 248.5 557.2 242.3 550.5 241zM153.5 450.7L109.9 374.9H153.5V450.7zM153.5 366.9H109.9C109.6 365.8 109.1 364.8 108.5 363.7L153.5 316.3V366.9zM153.5 304.5L103.2 357.8C101.8 357.3 100.5 356.4 99.2 356.2L43.4 259.8C44 258.4 44 257.1 44 255.7S44 253.3 43.7 252.3L95.7 162.3C98.4 162 101 161.2 103.4 159.6L153.5 211.5V304.5zM153.5 202.2L107.7 154.8C109.1 152.6 109.9 149.9 109.9 147 109.9 146.7 109.6 146.2 109.6 145.9L153.5 130.1V202.2zM153.5 121.5L109.9 137.3 153.5 61.8V121.5zM480.1 160.6L480.9 162 445.5 329.1 381.8 261.9 479.8 160.4 480.1 160.6zM291.8 355.1L303.3 366.9H280.5L291.8 355.1zM291.5 343.9L208.2 258.4 287.7 174 370.8 261.6 291.5 343.9zM296.8 349.8L376.1 267.5 443.6 338.8 437.7 366.9H313.7L296.8 349.8zM410.4 44.4C411.5 44.9 412.6 45.5 413.9 45.7L471.8 146.4V147C471.8 149.9 472.6 152.6 473.9 154.8L376.4 256 293.4 168.4 410.4 44.4zM401.3 42.3L287.7 162.5 230.7 102.3 397 42.3H401.3zM277.8 42.3C280.5 44.9 284 46.5 288 46.5S295.5 44.9 298.2 42.3H373.2L224.8 95.8 173.9 42.3H277.8zM161.6 47.9L162.6 45.7A33.8-33.8 0 0 1 165.3 44.9L216.5 98.8 161.6 118.6V47.9zM161.6 127.2L222.4 105.2 282.1 168.4 202.6 252.5 161.6 210.5V127.2zM161.6 219.8L198 257.6 161.6 295.9V219.8zM161.6 307.7L203.6 263.2 286.4 349.2 269.3 366.9H161.6V307.7zM168.5 469.8C166.9 468.1 165.1 467.1 162.6 466.3L161.6 464.7V374.9H261.5L169.9 469.8H168.5zM298.4 469.8C295.8 467.3 292 465.5 288 465.5S280.2 467.3 277.6 469.8H181.1L272.7 374.9H311L402.6 469.8H298.4zM418.4 458L414.2 465.5C412.8 465.7 411.8 466.3 410.7 466.8L321.5 374.9H435.9L418.4 458zM431.3 435.7L444.2 374.9H466.1L431.3 435.7zM466.1 366.9H445.8L450.3 345.7 467.5 363.9C466.9 364.7 466.4 365.8 466.1 366.9zM532.3 259.5L476.8 356.2C475.5 356.7 474.2 357.3 472.8 358.1L452.2 336.1 486.8 172.2 532.6 251.4C532.3 252.8 531.8 254.1 531.8 255.7 531.8 257.1 532 258.1 532.3 259.5z"}]}}),H.register({"brands/contao":{width:512,height:512,paths:[{d:"M45.4 305C59.8 372.1 71.8 434 113.6 480H34C15.3 480 0 464.8 0 446V66C0 47.3 15.2 32 34 32H91.7C77.9 44.6 65.6 59.2 54.8 75.6 9.4 145.6 27.8 222.4 45.4 305zM478 32H387.8C409.2 53.4 427 81.5 440.5 116.1L303.4 145.4C288.5 116.4 265.6 92.1 220.8 101.5 196.2 106.8 179.8 120.8 172.5 136.1 163.7 154.8 159.3 175.9 180.7 276.4 201.8 376.6 214.4 394.1 230.2 407.6 243.1 418.7 263.6 424.6 288.5 419.3 333 409.9 344.2 378.6 345.9 346.1L483.3 316.5C486.5 388 464.6 441.7 425.9 480.1H478C496.7 480.1 512 464.9 512 446.1V66C512 47.2 496.8 32 478 32z"}]}}),H.register({"brands/cpanel":{width:640,height:512,paths:[{d:"M52.9 213.7H92.9L86.7 237.3C84.8 243.8 79.3 248.2 72.4 248.2H53.8C28.9 248.2 29.1 285.6 53.8 285.6H65.1C69.3 285.6 72.7 289.5 71.5 293.9L64.4 320H52C18.5 320-7 288.6 1.7 254.8 9 227.8 30 213.7 52.9 213.7M73.1 320L108 189.9C109.8 183.5 115.2 179 122.3 179H159.3C183.4 179 204.7 195.4 210.3 220.2 216.9 249.3 195.8 285.5 158.6 285.5H126.6L133 261.7C134.8 255.5 140.3 250.9 147.3 250.9H157.6C170 250.9 178.4 239.2 175.9 228.3 173.8 219.1 166 213.5 157.6 213.5H137.8L112 309.2C110.1 315.4 104.6 319.9 97.8 319.9L73.1 320M293.7 250.6C294 249.6 295.6 245.3 291.6 245.3H234.1C224.4 245.3 217.5 236.4 219.9 226.8L223.4 213.4H301.3C320.1 213.4 334.6 231 329.8 250.2L315.8 302C313 312.6 303.6 319.8 292.4 319.8L234.9 319.6C192 319.6 196.4 255.8 235.6 255.8H284L280.5 269C278.6 275.2 273.1 279.8 266.3 279.8H244.7C239.4 279.8 239.4 287.7 244.7 287.7H279.6C284.2 287.7 284.7 283.8 285.1 282.4L293.7 250.6M396.8 213.7C431.2 213.7 456.1 246 447.1 279.1L438.3 312.2C437.1 317.1 432.6 320 428 320H408.9C404.4 320 401.3 316 402.5 311.7L413.1 271.7C416.4 260.1 407.5 248.3 395 248.3H375.2L358 312.3C356.8 317.1 352.4 320.1 347.6 320.1H328.7C324.5 320.1 321.1 316.2 322.3 311.8L348.5 213.8H396.8M498 251.6L490 281.6C489.1 284.9 491.5 288.3 495.1 288.3H568.4L562.7 309.3C560.8 315.5 555.3 320 548.5 320H481.8C461.8 320 448.5 301 453.5 283.3L464.3 243.3C469.1 225.7 485 213.7 502.9 213.7H550.2C569.2 213.7 583.4 231.4 578.5 250.5L575.3 262.5C572.4 273.5 562.6 280.1 552.1 280.1H498.7L502.2 267.1C503.8 260.9 509.4 256.3 516.4 256.3H538C540 256.3 541.3 255.3 541.9 253.3L542.6 250.7C543.3 248 541.3 245.6 538.7 245.6H505.8C501.7 245.6 498.9 247.7 498 251.6zM568.2 320L603.8 186.9C605 182.2 609.3 179 614.2 179H633.1C637.6 179 640.8 183 639.6 187.3L613.1 285.5C608 306.2 588.9 320 568.2 320"}]}}),H.register({"brands/creative-commons":{width:512,height:512,paths:[{d:"M255.5 8C392.9 8 504 114.4 504 256 504 406 381.1 504 255.6 504 122.3 504 8 394.6 8 256 8 124.8 113.5 8 255.5 8zM256.4 52.7C136.1 52.7 52.7 153.3 52.7 256 52.7 362.5 141.7 458.4 256.4 458.4 358 458.4 459.3 379 459.3 256 459.3 141.2 367.5 52.7 256.4 52.7zM253.3 214.8L220.1 232.1C214.7 220.9 204.9 212.2 192.7 212.2 170.5 212.2 159.4 226.8 159.4 256 159.4 279.9 168.9 299.9 192.7 299.9 207.1 299.9 217.3 292.8 223.2 278.6L253.8 294.1C241 318 216.9 333.1 188.7 333.1 145.5 333.1 114.7 305.8 114.7 256 114.7 206.5 147.4 179 187.3 179 218.1 179 240 190.9 253.3 214.8zM396.4 214.8L363.6 232.1C358.1 220.6 348.3 212.2 335.7 212.2 313.6 212.2 302.5 226.8 302.5 256 302.5 279.9 312 299.9 335.7 299.9 350.2 299.9 360.4 292.8 366.3 278.6L397.3 294.1C383.9 318 359.8 333.1 332.2 333.1 288.7 333.1 258.2 306.1 258.2 256 258.2 206.5 290.9 179 330.8 179 361.5 179 383.4 190.9 396.4 214.8z"}]}}),H.register({"brands/css3-alt":{width:384,height:512,paths:[{d:"M0 32L34.9 427.8 192 480 349.1 427.8 384 32H0zM313.1 112L308.3 159.3 193 208.6 192.7 208.7H304.2L291.4 355.3 193.2 384 94.4 354.8 88 280.9H136.9L140.1 319.2 192.7 332.5 247.4 317.1 251.1 255.5 84.8 255V254.9L84.6 255 81 208.7 193.1 162 199.6 159.3H76.7L70.9 112H313.1z"}]}}),H.register({"brands/css3":{width:512,height:512,paths:[{d:"M480 32L416 400 192.7 480 0 400 19.6 305.2H101.6L93.6 345.8 210 390.2 344.1 345.8 362.9 248.7H29.5L45.5 166.7H379.2L389.7 114H56.3L72.6 32H480z"}]}}),H.register({"brands/cuttlefish":{width:440,height:512,paths:[{d:"M344 305.5C326.5 337.1 286.6 360 248 360 191.4 360 144 312.6 144 256S191.4 152 248 152C286.6 152 326.5 174.9 344 206.5 357.7 155.6 385.7 113.2 431 88.7 385.7 39.1 320.5 8 248 8 111 8 0 119 0 256S111 504 248 504C320.5 504 385.7 472.9 431 423.3 385.7 398.8 357.7 356.4 344 305.5z"}]}}),H.register({"brands/d-and-d":{width:576,height:512,paths:[{d:"M82.5 98.9C81.9 81.7 84.5 65.1 95.2 50.7 95.5 58.1 96.4 65.2 99.4 72.3 105.3 44.8 119.1 23 141.7 6.8 139.8 12.7 138.2 18.6 138.7 24.5 147.4 17.1 157.5 6.7 183.1 1.8 197.8-1 212.8-0.2 225.2 2.8 263.7 12.1 286.2 37.1 294.9 75.1 300.2 98.2 295.6 120.1 286.6 141.5 281.4 153.9 274.6 165.9 265.9 176.6 263.9 174.7 262 172.8 260.1 171 217.3 130.2 233.3 145.8 222.7 133.6 221.6 132.4 221.7 131.4 222.6 130 230.9 116.5 234.4 101.8 232.6 86 231.5 76.2 228.3 67.1 221.3 59.8 206.8 44.5 182.1 44.8 167.8 60.4 156.4 72.9 153.7 87.8 156.9 104 157.1 105.3 157.3 106.7 156.9 107.9 153.5 121.6 152.3 135.5 154.4 149.5 154.5 150 154.5 150.6 154.5 151.1 154.5 151.4 154.4 151.6 154.3 152.2 132.5 141.2 118.3 123.9 111.1 100 102.8 117.8 100 135.5 104.5 154.1 88.9 138.9 83.2 119.8 82.5 98.9zM552.1 222.1C540.5 210.5 527.1 201.7 512 195.5 499.2 190.3 486 187.6 472.1 188.4 462.1 189 452.5 191.5 443.1 194.8 440.6 195.7 438 196.4 435.4 197 430.5 198.2 428.1 193.9 430.7 190.2 433.9 185.6 434.1 186 445.7 178.2 446.3 177.8 446.9 177.4 447.9 176.7H445.4C444.8 176.7 444.2 176.9 443.5 177 424.2 180.3 412.8 192.5 394.6 206.6 384.2 214.7 380.8 210.4 382.6 206.1 384 202.6 385.9 199.4 387.7 196.1 388.7 194.3 390 192.7 391.2 191 391 190.8 390.7 190.7 390.5 190.5 363.5 208.8 343.8 232.9 332.8 263.8 333.1 264.1 333.5 264.4 333.8 264.7 334.1 264.1 334.3 263.5 334.7 263 345.1 250.9 357.5 241.2 371.3 233.2 389.5 222.6 408.8 214.9 430 213 434.3 212.6 438.7 212.9 443.1 212.9 441.3 213.6 439.6 213.8 437.8 214 419.3 216.4 402.3 223 386.3 232.5 356.1 250.4 331.8 274.7 311.2 302.9 310.9 303.3 310.8 303.8 310.5 304.2 325 309.5 334.5 321.5 346.6 329.8 346.8 329.7 346.9 329.6 347 329.4L348.2 326.7C360.4 299.8 375.2 274.4 394.9 252.2 411.6 233.4 432.9 226.9 457.4 232.2 463.3 233.5 468.8 236.6 474.6 239 476.9 237.6 479.7 235.8 482.6 234.3 491 230 500 227.3 509.3 225.3 524 222.2 538.8 220.4 553.8 224V223.5C553.3 223.1 552.6 222.7 552.1 222.1zM316.7 397.6C277.3 364.6 293.9 378.1 274 362 273.2 362.9 274 361.8 272.1 365 260.9 384.1 246.6 400.3 228.1 412.6 217.8 419.4 206.6 424.4 194 424.4 172.4 424.4 155.8 414.9 144.6 396.6 132.6 377.1 131.3 355.9 136.4 334 144.2 300.2 166.5 278.8 175 269.7 156.3 263.5 142 271.4 128.6 283.6 129.4 269.7 132.9 257.4 140.4 246.3 116.1 256.9 94.5 271.3 75.6 290.2 75.3 284.4 81 246.5 81.2 245.5 81.5 242.8 80.6 240.2 78.2 238.1 54 262.8 33.7 289.9 22.1 322.7 29.5 316.8 37 311.3 45.7 306.5 37.4 328.8 26.1 359.3 37.9 407.6 42.5 426.6 49.8 444.4 62 459.9 64.9 463.6 68.3 466.8 71.5 470.2 71.7 470 71.9 469.9 72.1 469.7 70.7 462.7 69.9 455.6 70.6 447.8 72.8 451 74.5 453.8 76.5 456.4 89.1 472.4 105.2 483.8 123.7 492 148.7 503.3 174.8 505.3 201.6 500.6 256.5 490.9 292.3 452 317.6 401.8 318.6 400 318.2 398.9 316.7 397.6zM488.7 351.2C479.2 348.1 466.5 347 460 348.3 469.9 352.3 474.1 354.9 478.8 360.3 491.4 374.7 489.2 395 473.4 405.9 461.7 414 448.5 416.4 434.5 415 433.3 414.9 432.2 414.6 431.5 414.4 434.3 410.7 437.5 407.4 439.6 403.6 449 386.8 445 361.5 430.9 347.5 428.8 345.4 426.3 343.6 423.9 341.6 423.6 342.9 423.8 343.7 424 344.4 428.2 361 415.9 376.8 399.2 376.2 391.6 375.9 385.3 372.4 379.6 367.7 360.1 351.6 340.5 335.6 321.1 319.4 315.2 314.5 308.6 311.3 301 310.7 296.4 310.3 291.7 310.1 287.1 309.8 281.2 309.4 278.3 307 276.7 301.4 275.8 298 275.2 294.6 274.5 291.2 273 283.1 268.3 278.2 260.2 277 255.8 276.3 251.3 276 246.9 275.5 233.9 274.1 227.1 268.1 224.3 255.2 219.3 266.2 222.7 277.6 231.6 285.1 236.1 288.9 240.9 292.4 245.4 296.3 250 300.1 252.8 305 253.3 311.1 253.7 315.8 254.1 320.6 255.1 325.2 257.3 335.8 264 343.6 272.1 350.3 288.6 364 305.1 377.6 321.6 391.4 339.5 406.4 335.5 424.2 334.6 447.4 333.7 470.3 346.8 490.3 368.1 498.6 369.1 499 370.1 499.2 371.7 499.7 356 481.5 361.6 455.6 372.4 447.4 372.7 449.6 372.8 451.7 373.3 453.8 382.7 497.9 418.7 518 458.3 510.7 474.3 507.8 488.9 501.8 501.2 490.9 503.2 489.1 504.9 486.8 507.1 484.4 487.8 489 471.3 484.5 456.2 473.8 456.9 473.5 457.5 473.5 458.1 473.5 479.4 475.3 498.7 470.1 515.1 456.1 534.6 439.5 541.7 413.2 532.5 390.1 524.2 370 508.9 357.8 488.7 351.2zM99.4 179.3C94.1 170.1 86.2 163.7 77.3 158 91 157.5 103.9 158.2 116.9 161.7 109.9 149.5 108.4 137 111.9 123 117.2 134.9 125.6 143.1 135.5 149.8 155.2 163 171.2 169.4 182.2 180 185.6 183.3 188.5 187.1 191.8 190.9 191 188.8 190.4 186.8 189.6 184.9 184.6 174.3 176.6 166.3 167 159.9 165.2 158.7 164.2 157.4 163.6 155.4 160.3 142.9 160.6 130.3 162.9 117.8 163.9 112.3 165.7 106.9 167.4 101.5 168.2 99.1 169.7 96.9 171.4 94.9 172 101.8 171.4 120.4 191 140.9 201.8 152.2 213.4 162.8 224.9 173.6 233.9 182.1 243.2 190.3 250.4 200.4 251.5 202 252.6 203.7 254.2 205.1 249.2 192.1 240 181 230 171.3 220.4 162 210.6 152.9 200.8 143.9 197.5 140.9 196.2 137.2 195.7 133 194.5 122.6 195.7 112.4 200 102.8 200.5 101.8 201.1 100.8 201.9 99.5 202.4 103.7 202.5 107.4 203.3 111.1 208.1 134.2 223.7 147.4 252.6 174.6 262.6 184 271.9 193.8 278.2 206.2 283 215.5 285.5 225.2 283.9 235.8 283.8 236.4 284.4 237.5 285 237.8 291.2 240.4 295 244.7 294.7 252.1 302.4 249.5 307.2 244.1 311.1 237.6 315.3 257.8 302 287.9 283.9 296.3 284.3 291.8 288.9 272.9 267.4 268.6 260.6 267.3 254.6 267.3 244.5 266.5 249.2 257.5 254.9 245.9 245 244.1 220.1 239.5 192.2 246 187.2 248.7 195.4 249.1 203.5 249.7 210.7 252 208.7 258.5 206.7 264.7 204.9 270.9 203 277.4 207 285.5 214.2 280.5 215.4 279.6 216.5 278.6 217.5 277.8 214.4 295.7 214.6 293.7 214.7 296.1 215 306.3 224.2 303.9 230.4 303.4 227.9 315.2 200.9 330.7 185 329.2 192 324.5 197.7 318.9 200.9 311.3 194.4 312.1 188 312.9 181.7 313.7L181.4 312.8C186.1 309.4 189.4 305 191.6 299.7 200.3 278.6 188 261.7 166.6 259.8 157.5 259 148.8 260.6 140.7 265.3 146.9 249.7 157.9 238.7 173.3 230.8 158.1 226.5 164.4 228.1 148.7 224.5 163.3 215.2 178.9 211.3 195.2 209.9 190 206.7 147.1 206.3 125 230.8 132.9 232.2 140.5 233.6 148.2 235 124.4 242 104.2 254.7 85.8 270.6 86.9 265.8 88.5 261.1 89.1 256.3 89.7 251.8 89.9 247.1 89.2 242.7 87.7 233.3 80.3 227.6 69.5 226.4 61.6 225.5 53.9 226.5 46.2 227.7 45.3 227.8 44.5 228 43.3 227.7 59.1 212.9 79.3 206 96.4 194.2 102.4 189.7 103.2 186 99.4 179.3zM227.8 206.1C231.1 222.1 240.4 231.6 251.6 230.4 247 219.1 239.5 210.9 227.8 206.1z"}]}}),H.register({"brands/dashcube":{width:448,height:512,paths:[{d:"M326.6 104H110.4C59.3 104 19.2 147.3 19.2 197.5V427C19.2 477.5 59.3 512 110.4 512H337.6C388.7 512 428.8 477.5 428.8 427V0L326.6 104zM153.9 416.5C136.2 416.5 121.5 401.4 121.5 383.7V240.8C121.5 223.1 136.2 208.3 153.9 208.3H294.6C312.3 208.3 326.6 223.1 326.6 240.8V364.3L377.7 416.6H153.9z"}]}}),H.register({"brands/delicious":{width:448,height:512,paths:[{d:"M446.5 68C446.1 66.5 445.6 65 445.1 63.5 444.2 61 443.1 58.7 441.8 56.4 440.4 54 438.8 51.6 437.1 49.5 435 47 432.7 44.7 430.2 42.7 429.1 41.8 428 41 426.9 40.2 425.6 39.3 424.3 38.5 422.9 37.8 421.1 36.8 419.3 36 417.4 35.3 415.7 34.6 413.9 34 412 33.6 408.2 32.6 404.1 32.1 400 32.1H48C21.5 32 0 53.5 0 80V432C0 436.1 0.5 440.2 1.5 444 3.5 451.7 7.3 458.6 12.5 464.3 13.5 465.4 14.6 466.5 15.8 467.6 21.5 472.8 28.4 476.6 36.1 478.6 39.9 479.6 44 480.1 48.1 480.1H400.1C426.6 480.1 448.1 458.6 448.1 432.1V80C448 75.9 447.5 71.8 446.5 68zM416 432C416 440.8 408.8 448 400 448H224V256H32V80C32 71.2 39.2 64 48 64H224V256H416V432z"}]}}),H.register({"brands/deploydog":{width:512,height:512,paths:[{d:"M382.2 136H433.9V375.6H382.2V354.9C362.4 379.7 329.4 379 308.4 369.6 282.2 357.9 264.1 331.5 264.1 297.8 264.1 268 278.9 239.9 307.4 227 327.6 217.9 360.1 216.4 382.2 239.9V136zM317.5 297.8C317.5 316 331.1 331.3 350.7 331.3 370.5 331.3 383.9 314.9 383.9 298.4 383.9 281.3 370.2 265.2 350.7 265.2 331.1 265.2 317.5 281.6 317.5 297.8zM188.5 136H240.2V375.6H188.5V354.9C168.7 379.7 135.7 379 114.7 369.6 88.5 357.9 70.4 331.5 70.4 297.8 70.4 268 85.2 239.9 113.7 227 133.9 217.9 166.4 216.4 188.5 239.9V136zM123.8 297.8C123.8 316 137.4 331.3 157 331.3 176.8 331.3 190.2 314.9 190.2 298.4 190.2 281.3 176.5 265.2 157 265.2 137.3 265.2 123.8 281.6 123.8 297.8zM448 96C465.5 96 480 110.4 480 128V384C480 401.5 465.6 416 448 416H64C46.5 416 32 401.6 32 384V128C32 110.5 46.4 96 64 96H448M448 64H64C28.8 64 0 92.8 0 128V384C0 419.2 28.8 448 64 448H448C483.2 448 512 419.2 512 384V128C512 92.8 483.2 64 448 64z"}]}}),H.register({"brands/deskpro":{width:480,height:512,paths:[{d:"M205.9 512L237 473.6C249.3 473.4 262.6 472.2 273.5 467 312.4 448.4 311.9 405.1 311.8 403.2 311.7 398.2 311 398.8 282.9 365.8H362C361.8 415.9 354.7 434.3 351.8 441.5 342.4 465.2 307.9 504.3 256.6 510.9 247.9 512 223.8 512.1 205.9 512zM406.3 344.3C444.9 344.3 464.8 330.7 480 313.4L304.5 313.1 287.1 344.4 406.3 344.3zM362.7 120.4V288.7H289.2L256.5 344.2H250C197.7 344.2 191.9 287.7 191.7 285.3 190.5 272.1 170.4 273.7 171.6 287.1 173 302.9 180.4 327.1 198 344.2H107C81.5 344.2-3.8 317.4 0 230.2V16.9C0 0.9 9.7 0.3 15 0.1H97C97.2 0.1 97.3 0.2 97.5 0.2 101.8-0.2 147.6-1.9 147.6 43.9 147.6 57.2 167.8 57.3 167.8 43.9 167.8 25.7 162.3 11.1 152 0.2H236.2C344.9-0.2 362.7 79.6 362.7 120.4zM230.2 176.4L294.2 205.7C307.5 160.2 252 134 230.2 176.4z"}]}}),H.register({"brands/deviantart":{width:320,height:512,paths:[{d:"M320 93.2L221.8 272.3 229.2 281.8H320V409.5H159.1L145.6 418.7 101.9 502.7C101.6 502.7 93.3 511.3 92.7 511.9H0V418.7L93.2 239.3 85.8 230.1H0V102.5H156L169.5 93.3 213.2 9.3C213.5 9.3 221.8 0.7 222.4 0.1H320V93.2z"}]}}),H.register({"brands/digg":{width:512,height:512,paths:[{d:"M81.7 172.3H0V346.7H132.7V96H81.7V172.3zM81.7 305.7H50.9V213.4H81.7V305.7zM378.9 172.3V346.7H460.7V375.2H378.9V416H512V172.3H378.9zM460.7 305.7H429.9V213.4H460.7V305.7zM225.1 346.7H307.2V375.2H225.1V416H358.4V172.3H225.1V346.7zM276.3 213.4H307.1V305.7H276.3V213.4zM153.3 96H204.6V147H153.3V96zM153.3 172.3H204.6V346.7H153.3V172.3z"}]}}),H.register({"brands/digital-ocean":{width:512,height:512,paths:[{d:"M256 504V407.9C357.8 407.9 436.8 307 397.7 199.9 383.4 160.3 351.6 128.5 311.9 114.2 204.8 75.4 103.8 154.1 103.8 255.9H8C8 93.7 164.9-32.8 335 20.3 409.2 43.6 468.6 102.7 491.6 176.9 544.8 347.2 418.6 504 256 504zM256.3 312.6H160.7V408.2H256.3V312.6zM160.7 408.2H87V481.8H160.7V408.2zM87 346.6H25.4V408.2H87V346.6z"}]}}),H.register({"brands/discord":{width:448,height:512,paths:[{d:"M297.2 243.2C297.2 258.8 285.7 271.6 271.1 271.6 256.8 271.6 245 258.8 245 243.2S256.5 214.8 271.1 214.8C285.7 214.8 297.2 227.6 297.2 243.2zM177.7 214.8C163.1 214.8 151.6 227.6 151.6 243.2S163.3 271.6 177.7 271.6C192.3 271.6 203.8 258.8 203.8 243.2 204 227.6 192.3 214.8 177.7 214.8zM448 52.7V512C383.5 455 404.1 473.9 329.2 404.2L342.8 451.6H52.5C23.6 451.6 0 428 0 398.8V52.7C0 23.6 23.6 0 52.5 0H395.5C424.4 0 448 23.6 448 52.7zM375 295.4C375 213 338.2 146.2 338.2 146.2 301.3 118.5 266.2 119.3 266.2 119.3L262.7 123.4C306.2 136.7 326.4 155.9 326.4 155.9 265.6 122.6 194.2 122.6 135.2 148.5 125.7 152.8 120.1 155.9 120.1 155.9S141.3 135.7 187.4 122.4L184.8 119.3S149.8 118.5 112.9 146.2C112.9 146.2 76 213 76 295.4 76 295.4 97.5 332.5 154.1 334.3 154.1 334.3 163.6 322.8 171.3 313.1 138.8 303.4 126.5 282.9 126.5 282.9 130.2 285.5 136.4 288.9 137 289.3 180.2 313.5 241.5 321.4 296.7 298.2 305.7 294.9 315.6 290 326.1 283.1 326.1 283.1 313.3 304.1 279.8 313.6 287.5 323.3 296.7 334.3 296.7 334.3 353.3 332.5 375 295.4 375 295.4z"}]}}),H.register({"brands/discourse":{width:448,height:512,paths:[{d:"M225.9 32C103.3 32 0 130.5 0 252.1 0 256 0.1 480 0.1 480L225.9 479.8C348.6 479.8 448 377.5 448 255.9 448 134.3 348.6 32 225.9 32zM224 384C204.6 384 186.1 379.7 169.6 371.9L88.5 392 111.4 317C101.6 298.9 96 278.1 96 256 96 185.3 153.3 128 224 128S352 185.3 352 256 294.7 384 224 384z"}]}}),H.register({"brands/dochub":{width:416,height:512,paths:[{d:"M397.9 160H256V19.6L397.9 160zM304 192V322C304 388.8 267.5 422.1 190.7 422.1H96V84.8H190.7C202.7 84.8 213.8 85.6 223.8 87.3V3.3C212.9 1.1 201.4 0 189.2 0H0V512H189.2C329.7 512 400 447.4 400 318.1V192H304z"}]}}),H.register({"brands/docker":{width:640,height:512,paths:[{d:"M349.9 236.3H283.8V176.9H349.9V236.3zM349.9 32H283.8V92.7H349.9V32zM428.1 176.8H362V236.2H428.1V176.8zM271.8 104.7H205.7V164.8H271.8V104.7zM349.9 104.7H283.8V164.8H349.9V104.7zM626.7 204.7C612.3 195 579.1 191.5 553.6 196.3 550.3 172.3 536.9 151.4 512.5 132.6L498.5 123.3 489.2 137.3C470.8 165.1 465.8 210.9 485.5 241.1 476.8 245.8 459.7 252.2 437.1 251.8H2.4C-6.3 302.6 8.2 368.6 46.4 413.9 83.5 457.8 139.1 480.1 211.8 480.1 369.2 480.1 485.7 407.6 540.2 275.9 561.6 276.3 607.8 276 631.5 230.7 633 228.2 638.1 217.5 640 213.6L626.7 204.7zM115.6 176.8H49.6V236.2H115.7V176.8zM193.7 176.8H127.6V236.2H193.7V176.8zM271.8 176.8H205.7V236.2H271.8V176.8zM193.7 104.7H127.6V164.8H193.7V104.7z"}]}}),H.register({"brands/draft2digital":{width:480,height:512,paths:[{d:"M369.9 425.4V371L417 398.2 369.9 425.4zM82.4 380.6C107.9 353.3 180.1 275.9 233.3 210.6 268.4 167.5 273.6 128.2 261.7 97.9 254.3 79.1 244.2 67.7 237.4 62.2 282.7 64.3 305.4 85.6 319.6 100.5 319.6 100.5 362 148.7 325.4 213.8 288.4 279.7 214.5 361.3 196.9 380.5H82.4zM134.2 161.4C134.2 173.8 124.2 183.8 111.8 183.8 99.4 183.8 89.4 173.8 89.4 161.4 89.4 149 99.4 139 111.8 139 124.2 139 134.2 149.1 134.2 161.4M336 315.9V380.6H244.7C275.5 345.6 326.5 284.7 356.5 231.3 391.7 168.7 372.6 107.9 343.7 78 339.3 73.4 281.5 15.1 177.7 36.8 118.6 49.2 88.3 80.2 73.4 104.1 60.3 125 56.4 143.9 55.2 151.8 49.7 184.8 74.6 218.9 111.9 218.9 143.6 218.9 169.2 193.2 169.2 161.5 169.2 134.4 149.5 109.4 121.2 104.7 123 97.4 138.9 83.6 147.5 80 188.6 62.7 225.5 85.2 230.8 113.5 239.1 157.8 193.7 203.9 161.1 241.1 84.5 328.1 18.3 396.8 0 415.9L336 415.8V480L480 398.1 336 315.9z"}]}}),H.register({"brands/dribbble-square":{width:448,height:512,paths:[{d:"M90.2 228.2C99.1 185.8 127.6 150.5 165.9 132.5 169.5 137.4 193.9 171.3 216.6 211.5 152.6 228.5 96.3 228.3 90.2 228.2zM314.6 154C281 124.2 235.3 112.9 192 123.4 195.8 128.5 220.6 162.3 243 203.4 291.6 185.1 312.1 157.5 314.6 154zM140.1 364C180.6 395.6 233.4 400.7 277.4 382 275.4 370 267.4 328.2 248.2 278.4 193.1 297.2 154.4 334.8 140.1 364zM238.9 255.8C235.5 248 231.7 240.3 227.8 232.6 159.6 253 93.4 252.2 87.4 252 87.4 253.4 87.3 254.8 87.3 256.2 87.3 291.3 100.6 323.3 122.4 347.6 144.6 309.7 189.5 269.7 238.9 255.8zM273.8 272.1C291.7 321.2 298.9 361.2 300.3 369.5 331 348.8 352.8 315.9 358.9 277.9 354.3 276.4 316.6 265.2 273.8 272.1zM253.5 223.7C258.3 233.5 261.8 241.5 265.5 250.5 311 244.8 356.2 253.9 360.7 254.9 360.4 222.6 348.9 193 329.8 169.8 326.9 173.7 304 203 253.5 223.7zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM384 256C384 167.8 312.2 96 224 96S64 167.8 64 256 135.8 416 224 416 384 344.2 384 256z"}]}}),H.register({"brands/dribbble":{width:512,height:512,paths:[{d:"M256 8C119.3 8 8 119.3 8 256S119.3 504 256 504 504 392.7 504 256 392.7 8 256 8zM420 122.4C449.5 158.4 467.3 204.3 467.8 254.3 460.8 252.8 390.8 238.6 320.3 247.5 314.6 233.5 309.1 221.1 301.7 205.9 380 173.9 415.5 128.4 420 122.4zM396.4 97.9C392.6 103.3 360.7 146.2 285.4 174.4 250.7 110.6 212.2 58.2 206.4 50.4 273.5 34.2 344.3 51.7 396.4 97.9zM165.9 64.6C171.5 72.3 209.4 124.7 244.5 187.1 145.4 213.4 58.1 213.1 48.6 212.9 62.4 147.2 106.7 92.6 165.9 64.6zM44.2 256.3C44.2 254.2 44.2 252 44.3 249.8 53.5 250 156.2 251.4 262 219.7 268 231.6 273.8 243.6 279.2 255.7 202.6 277.2 133 339.2 98.6 398 64.8 360.4 44.2 310.7 44.2 256.3zM126 423.4C148.1 378.2 208.2 319.8 293.6 290.7 323.3 368 335.6 432.7 338.7 451.3 270.6 480.3 188.7 472.4 126 423.4zM374.4 431.9C372.2 419 360.9 357 333.2 280.9 399.6 270.3 457.9 287.7 465.2 289.9 455.7 348.9 421.9 399.8 374.4 431.9z"}]}}),H.register({"brands/dropbox":{width:528,height:512,paths:[{d:"M264.4 116.3L132.4 200.6 264.4 284.9 132.4 369.2 0 284.1 132.3 199.8 0 116.3 132.3 32 264.4 116.3zM131.6 395.7L263.6 311.4 395.6 395.7 263.6 480 131.6 395.7zM264.4 284.1L396.4 199.8 264.4 116.2 395.7 32 528 116.3 395.7 200.6 528 284.8 395.7 369.1 264.4 284.1z"}]}}),H.register({"brands/drupal":{width:448,height:512,paths:[{d:"M319.5 114.7C297.3 100.7 276 95.2 254.8 81.2 241.8 72.4 223.5 51.2 208.3 32.9 205.6 62.2 196.8 74.1 186.3 82.4 165 99.4 151.5 104.6 132.8 114.7 117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294 416 181.7 333 123 319.5 114.7zM322 440.3C301.9 460.4 231.9 469 205.3 444.5 200.5 439.7 205.6 432.5 211.8 432.5 211.8 432.5 228.8 445.8 263.3 445.8 290.3 445.8 309.3 438.1 317.8 431.8 323.9 427.2 326.2 436.1 322 440.3zM267.5 387.7C276.2 384.1 296.5 383.9 304.3 389 308.4 391.8 320.4 407.8 310.5 412.7 302.1 416.9 309.3 397 284 397 269.3 397 264.5 402.2 257.3 408 250.3 414 247.5 416 245.1 412.7 239.1 404.5 261 390.4 267.5 387.7zM360 405C344.8 404 314.5 356.2 295 355.5 264.1 354.6 190.9 436.2 133.7 397.5 94.9 370.9 119.1 292.7 185.5 292.3 235 291.8 269.3 341.3 294 340.8 315.3 340.5 355.8 299 375.8 299 424.5 299 399.1 408.3 360 405z"}]}}),H.register({"brands/dyalog":{width:416,height:512,paths:[{d:"M0 32V151.2H64V96H171.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0V480H171.2C331.9 480 416 367.3 416 255.9 416 197.2 393.9 142.5 353.7 101.6 308.9 56 245.7 32 171.2 32H0z"}]}}),H.register({"brands/earlybirds":{width:480,height:512,paths:[{d:"M313.2 47.5C314.4 34.5 334.5 33.5 349.8 38.8 350.7 39.1 376 48.5 368.8 54 340.9 46.6 312.4 72.2 313.2 47.5zM112.2 54.4C142.9 46.3 174.2 74.4 173.3 47.3 172 33.1 149.9 32 133.1 37.7 132.1 38 104.4 48.2 112.2 54.4zM319.4 160C310.6 160 303.4 167.2 303.4 176S310.6 192 319.4 192 335.4 184.8 335.4 176 328.2 160 319.4 160zM159.7 160C150.9 160 143.7 167.2 143.7 176S150.9 192 159.7 192 175.7 184.8 175.7 176 168.5 160 159.7 160zM478.2 323.2C468.3 347.2 437.5 334.2 414.3 322 400.8 391.1 356.2 433.4 288 446.2 288.3 447.1 286 446.1 312 447.2 345.6 448.6 375.8 444.1 409.4 439.2 389.6 425.4 398 402.1 399.6 401.1 401 400.2 414.3 402.8 421.2 412.6 429.8 400.1 449.6 397.8 451.4 399 453 400.1 458 419.9 444.5 433.6 449.2 432.7 452.7 432 454.3 431.5 456.9 430.7 472 442.8 457.4 444.8 443.1 447.1 434.8 449.9 410.3 455.6 364.4 466.3 324.4 467.4 292.6 468.4L293.6 480C297.4 498.1 270.2 504.3 266 486.2 266.8 504.1 238.9 508 237.6 485.2L237.1 490.5C236.4 508.9 208.7 508.4 208.8 489.9 201.3 503.4 180.7 496.7 182.4 481.4L183.6 469C146.9 469.9 123.9 472.1 121.8 472.1 100.9 472.1 100.9 440.5 121.8 440.5 124.2 440.5 149.5 441.8 185 443.3 123.9 427.8 81.3 388.3 70.1 325.1 45.1 337.9 12.6 351.9 1.9 325.9-8.6 300.5 23.4 283.3 68.7 252.5 69.4 245.9 70.3 239.2 71.4 232.7 57 213.1 59.8 196.4 55.3 172.3 38.5 174.7 32.1 163.2 31.7 149.2 32 141.9 33.8 134.3 34.1 133.8 35.2 132 44.2 131.8 46.8 131.2 52.8 99.5 97.4 98 137.7 96.7 157.4 74.9 182.9 55.2 218.6 48.4 203.3 29 215.2 8.5 216.2 8 217.9 7.2 237.4 12.3 242.5 31.2 247.7 22.4 260.8 19.8 262.1 20.5 263.2 21.1 268.5 35.5 257.2 46.4 297.5 49.9 329.4 71.1 353.2 97.1 389.3 98.6 425 103 430.3 131.1 433 131.7 441.9 131.9 443 133.7 443.3 134.2 445.1 141.8 445.4 149.1 444.9 163 438.6 174.5 421.8 172.2 418.6 189.5 419.1 205.1 413.1 219.9 415.5 231.6 417.1 243.7 417.9 256.3 454.9 281.7 488.2 298.8 478.2 323.2zM207.4 159.9C208.3 115.9 169.5 117.7 128.8 119.6 107.1 120.6 89.9 121.5 83.3 133.5 71.9 154.4 89.2 226.4 106.5 234.7 116.3 239.4 179.9 242.6 192.8 227.6 201 218.2 207.8 178.2 207.4 159.9zM259.4 218.2C255.1 205.8 253.4 188.1 244.1 185.5 242.1 185 235.1 185 233.1 185.5 223.1 188.3 222.3 207.6 216.1 222.7 231.5 222.7 235.4 232.4 239.8 232.4 244.1 232.4 246.1 221.1 259.4 218.2zM395.1 133.5C388.5 121.4 370.3 120.6 348.6 119.6 308.4 117.7 270.4 115.8 271.3 159.9 270.8 178.2 276.3 218.2 284.5 227.7 297.5 242.6 361.1 239.5 370.8 234.8 386.6 227.2 407.3 155.9 395.1 133.5z"}]}}),H.register({"brands/edge":{width:512,height:512,paths:[{d:"M25.7 228.2C25.8 228 25.9 227.8 26.1 227.7 26 227.8 26 228 26 228.2H25.7zM486.3 243.7C486.3 199.6 478.5 159.2 457.5 121.3 416.5 47.9 343.9 8 258.9 8 119 7.7 40.6 113.2 26.1 227.7 68.5 166.4 143.1 106.3 246.4 102.7 246.4 102.7 356.1 102.7 345.9 207.7H170C176.4 170.3 188.6 148.7 204.3 128.7 129.3 163.6 82.5 224.8 83.6 317.1 84.4 388.5 133.7 461.9 204.3 489 287.7 520.9 397.1 496.2 444.5 467.7V363.3C363.6 419.8 173.6 424.2 172.2 295.7H486.3V243.7z"}]}}),H.register({"brands/elementor":{width:448,height:512,paths:[{d:"M425.6 32H22.4C10 32 0 42 0 54.4V457.6C0 470 10 480 22.4 480H425.6C438 480 448 470 448 457.6V54.4C448 42 438 32 425.6 32M164.3 355.5H124.5V156.5H164.3V355.5zM323.6 355.5H204.1V315.7H323.6V355.5zM323.6 275.9H204.1V236.1H323.6V275.9zM323.6 196.2H204.1V156.4H323.6V196.2z"}]}}),H.register({"brands/ember":{width:640,height:512,paths:[{d:"M639.9 254.6C638.8 243.9 629.2 247.8 629.2 247.8S613.6 259.9 599.9 258.5C586.2 257.2 590.5 226.5 590.5 226.5S593.5 198.4 585.4 196.1C577.3 193.7 567.4 203.4 567.4 203.4S555 217.1 549.1 234.6L547.5 235.1S549.4 204.5 547.2 197.5C545.6 194 530.8 194.3 528.4 200.5S514.2 249.7 513.4 267.7C513.4 267.7 490.3 287.3 470.1 290.5S445.1 281.1 445.1 281.1 499.9 265.8 498 222C496.1 178.2 453.8 194.4 449 198 444.4 201.5 419.6 216.4 412.4 257.7 412.2 259.1 411.7 265.2 411.7 265.2S390.5 279.4 378.7 283.2C378.7 283.2 411.7 227.6 371.4 202.3 353.1 191.3 338.6 214.4 338.6 214.4S393.1 153.7 381.1 102.4C375.3 78 363.1 75.3 351.9 79.3 334.9 86 328.4 96 328.4 96S306.4 128 301.3 175.5 288.7 280.6 288.7 280.6 278.2 290.8 268.5 291.3 263.1 262.6 263.1 262.6 270.6 218 270.1 210.5 269 198.9 260.2 196.3C251.3 193.6 241.7 204.9 241.7 204.9S216.2 243.6 214 249.5L212.7 251.9 211.4 250.3S229.4 197.6 212.2 196.8C195 196 183.7 215.6 183.7 215.6S164.1 248.4 163.3 252.1L162 250.5S170.1 212.3 168.4 202.9C166.8 193.5 157.9 195.4 157.9 195.4S146.6 194.1 143.7 201.3 130 256.6 128.7 272C128.7 272 100.5 292.2 81.9 292.4 63.4 292.7 65.2 280.6 65.2 280.6S133.2 257.3 114.6 211.4C106.3 199.6 96.6 195.9 82.9 196.1 69.2 196.4 52.6 204.7 41.6 229.4 36.3 241.2 34.8 252.4 33.8 260.9 33.8 260.9 21.5 263.3 15 258S5 258 5 258-6.2 272 4.9 276.3 33 282.4 33 282.4C34.6 289.9 39.2 301.9 52.6 312.1 72.8 327.4 111.4 310.8 111.4 310.8L127.3 302S127.8 316.6 139.4 318.7C151 320.8 155.8 319.7 175.9 270.8 187.7 245.8 188.5 247.2 188.5 247.2L189.8 246.9S180.7 293.7 184.2 306.6C187.7 319.4 203 318 203 318S211.3 320.4 218 296.8C224.7 273.2 237.6 246.9 237.6 246.9H239.2S233.6 295 242.2 310.6C250.8 326.2 273.1 315.9 273.1 315.9S288.7 308.1 291.1 305.7C291.1 305.7 309.6 321.5 335.7 318.6 394 307.1 414.8 292.7 414.8 292.7S424.8 317.1 455.9 319.4C491.4 322.1 510.7 300.8 510.7 300.8S510.4 314.3 522.8 319.4C535.2 324.5 543.5 296.6 543.5 296.6L564.2 239.4H566.1S567.2 276.7 587.6 282.6 634.6 268.9 634.6 268.9 641 265.4 639.9 254.6zM61.9 259.9C62.7 227.9 83.7 214 90.9 220.9 98.2 227.9 95.5 242.9 81.8 252.3 68.1 261.8 61.9 259.9 61.9 259.9zM334.7 136.1S353.8 86.4 358.3 110.6 318.3 206.8 318.3 206.8C318.8 190.6 334.7 136.1 334.7 136.1zM357.5 274.5C344.9 307.5 314.2 294.1 314.2 294.1S310.7 282.3 320.6 249.2 353.9 229 353.9 229 370.1 241.4 357.5 274.5zM442.1 259.9S439.1 249.4 450.2 229.3C461.2 209.1 469.8 220.2 469.8 220.2S479.2 230.4 468.5 245.7 442.1 259.9 442.1 259.9z"}]}}),H.register({"brands/empire":{width:496,height:512,paths:[{d:"M287.6 54.2C276.8 52 265.5 50.9 254.1 50.6V32.4C332.2 34.6 400.2 76.4 438.7 139L422.9 148.1C416.8 138.4 410.2 129.3 402.7 121L384.7 136.5C358.7 106.9 323.3 85.8 282.8 78.1L287.6 54.2zM53.4 322.4L76.4 314.7C70 296.4 66.4 276.5 66.4 256S69.7 215.6 76.1 197.3L53.4 189.6C57 178.8 61.7 168.3 67 158.6L51.2 149.5C34 181 24.1 217.5 24.1 256S34.1 331 51.2 362.6L67 353.5C61.7 343.5 57.3 333.2 53.4 322.4zM213.1 434C172.7 426 137.3 404.9 111.2 375.3L93.2 391.1C85.7 382.5 78.8 373.4 73 363.7L57 373.1C95.5 435.4 163.8 477.4 241.9 479.7V461.4C230.6 461.1 219.2 459.7 208.4 457.8L213.1 434zM93.3 120.9L111.3 136.4C137.3 106.8 172.7 85.7 213.2 78L208.5 54.2C219.3 52 230.6 50.9 242 50.6V32.4C163.9 34.6 95.9 76.4 57.4 139L73.2 148.1C79.2 138.4 85.8 129.2 93.3 120.9zM402.7 391.1L384.7 375.3C358.7 404.9 323.3 426 282.8 434L287.5 457.8C276.7 459.7 265.4 461.1 254 461.4V479.7C332.1 477.5 400.4 435.4 438.9 373.1L422.8 363.7C417.1 373.4 410.2 382.5 402.7 391.1zM496 256C496 393 385 504 248 504S0 393 0 256 111 8 248 8 496 119 496 256zM483.8 256C483.8 125.9 378.1 20.2 248 20.2S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zM444.8 149.4L429 158.5C434.3 168.2 439 178.7 442.6 189.5L419.9 197.2C426.3 215.5 429.6 235.4 429.6 255.9S426 296.3 419.6 314.6L442.6 322.3C438.7 333.1 434.3 343.3 429 353.3L444.8 362.4C462 331 471.9 294.5 471.9 256S462 181 444.8 149.4zM261.8 327.1C278.1 323.8 292.2 315.5 302.5 303.6L353.7 348.4C365.6 334.8 375 319.1 380.8 301.6L316.6 279.5C319.1 272 320.5 264.3 320.5 256S319.1 239.9 316.6 232.5L381.1 210.4C375 193 365.6 177.2 353.7 163.6L302.5 208.4C292.3 196.5 278.1 187.9 261.8 184.6L275.1 118.2C266.5 116.3 257.4 115.4 248 115.4 238.6 115.4 229.5 116.2 220.9 118.2L234.2 184.6C217.9 187.9 203.8 196.5 193.5 208.4L142.3 163.6C130.4 177.2 121 192.9 114.9 210.4L179.4 232.5C176.9 240 175.5 247.7 175.5 256S176.9 272.1 179.4 279.5L115.2 301.6C121 319 130.4 334.8 142.3 348.4L193.5 303.6C203.7 315.5 217.9 323.8 234.2 327.1L220.9 393.8C229.5 395.5 238.6 396.6 248 396.6 257.4 396.6 266.5 395.5 275.1 393.8L261.8 327.1z"}]}}),H.register({"brands/envira":{width:448,height:512,paths:[{d:"M0 32C477.6 32 366.6 349.3 367.1 398.3L448 480H422L351.6 408.8C312.6 413 227.2 443.3 137.2 371.8 47 300.3 52 214.7 0 32zM79.7 78C30 54.5 74.5 87.2 74.5 87.2 119.7 118.4 140.5 160.9 164.7 207.1 196.2 267.3 243.7 346.8 308.9 374.8 373.9 402.8 343.1 387.3 314.9 366.3 286.7 345.1 246.7 279.3 223.9 236.1 192.2 176.1 162.9 117.5 79.7 78z"}]}}),H.register({"brands/erlang":{width:640,height:512,paths:[{d:"M21.7 246.4C21.6 333.2 50.7 405.9 100.4 458.5H0V53.5H87.2C45.7 103.7 21.6 169.7 21.7 246.4zM640 53.6H556.4C587.8 96.3 605.1 151.1 602.6 216.3 603.1 222.3 603.1 228 602.6 240.4H230.2C230 350.1 269.1 435.3 368.8 435.7 437.3 435.4 486.8 384.7 520.7 329.6L617.1 377.8C599.7 408.7 580.6 435.6 559.2 458.6H640V53.6zM559.2 458.6S559.2 458.5 559.2 458.6H559 559.2zM556.1 53.6H556.4L556.3 53.5 556.1 53.6zM325.4 63.2C279.5 63.3 240.3 96.7 236.2 146.4H406.1C405 96.7 371.6 63.3 325.4 63.2z"}]}}),H.register({"brands/ethereum":{width:320,height:512,paths:[{d:"M311.9 260.8L160 353.6 8 260.8 160 0 311.9 260.8zM160 383.4L8 290.6 160 512 312 290.6 160 383.4z"}]}}),H.register({"brands/etsy":{width:384,height:512,paths:[{d:"M384 348C382.3 358.8 370.3 458 368.5 480 250.6 475.7 148.6 475.3 0 480V454.5C45.5 445.6 60.6 446.5 61 419.3 62.8 346.9 64.5 175.1 61 97.3 60 68.8 48.9 70.5 0 61.3V35.8C73.9 38.1 255.9 44.3 363 32 359.5 70.3 355.2 158.5 355.2 158.5H332C320.9 115.7 313.2 68 277.3 68H140.3C130 68 129.5 71.5 129.5 77.8V241.5C187.5 242 218 239 218 239 247.8 238 245.6 230.5 258.8 173.7H284.5C280.1 275.1 280.6 235.6 282.8 334H257C247.8 293.9 247.9 273 217.5 272.5 217.5 272.5 196 270.5 129.5 270.5V409.5C129.5 435.5 143.7 447.7 173.7 447.7H263C326.6 447.7 329.6 422.8 361.8 348H384z"}]}}),H.register({"brands/expeditedssl":{width:496,height:512,paths:[{d:"M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zM150.6 176.3C150.6 122.6 194.3 78.9 248 78.9S345.4 122.6 345.4 176.3V202.9C345.4 207.9 341.5 211.8 336.5 211.8H318.8C313.8 211.8 309.9 207.9 309.9 202.9V176.3C309.9 94.2 185.9 94.2 185.9 176.3V202.9C185.9 207.9 182 211.8 177 211.8H159.3C154.3 211.8 150.4 207.9 150.4 202.9V176.3zM389.7 380C389.7 389.7 381.7 397.7 372 397.7H124C114.3 397.7 106.3 389.7 106.3 380V238.3C106.3 228.6 114.3 220.6 124 220.6H372C381.7 220.6 389.7 228.6 389.7 238.3V380zM141.7 242.7V375.6C141.7 378.1 139.8 380 137.3 380H128.4C125.9 380 124 378.1 124 375.6V242.7C124 240.2 125.9 238.3 128.4 238.3H137.3C139.8 238.3 141.7 240.2 141.7 242.7zM283.4 291.4C283.4 304.4 276.2 315.8 265.7 321.8V353.4C265.7 358.4 261.8 362.3 256.8 362.3H239.1C234.1 362.3 230.2 358.4 230.2 353.4V321.8C219.7 315.7 212.5 304.4 212.5 291.4 212.5 271.7 228.3 256 247.9 256S283.4 271.8 283.4 291.4zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 486.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"}]}}),H.register({"brands/facebook-f":{width:264,height:512,paths:[{d:"M76.7 512V283H0V192H76.7V120.3C76.7 42.4 124.3 0 193.8 0 227.1 0 255.7 2.5 264 3.6V85H215.8C178 85 170.7 103 170.7 129.3V192H256L244.3 283H170.7V512"}]}}),H.register({"brands/facebook-messenger":{width:448,height:512,paths:[{d:"M224 32C15.9 32-77.5 278 84.6 400.6V480L160.3 438C302.5 477.8 445.7 378.1 445.7 239.3 445.8 124.8 346.5 32 224 32zM247.4 310.1L190 250.5 79.6 311.6 200.7 183.1 258.1 242.7 368.5 181.6 247.4 310.1z"}]}}),H.register({"brands/facebook-square":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H314.7V302.8H375.3L384 235.2H314.7V192C314.7 172.4 320.1 159.1 348.2 159.1H384V98.7C377.8 97.9 356.6 96 331.8 96 280.2 96 244.8 127.5 244.8 185.4V235.3H184V302.9H244.9V480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80z"}]}}),H.register({"brands/facebook":{width:448,height:512,paths:[{d:"M448 56.7V455.2C448 468.9 436.9 479.9 423.3 479.9H309.1V306.5H367.3L376 238.9H309V195.7C309 176.1 314.4 162.8 342.5 162.8H378.3V102.3C372.1 101.5 350.9 99.6 326.1 99.6 274.5 99.6 239.1 131.1 239.1 189V238.9H180.7V306.5H239.1V480H24.7C11.1 480 0 468.9 0 455.3V56.7C0 43.1 11.1 32 24.7 32H423.2C436.9 32 448 43.1 448 56.7z"}]}}),H.register({"brands/firefox":{width:480,height:512,paths:[{d:"M478.1 235.3C477.4 230.8 476.7 228.2 476.7 228.2S474.9 230.2 472 234.1C471.1 223.4 469.2 212.9 466.2 202.5 462.5 189.6 457.7 177.1 451.7 165.1 447.9 157.1 443.5 149.5 438.4 142.3 436.6 139.6 434.7 136.9 432.8 134.4 424 120 413.8 111.1 402.1 94.4 394.5 81.6 389.2 67.5 386.7 52.8 383.5 61.7 381 70.8 379.3 80.1 367.2 67.9 356.8 59.3 350.4 53.4 319.4 24.2 323 9.1 323 9.1S264.7 74.2 289.9 142C298.6 165 313.7 185.1 333.3 199.9 357.7 220.1 384.1 235.9 398 276.5 386.8 255.2 369.9 237.3 349.2 225 355.4 239.7 358.6 255.6 358.5 271.5 358.5 332.5 308.9 382 247.9 381.9 239.6 381.9 231.4 381 223.4 379.1 213.9 377.3 204.7 374.2 196 369.8 183.1 362 172 351.7 163.2 339.5L163 339.2 165 339.9C169.6 341.5 174.2 342.7 179 343.6 197.7 347.6 217.3 345.3 234.6 337 252.1 327.3 262.6 320.1 271.2 323H271.4C279.8 325.7 286.4 317.5 280.4 309 270 295.6 253 289 236.2 292 218.7 294.5 202.7 307 179.8 294.9 178.3 294.1 176.9 293.3 175.5 292.4 173.9 291.5 180.4 293.7 178.9 292.7 173.9 290.2 169.1 287.3 164.5 284.1 164.2 283.8 168 285.2 167.6 284.9 161.7 280.9 156.6 275.7 152.6 269.7 148.5 262.3 148.1 253.3 151.6 245.6 153.7 241.8 157 238.7 160.9 236.9 163.9 238.4 165.7 239.5 165.7 239.5S164.4 237 163.6 235.7C163.9 235.6 164.1 235.7 164.4 235.5 167 236.6 172.7 239.5 175.8 241.3 177.9 242.4 179.6 244 181 246 181 246 182 245.5 181.3 243.3 180.2 240.6 178.4 238.3 175.9 236.7H176.1C178.4 237.9 180.6 239.3 182.7 240.8 184.6 236.4 185.5 231.6 185.3 226.8 185.5 224.2 185.1 221.5 184.2 219 183.4 217.4 184.7 216.8 186.1 218.5 185.9 217.2 185.4 216 184.9 214.8V214.7S185.7 213.6 186.1 213.2C187.1 212.2 188.2 211.3 189.5 210.5 196.7 206 204.3 202.1 212.2 198.9 218.6 196.1 223.9 194 225 193.3 226.6 192.3 228.1 191.1 229.5 189.8 234.8 185.3 238.5 179 239.7 172.1 239.8 171.2 239.9 170.3 240 169.3V167.8C239.1 164.3 233.1 161.7 201.6 158.7 190.5 156.9 181.6 148.6 179.1 137.6V137.7C178.7 138.8 178.2 140 177.8 141.2 178.2 140 178.6 138.9 179.1 137.7V137.5C185.1 121.8 195.9 108.4 209.9 99.2 210.7 98.5 206.7 99.4 207.5 98.7 210.2 97.4 212.9 96.2 215.7 95.2 217.1 94.6 209.7 91.8 203.1 92.5 199.1 92.7 195.1 93.7 191.4 95.3 193 94 197.6 92.2 196.5 92.2 188.1 93.8 180 96.9 172.6 101.2 172.6 100.4 172.7 99.7 173.1 99 167.2 101.5 162.1 105.5 158.1 110.5 158.2 109.6 158.3 108.7 158.3 107.8 155.6 109.8 153.1 112.1 151 114.7L150.9 114.8C133.5 108.1 114.6 106.5 96.3 110.1L96.1 110H96.3C92.5 106.9 89.2 103.3 86.6 99.1L86.4 99.2 86 99C84.8 97.2 83.6 95.2 82.3 93 81.4 91.4 80.5 89.6 79.6 87.8 79.6 87.7 79.5 87.6 79.4 87.6 79 87.6 78.8 89.3 78.5 88.9V88.8C75.3 80.5 73.8 71.6 74.1 62.6L73.9 62.7C68.8 66.2 64.9 71.3 62.8 77.2 61.9 79.3 61.2 80.5 60.6 81.7V81.2C60.7 80.1 61.2 77.9 61.1 78.1 61 78.3 60.9 78.4 60.8 78.5 59.3 80.2 57.9 82.2 56.9 84.3 56 86.2 55.2 88.2 54.6 90.2 54.5 90.5 54.6 89.9 54.6 89.2S54.7 87.2 54.6 87.5L54.3 88.2C47.6 103.1 43.4 119 41.9 135.3 41.5 138.1 41.3 140.9 41.4 143.6V143.8C36.6 149 32.4 154.8 28.7 160.9 16.6 181.3 7.6 203.4 1.9 226.5 5.9 217.7 10.7 209.3 16.2 201.4 5.5 228.5 0 257.4 0 286.6 1.8 278 4.2 269.6 7 261.3 5.3 295.8 11.9 330.2 26.4 361.6 45.8 405.1 78 441.6 118.7 466.3 135.3 477.5 153.4 486.2 172.5 492.1 175 493 177.6 493.9 180.2 494.8 179.4 494.5 178.6 494.1 177.8 493.8 200.4 500.6 224 504.1 247.6 504.1 331.3 504.1 358.9 472.2 361.4 469.1 365.5 465.4 368.9 460.9 371.3 455.8 372.9 455.1 374.5 454.4 376.2 453.7L377.2 453.2 379.1 452.3C391.7 446.4 403.6 438.9 414.4 430.2 430.7 418.5 442.3 401.5 447.3 382.1 450.3 375 450.4 367.1 447.7 359.9 448.6 358.5 449.4 357.1 450.4 355.6 468.4 326.7 478.6 293.7 480 259.7V256.9C480 249.6 479.4 242.4 478.1 235.3z"}]}}),H.register({"brands/first-order":{width:448,height:512,paths:[{d:"M12.9 229.2C13 229.1 13.1 228.9 13.2 228.8 13.2 228.9 13.2 229.1 13.1 229.2H12.9zM224 96.6C216.9 96.6 209.4 97.2 202.6 98.3L206.3 165.7 184.3 101.7C170 105.4 156.6 111.1 144.3 118.3L173.7 179.7 128.6 128.8C117.2 137.7 106.9 147.9 98 159.7L148.6 205.1 87.5 175.4C80.4 187.7 74.6 201.1 70.9 215.4L135.2 238 67.2 234C66.3 241.1 65.8 248.6 65.8 256S66.4 270.6 67.2 277.7L134.9 273.7 70.9 296.3C74.6 310.6 80.3 324 87.5 336.6L148.6 306.9 97.7 352C106.6 363.7 116.8 374.3 128.6 382.9L173.5 332 144 393.4C156.3 400.8 169.7 406.5 184 410.3L206.3 345.7 202.3 413.7C209.4 414.8 216.9 415.4 224 415.4 231.4 415.4 238.6 414.8 245.7 413.7L241.7 345.1 264.3 410.2C278.6 406.2 292 400.8 304.3 393.3L274.9 332 319.8 382.9C331.5 374 341.8 363.8 350.4 352L299.8 306.9 360.9 336.3C368 324 373.8 310.6 377.5 296L313.5 273.7 380.9 277.7C382 270.6 382.3 263.4 382.3 256S382 241.1 380.9 234L313.2 238 377.2 215.7C373.5 201.4 368.1 187.7 360.6 175.4L299.7 205.1 350.3 159.7C341.4 148 331.2 137.7 319.7 128.8L274.6 179.7 304 118.6C291.7 111.2 278.3 105.5 264 101.7L241.7 166 245.7 98.3C238.6 97.1 231.4 96.6 224 96.6zM443.4 128V384L224 512 4.6 384V128L224 0 443.4 128zM426.3 138.3L224 20.9 21.7 138.3V373.4L224 491.1 426.3 373.4V138.3zM224 37.1L411.7 146.5V365.4L224 474.9 36.3 365.4V146.6L224 37.1zM224 88C131.7 88 57.1 163.1 57.1 256 57.1 348.6 131.7 423.7 224 423.7 316 423.7 390.9 348.6 390.9 256 390.9 163.1 316 88 224 88z"}]}}),H.register({"brands/firstdraft":{width:384,height:512,paths:[{d:"M384 192H320V320H192V448H0V422.4H166.4V294.4H294.4V166.4H384V192zM358.4 230.4V358.4H230.4V486.4H64V512H256V384H384V230.4H358.4zM384 422.4H294.4V512H320V448H384V422.4zM0 0V384H128V256H256V128H384V0H0z"}]}}),H.register({"brands/flickr":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM144.5 319C109.4 319 81 290.6 81 255.5S109.4 192 144.5 192 208 220.4 208 255.5 179.6 319 144.5 319zM303.5 319C268.4 319 240 290.6 240 255.5S268.4 192 303.5 192 367 220.4 367 255.5 338.6 319 303.5 319z"}]}}),H.register({"brands/flipboard":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM358.4 211.2H268.8V300.8H179.2V390.4H89.6V121.6H358.4V211.2z"}]}}),H.register({"brands/fly":{width:384,height:512,paths:[{d:"M197.8 427.8C210.7 439.5 231.5 461.1 231 478.5 231 479.3 230.9 480.1 230.9 481 229.1 500.8 212.1 512.1 191.8 512 166.8 511.9 151.9 495.2 153.1 476.2 154.1 460 173.6 439.5 185.5 428.6 187.8 426.5 188.2 425.9 191.1 425 194.5 425 195 425.3 197.8 427.8zM331.9 67.3C315.6 41.6 293.3 26.7 268.6 15.2 243.1 4.5 214-0.2 192 0 147.9 0 120.8 13.2 110.9 17.3 57.3 45.2 26.5 87.2 28 158.6 35.1 240.8 125 334.6 183.8 392.4 185.5 394 188.3 396.9 190 397.5L193.3 397.6C195.4 396.9 195.1 397.1 196.8 395.5 249.1 346.3 337.5 249.7 352.7 179.8 359.7 140.6 355.8 107.3 331.9 67.3zM186.8 351.9C158.8 300.8 121.6 221.2 117.5 162.9 114.1 115.4 128.9 31.7 186.8 26.2V351.9zM328.7 180C312.3 236.8 251.4 308 209.8 350.3 237.6 298.4 275 217 277 158.4 278.6 112.5 267.2 52.6 229 27 317.8 45.3 344.5 125.1 328.7 180z"}]}}),H.register({"brands/font-awesome-alt":{width:448,height:512,paths:[{d:"M397.8 67.8C405.6 67.8 412.1 74.4 412.1 82.1V429.7C412.1 437.5 405.5 444 397.8 444H50.2C42.4 444 35.9 437.4 35.9 429.7V82.2C35.9 74.4 42.5 67.9 50.2 67.9H397.8M397.8 32H50.2C22.7 32 0 54.7 0 82.2V429.8C0 457.3 22.7 480 50.2 480H397.8C425.3 480 448 457.3 448 429.8V82.2C448 54.7 425.3 32 397.8 32zM339.3 171.2C333.3 171.2 309.4 186.7 286.7 186.7 282.5 186.7 278.3 186.1 274.2 184.3 254.5 176.5 237.2 170.6 215.1 170.6 194.8 170.6 173.3 177.2 155.4 184.3 153.6 184.9 151.8 185.5 150.6 186.1V168.2C158.4 162.2 163.1 153.3 163.1 142.5 163.1 124.6 148.8 110.2 130.8 110.2S98.5 124.5 98.5 142.5C98.5 152.7 103.3 162.2 111 168.2V380.3C111 391.1 120 400 130.7 400 139.7 400 146.8 394 149.2 386.3V385C149.8 383.2 149.8 382 149.8 380.2V336C151 336 152.2 335.4 152.8 334.8 172.5 326.4 195.8 318.1 218.5 318.1 249.6 318.1 261.5 334.2 287.8 334.2 306.3 334.2 324.2 327.6 339.8 320.5 344 318.7 347 316.9 347 312.7V178.3C348.8 174.2 344.7 171.2 339.3 171.2z"}]}}),H.register({"brands/font-awesome-flag":{width:448,height:512,paths:[{d:"M444.4 359.4C444.4 366.6 438.2 369.7 431.1 372.7 402.4 385 371.7 396.3 338.9 396.3 292.8 396.3 271.3 367.6 216 367.6 176.1 367.6 134.1 382 100.3 397.3 98.3 398.3 96.2 398.3 94.2 399.4V477.2C94.2 498.6 78 512 60.4 512 40.9 512 25.6 496.6 25.6 477.2V102.4C12.2 92.2 3 75.8 3 57.3 3 25.6 28.6 0 60.4 0S117.7 25.6 117.7 57.3C117.7 75.8 109.5 92.2 95.2 102.4V134.1C99.3 132.8 154 105.5 209.9 105.5 275.1 105.5 307.6 133.1 336.9 133.1 375.8 133.1 418.8 105.5 429 105.5 437.2 105.5 444.4 111.6 444.4 118.8V359.4z"}]}}),H.register({"brands/font-awesome":{width:448,height:512,paths:[{d:"M397.8 32H50.2C22.7 32 0 54.7 0 82.2V429.8C0 457.3 22.7 480 50.2 480H397.8C425.3 480 448 457.3 448 429.8V82.2C448 54.7 425.3 32 397.8 32zM352.4 316.3C352.4 320.5 348.8 322.3 344.6 324.1 327.9 331.3 310 337.8 290.8 337.8 263.9 337.8 251.4 321.1 219.1 321.1 195.8 321.1 171.3 329.5 151.6 338.4 150.4 339 149.2 339 148 339.6V385C148 386.8 148 388.6 147.4 389.8V391C145 399.4 137.2 405.3 128.3 405.3 117 405.3 108 396.3 108 385V166.4C100.2 160.4 94.9 150.9 94.9 140.1 94.9 121.6 109.8 106.6 128.4 106.6 146.9 106.6 161.9 121.5 161.9 140.1 161.9 150.9 157.1 160.4 148.8 166.4V184.9C150.6 184.3 152.4 183.7 154.2 182.5 172.7 174.7 194.8 168.2 215.7 168.2 238.4 168.2 256.3 174.2 276.6 181.9 280.8 183.7 285 184.3 289.7 184.3 312.4 184.3 337.5 168.2 343.5 168.2 348.3 168.2 352.5 171.8 352.5 176V316.3z"}]}}),H.register({"brands/fonticons-fi":{width:384,height:512,paths:[{d:"M114.4 224H206.8L191.6 275.2H115.2V433C115.2 441 112.4 442.2 119.6 443L179.2 448.6V483H0V447.8L29.2 445C36.4 444.2 38.4 441.8 38.4 434.2V278.4C38.4 275.2 34.4 275.2 30.4 275.2H0V224H38.4V195.2C38.4 127.2 74.8 99.2 144.4 99.2 191.2 99.2 233.2 110.4 233.2 171.6L163.6 180C164 154.4 157.6 148.4 141.2 148.4 116 148.4 115.2 162 115.2 186V218C115.2 221.2 110.4 224 114.4 224zM384 483H243.2V448.6L271.2 445C278.4 444.2 281.6 442.6 281.6 435V287C281.6 281.4 277.6 277.8 272.4 276.2L239.2 267.4 248.4 227H358.4V435C358.4 443 354.8 443.8 362.4 445L384 448.6V483zM354 135.8L366.4 181.4 356.4 191.4 313.6 168.6 270.8 191.4 260.8 181.4 273.2 135.8 243.2 99.4 248 89.4H286L307.2 51H320L341.2 89.4H379.2L384 102.6 354 135.8z"}]}}),H.register({"brands/fonticons":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM167.4 228H234.8L223.7 265.3H168V378.2C168 384 166 384.9 171.2 385.5L214.7 389.6V414.7H84V389L105.3 387C110.5 386.4 112 384.7 112 379.1V267.7C112 265.4 109.1 265.4 106.2 265.4H84V228H112V207C112 157.4 138.5 137 189.3 137 223.4 137 254 145.2 254 189.8L203.3 195.9C203.6 177.2 198.9 172.9 187 172.9 168.6 172.9 168 182.8 168 200.3V223.6C168 226 164.5 228 167.4 228zM364 414.7H261.3V389.6L281.7 387C286.9 386.4 289.3 385.3 289.3 379.7V271.8C289.3 267.7 286.4 265.1 282.6 263.9L258.4 257.5 265.1 228H345.3V379.7C345.3 385.5 342.7 386.1 348.2 387L363.9 389.6V414.7zM342.1 159.2L351.1 192.4 343.8 199.7 312.6 183.1 281.4 199.7 274.1 192.4 283.1 159.2 261.3 135 264.8 125.4H292.5L308 97.4H317.3L332.8 125.4H360.5L364 135 342.1 159.2z"}]}}),H.register({"brands/fort-awesome-alt":{width:512,height:512,paths:[{d:"M211.7 241.1V292.8C211.7 294.9 210.1 296.5 208 296.5H185.8C183.7 296.5 182.1 294.9 182.1 292.8V241.1C182.1 239 183.7 237.4 185.8 237.4H208C210.1 237.4 211.7 239 211.7 241.1zM326.2 237.4H304C301.9 237.4 300.3 239 300.3 241.1V292.8C300.3 294.9 301.9 296.5 304 296.5H326.2C328.3 296.5 329.9 294.9 329.9 292.8V241.1C329.8 239 328.2 237.4 326.2 237.4zM297.1 500.6C296.2 500.7 295.4 500.9 294.5 501 293.5 501.2 292.4 501.3 291.4 501.5 290.5 501.6 289.6 501.8 288.6 501.9 287.6 502 286.6 502.2 285.6 502.3 284.6 502.4 283.6 502.5 282.7 502.6 281.7 502.7 280.8 502.8 279.8 502.9 278.8 503 277.7 503.1 276.7 503.2 275.8 503.3 274.9 503.4 274 503.4 272.9 503.5 271.7 503.5 270.6 503.6 269.8 503.6 268.9 503.7 268.1 503.7 266.8 503.8 265.5 503.8 264.2 503.8 263.5 503.8 262.8 503.9 262.1 503.9 260.1 503.9 258.1 504 256.1 504S252.1 504 250.1 503.9C249.4 503.9 248.7 503.9 248 503.8 246.7 503.8 245.4 503.7 244.1 503.7 243.3 503.7 242.4 503.6 241.6 503.6 240.5 503.5 239.3 503.5 238.2 503.4 237.3 503.3 236.4 503.3 235.5 503.2 234.5 503.1 233.4 503 232.4 502.9 231.4 502.8 230.5 502.7 229.5 502.6 228.5 502.5 227.5 502.4 226.6 502.3 225.6 502.2 224.6 502.1 223.6 501.9 222.7 501.8 221.8 501.6 220.8 501.5 219.8 501.4 218.7 501.2 217.7 501 216.8 500.9 216 500.7 215.1 500.6 149.5 489.7 92.6 452.9 55.1 401.2 54.9 401 54.8 400.7 54.6 400.5 53.8 399.4 53 398.3 52.3 397.2 52 396.8 51.7 396.4 51.5 396 50.8 394.9 50.1 393.9 49.4 392.8 49.1 392.3 48.8 391.9 48.5 391.4 47.8 390.3 47.1 389.3 46.5 388.2 46.2 387.7 45.9 387.3 45.6 386.8 44.9 385.7 44.3 384.6 43.6 383.5 43.4 383.1 43.1 382.7 42.9 382.3 40.5 378.3 38.3 374.2 36.1 370.1 36 369.9 35.9 369.8 35.8 369.6 35.2 368.5 34.7 367.4 34.1 366.3 33.8 365.7 33.5 365.2 33.3 364.6 32.8 363.6 32.3 362.5 31.8 361.5 31.5 360.8 31.2 360.2 30.9 359.5 30.4 358.5 30 357.5 29.5 356.5L28.6 354.4C28.2 353.4 27.7 352.4 27.3 351.4 27 350.7 26.7 349.9 26.4 349.2L25.2 346.2C24.9 345.4 24.6 344.7 24.3 343.9 23.9 342.9 23.5 341.9 23.2 340.9 22.9 340 22.6 339.1 22.2 338.1 21.6 336.5 21.1 334.8 20.5 333.2 20.2 332.3 19.9 331.4 19.6 330.4 19.3 329.5 19.1 328.6 18.8 327.7 18.5 326.8 18.2 325.8 18 324.9 17.7 324 17.5 323.1 17.2 322.2 16.9 321.2 16.7 320.3 16.4 319.3 16.2 318.4 15.9 317.5 15.7 316.6 15.4 315.6 15.2 314.6 15 313.6 14.8 312.7 14.6 311.9 14.4 311 14.2 309.9 13.9 308.8 13.7 307.8 13.5 307 13.4 306.2 13.2 305.4 12.9 304.1 12.7 302.7 12.4 301.4 12.3 300.8 12.2 300.3 12.1 299.7L11.2 294C11.1 293.4 11 292.7 10.9 292.1 10.7 290.8 10.5 289.5 10.4 288.2 10.3 287.4 10.2 286.7 10.1 285.9 10 284.7 9.8 283.5 9.7 282.3 9.6 281.5 9.5 280.7 9.5 279.9 9.4 278.7 9.3 277.5 9.2 276.4 9.1 275.6 9.1 274.8 9 274 8.9 272.8 8.8 271.6 8.8 270.3 8.8 269.5 8.7 268.8 8.7 268 8.6 266.7 8.6 265.3 8.5 264 8.5 263.3 8.5 262.7 8.4 262 8.4 260 8.3 258 8.3 256 8.3 202.5 25.2 153 54.1 112.4 56.4 109.2 58.8 106 61.2 102.9 66.1 96.7 71.3 90.6 76.8 84.9 79.5 82 82.3 79.2 85.2 76.5 88.1 73.8 91 71.1 94 68.5 98.5 64.6 103.1 60.9 107.9 57.3 109.5 56.1 111.1 54.9 112.7 53.8 140 34.2 171.7 20.1 206 13 222.1 9.7 238.9 8 256 8S289.8 9.7 306 13C340.3 20 372 34.1 399.6 53.7 401.2 54.9 402.8 56 404.4 57.2 409.2 60.8 413.8 64.5 418.3 68.4 430.3 78.8 441.3 90.3 451.1 102.8 453.6 105.9 455.9 109.1 458.2 112.3 487.1 153 504 202.5 504 256 504 258 504 260 503.9 262 503.9 262.7 503.9 263.3 503.8 264 503.8 265.3 503.7 266.7 503.6 268 503.6 268.8 503.5 269.5 503.5 270.3 503.4 271.5 503.4 272.7 503.3 271 503.2 271.8 503.2 272.6 503.1 273.4 503 274.6 502.9 275.8 502.8 276.9 502.7 277.7 502.6 278.5 502.6 279.3 502.5 280.5 502.3 281.7 502.2 282.9 502.1 283.7 502 284.4 501.9 285.2 501.7 286.5 501.5 287.8 501.4 289.1 501.3 289.7 501.2 290.4 501.1 291L500.2 296.7C500.1 297.3 500 297.8 499.9 298.4 499.7 299.7 499.4 301.1 499.1 302.4 498.9 303.2 498.8 304 498.6 304.8 498.4 305.9 498.1 307 497.9 308 497.7 308.9 497.5 309.7 497.3 310.6 497.1 311.6 496.8 312.6 496.6 313.6 496.4 314.5 496.1 315.4 495.9 316.3 495.6 317.3 495.4 318.2 495.1 319.2 494.9 320.1 494.6 321 494.3 321.9 494 322.8 493.7 323.8 493.5 324.7 493.2 325.6 493 326.5 492.7 327.4 492.4 328.3 492.1 329.2 491.8 330.2 491.3 331.8 490.7 333.5 490.1 335.1 489.8 336 489.5 336.9 489.1 337.9 488.7 338.9 488.4 339.9 488 340.9 487.7 341.7 487.4 342.4 487.1 343.2L485.9 346.2C485.6 346.9 485.3 347.7 485 348.4 484.6 349.4 484.2 350.4 483.7 351.4L482.8 353.5C482.4 354.5 481.9 355.5 481.4 356.5 481.1 357.2 480.8 357.8 480.5 358.5 480 359.5 479.5 360.6 479 361.6 478.7 362.2 478.4 362.7 478.2 363.3 477.6 364.4 477.1 365.5 476.5 366.6 476.4 366.8 476.3 366.9 476.2 367.1 474 371.2 471.8 375.3 469.4 379.3 469.2 379.7 468.9 380.1 468.7 380.5 468 381.6 467.4 382.7 466.7 383.8 466.4 384.3 466.1 384.7 465.8 385.2 465.1 386.3 464.4 387.3 463.8 388.4 463.5 388.9 463.2 389.3 462.9 389.8 462.2 390.9 461.5 391.9 460.8 393 460.5 393.4 460.2 393.8 460 394.2 459.2 395.3 458.5 396.4 457.7 397.5 457.5 397.7 457.4 398 457.2 398.2 419.6 452.9 362.7 489.6 297.1 500.6zM414.4 414.4C427.4 401.4 438.6 387 448 371.5V300.2C448 298.1 446.4 296.5 444.3 296.5H422.1C420 296.5 418.4 298.1 418.4 300.2V326H388.9V182C388.9 179.9 387.3 178.3 385.2 178.3H363.1C361 178.3 359.4 179.9 359.4 182V207.9H329.9V182C329.9 179.9 328.3 178.3 326.2 178.3H304C301.9 178.3 300.3 179.9 300.3 182V207.9H270.8V182C270.8 177.2 264.3 178.3 261.3 178.3V147.6C268 146 275.1 144.8 282.1 144.8 290.9 144.8 298.9 148.3 307.5 148.3 311.2 148.3 329.9 147.4 329.9 141.8V93.4C329.9 91.3 328.3 89.7 326.2 89.7 322 89.7 314 93.2 306.8 93.2 298.9 93.2 289.9 89.7 280.5 89.7 274 89.7 267.6 90.6 261.3 92V88.1C265.7 86 268.7 81.4 268.7 76.6 268.7 59.8 243.3 59.8 243.3 76.6 243.3 81.4 246.3 86.1 250.7 88.1V178.3C247.7 178.3 241.2 177.2 241.2 182V207.9H211.7V182C211.7 179.9 210.1 178.3 208 178.3H185.8C183.7 178.3 182.1 179.9 182.1 182V207.9H152.6V182C152.6 179.9 151 178.3 148.9 178.3H126.8C124.7 178.3 123.1 179.9 123.1 182V326H93.5V300.2C93.5 298.1 91.9 296.5 89.8 296.5H67.7C65.6 296.5 64 298.1 64 300.2V371.5C73.4 387 84.6 401.4 97.6 414.4 118.2 435 142.1 451.1 168.8 462.4 182.7 468.3 197 472.7 211.7 475.6V399.8C211.7 341.2 300.3 341.2 300.3 399.8V475.6C315 472.7 329.3 468.2 343.2 462.4 369.9 451.1 393.8 435 414.4 414.4"}]}}),H.register({"brands/fort-awesome":{width:512,height:512,paths:[{d:"M489.2 287.9H461.8C459.2 287.9 457.2 289.9 457.2 292.5V324.5H420.6V146.2C420.6 143.6 418.6 141.6 416 141.6H388.6C386 141.6 384 143.6 384 146.2V178.2H347.4V146.2C347.4 143.6 345.4 141.6 342.8 141.6H315.4C312.8 141.6 310.8 143.6 310.8 146.2V178.2H274.2V146.2C274.2 140.2 266.2 141.6 262.5 141.6V103.6C270.8 101.6 279.6 100.2 288.2 100.2 299.1 100.2 309.1 104.5 319.6 104.5 324.2 104.5 347.3 103.4 347.3 96.5V36.5C347.3 33.9 345.3 31.9 342.7 31.9 337.6 31.9 327.6 36.2 318.7 36.2 309 36.2 297.8 31.9 286.1 31.9 278.1 31.9 270.1 33 262.4 34.8V29.9C267.8 27.3 271.5 21.6 271.5 15.6 271.5-5.1 240.1-5.2 240.1 15.6 240.1 21.6 243.8 27.3 249.2 29.9V141.6C245.5 141.6 237.5 140.2 237.5 146.2V178.2H200.9V146.2C200.9 143.6 198.9 141.6 196.3 141.6H168.9C166.3 141.6 164.3 143.6 164.3 146.2V178.2H128V146.2C128 143.6 126 141.6 123.4 141.6H96C93.4 141.6 91.4 143.6 91.4 146.2V324.5H54.8V292.5C54.8 289.9 52.8 287.9 50.2 287.9H22.8C20.2 287.9 18.2 289.9 18.2 292.5V512H201.1V416C201.1 343.4 310.8 343.4 310.8 416V512H493.7V292.5C493.8 289.9 491.8 287.9 489.2 287.9zM201.1 283.4C201.1 286 199.1 288 196.5 288H169.1C166.5 288 164.5 286 164.5 283.4V219.4C164.5 216.8 166.5 214.8 169.1 214.8H196.5C199.1 214.8 201.1 216.8 201.1 219.4V283.4zM347.5 283.4C347.5 286 345.5 288 342.9 288H315.5C312.9 288 310.9 286 310.9 283.4V219.4C310.9 216.8 312.9 214.8 315.5 214.8H342.9C345.5 214.8 347.5 216.8 347.5 219.4V283.4z"}]}}),H.register({"brands/forumbee":{width:448,height:512,paths:[{d:"M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35 239.7 35 256.4 37 272.4 40.5 149 87.5 51.9 186 5.8 309.7zM398.7 120.5C385 103 369 87.8 350.9 75.2 201.3 119.5 84.6 237.3 41.2 387.2 53.7 405.3 69.2 422.8 86.4 436.2 129.5 284.9 247.6 164.5 398.7 120.5zM414.5 373.2C429.7 348.1 439.9 319.5 444 290.4 364.6 333.3 299 401 256.4 480.7 286.4 476.3 315.3 465.4 341 449.4 376 462.5 411.9 473.7 448 483 438.7 446.5 427.6 408.5 414.5 373.2zM444.2 227.7C441.6 208.2 436.3 189 428.4 170.9 290.5 216.7 182 327.5 137.1 466 155.2 473.6 174.1 478.5 193.7 481.2 240 367.1 330.5 274.4 444.2 227.7z"}]}}),H.register({"brands/foursquare":{width:368,height:512,paths:[{d:"M323.1 3H49.9C12.4 3 0 31.3 0 49.1V482.9C0 503.2 12.1 510.6 18.2 513 24.4 515.5 41 517.6 51.1 505.9 180 356.5 182.2 354 182.2 354 185.3 350.6 185.6 350.9 189 350.9H272.4C307.5 350.9 313 325.7 316.7 311.2L365.3 68.2C373.8 25.8 363.1 3 323.1 3zM306.8 76.8L295.4 136.5C294.2 143 285.9 149.7 278.5 149.7H172.1C160.1 149.7 151.5 158 151.5 170V183C151.5 195 160.1 203.6 172.1 203.6H262.5C270.8 203.6 279.1 212.8 277.3 221.8 275.5 230.7 266.8 275.6 265.9 280.6 265 285.5 259.1 294.1 249 294.1H175.5C162 294.1 158.3 295.9 149 306.7 149 306.7 140.1 318.1 59.5 415 58.6 415.9 57.7 415.6 57.7 414.7V75.9C57.7 68.2 64.5 59.3 74.3 59.3H293.3C301.5 59.3 308.9 67 306.8 76.8z"}]}}),H.register({"brands/free-code-camp":{width:576,height:512,paths:[{d:"M69.3 144.5C28.3 213 32.9 307.5 70.3 371.5 92.5 409.7 120 423.9 120 438 120 444.8 114 451 107.2 451 87.7 451 8 375.5 8 253.2 8 141.7 86 67.2 105.1 67.2 111.1 67.2 120 72 120 78.3 120 91 91.7 106.9 69.3 144.5zM265.1 358.3C269.6 360.1 277.4 363.5 277.4 357.1 277.4 354.4 275.2 354.2 273.1 353.5 264.6 350.1 259.1 345.8 254 338.3 245.8 326.2 243.9 314.1 243.9 299.7 243.9 267.6 288.1 261.8 288.1 229.7 288.1 217.4 280.4 213.8 280.4 210.4 280.4 208.2 281.1 208.2 283.3 208.2 291.3 208.2 302.4 221.5 305.8 228 308 232.6 308.2 234 308.2 239.1 308.2 246.1 307.5 253.3 307.5 260.4 307.5 287.4 339.4 280.2 339.4 267.2 339.4 261.2 335.8 255.6 335.8 249.8 335.8 249.1 335.8 248.6 336.5 248.6 339.9 248.6 345.9 256.3 347.6 258.7 353.4 267.6 356.1 279.5 356.1 290.1 356.1 322.5 326.6 339.1 326.6 346.1 326.6 347.1 329.5 353.8 338.7 348 368.4 332.9 391.8 300.4 391.8 258.2 391.8 224.6 383.1 200.5 359.7 175.6 355.8 171.5 343.3 158.7 337.2 158.7 329 158.7 344.4 177.3 344.4 189.9 344.4 197.1 339.6 202.2 332.1 202.2 320.5 202.2 317.6 176.8 316.2 168.9 310.4 135.1 303.4 110.7 269.8 94.8 259.4 89.8 233.3 83 233.3 92.6 233.3 95 236 96.7 237.9 97.7 247.1 103.3 257.5 119.1 257.5 135.9 257.5 182 199.8 224.1 199.8 272.1 199.6 312.4 227.9 344.7 265.1 358.3zM470.4 67C464.4 67 456 73.5 456 79.6 456 88.3 468.1 99.2 473.6 105 555.2 190.1 552.2 319.3 491.2 396 484.2 404.9 455.9 431.3 455.9 439.5 455.9 444.6 464.1 450.9 469.1 450.9 494.5 450.9 567.9 370.1 567.9 265.2 568 145.9 491.8 67 470.4 67zM428.1 390.1H167C157.6 390.1 151.5 397.6 151.5 406.5 151.5 415 158.5 422 167 422H428.1C437.5 422 440 414.5 440 405.6 440 397.1 436.5 390.1 428.1 390.1z"}]}}),H.register({"brands/freebsd":{width:448,height:512,paths:[{d:"M303.7 96.2C314.8 85.1 419.2 19.2 442.9 43 466.6 66.7 400.8 171.1 389.7 182.2 378.6 193.3 350.3 183.1 326.6 159.3 302.8 135.6 292.5 107.3 303.7 96.2zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1-11 57.7 12.7 110.5 33.5 146.8 52 114.6 78.3 87.5 109.9 68.1zM406.7 174C410 185.3 409.4 194.7 404 200.1 383.7 220.4 316.5 173.1 294.7 130 276.7 97.7 283.6 76.6 309.6 81.3 315.3 77.7 321.9 73.7 329.2 69.7 299.4 54.2 265.6 45.4 229.7 45.4 110.6 45.4 14.1 141.9 14.1 261 14.1 380 110.6 476.6 229.7 476.6S445.3 380.1 445.3 261C445.3 222.6 435.2 186.5 417.6 155.2 413.7 162.2 410 168.5 406.7 174z"}]}}),H.register({"brands/get-pocket":{width:448,height:512,paths:[{d:"M407.6 64H40.6C18.5 64 0 82.5 0 104.6V239.8C0 364.5 99.7 464 224.2 464 348.2 464 448 364.5 448 239.8V104.6C448 82.2 430.3 64 407.6 64zM245.6 332.5C233.2 344.3 214.2 343.6 203.2 332.5 89.5 223.6 88.3 227.4 88.3 209.3 88.3 192.4 102.1 178.6 119 178.6 136 178.6 135.1 182.4 224.2 267.9 314.8 181 312.8 178.6 329.7 178.6 346.6 178.6 360.4 192.4 360.4 209.3 360.4 227.1 357.5 225 245.6 332.5z"}]}}),H.register({"brands/gg-circle":{width:512,height:512,paths:[{d:"M257 8C120 8 9 119 9 256S120 504 257 504 505 393 505 256 394 8 257 8zM207.5 382.8L81.8 257.1 207.5 131.4 242.7 166.8 218.5 191 207.4 179.9 130.2 257.1 207.4 334.3 234 307.7 180.9 254.8 205.3 230.4 282.5 307.6 207.5 382.8zM306.5 380.6L271.3 345.4 295.4 321 306.5 332.1 383.7 254.9 306.5 177.7 280 204.2 333.1 257.1 308.7 281.5 231.5 204.3 306.5 129.3 432.2 255 306.5 380.6z"}]}}),H.register({"brands/gg":{width:512,height:512,paths:[{d:"M179.2 230.4L281.6 332.8 179.2 435.2 0 256 179.2 76.8 224 121.6 198.4 147.2 179.2 128 51.2 256 179.2 384 230.7 332.5 153.6 256 179.2 230.4zM332.8 76.8L230.4 179.2 332.8 281.6 358.4 256 281.3 179.5 332.8 128 460.8 256 332.8 384 313.6 364.8 288 390.4 332.8 435.2 512 256 332.8 76.8z"}]}}),H.register({"brands/git-square":{width:448,height:512,paths:[{d:"M140.1 348.5C152.2 348.5 169.6 350.6 169.6 366.4 169.6 381.9 155.7 385.2 142.6 385.2 130.3 385.2 111.7 383.2 111.7 367.2S127.4 348.5 140.1 348.5zM115.4 231.9C115.4 246.7 122 256 137.7 256 153.2 256 158.9 246 158.9 231.5 159 197.1 115.4 196.7 115.4 231.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM207 173.7C194.7 178.5 181.5 182.1 168.1 182.1 129.6 160 77.4 183 77.4 231.6 77.4 249.6 89 274.5 107 280.5V281.2C93.6 287.1 89.9 317.3 107.7 328.2V328.9C88.2 335.3 75.4 347.7 75.4 369.1 75.4 405.9 110.2 416.1 140.8 416.1 177.9 416.1 205.6 402.7 205.6 361.8 205.6 311.4 133.5 330 133.5 302.7 133.5 293.1 138.7 289.3 147.6 287.5 177.2 282 195.8 258.9 195.8 228.8 195.8 223.6 194.7 218.6 192.9 213.8 197.7 212.7 202.4 211.5 207 209.9V173.7zM263.8 175.5H224.2C225.5 186.1 225.3 318.1 224.2 331H263.8C262.7 318.2 262.6 185.9 263.8 175.5zM268.3 122.2C268.3 108.8 258.3 96 244.2 96 229.9 96 219.6 108.5 219.6 122.2 219.6 135.8 230.1 148.1 244.2 148.1 257.9 148.1 268.3 135.6 268.3 122.2zM372.6 175.5H336.2C336.2 165.7 335.8 155.9 337.3 146H296.8C298.1 153.3 297.9 159.6 297.9 175.5H280.8V209.4C292.7 207.5 292.9 208.7 297.9 208.7V209.4H297.5V272.1C297.5 303.2 302 333.3 340.2 333.3 350.9 333.3 363.2 331.5 372.7 326.3V291.3C367 295.2 358.8 297.2 351.8 297.2 338.6 297.2 336.3 284.3 336.3 273.8V208.6C359 208.6 372.7 209.3 372.7 209.3V175.5z"}]}}),H.register({"brands/git":{width:448,height:512,paths:[{d:"M18.8 221.7C18.8 247 35 281.7 60.3 290.2V291.2C41.5 299.5 36.3 341.8 61.3 357V358C34 367 16 384.3 16 414.2 16 465.7 64.8 480 107.5 480 159.5 480 198.2 461.3 198.2 404 198.2 333.5 97.2 359.5 97.2 321.2 97.2 307.7 104.4 302.5 116.9 299.9 158.4 292.2 184.4 259.9 184.4 217.7 184.4 210.4 182.9 203.5 180.4 196.7 187.1 195.2 193.6 193.4 200.1 191.2V140.7C182.9 147.5 164.4 152.5 145.6 152.5 91.8 121.5 18.8 153.8 18.8 221.7zM106.5 385.5C123.5 385.5 147.7 388.5 147.7 410.5 147.7 432.3 128.2 436.8 110 436.8 92.7 436.8 66.7 434.1 66.7 411.6 66.8 389.3 88.8 385.5 106.5 385.5zM103.3 256C81.3 256 72 243 72 222.2 72 172.9 133 173.4 133 221.7 133 242 125 256 103.3 256zM432 305.5V354.5C418.7 361.8 401.5 364.3 386.5 364.3 333 364.3 326.7 322.1 326.7 278.6V190.9H327.2V189.9C320.2 189.9 319.9 188.3 303.2 190.9V143.4H327.2C327.2 121.1 327.5 112.4 325.7 102.2H382.4C380.4 116 380.9 129.7 380.9 143.4H431.9V190.9S412.6 189.9 380.9 189.9V281C380.9 295.8 384.2 313.8 402.7 313.8 412.5 313.8 424 311 432 305.5zM286 68.7C286 87.4 271.5 104.9 252.2 104.9 232.4 104.9 217.7 87.7 217.7 68.7 217.7 49.4 232.2 32 252.2 32 272 32 286 50 286 68.7zM279.8 143.2C278 157.8 278.2 343 279.8 361H224.3C225.9 342.9 226.1 158 224.3 143.2H279.8z"}]}}),H.register({"brands/github-alt":{width:480,height:512,paths:[{d:"M186.1 328.7C186.1 349.6 175.2 383.8 149.4 383.8S112.7 349.6 112.7 328.7 123.6 273.6 149.4 273.6 186.1 307.8 186.1 328.7zM480 278.2C480 310.1 476.8 343.9 462.5 373.2 424.6 449.8 320.4 448 245.8 448 170 448 59.6 450.7 20.2 373.2 5.6 344.2 0 310.1 0 278.2 0 236.3 13.9 196.7 41.5 164.6 36.3 148.8 33.8 132.2 33.8 115.8 33.8 94.3 38.7 83.5 48.4 64 93.7 64 122.7 73 157.2 100 186.2 93.1 216 90 245.9 90 272.9 90 300.1 92.9 326.3 99.2 360.3 72.5 389.3 64 434.1 64 443.9 83.5 448.7 94.3 448.7 115.8 448.7 132.2 446.1 148.5 441 164 468.5 196.4 480 236.3 480 278.2zM415.7 328.7C415.7 284.8 389 246.1 342.2 246.1 323.3 246.1 305.2 249.5 286.2 252.1 271.3 254.4 256.4 255.3 241.1 255.3 225.9 255.3 211 254.4 196 252.1 177.3 249.5 159 246.1 140 246.1 93.2 246.1 66.5 284.8 66.5 328.7 66.5 416.5 146.9 430 216.9 430H265.1C335.4 430 415.7 416.6 415.7 328.7zM333.1 273.6C307.3 273.6 296.4 307.8 296.4 328.7S307.3 383.8 333.1 383.8 369.8 349.6 369.8 328.7 358.9 273.6 333.1 273.6z"}]}}),H.register({"brands/github-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM277.3 415.7C268.9 417.2 265.8 412 265.8 407.7 265.8 402.3 266 374.7 266 352.4 266 336.8 260.8 326.9 254.7 321.7 291.7 317.6 330.7 312.5 330.7 248.6 330.7 230.4 324.2 221.3 313.6 209.6 315.3 205.3 321 187.6 311.9 164.6 298 160.3 266.2 182.5 266.2 182.5 253 178.8 238.7 176.9 224.6 176.9 210.5 176.9 196.2 178.8 183 182.5 183 182.5 151.2 160.3 137.3 164.6 128.2 187.5 133.8 205.2 135.6 209.6 125 221.3 120 230.4 120 248.6 120 312.2 157.3 317.6 194.3 321.7 189.5 326 185.2 333.4 183.7 344 174.2 348.3 149.9 355.7 135.4 330.1 126.3 314.3 109.9 313 109.9 313 93.7 312.8 108.8 323.2 108.8 323.2 119.6 328.2 127.2 347.4 127.2 347.4 136.9 377.1 183.3 367.1 183.3 367.1 183.3 381 183.5 403.6 183.5 407.7 183.5 412 180.5 417.2 172 415.7 106 393.6 59.8 330.8 59.8 257.4 59.8 165.6 130 95.9 221.8 95.9S388 165.6 388 257.4C388.1 330.8 343.3 393.7 277.3 415.7zM179.2 354.6C177.3 355 175.5 354.2 175.3 352.9 175.1 351.4 176.4 350.1 178.3 349.7 180.2 349.5 182 350.3 182.2 351.6 182.5 352.9 181.2 354.2 179.2 354.6zM169.7 353.7C169.7 355 168.2 356.1 166.2 356.1 164 356.3 162.5 355.2 162.5 353.7 162.5 352.4 164 351.3 166 351.3 167.9 351.1 169.7 352.2 169.7 353.7zM156 352.6C155.6 353.9 153.6 354.5 151.9 353.9 150 353.5 148.7 352 149.1 350.7 149.5 349.4 151.5 348.8 153.2 349.2 155.2 349.8 156.5 351.3 156 352.6zM143.7 347.2C142.8 348.3 140.9 348.1 139.4 346.6 137.9 345.3 137.5 343.4 138.5 342.5 139.4 341.4 141.3 341.6 142.8 343.1 144.1 344.4 144.6 346.4 143.7 347.2zM134.6 338.1C133.7 338.7 132 338.1 130.9 336.6S129.8 333.4 130.9 332.7C132 331.8 133.7 332.5 134.6 334 135.7 335.5 135.7 337.3 134.6 338.1zM128.1 328.4C127.2 329.3 125.7 328.8 124.6 327.8 123.5 326.5 123.3 325 124.2 324.3 125.1 323.4 126.6 323.9 127.7 324.9 128.8 326.2 129 327.7 128.1 328.4zM121.4 321C121 321.9 119.7 322.1 118.6 321.4 117.3 320.8 116.7 319.7 117.1 318.8 117.5 318.2 118.6 317.9 119.9 318.4 121.2 319.1 121.8 320.2 121.4 321z"}]}}),H.register({"brands/github":{width:496,height:512,paths:[{d:"M165.9 397.4C165.9 399.4 163.6 401 160.7 401 157.4 401.3 155.1 399.7 155.1 397.4 155.1 395.4 157.4 393.8 160.3 393.8 163.3 393.5 165.9 395.1 165.9 397.4zM134.8 392.9C134.1 394.9 136.1 397.2 139.1 397.8 141.7 398.8 144.7 397.8 145.3 395.8S144 391.5 141 390.6C138.4 389.9 135.5 390.9 134.8 392.9zM179 391.2C176.1 391.9 174.1 393.8 174.4 396.1 174.7 398.1 177.3 399.4 180.3 398.7 183.2 398 185.2 396.1 184.9 394.1 184.6 392.2 181.9 390.9 179 391.2zM244.8 8C106.1 8 0 113.3 0 252 0 362.9 69.8 457.8 169.5 491.2 182.3 493.5 186.8 485.6 186.8 479.1 186.8 472.9 186.5 438.7 186.5 417.7 186.5 417.7 116.5 432.7 101.8 387.9 101.8 387.9 90.4 358.8 74 351.3 74 351.3 51.1 335.6 75.6 335.9 75.6 335.9 100.5 337.9 114.2 361.7 136.1 400.3 172.8 389.2 187.1 382.6 189.4 366.6 195.9 355.5 203.1 348.9 147.2 342.7 90.8 334.6 90.8 238.4 90.8 210.9 98.4 197.1 114.4 179.5 111.8 173 103.3 146.2 117 111.6 137.9 105.1 186 138.6 186 138.6 206 133 227.5 130.1 248.8 130.1S291.6 133 311.6 138.6C311.6 138.6 359.7 105 380.6 111.6 394.3 146.3 385.8 173 383.2 179.5 399.2 197.2 409 211 409 238.4 409 334.9 350.1 342.6 294.2 348.9 303.4 356.8 311.2 371.8 311.2 395.3 311.2 429 310.9 470.7 310.9 478.9 310.9 485.4 315.5 493.3 328.2 491 428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9C95.9 353.9 96.2 356.2 97.9 358.1 99.5 359.7 101.8 360.4 103.1 359.1 104.4 358.1 104.1 355.8 102.4 353.9 100.8 352.3 98.5 351.6 97.2 352.9zM86.4 344.8C85.7 346.1 86.7 347.7 88.7 348.7 90.3 349.7 92.3 349.4 93 348 93.7 346.7 92.7 345.1 90.7 344.1 88.7 343.5 87.1 343.8 86.4 344.8zM118.8 380.4C117.2 381.7 117.8 384.7 120.1 386.6 122.4 388.9 125.3 389.2 126.6 387.6 127.9 386.3 127.3 383.3 125.3 381.4 123.1 379.1 120.1 378.8 118.8 380.4zM107.4 365.7C105.8 366.7 105.8 369.3 107.4 371.6 109 373.9 111.7 374.9 113 373.9 114.6 372.6 114.6 370 113 367.7 111.6 365.4 109 364.4 107.4 365.7z"}]}}),H.register({"brands/gitkraken":{width:592,height:512,paths:[{d:"M565.7 118.1C563.4 112 556.4 108.9 550.4 111.5 544.7 113.9 541.9 120.4 544.1 126.1 555 155.1 561 186.6 561 219.4 561 354 460.7 465.1 330.8 482.1V358.4C338.7 356.9 346.3 354.8 353.8 352.2V456.2C460.5 430.3 539.7 334.1 539.7 219.4 539.7 127.6 488.9 47.6 413.9 6.1 408.2 2.9 400.9 5.2 398 11.1 395.3 16.6 397.4 23.3 402.7 26.2 470.6 63.8 516.6 136.2 516.6 219.4 516.6 312.7 458.7 392.5 376.8 424.8V332.6C391 328.1 401.7 314.9 401.7 299.1 401.7 286 394.9 274.7 384.4 268.6 392.7 189.1 428.9 210 428.9 184.7V170C428.9 132 341 8.2 299.9 5.3 297.4 5.1 294.9 5.1 292.3 5.3 251.1 8.3 163.2 132 163.2 170V184.8C163.2 210.1 199.5 189.1 207.7 268.7 197.1 274.8 190.4 286.1 190.4 299.2 190.4 315 201 328.2 215.2 332.7V424.9C133.3 392.7 75.4 312.9 75.4 219.5 75.4 136.4 121.4 64 189.3 26.3 194.7 23.3 196.7 16.7 194 11.2 191.1 5.3 183.9 3 178.1 6.2 103.1 47.7 52.3 127.7 52.3 219.5 52.3 334.2 131.5 430.3 238.2 456.3V352.3C245.8 354.8 253.3 356.9 261.2 358.5V482.2C131.4 465.2 31 354.1 31 219.5 31 186.7 37 155.2 47.9 126.2 50.1 120.4 47.3 114 41.6 111.6 35.6 109 28.6 112 26.3 118.2 14.5 149.7 8 183.8 8 219.5 8 374.6 130.6 501.1 284.3 507.3V361.4C291.1 361.8 299.3 361.9 307.7 361.4V507.2C461.4 501.1 584 374.6 584 219.5 584 183.8 577.5 149.7 565.7 118.1zM365.9 275.5C378.9 275.5 389.6 286 389.6 299.2 389.6 312.3 379 322.9 365.9 322.9 352.9 322.9 342.2 312.4 342.2 299.2 342.2 286.1 352.8 275.5 365.9 275.5zM226.1 322.8C212.9 322.8 202.4 312.1 202.4 299.1S212.9 275.4 226.1 275.4C239.2 275.4 249.8 286 249.8 299.1 249.8 312.1 239.3 322.8 226.1 322.8z"}]}}),H.register({"brands/gitlab":{width:512,height:512,paths:[{d:"M29.8 199.7L256 493.7 8.1 309.7C1.2 304.6-1.6 295.7 0.9 287.7L29.8 199.7zM105.2 24.9C102 16.1 89.5 16.1 86.3 24.9L29.8 199.7H161.7L105.2 24.9zM161.7 199.7L256 493.7 350.3 199.7H161.7zM511.1 287.7L482.2 199.7 256 493.7 503.9 309.7C510.8 304.6 513.6 295.7 511.1 287.7zM425.7 24.9C422.5 16.1 410 16.1 406.8 24.9L350.3 199.7H482.2L425.7 24.9z"}]}}),H.register({"brands/gitter":{width:384,height:512,paths:[{d:"M66.4 322.5H16V0H66.4V322.5zM166.9 76.1H116.5V512H166.9V76.1zM267.5 76.1H217.1V512H267.5V76.1zM368 76H317.6V323H368V76z"}]}}),H.register({"brands/glide-g":{width:448,height:512,paths:[{d:"M407.1 211.2C403.6 209.8 395.5 207.4 391.7 207.4 354.6 207.4 329.5 224.2 298.2 241.9L297.3 241C304.3 193.7 320.8 149.1 320.8 100.6 320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335 189.6 335 188.6 334 188.6 338.8 171.7 467.7 97.8 471.9 97.8 433.4 97.8 394.2 142.8 374.8 143.3 372.4 143 360.2 96.3 344.8 84.4 344.8 50.5 344.9 32 396 32 424.1 32 476 64.8 512 117.5 512 194.9 512 251.5 434.2 268.9 366.6 284 306.1 280.1 303.3 288.6 299 320.8 282.8 346.1 272 382.4 272 400.2 272 412.9 275.7 441.3 280.4 444.2 280.4 448 277.5 448 274.6 448 266.6 414.6 214.1 407.1 211.2zM231.8 126.8C222.5 171.5 213.2 216.4 204 261.1 201.7 271.3 190.7 268.9 182 268.9 143.7 268.9 133 227.1 133 195.8 133 148.8 151 86.5 194.8 62.4 201.8 58.3 209.6 55.7 217.4 55.7 236 55.7 237.4 69 237.4 84.4 237.3 98.7 234.7 112.9 231.8 126.8z"}]}}),H.register({"brands/glide":{width:448,height:512,paths:[{d:"M252.8 148.6C252.8 157.4 251.2 166.3 249.4 175 243.6 202.8 237.8 230.8 232.1 258.6 230.7 264.9 223.8 263.5 218.4 263.5 194.6 263.5 187.9 237.5 187.9 218 187.9 188.7 199.1 149.9 226.4 134.9 230.7 132.4 235.6 130.7 240.5 130.7 251.9 130.7 252.8 139 252.8 148.6zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM384 267C384 261.9 363.2 229.3 358.5 227.5 356.3 226.6 351.3 225.2 348.9 225.2 325.8 225.2 310.2 235.7 290.7 246.7L290.2 246.2C294.5 216.8 304.8 189 304.8 158.8 304.8 114.2 281 96.1 237.3 96.1 165.6 96.1 129.3 166.9 129.3 219.6 129.3 274.3 161.3 304.6 215.6 304.6 223.1 304.6 222.5 304 222.5 306.9 212 387.2 166 389.8 166 365.8 166 341.4 194 329.3 194.3 327.8 194.1 320.2 165 310.6 157.6 310.6 136.5 310.6 124.9 343.6 124.9 361.2 124.9 393.5 145.3 415.9 178.2 415.9 226.4 415.9 261.6 366.2 272.5 324.2 281.9 286.5 279.5 284.8 284.8 282.1 304.8 272 320.6 265.3 343.2 265.3 354.3 265.3 362.2 267.6 379.9 270.5 381.7 270.6 384 268.8 384 267z"}]}}),H.register({"brands/gofore":{width:400,height:512,paths:[{d:"M324 319.8H310.8V354.5C286.3 377.6 254.5 390.3 220.9 390.3 147.7 390.3 88.5 330.1 88.5 255.9 88.5 181.8 147.7 121.5 220.9 121.5 256.2 121.5 289.5 135.5 314.5 160.9L376.8 97.6C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256 0 378.5 97 480 220.7 480 283.9 480 345.2 453.8 391.7 397.5 389.7 369.9 378.3 319.8 324 319.8zM311.9 207.3H205.6V296.3H324C357.5 296.3 384.5 311.4 400 338.1V307.5C400 242.3 359.6 207.3 311.9 207.3z"}]}}),H.register({"brands/goodreads-g":{width:384,height:512,paths:[{d:"M42.6 403.3H45.4C58.1 403.3 70.9 403.3 83.6 403.4 85.2 403.4 86.7 403 87.2 405.5 94.3 440.4 117.2 460.1 150.1 469.4 177 477 204.2 477.2 231.4 471.2 265.2 463.8 287.4 442.9 299.4 410.8 307.4 389.3 310.1 367 310.4 344.3 310.5 338.5 310.7 297.3 310.2 291.5L309.3 291.2C308.5 292.7 307.6 294.1 306.8 295.6 284.7 338.7 245.5 363 201.4 364.7 98.4 368.7 32 307.7 29.4 188.5 28.9 164.8 31.2 141.6 37.7 118.8 58.3 47.7 112.3 0.6 191.6 0 252.9-0.4 293.1 38.7 307.8 70.3 308.3 71.4 309.1 72.6 310.2 72.2V10.6H354.5C354.5 290.9 354.6 342.8 354.6 342.8 354.5 421.3 327.9 486.5 251.6 505 182.1 521.9 92.6 509.8 55.6 447.8 47.6 434.3 43.8 419.5 42.6 403.3zM188.9 36.5C136.4 36 80.4 77.2 73.9 170.3 69.8 229.3 88.7 292.5 145.4 318.9 173 331.8 219.7 333.9 253.7 310.2 301.3 277 316.4 213.2 308.5 156.2 298.8 85.1 260.7 36.2 188.9 36.5z"}]}}),H.register({"brands/goodreads":{width:448,height:512,paths:[{d:"M299.9 191.2C305 228.5 295.2 270.2 264 291.9 241.7 307.4 211.2 306 193.2 297.6 156.1 280.3 143.7 239 146.4 200.4 150.7 139.5 187.3 112.5 221.7 112.9 268.6 112.7 293.5 144.7 299.9 191.2zM448 88V424C448 454.9 422.9 480 392 480H56C25.1 480 0 454.9 0 424V88C0 57.1 25.1 32 56 32H392C422.9 32 448 57.1 448 88zM330 313.2S329.9 279.2 329.9 95.9H300.9V136.2C300.1 136.5 299.7 135.7 299.3 135 289.7 114.3 263.4 88.7 223.3 89 171.4 89.4 136.1 120.2 122.7 166.8 118.4 181.7 116.9 196.9 117.2 212.4 118.9 290.3 162.3 330.2 229.6 327.6 258.5 326.5 284.1 310.6 298.6 282.4 299.1 281.4 299.7 280.5 300.3 279.5 300.5 279.6 300.7 279.6 300.9 279.7 301.2 283.5 301.1 310.4 301 314.2 300.8 329 299 343.7 293.8 357.7 286 378.7 271.5 392.4 249.3 397.2 231.5 401.1 213.7 401 196.1 396 174.6 389.9 159.6 377 155 354.2 154.7 352.6 153.7 352.9 152.7 352.9H125.9C126.7 363.5 129.1 373.2 134.4 382.1 158.6 422.6 217.1 430.6 262.6 419.5 312.5 407.2 329.9 364.6 330 313.2z"}]}}),H.register({"brands/google-drive":{width:512,height:512,paths:[{d:"M339 314.9L175.4 32H336.6L500.2 314.9H339zM201.5 338.5L120.9 480H431.4L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"}]}}),H.register({"brands/google-play":{width:512,height:512,paths:[{d:"M325.3 234.3L104.6 13 385.4 174.2 325.3 234.3zM47 0C34 6.8 25.3 19.2 25.3 35.3V476.6C25.3 492.7 34 505.1 47 511.9L303.6 255.9 47 0zM472.2 225.6L413.3 191.5 347.6 256 413.3 320.5 473.4 286.4C491.4 272.1 491.4 239.9 472.2 225.6zM104.6 499L385.4 337.8 325.3 277.7 104.6 499z"}]}}),H.register({"brands/google-plus-g":{width:640,height:512,paths:[{d:"M386.1 228.5C387.9 238.2 389.2 247.9 389.2 260.5 389.2 370.2 315.6 448 204.8 448 98.7 448 12.8 362.1 12.8 256S98.7 64 204.8 64C256.7 64 299.9 82.9 333.4 114.3L281.3 164.3C267.1 150.7 242.3 134.7 204.8 134.7 139.3 134.7 85.9 188.9 85.9 256 85.9 323.1 139.3 377.3 204.8 377.3 280.8 377.3 309.3 322.5 313.8 294.5H204.8V228.5H386.1zM571.5 234.9V179.2H515.5V234.9H459.7V290.9H515.5V346.7H571.5V290.9H627.2V234.9H571.5z"}]}}),H.register({"brands/google-plus-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM164 356C108.7 356 64 311.3 64 256S108.7 156 164 156C191 156 213.5 165.8 231 182.2L203.9 208.3C196.5 201.2 183.6 192.9 164.1 192.9 130 192.9 102.2 221.1 102.2 256.1 102.2 291 130 319.3 164.1 319.3 203.7 319.3 218.5 290.8 220.9 276.2H164V241.8H258.4C259.4 246.8 260 251.9 260 258.4 260 315.5 221.7 356 164 356zM384 274.2H355V303.2H325.8V274.2H296.8V245H325.8V216H355V245H384V274.2z"}]}}),H.register({"brands/google-plus":{width:496,height:512,paths:[{d:"M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM177.3 380C108.5 380 53.3 324.5 53.3 256S108.5 132 177.3 132C208.6 132 237.4 143 260.3 164.3L226.7 196.9C213.5 184 195.4 177.8 177.3 177.8 134.4 177.8 100.1 213.3 100.1 255.9S134.3 334 177.3 334C209.9 334 242.2 314.9 247.4 280.7H177.3V238.1H294.2C295.5 244.9 296.1 251.7 296.1 258.8 296.1 329.6 248.6 380 177.3 380zM407.5 273.8V309.3H372V273.8H336.5V238.3H372V202.8H407.5V238.3H442.7V273.8H407.5z"}]}}),H.register({"brands/google-wallet":{width:448,height:512,paths:[{d:"M156.8 126.8C194.4 187.4 221 239.9 241.1 289.3 232.8 323.1 222.3 355.8 209.8 387.6 196.6 335.3 183.3 286.3 153.8 239.1 160.3 202.7 156.1 165.5 156.8 126.8zM109.3 200H16.1C9.6 200 5.6 207.5 9.6 212.7 51.8 267 81.3 330.5 101.3 400H204.8C188.6 330.3 166.1 266.3 122.3 206.5 119.3 202.5 114.3 200 109.3 200zM157.1 112C225.6 220 287.1 346.5 295.3 480H409C397 342 340.6 215 265.8 112H157.1zM408.9 43.5C407.1 36.7 400.7 32 393.7 32H305.4C300.1 32 296.4 37 297.6 42.3 310.8 88.8 319.9 137.8 324.1 188.3 372.3 274.5 403.8 366.6 414.7 459.1 430.5 398.6 440 325.6 440 256.1 440 182.5 427.9 111 408.9 43.5z"}]}}),H.register({"brands/google":{width:488,height:512,paths:[{d:"M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8C314.8 8 371 32.5 414.3 72.9L346.8 137.8C258.5 52.6 94.3 116.6 94.3 256 94.3 342.5 163.4 412.6 248 412.6 346.2 412.6 383 342.2 388.8 305.7H248V220.4H484.1C486.4 233.1 488 245.3 488 261.8z"}]}}),H.register({"brands/gratipay":{width:496,height:512,paths:[{d:"M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM362.6 234.4L249.6 387.1 136.9 234.4C128.2 222.5 117.8 184 150.5 162.4 178.6 144.3 205.1 158.2 219 174.3 234.9 192.2 265.6 191.2 280.7 174.3 294.6 158.2 321.1 144.3 348.8 162.4 381.7 184 371.4 222.4 362.6 234.4z"}]}}),H.register({"brands/grav":{width:512,height:512,paths:[{d:"M301.1 212C305.5 216.4 305.5 223.9 301.1 228.3L291.4 238C287 242.7 279.5 242.7 274.8 238L264.3 227.5C259.9 222.8 259.9 215.6 264.3 210.9L274 201.2C278.4 196.8 285.9 196.8 290.6 201.2L301.1 212zM270.9 192.3C273.9 189.3 273.9 184.5 270.9 181.8 268.1 178.8 263.4 178.8 260.4 181.8 257.6 184.6 257.6 189.3 260.4 192.3 263.5 195.1 268.2 195.1 270.9 192.3zM244.9 197.6C241.9 200.4 241.9 205.1 244.9 207.8 247.7 210.8 252.4 210.8 255.4 207.8 258.2 205 258.2 200.3 255.4 197.6 252.4 194.6 247.7 194.6 244.9 197.6zM317.4 184.3C297.5 169.9 283.6 141.1 305.5 116.2 327.1 91.3 346.2 99 365.3 117 377.2 128.3 394.6 141.9 382.5 165.2 370 188.7 337.4 198.4 317.4 184.3zM365.1 139.8C356.2 129.8 341.8 146.7 349.6 155.9 357 164.9 381.7 158.3 365.1 139.8zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM437.8 298.6C440.3 282.5 417.6 282 412.6 272.9 399 248.8 384.9 236.1 358.1 242.5 369.7 234.5 381.6 236.4 381.6 236.4 381.9 230 381.6 223.4 372.2 211.5 376.1 199 372.5 189.1 372.5 189.1 388 180.5 399.3 164.7 401.6 145.9 405.2 114.9 382.8 86.7 351.8 83.1 329.7 80.6 308.1 90.8 297.5 108.8 274.3 148.9 298.9 179.7 319.9 190.2 305.5 188.8 285.6 178.3 279.8 155.9 273.2 130.2 282.6 106.1 288.7 94.5 288.7 94.5 284.3 88.7 280.7 85.6 280.7 85.6 266.9 85.6 256.1 90.9 268 75.7 281.3 76.5 281.3 76.5 281.3 70.1 280.7 61.6 277.7 54.9 272.3 43.9 253.9 42 246 57.7 246.1 57.5 246.3 57.3 246.4 57.2 241.4 69.1 245.3 113.1 263.3 144.4 260.8 145.8 254.2 150.5 250.3 154.4 228.7 164.1 194.1 214.7 194.1 214.7 165.9 225.5 116.9 265.6 123.5 294.4 123.8 297.4 124.9 299.9 126.5 301.9 123.7 304.1 121 306.9 118.2 310.2 106.3 324 112.9 345.4 135.9 334.6 151.7 327.4 165.5 314.4 172.2 304.2 172.2 304.2 166.7 299.2 155.9 299.8 183.6 293.2 190.2 290.4 202.1 290.7 210.1 294.6 210.1 256.4 210.1 256.4 210.1 241.7 207.9 225.4 199 214.9 211.5 227.1 228.1 247.6 227 275.5 226.2 293.8 211.8 298.5 211.8 298.5 202.7 315.1 168.6 364.4 181.4 404.5 181.4 404.5 171.7 389.6 171.2 382.4 153.8 401.8 124.7 434.7 146.6 446.9 173.2 461.6 255.4 358.3 272.8 304.6 307.4 283.8 328.2 257.3 336.7 239.6 358.7 283.1 432 334.1 437.8 298.6z"}]}}),H.register({"brands/gripfire":{width:384,height:512,paths:[{d:"M171.8 503.8C171.8 498.5 176.6 491.6 176.6 481.5 176.6 466.3 163.6 441.6 98.5 394.9 64.2 365.8 32 336.4 32 286.6 32 171.9 179.1 110.1 179.1 18 179.1 14.7 178.9 11.3 178.5 8 183.6 10.4 217.6 51.3 217.6 98.4 217.6 178.9 112.5 227.6 112.5 301.4 112.5 328.3 129.1 348.6 145.1 370.9 167.6 401.1 189.3 427.8 189.3 457.4 189.2 471.9 184.9 487.1 171.8 503.8zM317.8 262.4C319.3 270.8 320 279 320 287 320 338.8 290.6 384.5 252.7 423.8 251.7 424.8 250.5 426.2 249.5 426.2 245.9 426.2 214 384.6 214 373 214 373 255.8 317.3 255.8 276.1 255.8 265.3 253.1 254.4 246.7 242.7 245.2 275 191 330.4 188.6 330.4 185.9 330.4 170.7 308.4 170.7 288.3 170.7 283 171.7 277.6 173.9 272.5 176.3 267 230.5 200.5 230.5 155.8 230.5 149.6 229.5 143.8 227.1 138.7L223.1 131.5C239.8 138 305.7 195.6 317.8 262.4"}]}}),H.register({"brands/grunt":{width:384,height:512,paths:[{d:"M61.3 189.3C60.2 199.3 66.5 208.4 66.5 208.4 67.2 200.9 68.7 195.6 70.5 191.8 70.9 202.1 73.7 215.3 83.3 225.9 90.2 233.5 118.9 249.2 138.2 232 139.2 234.4 140.3 237.3 141.2 240.5 144.1 250.8 138.5 265.8 138.5 265.8S153.6 248.7 152.4 233.3C163.2 232.8 173.8 224.9 173.5 213.8 173.5 213.8 154.6 224.2 138 205 128.3 193.8 97.1 163 54.9 173.2 59.2 174.2 63.8 175.6 68.4 177.3H68.3C64.1 179.3 61.8 184.4 61.3 189.3zM89.6 187.5C109.1 198.5 127 213.2 134.5 224.5 128.8 227.8 112.8 234.9 96.5 222.8 86.2 215.2 86.7 196.6 89.6 187.5zM168.8 421.2C171 423.5 170.3 426.5 169.7 428 168.6 430.7 164.2 439.6 156.7 447.8 154 450.7 150.1 452.4 145.7 452.4 141.4 452.4 137 450.8 133.9 448.1 131.6 446 123.7 438.6 120.2 429.5 118.9 426.1 119.2 423.4 121.1 421.4 122.4 420.1 125.1 418.5 130.6 418.5H160C164.1 418.5 167 419.4 168.8 421.2zM231.7 233.3C230.5 248.8 245.6 265.8 245.6 265.8S240 250.8 242.9 240.5C243.8 237.3 244.9 234.5 245.9 232 265.2 249.3 293.9 233.5 300.7 225.9 310.3 215.3 313 202.1 313.5 191.8 315.3 195.6 316.9 200.9 317.5 208.4 317.5 208.4 323.9 199.3 322.7 189.3 322.1 184.3 319.8 179.3 315.7 177.5H315.6C320.2 175.7 324.8 174.3 329.1 173.4 286.8 163.2 255.7 194 246 205.2 229.3 224.4 210.5 214 210.5 214 210.3 224.9 220.9 232.9 231.7 233.3zM249.5 224.5C257 213.1 274.9 198.5 294.4 187.5 297.4 196.6 297.8 215.2 287.4 222.9 271.1 235 255.2 227.9 249.5 224.5 249.4 224.6 249.5 224.5 249.5 224.5zM263 421.4C264.9 423.3 265.2 426 263.9 429.3 260.4 438.2 252.5 445.4 250.2 447.4 247.1 450 242.8 451.6 238.4 451.6S230.1 450 227.4 447.1C219.9 439.1 215.4 430.4 214.4 427.8 213.8 426.3 213.1 423.4 215.3 421.1 217 419.3 220 418.4 224.2 418.4H253.6C259 418.5 261.7 420.1 263 421.4zM164.7 169.9C174.6 175.9 183.5 178 192 178.2 200.5 178 209.4 175.9 219.3 169.9 219.3 169.9 204.8 187.6 192.1 187.7H191.9C179.2 187.5 164.7 169.9 164.7 169.9zM349.2 317.3C346.8 335.2 336.2 351.1 324.6 361 321.5 338.3 320.9 305.5 320.9 298.6 320.9 283.9 330.4 274.1 333.1 272.5 335.6 271 338.5 269.5 341.4 267.9 359.4 258.3 381.8 246.3 381.8 224.2 381.8 208 372.5 201 366.4 196.4 365.6 195.8 364.9 195.3 364.2 194.7 362.1 193 360.5 191.7 359.9 190.3 355.5 180.5 356.3 156.1 358.2 152.7 358.8 152.1 374.9 131.8 370 113.5 368 106.1 363.1 100.2 355.9 96.5 350.6 93.8 344 92.3 336.4 92 336.3 90 335.9 88.1 335.5 86.1 334.9 83.5 334.4 80.8 334.6 78 335 73.3 335.4 69 336.8 66.7 345.2 53.4 365.6 49.1 365.8 49.1L378.1 46.7 370 37.2C369.9 37 352.7 19.7 323.7 19.7 315.8 19.7 307.7 21 299.6 23.6 275.4 31.4 256.7 54.1 250.2 62.9 247.1 61.9 243.9 61 240.6 60.2 236.4 44.4 249.6 21.7 249.6 21.7S236 18.7 215.9 36.9C213.3 30.4 207.8 16.4 214.1-0.3 184.6 10.1 177.2 26 175 40.4 167.4 35 168.3 17.3 167.8 12.8 160.3 13.7 138.6 34.7 139.6 61.1 137.6 61.6 135.7 62.2 133.7 62.8 127.2 54 108.6 31.3 84.3 23.5 76.4 21.3 68.3 20 60.4 20 31.4 20 14.3 37.3 14.1 37.5L6 46.9 18.3 49.3C18.5 49.3 38.9 53.6 47.3 66.9 48.7 69.1 49.1 73.5 49.5 78.2 49.7 81 49.1 83.7 48.6 86.3 48.2 88.2 47.8 90.2 47.7 92.2 40 92.5 33.5 94 28.2 96.7 21 100.4 16.1 106.3 14.1 113.7 9.1 131.9 25.3 152.2 25.9 152.9 27.8 156.3 28.6 180.7 24.2 190.5 23.6 191.9 22 193.2 19.9 194.9 19.2 195.4 18.5 196 17.7 196.6 11.6 201.2 2.3 208.3 2.3 224.4 2.3 246.5 24.7 258.5 42.7 268.1 45.7 269.7 48.5 271.2 51 272.7 53.7 274.3 63.2 284.1 63.2 298.8 63.2 305.7 62.6 338.5 59.5 361.2 47.9 351.3 37.3 335.3 34.9 317.4 34.9 317.4 5.7 340 14.3 388.2 19.5 417.7 37.5 434.3 61.3 442.9 70.1 462 90.7 488.6 128.6 492.5 143 504.3 163 512 192.2 512H192.4C221.5 512 241.5 504.3 256 492.5 293.9 488.6 314.5 462 323.3 442.9 347.1 434.2 365 417.7 370.3 388.2 378.5 339.8 349.2 317.3 349.2 317.3zM305.7 37.7C311.3 35.9 317.3 35 323.4 35 334.4 35 343.3 38 348.1 40 345 41.4 341.7 43.2 338.4 45.3 336 44.9 332.8 44.5 329.2 44.5 318.7 44.5 308.7 47.6 300.5 53.4 288.2 62.1 282.5 70.3 279.8 75.8 277.6 74.5 275.3 73.3 272.7 72.1 271.1 71.3 269.6 70.6 268 69.9 274.1 60.8 287.9 43.4 305.7 37.7zM326.7 55.9C325.9 56.9 325.1 58 324.4 59.1 321.1 64.3 320.5 70.7 320 76.9 319.5 83.3 318.9 89.4 315.6 93.9 311.4 94.7 307.5 95.6 304.1 96.6 301.8 93.5 298.5 89.6 293.6 85.4 295 80.6 299.1 69.3 307.1 62.9 312.7 58.6 319.3 56.2 326.7 55.9zM45.6 45.3C42.3 43.1 39 41.3 35.9 40 40.7 38 49.6 35 60.6 35 66.7 35 72.6 35.9 78.3 37.7 96.1 43.5 109.9 60.9 116 69.8 114.4 70.5 112.8 71.2 111.2 72 108.7 73.2 106.3 74.5 104.1 75.7 101.5 70.3 95.8 62 83.4 53.3 75.1 47.5 65.2 44.4 54.6 44.4 51.2 44.5 48 44.9 45.6 45.3zM90.3 85.4C85.4 89.6 82 93.4 79.8 96.6 76.4 95.7 72.5 94.7 68.3 93.9 65 89.5 64.5 83.4 64 77 63.5 70.8 62.9 64.4 59.6 59.2 58.9 58.1 58.1 57 57.3 56 64.7 56.3 71.3 58.6 76.8 63 84.8 69.3 88.9 80.6 90.3 85.4zM58.1 259.9C55.4 258.3 52.5 256.8 49.7 255.3 34.8 247.3 19.5 239 19.5 224.8 19.5 213.7 23.8 210.2 28.4 206.6L28.9 206.2C29.6 205.6 30.3 205 31.1 204.4 30.2 211.6 29.2 217.7 28.4 219.3 28.4 219.3 40.5 204.3 44.1 175 45.5 163.5 43 140.7 39 132 39.2 136.9 39 141.8 38.7 146.4 38.3 145.6 37.9 144.8 37.4 144.2 34.2 140.2 25.6 126.7 28 117.6 28.9 114.1 31.1 111.6 34.7 109.8 38.5 107.9 43.5 106.9 49.8 106.9 62.1 106.9 75.7 110.6 82.7 112.9 107.8 120.9 138.1 143.8 146.8 150.6 147 150.8 147.2 150.9 147.2 150.9L152.8 154.8 149.3 149C149.1 148.7 130.2 117.6 96.1 102.5 98.1 99.6 103.5 94.4 117.7 87.4 139.1 76.9 164.2 71.6 192 71.6 219.9 71.6 244.9 76.9 266.3 87.4 280.5 94.3 285.9 99.6 287.9 102.5 253.9 117.6 235 148.7 234.8 149L231.3 154.8 236.9 150.9S237.1 150.8 237.3 150.6C246 143.8 276.3 120.8 301.4 112.9 308.4 110.7 322 106.9 334.3 106.9 340.6 106.9 345.6 107.9 349.4 109.8 352.9 111.6 355.1 114.2 356.1 117.6 358.6 126.7 350 140.2 346.7 144.2 346.2 144.8 345.8 145.5 345.4 146.4 345.1 141.8 344.9 136.9 345.1 132 341.1 140.8 338.6 163.5 340 175 343.6 204.3 355.7 219.3 355.7 219.3 354.9 217.7 353.9 211.6 353 204.4 353.7 205 354.5 205.6 355.2 206.2L355.7 206.6C360.3 210.3 364.6 213.7 364.6 224.8 364.6 239 349.2 247.3 334.4 255.3 331.5 256.8 328.7 258.4 326 259.9 317.3 264.9 308 276.6 306.9 294.1 306 308.7 307.8 344 310.3 370 297.9 374.8 283.6 376.4 270.6 376.8 268.6 372.7 266.7 368.3 265.1 363.7 264.4 361.7 245.5 312.6 238.7 301.5 244.2 340.5 256.2 375.2 262.2 391.1 258.7 390.6 254.9 390.4 250.5 390.4H133.5C129.1 390.4 125.2 390.7 121.8 391.1 127.8 375.2 139.9 340.5 145.3 301.5 138.5 312.7 119.6 361.8 118.9 363.7 117.3 368.3 115.4 372.7 113.4 376.8 100.4 376.4 86.2 374.8 73.7 370 76.2 344 78 308.8 77.1 294.1 76.2 276.7 66.8 264.9 58.1 259.9zM34.8 404.6C22.7 384.6 26.1 350.5 31.1 345.5 42 379.9 78.3 389.8 105.5 390.9 102.8 395.1 100.3 398.5 98.5 400.9L97.1 402.3C89.9 410.1 88.5 420.8 93 434.1 70.3 434 46.7 424.3 34.8 404.6zM80.5 448.1C86.5 449.2 92.7 450 99.1 450.5 102.6 458.5 106.5 466.4 111.4 473.6 97 467.7 87 457.6 80.5 448.1zM192 498.2C131.4 498.1 113.7 452.4 107.1 433.5 103.4 423 103.7 415.3 108 410.4 110.9 407.1 117.5 403.2 132.6 403.2H251.4C266.5 403.2 273.2 407.1 276 410.4 280.2 415.2 280.5 423 276.9 433.5 270.3 452.3 252.6 498.1 192 498.2zM272.6 473.6C277.5 466.4 281.4 458.5 284.9 450.5 291.3 450 297.5 449.2 303.5 448.1 297 457.6 287 467.7 272.6 473.6zM349.2 404.6C337.2 424.3 313.6 433.9 291.1 434.3 295.6 421 294.2 410.2 287 402.5 286.6 402 286.1 401.5 285.6 401 283.8 398.6 281.3 395.2 278.6 391 305.8 389.8 342.1 380 353 345.6 358 350.6 361.4 384.7 349.2 404.6z"}]}}),H.register({"brands/gulp":{width:256,height:512,paths:[{d:"M209.8 391.1L195.7 415.7 191.1 495.9C191.1 504.8 162.8 512 128 512S64.9 504.8 64.9 495.9L59.1 416.5 44.2 391.1C85.4 408.4 170.2 407.8 209.8 391.1zM13.8 137.8L27.4 263.3C33.3 243.3 48.2 216.3 67.4 208.1 73.7 205.4 80.1 205.4 86.1 209 91.3 212 95.7 218.3 96.2 220.8 97.4 227.3 94.2 229.9 91.7 229.9 88.7 229.9 86.4 225.3 84.9 222.6 80.8 215.3 74.6 215 68 219.8 61.1 224.8 55.1 233.2 50.9 240.5 45.8 249.3 41.5 259 38.9 268.7 37.4 274.3 36 283.3 38.3 288.6 39.3 290.8 40.8 292.2 43.2 292.2 48.2 292.2 55.5 285.6 59 282.1 63.5 277.6 69.3 270.6 71.5 266.1L76.7 250.6C79.3 243.8 86.6 245 86.6 250.6 86.6 260.8 82.9 264.2 76.6 285.3 70.8 304.8 69 311.1 69 311.1 68.3 313.9 65.6 318.6 62.7 318.6 61.5 318.6 60.6 318.2 60.1 317.4 59.1 316 59.2 312.1 59.3 311.1 59.5 307.9 65.6 288.9 66.6 285.9 64.6 288.1 62.5 290.3 60.2 292.5 54.8 297.6 46.1 304.3 38.7 304.3 35.3 304.3 33.1 303.4 31 301.9L38.6 381.5C40.6 386.5 77.8 398.6 126.8 398.6 175.9 398.6 213.1 386.4 215 381.5L225.9 286.9C220.2 292.1 213.6 298.5 206.3 301.7 200.9 304 188.9 305.5 188.9 296 188.9 290.8 198 281.2 203.3 274.5 204.7 272.8 208 268.6 208 266.4 208 263.5 202 264.2 196.3 268.9 193.1 271.6 190.1 275.2 187.6 278.6 183.3 284.6 181 289.8 179.1 294.1 172.9 308.3 175 302.7 170 316.1 165 329.4 165.8 327.9 164.8 330.1 163.9 332 162.6 333.6 160.8 334.6 158.9 335.6 156.3 335.5 154.7 334.3 153.8 333.7 153.4 332.4 153.4 330.6 153.4 329.7 153.5 328.8 153.7 327.9 155.2 321.8 161.5 309.8 168.7 293.6 170.3 289.9 169.7 291 169.5 291.3 163.3 297.3 158.6 300.2 155.1 301.8 149.3 304.4 142.1 304.4 140.6 297.7 140.5 297.3 140.5 296.9 140.4 296.5 128.6 305.7 116.1 308.2 120.4 288.4 115.8 296.6 107.8 303.3 98 303.3 93.9 303.3 90.9 301.9 89.4 298.2 87.1 292.7 90.7 283.3 94 274.4 95.7 269.9 98 264.5 101.1 258.2 102.7 254.8 105.3 252.8 108.7 253.7 109.3 253.9 109.8 254.1 110.3 254.4 112.9 256.2 111.9 258.9 110.6 261.6 106.8 269.1 103.5 274.6 101.3 282.4 100.4 285.7 99.3 291.4 102.8 291.4 105.2 291.4 107.5 290.6 109.7 289 114.3 285.6 118 280.5 120.8 275.5 122.8 271.9 125.2 267.2 126.4 263.2 126.9 261.5 127.5 259.9 128.2 258.4 129.3 255.9 130.8 253.3 133.4 253.3 134.7 253.3 135.8 253.8 136.6 254.8 138.3 257 137.9 259.3 137 261.7 135 267.3 132.3 272.3 130.1 278.4 128.8 281.9 127.4 286.4 127.4 290.1 127.4 293.5 131.1 292.7 134.2 291.3 136.6 290.2 139 288.5 141 286.8 142.2 281.9 141.9 283 167.4 218.6 168.7 215.3 171.1 213.9 173.5 213.9 174.7 213.9 175.7 214.3 176.7 215 178.4 216.3 178.4 219.1 177.7 221.2 177 223.1 177.1 222.5 173.2 231.7 168 243.8 164.6 252.5 160 263.6 158.1 268.2 152.3 282.5 151.3 285.9 150.7 288.1 150 291.7 152.3 291.7 157.7 291.7 171.6 278.6 175.4 274.7 175.6 274.4 175.9 274.3 176.3 274.1 176.9 272.2 177.5 270.4 178 268.6 179.4 264.8 180.7 260.4 183.3 257.3 184.1 256.3 185 255.7 186 255.7 188.8 255.7 190.2 256.9 190.2 259.7 190.2 260.8 189.5 264.8 189.1 265.9 190.5 264.4 192 262.9 193.6 261.4 208.6 247.5 219.3 254.6 219.3 261.6 219.3 269 210.4 279.3 205.5 285 203.9 286.9 200.6 290.4 200.5 291.4 200.5 292.7 201.4 293.2 202.7 293.2 204.7 293.2 209.1 289.7 210.7 288.5 215.7 284.6 222.5 278.6 227.3 274.4L242.1 137.6C211.6 154.7 44.5 154.8 13.8 137.8zM243.5 129.3C243.5 150.3 12.3 150.3 12.3 129.3 12.3 120.5 64.1 113.4 127.9 113.4 136.9 113.4 145.7 113.5 154.2 113.8L166.8 65.1 228.1 0.6C229.5-0.8 233.9 0.4 238 4.1S244.6 12 243.3 13.4L243.2 13.5 185.9 74 175.9 114.7C215.8 117.3 243.5 122.8 243.5 129.3zM174.1 133.9C174.1 133.1 173.2 132.4 171.6 131.8L171.4 132.6C171.4 133.9 166.4 135 160.3 135S149.2 133.9 149.2 132.6C149.2 132.5 149.2 132.4 149.3 132.3L149.5 131.6C147.7 132.2 146.5 133 146.5 133.9 146.5 136 152.7 137.6 160.2 137.6 167.9 137.7 174.1 136 174.1 133.9z"}]}}),H.register({"brands/hacker-news-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM21.2 229.2H21C21.1 229.1 21.2 228.9 21.3 228.8 21.3 228.9 21.3 229.1 21.2 229.2zM239.2 283.1V384H207.8V281.3L128 128H165.3C217.8 226.3 214.5 229.2 224.6 253.6 236.9 226.6 230.4 229.2 285.2 128H320L239.2 283.1z"}]}}),H.register({"brands/hacker-news":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM21.2 229.2H21C21.1 229.1 21.2 228.9 21.3 228.8 21.3 228.9 21.3 229.1 21.2 229.2zM239.2 283.1V384H207.8V281.3L128 128H165.3C217.8 226.3 214.5 229.2 224.6 253.6 236.9 226.6 230.4 229.2 285.2 128H320L239.2 283.1z"}]}}),H.register({"brands/hips":{width:640,height:512,paths:[{d:"M0 80.2C0 78.4 0.9 77.5 2.7 77.5H43.6C45.5 77.5 46.4 78.4 46.4 80.2V161.4C61.6 153.7 78.1 149.9 96.2 150 120.2 150.1 140.4 156.2 156.5 168 175.2 181.5 184.5 199.9 184.5 223.3V359.4C184.5 361.3 183.6 362.2 181.8 362.2H154.5C145.4 362.2 138.1 354.9 138.1 345.9V223.3C138.1 222.4 140.8 196.3 92.3 196.3 43.7 196.3 46.5 222.5 46.5 223.3V359.4C46.5 361.3 45.6 362.2 43.7 362.2H2.7C0.9 362.2 0 361.3 0 359.4V80.2zM497.7 301.7C511.4 311.9 531.8 320.8 556.1 320.8 579.4 320.8 588.9 316.3 592.6 307.2 595.6 299.3 592 291.1 580.4 286L526.8 262.5C505.4 253.1 493 238.5 489.6 218.9 483.9 185.2 511.8 165.6 512.3 165.2 525.5 155.6 544.3 149.8 570.8 149.8 589.8 149.8 608.2 153.1 625.9 159.7 627.2 160.2 627.8 161 627.8 162.3V207C627.8 209.1 625.5 210.4 623.8 209.4 584.1 188.7 547.2 197.1 539.8 202.6 533.2 207.5 533.8 215.1 542.4 218.7L600 244C616.5 251.1 628.1 262.4 634.9 278.1 640.4 290.7 641.5 303.7 638 317.2 628.4 354.1 593.1 362.7 592.4 363 581.9 366.1 568.8 367.3 556.1 367.3 539.5 367.3 523.5 364.6 507.9 359.1 498.2 355.7 493.3 348.8 493.3 338.4V304C493.3 301.9 495.6 300.3 497.7 301.7zM376.2 149.8C344.5 149.8 272 169.9 272 253.3V436.8C272 437.6 272.6 439.5 274.7 439.5H315.6C317.5 439.5 318.4 438.6 318.4 436.8V348C334.9 360.7 354.2 367.1 376.1 367.1 436.6 367.1 484.8 318.6 484.8 258.4 484.9 198.1 436.6 149.8 376.2 149.8zM376.2 320.7C359 320.7 344.3 314.6 332.2 302.5 320 290.3 314 275.7 314 258.5 314 224 341.6 196.3 376.2 196.3 410.7 196.3 438.4 223.9 438.4 258.5 438.5 292.8 411.1 320.7 376.2 320.7zM251.6 359.4C251.6 361.3 250.7 362.2 248.8 362.2H207.9C206.3 362.2 205.2 360.8 205.2 359.4V157.6C205.2 156.2 206.3 154.8 207.9 154.8H248.8C250.7 154.8 251.6 155.7 251.6 157.6V359.4M228.3 72.5C244.2 72.5 257.2 85.2 257.2 101.4 257.2 117.2 244.5 130.3 228.3 130.3S199.4 117 199.4 101.4C199.5 85.4 212.4 72.5 228.3 72.5"}]}}),H.register({"brands/hire-a-helper":{width:512,height:512,paths:[{d:"M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7V443.2C37.4 448.1 66 475.6 71.9 512H444.1C447.1 475.6 476.6 446.2 512 442.2V71.7C475.6 65.8 447 36.4 443.1 0zM406.1 404.9C369.8 404.9 387.3 402.9 351 402.9 315.2 402.9 330 404.9 294.9 404.9 289 404.9 290 396.7 294.9 395.1 317.7 387.5 317.8 384.9 319.5 382.3 329.9 366.7 325.4 299.3 325.4 269.3 325.4 264 319 256.5 311.6 256.5H200.4C193 256.5 186.6 264 186.6 269.3 186.6 299.3 182.1 366.7 192.5 382.3 194.2 384.8 194.3 387.5 217.1 395.1 222 396.7 223.1 404.9 217.1 404.9 182 404.9 196.8 402.9 161 402.9 124.7 402.9 142.2 404.9 105.9 404.9 98 404.9 100.1 394.1 105.9 394.1 116.1 390.7 119.4 390.6 127.6 380.3 135.3 367.4 135.5 335.9 135.5 252.5V151.3C135.5 129.1 123.3 123 106.9 118.9 98.1 116.7 102.9 107.1 107.9 107.1 144.4 107.1 128.5 109.1 165 109.1 197.7 109.1 181.5 107.1 214.2 107.1 217.5 107.1 222.7 115.4 215.2 117.9 210.3 119.5 187.6 121.6 187.6 157.2 187.6 202.8 187.4 213 188.6 226 188.6 227.3 190.9 238.8 201.4 238.8H310.6C321.1 238.8 323.4 227.3 323.4 226 324.6 213 324.4 202.8 324.4 157.2 324.4 121.6 301.7 119.5 296.8 117.9 289.3 115.4 294.5 107.1 297.8 107.1 330.5 107.1 314.3 109.1 347 109.1 383.5 109.1 367.6 107.1 404.1 107.1 409 107.1 414 116.7 405.1 118.9 388.7 123 376.5 129.2 376.5 151.3V252.5C376.5 335.9 376.6 367.4 384.4 380.3 392.6 390.5 395.8 390.7 406.1 394.1 411.9 394.1 413.9 404.9 406.1 404.9z"}]}}),H.register({"brands/hooli":{width:640,height:512,paths:[{d:"M508.4 352H566.3V156.7L508.4 184V352zM582.1 241.5V352H640V241.5H582.1zM331.4 232.6C313.2 214.4 281 215.5 281 215.5S248.8 214.4 230.6 232.6C228.7 234.5 226.9 236.5 225.3 238.6 187.1 209 152.8 192.1 123.2 177.5V156.8L100.7 167.4C46.3 145.3 11.7 149.2 3.4 167.5 3.4 167.5-21.5 200.3 65.3 278.4V247.4C16.5 192.8 26.3 171.3 30 168.2 43.5 156.8 67.5 160.2 94.4 170.3L65.2 184V247.3C78.3 262 95.7 278.8 118.7 297.7L123.2 301.3V271.5C123.2 264.6 124.9 253.3 134 253.3S144.6 260.2 144.6 268.3V317C162.6 329.2 181.9 339.1 202.3 346.6V252.7C202.3 234 188.9 215.3 161.7 215.3 145.9 215.2 131.2 223.5 123.2 237.2V182.9C165.1 203.8 207.1 229.4 223.1 241.2 212.9 255.8 213.8 269.3 213.8 284.9 213.8 303.6 212.4 319.2 230.6 337.4 248.8 355.6 281 354.5 281 354.5S313.3 355.6 331.4 337.4C349.6 319.2 348.1 303.6 348.1 284.9 348.1 266.4 349.6 250.7 331.4 232.6zM291.7 304.5C291.7 308.1 289.9 317 281 317 272.1 317 270.3 308.1 270.3 304.5V264.1C270.3 255.4 277.6 253.2 281 253.2 284.4 253.2 291.7 255.3 291.7 264.1V304.5zM477.4 232.6C459.2 214.4 427 215.5 427 215.5S394.7 214.4 376.6 232.6C358.4 250.8 359.8 266.5 359.8 285.2 359.8 303.9 358.4 319.5 376.6 337.7 394.8 355.9 427 354.8 427 354.8S459.3 355.9 477.4 337.7C495.6 319.5 494.2 303.9 494.2 285.2 494.1 266.4 495.5 250.7 477.4 232.6zM437.6 304.5C437.6 308.1 435.8 317 426.9 317 418 317 416.2 308.1 416.2 304.5V264.1C416.2 255.4 423.5 253.2 426.9 253.2 430.3 253.2 437.6 255.3 437.6 264.1V304.5zM611.1 231.5C627 231.5 640 218.6 640 202.6S627.1 178.1 611.1 178.1C595.2 178.1 582.2 186.7 582.2 202.6S595.1 231.5 611.1 231.5zM144.5 352L182.8 352.8C169.6 348.2 156.8 342.6 144.5 336V352zM123.1 352V323.4C116.6 319.2 110.1 314.7 103.7 309.8 88.9 298.6 76.2 288.1 65.2 278.3V352H123.1zM182.8 352.8C219.3 365.3 252.7 367 277.5 360 257.6 360.2 231.7 357.4 202.2 346.7V352L182.8 352.8z"}]}}),H.register({"brands/hotjar":{width:448,height:512,paths:[{d:"M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6 40.8 462.5 97.5 486.9 158.6 496 129.4 440.9 152 373.6 154.5 366.4 211.6 452.8 319.5 366.4 265.3 272.5 336.3 287.9 346.9 411.1 292.4 488 372.9 462.7 426.5 399.1 441.2 342.4 456.7 283.1 444.9 214.5 414.9 161.5z"}]}}),H.register({"brands/houzz":{width:414,height:512,paths:[{d:"M258.9 330.7H154.3V480H0V32H109.5V136.5L414.6 222.1V480H258.9V330.7z"}]}}),H.register({"brands/html5":{width:384,height:512,paths:[{d:"M0 32L34.9 427.8 191.5 480 349.1 427.8 384 32H0zM308.2 159.9H124.4L128.5 209.3H304.1L290.5 357.7 192.6 384.7V385H191.5L92.8 357.7 86.8 281.9H134.5L138 320 191.5 334.5 245.2 320 251.2 257.8H84.3L71.5 112.2H312.6L308.2 159.9z"}]}}),H.register({"brands/hubspot":{width:512,height:512,paths:[{d:"M267.4 211.6C242.3 235.3 226.6 268.9 226.6 306.2 226.6 335.5 236.3 362.5 252.6 384.2L203.1 434C198.7 432.4 194 431.5 189.1 431.5 178.3 431.5 168.2 435.7 160.6 443.3 153 450.9 148.8 461.1 148.8 471.9S153 492.8 160.6 500.4C168.2 508 178.4 512 189.1 512 199.9 512 210 508.1 217.7 500.4 225.3 492.8 229.5 482.6 229.5 471.9 229.5 467.7 228.9 463.7 227.6 459.8L277.6 409.6C299.6 426.5 327 436.5 356.9 436.5 428.8 436.5 486.9 378.2 486.9 306.3 486.9 241.1 439.2 187.1 376.7 177.6V116C394.2 108.6 404.9 92.2 404.9 73.1 404.9 47 384 25.2 357.9 25.2S311.2 47 311.2 73.1C311.2 92.2 321.9 108.6 339.4 116V177.2C324.2 179.3 309.8 183.9 296.7 190.8 269.1 169.9 179.2 105.1 127.8 66 129 61.6 129.8 57 129.8 52.2 129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2 25.2 81.1 48.6 104.5 77.4 104.5 87.2 104.5 96.3 101.6 104.2 96.9L267.4 211.6zM356.9 375.2C318.8 375.2 287.9 344.3 287.9 306.2S318.8 237.2 356.9 237.2 425.9 268.1 425.9 306.2 395 375.2 356.9 375.2z"}]}}),H.register({"brands/imdb":{width:448,height:512,paths:[{d:"M350.5 288.7C350.5 294.1 352.1 303.1 344.3 303.1 342.7 303.1 341.3 302.3 340.5 300.7 338.3 295.6 339.4 256.6 339.4 256 339.4 252.2 338.3 243.3 344.3 243.3 351.6 243.3 350.5 250.6 350.5 256V288.7zM265 229.9C265 220.2 266.6 213.9 254.7 213.9V297.6C266.9 297.9 265 288.9 265 279.2V229.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM21.3 228.8C21.2 228.9 21.1 229.1 21 229.2H21.3V228.8zM97 192H64V319.8H97V192zM210.3 192H167.2L159.6 251.9C156.9 231.9 154.2 211.8 150.9 192H108.1V319.8H137.1V235.3L149.3 319.8H169.9L181.5 233.4V319.8H210.2V192zM296.6 237.3C296.6 229.2 296.9 220.5 295.2 212.9 290.9 190.4 263.8 192 246.2 192H221.6V319.8C307.7 319.9 296.6 325.8 296.6 237.3zM382.5 254.6C382.5 237.3 381.7 224.5 360.3 224.5 351.4 224.5 345.4 227.2 339.4 233.7V192H307.7V319.8H337.5L339.4 311.7C345.1 318.5 351.3 321.5 360.3 321.5 380.1 321.5 382.5 306.3 382.5 290.6V254.6z"}]}}),H.register({"brands/instagram":{width:448,height:512,paths:[{d:"M224.1 141C160.5 141 109.2 192.3 109.2 255.9S160.5 370.8 224.1 370.8 339 319.5 339 255.9 287.7 141 224.1 141zM224.1 330.6C183 330.6 149.4 297.1 149.4 255.9S182.9 181.2 224.1 181.2 298.8 214.7 298.8 255.9 265.2 330.6 224.1 330.6zM370.5 136.3C370.5 151.2 358.5 163.1 343.7 163.1 328.8 163.1 316.9 151.1 316.9 136.3S328.9 109.5 343.7 109.5 370.5 121.5 370.5 136.3zM446.6 163.5C444.9 127.6 436.7 95.8 410.4 69.6 384.2 43.4 352.4 35.2 316.5 33.4 279.5 31.3 168.6 31.3 131.6 33.4 95.8 35.1 64 43.3 37.7 69.5S3.3 127.5 1.5 163.4C-0.6 200.4-0.6 311.3 1.5 348.3 3.2 384.2 11.4 416 37.7 442.2S95.7 476.6 131.6 478.4C168.6 480.5 279.5 480.5 316.5 478.4 352.4 476.7 384.2 468.5 410.4 442.2 436.6 416 444.8 384.2 446.6 348.3 448.7 311.3 448.7 200.5 446.6 163.5zM398.8 388C391 407.6 375.9 422.7 356.2 430.6 326.7 442.3 256.7 439.6 224.1 439.6S121.4 442.2 92 430.6C72.4 422.8 57.3 407.7 49.4 388 37.7 358.5 40.4 288.5 40.4 255.9S37.8 153.2 49.4 123.8C57.2 104.2 72.3 89.1 92 81.2 121.5 69.5 191.5 72.2 224.1 72.2S326.8 69.6 356.2 81.2C375.8 89 390.9 104.1 398.8 123.8 410.5 153.3 407.8 223.3 407.8 255.9S410.5 358.6 398.8 388z"}]}}),H.register({"brands/internet-explorer":{width:512,height:512,paths:[{d:"M483 159.7C493.9 135.1 504.5 99.3 504.5 71.8 504.5-0.9 424.8-26.5 294.8 33.3 187.2 26.1 83.6 106.9 57.7 219.7 88.6 184.9 136 137.4 179.7 118.6 125.4 166.9 79.1 228 44 291.7 23.2 329.7 0 390.9 0 436.7 0 535.3 92.9 523.2 180.3 478.8 211.7 494.2 246.8 494.3 281.9 494.3 379.1 494.3 466.2 440 498.8 348.3H377.9C325.4 436.9 181.1 401.3 181.1 300.9H509.9C516.3 257.3 508.2 205.2 483 159.7zM64.6 346.9C82.3 398 118.3 442.7 164.8 470.2 76.1 519.1-8.4 499.3 64.6 346.9zM180.5 238C182.5 182.9 230.8 143.1 284.5 143.1 337.9 143.1 386.5 182.9 388.5 238H180.5zM365.1 50.4C386.5 40.1 413.6 28.4 437.6 28.4 469.1 28.4 491.9 50.1 491.9 82.1 491.9 102.1 484.5 131.1 477.3 150 451.1 107.7 411.3 68.4 365.1 50.4z"}]}}),H.register({"brands/ioxhost":{width:640,height:512,paths:[{d:"M616 160H548.7C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256 72 272.4 73.6 288.5 76.7 304H24C10.7 304 0 314.8 0 328 0 341.3 10.7 352 24 352H91.3C128.8 441.3 217.1 504 320 504 457 504 568 393 568 256 568 239.6 566.4 223.5 563.3 208H616C629.3 208 640 197.2 640 184 640 170.7 629.3 160 616 160zM520 256C520 366.5 430.5 456 320 456 244.3 456 178.4 414 144.5 352H424C437.3 352 448 341.2 448 328 448 314.7 437.3 304 424 304H125.8C122 288.6 120 272.6 120 256 120 145.5 209.5 56 320 56 395.7 56 461.6 98 495.5 160H216C202.7 160 192 170.8 192 184 192 197.3 202.7 208 216 208H514.2C518 223.4 520 239.4 520 256zM216 232H424C437.3 232 448 242.7 448 256 448 269.2 437.3 280 424 280H216C202.7 280 192 269.3 192 256 192 242.8 202.7 232 216 232z"}]}}),H.register({"brands/itunes-note":{width:384,height:512,paths:[{d:"M381.9 388.2C375.5 415.6 354.7 431 326.8 436.2 302.3 440.7 281.9 441.8 262.3 426 238.4 405.9 238.1 372.6 259.6 351.6 276.6 335.4 300.5 332.1 336.4 325.8 342.4 324.7 347.6 323.3 352 318.4 358.4 311.2 356.4 314.3 356.4 155.2 356.4 144 350.9 140.9 339.4 142.9 331.2 144.3 153.7 177.5 153.7 177.5 143.5 179.7 140.3 182.7 140.3 194.2 140.3 428.9 141.4 418.1 137.8 433.7 133.6 451.9 122.4 465.6 107.6 473.2 90.8 482.5 60.4 486.6 44.2 483.6 1 475.5-14.2 425.6 15.1 397 32.1 380.8 56 377.5 91.9 371.2 97.9 370.1 103.1 368.7 107.5 363.8 117.6 352.3 109.3 107.2 112.7 93.6 113.5 88.4 115.7 84 119.8 80.7 124 77.2 131.6 75.2 133.2 75.2 337.2 37 362.1 32.1 365.6 32.1 377.1 31.3 383.7 38.1 383.7 49.7 383.9 394.2 384.8 375.7 381.9 388.2z"}]}}),H.register({"brands/itunes":{width:448,height:512,paths:[{d:"M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8 394.8 346.1 394.8 251.6C394.8 157 318.1 80.3 223.6 80.3zM303 320.3C299.8 333.9 289.5 341.5 275.7 344.1 263.6 346.3 253.5 346.9 243.8 339.1 232 329.1 231.8 312.7 242.4 302.3 250.8 294.3 262.7 292.7 280.4 289.5 283.4 289 286 288.3 288.1 285.8 291.3 282.2 290.3 283.8 290.3 205 290.3 199.4 287.6 197.9 281.9 198.9 277.9 199.6 190 216 190 216 185 217.1 183.3 218.6 183.3 224.3 183.3 340.4 183.8 335.1 182.1 342.8 180 351.8 174.5 358.6 167.2 362.4 158.9 367 143.8 369 135.8 367.6 114.4 363.6 106.9 338.9 121.4 324.7 129.8 316.7 141.7 315.1 159.4 311.9 162.4 311.4 165 310.7 167.1 308.2 172.1 302.5 168 181.2 169.7 174.5 170.1 171.9 171.2 169.7 173.2 168.1 175.3 166.4 179 165.4 179.9 165.4 280.9 146.4 293.2 144 295 144 300.7 143.6 304 147 304 152.7 303.9 323.3 304.4 314.1 303 320.3zM345.2 32H102.8C45.9 32 0 77.9 0 134.8V377.2C0 434.1 45.9 480 102.8 480H345.2C402.2 480 448 434.1 448 377.2V134.8C448 77.9 402.1 32 345.2 32zM223.6 444C117.3 444 31.1 357.8 31.1 251.5S117.3 59 223.6 59 416.1 145.2 416.1 251.5 329.9 444 223.6 444z"}]}}),H.register({"brands/jenkins":{width:512,height:512,paths:[{d:"M487.1 425C485.7 413.8 468.1 401.9 458.9 393.1 453.8 388.1 429.9 370 428.5 363.2 427.1 356.6 438.2 341.7 441.8 334.3 446.9 323.6 450.6 310.6 453.1 301.7 471.9 235.6 473.8 144.8 446.9 90.5 436.7 69.9 408.3 41.5 390.5 28 348.5-3.7 270.9-7.3 220.4 11.4 206.3 16.6 192.6 21.2 180.3 28.5 147.2 47.9 112 61 102.2 100.1 78 110.9 70.7 141.9 71.9 177.9 72.1 184.9 76 193.7 74.6 200.3 73.9 203.6 69.4 207.9 68.5 210.1 56.9 237.8 66.2 274.1 79.6 293.8 87.7 305.7 101.1 316.2 118.8 319 119.5 329.6 122.1 338.7 127 349.4 130.1 356.2 141.7 368.4 137.4 377.1 135.2 381.5 116.4 390.9 110.1 394.7 89 407.2 73.7 415 54.2 429 41.6 438 21.9 439.2 25 460.1 27.1 474.2 35.1 491.7 39.7 505.9 40.4 507.9 41.1 510 41.8 511.9H463.8C468.7 496.6 473.5 481 478.4 464.7 481.8 453.3 488.6 436.9 487.1 425zM205.9 33.7C207.7 33.2 209.3 34.4 210.8 36.1 210.6 41.3 205.4 41.2 201.9 42.9 196.5 49.6 188.5 52.7 181.9 60.1 175.1 67.6 167.5 87.8 158.5 90.1 154 91.2 148.8 89.3 144.9 89.6 134.5 90.3 127.2 95.6 116.6 97.1 130.2 67.2 172.7 43.1 205.9 33.7zM101.1 127.3C114.6 112.4 133.2 103.2 155.9 101.4 167.6 131.1 147.5 166.4 155 199 157.3 208.9 165.2 224.4 152.6 224.7 152.9 196.4 117.8 178.4 91.3 195.1 89.5 173.6 86.4 143.4 101.1 127.3zM137.8 327.5C136.8 323.4 135.1 314.6 135.5 312.4 137.1 303.7 152.6 299.9 146.5 287.7 135.2 287.6 132.7 297.9 122.4 299 95.7 301.6 76.8 263.6 78 240.6 79 221.1 95.6 202.4 118.1 204.8 134.1 206.6 139.5 224 142.6 239.5 151.8 240 165.1 239.1 169.5 231.9 168.9 214.4 160.7 200.3 161.3 184.2 162.3 153.9 178.8 126.6 166.1 96.8 179.7 65.9 219.6 41.5 249.2 26.8 285.8 8.5 344.1 23.1 378.5 42.6 398.2 53.7 412.9 75.3 426.8 93.3 407.3 87.5 390.7 97.5 393.7 113.6 410 98.7 437.9 113.4 446.2 130 454.1 145.8 454 169.3 455.2 192.8 458.1 249.8 444.8 308.7 416.1 349.9 408.4 360.9 402 372.9 391.2 380.5 365.2 398.7 325.8 415.2 292 403.9 247.3 388.9 227 359.1 202.5 325.1 203.2 343.8 216.3 359.2 229.3 373.5 240.6 386 254.3 400.1 269 405.9 256.7 403 237.9 402.1 232.8 413.1 204.2 411.2 177.7 408.3 164.1 388.9 153.5 373.5 142.7 347.5 137.8 327.5zM359.8 451.6C363.9 448.6 370.9 448.7 377.2 448 371.8 445.3 364.2 444.3 357.9 445.8 357.8 441.6 355.9 439 354.7 435.6 365.3 431.8 390.2 407.1 404.3 415.3 411 419.2 413.8 441.5 414.4 452.3 414.8 461.3 413.6 470.3 409.9 475.1 391.1 474.5 374.1 472.3 359.2 468.1 360.1 462 358.2 456 359.8 451.6zM342.6 431.6C325.8 432.4 316.6 430.4 304.3 420.8 304.5 420 305.7 420.3 305.8 419.4 323.8 427.4 346.6 416.1 364.8 414.5 356.9 419.6 350.2 426.1 342.6 431.6zM330.5 464.8C328.9 455.4 327 452.8 327.7 444.6 352.7 428 357.4 473.2 330.5 464.8zM226 438.6C214.4 437.9 177.9 424.6 187.5 414.9 196.9 421.4 215 419.8 228.8 422.2 229.6 426.6 226 432.4 226 438.6zM57.7 497.1C53.4 484.4 48.5 472 42.9 460.2 73.7 436.4 108.2 411.3 145.1 396.7 147.9 395.6 168.3 422.1 171.3 424.3 187.8 436 208.3 445.3 227.5 454.5 228.7 463.3 231.4 474.7 236.2 490 236.9 492.3 237.6 494.7 238.4 497.2H57.7zM298.3 502.8H297.5C297.8 502.6 298 502.4 298.3 502.3V502.8zM305.8 497.1C307.9 495.7 310.1 494.3 312.2 492.8 313.3 494.2 314.4 495.6 315.4 497.1H305.8zM320.9 472.4C310.1 479.7 300.3 490.7 287.6 497.6 281.6 500.9 260.6 509.3 254.2 507.8 250.6 507 250.3 502.5 248.8 498.3 245.7 489.3 238.7 474.9 238 461.3 237.2 444.1 235.5 415.3 254 418.9 268.9 421.8 286.3 428.6 297.9 435 305 438.9 309 443.6 319.8 444.5 319.7 445.9 319.7 447.3 319.6 448.8 313.7 452.7 304.3 452.6 297.8 455.9 307.3 456.3 314.8 458.6 321.3 461.8 321.2 465.2 321 468.8 320.9 472.4zM374.3 497.1H360.3C360.2 493.9 357.5 491.3 354.2 491.3S348.3 493.9 348.1 497.1H330.7C327.9 492.7 325 488.5 321.8 484.6 323.9 482.4 325.8 479.9 327.8 477.7 336.8 481.4 342.6 472.8 349.5 473.5 357.4 474.3 363.7 485.2 374.9 484.5L374.3 497.1zM383 497.1C383.2 493.1 383.4 489.3 383.6 485.6 399.2 478.3 412.6 486.9 419.3 497.1H383zM466.4 460.1C464.1 471.3 460.6 484.1 456.5 497.2 456.3 497.1 456.1 497.1 455.9 497.1H428C428.6 496 429.2 494.9 429.9 493.8 427.3 487.7 420.9 485.1 419 478.3 431.1 455.6 425.5 384.9 394.8 399.8 399.1 393.5 410.4 388.3 415.6 380.5 428.6 390.9 436.4 400.8 448.8 411.9 455.6 417.9 468.8 425.2 470.2 435 471 440.5 467.6 453.9 466.4 460.1zM222.2 130.5C227.6 115.6 249.4 95.8 267.2 98.5 274.9 99.7 285.2 106.7 279.4 116.2 249.2 109.2 234.2 128.8 225 149.3 216.9 147.3 220.1 136.2 222.2 130.5zM406.3 193.6C414.5 190 428.7 192.9 435.9 188.3 431.7 176.8 425.6 166.9 426.6 150.6 427.1 150.6 427.6 150.6 428 150.7 434.8 164.9 440.7 179.9 449.4 192.4 443.7 205.9 405.8 217.8 406.3 193.6zM426.7 150.6zM309.5 196.3C302.7 185.4 290.5 163.8 295 151 301.5 162.9 303.6 175.4 312.8 184.3 316.9 188.3 325 193.3 321 204.5 320.1 207.2 313.2 213.1 309.3 214.2 294.9 218.5 261.4 215.1 272.7 197.1 284.6 197.8 300.6 204.9 309.5 196.3zM336.8 266.3C340.6 272.9 338.2 285 348.9 286.9 369.1 290.3 392.5 274.6 407 269.1 416 253.9 406.2 248.4 398.1 238.6 381.5 218.6 359.3 193.8 360.1 163.9 366.8 159 367.4 171.3 368.3 173.6 377 193.9 398.7 219.8 414.6 237.1 418.5 241.4 424.9 245.5 425.6 248.3 427.7 256.5 420.2 266.3 421.1 271.8 399.4 285.7 375.3 300.9 339.7 297.4 332.3 290.7 329.4 276 336.8 266.3zM135.5 257.1C128.7 253.2 127.1 236.1 119.1 235.7 107.7 235 109.8 257.9 109.8 271.2 102 264.1 100.6 242.1 106.3 230.9 99.7 227.7 96.8 234.5 93.2 236.8 97.9 202.7 143 221 135.5 257.1zM435.1 285.9C425 305.1 410.7 326.3 381.1 326.9 380.5 320.7 380 311.3 381.1 307.5 403.8 305.3 417.7 293.8 435.1 285.9zM293.2 298.3C312.1 308.2 346.8 309.3 372.5 308.5 373.9 314.1 373.8 321.1 373.9 327.9 340.9 329.7 301.9 321.5 293.2 298.3zM385.4 345C383.7 349.3 380.1 354.3 375.6 356.1 363.5 361 330 364.8 313.2 355.8 302.5 350.1 295.7 337.3 289.8 329.8 287 326.2 272.9 316.9 289.6 316.9 302.7 349.6 347.6 345.9 385.4 345z"}]}}),H.register({"brands/joget":{width:496,height:512,paths:[{d:"M227.5 468.7C218.5 455.1 207.6 435.4 203.8 426.3 198.1 412.6 176.6 380.7 235 359.2 286.7 340.1 411.7 342.7 443.8 341.6 439.8 350.6 435.2 359.5 429.9 368.2 389.5 433.7 319.5 469.7 247.9 469.7 241.1 469.7 234.3 469.3 227.5 468.7M66.1 143.9C128 43.4 259.6 12.2 360.1 74.1 434.9 120.2 471.3 205 459.4 286.8 434.5 286.3 280.1 283.2 229.1 281.9 173.6 280.5 147.4 261.1 170.6 233.7 193.8 206.3 221.7 193 239.5 182.5 257.4 172 266.8 148.8 215.9 152.8 87.3 161.5 48.6 252.1 37.6 293 28.8 243.3 37.5 190.3 66.1 143.9M36.9 125.9C-35 242.5 1.3 395.2 117.9 467.1 234.5 539 387.2 502.7 459.1 386.2 531 269.6 494.7 116.8 378.1 45 337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9M281.3 236.3C249.8 256.8 216 267.6 216 267.6L385.5 266 432 242.6S435.6 233.1 412.9 227.1C390.2 221.1 355.9 238.4 326.2 254.3 296.5 270.1 295.1 262.5 295.1 262.5S335.3 234.4 345.8 228C356.3 221.6 377.7 214 359.2 203.4 356 201.6 352.5 200.7 348.8 200.7 331 200.7 307.3 219.4 281.3 236.3"}]}}),H.register({"brands/joomla":{width:448,height:512,paths:[{d:"M0.6 92.1C0.6 58.8 27.4 32 60.4 32 90.4 32 114.9 53.9 119.6 82.2 152.2 74.6 186.7 82.8 216.1 112.2L171.8 156.5C151.3 136 129.2 140.2 116.4 153 102.1 167.3 102.1 190.9 116.4 205.2L215.9 304.7 171.9 349C84.2 261.8 122.2 299.3 72.1 249.3 45.3 222.8 37.1 184.5 47.3 150.4 20.4 144.6 0.6 120.7 0.6 92.1zM130.1 208.5L174.4 252.8C184.4 242.8 264.1 163.1 274.1 153 288.4 138.7 311.7 138.7 326 153 338.8 165.8 343 188 322.5 208.4L366.5 252.7C397.7 221.5 405 185.1 395.4 151.5 424.6 147.4 447.3 122.3 447.3 92 447.3 58.8 420.5 31.9 387.5 31.9 357.2 31.9 332.1 54.4 328 83.5 294.2 73.6 256.3 82 229.7 108.6 211.4 127.7 158.6 180.1 130.1 208.5zM396.4 360.7C404.6 328 395.5 292.2 370.1 266.8 358.3 254.6 375.1 271.5 270.6 167.1L226.3 211.4 326 311.1C340.3 325.4 340.3 348.7 326 363 313.2 375.8 291 380 270.6 359.5L226.6 403.8C254.2 434 294.6 442.6 329.3 431.8 334.8 459.2 359 479.9 388.2 479.9 421.2 479.9 448 453.1 448 419.8 448 389.6 425.5 364.8 396.4 360.7zM312.1 307.6L268.1 263.3C181.1 349.7 217.7 313.7 168.4 363.1 154.1 377.4 130.8 377.4 116.5 363.1 103.4 349.7 99.6 327.8 119.7 307.7L75.7 263.4C45.5 293.6 37.7 328.6 46.2 361.7 19.5 367.7 0 391.6 0 419.9 0 453.2 26.8 480 59.8 480 88.4 480 112.3 460.2 118.4 433.3 151.1 441.5 186.9 432.7 212.6 407.3 244.7 375.3 224.8 394.9 312.1 307.6z"}]}}),H.register({"brands/js-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM243.8 381.4C243.8 425 218.2 444.9 180.9 444.9 147.2 444.9 127.7 427.5 117.7 406.4L152 385.7C158.6 397.4 164.6 407.3 179.1 407.3 192.9 407.3 201.7 401.9 201.7 380.8V237.7H243.8V381.4zM343.4 444.9C304.3 444.9 279 426.3 266.7 401.9L301 382.1C310 396.8 321.8 407.7 342.5 407.7 359.9 407.7 371.1 399 371.1 386.9 371.1 372.5 359.7 367.4 340.4 358.9L329.9 354.4C299.5 341.5 279.4 325.2 279.4 290.9 279.4 259.3 303.5 235.3 341 235.3 367.8 235.3 387 244.6 400.8 269L368 290C360.8 277.1 353 272 340.9 272 328.6 272 320.8 279.8 320.8 290 320.8 302.6 328.6 307.7 346.7 315.6L357.2 320.1C393 335.4 413.1 351.1 413.1 386.3 413.1 424.1 383.3 444.9 343.4 444.9z"}]}}),H.register({"brands/js":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM243.8 381.4C243.8 425 218.2 444.9 180.9 444.9 147.2 444.9 127.7 427.5 117.7 406.4L152 385.7C158.6 397.4 164.6 407.3 179.1 407.3 192.9 407.3 201.7 401.9 201.7 380.8V237.7H243.8V381.4zM343.4 444.9C304.3 444.9 279 426.3 266.7 401.9L301 382.1C310 396.8 321.8 407.7 342.5 407.7 359.9 407.7 371.1 399 371.1 386.9 371.1 372.5 359.7 367.4 340.4 358.9L329.9 354.4C299.5 341.5 279.4 325.2 279.4 290.9 279.4 259.3 303.5 235.3 341 235.3 367.8 235.3 387 244.6 400.8 269L368 290C360.8 277.1 353 272 340.9 272 328.6 272 320.8 279.8 320.8 290 320.8 302.6 328.6 307.7 346.7 315.6L357.2 320.1C393 335.4 413.1 351.1 413.1 386.3 413.1 424.1 383.3 444.9 343.4 444.9z"}]}}),H.register({"brands/jsfiddle":{width:576,height:512,paths:[{d:"M510.6 237.5C505.9 234.8 505 231.7 504.3 226.7 501.9 210.2 500.7 193.1 495.2 177.6 459.3 77.6 341.2 34.2 248.3 85.9 220.9 101.2 199.3 122.3 182.8 149.8 179.6 148.3 177.4 147.1 175 146.2 144.9 133.7 115.9 136 89.7 155.3 64.1 174.1 53.2 199.9 57 231.7 57.3 234.8 55 239.4 52.5 241.3 12.8 271.3-3.6 319.3 10.6 365.9 24.4 411.5 68.1 445.7 116.2 447.3 146.5 448.4 176.8 447.9 207.1 447.9 291.2 447.8 375.2 448.4 459.3 447.4 511.9 446.8 555.4 410.5 567.5 360.1 579 312 556.3 262.8 510.6 237.5zM531.7 394.3C513.5 416.8 489.4 429.6 460.5 430 403.6 430.8 346.7 430.2 289.8 430.2 289.8 430.9 126.8 430.4 126.1 430.4 82.2 430 49.3 410.6 30.9 370.4 12 329.1 26.9 279.5 65.1 254.3 74.3 248.2 77.6 242.7 75.2 231.1 69.7 204.8 79.6 183.2 101.6 168.2 124.6 152.4 149 152 173.6 165.1 183.9 170.5 188.2 176.6 195.8 162.5 210.1 136.1 230.4 115.8 256.5 101.3 354 46.9 484.9 108.8 486.8 234 486.9 242.1 489.2 246.4 496.6 249.8 554.2 276.7 571.1 346 531.7 394.3zM444 313.8C438.1 345 409.3 368.9 377.3 368.9 360.3 368.9 345.2 362.4 333.2 351.2 305.5 325.5 262.1 276.3 237.3 257.8 217.2 243 195.3 245.5 177 261.6 127 305.7 192.9 383.4 244.1 338.8 248.6 334.9 251.9 329.3 256.8 326 265 320.5 277.6 325.1 270 336.6 252.6 362.9 220.6 374.8 191.1 365.9 162.2 357.2 142.3 329.9 142.5 295.7 143.7 273.2 154.8 252.7 177.9 239.8 200.5 227.1 224.3 226.6 244.9 242.2 295.7 280.7 320.5 324 352.2 343.5 376.7 358.6 406.4 350.8 421 326 449.8 276.8 386.4 220.9 342.1 262.5 338.2 266.2 335.2 271.4 330.7 274.2 319.8 281 313.4 270.1 317.9 263.9 338.6 235.3 368.4 223.4 401.2 235.7 432.6 247.4 450.3 280 444 313.8z"}]}}),H.register({"brands/keycdn":{width:512,height:512,paths:[{d:"M63.8 409.3L124.3 350.3C156.4 393.1 195.4 416.3 250.9 417.7 281.4 418.4 311.2 410.7 337.3 395.3 342.4 400.6 355.8 414.8 358.2 417.3 326 438 288.6 448.4 250.1 447.5 206.8 446.4 165.5 430.8 132.4 403.1 132.7 402.5 94.2 440.6 93.8 441 103.3 470.8 80.7 503.4 47.5 503.4 20.7 503.3 0 481.7 0 454.9 0 420.6 33.1 398.3 63.8 409.3zM418.7 156.9C437.8 188.2 448.3 224.3 447.4 260.9 446.3 305.7 428.4 348.4 398.8 381.9 399.1 382.2 422.6 407.1 422.9 407.4 432.5 406.1 442.1 409.4 448.8 416.5 460.1 428.5 459.7 447.4 447.7 458.9 435.7 470.2 416.8 469.8 405.3 457.8 398.6 450.8 395.9 441 397.7 431.5 372.8 404.9 353.3 384.3 353.3 384.3 396 350.2 416.6 304.7 417.7 260.1 418.4 231.2 410.5 202.9 396.6 177.9L418.7 156.9zM104 53.1C110.7 60.1 113.4 69.9 111.6 79.4L157.5 127.5C152.8 131.3 144.2 137.9 134.7 148.8 109.3 177.3 95.1 213.6 94 251.7 93.3 280.6 100.1 308.9 114 334.1L92 355.6C72.7 324 63.1 287.9 64.2 250.9 65.2 206.3 82.5 163.3 111.7 129.8L86.4 103.4C76.8 104.7 67.2 101.4 60.5 94.3 49.2 82.3 49.6 63.4 61.6 51.9 73.5 40.7 92.2 41 104 53.1zM464.9 8C490.9 8 512 30.4 512 56.3S490.9 104 464.9 104C458.6 104.1 450.9 102.9 449 102.2L386.1 161.9C353.4 118.3 309.4 96 259.2 94.7 228.7 94 198.9 101.5 173 117.1L151.9 95.1C184.1 74.3 221.5 64 260 64.9 303.3 66 344.6 81.6 377.7 109.5L418.8 70.9C417.3 66.2 416.6 61.3 416.6 56.4 416.5 29.7 438.9 8 464.9 8zM256.7 113.4C262.2 113.4 267.6 113.8 273.1 114.5 351.2 124.3 406.5 195.6 396.9 273.6 387.1 351.7 315.8 407 237.8 397.4 159.7 387.6 104.4 316.3 114 238.2 123.3 165.8 184.1 113.6 256.7 113.4zM197.7 232.8C198.3 255.5 209.9 274.6 230.1 285L219.1 336.7H292.8L281.8 285C301.9 274.1 313.9 256 314.2 232.8 313.8 200 288.4 175.3 255.9 174.5 223.8 175.3 198.6 199.3 197.7 232.8zM256 160"}]}}),H.register({"brands/kickstarter-k":{width:384,height:512,paths:[{d:"M147.3 114.4C147.3 58.2 114.8 32 73.9 32 26.2 32 0 68.2 0 113.4V396.4C0 443.7 25.3 479.8 74.9 479.8 114.7 479.8 147.3 454.2 147.3 396.4V319.9L259.4 458.2C282.1 485.4 331.5 488.9 362.6 458.2 389.6 430.6 389.9 390.8 370 366L279.2 251.2 354.1 143.8C371.5 119.1 371.6 80.7 343.7 54 313.4 25 261.3 22.4 230.1 66.8L147.3 185V114.4z"}]}}),H.register({"brands/kickstarter":{width:448,height:512,paths:[{d:"M400 480H48C21.6 480 0 458.4 0 432V80C0 53.6 21.6 32 48 32H400C426.4 32 448 53.6 448 80V432C448 458.4 426.4 480 400 480zM199.6 178.5C199.6 147.8 182 133.4 159.9 133.4 134.1 133.4 119.9 153.2 119.9 177.9V332.7C119.9 358.5 133.6 378.3 160.4 378.3 181.9 378.3 199.6 364.3 199.6 332.7V290.9L260.2 366.6C272.5 381.5 299.2 383.4 316 366.6 330.6 351.5 330.8 329.8 320 316.2L270.9 253.4 311.4 194.7C320.8 181.2 320.9 160.2 305.8 145.6 289.4 129.7 261.2 128.3 244.4 152.6L199.6 217.3V178.5z"}]}}),H.register({"brands/korvue":{width:446,height:512,paths:[{d:"M386.5 34H59.5C26.8 34 0 60.8 0 93.5V420.6C0 453.2 26.8 480 59.5 480H386.6C419.6 480 446.1 453.2 446.1 420.5V93.5C446 60.8 419.2 34 386.5 34zM87.1 120.8H183.1V236.8L244.9 120.8H355.8L274.6 252.8H87.1V120.8zM248.9 392.9L183.2 279.3V392.9H87.2V262.1H278.7L367.3 392.9H248.9z"}]}}),H.register({"brands/laravel":{width:640,height:512,paths:[{d:"M637.5 241.6C633.3 236.8 574.7 163.5 564.4 151.1 554.1 138.7 549 140.9 542.7 141.8 536.3 142.7 462.2 155.2 453.6 156.6 445 158.1 439.6 161.5 444.9 168.9 449.6 175.5 498.3 244.6 509.1 259.8L315.4 306.2 161.2 48.7C155.1 39.6 153.8 36.4 139.8 37.1 125.8 37.7 18.9 46.6 11.3 47.3 3.7 47.9-4.7 51.3 2.9 69.3S131.9 348.9 135.3 356.5C138.7 364.1 147.5 376.5 168.1 371.5 189.2 366.4 262.4 347.3 302.4 336.8 323.5 375.1 366.6 452.7 374.6 463.8 385.2 478.7 392.6 476.2 408.9 471.2 421.7 467.3 608.5 400.1 616.9 396.7 625.3 393.2 630.5 390.8 624.8 382.3 620.6 376.1 571.3 310.1 545.5 275.5 563.2 270.8 626.1 254.1 632.8 252.2 640.7 250.2 641.8 246.4 637.5 241.6zM285.3 313.6C283 314.1 174.5 340.1 168.7 341.4 162.9 342.7 162.9 342.1 162.2 340.1 161.5 338.1 33.2 73.4 31.4 70.1 29.6 66.8 29.7 64.2 31.4 64.2S133.9 55.2 137.4 55C141 54.8 140.6 55.6 141.9 57.8 141.9 57.8 284.1 303.2 286.5 307.5 289.1 311.8 287.6 313.1 285.3 313.6zM591.3 371C593 373.7 594.8 375.5 589.3 377.4 583.9 379.4 405.6 439.5 402.2 441 398.7 442.5 396 443 391.6 436.5S329.2 329.7 329.2 329.7L518 280.6C522.7 279.1 524.2 278.1 527.2 282.8 530.1 287.6 589.6 368.3 591.3 371zM603.4 236.9C599.2 237.8 529.8 255 529.8 255L473.1 177.2C471.5 174.9 470.2 172.7 474.2 172.2S542.6 160 545.5 159.4C548.4 158.7 550.9 157.9 554.5 162.8 558.1 167.7 607.1 229.8 609 232.2 610.8 234.5 607.6 235.9 603.4 236.9z"}]}}),H.register({"brands/lastfm-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM307.8 344.9C244.4 344.9 222.4 316.3 210.7 280.8 194.4 229.8 189.2 196.5 147.7 196.5 125.3 196.5 102.6 212.6 102.6 257.7 102.6 292.9 120.6 314.9 145.9 314.9 174.5 314.9 193.5 293.6 193.5 293.6L205.2 325.5S185.4 344.9 144 344.9C92.7 344.9 64.1 314.8 64.1 259.1 64.1 201.2 92.7 167.1 146.6 167.1 220.1 167.1 227.4 208.5 247.4 269 256.2 295.8 271.6 315.2 308.6 315.2 333.5 315.2 346.7 309.7 346.7 296.1 346.7 276.2 324.9 274.1 296.8 267.5 266.4 260.2 254.3 244.4 254.3 219.5 254.3 179.5 286.6 167.1 319.5 167.1 356.9 167.1 379.6 180.7 382.5 213.7L345.8 218.1C344.3 202.3 334.8 195.7 317.2 195.7 301.1 195.7 291.2 203 291.2 215.5 291.2 226.5 296 233.1 312.1 236.8 344.8 243.9 383.9 248.8 383.9 294.3 384 331 353.2 344.9 307.8 344.9z"}]}}),H.register({"brands/lastfm":{width:512,height:512,paths:[{d:"M225.8 367.1L207 316.1S176.5 350.1 130.8 350.1C90.3 350.1 61.6 314.9 61.6 258.6 61.6 186.5 98 160.7 133.7 160.7 200.2 160.7 208.5 214 234.6 295.6 253.4 352.5 288.6 398.2 390 398.2 462.7 398.2 512 375.9 512 317.3 512 244.4 449.3 236.7 397 225.2 371.2 219.3 363.6 208.8 363.6 191.2 363.6 171.3 379.4 159.5 405.2 159.5 433.4 159.5 448.6 170.1 450.9 195.3L509.5 188.3C504.8 135.5 468.4 113.8 408.6 113.8 355.8 113.8 304.2 133.7 304.2 197.7 304.2 237.6 323.6 262.8 372.2 274.5 417.1 285.1 452 288.3 452 320.2 452 341.9 430.9 350.7 391 350.7 331.8 350.7 307.1 319.6 293.1 276.8 261.1 180 249.5 113.8 131.8 113.8 45.7 113.8 0 168.3 0 261 0 350.1 45.7 398.2 127.9 398.2 194.1 398.2 225.8 367.1 225.8 367.1z"}]}}),H.register({"brands/leanpub":{width:576,height:512,paths:[{d:"M386.5 111.5L401.6 360.4 390.7 360.2C354.4 359.3 319 368.9 288 388.2 257 368.9 221.6 360.2 185.3 360.2 139.8 360.2 103.3 370.9 61.8 387.9L93.1 129.6C121.7 117.8 154.6 111.5 185.3 111.5 226.5 111.5 259.2 124.7 288 154 315.7 125.8 347 112.3 386.5 111.5zM569.1 448C543.5 448 521.6 442.8 498.5 432.4 464.2 416.7 428.5 407.4 390.7 407.4 351.7 407.4 315.7 420.3 288 448 260.3 420.3 224.3 407.4 185.3 407.4 147.5 407.4 111.8 416.7 77.5 432.4 55.2 442.2 32.7 448 8.3 448H6.9L49.5 98.9C88.7 76.6 136.5 64 181.8 64 218.8 64 257 71.7 288 93.1 319 71.7 357.2 64 394.2 64 439.5 64 487.3 76.6 526.5 98.9L569.1 448zM525.7 403.3L491.7 123C460.9 109 424.4 101.6 390.7 101.6 352.2 101.6 316.3 113.7 288 140.3 259.7 113.7 223.8 101.6 185.3 101.6 151.6 101.6 115.1 109 84.3 123L50.3 403.3C97.5 383.8 133.2 369.8 185.3 369.8 222.9 369.8 256.2 379.4 288 399.4 319.8 379.4 353.1 369.8 390.7 369.8 442.8 369.8 478.5 383.8 525.7 403.3z"}]}}),H.register({"brands/less":{width:640,height:512,paths:[{d:"M612.7 219C612.7 198.5 615.9 186.4 615.9 164.4 615.9 130.2 603.3 119.2 575.4 119.2H554.9V143.4H561.2C575.4 143.4 578.5 148.1 578.5 165.5 578.5 181.8 576.9 198.1 576.9 217 576.9 241.2 584.8 250.6 600.5 254.3V255.9C584.7 259.6 576.9 269 576.9 293.2 576.9 312.1 578.5 327.4 578.5 344.7 578.5 362.6 574.8 367.3 561.2 367.3V367.8H554.9V393H575.4C603.2 393 615.9 382 615.9 347.8 615.9 325.2 612.7 313.6 612.7 293.2 612.7 282.2 619.5 270.6 640 269.6V242.3C619.5 241.6 612.7 230 612.7 219zM507.1 251C491.3 244.7 476.6 241 476.6 230.5 476.6 222.6 482.9 217.9 494.5 217.9S516.6 222.6 528.1 231L549.1 203.2C536 193.2 518.1 182.7 493.9 182.7 458.2 182.7 434 203.2 434 232.1 434 257.8 456.6 271 475.5 278.3 491.8 284.6 507.6 289.9 507.6 300.4 507.6 308.3 501.3 313.5 487.1 313.5 474 313.5 460.8 308.2 446.6 297.2L425.6 327.7C441.4 340.8 465.5 349.8 485.5 349.8 527.5 349.8 550.1 327.7 550.1 298.8S527.6 257.8 507.1 251zM148.2 310.4C144.5 310.4 139.8 307.2 139.8 297.3V119.1H65.2C36.8 119.1 24.2 130.1 24.2 164.3 24.2 186.9 27.4 199.5 27.4 218.9 27.4 229.9 20.6 241.5 0.1 242.5V269.8C20.6 270.3 27.4 281.9 27.4 292.9 27.4 312.3 24.2 323.9 24.2 346.5 24.2 380.7 36.8 391.7 64.7 391.7H85.2V367.5H78.9C65.8 367.5 61.6 362.2 61.6 344.9S63.2 312.8 63.2 293.4C63.2 269.2 55.3 259.8 39.6 256.1V254.5C55.4 250.8 63.2 241.4 63.2 217.2 63.2 198.3 61.6 183 61.6 165.7S65.3 143.6 78.9 143.6H93V294.4C93 326.5 104 347.5 136.1 347.5 146.1 347.5 154 345.9 159.7 343.8L154.4 309.6C151.3 310.4 149.8 310.4 148.2 310.4zM379.9 251C363.6 244.7 348.9 241 348.9 230.5 348.9 222.6 355.2 217.9 366.8 217.9 378.4 217.9 388.9 222.6 400.4 231L421.4 203.2C408.3 193.2 390.4 182.7 366.2 182.7 330.5 182.7 306.3 203.2 306.3 232.1 306.3 257.8 328.9 271 347.8 278.3 364.1 284.6 379.9 289.9 379.9 300.4 379.9 308.3 373.6 313.5 359.4 313.5 346.3 313.5 333.1 308.2 318.9 297.2L298.4 327.7C314.2 340.8 338.3 349.8 358.3 349.8 400.3 349.8 422.9 327.7 422.9 298.8 423 269.9 400.4 257.8 379.9 251zM224.9 182.2C186.5 182.2 149.8 214.3 150.8 264.7 150.8 316.7 185 347.2 230.1 347.2 249 347.2 270 340.4 286.3 329.3L270.5 301.5C258.9 308.3 247.9 311.5 236.3 311.5 215.3 311.5 199 301.5 194.8 277.3H290C290.5 273.6 291.6 266.3 291.6 257.9 292.2 215.3 269 182.2 224.9 182.2zM194.9 248.4C198.1 227.4 210.7 217.4 225.4 217.4 244.3 217.4 251.7 230.5 251.7 248.4H194.9z"}]}}),H.register({"brands/line":{width:448,height:512,paths:[{d:"M272.1 204.2V275.3C272.1 277.1 270.7 278.5 268.9 278.5H257.5C256.4 278.5 255.4 277.9 254.9 277.2L222.3 233.2V275.4C222.3 277.2 220.9 278.6 219.1 278.6H207.7C205.9 278.6 204.5 277.2 204.5 275.4V204.3C204.5 202.5 205.9 201.1 207.7 201.1H219C220 201.1 221.1 201.6 221.6 202.5L254.2 246.5V204.3C254.2 202.5 255.6 201.1 257.4 201.1H268.8C270.6 201 272.1 202.5 272.1 204.2zM190.1 201H178.7C176.9 201 175.5 202.4 175.5 204.2V275.3C175.5 277.1 176.9 278.5 178.7 278.5H190.1C191.9 278.5 193.3 277.1 193.3 275.3V204.2C193.3 202.5 191.9 201 190.1 201zM162.6 260.6H131.5V204.2C131.5 202.4 130.1 201 128.3 201H116.9C115.1 201 113.7 202.4 113.7 204.2V275.3C113.7 276.2 114 276.9 114.6 277.5 115.2 278 115.9 278.4 116.8 278.4H162.5C164.3 278.4 165.7 277 165.7 275.2V263.8C165.7 262.1 164.3 260.6 162.6 260.6zM332.1 201H286.4C284.7 201 283.2 202.4 283.2 204.2V275.3C283.2 277 284.6 278.5 286.4 278.5H332.1C333.9 278.5 335.3 277.1 335.3 275.3V263.9C335.3 262.1 333.9 260.7 332.1 260.7H301V248.7H332.1C333.9 248.7 335.3 247.3 335.3 245.5V234C335.3 232.2 333.9 230.8 332.1 230.8H301V218.8H332.1C333.9 218.8 335.3 217.4 335.3 215.6V204.2C335.2 202.5 333.8 201 332.1 201zM448 113.7V399C447.9 443.8 411.2 480.1 366.3 480H81C36.2 479.9-0.1 443.1 0 398.3V113C0.1 68.2 36.9 31.9 81.7 32H367C411.8 32.1 448.1 68.8 448 113.7zM386.4 236.3C386.4 163.3 313.2 103.9 223.3 103.9 133.4 103.9 60.2 163.3 60.2 236.3 60.2 301.7 118.2 356.5 196.6 366.9 215.7 371 213.5 378 209.2 403.7 208.5 407.8 205.9 419.8 223.3 412.5 240.7 405.2 317.2 357.2 351.5 317.8 375.1 291.8 386.4 265.5 386.4 236.3z"}]}}),H.register({"brands/linkedin-in":{width:448,height:512,paths:[{d:"M100.3 480H7.4V180.9H100.3V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32 83.5 32 107.6 56.1 107.6 85.8 107.6 115.5 83.5 140.1 53.8 140.1zM448 480H355.3V334.4C355.3 299.7 354.6 255.2 307 255.2 258.7 255.2 251.3 292.9 251.3 331.9V480H158.5V180.9H247.6V221.7H248.9C261.3 198.2 291.6 173.4 336.8 173.4 430.8 173.4 448.1 235.3 448.1 315.7V480z"}]}}),H.register({"brands/linkedin":{width:448,height:512,paths:[{d:"M416 32H31.9C14.3 32 0 46.5 0 64.3V447.7C0 465.5 14.3 480 31.9 480H416C433.6 480 448 465.5 448 447.7V64.3C448 46.5 433.6 32 416 32zM135.4 416H69V202.2H135.5V416zM102.2 173C80.9 173 63.7 155.7 63.7 134.5S80.9 96 102.2 96C123.4 96 140.7 113.3 140.7 134.5 140.7 155.8 123.5 173 102.2 173zM384.3 416H317.9V312C317.9 287.2 317.4 255.3 283.4 255.3 248.8 255.3 243.5 282.3 243.5 310.2V416H177.1V202.2H240.8V231.4H241.7C250.6 214.6 272.3 196.9 304.6 196.9 371.8 196.9 384.3 241.2 384.3 298.8V416z"}]}}),H.register({"brands/linode":{width:448,height:512,paths:[{d:"M437.4 226.3C437.1 225.4 436.5 224.9 436 224.3L366 185.7C365.1 185.1 364 185.1 362.9 185.7L304 221.7C303.1 222.3 302.6 223.4 302.6 224.3L301.7 255.7 277.7 239.7C276.8 239.1 275.4 239.1 274.6 239.7L240 260.9 238.6 225.8C238.6 224.9 238 223.8 237.2 223.5L201.2 199.2 234.9 181.8C236 181.2 236.6 180.1 236.6 178.9L230.9 46.6C230.9 45.7 230 44.6 229.2 44L138.6 0.3C137.7 0 136.9 0 136.3 0L12.6 38.6C11.2 39.2 10.3 40.6 10.6 42.3L38 175.4C38.9 178.8 72 202.8 76.6 206.3L49.7 219.2C48.3 220.1 47.7 221.5 48 222.6L68.6 322.9C69.2 325.8 92.3 346 95.7 349.2L78.3 359.8C77.4 360.4 76.6 361.8 76.9 362.9 78.3 370 92.3 440.6 93.8 442L158.9 511.1C159.5 511.7 160.3 511.7 161.2 512 161.8 512 162.3 511.7 162.9 511.4L246.6 444.5C247.5 443.9 247.7 443.1 247.7 442.2L245.7 396.2 273.7 419.9C274.8 420.8 276.6 420.8 277.7 419.9L344.6 366.5C345.5 365.9 345.7 365.1 345.7 364.2L348 330.8 368.3 344.8C369.4 345.7 370.9 345.7 372 344.8L426.6 301.1C427.2 300.8 427.7 300 427.7 299.1 428.6 292.6 438 228.3 437.4 226.3zM232.6 231.1L236.6 323.7 146 384.9 132 288.3 232.6 231.1zM224.9 51.1L230.3 177.1 123.7 232.5 104 97.7 224.9 51.1zM44 173.1L18 48 97.7 97.4 117.1 230.3 44 173.1zM74.6 320.9L55.7 230 125.7 288.3 139.4 381.7 74.6 320.9zM98.9 438.6L85.2 371.5 146.9 432.4 156.6 499.8 98.9 438.6zM163.4 503.1L152.8 432.2 238.5 370.8 241.6 440.8 163.4 503.1zM245.4 388C245.4 384.6 246.3 365.1 243.4 362.9L219.1 342.9 241.4 328C243.7 326.3 242.5 322.3 242.5 320L271.9 342.6 272.5 410.9 245.4 388zM339.7 362.6L278.8 411.2 278.2 342.6 343.9 295.7 339.7 362.6zM367.4 336.9L348.3 323.5 350.3 289.5C350.6 288.6 350 287.5 349.2 286.9L308 259.7 308.6 229.7 373.2 270.3 367.4 336.9zM422 297.1L373.7 335.4 379.4 270.3 430.5 233.7 422 297.1z"}]}}),H.register({"brands/linux":{width:448,height:512,paths:[{d:"M196.1 123.6C195.9 122.2 198 121.3 199.3 120.7 201 120 203.2 119.7 204.8 120.6 205.2 120.8 205.6 121.3 205.4 121.7 205 122.9 203 122.7 201.9 123.3 200.9 123.8 200.1 125 198.9 125 197.9 125.1 196.2 124.6 196.1 123.6zM220.8 123.3C221.8 123.8 222.6 125 223.8 125 224.9 125 226.6 124.6 226.7 123.5 226.9 122.1 224.8 121.2 223.5 120.6 221.8 119.9 219.6 119.6 218 120.5 217.6 120.7 217.2 121.2 217.4 121.6 217.7 122.9 219.7 122.7 220.8 123.3zM435.5 433.5C435 441.7 429 447.3 421.6 451.8 406.7 460.8 384.3 467.6 370.7 484L368.1 481.8 370.7 484C356.5 500.9 339 510.6 322.4 511.9 305.9 513.2 290.4 505.6 282.1 488.9V488.8C281 486.7 280.2 484.4 279.6 482.1 258.1 483.3 239.4 476.8 224.5 478 202.5 479.2 188.7 484.5 176.2 484.6 171.4 495.2 161.9 502.2 150.3 504.8 134.3 508.5 114.2 504.8 94.4 494.4L96 491.4 94.4 494.4C75.9 484.6 52.4 485.5 35.1 481.9 26.4 480.1 18.8 476.9 15 469.6 11.3 462.3 12 452.3 17.2 437.9 18.9 432.8 17.6 425.2 16.4 417.1 15.8 413.2 15.2 409.2 15.2 405.3 15.2 401 15.9 396.8 18 392.9 22.5 384.4 29.8 380.8 36.5 378.4 43.2 376 49.3 374.4 53.5 370.1 58.7 364.6 63.6 355.7 70.1 349.9 67.5 332.7 70.3 314.5 76.3 296.6 88.9 258.7 115.5 222.4 134.4 199.9 150.5 177 155.2 158.6 156.9 135.2 158 103.4 132.4-0.2 234.8 0 315.7 0.1 311.1 85.4 310.6 131.3 310.3 161.4 326.9 181.8 344 203.3 359.2 221.3 379.1 247.6 390.5 277.7 399.8 302.3 403.4 329.5 394.2 356.8 395.6 357.3 397 358 398.3 358.8 399.7 359.6 401 360.6 402.3 361.7 408.9 367.3 411 376 412.8 384.1 414.7 392.2 416.4 399.8 420 403.8 431.1 416.2 435.9 425.3 435.5 433.5zM220.8 109.1C224.4 110 229.7 111.5 233.8 113.5 231.7 101.3 238.3 90 245.6 90.5 254.5 90.8 259.5 106 254.7 117.8 253.9 119.7 251.9 121.2 250.8 122.4 257.5 124.7 261.8 126.5 263.4 127.3 271.3 117.8 274.2 101.1 267.7 86.9 257.9 65.5 233.5 65.1 223.7 87.3 220.5 94.5 219.8 102.2 220.8 109.1zM174.6 127.9C182.4 122.2 181.5 123.2 180.5 122.4 172.5 115.5 173.9 95 182.3 94.3 188.6 93.8 193.1 105 191.9 113.9 195 111.8 198.6 110.3 202.1 109.3 203.8 90 193.1 75.8 183 75.8 164.1 75.8 159 113.3 174.6 127.9zM165.2 148.8C166.7 153.7 171.3 159.3 179.9 164.1 187.7 168.7 191.9 175.6 199.9 179.1 202.5 180.2 205.6 181 209.5 181.2 227.9 182.3 236.6 169.9 247.7 166.3 259.4 162.6 267.8 155.3 270.4 148.2 273.6 139.7 268.3 133.5 259.9 130 248.6 125.1 243.6 124.8 237.3 120.7 227 114.1 218.5 111.8 211.4 111.8 197 111.8 188.2 121.6 183.5 126 183 126.5 175.6 131.9 169.4 136.5 165.2 139.8 163.8 143.9 165.2 148.8zM131.7 401.6L112.1 366C105.3 356.8 98.3 351.2 90.2 350 82.5 348.8 77.6 351.4 72.5 356.9 67.7 362 63.7 369.2 58.2 374.9 50.4 381.4 48.9 381.1 38.6 384.8 32.3 387 27.3 389.4 23.8 396.1 21.1 401.1 21.7 408.3 22.9 416.1 24.1 424 25.9 432.4 23.5 440V440.2C18.5 453.9 18.5 461.9 20.9 466.6 28.8 482 67.5 472.7 97.4 488.5 128.8 504.9 170 505.6 172.7 470.5 174.8 450 141.2 421.5 131.7 401.6zM285.6 437.4C288.8 426.4 291.9 416.1 292.4 408.4 293.2 393.2 294 379.7 296.8 368.5 299.9 355.9 306.1 345.4 318.2 341.2 320.5 320.1 336.9 320.1 356.5 328.7 375.4 337.2 382.5 344.7 379.3 354.8 380.3 354.8 381.3 354.7 383.5 354.8 388.7 337.9 369.2 326.8 352.8 320 355.7 308 355.2 295.9 352.4 284.3 346.4 259 329.8 236.5 317.2 225.3 314.9 225.2 315.1 227.2 319.8 231.8 331.4 242.5 356.9 281 343.1 316.7 339.2 315.7 335.5 315.2 332.2 315.3 326.9 286.2 314.7 262.1 308.6 250.7 297.1 229.3 279.1 185.4 271.4 155 266.9 161.4 259 166.9 249.1 170 244.4 171.5 239.4 175.5 233.2 179 219.3 187 203.2 187.8 190.8 177.8 186.3 174.2 182.8 170.2 178.2 167.5 176.6 166.6 173.1 164.2 172 163.4 170 201.2 144.7 248.7 132.7 276.1 124.4 295.8 119.5 316.9 118.9 337.6 97.1 308.5 113 271.3 121.5 255.2 131 237.6 132.5 232.7 130.2 234.4 121.6 248.4 108.2 270.7 103 293.6 100.3 305.5 99.8 317.6 103.3 328.8 106.8 340 114.4 350.3 127.9 358.7 127.9 358.7 152.7 373 166.2 391.2 173.6 401.2 175.9 409.9 173.6 416.1 171.1 422.8 164 425 156.9 425 161.7 431 167.2 438 171.3 444.6 208.9 470.3 253.5 460.3 285.6 437.4zM415 408.5C405 397.2 407.8 375.4 397.9 366.9 391 360.9 384.3 361.5 375.3 361.8 367.6 370.6 349.5 381.4 336.9 378.1 325.4 375.2 318.9 361.8 318.1 348.6 317.8 348.8 317.4 348.9 317.1 349.1 310 353 306 359.9 303.4 370.2 300.9 380.4 300 393.7 299.2 408.9 298.5 420.7 293 435.3 289.3 449.5 285.8 462.7 283.5 474.7 288.2 485.8 295.4 500.3 307.7 506.2 321.9 505.1 336.1 504 352.3 495.3 365.5 479.6 387.5 453 427.8 449.9 428.7 433.1 429 428 425.6 420.1 415 408.5zM173.3 148.7C175.3 150.6 178 153.2 181.3 155.8 187.9 161 197.1 166.4 208.6 166.4 220.2 166.4 231.1 160.5 240.4 155.6 245.3 153 251.3 148.6 255.2 145.2 259.1 141.8 261.1 138.9 258.3 138.6 255.5 138.3 255.7 141.2 252.3 143.7 247.9 146.9 242.6 151.1 238.4 153.5 231 157.7 218.9 163.7 208.5 163.7 198.1 163.7 189.8 158.9 183.6 154 180.5 151.5 177.9 149 175.9 147.1 174.4 145.7 174 142.5 171.6 142.2 170.2 142.1 169.8 145.9 173.3 148.7z"}]}}),H.register({"brands/lyft":{width:512,height:512,paths:[{d:"M0 81.1H77.8V289.8C77.8 322.9 92.8 342.6 105 350.8 92.3 361.9 53.8 371.7 24.8 348 7.8 334 0 310.7 0 289V81.1zM485.9 254.6V232.6H509.7V155.8H483.6C473.5 109.5 432.4 75.1 383.3 75.1 326.7 75.1 280.6 121.1 280.6 177.8V357C296.6 359.3 316 356.7 332.3 343 349.4 329 357.1 305.8 357.1 284V277.3H395.9V200.5H357.1V177.2C357.1 142.6 409.3 142.6 409.3 177.2V254.3C409.3 310.9 455.3 357 512 357V280.5C497.5 280.5 485.9 268.8 485.9 254.6zM191.6 155.6V268.6C191.6 284 167.8 284 167.8 268.6V155.6H91V288.3C91 312.1 99 342.3 136 352.2 173 362 194.2 341.6 194.2 341.6 192.1 355 179.7 364.9 159.3 366.9 143.8 368.5 124.1 363.3 114.3 359.1V429.4C139.4 436.9 165.8 439.2 191.9 434.1 239 425 268.7 385.7 268.7 333.3V155.1H191.6V155.6z"}]}}),H.register({"brands/magento":{width:448,height:512,paths:[{d:"M445.7 127.9V384L382.3 420.5V164.7L223.8 73.1 65.2 164.7 65.6 420.6 2.3 384V128.1L224.2 0 445.7 127.9zM255.6 420.5L224 438.9 192.2 420.7V164.7L128.9 201.3 129 457.2 223.9 512.1 319 457.2V201.2L255.6 164.6V420.5z"}]}}),H.register({"brands/maxcdn":{width:512,height:512,paths:[{d:"M461.1 442.7H363.7L415.6 200C417.9 189.8 416.5 180.5 411.2 174.3 406.2 168.2 397.5 164.7 387 164.7H337.7L278.2 442.7H180.8L240.3 164.7H156.9L97.4 442.7H0L59.5 164.7 14.9 69.3H387C426.4 69.3 462.3 85.6 485.3 114.2 508.6 142.8 517.1 181.6 508.9 220.1L461.1 442.7z"}]}}),H.register({"brands/medapps":{width:320,height:512,paths:[{d:"M118.3 238.4C121.8 225.9 125.2 204.8 131.5 204.8 139.8 206.6 141.1 228.2 150.1 241.4 154.7 217.9 155.4 156.3 164.2 154.7 173.2 154 183.9 221.2 186.2 232.2 196.1 236.3 235.1 238.8 235.1 238.8 237 246.1 211.1 246.4 195.1 246.6 190.5 261.4 189.7 274.3 183.7 274.6 179 274.8 175.5 245.8 166.2 225L156.8 290.5C152.4 303.5 141.3 268 134.9 251.2 131.6 251.1 72.5 249.6 87.3 243.4L118.3 238.4zM228 448C249.2 448 249.2 416 228 416H92C70.8 416 70.8 448 92 448H228zM204 512C225.2 512 225.2 480 204 480H116C94.8 480 94.8 512 116 512H204zM238.2 370.5C241.4 351.6 243.4 334.1 250.1 321.7 258 307 266.2 293.6 274.1 280.7 298.7 240.3 320 205.5 320 155.2 320 69.6 248.2 0 160 0S0 69.6 0 155.2C0 205.4 21.3 240.3 45.9 280.7 53.8 293.6 61.9 307 69.9 321.7 76.6 334.2 78.6 351.5 81.8 370.6 85.3 391.6 117.9 386.3 114.4 365.5 110.8 343.8 108.8 324.8 99.1 306.9 66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32S287 87.3 287 155.2C287 211.3 253.5 246.5 220.9 306.8 211.2 324.8 209.2 344.2 205.6 365.4 202.2 386 234.6 391.8 238.2 370.5z"}]}}),H.register({"brands/medium-m":{width:512,height:512,paths:[{d:"M71.5 142.3C72.1 136.4 69.8 130.5 65.4 126.5L20.3 72.1V64H160.5L268.9 301.7 364.2 64H497.9V72.1L459.3 109.1C456 111.6 454.3 115.8 455 119.9V391.9C454.3 396 456 400.2 459.3 402.7L497 439.7V447.8H307.3V439.7L346.4 401.8C350.2 398 350.2 396.8 350.2 391V171.2L241.5 447.1H226.8L100.4 171.2V356.1C99.3 363.9 101.9 371.7 107.4 377.3L158.2 438.9V447H14.2V439L65 377.3C70.4 371.7 72.9 363.8 71.5 356.1V142.3z"}]}}),H.register({"brands/medium":{width:448,height:512,paths:[{d:"M0 32V480H448V32H0zM372.2 138.1L348.2 161.1C346.1 162.7 345.1 165.3 345.5 167.8V337.1C345.1 339.7 346.1 342.3 348.2 343.8L371.7 366.8V371.9H253.7V367L278 343.4C280.4 341 280.4 340.3 280.4 336.7V199.8L212.8 371.4H203.7L125 199.8V314.8C124.3 319.6 126 324.5 129.4 328L161 366.3V371.4H71.2V366.3L102.8 328C106.2 324.5 107.7 319.6 106.9 314.8V181.8C107.3 178.1 105.9 174.5 103.1 172L75 138.1V133H162.3L229.7 281 289 133.1H372.2V138.1z"}]}}),H.register({"brands/medrt":{width:544,height:512,paths:[{d:"M113.7 256C113.7 377.8 197.6 478.8 307.2 497.1 288.5 501.6 269 504 249 504 111.4 504 0 393 0 256S111.4 8 248.9 8C269 8 288.5 10.4 307.1 14.9 197.5 33.2 113.7 134.2 113.7 256M411.1 356.3C333.4 411.7 231.5 403.8 170.7 341.7 176.2 355.8 183.4 369.4 192.4 382.2 254 470.4 374.8 491.5 462.1 429.2 549.4 366.9 570.2 244.9 508.6 156.6 499.6 143.7 489.3 132.3 478.1 122.4 515.5 201.2 488.8 300.9 411.1 356.3M192.3 112.3C190.9 113.3 189.6 114.4 188.3 115.4 252.6 97.6 324.2 119.4 367.2 175.9 402.9 222.9 410.1 282.5 391.6 333.9 448.3 277.7 459.2 191.8 413.9 132.1 363.9 66.6 264.8 57.7 192.3 112.3M296 224C291.6 224 288 220.4 288 216V176C288 171.6 284.4 168 280 168H232C227.6 168 224 171.6 224 176V216C224 220.4 220.4 224 216 224H176C171.6 224 168 227.6 168 232V280C168 284.4 171.6 288 176 288H216C220.4 288 224 291.6 224 296V336C224 340.4 227.6 344 232 344H280C284.4 344 288 340.4 288 336V296C288 291.6 291.6 288 296 288H336C340.4 288 344 284.4 344 280V232C344 227.6 340.4 224 336 224H296z"}]}}),H.register({"brands/meetup":{width:512,height:512,paths:[{d:"M99 414.3C100.1 420 96.7 425.4 91 426.6 85.6 427.7 80.1 424.3 79 418.6 77.9 413.2 81.3 407.5 86.7 406.3 92.1 405.1 97.8 408.6 99 414.3zM242.1 485.7C235.8 490.3 234.1 499.1 238.4 505.7 243 512.3 251.8 514 258.4 509.4 264.7 504.8 266.4 496 261.8 489.4 257.6 482.9 248.7 481.1 242.1 485.7zM156.1 23.4C162.4 22 166.4 15.7 165 9.4 163.9 2.8 157.6-1.2 151.3 0.3 145 1.7 141 8 142.2 14.3 143.6 20.9 149.8 24.9 156.1 23.4zM34.4 226.3C24.4 219.4 10.7 222 3.8 232.3-3.1 242.3-0.5 256.3 9.5 263.2 19.5 270.3 33.2 267.8 40.1 257.5 47 247.1 44.4 233.4 34.4 226.3zM306.4 55.4C317 49.1 320.1 35.4 314.1 25.1 307.8 14.5 294.4 11.1 284.1 17.4S270.4 37.4 276.7 48C282.7 58.3 296.1 61.7 306.4 55.4zM115.3 113.4C123 108 124.7 97.4 119.6 89.7S103.9 80.3 96.5 85.4C88.8 90.8 87.1 101.4 92.2 109.1 97.3 116.9 107.8 118.6 115.3 113.4zM487.6 269.4C480.2 271.1 475.3 278.5 477 286.3 478.4 293.7 485.9 298.6 493.3 296.9 500.7 295.5 505.6 288 503.9 280.3 502.4 272.9 495 268 487.6 269.4zM527.3 212.6C526.2 206.9 520.7 203.5 515.3 204.6 509.6 205.7 506.2 211.5 507.3 217.2 508.4 222.6 513.9 226.3 519.6 225.2 525 223.7 528.7 218.3 527.3 212.6zM447 138.9C438.4 144.9 436.4 156.6 442.1 165.2 447.8 173.8 459.5 175.8 468.1 170.1 476.4 164.1 478.4 152.4 472.7 143.8 467 135.1 455.3 132.9 447 138.9zM440.7 278.3C467 321.4 455.8 378.3 414.4 407.4 397 419.7 377.3 425.1 357.5 424.5 345.5 471.6 288.1 489.1 252.4 457.1 251.3 458 249.8 458.8 248.7 460 209.6 487.1 156.4 477.4 129.3 437.7 119.6 423.4 114.7 407.1 114.2 390.8 48.8 379.9 24.2 296.8 73.1 251.1 44.8 204.2 73.7 143.7 126.5 136.2 151.6 70 234.1 38.6 290.1 82 357.5 59.7 426.4 111.4 421 183.1 462.1 195.7 473.8 250 440.7 278.3zM370.7 352.6C367.6 332 329.8 348 327.6 325.5 324.5 293.5 371.3 224.4 367.6 197.5 364.2 173.5 348.2 168.4 334.2 168.1 320.8 167.8 317.3 170.1 312.8 172.7 309.9 174.4 306.2 177.6 301.1 172.4 294.8 166.4 290 160.7 281.7 159.5 269.4 157.5 264 161.5 255.1 169.2 251.7 172.1 243.1 182.1 235.1 178.3 231.7 176.6 219.7 170.6 211.1 166.9 194.8 159.8 171.1 171.5 162.5 186.9 149.6 209.8 124.5 300 120.8 312 112.2 338.6 131.7 360.6 157.7 359.1 168.8 358.5 176 354.5 183.1 341.7 187.1 334.3 224.8 234 227.7 229.1 229.7 225.7 236.6 221.1 242.3 224 248 227.1 249.2 233.4 248.3 239.1 247.2 248.8 220.3 310 219.4 316.8 216 339.7 246.3 343.4 258 320.8 261.7 313.7 303.7 228.2 307.4 222.5 311.7 216.2 314.8 214.2 319.1 214.5 322.2 214.5 327.4 215.4 326.2 225.4 324.8 234.8 291.1 297.7 287.3 313.1 282.7 333.7 293.9 354.5 312.2 363.7 323.6 369.4 374.7 379.4 370.7 352.6zM376.4 444.9C366.1 452.3 363.5 466.9 370.7 477.5 377.8 488.1 392.1 490.6 402.7 483.5 413.3 476.1 415.8 461.5 408.7 450.9 401.3 440.3 387 437.4 376.4 444.9z"}]}}),H.register({"brands/microsoft":{width:448,height:512,paths:[{d:"M0 32H214.6V246.6H0V32zM233.4 32H448V246.6H233.4V32zM0 265.4H214.6V480H0V265.4zM233.4 265.4H448V480H233.4V265.4z"}]}}),H.register({"brands/mix":{width:448,height:512,paths:[{d:"M0 64V412.9C0 469.1 88 471 88 412.9V174.3C95.9 121.4 176 123.9 176 180.8V356.1C176 414 272 414.1 272 356.1V240C277.3 185.3 360 187.5 360 244.3V268.1C360 328 448 324.7 448 268.1V64H0z"}]}}),H.register({"brands/mixcloud":{width:640,height:512,paths:[{d:"M424.4 219.7C416.1 134.7 344.1 68 256.9 68 184.7 68 120.7 114.5 97.7 182.1 43.2 190.1 1.1 236.9 1.1 293.7 1.1 356 51.8 406.6 114.3 406.6H403.9C456.3 406.6 498.9 364.3 498.9 311.9 498.9 266.8 466.8 228.9 424.4 219.7zM403.9 364.3H114.3C75.3 364.3 43.4 332.7 43.4 293.7S75.3 223.1 114.3 223.1C133.2 223.1 150.9 230.5 164.2 243.8 184.1 263.8 214.3 233.6 194.3 213.6 179.7 199.2 161.7 189.3 142.3 184.3 162.2 140 207.1 110.4 256.9 110.4 326.4 110.4 382.9 166.8 382.9 236.1 382.9 249.6 380.7 262.9 376.5 275.7 367.6 303.2 408.7 314.6 416.7 288.9 419.4 280.6 421.7 272.1 423 263.5 442.4 271 456.5 289.8 456.5 311.9 456.5 340.7 433 364.3 403.9 364.3zM639 311.9C639 356 626.3 398.3 601.9 434.6 597.8 440.7 591.1 444 584.2 444 567.9 444 557.1 425.2 566.7 411.1 586.1 381.7 596.6 347.4 596.6 311.9S586.1 242.2 566.7 213.1C551.1 190.3 586.1 165.8 601.9 189.5 626.3 225.5 639 267.9 639 311.9zM568.1 311.9C568.1 343.5 559 373.9 541.3 400.3 537.1 406.3 530.5 409.4 523.6 409.4 506.4 409.4 496.5 390.4 506.1 376.4 519.1 357.3 525.8 335.2 525.8 311.9 525.8 288.9 519.1 266.5 506.1 247.4 490.3 224.4 525.1 200.3 541.3 223.9 559 249.9 568.1 280.4 568.1 311.9z"}]}}),H.register({"brands/mizuni":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119.1 0 256 0 393 111 504 248 504S496 393 496 256C496 119.1 385 8 248 8zM168 359.9C136.6 370.5 109.2 387.2 88 408.1V136C88 113.9 105.9 96 128 96S168 113.9 168 136V359.9zM288 350C275.1 348 261.8 346.9 248.2 346.9 234.4 346.9 221 348 208 350V136C208 113.9 225.9 96 248 96S288 113.9 288 136V350zM408 407.7C386.8 386.9 359.4 370.3 328 359.7V136C328 113.9 345.9 96 368 96S408 113.9 408 136V407.7z"}]}}),H.register({"brands/modx":{width:448,height:512,paths:[{d:"M356 241.8L392.7 265.5V480L259.7 396.2 356 241.8zM440 75H226.3L203.3 112.8 356.8 209.3 440 75zM351 217.8L55.2 32V246.5L101.2 275.5 351 217.8zM97 294.2L8 437H221.7L346.7 236.5 97 294.2z"}]}}),H.register({"brands/monero":{width:496,height:512,paths:[{d:"M352 384H460.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361 352 256V384zM88 336V128L247.4 287.4 408 128V336H482.8C491.3 310.9 496 284 496 256 496 119 385 8 248 8S0 119 0 256C0 284 4.6 310.9 13.2 336H88z"}]}}),H.register({"brands/napster":{width:496,height:512,paths:[{d:"M298.3 373.6C284.1 387.2 267 397.7 247.9 404.1 228.9 397.7 211.7 387.2 197.6 373.6H298.3zM342.3 174C362.3 157.1 385.9 144.8 411.9 137.8V299C411.9 518.4 83.9 516.6 83.9 299.3V137.7C109.8 144.6 133.5 157.3 153.4 174.1 210.2 134.1 285.9 134.2 342.3 174zM133.5 115.5C197.9 55.5 297.8 55.4 362.4 115.3 355.3 118.8 348.5 122.6 341.8 126.8 283.1 96.3 212.6 96.4 153.9 126.9 147.6 122.9 140 118.7 133.5 115.5zM43.8 93.2V162.5C-14.6 199-14.6 283.6 43.9 320.8 70.3 565.9 425.6 561.1 451.5 322.3L451.8 320.6C510.5 284.3 510.7 198.9 452 162.4V93.2C434.7 93.7 418 96.2 401.9 100.6 319.9 9.1 176.4 9.1 94.4 100.7 78.1 96.3 61.3 93.7 43.8 93.2zM259.2 352S295.2 351.7 320.5 350.5C330.7 350 341.6 346.5 346 344 372.3 328.9 371.4 304.8 372.2 296.6 292.7 296 272.3 292.7 259.2 352zM123.7 296.7C124.5 304.9 123.6 329 149.9 344.1 154.3 346.6 165.1 350.1 175.4 350.6 200.7 351.7 236.7 352.1 236.7 352.1 223.5 292.7 203 296 123.7 296.7zM292.8 420.1C289.6 414.8 285.9 412.8 285.9 412.8 261.1 420.1 233.7 419.7 210 412.8 210 412.8 207.1 414.3 203.6 419.4 200.8 423.5 199.9 429 199.9 429 229 446.6 267 446.6 296.1 429 296 428.9 295.8 425 292.8 420.1z"}]}}),H.register({"brands/nintendo-switch":{width:448,height:512,paths:[{d:"M95.9 33.5C51.3 41.5 15.4 74.5 4.1 117.9 0 133.6-0.3 142.8 0.2 264.4 0.4 376 0.5 378.6 2.4 387.3 12.7 433.8 45.7 466.9 92.7 477.8 98.8 479.2 106.6 479.5 156.8 479.7 208.7 480.1 214.1 480 215.5 478.6 216.9 477.2 217 459.3 217 256.4 217 105.9 216.7 35.1 216.1 33.8 215.2 32.1 213.6 32 159.2 32.1 115 32.2 101.7 32.5 95.9 33.5zM179.8 256.1V444L142 443.5C107.2 443.1 103.5 442.9 96.5 441.2 66.6 433.5 44.5 410.5 38.2 380.5 36.2 371.1 36.2 140.4 38.1 131.2 43.7 105.1 61.8 83.5 86.1 73.8 98.3 68.9 104 68.3 143.7 68.2L179.6 68.1V256.1zM103.9 124.9C98.1 126 89.2 130.5 84.4 134.6 74.7 143 69.8 155 70.6 169.1 71 176.4 71.4 178.4 74.4 184.3 78.8 193.3 85.3 199.9 94.3 204.3 100.5 207.4 102.1 207.7 110.2 208 117.5 208.3 120.1 208 125 206.3 145.1 199.5 157.3 180 153.8 159.9 149.9 136.2 127.2 120.2 103.9 124.9zM262.1 32.6C261.7 32.9 261.5 133.4 261.5 256.1 261.5 458.4 261.6 478.9 263 479.5 265.5 480.4 337.5 480.1 346.4 479.1 384.1 474.8 417.4 451.9 435.4 417.9 437.7 413.5 440.8 406.2 442.4 401.7 448.2 384.3 448.1 388.9 448.1 255.6 448.1 149.2 447.9 133.3 446.6 126.6 437.4 78.3 400.5 41.8 352.1 33.5 345.6 32.4 335.6 32.1 303.3 32.1 280.9 32 262.4 32.3 262.1 32.6zM361.2 234.7C375.7 238.5 387.5 249.5 392.4 263.6 395.5 272.3 395.4 285.1 392.3 293.1 386.6 307.8 375.5 318.1 361.2 321.9 338 327.9 313.3 313.9 306.6 290.9 304.6 283.9 304.7 272 307 264.7 313.9 242 338 228.6 361.2 234.7z"}]}}),H.register({"brands/node-js":{width:448,height:512,paths:[{d:"M224 508C217.3 508 210.5 506.2 204.6 502.8L142.9 466.3C133.7 461.1 138.2 459.3 141.2 458.3 153.5 454 156 453.1 169.1 445.6 170.5 444.8 172.3 445.1 173.7 446L221.1 474.1C222.8 475.1 225.2 475.1 226.8 474.1L411.5 367.5C413.2 366.5 414.3 364.5 414.3 362.5V149.3C414.3 147.2 413.2 145.3 411.4 144.2L226.8 37.7C225.1 36.7 222.8 36.7 221.1 37.7L36.6 144.3C34.8 145.3 33.7 147.3 33.7 149.4V362.5C33.7 364.5 34.8 366.5 36.6 367.4L87.2 396.6C114.7 410.3 131.5 394.2 131.5 377.9V167.5C131.5 164.5 133.9 162.2 136.9 162.2H160.3C163.2 162.2 165.7 164.5 165.7 167.5V378C165.7 414.6 145.7 435.6 111 435.6 100.3 435.6 91.9 435.6 68.5 424L20.1 396.1C8.1 389.2 0.7 376.3 0.7 362.4V149.3C0.7 135.5 8.1 122.5 20.1 115.6L204.6 9C216.3 2.4 231.8 2.4 243.4 9L428.1 115.7C440.1 122.6 447.5 135.5 447.5 149.4V362.5C447.5 376.3 440.1 389.2 428.1 396.2L243.4 502.8C237.5 506.2 230.8 508 224 508zM373.1 297.9C373.1 258 346.1 247.4 289.4 239.9 232 232.3 226.2 228.4 226.2 215 226.2 203.9 231.1 189.1 273.6 189.1 311.5 189.1 325.5 197.3 331.3 222.9 331.8 225.3 334 227.1 336.5 227.1H360.5C362 227.1 363.4 226.5 364.4 225.4S365.9 222.8 365.8 221.3C362.1 177.2 332.8 156.7 273.6 156.7 220.9 156.7 189.5 178.9 189.5 216.2 189.5 256.6 220.8 267.8 271.3 272.8 331.8 278.7 336.5 287.6 336.5 299.5 336.5 320.1 319.9 328.9 281 328.9 232.1 328.9 221.4 316.6 217.8 292.3 217.4 289.7 215.2 287.8 212.5 287.8H188.6C185.6 287.8 183.3 290.2 183.3 293.1 183.3 324.2 200.2 361.3 281.1 361.3 339.5 361.2 373.1 338.1 373.1 297.9z"}]}}),H.register({"brands/node":{width:640,height:512,paths:[{d:"M316.3 452C314.2 452 312.1 451.4 310.2 450.4L291 439C288.1 437.4 289.5 436.8 290.5 436.5 294.3 435.2 295.1 434.9 299.2 432.5 299.6 432.3 300.2 432.4 300.6 432.6L315.4 441.4C315.9 441.7 316.7 441.7 317.2 441.4L375 408C375.5 407.7 375.9 407.1 375.9 406.4V339.7C375.9 339 375.6 338.4 375 338.1L317.2 304.8C316.7 304.5 316 304.5 315.4 304.8L257.6 338.1C257 338.4 256.7 339.1 256.7 339.7V406.4C256.7 407 257.1 407.6 257.6 407.9L273.4 417C282 421.3 287.3 416.2 287.3 411.2V345.3C287.3 344.4 288 343.6 289 343.6H296.3C297.2 343.6 298 344.3 298 345.3V411.2C298 422.7 291.8 429.2 280.9 429.2 277.6 429.2 274.9 429.2 267.6 425.6L252.4 416.9C248.7 414.7 246.3 410.7 246.3 406.4V339.7C246.3 335.4 248.6 331.3 252.4 329.2L310.2 295.8C313.9 293.7 318.7 293.7 322.3 295.8L380.1 329.2C383.8 331.4 386.2 335.4 386.2 339.7V406.4C386.2 410.7 383.9 414.8 380.1 416.9L322.3 450.3C320.6 451.4 318.5 452 316.3 452zM363 386.2C363 373.7 354.6 370.4 336.8 368 318.8 365.6 317 364.4 317 360.2 317 356.7 318.5 352.1 331.8 352.1 343.7 352.1 348.1 354.7 349.9 362.7 350.1 363.5 350.7 364 351.5 364H359C359.5 364 359.9 363.8 360.2 363.5 360.5 363.1 360.7 362.7 360.6 362.2 359.4 348.4 350.3 342 331.8 342 315.3 342 305.5 349 305.5 360.6 305.5 373.3 315.3 376.7 331.1 378.3 350 380.2 351.5 382.9 351.5 386.6 351.5 393.1 346.3 395.8 334.1 395.8 318.8 395.8 315.4 392 314.3 384.4 314.2 383.6 313.5 383 312.6 383H305.1C304.2 383 303.4 383.7 303.4 384.7 303.4 394.4 308.7 406 334 406 352.5 406 363 398.8 363 386.2zM417.5 336.1C417.5 342.2 412.5 347.2 406.4 347.2S395.3 342.2 395.3 336.1C395.3 329.8 400.5 325 406.4 325 412.4 324.9 417.5 329.8 417.5 336.1zM415.7 336.1C415.7 330.9 411.5 326.8 406.3 326.8 401.2 326.8 397 330.9 397 336.1 397 341.3 401.2 345.5 406.3 345.5 411.5 345.4 415.7 341.2 415.7 336.1zM411.2 342.3H408.6C408.5 341.7 408.1 338.5 408.1 338.4 407.9 337.7 407.7 337.3 406.8 337.3H404.6V342.3H402.2V329.8H406.5C408 329.8 410.9 329.8 410.9 333.1 410.9 335.4 409.4 335.9 408.5 336.2 410.2 336.3 410.3 337.4 410.6 339 410.7 340 410.9 341.7 411.2 342.3zM408.4 333.5C408.4 331.8 407.2 331.8 406.6 331.8H404.6V335.3H406.5C408.1 335.3 408.4 334.2 408.4 333.5zM137.3 191C137.3 188.3 135.9 185.9 133.6 184.6L72.3 149.3C71.3 148.7 70.1 148.4 68.9 148.3H68.3C67.1 148.3 66 148.7 64.9 149.3L3.7 184.6C1.4 185.9 0 188.4 0 191L0.1 286C0.1 287.3 0.8 288.5 1.9 289.2 3 289.9 4.4 289.9 5.6 289.2L42 268.3C44.3 266.9 45.7 264.5 45.7 261.9V217.5C45.7 214.9 47.1 212.4 49.4 211.1L64.9 202.2C66.1 201.5 67.3 201.2 68.6 201.2 69.9 201.2 71.2 201.5 72.3 202.2L87.8 211.1C90.1 212.4 91.5 214.9 91.5 217.5V261.9C91.5 264.5 92.9 267 95.2 268.3L131.6 289.2C132.7 289.9 134.2 289.9 135.3 289.2 136.4 288.6 137.1 287.3 137.1 286L137.3 191zM472.5 87.3V263.7C472.5 266.3 471.1 268.8 468.8 270.1L407.5 305.5C405.2 306.8 402.4 306.8 400.1 305.5L338.8 270.1C336.5 268.8 335.1 266.3 335.1 263.7V192.9C335.1 190.3 336.5 187.8 338.8 186.5L400.1 151.1C402.4 149.8 405.2 149.8 407.5 151.1L422.8 159.9C424.5 160.9 426.7 159.6 426.7 157.7V63.7C426.7 60.9 429.7 59.1 432.2 60.5L468.7 80.9C471 82.1 472.5 84.6 472.5 87.3zM426.5 216.2C426.5 215.5 426.1 214.9 425.6 214.6L404.6 202.4C404 202.1 403.3 202.1 402.7 202.4L381.7 214.6C381.1 214.9 380.8 215.5 380.8 216.2V240.5C380.8 241.2 381.2 241.8 381.7 242.1L402.7 254.2C403.3 254.5 404 254.5 404.5 254.2L425.5 242.1C426.1 241.8 426.4 241.2 426.4 240.5V216.2zM636.3 215.5C638.6 214.2 640 211.7 640 209.1V192C640 189.4 638.6 186.9 636.3 185.6L575.4 150.2C573.1 148.9 570.3 148.9 568 150.2L506.7 185.6C504.4 186.9 503 189.4 503 192V262.8C503 265.5 504.4 267.9 506.7 269.2L567.6 303.9C569.8 305.2 572.6 305.2 574.9 303.9L611.7 283.4C614.2 282 614.2 278.4 611.7 277L550 241.6C548.8 240.9 548.1 239.7 548.1 238.4V216.2C548.1 214.9 548.8 213.7 550 213L569.2 201.9C570.3 201.2 571.8 201.2 572.9 201.9L592.1 213C593.2 213.7 594 214.9 594 216.2V233.6C594 236.4 597.1 238.2 599.6 236.8L636.3 215.5zM559 219C558.6 219.3 558.3 219.7 558.3 220.2V233.8C558.3 234.3 558.6 234.8 559 235L570.8 241.8C571.2 242.1 571.8 242.1 572.2 241.8L584 235C584.4 234.7 584.7 234.3 584.7 233.8V220.2C584.7 219.7 584.4 219.2 584 219L572.2 212.2C571.8 211.9 571.2 211.9 570.8 212.2L559 219zM304.8 262.5V192.1C304.8 189.5 303.2 187 300.9 185.7L239.8 150.5C237.7 149.3 234.8 149.1 232.4 150.5L171.3 185.7C169 187 167.4 189.4 167.4 192.1V262.5C167.4 265.3 169.3 267.7 171.4 268.9L232.6 304.1C235 305.5 237.8 305.4 240 304.1L301 268.9C302.8 267.9 304.1 266.2 304.6 264.2 304.7 263.7 304.8 263.1 304.8 262.5zM230.5 137.6L229.7 138.1H230.8L230.5 137.6zM306.7 267.8L306.3 267.1V268L306.7 267.8z"}]}}),H.register({"brands/npm":{width:576,height:512,paths:[{d:"M288 288H256V224H288V288zM576 160V352H288V384H160V352H0V160H576zM160 192H32V320H96V224H128V320H160V192zM320 192H192V352H256V320H320V192zM544 192H352V320H416V224H448V320H480V224H512V320H544V192z"}]}}),H.register({"brands/ns8":{width:640,height:512,paths:[{d:"M187.1 159.9L152.9 273.6 98.4 159.9H49L0 320H44.9L76 213.5 126.6 320H183.5L232 159.9H187.1zM639.6 159C636.7 141 615.7 130.9 597.5 127.7 552.9 119.9 495.6 144 509 186.5V186.6C465.2 195.3 434.7 213.4 414.8 234.8 411.8 225 401.2 218.2 380.8 218.2H293.2C283.9 218.2 280.3 215.9 281.7 210.8 283.3 205.3 283.6 204 285.4 198.6 287.5 192.2 293.2 191.5 298.7 191.5H432.2L441.9 160C302.2 160 297.4 159.5 281.8 161.2 269.5 162.5 258.3 166 251.2 176.2 244.4 186.1 236.8 211.8 233.6 223.3 228.2 242.7 233 251.9 266.4 251.9H353.7C361.5 251.9 362.5 254.6 361.4 258.5 360.3 262.9 358.6 268.5 356.9 273.1 355.3 277.3 352.2 280.5 343.1 280.5H216.3L204.7 320C344.6 320 350 319.4 365.6 317.7 372.2 317 378.6 315.6 384.1 312.8 384.3 316.5 384.6 320.1 385.3 323.6 390.7 354.1 412.7 375.9 442.1 383.1 490.7 395 550.8 366.3 577.2 315.1 595.9 278.9 591.3 238.9 573.8 209.6H573.9C603.5 203.7 644.2 187.6 639.6 159zM530.7 263.7C524.8 293.2 494.1 311.5 469.1 307.6 438.2 302.8 430.6 268.1 455 242.8 471.2 226 500.2 218.8 523.5 215.9 530.2 230 533.8 247.9 530.7 263.7zM552.5 180.6C548.3 174.6 542.7 162.1 550 154.3 556.7 147.1 570.9 144.2 581.8 146.6 597.1 150 601.5 162.5 586.7 171 576 177.1 563.1 179.1 552.5 180.6z"}]}}),H.register({"brands/nutritionix":{width:400,height:512,paths:[{d:"M88 8.1S221.4-0.1 209 112.5C209 112.5 228.1 37.6 312 71.9 312 71.9 294.3 145.9 224 127.9 224 127.9 238.6 73.3 290.1 71.3 290.1 71.3 250.2 61 208 120.1 208 120.1 188.2 25.6 114.4 20.4 114.4 20.4 189.6 39.8 192 127.9 192 128 85.6 134.9 88 8.1zM400 323.7C400 372.2 390.3 419 368 456 325.8 486.9 263 504 200 504 137.1 504 74.2 486.9 32 456 9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192 82.2 161.1 137.1 143.4 200 143.4 263 143.4 317.8 161 360 192 382.3 229 400 275.3 400 323.7zM120 428C120 412.5 107.5 400 92 400S64 412.5 64 428 76.5 456 92 456 120 443.5 120 428zM120 361.8C120 346.3 107.5 333.8 92 333.8S64 346.3 64 361.8 76.5 389.8 92 389.8 120 377.3 120 361.8zM120 295.6C120 280.1 107.5 267.6 92 267.6S64 280.1 64 295.6 76.5 323.6 92 323.6 120 311.1 120 295.6zM192 428C192 412.5 179.5 400 164 400S136 412.5 136 428 148.5 456 164 456 192 443.5 192 428zM192 361.8C192 346.3 179.5 333.8 164 333.8S136 346.3 136 361.8 148.5 389.8 164 389.8 192 377.3 192 361.8zM192 295.6C192 280.1 179.5 267.6 164 267.6S136 280.1 136 295.6 148.5 323.6 164 323.6 192 311.1 192 295.6zM264 428C264 412.5 251.5 400 236 400S208 412.5 208 428 220.5 456 236 456 264 443.5 264 428zM264 361.8C264 346.3 251.5 333.8 236 333.8S208 346.3 208 361.8 220.5 389.8 236 389.8 264 377.3 264 361.8zM264 295.6C264 280.1 251.5 267.6 236 267.6S208 280.1 208 295.6 220.5 323.6 236 323.6 264 311.1 264 295.6zM336 428C336 412.5 323.5 400 308 400S280 412.5 280 428 292.5 456 308 456 336 443.5 336 428zM336 361.8C336 346.3 323.5 333.8 308 333.8S280 346.3 280 361.8 292.5 389.8 308 389.8 336 377.3 336 361.8zM336 295.6C336 280.1 323.5 267.6 308 267.6S280 280.1 280 295.6 292.5 323.6 308 323.6 336 311.1 336 295.6zM360 256C355.2 233.7 352.6 219.1 344 200 305.2 180.1 253.5 168 200 168S94.8 180.1 56 200C47.2 219.5 44.8 233.9 40 256 82.2 248.1 138.7 241.2 200 241.2S317.8 248.1 360 256z"}]}}),H.register({"brands/odnoklassniki-square":{width:448,height:512,paths:[{d:"M184.2 177.1C184.2 155 202.1 137.1 224 137.1S263.8 155 263.8 177.1C263.8 199.1 245.9 216.9 224 216.9S184.2 199 184.2 177.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM142.9 177.1C142.9 221.7 179.3 258 224 258S305.1 221.8 305.1 177.1C305.1 132.3 268.7 96 224 96S142.9 132.2 142.9 177.1zM317.4 267.8C312.8 258.7 300.1 251 283.3 264.2 283.3 264.2 260.6 282.2 224 282.2S164.7 264.2 164.7 264.2C147.9 251 135.2 258.7 130.6 267.8 122.7 283.9 131.7 291.5 152 304.8 169.3 315.9 193.2 320 208.6 321.6L195.7 334.5C177.5 352.5 160.2 370 148 382.2 130.4 399.8 158.7 428 176.4 410.8L224.1 362.9C242.3 381.1 259.8 398.6 271.8 410.8 289.4 428 317.8 400.1 300.4 382.2L252.7 334.5 239.7 321.6C255.2 320 278.8 315.7 295.9 304.8 316.3 291.5 325.2 283.8 317.4 267.8z"}]}}),H.register({"brands/odnoklassniki":{width:320,height:512,paths:[{d:"M275.1 334C247.7 351.4 210 358.3 185.1 360.9L206 381.5 282.3 457.8C310.2 486.4 264.8 531.1 236.6 503.5 217.5 484.1 189.5 456.1 160.3 426.9L84 503.4C55.8 530.9 10.4 485.8 38.6 457.7 58 438.3 85.7 410.3 114.9 381.4L135.5 360.8C110.9 358.2 72.6 351.7 44.9 333.9 12.3 312.9-2 300.6 10.6 274.9 18 260.3 38.3 248 65.2 269.2 65.2 269.2 101.5 298.1 160.1 298.1S255 269.2 255 269.2C281.9 248.1 302.1 260.3 309.6 274.9 322 300.6 307.7 312.9 275.1 334zM30.3 129.7C30.3 58 88.6 0 160 0S289.7 58 289.7 129.7C289.7 201.1 231.4 259.1 160 259.1S30.3 201.1 30.3 129.7zM96.3 129.7C96.3 164.8 124.9 193.4 160 193.4S223.7 164.8 223.7 129.7C223.7 94.3 195.1 65.7 160 65.7S96.3 94.3 96.3 129.7z"}]}}),H.register({"brands/opencart":{width:640,height:512,paths:[{d:"M423.3 440.7C423.3 466 403 486.3 377.7 486.3S331.9 466 331.9 440.7 352.5 394.9 377.7 394.9C403.1 394.9 423.3 415.4 423.3 440.7zM169.4 394.9C144.1 394.9 123.8 415.5 123.8 440.7S144.1 486.3 169.4 486.3 215.2 466 215.2 440.7 194.7 394.9 169.4 394.9zM461.1 124.9C158.9 124.9 81.9 112.1 0 25.7 34.4 77.4 53.3 174.6 373.1 169.9 706.4 164.9 503.1 256 443.9 358.8 630.6 192.1 763.3 124.9 461.1 124.9z"}]}}),H.register({"brands/openid":{width:448,height:512,paths:[{d:"M271.5 432L203.5 464C88.5 453.7 0 392.5 0 318.2 0 246.7 82.5 187.2 191.7 173.9V216.9C120.2 229.4 67.7 269.9 67.7 318.2 67.7 369.2 126.2 411.5 203.4 421.2V81.2L271.4 48V432zM448 291L316.7 262.5 353.5 241.8C334 230.3 310 221.8 283.5 217V174C329.7 179.5 371.2 193.5 403.8 213.3L438.8 193.5 448 291z"}]}}),H.register({"brands/opera":{width:496,height:512,paths:[{d:"M313.9 32.7C143.7 32.7 61.3 256.5 166.4 387.8 202.9 433.2 255 463.4 313.9 463.4 350.2 463.4 384.2 452.3 413.3 433 369.5 472.2 311.4 496 248 496 244.1 496 240 496 236.1 495.7 104.6 489.6 0 381.1 0 248 0 111 111 0 248 0H248.8C311.9 0.3 369.5 24.1 413.2 63.1 384.2 43.7 350.1 32.7 313.9 32.7zM415.7 430.4C374.8 455.1 325 454 283.7 424.6 339.9 404.1 381.4 333 381.4 248 381.4 163.3 340.2 92.2 284 71.4 325.8 42.2 375.2 41.1 416.9 66.4 522.8 165.1 522.4 332.1 415.7 430.4z"}]}}),H.register({"brands/optin-monster":{width:576,height:512,paths:[{d:"M550.7 450.3C550.7 461.9 535 469.8 518.5 465.2 506.4 461.9 487.2 447.6 482.3 437.9 476.6 426.3 486.4 405.2 501.2 407.1 516.9 408.7 550.7 432.5 550.7 450.3zM372.9 75.2C369.1 3.1 272.1-4.5 246.9 51.7 291.5 27.4 337.2 36 372.9 75.2zM74.8 407.1C59.1 408.7 25.3 432.5 25.3 450.3 25.3 461.9 41 469.8 57.5 465.2 69.7 461.9 88.6 447.6 93.4 437.9 99.4 426.3 89.7 405.2 74.8 407.1zM572.6 421.4C573.6 424.9 574.5 428.4 574.5 432.2 575.3 463.8 530.1 496.2 500.9 497.3 483.7 498.1 466.4 488.9 458.3 473.8 344.8 477.9 231.3 478.7 118 473.8 109.7 488.9 92.4 497.9 75.1 497.3 46.2 496.2 1 463.8 1.6 432.2 1.8 428.4 2.4 424.9 3.5 421.4-2.1 411.9-1.4 406.1 8.9 409.8 12.1 404.6 15.9 400.3 19.9 396 17.4 385.1 21.2 381.9 31 386.8 35.6 383.6 41 380.3 47 377.6 47 361.9 58.8 366.5 64.3 371.9 76.7 370.2 84.4 372.6 91 377.6V357.9C78 357.9 50.4 346.5 45.1 321.7 40.1 300.9 47.7 283.6 70.2 274.1 71 268.2 78.3 260.1 85.1 258.2 92.6 256.3 97.5 262.8 99.1 268.4 106.5 268.4 116.9 269.9 120.2 276.5 125.6 276 131.3 275.2 136.7 274.7 134.2 272.8 131.5 271.1 128.6 270.1 123.4 261.1 114.8 259 104 258.4 104 257.6 104 256.8 104.3 255.7 84.5 255.2 60.2 250.1 49.4 237.9 28.1 214.3 33.5 154.3 61.6 134.4 69.9 128.7 83.2 133.6 84.3 144.1 86.7 164.7 84.7 171 110.5 170.1 118.6 162.2 127.2 155.5 136.9 150.1 122.1 148.7 108 151.7 93.2 153.9 105.9 141.4 117.1 128.4 149.9 111.4 173.4 99.5 199.9 90.6 226.1 88.2 207.5 80.4 186.1 76.3 166.4 71.7 242.9 55.5 341 49.5 410.7 109.3 428.8 124.7 443.1 145.5 453.4 169.3 493.2 174.1 489.9 163.7 492 144.1 493.1 133.9 506.4 128.7 514.7 134.7 529.6 145.2 536.9 165.5 539.3 182.8 541.5 200.6 539.6 224.1 526.9 237.9 516.1 250.1 492.6 255.5 473.1 256V258.7C462 259 452.8 261.1 447.4 270.3 444.5 271.4 441.8 273 439.1 274.9 444.7 275.5 450.4 276.3 455.8 276.8 457.7 271.2 468.4 268.4 476.9 268.4 478.5 263 483.7 256.5 490.9 258.2S505 268.2 505.8 274.1C516.6 278.4 528 286.3 530.9 299.8 532.8 307.9 532.6 314.9 531.2 321.7 525.5 346.9 497.9 357.9 485.3 357.9 485.3 364.6 485.3 371.1 485 377.6 493 371.6 501.4 370.5 511.8 371.9 517.7 366 529.3 362.5 529.3 377.6 535 380.3 540.7 383.6 545.3 386.8 555.4 381.7 558.9 386.3 556.1 396 560.1 400.3 564.2 404.9 567.2 409.8 577.3 406.1 578.2 411.8 572.6 421.4zM498.8 167.4C516.1 174.1 525 189.5 529.1 203 530.1 192.5 526.3 163.6 515.3 152 508 144.7 501.2 146.8 501.2 152.8 501.2 159 499.9 164.4 498.8 167.4zM480.1 179.8C493.1 195.5 497.2 221.4 492.8 242.8 503.6 240.6 513.4 236.6 519.1 230.6 520.9 228.4 522.8 225.7 523.9 223 522.8 201.7 513.6 180.3 494.2 174.1 490.9 177.4 485 179 480.1 179.8zM458.3 180.6C465.8 201.2 470.7 223.3 472.6 245.2 476.1 245.2 480.1 244.9 484.2 244.4 490.1 220.1 483.9 192.8 470.1 180.9 466.4 180.9 462 180.9 458.3 180.6zM77.8 167.4C76.7 164.4 75.3 159 75.3 152.8 75.3 146.8 68.3 144.7 61.3 152 49.9 163.6 46.4 192.5 47.5 203 51.6 189.5 60.5 174.1 77.8 167.4zM83.4 242.8C79.1 221.4 83.2 195.5 96.1 179.8 91.3 179 85.3 177.4 82.1 174.1 62.6 180.3 53.7 201.7 52.4 223 53.7 225.7 55.3 228.4 57.2 230.6 62.9 236.8 72.6 240.6 83.4 242.8zM124.8 181.7C119.7 182.8 114.8 184.7 109.9 186.6L97.8 191.7V191.4C90.5 205.5 87.8 225.7 92.4 244.4 97 244.9 101 245.2 105.1 245.2 107.5 223 114.2 201.4 124.8 181.7zM212.9 158.5C212.9 200.6 247.2 234.7 289.1 234.7S365.3 200.6 365.3 158.5C365.3 116.6 331 82.5 289.1 82.5S212.9 116.6 212.9 158.5zM365.3 255.7C375.3 306.3 368.6 320.4 381.8 313.8 397.7 305.7 404.5 274.7 404.7 256.8 391.8 256 378.5 256 365.3 255.7zM293.7 255.2V254.9C293.4 260.1 294 293 298 296 309.1 301.4 337.5 300.6 349.1 297.1 354.5 295.5 351.5 260.1 350.7 255.2 331.8 254.9 312.6 254.9 293.7 255.2zM279.6 255.2V254.9C260.2 255.2 241 255.2 221.8 255.7 219.9 264.9 217.2 304.6 223.7 307.4 236.7 313 265.3 312.5 278.3 309 282.9 306.5 280.7 263.6 279.6 255.2zM194 312.8C199.4 315.2 202.6 315.2 203.7 308.4 205.6 299.8 206.1 271.7 208.6 256.3 196.4 256.5 184 257.1 171.8 257.9 166.4 277.6 172.1 303 194 312.8zM128.3 301.7C172.1 348.7 221 387.3 284.2 408.1 351.8 389 399.9 348.2 447.4 301.1 436.3 296.8 439.7 290.8 440.1 289.5 431.2 288.7 422.3 287.6 413.7 286.8 404.2 319.8 377.7 339.8 366.9 318.4 364.2 313.3 363.4 306.8 362.3 301.7 358.5 310.1 349.1 309.8 337.7 310.6 324.5 311.7 306.1 311.9 293.7 307.6 290.7 320.6 282.6 320.6 266.9 321.9 252.9 323.3 218.3 326 212.1 311.1 211 339.8 176.9 321.1 166.9 304.1 163.7 298.4 161.5 292.8 159.9 286.5 152.1 287.4 144.2 288.2 136.4 289.2 138.8 292.9 138 298.3 128.3 301.7zM115.6 453.5C109.9 430.3 97 403.8 82.1 399.5 59.7 392.7 13.2 423 15.9 454.1 28.6 473.5 55.9 489.8 75.1 490.6 92.9 491.4 111 479.5 114.8 461.7 115.3 459.2 115.6 456.5 115.6 453.5zM122.9 447.6C156.4 428.1 192.1 411.9 228.8 400.6 190.2 380 160.7 352.8 131.5 323.6 129.4 324.9 126.4 326 123.7 327.1 122.1 332 132.4 332.4 129.1 339.5 127 343.6 120.5 347.1 114 348.7 111.8 351.4 108.8 353.6 106.1 355.2H105.9C105.6 368.7 105.6 382.2 106.1 395.7 115.1 411.7 121.6 429 122.9 447.6zM443.7 460.3C406.9 439 369.6 419 328 407.3 314.2 413.6 300.2 418.7 285.8 422.7 283.7 423.6 283.7 423.6 281.5 422.7 269.6 419 258.3 414.6 246.7 409.5 206.4 421.1 169.4 438.7 134.2 460.3H134V460.6C134.2 460.6 134.2 460.6 134.2 460.3 237.5 464.4 340.7 463.8 443.7 460.3zM470.7 396.3L470.4 396.5C471 382.7 471.2 369 471.2 355.2 468.3 353.6 465.5 351.1 463.1 348.4 456.6 347.1 450.1 343.3 448 339.5 446.1 335.5 449.3 331.9 453.9 329.2 453.7 328.7 453.4 327.6 453.4 326.8 450.4 326 448 324.9 445.8 323.6 414.2 353 380.4 380.3 342.3 400.3 381.2 411.9 418.3 428.4 454.2 447.9 455.2 433.2 461.4 412.1 470.7 396.3zM493.9 399.5C479.3 403.8 466.1 430.3 460.4 453.5 460.4 477.4 481.7 491.4 500.9 490.6 520.1 489.8 547.4 473.5 560.1 454.1 563.1 423 516.6 392.7 493.9 399.5zM290.7 134.1C290.8 134.1 290.8 134.1 290.8 134.1 290.9 134.1 290.9 134.1 291 134.1H290.7zM290.7 230.9C319.4 230.9 342.6 209.3 342.6 182.5 342.6 146.4 302.1 124.4 270.4 138.2 279.9 141.2 286.9 149.8 286.9 159.8 286.9 183.1 253.6 191.8 240.4 171.2 233.1 205.2 259.8 230.9 290.7 230.9zM68 474.1C68.6 480.6 80.2 486.8 89.7 483.5 96.4 480.8 104.3 473 107 467.3 109.9 460.3 105.9 447.3 97.2 449 88.3 450.6 67.5 465.7 68 474.1zM478.8 449C470.4 447.3 466.4 460.3 469.3 467.3 471.8 473 479.6 480.8 486.6 483.5 495.8 486.8 507.7 480.6 508 474.1 508.8 465.7 487.7 450.6 478.8 449z"}]}}),H.register({"brands/osi":{width:495,height:512,paths:[{d:"M0 259.2C2.3 123.4 97.4 26.8 213.8 11.1 352.6-7.5 469.4 86.9 491.8 212.2 513.1 331 447.8 442.2 340.2 486.2 330.9 490 325.8 487.9 322.2 478.5 304.4 432.2 286.6 385.8 268.8 339.5 265.7 331.4 267.8 326.3 275.8 322.7 300 311.7 315.1 293.3 319.1 266.9 325.5 224.5 294.6 188.2 254.6 184.7 215.6 181.3 182.8 208.4 177.1 244.4 171.9 277.4 188.2 308.1 219 322.1 228.6 326.5 230.5 330.7 226.8 340.5 208.9 387.1 191 433.7 173.1 480.4 170.5 487.3 164.8 489.7 157.6 486.9 105 466.6 56.2 425.9 26.8 367.9 1.9 318.7 1.6 280.2 0 259.2zM20.9 257.3C21.3 263.9 21.5 271.6 22.2 279.4 28.5 351.3 71.8 422.9 153.2 462.5 156.4 464 157.6 463.3 158.8 460.2 173.7 421.1 188.7 382 203.8 342.9 205.1 339.6 204.4 338.1 201.4 336.2 169.8 316.3 154.1 287.7 155.8 250.2 156.8 228.6 165.1 209.7 179.6 193.9 209.6 161.2 256.6 154.1 295.1 176.3 327 194.7 344.6 230.1 340.3 266.7 336.7 297.3 321 320.6 294.6 336.5 291.9 338.1 291.1 339.4 292.3 342.5 307.5 381.7 322.5 420.9 337.5 460.2 338.7 463.3 339.9 464 343.1 462.5 378.6 445.9 408.3 422.2 431.2 390.5 466 342.3 480.3 288.6 473.5 229.5 459.8 112 354.1 14.7 218 31.5 111.9 44.5 22.7 134 20.9 257.3z"}]}}),H.register({"brands/page4":{width:496,height:512,paths:[{d:"M248 504C111 504 0 393 0 256S111 8 248 8C268.9 8 289.3 10.6 308.7 15.5L42.3 392H248V504zM248 360.4V146.8L98.6 360.4H248zM344 392V484.7C389.7 465.5 428.5 433 455.4 392H344zM401.4 253.8L380.2 262.2 401.4 270.5V253.8zM381.1 308.3C374.4 308.3 373.1 314.6 373.1 321.2V328.9H389.3V318.9C389.3 313 387 308.3 381.1 308.3zM496 256C496 293.3 487.8 328.7 473 360.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6H428.6V96H414.7V128.6H400.8V99H386.9V128.6H374.2V96H360.3V143.6zM428.5 328.9H402V317.9C402 302.5 396.4 292.7 381.1 292.7 365.7 292.7 360.4 303.3 360.4 318.6V343.9H428.6V328.9zM428.5 225.9L360.3 255.6V268L428.5 297.5V280.9L414.1 275.2V248.7L428.5 242.8V225.9zM423.7 157.4H388.1V184H402V171.8H413C421.6 187.6 414.3 207.1 394.4 207.1 371.9 207.1 366.1 181.8 378.9 169.4L367.3 158.8C351.1 176.3 355.1 222.7 394.4 222.7 428.4 222.7 439.1 186.8 423.7 157.4z"}]}}),H.register({"brands/pagelines":{width:384,height:512,paths:[{d:"M384 312.7C328.9 449.4 196.9 366.7 196.9 366.7 156.4 448.5 89.5 501.1 12.3 501.4-3.8 501.4-4.3 477 12.3 477 76.7 476.7 132.8 434.3 169.5 366.9 128.4 382.8 50.9 394.8 7.9 284.7 116.9 239.8 167 295.9 186.2 330.2 196.1 305.8 203.2 279.3 207.8 250.5 207.8 250.5 68.1 272.4 58.3 152.4 177.4 104.5 210.9 229.1 210.9 229.1 212.5 212.4 214.2 176.5 214.2 175.7 214.2 175.7 107.9 102 176.1 10.5 300.7 53.5 237.5 172.9 237.5 172.9 238 174.5 238 196.7 237.5 206.3 237.5 206.3 282.7 117.3 373.9 148.8 369.7 282.8 232 255.2 232 255.2 227.6 282.6 220.8 308.6 212 332.7 212 332.7 295 240.9 384 312.7z"}]}}),H.register({"brands/palfed":{width:576,height:512,paths:[{d:"M384.9 193.9C384.9 146.5 329.7 149.7 289.5 164.1 288.2 203.5 287 244.8 286.5 283.9 287.2 286.7 289.1 290.1 301.6 290.1 338.4 290.1 385 247.3 384.9 193.9zM190.4 266.1C190.6 266.1 196.9 263.4 201.6 263.4 228.2 263.4 222.3 307.5 187.2 307.5 165.7 307.5 150.1 289.4 150.1 264.5 150.1 222.5 193 168.9 250.8 138 251.8 125.6 253.8 116 261.3 109.8 272.5 100.8 287.9 106.3 290.8 120.9 363 98.7 426 121.9 426 192.9 426 270.8 346.7 345.5 285.9 331.1 285.8 370.5 286.8 405.5 288.6 431.1V431.3C288.8 434.7 289.2 443.8 283.3 450.4 273.7 461 249.9 460.4 246.9 428.1 242.8 383.7 247.1 222 248.3 185.6 226.8 200.6 189.8 235.9 189.8 261.5 190 264 190.2 265.5 190.4 266.1zM8 181.1S7.9 218.5 46.4 218.5H76.4L98.8 435.7S98.8 480 143.5 480H432.4S477.1 479.6 477.1 435.7L499.5 218.5H529.5S567.9 219.7 567.9 181.1C567.9 181.1 568 143.7 529.5 143.7H499.4C492.1 118.1 469.2 69.4 380 69.4H352V50.3S349.3 31.9 330.9 31.9H245.1S224 31.9 224 50.3V69.4H195.9S90.9 73.6 75.4 143.7H46.4S8 142.5 8 181.1z"}]}}),H.register({"brands/patreon":{width:512,height:512,paths:[{d:"M512 194.8C512 296.1 429.6 378.6 328.2 378.6 226.5 378.6 143.8 296.2 143.8 194.8 143.8 93.2 226.5 10.5 328.2 10.5 429.6 10.5 512 93.2 512 194.8zM0 501.5H90V10.5H0V501.5z"}]}}),H.register({"brands/paypal":{width:384,height:512,paths:[{d:"M111.4 295.9C107.9 315.1 94 404.6 89.9 429.9 89.6 431.7 88.9 432.4 86.9 432.4H12.3C4.7 432.4-0.8 425.8 0.2 418.5L58.8 46.6C60.3 37 68.9 29.7 78.8 29.7 231.1 29.7 243.9 26 282.8 41.1 342.9 64.4 348.4 120.6 326.8 181.4 305.3 244 254.3 270.9 186.7 271.7 143.3 272.4 117.2 264.7 111.4 295.9zM357.1 152C355.3 150.7 354.6 150.2 354.1 153.3 352.1 164.7 349 175.8 345.3 186.9 305.4 300.7 194.8 290.8 140.8 290.8 134.7 290.8 130.7 294.1 129.9 300.2 107.3 440.6 102.8 469.9 102.8 469.9 101.8 477 106.3 482.8 113.4 482.8H176.9C185.5 482.8 192.6 476.5 194.3 467.9 195 462.5 193.2 474 208.7 376.6 213.3 354.6 223 356.9 238 356.9 309 356.9 364.4 328.1 380.9 244.6 387.4 209.8 385.5 173.2 357.1 152z"}]}}),H.register({"brands/periscope":{width:448,height:512,paths:[{d:"M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4 18.5 289.5 76.3 374.2 101.2 407.1 137.8 455.5 192.6 512 226.6 512 268.2 512 339.5 417.8 347.5 407 372.1 373.9 429.5 288.7 429.5 214.4 429.5 157.9 408.4 104.3 370 63.6zM226.6 493.9C184.1 493.9 36.6 326.6 36.6 214.5 36.6 107.1 120.5 18.2 226.6 18.2 327.4 18.2 411.3 107.2 411.3 214.5 411.4 326.6 263.9 493.9 226.6 493.9zM338 206.8C338 265.9 286.9 316.5 227.2 316.5 126.6 316.5 76.5 208.3 134.3 134.7V135.1C134.3 159.6 154.4 179.5 179.1 179.5 203.8 179.5 223.9 159.6 223.9 135.1 223.9 116.9 212.8 101.3 197 94.4 273.6 75.2 338 133.7 338 206.8z"}]}}),H.register({"brands/phabricator":{width:496,height:512,paths:[{d:"M323 262.1L322.9 249.1S344.6 229.3 344 227.9L334.5 207.9C333.9 206.5 305 207.4 305 207.4L295.6 198.1S295.8 169.6 294.4 169L274.3 159.8C272.9 159.2 253.6 180.8 253.6 180.8L240.5 180.6S220 159.2 218.6 159.8L198.6 168.1C197.2 168.6 198.8 197 198.8 197L189.7 206.1S160.5 205.2 160 206.5L151.9 226.3C151.3 227.7 172.9 247.3 172.9 247.3L173 260.2S151.3 280 151.9 281.4L161.4 301.4C162 302.8 190.9 301.9 190.9 301.9L200.3 311.2S200.1 343 201.5 343.5L221.6 351.8C223 352.4 242.3 328.3 242.3 328.3L255.4 328.5S275.9 352.3 277.2 351.8L297.2 344.3C298.6 343.7 297 312.2 297 312.2L306.1 303.1S335.3 304 335.8 302.6L343.9 282.8C344.6 281.7 323 262.1 323 262.1zM278.1 253.4C278.8 270.5 265.3 285 248 285.8 230.7 286.6 215.9 273.3 215.2 256.2 214.5 239.1 228 224.6 245.3 223.9 262.6 223.1 277.4 236.4 278.1 253.4zM479.3 215.5L382.3 118.5 382.2 118.6C307.1 45.3 186.8 45.8 112.4 120.2 61.5 171.2 84.6 148.1 16.7 215.5-5.6 237.8-5.6 274.2 16.7 296.5 86.6 365.9 63.1 342.5 114.1 393.5L114.2 393.4C189.3 466.7 309.6 466.3 384 391.8 435 340.9 411.9 363.9 479.3 296.5 501.6 274.2 501.6 237.8 479.3 215.5zM140.4 363.8C80.8 304.3 80.8 207.8 140.4 148.3 199.9 88.7 296.4 88.8 356 148.3 415.5 207.8 415.6 304.3 356 363.9 296.4 423.4 200 423.3 140.4 363.8z"}]}}),H.register({"brands/phoenix-framework":{width:640,height:512,paths:[{d:"M212.9 344.3C216.7 344.2 235.7 342.9 238.5 342.1 236.1 339.5 194.9 341.1 170.5 292.5 166.2 283.9 163 274.9 164.1 264.9 167 239.4 197 234.9 216.1 246.4 252.1 268 279.4 337.7 329.8 343.9 366.8 348.4 414.4 326.9 438 298.5 437.4 298.4 437.2 298.3 437 298.4 436.6 298.5 436.2 298.6 435.9 298.7 402.6 310.8 341.6 308.4 301.2 283.9 263.6 261.1 248.1 225.2 249.4 209.3 251.2 188 272.3 186.1 285.3 189.7 299.7 193.6 309.7 207.3 324.2 217.1 339.8 227.5 357.1 230.8 375.5 227.4 390.4 224.7 409.9 215.1 412 212.9 410.9 212.8 410.2 212.8 409.5 212.7 403.3 212.1 397.1 211.9 391 211 279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9 1.4 73.5 0.7 74.1 0 74.7 0.1 74.9 0.1 75 0.2 75.2 1 75.2 1.8 75.1 2.6 75 8.9 74 15.1 74.2 21.3 75.3 45.1 79.6 69 98.4 77.2 151.8 82.5 186.1 76.5 202.6 85.2 237.9 104.2 315 176.2 345.5 212.9 344.3zM75.3 64.9C74.4 63.9 74.4 63.7 74 62.9 86.1 60.3 98.2 58.8 110.6 58.1 109.5 72.8 88.4 79.4 75.3 64.9zM272.2 415.4C229.4 416.6 180.2 388.7 148.7 354 144.1 349 131.9 333.8 130.1 330.6L130.5 330.2C137.1 334.3 156.2 348.8 185.3 357.2 209.5 364.2 233.4 363.5 256.9 353.9 279.6 344.6 297.9 353.4 300 356.8 281.5 360.6 279.9 361.2 276 364.7 270.9 369.1 271.4 376.4 283 381.9 309.2 394.3 346 379.1 380.2 407.3 382.6 409.3 388.3 415.1 390.3 418 390.2 418.2 390 418.3 389.9 418.5 385.1 417 373.5 411 349.7 409.2 325 407.2 303.4 414.5 272.2 415.4zM447 163.4C463.4 158.2 488.3 150 513.5 160.1 529.6 166.6 539.7 178.8 545.6 194.7 549.1 204.1 550.7 214.4 550.7 223.4 550.5 223.4 550.3 223.4 550.1 223.5 549.9 223.1 549.7 222.6 549.6 222.2 544.6 200.2 519.7 178.4 482 192.3 431.8 210.9 351.6 202 305.1 144.3 304.4 143.4 302.7 142.6 303.8 141.1 303.9 140.9 305.9 141.7 306.8 142.4 324.9 155.8 345.1 164.3 367.1 168.6 397.6 174.7 421.7 171.5 447 163.4zM549.7 280.9C517.3 281.1 515.9 331 446.1 345.3 427.9 349 407.4 349.9 401.2 349.5V349.1C404 347.6 415.9 346.5 430.9 332.5 438.8 325.2 446.2 317.4 453.7 309.6 473.2 289.4 495.1 267.4 535.6 270.6 558.7 272.4 564.9 278.8 571.7 283.3 572 283.5 572.1 283.8 572.4 284.2 571.9 284.2 571.7 284.3 571.5 284.2 564.5 281.5 557.2 280.9 549.7 280.9zM537.4 256.8C537.3 257 537.3 257.2 537.2 257.4 508.3 253 489.2 249.5 468.7 261.4 451.7 271.3 437.3 281.9 406.7 285.8 379.6 289.2 361.6 288.2 340.6 277.8 340.3 277.6 340 277.4 339.6 277.2 339.6 277 339.7 276.9 339.7 276.7 364.6 280.5 376.1 281.8 395.2 270.9 417.5 258 435.3 244.3 466.5 239.9 496.1 235.8 517.8 242.4 537.4 256.8zM268.6 97.3C268 96.7 267.5 96.1 266.5 95 274.1 95 296.2 93.8 319.9 103.4 339.6 111.4 352.1 124.4 370.1 136.3 381.2 143.6 393.5 145.6 406.5 144.4 410.8 144 415 143.2 419.3 142.7 419.7 142.6 420.2 142.7 420.8 143 420.2 143.4 419.6 143.9 419 144.2 410.9 148.2 402.3 150.5 393.4 151.3 367.3 153.9 343.1 147.6 320 135.9 300.7 126 283.6 113 268.6 97.3zM640 335.7C636.5 338.8 617.3 347.3 597.3 341 585 337.1 577.8 326.1 565.7 316.9 555.7 309.3 544.8 309 537.6 308.5 538.2 307.7 538.5 307.3 538.8 307.1 553.6 297.9 569.3 294.9 586.1 300.6 598.6 304.8 605.3 314.1 616.5 324.8 627.3 335.2 637.5 334.7 639.6 335.3 639.7 335.2 639.8 335.3 640 335.7zM427.5 472.7C429.7 473.9 429.1 474.2 429 474.7 410.5 473.3 395.1 467.1 382.2 452.5 360.4 427.8 340.5 424.6 333.6 422.8 334.1 422.6 334.4 422.4 334.7 422.4 347.8 422.5 360.8 423.1 373.6 426.3 398.9 432.7 408.6 451.7 415.2 461.6 418.4 466.4 422.5 469.9 427.5 472.7z"}]}}),H.register({"brands/php":{width:640,height:512,paths:[{d:"M320 104.5C491.4 104.5 623.2 176.7 623.2 256S491.3 407.5 320 407.5C148.6 407.5 16.8 335.3 16.8 256S148.7 104.5 320 104.5M320 87.7C143.3 87.7 0 163 0 256S143.3 424.3 320 424.3 640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5C210.3 283 182.4 278.8 148.1 278.8L161.8 208.2C199.8 208.2 225.6 204.1 218.2 242.5zM97.4 350.3H134.1L142.8 305.5C183.9 305.5 209.4 308.5 233 286.4 259.1 262.4 265.9 219.7 247.3 198.3 237.6 187.1 222 181.6 200.8 181.6H130.1L97.4 350.3zM283.1 136.7H319.6L310.9 181.5C342.4 181.5 371.6 179.2 385.7 192.2 400.5 205.8 393.4 223.2 377.4 305.3H340.4C355.8 225.9 358.7 219.3 353.1 213.3 347.7 207.5 335.4 208.7 305.7 208.7L286.9 305.3H250.4L283.1 136.7zM505 242.5C497 283.6 468.3 278.8 434.9 278.8L448.6 208.2C486.8 208.2 512.4 204.1 505 242.5zM384.2 350.3H421L429.7 305.5C472.9 305.5 496.8 308 519.9 286.4 546 262.4 552.8 219.7 534.2 198.3 524.5 187.1 508.9 181.6 487.7 181.6H417L384.2 350.3z"}]}}),H.register({"brands/pied-piper-alt":{width:576,height:512,paths:[{d:"M242 187C248.3 175.2 255.2 170 267.9 165.2 295.2 154.9 308.1 134.7 326.8 114.1 338.7 122.5 338.8 138.7 358.4 137.1V158.9L364.7 159.2C402.1 144.8 439.4 129 471.3 104.6 519.6 67.8 524.2 54.6 552.6 4.6L554.6 2C554 16.1 548.3 29.3 542.2 41.9 511.7 105.7 463.5 142.2 395.4 158.6 383 161.5 369 161.8 357.8 167.5 359.2 177.3 371 185.6 371 190.5 371 193.9 365.5 197.7 363.5 199.1 352.3 186.2 347.4 179.8 340.8 177 333.2 173.5 276.9 170.6 242 187zM379.9 443.9C360.9 443.9 315.8 453.4 300 463.7L306.9 508.8C342.6 514.9 377 512.4 412.9 499 408.1 489 389.4 443.9 379.9 443.9zM244 246C240.8 244 237.7 243.1 233.9 243.1 227.3 243.1 221.3 246.3 214.6 246.8L216.3 251.7 244 246zM231.4 277.8L255.5 339 276.5 325.2 245.2 274.3 231.4 277.8zM555.5 0L554.9 1.1 554.6 2 555.2 1.4 555.5 0zM496.3 382.1C462.4 325.2 421 263.7 346.3 266.6L346 260.6C344.9 247.1 378.8 263.8 381.1 229.6L366.7 236.8C346.9 191.1 358.1 182.5 301.2 182.5 286.5 182.5 274.5 184.2 259.8 187.1 262.7 205.7 262 223.8 248.9 237.4L268.4 242.9C266.7 246.1 265.5 249.2 265.5 252.7 265.5 273.7 308.3 255.6 308.3 286.3 308.3 304.7 271.5 346.4 253.4 346.4 245.4 346.4 199.7 296.4 200 286.3L200.3 281.7 252.6 270.2C265.6 267.6 264.9 247.5 249.7 247.5 246 247.5 206.6 256.7 200.3 258.1 198.3 252.9 192.8 244 186.5 244 183.3 244 180.2 247.2 177 248 167.8 250.6 146 250.9 155.5 268.1L15.9 298.5C10.4 299.6 7 304.8 7 310.3 7 316.3 12.5 321.2 18.5 321.2 26.5 321.2 149.8 292.8 165.9 289 168.5 292.2 170.5 295.3 173.7 297.6 193.8 312 233.5 383.5 250.1 383.5 274.2 383.5 308.1 361.1 321.4 341.6 324.6 337.3 328.3 334.1 333.8 334.7 334.4 348.5 302.2 368.9 300.8 378.4 299.4 388.6 299.8 413.6 300.5 419.5 327.2 427.6 352.5 415.9 378.4 416.6 382.7 395.6 389 374.7 388.2 353.1L387.9 343.6C386.5 309.4 377 305.1 353.1 285 352 283.9 350.5 282.4 349.4 281 351.6 279.6 350.5 280 354 279.3 442.5 279.3 410.3 462.9 465.5 509.2 498.6 494.2 538 481.3 569 462 540 436.4 516.4 416.3 496.3 382.1zM300.1 428.1V455.4L311.9 452 309 428.2H300.1zM376.2 431C376.2 429.6 375.6 427.8 375.3 426.4 348.5 426.4 338.4 430.2 315.8 432.7L317.8 445.1C326.8 443.6 376.2 438.5 376.2 431z"}]}}),H.register({"brands/pied-piper-pp":{width:448,height:512,paths:[{d:"M205.3 174.6C205.3 195.7 191.1 212.7 173.6 212.7 166.5 212.7 160.8 211.5 156.4 209V141C160.8 138.3 166.5 136.8 173.6 136.8 191.1 136.8 205.3 153.7 205.3 174.6zM257.9 241.6C250.8 241.6 245.1 243.1 240.7 245.8V313.8C245.1 316.3 250.8 317.5 257.9 317.5 275.3 317.5 289.6 300.6 289.6 279.7 289.6 258.6 275.3 241.6 257.9 241.6zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM185 255.1C226 255.1 259.2 219.5 259.2 175.5 259.2 131.5 226 95.9 185 95.9 173 95.9 160.9 99.1 150.4 104.7H104.7V311L156.5 300.9V250.3C165.1 253.4 174.6 255.1 185 255.1zM343.4 280.4C343.4 236.4 310.2 200.8 269.5 200.8 266.3 200.8 263.1 201 259.9 201.5 256.2 214 249.8 225.3 240.7 234.9 226.9 249.9 208.5 258.7 188.9 259.7V416L240.7 405.9V355.3C249.3 358.5 258.9 360 269.4 360 310.2 360 343.4 324.4 343.4 280.4z"}]}}),H.register({"brands/pied-piper":{width:640,height:512,paths:[{d:"M640 24.9C559.2 78.5 550.6 117.4 543.6 129.3 536.9 141.5 531.9 189.6 520.3 212.9 508.6 236.5 466.1 255.1 454.2 262.9 442.5 270.7 425.9 301 412.3 327.1 304.2 322.7 244.9 365.9 153.1 420.7 182.5 411 196.4 404 196.4 404 290.6 368 335.7 335.7 477.5 354.8 478.6 354.8 479.4 355.4 480.3 355.6 484.2 357.8 485.6 362.5 483.4 366.4L429.5 462.2C427 466.9 421.7 469.4 416.4 468.3 289.6 444.5 189.5 485.6 97.5 486.9 24.1 488 0 453.4 0 451.8 0 450.7 0.6 450.1 1.7 450.1 1.7 450.1 40 450.1 104.8 434.8 178.4 294.5 244 245.4 315.4 245.4 315.4 245.4 387.1 245.4 406 307.3 428.8 267.6 434.3 258.1 434.3 258.1 439.6 248.7 469.3 180.9 520.7 116.7 572.2 52.7 611.1 36.8 640 24.9z"}]}}),H.register({"brands/pinterest-p":{width:384,height:512,paths:[{d:"M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296 73.5 296 79.2 268.4 79.2 260.6 79.2 251.3 55.5 231.5 55.5 192.8 55.5 112.4 116.7 55.4 195.9 55.4 264 55.4 314.4 94.1 314.4 165.2 314.4 218.3 293.1 317.9 224.1 317.9 199.2 317.9 177.9 299.9 177.9 274.1 177.9 236.3 204.3 199.7 204.3 160.7 204.3 94.5 110.4 106.5 110.4 186.5 110.4 203.3 112.5 221.9 120 237.2 106.2 296.6 78 385.1 78 446.3 78 465.2 80.7 483.8 82.5 502.7 85.9 506.5 84.2 506.1 89.4 504.2 139.8 435.2 138 421.7 160.8 331.4 173.1 354.8 204.9 367.4 230.1 367.4 336.3 367.4 384 263.9 384 170.6 384 71.3 298.2 6.5 204 6.5z"}]}}),H.register({"brands/pinterest-square":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H154.4C164.2 463.6 176.8 440 181.8 420.7 184.8 409.2 197.1 362.3 197.1 362.3 205.1 377.6 228.5 390.5 253.4 390.5 327.5 390.5 380.8 322.4 380.8 237.8 380.8 156.7 314.6 96 229.4 96 123.4 96 67.2 167.1 67.2 244.6 67.2 280.6 86.4 325.4 117 339.7 121.7 341.9 124.1 340.9 125.2 336.4 126 333 130.2 316.3 132 308.6 132.6 306.1 132.3 304 130.3 301.6 120.2 289.3 112 266.7 112 245.6 112 191.4 153 139 222.9 139 283.2 139 325.5 180.1 325.5 238.9 325.5 305.3 292 351.3 248.3 351.3 224.2 351.3 206.2 331.4 211.9 306.9 218.8 277.7 232.2 246.2 232.2 225.1 232.2 172.1 156.7 179.4 156.7 250.1 156.7 271.8 164 286.6 164 286.6 132.6 419.4 127.9 421.1 134.4 479.2L136.6 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80z"}]}}),H.register({"brands/pinterest":{width:496,height:512,paths:[{d:"M496 256C496 393 385 504 248 504 222.4 504 197.8 500.1 174.6 492.9 184.7 476.4 199.8 449.4 205.4 427.9 208.4 416.3 220.8 368.9 220.8 368.9 228.9 384.3 252.5 397.4 277.6 397.4 352.4 397.4 406.3 328.6 406.3 243.1 406.3 161.2 339.4 99.9 253.4 99.9 146.4 99.9 89.5 171.7 89.5 250 89.5 286.4 108.9 331.7 139.8 346.1 144.5 348.3 147 347.3 148.1 342.8 148.9 339.4 153.1 322.5 155 314.7 155.6 312.2 155.3 310 153.3 307.6 143.2 295.1 135 272.3 135 251 135 196.3 176.4 143.4 247 143.4 307.9 143.4 350.6 184.9 350.6 244.3 350.6 311.4 316.7 357.9 272.6 357.9 248.3 357.9 230 337.8 235.9 313.1 242.9 283.6 256.4 251.8 256.4 230.5 256.4 211.5 246.2 195.6 225 195.6 200.1 195.6 180.1 221.3 180.1 255.8 180.1 277.8 187.5 292.6 187.5 292.6S163 396.4 158.5 415.8C153.5 437.2 155.5 467.4 157.6 487 65.4 450.9 0 361.1 0 256 0 119 111 8 248 8S496 119 496 256z"}]}}),H.register({"brands/playstation":{width:576,height:512,paths:[{d:"M570.9 372.3C559.6 386.5 532.1 396.6 532.1 396.6L327 470.2V415.9L477.9 362.1C495 356 497.7 347.3 483.7 342.7 469.8 338.1 444.6 339.4 427.5 345.6L327 381.1V324.7C350.2 316.9 374.1 311.1 402.7 307.9 443.6 303.4 493.6 308.5 532.9 323.4 577.1 337.4 582.1 358.1 570.9 372.3zM346.5 279.8V140.8C346.5 124.5 343.5 109.5 328.2 105.2 316.5 101.4 309.2 112.3 309.2 128.6V476.5L215.4 446.7V32C255.3 39.4 313.4 56.9 344.6 67.4 424.1 94.7 451 128.7 451 205.2 451 279.7 405 308 346.5 279.8zM43.2 410.2C-2.2 397.4-9.8 370.7 10.9 355.4 30 341.2 62.6 330.5 62.6 330.5L197.1 282.7V337.2L100.3 371.8C83.2 377.9 80.6 386.6 94.5 391.2 108.4 395.8 133.6 394.5 150.7 388.3L197.1 371.4V420.2C145.5 429.5 95.7 427.5 43.2 410.2z"}]}}),H.register({"brands/product-hunt":{width:512,height:512,paths:[{d:"M326.3 218.8C326.3 239.3 309.6 256 289.1 256H218.8V181.6H289.1C309.6 181.6 326.3 198.3 326.3 218.8zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM375.9 218.8C375.9 170.9 337 132 289.1 132H169.2V380H218.8V305.6H289.1C337 305.6 375.9 266.7 375.9 218.8z"}]}}),H.register({"brands/pushed":{width:432,height:512,paths:[{d:"M407 111.9L308.5 102.9 322.5 69.5C332.9 46 311.7 29.1 293.8 32.5L22.5 76.9C7.4 79.6-3.5 95.2 1.1 113.5L106.2 461.8C112.7 483.1 142.9 486 153.9 468.8L189.2 388 424.4 156.7C440.8 139.9 428.7 113.8 407 111.9zM297.6 53.6C302.7 52.9 305.1 56.1 302.8 61L286 100.9 108.6 84.6 297.6 53.6zM22.7 107.9C19.6 102.8 23.7 97.9 28.8 98.8L277.5 121.5 180.6 352.2 22.7 107.9zM136 456.4C133.4 460.4 128.1 459.5 126.6 455.2L43.5 179.7 171.2 377.3C164.2 392.3 136 456.4 136 456.4zM408.8 141.9L210.1 337.3 299.8 123.6 406.2 133.3C410.2 134.4 411.9 138.6 408.8 141.9z"}]}}),H.register({"brands/python":{width:448,height:512,paths:[{d:"M167.8 36.4C122.6 44.4 114.4 61.1 114.4 92V132.7H221.3V146.3H74.3C43.2 146.3 16 165 7.5 200.5-2.3 241.2-2.7 266.6 7.5 309.1 15.1 340.7 33.2 363.3 64.3 363.3H101V314.5C101 279.2 131.5 248.1 167.8 248.1H274.6C304.3 248.1 328 223.6 328 193.8V91.9C328 62.9 303.6 41.2 274.6 36.3 238.8 30.4 199.9 30.7 167.8 36.4zM161.1 64.8C172.1 64.8 181.2 74 181.2 85.2S172.2 105.5 161.1 105.5C150 105.5 141 96.4 141 85.2 141.1 73.9 150 64.8 161.1 64.8zM346.3 146.2V193.7C346.3 230.5 315.1 261.5 279.5 261.5H172.7C143.5 261.5 119.3 286.5 119.3 315.8V417.6C119.3 446.6 144.5 463.6 172.7 471.9 206.5 481.8 239 483.6 279.5 471.9 306.4 464.1 332.9 448.4 332.9 417.6V376.9H226.2V363.3H386.4C417.5 363.3 429 341.6 439.8 309.1 451 275.6 450.5 243.4 439.8 200.5 432.1 169.6 417.5 146.3 386.4 146.3H346.3zM286.2 404C297.3 404 306.3 413.1 306.3 424.3 306.3 435.6 297.3 444.7 286.2 444.7 275.2 444.7 266.1 435.5 266.1 424.3 266.2 413 275.2 404 286.2 404z"}]}}),H.register({"brands/qq":{width:448,height:512,paths:[{d:"M433.8 420.4C422.2 421.8 388.9 367.7 388.9 367.7 388.9 399 372.8 440 337.8 469.5 354.7 474.7 392.7 488.7 383.6 503.9 376.3 516.3 258.1 511.8 224 507.9 189.9 511.8 71.7 516.3 64.4 503.9 55.3 488.7 93.3 474.7 110.2 469.5 75.2 440 59.1 399.1 59.1 367.7 59.1 367.7 25.8 421.8 14.2 420.4 8.9 419.8 1.8 390.8 23.6 320.7 33.9 287.7 45.6 260.3 63.7 215 60.7 98.1 109 0 224 0 337.7 0 387.2 96.1 384.3 215 402.4 260.2 414.2 287.8 424.4 320.7 446.2 390.8 439.1 419.8 433.8 420.4z"}]}}),H.register({"brands/quinscape":{width:489,height:512,paths:[{d:"M301.9 474.6H300.6C213.3 474.6 142.5 403.8 142.5 316.5S213.3 158.4 300.6 158.4C395.5 158.4 468.8 241.5 457.6 335 461.6 340.1 465.8 344.6 468.8 350.3 482.2 320 489.1 287.9 489.1 252.6 489.1 117.5 379.6 8 244.5 8 109.5 8 0 117.5 0 252.6S109.5 497.2 244.5 497.2C269.3 497.2 292.3 494 314.9 487.1 309.7 483.6 305.9 478.9 301.5 474.5L301.9 474.6zM280.7 404.8C280.7 350 325.1 305.6 379.9 305.6 434.7 305.6 479.1 350 479.1 404.8 479.1 459.6 434.7 504 379.9 504 325.1 504 280.7 459.6 280.7 404.8"}]}}),H.register({"brands/quora":{width:448,height:512,paths:[{d:"M440.5 386.7H411.2C409.7 400.2 400.7 417.5 378.2 417.5 357.7 417.5 342.9 403.3 328.7 381.7 372.9 347.5 403.4 294.2 403.4 228.7 403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7 7.3 362.8 138.6 450.3 256.3 417.7 276 451.3 302 480 351.5 480 433.3 480 442.3 404.7 440.5 386.7zM297 329.2C277.5 300 253.3 277 205.5 277 175 277 151.2 287 136.5 299.8L148.7 324.1C154.9 321.1 161.7 320.1 168.5 320.1 204 320.1 222.2 350.9 237.7 381.4 227.7 384.4 217 385.6 205 385.6 130 385.6 97.5 332.6 97.5 228.9 97.5 124.5 130 71 205 71 281.2 71 313.7 124.5 313.7 228.7 313.8 270.5 308.3 304.3 297 329.2z"}]}}),H.register({"brands/ravelry":{width:512,height:512,paths:[{d:"M407.4 61.5C331.6 22.1 257.8 31 182.9 66 171.6 71.2 167.4 76.6 163 85 152.7 104.2 146.8 122.4 143.1 137.7 121.9 163.3 106.7 193.8 99.8 227.6 89.2 245.6 78.9 269 76.7 299 76.7 299 76 306.6 76.2 306.9 40.9 302.3 0 279.9 0 279.9 9.1 294.4 61.3 312.2 76.3 317.8 76.3 317.8 78 415.8 140.8 449 129.5 431.8 127.5 428.8 127.5 428.8S94.8 369 100.4 324.7C101.1 324.7 101.9 324.9 102.6 324.9 126.5 412.3 205.8 476.3 299.5 476.3 305.7 476.3 311.6 476.1 317.5 475.6 331.5 477.1 345.1 476.1 357.6 471.7 364.5 469.5 371.4 465.3 377.8 460.9 448 421.8 478.7 378.9 500.9 313.2 506.3 297.2 509 277.7 510.7 261 519.4 178.7 480.1 99.4 407.4 61.5zM138.8 163.2S137.6 175.5 138.1 182.9C134.7 185.4 128 191 119.9 199.6 125.1 186.8 131.2 174.5 138.8 163.2zM107.6 285.1C112 267.9 120.9 246 137.4 230 137.4 230 139.1 278 153.2 320.1L111.8 313.2C109.6 304 108.3 294.7 107.6 285.1zM115.5 327.9C130.3 331.1 149.5 335.5 158.6 337 185.9 413.8 266.9 461.3 266.9 461.3 267.9 461.8 268.6 462 269.6 462.3 196.5 450.7 136.9 397.6 115.5 327.9zM386 444.1C371.5 448.8 349.8 452.5 321.3 447.8 321.3 447.8 230.2 424.7 193.8 340 232 340.7 246.2 339.8 271.8 336.1 311.2 330.4 350.8 319.9 386.8 303.1 398.6 297.7 397.9 283.7 396.4 273.3 394.4 260.5 385.3 261.2 375 268.6 375 268.6 293 327.2 185.2 322.3 166.5 290.3 158.4 211.5 158.4 211.5 199.8 176.3 241.6 151.9 326.8 159.1 327 152.7 329.8 132 306.4 131 306.4 131 212.9 119.9 160.4 164.5 162.9 148 166.3 135.2 171.5 125.1 205.7 94.3 250.5 75.6 299.8 75.6 406.2 75.6 492.8 162.7 492.8 270.1 492.6 346.1 449 412.1 386 444.1z"}]}}),H.register({"brands/react":{width:512,height:512,paths:[{d:"M418.2 177.2C412.8 175.4 407.4 173.7 402 172.1 402.9 168.4 403.7 164.7 404.5 161 416.8 101.4 408.7 53.5 381.4 37.7 355.1 22.6 312.2 38.3 268.8 76.1 264.5 79.8 260.3 83.7 256.3 87.6 253.6 85 250.8 82.4 248 79.9 202.5 39.5 156.9 22.5 129.6 38.4 103.4 53.6 95.6 98.7 106.6 155.1 107.7 160.7 108.9 166.2 110.3 171.8 103.9 173.6 97.6 175.6 91.7 177.7 38.3 196.2 0 225.4 0 255.6 0 286.8 40.8 318.1 96.3 337.1 100.8 338.6 105.3 340.1 109.9 341.4 108.4 347.4 107.1 353.3 105.9 359.4 95.4 414.9 103.6 458.9 129.8 474 156.8 489.6 202.2 473.6 246.4 434.9 249.9 431.8 253.4 428.6 256.9 425.2 261.3 429.5 265.9 433.6 270.5 437.6 313.3 474.4 355.6 489.3 381.7 474.2 408.7 458.6 417.5 411.3 406.1 353.7 405.2 349.3 404.2 344.8 403.1 340.2 406.3 339.3 409.4 338.3 412.5 337.3 470.2 318.2 512 287.3 512 255.6 512 225.3 472.6 195.9 418.2 177.2zM282.9 92.3C320.1 59.9 354.8 47.2 370.6 56.3 387.5 66 394 105.2 383.4 156.7 382.7 160.1 382 163.4 381.1 166.7 358.9 161.7 336.4 158.1 313.8 156.1 300.8 137.5 286.6 119.7 271.2 103 275.1 99.3 278.9 95.8 282.9 92.3zM152.9 281.4C157.5 290.2 162.2 298.9 167.2 307.5 172.3 316.2 177.5 324.9 183 333.4 167.4 331.7 151.9 329.2 136.6 325.9 141 311.5 146.5 296.6 152.9 281.4zM152.9 230.8C146.6 215.9 141.3 201.3 136.9 187.2 151.3 184 166.6 181.4 182.5 179.4 177.2 187.7 172 196.2 167.1 204.8 162.2 213.3 157.4 222 152.9 230.8zM164.3 256.1C170.9 242.3 178.1 228.8 185.7 215.5 193.3 202.2 201.5 189.3 210.1 176.6 225.1 175.5 240.4 174.9 256 174.9 271.6 174.9 287 175.5 301.9 176.6 310.4 189.2 318.5 202.1 326.2 215.3 333.9 228.5 341.1 242 347.9 255.7 341.2 269.5 334 283.1 326.3 296.5 318.7 309.8 310.6 322.7 302.1 335.5 287.2 336.6 271.7 337.1 256 337.1 240.3 337.1 225.1 336.6 210.4 335.7 201.7 323 193.5 310 185.8 296.7 178.1 283.4 171 269.9 164.3 256.1zM344.9 307.3C350 298.5 354.8 289.6 359.5 280.6 365.9 295.1 371.5 309.8 376.4 324.9 360.9 328.4 345.2 331.1 329.4 332.9 334.8 324.5 339.9 315.9 344.9 307.3zM359.3 230.8C354.6 222 349.8 213.2 344.8 204.6 339.9 196.1 334.8 187.7 329.5 179.4 345.6 181.4 361 184.1 375.4 187.4 370.8 202.2 365.4 216.6 359.3 230.8zM256.2 118.3C266.7 129.7 276.6 141.7 285.8 154.1 266 153.2 246.1 153.2 226.3 154.1 236.1 141.2 246.2 129.2 256.2 118.3zM140.2 57C157 47.2 194.3 61.2 233.6 96 236.1 98.2 238.6 100.6 241.2 103 225.7 119.7 211.4 137.5 198.3 156.1 175.7 158.1 153.3 161.6 131.1 166.5 129.8 161.4 128.7 156.2 127.6 151 118.2 102.6 124.4 66.1 140.2 57zM115.7 320.6C111.5 319.4 107.4 318.1 103.3 316.7 82 310 57.8 299.4 40.3 285.5 30.2 278.5 23.4 267.7 21.5 255.6 21.5 237.3 53.1 213.9 98.7 198 104.4 196 110.2 194.2 116 192.5 122.8 214.2 131 235.5 140.5 256.1 130.9 277 122.6 298.6 115.7 320.6zM232.3 418.6C215.8 433.7 196.7 445.7 175.9 453.9 164.8 459.2 152 459.7 140.6 455.2 124.7 446 118.1 410.7 127.1 363.2 128.2 357.6 129.4 352 130.8 346.5 153.2 351.3 175.8 354.6 198.7 356.3 211.9 375 226.4 392.9 241.9 409.7 238.7 412.8 235.5 415.8 232.3 418.6zM256.8 394.3C246.6 383.3 236.4 371.1 226.5 358 236.1 358.4 246 358.6 256 358.6 266.3 358.6 276.4 358.4 286.4 357.9 277.2 370.6 267.3 382.7 256.8 394.3zM387.5 424.3C386.6 436.5 380.6 447.9 371 455.6 355.1 464.8 321.2 452.8 284.6 421.4 280.4 417.8 276.2 413.9 271.9 409.9 287.2 393 301.3 375.1 314.1 356.3 337 354.4 359.8 350.9 382.3 345.8 383.3 349.9 384.2 354 385 358 389.9 379.6 390.7 402.1 387.5 424.3zM405.7 316.8C402.9 317.7 400.1 318.6 397.2 319.4 390.2 297.6 381.6 276.3 371.7 255.6 381.3 235.2 389.4 214.2 396.2 192.7 401.4 194.2 406.4 195.8 411.2 197.4 457.8 213.4 490.5 237.2 490.5 255.4 490.5 275 455.6 300.3 405.7 316.8zM256 210.2C281.3 210.2 301.8 230.7 301.8 256 301.8 281.3 281.3 301.8 256 301.8 230.7 301.8 210.2 281.3 210.2 256 210.2 230.7 230.7 210.2 256 210.2"}]}}),H.register({"brands/readme":{width:576,height:512,paths:[{d:"M528.3 46.5H388.5C340.4 46.5 298.6 79.8 288.1 126.8 277.5 79.8 235.8 46.5 187.7 46.5H48C21.5 46.5 0 68 0 94.5V340.3C0 366.8 21.5 388.3 48 388.3H137.7C239.9 388.3 270.4 412.7 285 463.3 285.7 466.1 290.2 466.1 291 463.3 305.7 412.7 336.2 388.3 438.3 388.3H5 8C34.5 388.3 56 366.8 56 340.3V94.6C576 68.2 554.7 46.7 528.3 46.5zM242 311.9C242 313.8 240.5 315.4 238.5 315.4H78.2C76.3 315.4 74.7 313.9 74.7 311.9V289C74.7 287.1 76.2 285.5 78.2 285.5H238.6C240.5 285.5 242.1 287 242.1 289V311.9zM242 251C242 252.9 240.5 254.5 238.5 254.5H78.2C76.3 254.5 74.7 253 74.7 251V228.1C74.7 226.2 76.2 224.6 78.2 224.6H238.6C240.5 224.6 242.1 226.1 242.1 228.1V251zM242 190.1C242 192 240.5 193.6 238.5 193.6H78.2C76.3 193.6 74.7 192.1 74.7 190.1V167.2C74.7 165.3 76.2 163.7 78.2 163.7H238.6C240.5 163.7 242.1 165.2 242.1 167.2V190.1zM501.3 311.8C501.3 313.7 499.8 315.3 497.8 315.3H337.5C335.6 315.3 334 313.8 334 311.8V288.9C334 287 335.5 285.4 337.5 285.4H497.9C499.8 285.4 501.4 286.9 501.4 288.9V311.8zM501.3 250.9C501.3 252.8 499.8 254.4 497.8 254.4H337.5C335.6 254.4 334 252.9 334 250.9V228C334 226.1 335.5 224.5 337.5 224.5H497.9C499.8 224.5 501.4 226 501.4 228V250.9zM501.3 190C501.3 191.9 499.8 193.5 497.8 193.5H337.5C335.6 193.5 334 192 334 190V167.2C334 165.3 335.5 163.7 337.5 163.7H497.9C499.8 163.7 501.4 165.2 501.4 167.2V190H501.3z"}]}}),H.register({"brands/rebel":{width:512,height:512,paths:[{d:"M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5 130 49.5 131.6 48.9 130.8 50.3 125 55.8 19.5 180.1 116.7 276.7 166.5 326.2 206.7 279.2 206.7 279.2 245.2 229.1 206.1 153.3 206.1 153.3 196.1 128.4 160.4 113.2 160.4 113.2L189.2 81.4C213.6 91.9 232.4 120.1 232.4 120.1 233.2 90.5 210.5 58.7 210.5 58.7L255.1 8 299.4 58.1C278.9 86.9 277.5 120.7 277.5 120.7 291.3 97.7 321 81.4 321 81.4L349.5 113.2C322.1 122.1 304.1 153.1 304.1 153.1 288.3 181.6 277 242.5 304.7 280.4 337.1 325 392.4 277.6 392.4 277.6 495.1 185.7 381.9 52.6 381.9 52.6 375.8 47.1 382.7 49.8 382.7 49.8 432.8 86.3 497.3 134.2 498.9 254.6 500.9 400.2 399 504 256.5 504z"}]}}),H.register({"brands/red-river":{width:448,height:512,paths:[{d:"M353.2 32H94.8C42.4 32 0 74.4 0 126.8V385.2C0 437.6 42.4 480 94.8 480H353.2C405.6 480 448 437.6 448 385.2V126.8C448 74.4 405.6 32 353.2 32zM144.9 200.9V257.2C144.9 284.2 123 306.1 96 306.1V151.9C96 138.7 106.7 128 119.9 128H274.1C274.1 155 252.2 176.9 225.2 176.9H168.9C156.6 176.3 144.3 188.5 144.9 200.9zM321.2 272.9H264.9C252.6 272.3 240.3 284.5 240.9 296.9V353.2C240.9 380.2 219 402.1 192 402.1V247.9C192 234.7 202.7 224 215.9 224H370.1C370.1 251 348.2 272.9 321.2 272.9z"}]}}),H.register({"brands/reddit-alien":{width:512,height:512,paths:[{d:"M440.3 203.5C425.3 203.5 412.1 209.7 402.4 219.4 366.7 194.7 318.6 178.8 265.3 177.1L293 52.3 381.2 72.1C381.2 93.7 398.8 111.3 420.4 111.3 442.4 111.3 460.1 93.2 460.1 71.6S442.5 31.9 420.4 31.9C405 31.9 391.7 41.2 385.1 53.9L287.7 32.3C282.8 31 278 34.5 276.7 39.4L246.3 177C193.4 179.2 145.8 195.1 110 219.8 100.3 209.7 86.6 203.5 71.6 203.5 16 203.5-2.2 278.1 48.7 303.6 46.9 311.5 46.1 319.9 46.1 328.3 46.1 412.1 140.5 480 256.4 480 372.8 480 467.2 412.1 467.2 328.3 467.2 319.9 466.3 311.1 464.1 303.2 514 277.6 495.6 203.5 440.3 203.5zM129.4 308.9C129.4 286.9 147 269.2 169.1 269.2 190.7 269.2 208.3 286.8 208.3 308.9 208.3 330.5 190.7 348.1 169.1 348.1 147.1 348.2 129.4 330.5 129.4 308.9zM343.7 402.4C307.3 438.8 204.6 438.8 168.2 402.4 164.2 398.9 164.2 392.7 168.2 388.7 171.7 385.2 177.9 385.2 181.4 388.7 209.2 417.2 301.4 417.7 330.4 388.7 333.9 385.2 340.1 385.2 343.6 388.7 347.7 392.7 347.7 398.9 343.7 402.4zM342.9 348.2C321.3 348.2 303.7 330.6 303.7 309 303.7 287 321.3 269.3 342.9 269.3 364.9 269.3 382.6 286.9 382.6 309 382.5 330.5 364.9 348.2 342.9 348.2z"}]}}),H.register({"brands/reddit-square":{width:448,height:512,paths:[{d:"M283.2 345.5C285.9 348.2 285.9 352.3 283.2 354.7 258.7 379.2 189.4 379.3 164.8 354.7 162.1 352.3 162.1 348.2 164.8 345.5 167.2 343.1 171.3 343.1 173.7 345.5 192.4 364.7 254.7 365.1 274.2 345.5 276.6 343.2 280.8 343.2 283.2 345.5zM191.9 291.7C191.9 276.8 180 264.9 165.4 264.9 150.5 264.9 138.6 276.8 138.6 291.7 138.6 306.3 150.5 318.2 165.4 318.2 180 318.2 191.9 306.3 191.9 291.7zM282.6 264.9C268 264.9 256.1 276.8 256.1 291.7 256.1 306.3 268 318.2 282.6 318.2 297.5 318.2 309.4 306.3 309.4 291.7 309.4 276.8 297.5 264.9 282.6 264.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM348.3 220.6C338.2 220.6 329.3 224.8 322.7 231.3 298.6 214.6 266.2 203.9 230.2 202.7L248.9 118.5 308.4 131.9C308.4 146.5 320.3 158.4 334.9 158.4 349.8 158.4 361.7 146.2 361.7 131.6 361.7 117 349.8 104.8 334.9 104.8 324.5 104.8 315.6 111 311.1 119.7L245.4 105.1C242.1 104.2 238.9 106.6 238 109.9L217.5 202.7C181.8 204.2 149.7 214.9 125.6 231.6 119.1 224.8 109.8 220.6 99.7 220.6 62.2 220.6 49.9 271 84.2 288.1 83 293.5 82.4 299.1 82.4 304.8 82.4 361.3 146.1 407.1 224.3 407.1 302.8 407.1 366.5 361.3 366.5 304.8 366.5 299.1 365.9 293.2 364.4 287.8 398 270.6 385.6 220.6 348.3 220.6z"}]}}),H.register({"brands/reddit":{width:512,height:512,paths:[{d:"M201.5 305.5C187.7 305.5 176.6 294.4 176.6 280.9 176.6 267.1 187.7 256 201.5 256 215.1 256 226.1 267.1 226.1 280.9 226.1 294.5 215 305.5 201.5 305.5zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM371.7 214.8C362.3 214.8 354 218.7 347.9 224.8 325.5 209.3 295.3 199.3 261.8 198.2L279.2 119.9 334.6 132.4C334.6 146 345.7 157 359.2 157 373 157 384.1 145.7 384.1 132.1S373 107.2 359.2 107.2C349.5 107.2 341.2 113 337.1 121L275.9 107.4C272.9 106.6 269.8 108.8 269 111.8L249.9 198.2C216.7 199.6 186.8 209.5 164.4 225 158.3 218.6 149.7 214.8 140.3 214.8 105.4 214.8 94 261.7 125.9 277.6 124.8 282.6 124.2 287.8 124.2 293.1 124.2 345.7 183.4 388.3 256.2 388.3 329.3 388.3 388.5 345.7 388.5 293.1 388.5 287.8 387.9 282.3 386.6 277.3 417.9 261.3 406.4 214.8 371.7 214.8zM302.8 331C284.6 349.2 226.7 348.9 209.2 331 207 328.8 203.1 328.8 200.9 331 198.4 333.5 198.4 337.4 200.9 339.6 223.7 362.4 288.2 362.4 311.1 339.6 313.6 337.4 313.6 333.5 311.1 331 308.9 328.8 305 328.8 302.8 331zM310.5 256C296.9 256 285.9 267.1 285.9 280.9 285.9 294.5 297 305.5 310.5 305.5 324.3 305.5 335.4 294.4 335.4 280.9 335.4 267.1 324.4 256 310.5 256z"}]}}),H.register({"brands/rendact":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504C266.6 504 284.7 501.9 302.1 498.1 296.5 490.7 291.3 483.7 286.2 476.8 273.8 478.9 261 480.1 247.9 480.1 124.3 480 24 379.7 24 256S124.3 32 248 32 472 132.3 472 256C472 327 439 390.2 387.5 431.3 361.6 450.1 348.4 452.7 304 387.1 225.3 274.2 256 316 230.3 278.8 303.1 287.7 458.8 206.8 398.9 110.2 314-26.8 15 93.8 59.7 226.4 62.9 236.2 74.1 265 105.3 265 107.3 265 107.9 264.4 107.3 263.3 102.9 254.6 87.2 253.5 87.2 225.9 87.2 185.4 127.7 136.3 187.5 105.9 253.6 73.6 319.4 75.7 345.7 111.3 372.9 149.6 324.8 230.5 225.3 248.2 232.8 238.8 282.3 173 288.1 164.2 310.8 129.6 311.7 115.2 302.1 105 286.6 88.1 272.6 94.7 251.4 93.3 240.6 92.4 137.7 274.5 115 310.2 109.1 319.2 93.8 344.3 93.8 361.1 93.8 382.4 96.6 412.5 114.4 412.5 125 412.5 122.4 393.8 122.4 385.9 122.4 373 149.8 336.5 197.2 281.3 217.6 317.4 254.9 395.6 327.4 491 425.4 457.9 495.9 365.2 495.9 256 496 119 385 8 248 8z"}]}}),H.register({"brands/renren":{width:512,height:512,paths:[{d:"M214 169.1C214 279.5 153 374.5 66.4 416.5 30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5V169.1zM255 504C212.1 504 171.7 493 136.5 473.6 193.7 437.5 239.9 382.9 255 319 270.5 382.9 316.7 437.5 373.8 473.7 338.7 493 298.3 504 255 504zM445.6 416.5C359 374.5 298 279.6 298 169.1V12.5C414.9 32.2 504 133.9 504 256.6 504 317.7 482 373.2 445.6 416.5z"}]}}),H.register({"brands/replyd":{width:448,height:512,paths:[{d:"M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32H320C390.4 32 448 89.6 448 160V352C448 422.4 390.4 480 320 480zM193.4 273.2C187.3 271.2 181.8 270.1 177 270.1 169.8 270.1 163.5 272 158.1 275.7 152.7 279.4 148.5 284.7 145.3 291.5H144.2L140 273.2H112V412.1H148.1V322.4C149.6 317 152.5 312.6 156.8 309.2 161.1 305.8 166.6 304.1 173 304.1 177.6 304.1 182.8 305.1 188.6 307.2L193.4 273.2zM308.6 376.6C305.4 379 300.9 381.4 294.9 383.7 288.9 386 282.1 387.2 274.5 387.2 262.3 387.2 253.4 384.2 248 378.3 242.5 372.4 239.5 363.6 239 351.9H322.3C323.2 347.1 323.9 342.5 324.4 338 324.9 333.6 325.1 329.4 325.1 325.5 325.1 314.8 323.5 305.8 320.4 298.6 317.2 291.4 313.1 285.6 307.9 281.4 302.7 277.1 296.8 274.1 290.1 272.2 283.4 270.4 276.6 269.4 269.5 269.4 248.4 269.4 232 275.5 220.3 287.7S202.8 318.2 202.8 342.7C202.8 365.5 208 383.4 218.4 396.4 228.8 409.5 245.2 416 267.6 416 278.3 416 288.5 414.5 298 411.4 307.5 408.3 315.1 404.6 320.6 400.2L308.6 376.6zM286.8 306.3C290.6 311.7 292.1 319.4 291.4 329.4H239.7C240.6 320 243.4 312.4 247.9 306.8 252.4 301.2 259.4 298.3 268.9 298.3 277.1 298.2 283 300.9 286.8 306.3zM366.7 308.8C370.8 312.7 376.1 314.6 382.8 314.6 389.8 314.6 395.4 312.7 399.5 308.8S405.6 299.7 405.6 293.2 403.6 281.6 399.5 277.8C395.4 274 389.9 272.1 382.8 272.1 376.1 272.1 370.8 274 366.7 277.8 362.6 281.6 360.6 286.7 360.6 293.2S362.6 304.9 366.7 308.8zM366.7 409.3C370.8 413.2 376.1 415.1 382.8 415.1 389.8 415.1 395.4 413.2 399.5 409.3S405.6 400.2 405.6 393.7 403.6 382.1 399.5 378.3C395.4 374.5 389.9 372.6 382.8 372.6 376.1 372.6 370.8 374.5 366.7 378.3 362.6 382.1 360.6 387.2 360.6 393.7 360.6 400.3 362.6 405.4 366.7 409.3z"}]}}),H.register({"brands/resolving":{width:496,height:512,paths:[{d:"M281.2 278.2C327.2 264.9 330.8 254.7 325.2 234.8L314 195.5C307.9 174.6 295.6 167.4 242.9 182.7L54.7 236.8 83.3 335.4 281.2 278.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5L229.1 133.6C263.9 123.4 283.3 121.9 308.4 125.4 344.7 131.5 361.1 150.4 369.8 180.6L380.5 218.4C388.7 246.5 381.5 269 357 292 337.6 309.4 325.8 316.5 295.6 325.2L203 351.8 423.4 378.9 433.1 413.1 385 426.4 98.2 389.1 121.2 469.3C158 491.3 201.5 504 247.5 504 384.5 504 496 392.6 496 255.7 497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8C0 305.3 14.3 350.2 38.3 388.6z"}]}}),H.register({"brands/rocketchat":{width:448,height:512,paths:[{d:"M448 256.2C448 169 348.4 102.9 228.2 102.9 209.4 102.9 190.9 104.5 172.9 107.7 161.8 97.2 148.7 87.7 134.9 80.3 61.2 44.2 0 79.4 0 79.4S56.9 126.5 47.6 167.7C-4.7 220-4.9 291.8 47.6 344.3 56.9 385.6 0 432.6 0 432.6S61.2 467.8 134.9 431.8C148.7 424.3 161.8 414.9 172.9 404.4 190.9 407.6 209.4 409.2 228.2 409.2 348.5 409.1 448 343.4 448 256.2zM228.3 380.2C204.6 380.2 182 377.4 161 372.4 139.7 398.2 92.9 434.1 47.4 422.5 62.2 406.5 84.1 379.4 79.4 334.9 52.1 313.5 35.8 286.2 35.8 256.4 35.8 188 122 132.5 228.3 132.5S420.8 188 420.8 256.4C420.8 324.7 334.6 380.2 228.3 380.2zM253.9 256.3C253.9 270.5 242.4 282.1 228.3 282.1 214.2 282.1 202.7 270.6 202.7 256.3 202.7 242.1 214.2 230.5 228.3 230.5 242.4 230.5 253.9 242.1 253.9 256.3zM342.8 256.3C342.8 270.5 331.4 282.1 317.2 282.1 303.1 282.1 291.6 270.6 291.6 256.3 291.6 242.1 303 230.5 317.2 230.5 331.3 230.5 342.8 242.1 342.8 256.3zM164.9 256.3C164.9 270.5 153.5 282.1 139.3 282.1 125.2 282.1 113.7 270.6 113.7 256.3 113.7 242.1 125.1 230.5 139.3 230.5 153.5 230.5 164.9 242.1 164.9 256.3z"}]}}),H.register({"brands/rockrms":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM405.4 427.5H315.4L203.4 296.2C185.5 275.8 199.5 240.1 230 240.1H305.3L220.7 140.8 136.4 239.7H46.4L193.5 67.2C207.9 48.8 234.8 49.9 248 67.2L405.7 252.3C424.7 275.1 407.7 309.5 378.1 308.4 377.5 308.4 303.9 308.6 303.9 308.6L405.4 427.5z"}]}}),H.register({"brands/safari":{width:512,height:512,paths:[{d:"M236.9 256.8C236.9 247.7 243.5 239.1 253.2 239.1 262.1 239.1 270.6 245.5 270.6 255.2 270.6 264.3 264.2 272.9 254.5 272.9 245.5 272.9 236.9 266.2 236.9 256.8zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM477.4 256C477.4 133.7 378.3 34.6 256 34.6S34.6 133.7 34.6 256 133.7 477.4 256 477.4 477.4 378.3 477.4 256zM404.9 352.6C404.9 356.2 417.9 362.8 421.2 364.8 393.8 406.3 351.4 436.2 303.3 448.1L298.9 429.6C298.6 427.1 297 426.8 294.7 426.8 292.8 426.8 291.7 429.6 291.9 431L296.3 449.8C283 452.6 269.5 454 255.9 454 219.6 454 183.9 443.8 152.9 424.9 154.6 422.1 165.1 406.9 165.1 404.7 165.1 402.8 163.4 401.1 161.5 401.1 157.6 401.1 149.3 417.7 146.8 421 105 393.3 74.8 350.4 63.2 301.4L82.3 297.2C84.5 296.6 85.1 295 85.1 293 85.1 291.1 82.3 290 80.7 290.2L62 294.5C59.5 281.8 58.1 269 58.1 256 58.1 218.9 68.6 182.4 88.3 151.1 91.1 152.8 104.4 161.9 106.6 161.9 108.5 161.9 110.2 160.5 110.2 158.6 110.2 154.7 95.5 147.3 92.2 145 120.4 103.8 163.3 74.1 212 63.1L216.2 81.6C216.8 83.8 218.4 84.4 220.4 84.4S223.4 81.6 223.2 80L219 61.7C231.2 59.5 243.6 58.1 256.1 58.1 293.2 58.1 329.4 68.6 361 88.3 359.1 91.1 350.2 104.1 350.2 106.3 350.2 108.2 351.6 109.9 353.5 109.9 357.4 109.9 364.8 95.5 366.8 92.2 407.8 119.9 437.1 162.2 448.5 210.4L433 213.7C430.5 214.3 430.2 215.9 430.2 218.1 430.2 220 433 221.1 434.4 220.9L450.2 217.3C452.7 230 454.1 243 454.1 256 454.1 292.3 444.1 328 425.3 358.7 422.5 357.3 410.9 349 408.7 349 406.6 349 404.9 350.7 404.9 352.6zM371.7 110.4C358.7 122.6 237.5 234.1 234.1 239.9L137.5 400.4C150.2 388.5 271.7 276.4 274.8 271.1L371.7 110.4z"}]}}),H.register({"brands/sass":{width:640,height:512,paths:[{d:"M551.1 291.9C528.7 292 509.3 297.4 493.1 305.4 487.2 293.5 481.1 283.1 480.1 275.3 478.9 266.2 477.6 260.8 479 250S486.7 223.9 486.6 222.8C486.5 221.7 485.2 216.2 472.3 216.1 459.4 216 448.3 218.6 447 222 445.7 225.4 443.2 233.1 441.7 241.1 439.4 252.8 415.9 294.6 402.6 316.4 398.2 307.9 394.5 300.4 393.7 294.4 392.5 285.3 391.2 279.9 392.6 269.1S400.3 243 400.2 241.9C400.1 240.8 398.8 235.3 385.9 235.2 373 235.1 361.9 237.7 360.6 241.1 359.3 244.5 357.9 252.5 355.3 260.2 352.7 267.9 321.4 337.5 313.2 355.6 309 364.8 305.4 372.2 302.8 377.2S302.6 377.5 302.4 378.1C300.2 382.4 298.9 384.8 298.9 384.8V384.9C297.2 388.1 295.3 391 294.4 391 293.8 391 292.5 382.6 294.7 371.1 299.4 346.9 310.5 309.3 310.4 308 310.3 307.3 312.5 300.8 303.1 297.3 294 294 290.7 299.5 289.9 299.5 289.1 299.5 288.5 301.5 288.5 301.5S298.6 259.1 269.1 259.1C250.7 259.1 225.1 279.3 212.5 297.6 204.6 301.9 187.5 311.2 169.5 321.1 162.6 324.9 155.5 328.8 148.8 332.5 148.3 332 147.9 331.5 147.4 331 111.6 292.8 45.5 265.8 48.3 214.5 49.3 195.8 55.8 146.7 175.4 87.1 273.4 38.3 351.8 51.7 365.3 81.5 384.7 124 323.4 203.1 221.6 214.5 182.8 218.8 162.4 203.8 157.3 198.2 152 192.3 151.2 192 149.2 193.1 145.9 194.9 148 200.1 149.2 203.2 152.2 211.1 164.7 225.1 186 232.1 204.7 238.2 250.2 241.6 305.2 220.3 367 196.5 415.1 130.2 401 74.7 386.6 18.3 293.1-0.2 204.6 31.2 151.9 49.9 94.9 79.3 53.9 117.6 5.2 163.2-2.6 202.9 0.6 219.5 12 278.4 93.2 316.8 125.7 345.2 124.1 346.1 122.6 346.9 121.2 347.7 104.9 355.8 43 388.2 27.5 422.4 10 461.2 30.4 489 43.8 492.8 85.6 504.4 128.4 483.5 151.4 449.2S171.6 370.1 161 349.7C160.9 349.4 160.7 349.2 160.6 348.9 164.8 346.4 169.1 343.9 173.4 341.4 181.7 336.5 189.8 332 196.9 328.1 192.9 338.9 190 351.9 188.5 370.7 186.7 392.7 195.8 421.2 207.6 432.4 212.8 437.3 219.1 437.4 223 437.4 236.8 437.4 243 426 249.9 412.4 258.4 395.8 265.9 376.5 265.9 376.5S256.5 428.7 282.2 428.7C291.6 428.7 301 416.6 305.2 410.4V410.5S305.4 410.1 305.9 409.3C306.9 407.8 307.4 406.9 307.4 406.9V406.6C311.2 400.1 319.5 385.2 332 360.6 348.2 328.8 363.7 289.1 363.7 289.1S365.1 298.8 369.9 314.9C372.7 324.4 378.6 334.8 383.3 344.9 379.5 350.1 377.2 353.1 377.2 353.1S377.2 353.2 377.3 353.3C374.3 357.3 370.9 361.6 367.4 365.8 354.6 381 339.4 398.4 337.4 403.4 335 409.3 335.6 413.7 340.2 417.1 343.6 419.7 349.6 420.1 355.9 419.6 367.4 418.8 375.5 416 379.4 414.2 385.6 412 392.8 408.5 399.6 403.6 412.1 394.4 419.7 381.2 419 363.8 418.6 354.2 415.5 344.6 411.7 335.6 412.8 334 414 332.3 415.1 330.6 434.9 301.7 450.2 270 450.2 270S451.6 279.7 456.4 295.8C458.8 303.9 463.5 312.8 467.8 321.5 449.2 336.6 437.7 354.1 433.7 365.6 426.3 386.9 432.1 396.5 443 398.7 447.9 399.7 454.9 397.4 460.1 395.2 466.6 393 474.4 389.5 481.7 384.1 494.2 374.9 506.3 362 505.5 344.5 505.2 336.6 503 328.7 500.1 321.1 515.8 314.5 536.2 310.9 562.2 313.9 617.9 320.4 628.8 355.2 626.7 369.7 624.6 384.3 612.9 392.3 609 394.7 605.1 397.1 603.9 398 604.2 399.8 604.7 402.4 606.5 402.3 609.8 401.7 614.4 400.9 639 389.9 640.1 363 641.7 329 609 291.6 551.1 291.9zM121.8 436.6C103.4 456.7 77.6 464.3 66.5 457.9 54.6 451 59.3 421.4 82 400 95.8 387 113.6 375 125.4 367.6 128.1 366 132 363.6 136.8 360.7 137.6 360.2 138 360 138 360 138.9 359.4 139.9 358.9 140.9 358.3 149.2 388.7 141.2 415.5 121.8 436.6zM256.2 345.2C249.8 360.9 236.3 400.9 228.1 398.8 221.1 397 216.8 366.5 226.7 336.5 231.7 321.4 242.3 303.4 248.6 296.4 258.7 285.1 269.8 281.5 272.4 286 275.9 291.9 260.2 335.4 256.2 345.2zM367.2 398.2C364.5 399.6 362 400.5 360.8 399.8 359.9 399.3 361.9 397.4 361.9 397.4S375.8 382.5 381.3 375.7C384.5 371.7 388.2 367 392.2 361.8 392.2 362.3 392.3 362.8 392.3 363.4 392.2 381.3 375 393.4 367.2 398.2zM452.8 378.7C450.8 377.3 451.1 372.6 457.8 358 460.4 352.3 466.4 342.7 476.8 333.5 478 337.3 478.7 340.9 478.7 344.3 478.6 366.8 462.5 375.2 452.8 378.7z"}]}}),H.register({"brands/schlix":{width:448,height:512,paths:[{d:"M350.5 157.7L296.3 111.6 369.7 72.6 448 116.8 350.5 157.7zM192 122.1L237.7 93.9 272.4 128.5 217 157.5 192 122.1zM126.9 128.7L158.8 106.6 176 135 139.3 157.5 126.9 128.7zM103.6 216.9L94.8 182.1 124.4 163.8 137.5 199.1 103.6 216.9zM82.4 133.2L106.3 115.1 115.2 139.1 88.5 157.4 82.4 133.2zM59 206.5L55.4 178.1 77.7 162.6 83.8 191.3 59 206.5zM28.4 223.1L49.2 210.3 52.5 243.7 29.6 255.7 28.4 223.1zM1.4 268L20.6 257.8 21 296 0 304.8 1.4 268zM60.5 327.3L32.2 335.6 30.6 288.8 55.7 278.1 60.5 327.3zM99 263.2L67.9 276.2 62.7 235.4 90.1 221 99 263.2zM123.2 377L81.6 382.9 73.5 319.4 108.7 308.6 123.2 377zM151.7 237.1L172.9 294.2 126.7 307.8 113 253.7 151.7 237.1zM237.4 467.6L166.5 464.3 142.2 368.5 197.4 359.9 237.4 467.6zM152.5 187.9L194.7 165.5 222.7 211.4 171.9 232.7 152.5 187.9zM193.5 282.8L254.8 264.1 307.6 350.7 227.8 362 193.5 282.8zM244.9 197.2L312.2 168.4 377.7 233.8 289.1 260 244.9 197.2z"}]}}),H.register({"brands/scribd":{width:384,height:512,paths:[{d:"M42.3 252.7C26.2 233.7 17.6 206.8 17.5 172.8 17.5 72.4 92.7 19.7 184.7 19.7 283.3 18.1 341.5 68.7 369 90.3L318.5 162.4 281.2 137.8 308.1 99.2C271.6 75.2 228.7 62.7 185.1 63.4 134.4 62.6 73.4 90.6 73.4 139.6 73.4 158.3 84.6 160.3 102 155.2 125.3 149.9 143.9 155.8 157.8 169.2 184.2 193.5 181 236.8 157.1 261.1 127.9 290.6 71.9 288.4 42.3 252.7zM360 258.6C344.5 239.8 321.1 229.2 296.8 230 258.7 228 225.7 258 226.3 297.2 225.6 314 232.3 330.2 244.7 341.5 258.8 355.4 277.7 361.2 301 355.9 318.4 350.8 329.6 352.8 329.6 371.5 329.6 375.8 329.1 380 328.2 384.2 311.5 425.1 268.7 448.6 206.8 448.6 154.9 448.8 104.4 432.2 62.7 401.3L96.4 361.9 60.8 334.5 0 406.3 15.4 420.1C67.9 466.9 135.8 492.6 206.1 492.3 257.5 492.3 300.5 481.8 339.7 448.2 396.8 396.8 393.9 299 360 258.6z"}]}}),H.register({"brands/searchengin":{width:460,height:512,paths:[{d:"M220.6 130.3L153.4 158.5V43.2L98.7 233.5 153.4 209.3V339.6L220.6 130.3zM137.4 33.6L136.1 38.3 120.9 91.2C80.6 106.7 52 145.8 52 191.5 52 243.8 86.3 287.4 135.4 297V350.6C57.5 340.1 0 272.4 0 191.6 0 111.1 59.8 44.4 137.4 33.6zM448.8 480.8C437.6 492 425.7 493.1 420.2 491.3 414.8 489.5 393.1 471.4 359.8 446.9 326.5 422.3 326.2 411.2 316.8 390.2 307.4 369.3 286.4 347.6 259.3 337.8L249.6 323.1C224.9 340 196.6 350 168.3 351.8L170.4 345.2 186.3 295.7C232.8 283.8 267.2 241.7 267.2 191.5 267.2 137 228.8 89.4 171.2 84.4V32.3C254.4 37.4 320 106.8 320 191.6 320 225.2 308.8 256.3 291 282L305.6 291.6C315.4 318.7 337.1 339.6 358 349S390.2 358.7 414.8 392C439.4 425.2 457.5 446.9 459.3 452.3S460 469.6 448.8 480.8zM438.9 462.9C438.9 458.5 435.3 454.9 430.9 454.9S422.9 458.5 422.9 462.9 426.5 470.9 430.9 470.9 438.9 467.3 438.9 462.9z"}]}}),H.register({"brands/sellcast":{width:448,height:512,paths:[{d:"M353.4 32H94.7C42.6 32 0 74.6 0 126.6V385.3C0 437.4 42.6 480 94.7 480H353.4C405.5 480 448.1 437.4 448.1 385.4V126.6C448.1 74.6 405.5 32 353.4 32zM303.4 348.4C275.5 396.6 213.5 413.3 165.2 385.6 142.3 425.4 110.3 394.2 122.9 372.4L138.6 345.2C144.5 334.9 157.8 331.3 168.1 337.3 186.7 348.1 168 337.2 186.6 348 214.2 363.9 250 354.3 266 326.7 281.9 299.1 272.3 263.3 244.7 247.3 226.9 237.1 244.1 246.9 226.1 236.7 201.5 222.5 222.7 184.8 247.7 199.2 266.3 210 247.6 199.1 266.2 209.9 314.6 237.9 331.3 300.2 303.4 348.4zM325.2 139.6C308.2 169.1 308.9 168.4 306.2 171.1 299.7 177.6 289.9 179.8 279.7 174.7 261.1 163.9 279.8 174.8 261.2 164 233.6 148.1 197.8 157.7 181.8 185.3S175.5 248.7 203.1 264.7C203.1 264.7 221.6 275.3 221.7 275.3 246.3 289.5 225.1 327.2 200.1 312.8 181.5 302 200.2 312.9 181.6 302.1 133.4 274.3 116.7 212 144.5 163.7 172.4 115.5 234.4 98.8 282.7 126.5L287.5 118.1C301.8 93.2 339.5 114.8 325.2 139.6z"}]}}),H.register({"brands/sellsy":{width:640,height:512,paths:[{d:"M539.7 237.3C542.8 225.1 544 212.5 544 199.9 544 107.4 468.6 32 376.1 32 298.9 32 231.4 85 213.1 159.8 197.7 146.6 178.1 139.3 157.9 139.3 111.6 139.3 73.9 176.9 73.9 223.2 73.9 230.6 74.9 238.2 77 245.6 34.1 265.8 6.2 309.3 6.2 356.8 6.2 424.8 61.7 480 129.4 480H510.6C578.3 480 633.8 424.8 633.8 356.8 633.8 300.4 594.9 250.8 539.7 237.3zM199.9 401.6C199.9 409.8 192.8 416.9 184.6 416.9H153.6C145.3 416.9 138.3 409.8 138.3 401.6V290.6C138.3 282.4 145.3 275.3 153.6 275.3H184.6C192.8 275.3 199.9 282.4 199.9 290.6V401.6zM289.4 401.6C289.4 409.8 282.3 416.9 274 416.9H243.1C234.8 416.9 227.8 409.8 227.8 401.6V270.1C227.8 261.8 234.8 254.8 243.1 254.8H274C282.3 254.8 289.4 261.8 289.4 270.1V401.6zM378.8 401.6C378.8 409.8 371.8 416.9 363.5 416.9H332.6C324.3 416.9 317.2 409.8 317.2 401.6V238.8C317.2 230.6 324.3 223.5 332.6 223.5H363.5C371.8 223.5 378.8 230.6 378.8 238.8V401.6zM465.9 401.6C465.9 409.8 458.8 416.9 450.5 416.9H422C413.8 416.9 406.7 409.8 406.7 401.6V176.9C406.7 168.4 413.8 161.3 422 161.3H450.5C458.8 161.3 465.9 168.4 465.9 176.9V401.6z"}]}}),H.register({"brands/servicestack":{width:496,height:512,paths:[{d:"M88 216C169.7 226.2 361.7 318.3 392 448H0C99.5 439.9 184.5 311 88 216zM120 64C152.3 99.6 167.7 147.9 166.4 197.6 249.3 231.3 373.7 321.3 400 448H496C455.3 231.9 222.8 79.5 120 64z"}]}}),H.register({"brands/shirtsinbulk":{width:448,height:512,paths:[{d:"M395.2 221.6H406V255.1H395.2V221.6zM395.2 212H406V178.4H395.2V212zM395.2 298.3H406V264.8H395.2V298.3zM358.8 135.3H325.2V145.8H358.8V135.3zM395.2 341.5H406V307.9H395.2V341.5zM311.5 135.3H278V145.8H311.5V135.3zM264.3 135.3H231V145.8H264.3V135.3zM217 135.3H183.8V145.8H217V135.3zM395.2 168.8H406V135.3H372.5V145.8H395.2V168.8zM139.4 427.8L170 441.2 174.4 431.3 143.8 417.9 139.4 427.8zM179.1 445L209.4 458.7 213.8 448.8 183.5 435.4 179.1 445zM395.2 384.6H406V351.1H395.2V384.6zM60.4 392.8L91 406.2 95.4 396.6 64.8 382.9 60.4 392.8zM100 410.3L130.7 423.7 135 413.8 104.4 400.4 100 410.3zM232.5 448.8L236.8 458.7 267.5 445 263.1 435.4 232.5 448.8zM350.9 396.6L355.3 406.2 385.9 392.8 381.5 382.9 350.9 396.6zM311.5 413.8L315.9 423.7 346.5 410.3 342.1 400.4 311.5 413.8zM271.8 431.3L276.2 441.2 306.8 427.8 302.5 417.9 271.8 431.3zM311.5 46.6H278V57.1H311.5V46.6zM405.7 46.6H372.5V57.1H405.7V46.6zM217 46.6H183.8V57.1H217V46.6zM358.8 46.6H325.2V57.1H358.8V46.6zM264.3 46.6H231V57.1H264.3V46.6zM448 3.7V409.7L221.7 508.3 0 409.7V3.7H448zM418.8 120.7H29.2V390.8L222 476.5 418.8 390.8V120.7zM418.8 32.9H29.2V91.5H418.8V32.9zM75.5 46.6H42.3V57.1H75.5V46.6zM170 46.6H136.5V57.1H170V46.6zM122.8 46.6H89.3V57.1H122.8V46.6zM130.4 283.1C130.4 233 171.5 191.8 221.7 191.8 272.1 191.8 313 233 313 283.1 313 333.6 272.1 374.4 221.7 374.4 171.5 374.4 130.4 333.6 130.4 283.1zM251.1 301.2C251.1 314.3 227.2 315.5 218.5 315.5 206.2 315.5 188.7 312.9 182.6 300.6H181.7L172.7 319C187.5 328.3 201.8 331.3 219.9 331.3 239.5 331.3 271 325.4 271 300 271 251.9 192.5 283.7 192.5 262.1 192.5 249 213.2 247.3 222.3 247.3 233 247.3 251.4 250.5 257.8 260.4H258.7L267.5 243.5C252.3 237.3 240 231.5 223.1 231.5 203 231.5 173.5 237.9 173.5 263.3 173.5 307.6 251.1 275.3 251.1 301.2zM122.8 135.3H89.3V145.8H122.8V135.3zM52.8 145.8H75.5V135.3H42V168.8H52.8V145.8zM52.8 178.4H42V212H52.8V178.4zM170 135.3H136.5V145.8H170V135.3zM52.8 221.6H42V255.1H52.8V221.6zM52.8 307.9H42V341.5H52.8V307.9zM52.8 264.8H42V298.3H52.8V264.8zM52.8 351.1H42V384.6H52.8V351.1z"}]}}),H.register({"brands/simplybuilt":{width:512,height:512,paths:[{d:"M481.2 64H375.2C360.7 64 348.6 75.8 348.6 90.3V129.9H163.3V90.3C163.3 75.8 151.3 64 136.7 64H30.7C16.1 64 4.3 75.8 4.3 90.3V421.7C4.3 436.2 16.1 448 30.9 448H481.3C496.1 448 507.9 436.2 507.9 421.7V90.3C507.7 75.8 495.9 64 481.2 64zM149.8 355.8C113.2 355.8 83.4 326.1 83.4 289.4 83.4 252.5 113.1 222.8 149.8 222.8 186.7 222.8 216.4 252.5 216.4 289.4 216.4 326.1 186.7 355.8 149.8 355.8zM362.2 355.8C325.3 355.8 295.6 326.1 295.6 289.2 295.6 252.6 325.3 222.8 362.2 222.8 398.8 222.8 428.6 252.5 428.6 289.2 428.6 326.1 398.8 355.8 362.2 355.8z"}]}}),H.register({"brands/sistrix":{width:448,height:512,paths:[{d:"M448 449L301.2 300.2C321.2 272.3 333.1 238 333.1 201 333.1 107.9 258.4 32.1 166.6 32.1 74.7 32 0 107.8 0 200.9S74.7 369.8 166.5 369.8C206.3 369.8 242.8 355.6 271.5 331.9L417.5 480 448 449zM166.5 330.8C95.9 330.8 38.4 272.5 38.4 200.9S95.9 71 166.5 71 294.6 129.3 294.6 200.9 237.2 330.8 166.5 330.8z"}]}}),H.register({"brands/skyatlas":{width:640,height:512,paths:[{d:"M640 329.3C640 395.2 587.5 443.7 522.5 443.7 356.6 443.7 325.9 194 162.8 194 15.9 194 15.7 406.2 168.4 406.2 210.9 406.2 259.3 388.4 293.7 363.7 299.3 359.6 310.6 347.4 316.5 347.4S327.4 352.4 327.4 358.3C327.4 366.1 314.3 377.4 308.7 382.4 267.8 418 208.4 443.6 154 443.6 70.6 443.7 0 384.6 0 298.7S67.5 149.6 152.8 149.6C338.1 149.6 375.3 395.5 514.7 395.5 614.6 395.5 609.5 255.8 518.1 255.8 500.6 255.8 483.1 267.4 471.2 267.4 462.8 267.4 455.3 260.2 455.3 251.8 455.3 240.2 460.6 228.1 460.6 215.5 460.6 148.9 409.7 100.8 343.7 100.8 290.6 100.8 263.7 137.7 254.9 137.7 248.7 137.7 243.7 132.7 243.7 126.5 243.7 120.9 247.8 116.2 251.5 112.1 276.8 83.3 316.2 68.4 354.3 68.4 433.7 68.4 493.4 126.8 493.4 206.2 493.4 213.1 493.1 219.9 492.2 226.8 504.1 223.7 516.3 222.1 528.1 222.1 588.8 222.1 640 267.4 640 329.3z"}]}}),H.register({"brands/skype":{width:448,height:512,paths:[{d:"M424.7 299.8C427.6 285.8 429.4 270.9 429.4 256 429.4 142.5 337.5 50.7 224.1 50.7 209.2 50.7 194.4 52.4 180.3 55.4 161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144 0 169.7 8.7 193.3 23.3 212.2 20.4 226.2 18.6 241.1 18.6 256 18.6 369.5 110.5 461.3 223.9 461.3 238.8 461.3 253.6 459.6 267.7 456.6 286.7 471.2 310.3 479.9 335.9 479.9 397.7 479.9 447.9 429.7 447.9 367.9 448 342.3 439.3 318.7 424.7 299.8zM230.1 391.3C164.5 391.3 109.6 362.1 109.6 326.3 109.6 310.3 118.6 295.7 139.1 295.7 170.3 295.7 173.2 340.6 227.2 340.6 252.9 340.6 269.5 329.2 269.5 314.3 269.5 295.6 253.5 292.7 227.5 286.3 165 270.9 109.7 264.3 109.7 199.1 109.7 139.9 168.3 118 218.8 118 273.9 118 329.6 139.9 329.6 173.4 329.6 190.3 318.2 205.2 299.3 205.2 271 205.2 270.1 171.7 224.3 171.7 198.6 171.7 182.3 178.7 182.3 194.2 182.3 214 203.1 216 251.4 227.2 292.8 236.5 342.1 254 342.1 304.8 342.1 363.9 285 391.3 230.1 391.3z"}]}}),H.register({"brands/slack-hash":{width:448,height:512,paths:[{d:"M446.2 270.4C440 251.4 419.3 241.3 400.2 247.5L354.8 262.6 324.5 172.6 369.9 157.5C389 151.3 399 130.7 392.9 111.6 386.7 92.6 366 82.5 346.9 88.7L301.5 103.8 285.8 56.8C279.6 37.8 258.9 27.7 239.8 33.9 220.7 40.1 210.7 60.7 216.8 79.8L232.5 126.8 139.1 158 123.4 111C117.2 92 96.5 81.9 77.4 88.1 58.3 94.3 48.3 114.9 54.4 134L70.1 181 24.8 196C5.7 202.2-4.3 222.8 1.8 241.9 6.8 256.4 20.9 265.9 35.4 266.5 42.2 267.5 47.4 264.9 93.1 249.7L123.4 339.7 78 354.8C59 361 48.9 381.7 55 400.7 60 415.2 74.1 424.7 88.6 425.3 95.4 426.3 100.6 423.7 146.3 408.5L162 455.5C167.9 472.4 186.7 484.5 208 478.4 227.1 472.2 237.1 451.6 231 432.5L215.3 385.5 308.9 354.2 324.6 401.2C330.5 418.1 349.3 430.2 370.6 424.1 389.7 417.9 399.7 397.3 393.6 378.2L377.9 331.2 423.3 316.1C442.3 310.1 452.4 289.4 446.2 270.4zM192.1 317.6L161.8 227.4 255.3 196.1 285.6 286.3 192.1 317.6z"}]}}),H.register({"brands/slack":{width:448,height:512,paths:[{d:"M244.2 217.5L263.5 275.2 203.7 295.2 184.4 237.5 244.2 217.5zM285.6 461.2C131.6 507.4 65 471.6 18.8 317.6S8.4 97 162.4 50.8C316.4 4.6 383 40.4 429.2 194.4 475.4 348.4 439.6 415 285.6 461.2zM366.2 265C362.3 252.8 349 246.4 336.8 250.3L307.8 260 288.5 202.3 317.5 192.6C329.7 188.7 336.1 175.4 332.2 163.2 328.3 151 315 144.6 302.8 148.5L273.8 158.2 263.8 128.1C259.9 115.9 246.6 109.5 234.4 113.4 222.2 117.3 215.8 130.6 219.7 142.8L229.7 172.9 169.9 193 159.9 162.9C156 150.7 142.7 144.3 130.5 148.2 118.3 152.1 111.9 165.4 115.8 177.6L125.8 207.7 96.8 217.4C84.6 221.3 78.2 234.6 82.1 246.8 85.3 256.1 94.3 262.2 103.6 262.6 107.9 263.2 111.3 261.6 140.5 251.9L159.8 309.6 130.8 319.3C118.6 323.2 112.2 336.5 116.1 348.7 119.3 358 128.3 364.1 137.6 364.5 141.9 365.1 145.3 363.5 174.5 353.8L184.5 383.9C188.2 394.7 200.3 402.5 213.9 398.6 226.1 394.7 232.5 381.4 228.6 369.2L218.6 339.1 278.4 319 288.4 349.1C292.1 359.9 304.2 367.7 317.8 363.8 330 359.9 336.4 346.6 332.5 334.4L322.5 304.3 351.5 294.6C363.7 290.4 370.1 277.1 366.2 265z"}]}}),H.register({"brands/slideshare":{width:512,height:512,paths:[{d:"M249.4 211.4C249.4 243.2 221.7 269.2 187.7 269.2 153.7 269.2 126 243.2 126 211.4 126 179.4 153.7 153.7 187.7 153.7 221.7 153.7 249.4 179.4 249.4 211.4zM503.7 261.4C485.4 284 450.6 311.7 397.4 333.4 453.7 525.2 260 555.7 263.1 457.4 263.1 459.2 262.9 404.6 262.9 364 258.6 363.2 254.3 362 249.1 360.9 249.1 401.7 248.9 459.2 248.9 457.4 252 555.7 58.3 525.2 114.6 333.4 61.4 311.7 26.6 284 8.3 261.4-0.9 247.7 9.1 233.2 24.3 243.7 26.3 245.2 28.6 246.6 30.6 248V49.7C30.6 22.3 51.1 0 76.6 0H435.7C461.2 0 481.7 22.3 481.7 49.7V248L487.7 243.7C502.9 233.2 512.9 247.7 503.7 261.4zM457.2 72.3C457.2 39.4 446.6 26.6 416.3 26.6H98.6C66.8 26.6 58 37.4 58 72.3V264.6C125.7 300 183.7 293.7 215.4 292.6 228.9 292.3 237.4 294.9 242.6 300.3 244.3 302 252.6 309.7 262.9 317.4 264 301.7 272.9 291.7 296.6 292.6 328.9 294 388.3 300.3 457.2 262.9V72.3zM331.1 153.7C297.1 153.7 269.4 179.4 269.4 211.4 269.4 243.2 297.1 269.2 331.1 269.2 365.4 269.2 392.9 243.2 392.9 211.4 392.9 179.4 365.4 153.7 331.1 153.7z"}]}}),H.register({"brands/snapchat-ghost":{width:512,height:512,paths:[{d:"M510.8 392.7C505.6 404.8 483.6 413.8 443.5 420 441.4 422.8 439.7 434.7 437 443.9 435.4 449.5 431.4 452.8 424.9 452.8L424.6 452.8C415.2 452.8 405.4 448.5 385.7 448.5 359.2 448.5 350 454.5 329.4 469.1 307.6 484.5 286.7 497.8 255.4 496.5 223.8 498.8 197.4 479.6 182.6 469.1 161.8 454.4 152.7 448.5 126.3 448.5 107.4 448.5 95.6 453.2 87.5 453.2 79.4 453.2 76.2 448.3 75 444.2 72.3 435 70.6 422.9 68.5 420 47.8 416.8 1.2 408.7 0 387.9A10.6-10.6 0 0 0 8.9 376.8C78.5 365.4 109.8 293.9 111.1 290.9 111.2 290.7 111.3 290.5 111.4 290.4 115.1 282.8 115.9 276.5 113.8 271.6 108.8 259.7 86.9 255.5 77.8 251.8 54 242.5 50.8 231.7 52.2 224.3 54.6 211.5 73.9 203.6 85.2 208.9 94.1 213 102 215.2 108.7 215.2 113.7 215.2 116.9 214 118.7 213 116.6 177.1 111.6 125.7 124.3 97 158.1 21.3 229.7 15.4 250.8 15.4 251.8 15.4 260 15.3 260.9 15.3 313.1 15.3 363.2 42.1 387.7 97 400.4 125.6 395.4 176.8 393.4 213 394.9 213.9 397.7 214.9 402 215.1 408.4 214.8 415.8 212.7 424 208.9 430.1 206 438.4 206.4 444.5 208.9L444.5 208.9C454 212.3 460 219.1 460.1 226.8 460.3 236.6 451.6 245 434.2 251.8 432.1 252.7 429.5 253.5 426.8 254.3 417 257.5 402.2 262.2 398.2 271.6 396.1 276.5 396.9 282.8 400.7 290.4 400.7 290.5 400.8 290.7 400.9 290.9 402.2 293.9 433.5 365.3 503.1 376.8 509.5 377.9 514.3 384.7 510.8 392.7z"}]}}),H.register({"brands/snapchat-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM393.5 346.9C390 355 375.4 360.9 348.7 365.1 347.3 367 346.2 374.9 344.4 381 343.3 384.7 340.7 386.9 336.3 386.9H336.1C329.9 386.9 323.3 384 310.3 384 292.7 384 286.6 388 272.9 397.7 258.4 408 244.5 416.8 223.7 415.9 202.7 417.5 185.1 404.7 175.2 397.7 161.4 388 155.4 384 137.8 384 125.3 384 117.4 387.1 112 387.1 106.6 387.1 104.5 383.8 103.7 381.1 101.9 375 100.8 367 99.4 365.1 85.6 363 54.6 357.6 53.9 343.7 53.7 340.1 56.2 336.9 59.8 336.3 106.1 328.7 126.9 281.2 127.8 279.2 127.8 279.1 127.9 279 128 278.9 130.5 273.9 131 269.7 129.6 266.4 126.2 258.5 111.7 255.7 105.6 253.2 89.8 247 87.6 239.8 88.6 234.9 90.2 226.4 103 221.1 110.5 224.6 116.4 227.4 121.7 228.8 126.2 228.8 129.5 228.8 131.7 228 132.8 227.4 131.4 203.5 128.1 169.4 136.6 150.3 159.1 100 206.7 96 220.7 96 221.3 96 226.8 95.9 227.4 95.9 262.1 95.9 295.4 113.7 311.7 150.2 320.2 169.3 316.9 203.3 315.5 227.3 316.6 227.9 318.4 228.6 321.2 228.7 325.5 228.5 330.4 227.1 335.9 224.5 339.9 222.6 345.5 222.9 349.5 224.5 355.8 226.8 359.8 231.3 359.9 236.4 360 242.9 354.2 248.5 342.7 253 341.3 253.6 339.6 254.1 337.8 254.7 331.3 256.8 321.4 259.9 318.8 266.2 317.4 269.5 318 273.7 320.4 278.7 320.5 278.8 320.5 278.9 320.6 279 321.5 281 342.3 328.5 388.6 336.1 392.6 337.1 395.7 341.6 393.5 346.9z"}]}}),H.register({"brands/snapchat":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM417.5 346.9C414 355 399.4 360.9 372.7 365.1 371.3 367 370.2 374.9 368.4 381 367.3 384.7 364.7 386.9 360.3 386.9H360.1C353.9 386.9 347.3 384 334.3 384 316.7 384 310.6 388 296.9 397.7 282.4 408 268.5 416.8 247.7 415.9 226.7 417.5 209.1 404.7 199.2 397.7 185.4 388 179.4 384 161.8 384 149.3 384 141.4 387.1 136 387.1 130.6 387.1 128.5 383.8 127.7 381.1 125.9 375 124.8 367 123.4 365.1 109.6 363 78.6 357.6 77.9 343.7 77.7 340.1 80.2 336.9 83.8 336.3 130.1 328.7 150.9 281.2 151.8 279.2 151.8 279.1 151.9 279 152 278.9 154.5 273.9 155 269.7 153.6 266.4 150.2 258.5 135.7 255.7 129.6 253.2 113.8 247 111.6 239.8 112.6 234.9 114.2 226.4 127 221.1 134.5 224.6 140.4 227.4 145.7 228.8 150.2 228.8 153.5 228.8 155.7 228 156.8 227.4 155.4 203.5 152.1 169.4 160.6 150.3 183.1 100 230.7 96 244.7 96 245.3 96 250.8 95.9 251.4 95.9 286.1 95.9 319.4 113.7 335.7 150.2 344.2 169.3 340.9 203.3 339.5 227.3 340.6 227.9 342.4 228.6 345.2 228.7 349.5 228.5 354.4 227.1 359.9 224.5 363.9 222.6 369.5 222.9 373.5 224.5 379.8 226.8 383.8 231.3 383.9 236.4 384 242.9 378.2 248.5 366.7 253 365.3 253.6 363.6 254.1 361.8 254.7 355.3 256.8 345.4 259.9 342.8 266.2 341.4 269.5 342 273.7 344.4 278.7 344.5 278.8 344.5 278.9 344.6 279 345.5 281 366.3 328.5 412.6 336.1 416.6 337.1 419.7 341.6 417.5 346.9z"}]}}),H.register({"brands/soundcloud":{width:640,height:512,paths:[{d:"M111.4 256.3L117.2 321.3 111.4 389.6C111.1 392.1 109.2 394 107 394S102.8 392.1 102.8 389.6L97.2 321.3 102.8 256.3C102.8 254.1 104.7 252.1 107 252.1 109.2 252.1 111.1 254.1 111.4 256.3zM132.8 210.7C130 210.7 128.1 212.9 127.8 215.7L122.8 321.3 127.8 389.6C128.1 392.4 130 394.6 132.8 394.6 135.3 394.6 137.5 392.4 137.5 389.6L143.3 321.3 137.5 215.7C137.5 212.9 135.3 210.7 132.8 210.7zM158.3 186.6C155.2 186.6 153 188.8 152.7 191.9L148.3 321.9 152.7 389.7C153 392.8 155.2 395 158.3 395 161.1 395 163.6 392.8 163.6 389.7L168.9 321.9 163.6 191.9C163.6 188.8 161.1 186.6 158.3 186.6zM7.2 283.2C5.8 283.2 5 284.3 4.7 285.7L0 321.3 4.7 356.3C5 357.7 5.8 358.8 7.2 358.8S9.4 357.7 9.7 356.3L15.3 321.3 9.7 285.7C9.4 284.3 8.6 283.2 7.2 283.2zM30.8 261.3C29.4 261.3 28.3 262.4 28.3 263.8L21.9 321.3 28.3 377.4C28.3 379.1 29.4 380.2 30.8 380.2S33.3 379.1 33.6 377.7L40.8 321.3 33.6 263.8C33.3 262.4 32.2 261.3 30.8 261.3zM56.1 249.9C54.4 249.9 53 251.3 52.8 253.2L47 321.3 52.8 387.1C53.1 388.8 54.5 390.2 56.1 390.2 57.8 390.2 59.2 388.8 59.2 387.1L66.1 321.3 59.2 253.2C59.2 251.3 57.8 249.9 56.1 249.9zM81.4 247.7C79.5 247.7 77.8 249.1 77.8 251.3L72 321.3 77.8 389.1C77.8 391.3 79.5 392.7 81.4 392.7S85 391.3 85.3 389.1L91.7 321.3 85.3 251.3C85 249.1 83.3 247.7 81.4 247.7zM322.8 136.8C321.7 136 320 135.4 318.6 135.4 316.4 135.4 314.4 136.2 313 137.3 311.1 139 309.9 141.5 309.7 144V144.8L306.4 321.5 308.1 354 309.8 385.7C310.1 390.4 314 394.3 318.7 394.3S327.3 390.4 327.3 385.7L331.2 321.5 327.3 144C326.9 141 325.3 138.2 322.8 136.8zM296.1 152.1C294.7 151.3 293.3 150.7 291.7 150.7S288.6 151.3 287.3 152.1C285.1 153.5 283.7 156 283.7 158.8L283.4 160.5 280.6 321.3S280.6 321.6 283.7 386.9V387.2C283.7 388.9 284.3 390.5 285.4 391.9 287.1 393.8 289.3 395 291.8 395 294 395 296 393.9 297.4 392.5 299.1 391.1 299.9 389.2 299.9 386.9L300.2 380.2 303.3 321.6 300 158.8C299.7 156 298.3 153.5 296.1 152.1zM184.7 174.6C181.6 174.6 178.9 177.4 178.9 180.7L174.5 321.3 178.9 388.5C179.2 391.8 181.7 394.3 184.7 394.3 188 394.3 190.5 391.8 190.8 388.5L195.8 321.3 190.8 180.7C190.6 177.4 188.1 174.6 184.7 174.6zM561.4 237.4C550.6 237.4 540.3 239.6 530.8 243.5 524.4 172.7 465 117.1 392.5 117.1 374.7 117.1 357.5 120.4 342.2 126.5 336.1 128.7 334.4 130.9 334.4 135.7V385.4C334.4 390.4 338.3 394 343 394.6H561.3C604.6 394.6 639.9 359.6 639.9 316.3 640 272.7 604.7 237.4 561.4 237.4zM264.7 177.1C260.5 177.1 257.2 180.4 256.9 184.9L253.6 321.6 256.9 387.2C257.2 391.4 260.5 394.7 264.7 394.7 268.9 394.7 272.2 391.4 272.2 387.2L276.1 321.6 272.2 184.9C271.9 180.4 268.9 177.1 264.7 177.1zM211.1 169.3C207.8 169.3 204.7 172.4 204.7 176L200.8 321.3 204.7 388.2C205 391.8 207.8 394.6 211.1 394.6 214.7 394.6 217.5 391.8 217.8 388.2L222.2 321.3 217.8 176C217.5 172.4 214.7 169.3 211.1 169.3zM237.8 172.7C233.9 172.7 230.9 175.8 230.9 179.6L227 321.3 230.9 387.7C231.2 391.6 234 394.6 237.8 394.6S244.7 391.5 244.7 387.7L248.9 321.3 244.7 179.6C244.7 175.7 241.7 172.7 237.8 172.7z"}]}}),H.register({"brands/speakap":{width:448,height:512,paths:[{d:"M352 32H96C43.2 32 0 75.2 0 128V384C0 436.8 43.2 480 96 480H352C404.8 480 448 436.8 448 384V128C448 75.2 404.8 32 352 32zM221 382.9C181.4 382.9 139.1 365.1 139.1 329.2V302H179V319.8C179 334.9 198.5 344.3 220.9 344.3 245.1 344.3 262.2 333.9 262.2 314.8 262.2 291 235 282.9 207.5 272.2 175.6 259.8 144.4 246 144.4 203.1 144.4 155.1 183 136.7 224.3 136.7 261.9 136.7 299.8 150.8 299.8 178.6V209.8H259.9V193.7C259.9 181.6 242.1 175.2 224.3 175.2 204.8 175.2 188.7 183.3 188.7 201.4 188.7 223.5 211.2 230.6 235.7 240.3 271.6 252.7 306.8 267.5 306.8 311.8 306.9 360.4 266 382.9 221 382.9z"}]}}),H.register({"brands/spotify":{width:496,height:512,paths:[{d:"M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM348.7 372.9C344.5 372.9 341.9 371.6 338 369.3 275.6 331.7 203 330.1 131.3 344.8 127.4 345.8 122.3 347.4 119.4 347.4 109.7 347.4 103.6 339.7 103.6 331.6 103.6 321.3 109.7 316.4 117.2 314.8 199.1 296.7 282.8 298.3 354.2 341 360.3 344.9 363.9 348.4 363.9 357.5S356.8 372.9 348.7 372.9zM375.6 307.3C370.4 307.3 366.9 305 363.3 303.1 300.8 266.1 207.6 251.2 124.7 273.7 119.9 275 117.3 276.3 112.8 276.3 102.1 276.3 93.4 267.6 93.4 256.9S98.6 239.1 108.9 236.2C136.7 228.4 165.1 222.6 206.7 222.6 271.6 222.6 334.3 238.7 383.7 268.1 391.8 272.9 395 279.1 395 287.8 394.9 298.6 386.5 307.3 375.6 307.3zM406.6 231.1C401.4 231.1 398.2 229.8 393.7 227.2 322.5 184.7 195.2 174.5 112.8 197.5 109.2 198.5 104.7 200.1 99.9 200.1 86.7 200.1 76.6 189.8 76.6 176.5 76.6 162.9 85 155.2 94 152.6 129.2 142.3 168.6 137.4 211.5 137.4 284.5 137.4 361 152.6 416.9 185.2 424.7 189.7 429.8 195.9 429.8 207.8 429.8 221.4 418.8 231.1 406.6 231.1z"}]}}),H.register({"brands/stack-exchange":{width:448,height:512,paths:[{d:"M17.7 332.3H430.4V354.3C430.4 392 401.1 422.3 365.1 422.3H346.1L259.3 512V422.3H83C47 422.3 17.7 392 17.7 354.3V332.3zM17.7 308.7H430.4V223.7H17.7V308.7zM17.7 199.3H430.4V114.3H17.7V199.3zM365 0H83C47 0 17.7 30.3 17.7 67.7V90H430.4V67.7C430.3 30.3 401 0 365 0z"}]}}),H.register({"brands/stack-overflow":{width:384,height:512,paths:[{d:"M293.7 300L112.5 215.5 129.2 179 310.5 263.7 293.7 300zM341.7 224L188.2 95.7 162.7 126.5 316.2 254.8 341.7 224zM381.3 192.3L262 32 230 56 349.3 216.3 381.3 192.3zM290.7 311L95 269.7 86.8 309 282.5 350 290.7 311zM322.3 440H42.7V320H2.7V480H362.2V320H322.2V440zM282.5 360H82.5V399.7H282.5V360z"}]}}),H.register({"brands/staylinked":{width:440,height:512,paths:[{d:"M201.6 127.4C205.7 124.2 211.9 124.4 215.4 127.9L385.4 295.2 382.7 292.5 427 333.8C430.7 337.3 430.3 342.8 426.3 346L228.3 509.9C218.4 517.5 211 510.7 211 510.7L2.3 314.6C-1.2 311.1-0.7 305.6 3.5 302.4L49.3 267.5C53.5 264.3 59.7 264.5 63.2 268L215.1 415.5C218.8 419 225.1 419.2 229.3 415.9L322.5 341.9C326.6 338.7 327 333.2 323.4 329.7L239.4 248.4C235.8 244.9 229.5 244.7 225.4 247.9L225.3 248C221.2 251.2 214.9 251 211.3 247.5L143.2 183.2C139.7 179.7 140.1 174.2 144.3 171L201.6 127.4M216.4 384.7C220.1 388.2 226.5 388.4 230.7 385.1L280.9 346.3 280.6 346 288.3 340C292.5 336.8 292.9 331.3 289.2 327.8L232.1 273.4C228.5 269.9 222.1 269.7 217.9 272.9L217.8 273C213.6 276.2 207.3 276.1 203.6 272.6L109 180.8C105.4 177.3 105.9 171.9 110.1 168.6L202.3 97.1C206.4 93.9 212.6 94.1 216.2 97.6L376.6 256.6C380.3 260.1 386.6 260.3 390.7 257.1L436.5 221.3C440.6 218.1 440.9 212.6 437.2 209.1L226.7 2.5C225.2 1.3 218.7-3 210.4 3.6L3.6 165.7C-0.6 168.9-1.2 174.4 2.4 177.9L44.7 219.6"}]}}),H.register({"brands/steam-square":{width:448,height:512,paths:[{d:"M185.2 356.5C192.9 338 184.2 316.8 165.6 309.1L136.1 296.9C147.5 292.6 160.4 292.4 172.5 297.4 184.7 302.5 194.1 312 199.2 324.1 204.2 336.3 204.2 349.7 199.1 361.8 188.6 386.9 159.7 398.8 134.5 388.3 122.9 383.5 114.1 374.7 109.1 364.1L137.6 375.9C156.2 383.7 177.5 375 185.2 356.5zM400 32H48C21.5 32 0 53.5 0 80V240.7L116.6 288.8C128.6 280.6 142.8 276.7 157.3 277.5L212.7 197.3V196.2C212.7 148 252 108.7 300.3 108.7S387.9 148 387.9 196.2C387.9 245.4 347 284.9 298.3 283.7L219.3 340C220.9 378.5 190.2 408.8 153.6 408.8 121.8 408.8 95.1 386.1 89.1 356.1L0 319.2V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM300.3 254.5C268.1 254.5 241.9 228.4 241.9 196.2S268.1 137.9 300.3 137.9 358.7 164.1 358.7 196.2 332.5 254.5 300.3 254.5zM300.4 239.9C324.6 239.9 344.3 220.3 344.3 196.1 344.3 171.9 324.7 152.3 300.4 152.3 276.2 152.3 256.5 171.9 256.5 196.1 256.5 220.3 276.2 239.9 300.4 239.9z"}]}}),H.register({"brands/steam-symbol":{width:448,height:512,paths:[{d:"M395.5 177.5C395.5 211.3 368 238.5 334.5 238.5 300.7 238.5 273.5 211.2 273.5 177.5S300.8 116.5 334.5 116.5C368 116.5 395.5 143.7 395.5 177.5zM448 177.7C448 240.7 397 291.5 334.3 291.5L225 371.3C221 414.3 184.5 448.1 140.5 448.1 100 448.1 65.8 419.3 57.5 381.1L0 358V250.7L97.2 290C112.3 280.8 129.4 276.7 149.2 278.5L220.2 176.8C220.7 114.5 271.7 64 334.2 64 397 64 448 115 448 177.7zM203 363C203 328.3 175.2 300.5 140.5 300.5 136 300.5 131.5 301 127 302L153 312.5C178.5 322.7 191 351.5 180.7 377 170.5 402.5 141.5 415 116 404.5 105.8 400.5 95.5 396.2 85.3 392.3 95.8 412 116.5 425.5 140.5 425.5 175.2 425.5 203 397.7 203 363zM410.5 177.7C410.5 135.7 376.2 101.5 334.3 101.5 292 101.5 257.8 135.7 257.8 177.7 257.8 219.9 292.1 253.9 334.3 253.9 376.2 254 410.5 220 410.5 177.7z"}]}}),H.register({"brands/steam":{width:496,height:512,paths:[{d:"M496 256C496 393 384.8 504 247.6 504 133.8 504 38 427.7 8.6 323.6L103.8 362.9C110.2 395 138.7 419.3 172.7 419.3 211.9 419.3 244.6 386.9 242.9 345.8L327.4 285.6C379.5 286.9 423.2 244.7 423.2 192.1 423.2 140.5 381.2 98.6 329.5 98.6S235.8 140.6 235.8 192.1V193.3L176.6 279C161.1 278.1 145.9 282.4 133.1 291.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3L125.2 371.7A52.8-52.8 0 0 1 152.4 397.5C179.3 408.7 210.2 395.9 221.4 369.1 226.8 356.1 226.9 341.8 221.5 328.8 216.1 315.8 206 305.6 193 300.2 180.1 294.8 166.3 295 154.1 299.6L185.6 312.6C205.4 320.8 214.8 343.5 206.5 363.3 198.2 383.2 175.5 392.5 155.7 384.3zM329.5 254.4C295.1 254.4 267.1 226.4 267.1 192.1S295.1 129.8 329.5 129.8 391.9 157.8 391.9 192.1 364 254.4 329.5 254.4zM329.6 238.8C355.5 238.8 376.5 217.8 376.5 192 376.5 166.1 355.5 145.2 329.6 145.2S282.7 166.2 282.7 192C282.8 217.8 303.8 238.8 329.6 238.8z"}]}}),H.register({"brands/sticker-mule":{width:576,height:512,paths:[{d:"M353.1 509.8C347.2 512.7 321 513 316.6 509.3 312.5 506.3 314.4 497.4 315.1 494.3 317.3 479.3 312.6 486.4 305.3 482.8 302.2 481.3 301.2 477.3 300.7 472.8 300.2 471.3 299.7 470.3 299.2 469.3 297.5 458.6 306 435.7 307.4 425.9 312.3 402.2 306.7 388.7 308.9 379 312.6 362.8 313 375.5 313 349.1 311.6 323.2 316.3 312.2 313.5 310.2 298.7 310.2 249.2 320.9 201.3 312.2 155.2 303.3 141.9 283.2 135.9 281.3 125.6 276.8 112.7 281.8 108.6 288.3 108.5 288.4 73.6 358.9 69 376.1 62.8 396.6 68.5 423.5 73.1 442.9 73.1 443 77.6 457.5 83.4 462.4 85.5 463.9 88.5 464.9 90.6 466.9 93.4 469.6 100 482.1 100.4 482.9 103 487.4 104 490.9 98.9 493.4 95.3 495.4 89.6 495.9 84.5 495.9 81.9 496.4 83 499.4 81.4 500.9 78.5 503.7 60.7 507 51.5 503.4 48.9 502.4 45.8 500.4 45.3 498.4 43.8 494.4 47.4 489.4 44.3 485.9 39.8 483 31.2 483.9 27.3 473.9 25.1 468.5 24.7 466.3 24.7 424.5 24.7 414.8 18.8 385.8 16.5 377.6 15 372.1 15 366.1 16.5 361.6 16.8 360.7 20.6 357 20.6 348.6 19.6 347.1 16 348.1 15.5 347.1 5.1 266.5 9.6 268.1 7.8 248.8 6.3 232.8-3.1 204.9 1.1 184.5 1.6 182.1 4.5 163.5 25.3 145.6 56.3 118.9 73.7 107.3 184.3 134.1 185.4 134.5 250.6 155.2 295 125.1 310.5 113.8 323.8 113.8 330.5 109.1 330.6 109 392.2 57 417.5 43.8 464.7 14.4 487.4 27.1 492.6 25.8 497.3 24.8 506 0 509.6 0 515.1 0 511.2 20.2 513.2 25.9 513.7 27.9 516.8 30.9 519.4 30.9 521.7 30.9 521.1 30.1 529.7 25.9 538.1 20.5 544.6 8.3 550.3 8.9 562 10.5 531.3 50.5 531.3 55.8 531.3 57.8 531.5 56.6 535.9 65.3 538.5 70.8 540.5 78.8 542.1 85.3 550.4 115 547.8 99.9 555.5 122.2 575.7 172.3 576.1 167.4 576.1 175.1 576.1 182.6 572 186.1 568.9 191.6 567.4 194.6 564.3 199.1 561.7 199.6 559 200.3 568.7 198.1 548.3 202.1 541.1 203.1 534.9 197.6 533.4 192.6 531.8 187.9 536.2 182.5 521.6 169.7 511.3 159.7 500.5 158.4 489.7 152.7 479.9 147 477.8 153.7 471.7 160.7 453.7 183.6 437.7 207.6 419.7 230.5 407.9 245.5 395.5 260.9 386.2 277.9 382.3 284.7 376.7 306 375.9 307.8 369.7 325.5 370.4 333.6 359.4 376.1 356.3 386.1 353.7 397.5 350.7 408.5 348.5 415.3 343.3 457.8 350.2 467.9 352.3 471.4 358.9 472.4 361.5 475.9 361.6 476 371.1 494.1 370.8 495.9 370.8 502 361.4 501.5 359.5 502.4 354.7 505.3 355.7 508.3 353.1 509.8"}]}}),H.register({"brands/strava":{width:369,height:512,paths:[{d:"M301.6 292L257.7 380.2 213.1 292H145.5L257.7 512 369.2 292H301.6zM151.4 0L0 292H89.2L151.4 175.9 213.1 292H301.6L151.4 0z"}]}}),H.register({"brands/stripe-s":{width:362,height:512,paths:[{d:"M144.3 154.6C144.3 132.3 162.9 123.7 192.7 123.7 236.1 123.7 291.2 137 334.6 160.4V26.1C287.3 7.2 240.1 0 192.8 0 77.1 0 0 60.4 0 161.4 0 319.3 216.8 293.7 216.8 361.8 216.8 388.2 193.9 396.7 162.1 396.7 114.9 396.7 53.9 377.2 6 351.2V479.7C59 502.5 112.8 512.1 162 512.1 280.6 512.1 362.3 461.1 362.3 358.5 362.3 188.3 144.3 218.8 144.3 154.6"}]}}),H.register({"brands/stripe":{width:640,height:512,paths:[{d:"M640 261.6C640 216.1 618 180.2 575.8 180.2S507.9 216.1 507.9 261.3C507.9 314.8 538.2 339.5 581.4 339.5 602.6 339.5 618.5 334.7 630.6 328V294.6C618.5 300.7 604.6 304.4 587 304.4 569.7 304.4 554.5 298.3 552.5 277.5H639.4C639.6 275.2 640 265.9 640 261.6M552.1 244.8C552.1 224.8 564.4 216.4 575.5 216.4 586.4 216.4 598 224.8 598 244.8H552.1zM439.2 180.2C421.8 180.2 410.6 188.4 404.4 194.1L402.1 183.1H363V387.9L407.4 378.5 407.5 328.3C413.9 333 423.4 339.5 438.9 339.5 470.7 339.5 499.7 316.3 499.7 259.9 499.8 208.3 470.4 180.2 439.2 180.2M428.6 302.7C418.2 302.7 412 298.9 407.7 294.3L407.4 228.3C412 223.2 418.4 219.5 428.6 219.5 444.8 219.5 456 237.7 456 260.9 456.1 284.8 445.1 302.7 428.6 302.7M346.4 124V160.2L301.8 169.7V133.5L346.4 124M301.9 183.2H346.5V336.4H301.9V183.2zM254.1 196.3C264.5 177.2 285.2 181.1 291.2 183.2V224C285.5 222.2 267.8 219.5 257.3 233.3V336.4H213V183.2H251.4L254.1 196.3M165.1 183.2H198.8V221H165.1V284.2C165.1 310.4 193.1 302.2 198.8 299.9V333.7C192.9 336.9 182.2 339.6 167.6 339.6 141.3 339.6 121.5 322.6 121.5 296.3L121.7 153.9 165 144.7 165.1 183.2zM44.9 228.3C44.9 248.3 112.8 238.8 112.8 291.7 112.8 323.7 87.4 339.5 50.5 339.5 35.2 339.5 18.5 336.5 2 329.4V289.4C16.9 297.5 35.9 303.6 50.6 303.6 60.5 303.6 67.6 300.9 67.6 292.7 67.6 271.5 0.1 279.5 0.1 230.3 0.1 198.9 24.1 180.1 60.1 180.1 74.8 180.1 89.5 182.4 104.2 188.2V230C90.7 222.7 73.5 218.6 60 218.6 50.7 218.7 44.9 221.4 44.9 228.3"}]}}),H.register({"brands/studiovinari":{width:512,height:512,paths:[{d:"M480.3 187.7L484.5 215.7V243.7L459.4 287.8 419.6 366.2 363.5 433.7 284.4 471.5 266.7 496 259 508 249.4 512S266.7 448.4 268.8 448.4C270.9 448.4 289.1 449.1 289.1 449.1L355.8 410.5 263.3 436.6 207.4 473.4 184.6 501.4 178 502.8 198.8 429.2 205.7 423.7 226.4 436.6 314.7 391.4 371.5 339.9 386.3 271.5 260.9 294.8 276.1 276.6 102.7 223.3 184.6 212.8 18.6 89.9 133.5 108 32.2 0 285.1 126.6 253.6 88.6 378 163 234.7 64 253.4 102.4 203.8 84.3 158.3 0 352.9 122 310 66.2 418 162.6 430 153.7 409 137.3 413.2 99.5 451 89.1 480.2 113.8 491.7 118 484.7 124.2 493.2 136.2 480.1 143.6 469.8 163.8 480.3 187.7z"}]}}),H.register({"brands/stumbleupon-circle":{width:496,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 185.5C246.2 185.5 238.2 193.5 238.2 203.3V310.2C238.2 351.1 204.3 384.1 163.3 384.1 121.9 384.1 88.4 350.6 88.4 309.2V262.7H145.7V308.5C145.7 318.5 153.7 326.3 163.5 326.3S181.3 318.4 181.3 308.5V200.1C181.3 160.1 215.5 128 256 128 296.7 128 330.7 160.3 330.7 200.6V224.3L296.6 234.4 273.7 223.7V203.1C273.8 193.5 265.8 185.5 256 185.5zM423.6 309.1C423.6 350.5 390.1 384 348.7 384 307.5 384 273.8 350.8 273.8 309.8V263L296.7 273.7 330.8 263.6V310.7C330.8 320.5 338.8 328.3 348.6 328.3S366.4 320.4 366.4 310.7V262.7H423.7C423.6 308.6 423.6 309.1 423.6 309.1z"}]}}),H.register({"brands/stumbleupon":{width:512,height:512,paths:[{d:"M502.9 266V335.7C502.9 397.8 452.6 448.1 390.5 448.1 328.7 448.1 278.1 398.3 278.1 336.8V266.6L312.4 282.6 363.5 267.4V338C363.5 352.7 375.5 364.5 390.2 364.5S417 352.7 417 338V266H502.9zM278.2 207.8L312.5 223.8 363.6 208.6V173C363.6 112.5 312.5 64 251.5 64 190.7 64 139.4 112.2 139.4 172.2V334.6C139.4 349.5 127.4 361.3 112.7 361.3S86 349.5 86 334.6V266H0V335.7C0 397.7 50.3 448 112.4 448 174 448 224.8 398.5 224.8 337.2V176.9C224.8 162.2 236.8 150.2 251.5 150.2S278.2 162.2 278.2 176.9V207.8z"}]}}),H.register({"brands/superpowers":{width:448,height:512,paths:[{d:"M448 32C364.7 43 281.2 54 198 65 106 77.5 34.7 151.7 29 245 25.7 300.5 47 354.5 86.8 393.2L0 480C83.3 469 166.5 458 249.8 447 341.6 434.5 413.1 360.2 418.5 267.2 422 211.7 400.5 157.7 360.8 119L448 32zM368.3 264.3C364.1 343.8 294.3 403.5 215.5 398.8 136 394.1 74.8 327.8 79.2 247.8 83.7 168.6 153.5 108.5 232.2 113.3 311.5 118 372.7 184.3 368.3 264.3z"}]}}),H.register({"brands/supple":{width:640,height:512,paths:[{d:"M640 262.5C640 326.6 531 378.6 396.5 378.6 371.7 378.6 347.9 376.8 325.4 373.6 333.1 374 340.9 374.2 348.8 374.2 483.3 374.2 592.3 317.3 592.3 247.1 592.3 217.7 573.2 190.7 541.1 169.1 601.1 190.2 640 224.2 640 262.5zM47.7 227.9C47.6 157.7 156.5 100.6 291 100.3 298.9 100.3 306.6 100.5 314.3 100.8 291.8 97.6 268 95.9 243.3 95.9 108.8 96.3-0.1 148.5 0 212.6 0.1 250.9 39.1 284.9 99.3 305.9 67 284.4 47.8 257.3 47.7 227.9zM107.9 267.8S118.4 281 137.2 281C155.1 281 165.6 269.5 165.6 255.9 165.6 227.9 125.4 230.8 125.4 216.2 125.4 210.8 130.7 207.1 137.9 207.1 143.6 207.1 149.2 209.7 149.2 213.7V217.6H163.4V209.7C163.4 197.6 148 192.9 138 192.9 121.5 192.9 109.5 203.1 109.5 217 109.5 243.6 149.7 242.4 149.7 256.9 149.7 263.5 143.9 267 137.4 267 125.5 267 116.7 256.9 116.7 256.9L107.9 267.8zM228.7 194.2V248.6C228.7 259.9 221.6 266.4 210.9 266.4 200.2 266.4 193.1 259.9 193.1 248.7V194.2H177.3V249.2C177.3 268.1 190.7 281.1 211 281.1 231.1 281.1 244.4 268.1 244.4 249.2V194.2H228.7zM263.1 279.6H278.9V250.1H294.4C310.4 250.1 321.6 238.6 321.6 222S310.4 194.2 294.4 194.2H255.3V207.6H263.1V279.6zM278.9 236.6V207.5H291.8C300.5 207.5 305.5 213.2 305.5 221.9 305.5 230.8 300.4 236.6 291.5 236.6H278.9zM335.9 279.6H351.7V250.1H367.2C383.2 250.1 394.4 238.6 394.4 222S383.2 194.2 367.2 194.2H328.1V207.6H335.9V279.6zM351.6 236.6V207.5H364.5C373.2 207.5 378.2 213.2 378.2 221.9 378.2 230.8 373.2 236.6 364.2 236.6H351.6zM408.7 271.4C408.7 277.2 411.1 279.6 416.9 279.6H454.5C460.3 279.6 462.7 277.2 462.7 271.4V258.4H448.4V263.6C448.4 265.3 447.4 266.2 445.8 266.2H427.2C425.5 266.2 424.6 265.2 424.6 263.6V202.4C424.6 196.7 422.2 194.2 416.4 194.2H401V207.6H406.2C407.9 207.6 408.8 208.6 408.8 210.2V271.4zM472.1 271.4C472.1 277.2 474.5 279.6 480.3 279.6H519C524.7 279.6 527.2 277.2 527.2 271.4V258.4H512.9V263.6C512.9 265.3 511.9 266.2 510.3 266.2H490.6C488.9 266.2 488 265.2 488 263.6V243.3H515.7V229.9H488V207.5H507.2C508.9 207.5 509.8 208.5 509.8 210.1V215.3H524V202.3C524 196.6 521.5 194.1 515.8 194.1H464.2V207.5H472V271.4zM531 195.4V201.3H532.6V195.4H535.3V194.2H528.3V195.4H531zM536.7 194.2V201.3H538.2V195.6L540.5 201.3H541.8L544.1 195.6V201.3H545.6V194.2H543.3L541.2 199.3 539.1 194.2H536.7z"}]}}),H.register({"brands/telegram-plane":{width:448,height:512,paths:[{d:"M446.7 98.6L379.1 417.4C374 439.9 360.7 445.5 341.8 434.9L238.8 359 189.1 406.8C183.6 412.3 179 416.9 168.4 416.9L175.8 312 366.7 139.5C375 132.1 364.9 128 353.8 135.4L117.8 284 16.2 252.2C-5.9 245.3-6.3 230.1 20.8 219.5L418.2 66.4C436.6 59.5 452.7 70.5 446.7 98.6z"}]}}),H.register({"brands/telegram":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM369.8 177.9L329.1 369.7C326.1 383.3 318 386.6 306.7 380.2L244.7 334.5 214.8 363.3C211.5 366.6 208.7 369.4 202.3 369.4L206.7 306.3 321.6 202.5C326.6 198.1 320.5 195.6 313.9 200L171.9 289.4 110.7 270.3C97.4 266.1 97.1 257 113.5 250.6L352.6 158.4C363.7 154.4 373.4 161.1 369.8 177.9z"}]}}),H.register({"brands/tencent-weibo":{width:384,height:512,paths:[{d:"M72.3 495.8C73.7 515.7 44.7 518 42.6 498.7 31 368.8 73.7 259.2 144 185.5 128.4 151.5 153.2 108.4 194.6 108.4 224.9 108.4 249.7 133 249.7 163.5 249.7 207.5 200.2 234.3 162.8 208.6 97.1 279.9 61.4 378.4 72.3 495.8zM192 0.1C66.1 0.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8 267.4 29.8 328.9 91.2 328.9 166.7 328.9 257.5 242 320.6 161.2 299.8 142.1 295.7 135.6 324.2 154.6 328.9 265.3 352.1 358.6 268.9 358.6 166.6 358.6 74.7 284 0.1 192 0.1z"}]}}),H.register({"brands/themeisle":{width:512,height:512,paths:[{d:"M208 88.3C208 78.3 214.3 66.6 225.7 66.6 236.9 66.6 243.4 78.3 243.4 88.3 243.4 98.6 236.9 110 225.7 110 214.3 110 208 98.6 208 88.3zM512 248.3C512 284.3 500.6 350.6 475.7 378 452.9 402.9 388.3 439.1 354.9 448.6L353.7 448.9V481.4C353.7 497.7 341.1 512 324.6 512 314.6 512 305.1 506.3 300 497.7 294.6 506.3 285.1 512 275.1 512 265.1 512 255.7 506.3 250.3 497.7 245.1 506.3 235.7 512 225.7 512 215.4 512 206.3 506.3 200.9 497.7 195.7 506.3 186.3 512 176.3 512 157.4 512 146.9 496.3 146.9 479.1 130.6 491.4 111.1 498.6 90.3 498.6 68.3 498.6 46.9 490.3 30 475.7 40.3 475.4 50.6 473.4 60.3 470 39.4 464.3 20.9 451.1 8.3 433.7 29.7 438.4 54.5 435.4 75.4 422.6 53.4 400.6 18.9 363.7 6.9 335.1 1.1 321.7 0 303.7 0 289.4 0 239.7 20.3 129.4 86.3 129.4 96.9 129.4 105.1 134.3 109.4 144.3A158.8-158.8 0 0 0 121.4 128.9C123.4 126.3 127.1 123.4 128.6 120.6 136.6 108 140.3 99.4 150.3 86.6 182.6 45.4 232 17.1 285.1 17.1 291.1 17.1 297.1 17.4 302.9 18.3 313.7 6.6 328.9 0 344.6 0 359.1 0 374.3 6 384.6 16.3 385.4 17.1 386 18.6 386 19.7 386 23.4 375.7 33.1 373.1 36 377.4 37.4 388.9 42.9 388.9 48 388.9 50.9 386 53.1 384.3 55.1 415.7 82.9 433.7 122.3 440.6 163.1 444.9 158 450.9 154.6 457.7 154.6 468.3 154.6 478.6 161.7 486.3 168.6 507.1 187.1 512 221.7 512 248.3zM188 89.4C188 107.7 200.6 126.6 220.3 126.6 240 126.6 252.6 107.7 252.6 89.4 252.6 71.4 240 52.6 220.3 52.6 200.6 52.6 188 71.4 188 89.4zM237.7 194C237.7 174.3 241.4 154.9 246.3 135.7 194.2 215.2 232.8 320.3 315.1 320.3 336.6 320.3 357.7 312.6 375.1 300.3 377.1 292.9 378.9 285.4 378.9 277.7 378.9 263.4 372.6 256.3 358.3 256.3 353.7 256.3 349.1 257.1 344.9 258 281.5 270.7 237.7 261.7 237.7 194zM196.6 448.9C196.6 437.7 187.7 428 176.3 428 164.9 428 156.3 437.7 156.3 448.9V481.4C156.3 492.6 164.9 502.6 176.3 502.6 187.7 502.6 196.6 492.9 196.6 481.4V448.9zM245.7 448.9C245.7 437.7 237.1 428 225.7 428 214.3 428 205.4 437.7 205.4 448.9V481.4C205.4 492.6 214.3 502.6 225.7 502.6 237.1 502.6 245.7 492.6 245.7 481.4V448.9zM295.4 448.9C295.4 437.7 286.6 428 275.1 428 263.7 428 254.9 437.7 254.9 448.9V481.4C254.9 492.6 263.7 502.6 275.1 502.6 286.6 502.6 295.4 492.9 295.4 481.4V448.9zM345.1 448.9C345.1 437.7 336.3 428 324.9 428 313.4 428 304.6 437.7 304.6 448.9V481.4C304.6 492.6 313.4 502.6 324.9 502.6 336.3 502.6 345.1 492.6 345.1 481.4V448.9zM421.7 286C390.9 345.1 331.4 388.6 263.1 388.6 166.6 388.6 102.6 304 102.6 212 102.6 195.1 104.6 178.6 108.6 162.3 88.6 196 78.9 234.9 78.9 273.7 78.9 334 103.7 395.4 150.3 434.6 155.4 424.9 165.1 418.3 176.3 418.3 186.3 418.3 195.7 424 200.9 432.6 206.3 424 215.4 418.3 225.7 418.3 235.7 418.3 245.1 424 250.3 432.6 255.7 424 265.1 418.3 275.1 418.3 285.1 418.3 294.6 424 300 432.6 305.1 424 314.6 418.3 324.6 418.3 335.4 418.3 345.4 424.9 350.3 434.3 393.7 398 418.9 342.3 421.7 286zM432.3 186.3C432.3 132.6 397.7 80.6 339.7 80.6 309.4 80.6 281.1 95.7 260.9 117.4 240.9 183.8 233.4 254 302.3 254 331.1 254 399.6 225.5 386.6 290.9 415.4 264.9 432.3 225.1 432.3 186.3z"}]}}),H.register({"brands/trello":{width:448,height:512,paths:[{d:"M392 32H56C25.1 32 0 57.1 0 88V424C0 454.9 25.1 480 56 480H392C422.9 480 448 454.9 448 424V88C448 57.1 422.9 32 392 32zM194.9 371.4C194.9 386.2 182.9 398.3 168 398.3H85.1C70.3 398.3 58.2 386.3 58.2 371.4V117.1C58.2 102.3 70.2 90.2 85.1 90.2H168C182.8 90.2 194.9 102.2 194.9 117.1V371.4zM389.8 259.4C389.8 274.2 377.8 286.3 362.9 286.3H280C265.2 286.3 253.1 274.3 253.1 259.4V117.1C253.1 102.3 265.1 90.2 280 90.2H362.9C377.7 90.2 389.8 102.2 389.8 117.1V259.4z"}]}}),H.register({"brands/tripadvisor":{width:576,height:512,paths:[{d:"M166.4 280.5C166.4 293.8 155.7 304.5 142.4 304.5S118.5 293.8 118.5 280.5 129.2 256.6 142.4 256.6 166.4 267.3 166.4 280.5zM431.4 256.6C418.1 256.6 407.4 267.3 407.4 280.5 407.4 293.8 418.1 304.5 431.4 304.5 444.6 304.5 455.3 293.8 455.3 280.5 455.3 267.3 444.6 256.6 431.4 256.6zM520.8 396.1C458.1 445.2 367.5 434.2 318.4 371.5L287.4 417.8 256.7 371.9C208.4 432.3 121.1 443.8 58.8 397.9-5.2 350.8-18.9 260.6 28.2 196.6A186.8-186.8 0 0 1 0 139.4L90.3 139.4A358.5-358.5 0 0 0 287.4 85.3 350.4-350.4 0 0 0 479.5 138.7L575.8 138.8A185.7-185.7 0 0 1 547.4 196.4C594.2 259.2 582.4 347.8 520.8 396.1zM259.4 281.8C259.4 218.2 207.8 166.7 144.3 166.7 80.7 166.7 29.2 218.2 29.2 281.8 29.2 345.3 80.7 396.9 144.3 396.9 207.8 396.8 259.3 345.3 259.4 281.8V281.8zM288 271.3C293.4 197.9 353.5 140.4 427.1 138.3A339.1-339.1 0 0 1 287.4 110.5 356.3-356.3 0 0 1 147.2 137.7C221.5 139.3 282.5 197.1 288 271.3zM539.7 242.5C517.7 182.9 451.5 152.4 391.9 174.4 332.2 196.4 301.7 262.5 323.7 322.2V322.2C345.7 381.8 411.9 412.3 471.5 390.3 531.2 368.3 561.7 302.2 539.7 242.5zM213.6 280.5V280.6C213.6 320 181.6 351.8 142.3 351.7 103 351.7 71.1 319.7 71.2 280.4 71.3 241.1 103.2 209.3 142.5 209.3 181.8 209.4 213.6 241.3 213.6 280.5zM189.1 280.5V280.4C189.1 254.6 168.1 233.8 142.3 233.8 116.6 233.9 95.7 254.8 95.7 280.6 95.8 306.4 116.7 327.3 142.5 327.2 168.2 327.1 189.1 306.2 189.1 280.5zM502.5 280.5V280.6C502.5 319.9 470.6 351.8 431.3 351.7S360.1 319.8 360.1 280.5C360.1 241.2 392 209.3 431.4 209.3 470.7 209.4 502.5 241.2 502.5 280.5zM478 280.5C478 254.7 457.1 233.8 431.3 233.8 405.5 233.8 384.6 254.8 384.7 280.5 384.7 306.3 405.6 327.2 431.4 327.2 457.1 327.2 478 306.3 478 280.5V280.5z"}]}}),H.register({"brands/tumblr-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM317.7 396.2C309.2 405.3 286.5 416 256.8 416 181.3 416 164.9 360.5 164.9 328.1V238.1H135.2C131.8 238.1 129 235.3 129 231.9V189.4C129 184.9 131.8 180.9 136.1 179.4 174.9 165.7 187 131.9 188.8 106.2 189.3 99.3 192.9 96 198.8 96H243.1C246.5 96 249.3 98.8 249.3 102.2V174.2H301.2C304.6 174.2 307.4 177 307.4 180.4V231.5C307.4 234.9 304.6 237.7 301.2 237.7H249.1V321C249.1 342.4 263.9 354.5 291.6 343.4 294.6 342.2 297.2 341.4 299.6 342 301.8 342.5 303.2 344.1 304.2 346.9L318 387.1C319 390.3 320 393.8 317.7 396.2z"}]}}),H.register({"brands/tumblr":{width:320,height:512,paths:[{d:"M309.8 480.3C296.2 494.8 259.8 512 212.4 512 91.6 512 65.4 423.2 65.4 371.4V227.4H17.9C12.4 227.4 7.9 222.9 7.9 217.4V149.4C7.9 142.2 12.4 135.8 19.2 133.4 81.2 111.6 100.7 57.4 103.5 16.3 104.3 5.3 110 0 119.6 0H190.5C196 0 200.5 4.5 200.5 10V125.2H283.5C289 125.2 293.5 129.6 293.5 135.1V216.8C293.5 222.3 289 226.8 283.5 226.8H200.1V360C200.1 394.2 223.8 413.6 268.1 395.8 272.9 393.9 277.1 392.6 280.8 393.6 284.3 394.5 286.6 397 288.2 401.5L310.2 465.8C312 470.8 313.5 476.4 309.8 480.3z"}]}}),H.register({"brands/twitch":{width:448,height:512,paths:[{d:"M40.1 32L10 108.9V423.2H117V480H177.2L234 423.2H321L438 306.2V32H40.1zM397.9 286.1L331 353H224L167.2 409.8V353H76.9V72.1H397.9V286.1zM331 149V265.9H290.9V149H331zM224 149V265.9H183.9V149H224z"}]}}),H.register({"brands/twitter-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM351.1 190.8C351.3 193.6 351.3 196.5 351.3 199.3 351.3 286 285.3 385.9 164.7 385.9 127.5 385.9 93 375.1 64 356.5 69.3 357.1 74.4 357.3 79.8 357.3 110.5 357.3 138.7 346.9 161.2 329.3 132.4 328.7 108.2 309.8 99.9 283.8 110 285.3 119.1 285.3 129.5 282.6 99.5 276.5 77 250.1 77 218.2V217.4C85.7 222.3 95.9 225.3 106.6 225.7A65.4-65.4 0 0 0 77.4 171.1C77.4 158.9 80.6 147.7 86.3 138 118.6 177.8 167.1 203.8 221.5 206.6 212.2 162.1 245.5 126 285.5 126 304.4 126 321.4 133.9 333.4 146.7 348.2 143.9 362.4 138.4 375 130.9 370.1 146.1 359.8 158.9 346.2 167 359.4 165.6 372.2 161.9 384 156.8 375.1 169.9 363.9 181.5 351.1 190.8z"}]}}),H.register({"brands/twitter":{width:512,height:512,paths:[{d:"M459.4 151.7C459.7 156.3 459.7 160.8 459.7 165.4 459.7 304.1 354.1 463.9 161.1 463.9 101.7 463.9 46.5 446.7 0 416.8 8.4 417.8 16.6 418.1 25.3 418.1 74.4 418.1 119.6 401.5 155.6 373.3 109.5 372.3 70.8 342.1 57.5 300.5 64 301.5 70.5 302.1 77.3 302.1 86.7 302.1 96.2 300.8 104.9 298.6 56.9 288.8 20.8 246.6 20.8 195.6V194.3C34.8 202.1 51 206.9 68.2 207.6 40 188.8 21.4 156.6 21.4 120.2 21.4 100.7 26.6 82.8 35.7 67.2 87.4 130.9 165 172.5 252.1 177.1 250.5 169.3 249.5 161.1 249.5 153 249.5 95.2 296.3 48.1 354.4 48.1 384.6 48.1 411.9 60.8 431.1 81.2 454.8 76.7 477.6 67.9 497.7 55.9 489.9 80.2 473.3 100.7 451.6 113.7 472.7 111.4 493.2 105.6 512 97.5 497.7 118.3 479.8 136.8 459.4 151.7z"}]}}),H.register({"brands/typo3":{width:433,height:512,paths:[{d:"M330.8 341C323.8 343.3 319.2 343.3 312.3 343.3 255.1 343.3 171.7 144.8 171.7 78.4 171.7 53.7 177.1 46 185.6 39 116.1 47.5 36.3 73 9.3 105.4 3.9 113.1 0 126.2 0 142.5 0 246 106.8 480 184.1 480 220.4 480 281.4 420.5 330.8 341M294.5 32C366.3 32 433.3 43.6 433.3 84.5 433.3 167.1 380.8 266.8 354.5 266.8 306.6 266.8 252.8 134.7 252.8 68.3 252.8 37.4 264.4 32 294.5 32"}]}}),H.register({"brands/uber":{width:448,height:512,paths:[{d:"M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446C0 464.8 15.2 480 33.9 480H414C432.7 480 447.9 464.8 447.9 446.1V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6H183.3V290C183.3 293.7 186.3 296.8 190.1 296.8H258C261.7 296.8 264.8 293.8 264.8 290V222.1C264.8 218.4 261.8 215.3 258 215.3H190.1C186.4 215.3 183.3 218.3 183.3 222.1V242.5H88.9C95.9 173.1 154.3 120.3 224 120.3 293.7 120.3 352.1 173.1 359.1 242.5 366.6 317 312.2 383.6 237.6 391.1z"}]}}),H.register({"brands/uikit":{width:448,height:512,paths:[{d:"M443.9 128V384L218 512 0 384V169.7L87.6 214.8V331.8L221.1 407.3 356.9 331.8V180.8L255.8 123.2 343.4 70.1 443.9 128zM308.6 49.1L223.8 0 135.2 54.8 221.2 102.1 308.6 49.1z"}]}}),H.register({"brands/uniregistry":{width:384,height:512,paths:[{d:"M281.1 220.1H384V205.3H281.1V220.1zM281.1 183H384V170.6H281.1V183zM281.1 257.2H384V239.9H281.1V257.2zM123.4 343.9H8.5C11.1 352.4 14.3 360.7 18.1 368.7H156.4C143.5 363 132.3 354.5 123.4 343.9M269.1 331.5H378.8C380.6 324.2 381.9 316.8 382.7 309.2H278.3C276.2 317.1 273.1 324.6 269.1 331.5M227.6 368.6H367C370.7 360.6 372.8 352.4 375.5 343.8H260.5C251.7 354.5 240.4 363 227.6 368.6M384 32H281.1V34.5H384V32zM192 480C231.5 480 268.2 468.2 298.8 447.8H85.3C115.8 468.2 152.5 480 192 480M281.1 145.8H384V136H281.1V145.8zM281.1 108.7H384V101.3H281.1V108.7zM281.1 71.6H384V66.7H281.1V71.6zM102.9 170.6H0V183H102.9V170.6zM38.8 405.7H344.1C350.8 397.2 356.7 388.1 361.9 378.5H23C28.2 388.1 32.2 397.2 38.8 405.7M102.9 286.9V274.5H0V286.9C0 289.4 0 291.9 0.1 294.3H103.2C103 291.9 102.9 289.4 102.9 286.9M281.1 286.9C281.1 289.4 281 291.9 280.7 294.3H383.8C383.9 291.8 384 289.4 384 286.9V274.5H281.1V286.9zM78.1 442.9H305.8C317.6 434.2 328.5 424.3 338 413.2H44.9C54.5 424.2 66.3 434.2 78.1 442.9M102.9 66.7H0V71.6H102.9V66.7zM102.9 32H0V34.5H102.9V32zM102.9 205.3H0V220.1H102.9V205.3zM102.9 239.9H0V257.2H102.9V239.9zM102.9 136H0V145.9H102.9V136zM102.9 101.3H0V108.7H102.9V101.3zM105.7 309.2H1.3C2.2 316.8 3.5 324.2 5.2 331.5H114.9C110.9 324.6 107.7 317.1 105.7 309.2"}]}}),H.register({"brands/untappd":{width:640,height:512,paths:[{d:"M401.3 49.9C321.5 210 316.7 202.4 313.4 223.1L308.2 255.9C306.3 267.9 301.6 279.4 294.5 289.3L145.6 497.1C138 507.7 125.2 513.3 112.2 511.7 71.9 506.7 34.4 479.5 16.9 443.2 11.2 431.4 12.4 417.4 20 406.8L168.9 198.9C176 189 185.3 180.9 196.1 175.2L225.4 159.7C243.9 149.9 235.1 147.8 361 20.8 362 16 362 13.5 364.6 12.8 367.6 12.1 371.2 11.8 370.9 8.2L370.5 3.6C370.3 1.7 371.8 0 373.7 0 378.2-0.1 386.9 1.2 399.3 10 411.6 18.9 415.7 26.8 417 31.1 417.6 32.9 416.4 34.8 414.6 35.3L410.1 36.4C406.7 37.3 407.6 40.8 407.8 43.8 407.9 46.6 405.5 47.4 401.3 49.9zM230.1 36.4C233.5 37.3 232.6 40.8 232.4 43.8 232.2 46.5 234.5 47.3 238.8 49.8 246.7 65.7 254.1 80.3 261 93.8 261.7 95.1 263.3 95.3 264.3 94.3 275.5 82.3 288.9 68.1 304.8 51.7 306.1 50.3 306.2 48.2 304.9 46.8 296.9 38.6 288.4 29.9 279.3 20.7 278.3 16 278.3 13.4 275.7 12.7 272.7 11.9 269.1 11.7 269.4 8.1 269.7 4.8 270.8 0 266.6-0.1 262.1-0.2 253.4 1 241 9.9 228.7 18.8 224.6 26.7 223.3 31 221.9 35.2 226.9 35.6 230.1 36.4zM620 406.7L471.2 198.8C458 180.3 444.6 175.4 414.8 159.7 403.6 153.8 400.6 148.8 384.3 130.8 383.3 129.7 381.4 129.9 380.7 131.3 334.4 220.1 333.6 214.1 331.7 226.1 330 236.8 330.4 246.1 332 255.9 333.9 267.9 338.6 279.4 345.7 289.3L494.6 497.2C502.2 507.8 514.8 513.4 527.7 511.9 568 507 605.7 479.9 623.4 443.3 628.8 431.4 627.7 417.4 620 406.7z"}]}}),H.register({"brands/usb":{width:640,height:512,paths:[{d:"M641.5 256C641.5 259.1 639.8 262.1 637 263.5L547.9 317C546.5 317.8 545.1 318.4 543.4 318.4 542 318.4 540.3 318.1 538.9 317.3 536.1 315.6 534.4 312.8 534.4 309.5V273.9H295.7C321 313.5 336.2 380.8 365.3 380.8H392V354C392 349 395.9 345.1 400.9 345.1H490C495 345.1 498.9 349 498.9 354V443.1C498.9 448.1 495 452 490 452H400.9C395.9 452 392 448.1 392 443.1V416.4H365.3C289.9 416.4 284.2 273.9 240.6 273.9H140.3C132.2 304.5 104.4 327.4 71.3 327.4 32 327.3 0 295.3 0 256S32 184.7 71.3 184.7C104.4 184.7 132.3 207.5 140.3 238.2 179.4 238.2 184.2 247.7 214.9 177.8 255 88.7 273 95.7 323.8 95.7 331.3 74.8 350.8 60.1 374.2 60.1 403.7 60.1 427.7 84 427.7 113.6S403.8 167.1 374.2 167.1C350.8 167.1 331.3 152.3 323.8 131.5H294C264.9 131.5 249.7 198.9 224.4 238.4H534.5V202.8C534.5 199.5 536.2 196.7 539 195 541.8 193.3 545.4 193.6 547.9 195.3L637 248.8C639.8 249.9 641.5 252.9 641.5 256z"}]}}),H.register({"brands/ussunnah":{width:512,height:512,paths:[{d:"M156.8 285.1L162.5 299.5H154.3C153 296.3 151.2 291.8 150.5 290 148 283.7 149.4 281.6 150.5 280 152.4 277.3 153.7 275.6 154.1 274.8 154.1 277 154.9 280.5 156.8 285.1zM454.1 303.9C452 317.7 448.4 331 443.6 343.6L486.6 367 441.8 348.2C436.5 361.4 429.8 373.8 421.9 385.4L456.1 415.6 419.3 389.2C410.9 401 401.3 411.8 390.6 421.5L415.5 456.2 387.4 424.4C376.4 434 364.3 442.4 351.3 449.5L367 486.7 347.7 451.4C334.6 458.2 320.7 463.5 306.1 467.3L312.8 505.7 302.3 468.3C288 471.7 273.1 473.6 257.8 473.7L256 512 254.1 473.6C238.8 473.5 223.9 471.6 209.6 468.3L199 505.6 205.7 467.4C191.1 463.7 177.1 458.3 164 451.6L144.8 486.7 160.4 449.7C147.4 442.7 135.2 434.3 124.2 424.6L96.3 456.2 121 421.8C110.3 412.1 100.6 401.3 92.2 389.5L55.7 415.7 89.6 385.8C81.7 374.2 75 361.7 69.6 348.5L25.2 367.2 67.8 344C63 331.3 59.4 317.9 57.3 304.1L6.3 313.1 56.6 298.9C55.5 290.4 54.9 281.8 54.9 273 54.9 268.3 55.1 263.6 55.4 258.9L0 256 56 253.2C57.3 240.1 59.8 227.4 63.5 215.1L6.4 199 65.3 209.4C69.3 197.4 74.4 185.9 80.5 175L25.4 145 83.7 169.6C90 159 97.2 149.2 105.3 140L55.8 96.4 109.7 135.1C117.8 126.5 126.7 118.6 136.3 111.5L96.3 55.9 141.9 107.5C151.4 100.9 161.6 95.2 172.2 90.3L144.9 25.4 178.7 87.5C189.2 83.1 200.1 79.6 211.4 77.1L199 6.4 218.5 75.6C229.5 73.5 240.8 72.4 252.3 72.2L256 0 259.6 72.2C271.1 72.4 282.4 73.6 293.4 75.7L313 6.4 300.6 77.1C311.9 79.7 322.8 83.2 333.2 87.6L367.1 25.4 339.7 90.5C350.3 95.4 360.4 101.2 369.9 107.7L415.7 55.9 375.6 111.8C385.1 118.9 394 126.8 402.1 135.4L456.3 96.5 406.6 140.4C414.6 149.5 421.8 159.3 428.1 169.8L486.8 145.1 431.3 175.3C437.4 186.2 442.4 197.6 446.4 209.6L505.7 199.2 448.2 215.4C451.9 227.6 454.4 240.3 455.7 253.3L512 256 456 258.8C456.3 263.4 456.5 268.1 456.5 272.9 456.5 281.6 455.9 290.2 454.9 298.7L505.6 313 454.1 303.9zM432.3 272.9C432.3 175.4 353.3 96.4 255.8 96.4S79.3 175.4 79.3 272.9 158.3 449.4 255.8 449.4 432.3 370.4 432.3 272.9zM408.3 272.9C408.3 357.2 340 425.5 255.7 425.5S103.1 357.2 103.1 272.9 171.4 120.3 255.7 120.3 408.3 188.6 408.3 272.9zM195 241C195 243.1 196.3 244.8 198.6 246.1 201.9 248 204.8 250.7 206.8 254.3 209.6 248.6 211.1 244.8 211.1 243.1 211.1 240.9 210 238.7 207.9 236.1 205.8 233.6 204.7 230.9 204.6 228.4 198.1 235.2 195 239.3 195 241zM154.3 222C154.3 224.1 155.6 225.8 157.9 227.1 161.4 229 164.1 231.7 166.1 235.3 168.9 229.6 170.4 225.8 170.4 224.1 170.4 221.9 169.3 219.7 167.2 217.1 165.1 214.6 164 211.9 163.9 209.4 157.4 216.2 154.3 220.3 154.3 222zM135.3 222C135.3 224.1 136.6 225.8 138.9 227.1 142.2 229 145.1 231.7 147.1 235.3 149.9 229.6 151.4 225.8 151.4 224.1 151.4 221.9 150.3 219.7 148.2 217.1 146.1 214.6 145 211.9 144.9 209.4 138.5 216.2 135.3 220.3 135.3 222zM340.2 309.9C331.8 306.9 331.5 303.1 331.5 294.3V182C323.3 194.5 317.3 200.6 313.5 200.6 319.8 215 323 224.5 323 228.9V293.2C323 295.4 320.8 299.7 318.3 299.7H300.3C297.5 292.2 290.1 272.8 285 259.4 283 261.9 277.8 268.6 274.3 273.1 276.7 274.7 278.4 276.7 279.5 279.4 282.1 286.1 285.9 295.9 287.4 299.6H278.2C274.3 289.2 268.6 274.2 266.4 268.5 264.4 271 259.2 277.7 255.7 282.2 258.1 283.8 259.8 285.8 260.9 288.5 261.7 290.5 263.7 295.8 265.2 299.4H256C254.5 295.3 250.4 284.8 247.6 277.4 245.6 279.9 240.4 286.6 236.9 291.1 239.4 292.7 241.2 294.7 242.1 297.4 242.3 298 242.6 298.8 242.7 299.1H225C220.4 285.2 213.6 271.4 213.6 265 213.6 262.8 213.9 259.9 214.7 256.8 205.9 267.6 200.7 272.7 200.7 281.8 200.7 289.3 211.1 310.1 211.1 315.1 211.1 316.8 210.6 318.4 209.7 320 200.1 307.3 194.2 299.3 190.9 299.3H178.9L167.7 271.3C163.9 261.7 162 255.3 162 252.5 162 248.7 162.5 244.8 163.7 240.3 162.7 241.6 160 245 158.2 247.4 157.4 245.3 155.1 239.7 153.6 235.9 151.5 238.4 146.1 245 142.4 249.5 143.3 251.8 145.7 257.6 147.3 261.7 144.8 265 138.2 273.5 133.7 279.4 129.7 284.7 127.9 292.7 131 301.2 133.5 307.9 133 309.1 129.3 315.3H191C196.5 315.3 205.3 329.3 206.5 337.3 219.7 321.3 221.9 317.7 223.3 315.7H330.3C334.2 315.7 337.5 313.8 340.2 309.9zM360.3 283.3V181.7C351.3 194.2 344.4 200.3 339.6 200.3 346.7 214.7 350.3 224.2 350.3 228.6V294.9C350.3 312.4 358.9 315.3 374.3 315.3 382.4 315.3 386.8 314.5 388 312.6 383.7 311 380.4 310.1 378.1 309.3 370 306.1 360.3 301.9 360.3 283.3z"}]}}),H.register({"brands/vaadin":{width:448,height:512,paths:[{d:"M224.5 140.7C226 123.1 229.4 88 274.3 88H372.9C393.6 88 405 80.2 405 66.4V54.1C405 41.9 414.3 32 426.5 32S448 41.9 448 54.1V90.6C448 133.5 426.5 152.6 381.2 152.6H280.7C250.6 152.6 247.7 167.3 247.7 179.7 247.7 181 247.6 182.2 247.5 183.4 246.8 195.7 236.6 205.6 224.1 205.6S201.4 195.8 200.7 183.4C200.6 182.2 200.5 181 200.5 179.7 200.5 167.4 197.5 152.6 167.5 152.6H66.8C21.5 152.6 0 133.5 0 90.6V54.1C0 41.9 9.4 32 21.6 32S43.1 41.9 43.1 54.1V66.4C43.1 80.2 54.5 88 75.2 88H173.8C218.6 88 222.1 123.1 223.6 140.7H224.5zM224 456C235.5 456 245.4 449 249.7 439.7 250.8 437.9 346.8 270.1 347.9 268.3 359.8 248.7 344.7 224 320.7 224 306.8 224 297.4 230.4 290.9 244.3L224 362 157.1 244.3C150.7 230.4 141.2 224 127.3 224 103.3 224 88.2 248.6 100.1 268.3 101.2 270.2 197.2 437.9 198.3 439.7 202.6 449 212.5 456 224 456z"}]}}),H.register({"brands/viacoin":{width:384,height:512,paths:[{d:"M384 32H320L239.3 224H144.8L64 32H0L48 144H0V192H68.5L82.3 224H0V272H102.8L192 480 281.2 272H384V224H301.7L315.5 192H384V144H336L384 32zM192 336L165 272H219L192 336z"}]}}),H.register({"brands/viadeo-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM280.7 381.2C238.3 427.4 160.7 427.8 118.3 381.2 50.3 307.6 98.5 185.1 199.5 185.1 212.8 185.1 226.1 187.2 238.6 191.8 234.3 200.2 231.3 209.4 230.2 218.9 220.5 214.8 210 212.9 199.5 212.9 150.7 212.9 114.9 254.6 114.9 301.8 114.9 344.8 143.4 380.5 184.4 387.7 245.9 363.7 257.3 270.1 257.3 212.7 257.3 205.4 257.3 197.9 256.7 190.6 245.5 157.7 230.1 126 212.5 96.1 239.6 114.4 254.4 158.6 256.7 190.2V190.6C264.4 213.1 268.5 236.8 268.5 260.6 268.5 314.7 246.6 359.6 200.2 388.8L197.8 389C247.8 390 284 350.4 284 301.8 284 289.6 281.9 277.5 277.1 266.1 286.6 264.2 295.6 260.5 303.5 255.6 318.8 292.2 316.1 342.9 280.7 381.2zM309 233.7C295.7 233.7 283.9 226.6 274.6 217.6 296.5 205.6 324.2 186.9 336.9 164.6 338.4 161.6 341 156 341.4 152.6 328.9 180.5 297.2 202.4 267.5 209.3 262.8 202 260 193.8 260 185 260 174.7 265.2 160.9 272.9 153.4 294.5 132.9 325.9 144.9 345.3 103.4 377.8 149.6 358.4 233.7 309 233.7z"}]}}),H.register({"brands/viadeo":{width:448,height:512,paths:[{d:"M276.2 150.5V151.2C258.3 98.6 233.6 47.8 205.4 0 248.7 29.2 272.4 100 276.2 150.5zM308.9 272.2C316.5 290.4 319.9 309.7 319.9 329.2 319.9 406.9 262.1 470.2 182.1 468.6L185.9 468.3C260.1 421.6 295.2 349.7 295.2 263.2 295.2 225.1 288.7 187.3 276.3 151.2 277.3 162.9 277.3 174.9 277.3 186.6 277.3 278.4 259.2 428.2 160.7 466.6 95 455.2 49.4 398 49.4 329.2 49.4 253.6 106.8 186.9 184.8 186.9 201.6 186.9 218.5 190 233.9 196.5 235.6 181.4 240.4 166.6 247.3 153.2 227.4 146 206.1 142.5 184.8 142.5 23.3 142.5-53.9 338.4 54.9 456.2 122.8 530.8 246.9 530.1 314.7 456.2 371.3 394.9 375.6 313.8 351.1 255.2 338.4 263.2 324 269.1 308.9 272.2zM418.1 11.7C387.1 78.2 336.8 58.9 302.3 91.8 289.9 103.8 281.7 125.8 281.7 142.3 281.7 156.4 286.2 169.4 293.7 181.1 341.1 170.1 392 135.1 411.9 90.4 411.2 95.9 407.1 104.8 404.7 109.6 384.4 145.3 340.1 175.2 305 194.5 319.8 208.9 338.7 220.3 360 220.3 439 220.3 470.1 85.7 418.1 11.7z"}]}}),H.register({"brands/viber":{width:512,height:512,paths:[{d:"M444 49.9C431.3 38.2 379.9 0.9 265.3 0.4 265.3 0.4 130.2-7.7 64.4 52.7 27.8 89.3 14.9 143 13.5 209.5 12.1 276 10.4 400.6 130.5 434.4H130.6L130.5 486S129.7 506.9 143.5 511.1C160.1 516.3 169.9 500.4 185.8 483.3 194.5 473.9 206.5 460.1 215.6 449.6 297.8 456.5 360.9 440.7 368.1 438.4 384.7 433 478.6 421 493.8 296.4 509.6 167.8 486.2 86.6 444 49.9zM457.9 287C445 391 368.9 397.6 354.9 402.1 348.9 404 293.4 417.8 223.7 413.3 223.7 413.3 171.7 476 155.5 492.3 150.2 497.6 144.4 497.1 144.5 486.6 144.5 479.7 144.9 400.9 144.9 400.9 144.8 400.9 144.8 400.9 144.9 400.9 43.1 372.7 49.1 266.6 50.2 211.1 51.3 155.6 61.8 110.1 92.8 79.5 148.5 29 263.2 36.5 263.2 36.5 360.1 36.9 406.5 66.1 417.3 75.9 453 106.5 471.2 179.7 457.9 287zM318.9 206.2C319.3 214.8 306.4 215.4 306 206.8 304.9 184.8 294.6 174.1 273.4 172.9 264.8 172.4 265.6 159.5 274.1 160 302 161.5 317.5 177.5 318.9 206.2zM339.2 217.5C340.2 175.1 313.7 141.9 263.4 138.2 254.9 137.6 255.8 124.7 264.3 125.3 322.3 129.5 353.2 169.4 352.1 217.8 352 226.4 339 226 339.2 217.5zM386.2 230.9C386.3 239.5 373.3 239.6 373.3 231 372.7 149.5 318.4 105.1 252.5 104.6 244 104.5 244 91.7 252.5 91.7 326.2 92.2 385.5 143.1 386.2 230.9zM374.9 329V329.2C364.1 348.2 343.9 369.2 323.1 362.5L322.9 362.2C301.8 356.3 252.1 330.7 220.7 305.7 204.5 292.9 189.7 277.8 178.3 263.3 168 250.4 157.6 235.1 147.5 216.7 126.2 178.2 121.5 161 121.5 161 114.8 140.2 135.7 120 154.8 109.2H155C164.2 104.4 173 106 178.9 113.1 178.9 113.1 191.3 127.9 196.6 135.2 201.6 142 208.3 152.9 211.8 159 217.9 169.9 214.1 181 208.1 185.6L196.1 195.2C190 200.1 190.8 209.2 190.8 209.2S208.6 276.5 275.1 293.5C275.1 293.5 284.2 294.3 289.1 288.2L298.7 276.2C303.3 270.2 314.4 266.4 325.3 272.5 340 280.8 358.7 293.7 371.1 305.4 378.1 311.1 379.7 319.8 374.9 329z"}]}}),H.register({"brands/vimeo-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM383.8 181.6C382.4 212.7 360.6 255.4 318.5 309.5 275 366 238.2 394.3 208.1 394.3 189.4 394.3 173.7 377.1 160.8 342.7 135.6 250.4 124.9 196.3 104.1 196.3 101.7 196.3 93.3 201.3 79 211.4L64 192C100.9 159.6 136.1 123.6 158.1 121.6 183 119.2 198.3 136.2 204.1 172.7 224.6 302.3 233.7 321.9 270.9 263.2 284.3 242 291.5 226 292.4 214.9 295.8 182.1 266.8 184.3 247.2 192.7 262.9 141.2 293 116.2 337.3 117.6 370.2 118.6 385.7 140 383.8 181.6z"}]}}),H.register({"brands/vimeo-v":{width:448,height:512,paths:[{d:"M447.8 153.6C445.8 197.2 415.4 256.9 356.4 332.7 295.5 411.9 244 451.5 201.8 451.5 175.7 451.5 153.6 427.4 135.5 379.2 100.3 250 85.3 174.3 56.2 174.3 52.8 174.3 41.1 181.4 21 195.4L0 168.2C51.6 122.9 100.9 72.5 131.8 69.7 166.7 66.3 188.1 90.2 196.2 141.2 224.9 322.7 237.6 350.1 289.8 267.9 308.5 238.3 318.6 215.8 320 200.3 324.8 154.4 284.2 157.5 256.7 169.3 278.7 97.2 320.8 62.2 382.9 64.2 428.7 65.4 450.4 95.3 447.8 153.6z"}]}}),H.register({"brands/vimeo":{width:448,height:512,paths:[{d:"M403.2 32H44.8C20.1 32 0 52.1 0 76.8V435.2C0 459.9 20.1 480 44.8 480H403.2C427.9 480 448 459.9 448 435.2V76.8C448 52.1 427.9 32 403.2 32zM377 180.8C375.6 212.3 353.6 255.5 311 310.2 267 367.4 229.7 396 199.3 396 180.4 396 164.5 378.6 151.4 343.7 125.9 250.4 115 195.7 94 195.7 91.6 195.7 83.1 200.8 68.6 210.9L53.4 191.3C90.7 158.5 126.3 122.1 148.6 120.1 173.8 117.7 189.3 134.9 195.1 171.8 215.8 303 225 322.8 262.7 263.4 276.2 242 283.5 225.7 284.5 214.5 288 181.3 258.6 183.6 238.7 192.1 254.6 140 285 114.7 329.9 116.1 363.2 117 378.9 138.6 377 180.8z"}]}}),H.register({"brands/vine":{width:384,height:512,paths:[{d:"M384 254.7V306.8C365.6 311 347.1 312.9 331.9 312.9 295 390.3 228.9 456.7 206.8 469.1 192.8 477 179.7 477.5 164.1 468.3 137 452 34.2 367.7 0 102.7H74.5C93.2 261.8 139 343.4 189.3 404.5 217.2 376.6 244.1 339.4 264.9 297.6 215.1 272.3 184.8 216.7 184.8 152 184.8 86.4 222.5 36.9 287 36.9 401.9 36.9 393.2 164.8 368.6 218.4 368.6 218.4 322.2 227.6 305.1 197.9 308.5 186.6 313.3 167.1 313.3 149.4 313.3 118.1 302 102.8 284.9 102.8 266.7 102.8 254.1 119.9 254.1 152.8 254.2 232 313.5 271.5 384 254.7z"}]}}),H.register({"brands/vk":{width:576,height:512,paths:[{d:"M545 117.7C548.7 105.2 545 96 527.2 96H468.3C453.3 96 446.4 103.9 442.7 112.7 442.7 112.7 412.7 185.8 370.3 233.2 356.6 246.9 350.3 251.3 342.8 251.3 339.1 251.3 333.4 246.9 333.4 234.4V117.7C333.4 102.7 329.2 96 316.8 96H224.2C214.8 96 209.2 103 209.2 109.5 209.2 123.7 230.4 127 232.6 167V253.8C232.6 272.8 229.2 276.3 221.7 276.3 201.7 276.3 153.1 202.9 124.3 118.9 118.5 102.6 112.8 96 97.7 96H38.8C22 96 18.6 103.9 18.6 112.7 18.6 128.3 38.6 205.8 111.7 308.2 160.4 378.1 229 416 291.4 416 328.9 416 333.5 407.6 333.5 393.1 333.5 326.3 330.1 320 348.9 320 357.6 320 372.6 324.4 407.6 358.1 447.6 398.1 454.2 416 476.6 416H535.5C552.3 416 560.8 407.6 555.9 391 544.7 356.1 469 284.3 465.6 279.5 456.9 268.3 459.4 263.3 465.6 253.3 465.7 253.2 537.6 152 545 117.7z"}]}}),H.register({"brands/vnv":{width:640,height:512,paths:[{d:"M104.9 352C70.8 352 58.5 321.6 58.5 321.6L2.6 210.1S-7.8 192 13 192H45.8C56.2 192 59 200.7 64.6 210.1L101.3 284.6S106.5 297.7 122.4 297.7 143.5 284.6 143.5 284.6L180.2 210.1C185.8 200.6 188.6 192 199 192H231.8C252.6 192 242.2 210.1 242.2 210.1L186.4 321.6S174.2 352 140 352H104.9zM499.9 352C465.8 352 453.5 321.6 453.5 321.6L397.6 210.1S387.2 192 408 192H440.8C451.2 192 454 200.7 459.6 210.1L496.3 284.6S501.5 297.7 517.4 297.7 538.5 284.6 538.5 284.6L575.3 210.1C580.9 200.6 583.7 192 594.1 192H627C647.8 192 637.4 210.1 637.4 210.1L581.5 321.6S569.3 352 535.1 352H499.9zM337.6 192C371.7 192 384 222.4 384 222.4L439.9 333.9S450.3 352 429.5 352H396.7C386.3 352 383.5 343.3 377.9 333.9L341.2 259.4S336 246.3 320.1 246.3C304.2 246.3 299 259.4 299 259.4L262.3 333.9C256.7 343.3 253.9 352 243.5 352H210.6C189.8 352 200.2 333.9 200.2 333.9L256.1 222.4S268.3 192 302.5 192H337.6z"}]}}),H.register({"brands/vuejs":{width:448,height:512,paths:[{d:"M356.9 64.3H280L224 152.9 176 64.3H0L224 448 448 64.3H356.9zM55.7 96.3H109.5L224 294.5 338.4 96.3H392.2L224 384.5 55.7 96.3z"}]}}),H.register({"brands/weibo":{width:512,height:512,paths:[{d:"M407 177.6C414.6 153.6 393.6 130.8 369.6 135.9 347.6 140.7 340.8 107.8 362.5 103.1 412.6 92.2 454.8 140.2 439 187.9 432.2 209.1 400.2 198.7 407 177.6zM214.8 446.7C108.5 446.7 0 395.3 0 310.4 0 266.1 28 215 76.3 166.7 176 67 279.5 65.8 249.9 161 245.9 174.1 262.2 166.7 262.2 167 341.7 133.4 402.7 150.2 376.2 218.4 372.5 227.8 377.3 229.3 384.5 231.5 520.2 273.8 419.3 446.7 214.8 446.7zM358.5 300.4C353.1 244.7 280 206.4 195.1 214.7 110.3 223.3 46.3 275 51.7 330.7S130.2 424.7 215.1 416.4C299.9 407.8 363.9 356.1 358.5 300.4zM347.9 35.1C322 40.7 331.1 78.8 356.2 73.4 428.5 58.2 491 126.2 467.9 197.4 460.5 221.6 497 234.4 505.3 209.4 537.2 109.6 450.2 13.5 347.9 35.1zM269.4 346.1C252.3 384.9 202.6 406.1 160.3 392.4 119.5 379.3 102.3 339 120 302.7 137.7 267.3 183.1 247.3 223.4 257.6 265.4 268.4 286.5 307.8 269.4 346.1zM183.1 316.1C170.2 310.7 153.1 316.4 145.1 329 136.8 341.9 140.8 357 153.7 363 166.8 369 184.5 363.3 192.8 350.1 200.8 337 196.5 321.8 183.1 316.1zM215.7 302.7C210.6 301 204.3 303.3 201.4 308.1 198.5 313.2 200 318.7 205.1 321 210.2 323 216.8 320.7 219.7 315.6 222.5 310.4 220.8 304.7 215.7 302.7z"}]}}),H.register({"brands/weixin":{width:576,height:512,paths:[{d:"M385.2 167.6C391.6 167.6 397.8 167.9 404 168.7 387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4 13 250.8 42.3 294.9 90.9 329L71.6 387.6 139.6 353.5C164 358.3 183.4 363.2 207.8 363.2 214 363.2 219.9 362.9 226.1 362.4 222.1 349.5 219.9 335.8 219.9 321.6 219.8 236.7 292.8 167.6 385.2 167.6zM280.7 114.7C295.2 114.7 304.9 124.4 304.9 139.1 304.9 153.6 295.2 163.3 280.7 163.3 265.9 163.3 251.4 153.6 251.4 139.1 251.5 124.4 266 114.7 280.7 114.7zM144.3 163.3C129.8 163.3 115 153.6 115 139.1 115 124.3 129.8 114.7 144.3 114.7 159.1 114.7 168.7 124.4 168.7 139.1 168.7 153.7 159.1 163.3 144.3 163.3zM563 319.4C563 241.5 485.1 178.1 397.6 178.1 304.9 178.1 232.2 241.5 232.2 319.4S305 460.7 397.6 460.7C416.9 460.7 436.5 455.6 456.2 450.8L509.6 480.1 494.8 431.5C534 402.1 563 363.2 563 319.4zM343.9 294.9C334.2 294.9 324.6 285.2 324.6 275.3 324.6 265.6 334.3 256 343.9 256 358.7 256 368.3 265.7 368.3 275.3 368.3 285.3 358.6 294.9 343.9 294.9zM451 294.9C441.3 294.9 431.7 285.2 431.7 275.3 431.7 265.6 441.4 256 451 256 465.5 256 475.4 265.7 475.4 275.3 475.5 285.3 465.5 294.9 451 294.9z"}]}}),H.register({"brands/whatsapp-square":{width:448,height:512,paths:[{d:"M224 122.8C151.3 122.8 92.2 181.9 92.1 254.6 92.1 279.5 99.1 303.8 112.3 324.7L115.4 329.7 102.1 378.3 152 365.2 156.8 368.1C177 380.1 200.2 386.5 223.9 386.5H224C296.6 386.5 357.3 327.4 357.3 254.7 357.3 219.5 342.1 186.4 317.2 161.5 292.2 136.5 259.2 122.8 224 122.8zM301.5 311.2C298.2 320.5 282.4 328.9 274.8 330 262.2 331.9 252.4 330.9 227.3 320.1 187.6 302.9 161.6 262.9 159.6 260.3 157.6 257.7 143.4 238.8 143.4 219.3S153.6 190.2 157.3 186.2C160.9 182.2 165.2 181.2 167.9 181.2 170.5 181.2 173.2 181.2 175.5 181.3 177.9 181.4 181.2 180.4 184.4 188.1 187.7 196 195.6 215.5 196.6 217.5S198.3 221.8 196.9 224.4C189.3 239.6 181.2 239 185.3 246 200.6 272.3 215.9 281.4 239.2 293.1 243.2 295.1 245.5 294.8 247.8 292.1 250.1 289.5 257.7 280.5 260.3 276.6 262.9 272.6 265.6 273.3 269.2 274.6 272.8 275.9 292.3 285.5 296.3 287.5S302.9 290.5 303.9 292.1C304.8 294 304.8 302 301.5 311.2zM400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM223.9 413.2C197.3 413.2 171.2 406.5 148.1 393.9L64 416 86.5 333.8C72.6 309.8 65.3 282.5 65.3 254.5 65.4 167.1 136.5 96 223.9 96 266.3 96 306.1 112.5 336.1 142.5 366 172.5 384 212.3 384 254.7 384 342.1 311.3 413.2 223.9 413.2z"}]}}),H.register({"brands/whatsapp":{width:448,height:512,paths:[{d:"M380.9 97.1C339 55.1 283.2 32 223.9 32 101.5 32 1.9 131.6 1.9 254 1.9 293.1 12.1 331.3 31.5 365L0 480 117.7 449.1C150.1 466.8 186.6 476.1 223.8 476.1H223.9C346.2 476.1 448 376.5 448 254.1 448 194.8 422.8 139.1 380.9 97.1zM223.9 438.7C190.7 438.7 158.2 429.8 129.9 413L123.2 409 53.4 427.3 72 359.2 67.6 352.2C49.1 322.8 39.4 288.9 39.4 254 39.4 152.3 122.2 69.5 224 69.5 273.3 69.5 319.6 88.7 354.4 123.6 389.2 158.5 410.6 204.8 410.5 254.1 410.5 355.9 325.6 438.7 223.9 438.7zM325.1 300.5C319.6 297.7 292.3 284.3 287.2 282.5 282.1 280.6 278.4 279.7 274.7 285.3 271 290.9 260.4 303.3 257.1 307.1 253.9 310.8 250.6 311.3 245.1 308.5 212.5 292.2 191.1 279.4 169.6 242.5 163.9 232.7 175.3 233.4 185.9 212.2 187.7 208.5 186.8 205.3 185.4 202.5 184 199.7 172.9 172.4 168.3 161.3 163.8 150.5 159.2 152 155.8 151.8 152.6 151.6 148.9 151.6 145.2 151.6 141.5 151.6 135.5 153 130.4 158.5 125.3 164.1 111 177.5 111 204.8 111 232.1 130.9 258.5 133.6 262.2 136.4 265.9 172.7 321.9 228.4 346 263.6 361.2 277.4 362.5 295 359.9 305.7 358.3 327.8 346.5 332.4 333.5 337 320.5 337 309.4 335.6 307.1 334.3 304.6 330.6 303.2 325.1 300.5z"}]}}),H.register({"brands/whmcs":{width:448,height:512,paths:[{d:"M448 161V139.7L419.5 130.9 417.3 120.5 437.4 99.8 427 80.4 398 87.9 390.8 80.4 398.3 52.2 379.2 40.6 357.9 61.6 347.2 58.4 340.2 32H317.6L311.4 58.4 299.3 61.6 279.6 40.6 260.2 51.6 268.3 79.3 260.2 87.7 231.7 80.2 220.7 99.3 241.4 120.3 238.5 130.7 210 138.5 209.7 160.2 238.5 167.7 240.9 179.8 220.8 199.7 231.2 218.2 260.8 210.7 268 219.3 259.9 246.2 279.8 257.8 299.2 237.4 310.8 240.3 317.5 268.8 340.1 269.1 346.8 240.3 358.4 236.8 379.1 258.4 399.5 246.3 390.7 218.3 398.5 210.2 427.3 219 437.6 198.9 416.7 180.1 418.9 168 448 161zM328.8 206.2C297.5 206.2 272 180.8 272 149.4S297.4 92.6 328.8 92.6 385.6 118 385.6 149.4C385.6 180.9 360.2 206.2 328.8 206.2zM401.1 222.6L448 237.1V277L392.9 290.4 388.8 313.1 427.7 348.4 408.5 386.3 354.5 369.6 339.9 384.8 356.6 437.3 318.3 460 279.4 419.5 257.7 426.1 245.1 480.1 202.7 479.6 190.1 426 168.4 420.4 132 458.8 94.6 437.1 109.8 386.6 96.1 370.5 40.6 384.6 20.9 349.8 58.8 312.4 54 289.6 0 275.5 0.5 234.6 54 219.9 59.7 200.2 20.8 160.8 41.5 125 95.1 139.1 110.3 123.4 95.1 71.4 131.5 50.7 168.3 90.1 191 84 202.6 32H245L256.6 77.9 234 72 227.7 70.3 224.4 76 213.4 95.1 210.1 100.7 214.7 105.3 231.9 122.7 231.6 123.7 207.8 130.2 201.6 131.9 201.5 138.3 201.3 151.2C153.8 161.6 118 204 118 254.7 118 313 165.3 360.4 223.7 360.4 274.2 360.4 316.4 325 326.9 277.6L340.1 277.8 347 277.9 348.6 271.2 354.2 247.2 356.1 246.6 373.2 264.4 377.9 269.3 383.7 265.9 404.1 253.8 409.9 250.3 407.9 243.8 401.1 222.6z"}]}}),H.register({"brands/wikipedia-w":{width:640,height:512,paths:[{d:"M640 51.2L639.7 63.4C611.6 64.2 594.7 79.2 583.9 103.7 558.9 161.5 480.6 343.7 428.6 462.3H415L333.1 269.2C300.6 332.8 264.8 399.2 233.9 462.3 233.6 462.6 218.9 462.3 218.9 462 172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4 0.2 63.7 0.2 60.6-0.1 53.7-0.1 49.5H161.8V63.4C142.6 64.5 109 76.7 118.5 97.6 140.4 147.3 222.1 337.9 244.1 386.2 259.1 356.5 301.9 277 319.4 243.4 305.5 215.1 260.8 109.5 246.6 83.4 236.9 65.6 210.5 64 190.8 63.7V49.8L333.3 50.1V63.2C313.9 63.8 295.2 71 303.9 89.3 322.8 129.3 334.5 157.4 352 194 357.6 183.2 386.7 124.6 400.1 93.2 409 72.6 396.2 64.6 361.5 63.8 361.8 60.2 361.5 53.5 361.8 50.2 406.2 49.9 472.9 49.9 484.9 49.6V63.2C462.4 64 439.1 76 426.8 94.9L367.6 217.7C374 233.8 430.9 360.5 436.8 374.4L559.2 91.8C550.6 68.7 522.8 63.7 512 63.5V49.6L639.8 50.7 640 51.2z"}]}}),H.register({"brands/windows":{width:448,height:512,paths:[{d:"M0 93.7L183.6 68.4V245.8H0V93.7zM0 418.3L183.6 443.6V268.4H0V418.3zM203.8 446.3L448 480V268.4H203.8V446.3zM203.8 65.7V245.8H448V32L203.8 65.7z"}]}}),H.register({"brands/wordpress-simple":{width:512,height:512,paths:[{d:"M256 8C119.3 8 8 119.2 8 256 8 392.7 119.3 504 256 504S504 392.7 504 256C504 119.2 392.7 8 256 8zM33 256C33 223.7 39.9 193 52.3 165.3L158.7 456.7C84.3 420.5 33 344.2 33 256zM256 479C234.1 479 213 475.8 193 469.9L259.9 275.5 328.4 463.3C328.9 464.4 329.4 465.4 330 466.4 306.9 474.5 282 479 256 479zM286.7 151.5C300.1 150.8 312.2 149.4 312.2 149.4 324.2 148 322.8 130.3 310.8 131 310.8 131 274.7 133.8 251.4 133.8 229.5 133.8 192.7 131 192.7 131 180.7 130.3 179.3 148.7 191.3 149.4 191.3 149.4 202.7 150.8 214.7 151.5L249.4 246.7 200.6 393 119.4 151.5C132.8 150.8 144.9 149.4 144.9 149.4 156.9 148 155.5 130.3 143.5 131 143.5 131 107.4 133.8 84.1 133.8 79.9 133.8 75 133.7 69.7 133.5 109.6 73 178.1 33 256 33 314 33 366.9 55.2 406.6 91.5 405.6 91.4 404.7 91.3 403.7 91.3 381.8 91.3 366.3 110.4 366.3 130.9 366.3 149.3 376.9 164.8 388.2 183.2 396.7 198 406.6 217.1 406.6 244.7 406.6 263.8 399.3 285.9 389.6 316.8L367.4 391.1 286.7 151.5zM368.1 448.7L436.2 251.8C448.9 220 453.2 194.6 453.2 171.9 453.2 163.7 452.7 156.1 451.7 149 469.1 180.8 479 217.2 479 256 479 338.3 434.4 410.1 368.1 448.7z"}]}}),H.register({"brands/wordpress":{width:512,height:512,paths:[{d:"M61.7 169.4L163.2 447.4C92.2 413 43.3 340.2 43.3 256 43.3 225.1 49.9 195.9 61.7 169.4zM399.6 245.3C399.6 219 390.2 200.8 382.1 186.6 371.3 169.1 361.2 154.2 361.2 136.7 361.2 117.1 376 98.9 396.9 98.9 397.8 98.9 398.7 99 399.7 99.1 361.8 64.4 311.4 43.2 256 43.2 181.7 43.2 116.3 81.3 78.2 139.1 83.2 139.3 87.9 139.4 91.9 139.4 114.1 139.4 148.6 136.7 148.6 136.7 160.1 136 161.4 152.9 150 154.2 150 154.2 138.5 155.5 125.7 156.2L203.2 386.6 249.8 247 216.7 156.2C205.2 155.5 194.4 154.2 194.4 154.2 182.9 153.5 184.3 136 195.7 136.7 195.7 136.7 230.8 139.4 251.7 139.4 273.9 139.4 308.4 136.7 308.4 136.7 319.9 136 321.2 152.9 309.8 154.2 309.8 154.2 298.3 155.5 285.5 156.2L362.4 384.9 383.6 314C392.6 284.6 399.6 263.5 399.6 245.3zM259.7 274.6L195.9 460.1C215 465.7 235.1 468.8 256 468.8 280.8 468.8 304.5 464.5 326.6 456.7 326 455.8 325.5 454.8 325.1 453.8L259.7 274.6zM442.7 153.9C443.6 160.7 444.1 167.9 444.1 175.8 444.1 197.4 440.1 221.6 427.9 252L362.9 439.9C426.2 403 468.7 334.5 468.7 256 468.7 219 459.3 184.2 442.7 153.9zM504 256C504 392.8 392.7 504 256 504 119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8 392.7 8 504 119.2 504 256zM492.6 256C492.6 125.5 386.4 19.4 256 19.4 125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6C386.5 492.6 492.6 386.5 492.6 256z"}]}}),H.register({"brands/wpbeginner":{width:512,height:512,paths:[{d:"M462.8 322.4C519 386.7 467 480 370.9 480 331.3 480 292.1 462.3 270.8 430 263.9 430.3 248.1 430.3 241.2 430 219.8 462.4 180.6 480 141.1 480 45.6 480-7.3 387 49.2 322.4-29.9 190.5 80.5 32 256 32 431.6 32 541.9 190.6 462.8 322.4zM123.2 239.4H164.7V181.3H123.2V239.4zM340.3 325.5V301.6C279.8 322.6 208 310.8 152.7 267.7L153 292.6C204.1 338.9 284.7 350.4 340.3 325.5zM189.6 239.4H355.6V181.3H189.6V239.4z"}]}}),H.register({"brands/wpexplorer":{width:512,height:512,paths:[{d:"M512 256C512 397.2 397.3 512 256 512 114.8 512 0 397.3 0 256S114.7 0 256 0 512 114.7 512 256zM480 256C480 132.8 379.7 32 256 32 132.5 32 32 132.5 32 256S132.5 480 256 480 480 379.5 480 256zM160.9 124.6L247.8 161.7 210.7 248.6 123.8 211.5 160.9 124.6zM270.9 293.7L317.5 387.7H302.9L252.9 287.7 204 387.7H190L241.1 280.8 218.8 271.4 224.8 257.4 293.4 286.5 287.4 300.8 270.9 293.7zM259.1 177.4L327.7 206.8 298.3 275.1 230 246 259.1 177.4zM339.4 220.3L394 243.4 370.6 297.7 316.3 274.6 339.4 220.3z"}]}}),H.register({"brands/wpforms":{width:448,height:512,paths:[{d:"M448 75.2V436.9C448 461.2 429 480.1 404.8 480.1H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32H404.9C428.9 32 448 50.8 448 75.2zM410.7 436.8V75.2C410.7 72.2 408.1 69.4 404.9 69.4H395.6L285.3 144 224 94.1 162.8 144 52.5 69.3H43.2C40 69.3 37.4 72.1 37.4 75.1V436.8C37.4 439.8 40 442.6 43.2 442.6H404.9C408.1 442.7 410.7 439.9 410.7 436.8zM150.2 186V223H76.7V186H150.2zM150.2 260.4V297.7H76.7V260.4H150.2zM161.3 113.1L215.3 69.4H96.8L161.3 113.1zM371.3 186V223H175.3V186H371.3zM371.3 260.4V297.7H175.3V260.4H371.3zM286.7 113.1L351.2 69.4H232.8L286.7 113.1zM371.3 335V372.3H271.9V335H371.3z"}]}}),H.register({"brands/xbox":{width:512,height:512,paths:[{d:"M369.9 318.2C414.2 372.5 434.6 417 424.3 436.9 416.4 452 367.6 481.5 331.7 492.8 302.1 502.1 263.3 506.1 231.3 503 193.1 499.3 154.4 485.6 121.2 464 93.3 445.8 87 438.3 87 423.4 87 393.5 119.9 341.1 176.2 281.3 208.2 247.4 252.7 207.6 257.6 208.7 267 210.8 341.9 283.8 369.9 318.2zM188.6 143.8C158.9 116.9 130.5 89.9 102.2 80.4 87 75.3 85.9 75.6 73.5 88.5 44.3 118.9 20 168.2 13.2 210.9 7.8 245.1 7.1 254.7 9 271.4 14.6 321.9 26.3 356.8 49.5 392.3 59 406.9 61.6 409.6 58.8 402.2 54.6 391.2 58.5 364.7 68.3 338.2 82.6 299.2 122.2 225.3 188.6 143.8zM500.2 207.3C483.3 127.3 432.7 77 425.6 77 418.3 77 401.4 83.5 389.6 90.9 366.3 105.4 348.6 122.3 325.3 143.7 367.7 197 427.5 283.1 448.2 346 455 366.7 457.9 387.1 455.6 398.3 453.9 406.8 453.9 406.8 457 402.9 463.1 395.2 476.9 371.6 482.4 359.4 489.8 343.2 497.4 319.2 501 300.7 505.3 278.2 504.9 229.9 500.2 207.3zM141.3 43C189 40.5 251 77.5 255.6 78.4 256.3 78.5 266 74.2 277.2 68.7 341.1 37.6 371.2 42.9 384.6 43.5 320.7 4.2 231.9-6.5 150.7 31.8 127.3 42.9 126.7 43.7 141.3 43z"}]}}),H.register({"brands/xing-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM140.4 320.2H93.8C88.3 320.2 85.1 314.9 87.8 309.9L137.1 223.2C137.2 223.2 137.2 223.1 137.1 223L105.7 169C102.7 163.4 105.9 158.9 111.7 158.9H158.3C163.5 158.9 167.8 161.8 171.2 167.6L203.1 222.9C201.8 225.2 185.1 254.6 153 311.1 149.5 317.3 145.3 320.2 140.4 320.2zM360.1 106.1L257.3 286.8V287L322.8 406C325.6 411.1 322.9 416.1 316.8 416.1H270.2C264.7 416.1 260.5 413.2 257.3 407.4L191.3 287.1C193.6 283 228.1 222.2 294.7 104.8 298 99 302.1 96.1 307.2 96.1H354.1C359.8 96 362.9 100.8 360.1 106.1z"}]}}),H.register({"brands/xing":{width:384,height:512,paths:[{d:"M162.7 210C160.9 213.3 137.5 254.4 92.6 333.5 87.7 341.8 81.8 346 74.9 346H9.8C2.1 346-2.3 338.5 1.3 331.6L70.3 210.3C70.5 210.3 70.5 210.2 70.3 210L26.4 134.4C22.1 126.6 26.7 120.3 34.9 120.3H100C107.3 120.3 113.3 124.4 118 132.5L162.7 210zM382.6 46.1L238.6 299.1V299.4L330.2 466C334.1 473.1 330.4 480.1 321.7 480.1H256.5C248.9 480.1 242.9 476.1 238.5 467.9L146.1 299.4C149.4 293.6 197.6 208.6 290.9 44.2 295.5 36.1 301.3 32 308.4 32H374.1C382.1 32 386.4 38.7 382.6 46.1z"}]}}),H.register({"brands/y-combinator":{width:448,height:512,paths:[{d:"M448 32V480H0V32H448zM236 287.5L313.5 142H280.8L235 233C230.3 242.3 226 251.3 222.2 259.8L210 233 164.8 142H129.8L206.5 285.8V380.3H236V287.5z"}]}}),H.register({"brands/yahoo":{width:448,height:512,paths:[{d:"M252 292L256 512C243.3 509.8 232.5 508.1 223.7 508.1 215.3 508.1 204.5 509.8 191.4 512L195.4 292C140.4 197.2 85 95.2 21.4 0 33.3 3.1 44.4 3.9 54.6 3.9 63.6 3.9 75 3.1 88.7 0 129.6 72.2 170.8 138.7 223.7 225.5 261 163.9 314.8 81.4 358.6 0 369.7 2.9 380.6 3.9 391.5 3.9 403 3.9 414.7 2.9 426.5 0 392.1 47.9 294.9 216.9 252 292z"}]}}),H.register({"brands/yandex-international":{width:320,height:512,paths:[{d:"M129.5 512V345.9L18.5 48H74.3L156.1 277.7 250.2 0H301.5L180.8 347.8V512H129.5z"}]}}),H.register({"brands/yandex":{width:256,height:512,paths:[{d:"M153.1 315.8L65.7 512H2L98 302.2C52.9 279.3 22.8 237.8 22.8 161.1 22.7 53.7 90.8 0 171.7 0H254V512H198.9V315.8H153.1zM198.9 46.5H169.5C125.1 46.5 82.1 75.9 82.1 161.1 82.1 243.4 121.5 269.9 169.5 269.9H198.9V46.5z"}]}}),H.register({"brands/yelp":{width:384,height:512,paths:[{d:"M136.9 328C135.9 328.3 27.7 363.7 21.1 363.7 5.9 362.8 2.6 347.5 1.2 332.5-0.3 318.3-0.2 302.7 1.5 285.7 3.4 266.9 7 240.6 25.7 241.7 30.5 241.7 92.8 267.6 138.4 286.1 155.5 292.9 157 321.9 136.9 328zM194.8 214.1C196.6 252.3 169.3 262.6 147.6 228.4L41.3 60.4C39.8 53.8 41.6 48 46.6 43 62.2 26.5 146 3.2 168.1 8.9 175.6 10.8 180.2 15 181.9 21.5 183.2 29.8 193.4 188.9 194.8 214.1zM193.4 378.9C193.4 383.5 193.6 495.3 191.7 500.4 189.4 506.4 184.7 510.1 177.4 511.6 167.3 513.3 150.3 509.7 126.4 500.9 104.4 492.8 69.7 479.4 77.1 458.4 79.9 451.5 128.5 395.6 154.4 364.8 166.4 349.6 194.2 359.3 193.4 378.9zM373.6 261.1C368 264.8 262.8 289.3 255.5 291.7L255.8 291.1C237.7 295.8 220.4 272.6 232.5 256.5 236.2 252.8 298.4 164.1 305.3 159.5 310.5 155.9 316.6 155.7 323.6 158.9 342 167.7 378.7 222 381 243.5 380.9 246.4 382.2 255.2 373.6 261.1zM383.7 391.8C381 412.4 339.2 465.2 319.9 472.8 313 475.4 307 474.8 302.2 470.8 297.2 467.3 240.4 373.7 237.3 368.5 226.4 352.3 244.1 328.7 262.9 335.3 262.9 335.3 373.4 371 377.6 374.7 382.8 378.8 384.8 384.5 383.7 391.8z"}]}}),H.register({"brands/yoast":{width:448,height:512,paths:[{d:"M91.3 76H277.3L270.3 94.9H91.3C51.6 94.9 19.4 126.5 19.4 165.2V370.6C19.4 406 44.3 440.9 103.4 440.9V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zM320.4 20H386.9C243.1 398.1 241.2 418.9 202.2 459.3 181.4 480.9 152.9 491 123.9 492V440.9C173.1 433.2 188.5 391 188.5 365.6 188.5 345.5 189.1 353 106.4 142.4H167.8L218.2 299 320.4 20zM448 161.5V460H234C240.6 450.4 244.7 443.7 246.1 440.6H428.6V161.5C428.6 129 411.5 109.6 380.4 98.6L387.1 81C428.8 94.6 448 124.1 448 161.5z"}]}}),H.register({"brands/youtube-square":{width:448,height:512,paths:[{d:"M186.8 202.1L282 256.2 186.8 310.3V202.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM406 256.3S406 196.7 398.4 168.1C394.2 152.3 381.9 139.9 366.2 135.7 337.9 128 224 128 224 128S110.1 128 81.8 135.7C66.1 139.9 53.8 152.3 49.6 168.1 42 196.6 42 256.3 42 256.3S42 315.9 49.6 344.5C53.8 360.3 66.1 372.2 81.8 376.4 110.1 384 224 384 224 384S337.9 384 366.2 376.3C381.9 372.1 394.2 360.2 398.4 344.4 406 315.9 406 256.3 406 256.3z"}]}}),H.register({"brands/youtube":{width:576,height:512,paths:[{d:"M549.7 124.1C543.4 100.4 524.9 81.8 501.4 75.5 458.8 64 288 64 288 64S117.2 64 74.6 75.5C51.1 81.8 32.6 100.4 26.3 124.1 14.9 166.9 14.9 256.4 14.9 256.4S14.9 345.8 26.3 388.7C32.6 412.3 51.1 430.2 74.6 436.5 117.2 448 288 448 288 448S458.8 448 501.4 436.5C524.9 430.2 543.4 412.3 549.7 388.7 561.1 345.8 561.1 256.4 561.1 256.4S561.1 166.9 549.7 124.1zM232.1 337.6V175.2L374.9 256.4 232.1 337.6z"}]}}),H.register({"address-book":{width:448,height:512,paths:[{d:"M436 160C442.6 160 448 154.6 448 148V108C448 101.4 442.6 96 436 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H436C442.6 416 448 410.6 448 404V364C448 357.4 442.6 352 436 352H416V288H436C442.6 288 448 282.6 448 276V236C448 229.4 442.6 224 436 224H416V160H436zM208 128C252.2 128 288 163.8 288 208S252.2 288 208 288 128 252.2 128 208 163.8 128 208 128zM336 360C336 373.3 325.3 384 312 384H104C90.7 384 80 373.3 80 360V341.5C80 319.5 95 300.3 116.4 294.9L152 286C181.1 306.9 226.5 312.9 264 286L299.6 294.9C321 300.3 336 319.5 336 341.5V360z"}]}}),H.register({"address-card":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM176 144C214.7 144 246 175.3 246 214S214.7 284 176 284 106 252.7 106 214 137.3 144 176 144zM288 347C288 358.6 278.6 368 267 368H85C73.4 368 64 358.6 64 347V330.8C64 311.5 77.1 294.7 95.8 290L127 282.2C152.5 300.6 192.2 305.8 225 282.2L256.2 290C274.9 294.7 288 311.5 288 330.8V347zM448 308C448 314.6 442.6 320 436 320H332C325.4 320 320 314.6 320 308V300C320 293.4 325.4 288 332 288H436C442.6 288 448 293.4 448 300V308zM448 244C448 250.6 442.6 256 436 256H332C325.4 256 320 250.6 320 244V236C320 229.4 325.4 224 332 224H436C442.6 224 448 229.4 448 236V244zM448 180C448 186.6 442.6 192 436 192H332C325.4 192 320 186.6 320 180V172C320 165.4 325.4 160 332 160H436C442.6 160 448 165.4 448 172V180z"}]}}),H.register({adjust:{width:512,height:512,paths:[{d:"M8 256C8 393 119 504 256 504S504 393 504 256 393 8 256 8 8 119 8 256zM256 440V72C357.7 72 440 154.3 440 256 440 357.7 357.7 440 256 440z"}]}}),H.register({"align-center":{width:448,height:512,paths:[{d:"M352 44V84C352 92.8 344.8 100 336 100H112C103.2 100 96 92.8 96 84V44C96 35.2 103.2 28 112 28H336C344.8 28 352 35.2 352 44zM16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172V212C0 220.8 7.2 228 16 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM336 284H112C103.2 284 96 291.2 96 300V340C96 348.8 103.2 356 112 356H336C344.8 356 352 348.8 352 340V300C352 291.2 344.8 284 336 284z"}]}}),H.register({"align-justify":{width:448,height:512,paths:[{d:"M0 84V44C0 35.2 7.2 28 16 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H16C7.2 100 0 92.8 0 84zM16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172V212C0 220.8 7.2 228 16 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM16 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H16C7.2 284 0 291.2 0 300V340C0 348.8 7.2 356 16 356z"}]}}),H.register({"align-left":{width:448,height:512,paths:[{d:"M288 44V84C288 92.8 280.8 100 272 100H16C7.2 100 0 92.8 0 84V44C0 35.2 7.2 28 16 28H272C280.8 28 288 35.2 288 44zM0 172V212C0 220.8 7.2 228 16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM272 284H16C7.2 284 0 291.2 0 300V340C0 348.8 7.2 356 16 356H272C280.8 356 288 348.8 288 340V300C288 291.2 280.8 284 272 284z"}]}}),H.register({"align-right":{width:448,height:512,paths:[{d:"M160 84V44C160 35.2 167.2 28 176 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H176C167.2 100 160 92.8 160 84zM16 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H16C7.2 156 0 163.2 0 172V212C0 220.8 7.2 228 16 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM176 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H176C167.2 284 160 291.2 160 300V340C160 348.8 167.2 356 176 356z"}]}}),H.register({allergies:{width:448,height:512,paths:[{d:"M416 112C398.4 112 384 126.4 384 144V216C384 220.4 380.4 224 376 224H360C355.6 224 352 220.4 352 216V64C352 46.4 337.6 32 320 32S288 46.4 288 64V216C288 220.4 284.4 224 280 224H264C259.6 224 256 220.4 256 216V32C256 14.4 241.6 0 224 0S192 14.4 192 32V216C192 220.4 188.4 224 184 224H168C163.6 224 160 220.4 160 216V64C160 46.4 145.6 32 128 32S96 46.4 96 64V305L72.4 272.5C59.4 254.6 34.4 250.7 16.5 263.7S-5.3 301.7 7.7 319.6L133.3 492.3C142.3 504.7 156.8 512.1 172.1 512.1H369.7C392 512.1 411.3 496.8 416.4 475.1L442.9 362.4C446.1 348.7 447.8 334.1 448 320.1V144C448 126.4 433.6 112 416 112zM176 416C167.2 416 160 408.8 160 400S167.2 384 176 384 192 391.2 192 400 184.8 416 176 416zM176 320C167.2 320 160 312.8 160 304S167.2 288 176 288 192 295.2 192 304 184.8 320 176 320zM240 448C231.2 448 224 440.8 224 432S231.2 416 240 416 256 423.2 256 432 248.8 448 240 448zM240 352C231.2 352 224 344.8 224 336S231.2 320 240 320 256 327.2 256 336 248.8 352 240 352zM304 384C295.2 384 288 376.8 288 368S295.2 352 304 352 320 359.2 320 368 312.8 384 304 384zM336 448C327.2 448 320 440.8 320 432S327.2 416 336 416 352 423.2 352 432 344.8 448 336 448zM368 320C359.2 320 352 312.8 352 304S359.2 288 368 288 384 295.2 384 304 376.8 320 368 320z"}]}}),H.register({ambulance:{width:640,height:512,paths:[{d:"M624 352H608V243.9C608 231.2 602.9 219 593.9 210L494 110.1C485 101.1 472.8 96 460.1 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H64C64 469 107 512 160 512S256 469 256 416H384C384 469 427 512 480 512S576 469 576 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM160 464C133.5 464 112 442.5 112 416S133.5 368 160 368 208 389.5 208 416 186.5 464 160 464zM304 216C304 220.4 300.4 224 296 224H240V280C240 284.4 236.4 288 232 288H184C179.6 288 176 284.4 176 280V224H120C115.6 224 112 220.4 112 216V168C112 163.6 115.6 160 120 160H176V104C176 99.6 179.6 96 184 96H232C236.4 96 240 99.6 240 104V160H296C300.4 160 304 163.6 304 168V216zM480 464C453.5 464 432 442.5 432 416S453.5 368 480 368 528 389.5 528 416 506.5 464 480 464zM560 256H416V144H460.1L560 243.9V256z"}]}}),H.register({"american-sign-language-interpreting":{width:640,height:512,paths:[{d:"M290.5 189C270.3 178.9 246.4 177.8 225.8 185.1 268.4 185.1 297 205.6 311.4 235.7 320 253.6 306.2 273.8 287.8 273.8 306.2 273.8 320 293.9 311.4 311.9 296.7 342.7 265.3 362.7 231.1 362.7 230.5 362.7 136.6 354.1 136.6 354.1L70.2 387.5C60.8 392.1 50.4 387.8 46.3 379.7L1.9 290.7C-2.3 282.1 0.7 271.9 8.8 267.1L66.9 234.1 108 159.9C114.4 102.6 142.7 50.1 187.7 13.1 199.1 3.7 216.1 5.4 225.3 16.7 234.7 28.1 233 44.8 221.6 54.3 209.1 64.8 198 76.8 189.1 89.8 210.8 75.1 235.8 65.1 263.3 61.8 278 59.8 291.4 70.1 293 84.8 295 99.6 284.7 112.9 270 114.6 253.9 116.5 238.9 122.1 225.8 129.9 251.9 124.1 284.5 126.7 313.9 141 327.2 147.6 332.8 163.5 326.1 176.8 319.7 189.9 303.6 195.4 290.5 189zM263.3 258.5C257.2 246 245 238.2 231.1 238.2A35.5-35.5 0 0 1 195.5 273.8C195.5 295.2 213.3 309.4 231.1 309.4 245 309.4 257.2 301.6 263.3 289.1 267.8 279.6 276.9 274.1 286.7 273.8 276.9 273.5 267.8 268 263.3 258.5zM638.1 221.3C642.3 229.9 639.3 240.2 631.2 244.9L573.1 278 532 352.2C525.6 409.4 497.3 461.9 452.3 498.9 441.3 508 424.5 507 414.7 495.3 405.3 483.9 407 467.2 418.4 457.8 430.9 447.2 442 435.2 450.9 422.2 429.2 436.9 404.2 446.9 376.7 450.3 366.7 452.8 349.1 444.6 347 427.2 345 412.5 355.3 399.1 370 397.5 386.1 395.5 401.1 390 414.2 382.2 388.1 387.9 355.5 385.3 326.1 371.1 312.8 364.4 307.2 348.5 313.9 335.2 320.3 322.1 336.4 316.6 349.5 323 369.7 333.1 393.6 334.2 414.2 326.9 371.6 326.9 343 306.4 328.6 276.3 320 258.4 333.8 238.2 352.2 238.2 333.8 238.2 320 218.1 328.6 200.2 342.6 170.8 372.7 149.3 410.6 149.3L503.4 157.9 569.8 124.6C579.2 119.9 589.6 124.2 593.7 132.3L638.1 221.3zM408.9 202.7C395 202.7 382.8 210.4 376.7 222.9 372.2 232.4 363.1 237.9 353.3 238.2 363.1 238.5 372.2 244.1 376.7 253.5 382.8 266 395 273.8 408.9 273.8A35.5-35.5 0 0 1 444.5 238.2C444.5 216.8 426.7 202.7 408.9 202.7z"}]}}),H.register({anchor:{width:576,height:512,paths:[{d:"M13 352H45.4C67.2 454.7 181.9 512 288 512 394.2 512 508.9 454.6 530.6 352H563C573.7 352 579.1 339.1 571.5 331.5L504.5 264.5C499.8 259.8 492.2 259.8 487.5 264.5L420.5 331.5C412.9 339.1 418.3 352 429 352H464.1C443.8 406.3 379.2 438.6 320 446V256H372C378.6 256 384 250.6 384 244V204C384 197.4 378.6 192 372 192H320V186.5C357.3 173.4 384 137.8 384 96 384 43.8 341.6 0.7 289.4 0 235.7-0.7 192 42.5 192 96 192 137.8 218.7 173.4 256 186.5V192H204C197.4 192 192 197.4 192 204V244C192 250.6 197.4 256 204 256H256V446C197.1 438.6 132.2 406.3 111.9 352H147C157.7 352 163.1 339.1 155.5 331.5L88.5 264.5C83.8 259.8 76.2 259.8 71.5 264.5L4.5 331.5C-3.1 339.1 2.3 352 13 352zM288 64C305.6 64 320 78.4 320 96S305.6 128 288 128 256 113.6 256 96 270.4 64 288 64z"}]}}),H.register({"angle-double-down":{width:320,height:512,paths:[{d:"M143 256.3L7 120.3C-2.4 110.9-2.4 95.7 7 86.4L29.6 63.8C39 54.4 54.2 54.4 63.5 63.8L159.9 160.2 256.3 63.8C265.7 54.4 280.9 54.4 290.2 63.8L313 86.3C322.4 95.7 322.4 110.9 313 120.2L177 256.2C167.6 265.7 152.4 265.7 143 256.3zM177 448.3L313 312.3C322.4 302.9 322.4 287.7 313 278.4L290.4 255.8C281 246.4 265.8 246.4 256.5 255.8L160 352.1 63.6 255.7C54.2 246.3 39 246.3 29.7 255.7L7 278.3C-2.4 287.7-2.4 302.9 7 312.2L143 448.2C152.4 457.7 167.6 457.7 177 448.3z"}]}}),H.register({"angle-double-left":{width:448,height:512,paths:[{d:"M223.7 239L359.7 103C369.1 93.6 384.3 93.6 393.6 103L416.2 125.6C425.6 135 425.6 150.2 416.2 159.5L319.9 256 416.3 352.4C425.7 361.8 425.7 377 416.3 386.3L393.7 409C384.3 418.4 369.1 418.4 359.8 409L223.8 273C214.3 263.6 214.3 248.4 223.7 239zM31.7 273L167.7 409C177.1 418.4 192.3 418.4 201.6 409L224.2 386.4C233.6 377 233.6 361.8 224.2 352.5L127.9 256 224.3 159.6C233.7 150.2 233.7 135 224.3 125.7L201.7 103C192.3 93.6 177.1 93.6 167.8 103L31.8 239C22.3 248.4 22.3 263.6 31.7 273z"}]}}),H.register({"angle-double-right":{width:448,height:512,paths:[{d:"M224.3 273L88.3 409C78.9 418.4 63.7 418.4 54.4 409L31.8 386.4C22.4 377 22.4 361.8 31.8 352.5L128.2 256.1 31.8 159.7C22.4 150.3 22.4 135.1 31.8 125.8L54.3 103C63.7 93.6 78.9 93.6 88.2 103L224.2 239C233.7 248.4 233.7 263.6 224.3 273zM416.3 239L280.3 103C270.9 93.6 255.7 93.6 246.4 103L223.8 125.6C214.4 135 214.4 150.2 223.8 159.5L320.2 255.9 223.8 352.3C214.4 361.7 214.4 376.9 223.8 386.2L246.4 408.8C255.8 418.2 271 418.2 280.3 408.8L416.3 272.8C425.7 263.6 425.7 248.4 416.3 239z"}]}}),H.register({"angle-double-up":{width:320,height:512,paths:[{d:"M177 255.7L313 391.7C322.4 401.1 322.4 416.3 313 425.6L290.4 448.2C281 457.6 265.8 457.6 256.5 448.2L160 351.9 63.6 448.3C54.2 457.7 39 457.7 29.7 448.3L7 425.7C-2.4 416.3-2.4 401.1 7 391.8L143 255.8C152.4 246.3 167.6 246.3 177 255.7zM143 63.7L7 199.7C-2.4 209.1-2.4 224.3 7 233.6L29.6 256.2C39 265.6 54.2 265.6 63.5 256.2L159.9 159.8 256.3 256.2C265.7 265.6 280.9 265.6 290.2 256.2L312.8 233.6C322.2 224.2 322.2 209 312.8 199.7L176.8 63.7C167.6 54.3 152.4 54.3 143 63.7z"}]}}),H.register({"angle-down":{width:320,height:512,paths:[{d:"M143 352.3L7 216.3C-2.4 206.9-2.4 191.7 7 182.4L29.6 159.8C39 150.4 54.2 150.4 63.5 159.8L159.9 256.2 256.3 159.8C265.7 150.4 280.9 150.4 290.2 159.8L312.8 182.4C322.2 191.8 322.2 207 312.8 216.3L176.8 352.3C167.6 361.7 152.4 361.7 143 352.3z"}]}}),H.register({"angle-left":{width:256,height:512,paths:[{d:"M31.7 239L167.7 103C177.1 93.6 192.3 93.6 201.6 103L224.2 125.6C233.6 135 233.6 150.2 224.2 159.5L127.9 256 224.3 352.4C233.7 361.8 233.7 377 224.3 386.3L201.7 409C192.3 418.4 177.1 418.4 167.8 409L31.8 273C22.3 263.6 22.3 248.4 31.7 239z"}]}}),H.register({"angle-right":{width:256,height:512,paths:[{d:"M224.3 273L88.3 409C78.9 418.4 63.7 418.4 54.4 409L31.8 386.4C22.4 377 22.4 361.8 31.8 352.5L128.2 256.1 31.8 159.7C22.4 150.3 22.4 135.1 31.8 125.8L54.3 103C63.7 93.6 78.9 93.6 88.2 103L224.2 239C233.7 248.4 233.7 263.6 224.3 273z"}]}}),H.register({"angle-up":{width:320,height:512,paths:[{d:"M177 159.7L313 295.7C322.4 305.1 322.4 320.3 313 329.6L290.4 352.2C281 361.6 265.8 361.6 256.5 352.2L160 255.9 63.6 352.3C54.2 361.7 39 361.7 29.7 352.3L7 329.7C-2.4 320.3-2.4 305.1 7 295.8L143 159.8C152.4 150.3 167.6 150.3 177 159.7z"}]}}),H.register({archive:{width:512,height:512,paths:[{d:"M32 448C32 465.7 46.3 480 64 480H448C465.7 480 480 465.7 480 448V160H32V448zM192 236C192 229.4 197.4 224 204 224H308C314.6 224 320 229.4 320 236V244C320 250.6 314.6 256 308 256H204C197.4 256 192 250.6 192 244V236zM480 32H32C14.3 32 0 46.3 0 64V112C0 120.8 7.2 128 16 128H496C504.8 128 512 120.8 512 112V64C512 46.3 497.7 32 480 32z"}]}}),H.register({"arrow-alt-circle-down":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM212 140V256H141.1C130.4 256 125 269 132.6 276.5L247.5 390.8C252.2 395.5 259.7 395.5 264.4 390.8L379.3 276.5C386.9 268.9 381.5 256 370.8 256H300V140C300 133.4 294.6 128 288 128H224C217.4 128 212 133.4 212 140z"}]}}),H.register({"arrow-alt-circle-left":{width:512,height:512,paths:[{d:"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM372 212H256V141.1C256 130.4 243 125 235.5 132.6L121.2 247.5C116.5 252.2 116.5 259.7 121.2 264.4L235.5 379.3C243.1 386.9 256 381.5 256 370.8V300H372C378.6 300 384 294.6 384 288V224C384 217.4 378.6 212 372 212z"}]}}),H.register({"arrow-alt-circle-right":{width:512,height:512,paths:[{d:"M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM140 300H256V370.9C256 381.6 269 387 276.5 379.4L390.8 264.5C395.5 259.8 395.5 252.3 390.8 247.6L276.5 132.6C268.9 125 256 130.4 256 141.1V212H140C133.4 212 128 217.4 128 224V288C128 294.6 133.4 300 140 300z"}]}}),H.register({"arrow-alt-circle-up":{width:512,height:512,paths:[{d:"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM300 372V256H370.9C381.6 256 387 243 379.4 235.5L264.5 121.2C259.8 116.5 252.3 116.5 247.6 121.2L132.6 235.5C125 243.1 130.4 256 141.1 256H212V372C212 378.6 217.4 384 224 384H288C294.6 384 300 378.6 300 372z"}]}}),H.register({"arrow-circle-down":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM360.4 227.1L288 302.6V120C288 106.7 277.3 96 264 96H248C234.7 96 224 106.7 224 120V302.6L151.6 227.1C142.3 217.4 126.8 217.2 117.3 226.7L106.4 237.7C97 247.1 97 262.3 106.4 271.6L239 404.3C248.4 413.7 263.6 413.7 272.9 404.3L405.6 271.6C415 262.2 415 247 405.6 237.7L394.7 226.7C385.2 217.2 369.7 217.4 360.4 227.1z"}]}}),H.register({"arrow-circle-left":{width:512,height:512,paths:[{d:"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM284.9 360.4L209.4 288H392C405.3 288 416 277.3 416 264V248C416 234.7 405.3 224 392 224H209.4L284.9 151.6C294.6 142.3 294.8 126.8 285.3 117.3L274.3 106.4C264.9 97 249.7 97 240.4 106.4L107.7 239C98.3 248.4 98.3 263.6 107.7 272.9L240.4 405.6C249.8 415 265 415 274.3 405.6L285.3 394.7C294.8 385.2 294.6 369.7 284.9 360.4z"}]}}),H.register({"arrow-circle-right":{width:512,height:512,paths:[{d:"M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM227.1 151.6L302.6 224H120C106.7 224 96 234.7 96 248V264C96 277.3 106.7 288 120 288H302.6L227.1 360.4C217.4 369.7 217.2 385.2 226.7 394.7L237.7 405.6C247.1 415 262.3 415 271.6 405.6L404.3 273C413.7 263.6 413.7 248.4 404.3 239.1L271.6 106.3C262.2 96.9 247 96.9 237.7 106.3L226.7 117.2C217.2 126.8 217.4 142.3 227.1 151.6z"}]}}),H.register({"arrow-circle-up":{width:512,height:512,paths:[{d:"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM151.6 284.9L224 209.4V392C224 405.3 234.7 416 248 416H264C277.3 416 288 405.3 288 392V209.4L360.4 284.9C369.7 294.6 385.2 294.8 394.7 285.3L405.6 274.3C415 264.9 415 249.7 405.6 240.4L273 107.7C263.6 98.3 248.4 98.3 239.1 107.7L106.3 240.4C96.9 249.8 96.9 265 106.3 274.3L117.2 285.3C126.8 294.8 142.3 294.6 151.6 284.9z"}]}}),H.register({"arrow-down":{width:448,height:512,paths:[{d:"M413.1 222.5L435.3 244.7C444.7 254.1 444.7 269.3 435.3 278.6L241 473C231.6 482.4 216.4 482.4 207.1 473L12.7 278.6C3.3 269.2 3.3 254 12.7 244.7L34.9 222.5C44.4 213 59.9 213.2 69.2 222.9L184 343.4V56C184 42.7 194.7 32 208 32H240C253.3 32 264 42.7 264 56V343.4L378.8 222.9C388.1 213.1 403.6 212.9 413.1 222.5z"}]}}),H.register({"arrow-left":{width:448,height:512,paths:[{d:"M257.5 445.1L235.3 467.3C225.9 476.7 210.7 476.7 201.4 467.3L7 273C-2.4 263.6-2.4 248.4 7 239.1L201.4 44.7C210.8 35.3 226 35.3 235.3 44.7L257.5 66.9C267 76.4 266.8 91.9 257.1 101.2L136.6 216H424C437.3 216 448 226.7 448 240V272C448 285.3 437.3 296 424 296H136.6L257.1 410.8C266.9 420.1 267.1 435.6 257.5 445.1z"}]}}),H.register({"arrow-right":{width:448,height:512,paths:[{d:"M190.5 66.9L212.7 44.7C222.1 35.3 237.3 35.3 246.6 44.7L441 239C450.4 248.4 450.4 263.6 441 272.9L246.6 467.3C237.2 476.7 222 476.7 212.7 467.3L190.5 445.1C181 435.6 181.2 420.1 190.9 410.8L311.4 296H24C10.7 296 0 285.3 0 272V240C0 226.7 10.7 216 24 216H311.4L190.9 101.2C181.1 91.9 180.9 76.4 190.5 66.9z"}]}}),H.register({"arrow-up":{width:448,height:512,paths:[{d:"M34.9 289.5L12.7 267.3C3.3 257.9 3.3 242.7 12.7 233.4L207 39C216.4 29.6 231.6 29.6 240.9 39L435.2 233.3C444.6 242.7 444.6 257.9 435.2 267.2L413 289.4C403.5 298.9 388 298.7 378.7 289L264 168.6V456C264 469.3 253.3 480 240 480H208C194.7 480 184 469.3 184 456V168.6L69.2 289.1C59.9 298.9 44.4 299.1 34.9 289.5z"}]}}),H.register({"arrows-alt-h":{width:512,height:512,paths:[{d:"M377.9 169.9V216H134.1V169.9C134.1 148.6 108.2 137.9 93.1 153L7 239C-2.3 248.4-2.3 263.6 7 273L93.1 359C108.2 374.1 134.1 363.4 134.1 342.1V296H377.9V342.1C377.9 363.4 403.8 374.1 418.9 359L505 273C514.3 263.6 514.3 248.4 505 239L418.9 153C403.8 137.9 377.9 148.6 377.9 169.9z"}]}}),H.register({"arrows-alt-v":{width:256,height:512,paths:[{d:"M214.1 377.9H168V134.1H214.1C235.4 134.1 246.1 108.2 231 93.1L145 7C135.6-2.3 120.4-2.3 111 7L25 93.1C9.9 108.2 20.6 134.1 41.9 134.1H88V377.9H41.9C20.6 377.9 9.9 403.8 25 418.9L111 505C120.4 514.3 135.6 514.3 145 505L231 418.9C246.1 403.8 235.4 377.9 214.1 377.9z"}]}}),H.register({"arrows-alt":{width:512,height:512,paths:[{d:"M352.2 425.8L273 505C263.6 514.3 248.4 514.3 239.1 505L159.9 425.8C144.7 410.7 155.5 384.8 176.8 384.8H228L228 284H127.2V335.2C127.2 356.5 101.3 367.3 86.2 352.1L7 272.9C-2.3 263.6-2.3 248.4 7 239L86.2 159.8C101.3 144.7 127.2 155.4 127.2 176.8V228H228V127.2H176.8C155.4 127.2 144.7 101.3 159.8 86.2L239 7C248.4-2.3 263.6-2.3 272.9 7L352.1 86.2C367.3 101.3 356.5 127.2 335.2 127.2H284V228H384.8V176.8C384.8 155.5 410.7 144.7 425.8 159.9L505 239.1C514.3 248.4 514.3 263.6 505 273L425.8 352.2C410.7 367.3 384.8 356.6 384.8 335.2V284H284V384.8H335.2C356.6 384.8 367.3 410.7 352.2 425.8z"}]}}),H.register({"assistive-listening-systems":{width:512,height:512,paths:[{d:"M216 260C216 275.5 203.5 288 188 288S160 275.5 160 260C160 215.9 195.9 180 240 180S320 215.9 320 260C320 275.5 307.5 288 292 288S264 275.5 264 260C264 246.8 253.2 236 240 236S216 246.8 216 260zM240 84C143 84 64 163 64 260 64 275.5 76.5 288 92 288S120 275.5 120 260C120 193.8 173.8 140 240 140S360 193.8 360 260C360 335.2 289 330.3 288 403.6L288 404C288 432.7 264.7 456 236 456 220.5 456 208 468.5 208 484S220.5 512 236 512C295.5 512 343.9 463.7 344 404.2 344.6 369.8 416 356 416 260 416 163 337 84 240 84zM160 320C142.3 320 128 334.3 128 352S142.3 384 160 384 192 369.7 192 352 177.7 320 160 320zM32 448C14.3 448 0 462.3 0 480S14.3 512 32 512 64 497.7 64 480 49.7 448 32 448zM512 260C512 258.5 512 257 512 255.5 510.1 140.5 436.2 38.5 328 1.5 313.4-3.5 297.4 4.3 292.4 19 287.4 33.6 295.3 49.5 309.9 54.5 395.8 83.9 454.5 165 456 256.5L456 256.6C456 257.8 456 258.9 456 260 456 275.5 468.5 288 484 288S512 275.5 512 260zM153 439L73 359 39 393 119 473 153 439z"}]}}),H.register({asterisk:{width:512,height:512,paths:[{d:"M478.2 334.1L336 256 478.2 177.9C490 171.4 494.2 156.5 487.4 144.9L468 111.1C461.2 99.5 446.2 95.6 434.7 102.6L296 186.7 299.5 24.5C299.8 11.1 288.9 0 275.5 0H236.5C223.1 0 212.2 11.1 212.5 24.5L216 186.7 77.3 102.6C65.8 95.6 50.8 99.5 44 111.1L24.6 144.9C17.8 156.5 22 171.4 33.8 177.9L176 256 33.8 334.1C22 340.6 17.8 355.5 24.6 367.1L44 400.9C50.8 412.5 65.8 416.4 77.3 409.4L216 325.3 212.5 487.5C212.2 500.9 223.1 512 236.5 512H275.5C288.9 512 299.8 500.9 299.5 487.5L296 325.3 434.7 409.4C446.2 416.4 461.2 412.5 468 400.9L487.4 367.1C494.2 355.5 490 340.6 478.2 334.1z"}]}}),H.register({at:{width:512,height:512,paths:[{d:"M256 8C118.9 8 8 118.9 8 256 8 393.1 118.9 504 256 504 304.2 504 351.3 489.9 391.4 463.8 403.4 456 406 439.5 397 428.4L386.8 416C379.1 406.6 365.6 404.3 355.4 410.8 325.9 429.8 291.3 440 256 440 154.5 440 72 357.5 72 256S154.5 72 256 72C356.1 72 440 129.6 440 232 440 270.8 418.9 311.7 381.8 315.7 364.5 315.2 364.9 302.8 368.4 285.7L391.8 164.6C394.7 149.8 383.3 136 368.2 136H323.2A13.5-13.5 0 0 1 309.8 148L309.8 148.1C295.1 130.2 269.4 126.3 249.8 126.3 175.3 126.3 112 188.5 112 277.8 112 343.1 148.8 383.6 208 383.6 235 383.6 265.4 368 283 345.3 292.5 379.4 323.6 379.4 353.7 379.4 462.6 379.4 504 307.8 504 232 504 95.7 394 8 256 8zM234.3 312.4C212.1 312.4 198.3 296.8 198.3 271.7 198.3 226.7 229 198.9 256.9 198.9 279.2 198.9 292.5 214.2 292.5 239.7 292.5 284.8 258.6 312.4 234.3 312.4z"}]}}),H.register({"audio-description":{width:512,height:512,paths:[{d:"M162.9 238.7L171.7 269.4H146.1L155.2 238.7C156.5 234.3 157.8 228.7 159.1 223.5 160.3 228.7 161.6 234.3 162.9 238.7zM329.4 206.6H314.9V305.4H329.4C359.2 305.4 375.6 287.7 375.6 255.6 375.6 223.4 358.1 206.6 329.4 206.6zM512 112V400C512 426.5 490.5 448 464 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H464C490.5 64 512 85.5 512 112zM245.5 336.1L188.4 168.1A12-12 0 0 1 177 160H141.1A12-12 0 0 1 129.7 168.1L72.6 336.1C70 343.9 75.8 352 84 352H113.1A12-12 0 0 1 124.7 343.3L133.3 313.4H184.6L193.4 343.4A12-12 0 0 1 204.9 352H234.1C242.3 352 248.1 343.9 245.5 336.1zM430.2 255.6C430.2 196.6 392.2 160 331.2 160H273.8C267.2 160 261.8 165.4 261.8 172V340C261.8 346.6 267.2 352 273.8 352H331.2C392.2 352 430.2 315.1 430.2 255.6z"}]}}),H.register({backward:{width:512,height:512,paths:[{d:"M11.5 280.6L203.5 440.6C224.1 457.8 256 443.4 256 416V96C256 68.6 224.1 54.2 203.5 71.4L11.5 231.4C-3.8 244.2-3.8 267.8 11.5 280.6zM267.5 280.6L459.5 440.6C480.1 457.8 512 443.4 512 416V96C512 68.6 480.1 54.2 459.5 71.4L267.5 231.4C252.2 244.2 252.2 267.8 267.5 280.6z"}]}}),H.register({"balance-scale":{width:640,height:512,paths:[{d:"M352 448H520C533.3 448 544 458.7 544 472V488C544 501.3 533.3 512 520 512H120C106.7 512 96 501.3 96 488V472C96 458.7 106.7 448 120 448H288V153.3C264.5 143 246.8 121.8 241.6 96H120C106.7 96 96 85.3 96 72V56C96 42.7 106.7 32 120 32H256C270.6 12.6 293.8 0 320 0S369.4 12.6 384 32H520C533.3 32 544 42.7 544 56V72C544 85.3 533.3 96 520 96H398.4C393.2 121.8 375.5 143 352 153.3V448zM640 336C640 319.8 641.3 327.3 554.9 154.5 537.3 119.2 486.7 119.1 469.1 154.5 381.9 328.8 384 320.3 384 336H384C384 380.2 441.3 416 512 416S640 380.2 640 336H640zM512 176L584 320H440L512 176zM256 336C256 319.8 257.3 327.3 170.9 154.5 153.3 119.2 102.7 119.1 85.1 154.5-2.1 328.8 0 320.3 0 336H0C0 380.2 57.3 416 128 416S256 380.2 256 336H256zM128 176L200 320H56L128 176z"}]}}),H.register({ban:{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM386.1 125.9C451.6 191.3 456.1 291.4 406.8 361.5L150.5 105.2C220.7 55.9 320.7 60.5 386.1 125.9zM125.9 386.1C60.4 320.7 55.9 220.6 105.2 150.5L361.5 406.8C291.3 456.1 191.3 451.5 125.9 386.1z"}]}}),H.register({"band-aid":{width:640,height:512,paths:[{d:"M0 160V352C0 387.3 28.7 416 64 416H160V96H64C28.7 96 0 124.7 0 160zM576 96H480V416H576C611.3 416 640 387.3 640 352V160C640 124.7 611.3 96 576 96zM192 416H448V96H192V416zM368 184C381.3 184 392 194.7 392 208S381.3 232 368 232 344 221.3 344 208 354.7 184 368 184zM368 280C381.3 280 392 290.7 392 304S381.3 328 368 328 344 317.3 344 304 354.7 280 368 280zM272 184C285.3 184 296 194.7 296 208S285.3 232 272 232 248 221.3 248 208 258.7 184 272 184zM272 280C285.3 280 296 290.7 296 304S285.3 328 272 328 248 317.3 248 304 258.7 280 272 280z"}]}}),H.register({barcode:{width:512,height:512,paths:[{d:"M0 448V64H18V448H0zM26.9 447.7V64H36V447.7H26.9zM54 447.7V64H62.9V447.7H54zM98.9 447.7V64H107.7V447.7H98.9zM134.9 447.7V64H152.6V447.7H134.9zM179.7 447.7V64H188.6V447.7H179.7zM197.7 447.7V64H206.6V447.7H197.7zM215.7 447.7V64H224.6V447.7H215.7zM251.4 447.7V64H269.4V447.7H251.4zM296.3 447.7V64H314.3V447.7H296.3zM332.3 447.7V64H350.3V447.7H332.3zM368.3 447.7V64H386.3V447.7H368.3zM395.1 447.7V64H413.1V447.7H395.1zM440.3 447.7V64H467.1V447.7H440.3zM476 447.7V64H485.1V447.7H476zM494 448V64H512V448H494z"}]}}),H.register({bars:{width:448,height:512,paths:[{d:"M16 132H432C440.8 132 448 124.8 448 116V76C448 67.2 440.8 60 432 60H16C7.2 60 0 67.2 0 76V116C0 124.8 7.2 132 16 132zM16 292H432C440.8 292 448 284.8 448 276V236C448 227.2 440.8 220 432 220H16C7.2 220 0 227.2 0 236V276C0 284.8 7.2 292 16 292zM16 452H432C440.8 452 448 444.8 448 436V396C448 387.2 440.8 380 432 380H16C7.2 380 0 387.2 0 396V436C0 444.8 7.2 452 16 452z"}]}}),H.register({"baseball-ball":{width:496,height:512,paths:[{d:"M368.5 363.9L397.3 350C408.4 372.9 423.3 393.2 441.4 410.9 475.4 368.4 495.9 314.6 495.9 256 495.9 197.5 475.5 143.8 441.7 101.4 423.9 118.7 409.1 138.5 398.1 160.9L369.4 146.8C382.2 120.8 399.4 97.8 420.2 77.8 375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7 96.6 97.6 113.8 120.6 126.6 146.5L97.9 160.6C86.9 138.3 72.2 118.5 54.4 101.2 20.4 143.7 0 197.4 0 256 0 314.6 20.4 368.3 54.4 410.7 72.6 393 87.6 372.7 98.7 349.7L127.5 363.6C114.6 390.3 97.2 413.9 76 434.3 120.5 477.4 181.1 504 248 504 314.8 504 375.3 477.5 419.9 434.5 398.8 414.1 381.4 390.6 368.5 363.9zM140.2 331.9L109.7 322.1C124.6 275.7 122.4 228.3 109.1 188.1L139.5 178.1C154.5 223.7 157.5 278 140.2 331.9zM356.5 178.5L386.9 188.5C373.7 228.6 371.4 276 386.3 322.5L355.8 332.3C338.5 278.3 341.5 224 356.5 178.5z"}]}}),H.register({"basketball-ball":{width:496,height:512,paths:[{d:"M212.3 10.3C168.5 16.6 126.1 34.4 90.1 64.1L167.5 141.5C195.3 105.7 210.8 60.3 212.3 10.3zM248 222L405.9 64.1C363.5 29.1 312.3 10.6 260.4 8 259.2 71.9 238.9 130.3 201.7 175.7L248 222zM56.1 98.1C26.4 134.1 8.6 176.5 2.3 220.3 52.3 218.8 97.8 203.3 133.5 175.5L56.1 98.1zM328.3 302.3C373.6 265.2 432 244.9 496 243.6 493.4 191.7 474.9 140.5 439.9 98.1L282 256 328.3 302.3zM248 290L90.1 447.9C132.5 482.8 183.7 501.4 235.6 504 236.9 440 257.2 381.6 294.3 336.3L248 290zM439.9 413.9C469.6 377.9 487.4 335.5 493.7 291.7 443.6 293.3 398.2 308.8 362.5 336.5L439.9 413.9zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4 2.6 320.3 21.1 371.5 56.1 413.9L214 256 167.7 209.7zM283.7 501.7C327.5 495.4 369.9 477.6 405.9 447.9L328.5 370.5C300.8 406.2 285.3 451.7 283.7 501.7z"}]}}),H.register({bath:{width:512,height:512,paths:[{d:"M488 256H80V112C80 94.4 94.4 80 112 80 123.4 80 133.3 85.9 139 94.9 122.5 120.1 124.3 154.5 145.9 177.9 141.7 182.6 141.8 189.8 146.3 194.3L157.7 205.7C162.3 210.3 169.9 210.3 174.6 205.7L269.7 110.6C274.3 105.9 274.3 98.3 269.7 93.7L258.3 82.3C253.8 77.8 246.6 77.7 241.9 81.9 224 65.4 199.6 60.4 177.7 66.5 163.3 45.7 139.2 32 112 32 67.9 32 32 67.9 32 112V256H24C10.7 256 0 266.7 0 280V296C0 309.3 10.7 320 24 320H32V352C32 380.4 44.4 406 64 423.5V456C64 469.3 74.7 480 88 480H104C117.3 480 128 469.3 128 456V448H384V456C384 469.3 394.7 480 408 480H424C437.3 480 448 469.3 448 456V423.5C467.6 406 480 380.4 480 352V320H488C501.3 320 512 309.3 512 296V280C512 266.7 501.3 256 488 256z"}]}}),H.register({"battery-empty":{width:640,height:512,paths:[{d:"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96z"}]}}),H.register({"battery-full":{width:640,height:512,paths:[{d:"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96zM512 192H96V320H512V192z"}]}}),H.register({"battery-half":{width:640,height:512,paths:[{d:"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96zM320 192H96V320H320V192z"}]}}),H.register({"battery-quarter":{width:640,height:512,paths:[{d:"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96zM224 192H96V320H224V192z"}]}}),H.register({"battery-three-quarters":{width:640,height:512,paths:[{d:"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96zM416 192H96V320H416V192z"}]}}),H.register({bed:{width:576,height:512,paths:[{d:"M552 288C565.3 288 576 298.7 576 312V448H480V384H96V448H0V88C0 74.7 10.7 64 24 64H72C85.3 64 96 74.7 96 88V288H552zM192 96C147.8 96 112 131.8 112 176S147.8 256 192 256 272 220.2 272 176 236.2 96 192 96zM576 224C576 171 533 128 480 128H312C298.7 128 288 138.7 288 152V256H576V224z"}]}}),H.register({beer:{width:448,height:512,paths:[{d:"M368 96H320V56C320 42.7 309.3 32 296 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H296C309.3 480 320 469.3 320 456V413.9L400.6 377.9C429.4 365.1 448 336.4 448 304.9V176C448 131.9 412.1 96 368 96zM384 304.9A16-16 0 0 0 374.5 319.5L320 343.8V160H368C376.8 160 384 167.2 384 176V304.9zM208 384C199.2 384 192 376.8 192 368V144C192 135.2 199.2 128 208 128S224 135.2 224 144V368C224 376.8 216.8 384 208 384zM112 384C103.2 384 96 376.8 96 368V144C96 135.2 103.2 128 112 128S128 135.2 128 144V368C128 376.8 120.8 384 112 384z"}]}}),H.register({"bell-slash":{width:576,height:512,paths:[{d:"M78.1 366.1C48 396.2 69.3 448 112 448H224C224 483.3 252.7 512 288 512 323.3 512 352 483.3 352 448H384.7L127.8 221.4C125.7 318.5 99.4 344.8 78.1 366.1zM264 448C264 461.2 274.8 472 288 472A8-8 0 0 0 288 488C265.9 488 248 470.1 248 448H264zM569.9 491.7L559.1 503.8C550.2 513.8 534.8 514.8 524.7 506L8.3 54.4C-1.8 45.6-2.8 30.3 6.1 20.3L16.9 8.2C25.8-1.8 41.2-2.8 51.3 6L165.1 105.6C189.1 76.8 223.1 56.6 261.7 50.2A31.9-31.9 0 0 0 256 32C256 14.3 270.3 0 288 0S320 14.3 320 32C320 38.8 317.9 45 314.3 50.2 390.2 62.7 448 128.6 448 208 448 316.1 475.6 343.8 497.9 366.1 510 378.2 513.8 393.8 511.2 408.2L567.7 457.6C577.8 466.4 578.8 481.7 569.9 491.7z"}]}}),H.register({bell:{width:448,height:512,paths:[{d:"M433.9 366.1C411.6 343.8 384 316.1 384 208 384 128.6 326.2 62.7 250.3 50.2A31.8-31.8 0 0 1 256 32C256 14.3 241.7 0 224 0S192 14.3 192 32C192 38.8 194.1 45 197.7 50.2 121.8 62.7 64 128.6 64 208 64 316.1 36.4 343.8 14.1 366.1-16 396.2 5.3 448 48 448H160C160 483.3 188.7 512 224 512S288 483.3 288 448H399.9C442.6 448 464.1 396.3 433.9 366.1zM224 472A8-8 0 0 0 224 488C201.9 488 184 470.1 184 448H200C200 461.2 210.8 472 224 472z"}]}}),H.register({bicycle:{width:640,height:512,paths:[{d:"M512.5 192C496.1 191.9 480.5 195 466.1 200.5L388.4 75.3A24-24 0 0 1 368 64H304C295.2 64 288 71.2 288 80V96C288 104.8 295.2 112 304 112H354.6L369.5 136H256V120C256 111.2 248.8 104 240 104H152.5C139.1 104 127.8 115 128 128.4 128.2 141.5 138.9 152 152 152H200.7L171.3 199.5C157.9 194.7 143.4 192 128.3 192 58.1 191.8 0.4 249 0 319.2-0.4 390.3 57.1 448 128 448 187.6 448 237.8 407.2 252 352H304A24-24 0 0 1 324.4 340.6L410.4 201.8 425.3 225.8C399.9 249.3 383.9 282.9 384 320.3 384.1 389.1 441.9 447.3 510.7 448 581.3 448.7 638.9 392.2 640 322 641.1 251.1 583.5 192.3 512.5 192zM186.8 265.8C196.5 276.3 203.4 289.4 206.4 304H163.1L186.8 265.8zM128 400C83.9 400 48 364.1 48 320S83.9 240 128 240C133.9 240 139.6 240.7 145.1 241.9L99.6 315.4C89.7 331.3 101.2 352 120 352H201.3C188.9 380.2 160.7 400 128 400zM290.6 304H255C251 272.2 235.5 244.1 212.6 224L237.4 184H364.9L290.6 304zM507.7 399.9C466.7 397.7 433.6 364.2 432.1 323.1 431.3 302 438.7 282.6 451.4 267.9L495.8 339.5C500.5 347 510.4 349.3 517.9 344.6L531.5 336.2C539 331.5 541.3 321.6 536.6 314.1L492.1 242.5A79.9-79.9 0 0 0 512 240C556.1 240 592 275.9 592 320 592 365.5 553.8 402.3 507.7 399.9z"}]}}),H.register({binoculars:{width:512,height:512,paths:[{d:"M192 104H96V56C96 42.7 106.7 32 120 32H168C181.3 32 192 42.7 192 56V104zM416 56C416 42.7 405.3 32 392 32H344C330.7 32 320 42.7 320 56V104H416V56zM0 456C0 469.3 10.7 480 24 480H144C157.3 480 168 469.3 168 456V440H0V456zM88 128C74.7 128 64 138.7 64 152 64 256 0 272 0 416H168V312C168 298.7 178.7 288 192 288V128H88zM344 456C344 469.3 354.7 480 368 480H488C501.3 480 512 469.3 512 456V440H344V456zM216 128V288H296V128H216zM344 416H512C512 272 448 256 448 152 448 138.7 437.3 128 424 128H320V288C333.3 288 344 298.7 344 312V416z"}]}}),H.register({"birthday-cake":{width:448,height:512,paths:[{d:"M448 384C420 384 416.7 352 373.5 352 330.1 352 326.7 384 298.8 384 271.1 384 267.3 352 224 352 181.2 352 176.8 384 149.5 384 121.4 384 118.3 352 74.8 352 31.2 352 28.1 384 0 384V304C0 277.5 21.5 256 48 256H64V112H128V256H192V112H256V256H320V112H384V256H400C426.5 256 448 277.5 448 304V384zM448 512H0V416C43.4 416 46.8 384 74.8 384 102.7 384 106 416 149.5 416 192.3 416 196.7 384 224 384 252.1 384 255.2 416 298.8 416 342.1 416 345.5 384 373.5 384 401 384 404.8 416 448 416V512zM96 96C78.3 96 64 81.8 64 64 64 33 96 41 96 0 108 0 128 29.5 128 56S113.8 96 96 96zM224 96C206.3 96 192 81.8 192 64 192 33 224 41 224 0 236 0 256 29.5 256 56S241.8 96 224 96zM352 96C334.3 96 320 81.8 320 64 320 33 352 41 352 0 364 0 384 29.5 384 56S369.8 96 352 96z"}]}}),H.register({blind:{width:384,height:512,paths:[{d:"M380.1 510.8A8-8 0 0 0 369.2 508.1L243.8 301.7A31.9-31.9 0 0 1 256.8 292.2L382.8 499.8A8-8 0 0 0 380.2 510.8zM142.8 314.3L110.3 403.8 146.4 492.1C153.1 508.5 171.8 516.3 188.1 509.6 204.5 502.9 212.3 484.2 205.6 467.9L142.8 314.3zM96 88C120.3 88 140 68.3 140 44S120.3 0 96 0 52 19.7 52 44 71.7 88 96 88zM250.8 257.1L130.8 105.1C126.1 99.1 119.1 96 112 96V96H80V96C72.9 96 65.8 99.2 61.1 105.3L0 183.8V279.5C0 292.9 11 304.3 24.5 304 37.5 303.7 48 293.1 48 280V200.2L64 179.7V320.4L9.9 469.1C3.9 485.7 12.5 504 29.1 510.1 45.7 516.1 64 507.5 70.1 490.9L136 309.6V202.4L104.6 162.6A4-4 0 1 0 110.9 157.7L213.2 286.9C222.3 298.5 237.5 298.2 246.9 290.8 257.3 282.6 259 267.5 250.8 257.1z"}]}}),H.register({bold:{width:384,height:512,paths:[{d:"M304.8 243.9C338.4 225.4 358.4 189.7 358.4 148.2 358.4 100 332.2 60.6 289.8 44 265.1 34 240.8 32 209.7 32H24C15.2 32 8 39.2 8 48V81C8 89.9 15.2 97 24 97H57.1V415.6H24C15.2 415.6 8 422.7 8 431.6V464C8 472.8 15.2 480 24 480H219.7C243.9 480 264.5 478.7 286.6 472.4 337.5 457.2 376 410.6 376 350 376 297.8 349.4 258.3 304.8 243.9zM142.2 100.8H209.7C226 100.8 237.2 102.8 247.2 107.5 263 116 272.1 134 272.1 157 272.1 192 251.8 213.8 219.1 213.8H142.2V100.8zM254.9 406.3C244.7 410.3 232.2 411.2 223.4 411.2H142.2V281.9H226.6C266.2 281.9 289.6 307.3 289.6 345 289.6 373.4 276 397.5 254.9 406.3z"}]}}),H.register({bolt:{width:320,height:512,paths:[{d:"M296 160H180.6L215.2 30.2C219.3 15 207.8 0 192 0H56C44 0 33.8 8.9 32.2 20.8L0.2 260.8C-1.7 275.2 9.5 288 24 288H142.7L96.6 482.5C93 497.6 104.7 512 120 512 128.3 512 136.4 507.6 140.8 500L316.7 196C326 180.1 314.5 160 296 160z"}]}}),H.register({bomb:{width:512,height:512,paths:[{d:"M440.5 88.5L388.5 140.5 415 167C424.4 176.4 424.4 191.6 415 200.9L397.6 218.3C409.4 244.4 416 273.4 416 303.9 416 418.8 322.9 511.9 208 511.9S0 418.9 0 304 93.1 96 208 96C238.5 96 267.5 102.6 293.6 114.4L311 97C320.4 87.6 335.6 87.6 344.9 97L371.4 123.5 423.4 71.5 440.5 88.5zM500 60H476C469.4 60 464 65.4 464 72S469.4 84 476 84H500C506.6 84 512 78.6 512 72S506.6 60 500 60zM440 0C433.4 0 428 5.4 428 12V36C428 42.6 433.4 48 440 48S452 42.6 452 36V12C452 5.4 446.6 0 440 0zM473.9 55L490.9 38C495.6 33.3 495.6 25.7 490.9 21 486.2 16.3 478.6 16.3 473.9 21L456.9 38C452.2 42.7 452.2 50.3 456.9 55 461.7 59.7 469.3 59.7 473.9 55zM406.1 55C410.8 59.7 418.4 59.7 423.1 55 427.8 50.3 427.8 42.7 423.1 38L406.1 21C401.4 16.3 393.8 16.3 389.1 21 384.4 25.7 384.4 33.3 389.1 38L406.1 55zM473.9 89C469.2 84.3 461.6 84.3 456.9 89 452.2 93.7 452.2 101.3 456.9 106L473.9 123C478.6 127.7 486.2 127.7 490.9 123 495.6 118.3 495.6 110.7 490.9 106L473.9 89zM112 272C112 236.7 140.7 208 176 208 184.8 208 192 200.8 192 192S184.8 176 176 176C123.1 176 80 219.1 80 272 80 280.8 87.2 288 96 288S112 280.8 112 272z"}]}}),H.register({book:{width:448,height:512,paths:[{d:"M448 360V24C448 10.7 437.3 0 424 0H96C43 0 0 43 0 96V416C0 469 43 512 96 512H424C437.3 512 448 501.3 448 488V472C448 464.5 444.5 457.7 439.1 453.3 434.9 437.9 434.9 394 439.1 378.6 444.5 374.3 448 367.5 448 360zM128 134C128 130.7 130.7 128 134 128H346C349.3 128 352 130.7 352 134V154C352 157.3 349.3 160 346 160H134C130.7 160 128 157.3 128 154V134zM128 198C128 194.7 130.7 192 134 192H346C349.3 192 352 194.7 352 198V218C352 221.3 349.3 224 346 224H134C130.7 224 128 221.3 128 218V198zM381.4 448H96C78.3 448 64 433.7 64 416 64 398.4 78.4 384 96 384H381.4C379.5 401.1 379.5 430.9 381.4 448z"}]}}),H.register({bookmark:{width:384,height:512,paths:[{d:"M0 512V48C0 21.5 21.5 0 48 0H336C362.5 0 384 21.5 384 48V512L192 400 0 512z"}]}}),H.register({"bowling-ball":{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM120 192C102.3 192 88 177.7 88 160S102.3 128 120 128 152 142.3 152 160 137.7 192 120 192zM184 96C184 78.3 198.3 64 216 64S248 78.3 248 96 233.7 128 216 128 184 113.7 184 96zM232 240C214.3 240 200 225.7 200 208S214.3 176 232 176 264 190.3 264 208 249.7 240 232 240z"}]}}),H.register({"box-open":{width:640,height:512,paths:[{d:"M53.2 41L1.7 143.8C-2.9 153 2 164 11.8 166.8L209.7 223.3C216.8 225.3 224.4 222.3 228.2 216L320 64 69.8 32.1C62.9 31.3 56.3 34.8 53.2 41zM638.3 143.8L586.8 41C583.7 34.8 577 31.2 570.1 32.1L320 64 411.7 216.1C415.5 222.4 423.1 225.4 430.2 223.4L628.1 166.9C638 164 642.8 153 638.3 143.8zM425.7 256C408.8 256 392.9 247 384.3 232.6L320 126 255.8 232.6C247.1 247.1 231.2 256.1 214.3 256.1 209.8 256.1 205.3 255.5 201 254.2L64 215V393C64 407.7 74 420.5 88.2 424L304.4 478.1C314.6 480.6 325.3 480.6 335.4 478.1L551.8 424C566 420.4 576 407.6 576 393V215L439 254.1C434.7 255.4 430.2 256 425.7 256z"}]}}),H.register({box:{width:512,height:512,paths:[{d:"M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272V192H510.7C510.3 189.5 510.3 187 509.5 184.6zM240 0H98.6C77.9 0 59.6 13.2 53.1 32.8L2.5 184.6C1.7 187 1.7 189.5 1.3 192H240V0zM0 224V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V224H0z"}]}}),H.register({boxes:{width:576,height:512,paths:[{d:"M560 288H480V384L448 362.7 416 384V288H336C327.2 288 320 295.2 320 304V496C320 504.8 327.2 512 336 512H560C568.8 512 576 504.8 576 496V304C576 295.2 568.8 288 560 288zM176 224H400C408.8 224 416 216.8 416 208V16C416 7.2 408.8 0 400 0H320V96L288 74.7 256 96V0H176C167.2 0 160 7.2 160 16V208C160 216.8 167.2 224 176 224zM240 288H160V384L128 362.7 96 384V288H16C7.2 288 0 295.2 0 304V496C0 504.8 7.2 512 16 512H240C248.8 512 256 504.8 256 496V304C256 295.2 248.8 288 240 288z"}]}}),H.register({braille:{width:640,height:512,paths:[{d:"M128 256C128 291.3 99.3 320 64 320S0 291.3 0 256 28.7 192 64 192 128 220.7 128 256zM64 384C46.3 384 32 398.3 32 416S46.3 448 64 448 96 433.7 96 416 81.7 384 64 384zM64 32C28.7 32 0 60.7 0 96S28.7 160 64 160 128 131.3 128 96 99.3 32 64 32zM224 224C206.3 224 192 238.3 192 256S206.3 288 224 288 256 273.7 256 256 241.7 224 224 224zM224 384C206.3 384 192 398.3 192 416S206.3 448 224 448 256 433.7 256 416 241.7 384 224 384zM224 32C188.7 32 160 60.7 160 96S188.7 160 224 160 288 131.3 288 96 259.3 32 224 32zM448 224C430.3 224 416 238.3 416 256S430.3 288 448 288 480 273.7 480 256 465.7 224 448 224zM448 384C430.3 384 416 398.3 416 416S430.3 448 448 448 480 433.7 480 416 465.7 384 448 384zM448 32C412.7 32 384 60.7 384 96S412.7 160 448 160 512 131.3 512 96 483.3 32 448 32zM608 224C590.3 224 576 238.3 576 256S590.3 288 608 288 640 273.7 640 256 625.7 224 608 224zM608 384C590.3 384 576 398.3 576 416S590.3 448 608 448 640 433.7 640 416 625.7 384 608 384zM608 64C590.3 64 576 78.3 576 96S590.3 128 608 128 640 113.7 640 96 625.7 64 608 64z"}]}}),H.register({"briefcase-medical":{width:512,height:512,paths:[{d:"M464 128H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V128H48C21.5 128 0 149.5 0 176V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V176C512 149.5 490.5 128 464 128zM192 96H320V128H192V96zM352 344C352 348.4 348.4 352 344 352H288V408C288 412.4 284.4 416 280 416H232C227.6 416 224 412.4 224 408V352H168C163.6 352 160 348.4 160 344V296C160 291.6 163.6 288 168 288H224V232C224 227.6 227.6 224 232 224H280C284.4 224 288 227.6 288 232V288H344C348.4 288 352 291.6 352 296V344z"}]}}),H.register({briefcase:{width:512,height:512,paths:[{d:"M320 288H512V432C512 458.5 490.5 480 464 480H48C21.5 480 0 458.5 0 432V288H192V308C192 314.6 197.4 320 204 320H308C314.6 320 320 314.6 320 308V288zM512 176V256H0V176C0 149.5 21.5 128 48 128H128V80C128 53.5 149.5 32 176 32H336C362.5 32 384 53.5 384 80V128H464C490.5 128 512 149.5 512 176zM320 96H192V128H320V96z"}]}}),H.register({bug:{width:512,height:512,paths:[{d:"M512 288.9C511.5 306.3 496.8 320 479.3 320H424V336C424 357.9 419.1 378.6 410.4 397.1L470.6 457.4C483.1 469.9 483.1 490.1 470.6 502.6 458.1 515.1 437.9 515.1 425.4 502.6L370.6 447.9C345.9 468 314.4 480 280 480V236C280 229.4 274.6 224 268 224H244C237.4 224 232 229.4 232 236V480C197.6 480 166.1 468 141.4 447.9L86.6 502.6C74.1 515.1 53.9 515.1 41.4 502.6 28.9 490.1 28.9 469.9 41.4 457.4L101.6 397.1C92.9 378.6 88 357.9 88 336V320H32.7C15.2 320 0.5 306.3 0 288.9-0.5 270.8 14 256 32 256H88V197.3L41.4 150.6C28.9 138.1 28.9 117.9 41.4 105.4 53.9 92.9 74.1 92.9 86.6 105.4L141.3 160H370.7L425.4 105.4C437.9 92.9 458.1 92.9 470.6 105.4 483.1 117.9 483.1 138.1 470.6 150.6L424 197.3V256H480C498 256 512.5 270.8 512 288.9zM257 0C195.1 0 145 50.1 145 112H369C369 50.1 318.9 0 257 0z"}]}}),H.register({building:{width:448,height:512,paths:[{d:"M436 480H416V24C416 10.7 405.3 0 392 0H56C42.7 0 32 10.7 32 24V480H12C5.4 480 0 485.4 0 492V512H448V492C448 485.4 442.6 480 436 480zM128 76C128 69.4 133.4 64 140 64H180C186.6 64 192 69.4 192 76V116C192 122.6 186.6 128 180 128H140C133.4 128 128 122.6 128 116V76zM128 172C128 165.4 133.4 160 140 160H180C186.6 160 192 165.4 192 172V212C192 218.6 186.6 224 180 224H140C133.4 224 128 218.6 128 212V172zM180 320H140C133.4 320 128 314.6 128 308V268C128 261.4 133.4 256 140 256H180C186.6 256 192 261.4 192 268V308C192 314.6 186.6 320 180 320zM256 480H192V396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V480zM320 308C320 314.6 314.6 320 308 320H268C261.4 320 256 314.6 256 308V268C256 261.4 261.4 256 268 256H308C314.6 256 320 261.4 320 268V308zM320 212C320 218.6 314.6 224 308 224H268C261.4 224 256 218.6 256 212V172C256 165.4 261.4 160 268 160H308C314.6 160 320 165.4 320 172V212zM320 116C320 122.6 314.6 128 308 128H268C261.4 128 256 122.6 256 116V76C256 69.4 261.4 64 268 64H308C314.6 64 320 69.4 320 76V116z"}]}}),H.register({bullhorn:{width:576,height:512,paths:[{d:"M576 224C576 203.1 562.6 185.3 544 178.7V64C544 28.7 515.3 0 480 0 415 56 338 128 208 128H48C21.5 128 0 149.5 0 176V272C0 298.5 21.5 320 48 320H91.3C72.5 384.6 93.7 436.4 110.1 487.4 111.8 492.8 115.3 497.3 120 500.3 140.8 513.5 188.4 516 213.8 505.5 229.8 498.8 233.7 478 221.3 465.9 202.8 447.9 191.2 429 201.5 405.1A12.3-12.3 0 0 1 200.5 393.4C184.1 368.7 196.9 331.3 229 320.7 346.4 327.9 418.6 395.1 480 448 515.3 448 544 419.3 544 384V269.3C562.6 262.7 576 244.9 576 224zM480 363.9C425.4 318.9 355 270.9 256 258.9V189.1C355 177.1 425.4 129.1 480 84.1V363.9z"}]}}),H.register({bullseye:{width:512,height:512,paths:[{d:"M256 72C357.7 72 440 154.3 440 256 440 357.7 357.7 440 256 440 154.3 440 72 357.7 72 256 72 154.3 154.3 72 256 72M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 192C291.3 192 320 220.7 320 256S291.3 320 256 320 192 291.3 192 256 220.7 192 256 192M256 128C185.3 128 128 185.3 128 256S185.3 384 256 384 384 326.7 384 256 326.7 128 256 128z"}]}}),H.register({burn:{width:384,height:512,paths:[{d:"M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512S384 425 384 300.5C384 220.6 303.8 100.9 192 0zM192 448C135.5 448 96 409 96 353.2 96 339.7 100.6 291.7 192 192 283.4 291.7 288 339.7 288 353.2 288 409 248.5 448 192 448z"}]}}),H.register({bus:{width:512,height:512,paths:[{d:"M512 152V232C512 245.3 501.3 256 488 256H480V424C480 437.3 469.3 448 456 448H448V488C448 501.3 437.3 512 424 512H376C362.7 512 352 501.3 352 488V448H160V488C160 501.3 149.3 512 136 512H88C74.7 512 64 501.3 64 488V448H56C42.7 448 32 437.3 32 424V256H24C10.7 256 0 245.3 0 232V152C0 138.7 10.7 128 24 128H32V80C32 35.8 132.3 0 256 0S480 35.8 480 80V128H488C501.3 128 512 138.7 512 152zM112 320C89.9 320 72 337.9 72 360S89.9 400 112 400 152 382.1 152 360 134.1 320 112 320zM400 320C377.9 320 360 337.9 360 360S377.9 400 400 400 440 382.1 440 360 422.1 320 400 320zM432 264V120C432 106.7 421.3 96 408 96H104C90.7 96 80 106.7 80 120V264C80 277.3 90.7 288 104 288H408C421.3 288 432 277.3 432 264z"}]}}),H.register({calculator:{width:448,height:512,paths:[{d:"M0 464V48C0 21.5 21.5 0 48 0H400C426.5 0 448 21.5 448 48V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464zM384 180V76C384 69.4 378.6 64 372 64H76C69.4 64 64 69.4 64 76V180C64 186.6 69.4 192 76 192H372C378.6 192 384 186.6 384 180zM128 308V268C128 261.4 122.6 256 116 256H76C69.4 256 64 261.4 64 268V308C64 314.6 69.4 320 76 320H116C122.6 320 128 314.6 128 308zM384 436V268C384 261.4 378.6 256 372 256H332C325.4 256 320 261.4 320 268V436C320 442.6 325.4 448 332 448H372C378.6 448 384 442.6 384 436zM128 436V396C128 389.4 122.6 384 116 384H76C69.4 384 64 389.4 64 396V436C64 442.6 69.4 448 76 448H116C122.6 448 128 442.6 128 436zM256 308V268C256 261.4 250.6 256 244 256H204C197.4 256 192 261.4 192 268V308C192 314.6 197.4 320 204 320H244C250.6 320 256 314.6 256 308zM256 436V396C256 389.4 250.6 384 244 384H204C197.4 384 192 389.4 192 396V436C192 442.6 197.4 448 204 448H244C250.6 448 256 442.6 256 436z"}]}}),H.register({"calendar-alt":{width:448,height:512,paths:[{d:"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM128 396C128 389.4 122.6 384 116 384H76C69.4 384 64 389.4 64 396V436C64 442.6 69.4 448 76 448H116C122.6 448 128 442.6 128 436V396zM128 268C128 261.4 122.6 256 116 256H76C69.4 256 64 261.4 64 268V308C64 314.6 69.4 320 76 320H116C122.6 320 128 314.6 128 308V268zM256 396C256 389.4 250.6 384 244 384H204C197.4 384 192 389.4 192 396V436C192 442.6 197.4 448 204 448H244C250.6 448 256 442.6 256 436V396zM256 268C256 261.4 250.6 256 244 256H204C197.4 256 192 261.4 192 268V308C192 314.6 197.4 320 204 320H244C250.6 320 256 314.6 256 308V268zM384 396C384 389.4 378.6 384 372 384H332C325.4 384 320 389.4 320 396V436C320 442.6 325.4 448 332 448H372C378.6 448 384 442.6 384 436V396zM384 268C384 261.4 378.6 256 372 256H332C325.4 256 320 261.4 320 268V308C320 314.6 325.4 320 332 320H372C378.6 320 384 314.6 384 308V268z"}]}}),H.register({"calendar-check":{width:448,height:512,paths:[{d:"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM345.3 287.9L317.1 259.5C312.5 254.8 304.9 254.8 300.2 259.5L194.1 364.7 148.1 318.3C143.5 313.6 135.9 313.6 131.2 318.2L102.8 346.4C98.1 351.1 98 358.7 102.7 363.4L185.3 446.7C190 451.4 197.6 451.4 202.3 446.7L345.2 304.9C349.9 300.3 350 292.7 345.3 287.9z"}]}}),H.register({"calendar-minus":{width:448,height:512,paths:[{d:"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM316 384C322.6 384 328 378.6 328 372V332C328 325.4 322.6 320 316 320H132C125.4 320 120 325.4 120 332V372C120 378.6 125.4 384 132 384H316z"}]}}),H.register({"calendar-plus":{width:448,height:512,paths:[{d:"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM328 332C328 325.4 322.6 320 316 320H256V260C256 253.4 250.6 248 244 248H204C197.4 248 192 253.4 192 260V320H132C125.4 320 120 325.4 120 332V372C120 378.6 125.4 384 132 384H192V444C192 450.6 197.4 456 204 456H244C250.6 456 256 450.6 256 444V384H316C322.6 384 328 378.6 328 372V332z"}]}}),H.register({"calendar-times":{width:448,height:512,paths:[{d:"M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM269.3 352L317.4 303.9C322.1 299.2 322.1 291.6 317.4 286.9L289.1 258.6C284.4 253.9 276.8 253.9 272.1 258.6L224 306.7 175.9 258.6C171.2 253.9 163.6 253.9 158.9 258.6L130.6 286.9C125.9 291.6 125.9 299.2 130.6 303.9L178.7 352 130.6 400.1C125.9 404.8 125.9 412.4 130.6 417.1L158.9 445.4C163.6 450.1 171.2 450.1 175.9 445.4L224 397.3 272.1 445.4C276.8 450.1 284.4 450.1 289.1 445.4L317.4 417.1C322.1 412.4 322.1 404.8 317.4 400.1L269.3 352z"}]}}),H.register({calendar:{width:448,height:512,paths:[{d:"M12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM448 148V112C448 85.5 426.5 64 400 64H352V12C352 5.4 346.6 0 340 0H300C293.4 0 288 5.4 288 12V64H160V12C160 5.4 154.6 0 148 0H108C101.4 0 96 5.4 96 12V64H48C21.5 64 0 85.5 0 112V148C0 154.6 5.4 160 12 160H436C442.6 160 448 154.6 448 148z"}]}}),H.register({"camera-retro":{width:512,height:512,paths:[{d:"M48 32C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32H48zM48 64H154C157.3 64 160 66.7 160 70V90C160 93.3 157.3 96 154 96H38C34.7 96 32 93.3 32 90V80C32 71.2 39.2 64 48 64zM474 160H38C34.7 160 32 157.3 32 154V118C32 114.7 34.7 112 38 112H176L206.2 66.7C207.3 65 209.2 64 211.2 64H464C472.8 64 480 71.2 480 80V154C480 157.3 477.3 160 474 160zM256 424C189.8 424 136 370.2 136 304S189.8 184 256 184 376 237.8 376 304 322.2 424 256 424zM256 216C207.5 216 168 255.5 168 304S207.5 392 256 392 344 352.5 344 304 304.5 216 256 216zM208 320C199.2 320 192 312.8 192 304 192 268.7 220.7 240 256 240 264.8 240 272 247.2 272 256S264.8 272 256 272C238.4 272 224 286.4 224 304 224 312.8 216.8 320 208 320z"}]}}),H.register({camera:{width:512,height:512,paths:[{d:"M512 144V432C512 458.5 490.5 480 464 480H48C21.5 480 0 458.5 0 432V144C0 117.5 21.5 96 48 96H136L148.3 63.1C155.3 44.4 173.2 32 193.2 32H318.7C338.7 32 356.6 44.4 363.6 63.1L376 96H464C490.5 96 512 117.5 512 144zM376 288C376 221.8 322.2 168 256 168S136 221.8 136 288 189.8 408 256 408 376 354.2 376 288zM344 288C344 336.5 304.5 376 256 376S168 336.5 168 288 207.5 200 256 200 344 239.5 344 288z"}]}}),H.register({capsules:{width:576,height:512,paths:[{d:"M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64 307.8 64 284.9 70.7 264.9 84.7 245.2 98.5 231.2 117.5 223.4 138.5 220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144V368C0 429.9 50.1 480 112 480S224 429.9 224 368V218.9C227.3 227.5 231.3 236 236.8 243.9L368 431.2C390.2 463 425.7 480 461.8 480 484.5 480 507.3 473.3 527.3 459.3 579 423.1 591.5 351.8 555.3 300.1zM160 256H64V144C64 117.5 85.5 96 112 96S160 117.5 160 144V256zM354.8 300.9L289.2 207.2C281.5 196.2 278.5 182.8 280.9 169.6 283.2 156.4 290.6 144.8 301.6 137.1 310.1 131.1 320.1 128 330.4 128 346.9 128 362.3 136 371.7 149.5L437.3 243.2 354.8 300.9z"}]}}),H.register({car:{width:512,height:512,paths:[{d:"M500 168H445.2L437.3 147.1C428.1 122.5 411.9 101.7 390.4 86.8S343.7 64 317.5 64H194.5C168.3 64 143.1 71.9 121.6 86.8 100.1 101.7 83.9 122.5 74.7 147.1L66.8 168H12C3.8 168-2 176 0.6 183.8L8.6 207.8A12-12 0 0 1 20 216H48.8L48.8 216.1C29.2 227.1 16 248 16 272V320C16 336.2 22 351 32 362.3V424C32 437.3 42.7 448 56 448H104C117.3 448 128 437.3 128 424V384H384V424C384 437.3 394.7 448 408 448H456C469.3 448 480 437.3 480 424V362.3C490 351 496 336.2 496 320V272C496 248 482.8 227.1 463.2 216.1L463.2 216H492A12-12 0 0 1 503.4 207.8L511.4 183.8C514 176 508.2 168 500 168zM134.6 169.5C143.9 144.7 168 128 194.5 128H317.5C344 128 368.1 144.7 377.4 169.5L391.8 208H120.2L134.6 169.5zM88 328C70.3 328 56 313.7 56 296 56 278.3 70.3 264 88 264S136 294.3 136 312 105.7 328 88 328zM424 328C406.3 328 376 329.7 376 312 376 294.3 406.3 264 424 264S456 278.3 456 296C456 313.7 441.7 328 424 328z"}]}}),H.register({"caret-down":{width:320,height:512,paths:[{d:"M31.3 192H288.6C306.4 192 315.3 213.5 302.7 226.1L174.1 354.8C166.3 362.6 153.6 362.6 145.8 354.8L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"}]}}),H.register({"caret-left":{width:192,height:512,paths:[{d:"M192 127.3V384.7C192 402.5 170.5 411.4 157.9 398.8L29.2 270.1C21.4 262.3 21.4 249.7 29.2 241.9L157.9 113.2C170.5 100.6 192 109.5 192 127.3z"}]}}),H.register({"caret-right":{width:192,height:512,paths:[{d:"M0 384.7V127.3C0 109.5 21.5 100.6 34.1 113.2L162.8 241.9C170.6 249.7 170.6 262.3 162.8 270.1L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"}]}}),H.register({"caret-square-down":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM92.5 220.5L215.5 343.5C220.2 348.2 227.8 348.2 232.5 343.5L355.5 220.5C363.1 212.9 357.7 200 347 200H101C90.3 200 84.9 212.9 92.5 220.5z"}]}}),H.register({"caret-square-left":{width:448,height:512,paths:[{d:"M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM259.5 124.5L136.5 247.5C131.8 252.2 131.8 259.8 136.5 264.5L259.5 387.5C267.1 395.1 280 389.7 280 379V133C280 122.3 267.1 116.9 259.5 124.5z"}]}}),H.register({"caret-square-right":{width:448,height:512,paths:[{d:"M48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32zM188.5 387.5L311.5 264.5C316.2 259.8 316.2 252.2 311.5 247.5L188.5 124.5C180.9 116.9 168 122.3 168 133V379C168 389.7 180.9 395.1 188.5 387.5z"}]}}),H.register({"caret-square-up":{width:448,height:512,paths:[{d:"M0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432zM355.5 291.5L232.5 168.5C227.8 163.8 220.2 163.8 215.5 168.5L92.5 291.5C84.9 299.1 90.3 312 101 312H347C357.7 312 363.1 299.1 355.5 291.5z"}]}}),H.register({"caret-up":{width:320,height:512,paths:[{d:"M288.7 352H31.3C13.5 352 4.6 330.5 17.2 317.9L145.9 189.2C153.7 181.4 166.3 181.4 174.1 189.2L302.8 317.9C315.4 330.5 306.5 352 288.7 352z"}]}}),H.register({"cart-arrow-down":{width:576,height:512,paths:[{d:"M504.7 320H211.6L218.1 352H486.5C501.9 352 513.4 366.3 509.9 381.3L504.4 405.6C523.1 414.7 536 433.8 536 456 536 487.2 510.5 512.4 479.2 512 449.4 511.6 424.8 487.4 424 457.5 423.6 441.3 430.1 426.5 440.8 416H231.2C241.6 426.2 248 440.3 248 456 248 487.8 221.5 513.4 189.3 511.9 160.8 510.6 137.6 487.6 136.1 459 134.9 437 146.5 417.6 164.1 407.4L93.9 64H24C10.7 64 0 53.3 0 40V24C0 10.7 10.7 0 24 0H126.5C137.9 0 147.8 8 150 19.2L159.2 64H552C567.4 64 578.8 78.3 575.4 93.3L528.1 301.3C525.6 312.2 515.9 320 504.7 320zM403 192H360V132C360 125.4 354.6 120 348 120H324C317.4 120 312 125.4 312 132V192H269C258.3 192 252.9 204.9 260.5 212.5L327.5 279.5C332.2 284.2 339.8 284.2 344.5 279.5L411.5 212.5C419.1 204.9 413.7 192 403 192z"}]}}),H.register({"cart-plus":{width:576,height:512,paths:[{d:"M504.7 320H211.6L218.1 352H486.5C501.9 352 513.4 366.3 509.9 381.3L504.4 405.6C523.1 414.7 536 433.8 536 456 536 487.2 510.5 512.4 479.2 512 449.4 511.6 424.8 487.4 424 457.5 423.6 441.3 430.1 426.5 440.8 416H231.2C241.6 426.2 248 440.3 248 456 248 487.8 221.5 513.4 189.3 511.9 160.8 510.6 137.6 487.6 136.1 459 134.9 437 146.5 417.6 164.1 407.4L93.9 64H24C10.7 64 0 53.3 0 40V24C0 10.7 10.7 0 24 0H126.5C137.9 0 147.8 8 150 19.2L159.2 64H552C567.4 64 578.8 78.3 575.4 93.3L528.1 301.3C525.6 312.2 515.9 320 504.7 320zM408 168H360V128C360 119.2 352.8 112 344 112H328C319.2 112 312 119.2 312 128V168H264C255.2 168 248 175.2 248 184V200C248 208.8 255.2 216 264 216H312V256C312 264.8 319.2 272 328 272H344C352.8 272 360 264.8 360 256V216H408C416.8 216 424 208.8 424 200V184C424 175.2 416.8 168 408 168z"}]}}),H.register({certificate:{width:512,height:512,paths:[{d:"M458.6 255.9L504.6 210.9C518.3 197.9 511.9 174.9 493.9 170.6L431.3 154.6 449 92.6C453.9 74.7 437.1 57.9 419.3 62.9L357.3 80.6 341.3 17.9C337.1 0.2 313.8-6.3 301 7.2L256 53.6 211 7.2C198.4-6.1 175 0 170.7 17.9L154.7 80.6 92.7 62.9C74.9 57.9 58.1 74.7 63 92.6L80.7 154.6 18.1 170.6C0.1 174.9-6.3 197.9 7.4 210.9L53.4 255.9 7.4 300.9C-6.3 313.9 0.1 337 18.1 341.3L80.7 357.3 63 419.3C58.1 437.1 74.9 453.9 92.7 448.9L154.7 431.3 170.7 493.9C175.1 512.5 198.4 518 211 504.6L256 458.6 301 504.6C313.5 518.1 337 512.1 341.3 493.9L357.3 431.3 419.3 448.9C437.1 453.9 453.9 437.1 449 419.3L431.3 357.3 493.9 341.3C511.9 337 518.3 313.9 504.6 300.9L458.6 255.9z"}]}}),H.register({"chart-area":{width:512,height:512,paths:[{d:"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM372.7 159.5L288 216 202.7 102.3C197.6 95.5 187.2 96 182.8 103.3L96 248V352H480L390.1 164.2C386.9 157.7 378.7 155.5 372.7 159.5z"}]}}),H.register({"chart-bar":{width:512,height:512,paths:[{d:"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM192 340V268C192 261.4 186.6 256 180 256H140C133.4 256 128 261.4 128 268V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340zM384 340V204C384 197.4 378.6 192 372 192H332C325.4 192 320 197.4 320 204V340C320 346.6 325.4 352 332 352H372C378.6 352 384 346.6 384 340zM288 340V140C288 133.4 282.6 128 276 128H236C229.4 128 224 133.4 224 140V340C224 346.6 229.4 352 236 352H276C282.6 352 288 346.6 288 340zM480 340V108C480 101.4 474.6 96 468 96H428C421.4 96 416 101.4 416 108V340C416 346.6 421.4 352 428 352H468C474.6 352 480 346.6 480 340z"}]}}),H.register({"chart-line":{width:512,height:512,paths:[{d:"M500 384C506.6 384 512 389.4 512 396V436C512 442.6 506.6 448 500 448H12C5.4 448 0 442.6 0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V384H500zM456 96H344C322.6 96 311.9 121.9 327 137L359.9 169.9 287.9 242.8 232.3 187.2C227.6 182.5 220.1 182.5 215.4 187.2L96.4 305C91.7 309.6 91.6 317.2 96.2 321.9L124.7 351.3C129.4 356.1 137.1 356.2 141.8 351.4L223.9 269.3 279.4 324.8C284.1 329.5 291.7 329.5 296.4 324.8L405.6 215.6 439 249C454.1 264.1 480 253.4 480 232V120C480 106.7 469.3 96 456 96z"}]}}),H.register({"chart-pie":{width:576,height:512,paths:[{d:"M288 12.3V240H515.7C522.6 240 528 234.2 527.7 227.3 521.3 104.9 423.2 6.7 300.7 0.3 293.8 0 288 5.4 288 12.3zM552.7 288C559.6 288 565 293.8 564.7 300.7 561.9 353.9 541.5 406.3 503.5 448.5 498.9 453.6 490.9 453.9 486 449L325 288H552.7zM401 433C405.8 437.8 405.7 445.8 400.6 450.3 358 488.7 301.6 512 239.8 512 107.6 511.9-0.2 403.8 0 271.5 0.2 143.4 100.8 38.9 227.3 32.3 234.2 31.9 240 37.4 240 44.3V272L401 433z"}]}}),H.register({"check-circle":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM227.3 387.3L411.3 203.3C417.6 197.1 417.6 186.9 411.3 180.7L388.7 158.1C382.4 151.8 372.3 151.8 366.1 158.1L216 308.1 145.9 238.1C139.7 231.8 129.6 231.8 123.3 238.1L100.7 260.7C94.4 266.9 94.4 277.1 100.7 283.3L204.7 387.3C210.9 393.6 221.1 393.6 227.3 387.3z"}]}}),H.register({"check-square":{width:448,height:512,paths:[{d:"M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM195.3 381.9L379.3 197.9C385.6 191.7 385.6 181.6 379.3 175.3L356.7 152.7C350.4 146.4 340.3 146.4 334.1 152.7L184 302.7 113.9 232.7C107.7 226.4 97.6 226.4 91.3 232.7L68.7 255.3C62.4 261.6 62.4 271.7 68.7 277.9L172.7 381.9C178.9 388.2 189.1 388.2 195.3 381.9z"}]}}),H.register({check:{width:512,height:512,paths:[{d:"M173.9 439.4L7.5 273C-2.5 263-2.5 246.8 7.5 236.8L43.7 200.6C53.7 190.6 69.9 190.6 79.9 200.6L192 312.7 432.1 72.6C442.1 62.6 458.3 62.6 468.3 72.6L504.5 108.8C514.5 118.8 514.5 135 504.5 145L210.1 439.4C200.1 449.4 183.9 449.4 173.9 439.4z"}]}}),H.register({"chess-bishop":{width:320,height:512,paths:[{d:"M123.2 77.9C107.4 72.5 96 57.6 96 40 96 17.9 113.9 0 136 0H183.8C205.9 0 223.8 17.9 223.8 40 223.8 57.5 212.5 72.4 196.8 77.8 220.8 94.5 245.4 124.7 265.5 159.9L144.9 280.4A6-6 0 0 1 144.9 288.9L159.1 303.1A6-6 0 0 1 167.6 303.1L280.9 189.7C298.7 228 310.3 269.2 310.3 304 310.3 357.8 287.4 379.8 251.8 390V448H68.2V390C32.6 379.8 9.7 357.8 9.7 304 9.7 226 68 116.2 123.2 77.9zM320 500V476C320 469.4 314.6 464 308 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H308C314.6 512 320 506.6 320 500z"}]}}),H.register({"chess-board":{width:512,height:512,paths:[{d:"M256 256V320H192V256H256zM256 0H192V64H256V0zM256 256H320V192H256V256zM384 0H320V64H384V0zM384 512H448V448H384V512zM512 448V384H448V448H512zM128 512H192V448H128V512zM128 0H64V64H128V0zM512 192V128H448V192H512zM512 320V256H448V320H512zM0 512H64V448H0V512zM0 64V128H64V64H0zM0 192V256H64V192H0zM0 320V384H64V320H0zM256 512H320V448H256V512zM192 384V448H256V384H192zM256 192V128H192V192H256zM64 384V448H128V384H64zM128 256H64V320H128V256zM384 384H448V320H384V384zM512 0H448V64H512V0zM384 256H448V192H384V256zM384 64V128H448V64H384zM320 384V448H384V384H320zM128 320V384H192V320H128zM256 320V384H320V320H256zM192 192H128V256H192V192zM128 128H64V192H128V128zM320 320H384V256H320V320zM192 128V64H128V128H192zM320 128V64H256V128H320zM320 192H384V128H320V192z"}]}}),H.register({"chess-king":{width:448,height:512,paths:[{d:"M416 476V500C416 506.6 410.6 512 404 512H44C37.4 512 32 506.6 32 500V476C32 469.4 37.4 464 44 464H404C410.6 464 416 469.4 416 476zM408 152H248V104H298A6-6 0 0 1 304 98V62A6-6 0 0 1 298 56H248V6A6-6 0 0 1 242 0H206A6-6 0 0 1 200 6V56H150A6-6 0 0 1 144 62V98A6-6 0 0 1 150 104H200V152H40C12.5 152-6.8 179.2 2.3 205.3L87.6 448H360.4L445.7 205.3C454.8 179.2 435.5 152 408 152z"}]}}),H.register({"chess-knight":{width:384,height:512,paths:[{d:"M352 224V448H32V401.4C32 371.1 49.1 343.4 76.2 329.9L133.5 301.3A48-48 0 0 1 160 258.3V208L137.9 219.1A24-24 0 0 1 125.3 234.7L113.5 282A12-12 0 0 0 106.3 290.3L76.7 302.1A12-12 0 0 0 67.4 301.9L7.1 275.2A12-12 0 0 0 0 264.2V105.9C0 99.6 2.5 93.5 7 89L16 80 1.8 51.6A16.9-16.9 0 0 0 0 44C0 37.4 5.4 32 12 32H160C266 32 352 118 352 224zM372 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H372C378.6 512 384 506.6 384 500V476C384 469.4 378.6 464 372 464zM52 128C41 128 32 137 32 148S41 168 52 168 72 159 72 148 63 128 52 128z"}]}}),H.register({"chess-pawn":{width:320,height:512,paths:[{d:"M264 448H56S116 405.3 116 272H84C77.4 272 72 266.6 72 260V236C72 229.4 77.4 224 84 224H124.2C95.7 210.6 76 181.6 76 148 76 101.6 113.6 64 160 64S244 101.6 244 148C244 181.6 224.3 210.6 195.8 224H236C242.6 224 248 229.4 248 236V260C248 266.6 242.6 272 236 272H204C204 405.3 264 448 264 448zM292 464H28C21.4 464 16 469.4 16 476V500C16 506.6 21.4 512 28 512H292C298.6 512 304 506.6 304 500V476C304 469.4 298.6 464 292 464z"}]}}),H.register({"chess-queen":{width:512,height:512,paths:[{d:"M436 512H76C69.4 512 64 506.6 64 500V476C64 469.4 69.4 464 76 464H436C442.6 464 448 469.4 448 476V500C448 506.6 442.6 512 436 512zM255.6 0C224.7 0 199.6 25.1 199.6 56S224.7 112 255.6 112 311.6 86.9 311.6 56 286.5 0 255.6 0zM460.1 154.6C454.4 151.6 447.2 153.7 444.1 159.4 435.4 174.9 421.3 197.2 400 197.2 371.3 197.2 369.4 177.4 368.3 139.7 368.1 133.2 362.8 128 356.3 128H315.3C310.1 128 305.6 131.3 303.9 136.2 295 162.9 277.9 177.2 256 177.2S217 162.9 208.1 136.2C206.4 131.3 201.9 128 196.7 128H155.7C149.2 128 143.9 133.2 143.7 139.7 142.6 177.3 140.8 197.2 112 197.2 91.3 197.2 78.2 177 67.6 159.2 64.3 153.7 57.3 151.7 51.7 154.7L12.5 175.4A12-12 0 0 1 7 190.6L112 448H400L505 190.6A12-12 0 0 1 499.5 175.4L460.1 154.6z"}]}}),H.register({"chess-rook":{width:384,height:512,paths:[{d:"M81.2 215C81 258.9 77.4 348.1 48 448H336C306.6 348.4 303 259.1 302.8 215L348.2 172.7A12-12 0 0 1 352 163.9V44C352 37.4 346.6 32 340 32H300C293.4 32 288 37.4 288 44V88H240V44C240 37.4 234.6 32 228 32H156C149.4 32 144 37.4 144 44V88H96V44C96 37.4 90.6 32 84 32H44C37.4 32 32 37.4 32 44V163.9C32 167.3 33.4 170.4 35.8 172.7L81.2 215zM160 256C160 238.3 174.3 224 192 224 209.7 224 224 238.3 224 256V320H160V256zM384 476V500C384 506.6 378.6 512 372 512H12C5.4 512 0 506.6 0 500V476C0 469.4 5.4 464 12 464H372C378.6 464 384 469.4 384 476z"}]}}),H.register({chess:{width:512,height:512,paths:[{d:"M199.8 217.6A6-6 0 0 0 205.8 223.6L205.8 244.4A6-6 0 0 0 199.8 250.4H174C174 282.1 171.9 346.6 191.4 403.6H64.6C84.5 345.5 82 279.2 82 250.4H56.2A6-6 0 0 0 50.2 244.4L50.2 223.6A6-6 0 0 0 56.2 217.6H199.8zM41.6 115.1L76.1 210.2H179.9L214.4 115.1C217.3 107.3 211.5 99 203.2 99H152V68.8H173.6A6-6 0 0 1 179.6 62.8V40.4A6-6 0 0 1 173.6 34.4H145.2V6A6-6 0 0 1 139.2 0H116.8A6-6 0 0 1 110.8 6V34.4H82.4A6-6 0 0 1 76.4 40.4V62.8A6-6 0 0 1 82.4 68.8H104V99H52.8C44.5 99 38.7 107.3 41.6 115.1zM222.7 445.2V417.1A6-6 0 0 1 216.7 411.1H39.3A6-6 0 0 1 33.3 417.1V445.2L11.2 459.3A6-6 0 0 1 8.4 464.4V506A6-6 0 0 1 14.4 512H241.6A6-6 0 0 1 247.6 506V464.4A6-6 0 0 1 244.8 459.3L222.7 445.2zM313.3 300.9L338.1 317.9C338.2 336 338 381.8 326.2 432.4H473.8C462 382 461.8 336.1 461.9 317.9L486.7 300.9A3.9-3.9 0 0 1 488.4 297.8V227.9A3.9-3.9 0 0 1 484.6 224H456.9A3.9-3.9 0 0 1 453 227.9V259.4H430.3V227.9A3.9-3.9 0 0 1 426.5 224H373.5A3.9-3.9 0 0 1 369.7 227.9V259.4H346.9V227.9A3.9-3.9 0 0 1 343.1 224H315.4A3.9-3.9 0 0 1 311.6 227.9V297.8A3.9-3.9 0 0 1 313.3 300.9zM384.8 352.9C384.8 344.5 391.6 337.7 400 337.7S415.2 344.5 415.2 352.9V383.2H384.8V352.9zM504.6 470.1L491 459.4V443.9A3.9-3.9 0 0 1 487.1 440H312.9A3.9-3.9 0 0 1 309.1 443.9V459.4L295.4 470.1A3.9-3.9 0 0 1 293.9 473.1V508.1A3.9-3.9 0 0 1 297.8 512H502.3A3.9-3.9 0 0 1 506.1 508.1V473.1A3.9-3.9 0 0 1 504.6 470.1z"}]}}),H.register({"chevron-circle-down":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM273 369.9L408.5 234.4C417.9 225 417.9 209.8 408.5 200.5L391.5 183.5C382.1 174.1 366.9 174.1 357.6 183.5L256 285.1 154.4 183.5C145 174.1 129.8 174.1 120.5 183.5L103.5 200.5C94.1 209.9 94.1 225.1 103.5 234.4L239 369.9C248.4 379.3 263.6 379.3 273 369.9z"}]}}),H.register({"chevron-circle-left":{width:512,height:512,paths:[{d:"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM142.1 273L277.6 408.5C287 417.9 302.2 417.9 311.5 408.5L328.5 391.5C337.9 382.1 337.9 366.9 328.5 357.6L226.9 256 328.5 154.4C337.9 145 337.9 129.8 328.5 120.5L311.5 103.5C302.1 94.1 286.9 94.1 277.6 103.5L142.1 239C132.7 248.4 132.7 263.6 142.1 273z"}]}}),H.register({"chevron-circle-right":{width:512,height:512,paths:[{d:"M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM369.9 239L234.4 103.5C225 94.1 209.8 94.1 200.5 103.5L183.5 120.5C174.1 129.9 174.1 145.1 183.5 154.4L285.1 256 183.5 357.6C174.1 367 174.1 382.2 183.5 391.5L200.5 408.5C209.9 417.9 225.1 417.9 234.4 408.5L369.9 273C379.3 263.6 379.3 248.4 369.9 239z"}]}}),H.register({"chevron-circle-up":{width:512,height:512,paths:[{d:"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM239 142.1L103.5 277.6C94.1 287 94.1 302.2 103.5 311.5L120.5 328.5C129.9 337.9 145.1 337.9 154.4 328.5L256 226.9 357.6 328.5C367 337.9 382.2 337.9 391.5 328.5L408.5 311.5C417.9 302.1 417.9 286.9 408.5 277.6L273 142.1C263.6 132.7 248.4 132.7 239 142.1z"}]}}),H.register({"chevron-down":{width:448,height:512,paths:[{d:"M207 381.5L12.7 187.1C3.3 177.8 3.3 162.6 12.7 153.2L35.4 130.5C44.7 121.2 59.9 121.1 69.3 130.5L224 284.5 378.7 130.5C388.1 121.1 403.3 121.2 412.6 130.5L435.3 153.2C444.7 162.6 444.7 177.8 435.3 187.1L241 381.5C231.6 390.8 216.4 390.8 207 381.5z"}]}}),H.register({"chevron-left":{width:320,height:512,paths:[{d:"M34.5 239L228.9 44.7C238.2 35.3 253.4 35.3 262.8 44.7L285.5 67.4C294.8 76.7 294.9 91.9 285.5 101.3L131.5 256 285.5 410.8C294.9 420.1 294.8 435.3 285.5 444.6L262.8 467.3C253.4 476.7 238.2 476.7 228.9 467.3L34.5 273C25.1 263.6 25.1 248.4 34.5 239z"}]}}),H.register({"chevron-right":{width:320,height:512,paths:[{d:"M285.5 273L91.1 467.3C81.8 476.7 66.6 476.7 57.2 467.3L34.5 444.6C25.2 435.3 25.1 420.1 34.5 410.7L188.5 256 34.5 101.3C25.1 91.9 25.2 76.7 34.5 67.4L57.2 44.7C66.6 35.3 81.8 35.3 91.1 44.7L285.5 239C294.8 248.4 294.8 263.6 285.5 273z"}]}}),H.register({"chevron-up":{width:448,height:512,paths:[{d:"M241 130.5L435.3 324.9C444.7 334.2 444.7 349.4 435.3 358.8L412.6 381.5C403.3 390.8 388.1 390.9 378.7 381.5L224 227.5 69.3 381.5C59.9 390.9 44.7 390.8 35.4 381.5L12.7 358.8C3.3 349.4 3.3 334.2 12.7 324.9L207 130.5C216.4 121.2 231.6 121.2 241 130.5z"}]}}),H.register({child:{width:384,height:512,paths:[{d:"M120 72C120 32.2 152.2 0 192 0S264 32.2 264 72C264 111.8 231.8 144 192 144S120 111.8 120 72zM374.6 73.4C362.1 60.9 341.9 60.9 329.4 73.4L242.7 160H141.3L54.6 73.4C42.1 60.9 21.9 60.9 9.4 73.4-3.1 85.9-3.1 106.1 9.4 118.6L104 213.3V480C104 497.7 118.3 512 136 512H152C169.7 512 184 497.7 184 480V368H200V480C200 497.7 214.3 512 232 512H248C265.7 512 280 497.7 280 480V213.3L374.6 118.6C387.1 106.1 387.1 85.9 374.6 73.4z"}]}}),H.register({"circle-notch":{width:512,height:512,paths:[{d:"M288 39.1V55.7C288 66.5 295.3 75.9 305.7 78.8 383.2 100.4 440 171.5 440 256 440 357.7 357.7 440 256 440 154.3 440 72 357.7 72 256 72 171.5 128.8 100.4 206.3 78.8 216.7 75.9 224 66.5 224 55.7V39.1C224 23.4 209.2 11.9 194 15.8 86.6 43.5 7.4 141.2 8 257.3 8.7 394.4 119.5 504.3 256.5 504 393.3 503.7 504 392.8 504 256 504 140.4 424.9 43.2 317.8 15.8 302.7 11.9 288 23.5 288 39.1z"}]}}),H.register({circle:{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8z"}]}}),H.register({"clipboard-check":{width:384,height:512,paths:[{d:"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM313.2 271.8L170.2 413.6C165.5 418.3 157.9 418.2 153.2 413.5L70.6 330.2C65.9 325.5 66 317.9 70.7 313.2L99.1 285C103.8 280.3 111.4 280.4 116.1 285.1L162.1 331.5 268.1 226.3C272.8 221.6 280.4 221.7 285.1 226.4L313.3 254.8C318 259.6 317.9 267.1 313.2 271.8z"}]}}),H.register({"clipboard-list":{width:384,height:512,paths:[{d:"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM96 424C82.7 424 72 413.3 72 400S82.7 376 96 376 120 386.7 120 400 109.3 424 96 424zM96 328C82.7 328 72 317.3 72 304S82.7 280 96 280 120 290.7 120 304 109.3 328 96 328zM96 232C82.7 232 72 221.3 72 208S82.7 184 96 184 120 194.7 120 208 109.3 232 96 232zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM320 408C320 412.4 316.4 416 312 416H168C163.6 416 160 412.4 160 408V392C160 387.6 163.6 384 168 384H312C316.4 384 320 387.6 320 392V408zM320 312C320 316.4 316.4 320 312 320H168C163.6 320 160 316.4 160 312V296C160 291.6 163.6 288 168 288H312C316.4 288 320 291.6 320 296V312zM320 216C320 220.4 316.4 224 312 224H168C163.6 224 160 220.4 160 216V200C160 195.6 163.6 192 168 192H312C316.4 192 320 195.6 320 200V216z"}]}}),H.register({clipboard:{width:384,height:512,paths:[{d:"M384 112V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H128C128 28.7 156.7 0 192 0S256 28.7 256 64H336C362.5 64 384 85.5 384 112zM192 40C178.7 40 168 50.7 168 64S178.7 88 192 88 216 77.3 216 64 205.3 40 192 40M288 154V134A6-6 0 0 1 282 128H102A6-6 0 0 1 96 134V154A6-6 0 0 1 102 160H282A6-6 0 0 1 288 154z"}]}}),H.register({clock:{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM313.1 358.1L224.9 294C221.8 291.7 220 288.1 220 284.3V116C220 109.4 225.4 104 232 104H280C286.6 104 292 109.4 292 116V253.7L355.5 299.9C360.9 303.8 362 311.3 358.1 316.7L329.9 355.5C326 360.8 318.5 362 313.1 358.1z"}]}}),H.register({clone:{width:512,height:512,paths:[{d:"M464 0C490.5 0 512 21.5 512 48V336C512 362.5 490.5 384 464 384H176C149.5 384 128 362.5 128 336V48C128 21.5 149.5 0 176 0H464M176 416C131.9 416 96 380.1 96 336V128H48C21.5 128 0 149.5 0 176V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V416H176z"}]}}),H.register({"closed-captioning":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM218.1 287.7C220.9 285.2 225.2 285.6 227.3 288.6L246.8 316.3C248.5 318.7 248.3 321.9 246.3 324 192.7 380.8 73.5 356.1 73.5 256.1 73.5 158.8 195.2 136.6 246 186 248.1 188 248.5 189.2 247 191.7L229.5 222.2C227.6 225.3 223.3 226.2 220.4 223.9 179.6 191.9 125.8 209 125.8 255.1 125.9 303.1 176.9 325.6 218.1 287.7zM408.5 287.7C411.3 285.2 415.6 285.6 417.7 288.6L437.2 316.3C438.9 318.7 438.7 321.9 436.7 324 383.2 380.9 264 356.1 264 256.1 264 158.8 385.7 136.6 436.5 186 438.6 188 439 189.2 437.5 191.7L420 222.2C418.1 225.3 413.8 226.2 410.9 223.9 370.1 191.9 316.3 209 316.3 255.1 316.3 303.1 367.3 325.6 408.5 287.7z"}]}}),H.register({"cloud-download-alt":{width:640,height:512,paths:[{d:"M640 352C640 422.7 582.7 480 512 480H144C64.5 480 0 415.5 0 336 0 273.2 40.2 219.8 96.2 200.1A163.7-163.7 0 0 0 96 192C96 103.6 167.6 32 256 32 315.3 32 367 64.2 394.7 112.2 409.9 102 428.3 96 448 96 501 96 544 139 544 192 544 204.2 541.7 215.8 537.6 226.6 596 238.4 640 290.1 640 352zM393.4 288H328V176C328 167.2 320.8 160 312 160H264C255.2 160 248 167.2 248 176V288H182.6C168.4 288 161.2 305.2 171.3 315.3L276.7 420.7C282.9 426.9 293.1 426.9 299.3 420.7L404.7 315.3C414.8 305.2 407.6 288 393.4 288z"}]}}),H.register({"cloud-upload-alt":{width:640,height:512,paths:[{d:"M640 352C640 422.7 582.7 480 512 480H144C64.5 480 0 415.5 0 336 0 273.2 40.2 219.8 96.2 200.1A163.7-163.7 0 0 0 96 192C96 103.6 167.6 32 256 32 315.3 32 367 64.2 394.7 112.2 409.9 102 428.3 96 448 96 501 96 544 139 544 192 544 204.2 541.7 215.8 537.6 226.6 596 238.4 640 290.1 640 352zM404.7 260.7L299.3 155.3C293.1 149.1 282.9 149.1 276.7 155.3L171.3 260.7C161.2 270.8 168.4 288 182.6 288H248V400C248 408.8 255.2 416 264 416H312C320.8 416 328 408.8 328 400V288H393.4C407.6 288 414.8 270.8 404.7 260.7z"}]}}),H.register({cloud:{width:640,height:512,paths:[{d:"M537.6 226.6C541.7 215.8 544 204.2 544 192 544 139 501 96 448 96 428.3 96 409.9 102 394.7 112.2 367 64.2 315.3 32 256 32 167.6 32 96 103.6 96 192 96 194.7 96.1 197.4 96.2 200.1 40.2 219.8 0 273.2 0 336 0 415.5 64.5 480 144 480H512C582.7 480 640 422.7 640 352 640 290.1 596 238.4 537.6 226.6z"}]}}),H.register({"code-branch":{width:384,height:512,paths:[{d:"M384 144C384 99.8 348.2 64 304 64S224 99.8 224 144C224 180.4 248.3 211.1 281.5 220.8 280.9 236.9 277.3 249.3 270.5 257.7 255.1 276.9 221.2 280.1 185.3 283.4 157.1 286 127.9 288.8 104 300.3V156.3C136.5 146.1 160 115.8 160 80 160 35.8 124.2 0 80 0S0 35.8 0 80C0 115.8 23.5 146.1 56 156.3V355.6C23.5 365.9 0 396.2 0 432 0 476.2 35.8 512 80 512S160 476.2 160 432C160 398 138.8 368.9 108.8 357.4 111.9 352.2 116.6 347.6 123.7 344 139.9 335.8 164.1 333.6 189.8 331.2 232 327.3 279.8 322.8 308 287.8 322 270.4 329.1 248 329.6 219.9 361.2 209.1 384 179.2 384 144zM80 64C88.8 64 96 71.2 96 80S88.8 96 80 96 64 88.8 64 80 71.2 64 80 64zM80 448C71.2 448 64 440.8 64 432S71.2 416 80 416 96 423.2 96 432 88.8 448 80 448zM304 128C312.8 128 320 135.2 320 144S312.8 160 304 160 288 152.8 288 144 295.2 128 304 128z"}]}}),H.register({code:{width:640,height:512,paths:[{d:"M278.9 511.5L217.9 493.8C211.5 492 207.9 485.3 209.7 478.9L346.2 8.7C348 2.3 354.7-1.3 361.1 0.5L422.1 18.2C428.5 20 432.1 26.7 430.3 33.1L293.8 503.3C291.9 509.7 285.3 513.4 278.9 511.5zM164.9 399.3L208.4 352.9C213 348 212.7 340.2 207.6 335.7L117 256 207.6 176.3C212.7 171.8 213.1 164 208.4 159.1L164.9 112.7C160.4 107.9 152.8 107.6 147.9 112.2L3.8 247.2C-1.3 251.9-1.3 260 3.8 264.7L147.9 399.8C152.8 404.4 160.4 404.2 164.9 399.3zM492.1 399.9L636.2 264.8C641.3 260.1 641.3 252 636.2 247.3L492.1 112.1C487.3 107.6 479.7 107.8 475.1 112.6L431.6 159C427 163.9 427.3 171.7 432.4 176.2L523 256 432.4 335.7C427.3 340.2 426.9 348 431.6 352.9L475.1 399.3C479.6 404.2 487.2 404.4 492.1 399.9z"}]}}),H.register({coffee:{width:640,height:512,paths:[{d:"M192 384H384C437 384 480 341 480 288H512C582.6 288 640 230.6 640 160S582.6 32 512 32H120C106.7 32 96 42.7 96 56V288C96 341 139 384 192 384zM512 96C547.3 96 576 124.7 576 160S547.3 224 512 224H480V96H512zM559.7 480H48.3C0.7 480-12.7 416 12.3 416H595.6C620.6 416 607.4 480 559.7 480z"}]}}),H.register({cog:{width:512,height:512,paths:[{d:"M444.8 291.1L487.4 315.7C492.3 318.5 494.5 324.3 492.9 329.7 481.8 365.3 462.9 397.5 438.2 424.3A12-12 0 0 0 423.3 426.5L380.8 401.9A191.6-191.6 0 0 0 320 437.1V486.2A12-12 0 0 0 310.6 498C275.7 505.8 238.1 506.2 201.4 498 195.9 496.7 192 491.9 192 486.2V437.1A191.6-191.6 0 0 0 131.2 401.9L88.7 426.5A12-12 0 0 0 73.8 424.3C49.1 397.5 30.2 365.3 19.1 329.7 17.5 324.3 19.7 318.5 24.6 315.7L67.2 291.1A193.5-193.5 0 0 0 67.2 220.9L24.6 196.3C19.7 193.5 17.5 187.7 19.1 182.3 30.2 146.7 49.1 114.5 73.8 87.7A12-12 0 0 0 88.7 85.5L131.2 110.1A191.6-191.6 0 0 0 192 74.9V25.8A12-12 0 0 0 201.4 14C236.3 6.2 273.9 5.8 310.6 14 316.1 15.3 320 20.1 320 25.8V74.9A191.6-191.6 0 0 0 380.8 110.1L423.3 85.5A12-12 0 0 0 438.2 87.7C462.9 114.5 481.8 146.7 492.9 182.3 494.5 187.7 492.3 193.5 487.4 196.3L444.8 220.9A193.5-193.5 0 0 0 444.8 291.1zM336 256C336 211.9 300.1 176 256 176S176 211.9 176 256 211.9 336 256 336 336 300.1 336 256z"}]}}),H.register({cogs:{width:640,height:512,paths:[{d:"M512.1 191L503.9 205.3C500.9 210.6 494.5 212.8 488.8 210.7 477 206.3 466.2 200 456.7 192.1 452.1 188.3 450.9 181.6 453.9 176.4L462.1 162.1C455.2 154.1 449.8 144.8 446.2 134.7H429.7C423.7 134.7 418.5 130.4 417.5 124.4 415.5 112.4 415.4 99.8 417.5 87.3 418.5 81.3 423.7 76.9 429.7 76.9H446.2C449.8 66.8 455.2 57.5 462.1 49.5L453.9 35.2C450.9 30 452 23.3 456.7 19.5 466.2 11.6 477.1 5.3 488.8 0.9 494.5-1.2 500.9 1 503.9 6.3L512.1 20.6C522.6 18.7 533.3 18.7 543.8 20.6L552 6.3C555 1 561.4-1.2 567.1 0.9 578.9 5.3 589.7 11.6 599.2 19.5 603.8 23.3 605 30 602 35.2L593.8 49.5C600.7 57.5 606.1 66.8 609.7 76.9H626.2C632.2 76.9 637.4 81.2 638.4 87.2 640.4 99.2 640.5 111.8 638.4 124.3 637.4 130.3 632.2 134.7 626.2 134.7H609.7C606.1 144.8 600.7 154.1 593.8 162.1L602 176.4C605 181.6 603.9 188.3 599.2 192.1 589.7 200 578.8 206.3 567.1 210.7 561.4 212.8 555 210.6 552 205.3L543.8 191C533.4 192.9 522.6 192.9 512.1 191zM501.6 132.2C540.1 161.8 584 117.9 554.4 79.4 515.9 49.7 472 93.7 501.6 132.2zM386.3 286.1L420 302.9C430.1 308.7 434.5 321 430.5 332 421.6 356.2 404.1 378.4 387.9 397.8 380.5 406.7 367.7 408.9 357.6 403.1L328.5 386.3C312.5 400 293.9 410.9 273.6 418V451.6C273.6 463.2 265.3 473.2 253.9 475.2 229.3 479.4 203.5 479.6 178 475.2 166.5 473.2 158 463.3 158 451.6V418C137.7 410.8 119.1 400 103.1 386.3L74 403C64 408.8 51.1 406.6 43.7 397.7 27.5 378.3 10.4 356.1 1.5 332-2.5 321.1 1.9 308.8 12 302.9L45.3 286.1C41.4 265.2 41.4 243.7 45.3 222.7L12 205.8C1.9 200-2.6 187.7 1.5 176.8 10.4 152.6 27.5 130.4 43.7 111 51.1 102.1 63.9 99.9 74 105.7L103.1 122.5C119.1 108.8 137.7 97.9 158 90.8V57.1C158 45.6 166.2 35.6 177.6 33.6 202.2 29.4 228.1 29.2 253.6 33.5 265.1 35.5 273.6 45.4 273.6 57.1V90.7C293.9 97.9 312.5 108.7 328.5 122.4L357.6 105.6C367.6 99.8 380.5 102 387.9 110.9 404.1 130.3 421.1 152.5 430 176.7 434 187.6 430.1 199.9 420 205.8L386.3 222.6C390.2 243.6 390.2 265.1 386.3 286.1zM268.7 307.2C327.9 230.2 240 142.3 163 201.5 103.8 278.5 191.7 366.4 268.7 307.2zM512.1 489.9L503.9 504.2C500.9 509.5 494.5 511.7 488.8 509.6 477 505.2 466.2 498.9 456.7 491 452.1 487.2 450.9 480.5 453.9 475.3L462.1 461C455.2 453 449.8 443.7 446.2 433.6H429.7C423.7 433.6 418.5 429.3 417.5 423.3 415.5 411.3 415.4 398.7 417.5 386.2 418.5 380.2 423.7 375.8 429.7 375.8H446.2C449.8 365.7 455.2 356.4 462.1 348.4L453.9 334.1C450.9 328.9 452 322.2 456.7 318.4 466.2 310.5 477.1 304.2 488.8 299.8 494.5 297.7 500.9 299.9 503.9 305.2L512.1 319.5C522.6 317.6 533.3 317.6 543.8 319.5L552 305.2C555 299.9 561.4 297.7 567.1 299.8 578.9 304.2 589.7 310.5 599.2 318.4 603.8 322.2 605 328.9 602 334.1L593.8 348.4C600.7 356.4 606.1 365.7 609.7 375.8H626.2C632.2 375.8 637.4 380.1 638.4 386.1 640.4 398.1 640.5 410.7 638.4 423.2 637.4 429.2 632.2 433.6 626.2 433.6H609.7C606.1 443.7 600.7 453 593.8 461L602 475.3C605 480.5 603.9 487.2 599.2 491 589.7 498.9 578.8 505.2 567.1 509.6 561.4 511.7 555 509.5 552 504.2L543.8 489.9C533.4 491.8 522.6 491.8 512.1 489.9zM501.6 431C540.1 460.6 584 416.7 554.4 378.2 515.9 348.6 472 392.5 501.6 431z"}]}}),H.register({columns:{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM224 416H64V160H224V416zM448 416H288V160H448V416z"}]}}),H.register({"comment-alt":{width:512,height:512,paths:[{d:"M448 0H64C28.7 0 0 28.7 0 64V352C0 387.3 28.7 416 64 416H160V500C160 509.8 171.2 515.5 179.1 509.7L304 416H448C483.3 416 512 387.3 512 352V64C512 28.7 483.3 0 448 0z"}]}}),H.register({"comment-dots":{width:512,height:512,paths:[{d:"M256 32C114.6 32 0 125.1 0 240 0 289.6 21.4 335 57 370.7 44.5 421.1 2.7 466 2.2 466.5 0 468.8-0.6 472.2 0.7 475.2S4.8 480 8 480C74.3 480 124 448.2 148.6 428.6 181.3 440.9 217.6 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32zM128 272C110.3 272 96 257.7 96 240S110.3 208 128 208 160 222.3 160 240 145.7 272 128 272zM256 272C238.3 272 224 257.7 224 240S238.3 208 256 208 288 222.3 288 240 273.7 272 256 272zM384 272C366.3 272 352 257.7 352 240S366.3 208 384 208 416 222.3 416 240 401.7 272 384 272z"}]}}),H.register({"comment-slash":{width:640,height:512,paths:[{d:"M64 240C64 289.6 85.4 335 121 370.7 108.4 421 66.7 465.9 66.2 466.5 64 468.8 63.4 472.2 64.7 475.2 66 478.1 68.8 480 72 480 138.3 480 188 448.2 212.6 428.6 245.3 440.9 281.6 448 320 448 347.4 448 373.7 444.4 398.4 438L72.9 186.4C67.3 203.5 64 221.4 64 240zM633.8 458.1L519.4 369.7C554.6 334.1 576 289.2 576 240 576 125.1 461.4 32 320 32 254.9 32 195.8 52.1 150.6 84.7L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1z"}]}}),H.register({comment:{width:512,height:512,paths:[{d:"M256 32C114.6 32 0 125.1 0 240 0 289.6 21.4 335 57 370.7 44.5 421.1 2.7 466 2.2 466.5 0 468.8-0.6 472.2 0.7 475.2S4.8 480 8 480C74.3 480 124 448.2 148.6 428.6 181.3 440.9 217.6 448 256 448 397.4 448 512 354.9 512 240S397.4 32 256 32z"}]}}),H.register({comments:{width:576,height:512,paths:[{d:"M416 192C416 103.6 322.9 32 208 32S0 103.6 0 192C0 226.3 14.1 257.9 38 284 24.6 314.2 2.5 338.2 2.2 338.5 0 340.8-0.6 344.2 0.7 347.2S4.8 352 8 352C44.6 352 74.9 339.7 96.7 327 128.9 342.7 167 352 208 352 322.9 352 416 280.4 416 192zM538 412C561.9 386 576 354.3 576 320 576 253.1 522.5 195.8 446.7 171.9 447.6 178.5 448 185.2 448 192 448 297.9 340.3 384 208 384 197.2 384 186.7 383.2 176.3 382.1 207.8 439.6 281.8 480 368 480 409 480 447.1 470.8 479.3 455 501.1 467.7 531.4 480 568 480 571.2 480 574.1 478.1 575.3 475.2 576.6 472.3 576 468.9 573.8 466.5 573.5 466.2 551.4 442.3 538 412z"}]}}),H.register({compass:{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM307.4 120.8L204.8 218.6A24-24 0 0 1 198 230.4L164.7 368.1C159 391.6 187.5 407.4 204.6 391.2L307.2 293.4A24-24 0 0 1 314 281.6L347.3 143.9C352.9 120.7 324.7 104.4 307.4 120.8zM256 224C238.3 224 224 238.3 224 256S238.3 288 256 288 288 273.7 288 256 273.7 224 256 224z"}]}}),H.register({compress:{width:448,height:512,paths:[{d:"M436 192H312C298.7 192 288 181.3 288 168V44C288 37.4 293.4 32 300 32H340C346.6 32 352 37.4 352 44V128H436C442.6 128 448 133.4 448 140V180C448 186.6 442.6 192 436 192zM160 168V44C160 37.4 154.6 32 148 32H108C101.4 32 96 37.4 96 44V128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H136C149.3 192 160 181.3 160 168zM160 468V344C160 330.7 149.3 320 136 320H12C5.4 320 0 325.4 0 332V372C0 378.6 5.4 384 12 384H96V468C96 474.6 101.4 480 108 480H148C154.6 480 160 474.6 160 468zM352 468V384H436C442.6 384 448 378.6 448 372V332C448 325.4 442.6 320 436 320H312C298.7 320 288 330.7 288 344V468C288 474.6 293.4 480 300 480H340C346.6 480 352 474.6 352 468z"}]}}),H.register({copy:{width:448,height:512,paths:[{d:"M320 448V488C320 501.3 309.3 512 296 512H24C10.7 512 0 501.3 0 488V120C0 106.7 10.7 96 24 96H96V392C96 422.9 121.1 448 152 448H320zM320 104V0H152C138.7 0 128 10.7 128 24V392C128 405.3 138.7 416 152 416H424C437.3 416 448 405.3 448 392V128H344C330.8 128 320 117.2 320 104zM441 73L375 7A24-24 0 0 1 358.1 0H352V96H448V89.9A24-24 0 0 1 441 73z"}]}}),H.register({copyright:{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM373.1 354.8C371.5 356.6 333.4 400.5 263.3 400.5 178.6 400.5 118.8 337.2 118.8 254.9 118.8 173.6 180.8 111.5 262.6 111.5 329.5 111.5 364.5 148.8 366 150.4A12-12 0 0 0 367.2 165L344.8 199.7C340.8 206 332.1 207 326.6 202 326.4 201.8 300.1 178.1 264.7 178.1 218.6 178.1 190.8 211.7 190.8 254.2 190.8 293.8 216.3 333.9 265.1 333.9 303.8 333.9 330.4 305.5 330.6 305.3 335.8 299.7 344.7 300.2 349.1 306.3L373.7 339.9A12-12 0 0 0 373.1 354.8z"}]}}),H.register({couch:{width:640,height:512,paths:[{d:"M160 224V288H480V224C480 188.7 508.7 160 544 160H576C576 107 533 64 480 64H160C107 64 64 107 64 160H96C131.3 160 160 188.7 160 224zM576 192H544C526.3 192 512 206.3 512 224V320H128V224C128 206.3 113.7 192 96 192H64C28.7 192 0 220.7 0 256 0 279.6 13 300 32 311.1V432C32 440.8 39.2 448 48 448H112C120.8 448 128 440.8 128 432V416H512V432C512 440.8 519.2 448 528 448H592C600.8 448 608 440.8 608 432V311.1C627 300 640 279.6 640 256 640 220.7 611.3 192 576 192z"}]}}),H.register({"credit-card":{width:576,height:512,paths:[{d:"M0 432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V256H0V432zM192 364C192 357.4 197.4 352 204 352H340C346.6 352 352 357.4 352 364V404C352 410.6 346.6 416 340 416H204C197.4 416 192 410.6 192 404V364zM64 364C64 357.4 69.4 352 76 352H148C154.6 352 160 357.4 160 364V404C160 410.6 154.6 416 148 416H76C69.4 416 64 410.6 64 404V364zM576 80V128H0V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80z"}]}}),H.register({crop:{width:512,height:512,paths:[{d:"M488 352H448V109.3L505 52.3C514.4 42.9 514.4 27.7 505 18.4L493.7 7C484.3-2.4 469.1-2.4 459.8 7L402.8 64H160V24C160 10.7 149.3 0 136 0H88C74.7 0 64 10.7 64 24V64H24C10.7 64 0 74.7 0 88V136C0 149.3 10.7 160 24 160H64V424C64 437.3 74.7 448 88 448H352V488C352 501.3 362.7 512 376 512H424C437.3 512 448 501.3 448 488V448H488C501.3 448 512 437.3 512 424V376C512 362.7 501.3 352 488 352zM306.7 160L160 306.7V160H306.7zM205.3 352L352 205.3V352H205.3z"}]}}),H.register({crosshairs:{width:512,height:512,paths:[{d:"M500 224H469.6C455.7 130.3 381.7 56.3 288 42.4V12C288 5.4 282.6 0 276 0H236C229.4 0 224 5.4 224 12V42.4C130.3 56.3 56.3 130.3 42.4 224H12C5.4 224 0 229.4 0 236V276C0 282.6 5.4 288 12 288H42.4C56.3 381.7 130.3 455.7 224 469.6V500C224 506.6 229.4 512 236 512H276C282.6 512 288 506.6 288 500V469.6C381.7 455.7 455.7 381.7 469.6 288H500C506.6 288 512 282.6 512 276V236C512 229.4 506.6 224 500 224zM288 404.6V364C288 357.4 282.6 352 276 352H236C229.4 352 224 357.4 224 364V404.6C165.8 392.2 119.8 346.2 107.4 288H148C154.6 288 160 282.6 160 276V236C160 229.4 154.6 224 148 224H107.4C119.8 165.8 165.8 119.8 224 107.4V148C224 154.6 229.4 160 236 160H276C282.6 160 288 154.6 288 148V107.4C346.2 119.8 392.2 165.8 404.6 224H364C357.4 224 352 229.4 352 236V276C352 282.6 357.4 288 364 288H404.6C392.2 346.2 346.2 392.2 288 404.6zM288 256C288 273.7 273.7 288 256 288S224 273.7 224 256C224 238.3 238.3 224 256 224S288 238.3 288 256z"}]}}),H.register({cube:{width:512,height:512,paths:[{d:"M239.1 6.3L31.1 84.3C12.4 91.3 0 109.3 0 129.3V354.4C0 372.6 10.3 389.2 26.5 397.3L234.5 501.3C248 508.1 263.9 508.1 277.4 501.3L485.4 397.3C501.7 389.2 511.9 372.5 511.9 354.4V129.3C511.9 109.3 499.5 91.4 480.8 84.4L272.8 6.4C262 2.2 250 2.2 239.1 6.3zM256 68.4L448 140.4V141.5L256 219.5 64 141.5V140.4L256 68.4zM288 424.4V275.5L448 210.5V344.4L288 424.4z"}]}}),H.register({cubes:{width:512,height:512,paths:[{d:"M488.6 250.2L392 214V105.5C392 90.5 382.7 77.1 368.6 71.8L268.6 34.3C260.5 31.2 251.5 31.2 243.3 34.3L143.3 71.8C129.2 77.1 119.9 90.5 119.9 105.5V214L23.3 250.2C9.3 255.5 0 268.9 0 283.9V394C0 407.6 7.7 420.1 19.9 426.2L119.9 476.2C130 481.3 142 481.3 152.1 476.2L256 424.2 359.9 476.2C370 481.3 382 481.3 392.1 476.2L492.1 426.2C504.3 420.1 512 407.6 512 394V283.9C512 268.9 502.7 255.5 488.6 250.2zM358 214.8L273 246.7V178.5L358 141.5V214.8zM154 104.1L256 65.9 358 104.1V104.7L256 146.1 154 104.7V104.1zM238 395.2L153 437.7V358.6L238 319.8V395.2zM238 283.2L136 324.6 34 283.2V282.6L136 244.4 238 282.6V283.2zM478 395.2L393 437.7V358.6L478 319.8V395.2zM478 283.2L376 324.6 274 283.2V282.6L376 244.4 478 282.6V283.2z"}]}}),H.register({cut:{width:448,height:512,paths:[{d:"M444.5 422.4C449.2 427.1 449.2 434.7 444.5 439.4 411.7 472.2 358.5 472.2 325.7 439.4L210.2 323.9 185.3 348.7C189.6 359.7 192 371.6 192 384 192 437 149 480 96 480S0 437 0 384 43 288 96 288C100.5 288 105 288.3 109.4 288.9L142.3 256 109.4 223.1C105 223.7 100.5 224 96 224 43 224 0 181 0 128S43 32 96 32 192 75 192 128C192 140.4 189.6 152.3 185.3 163.3L210.2 188.1 325.7 72.6C358.5 39.8 411.7 39.8 444.5 72.6 449.2 77.3 449.2 84.9 444.5 89.6L278.1 256 444.5 422.4zM96 96C78.4 96 64 110.4 64 128S78.4 160 96 160 128 145.6 128 128 113.6 96 96 96M96 352C78.4 352 64 366.4 64 384S78.4 416 96 416 128 401.6 128 384 113.6 352 96 352M208 244C201.4 244 196 249.4 196 256S201.4 268 208 268 220 262.6 220 256 214.6 244 208 244z"}]}}),H.register({database:{width:448,height:512,paths:[{d:"M448 73.1V118.9C448 159.1 347.7 192 224 192S0 159.1 0 118.9V73.1C0 32.9 100.3 0 224 0S448 32.9 448 73.1zM448 176V278.9C448 319.1 347.7 352 224 352S0 319.1 0 278.9V176C48.1 209.1 136.2 224.6 224 224.6S399.9 209.1 448 176zM448 336V438.9C448 479.1 347.7 512 224 512S0 479.1 0 438.9V336C48.1 369.1 136.2 384.6 224 384.6S399.9 369.1 448 336z"}]}}),H.register({deaf:{width:512,height:512,paths:[{d:"M216 260C216 275.5 203.5 288 188 288S160 275.5 160 260C160 215.9 195.9 180 240 180S320 215.9 320 260C320 275.5 307.5 288 292 288S264 275.5 264 260C264 246.8 253.2 236 240 236S216 246.8 216 260zM240 84C143 84 64 163 64 260 64 275.5 76.5 288 92 288S120 275.5 120 260C120 193.8 173.8 140 240 140S360 193.8 360 260C360 335.2 289 330.3 288 403.6L288 404C288 432.7 264.7 456 236 456 220.5 456 208 468.5 208 484S220.5 512 236 512C295.5 512 343.9 463.7 344 404.2 344.6 369.8 416 356 416 260 416 163 337 84 240 84zM508.5 31.8L480.2 3.5C475.5-1.2 467.9-1.2 463.2 3.5L376.2 90.5C371.5 95.2 371.5 102.8 376.2 107.5L404.5 135.8C409.2 140.5 416.8 140.5 421.5 135.8L508.5 48.8C513.2 44.1 513.2 36.5 508.5 31.8zM169 314.7C164.3 310.1 156.7 310.1 152 314.7L3.5 463.2C-1.2 467.9-1.2 475.5 3.5 480.2L31.8 508.5C36.5 513.2 44.1 513.2 48.8 508.5L197.3 360C201.9 355.3 201.9 347.7 197.3 343L169 314.7z"}]}}),H.register({desktop:{width:576,height:512,paths:[{d:"M528 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H240L224 464H152C138.7 464 128 474.7 128 488S138.7 512 152 512H424C437.3 512 448 501.3 448 488S437.3 464 424 464H352L336 416H528C554.5 416 576 394.5 576 368V48C576 21.5 554.5 0 528 0zM512 352H64V64H512V352z"}]}}),H.register({diagnoses:{width:640,height:512,paths:[{d:"M496 256C504.8 256 512 248.8 512 240S504.8 224 496 224 480 231.2 480 240 487.2 256 496 256zM320 176C368.5 176 408 136.5 408 88S368.5 0 320 0 232 39.5 232 88 271.5 176 320 176zM59.8 364C70 379.3 89.1 381.8 102.7 373.8 118.9 364.2 158.9 342.1 208 325.2V416H432V325.3C481.1 342.1 521.1 364.3 537.3 373.9 550.9 381.9 570 379.2 580.2 364.1L598 337.4C606.8 324.2 605.6 302.8 588 292.3 576.1 285.2 558.3 275.3 536.9 264.9 508.8 311 437.5 282.7 449.2 229.8 409.3 217.2 365.1 208 320 208 263 208 207.1 222.5 160 240.2 159.8 280.4 112.4 303.5 80.8 276.2 69.6 282.2 59.5 287.8 52.1 292.2 34.5 302.7 33.3 324 42.1 337.3L59.8 364zM368 344C381.3 344 392 354.7 392 368S381.3 392 368 392 344 381.3 344 368 354.7 344 368 344zM272 248C285.3 248 296 258.7 296 272S285.3 296 272 296 248 285.3 248 272 258.7 248 272 248zM112 256C120.8 256 128 248.8 128 240S120.8 224 112 224 96 231.2 96 240 103.2 256 112 256zM624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448z"}]}}),H.register({dna:{width:448,height:512,paths:[{d:"M447.9 17.9C449 8.4 441.6 0.1 432 0.1L399.6 0C391.5 0 384.7 5.9 383.6 13.9 382.9 18.8 381.8 25 380.2 32H67.9C66.3 25.1 65 18.8 64.4 13.9 63.3 5.9 56.5-0.1 48.4 0L16.1 0.1C6.5 0.1-1 8.4 0.1 17.9 4.7 55.8 25.7 146.9 119 225.6 136.6 213.2 156.1 201.4 177.5 190.2 171.3 185.6 166.1 180.8 160.5 176H288.1C266.8 194.1 241.1 211.6 209.4 227.4 37.5 312.9 5.9 446.2 0.1 494.1-1 503.6 6.4 511.9 16 511.9L48.3 512C56.4 512 63.2 506.1 64.3 498.1 65 493.2 66.1 487 67.7 480H380.1C381.7 487 382.8 493.1 383.5 498.1 384.6 506.1 391.4 512.1 399.5 512L431.8 511.9C441.4 511.9 448.9 503.6 447.7 494.1 442.7 451.2 416.6 340.2 288 256 416.5 171.8 442.7 60.8 447.9 17.9zM224 292.4C249.1 306.1 270.4 320.8 288.3 336H159.7C177.6 320.8 198.9 306 224 292.4zM92.9 416C98.7 405.6 105.7 394.9 113.9 384H333.9C342.2 394.9 349.2 405.6 354.9 416H92.9zM355.1 96C349.3 106.4 342.3 117.1 334.1 128H114.6C106.3 117.1 99.2 106.4 93.4 96H355.1z"}]}}),H.register({"dollar-sign":{width:288,height:512,paths:[{d:"M209.2 233.4L101.2 201.8C88.7 198.2 80 186.5 80 173.5 80 157.2 93.2 144 109.5 144H175.8C188 144 200 147.7 210 154.5 216.1 158.6 224.3 157.6 229.5 152.5L264.3 118.5C271.4 111.6 270.4 100.1 262.5 94 238 74.8 207.4 64.1 176 64V16C176 7.2 168.8 0 160 0H128C119.2 0 112 7.2 112 16V64H109.5C45.8 64-5.4 118.7 0.5 183.6 4.7 229.7 39.9 267.2 84.3 280.2L186.8 310.2C199.3 313.9 208 325.5 208 338.5 208 354.8 194.8 368 178.5 368H112.2C100 368 88 364.3 78 357.5 71.9 353.4 63.7 354.4 58.5 359.5L23.7 393.5C16.6 400.4 17.6 411.9 25.5 418 50 437.2 80.6 447.9 112 448V496C112 504.8 119.2 512 128 512H160C168.8 512 176 504.8 176 496V447.8C222.6 446.9 266.3 419.2 281.7 375.1 303.2 313.5 267.1 250.3 209.2 233.4z"}]}}),H.register({"dolly-flatbed":{width:640,height:512,paths:[{d:"M208 320H592C600.8 320 608 312.8 608 304V48C608 39.2 600.8 32 592 32H448V160L400 128 352 160V32H208C199.2 32 192 39.2 192 48V304C192 312.8 199.2 320 208 320zM624 384H128V16C128 7.2 120.8 0 112 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H64V432C64 440.8 71.2 448 80 448H162.9C161.1 453 160 458.4 160 464 160 490.5 181.5 512 208 512S256 490.5 256 464C256 458.4 254.8 453 253.1 448H451C449.2 453 448.1 458.4 448.1 464 448.1 490.5 469.6 512 496.1 512S544.1 490.5 544.1 464C544.1 458.4 542.9 453 541.2 448H624C632.8 448 640 440.8 640 432V400C640 391.2 632.8 384 624 384z"}]}}),H.register({dolly:{width:576,height:512,paths:[{d:"M294.2 277.7C312.2 282.7 328.9 291.1 343.7 302.4L505.2 248.6C513.6 245.8 518.1 236.7 515.3 228.4L454.9 47.2C452.1 38.8 443 34.3 434.7 37.1L373.6 57.5 406.7 156.9 346 177 312.9 77.6 251.3 98.1C242.9 100.9 238.4 110 241.2 118.3L294.2 277.7zM575.2 326.4L565 296C562.2 287.6 553.1 283.1 544.8 285.9L331.3 357.1C314.1 335.1 287.7 320.7 257.8 320.1L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H104.9L197.1 340.7C171 361.1 155.4 394.3 161.1 431.2 167.2 470.6 199 503.5 238.4 510.4 298.6 521.1 350.7 475.6 351.8 417.8L565.1 346.6C573.4 343.8 578 334.8 575.2 326.4zM256 464C229.5 464 208 442.5 208 416S229.5 368 256 368 304 389.5 304 416 282.5 464 256 464z"}]}}),H.register({donate:{width:512,height:512,paths:[{d:"M256 416C370.9 416 464 322.9 464 208S370.9 0 256 0 48 93.1 48 208 141.1 416 256 416zM233.8 97.4V80.6C233.8 71.4 241.2 64 250.4 64H261.5C270.7 64 278.1 71.4 278.1 80.6V97.6C293.6 98.4 308.6 103.7 321.1 113 326.7 117.1 327.3 125.3 322.3 130.1L306 145.6C302.2 149.3 296.5 149.4 292 146.6 286.6 143.2 280.6 141.5 274.2 141.5H235.3C226.3 141.5 219 149.7 219 159.8 219 168 224 175.3 231.1 177.4L293.4 196.1C319.1 203.8 337.1 228.5 337.1 256.2 337.1 290.2 310.7 317.7 278 318.6V335.4C278 344.6 270.6 352 261.4 352H250.3C241.1 352 233.7 344.6 233.7 335.4V318.4C218.2 317.6 203.2 312.3 190.7 303 185.1 298.9 184.5 290.7 189.5 285.9L205.8 270.4C209.6 266.7 215.3 266.6 219.8 269.4 225.2 272.8 231.2 274.5 237.6 274.5H276.5C285.5 274.5 292.8 266.3 292.8 256.2 292.8 248 287.8 240.7 280.7 238.6L218.4 219.9C192.7 212.2 174.7 187.5 174.7 159.8 174.8 125.8 201.1 98.3 233.8 97.4zM480 352H447.5C427.9 378 402.9 399.7 374.5 416H438.3C443.6 416 447.9 419.6 447.9 424V440C447.9 444.4 443.6 448 438.3 448H73.6C68.3 448 64 444.4 64 440V424C64 419.6 68.3 416 73.6 416H137.4C109 399.7 84.1 378 64.4 352H32C14.3 352 0 366.3 0 384V480C0 497.7 14.3 512 32 512H480C497.7 512 512 497.7 512 480V384C512 366.3 497.7 352 480 352z"}]}}),H.register({"dot-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM336 256C336 300.1 300.1 336 256 336S176 300.1 176 256 211.9 176 256 176 336 211.9 336 256z"}]}}),H.register({dove:{width:512,height:512,paths:[{d:"M288 167.2V139.1C259.8 102.8 240.9 59.8 233.9 13.9 231.8 0.4 214.9-4.9 206.1 5.6 185 30.5 168.4 59.7 157.2 92.1 191.4 130.4 237.2 156.7 288 167.2zM400 64C355.8 64 320 99.9 320 144.1V203.5C215.6 197.3 127 133 87 41.8 81.5 29.3 63.8 28.6 58 40.9 41.4 76 32 115.2 32 156.6 32 227.4 66.1 293.5 117.1 342.5 130.3 355.2 143.2 365.7 156 375.3L12.1 411.3C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512 163.8 512.3 171.8 509.4 177.9 504.1L243.1 448H320C408.4 448 480 376.5 480 288.1V128L512 64H400zM400 160.1C391.2 160.1 384 152.9 384 144.1S391.2 128.1 400 128.1 416 135.3 416 144.1 408.8 160.1 400 160.1z"}]}}),H.register({download:{width:512,height:512,paths:[{d:"M216 0H296C309.3 0 320 10.7 320 24V192H407.7C425.5 192 434.4 213.5 421.8 226.1L269.7 378.3C262.2 385.8 249.9 385.8 242.4 378.3L90.1 226.1C77.5 213.5 86.4 192 104.2 192H192V24C192 10.7 202.7 0 216 0zM512 376V488C512 501.3 501.3 512 488 512H24C10.7 512 0 501.3 0 488V376C0 362.7 10.7 352 24 352H170.7L219.7 401C239.8 421.1 272.2 421.1 292.3 401L341.3 352H488C501.3 352 512 362.7 512 376zM388 464C388 453 379 444 368 444S348 453 348 464 357 484 368 484 388 475 388 464zM452 464C452 453 443 444 432 444S412 453 412 464 421 484 432 484 452 475 452 464z"}]}}),H.register({edit:{width:576,height:512,paths:[{d:"M402.6 83.2L492.8 173.4C496.6 177.2 496.6 183.4 492.8 187.2L274.4 405.6 181.6 415.9C169.2 417.3 158.7 406.8 160.1 394.4L170.4 301.6 388.8 83.2C392.6 79.4 398.8 79.4 402.6 83.2zM564.6 60.3L515.8 11.5C500.6-3.7 475.9-3.7 460.6 11.5L425.2 46.9C421.4 50.7 421.4 56.9 425.2 60.7L515.4 150.9C519.2 154.7 525.4 154.7 529.2 150.9L564.6 115.5C579.8 100.2 579.8 75.5 564.6 60.3zM384 346.2V448H64V128H293.8C297 128 300 126.7 302.3 124.5L342.3 84.5C349.9 76.9 344.5 64 333.8 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V306.2C448 295.5 435.1 290.2 427.5 297.7L387.5 337.7C385.3 340 384 343 384 346.2z"}]}}),H.register({eject:{width:448,height:512,paths:[{d:"M448 384V448C448 465.7 433.7 480 416 480H32C14.3 480 0 465.7 0 448V384C0 366.3 14.3 352 32 352H416C433.7 352 448 366.3 448 384zM48.1 320H399.9C441.6 320 463.5 270.3 435.3 239.6L259.4 47.6C240.4 26.8 207.6 26.8 188.6 47.6L12.7 239.6C-15.5 270.3 6.3 320 48.1 320z"}]}}),H.register({"ellipsis-h":{width:512,height:512,paths:[{d:"M328 256C328 295.8 295.8 328 256 328S184 295.8 184 256 216.2 184 256 184 328 216.2 328 256zM432 184C392.2 184 360 216.2 360 256S392.2 328 432 328 504 295.8 504 256 471.8 184 432 184zM80 184C40.2 184 8 216.2 8 256S40.2 328 80 328 152 295.8 152 256 119.8 184 80 184z"}]}}),H.register({"ellipsis-v":{width:192,height:512,paths:[{d:"M96 184C135.8 184 168 216.2 168 256S135.8 328 96 328 24 295.8 24 256 56.2 184 96 184zM24 80C24 119.8 56.2 152 96 152S168 119.8 168 80 135.8 8 96 8 24 40.2 24 80zM24 432C24 471.8 56.2 504 96 504S168 471.8 168 432 135.8 360 96 360 24 392.2 24 432z"}]}}),H.register({"envelope-open":{width:512,height:512,paths:[{d:"M512 464C512 490.5 490.5 512 464 512H48C21.5 512 0 490.5 0 464V200.7A48-48 0 0 0 18.4 162.9C43.3 143.4 63.9 127.6 182.6 41.4 199.4 29.2 232.8-0.3 256 0 279.2-0.4 312.6 29.2 329.4 41.4 448.1 127.6 468.7 143.4 493.6 162.9A48-48 0 0 0 512 200.7V464zM446.3 267.4C443.8 263.7 438.6 262.8 435 265.5 412.1 282.4 379.5 306.2 329.4 342.6 312.6 354.8 279.2 384.3 256 384 232.8 384.3 199.4 354.9 182.6 342.6 132.5 306.2 99.9 282.4 77 265.5 73.4 262.8 68.2 263.7 65.7 267.4L56.6 280.6A8-8 0 0 1 58.4 291.6C81.3 308.5 113.9 332.2 163.7 368.4 184 383.2 220.3 416.2 256 416 291.7 416.2 328 383.2 348.3 368.4 398.1 332.2 430.7 308.5 453.6 291.6A8-8 0 0 1 455.4 280.6L446.3 267.4z"}]}}),H.register({"envelope-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM178.1 262.1C87.4 196.3 88.4 196.1 64 177.2V152C64 138.7 74.7 128 88 128H360C373.3 128 384 138.7 384 152V177.2C359.6 196.1 360.6 196.3 269.9 262.1 259.4 269.8 238.5 288.2 224 288 209.5 288.2 188.6 269.8 178.1 262.1zM384 217.8V360C384 373.3 373.3 384 360 384H88C74.7 384 64 373.3 64 360V217.8C78 228.6 97.3 243 159.3 288 173.5 298.3 197.3 320.1 224 320 250.9 320.1 275 298 288.7 288 350.7 243 370 228.6 384 217.8z"}]}}),H.register({envelope:{width:512,height:512,paths:[{d:"M502.3 190.8C506.2 187.7 512 190.6 512 195.5V400C512 426.5 490.5 448 464 448H48C21.5 448 0 426.5 0 400V195.6C0 190.6 5.7 187.8 9.7 190.9 32.1 208.3 61.8 230.4 163.8 304.5 184.9 319.9 220.5 352.3 256 352.1 291.7 352.4 328 319.3 348.3 304.5 450.3 230.4 479.9 208.2 502.3 190.8zM256 320C279.2 320.4 312.6 290.8 329.4 278.6 462.1 182.3 472.2 173.9 502.8 149.9 508.6 145.4 512 138.4 512 131V112C512 85.5 490.5 64 464 64H48C21.5 64 0 85.5 0 112V131C0 138.4 3.4 145.3 9.2 149.9 39.8 173.8 49.9 182.3 182.6 278.6 199.4 290.8 232.8 320.4 256 320z"}]}}),H.register({eraser:{width:512,height:512,paths:[{d:"M497.9 273.9C516.7 255.2 516.7 224.8 497.9 206.1L337.9 46.1C319.2 27.3 288.8 27.3 270.1 46.1L14.1 302.1C-4.7 320.8-4.7 351.2 14.1 369.9L110.1 465.9A48-48 0 0 1 144 480H500C506.6 480 512 474.6 512 468V428C512 421.4 506.6 416 500 416H355.9L497.9 273.9zM195.3 211.3L332.7 348.7 265.4 416H150.6L70.6 336 195.3 211.3z"}]}}),H.register({"euro-sign":{width:320,height:512,paths:[{d:"M310.7 413.8C309.4 407.1 302.9 402.9 296.3 404.4 285.6 406.8 268.9 409.8 250.9 409.8 194.1 409.8 148.9 375 129.4 324.4H243.1A12-12 0 0 1 254.8 315L261.2 286.6C262.9 279.1 257.1 272 249.5 272H115.2C114 257.7 113.8 243.7 115.4 229.8H261.9A12-12 0 0 1 273.7 220.3L280.2 190.6C281.8 183.1 276.1 176 268.5 176H130.2C150.8 131 192.9 101 247.8 101 262.3 101 276.4 103.2 285.7 105.1 291.9 106.4 298 102.6 299.7 96.5L311.6 52.1C313.5 45.4 309.2 38.5 302.3 37.2 290.2 34.9 270.7 32 249.6 32 152.5 32 74 92.3 45.1 176H12C5.4 176 0 181.4 0 188V217.8C0 224.4 5.4 229.8 12 229.8H33.6C32.6 243.4 32.4 259 33.4 272H12C5.4 272 0 277.4 0 284V312.4C0 319 5.4 324.4 12 324.4H42.1C67.1 414.7 145.3 480 249.6 480 275.9 480 298.2 475.5 310.7 472.2 316.9 470.6 320.8 464.5 319.5 458.3L310.7 413.8z"}]}}),H.register({"exchange-alt":{width:512,height:512,paths:[{d:"M0 168V152C0 138.7 10.7 128 24 128H384V80C384 58.6 409.9 48 425 63L505 143C514.3 152.4 514.3 167.6 505 177L425 257C410 272 384 261.5 384 240V192H24C10.7 192 0 181.3 0 168zM488 320H128V272C128 250.7 102.1 239.9 87 255L7 335C-2.3 344.4-2.3 359.6 7 369L87 449C102.1 464 128 453.4 128 432V384H488C501.3 384 512 373.3 512 360V344C512 330.7 501.3 320 488 320z"}]}}),H.register({"exclamation-circle":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256C8 119.1 119 8 256 8S504 119.1 504 256zM256 306C230.6 306 210 326.6 210 352S230.6 398 256 398 302 377.4 302 352 281.4 306 256 306zM212.3 140.7L219.7 276.7C220.1 283 225.4 288 231.7 288H280.3C286.6 288 291.9 283 292.3 276.7L299.7 140.7C300 133.8 294.6 128 287.7 128H224.3C217.4 128 212 133.8 212.3 140.7z"}]}}),H.register({"exclamation-triangle":{width:576,height:512,paths:[{d:"M569.5 440C588 472 564.8 512 527.9 512H48.1C11.1 512-11.9 471.9 6.5 440L246.4 24C264.9-8 311.1-8 329.6 24L569.5 440zM288 354C262.6 354 242 374.6 242 400S262.6 446 288 446 334 425.4 334 400 313.4 354 288 354zM244.3 188.7L251.7 324.7C252.1 331 257.4 336 263.7 336H312.3C318.6 336 323.9 331 324.3 324.7L331.7 188.7C332 181.8 326.6 176 319.7 176H256.3C249.4 176 244 181.8 244.3 188.7z"}]}}),H.register({exclamation:{width:192,height:512,paths:[{d:"M176 432C176 476.1 140.1 512 96 512S16 476.1 16 432 51.9 352 96 352 176 387.9 176 432zM25.3 25.2L38.9 297.2C39.5 310 50 320 62.8 320H129.2C142 320 152.5 310 153.1 297.2L166.7 25.2C167.4 11.5 156.5 0 142.8 0H49.2C35.5 0 24.6 11.5 25.3 25.2z"}]}}),H.register({"expand-arrows-alt":{width:448,height:512,paths:[{d:"M448.1 344V456C448.1 469.3 437.4 480 424.1 480H312.1C290.7 480 280 454.1 295.1 439L331.3 402.8 224 295.6 116.8 402.9 153 439C168.1 454.1 157.4 480 136 480H24C10.7 480 0 469.3 0 456V344C0 322.6 25.9 311.9 41 327L77.2 363.2 184.5 256 77.2 148.7 41 185C25.9 200.1 0 189.4 0 168V56C0 42.7 10.7 32 24 32H136C157.4 32 168.1 57.9 153 73L116.8 109.2 224 216.4 331.3 109.1 295.1 73C280 57.9 290.7 32 312.1 32H424.1C437.4 32 448.1 42.7 448.1 56V168C448.1 189.4 422.2 200.1 407.1 185L370.9 148.8 263.6 256 370.9 363.3 407.1 327.1C422.2 311.9 448.1 322.6 448.1 344z"}]}}),H.register({expand:{width:448,height:512,paths:[{d:"M0 180V56C0 42.7 10.7 32 24 32H148C154.6 32 160 37.4 160 44V84C160 90.6 154.6 96 148 96H64V180C64 186.6 58.6 192 52 192H12C5.4 192 0 186.6 0 180zM288 44V84C288 90.6 293.4 96 300 96H384V180C384 186.6 389.4 192 396 192H436C442.6 192 448 186.6 448 180V56C448 42.7 437.3 32 424 32H300C293.4 32 288 37.4 288 44zM436 320H396C389.4 320 384 325.4 384 332V416H300C293.4 416 288 421.4 288 428V468C288 474.6 293.4 480 300 480H424C437.3 480 448 469.3 448 456V332C448 325.4 442.6 320 436 320zM160 468V428C160 421.4 154.6 416 148 416H64V332C64 325.4 58.6 320 52 320H12C5.4 320 0 325.4 0 332V456C0 469.3 10.7 480 24 480H148C154.6 480 160 474.6 160 468z"}]}}),H.register({"external-link-alt":{width:576,height:512,paths:[{d:"M576 24V152C576 173.4 550 184 535 169L499.3 133.2 255.8 376.8C246.4 386.1 231.2 386.1 221.9 376.8L199.2 354.1C189.9 344.8 189.9 329.6 199.2 320.2L442.8 76.7 407.1 41C392 25.9 402.7 0 424 0H552C565.3 0 576 10.7 576 24zM407 270.8L391 286.8A24-24 0 0 1 384 303.8V448H64V128H328A24-24 0 0 1 345 121L361 105C376.1 89.9 365.4 64 344 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V287.8C448 266.4 422.1 255.7 407 270.8z"}]}}),H.register({"external-link-square-alt":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM360 96H248C226.7 96 215.9 121.9 231.1 137L263 169 67.5 364.5C62.8 369.2 62.8 376.8 67.5 381.5L98.5 412.5C103.2 417.2 110.8 417.2 115.5 412.5L311 217 343 248.9C358.1 264 384 253.4 384 232V120C384 106.7 373.3 96 360 96z"}]}}),H.register({"eye-dropper":{width:512,height:512,paths:[{d:"M177.4 206.6L39 345A24-24 0 0 1 32 361.9V424L0 480 32 512 88 480H150.1C156.4 480 162.5 477.5 167 473L305.4 334.6 177.4 206.6zM402.9 237.1L419.9 254.1C429.3 263.4 429.3 278.6 419.9 288L378.9 329C369.6 338.3 354.4 338.4 345 329L183 167C173.7 157.7 173.7 142.5 183 133.1L224 92.1C233.3 82.8 248.5 82.7 257.9 92.1L274.9 109.1 357.5 26.5C392.7-8.7 450-9 485.5 26.5 526 74.6 515.2 124.8 485.5 154.5L402.9 237.1z"}]}}),H.register({"eye-slash":{width:576,height:512,paths:[{d:"M286.7 392L319.3 438.5A334-334 0 0 0 288 440C168.2 440 63 376.1 6.6 280.4A48-48 0 0 0 6.6 231.6C30.7 190.9 63.6 155.9 102.7 129.1L159.7 210.6C154.7 224.8 152 240.1 152 256 152 330.7 212.1 391.3 286.7 392zM569.4 280.4C537.7 334.1 490.6 377.8 434.2 405.8L434.2 405.9 475.7 465.1C483.3 475.9 480.6 490.9 469.8 498.5L456.7 507.7C445.8 515.3 430.8 512.6 423.2 501.8L100.3 46.9C92.7 36.1 95.4 21.1 106.2 13.5L119.3 4.3C130.2-3.3 145.2-0.6 152.8 10.2L203.8 82.9C230.7 75.8 258.9 72 288 72 407.8 72 513 135.9 569.4 231.6A48-48 0 0 0 569.4 280.4zM424 256C424 180.8 363.2 120 288 120 270.1 120 252.9 123.5 237.3 129.8L256.6 156.8C282.4 148.7 311.6 150.7 337 164.2H336.9C313.3 164.2 294.1 183.4 294.1 207.1 294.1 230.7 313.3 249.9 336.9 249.9 360.6 249.9 379.8 230.7 379.8 207.1V207C398.2 241.5 396.1 284.9 371.5 318V318L390.8 345.1C411.5 321.2 424 290.1 424 256zM262 356.7L184.5 246C179.5 298.4 213.8 344.3 262 356.7z"}]}}),H.register({eye:{width:576,height:512,paths:[{d:"M569.4 231.6C513 135.9 407.8 72 288 72 168.1 72 63 136 6.6 231.6A48-48 0 0 1 6.6 280.4C63 376.1 168.2 440 288 440 407.9 440 513 376 569.4 280.4A48-48 0 0 1 569.4 231.6zM288 392C212.8 392 152 331.2 152 256 152 180.8 212.8 120 288 120 363.2 120 424 180.8 424 256 424 331.2 363.2 392 288 392zM392 256C392 313.4 345.4 360 288 360S184 313.4 184 256C184 238.3 188.4 221.6 196.2 207L196.2 207.1C196.2 230.7 215.4 249.9 239.1 249.9S281.9 230.7 281.9 207.1C281.9 183.4 262.7 164.2 239.1 164.2L239 164.2C253.6 156.4 270.3 152 288 152 345.4 152 392 198.6 392 256z"}]}}),H.register({"fast-backward":{width:512,height:512,paths:[{d:"M0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V227.9L235.5 71.4C256.1 54.3 288 68.6 288 96V227.9L459.5 71.4C480.1 54.3 512 68.6 512 96V416C512 443.4 480.1 457.7 459.5 440.6L288 285.3V416C288 443.4 256.1 457.7 235.5 440.6L64 285.3V436C64 442.6 58.6 448 52 448H12C5.4 448 0 442.6 0 436z"}]}}),H.register({"fast-forward":{width:512,height:512,paths:[{d:"M512 76V436C512 442.6 506.6 448 500 448H460C453.4 448 448 442.6 448 436V284.1L276.5 440.6C255.9 457.8 224 443.4 224 416V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96C0 68.6 31.9 54.3 52.5 71.4L224 226.8V96C224 68.6 255.9 54.3 276.5 71.4L448 226.8V76C448 69.4 453.4 64 460 64H500C506.6 64 512 69.4 512 76z"}]}}),H.register({fax:{width:512,height:512,paths:[{d:"M128 144V464C128 490.5 106.5 512 80 512H48C21.5 512 0 490.5 0 464V144C0 117.5 21.5 96 48 96H80C106.5 96 128 117.5 128 144zM512 208V464C512 490.5 490.5 512 464 512H192C165.5 512 144 490.5 144 464V40C144 17.9 161.9 0 184 0H391.4A40-40 0 0 0 419.7 11.7L468.3 60.3A40-40 0 0 0 480 88.6V162.7C498.6 169.3 512 187.1 512 208zM192 192H432V96H408C394.8 96 384 85.2 384 72V48H192V192zM288 396C288 389.4 282.6 384 276 384H236C229.4 384 224 389.4 224 396V436C224 442.6 229.4 448 236 448H276C282.6 448 288 442.6 288 436V396zM288 268C288 261.4 282.6 256 276 256H236C229.4 256 224 261.4 224 268V308C224 314.6 229.4 320 236 320H276C282.6 320 288 314.6 288 308V268zM416 396C416 389.4 410.6 384 404 384H364C357.4 384 352 389.4 352 396V436C352 442.6 357.4 448 364 448H404C410.6 448 416 442.6 416 436V396zM416 268C416 261.4 410.6 256 404 256H364C357.4 256 352 261.4 352 268V308C352 314.6 357.4 320 364 320H404C410.6 320 416 314.6 416 308V268z"}]}}),H.register({female:{width:256,height:512,paths:[{d:"M128 0C163.3 0 192 28.7 192 64S163.3 128 128 128C92.7 128 64 99.3 64 64S92.7 0 128 0M247.3 354.2L199.3 162.2A24-24 0 0 1 176 144H164.6C141.9 154.4 115 154.9 91.4 144H80A24-24 0 0 1 56.7 162.2L8.7 354.2C4.9 369.3 16.4 384 32 384H88V488C88 501.3 98.7 512 112 512H144C157.3 512 168 501.3 168 488V384H224C239.6 384 251.1 369.3 247.3 354.2z"}]}}),H.register({"fighter-jet":{width:640,height:512,paths:[{d:"M544 224L416 208 368 192H344L227.2 44H266.7C278.3 44 288 41.4 288 38S278.3 32 266.7 32H152V44H168V208H120L53.3 128H18.7L8 138.7V208H16V224H64V226.7L0 234.7V277.3L64 285.3V288H16V304H8V373.3L18.7 384H53.3L120 304H168V468H152V480H266.7C278.3 480 288 477.4 288 474S278.3 468 266.7 468H227.2L344 320H368L416 304 544 288C640 266.7 640 261.4 640 256 640 250.6 640 245.3 544 224z"}]}}),H.register({"file-alt":{width:384,height:512,paths:[{d:"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM288 372C288 378.6 282.6 384 276 384H108C101.4 384 96 378.6 96 372V364C96 357.4 101.4 352 108 352H276C282.6 352 288 357.4 288 364V372zM288 308C288 314.6 282.6 320 276 320H108C101.4 320 96 314.6 96 308V300C96 293.4 101.4 288 108 288H276C282.6 288 288 293.4 288 300V308zM288 236V244C288 250.6 282.6 256 276 256H108C101.4 256 96 250.6 96 244V236C96 229.4 101.4 224 108 224H276C282.6 224 288 229.4 288 236zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({"file-archive":{width:384,height:512,paths:[{d:"M224 136V0H160.4V32H128.4V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM95.9 32H127.9V64H95.9V32zM128.2 416C95 416 70.2 385.6 76.8 353.1L96.4 256V224H128.4V192H96.4V160H128.4V128H96.4V96H128.4V64H160.4V96H128.4V128H160.4V160H128.4V192H160.4V224H128.4V256H150.5C156.2 256 161.2 260.1 162.3 265.7L179.6 353.4C186 385.8 161.2 416 128.2 416zM160.9 363C160.9 377.9 146.4 390 128.5 390S96 378 96 363C96 348.1 110.5 336 128.4 336S160.9 348.1 160.9 363zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({"file-audio":{width:384,height:512,paths:[{d:"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM160 404C160 414.7 147.1 420 139.5 412.5L104 376H76C69.4 376 64 370.6 64 364V308C64 301.4 69.4 296 76 296H104L139.5 259.5C147.1 251.9 160 257.3 160 268V404zM193.2 356.4C202.3 347.1 202.3 332.3 193.2 323 171.1 300.2 205.4 266.8 227.6 289.5 254.8 317.4 254.8 361.9 227.6 389.9 205.8 412.2 170.7 379.5 193.2 356.4zM279.2 239.3C333.6 295.2 333.6 384.1 279.2 440.1 257.4 462.5 222.2 429.8 244.8 406.6 281 369.4 281.1 310.1 244.8 272.8 222.7 250 257.1 216.5 279.2 239.3zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({"file-code":{width:384,height:512,paths:[{d:"M384 121.9V128H256V0H262.1C268.4 0 274.5 2.5 279 7L377 105A24-24 0 0 0 384 121.9zM248 160C234.8 160 224 149.2 224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248zM123.2 400.5A5.4-5.4 0 0 0 115.6 400.8L50.7 339.9A5.4-5.4 0 0 0 50.7 332.1L115.6 271.2A5.4-5.4 0 0 0 123.2 271.5L142.8 292.4A5.4-5.4 0 0 0 142.4 300.1L101.7 336 142.4 371.9A5.4-5.4 0 0 0 142.8 379.6L123.2 400.5zM174.5 451L147 443A5.4-5.4 0 0 0 143.4 436.3L204.8 224.7A5.4-5.4 0 0 0 211.5 221L239 229A5.4-5.4 0 0 0 242.6 235.7L181.2 447.3A5.4-5.4 0 0 0 174.5 451zM335.3 339.9L270.4 400.8A5.4-5.4 0 0 0 262.8 400.5L243.2 379.6A5.4-5.4 0 0 0 243.6 371.9L284.4 336 243.6 300.1A5.4-5.4 0 0 0 243.2 292.4L262.8 271.5A5.4-5.4 0 0 0 270.4 271.2L335.3 332.1A5.4-5.4 0 0 0 335.3 339.9z"}]}}),H.register({"file-excel":{width:384,height:512,paths:[{d:"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM284.1 242.5L224 336 284.1 429.5C289.2 437.5 283.5 448 274 448H239.1C234.7 448 230.6 445.6 228.5 441.7 208.9 405.5 192 373 192 373 185.6 387.8 182 393 155.4 441.8 153.3 445.7 149.3 448.1 144.9 448.1H110C100.5 448.1 94.8 437.6 99.9 429.6L160.2 336.1 99.9 242.6C94.7 234.6 100.5 224.1 110 224.1H144.8C149.2 224.1 153.3 226.5 155.4 230.4 181.5 279.2 175.4 264 192 298.9 192 298.9 198.1 287.2 228.6 230.4 230.7 226.5 234.8 224.1 239.2 224.1H274C283.5 224 289.2 234.5 284.1 242.5zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({"file-image":{width:384,height:512,paths:[{d:"M384 121.9V128H256V0H262.1A24-24 0 0 0 279 7L377 105A24-24 0 0 0 384 121.9zM248 160C234.8 160 224 149.2 224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248zM112.5 176C139.1 176 160.5 197.5 160.5 224S139.1 272 112.5 272 64.5 250.5 64.5 224 86 176 112.5 176zM320.5 416H64.5L65 367.5 104.5 328C109.2 323.3 116.3 323.8 121 328.5L160.5 368 264.1 264.5C268.7 259.8 276.3 259.8 281 264.5L320.5 304V416z"}]}}),H.register({"file-medical-alt":{width:448,height:512,paths:[{d:"M288 136V0H88C74.7 0 64 10.7 64 24V256H8C3.6 256 0 259.6 0 264V280C0 284.4 3.6 288 8 288H148.9C151.9 288 154.7 289.7 156.1 292.4L176 332.2 232.8 218.5C235.7 212.6 244.2 212.6 247.1 218.5L281.8 288H352C360.8 288 368 295.2 368 304S360.8 320 352 320H262.1L240 275.8 183.2 389.5C180.3 395.4 171.8 395.4 168.9 389.5L134.1 320H64V488C64 501.3 74.7 512 88 512H424C437.3 512 448 501.3 448 488V160H312C298.8 160 288 149.2 288 136zM441 105L343.1 7C338.6 2.5 332.5 0 326.1 0H320V128H448V121.9C448 115.6 445.5 109.5 441 105z"}]}}),H.register({"file-medical":{width:384,height:512,paths:[{d:"M377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM288 296V344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296z"}]}}),H.register({"file-pdf":{width:384,height:512,paths:[{d:"M181.9 256.1C176.9 240.1 177 209.2 179.9 209.2 188.3 209.2 187.5 246.1 181.9 256.1zM180.2 303.3C172.5 323.5 162.9 346.6 151.8 366 170.1 359 190.8 348.8 214.7 344.1 202 334.5 189.8 320.7 180.2 303.3zM86.1 428.1C86.1 428.9 99.3 422.7 121 387.9 114.3 394.2 91.9 412.4 86.1 428.1zM248 160H384V488C384 501.3 373.3 512 360 512H24C10.7 512 0 501.3 0 488V24C0 10.7 10.7 0 24 0H224V136C224 149.2 234.8 160 248 160zM240 331.8C220 319.6 206.7 302.8 197.3 278 201.8 259.5 208.9 231.4 203.5 213.8 198.8 184.4 161.1 187.3 155.7 207 150.7 225.3 155.3 251.1 163.8 284 152.2 311.6 135.1 348.6 123 369.8 122.9 369.8 122.9 369.9 122.8 369.9 95.7 383.8 49.2 414.4 68.3 437.9 73.9 444.8 84.3 447.9 89.8 447.9 107.7 447.9 125.5 429.9 150.9 386.1 176.7 377.6 205 367 229.9 362.9 251.6 374.7 277 382.4 293.9 382.4 323.1 382.4 325.1 350.4 313.6 339 299.7 325.4 259.3 329.3 240 331.8zM377 105L279 7C274.5 2.5 268.4 0 262 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM302.9 360.3C307 357.6 300.4 348.4 260.1 351.3 297.2 367.1 302.9 360.3 302.9 360.3z"}]}}),H.register({"file-powerpoint":{width:384,height:512,paths:[{d:"M193.7 271.2C202.5 271.2 209.2 273.9 214 279.3 223.6 290.2 223.8 312 213.8 323.4 208.9 329 201.9 331.9 192.7 331.9H165.8V271.2H193.7zM377 105L279 7C274.5 2.5 268.4 0 262 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM277 301.2C277 391.5 188.2 378.8 165.9 378.8V436C165.9 442.6 160.5 448 153.9 448H123.1C116.5 448 111.1 442.6 111.1 436V236.2C111.1 229.6 116.5 224.2 123.1 224.2H204.1C248.6 224.2 277 257 277 301.2z"}]}}),H.register({"file-video":{width:384,height:512,paths:[{d:"M384 121.9V128H256V0H262.1C268.4 0 274.5 2.5 279 7L377 105A24-24 0 0 0 384 121.9zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM320 280V392C320 413.4 294.1 424 279 408.9L224 353.9V392C224 405.3 213.3 416 200 416H88C74.7 416 64 405.3 64 392V280C64 266.7 74.7 256 88 256H200C213.3 256 224 266.7 224 280V318.1L279 263C294 248 320 258.6 320 280z"}]}}),H.register({"file-word":{width:384,height:512,paths:[{d:"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM281.1 256H305C312.7 256 318.4 263.1 316.7 270.7L278.7 438.7C277.5 444.2 272.6 448 267 448H229C223.5 448 218.7 444.2 217.4 438.9 191.6 335.4 196.6 357.7 191.8 328.4H191.3C190.2 342.7 188.9 345.8 165.7 438.9 164.4 444.2 159.6 448 154.1 448H117C111.4 448 106.5 444.1 105.3 438.6L67.5 270.6C65.8 263.1 71.5 256 79.2 256H103.7C109.4 256 114.4 260 115.5 265.7 131.1 343.7 135.6 375.2 136.5 387.9 138.1 377.7 143.8 355.2 165.9 265.2 167.2 259.8 172 256.1 177.6 256.1H206.7C212.3 256.1 217.1 259.9 218.4 265.3 242.4 365.7 247.2 389.3 248 394.7 247.8 383.5 245.4 376.9 269.6 265.5 270.6 259.9 275.5 256 281.1 256zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({file:{width:384,height:512,paths:[{d:"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}}),H.register({film:{width:512,height:512,paths:[{d:"M488 64H480V84C480 90.6 474.6 96 468 96H428C421.4 96 416 90.6 416 84V64H96V84C96 90.6 90.6 96 84 96H44C37.4 96 32 90.6 32 84V64H24C10.7 64 0 74.7 0 88V424C0 437.3 10.7 448 24 448H32V428C32 421.4 37.4 416 44 416H84C90.6 416 96 421.4 96 428V448H416V428C416 421.4 421.4 416 428 416H468C474.6 416 480 421.4 480 428V448H488C501.3 448 512 437.3 512 424V88C512 74.7 501.3 64 488 64zM96 372C96 378.6 90.6 384 84 384H44C37.4 384 32 378.6 32 372V332C32 325.4 37.4 320 44 320H84C90.6 320 96 325.4 96 332V372zM96 276C96 282.6 90.6 288 84 288H44C37.4 288 32 282.6 32 276V236C32 229.4 37.4 224 44 224H84C90.6 224 96 229.4 96 236V276zM96 180C96 186.6 90.6 192 84 192H44C37.4 192 32 186.6 32 180V140C32 133.4 37.4 128 44 128H84C90.6 128 96 133.4 96 140V180zM368 388C368 394.6 362.6 400 356 400H156C149.4 400 144 394.6 144 388V292C144 285.4 149.4 280 156 280H356C362.6 280 368 285.4 368 292V388zM368 220C368 226.6 362.6 232 356 232H156C149.4 232 144 226.6 144 220V124C144 117.4 149.4 112 156 112H356C362.6 112 368 117.4 368 124V220zM480 372C480 378.6 474.6 384 468 384H428C421.4 384 416 378.6 416 372V332C416 325.4 421.4 320 428 320H468C474.6 320 480 325.4 480 332V372zM480 276C480 282.6 474.6 288 468 288H428C421.4 288 416 282.6 416 276V236C416 229.4 421.4 224 428 224H468C474.6 224 480 229.4 480 236V276zM480 180C480 186.6 474.6 192 468 192H428C421.4 192 416 186.6 416 180V140C416 133.4 421.4 128 428 128H468C474.6 128 480 133.4 480 140V180z"}]}}),H.register({filter:{width:512,height:512,paths:[{d:"M488 0H24C2.7 0-8 25.9 7.1 41L192 225.9V432C192 439.8 195.8 447.2 202.2 451.7L282.2 507.6C298 518.7 320 507.5 320 488V225.9L504.9 41C520 25.9 509.3 0 488 0z"}]}}),H.register({"fire-extinguisher":{width:448,height:512,paths:[{d:"M434 26.3L266 54.3C254.7 56.2 256 67.8 256 72H197.7C208.4 36.1 181.4 0 144 0 104.6 0 77.6 39.7 91.8 76.2 39.7 89.3 16.4 130.4 1.7 167.1-3.2 179.4 2.8 193.4 15.1 198.3 27.4 203.2 41.4 197.2 46.3 184.9 75.1 113 107 120 168 120V147.1C126.5 157.9 96 196.3 96 241.2V488C96 501.3 106.7 512 120 512H264C277.3 512 288 501.3 288 488V240C288 195.3 257.4 157.7 216 147V120H256C256 123 254.3 135.7 266 137.7L434 165.7C441.3 166.9 448 161.3 448 153.8V38.2C448 30.8 441.3 25.1 434 26.3zM144 72C135.2 72 128 64.8 128 56S135.2 40 144 40 160 47.2 160 56 152.8 72 144 72z"}]}}),H.register({fire:{width:384,height:512,paths:[{d:"M216 23.9C216 0.1 185.3-8.9 171.9 10.8 48 191.9 224 200 224 288 224 323.6 194.9 352.5 159.2 352 124 351.5 96 322.2 96 287V201.5C96 179.8 69.5 169.3 54.6 185 27.8 213.2 0 261.3 0 320 0 425.9 86.1 512 192 512S384 425.9 384 320C384 149.7 216 127 216 23.9z"}]}}),H.register({"first-aid":{width:576,height:512,paths:[{d:"M0 80V432C0 458.5 21.5 480 48 480H96V32H48C21.5 32 0 53.5 0 80zM128 480H448V32H128V480zM192 232C192 227.6 195.6 224 200 224H256V168C256 163.6 259.6 160 264 160H312C316.4 160 320 163.6 320 168V224H376C380.4 224 384 227.6 384 232V280C384 284.4 380.4 288 376 288H320V344C320 348.4 316.4 352 312 352H264C259.6 352 256 348.4 256 344V288H200C195.6 288 192 284.4 192 280V232zM528 32H480V480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32z"}]}}),H.register({"flag-checkered":{width:512,height:512,paths:[{d:"M466.5 66.9C487.7 57.1 512 72.6 512 95.9V339C512 349.6 506.8 359.5 498.2 365.4 462.3 390 423.8 406.3 375.7 406.3 308.3 406.3 264 371.5 210.4 371.5 159.6 371.5 124.3 381.5 96 393.6V488C96 501.3 85.3 512 72 512H56C42.7 512 32 501.3 32 488V101.9C17.5 91.8 8 75 8 56 8 24.3 34.3-1.3 66.3 0 94.8 1.2 118.1 24 119.9 52.5 120.4 60.8 119.1 68.8 116.3 76 137 68.4 159.4 64 184.3 64 251.7 64 296 98.8 349.6 98.8 390.1 98.8 432.2 82.9 466.5 66.9zM96 134.6V205.1C125 194.4 147.2 187.3 169.6 184.2V112.6C146.1 114.8 129.2 122.4 96 134.6zM316.8 143.8C290.4 139.1 266.9 129.8 243.2 122.5V189.9C267.4 196.6 290.8 206.3 316.8 212.2V143.8zM169.6 184.2V254.3C202.4 251.3 223.5 253.6 243.2 258.1V189.9C218 182.9 196.6 180.5 169.6 184.2zM243.2 326.4C269.5 331.1 292.9 340.4 316.8 347.8V280.4C292.5 273.6 269.3 263.9 243.2 258V326.4zM96 342.1C119.6 333.7 143.8 328.3 169.6 325.5V254.3C143.5 256.6 122.2 262.3 96 271.6V342.1zM464 120.5C442.7 129.4 417.4 138.1 390.4 143V214.9C417.7 210.5 440.4 200.8 464 191V120.5zM464 330.5V260C441.8 274.2 415.2 282.6 390.4 286V357.6C415.5 355.2 438.9 346.5 464 330.5zM316.8 212.2V280.4C342.5 287.5 363.4 289.7 390.4 286V214.9C364.4 219.1 340.5 217.6 316.8 212.2z"}]}}),H.register({flag:{width:512,height:512,paths:[{d:"M349.6 98.8C296 98.8 251.7 64 184.3 64 159.4 64 137 68.4 116.3 76A55.9-55.9 0 0 1 119.9 52.5C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56 8 75 17.5 91.8 32 101.9V488C32 501.3 42.7 512 56 512H72C85.3 512 96 501.3 96 488V393.6C124.3 381.5 159.6 371.5 210.4 371.5 264 371.5 308.3 406.3 375.7 406.3 423.8 406.3 462.3 390 498.2 365.4 506.8 359.5 512 349.6 512 339V95.9C512 72.6 487.7 57.1 466.5 66.9 432.2 82.9 390.1 98.8 349.6 98.8z"}]}}),H.register({flask:{width:448,height:512,paths:[{d:"M437.2 403.5L320 215V64H328C341.3 64 352 53.3 352 40V24C352 10.7 341.3 0 328 0H120C106.7 0 96 10.7 96 24V40C96 53.3 106.7 64 120 64H128V215L10.8 403.5C-18.5 450.6 15.3 512 70.9 512H377.1C432.8 512 466.5 450.5 437.2 403.5zM137.9 320L186.1 242.4C189.8 237.2 191.9 230.8 191.9 224V64H255.9V224C255.9 230.9 258.1 237.2 261.7 242.4L309.9 320H137.9z"}]}}),H.register({"folder-open":{width:576,height:512,paths:[{d:"M572.7 292.1L500.3 416.2A64-64 0 0 0 445 448H45C26.5 448 15 427.9 24.3 411.9L96.7 287.8A64-64 0 0 0 152 256H552C570.5 256 582 276.1 572.7 292.1zM152 224H480V176C480 149.5 458.5 128 432 128H272L208 64H48C21.5 64 0 85.5 0 112V390L69.1 271.6C86.2 242.3 118 224 152 224z"}]}}),H.register({folder:{width:512,height:512,paths:[{d:"M464 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128z"}]}}),H.register({font:{width:448,height:512,paths:[{d:"M152 416H128L154.6 335.2H292.8L319.4 416H296C287.2 416 280 423.2 280 432V464C280 472.8 287.2 480 296 480H432C440.8 480 448 472.8 448 464V432C448 423.2 440.8 416 432 416H405.3L275.5 42.7A16-16 0 0 1 260.4 32H187.6A16-16 0 0 1 172.5 42.7L42.7 416H16C7.2 416 0 423.2 0 432V464C0 472.8 7.2 480 16 480H152C160.8 480 168 472.8 168 464V432C168 423.2 160.8 416 152 416zM216.4 144.2C220.7 129 223 116.1 223.9 109.6 224.8 116.1 226.9 129.1 231.7 144.3L273 268.3H174.4L216.4 144.2z"}]}}),H.register({"football-ball":{width:496,height:512,paths:[{d:"M481.5 60.3C476.7 42.1 462.4 27.8 444.2 22.9 420.3 16.5 383 8.9 339.4 8L496 164.8C495.2 121.3 487.8 84.2 481.5 60.3zM14.5 451.7C19.3 469.9 33.6 484.2 51.8 489.1 75.7 495.5 113 503.1 156.6 504L0 347.2C0.8 390.7 8.2 427.8 14.5 451.7zM4.2 283.4L220.4 500C352.9 480.6 469.2 381.3 491.9 228.6L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zM321.5 159.8C324.6 156.7 329.7 156.7 332.8 159.8L344.1 171.1C347.2 174.2 347.2 179.3 344.1 182.4L315.8 210.7 344.1 239C347.2 242.1 347.2 247.2 344.1 250.3L332.8 261.6C329.7 264.7 324.6 264.7 321.5 261.6L293.2 233.3 270.6 256 298.9 284.3C302 287.4 302 292.5 298.9 295.6L287.6 306.9C284.5 310 279.4 310 276.3 306.9L248 278.6 225.4 301.2 253.7 329.5C256.8 332.6 256.8 337.7 253.7 340.8L242.4 352.1C239.3 355.2 234.2 355.2 231.1 352.1L202.8 323.8 174.5 352.1C171.4 355.2 166.3 355.2 163.2 352.1L151.9 340.8C148.8 337.7 148.8 332.6 151.9 329.5L180.2 301.2 151.9 273C148.8 269.9 148.8 264.8 151.9 261.7L163.2 250.4C166.3 247.3 171.4 247.3 174.5 250.4L202.8 278.7 225.4 256.1 197.1 227.8C194 224.7 194 219.6 197.1 216.5L208.4 205.2C211.5 202.1 216.6 202.1 219.7 205.2L248 233.5 270.6 210.9 242.3 182.6C239.2 179.5 239.2 174.4 242.3 171.3L253.6 160C256.7 156.9 261.8 156.9 264.9 160L293.2 188.3 321.5 159.8z"}]}}),H.register({forward:{width:512,height:512,paths:[{d:"M500.5 231.4L308.5 71.4C287.9 54.3 256 68.6 256 96V416C256 443.4 287.9 457.8 308.5 440.6L500.5 280.6C515.8 267.8 515.8 244.2 500.5 231.4zM244.5 231.4L52.5 71.4C31.9 54.3 0 68.6 0 96V416C0 443.4 31.9 457.8 52.5 440.6L244.5 280.6C259.8 267.8 259.8 244.2 244.5 231.4z"}]}}),H.register({frown:{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM360.7 396.3C357.7 398.8 354.1 400 350.5 400 345.9 400 341.4 398 338.2 394.2 315.8 367.4 282.9 352 248 352S180.2 367.4 157.8 394.2C152.2 401 142.1 401.9 135.3 396.2 128.5 390.5 127.6 380.5 133.3 373.7 161.7 339.6 203.6 320 248 320S334.3 339.6 362.7 373.8C368.4 380.5 367.5 390.6 360.7 396.3z"}]}}),H.register({futbol:{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM456 256L456 255.7 429.9 278.5 367.3 220 383.7 135.6 418 138.7C393.1 104.5 358 78.6 317.3 65.5L331 97.5 256 139 181 97.5 194.7 65.5C154.1 78.6 118.9 104.4 94 138.7L128.6 135.6 144.7 220 82.1 278.5 56 255.7 56 256C56 299 69.5 340 94.5 374L102.2 340.1 187.3 350.5 223.6 428.4 193.7 446.2C233.9 459.3 278 459.3 318.3 446.2L288.4 428.4 324.7 350.5 409.8 340.1 417.5 374C442.5 340 456 299 456 256zM207.9 325.6L178 234.3 256 177.7 334 234.3 304.4 325.6H207.9z"}]}}),H.register({gamepad:{width:640,height:512,paths:[{d:"M480 96H160C71.6 96 0 167.6 0 256S71.6 416 160 416C204.8 416 245.2 397.6 274.2 368H365.7C394.7 397.6 435.2 416 479.9 416 568.3 416 639.9 344.4 639.9 256S568.4 96 480 96zM256 276C256 282.6 250.6 288 244 288H192V340C192 346.6 186.6 352 180 352H140C133.4 352 128 346.6 128 340V288H76C69.4 288 64 282.6 64 276V236C64 229.4 69.4 224 76 224H128V172C128 165.4 133.4 160 140 160H180C186.6 160 192 165.4 192 172V224H244C250.6 224 256 229.4 256 236V276zM440 344C413.5 344 392 322.5 392 296S413.5 248 440 248 488 269.5 488 296 466.5 344 440 344zM520 264C493.5 264 472 242.5 472 216S493.5 168 520 168 568 189.5 568 216 546.5 264 520 264z"}]}}),H.register({gavel:{width:512,height:512,paths:[{d:"M505 199.4L482.3 176.7C473 167.4 457.8 167.4 448.4 176.7L442.7 182.4 329.6 69.3 335.3 63.6C344.6 54.2 344.6 39 335.3 29.7L312.6 7C303.3-2.3 288.1-2.3 278.7 7L154.2 131.5C144.9 140.9 144.9 156 154.2 165.4L176.9 188C186.2 197.4 201.4 197.4 210.8 188L216.5 182.4 256.1 222 175 303 169.4 297.4C156.9 284.9 136.6 284.9 124.1 297.4L9.4 412.1C-3.1 424.6-3.1 444.9 9.4 457.4L54.6 502.6C67.1 515.1 87.4 515.1 99.9 502.6L214.6 387.9C227.1 375.4 227.1 355.1 214.6 342.6L209 337 290 255.9 329.6 295.5 324 301.2C314.6 310.6 314.6 325.8 324 335.1L346.6 357.8C356 367.1 371.1 367.1 380.5 357.8L505 233.3C514.3 223.9 514.3 208.7 505 199.4z"}]}}),H.register({gem:{width:576,height:512,paths:[{d:"M485.5 0L576 160H474.9L405.7 0H485.5zM357.5 0L426.7 160H149.3L218.5 0H357.5zM90.5 0H170.3L101.1 160H0L90.5 0zM0 192H100.7L223.7 443.7C225.2 446.8 221 449.6 218.7 447L0 192zM148.2 192H427.8L290.8 510.2C289.8 512.6 286.3 512.6 285.3 510.2L148.2 192zM352.3 443.7L475.3 192H576L357.3 446.9C355 449.6 350.8 446.8 352.3 443.7z"}]}}),H.register({genderless:{width:288,height:512,paths:[{d:"M144 176C188.1 176 224 211.9 224 256S188.1 336 144 336 64 300.1 64 256 99.9 176 144 176M144 112C64.5 112 0 176.5 0 256S64.5 400 144 400 288 335.5 288 256 223.5 112 144 112z"}]}}),H.register({gift:{width:512,height:512,paths:[{d:"M32 448C32 465.7 46.3 480 64 480H224V320H32V448zM480 160H437.9C444.1 147.9 448 134.5 448 120 448 71.5 408.5 32 360 32 318.4 32 291.5 53.3 257 100.3 222.5 53.3 195.6 32 154 32 105.5 32 66 71.5 66 120 66 134.5 69.8 147.9 76.1 160H32C14.3 160 0 174.3 0 192V272C0 280.8 7.2 288 16 288H496C504.8 288 512 280.8 512 272V192C512 174.3 497.7 160 480 160zM153.9 160C131.8 160 113.9 142.1 113.9 120S131.8 80 153.9 80C173.8 80 188.5 83.3 240 160H153.9zM360 160H273.9C325.3 83.5 339.6 80 360 80 382.1 80 400 97.9 400 120S382.1 160 360 160zM288 480H448C465.7 480 480 465.7 480 448V320H288V480z"}]}}),H.register({"glass-martini":{width:512,height:512,paths:[{d:"M507.3 27.3C517.3 17.3 510.2 0 496 0H16C1.8 0-5.4 17.2 4.7 27.3L216 238.6V472H124C108.5 472 96 484.5 96 500 96 506.6 101.4 512 108 512H404C410.6 512 416 506.6 416 500 416 484.5 403.5 472 388 472H296V238.6L507.3 27.3z"}]}}),H.register({globe:{width:496,height:512,paths:[{d:"M336.5 160C322 70.7 287.8 8 248 8S174 70.7 159.5 160H336.5zM152 256C152 278.2 153.2 299.5 155.3 320H340.6C342.7 299.5 343.9 278.2 343.9 256S342.7 212.5 340.6 192H155.3C153.2 212.5 152 233.8 152 256zM476.7 160C448.1 92.1 390.2 39.6 318.7 18.4 343.1 52.2 359.9 103.1 368.7 160H476.7zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160H127.3C136 103.1 152.8 52.2 177.2 18.4zM487.4 192H372.7C374.8 213 376 234.5 376 256S374.8 299 372.7 320H487.3C492.8 299.5 495.9 278.2 495.9 256S492.8 212.5 487.4 192zM120 256C120 234.5 121.2 213 123.3 192H8.6C3.2 212.5 0 233.8 0 256S3.2 299.5 8.6 320H123.2C121.2 299 120 277.5 120 256zM159.5 352C174 441.3 208.2 504 248 504S322 441.3 336.5 352H159.5zM318.8 493.6C390.2 472.4 448.2 419.9 476.8 352H368.8C360 408.9 343.2 459.8 318.8 493.6zM19.3 352C47.9 419.9 105.8 472.4 177.3 493.6 152.9 459.8 136.1 408.9 127.3 352H19.3z"}]}}),H.register({"golf-ball":{width:416,height:512,paths:[{d:"M96 416H320C320 433.7 305.7 448 288 448H272C254.3 448 240 462.3 240 480V500C240 506.6 234.6 512 228 512H188C181.4 512 176 506.6 176 500V480C176 462.3 161.7 448 144 448H128C110.3 448 96 433.7 96 416zM416 208C416 282.2 377 347.2 318.5 384H97.5C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0S416 93.1 416 208zM235.9 251.9C254.2 251.9 269 237.1 269 218.8 269 204.4 259.7 192.5 246.9 187.9 256.5 214.7 231.3 239.2 205 229.8 209.6 242.6 221.5 251.9 235.9 251.9zM285 298.8C285 284.4 275.7 272.5 262.9 267.9 272.5 294.7 247.3 319.2 221 309.8 225.6 322.6 237.5 331.9 251.9 331.9 270.2 331.9 285 317 285 298.8zM349 234.8C349 220.4 339.7 208.5 326.9 203.9 336.5 230.7 311.3 255.2 285 245.8 289.6 258.6 301.5 267.9 315.9 267.9 334.2 267.9 349 253 349 234.8z"}]}}),H.register({"graduation-cap":{width:640,height:512,paths:[{d:"M622.9 199L347.1 284.1A96-96 0 0 0 292.9 284.1L92.4 222.2C83.8 233.7 81.4 245.3 80.5 260.6 89.8 266.2 96 276.4 96 288 96 300 89.4 310.4 79.7 315.9L95.9 439C96.6 443.7 92.8 448 88 448H40C35.2 448 31.4 443.7 32.1 439L48.3 315.9C38.6 310.4 32 300 32 288 32 276 38.6 265.5 48.5 260 49.4 242.1 52.4 226.8 60.6 212.4L17.1 199C-5.8 192.2-5.7 159.8 17.1 153L292.9 67.9A96-96 0 0 0 347.1 67.9L622.9 153C645.8 159.8 645.7 192.2 622.9 199zM356.5 314.7L356.3 314.7 356.1 314.8A128-128 0 0 0 283.9 314.8L283.7 314.7 283.5 314.7 132.6 268.1 120 352C120 387.3 209.5 416 320 416S520 387.3 520 352L507.4 268.1 356.5 314.7z"}]}}),H.register({"h-square":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM336 128H304C295.2 128 288 135.2 288 144V224H160V144C160 135.2 152.8 128 144 128H112C103.2 128 96 135.2 96 144V368C96 376.8 103.2 384 112 384H144C152.8 384 160 376.8 160 368V288H288V368C288 376.8 295.2 384 304 384H336C344.8 384 352 376.8 352 368V144C352 135.2 344.8 128 336 128z"}]}}),H.register({"hand-holding-heart":{width:576,height:512,paths:[{d:"M275.3 250.5C282.3 257.9 293.7 257.9 300.8 250.5L409.7 136.3C441.3 103.1 439.5 48.1 404.1 17.5 373.3-9.2 327.4-4.4 299.2 25.2L288 36.9 276.9 25.3C248.7-4.4 202.8-9.2 172 17.5 136.7 48.1 134.8 103.1 166.4 136.3L275.3 250.5zM565.3 328.1C553.5 317.4 535.1 318.1 522.7 328.1L430.3 402C419 411.1 404.9 416 390.3 416H272C263.2 416 256 408.8 256 400S263.2 384 272 384H350.3C366.2 384 381 373.1 383.6 357.4 386.9 337.4 371.5 320 352 320H192C165 320 138.9 329.3 117.9 346.3L71.4 384H16C7.2 384 0 391.2 0 400V496C0 504.8 7.2 512 16 512H372.8C387.3 512 401.4 507.1 412.8 498L564 377C579.2 364.9 580.4 341.7 565.3 328.1z"}]}}),H.register({"hand-holding-usd":{width:544,height:512,paths:[{d:"M257.6 144.3L307.6 158.6C311.2 159.6 313.7 163 313.7 166.7 313.7 171.3 309.9 175.1 305.3 175.1H272.5C268.9 175.1 265.4 174.3 262.2 172.9 257.4 170.7 251.8 171.2 248.1 174.9L230.6 192.4C225.3 197.7 225.9 206.7 232.1 210.8 241.6 217.1 252.4 220.9 263.9 222.3V240C263.9 248.8 271.1 256 279.9 256H295.9C304.7 256 311.9 248.8 311.9 240V222.4C342.2 218.8 365.2 191.4 361.2 159.4 358.3 136.4 340.5 118.1 318.3 111.7L268.3 97.4C264.7 96.4 262.2 93 262.2 89.3 262.2 84.7 266 80.9 270.6 80.9H303.4C307 80.9 310.5 81.7 313.7 83.1 318.5 85.3 324.1 84.8 327.8 81.1L345.3 63.6C350.6 58.3 350 49.3 343.8 45.2 334.3 38.9 323.5 35.1 312 33.7V16C312 7.2 304.8 0 296 0H280C271.2 0 264 7.2 264 16V33.6C233.7 37.2 210.7 64.6 214.7 96.6 217.6 119.6 235.4 137.9 257.6 144.3zM533.9 328.1C522.7 317.4 505.4 318.1 493.6 328.1L406.4 402C395.7 411.1 382.4 416 368.6 416H256.9C248.6 416 241.8 408.8 241.8 400S248.6 384 256.9 384H330.8C345.9 384 359.8 373.1 362.2 357.4 365.3 337.4 350.7 320 332.4 320H181.3C155.8 320 131.1 329.3 111.4 346.3L67.5 384H15.1C6.8 384 0 391.2 0 400V496C0 504.8 6.8 512 15.1 512H352C365.7 512 379 507.1 389.8 498L532.6 377C547 364.9 548.1 341.7 533.9 328.1z"}]}}),H.register({"hand-holding":{width:576,height:512,paths:[{d:"M565.3 328.1C553.5 317.4 535.1 318.1 522.7 328.1L430.3 402C419 411.1 404.9 416 390.3 416H272C263.2 416 256 408.8 256 400S263.2 384 272 384H350.3C366.2 384 381 373.1 383.6 357.4 386.9 337.4 371.5 320 352 320H192C165 320 138.9 329.3 117.9 346.3L71.4 384H16C7.2 384 0 391.2 0 400V496C0 504.8 7.2 512 16 512H372.8C387.3 512 401.4 507.1 412.8 498L564 377C579.2 364.9 580.4 341.7 565.3 328.1z"}]}}),H.register({"hand-lizard":{width:576,height:512,paths:[{d:"M384 480H576V363.8A96-96 0 0 1 561.2 312.5L398.1 54.4A48-48 0 0 1 357.5 32H24C10.7 32 0 42.7 0 56V72C0 102.9 25.1 128 56 128H286C298.8 128 307.5 141.1 302.6 152.9L281.2 204.3A32-32 0 0 0 251.6 224H128C92.7 224 64 252.7 64 288V296C64 309.3 74.7 320 88 320H235.4A48-48 0 0 0 261.1 327.5L372.8 398.3A24-24 0 0 0 384 418.5V480z"}]}}),H.register({"hand-paper":{width:448,height:512,paths:[{d:"M408.8 128C386.4 127.6 368 146.4 368 168.8V256H360V79.8C360 57.4 341.6 38.6 319.2 39 297.5 39.4 280 57.2 280 79V256H272V40.8C272 18.4 253.6-0.4 231.2 0 209.5 0.4 192 18.2 192 40V256H184V80.8C184 58.4 165.6 39.6 143.2 40 121.5 40.4 104 58.2 104 80V316L72.4 272.5C59.4 254.6 34.3 250.7 16.5 263.6-1.4 276.6-5.3 301.7 7.7 319.5L133.3 492.2A48-48 0 0 1 172.1 512H369.7C391.9 512 411.3 496.7 416.4 475L442.9 362.3A192-192 0 0 1 448 318.4V168C448 146.2 430.5 128.4 408.8 128z"}]}}),H.register({"hand-peace":{width:448,height:512,paths:[{d:"M408 216C385.9 216 368 233.9 368 256H360V224C360 201.9 342.1 184 320 184S280 201.9 280 224V256H272V48C272 21.5 250.5 0 224 0S176 21.5 176 48V256H162.4L92.7 78.4C83 53.8 55.1 41.6 30.5 51.3 5.8 61-6.4 88.9 3.3 113.6L78.1 303.9 47 328.8C31.6 341.1 27.5 362.7 37.3 379.8L101.3 491.8A40-40 0 0 1 136 512H376C394.6 512 410.7 499.2 414.9 481.2L446.9 345.2A40-40 0 0 1 448 336V256C448 233.9 430.1 216 408 216z"}]}}),H.register({"hand-point-down":{width:384,height:512,paths:[{d:"M91.8 467.2V318C83.6 323.8 75.3 328.5 66.9 332.1 35.1 345.8 0 322.2 0 288 0 269.4 10.9 255.8 29.1 248 57.4 235.9 93.4 169.4 106.4 140.5 114.4 122.6 131.9 112 150.3 112L150.3 112H321.8C333.6 112 343.7 120.6 345.5 132.3 352.7 179.1 384 194 383.8 256 383.8 258.7 384 269.3 384 272 384 322.7 361.9 353.6 312.7 344.6 303.4 363.2 273.3 375.3 250.4 361.1 229.2 385.7 196.5 383.7 179.5 367.3V467.2C179.5 491.4 159.3 512 135.7 512 112.4 512 91.8 490.6 91.8 467.2zM112 72V24C112 10.7 122.7 0 136 0H328C341.3 0 352 10.7 352 24V72C352 85.3 341.3 96 328 96H136C122.7 96 112 85.3 112 72zM324 48C324 37 315 28 304 28S284 37 284 48 293 68 304 68 324 59 324 48z"}]}}),H.register({"hand-point-left":{width:512,height:512,paths:[{d:"M44.8 155.8H194C188.2 147.6 183.5 139.3 179.9 130.9 166.2 99.1 189.8 64 224 64 242.6 64 256.2 74.9 264 93.1 276.1 121.4 342.6 157.4 371.5 170.4 389.4 178.4 400 195.9 400 214.3L400 214.3V385.8C400 397.6 391.4 407.7 379.7 409.5 332.9 416.7 318 448 256 447.8 253.3 447.8 242.7 448 240 448 189.3 448 158.4 425.9 167.4 376.7 148.8 367.4 136.7 337.3 150.9 314.4 126.3 293.2 128.3 260.5 144.7 243.5H44.8C20.6 243.5 0 223.3 0 199.7 0 176.4 21.4 155.8 44.8 155.8zM440 176H488C501.3 176 512 186.7 512 200V392C512 405.3 501.3 416 488 416H440C426.7 416 416 405.3 416 392V200C416 186.7 426.7 176 440 176zM464 388C475 388 484 379 484 368S475 348 464 348 444 357 444 368 453 388 464 388z"}]}}),H.register({"hand-point-right":{width:512,height:512,paths:[{d:"M512 199.7C512 223.3 491.4 243.5 467.2 243.5H367.3C383.7 260.5 385.7 293.2 361.1 314.4 375.3 337.3 363.2 367.4 344.6 376.7 353.6 425.9 322.7 448 272 448 269.3 448 258.7 447.8 256 447.8 194 448 179.1 416.7 132.3 409.5 120.6 407.7 112 397.6 112 385.8V214.3L112 214.3C112 195.9 122.6 178.4 140.5 170.4 169.4 157.4 235.9 121.4 248 93.1 255.8 74.9 269.4 64 288 64 322.2 64 345.8 99.1 332.1 130.9 328.5 139.3 323.8 147.6 318 155.8H467.2C490.6 155.8 512 176.4 512 199.7zM96 200V392C96 405.3 85.3 416 72 416H24C10.7 416 0 405.3 0 392V200C0 186.7 10.7 176 24 176H72C85.3 176 96 186.7 96 200zM68 368C68 357 59 348 48 348S28 357 28 368 37 388 48 388 68 379 68 368z"}]}}),H.register({"hand-point-up":{width:384,height:512,paths:[{d:"M135.7 0C159.3 0 179.5 20.6 179.5 44.8V144.7C196.5 128.3 229.2 126.3 250.4 150.9 273.3 136.7 303.4 148.8 312.7 167.4 361.9 158.4 384 189.3 384 240 384 242.7 383.8 253.3 383.8 256 384 318 352.7 332.9 345.5 379.7 343.7 391.4 333.6 400 321.8 400H150.3L150.3 400C131.9 400 114.4 389.4 106.4 371.5 93.4 342.6 57.4 276.1 29.1 264 10.9 256.2 0 242.6 0 224 0 189.8 35.1 166.2 66.9 179.9 75.3 183.5 83.6 188.2 91.8 194V44.8C91.8 21.4 112.4 0 135.7 0zM136 416H328C341.3 416 352 426.7 352 440V488C352 501.3 341.3 512 328 512H136C122.7 512 112 501.3 112 488V440C112 426.7 122.7 416 136 416zM304 444C293 444 284 453 284 464S293 484 304 484 324 475 324 464 315 444 304 444z"}]}}),H.register({"hand-pointer":{width:448,height:512,paths:[{d:"M448 240V336C448 339.1 447.6 342.2 446.9 345.2L414.9 481.2C410.7 499.2 394.6 512 376 512H168A40-40 0 0 0 135.7 495.5L7.7 319.5C-5.3 301.7-1.4 276.6 16.5 263.7 34.3 250.7 59.4 254.6 72.4 272.5L104 316V40C104 17.9 121.9 0 144 0S184 17.9 184 40V240H192V200C192 177.9 209.9 160 232 160S272 177.9 272 200V240H280V216C280 193.9 297.9 176 320 176S360 193.9 360 216V240H368C368 217.9 385.9 200 408 200S448 217.9 448 240zM192 320H184V416H192V320zM280 320H272V416H280V320zM368 320H360V416H368V320z"}]}}),H.register({"hand-rock":{width:512,height:512,paths:[{d:"M512 128.8C512 102.5 491.1 80.4 464.8 80 437.9 79.6 416 101.2 416 128H408V96.8C408 70.5 387.1 48.4 360.8 48 333.9 47.6 312 69.2 312 96V128H304V80.8C304 54.5 283.1 32.4 256.8 32 229.9 31.6 208 53.2 208 80V128H200V96.8C200 70.5 179.1 48.4 152.8 48 125.9 47.6 104 69.2 104 96V232L96 224.9V176.8C96 150.5 75.1 128.4 48.8 128 21.9 127.6 0 149.2 0 176V242.4A96-96 0 0 1 32.2 314.2L143.9 413.5A48-48 0 0 0 160 449.3V456C160 469.3 170.7 480 184 480H424C437.3 480 448 469.3 448 456V453.1A96-96 0 0 0 455.5 415.8L504.5 299.6A96-96 0 0 1 512 262.3V128.8z"}]}}),H.register({"hand-scissors":{width:512,height:512,paths:[{d:"M216 440C216 417.9 233.9 400 256 400V392H224C201.9 392 184 374.1 184 352S201.9 312 224 312H256V304H48C21.5 304 0 282.5 0 256S21.5 208 48 208H256V194.4L78.4 124.7C53.8 115 41.6 87.1 51.3 62.5 61 37.8 88.9 25.6 113.6 35.3L303.9 110.1 328.8 79C341.1 63.6 362.7 59.5 379.8 69.3L491.8 133.3A40-40 0 0 0 512 168V408C512 426.6 499.2 442.7 481.2 446.9L345.2 478.9A40-40 0 0 0 336 480H256C233.9 480 216 462.1 216 440z"}]}}),H.register({"hand-spock":{width:512,height:512,paths:[{d:"M10.9 316.6C26 300.5 51.3 299.7 67.4 314.9L128 371.9V292.5L89 120.9C84.1 99.3 97.6 77.9 119.1 73 140.7 68.1 162.1 81.6 167 103.1L201.7 256H211.6L164 49C159.1 27.4 172.5 6 194 1 215.6-3.9 237 9.5 242 31.1L293.7 256H308.8L357.2 62.3C362.6 40.9 384.3 27.8 405.7 33.2 427.1 38.6 440.2 60.3 434.8 81.7L391.2 256H402.3L433.1 126.7C438.2 105.2 459.8 92 481.3 97.1 502.7 102.2 516 123.8 510.9 145.3L474.6 297.7A96-96 0 0 1 472 320V362.1A96-96 0 0 0 468 389.4L441.9 477.6C435.8 498 417.1 512 395.8 512H179.2A48-48 0 0 0 146.3 499L12.6 373.1C-3.5 358-4.3 332.7 10.9 316.6z"}]}}),H.register({"hands-helping":{width:640,height:512,paths:[{d:"M488 192H336V248C336 287.7 303.7 320 264 320S192 287.7 192 248V126.4L127.1 165.4C107.8 176.9 96 197.8 96 220.2V267.5L16 313.7C0.7 322.5-4.6 342.1 4.3 357.4L84.3 496C93.1 511.3 112.7 516.5 128 507.7L231.4 448H368C403.3 448 432 419.3 432 384H448C465.7 384 480 369.7 480 352V288H488C501.3 288 512 277.3 512 264V216C512 202.7 501.3 192 488 192zM635.7 154.6L555.7 16C546.9 0.7 527.3-4.5 512 4.3L408.6 64H306.4C294.4 64 282.7 67.4 272.5 73.7L239 94.6C229.6 100.4 224 110.7 224 121.7V248C224 270.1 241.9 288 264 288S304 270.1 304 248V160H488C518.9 160 544 185.1 544 216V244.5L624 198.3C639.3 189.4 644.5 169.9 635.7 154.6z"}]}}),H.register({hands:{width:640,height:512,paths:[{d:"M204.8 230.4C194.2 216.3 174.1 213.4 160 224 145.9 234.6 143 254.7 153.6 268.8L191.7 319.6C196.5 326 195.8 334.9 190.2 340.5L177.4 353.3C170.7 360 159.8 359.5 153.8 352.2L64 244.4V96C64 78.3 49.7 64 32 64S0 78.3 0 96V314.4C0 325.3 3.7 335.9 10.5 344.4L114.6 478.7C119.6 485.2 123 492.6 125 500.4 126.8 507.3 133.1 512 140.3 512H272C280.8 512 288 504.8 288 496V384C288 356.3 279 329.4 262.4 307.2L204.8 230.4zM608 64C590.3 64 576 78.3 576 96V244.4L486.2 352.2C480.2 359.4 469.2 359.9 462.6 353.3L449.8 340.5C444.2 334.9 443.5 326 448.3 319.6L486.4 268.8C497 254.7 494.1 234.6 480 224 465.9 213.4 445.8 216.3 435.2 230.4L377.6 307.2C361 329.4 352 356.3 352 384V496C352 504.8 359.2 512 368 512H499.7C506.8 512 513.2 507.3 515 500.4 517 492.6 520.4 485.2 525.4 478.7L629.5 344.4C636.3 335.9 640 325.3 640 314.4V96C640 78.3 625.7 64 608 64z"}]}}),H.register({handshake:{width:640,height:512,paths:[{d:"M434.7 64H348.8C340.8 64 333.1 67 327.2 72.4L228.9 162.4C228.8 162.5 228.7 162.7 228.6 162.8 212 178.4 212.3 203.3 226.5 218.8 239.2 232.7 265.9 236.4 282.6 221.5 282.7 221.4 282.9 221.4 283 221.3L362.9 148.1C369.4 142.2 379.6 142.6 385.5 149.1 391.5 155.6 391 165.7 384.5 171.7L358.4 195.6 504 313.8C506.9 316.2 509.5 318.8 511.9 321.5V128L457.3 73.4C451.4 67.4 443.2 64 434.7 64zM544 128.2V352.1C544 369.8 558.3 384.1 576 384.1H640V128.2H544zM592 352.1C583.2 352.1 576 344.9 576 336.1S583.2 320.1 592 320.1 608 327.3 608 336.1 600.8 352.1 592 352.1zM0 384H64C81.7 384 96 369.7 96 352V128.2H0V384zM48 320.1C56.8 320.1 64 327.3 64 336.1S56.8 352.1 48 352.1 32 344.9 32 336.1C32 327.2 39.2 320.1 48 320.1zM483.9 338.7L334.6 217.5 304.6 245C274.9 272.1 229.4 269.5 202.9 240.6 176 211.2 178.1 165.7 207.3 138.9L289.1 64H205.3C196.8 64 188.7 67.4 182.7 73.4L128 128V351.9H146.3L236.8 433.8C264.2 456.1 304.5 451.9 326.8 424.5L327 424.3 344.9 439.8C360.8 452.8 384.3 450.3 397.2 434.4L428.6 395.8 434 400.2C447.7 411.3 467.9 409.3 479 395.5L488.5 383.8C499.7 370 497.6 349.9 483.9 338.7z"}]}}),H.register({hashtag:{width:448,height:512,paths:[{d:"M440.7 182.1L447.8 142.1C449.1 134.8 443.5 128 436 128H361.2L375.8 46.1C377.1 38.8 371.5 32 364 32H323.4A12-12 0 0 1 311.6 41.9L296.2 128H197.5L212.2 46.1C213.5 38.8 207.8 32 200.3 32H159.7A12-12 0 0 1 147.9 41.9L132.5 128H53.4A12-12 0 0 1 41.6 137.9L34.5 177.9C33.2 185.2 38.8 192 46.3 192H121.1L98.2 320H19.1A12-12 0 0 1 7.3 329.9L0.2 369.9C-1.1 377.2 4.5 384 12 384H86.8L72.2 465.9C70.9 473.2 76.5 480 84 480H124.6A12-12 0 0 1 136.4 470.1L151.8 384H250.5L235.8 465.9C234.5 473.2 240.2 480 247.7 480H288.3A12-12 0 0 1 300.1 470.1L315.5 384H394.6A12-12 0 0 1 406.4 374.1L413.5 334.1C414.8 326.8 409.2 320 401.7 320H326.9L349.8 192H428.9A12-12 0 0 1 440.7 182.1zM261.9 320H163.3L186.1 192H284.7L261.9 320z"}]}}),H.register({hdd:{width:576,height:512,paths:[{d:"M576 304V400C576 426.5 554.5 448 528 448H48C21.5 448 0 426.5 0 400V304C0 277.5 21.5 256 48 256H528C554.5 256 576 277.5 576 304zM528 224A79.6-79.6 0 0 0 558.8 230.2L462.3 85.4A48-48 0 0 1 422.3 64H153.7A48-48 0 0 1 113.8 85.4L17.2 230.2A79.6-79.6 0 0 0 48 224H528zM480 320C462.3 320 448 334.3 448 352S462.3 384 480 384 512 369.7 512 352 497.7 320 480 320zM384 320C366.3 320 352 334.3 352 352S366.3 384 384 384 416 369.7 416 352 401.7 320 384 320z"}]}}),H.register({heading:{width:512,height:512,paths:[{d:"M496 80V48C496 39.2 488.8 32 480 32H320C311.2 32 304 39.2 304 48V80C304 88.8 311.2 96 320 96H357.6V224H154.4V96H192C200.8 96 208 88.8 208 80V48C208 39.2 200.8 32 192 32H32C23.2 32 16 39.2 16 48V80C16 88.8 23.2 96 32 96H69.3V416H32C23.2 416 16 423.2 16 432V464C16 472.8 23.2 480 32 480H192C200.8 480 208 472.8 208 464V432C208 423.2 200.8 416 192 416H154.4V288H357.6V416H320C311.2 416 304 423.2 304 432V464C304 472.8 311.2 480 320 480H480C488.8 480 496 472.8 496 464V432C496 423.2 488.8 416 480 416H442.7V96H480C488.8 96 496 88.8 496 80z"}]}}),H.register({headphones:{width:512,height:512,paths:[{d:"M256 32C114.5 32 0 146.5 0 288V336A32-32 0 0 1 17.7 364.6L32.1 371.8C34.1 431.9 83.4 480 144 480H168C181.3 480 192 469.3 192 456V280C192 266.7 181.3 256 168 256H144C112.7 256 84.3 268.9 64 289.6V288C64 182.1 150.1 96 256 96S448 182.1 448 288V289.6C427.7 268.9 399.3 256 368 256H344C330.7 256 320 266.7 320 280V456C320 469.3 330.7 480 344 480H368C428.6 480 477.9 431.9 479.9 371.8L494.3 364.6A32-32 0 0 1 512 336V288C512 146.5 397.5 32 256 32z"}]}}),H.register({heart:{width:512,height:512,paths:[{d:"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5 236.3 76.2C186.1 24.3 104.5 15.9 49.7 62.6-13.1 116.2-16.4 212.4 39.8 270.5L233.3 470.3C245.8 483.2 266.1 483.2 278.6 470.3L472.1 270.5C528.4 212.4 525.1 116.2 462.3 62.6z"}]}}),H.register({heartbeat:{width:512,height:512,paths:[{d:"M320.2 243.8L270.5 343.2C264.5 355.3 247.1 354.9 241.6 342.6L184.7 216.3 154.7 288H60.6L243.1 474.5C250.2 481.8 261.7 481.8 268.8 474.5L451.4 288H342.3L320.2 243.8zM473.7 73.9L471.3 71.4C419.8 18.8 335.5 18.8 283.9 71.4L256 100 228.1 71.5C176.6 18.8 92.2 18.8 40.7 71.5L38.3 73.9C-10.4 123.7-12.5 203 31 256H133.4L169.3 169.8C174.7 156.9 192.9 156.6 198.7 169.4L256.9 298.7 305.9 200.8C311.8 189 328.6 189 334.5 200.8L362.1 256H481C524.5 203 522.4 123.7 473.7 73.9z"}]}}),H.register({history:{width:512,height:512,paths:[{d:"M504 255.5C504.3 392.2 392.8 503.9 256.2 504 197.2 504 143 483.5 100.4 449.1 89.3 440.1 88.5 423.5 98.5 413.5L109.8 402.2C118.4 393.6 132.1 392.7 141.7 400.2 173.1 425.1 212.8 440 256 440 357.7 440 440 357.7 440 256 440 154.3 357.7 72 256 72 207.2 72 162.9 91 129.9 121.9L180.7 172.7C190.8 182.8 183.6 200 169.4 200H24C15.2 200 8 192.8 8 184V38.6C8 24.4 25.2 17.2 35.3 27.3L84.7 76.7C129.2 34.1 189.6 8 256 8 392.8 8 503.7 118.8 504 255.5zM323.1 334.3L332.9 321.7C341 311.2 339.2 296.1 328.7 288L288 256.3V152C288 138.7 277.3 128 264 128H248C234.7 128 224 138.7 224 152V287.7L289.4 338.5C299.9 346.7 314.9 344.8 323.1 334.3z"}]}}),H.register({"hockey-puck":{width:512,height:512,paths:[{d:"M0 160C0 107 114.6 64 256 64S512 107 512 160 397.4 256 256 256 0 213 0 160zM0 242.2V352C0 405 114.6 448 256 448S512 405 512 352V242.2C398.6 324.5 113.5 324.6 0 242.2z"}]}}),H.register({home:{width:576,height:512,paths:[{d:"M488 312.7V456C488 469.3 477.3 480 464 480H348C341.4 480 336 474.6 336 468V356C336 349.4 330.6 344 324 344H252C245.4 344 240 349.4 240 356V468C240 474.6 234.6 480 228 480H112C98.7 480 88 469.3 88 456V312.7C88 309.1 89.6 305.7 92.4 303.4L280.4 148.6C284.8 145 291.2 145 295.7 148.6L483.7 303.4C486.4 305.7 488 309.1 488 312.7zM571.6 251.8L488 182.9V44.4C488 37.8 482.6 32.4 476 32.4H420C413.4 32.4 408 37.8 408 44.4V117L318.5 43.3C300.8 28.7 275.2 28.7 257.5 43.3L4.4 251.8C-0.7 256-1.4 263.6 2.8 268.7L28.3 299.7C32.5 304.8 40.1 305.5 45.2 301.3L280.4 107.6C284.8 104 291.2 104 295.7 107.6L530.9 301.3C536 305.5 543.6 304.8 547.8 299.7L573.3 268.7C577.5 263.5 576.7 256 571.6 251.8z"}]}}),H.register({"hospital-alt":{width:576,height:512,paths:[{d:"M544 96H416V32C416 14.3 401.7 0 384 0H192C174.3 0 160 14.3 160 32V96H32C14.3 96 0 110.3 0 128V496C0 504.8 7.2 512 16 512H560C568.8 512 576 504.8 576 496V128C576 110.3 561.7 96 544 96zM160 436C160 442.6 154.6 448 148 448H108C101.4 448 96 442.6 96 436V396C96 389.4 101.4 384 108 384H148C154.6 384 160 389.4 160 396V436zM160 308C160 314.6 154.6 320 148 320H108C101.4 320 96 314.6 96 308V268C96 261.4 101.4 256 108 256H148C154.6 256 160 261.4 160 268V308zM320 436C320 442.6 314.6 448 308 448H268C261.4 448 256 442.6 256 436V396C256 389.4 261.4 384 268 384H308C314.6 384 320 389.4 320 396V436zM320 308C320 314.6 314.6 320 308 320H268C261.4 320 256 314.6 256 308V268C256 261.4 261.4 256 268 256H308C314.6 256 320 261.4 320 268V308zM336 138C336 141.3 333.3 144 330 144H304V170C304 173.3 301.3 176 298 176H278C274.7 176 272 173.3 272 170V144H246C242.7 144 240 141.3 240 138V118C240 114.7 242.7 112 246 112H272V86C272 82.7 274.7 80 278 80H298C301.3 80 304 82.7 304 86V112H330C333.3 112 336 114.7 336 118V138zM480 436C480 442.6 474.6 448 468 448H428C421.4 448 416 442.6 416 436V396C416 389.4 421.4 384 428 384H468C474.6 384 480 389.4 480 396V436zM480 308C480 314.6 474.6 320 468 320H428C421.4 320 416 314.6 416 308V268C416 261.4 421.4 256 428 256H468C474.6 256 480 261.4 480 268V308z"}]}}),H.register({"hospital-symbol":{width:512,height:512,paths:[{d:"M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512 512 397.4 512 256 397.4 0 256 0zM368 376C368 380.4 364.4 384 360 384H312C307.6 384 304 380.4 304 376V288H208V376C208 380.4 204.4 384 200 384H152C147.6 384 144 380.4 144 376V136C144 131.6 147.6 128 152 128H200C204.4 128 208 131.6 208 136V224H304V136C304 131.6 307.6 128 312 128H360C364.4 128 368 131.6 368 136V376z"}]}}),H.register({hospital:{width:448,height:512,paths:[{d:"M448 492V512H0V492C0 485.4 5.4 480 12 480H32V120C32 106.7 42.7 96 56 96H144V24C144 10.7 154.7 0 168 0H280C293.3 0 304 10.7 304 24V96H392C405.3 96 416 106.7 416 120V480H436C442.6 480 448 485.4 448 492zM308 192H268C261.4 192 256 197.4 256 204V244C256 250.6 261.4 256 268 256H308C314.6 256 320 250.6 320 244V204C320 197.4 314.6 192 308 192zM140 256H180C186.6 256 192 250.6 192 244V204C192 197.4 186.6 192 180 192H140C133.4 192 128 197.4 128 204V244C128 250.6 133.4 256 140 256zM244 384H204C197.4 384 192 389.4 192 396V480H256V396C256 389.4 250.6 384 244 384zM308 288H268C261.4 288 256 293.4 256 300V340C256 346.6 261.4 352 268 352H308C314.6 352 320 346.6 320 340V300C320 293.4 314.6 288 308 288zM192 300C192 293.4 186.6 288 180 288H140C133.4 288 128 293.4 128 300V340C128 346.6 133.4 352 140 352H180C186.6 352 192 346.6 192 340V300zM182 96H208V122A6-6 0 0 1 214 128H234A6-6 0 0 1 240 122V96H266A6-6 0 0 1 272 90V70A6-6 0 0 1 266 64H240V38A6-6 0 0 1 234 32H214A6-6 0 0 1 208 38V64H182A6-6 0 0 1 176 70V90A6-6 0 0 1 182 96z"}]}}),H.register({"hourglass-end":{width:384,height:512,paths:[{d:"M360 64C373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64zM192 208C134.2 208 88 141.5 88 64H296C296 141.9 249.5 208 192 208z"}]}}),H.register({"hourglass-half":{width:384,height:512,paths:[{d:"M360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64 373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0zM284.9 384H99.1C116.1 337.2 151.2 304 192 304 232.8 304 267.9 337.2 284.9 384zM284.9 128H99.1C92 108.5 88 86.7 88 64H296C296 86.8 292 108.6 284.9 128z"}]}}),H.register({"hourglass-start":{width:384,height:512,paths:[{d:"M360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64 373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0zM296 448H88C88 370.5 134.2 304 192 304 249.8 304 296 370.5 296 448z"}]}}),H.register({hourglass:{width:384,height:512,paths:[{d:"M360 64C373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64z"}]}}),H.register({"i-cursor":{width:256,height:512,paths:[{d:"M256 52V12.1C256 5.5 250.7 0.1 244.2 0.1 211.6-0.3 166.5 0 128 38 90.3 0.7 47-0.1 11.9 0.1 5.3 0.2 0 5.5 0 12.1V51.8C0 58.4 5.5 63.8 12.1 63.8 38.1 63.4 96 67.2 96 112.2V224H60C53.4 224 48 229.4 48 236V276C48 282.6 53.4 288 60 288H96V400C96 444.9 39.9 448 12.1 448 5.4 447.9 0 453.3 0 460V499.9C0 506.5 5.3 511.9 11.8 511.9 44.4 512.3 89.5 512 128 474 165.7 511.3 209 512.1 244.1 511.9 250.7 511.8 256 506.5 256 499.9V460.2C256 453.6 250.5 448.2 243.9 448.2 217.9 448.6 160 444.9 160 400V288H196C202.6 288 208 282.6 208 276V236C208 229.4 202.6 224 196 224H160V112.2C160 67.3 216.1 64 243.9 64 250.6 64.1 256 58.7 256 52z"}]}}),H.register({"id-badge":{width:384,height:512,paths:[{d:"M336 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0zM128 44C128 37.4 133.4 32 140 32H244C250.6 32 256 37.4 256 44V52C256 58.6 250.6 64 244 64H140C133.4 64 128 58.6 128 52V44zM192 160C236.2 160 272 195.8 272 240S236.2 320 192 320 112 284.2 112 240 147.8 160 192 160zM320 392C320 405.3 309.3 416 296 416H88C74.7 416 64 405.3 64 392V373.5C64 351.5 79 332.3 100.4 326.9L136 318C165.1 338.9 210.5 344.9 248 318L283.6 326.9C305 332.3 320 351.5 320 373.5V392z"}]}}),H.register({"id-card-alt":{width:576,height:512,paths:[{d:"M512 64H384V160H192V64H64C28.7 64 0 92.7 0 128V448C0 483.3 28.7 512 64 512H160V501.3C160 454.2 198.2 416 245.3 416H330.6C377.7 416 415.9 454.2 415.9 501.3V512H511.9C547.2 512 575.9 483.3 575.9 448V128C576 92.7 547.3 64 512 64zM288 384C243.8 384 208 348.2 208 304S243.8 224 288 224 368 259.8 368 304 332.2 384 288 384zM352 32C352 14.3 337.7 0 320 0H256C238.3 0 224 14.3 224 32V128H352V32z"}]}}),H.register({"id-card":{width:512,height:512,paths:[{d:"M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM256 350C256 359.9 247.9 368 238 368H82C72.1 368 64 359.9 64 350V336.1C64 319.6 75.2 305.2 91.3 301.2L118 294.5C139.8 310.2 173.9 314.7 202 294.5L228.7 301.2C244.8 305.2 256 319.6 256 336.1V350zM100 236C100 202.9 126.9 176 160 176S220 202.9 220 236 193.1 296 160 296 100 269.1 100 236zM448 340C448 346.6 442.6 352 436 352H300C293.4 352 288 346.6 288 340V332C288 325.4 293.4 320 300 320H436C442.6 320 448 325.4 448 332V340zM448 276C448 282.6 442.6 288 436 288H300C293.4 288 288 282.6 288 276V268C288 261.4 293.4 256 300 256H436C442.6 256 448 261.4 448 268V276zM448 212C448 218.6 442.6 224 436 224H300C293.4 224 288 218.6 288 212V204C288 197.4 293.4 192 300 192H436C442.6 192 448 197.4 448 204V212zM480 116C480 122.6 474.6 128 468 128H44C37.4 128 32 122.6 32 116V108C32 101.4 37.4 96 44 96H468C474.6 96 480 101.4 480 108V116z"}]}}),H.register({image:{width:512,height:512,paths:[{d:"M464 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H464C490.5 64 512 85.5 512 112V400C512 426.5 490.5 448 464 448zM112 120C81.1 120 56 145.1 56 176S81.1 232 112 232 168 206.9 168 176 142.9 120 112 120zM64 384H448V272L360.5 184.5C355.8 179.8 348.2 179.8 343.5 184.5L208 320 152.5 264.5C147.8 259.8 140.2 259.8 135.5 264.5L64 336V384z"}]}}),H.register({images:{width:576,height:512,paths:[{d:"M480 416V432C480 458.5 458.5 480 432 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H64V336C64 380.1 99.9 416 144 416H480zM576 336V80C576 53.5 554.5 32 528 32H144C117.5 32 96 53.5 96 80V336C96 362.5 117.5 384 144 384H528C554.5 384 576 362.5 576 336zM256 128C256 154.5 234.5 176 208 176S160 154.5 160 128 181.5 80 208 80 256 101.5 256 128zM160 272L215.5 216.5C220.2 211.8 227.8 211.8 232.5 216.5L272 256 407.5 120.5C412.2 115.8 419.8 115.8 424.5 120.5L512 208V320H160V272z"}]}}),H.register({inbox:{width:576,height:512,paths:[{d:"M567.9 243.9L462.3 85.4A48-48 0 0 1 422.3 64H153.7A48-48 0 0 1 113.8 85.4L8.1 243.9A48-48 0 0 1 0 270.5V400C0 426.5 21.5 448 48 448H528C554.5 448 576 426.5 576 400V270.5A48-48 0 0 1 567.9 243.9zM162.3 128H413.7L499.1 256H376L344 320H232L200 256H76.9L162.3 128z"}]}}),H.register({indent:{width:448,height:512,paths:[{d:"M0 84V44C0 35.2 7.2 28 16 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H16C7.2 100 0 92.8 0 84zM176 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H176C167.2 156 160 163.2 160 172V212C160 220.8 167.2 228 176 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM176 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H176C167.2 284 160 291.2 160 300V340C160 348.8 167.2 356 176 356zM123.3 244.7L27.3 148.7C17.3 138.7 0 145.8 0 160V352C0 366.3 17.3 373.3 27.3 363.3L123.3 267.3C129.6 261.1 129.6 250.9 123.3 244.7z"}]}}),H.register({industry:{width:512,height:512,paths:[{d:"M475.1 163.8L336 252.3V184C336 165.1 315.1 153.6 299.1 163.8L160 252.3V56C160 42.7 149.3 32 136 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H488C501.3 480 512 469.3 512 456V184C512 165.1 491.1 153.6 475.1 163.8z"}]}}),H.register({"info-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119.1 8 256 8 393 119 504 256 504S504 393 504 256C504 119.1 393 8 256 8zM256 118C279.2 118 298 136.8 298 160S279.2 202 256 202 214 183.2 214 160 232.8 118 256 118zM312 372C312 378.6 306.6 384 300 384H212C205.4 384 200 378.6 200 372V348C200 341.4 205.4 336 212 336H224V272H212C205.4 272 200 266.6 200 260V236C200 229.4 205.4 224 212 224H276C282.6 224 288 229.4 288 236V336H300C306.6 336 312 341.4 312 348V372z"}]}}),H.register({info:{width:192,height:512,paths:[{d:"M20 424.2H40V279.8H20C9 279.8 0 270.8 0 259.8V212C0 201 9 192 20 192H132C143 192 152 201 152 212V424.2H172C183 424.2 192 433.2 192 444.2V492C192 503 183 512 172 512H20C9 512 0 503 0 492V444.2C0 433.2 9 424.2 20 424.2zM96 0C56.2 0 24 32.2 24 72S56.2 144 96 144 168 111.8 168 72 135.8 0 96 0z"}]}}),H.register({italic:{width:320,height:512,paths:[{d:"M204.8 416H170.9L233 96H273.7A16-16 0 0 1 289.4 83.1L295.7 51.1C297.6 41.2 290 32 280 32H120.2A16-16 0 0 1 104.5 44.9L98.3 76.9C96.4 86.8 103.9 96 114 96H147.8L85.7 416H46.3A16-16 0 0 1 30.6 428.9L24.3 460.9C22.4 470.8 30 480 40 480H198.5A16-16 0 0 1 214.2 467.1L220.5 435.1C222.4 425.2 214.8 416 204.8 416z"}]}}),H.register({key:{width:512,height:512,paths:[{d:"M512 176C512 273.2 433.2 352 336 352 324.8 352 313.8 350.9 303.2 348.9L279.2 375.9A24-24 0 0 0 261.2 384H224V424C224 437.3 213.3 448 200 448H160V488C160 501.3 149.3 512 136 512H24C10.7 512 0 501.3 0 488V409.9C0 403.6 2.5 397.5 7 393L168.8 231.2C163.1 213.8 160 195.3 160 176 160 78.8 238.8 0 336 0 433.5 0 512 78.5 512 176zM336 128C336 154.5 357.5 176 384 176S432 154.5 432 128 410.5 80 384 80 336 101.5 336 128z"}]}}),H.register({keyboard:{width:576,height:512,paths:[{d:"M528 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H528C554.5 64 576 85.5 576 112V400C576 426.5 554.5 448 528 448zM128 180V140C128 133.4 122.6 128 116 128H76C69.4 128 64 133.4 64 140V180C64 186.6 69.4 192 76 192H116C122.6 192 128 186.6 128 180zM224 180V140C224 133.4 218.6 128 212 128H172C165.4 128 160 133.4 160 140V180C160 186.6 165.4 192 172 192H212C218.6 192 224 186.6 224 180zM320 180V140C320 133.4 314.6 128 308 128H268C261.4 128 256 133.4 256 140V180C256 186.6 261.4 192 268 192H308C314.6 192 320 186.6 320 180zM416 180V140C416 133.4 410.6 128 404 128H364C357.4 128 352 133.4 352 140V180C352 186.6 357.4 192 364 192H404C410.6 192 416 186.6 416 180zM512 180V140C512 133.4 506.6 128 500 128H460C453.4 128 448 133.4 448 140V180C448 186.6 453.4 192 460 192H500C506.6 192 512 186.6 512 180zM176 276V236C176 229.4 170.6 224 164 224H124C117.4 224 112 229.4 112 236V276C112 282.6 117.4 288 124 288H164C170.6 288 176 282.6 176 276zM272 276V236C272 229.4 266.6 224 260 224H220C213.4 224 208 229.4 208 236V276C208 282.6 213.4 288 220 288H260C266.6 288 272 282.6 272 276zM368 276V236C368 229.4 362.6 224 356 224H316C309.4 224 304 229.4 304 236V276C304 282.6 309.4 288 316 288H356C362.6 288 368 282.6 368 276zM464 276V236C464 229.4 458.6 224 452 224H412C405.4 224 400 229.4 400 236V276C400 282.6 405.4 288 412 288H452C458.6 288 464 282.6 464 276zM128 372V332C128 325.4 122.6 320 116 320H76C69.4 320 64 325.4 64 332V372C64 378.6 69.4 384 76 384H116C122.6 384 128 378.6 128 372zM416 372V332C416 325.4 410.6 320 404 320H172C165.4 320 160 325.4 160 332V372C160 378.6 165.4 384 172 384H404C410.6 384 416 378.6 416 372zM512 372V332C512 325.4 506.6 320 500 320H460C453.4 320 448 325.4 448 332V372C448 378.6 453.4 384 460 384H500C506.6 384 512 378.6 512 372z"}]}}),H.register({language:{width:640,height:512,paths:[{d:"M304 416H24C10.7 416 0 405.3 0 392V120C0 106.7 10.7 96 24 96H304V416zM183.3 343.4A12-12 0 0 1 194.8 352H217.7C225.9 352 231.7 343.9 229.1 336.1L171.6 167.1A12-12 0 0 1 160.2 158.9H127.8A12-12 0 0 1 116.4 167.1L58.9 336.1C56.3 343.9 62.1 352 70.3 352H93.1A12-12 0 0 1 104.6 343.3L113.8 311.5H174L183.3 343.4zM144.3 203S148.6 224 152.1 236.2L162.9 273.7H124.8L135.9 236.2C139.4 224 143.7 203 143.7 203H144.3zM616 416H336V96H616C629.3 96 640 106.7 640 120V392C640 405.3 629.3 416 616 416zM580 188H516V172C516 165.4 510.6 160 504 160H488C481.4 160 476 165.4 476 172V188H412C405.4 188 400 193.4 400 200V216C400 222.6 405.4 228 412 228H526.1C519.8 242.3 509.6 257 496.1 271.2 489.5 264.3 483.7 257.3 478.7 250.3 475.1 245.1 468.1 243.6 462.7 246.8L455.4 251.2 448.9 255.1C443 258.6 441.3 266.5 445.2 272.2 451.3 280.9 458.3 289.5 466.2 297.9 458.1 304.1 449.4 310.1 440.1 315.9 434.6 319.3 432.7 326.4 435.9 332L443.9 345.9C447.2 351.8 454.8 353.8 460.6 350.2 473.3 342.4 485.1 334 496 325.3 506.9 334.1 518.8 342.4 531.4 350.2 537.2 353.8 544.8 351.8 548.1 345.9L556.1 332C559.3 326.4 557.4 319.3 551.9 315.9A312.7-312.7 0 0 0 525.9 297.8C546.9 275.4 561.6 251.6 568.6 228H580C586.6 228 592 222.6 592 216V200C592 193.4 586.6 188 580 188z"}]}}),H.register({laptop:{width:640,height:512,paths:[{d:"M512 64V320H128V64H512M528 0H112C85.5 0 64 21.5 64 48V336C64 362.5 85.5 384 112 384H528C554.5 384 576 362.5 576 336V48C576 21.5 554.5 0 528 0zM628 416H389.5C386.5 416 384 418.1 383.6 421.1 381.2 436.3 368 448 352 448H288C272 448 258.8 436.3 256.4 421.1 255.9 418.2 253.4 416 250.5 416H12C5.4 416 0 421.4 0 428V464C0 490.5 21.5 512 48 512H592C618.5 512 640 490.5 640 464V428C640 421.4 634.6 416 628 416z"}]}}),H.register({leaf:{width:576,height:512,paths:[{d:"M546.2 9.7C540.6-2.8 524.6-3.3 517.9 8.5 486.9 62.4 431.4 96 368 96H288C182 96 96 182 96 288 96 295 96.8 301.7 97.5 308.5 161.3 262.8 253.4 224 384 224 392.8 224 400 231.2 400 240S392.8 256 384 256C132.6 256 26 410.1 2.4 468-4.2 484.3 3.6 502.9 19.9 509.6 36.3 516.4 54.9 508.5 61.7 492.3 63.2 488.7 82.6 444.4 133.6 401.7 166 445.6 227.6 487.5 308.5 478.9 465.5 467.5 576 326.7 576 154.3 576 104.1 565.2 52.1 546.2 9.7z"}]}}),H.register({lemon:{width:512,height:512,paths:[{d:"M489 23C465.9-0.1 434.6-5.9 413.9 6.1 355 40.4 232.7-46.9 92.9 92.9S40.4 355 6.1 413.9C-5.9 434.6-0.1 465.9 23 489 46.1 512.1 77.4 517.9 98.1 505.9 157 471.6 279.3 558.9 419.1 419.1S471.6 157 505.9 98.1C517.9 77.4 512.1 46.1 489 23zM243.9 95.5C185.7 110.1 110.1 185.7 95.5 243.9 93.7 251.2 87.2 256 80 256 78.7 256 77.4 255.8 76.1 255.5 67.5 253.4 62.3 244.7 64.5 236.1 81.9 166.4 166.3 81.9 236.1 64.5 244.7 62.3 253.4 67.5 255.5 76.1S252.5 93.4 243.9 95.5z"}]}}),H.register({"level-down-alt":{width:320,height:512,paths:[{d:"M313.6 392.3L209.6 504.3C200.1 514.5 183.9 514.6 174.4 504.3L70.4 392.3C56.2 377 67.1 352 88 352H152V80H68A12-12 0 0 0 59.5 76.5L3.5 20.5C-4 12.9 1.3 0 12 0H208C221.3 0 232 10.7 232 24V352H296C316.8 352 327.8 377 313.6 392.3z"}]}}),H.register({"level-up-alt":{width:320,height:512,paths:[{d:"M313.6 119.7L209.6 7.7C200.1-2.5 183.9-2.6 174.4 7.7L70.4 119.7C56.2 135 67.1 160 88 160H152V432H68A12-12 0 0 1 59.5 435.5L3.5 491.5C-4 499.1 1.3 512 12 512H208C221.3 512 232 501.3 232 488V160H296C316.8 160 327.8 135 313.6 119.7z"}]}}),H.register({"life-ring":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM429.7 127.6L366.3 191C355.3 172.4 339.6 156.7 321 145.7L384.4 82.3A218.4-218.4 0 0 0 429.7 127.6zM256 352C203 352 160 309 160 256S203 160 256 160 352 203 352 256 309 352 256 352zM127.6 82.3L191 145.7C172.4 156.7 156.7 172.4 145.7 191L82.3 127.6A218.4-218.4 0 0 0 127.6 82.3zM82.3 384.4L145.7 321C156.7 339.6 172.4 355.3 191 366.3L127.6 429.7A218.4-218.4 0 0 0 82.3 384.4zM384.4 429.7L321 366.3C339.6 355.3 355.3 339.6 366.3 321L429.7 384.4A218.4-218.4 0 0 0 384.4 429.7z"}]}}),H.register({lightbulb:{width:384,height:512,paths:[{d:"M272 428V456C272 466.4 265.3 475.3 256 478.6V488C256 501.3 245.3 512 232 512H152C138.7 512 128 501.3 128 488V478.6C118.7 475.3 112 466.4 112 456V428C112 421.4 117.4 416 124 416H260C266.6 416 272 421.4 272 428zM128.9 384C119 384 110.1 377.9 106.5 368.7 67.7 267.5 16 277.7 16 176 16 78.8 94.8 0 192 0S368 78.8 368 176C368 277.7 316.3 267.5 277.5 368.7 273.9 377.9 265 384 255.1 384H128.9zM112 176C112 131.9 147.9 96 192 96 200.8 96 208 88.8 208 80S200.8 64 192 64C130.2 64 80 114.2 80 176 80 184.8 87.2 192 96 192S112 184.8 112 176z"}]}}),H.register({link:{width:512,height:512,paths:[{d:"M326.6 185.4C386.4 245.2 385.5 341.1 327 400 326.9 400.1 326.7 400.2 326.6 400.4L259.4 467.6C200.1 526.8 103.7 526.8 44.5 467.6-14.8 408.3-14.8 311.9 44.5 252.6L81.6 215.5C91.4 205.6 108.3 212.2 108.9 226.1 109.5 243.8 112.7 261.6 118.5 278.8 120.5 284.6 119.1 291.1 114.8 295.4L101.7 308.5C73.6 336.5 72.8 382.2 100.5 410.5 128.5 439.1 174.6 439.2 202.8 411L270 343.8C298.2 315.6 298.1 270 270 242 266.3 238.3 262.6 235.4 259.7 233.4A16-16 0 0 0 252.8 220.8C252.4 210.2 256.1 199.3 264.5 191L285.5 169.9C291 164.4 299.7 163.7 306.1 168.2A152.5-152.5 0 0 0 326.6 185.4zM467.5 44.4C408.3-14.8 311.9-14.8 252.6 44.4L185.4 111.6C185.3 111.8 185.1 111.9 185 112 126.5 170.9 125.6 266.8 185.4 326.6A152.5-152.5 0 0 1 205.9 343.8C212.3 348.3 221 347.6 226.5 342.1L247.5 321C255.9 312.7 259.6 301.8 259.2 291.2A16-16 0 0 1 252.3 278.6C249.4 276.6 245.7 273.7 242 270 213.9 242 213.8 196.4 242 168.2L309.2 101C337.4 72.8 383.5 72.9 411.5 101.5 439.2 129.8 438.4 175.5 410.3 203.5L397.2 216.6C392.9 220.9 391.5 227.4 393.5 233.2 399.3 250.4 402.5 268.2 403.1 285.9 403.7 299.8 420.6 306.4 430.4 296.5L467.5 259.4C526.8 200.1 526.8 103.7 467.5 44.4z"}]}}),H.register({"lira-sign":{width:384,height:512,paths:[{d:"M372 256H324C317.6 256 312 260.9 312 267.2 312 368 230.2 416 144 416V256.8L278.6 226.9A12-12 0 0 1 288 215.2V174.2C288 166.5 280.9 160.8 273.4 162.5L144 191.2V160.8L278.6 130.9A12-12 0 0 1 288 119.2V78.2C288 70.5 280.9 64.8 273.4 66.5L144 95.2V44C144 37.4 138.6 32 132 32H76C69.4 32 64 37.4 64 44V113L9.4 125.1A12-12 0 0 1 0 136.8V177.8C0 185.5 7.1 191.2 14.6 189.5L64 178.6V209L9.4 221.1A12-12 0 0 1 0 232.8V273.8C0 281.5 7.1 287.2 14.6 285.5L64 274.6V468C64 474.6 69.4 480 76 480H155.6C289.7 480 378.8 402.2 384 268.4 384.3 261.6 378.8 256 372 256z"}]}}),H.register({"list-alt":{width:512,height:512,paths:[{d:"M464 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H464C490.5 32 512 53.5 512 80V432C512 458.5 490.5 480 464 480zM128 120C105.9 120 88 137.9 88 160S105.9 200 128 200 168 182.1 168 160 150.1 120 128 120zM128 216C105.9 216 88 233.9 88 256S105.9 296 128 296 168 278.1 168 256 150.1 216 128 216zM128 312C105.9 312 88 329.9 88 352S105.9 392 128 392 168 374.1 168 352 150.1 312 128 312zM416 176V144C416 137.4 410.6 132 404 132H204C197.4 132 192 137.4 192 144V176C192 182.6 197.4 188 204 188H404C410.6 188 416 182.6 416 176zM416 272V240C416 233.4 410.6 228 404 228H204C197.4 228 192 233.4 192 240V272C192 278.6 197.4 284 204 284H404C410.6 284 416 278.6 416 272zM416 368V336C416 329.4 410.6 324 404 324H204C197.4 324 192 329.4 192 336V368C192 374.6 197.4 380 204 380H404C410.6 380 416 374.6 416 368z"}]}}),H.register({"list-ol":{width:512,height:512,paths:[{d:"M3.3 139.5C3.3 132 7.2 128 14.8 128H30V88.1C30 82.9 30.5 77.6 30.5 77.6H30.1S28.4 80.2 27.3 81.3C22.8 85.6 16.8 85.8 11.6 80.2L6.1 74C0.8 68.7 1.1 62.8 6.6 57.6L28.4 37.7C32.8 33.6 36.7 32 42.8 32H54.9C62.5 32 66.6 35.9 66.6 43.6V128H82.1C89.8 128 93.7 132.1 93.7 139.5V148.4C93.7 155.9 89.8 160 82.1 160H14.8C7.2 160 3.3 155.9 3.3 148.4V139.5zM2.2 304.6C2.2 257.3 53.2 248.2 53.2 235.4 53.2 228.2 47.2 226.7 43.9 226.7 40.7 226.7 37.4 227.7 34.4 230.5 29.4 235.4 23.9 237.5 18.3 233L9.7 226.1C4 221.6 2.6 216.3 6.9 210.7 13.6 202 26 192 47.4 192 66.8 192 91.9 202.5 91.9 231.6 91.9 269.9 45.1 278 43.2 288.5H82.2C89.8 288.5 93.8 292.5 93.8 299.9V308.6C93.8 316 89.8 320 82.2 320H14.3C7.3 320 2.2 316 2.2 308.6V304.6zM5.7 454.6L11.3 445.3C15.1 438.7 20.4 438.3 26.8 442.2 31.7 444.3 36.5 445.3 41.2 445.3 51.4 445.3 55.6 441.8 55.6 437.1 55.6 430.4 50 428 39.6 428H34.9C28.9 428 25.6 425.9 22.6 420.1L21.6 418.2C19.1 413.5 20.4 408.4 24.4 403.3L30 396.3C36.8 387.9 42.3 382.8 42.3 382.8V382.5S38 383.5 29.6 383.5H16.7C9.2 383.5 5.3 379.5 5.3 372.1V363.4C5.3 355.9 9.2 352 16.7 352H75.2C82.7 352 86.6 356 86.6 363.4V366.7C86.6 372.5 85.2 376.5 81.5 380.9L64 401C83.6 406.1 92.7 421.5 92.7 435.9 92.7 457.2 78.3 480 44.2 480 27.5 480 16 475.3 8.3 470.5 2.5 466.3 2 460.7 5.7 454.6zM144 132H496C504.8 132 512 124.8 512 116V76C512 67.2 504.8 60 496 60H144C135.2 60 128 67.2 128 76V116C128 124.8 135.2 132 144 132zM144 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H144C135.2 220 128 227.2 128 236V276C128 284.8 135.2 292 144 292zM144 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H144C135.2 380 128 387.2 128 396V436C128 444.8 135.2 452 144 452z"}]}}),H.register({"list-ul":{width:512,height:512,paths:[{d:"M96 96C96 122.5 74.5 144 48 144S0 122.5 0 96 21.5 48 48 48 96 69.5 96 96zM48 208C21.5 208 0 229.5 0 256S21.5 304 48 304 96 282.5 96 256 74.5 208 48 208zM48 368C21.5 368 0 389.5 0 416S21.5 464 48 464 96 442.5 96 416 74.5 368 48 368zM144 132H496C504.8 132 512 124.8 512 116V76C512 67.2 504.8 60 496 60H144C135.2 60 128 67.2 128 76V116C128 124.8 135.2 132 144 132zM144 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H144C135.2 220 128 227.2 128 236V276C128 284.8 135.2 292 144 292zM144 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H144C135.2 380 128 387.2 128 396V436C128 444.8 135.2 452 144 452z"}]}}),H.register({list:{width:512,height:512,paths:[{d:"M128 116V76C128 67.2 135.2 60 144 60H496C504.8 60 512 67.2 512 76V116C512 124.8 504.8 132 496 132H144C135.2 132 128 124.8 128 116zM144 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H144C135.2 220 128 227.2 128 236V276C128 284.8 135.2 292 144 292zM144 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H144C135.2 380 128 387.2 128 396V436C128 444.8 135.2 452 144 452zM16 144H80C88.8 144 96 136.8 96 128V64C96 55.2 88.8 48 80 48H16C7.2 48 0 55.2 0 64V128C0 136.8 7.2 144 16 144zM16 304H80C88.8 304 96 296.8 96 288V224C96 215.2 88.8 208 80 208H16C7.2 208 0 215.2 0 224V288C0 296.8 7.2 304 16 304zM16 464H80C88.8 464 96 456.8 96 448V384C96 375.2 88.8 368 80 368H16C7.2 368 0 375.2 0 384V448C0 456.8 7.2 464 16 464z"}]}}),H.register({"location-arrow":{width:512,height:512,paths:[{d:"M443.7 4.5L27.8 196.4C-18.7 217.9-3.4 288 47.9 288H224V464C224 515.7 294.2 530.5 315.6 484.1L507.4 68.2C526.3 27.3 483.6-13.9 443.7 4.5z"}]}}),H.register({"lock-open":{width:576,height:512,paths:[{d:"M423.5 0C339.5 0.3 272 69.5 272 153.5V224H48C21.5 224 0 245.5 0 272V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V272C448 245.5 426.5 224 400 224H352V152.9C352 113.3 383.7 80.4 423.3 80 463.3 79.6 496 112.1 496 152V232C496 245.3 506.7 256 520 256H552C565.3 256 576 245.3 576 232V152C576 68 507.5-0.3 423.5 0z"}]}}),H.register({lock:{width:448,height:512,paths:[{d:"M400 224H376V152C376 68.2 307.8 0 224 0S72 68.2 72 152V224H48C21.5 224 0 245.5 0 272V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V272C448 245.5 426.5 224 400 224zM296 224H152V152C152 112.3 184.3 80 224 80S296 112.3 296 152V224z"}]}}),H.register({"long-arrow-alt-down":{width:256,height:512,paths:[{d:"M168 345.9V44C168 37.4 162.6 32 156 32H100C93.4 32 88 37.4 88 44V345.9H41.9C20.6 345.9 9.9 371.8 25 386.9L111 473C120.4 482.3 135.6 482.3 145 473L231 386.9C246.1 371.8 235.4 345.9 214.1 345.9H168z"}]}}),H.register({"long-arrow-alt-left":{width:448,height:512,paths:[{d:"M134.1 296H436C442.6 296 448 290.6 448 284V228C448 221.4 442.6 216 436 216H134.1V169.9C134.1 148.6 108.2 137.9 93.1 153L7 239C-2.3 248.4-2.3 263.6 7 273L93.1 359C108.2 374.1 134.1 363.4 134.1 342.1V296z"}]}}),H.register({"long-arrow-alt-right":{width:448,height:512,paths:[{d:"M313.9 216H12C5.4 216 0 221.4 0 228V284C0 290.6 5.4 296 12 296H313.9V342.1C313.9 363.4 339.8 374.1 354.9 359L441 273C450.3 263.6 450.3 248.4 441 239L354.9 153C339.8 137.9 313.9 148.6 313.9 169.9V216z"}]}}),H.register({"long-arrow-alt-up":{width:256,height:512,paths:[{d:"M88 166.1V468C88 474.6 93.4 480 100 480H156C162.6 480 168 474.6 168 468V166.1H214.1C235.4 166.1 246.1 140.2 231 125.1L145 39C135.6 29.7 120.4 29.7 111 39L25 125.1C9.9 140.2 20.6 166.1 41.9 166.1H88z"}]}}),H.register({"low-vision":{width:576,height:512,paths:[{d:"M569.3 231.6C513 135.9 407.8 72 288 72 259.5 72 231.9 75.6 205.5 82.4L152.8 10.2C145.2-0.6 130.2-3.3 119.4 4.3L106.2 13.5C95.4 21.1 92.7 36.1 100.3 46.9L143.5 105.3C89.4 131.7 40.2 174.7 6.7 231.6 6.7 231.6 6.7 231.6 6.6 231.6-2.1 246.5-2.3 265.2 6.6 280.4 45.1 345.7 106.4 396.2 179.5 421.7L55.3 244.3A272.2-272.2 0 0 0 83.6 208.4L203 379H203L243.7 437A330.1-330.1 0 0 1 322.6 438.2L132.6 166.8A277.6-277.6 0 0 0 171.4 145.2L423.2 501.8C430.8 512.6 445.8 515.3 456.6 507.7L469.8 498.5C480.6 490.9 483.3 475.9 475.7 465.1L432.5 406.7 432.5 406.7C489.7 378.7 537.4 334.6 569.3 280.4A47.9-47.9 0 0 1 569.3 231.6zM390 345.9L371 318.7C395.6 286.1 398.7 242.4 379.8 207V207.1C379.8 230.7 360.6 249.9 336.9 249.9 313.1 249.9 294.1 230.5 294.1 207.1 294.1 183.4 313.3 164.2 336.9 164.2H337C312.2 151 283.4 148.6 257.5 156.6L238.4 129.3C253.8 123.3 270.5 120 288 120 363.2 120 424 180.8 424 256 424 290.5 411.2 322 390 345.9z"}]}}),H.register({magic:{width:512,height:512,paths:[{d:"M101.1 505L7 410.9C-2.4 401.5-2.4 386.3 7 377L377 7C386.4-2.4 401.6-2.4 410.9 7L505 101.1C514.4 110.5 514.4 125.7 505 135L135 505C125.7 514.3 110.5 514.3 101.1 505zM304 159.2L352.8 208 442.7 118.1 393.9 69.3 304 159.2zM138.9 39.3L127.2 63.1 101 66.9C96.3 67.6 94.4 73.4 97.8 76.7L116.8 95.2 112.3 121.3C111.5 126 116.4 129.6 120.6 127.4L144 115 167.4 127.3C171.6 129.5 176.5 125.9 175.7 121.2L171.2 95.1 190.2 76.6C193.6 73.3 191.7 67.5 187 66.8L160.8 63 149.1 39.2C147.1 35.1 141 35.1 138.9 39.3zM236.6 18.6L228.8 34.4 211.3 37C208.2 37.5 206.9 41.3 209.2 43.5L221.8 55.8 218.8 73.2C218.3 76.3 221.6 78.7 224.4 77.2L240 69 255.6 77.2C258.4 78.7 261.7 76.3 261.2 73.2L258.2 55.8 270.8 43.5C273.1 41.3 271.8 37.4 268.7 37L251.2 34.5 243.4 18.7C242 15.7 238 15.7 236.6 18.6zM44.6 18.6L36.8 34.4 19.3 37C16.2 37.5 14.9 41.3 17.2 43.5L29.8 55.8 26.8 73.2C26.3 76.3 29.6 78.7 32.4 77.2L48 69 63.6 77.2C66.4 78.7 69.7 76.3 69.2 73.2L66.2 55.8 78.8 43.5C81.1 41.3 79.8 37.4 76.7 37L59.2 34.5 51.4 18.7C50 15.7 46 15.7 44.6 18.6zM460.6 242.1L452.8 257.9 435.3 260.4C432.2 260.9 430.9 264.7 433.2 266.9L445.8 279.2 442.8 296.6C442.3 299.7 445.6 302.1 448.4 300.6L464 292.4 479.6 300.6C482.4 302.1 485.7 299.7 485.2 296.6L482.2 279.2 494.8 266.9C497.1 264.7 495.8 260.8 492.7 260.4L475.2 257.9 467.4 242.1C466 239.3 462 239.3 460.6 242.1z"}]}}),H.register({magnet:{width:512,height:512,paths:[{d:"M164.1 160H12C5.4 160 0 154.6 0 148V68C0 48.1 16.1 32 36 32H140C159.9 32 176 48.1 176 68V148C176.1 154.6 170.7 160 164.1 160zM512.1 148V67.9C512.1 48 496 31.9 476.1 31.9H372.1C352.2 31.9 336.1 48 336.1 67.9V147.9C336.1 154.5 341.5 159.9 348.1 159.9H500.1C506.7 160 512.1 154.6 512.1 148zM348.1 192C341.5 192 336.1 197.4 336.1 204V256C336.1 384.1 176.1 383.9 176.1 256V204C176.1 197.4 170.7 192 164.1 192H12.1C5.4 192 0.1 197.4 0.1 204.1 0.2 225.5 0.7 244.4 0.1 257.4 0.1 408 136.3 504 256.9 504 377.5 504 512 408 512 257.3 511.4 244.5 511.8 224.3 512 204.1 512 197.4 506.7 192 500 192H348.1z"}]}}),H.register({male:{width:192,height:512,paths:[{d:"M96 0C131.3 0 160 28.7 160 64S131.3 128 96 128 32 99.3 32 64 60.7 0 96 0M144 144H132.6C109.9 154.4 83 154.9 59.4 144H48C21.5 144 0 165.5 0 192V328C0 341.3 10.7 352 24 352H40V488C40 501.3 50.7 512 64 512H128C141.3 512 152 501.3 152 488V352H168C181.3 352 192 341.3 192 328V192C192 165.5 170.5 144 144 144z"}]}}),H.register({"map-marker-alt":{width:384,height:512,paths:[{d:"M172.3 501.7C27 291 0 269.4 0 192 0 86 86 0 192 0S384 86 384 192C384 269.4 357 291 211.7 501.7 202.2 515.4 181.8 515.4 172.3 501.7zM192 272C236.2 272 272 236.2 272 192S236.2 112 192 112 112 147.8 112 192 147.8 272 192 272z"}]}}),H.register({"map-marker":{width:384,height:512,paths:[{d:"M172.3 501.7C27 291 0 269.4 0 192 0 86 86 0 192 0S384 86 384 192C384 269.4 357 291 211.7 501.7 202.2 515.4 181.8 515.4 172.3 501.7z"}]}}),H.register({"map-pin":{width:320,height:512,paths:[{d:"M192 300.8V473.6L170 506.7C165.2 513.8 154.8 513.8 150 506.7L128 473.6V300.8A162.2-162.2 0 0 1 192 300.8zM160 0C239.5 0 304 64.5 304 144S239.5 288 160 288 16 223.5 16 144 80.5 0 160 0M80 136C80 96.3 112.3 64 152 64A8-8 0 0 1 152 48C103.5 48 64 87.5 64 136A8-8 0 0 1 80 136z"}]}}),H.register({"map-signs":{width:512,height:512,paths:[{d:"M487.5 104.5L439 153A24-24 0 0 0 422.1 160H56C42.7 160 32 149.3 32 136V56C32 42.7 42.7 32 56 32H216V24C216 10.7 226.7 0 240 0H272C285.3 0 296 10.7 296 24V32H422.1A24-24 0 0 0 439 39L487.5 87.5C492.2 92.2 492.2 99.8 487.5 104.5zM216 368V488C216 501.3 226.7 512 240 512H272C285.3 512 296 501.3 296 488V368H216zM456 224H296V176H216V224H89.9A24-24 0 0 1 73 231L24.5 279.5C19.8 284.2 19.8 291.8 24.5 296.5L73 345A24-24 0 0 1 89.9 352H456C469.3 352 480 341.3 480 328V248C480 234.7 469.3 224 456 224z"}]}}),H.register({map:{width:576,height:512,paths:[{d:"M576 56V392A24-24 0 0 0 562.7 413.5L434.7 477.5C418.9 485.3 400 474 400 456V120A24-24 0 0 0 413.3 98.5L541.3 34.5C557.1 26.7 576 38 576 56zM369.7 98.1L225.7 34.1C210 27.1 192 38.5 192 56V392A24-24 0 0 1 206.3 413.9L350.3 477.9C366 484.9 384 473.5 384 456V120A24-24 0 0 1 369.7 98.1zM141.3 34.5L13.3 98.5A24-24 0 0 1 0 120V456C0 474 18.9 485.3 34.7 477.5L162.7 413.5A24-24 0 0 1 176 392V56C176 38 157.1 26.7 141.3 34.5z"}]}}),H.register({"mars-double":{width:512,height:512,paths:[{d:"M340 0H261C250.3 0 245 12.9 252.5 20.5L269.4 37.4 220.7 86.1C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208S64.5 352 144 352 288 287.5 288 208C288 179.8 279.9 153.5 265.9 131.3L314.6 82.6 331.5 99.5C333.9 101.9 337 103 339.9 103 346.1 103 352 98.2 352 91V12C352 5.4 346.6 0 340 0zM144 288C99.9 288 64 252.1 64 208S99.9 128 144 128 224 163.9 224 208 188.1 288 144 288zM500 159.9H421C410.3 159.9 405 172.8 412.5 180.4L429.4 197.3 380.7 246C362.5 234.6 341.7 227.1 319.2 224.7 317.1 246.5 311 268 300.8 288 301.9 288 303 287.9 304 287.9 348.1 287.9 384 323.8 384 367.9S348.1 447.9 304 447.9 224 412 224 367.9C224 366.8 224 365.7 224.1 364.7 204.1 374.9 182.6 381.1 160.8 383.1 168.4 455.6 229.6 512 304 512 383.5 512 448 447.5 448 368 448 339.8 439.9 313.5 425.9 291.3L474.6 242.6 491.5 259.5C493.9 261.9 496.9 263 499.9 263 506.1 263 512 258.2 512 251V172C512 165.3 506.6 159.9 500 159.9z"}]}}),H.register({"mars-stroke-h":{width:480,height:512,paths:[{d:"M476.2 247.5L420.3 191.6C412.7 184 399.8 189.4 399.8 200.1V224H376V204C376 197.4 370.6 192 364 192H324C317.4 192 312 197.4 312 204V224H284.4C278.6 198.4 265.7 174.1 245.8 154.2 189.6 98 98.4 98 42.2 154.2-14 210.4-14 301.6 42.2 357.8 98.4 414 189.6 414 245.8 357.8 265.7 337.9 278.6 313.6 284.4 288H312V308C312 314.6 317.4 320 324 320H364C370.6 320 376 314.6 376 308V288H399.9V311.9C399.9 322.6 412.8 327.9 420.4 320.4L476.3 264.5C480.9 259.8 480.9 252.2 476.2 247.5zM200.6 312.6C169.4 343.8 118.7 343.8 87.5 312.6 56.3 281.4 56.3 230.7 87.5 199.5 118.7 168.3 169.4 168.3 200.6 199.5 231.8 230.6 231.8 281.4 200.6 312.6z"}]}}),H.register({"mars-stroke-v":{width:288,height:512,paths:[{d:"M245.8 234.2C225.9 214.3 201.6 201.4 176 195.6V170.2H196C202.6 170.2 208 164.8 208 158.2V118.2C208 111.6 202.6 106.2 196 106.2H176V81.4H199.9C210.6 81.4 215.9 68.5 208.4 60.9L152.5 5.1C147.8 0.4 140.2 0.4 135.5 5.1L79.6 61C72 68.6 77.4 81.5 88.1 81.5H112V106.2H92C85.4 106.2 80 111.6 80 118.2V158.2C80 164.8 85.4 170.2 92 170.2H112V195.6C86.4 201.4 62.1 214.3 42.2 234.2-14 290.4-14 381.6 42.2 437.8 98.4 494 189.6 494 245.8 437.8 302.1 381.6 302.1 290.4 245.8 234.2zM200.6 392.6C169.4 423.8 118.7 423.8 87.5 392.6 56.3 361.4 56.3 310.7 87.5 279.5 118.7 248.3 169.4 248.3 200.6 279.5 231.8 310.6 231.8 361.4 200.6 392.6z"}]}}),H.register({"mars-stroke":{width:384,height:512,paths:[{d:"M372 64H293C282.3 64 277 76.9 284.5 84.5L301.4 101.4 283.9 118.9 269.8 104.8C265.1 100.1 257.5 100.1 252.8 104.8L224.5 133C219.8 137.7 219.8 145.3 224.5 150L238.6 164.1 220.6 182.1C198.4 168.1 172.1 160 143.9 160 64.5 160 0 224.5 0 304S64.5 448 144 448 288 383.5 288 304C288 275.8 279.9 249.5 265.9 227.3L283.9 209.3 298 223.4C302.7 228.1 310.3 228.1 315 223.4L343.3 195.1C348 190.4 348 182.8 343.3 178.1L329.2 164 346.7 146.5 363.6 163.4C371.2 171 384.1 165.6 384.1 154.9V76C384 69.4 378.6 64 372 64zM144 384C99.9 384 64 348.1 64 304S99.9 224 144 224 224 259.9 224 304 188.1 384 144 384z"}]}}),H.register({mars:{width:384,height:512,paths:[{d:"M372 64H293C282.3 64 277 76.9 284.5 84.5L301.4 101.4 220.7 182.1C198.5 168.1 172.2 160 144 160 64.5 160 0 224.5 0 304S64.5 448 144 448 288 383.5 288 304C288 275.8 279.9 249.5 265.9 227.3L346.6 146.6 363.5 163.5C371.1 171.1 384 165.7 384 155V76C384 69.4 378.6 64 372 64zM144 384C99.9 384 64 348.1 64 304S99.9 224 144 224 224 259.9 224 304 188.1 384 144 384z"}]}}),H.register({medkit:{width:512,height:512,paths:[{d:"M96 480H416V128H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V128H96V480zM192 96H320V128H192V96zM512 176V432C512 458.5 490.5 480 464 480H448V128H464C490.5 128 512 149.5 512 176zM64 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H64V480zM352 272V304C352 312.8 344.8 320 336 320H288V368C288 376.8 280.8 384 272 384H240C231.2 384 224 376.8 224 368V320H176C167.2 320 160 312.8 160 304V272C160 263.2 167.2 256 176 256H224V208C224 199.2 231.2 192 240 192H272C280.8 192 288 199.2 288 208V256H336C344.8 256 352 263.2 352 272z"}]}}),H.register({meh:{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM344 368H152C143.2 368 136 360.8 136 352S143.2 336 152 336H344C352.8 336 360 343.2 360 352S352.8 368 344 368zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z"}]}}),H.register({mercury:{width:288,height:512,paths:[{d:"M288 208C288 163.8 268.1 124.3 236.8 97.9 239.3 96.1 241.7 94.1 244 92.1 268.7 70.9 283.8 43.3 287.2 13.3 288.1 6.2 282.5 0 275.3 0H234.8C229 0 224.1 4.1 223 9.8 220.6 22.3 213.4 34.1 202.3 43.6 187 56.8 166.3 64 144 64S101 56.8 85.6 43.6C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-0.1 6.2 0.8 13.3 4.2 43.4 19.2 71 44 92.2 46.3 94.2 48.7 96.1 51.2 98 19.9 124.3 0 163.8 0 208 0 276.5 47.9 333.9 112 348.4V400H76C69.4 400 64 405.4 64 412V452C64 458.6 69.4 464 76 464H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V464H212C218.6 464 224 458.6 224 452V412C224 405.4 218.6 400 212 400H176V348.4C240.1 333.9 288 276.5 288 208zM64 208C64 163.9 99.9 128 144 128S224 163.9 224 208 188.1 288 144 288 64 252.1 64 208z"}]}}),H.register({microchip:{width:512,height:512,paths:[{d:"M416 48V464C416 490.5 394.5 512 368 512H144C117.5 512 96 490.5 96 464V48C96 21.5 117.5 0 144 0H368C394.5 0 416 21.5 416 48zM512 106V118A6-6 0 0 0 506 124H488V130A6-6 0 0 0 482 136H440V88H482A6-6 0 0 0 488 94V100H506A6-6 0 0 0 512 106zM512 202V214A6-6 0 0 0 506 220H488V226A6-6 0 0 0 482 232H440V184H482A6-6 0 0 0 488 190V196H506A6-6 0 0 0 512 202zM512 298V310A6-6 0 0 0 506 316H488V322A6-6 0 0 0 482 328H440V280H482A6-6 0 0 0 488 286V292H506A6-6 0 0 0 512 298zM512 394V406A6-6 0 0 0 506 412H488V418A6-6 0 0 0 482 424H440V376H482A6-6 0 0 0 488 382V388H506A6-6 0 0 0 512 394zM30 376H72V424H30A6-6 0 0 0 24 418V412H6A6-6 0 0 0 0 406V394A6-6 0 0 0 6 388H24V382A6-6 0 0 0 30 376zM30 280H72V328H30A6-6 0 0 0 24 322V316H6A6-6 0 0 0 0 310V298A6-6 0 0 0 6 292H24V286A6-6 0 0 0 30 280zM30 184H72V232H30A6-6 0 0 0 24 226V220H6A6-6 0 0 0 0 214V202A6-6 0 0 0 6 196H24V190A6-6 0 0 0 30 184zM30 88H72V136H30A6-6 0 0 0 24 130V124H6A6-6 0 0 0 0 118V106A6-6 0 0 0 6 100H24V94A6-6 0 0 0 30 88z"}]}}),H.register({"microphone-slash":{width:512,height:512,paths:[{d:"M421.4 285.2L376 239.7V212C376 205.4 381.4 200 388 200H412C418.6 200 424 205.4 424 212V256C424 266 423.1 275.7 421.4 285.2zM352 96C352 43 309 0 256 0 223.4 0 194.6 16.2 177.3 41L352 215.7V96zM505 459.7L52.3 7C42.9-2.3 27.7-2.3 18.3 7L7 18.3C-2.3 27.7-2.3 42.9 7 52.3L160 205.3V254.8C160 307.9 203.4 352.3 256.5 352 271.1 351.9 285 348.6 297.4 342.6L315.1 360.4C297.6 370.3 277.3 376 255.8 376 189.4 375.9 136 321.1 136 254.7V212C136 205.4 130.6 200 124 200H100C93.4 200 88 205.4 88 212V256C88 340.5 150.7 410.6 232 422.3V468H164C157.4 468 152 473.4 152 480V500C152 506.6 157.4 512 164 512H348C354.6 512 360 506.6 360 500V480C360 473.4 354.6 468 348 468H280V422.3C305.6 418.6 329.4 409.1 349.9 395.2L459.7 505C469.1 514.3 484.3 514.3 493.7 505L505 493.7C514.3 484.3 514.3 469.1 505 459.7z"}]}}),H.register({microphone:{width:384,height:512,paths:[{d:"M96 256V96C96 43 139 0 192 0S288 43 288 96V256C288 309 245 352 192 352S96 309 96 256zM348 200H324C317.4 200 312 205.4 312 212V254.7C312 320.9 258.9 375.6 192.7 376 126.2 376.4 72 322.4 72 256V212C72 205.4 66.6 200 60 200H36C29.4 200 24 205.4 24 212V256C24 340.5 86.7 410.6 168 422.3V468H100C93.4 468 88 473.4 88 480V500C88 506.6 93.4 512 100 512H284C290.6 512 296 506.6 296 500V480C296 473.4 290.6 468 284 468H216V422.3C297.3 410.6 360 340.5 360 256V212C360 205.4 354.6 200 348 200z"}]}}),H.register({"minus-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM124 296C117.4 296 112 290.6 112 284V228C112 221.4 117.4 216 124 216H388C394.6 216 400 221.4 400 228V284C400 290.6 394.6 296 388 296H124z"}]}}),H.register({"minus-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM92 296C85.4 296 80 290.6 80 284V228C80 221.4 85.4 216 92 216H356C362.6 216 368 221.4 368 228V284C368 290.6 362.6 296 356 296H92z"}]}}),H.register({minus:{width:448,height:512,paths:[{d:"M424 318.2C437.3 318.2 448 307.5 448 294.2V217.8C448 204.5 437.3 193.8 424 193.8H24C10.7 193.8 0 204.5 0 217.8V294.2C0 307.5 10.7 318.2 24 318.2H424z"}]}}),H.register({"mobile-alt":{width:320,height:512,paths:[{d:"M272 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V48C320 21.5 298.5 0 272 0zM160 480C142.3 480 128 465.7 128 448S142.3 416 160 416 192 430.3 192 448 177.7 480 160 480zM272 372C272 378.6 266.6 384 260 384H60C53.4 384 48 378.6 48 372V60C48 53.4 53.4 48 60 48H260C266.6 48 272 53.4 272 60V372z"}]}}),H.register({mobile:{width:320,height:512,paths:[{d:"M272 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H272C298.5 512 320 490.5 320 464V48C320 21.5 298.5 0 272 0zM160 480C142.3 480 128 465.7 128 448S142.3 416 160 416 192 430.3 192 448 177.7 480 160 480z"}]}}),H.register({"money-bill-alt":{width:640,height:512,paths:[{d:"M640 120V392C640 405.3 629.3 416 616 416H24C10.7 416 0 405.3 0 392V120C0 106.7 10.7 96 24 96H616C629.3 96 640 106.7 640 120zM96 384C96 348.7 67.3 320 32 320V384H96zM96 128H32V192C67.3 192 96 163.3 96 128zM400 256C400 203 364.2 160 320 160S240 203 240 256C240 309 275.8 352 320 352 364.2 352 400 309 400 256zM608 320C572.7 320 544 348.7 544 384H608V320zM608 128H544C544 163.3 572.7 192 608 192V128zM277.6 299.5C277.6 292.1 281.5 288 289.1 288H304.3V248.1C304.3 242.9 304.8 237.6 304.8 237.6H304.4S302.7 240.2 301.6 241.3C297.1 245.6 291.1 245.8 285.9 240.2L280.4 234C275.1 228.7 275.4 222.8 280.9 217.6L302.7 197.7C307.1 193.6 311 192 317.1 192H329.2C336.8 192 340.9 195.9 340.9 203.6V288H356.4C364.1 288 368 292 368 299.5V308.4C368 315.9 364.1 320 356.4 320H289.1C281.5 320 277.6 315.9 277.6 308.4V299.5z"}]}}),H.register({moon:{width:512,height:512,paths:[{d:"M283.2 512C362.2 512 434.3 476.1 482.1 417.2 489.1 408.5 481.4 395.8 470.5 397.9 346.3 421.5 232.2 326.3 232.2 200.9 232.2 128.7 270.9 62.3 333.7 26.5 343.4 21 341 6.3 330 4.3A258.2-258.2 0 0 1 283.2 0C141.9 0 27.2 114.5 27.2 256 27.2 397.3 141.7 512 283.2 512z"}]}}),H.register({motorcycle:{width:640,height:512,paths:[{d:"M512.9 192C498.1 191.9 483.8 194.3 470.5 198.9L437.6 144H520C533.3 144 544 133.3 544 120V88C544 74.7 533.3 64 520 64H474.7A24-24 0 0 1 456.9 71.9L419.4 113.6 396.6 75.7A24-24 0 0 1 376 64H296C287.2 64 280 71.2 280 80V96C280 104.8 287.2 112 296 112H362.4L381.6 144H227.9C210.2 120.9 183 104 128 104H72.5C59.1 104 47.7 115 48 128.5 48.3 141.5 58.9 152 72 152H128C152.5 152 166.7 162.9 175.8 176.8L164.5 197.3C151.5 193.4 137.6 191.6 123.2 192.1 55.9 194.5 1.6 249.6 0 317-1.6 389.1 56.3 448 128 448 187.6 448 237.7 407.2 252 352H336.2C349.9 352 360.8 340.6 360.2 326.9 358 279.8 377.7 233.3 416.4 201.9L428.8 222.7C401.2 246.4 383.7 281.6 384 320.9 384.5 390.4 441.2 447.3 510.8 448 582.4 448.7 640.6 390.5 640 318.9 639.4 249.3 582.5 192.5 512.9 192zM128 400C83.9 400 48 364.1 48 320S83.9 240 128 240C132.2 240 136.4 240.3 140.5 241L99 316.4C90.2 332.4 101.8 352 120 352H201.3C188.9 380.2 160.7 400 128 400zM516.4 399.9C470.3 402.3 432 365.6 432 320 432 298.6 440.4 279.2 454.1 264.9L503.5 347.2C508.1 354.8 517.9 357.2 525.5 352.7L539.2 344.5C546.8 339.9 549.2 330.1 544.7 322.5L496.1 241.6A80-80 0 0 0 512 240C557.6 240 594.3 278.3 591.9 324.4 589.7 364.9 556.9 397.7 516.4 399.9z"}]}}),H.register({"mouse-pointer":{width:320,height:512,paths:[{d:"M302.2 329.1H196.1L251.9 465.1C255.8 474.5 251.4 485.1 242.5 489.1L193.3 510.5C184.2 514.5 173.9 510 170 500.8L116.9 371.7 30.3 460.8C18.7 472.7 0 463.6 0 448V18.3C0 1.9 19.9-6.1 30.3 5.4L314.7 298C326.2 309.2 317.7 329.1 302.2 329.1z"}]}}),H.register({music:{width:512,height:512,paths:[{d:"M470.4 1.5L166.4 97.5C153.1 101.7 144 114 144 128V392.6C129.9 387.2 113.5 384 96 384 43 384 0 412.7 0 448S43 512 96 512 192 483.3 192 448V220.5L464 134.6V328.6C449.9 323.2 433.5 320 416 320 363 320 320 348.7 320 384S363 448 416 448 512 419.3 512 384V32C512 10.3 490.9-5 470.4 1.5z"}]}}),H.register({neuter:{width:288,height:512,paths:[{d:"M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V316.4C240.1 301.9 288 244.5 288 176zM144 256C99.9 256 64 220.1 64 176S99.9 96 144 96 224 131.9 224 176 188.1 256 144 256z"}]}}),H.register({newspaper:{width:576,height:512,paths:[{d:"M552 64H88C74.7 64 64 74.7 64 88V96H24C10.7 96 0 106.7 0 120V392C0 422.9 25.1 448 56 448H528C554.5 448 576 426.5 576 400V88C576 74.7 565.3 64 552 64zM56 400A8-8 0 0 0 48 392V144H64V392A8-8 0 0 0 56 400zM292 384H140C133.4 384 128 378.6 128 372V364C128 357.4 133.4 352 140 352H292C298.6 352 304 357.4 304 364V372C304 378.6 298.6 384 292 384zM500 384H348C341.4 384 336 378.6 336 372V364C336 357.4 341.4 352 348 352H500C506.6 352 512 357.4 512 364V372C512 378.6 506.6 384 500 384zM292 288H140C133.4 288 128 282.6 128 276V268C128 261.4 133.4 256 140 256H292C298.6 256 304 261.4 304 268V276C304 282.6 298.6 288 292 288zM500 288H348C341.4 288 336 282.6 336 276V268C336 261.4 341.4 256 348 256H500C506.6 256 512 261.4 512 268V276C512 282.6 506.6 288 500 288zM500 192H140C133.4 192 128 186.6 128 180V140C128 133.4 133.4 128 140 128H500C506.6 128 512 133.4 512 140V180C512 186.6 506.6 192 500 192z"}]}}),H.register({"notes-medical":{width:384,height:512,paths:[{d:"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM288 344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296V344zM288 152C288 156.4 284.4 160 280 160H104C99.6 160 96 156.4 96 152V136C96 131.6 99.6 128 104 128H280C284.4 128 288 131.6 288 136V152z"}]}}),H.register({"object-group":{width:512,height:512,paths:[{d:"M480 128V96H500C506.6 96 512 90.6 512 84V44C512 37.4 506.6 32 500 32H460C453.4 32 448 37.4 448 44V64H64V44C64 37.4 58.6 32 52 32H12C5.4 32 0 37.4 0 44V84C0 90.6 5.4 96 12 96H32V416H12C5.4 416 0 421.4 0 428V468C0 474.6 5.4 480 12 480H52C58.6 480 64 474.6 64 468V448H448V468C448 474.6 453.4 480 460 480H500C506.6 480 512 474.6 512 468V428C512 421.4 506.6 416 500 416H480V128zM96 276V140C96 133.4 101.4 128 108 128H276C282.6 128 288 133.4 288 140V276C288 282.6 282.6 288 276 288H108C101.4 288 96 282.6 96 276zM416 372C416 378.6 410.6 384 404 384H236C229.4 384 224 378.6 224 372V320H296C309.3 320 320 309.3 320 296V224H404C410.6 224 416 229.4 416 236V372z"}]}}),H.register({"object-ungroup":{width:576,height:512,paths:[{d:"M64 320V346A6-6 0 0 0 58 352H6A6-6 0 0 0 0 346V294A6-6 0 0 0 6 288H32V96H6A6-6 0 0 0 0 90V38A6-6 0 0 0 6 32H58A6-6 0 0 0 64 38V64H352V38A6-6 0 0 0 358 32H410A6-6 0 0 0 416 38V90A6-6 0 0 0 410 96H384V288H410A6-6 0 0 0 416 294V346A6-6 0 0 0 410 352H358A6-6 0 0 0 352 346V320H64zM544 256V224H570A6-6 0 0 1 576 218V166A6-6 0 0 1 570 160H518A6-6 0 0 1 512 166V192H408V264H416C429.3 264 440 274.7 440 288V352C440 365.3 429.3 376 416 376H352C338.7 376 328 365.3 328 352V344H192V416H166A6-6 0 0 1 160 422V474A6-6 0 0 1 166 480H218A6-6 0 0 1 224 474V448H512V474A6-6 0 0 1 518 480H570A6-6 0 0 1 576 474V422A6-6 0 0 1 570 416H544V256z"}]}}),H.register({outdent:{width:448,height:512,paths:[{d:"M0 84V44C0 35.2 7.2 28 16 28H432C440.8 28 448 35.2 448 44V84C448 92.8 440.8 100 432 100H16C7.2 100 0 92.8 0 84zM208 228H432C440.8 228 448 220.8 448 212V172C448 163.2 440.8 156 432 156H208C199.2 156 192 163.2 192 172V212C192 220.8 199.2 228 208 228zM16 484H432C440.8 484 448 476.8 448 468V428C448 419.2 440.8 412 432 412H16C7.2 412 0 419.2 0 428V468C0 476.8 7.2 484 16 484zM208 356H432C440.8 356 448 348.8 448 340V300C448 291.2 440.8 284 432 284H208C199.2 284 192 291.2 192 300V340C192 348.8 199.2 356 208 356zM4.7 267.3L100.7 363.3C110.7 373.3 128 366.2 128 352V160C128 145.7 110.7 138.7 100.7 148.7L4.7 244.7C-1.6 250.9-1.6 261.1 4.7 267.3z"}]}}),H.register({"paint-brush":{width:512,height:512,paths:[{d:"M269.9 364.6C271.3 371 272 377.6 272 384.3 272 465.5 217.8 512 137.2 512 41.5 512 0 435.1 0 347.6 10.4 354.7 46.9 384.1 58.7 384.1 65.7 384.1 71.7 380.1 74.2 373.5 97.8 311.3 140.7 297 187.1 296.1 202.7 329.9 233.2 355.7 269.9 364.6zM460.6 0C446.2 0 432.7 6.4 422.4 15.7 228.2 190 208 194.1 208 245.4 208 294.2 248.5 336 298.2 336 357.2 336 391.4 292.6 498.8 91.2 505.8 77.5 512 62.7 512 47.3 512 19.7 487.3 0 460.6 0z"}]}}),H.register({pallet:{width:640,height:512,paths:[{d:"M144 256H496C504.8 256 512 248.8 512 240V16C512 7.2 504.8 0 496 0H384V128L320 96 256 128V0H144C135.2 0 128 7.2 128 16V240C128 248.8 135.2 256 144 256zM624 384C632.8 384 640 376.8 640 368V336C640 327.2 632.8 320 624 320H16C7.2 320 0 327.2 0 336V368C0 376.8 7.2 384 16 384H64V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448H576V384H624zM288 448H128V384H288V448zM512 448H352V384H512V448z"}]}}),H.register({"paper-plane":{width:512,height:512,paths:[{d:"M476 3.2L12.5 270.6C-5.6 281-3.3 306.2 14.7 313.8L121 358.4 408.3 105.2C413.8 100.3 421.6 107.8 416.9 113.5L176 407V487.5C176 511.1 204.5 520.4 218.5 503.3L282 426 406.6 478.2C420.8 484.2 437 475.3 439.6 460L511.6 28C515 7.8 493.3-6.8 476 3.2z"}]}}),H.register({paperclip:{width:448,height:512,paths:[{d:"M43.2 466.1C-15.2 405.9-14.1 308.6 44.6 248.6L254.4 34C298.7-11.3 370.7-11.3 415.1 34 459 78.9 459 151.3 415.1 196.3L232.2 383.1C202.4 413.7 153.6 413.2 124.2 382.1 96 352.2 96.9 304.7 125.7 275.2L269.4 128.3C275.6 122 285.7 121.9 292.1 128.1L314.9 150.5C321.2 156.7 321.3 166.8 315.2 173.1L171.4 319.9C166.5 325 166.2 333.4 170.8 338.2 175.2 342.9 182 342.9 186.5 338.4L369.3 151.5C388.9 131.5 388.9 98.8 369.3 78.7 350.1 59.1 319.3 59.1 300.2 78.7L90.4 293.3C55.6 328.9 55.1 386.4 89.2 421.6 123.2 456.7 178.2 456.7 212.3 421.9L384.3 245.9C390.5 239.6 400.6 239.5 406.9 245.6L429.8 268C436.1 274.2 436.3 284.3 430.1 290.6L258 466.6C198.4 527.6 102.1 526.8 43.2 466.1z"}]}}),H.register({"parachute-box":{width:512,height:512,paths:[{d:"M511.9 175C502.8 99.4 433.5 42.6 353.6 16.3 390 55.7 416 116.9 416 192H444.1L327.5 321.5C325 320.9 322.7 320 320 320H272V192H384C384 76.8 315.1 0 256 0S128 76.8 128 192H240V320H192C189.3 320 187 320.9 184.5 321.5L67.9 192H96C96 116.9 122 55.7 158.4 16.3 78.5 42.7 9.2 99.5 0.1 175-1 184.1 6.9 192 16.1 192H24.8L161.5 343.9C160.8 346.5 159.9 349.1 159.9 352V480C159.9 497.7 174.2 512 191.9 512H319.9C337.6 512 351.9 497.7 351.9 480V352C351.9 349.1 351 346.6 350.3 343.9L487.1 192H495.8C505.1 192 513 184.2 511.9 175z"}]}}),H.register({paragraph:{width:448,height:512,paths:[{d:"M408 32H177.5C88.9 32 16 103.3 16 191.9 16 280.3 87.6 352 176 352V456C176 469.3 186.7 480 200 480H232C245.3 480 256 469.3 256 456V112H288V456C288 469.3 298.7 480 312 480H344C357.3 480 368 469.3 368 456V112H408C421.3 112 432 101.3 432 88V56C432 42.7 421.3 32 408 32z"}]}}),H.register({paste:{width:448,height:512,paths:[{d:"M128 184C128 153.1 153.1 128 184 128H320V56C320 42.7 309.3 32 296 32H215.4C204.3 12.9 183.6 0 160 0S115.7 12.9 104.6 32H24C10.7 32 0 42.7 0 56V392C0 405.3 10.7 416 24 416H128V184zM160 40C173.3 40 184 50.7 184 64S173.3 88 160 88 136 77.3 136 64 146.7 40 160 40zM344 288H448V488C448 501.3 437.3 512 424 512H184C170.7 512 160 501.3 160 488V184C160 170.7 170.7 160 184 160H320V264C320 277.2 330.8 288 344 288zM448 249.9V256H352V160H358.1A24-24 0 0 0 375 167L441 233A24-24 0 0 0 448 249.9z"}]}}),H.register({"pause-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM240 336C240 344.8 232.8 352 224 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H224C232.8 160 240 167.2 240 176V336zM352 336C352 344.8 344.8 352 336 352H288C279.2 352 272 344.8 272 336V176C272 167.2 279.2 160 288 160H336C344.8 160 352 167.2 352 176V336z"}]}}),H.register({pause:{width:448,height:512,paths:[{d:"M144 479H48C21.5 479 0 457.5 0 431V79C0 52.5 21.5 31 48 31H144C170.5 31 192 52.5 192 79V431C192 457.5 170.5 479 144 479zM448 431V79C448 52.5 426.5 31 400 31H304C277.5 31 256 52.5 256 79V431C256 457.5 277.5 479 304 479H400C426.5 479 448 457.5 448 431z"}]}}),H.register({paw:{width:512,height:512,paths:[{d:"M85.2 331C36 331 0 273.8 0 231.5 0 203.2 16 173.5 49.5 173.5 98.8 173.5 134.8 230.9 134.8 273.2 134.8 301.5 119.1 331 85.2 331zM433.2 437.1C433.2 474.2 401.2 480 369.8 480 328.6 480 295.4 453.8 256 453.8 214.8 453.8 179.7 479.7 135.1 479.7 105.2 479.7 78.8 470.1 78.8 437.1 78.8 368 180.6 265.3 256 265.3S433.2 368.3 433.2 437.1zM182.5 203.8C132.6 203.8 102.5 144.3 102.5 103.5 102.5 70.8 120.3 32 160 32 210.2 32 240 91.5 240 132.3 240 165 222.2 203.8 182.5 203.8zM272 132.3C272 91.5 301.8 32 352 32 391.7 32 409.5 70.8 409.5 103.5 409.5 144.3 379.4 203.8 329.5 203.8 289.8 203.8 272 165 272 132.3zM512 231.5C512 273.8 476 331 426.8 331 392.9 331 377.2 301.5 377.2 273.2 377.2 230.9 413.2 173.5 462.5 173.5 496 173.5 512 203.2 512 231.5z"}]}}),H.register({"pen-square":{width:448,height:512,paths:[{d:"M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM238.1 177.9L102.4 313.6 96.1 370.7C95.3 378.3 101.7 384.8 109.4 384L166.5 377.7 302.2 242C304.5 239.7 304.5 235.9 302.2 233.5L246.7 178C244.2 175.6 240.4 175.6 238.1 177.9zM345 165.1L314.9 135C305.5 125.6 290.3 125.6 281 135L257.9 158.1C255.6 160.4 255.6 164.2 257.9 166.6L313.4 222.1C315.7 224.4 319.5 224.4 321.9 222.1L345 199C354.3 189.7 354.3 174.5 345 165.1z"}]}}),H.register({"pencil-alt":{width:512,height:512,paths:[{d:"M497.9 142.1L451.8 188.2C447.1 192.9 439.5 192.9 434.8 188.2L323.8 77.2C319.1 72.5 319.1 64.9 323.8 60.2L369.9 14.1C388.6-4.6 419-4.6 437.8 14.1L497.9 74.2C516.7 92.9 516.7 123.3 497.9 142.1zM284.2 99.8L21.6 362.4 0.4 483.9C-2.5 500.3 11.8 514.5 28.2 511.7L149.7 490.4 412.3 227.8C417 223.1 417 215.5 412.3 210.8L301.3 99.8C296.5 95.1 288.9 95.1 284.2 99.8zM124.1 339.9C118.6 334.4 118.6 325.6 124.1 320.1L278.1 166.1C283.6 160.6 292.4 160.6 297.9 166.1S303.4 180.4 297.9 185.9L143.9 339.9C138.4 345.4 129.6 345.4 124.1 339.9zM88 424H136V460.3L71.5 471.6 40.4 440.5 51.7 376H88V424z"}]}}),H.register({"people-carry":{width:640,height:512,paths:[{d:"M128 96C154.5 96 176 74.5 176 48S154.5 0 128 0 80 21.5 80 48 101.5 96 128 96zM512 96C538.5 96 560 74.5 560 48S538.5 0 512 0 464 21.5 464 48 485.5 96 512 96zM637.7 468.1L593.7 358.1 552.6 404.5 550.6 422.7 578.3 491.9C583.3 504.4 595.3 512 608 512 612 512 616 511.3 619.9 509.7 636.3 503.1 644.3 484.5 637.7 468.1zM603.5 258.3L585 178.1C580.4 158.1 566.4 141.3 547.5 133.2 529 125.2 508.5 126.5 491.4 136.5 468.7 149.9 451.7 171 443.3 195.9L432 229.8 416 240V144C416 135.2 408.8 128 400 128H240C231.2 128 224 135.2 224 144V240L207.9 229.8 196.6 195.9C188.3 170.9 171.2 149.9 148.5 136.5 131.3 126.5 110.9 125.2 92.4 133.2 73.5 141.3 59.5 158.1 54.9 178.1L36.5 258.3C31.9 278.3 37.2 299.5 50.9 315L118.1 390.9 128.2 483.5C130 499.8 143.8 512 160 512 161.2 512 162.3 511.9 163.5 511.8 181.1 509.9 193.7 494.1 191.8 476.5L181.7 383.7C180.2 370.7 174.8 358.6 166.1 348.7L122.8 299.7 140.4 229.4 147.2 249.8C151.3 262.3 159.1 273.2 171.7 282.4L222.8 314.9C227.4 317.8 234.9 319.5 240 319.9H400C405.1 319.5 412.6 317.8 417.2 314.9L468.3 282.4C480.9 273.2 488.7 262.4 492.8 249.8L499.6 229.4 517.2 299.7 473.9 348.7C465.2 358.6 459.8 370.7 458.3 383.7L448.2 476.5C446.3 494.1 459 509.9 476.5 511.8 477.7 511.9 478.8 512 480 512 496.1 512 510 499.9 511.8 483.5L521.9 390.9 589.1 315C602.7 299.5 608.1 278.3 603.5 258.3zM46.3 358.1L2.3 468.1C-4.3 484.5 3.7 503.1 20.1 509.7 36.9 516.3 55.2 508 61.7 491.9L89.4 422.7 87.4 404.5 46.3 358.1z"}]}}),H.register({percent:{width:448,height:512,paths:[{d:"M112 224C173.9 224 224 173.9 224 112S173.9 0 112 0 0 50.1 0 112 50.1 224 112 224zM112 64C138.5 64 160 85.5 160 112S138.5 160 112 160 64 138.5 64 112 85.5 64 112 64zM336 288C274.1 288 224 338.1 224 400S274.1 512 336 512 448 461.9 448 400 397.9 288 336 288zM336 448C309.5 448 288 426.5 288 400S309.5 352 336 352 384 373.5 384 400 362.5 448 336 448zM392.3 0.2L423.9 0.1C443.3 0 454.8 21.9 443.6 37.9L77.4 501.6A23.9-23.9 0 0 0 57.8 511.8L24.4 511.9C4.9 511.9-6.5 490 4.7 474.1L372.7 10.4C377.2 4 384.5 0.2 392.3 0.2z"}]}}),H.register({"phone-slash":{width:640,height:512,paths:[{d:"M268.2 381.4L218.6 320.8C211.8 312.5 200.4 309.7 190.6 313.9L78.6 361.9C67.9 366.5 62.1 378 64.7 389.4L88.7 493.4C91.2 504.2 100.8 512 112.1 512 212.8 512 305.8 479.6 381.8 425.1L301.8 363.3C290.9 369.8 279.7 376 268.2 381.4zM633.8 458.1L475.1 335.5C537.9 256.4 576 156.9 576 48 576 36.8 568.3 27.1 557.4 24.6L453.4 0.6C442.1-2 430.5 3.9 425.9 14.5L377.9 126.5C373.7 136.3 376.5 147.8 384.8 154.5L445.4 204.1C433.2 230.2 417.5 254.4 399.4 276.9L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1z"}]}}),H.register({"phone-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM94 416C87 416 80.9 411.1 79.4 404.4L64.4 339.4A15-15 0 0 0 73.1 322.2L143.1 292.2A15-15 0 0 0 160.6 296.5L191.6 334.4C240.6 311.4 279.9 271.5 302.4 223.6L264.5 192.6A15-15 0 0 0 260.2 175.1L290.2 105.1A15-15 0 0 0 307.4 96.4L372.4 111.4A15-15 0 0 0 384 126C384 286.3 254.1 416 94 416z"}]}}),H.register({"phone-volume":{width:384,height:512,paths:[{d:"M97.3 507C-32.5 377.1-32.3 166.7 97.3 37 103 31.3 111.9 30.4 118.6 34.6L183.4 75.1A17.2-17.2 0 0 0 190.3 96.1L157.9 177.1A17.2-17.2 0 0 0 140.2 187.8L84.4 182.2C63.3 240.5 63.8 304.7 84.4 361.8L140.2 356.2A17.2-17.2 0 0 0 157.9 366.9L190.3 447.9A17.2-17.2 0 0 0 183.4 468.9L118.6 509.4A17.2-17.2 0 0 0 97.3 507zM247.1 95.5C259 115.5 259 140.5 247.1 160.5 243.2 167.2 234 168.5 228.4 163.1L222.4 157.4C218.5 153.6 217.6 147.8 220.2 143A32.1-32.1 0 0 1 220.2 113C217.6 108.2 218.5 102.4 222.4 98.6L228.4 92.9C234 87.5 243.2 88.8 247.1 95.5zM338.9 4.3C399.1 75.9 399 180.2 338.9 251.7 334.4 257 326.4 257.5 321.4 252.6L315.6 247.1C311 242.7 310.6 235.6 314.6 230.7 364.3 171.2 364.3 84.8 314.6 25.3 310.6 20.4 311 13.3 315.6 8.9L321.4 3.4C326.4-1.5 334.4-1 338.9 4.3zM292.9 49.2C329 95.5 329 160.4 292.9 206.8 288.6 212.4 280.2 213 275.1 208.1L269.3 202.5C264.9 198.3 264.3 191.4 268 186.6 294.5 152 294.5 104 268 69.4 264.3 64.6 264.9 57.7 269.3 53.5L275.1 47.9C280.2 43 288.6 43.6 292.9 49.2z"}]}}),H.register({phone:{width:512,height:512,paths:[{d:"M493.4 24.6L389.4 0.6C378.1-2 366.5 3.9 361.9 14.5L313.9 126.5C309.7 136.3 312.5 147.8 320.8 154.5L381.4 204.1C345.4 280.8 282.5 344.6 204.2 381.3L154.6 320.7C147.8 312.4 136.4 309.6 126.6 313.8L14.6 361.8C3.9 366.5-2 378.1 0.6 389.4L24.6 493.4C27.1 504.2 36.7 512 48 512 304.1 512 512 304.5 512 48 512 36.8 504.3 27.1 493.4 24.6z"}]}}),H.register({"piggy-bank":{width:576,height:512,paths:[{d:"M560 224H530.5C521.7 204 508.9 186.3 493.1 171.5L512 96H480C450.6 96 424.6 109.5 407 130.3 399.4 129.2 391.9 128 384 128H256C178.6 128 114.1 183 99.2 256H56C41.2 256 29.5 242.5 32.5 227.2 34.7 215.8 45.4 208 57 208H58C61.3 208 64 205.3 64 202V182C64 178.7 61.3 176 58 176 29.5 176 4.1 196.4 0.5 224.6-3.9 258.8 22.7 288 56 288H96C96 340.2 121.4 386.1 160 415.3V496C160 504.8 167.2 512 176 512H240C248.8 512 256 504.8 256 496V448H384V496C384 504.8 391.2 512 400 512H464C472.8 512 480 504.8 480 496V415.3C491.8 406.4 502.3 395.9 511.3 384H560C568.8 384 576 376.8 576 368V240C576 231.2 568.8 224 560 224zM432 288C423.2 288 416 280.8 416 272S423.2 256 432 256 448 263.2 448 272 440.8 288 432 288zM256 96H384C389.4 96 394.7 96.4 399.9 96.8 399.9 96.5 400 96.3 400 96 400 43 357 0 304 0S208 43 208 96C208 98.1 208.5 100.1 208.6 102.2 223.8 98.3 239.6 96 256 96z"}]}}),H.register({pills:{width:576,height:512,paths:[{d:"M112 32C50.1 32 0 82.1 0 144V368C0 429.9 50.1 480 112 480S224 429.9 224 368V144C224 82.1 173.9 32 112 32zM160 256H64V144C64 117.5 85.5 96 112 96S160 117.5 160 144V256zM299.7 226.3C296.2 222.8 290.3 223.2 287.4 227.1 242.1 289.6 247 377.2 303.3 433.5 359.6 489.8 447.2 494.7 509.7 449.4 513.7 446.5 514 440.6 510.5 437.1L299.7 226.3zM529.5 207.3C473.2 151 385.6 146.1 323.1 191.4 319.1 194.3 318.8 200.2 322.3 203.7L533.1 414.5C536.6 418 542.5 417.6 545.4 413.7 590.7 351.1 585.9 263.6 529.5 207.3z"}]}}),H.register({plane:{width:576,height:512,paths:[{d:"M472 200H360.2L256 5.7A12-12 0 0 1 245.8 0H188C180.2 0 174.4 7.4 176.4 15L209.6 200H99.8L64.9 141.8A12-12 0 0 1 54.6 136H12C4.4 136-1.2 142.9 0.2 150.4L21.4 256 0.2 361.6C-1.2 369.1 4.4 376 12 376L54.6 376C58.8 376 62.7 373.8 64.9 370.2L99.8 312H209.6L176.4 497C174.4 504.6 180.2 512 188 512H245.8A12-12 0 0 1 256 506.3L360.2 312H472C529.4 312 576 286.9 576 256S529.4 200 472 200z"}]}}),H.register({"play-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM371.7 280L195.7 381C179.9 389.8 160 378.5 160 360V152C160 133.6 179.8 122.2 195.7 131L371.7 238C388.1 247.2 388.1 270.9 371.7 280z"}]}}),H.register({play:{width:448,height:512,paths:[{d:"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464C0 501.5 40.7 524.1 72.4 505.3L424.4 297.3C455.8 278.8 455.9 233.2 424.4 214.7z"}]}}),H.register({plug:{width:384,height:512,paths:[{d:"M256 144V32C256 14.3 270.3 0 288 0S320 14.3 320 32V144H256zM368 160H16C7.2 160 0 167.2 0 176V208C0 216.8 7.2 224 16 224H32V256C32 333.4 87 398 160 412.8V512H224V412.8C297 398 352 333.4 352 256V224H368C376.8 224 384 216.8 384 208V176C384 167.2 376.8 160 368 160zM128 144V32C128 14.3 113.7 0 96 0S64 14.3 64 32V144H128z"}]}}),H.register({"plus-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM400 284C400 290.6 394.6 296 388 296H296V388C296 394.6 290.6 400 284 400H228C221.4 400 216 394.6 216 388V296H124C117.4 296 112 290.6 112 284V228C112 221.4 117.4 216 124 216H216V124C216 117.4 221.4 112 228 112H284C290.6 112 296 117.4 296 124V216H388C394.6 216 400 221.4 400 228V284z"}]}}),H.register({"plus-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM368 284C368 290.6 362.6 296 356 296H264V388C264 394.6 258.6 400 252 400H196C189.4 400 184 394.6 184 388V296H92C85.4 296 80 290.6 80 284V228C80 221.4 85.4 216 92 216H184V124C184 117.4 189.4 112 196 112H252C258.6 112 264 117.4 264 124V216H356C362.6 216 368 221.4 368 228V284z"}]}}),H.register({plus:{width:448,height:512,paths:[{d:"M448 294.2V217.8C448 204.5 437.3 193.8 424 193.8H286.2V56C286.2 42.7 275.5 32 262.2 32H185.8C172.5 32 161.8 42.7 161.8 56V193.8H24C10.7 193.8 0 204.5 0 217.8V294.2C0 307.5 10.7 318.2 24 318.2H161.8V456C161.8 469.3 172.5 480 185.8 480H262.2C275.5 480 286.2 469.3 286.2 456V318.2H424C437.3 318.2 448 307.5 448 294.2z"}]}}),H.register({podcast:{width:448,height:512,paths:[{d:"M267.4 488.6C262.3 507.6 242.9 512 224 512 205.1 512 185.7 507.6 180.6 488.6 172.9 460.1 160 388.9 160 355.8 160 320.6 191.1 312 224 312S288 320.6 288 355.8C288 388.7 275.1 459.9 267.4 488.6zM156.9 288.6C138.2 270.2 126.9 244.4 128.1 216 130.1 166.2 170.5 126 220.2 124.1 274.9 122 320 165.8 320 220 320 246.8 308.9 271.1 291.1 288.6 288.5 291.2 288.7 295.5 291.8 297.7 301.1 304.5 308.2 313.1 313 323.1 314.7 326.8 319.5 327.8 322.4 325 351.3 297.9 369 259.2 368 216.4 366.1 140.2 304.4 78.2 228.2 76.1 146.9 73.8 80 139.2 80 220 80 261.4 97.5 298.7 125.5 325 128.5 327.8 133.3 326.8 135 323.1 139.8 313.1 146.9 304.5 156.2 297.7 159.3 295.5 159.5 291.2 156.9 288.6zM224 0C100.2 0 0 100.2 0 224 0 314 52.6 389.6 125.7 425.4 130.1 427.5 135 423.9 134.3 419.1 131.9 403.6 129.9 388.2 128.9 374.8 128.7 372.9 127.7 371.3 126.2 370.2 78.8 338.4 47.6 284.2 48 222.9 48.6 126.7 127.3 48.3 223.5 48 320.8 47.7 400 126.8 400 224 400 285.9 367.8 340.5 319.4 371.9 318.4 385.9 316.3 402.5 313.7 419.1 313 423.9 317.9 427.5 322.3 425.4 395.2 389.7 448 314.2 448 224 448 100.2 347.8 0 224 0zM224 160C188.7 160 160 188.7 160 224S188.7 288 224 288 288 259.3 288 224 259.3 160 224 160z"}]}}),H.register({poo:{width:512,height:512,paths:[{d:"M451.4 369.1C468.7 356 480 335.4 480 312 480 272.2 447.8 240 408 240H393.9C407.3 228.3 416 211.2 416 192 416 156.7 387.3 128 352 128H346.1C349.7 117.9 352 107.3 352 96 352 43 309 0 256 0 250.8 0 245.8 0.7 240.9 1.5 250.3 14.6 256 30.6 256 48 256 92.2 220.2 128 176 128H160C124.7 128 96 156.7 96 192 96 211.2 104.7 228.3 118.1 240H104C64.2 240 32 272.2 32 312 32 335.4 43.3 356 60.6 369.1 26.3 374.6 0 404.1 0 440 0 479.8 32.2 512 72 512H440C479.8 512 512 479.8 512 440 512 404.1 485.7 374.6 451.4 369.1zM192 256C209.7 256 224 270.3 224 288S209.7 320 192 320 160 305.7 160 288 174.3 256 192 256zM351.5 395C341 422.9 293 448 256 448S171 422.9 160.5 395C158.5 389.7 162.5 384 168.3 384H343.7C349.5 384 353.5 389.7 351.5 395zM320 320C302.3 320 288 305.7 288 288S302.3 256 320 256 352 270.3 352 288 337.7 320 320 320z"}]}}),H.register({"pound-sign":{width:320,height:512,paths:[{d:"M308 352H262.5C255.9 352 250.5 357.4 250.5 364V414.8H128V288H212C218.6 288 224 282.6 224 276V236C224 229.4 218.6 224 212 224H128V160.4C128 128.2 152.6 103.4 189.8 103.4 213.4 103.4 235.7 114.9 247.4 122.2 252.6 125.4 259.3 124.3 263.1 119.5L291.6 84C295.9 78.7 294.9 71 289.5 66.9 273.1 54.6 236.6 32 187.9 32 106 32 48 84.7 48 158V224H20C13.4 224 8 229.4 8 236V276C8 282.6 13.4 288 20 288H48V416H12C5.4 416 0 421.4 0 428V468C0 474.6 5.4 480 12 480H308C314.6 480 320 474.6 320 468V364C320 357.4 314.6 352 308 352z"}]}}),H.register({"power-off":{width:512,height:512,paths:[{d:"M400 54.1C463 99.1 504 172.7 504 256 504 392.8 393.2 503.7 256.5 504 120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2 123.5 45.9 139.8 49.4 146.8 61.9L162.6 90C168.5 100.5 165.7 113.8 156 121 114.5 151.8 88 200.6 88 255.9 87.9 348.2 162.5 424 256 424 347.6 424 424.6 349.8 424 254.9 423.7 203.1 399.3 153.1 355.9 120.9 346.2 113.7 343.5 100.4 349.4 90L365.2 61.9C372.2 49.5 388.4 45.8 400 54.1zM296 264V24C296 10.7 285.3 0 272 0H240C226.7 0 216 10.7 216 24V264C216 277.3 226.7 288 240 288H272C285.3 288 296 277.3 296 264z"}]}}),H.register({"prescription-bottle-alt":{width:384,height:512,paths:[{d:"M360 0H24C10.8 0 0 10.8 0 24V72C0 85.2 10.8 96 24 96H360C373.2 96 384 85.2 384 72V24C384 10.8 373.2 0 360 0zM32 480C32 497.6 46.4 512 64 512H320C337.6 512 352 497.6 352 480V128H32V480zM96 296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296V344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296z"}]}}),H.register({"prescription-bottle":{width:384,height:512,paths:[{d:"M32 192H152C156.4 192 160 195.6 160 200V216C160 220.4 156.4 224 152 224H32V288H152C156.4 288 160 291.6 160 296V312C160 316.4 156.4 320 152 320H32V384H152C156.4 384 160 387.6 160 392V408C160 412.4 156.4 416 152 416H32V480C32 497.6 46.4 512 64 512H320C337.6 512 352 497.6 352 480V128H32V192zM360 0H24C10.8 0 0 10.8 0 24V72C0 85.2 10.8 96 24 96H360C373.2 96 384 85.2 384 72V24C384 10.8 373.2 0 360 0z"}]}}),H.register({print:{width:512,height:512,paths:[{d:"M464 192H448V81.9A24-24 0 0 1 441 65L383 7A24-24 0 0 1 366.1 0H88C74.7 0 64 10.7 64 24V192H48C21.5 192 0 213.5 0 240V372C0 378.6 5.4 384 12 384H64V488C64 501.3 74.7 512 88 512H424C437.3 512 448 501.3 448 488V384H500C506.6 384 512 378.6 512 372V240C512 213.5 490.5 192 464 192zM384 448H128V352H384V448zM128 224V64H320V104C320 117.2 330.8 128 344 128H384V224H128zM432 296C418.7 296 408 285.3 408 272S418.7 248 432 248 456 258.7 456 272 445.3 296 432 296z"}]}}),H.register({procedures:{width:640,height:512,paths:[{d:"M528 224H272C263.2 224 256 231.2 256 240V384H64V144C64 135.2 56.8 128 48 128H16C7.2 128 0 135.2 0 144V496C0 504.8 7.2 512 16 512H48C56.8 512 64 504.8 64 496V448H576V496C576 504.8 583.2 512 592 512H624C632.8 512 640 504.8 640 496V336C640 274.1 589.9 224 528 224zM136 96H262.1L289.7 151.2C295.6 163 312.4 163 318.3 151.2L368 51.8 390.1 96H512C520.8 96 528 88.8 528 80S520.8 64 512 64H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2 284.1 68.4C282.7 65.7 280 64 276.9 64H136C131.6 64 128 67.6 128 72V88C128 92.4 131.6 96 136 96zM160 352C195.3 352 224 323.3 224 288S195.3 224 160 224 96 252.7 96 288 124.7 352 160 352z"}]}}),H.register({"puzzle-piece":{width:576,height:512,paths:[{d:"M519.4 288.7C477.9 288.7 459.9 320.2 437.4 320.2 377.4 320.2 432 144 432 144S235.7 224 235.7 140.7C235.7 104.9 272 94.5 272 54.7 272 19.2 243.9 0 210.5 0 175.9 0 144.2 18.9 144.2 56.3 144.2 97.7 175.9 115.6 175.9 138.1 175.9 207.7 0 166.8 0 166.8V500S178.6 541 178.6 471.3C178.6 448.9 138.6 431.2 138.6 389.9 138.6 352.4 167.9 333.5 202.2 333.5 235.9 333.5 264 352.7 264 388.2 264 428 227.7 438.4 227.7 474.2 227.7 535 357.4 499.9 408.9 499.9 408.9 499.9 374.2 379.8 434.8 379.8 470.7 379.8 481.2 416 521.1 416 556.7 416 576 388 576 354.4 576 320.2 557 288.7 519.4 288.7z"}]}}),H.register({qrcode:{width:448,height:512,paths:[{d:"M0 224H192V32H0V224zM64 96H128V160H64V96zM256 32V224H448V32H256zM384 160H320V96H384V160zM0 480H192V288H0V480zM64 352H128V416H64V352zM416 288H448V416H352V384H320V480H256V288H352V320H416V288zM416 448H448V480H416V448zM352 448H384V480H352V448z"}]}}),H.register({"question-circle":{width:512,height:512,paths:[{d:"M504 256C504 393 393 504 256 504S8 393 8 256C8 119.1 119 8 256 8S504 119.1 504 256zM262.7 90C208.2 90 173.4 113 146.1 153.8 142.6 159 143.8 166.2 148.8 170L183.5 196.3C188.7 200.3 196.1 199.3 200.2 194.2 218 171.5 230.3 158.4 257.5 158.4 277.9 158.4 303.2 171.6 303.2 191.4 303.2 206.3 290.8 214 270.7 225.3 247.1 238.5 216 254.9 216 296V300C216 306.6 221.4 312 228 312H284C290.6 312 296 306.6 296 300V298.7C296 270.2 379.2 269 379.2 192 379.2 134 319 90 262.7 90zM256 338C230.6 338 210 358.6 210 384 210 409.4 230.6 430 256 430S302 409.4 302 384C302 358.6 281.4 338 256 338z"}]}}),H.register({question:{width:384,height:512,paths:[{d:"M202 0C122.2 0 70.5 32.7 29.9 91 22.6 101.6 24.8 116.1 35.1 123.9L78.2 156.6C88.6 164.5 103.4 162.6 111.5 152.5 136.5 121.1 155.1 103 194.2 103 225 103 263.1 122.8 263.1 152.6 263.1 175.2 244.4 186.8 214.1 203.8 178.6 223.7 131.8 248.4 131.8 310.2V320C131.8 333.3 142.5 344 155.8 344H228.2C241.5 344 252.2 333.3 252.2 320V314.2C252.2 271.4 377.5 269.6 377.5 153.6 377.5 66.3 286.9 0 202 0zM192 373.5C153.8 373.5 122.7 404.5 122.7 442.7 122.7 480.9 153.8 512 192 512S261.3 480.9 261.3 442.7 230.2 373.5 192 373.5z"}]}}),H.register({quidditch:{width:640,height:512,paths:[{d:"M256.5 216.8L343.2 326S326.6 428.4 266.6 476.1C206.7 523.8 0 510.2 0 510.2S3.8 487.1 11 454.8L105.6 342.6C109.6 337.9 104.7 331 99 333.1L38.6 355.2C53 313.5 71.3 275.2 93.2 257.7 153.1 209.9 256.5 216.8 256.5 216.8zM494.5 351.8C450.5 351.8 414.7 387.6 414.7 431.7 414.7 475.8 450.4 511.6 494.5 511.6 538.6 511.6 574.3 475.8 574.3 431.7 574.3 387.5 538.5 351.8 494.5 351.8zM636.5 31L616.7 6C611.2-0.9 601.2-2 594.3 3.4L361.8 181.3 327.7 138.3C322.6 131.9 312.6 133.1 309.1 140.5L283.8 195.1 370.5 304.3 429.3 291.9C437.3 290.2 440.7 280.7 435.6 274.3L401.5 231.4 634 53.5C640.9 48 642 37.9 636.5 31z"}]}}),H.register({"quote-left":{width:512,height:512,paths:[{d:"M464 256H384V192C384 156.7 412.7 128 448 128H456C469.3 128 480 117.3 480 104V56C480 42.7 469.3 32 456 32H448C359.6 32 288 103.6 288 192V432C288 458.5 309.5 480 336 480H464C490.5 480 512 458.5 512 432V304C512 277.5 490.5 256 464 256zM176 256H96V192C96 156.7 124.7 128 160 128H168C181.3 128 192 117.3 192 104V56C192 42.7 181.3 32 168 32H160C71.6 32 0 103.6 0 192V432C0 458.5 21.5 480 48 480H176C202.5 480 224 458.5 224 432V304C224 277.5 202.5 256 176 256z"}]}}),H.register({"quote-right":{width:512,height:512,paths:[{d:"M464 32H336C309.5 32 288 53.5 288 80V208C288 234.5 309.5 256 336 256H416V320C416 355.3 387.3 384 352 384H344C330.7 384 320 394.7 320 408V456C320 469.3 330.7 480 344 480H352C440.4 480 512 408.4 512 320V80C512 53.5 490.5 32 464 32zM176 32H48C21.5 32 0 53.5 0 80V208C0 234.5 21.5 256 48 256H128V320C128 355.3 99.3 384 64 384H56C42.7 384 32 394.7 32 408V456C32 469.3 42.7 480 56 480H64C152.4 480 224 408.4 224 320V80C224 53.5 202.5 32 176 32z"}]}}),H.register({random:{width:512,height:512,paths:[{d:"M505 359C514.3 368.4 514.3 383.6 505 393L425 473C410 488 384 477.4 384 456V416H325.2A12-12 0 0 0 316.4 412.2L245.9 336.6 299.2 279.4 352 336H384V296C384 274.6 409.9 264 425 279L505 359zM12 176H96L148.8 232.6 202.1 175.4 131.6 99.8A12-12 0 0 1 122.8 96H12C5.4 96 0 101.4 0 108V164C0 170.6 5.4 176 12 176zM384 176V216C384 237.4 410 248 425 233L505 153C514.3 143.6 514.3 128.4 505 119L425 39C409.9 24 384 34.6 384 56V96H325.2A12-12 0 0 1 316.4 99.8L96 336H12C5.4 336 0 341.4 0 348V404C0 410.6 5.4 416 12 416H122.8C126.1 416 129.3 414.6 131.6 412.2L352 176H384z"}]}}),H.register({recycle:{width:512,height:512,paths:[{d:"M184.6 261.9C187.8 275.9 172.4 286.5 160.5 279.1L119.8 253.6 68.9 335C55.6 356.3 71 384 96 384H148C154.6 384 160 389.4 160 396V436C160 442.6 154.6 448 148 448H96.1C20.8 448-25.2 365 14.7 301.1L65.5 219.7 24.8 194.3C12.7 186.7 15.8 168.3 29.7 165.1L139.9 139.7C148.5 137.7 157.1 143.1 159.1 151.7L184.6 261.9zM283.1 79L324.4 145.1 283.7 170.5C271.6 178 274.7 196.5 288.6 199.7L398.8 225.1C407.5 227.1 416 221.7 418 213.1L443.4 102.9C446.6 89.1 431.4 78.2 419.4 85.7L378.7 111.2 337.4 45.1C299.9-15 212.2-15.1 174.6 45.1L156.6 73.8C153.1 79.5 154.8 86.9 160.4 90.4L194.4 111.6C200 115.1 207.4 113.4 210.9 107.8L228.9 79C241.6 58.7 270.8 59.3 283.1 79zM497.3 301.1L469.8 257.1C466.3 251.4 458.9 249.7 453.2 253.2L419.4 274.4C413.8 277.9 412 285.3 415.6 290.9L443.1 335C456.4 356.3 441.1 384 416 384H320V336C320 321.8 302.8 314.6 292.7 324.7L212.7 404.7C206.4 410.9 206.4 421.1 212.7 427.3L292.7 507.3C302.7 517.3 320 510.3 320 496V448H415.9C491.2 448 537.2 365 497.3 301.1z"}]}}),H.register({"redo-alt":{width:512,height:512,paths:[{d:"M256.5 8C322.7 8.1 382.9 34.2 427.3 76.7L463 41C478.1 25.9 504 36.6 504 57.9V192C504 205.3 493.3 216 480 216H345.9C324.6 216 313.9 190.1 329 175L370.7 133.3C339.9 104.4 299.9 88.4 257.5 88 165.1 87.2 87.2 162 88 257.4 88.8 348 162.2 424 256 424 297.1 424 336 409.3 366.6 382.4 371.4 378.3 378.5 378.5 383 383L422.7 422.7C427.5 427.5 427.3 435.5 422.2 440.1 378.2 479.8 319.9 504 256 504 119 504 8 393 8 256 8 119.2 119.6 7.8 256.5 8z"}]}}),H.register({redo:{width:512,height:512,paths:[{d:"M500.3 0H452.9C446.1 0 440.6 5.7 440.9 12.6L444.9 95.3C399.4 41.9 331.7 8 256 8 119.3 8 7.9 119.5 8 256.2 8.1 393.1 119.1 504 256 504 319.9 504 378.2 479.8 422.2 440.1 427.3 435.5 427.5 427.5 422.7 422.7L388.7 388.7C384.2 384.2 377 384 372.3 388.1 341.3 415.4 300.6 432 256 432 158.7 432 80 353.3 80 256 80 158.7 158.7 80 256 80 316.9 80 370.5 110.9 402.1 157.8L300.6 152.9C293.7 152.6 288 158.1 288 164.9V212.3C288 219 293.4 224.3 300 224.3H500.3C507 224.3 512.3 219 512.3 212.3V12C512.3 5.4 507 0 500.3 0z"}]}}),H.register({registered:{width:512,height:512,paths:[{d:"M285.4 207.5C285.4 226.1 275.5 235.9 256.9 235.9H227.1V179.8H250.4C279.1 179.8 285.4 188.5 285.4 207.5zM504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM363.4 360.4C316.7 275.6 320.1 281.8 318.7 279.4 342.1 264.3 356.7 236.5 356.7 204.9 356.7 150.7 325.2 115.7 251.2 115.7H180.5C167.2 115.7 156.5 126.4 156.5 139.7V372C156.5 385.3 167.2 396 180.5 396H203.1C216.3 396 227.1 385.3 227.1 372V300.3H252.6L296.7 383.3A24-24 0 0 1 317.9 396H342.4C360.7 396 372.2 376.4 363.4 360.4z"}]}}),H.register({"reply-all":{width:576,height:512,paths:[{d:"M136.3 189.8L312.3 37.9C327.7 24.5 352 35.3 352 56V138.8C481.2 149 576 191 576 322.3 576 383.8 536.4 444.6 492.7 476.5 479 486.4 459.6 473.9 464.6 457.8 503.1 334.7 460.7 288.3 352 275.8V360C352 380.7 327.7 391.4 312.3 378.2L136.3 226.2C125.2 216.6 125.2 199.4 136.3 189.8zM8.3 226.2L184.3 378.1C199.7 391.4 224 380.7 224 360V344.2L115.4 250.4A56-56 0 0 0 96 208 56-56 0 0 0 115.4 165.6L224 71.8V56C224 35.3 199.7 24.5 184.3 37.9L8.3 189.8C-2.8 199.4-2.8 216.6 8.3 226.2z"}]}}),H.register({reply:{width:512,height:512,paths:[{d:"M8.3 189.8L184.3 37.9C199.7 24.5 224 35.3 224 56V136.1C384.6 137.9 512 170.1 512 322.3 512 383.8 472.4 444.6 428.7 476.5 415 486.4 395.6 473.9 400.6 457.8 445.9 312.8 379.1 274.3 224 272.1V360C224 380.7 199.7 391.5 184.3 378.2L8.3 226.2C-2.8 216.6-2.8 199.4 8.3 189.8z"}]}}),H.register({retweet:{width:640,height:512,paths:[{d:"M629.7 343.6L529 444.3C519.6 453.7 504.4 453.7 495 444.3L394.3 343.6C385 334.2 385 319 394.3 309.7L405.2 298.8C414.7 289.3 430.3 289.5 439.6 299.3L480 342.1V160H292.5A24-24 0 0 0 275.5 153L259.5 137C244.4 121.9 255.1 96 276.5 96H520C533.3 96 544 106.7 544 120V342.1L584.4 299.3C593.7 289.5 609.3 289.3 618.8 298.8L629.7 309.7C639 319 639 334.2 629.7 343.6zM364.5 359A24-24 0 0 1 347.5 352H160V169.9L200.4 212.7C209.7 222.5 225.3 222.7 234.8 213.2L245.7 202.3C255 193 255 177.8 245.7 168.4L145 67.7C135.6 58.3 120.4 58.3 111 67.7L10.3 168.4C1 177.8 1 193 10.3 202.3L21.2 213.2C30.7 222.7 46.3 222.5 55.6 212.7L96 169.9V392C96 405.3 106.7 416 120 416H363.5C384.9 416 395.6 390.1 380.5 375L364.5 359z"}]}}),H.register({ribbon:{width:448,height:512,paths:[{d:"M6.1 444.3C-3.5 455.1-1.4 471.9 10.6 480L79.4 507.9C89.3 514.6 102.7 512.9 110.7 504.1L202.5 402.2 123.3 314.3 6.1 444.3zM441.9 444.3S149.9 119.7 146.5 114.2C161.9 105.8 186.7 96.3 224 96.3S286.1 105.8 301.5 114.2C298.2 119.8 245.5 178.8 245.5 178.8L324.6 266.5 358.8 228.5C387.5 196.6 392.1 149.9 370.2 113L326.5 39.5C322.2 32.3 316.6 26.2 309.7 21.5 269-6.1 182.3-8.2 138.3 21.5 131.4 26.2 125.8 32.3 121.5 39.5L77.9 112.7C76.4 115.2 40.8 174.9 89.4 228.7L337.5 504C345.5 512.9 358.9 514.5 368.8 507.8L437.6 479.9C449.5 471.9 451.6 455.1 441.9 444.3z"}]}}),H.register({road:{width:576,height:512,paths:[{d:"M567.3 383.6L429.9 78.2C426 69.5 417.4 64 408 64H311.9L313.8 82.8C314.5 89.9 309 96 301.9 96H274C266.9 96 261.3 89.8 262.1 82.8L264 64H168C158.6 64 150 69.5 146.1 78.2L8.7 383.6C3.2 395.8 0 409.6 0 424 0 437.3 10.7 448 24 448H237.6C230.5 448 224.9 441.8 225.7 434.8L236.5 330.8C237.1 324.7 242.3 320 248.4 320H327.6C333.7 320 338.9 324.6 339.5 330.8L350.3 434.8C351 441.9 345.5 448 338.4 448H552C565.2 448 576 437.3 576 424 576 410.1 573 396.3 567.3 383.6zM254.7 154.8L258 122.8C258.6 116.7 263.8 112 269.9 112H306.1C312.2 112 317.4 116.6 318 122.8L321.3 154.8C322 161.9 316.5 168 309.4 168H266.6C259.5 168 253.9 161.8 254.7 154.8zM321.8 288H254.2C247.1 288 241.5 281.8 242.3 274.8L249.7 202.8C250.3 196.7 255.5 192 261.6 192H314.3C320.4 192 325.6 196.6 326.2 202.8L333.6 274.8C334.5 281.8 328.9 288 321.8 288z"}]}}),H.register({rocket:{width:512,height:512,paths:[{d:"M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9C76.7 128 60.1 138.3 52 154.5L2.6 253.3C-5.4 269.3 6.2 288 24.1 288H119.2C113.3 300.8 107.3 313.5 101.2 325.7 98.1 331.9 99.3 339.3 104.2 344.2L167.8 407.8C172.7 412.7 180.1 413.9 186.3 410.8 198.5 404.7 211.2 398.8 224 392.9V488C224 505.8 242.8 517.4 258.7 509.5L357.4 460.1C373.7 452 383.9 435.3 383.9 417.2V312.8C456.5 266.5 511.9 204.4 511.9 101.7 512 76.5 512 51.3 505.1 19.1zM400 160C373.5 160 352 138.5 352 112S373.5 64 400 64 448 85.5 448 112 426.5 160 400 160z"}]}}),H.register({"rss-square":{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM112 416C85.5 416 64 394.5 64 368S85.5 320 112 320 160 341.5 160 368 138.5 416 112 416zM269.5 416H235.2C229.2 416 224.1 411.4 223.8 405.4 218.5 325.3 154.5 261.4 74.6 256.2 68.6 255.9 64 250.8 64 244.8V210.5C64 203.9 69.5 198.7 76 199 186.5 205 275 293.6 281 404 281.3 410.5 276.1 416 269.5 416zM372.6 416H338.2C332.1 416 327.1 411.1 326.8 405 321.2 268.4 211.6 158.8 75 153.2 68.9 152.9 64 147.9 64 141.8V107.4C64 101 69.3 95.8 75.8 96 243.6 102 378 237.2 384 404.2 384.2 410.7 379 416 372.6 416z"}]}}),H.register({rss:{width:448,height:512,paths:[{d:"M128.1 416C128.1 451.3 99.4 480 64 480S0 451.3 0 416 28.7 351.9 64 351.9 128.1 380.6 128.1 416zM303.7 463.2C295.4 308.6 171.6 184.6 16.8 176.3 7.7 175.8 0 183.1 0 192.3V240.3C0 248.7 6.5 255.8 14.9 256.3 126.7 263.6 216.4 353 223.7 465.1 224.2 473.5 231.3 480 239.7 480H287.7C296.9 480 304.2 472.3 303.7 463.2zM448 463.5C439.6 229.7 251.5 40.4 16.5 32 7.5 31.7 0 39 0 48V96.1C0 104.7 6.8 111.7 15.5 112.1 206.6 119.9 360.1 273.4 367.9 464.5 368.3 473.2 375.3 480 383.9 480H432C441 480 448.3 472.5 448 463.5z"}]}}),H.register({"ruble-sign":{width:384,height:512,paths:[{d:"M239.4 320C324.5 320 384 260.5 384 175.1S324.5 32 239.4 32H76C69.4 32 64 37.4 64 44V250.6H12C5.4 250.6 0 256 0 262.6V308C0 314.6 5.4 320 12 320H64V352H12C5.4 352 0 357.4 0 364V404C0 410.6 5.4 416 12 416H64V468C64 474.6 69.4 480 76 480H134.6C141.2 480 146.6 474.6 146.6 468V416H308C314.6 416 320 410.6 320 404V364C320 357.4 314.6 352 308 352H146.6V320H239.4zM146.6 100.7H225.3C272 100.7 300.2 129.9 300.2 175.1 300.2 220.9 272 250.6 224 250.6H146.6V100.7z"}]}}),H.register({"rupee-sign":{width:320,height:512,paths:[{d:"M308 96C314.6 96 320 90.6 320 84V44C320 37.4 314.6 32 308 32H12C5.4 32 0 37.4 0 44V88.7C0 95.4 5.4 100.7 12 100.7H97.3C124.6 100.7 145.5 110.7 158.3 128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H170.8C164.5 228.1 137.8 250.6 96 250.6H12C5.4 250.6 0 256 0 262.6V315.6C0 319 1.4 322.2 3.9 324.5L168.9 476.8A12-12 0 0 1 177.1 480H259.6C270.5 480 275.8 466.6 267.8 459.2L116.9 319.9C193.4 317.6 248 266.5 255.2 192H308C314.6 192 320 186.6 320 180V140C320 133.4 314.6 128 308 128H249.3C245.8 116.5 241 105.8 235.1 96H308z"}]}}),H.register({save:{width:448,height:512,paths:[{d:"M433.9 129.9L350.1 46.1A48-48 0 0 1 316.1 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V163.9A48-48 0 0 1 433.9 129.9zM224 416C188.7 416 160 387.3 160 352 160 316.7 188.7 288 224 288S288 316.7 288 352C288 387.3 259.3 416 224 416zM320 111.5V212C320 218.6 314.6 224 308 224H76C69.4 224 64 218.6 64 212V108C64 101.4 69.4 96 76 96H304.5C307.7 96 310.8 97.3 313 99.5L316.5 103A12-12 0 0 0 320 111.5z"}]}}),H.register({"search-minus":{width:512,height:512,paths:[{d:"M304 192V224C304 230.6 298.6 236 292 236H124C117.4 236 112 230.6 112 224V192C112 185.4 117.4 180 124 180H292C298.6 180 304 185.4 304 192zM505 476.7L476.7 505C467.3 514.4 452.1 514.4 442.8 505L343 405.3C338.5 400.8 336 394.7 336 388.3V372C300.7 399.6 256.3 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208C416 256.3 399.6 300.7 372 336H388.3C394.7 336 400.8 338.5 405.3 343L505 442.7C514.3 452.1 514.3 467.3 505 476.7zM344 208C344 132.8 283.2 72 208 72S72 132.8 72 208 132.8 344 208 344 344 283.2 344 208z"}]}}),H.register({"search-plus":{width:512,height:512,paths:[{d:"M304 192V224C304 230.6 298.6 236 292 236H236V292C236 298.6 230.6 304 224 304H192C185.4 304 180 298.6 180 292V236H124C117.4 236 112 230.6 112 224V192C112 185.4 117.4 180 124 180H180V124C180 117.4 185.4 112 192 112H224C230.6 112 236 117.4 236 124V180H292C298.6 180 304 185.4 304 192zM505 476.7L476.7 505C467.3 514.4 452.1 514.4 442.8 505L343 405.3C338.5 400.8 336 394.7 336 388.3V372C300.7 399.6 256.3 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208C416 256.3 399.6 300.7 372 336H388.3C394.7 336 400.8 338.5 405.3 343L505 442.7C514.3 452.1 514.3 467.3 505 476.7zM344 208C344 132.8 283.2 72 208 72S72 132.8 72 208 132.8 344 208 344 344 283.2 344 208z"}]}}),H.register({search:{width:512,height:512,paths:[{d:"M505 442.7L405.3 343C400.8 338.5 394.7 336 388.3 336H372C399.6 300.7 416 256.3 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416C256.3 416 300.7 399.6 336 372V388.3C336 394.7 338.5 400.8 343 405.3L442.7 505C452.1 514.4 467.3 514.4 476.6 505L504.9 476.7C514.3 467.3 514.3 452.1 505 442.7zM208 336C137.3 336 80 278.8 80 208 80 137.3 137.2 80 208 80 278.7 80 336 137.2 336 208 336 278.7 278.8 336 208 336z"}]}}),H.register({seedling:{width:512,height:512,paths:[{d:"M64 96H0C0 219.7 100.3 320 224 320V464C224 472.8 231.2 480 240 480H272C280.8 480 288 472.8 288 464V320C288 196.3 187.7 96 64 96zM448 32C363.8 32 290.6 78.5 252.3 147.2 280 177.4 300.5 214.1 311.3 254.8 424 243.1 512 147.9 512 32H448z"}]}}),H.register({server:{width:512,height:512,paths:[{d:"M480 160H32C14.3 160 0 145.7 0 128V64C0 46.3 14.3 32 32 32H480C497.7 32 512 46.3 512 64V128C512 145.7 497.7 160 480 160zM432 72C418.7 72 408 82.7 408 96S418.7 120 432 120 456 109.3 456 96 445.3 72 432 72zM368 72C354.7 72 344 82.7 344 96S354.7 120 368 120 392 109.3 392 96 381.3 72 368 72zM480 320H32C14.3 320 0 305.7 0 288V224C0 206.3 14.3 192 32 192H480C497.7 192 512 206.3 512 224V288C512 305.7 497.7 320 480 320zM432 232C418.7 232 408 242.7 408 256S418.7 280 432 280 456 269.3 456 256 445.3 232 432 232zM368 232C354.7 232 344 242.7 344 256S354.7 280 368 280 392 269.3 392 256 381.3 232 368 232zM480 480H32C14.3 480 0 465.7 0 448V384C0 366.3 14.3 352 32 352H480C497.7 352 512 366.3 512 384V448C512 465.7 497.7 480 480 480zM432 392C418.7 392 408 402.7 408 416S418.7 440 432 440 456 429.3 456 416 445.3 392 432 392zM368 392C354.7 392 344 402.7 344 416S354.7 440 368 440 392 429.3 392 416 381.3 392 368 392z"}]}}),H.register({"share-alt-square":{width:448,height:512,paths:[{d:"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM304 296C289.4 296 276.2 301.6 266.2 310.7L198.3 269.9A56.3-56.3 0 0 1 198.3 242.1L266.2 201.3C276.2 210.4 289.4 216 304 216 334.9 216 360 190.9 360 160S334.9 104 304 104 248 129.1 248 160C248 164.8 248.6 169.5 249.7 173.9L181.8 214.7C171.8 205.6 158.6 200 144 200 113.1 200 88 225.1 88 256S113.1 312 144 312C158.6 312 171.8 306.4 181.8 297.3L249.7 338.1A56.1-56.1 0 0 1 248 352C248 382.9 273.1 408 304 408S360 382.9 360 352C360 321.1 334.9 296 304 296z"}]}}),H.register({"share-alt":{width:448,height:512,paths:[{d:"M352 320C329.4 320 308.6 327.8 292.2 340.9L189.7 276.8A96.6-96.6 0 0 1 189.7 235.2L292.2 171.1C308.6 184.2 329.4 192 352 192 405 192 448 149 448 96S405 0 352 0 256 43 256 96C256 103.2 256.8 110.1 258.3 116.8L155.8 180.9C139.4 167.8 118.6 160 96 160 43 160 0 203 0 256S43 352 96 352C118.6 352 139.4 344.2 155.8 331.1L258.3 395.2A96.3-96.3 0 0 1 256 416C256 469 299 512 352 512S448 469 448 416 405 320 352 320z"}]}}),H.register({"share-square":{width:576,height:512,paths:[{d:"M568.5 177.4L424.5 313.4C409.3 327.8 384 317.1 384 296V224C239.4 225 178.4 259.1 219.2 395.4 223.7 410.3 206.4 421.9 194.2 412.7 155.3 383.1 120 326.5 120 269.3 120 125.4 237.6 96.8 384 96V24C384 2.8 409.3-7.8 424.5 6.6L568.5 142.6C578.5 152 578.5 168 568.5 177.4zM384 379.1V448H64V128H114.9A12-12 0 0 1 123.6 124.3C138.5 108.7 155.8 96.4 174.6 86.6 185.7 80.8 181.6 64 169 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V375.2C448 366.9 439.8 361.1 432 363.9A71.8-71.8 0 0 0 397.8 367.3C390.5 366.2 384 371.8 384 379.1z"}]}}),H.register({share:{width:512,height:512,paths:[{d:"M503.7 189.8L327.7 37.9C312.3 24.5 288 35.3 288 56V136.1C127.4 137.9 0 170.1 0 322.3 0 383.8 39.6 444.6 83.3 476.5 97 486.4 116.4 473.9 111.4 457.8 66.1 312.8 132.9 274.3 288 272.1V360C288 380.7 312.3 391.5 327.7 378.2L503.7 226.2C514.8 216.6 514.8 199.4 503.7 189.8z"}]}}),H.register({"shekel-sign":{width:448,height:512,paths:[{d:"M170.1 96H80V468C80 474.6 74.6 480 68 480H12C5.4 480 0 474.6 0 468V44C0 37.4 5.4 32 12 32H180.4C265.5 32 325 89.6 325 175.1V359C325 365.6 319.6 371 313 371H269C255.7 371 245 360.3 245 347V170.3C245 125.1 216.8 96 170.1 96zM436 32H380C373.4 32 368 37.4 368 44V416H277.9C231.2 416 203 386.9 203 341.7V165C203 151.7 192.3 141 179 141H135C128.4 141 123 146.4 123 153V336.9C123 422.4 182.5 480 267.6 480H436C442.6 480 448 474.6 448 468V44C448 37.4 442.6 32 436 32z"}]}}),H.register({"shield-alt":{width:512,height:512,paths:[{d:"M496 128C496 349.3 360.1 472.6 274.5 508.3A48-48 0 0 0 237.5 508.3C130.5 463.7 16 326.5 16 128A48-48 0 0 0 45.5 83.7L237.5 3.7A48-48 0 0 0 274.5 3.7L466.5 83.7A48-48 0 0 0 496 128zM256 446.3L256.1 446.3C349.8 399.7 428.6 290 431.9 138.6L256 65.3V446.3z"}]}}),H.register({ship:{width:640,height:512,paths:[{d:"M496.6 372.6L566.6 302.6C583.5 285.7 576.6 256.9 553.8 249.5L512 236.1V96C512 78.3 497.7 64 480 64H416V24C416 10.7 405.3 0 392 0H248C234.7 0 224 10.7 224 24V64H160C142.3 64 128 78.3 128 96V236.1L86.2 249.5C63.5 256.8 56.5 285.7 73.4 302.6L143.4 372.6C125.8 416.3 85.6 448 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512 85 512 131.5 491.4 167.3 452.6 181.7 487.4 216 512 256 512H384C424 512 458.3 487.4 472.7 452.6 508.5 491.4 555 512 616 512 629.3 512 640 501.3 640 488V472C640 458.7 629.3 448 616 448 555.2 448 514.5 417 496.6 372.6zM192 128H448V215.5L329.8 177.5A32-32 0 0 1 310.2 177.5L192 215.5V128z"}]}}),H.register({"shipping-fast":{width:640,height:512,paths:[{d:"M624 352H608V243.9C608 231.2 602.9 219 593.9 210L494 110.1C485 101.1 472.8 96 460.1 96H416V48C416 21.5 394.5 0 368 0H112C85.5 0 64 21.5 64 48V96H8C3.6 96 0 99.6 0 104V120C0 124.4 3.6 128 8 128H280C284.4 128 288 131.6 288 136V152C288 156.4 284.4 160 280 160H40C35.6 160 32 163.6 32 168V184C32 188.4 35.6 192 40 192H248C252.4 192 256 195.6 256 200V216C256 220.4 252.4 224 248 224H8C3.6 224 0 227.6 0 232V248C0 252.4 3.6 256 8 256H216C220.4 256 224 259.6 224 264V280C224 284.4 220.4 288 216 288H64V416C64 469 107 512 160 512S256 469 256 416H384C384 469 427 512 480 512S576 469 576 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM160 464C133.5 464 112 442.5 112 416S133.5 368 160 368 208 389.5 208 416 186.5 464 160 464zM480 464C453.5 464 432 442.5 432 416S453.5 368 480 368 528 389.5 528 416 506.5 464 480 464zM560 256H416V144H460.1L560 243.9V256z"}]}}),H.register({"shopping-bag":{width:448,height:512,paths:[{d:"M352 160V128C352 57.4 294.6 0 224 0 153.4 0 96 57.4 96 128V160H0V432C0 476.2 35.8 512 80 512H368C412.2 512 448 476.2 448 432V160H352zM160 128C160 92.7 188.7 64 224 64S288 92.7 288 128V160H160V128zM320 248C306.7 248 296 237.3 296 224S306.7 200 320 200 344 210.7 344 224 333.3 248 320 248zM128 248C114.7 248 104 237.3 104 224S114.7 200 128 200 152 210.7 152 224 141.3 248 128 248z"}]}}),H.register({"shopping-basket":{width:576,height:512,paths:[{d:"M576 216V232C576 245.3 565.3 256 552 256H544L517.9 438.8C514.5 462.4 494.3 480 470.4 480H105.6C81.7 480 61.5 462.4 58.1 438.8L32 256H24C10.7 256 0 245.3 0 232V216C0 202.7 10.7 192 24 192H91.3L198.1 45.2C208.5 30.9 228.5 27.7 242.8 38.1 257.1 48.5 260.3 68.5 249.9 82.8L170.5 192H405.5L326.1 82.8C315.7 68.5 318.9 48.5 333.2 38.1 347.5 27.7 367.5 30.9 377.9 45.2L484.7 192H552C565.3 192 576 202.7 576 216zM312 392V280C312 266.7 301.3 256 288 256S264 266.7 264 280V392C264 405.3 274.7 416 288 416S312 405.3 312 392zM424 392V280C424 266.7 413.3 256 400 256S376 266.7 376 280V392C376 405.3 386.7 416 400 416S424 405.3 424 392zM200 392V280C200 266.7 189.3 256 176 256S152 266.7 152 280V392C152 405.3 162.7 416 176 416S200 405.3 200 392z"}]}}),H.register({"shopping-cart":{width:576,height:512,paths:[{d:"M528.1 301.3L575.4 93.3C578.8 78.3 567.4 64 552 64H159.2L150 19.2C147.8 8 137.9 0 126.5 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64H93.9L164.1 407.4C147.3 417.1 136 435.2 136 456 136 486.9 161.1 512 192 512S248 486.9 248 456C248 440.3 241.6 426.2 231.2 416H440.8C430.4 426.2 424 440.3 424 456 424 486.9 449.1 512 480 512S536 486.9 536 456C536 433.8 523.1 414.7 504.4 405.6L509.9 381.3C513.4 366.3 501.9 352 486.5 352H218.1L211.6 320H504.7C515.9 320 525.6 312.2 528.1 301.3z"}]}}),H.register({shower:{width:512,height:512,paths:[{d:"M389.7 135.6L231.6 293.7C222.2 303 207 303 197.7 293.7L186.3 282.3C177 273 177 257.8 186.3 248.4L186.4 248.3C152.4 208.1 151.3 149.4 183.1 107.9 171.1 100.4 156.9 96 141.8 96 98.9 96 64 130.9 64 173.8V480H0V173.8C0 95.6 63.6 32 141.8 32 178.7 32 212.4 46.2 237.6 69.4 273.5 57.9 314.1 64.9 344.3 90.4L344.4 90.3C353.8 81 369 81 378.3 90.3L389.7 101.7C399 111 399 126.2 389.7 135.6zM384 208C384 216.8 376.8 224 368 224S352 216.8 352 208 359.2 192 368 192 384 199.2 384 208zM416 208C416 199.2 423.2 192 432 192S448 199.2 448 208 440.8 224 432 224 416 216.8 416 208zM512 208C512 216.8 504.8 224 496 224S480 216.8 480 208 487.2 192 496 192 512 199.2 512 208zM352 240C352 248.8 344.8 256 336 256S320 248.8 320 240 327.2 224 336 224 352 231.2 352 240zM400 224C408.8 224 416 231.2 416 240S408.8 256 400 256 384 248.8 384 240 391.2 224 400 224zM480 240C480 248.8 472.8 256 464 256S448 248.8 448 240 455.2 224 464 224 480 231.2 480 240zM320 272C320 280.8 312.8 288 304 288S288 280.8 288 272 295.2 256 304 256 320 263.2 320 272zM352 272C352 263.2 359.2 256 368 256S384 263.2 384 272 376.8 288 368 288 352 280.8 352 272zM448 272C448 280.8 440.8 288 432 288S416 280.8 416 272 423.2 256 432 256 448 263.2 448 272zM320 304C320 295.2 327.2 288 336 288S352 295.2 352 304 344.8 320 336 320 320 312.8 320 304zM416 304C416 312.8 408.8 320 400 320S384 312.8 384 304 391.2 288 400 288 416 295.2 416 304zM320 336C320 344.8 312.8 352 304 352S288 344.8 288 336 295.2 320 304 320 320 327.2 320 336zM384 336C384 344.8 376.8 352 368 352S352 344.8 352 336 359.2 320 368 320 384 327.2 384 336zM352 368C352 376.8 344.8 384 336 384S320 376.8 320 368 327.2 352 336 352 352 359.2 352 368zM320 400C320 408.8 312.8 416 304 416S288 408.8 288 400 295.2 384 304 384 320 391.2 320 400z"}]}}),H.register({"sign-in-alt":{width:512,height:512,paths:[{d:"M416 448H332C325.4 448 320 442.6 320 436V396C320 389.4 325.4 384 332 384H416C433.7 384 448 369.7 448 352V160C448 142.3 433.7 128 416 128H332C325.4 128 320 122.6 320 116V76C320 69.4 325.4 64 332 64H416C469 64 512 107 512 160V352C512 405 469 448 416 448zM369 247L201 79C186 64 160 74.5 160 96V192H24C10.7 192 0 202.7 0 216V312C0 325.3 10.7 336 24 336H160V432C160 453.5 186 464 201 449L369 281C378.3 271.6 378.3 256.4 369 247z"}]}}),H.register({"sign-language":{width:448,height:512,paths:[{d:"M91.4 484C91.1 468 104.5 454.9 120.6 454.9H182.9V449.1H57C41 449.1 27.6 436 27.9 420 28.2 404.5 40.8 392 56.4 392H182.9V386.3H29.1C13.1 386.3-0.3 373.2 0 357.2 0.3 341.6 13 329.1 28.6 329.1H182.9V323.4H57.7C41.7 323.4 28.3 310.3 28.6 294.3 28.9 278.8 41.5 266.3 57.1 266.3H225.7L194.6 243.7C181.9 234.4 179 216.5 188.3 203.8 197.6 191 215.5 188.2 228.2 197.5L351.6 287.2A34.3-34.3 0 0 0 365.7 314.9V456C365.7 472 354.8 485.8 339.3 489.4L258.8 508.4A137.2-137.2 0 0 0 227.4 512H120C104.4 512 91.7 499.5 91.4 484zM164.7 258.3H201.1L189.9 250.2C171.3 236.6 169.6 209.3 186.7 193.6L173.7 176.9C163.9 164.3 145.3 161.7 132.9 171.8 120.8 181.6 118.7 199.3 128.3 211.6L164.7 258.3zM448 256.2L443 103.7C442.5 88 429.3 75.6 413.5 76.1 397.7 76.6 385.3 89.8 385.9 105.6L387.1 144 283.6 11C274-1.3 256.3-3.6 243.9 5.7 231.1 15.3 229 33.9 238.8 46.6L315.7 145.3 311.2 148.8 216.4 27.1C206.8 14.8 189.2 12.5 176.8 21.8 163.9 31.4 161.8 50 171.7 62.6L266.1 183.9 261.6 187.4 183.9 87.7C174.4 75.4 156.7 73.1 144.3 82.4 131.5 92 129.4 110.6 139.2 123.2L191.2 190.1C203.7 181.8 220.3 181.8 232.9 191L356.3 280.7C367.2 288.6 373.7 301.4 373.7 314.9V331.9L434.8 284.4A34.3-34.3 0 0 1 448 256.2z"}]}}),H.register({"sign-out-alt":{width:512,height:512,paths:[{d:"M497 273L329 441C314 456 288 445.5 288 424V328H152C138.7 328 128 317.3 128 304V208C128 194.7 138.7 184 152 184H288V88C288 66.6 313.9 56 329 71L497 239C506.3 248.4 506.3 263.6 497 273zM192 436V396C192 389.4 186.6 384 180 384H96C78.3 384 64 369.7 64 352V160C64 142.3 78.3 128 96 128H180C186.6 128 192 122.6 192 116V76C192 69.4 186.6 64 180 64H96C43 64 0 107 0 160V352C0 405 43 448 96 448H180C186.6 448 192 442.6 192 436z"}]}}),H.register({sign:{width:512,height:512,paths:[{d:"M496 64H128V16C128 7.2 120.8 0 112 0H80C71.2 0 64 7.2 64 16V64H16C7.2 64 0 71.2 0 80V112C0 120.8 7.2 128 16 128H64V496C64 504.8 71.2 512 80 512H112C120.8 512 128 504.8 128 496V128H496C504.8 128 512 120.8 512 112V80C512 71.2 504.8 64 496 64zM160 384H480V160H160V384z"}]}}),H.register({signal:{width:640,height:512,paths:[{d:"M36 384H92C98.6 384 104 389.4 104 396V500C104 506.6 98.6 512 92 512H36C29.4 512 24 506.6 24 500V396C24 389.4 29.4 384 36 384zM152 348V500C152 506.6 157.4 512 164 512H220C226.6 512 232 506.6 232 500V348C232 341.4 226.6 336 220 336H164C157.4 336 152 341.4 152 348zM280 268V500C280 506.6 285.4 512 292 512H348C354.6 512 360 506.6 360 500V268C360 261.4 354.6 256 348 256H292C285.4 256 280 261.4 280 268zM408 156V500C408 506.6 413.4 512 420 512H476C482.6 512 488 506.6 488 500V156C488 149.4 482.6 144 476 144H420C413.4 144 408 149.4 408 156zM536 12V500C536 506.6 541.4 512 548 512H604C610.6 512 616 506.6 616 500V12C616 5.4 610.6 0 604 0H548C541.4 0 536 5.4 536 12z"}]}}),H.register({sitemap:{width:640,height:512,paths:[{d:"M616 320H568V272C568 249.9 550.1 232 528 232H344V192H392C405.3 192 416 181.3 416 168V24C416 10.7 405.3 0 392 0H248C234.7 0 224 10.7 224 24V168C224 181.3 234.7 192 248 192H296V232H112C89.9 232 72 249.9 72 272V320H24C10.7 320 0 330.7 0 344V488C0 501.3 10.7 512 24 512H168C181.3 512 192 501.3 192 488V344C192 330.7 181.3 320 168 320H120V280H296V320H248C234.7 320 224 330.7 224 344V488C224 501.3 234.7 512 248 512H392C405.3 512 416 501.3 416 488V344C416 330.7 405.3 320 392 320H344V280H520V320H472C458.7 320 448 330.7 448 344V488C448 501.3 458.7 512 472 512H616C629.3 512 640 501.3 640 488V344C640 330.7 629.3 320 616 320z"}]}}),H.register({"sliders-h":{width:576,height:512,paths:[{d:"M576 80V120C576 126.6 570.6 132 564 132H160V140C160 153.3 149.3 164 136 164H120C106.7 164 96 153.3 96 140V132H12C5.4 132 0 126.6 0 120V80C0 73.4 5.4 68 12 68H96V60C96 46.7 106.7 36 120 36H136C149.3 36 160 46.7 160 60V68H564C570.6 68 576 73.4 576 80zM564 228H480V220C480 206.7 469.3 196 456 196H440C426.7 196 416 206.7 416 220V228H12C5.4 228 0 233.4 0 240V280C0 286.6 5.4 292 12 292H416V300C416 313.3 426.7 324 440 324H456C469.3 324 480 313.3 480 300V292H564C570.6 292 576 286.6 576 280V240C576 233.4 570.6 228 564 228zM564 388H288V380C288 366.7 277.3 356 264 356H248C234.7 356 224 366.7 224 380V388H12C5.4 388 0 393.4 0 400V440C0 446.6 5.4 452 12 452H224V460C224 473.3 234.7 484 248 484H264C277.3 484 288 473.3 288 460V452H564C570.6 452 576 446.6 576 440V400C576 393.4 570.6 388 564 388z"}]}}),H.register({smile:{width:496,height:512,paths:[{d:"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM362.8 346.2C334.3 380.4 292.5 400 248 400S161.7 380.4 133.2 346.2C127.5 339.4 128.5 329.3 135.2 323.7 142 318 152.1 319 157.7 325.7 180.1 352.6 212.9 367.9 247.9 367.9S315.7 352.5 338.1 325.7C343.8 318.9 353.8 318 360.6 323.7 367.5 329.4 368.4 339.5 362.8 346.2z"}]}}),H.register({smoking:{width:640,height:512,paths:[{d:"M632 352H584C579.6 352 576 355.6 576 360V504C576 508.4 579.6 512 584 512H632C636.4 512 640 508.4 640 504V360C640 355.6 636.4 352 632 352zM553.3 87.1C547.6 83.3 544 77.1 544 70.3V8C544 3.6 540.4 0 536 0H488C483.6 0 480 3.6 480 8V70.3C480 92.3 490.2 113.7 508.6 125.7 550.8 153 576 199.5 576 249.7V280C576 284.4 579.6 288 584 288H632C636.4 288 640 284.4 640 280V249.7C640 184.2 607.6 123.5 553.3 87.1zM432 352H48C21.5 352 0 373.5 0 400V464C0 490.5 21.5 512 48 512H432C440.8 512 448 504.8 448 496V368C448 359.2 440.8 352 432 352zM400 464H224V400H400V464zM487.7 141.6C463.8 125 448 99.3 448 70.3V8C448 3.6 444.4 0 440 0H392C387.6 0 384 3.6 384 8V74.4C384 118.1 408.6 156 444.3 181.1 466.7 196.8 480 222.3 480 249.7V280C480 284.4 483.6 288 488 288H536C540.4 288 544 284.4 544 280V249.7C544 206.4 523 166.3 487.7 141.6zM536 352H488C483.6 352 480 355.6 480 360V504C480 508.4 483.6 512 488 512H536C540.4 512 544 508.4 544 504V360C544 355.6 540.4 352 536 352z"}]}}),H.register({snowflake:{width:448,height:512,paths:[{d:"M444.8 301.6A24.1-24.1 0 0 1 447.5 284.7C444.8 271.7 432.1 263.4 419.3 266.2L331.9 291.2 264 256 331.9 220.8 419.3 245.8C432.1 248.6 444.8 240.3 447.5 227.3 450.2 214.4 442 201.6 429.2 198.9L381.7 191.7 434.8 160.8C446.1 154.2 450 139.5 443.5 128 436.9 116.5 422.4 112.6 411 119.2L357.9 150.2 375.6 105.1C379.6 92.5 372.8 78.9 360.3 74.8 347.8 70.7 334.4 77.6 330.4 90.2L308.1 179.2 247.8 214.4V144L312.9 80.1C321.7 70.2 320.9 55 311.2 46.2 301.4 37.3 286.4 38.1 277.6 47.9L247.8 85.9V24C247.8 10.7 237.1 0 224 0S200.2 10.7 200.2 24V85.9L170.4 47.9C161.6 38.1 146.6 37.3 136.8 46.2 127.1 55 126.3 70.2 135.1 80.1L200.2 144V214.4L139.9 179.2 117.6 90.2C113.6 77.6 100.2 70.7 87.7 74.8 75.2 78.9 68.4 92.5 72.4 105.1L90.1 150.2 37 119.2C25.6 112.6 11.1 116.5 4.5 128S1.9 154.2 13.2 160.8L66.3 191.7 18.8 198.9C6 201.6-2.2 214.4 0.5 227.3 3.2 240.3 15.9 248.6 28.7 245.8L116.1 220.8 184 256 116.1 291.2 28.7 266.2C15.9 263.4 3.2 271.7 0.5 284.7-2.2 297.6 6 310.4 18.8 313.1L66.3 320.3 13.2 351.2C1.9 357.8-2 372.5 4.5 384S25.6 399.4 37 392.8L90.1 361.8 72.4 406.9A24.2-24.2 0 0 1 74.5 426.4C77.3 431.3 81.9 435.3 87.7 437.2 100.2 441.3 113.6 434.4 117.6 421.8L139.9 332.8 200.2 297.6V368L135.1 431.9C126.3 441.8 127.1 457 136.8 465.8 146.6 474.7 161.6 473.9 170.4 464.1L200.2 426.1V488C200.2 501.3 210.9 512 224 512S247.8 501.3 247.8 488V426.1L277.6 464.1A23.6-23.6 0 0 1 295.3 472 23.5-23.5 0 0 1 311.2 465.8C320.9 457 321.7 441.8 312.9 431.9L247.8 368V297.6L308.1 332.8 330.4 421.8C334.4 434.4 347.8 441.3 360.3 437.2 372.8 433.1 379.6 419.5 375.6 406.9L357.9 361.8 411 392.8C422.4 399.4 436.9 395.5 443.5 384S446.1 357.8 434.8 351.2L381.7 320.3 429.2 313.1C436 311.7 441.6 307.3 444.8 301.6z"}]}}),H.register({"sort-alpha-down":{width:448,height:512,paths:[{d:"M187.3 395.3L107.3 475.3C101.1 481.6 90.9 481.6 84.7 475.3L4.7 395.3C-5.4 385.2 1.8 368 16 368H64V48C64 39.2 71.2 32 80 32H112C120.8 32 128 39.2 128 48V368H176C190.2 368 197.3 385.3 187.3 395.3zM306.4 215.3A12-12 0 0 0 294.8 224H259.1C250.9 224 245.1 215.9 247.8 208.1L304.9 40.1A12-12 0 0 0 316.2 32H355.8C360.9 32 365.5 35.3 367.1 40.1L424.2 208.1C426.9 215.9 421.1 224 412.9 224H377.1A12-12 0 0 0 365.6 215.4L357.3 187.1H314.5L306.4 215.3zM329.2 136.6H342.6L336 113.7 329.2 136.6zM341.8 423.9L409.3 328.2A12-12 0 0 1 411.4 321.3V300C411.4 293.4 406.1 288 399.4 288H274.5C267.9 288 262.5 293.4 262.5 300V328.9C262.5 335.6 267.9 340.9 274.5 340.9H331C330.3 341.9 329.5 343 328.7 344.1L261.5 439.3A12-12 0 0 1 259.3 446.2V468C259.3 474.6 264.7 480 271.3 480H400.7C407.3 480 412.7 474.6 412.7 468V439.1C412.7 432.4 407.3 427.1 400.7 427.1H339.5C340.3 426.1 341 425 341.8 423.9z"}]}}),H.register({"sort-alpha-up":{width:448,height:512,paths:[{d:"M4.7 116.7L84.7 36.7C90.9 30.4 101.1 30.4 107.3 36.7L187.3 116.7C197.4 126.8 190.2 144 176 144H128V464C128 472.8 120.8 480 112 480H80C71.2 480 64 472.8 64 464V144H16C1.8 144-5.3 126.7 4.7 116.7zM306.4 215.3A12-12 0 0 0 294.8 224H259.1C250.9 224 245.1 215.9 247.8 208.1L304.9 40.1A12-12 0 0 0 316.2 32H355.8C360.9 32 365.5 35.3 367.1 40.1L424.2 208.1C426.9 215.9 421.1 224 412.9 224H377.1A12-12 0 0 0 365.6 215.4L357.3 187.1H314.5L306.4 215.3zM329.2 136.6H342.6L336 113.7 329.2 136.6zM341.8 423.9L409.3 328.2A12-12 0 0 1 411.4 321.3V300C411.4 293.4 406.1 288 399.4 288H274.5C267.9 288 262.5 293.4 262.5 300V328.9C262.5 335.6 267.9 340.9 274.5 340.9H331C330.3 341.9 329.5 343 328.7 344.1L261.5 439.3A12-12 0 0 1 259.3 446.2V468C259.3 474.6 264.7 480 271.3 480H400.7C407.3 480 412.7 474.6 412.7 468V439.1C412.7 432.4 407.3 427.1 400.7 427.1H339.5C340.3 426.1 341 425 341.8 423.9z"}]}}),H.register({"sort-amount-down":{width:512,height:512,paths:[{d:"M187.3 395.3L107.3 475.3C101.1 481.6 90.9 481.6 84.7 475.3L4.7 395.3C-5.4 385.2 1.8 368 16 368H64V48C64 39.2 71.2 32 80 32H112C120.8 32 128 39.2 128 48V368H176C190.2 368 197.3 385.3 187.3 395.3zM240 96H496C504.8 96 512 88.8 512 80V48C512 39.2 504.8 32 496 32H240C231.2 32 224 39.2 224 48V80C224 88.8 231.2 96 240 96zM224 208V176C224 167.2 231.2 160 240 160H432C440.8 160 448 167.2 448 176V208C448 216.8 440.8 224 432 224H240C231.2 224 224 216.8 224 208zM224 464V432C224 423.2 231.2 416 240 416H304C312.8 416 320 423.2 320 432V464C320 472.8 312.8 480 304 480H240C231.2 480 224 472.8 224 464zM224 336V304C224 295.2 231.2 288 240 288H368C376.8 288 384 295.2 384 304V336C384 344.8 376.8 352 368 352H240C231.2 352 224 344.8 224 336z"}]}}),H.register({"sort-amount-up":{width:512,height:512,paths:[{d:"M4.7 116.7L84.7 36.7C90.9 30.4 101.1 30.4 107.3 36.7L187.3 116.7C197.4 126.8 190.2 144 176 144H128V464C128 472.8 120.8 480 112 480H80C71.2 480 64 472.8 64 464V144H16C1.8 144-5.3 126.7 4.7 116.7zM240 96H496C504.8 96 512 88.8 512 80V48C512 39.2 504.8 32 496 32H240C231.2 32 224 39.2 224 48V80C224 88.8 231.2 96 240 96zM224 208V176C224 167.2 231.2 160 240 160H432C440.8 160 448 167.2 448 176V208C448 216.8 440.8 224 432 224H240C231.2 224 224 216.8 224 208zM224 464V432C224 423.2 231.2 416 240 416H304C312.8 416 320 423.2 320 432V464C320 472.8 312.8 480 304 480H240C231.2 480 224 472.8 224 464zM224 336V304C224 295.2 231.2 288 240 288H368C376.8 288 384 295.2 384 304V336C384 344.8 376.8 352 368 352H240C231.2 352 224 344.8 224 336z"}]}}),H.register({"sort-down":{width:320,height:512,paths:[{d:"M41 288H279C300.4 288 311.1 313.9 296 329L177 448C167.6 457.4 152.4 457.4 143.1 448L24 329C8.9 313.9 19.6 288 41 288z"}]}}),H.register({"sort-numeric-down":{width:448,height:512,paths:[{d:"M308.8 113.8L289.4 93C284.8 88.2 285.1 80.6 289.9 76L333.4 35.3A12-12 0 0 0 341.6 32.1H373.2C379.8 32.1 385.2 37.4 385.2 44.1V171.1H410.8C417.4 171.1 422.8 176.5 422.8 183.1V212.1C422.8 218.7 417.4 224.1 410.8 224.1H301.6C295 224.1 289.6 218.7 289.6 212.1V183.1C289.6 176.5 295 171.1 301.6 171.1H327.1V113.2C319.8 119.8 312.9 118.1 308.8 113.8zM278.2 352.4C278.2 319.7 302.1 285 346.3 285 384.6 285 425.8 313.9 425.8 377.2 425.8 428.5 393.5 483 333.8 483 315.9 483 303.2 479.4 295.2 476.2 289.4 473.9 286.4 467.5 288.3 461.5L297.5 432C299.6 425.5 306.6 422.1 313 424.3 326 428.9 340.9 429.6 351.1 420.2 312.4 425.3 278.2 394.8 278.2 352.4zM370.5 371.7C370.5 349.4 355.2 335.2 344.7 335.2 336 335.2 331.5 343.2 331.5 351 331.5 356.7 333.3 375.2 356.7 375.2 366.7 375.2 370.1 373 370.4 372.5 370.4 372.4 370.5 372.2 370.5 371.7zM176 368H128V48C128 39.2 120.8 32 112 32H80C71.2 32 64 39.2 64 48V368H16C1.8 368-5.4 385.2 4.7 395.3L84.7 475.3C90.9 481.6 101.1 481.6 107.3 475.3L187.3 395.3C197.3 385.3 190.2 368 176 368z"}]}}),H.register({"sort-numeric-up":{width:448,height:512,paths:[{d:"M308.8 113.8L289.4 93C284.8 88.2 285.1 80.6 289.9 76L333.4 35.3A12-12 0 0 0 341.6 32.1H373.2C379.8 32.1 385.2 37.4 385.2 44.1V171.1H410.8C417.4 171.1 422.8 176.5 422.8 183.1V212.1C422.8 218.7 417.4 224.1 410.8 224.1H301.6C295 224.1 289.6 218.7 289.6 212.1V183.1C289.6 176.5 295 171.1 301.6 171.1H327.1V113.2C319.8 119.8 312.9 118.1 308.8 113.8zM278.2 352.4C278.2 319.7 302.1 285 346.3 285 384.6 285 425.8 313.9 425.8 377.2 425.8 428.5 393.5 483 333.8 483 315.9 483 303.2 479.4 295.2 476.2 289.4 473.9 286.4 467.5 288.3 461.5L297.5 432C299.6 425.5 306.6 422.1 313 424.3 326 428.9 340.9 429.6 351.1 420.2 312.4 425.3 278.2 394.8 278.2 352.4zM370.5 371.7C370.5 349.4 355.2 335.2 344.7 335.2 336 335.2 331.5 343.2 331.5 351 331.5 356.7 333.3 375.2 356.7 375.2 366.7 375.2 370.1 373 370.4 372.5 370.4 372.4 370.5 372.2 370.5 371.7zM16 144H64V464C64 472.8 71.2 480 80 480H112C120.8 480 128 472.8 128 464V144H176C190.2 144 197.4 126.8 187.3 116.7L107.3 36.7C101.1 30.4 90.9 30.4 84.7 36.7L4.7 116.7C-5.3 126.7 1.8 144 16 144z"}]}}),H.register({"sort-up":{width:320,height:512,paths:[{d:"M279 224H41C19.6 224 8.9 198.1 24 183L143 64C152.4 54.6 167.6 54.6 176.9 64L295.9 183C311.1 198.1 300.4 224 279 224z"}]}}),H.register({sort:{width:320,height:512,paths:[{d:"M41 288H279C300.4 288 311.1 313.9 296 329L177 448C167.6 457.4 152.4 457.4 143.1 448L24 329C8.9 313.9 19.6 288 41 288zM296 183L177 64C167.6 54.6 152.4 54.6 143.1 64L24 183C8.9 198.1 19.6 224 41 224H279C300.4 224 311.1 198.1 296 183z"}]}}),H.register({"space-shuttle":{width:640,height:512,paths:[{d:"M592.6 208.2C559.7 192.8 515.8 184 472 184H186.3C181.4 177.4 175.7 172 169.6 168H376C229.2 137.7 219.4 32 96 32H96V160H80V32C53.5 32 32 60.7 32 96V160C8.8 160 0 170 0 184V224C0 238 8.8 248 32 248V264C8.8 264 0 274 0 288V328C0 342 8.8 352 32 352V416C32 451.3 53.5 480 80 480V352H96V480H96C219.4 480 229.2 374.3 376 344H169.6C175.7 340 181.4 334.6 186.3 328H472C515.8 328 559.7 319.2 592.6 303.8 622.3 289.8 640 272 640 256S622.3 222.2 592.6 208.2zM488 296A8-8 0 0 0 480 288V224A8-8 0 0 0 488 216C519.9 216 519.9 296 488 296z"}]}}),H.register({spinner:{width:512,height:512,paths:[{d:"M304 48C304 74.5 282.5 96 256 96S208 74.5 208 48 229.5 0 256 0 304 21.5 304 48zM256 416C229.5 416 208 437.5 208 464S229.5 512 256 512 304 490.5 304 464 282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256S437.5 304 464 304 512 282.5 512 256 490.5 208 464 208zM96 256C96 229.5 74.5 208 48 208S0 229.5 0 256 21.5 304 48 304 96 282.5 96 256zM108.9 355.1C82.4 355.1 60.9 376.6 60.9 403.1S82.4 451.1 108.9 451.1 156.9 429.6 156.9 403.1C156.9 376.6 135.4 355.1 108.9 355.1zM403.1 355.1C376.6 355.1 355.1 376.6 355.1 403.1S376.6 451.1 403.1 451.1 451.1 429.6 451.1 403.1C451.1 376.6 429.6 355.1 403.1 355.1zM108.9 60.9C82.4 60.9 60.9 82.4 60.9 108.9S82.4 156.9 108.9 156.9 156.9 135.4 156.9 108.9 135.4 60.9 108.9 60.9z"}]}}),H.register({"square-full":{width:512,height:512,paths:[{d:"M512 512H0V0H512V512z"}]}}),H.register({square:{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32z"}]}}),H.register({"star-half":{width:576,height:512,paths:[{d:"M288 0C276.6 0 265.2 5.9 259.3 17.8L194 150.2 47.9 171.4C21.7 175.2 11.2 207.5 30.2 226L135.9 329 110.9 474.5C106.4 500.6 133.9 520.5 157.3 508.2L288 439.6V0z"}]}}),H.register({star:{width:576,height:512,paths:[{d:"M259.3 17.8L194 150.2 47.9 171.5C21.7 175.3 11.2 207.6 30.2 226.1L135.9 329.1 110.9 474.6C106.4 500.9 134.1 520.6 157.3 508.3L288 439.6 418.7 508.3C441.9 520.5 469.6 500.9 465.1 474.6L440.1 329.1 545.8 226.1C564.8 207.6 554.3 175.3 528.1 171.5L382 150.2 316.7 17.8C305-5.8 271.1-6.1 259.3 17.8z"}]}}),H.register({"step-backward":{width:448,height:512,paths:[{d:"M64 468V44C64 37.4 69.4 32 76 32H124C130.6 32 136 37.4 136 44V220.4L331.5 39.4C352.1 22.3 384 36.6 384 64V448C384 475.4 352.1 489.7 331.5 472.6L136 292.7V468C136 474.6 130.6 480 124 480H76C69.4 480 64 474.6 64 468z"}]}}),H.register({"step-forward":{width:448,height:512,paths:[{d:"M384 44V468C384 474.6 378.6 480 372 480H324C317.4 480 312 474.6 312 468V291.6L116.5 472.6C95.9 489.7 64 475.4 64 448V64C64 36.6 95.9 22.3 116.5 39.4L312 219.3V44C312 37.4 317.4 32 324 32H372C378.6 32 384 37.4 384 44z"}]}}),H.register({stethoscope:{width:512,height:512,paths:[{d:"M447.1 112C412.9 112.5 384.8 140.4 384.1 174.6 383.6 198.9 396.6 220.2 416.1 231.4V344C416.1 401.3 365.9 448 304.1 448 244.1 448 194.9 403.9 192.2 348.8 265 333.8 320 269.2 320 192V36.6C320 25.2 311.9 15.3 300.7 13.1L237.8 0.5C224.8-2.1 212.2 6.3 209.6 19.3L206.4 35C203.8 48 212.2 60.6 225.2 63.2L255.9 69.3V190.7C255.9 243.6 213.7 287.4 160.8 287.9 107.4 288.4 63.9 245.2 63.9 191.9V69.4L94.6 63.3C107.6 60.7 116 48.1 113.4 35.1L110.3 19.4C107.7 6.4 95.1-2 82.1 0.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192C0 269.3 55.1 334 128.1 348.8 130.7 439.2 208.6 512 304 512 401 512 480 436.6 480 344V231.4C499.1 220.3 512 199.7 512 176 512 140.3 482.8 111.5 447.1 112zM448 192C439.2 192 432 184.8 432 176S439.2 160 448 160 464 167.2 464 176 456.8 192 448 192z"}]}}),H.register({"sticky-note":{width:448,height:512,paths:[{d:"M312 320H448V56C448 42.7 437.3 32 424 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H288V344C288 330.8 298.8 320 312 320zM441 375L343 473C338.5 477.5 332.4 480 326 480H320V352H448V358.1C448 364.4 445.5 370.5 441 375z"}]}}),H.register({"stop-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM352 336C352 344.8 344.8 352 336 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H336C344.8 160 352 167.2 352 176V336z"}]}}),H.register({stop:{width:448,height:512,paths:[{d:"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32z"}]}}),H.register({stopwatch:{width:448,height:512,paths:[{d:"M432 304C432 418.9 338.9 512 224 512S16 418.9 16 304C16 200 92.3 113.8 192 98.5V64H164C157.4 64 152 58.6 152 52V12C152 5.4 157.4 0 164 0H284C290.6 0 296 5.4 296 12V52C296 58.6 290.6 64 284 64H256V98.5C293.5 104.3 327.7 120.1 355.7 143.1L383.2 115.6C387.9 110.9 395.5 110.9 400.2 115.6L428.5 143.9C433.2 148.6 433.2 156.2 428.5 160.9L399.1 190.3 398.5 190.9C419.7 223.3 432 262.2 432 304zM256 340V188.5C256 181.9 250.6 176.5 244 176.5H204C197.4 176.5 192 181.9 192 188.5V340C192 346.6 197.4 352 204 352H244C250.6 352 256 346.6 256 340z"}]}}),H.register({"street-view":{width:512,height:512,paths:[{d:"M192 64C192 28.7 220.7 0 256 0S320 28.7 320 64C320 99.3 291.3 128 256 128S192 99.3 192 64zM304 144H292.6C269.9 154.4 243.1 154.9 219.4 144H208C181.5 144 160 165.5 160 192V296C160 309.3 170.7 320 184 320H200V424C200 437.3 210.7 448 224 448H288C301.3 448 312 437.3 312 424V320H328C341.3 320 352 309.3 352 296V192C352 165.5 330.5 144 304 144zM389.6 333.2A72.5-72.5 0 0 0 360.6 360.2C391.1 365.3 480 385.9 480 416 480 462.3 312.3 480 256 480 185.7 480 32 459.1 32 416 32 385.9 120.4 365.3 151.4 360.2A72.5-72.5 0 0 0 122.4 333.2C75 343.4 0 367.6 0 416 0 493.1 178.7 512 256 512 333.2 512 512 493.1 512 416 512 367.6 437 343.4 389.6 333.2z"}]}}),H.register({strikethrough:{width:512,height:512,paths:[{d:"M496 288H16C7.2 288 0 280.8 0 272V240C0 231.2 7.2 224 16 224H496C504.8 224 512 231.2 512 240V272C512 280.8 504.8 288 496 288zM281.3 304C308.6 316.9 327.9 332.7 327.9 360.2 327.9 393.4 298.9 413.9 252.2 413.9 219.9 413.9 175.4 401.8 175.4 369.6V368C175.4 359.2 168.2 352 159.4 352H113.8C104.9 352 97.8 359.2 97.8 368V387.2C97.8 454 175.5 489 252.2 489 340.8 489 414.3 443.6 414.3 354.6 414.3 334.8 410.6 318.2 404.1 304H281.3zM250.4 208C218 194.5 193.5 179.1 193.5 148.3 193.5 114.4 224.4 100.9 258.5 100.9 301.2 100.9 323.5 117.5 323.5 133.9V136C323.5 144.8 330.6 152 339.5 152H385.1C393.9 152 401.1 144.8 401.1 136V105.7C401.1 53.2 329.4 25.8 258.5 25.8 173.3 25.8 107.8 66.8 107.8 151.5 107.8 174.2 112.4 192.6 120.6 208H250.4z"}]}}),H.register({subscript:{width:512,height:512,paths:[{d:"M395.2 416C398.7 405.5 414 394.7 431.5 383.6 448.1 373 466.9 360.9 481.8 344.7 499.3 325.7 507.7 304.5 507.7 280.1 507.7 219.6 457 192 409.9 192 367.4 192 333.6 214 315.5 242.4 310.9 249.8 312.9 259.5 320.1 264.3L350.5 284.6C357.5 289.3 366.9 287.7 372.1 281 380.1 270.6 390.9 262.8 403.8 262.8 423.1 262.8 430 275.7 430 286.7 430 322.9 310.6 343.7 310.6 446.7 310.6 453.4 311.1 459.8 312 466.1 313.1 474 319.8 480 327.9 480H496C504.8 480 512 472.8 512 464V432C512 423.2 504.8 416 496 416H395.2zM272 256C280.8 256 288 263.2 288 272V304C288 312.8 280.8 320 272 320H209.6A16-16 0 0 0 196.1 312.5L150.4 239.9C148.1 236.6 145.9 232.9 144.2 229.7 142.5 232.9 140.5 236.6 138.3 240.3L93.6 312.4A16-16 0 0 0 80 320H16C7.2 320 0 312.8 0 304V272C0 263.2 7.2 256 16 256H42.3L98.9 173.3 46.1 96H16C7.2 96 0 88.8 0 80V48C0 39.2 7.2 32 16 32H84.8A16-16 0 0 0 98.5 39.6L138.3 104.8C140.4 108.3 142.4 111.9 144.1 115.1 145.8 111.9 148 108.2 150.3 104.6L190.6 39.6A16-16 0 0 0 204.2 32H272C280.8 32 288 39.2 288 48V80C288 88.8 280.8 96 272 96H244L191.3 171.7 250 256H272z"}]}}),H.register({subway:{width:448,height:512,paths:[{d:"M448 96V352C448 403.8 386.4 448 318 448L381 497.7C386.9 502.4 383.6 512 376 512H72C64.4 512 61.1 502.4 67 497.7L130 448C61.8 448 0 404 0 352V96C0 43 64 0 128 0H320C385 0 448 43 448 96zM200 232V120C200 106.7 189.3 96 176 96H72C58.7 96 48 106.7 48 120V232C48 245.3 58.7 256 72 256H176C189.3 256 200 245.3 200 232zM400 232V120C400 106.7 389.3 96 376 96H272C258.7 96 248 106.7 248 120V232C248 245.3 258.7 256 272 256H376C389.3 256 400 245.3 400 232zM352 288C325.5 288 304 309.5 304 336S325.5 384 352 384 400 362.5 400 336 378.5 288 352 288zM96 288C69.5 288 48 309.5 48 336S69.5 384 96 384 144 362.5 144 336 122.5 288 96 288z"}]}}),H.register({suitcase:{width:512,height:512,paths:[{d:"M128 480H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V480zM192 96H320V128H192V96zM512 176V432C512 458.5 490.5 480 464 480H416V128H464C490.5 128 512 149.5 512 176zM96 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H96V480z"}]}}),H.register({sun:{width:512,height:512,paths:[{d:"M274.8 12.6L300.4 75C304.6 85.3 317 89.4 326.5 83.5L383.8 48.1C399.3 38.5 418.6 52.5 414.3 70.2L398.2 135.7C395.6 146.5 403.3 157.1 414.4 157.9L481.6 162.9C499.8 164.2 507.2 186.9 493.3 198.7L441.8 242.3C433.3 249.4 433.3 262.5 441.8 269.7L493.3 313.3C507.2 325.1 499.8 347.8 481.6 349.1L414.4 354.1C403.3 354.9 395.6 365.5 398.2 376.3L414.3 441.8C418.6 459.5 399.3 473.5 383.8 463.9L326.5 428.5C317 422.6 304.6 426.7 300.4 437L274.8 499.4C267.9 516.2 244.1 516.2 237.2 499.4L211.7 437C207.4 426.7 195 422.6 185.5 428.5L128.2 463.9C112.7 473.5 93.4 459.5 97.7 441.8L113.8 376.3C116.4 365.5 108.7 354.9 97.6 354.1L30.4 349.1C12.2 347.8 4.8 325.1 18.7 313.3L70.2 269.7C78.7 262.6 78.7 249.5 70.2 242.3L18.7 198.7C4.8 186.9 12.2 164.2 30.4 162.9L97.6 157.9C108.7 157.1 116.4 146.5 113.8 135.7L97.7 70.2C93.4 52.5 112.7 38.5 128.2 48.1L185.5 83.5C195 89.4 207.4 85.3 211.6 75L237.2 12.6C244.1-4.2 267.9-4.2 274.8 12.6zM392 256C392 181 331 120 256 120 181 120 120 181 120 256S181 392 256 392C331 392 392 331 392 256zM360 256C360 313.3 313.3 360 256 360S152 313.3 152 256 198.7 152 256 152 360 198.7 360 256z"}]}}),H.register({superscript:{width:512,height:512,paths:[{d:"M395.2 256C398.7 245.5 414 234.7 431.5 223.6 448.1 213 466.9 200.9 481.8 184.7 499.3 165.7 507.7 144.5 507.7 120.1 507.7 59.6 457 32 409.9 32 367.4 32 333.6 54 315.5 82.4 310.9 89.8 312.9 99.5 320.1 104.3L350.5 124.6C357.5 129.3 366.9 127.7 372.1 121 380.1 110.6 390.9 102.8 403.8 102.8 423.1 102.8 430 115.7 430 126.7 430 162.9 310.6 183.7 310.6 286.7 310.6 293.4 311.1 299.8 312 306.1 313.1 314 319.8 320 327.9 320H496C504.8 320 512 312.8 512 304V272C512 263.2 504.8 256 496 256H395.2zM272 416C280.8 416 288 423.2 288 432V464C288 472.8 280.8 480 272 480H209.6A16-16 0 0 0 196.1 472.5L150.4 399.9C148.1 396.6 145.9 392.9 144.2 389.7 142.5 392.9 140.5 396.6 138.3 400.3L93.6 472.4A16-16 0 0 0 80 480H16C7.2 480 0 472.8 0 464V432C0 423.2 7.2 416 16 416H42.3L98.9 333.3 46.1 256H16C7.2 256 0 248.8 0 240V208C0 199.2 7.2 192 16 192H84.8A16-16 0 0 0 98.5 199.6L138.3 264.8C140.4 268.3 142.4 271.9 144.1 275.1 145.8 271.9 148 268.2 150.3 264.6L190.6 199.6A16-16 0 0 0 204.2 192H272C280.8 192 288 199.2 288 208V240C288 248.8 280.8 256 272 256H244L191.3 331.7 250 416H272z"}]}}),H.register({"sync-alt":{width:512,height:512,paths:[{d:"M370.7 133.3C339.5 104 298.9 88 255.8 88 178.4 88.1 111.5 141.2 93.1 214.8 91.7 220.2 86.9 224 81.4 224H24.1C16.6 224 10.9 217.2 12.3 209.8 33.9 94.9 134.8 8 256 8 322.4 8 382.8 34.1 427.3 76.7L463 41C478.1 25.9 504 36.6 504 57.9V192C504 205.3 493.3 216 480 216H345.9C324.6 216 313.9 190.1 329 175L370.7 133.3zM32 296H166.1C187.4 296 198.1 321.9 183 337L141.3 378.7C172.5 408 213.1 424 256.2 424 333.6 423.9 400.5 370.9 418.9 297.2 420.3 291.8 425.1 288 430.6 288H487.9C495.4 288 501.1 294.8 499.7 302.2 478.1 417.1 377.2 504 256 504 189.6 504 129.2 477.9 84.7 435.3L49 471C33.9 486.1 8 475.4 8 454.1V320C8 306.7 18.7 296 32 296z"}]}}),H.register({sync:{width:512,height:512,paths:[{d:"M440.9 12.6L444.9 95.3C399.4 41.9 331.7 8 256 8 134.8 8 33.9 94.9 12.3 209.8 10.9 217.2 16.6 224 24.1 224H73.2C78.8 224 83.6 220.2 84.9 214.7 103.4 137.4 172.9 80 256 80 316.9 80 370.5 110.9 402.1 157.8L300.6 152.9C293.7 152.6 288 158.1 288 164.9V212.3C288 219 293.4 224.3 300 224.3H500.3C507 224.3 512.3 219 512.3 212.3V12C512.3 5.4 507 0 500.3 0H452.9C446.1 0 440.6 5.7 440.9 12.6zM256 432C195.1 432 141.5 401.1 109.9 354.2L211.8 359.1C218.6 359.4 224.3 353.9 224.3 347.1V299.7C224.3 293 219 287.7 212.3 287.7H12C5.4 287.7 0 293 0 299.7V500C0 506.6 5.4 512 12 512H59.4C66.2 512 71.7 506.3 71.4 499.4L67.2 416.8C112.7 470.2 180.4 504 256 504 377.2 504 478.1 417.1 499.7 302.2 501.1 294.8 495.4 288 487.9 288H438.8C433.2 288 428.4 291.8 427.1 297.3 408.6 374.6 339.1 432 256 432z"}]}}),H.register({syringe:{width:512,height:512,paths:[{d:"M201.5 174.8L257.2 230.6C260.3 233.7 260.3 238.8 257.2 241.9L245.9 253.2C242.8 256.3 237.7 256.3 234.6 253.2L178.9 197.4 133.6 242.7 189.4 298.5C192.5 301.6 192.5 306.7 189.4 309.8L178.1 321.1C175 324.2 169.9 324.2 166.8 321.1L111 265.2 84.6 291.6C67.3 308.9 59 332.7 61.6 357L68.7 420.6 2.3 487C-0.8 490.1-0.8 495.2 2.3 498.3L13.6 509.6C16.7 512.7 21.8 512.7 24.9 509.6L91.2 443.3 154.8 450.4C178.7 453 202.7 445 220.2 427.4L402.1 245.5 266.4 109.8 201.5 174.8zM509.7 81.5L430.5 2.3C427.4-0.8 422.3-0.8 419.2 2.3L407.9 13.6C404.8 16.7 404.8 21.8 407.9 24.9L436.2 53.2 390.9 98.5 334.3 41.9 317.3 24.9C314.2 21.8 309.1 21.8 306 24.9L272.1 58.8C269 61.9 269 67 272.1 70.1L289.1 87.1 424.8 223 441.8 240C444.9 243.1 450 243.1 453.1 240L487 206C490.1 202.9 490.1 197.8 487 194.7L413.5 121.2 458.8 75.9 487.1 104.2C490.2 107.3 495.3 107.3 498.4 104.2L509.7 92.9C512.8 89.7 512.8 84.7 509.7 81.5z"}]}}),H.register({"table-tennis":{width:512,height:512,paths:[{d:"M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1L89.1 119.2 300.6 330.7C346.7 268.6 432.1 253.3 496.2 296.5zM278.3 376.2L57.9 155.9C30.6 201.2 36.2 260.9 75.2 300L109.7 334.6 6.7 424C-1.9 431.5-2.4 444.7 5.7 452.8L59.1 506.3C67.1 514.4 80.3 513.9 87.8 505.3L177.1 402 212.8 437.7C232.5 457.4 257.4 468.2 283.1 471 276 454 272.1 435.4 272.1 415.9 272 402.1 274.6 388.9 278.3 376.2zM416 320C363 320 320 363 320 416S363 512 416 512 512 469 512 416 469 320 416 320z"}]}}),H.register({table:{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM224 416H64V320H224V416zM224 256H64V160H224V256zM448 416H288V320H448V416zM448 256H288V160H448V256z"}]}}),H.register({"tablet-alt":{width:448,height:512,paths:[{d:"M400 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V48C448 21.5 426.5 0 400 0zM224 480C206.3 480 192 465.7 192 448S206.3 416 224 416 256 430.3 256 448 241.7 480 224 480zM400 372C400 378.6 394.6 384 388 384H60C53.4 384 48 378.6 48 372V60C48 53.4 53.4 48 60 48H388C394.6 48 400 53.4 400 60V372z"}]}}),H.register({tablet:{width:448,height:512,paths:[{d:"M400 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V48C448 21.5 426.5 0 400 0zM224 480C206.3 480 192 465.7 192 448S206.3 416 224 416 256 430.3 256 448 241.7 480 224 480z"}]}}),H.register({tablets:{width:640,height:512,paths:[{d:"M160 192C78.9 192 12.5 250.5 0.1 326.7-0.7 331.5 3.4 336 8.4 336H311.7C316.7 336 320.8 331.5 320 326.7 307.5 250.5 241.1 192 160 192zM311.6 368H8.4C3.4 368-0.7 372.5 0.1 377.3 12.5 453.5 78.9 512 160 512S307.5 453.5 319.9 377.3C320.7 372.5 316.6 368 311.6 368zM593.4 46.6C536.9-9.9 449.2-14.8 386.5 30.6 382.5 33.5 382.2 39.5 385.7 42.9L597 254.3C600.5 257.8 606.5 257.5 609.3 253.5 654.8 190.8 649.9 103.1 593.4 46.6zM363 65.7C359.5 62.2 353.5 62.5 350.7 66.5 305.3 129.2 310.2 216.9 366.6 273.4 423.1 329.9 510.8 334.8 573.5 289.3 577.5 286.4 577.8 280.4 574.3 277L363 65.7z"}]}}),H.register({"tachometer-alt":{width:576,height:512,paths:[{d:"M75.7 480A48-48 0 0 0 33.2 454.4C12 414.3 0 368.6 0 320 0 160.9 128.9 32 288 32S576 160.9 576 320C576 368.6 564 414.3 542.8 454.4A48-48 0 0 0 500.3 480H75.7zM512 288C494.3 288 480 302.3 480 320 480 337.7 494.3 352 512 352S544 337.7 544 320C544 302.3 529.7 288 512 288zM288 128C305.7 128 320 113.7 320 96 320 78.3 305.7 64 288 64S256 78.3 256 96C256 113.7 270.3 128 288 128zM64 288C46.3 288 32 302.3 32 320 32 337.7 46.3 352 64 352S96 337.7 96 320C96 302.3 81.7 288 64 288zM129.6 129.6C111.9 129.6 97.6 143.9 97.6 161.6 97.6 179.3 111.9 193.6 129.6 193.6S161.6 179.3 161.6 161.6C161.6 143.9 147.3 129.6 129.6 129.6zM446.4 129.6C428.7 129.6 414.4 143.9 414.4 161.6 414.4 179.3 428.7 193.6 446.4 193.6S478.4 179.3 478.4 161.6C478.4 143.9 464.1 129.6 446.4 129.6zM359.3 161.1C346.7 157.1 333.2 164.1 329.1 176.7L283.2 320.2C250.1 322.6 224 350.3 224 384 224 419.3 252.7 448 288 448 323.3 448 352 419.3 352 384 352 364.2 343 346.6 328.9 334.8L374.9 191.3C378.9 178.7 371.9 165.2 359.3 161.1z"}]}}),H.register({tag:{width:512,height:512,paths:[{d:"M0 252.1V48C0 21.5 21.5 0 48 0H252.1A48-48 0 0 0 286.1 14.1L497.9 225.9C516.7 244.7 516.7 275.1 497.9 293.8L293.8 497.9C275.1 516.7 244.7 516.7 225.9 497.9L14.1 286.1A48-48 0 0 0 0 252.1zM112 64C85.5 64 64 85.5 64 112S85.5 160 112 160 160 138.5 160 112 138.5 64 112 64z"}]}}),H.register({tags:{width:640,height:512,paths:[{d:"M497.9 225.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V252.1A48-48 0 0 1 14.1 286.1L225.9 497.9C244.7 516.7 275.1 516.7 293.8 497.9L497.9 293.8C516.7 275.1 516.7 244.7 497.9 225.9zM112 160C85.5 160 64 138.5 64 112S85.5 64 112 64 160 85.5 160 112 138.5 160 112 160zM625.9 293.8L421.8 497.9C403.1 516.7 372.7 516.7 353.9 497.9L353.6 497.6 527.6 323.5C544.6 306.5 554 283.9 554 259.9S544.6 213.2 527.6 196.2L331.4 0H380.1A48-48 0 0 0 414.1 14.1L625.9 225.9C644.7 244.7 644.7 275.1 625.9 293.8z"}]}}),H.register({tape:{width:640,height:512,paths:[{d:"M224 192C188.7 192 160 220.7 160 256S188.7 320 224 320 288 291.3 288 256 259.3 192 224 192zM624 416H380.6C422.1 375.3 448 318.7 448 256 448 132.3 347.7 32 224 32S0 132.3 0 256 100.3 480 224 480H624C632.8 480 640 472.8 640 464V432C640 423.2 632.8 416 624 416zM224 352C171 352 128 309 128 256S171 160 224 160 320 203 320 256 277 352 224 352z"}]}}),H.register({tasks:{width:512,height:512,paths:[{d:"M208 132H496C504.8 132 512 124.8 512 116V76C512 67.2 504.8 60 496 60H208C199.2 60 192 67.2 192 76V116C192 124.8 199.2 132 208 132zM208 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H208C199.2 220 192 227.2 192 236V276C192 284.8 199.2 292 208 292zM208 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H208C199.2 380 192 387.2 192 396V436C192 444.8 199.2 452 208 452zM64 368C37.5 368 15.4 389.5 15.4 416S37.5 464 64 464 112 442.5 112 416 90.5 368 64 368zM156.5 69L84.3 141.2 68.7 156.8C64 161.5 55.8 161.5 51.1 156.8L3.5 109.4C-1.2 104.7-1.2 97.1 3.5 92.4L19.2 76.7C23.9 72 31.5 72 36.2 76.7L58.9 98.8 122.6 35.5C127.3 30.8 134.9 30.8 139.6 35.5L156.6 52C161.2 56.7 161.2 64.3 156.5 69zM156.5 228.6L84.3 300.8 68.6 316.5C63.9 321.2 55.7 321.2 51 316.5L3.5 269C-1.2 264.3-1.2 256.7 3.5 252L19.2 236.3C23.9 231.6 31.5 231.6 36.2 236.3L58.9 258.4 122.6 194.7C127.3 190 134.9 190 139.6 194.7L156.6 211.7C161.2 216.3 161.2 223.9 156.5 228.6z"}]}}),H.register({taxi:{width:512,height:512,paths:[{d:"M462 243.9L440.1 156.6A79.9-79.9 0 0 1 362.5 96H352V56C352 42.7 341.3 32 328 32H184C170.7 32 160 42.7 160 56V96H149.5A79.9-79.9 0 0 1 71.9 156.6L50 243.9C25.5 252.8 8 276.4 8 304V352C8 372.2 17.4 390.2 32 401.9V456C32 469.3 42.7 480 56 480H104C117.3 480 128 469.3 128 456V416H384V456C384 469.3 394.7 480 408 480H456C469.3 480 480 469.3 480 456V401.9C494.6 390.2 504 372.2 504 352V304C504 276.4 486.5 252.8 462 243.9zM149.5 160H362.5A16-16 0 0 0 378 172.1L395 240H117L134 172.1A16-16 0 0 0 149.5 160zM132 336C132 355.9 115.9 372 96 372S60 355.9 60 336 76.1 300 96 300 132 316.1 132 336zM452 336C452 355.9 435.9 372 416 372S380 355.9 380 336 396.1 300 416 300 452 316.1 452 336z"}]}}),H.register({terminal:{width:640,height:512,paths:[{d:"M258 273L63.6 467.3C54.3 476.7 39.1 476.7 29.7 467.3L7 444.6C-2.3 435.3-2.3 420.1 7 410.7L161 256 7 101.3C-2.3 91.9-2.3 76.7 7 67.4L29.7 44.7C39.1 35.3 54.3 35.3 63.6 44.7L258 239C267.4 248.4 267.4 263.6 258 273zM640 456V424C640 410.7 629.3 400 616 400H312C298.7 400 288 410.7 288 424V456C288 469.3 298.7 480 312 480H616C629.3 480 640 469.3 640 456z"}]}}),H.register({"text-height":{width:576,height:512,paths:[{d:"M16 32H304C312.8 32 320 39.2 320 48V144C320 152.8 312.8 160 304 160H268.5C259.7 160 252.5 152.8 252.5 144V96H197.7V416H232C240.8 416 248 423.2 248 432V464C248 472.8 240.8 480 232 480H88C79.2 480 72 472.8 72 464V432C72 423.2 79.2 416 88 416H122.3V96H67.5V144C67.5 152.8 60.3 160 51.5 160H16C7.2 160 0 152.8 0 144V48C0 39.2 7.2 32 16 32zM491.3 36.7L571.3 116.7C581.3 126.7 574.3 144 560 144H512V368H560C575.6 368 580.6 386 571.3 395.3L491.3 475.3C485.1 481.6 474.9 481.6 468.7 475.3L388.7 395.3C378.7 385.3 385.7 368 400 368H448V144H400C384.4 144 379.4 126 388.7 116.7L468.7 36.7C474.9 30.4 485.1 30.4 491.3 36.7z"}]}}),H.register({"text-width":{width:448,height:512,paths:[{d:"M16 32H432C440.8 32 448 39.2 448 48V144C448 152.8 440.8 160 432 160H396.5C387.7 160 380.5 152.8 380.5 144V96H261.7V224H296C304.8 224 312 231.2 312 240V272C312 280.8 304.8 288 296 288H152C143.2 288 136 280.8 136 272V240C136 231.2 143.2 224 152 224H186.3V96H67.5V144C67.5 152.8 60.3 160 51.5 160H16C7.2 160 0 152.8 0 144V48C0 39.2 7.2 32 16 32zM443.3 372.7L363.3 292.7C354 283.4 336 288.4 336 304V352H112V304C112 289.7 94.7 282.7 84.7 292.7L4.7 372.7C-1.6 378.9-1.6 389.1 4.7 395.3L84.7 475.3C94 484.6 112 479.6 112 464V416H336V464C336 478.3 353.3 485.3 363.3 475.3L443.3 395.3C449.6 389.1 449.6 378.9 443.3 372.7z"}]}}),H.register({"th-large":{width:512,height:512,paths:[{d:"M296 32H488C501.3 32 512 42.7 512 56V216C512 229.3 501.3 240 488 240H296C282.7 240 272 229.3 272 216V56C272 42.7 282.7 32 296 32zM216 32H24C10.7 32 0 42.7 0 56V216C0 229.3 10.7 240 24 240H216C229.3 240 240 229.3 240 216V56C240 42.7 229.3 32 216 32zM0 296V456C0 469.3 10.7 480 24 480H216C229.3 480 240 469.3 240 456V296C240 282.7 229.3 272 216 272H24C10.7 272 0 282.7 0 296zM296 480H488C501.3 480 512 469.3 512 456V296C512 282.7 501.3 272 488 272H296C282.7 272 272 282.7 272 296V456C272 469.3 282.7 480 296 480z"}]}}),H.register({"th-list":{width:512,height:512,paths:[{d:"M149.3 216V296C149.3 309.3 138.6 320 125.3 320H24C10.7 320 0 309.3 0 296V216C0 202.7 10.7 192 24 192H125.3C138.6 192 149.3 202.7 149.3 216zM0 376V456C0 469.3 10.7 480 24 480H125.3C138.6 480 149.3 469.3 149.3 456V376C149.3 362.7 138.6 352 125.3 352H24C10.7 352 0 362.7 0 376zM125.3 32H24C10.7 32 0 42.7 0 56V136C0 149.3 10.7 160 24 160H125.3C138.6 160 149.3 149.3 149.3 136V56C149.3 42.7 138.6 32 125.3 32zM205.3 480H488C501.3 480 512 469.3 512 456V376C512 362.7 501.3 352 488 352H205.3C192.1 352 181.3 362.7 181.3 376V456C181.3 469.3 192.1 480 205.3 480zM181.3 56V136C181.3 149.3 192.1 160 205.3 160H488C501.3 160 512 149.3 512 136V56C512 42.7 501.3 32 488 32H205.3C192.1 32 181.3 42.7 181.3 56zM205.3 320H488C501.3 320 512 309.3 512 296V216C512 202.7 501.3 192 488 192H205.3C192.1 192 181.3 202.7 181.3 216V296C181.3 309.3 192.1 320 205.3 320z"}]}}),H.register({th:{width:512,height:512,paths:[{d:"M149.3 56V136C149.3 149.3 138.6 160 125.3 160H24C10.7 160 0 149.3 0 136V56C0 42.7 10.7 32 24 32H125.3C138.6 32 149.3 42.7 149.3 56zM330.7 296V216C330.7 202.7 319.9 192 306.7 192H205.3C192.1 192 181.3 202.7 181.3 216V296C181.3 309.3 192.1 320 205.3 320H306.7C319.9 320 330.7 309.3 330.7 296zM362.7 56V136C362.7 149.3 373.4 160 386.7 160H488C501.3 160 512 149.3 512 136V56C512 42.7 501.3 32 488 32H386.7C373.4 32 362.7 42.7 362.7 56zM330.7 136V56C330.7 42.7 319.9 32 306.7 32H205.3C192.1 32 181.3 42.7 181.3 56V136C181.3 149.3 192.1 160 205.3 160H306.7C319.9 160 330.7 149.3 330.7 136zM125.3 192H24C10.7 192 0 202.7 0 216V296C0 309.3 10.7 320 24 320H125.3C138.6 320 149.3 309.3 149.3 296V216C149.3 202.7 138.6 192 125.3 192zM0 376V456C0 469.3 10.7 480 24 480H125.3C138.6 480 149.3 469.3 149.3 456V376C149.3 362.7 138.6 352 125.3 352H24C10.7 352 0 362.7 0 376zM386.7 320H488C501.3 320 512 309.3 512 296V216C512 202.7 501.3 192 488 192H386.7C373.4 192 362.7 202.7 362.7 216V296C362.7 309.3 373.4 320 386.7 320zM386.7 480H488C501.3 480 512 469.3 512 456V376C512 362.7 501.3 352 488 352H386.7C373.4 352 362.7 362.7 362.7 376V456C362.7 469.3 373.4 480 386.7 480zM181.3 376V456C181.3 469.3 192.1 480 205.3 480H306.7C319.9 480 330.7 469.3 330.7 456V376C330.7 362.7 319.9 352 306.7 352H205.3C192.1 352 181.3 362.7 181.3 376z"}]}}),H.register({"thermometer-empty":{width:256,height:512,paths:[{d:"M192 384C192 419.3 163.3 448 128 448S64 419.3 64 384C64 348.7 92.7 320 128 320S192 348.7 192 384zM224 299.3C243.9 321.9 256 351.5 256 384 256 454.7 198.7 512 128 512 127.7 512 127.4 512 127.1 512 56.8 511.5-0.4 453.6 0 383.3 0.2 351.1 12.2 321.8 32 299.3V96C32 43 75 0 128 0S224 43 224 96V299.3zM208 384C208 349.7 188.6 331.8 176 317.5V96C176 69.5 154.5 48 128 48S80 69.5 80 96V317.5C67.3 331.9 48.2 349.6 48 383.6 47.8 427.5 83.6 463.7 127.4 464L128 464C172.1 464 208 428.1 208 384z"}]}}),H.register({"thermometer-full":{width:256,height:512,paths:[{d:"M224 96C224 43 181 0 128 0S32 43 32 96V299.3C12.2 321.8 0.2 351.1 0 383.3-0.4 453.6 56.8 511.5 127.1 512 127.4 512 127.7 512 128 512 198.7 512 256 454.7 256 384 256 351.5 243.9 321.9 224 299.3V96zM128 464L127.4 464C83.6 463.7 47.8 427.5 48 383.6 48.2 349.6 67.3 331.9 80 317.5V96C80 69.5 101.5 48 128 48S176 69.5 176 96V317.5C188.6 331.8 208 349.7 208 384 208 428.1 172.1 464 128 464zM192 384C192 419.3 163.3 448 128 448S64 419.3 64 384C64 360.3 76.9 339.7 96 328.6V96C96 78.3 110.3 64 128 64S160 78.3 160 96V328.6C179.1 339.7 192 360.3 192 384z"}]}}),H.register({"thermometer-half":{width:256,height:512,paths:[{d:"M192 384C192 419.3 163.3 448 128 448S64 419.3 64 384C64 360.3 76.9 339.7 96 328.6V224C96 206.3 110.3 192 128 192S160 206.3 160 224V328.6C179.1 339.7 192 360.3 192 384zM224 299.3C243.9 321.9 256 351.5 256 384 256 454.7 198.7 512 128 512 127.7 512 127.4 512 127.1 512 56.8 511.5-0.4 453.6 0 383.3 0.2 351.1 12.2 321.8 32 299.3V96C32 43 75 0 128 0S224 43 224 96V299.3zM208 384C208 349.7 188.6 331.8 176 317.5V96C176 69.5 154.5 48 128 48S80 69.5 80 96V317.5C67.3 331.9 48.2 349.6 48 383.6 47.8 427.5 83.6 463.7 127.4 464L128 464C172.1 464 208 428.1 208 384z"}]}}),H.register({"thermometer-quarter":{width:256,height:512,paths:[{d:"M192 384C192 419.3 163.3 448 128 448S64 419.3 64 384C64 360.3 76.9 339.7 96 328.6V288C96 270.3 110.3 256 128 256S160 270.3 160 288V328.6C179.1 339.7 192 360.3 192 384zM224 299.3C243.9 321.9 256 351.5 256 384 256 454.7 198.7 512 128 512 127.7 512 127.4 512 127.1 512 56.8 511.5-0.4 453.6 0 383.3 0.2 351.1 12.2 321.8 32 299.3V96C32 43 75 0 128 0S224 43 224 96V299.3zM208 384C208 349.7 188.6 331.8 176 317.5V96C176 69.5 154.5 48 128 48S80 69.5 80 96V317.5C67.3 331.9 48.2 349.6 48 383.6 47.8 427.5 83.6 463.7 127.4 464L128 464C172.1 464 208 428.1 208 384z"}]}}),H.register({"thermometer-three-quarters":{width:256,height:512,paths:[{d:"M192 384C192 419.3 163.3 448 128 448 92.7 448 64 419.3 64 384 64 360.3 76.9 339.7 96 328.6V160C96 142.3 110.3 128 128 128S160 142.3 160 160V328.6C179.1 339.7 192 360.3 192 384zM224 299.3C243.9 321.9 256 351.5 256 384 256 454.7 198.7 512 128 512 127.7 512 127.4 512 127.1 512 56.8 511.5-0.4 453.6 0 383.3 0.2 351.1 12.2 321.8 32 299.3V96C32 43 75 0 128 0S224 43 224 96V299.3zM208 384C208 349.7 188.6 331.8 176 317.5V96C176 69.5 154.5 48 128 48S80 69.5 80 96V317.5C67.3 331.9 48.2 349.6 48 383.6 47.8 427.5 83.6 463.7 127.4 464L128 464C172.1 464 208 428.1 208 384z"}]}}),H.register({thermometer:{width:512,height:512,paths:[{d:"M476.8 20.4C439.3-10.3 381.3-5.9 344.9 30.6L299.2 76.6 349.7 127.1C352.8 130.2 352.8 135.3 349.7 138.4L338.4 149.7C335.3 152.8 330.2 152.8 327.1 149.7L276.7 99.2 231.6 144.6 281.9 195C285 198.1 285 203.2 281.9 206.3L270.6 217.6C267.5 220.7 262.4 220.7 259.3 217.6L209 167.4 163.9 212.8 214 263C217.1 266.1 217.1 271.2 214 274.3L202.7 285.6C199.6 288.7 194.5 288.7 191.4 285.6L141.3 235.4 96 281.1V382L7 471C-2.4 480.4-2.4 495.6 7 504.9 16.4 514.3 31.6 514.3 40.9 504.9L129.9 415.9H229.8L484 162.6C518.9 127.7 526.2 61.1 476.8 20.4z"}]}}),H.register({"thumbs-down":{width:512,height:512,paths:[{d:"M0 56V296C0 309.3 10.7 320 24 320H104C117.3 320 128 309.3 128 296V56C128 42.7 117.3 32 104 32H24C10.7 32 0 42.7 0 56zM40 256C40 242.7 50.7 232 64 232S88 242.7 88 256 77.3 280 64 280 40 269.3 40 256zM312 512C291.8 512 282.5 472.7 278.1 454.2 272.9 432.5 267.5 410.1 252.7 395.3 220.2 362.8 203.2 321.3 163.6 282.2A12-12 0 0 0 160 273.7V59.9C160 53.4 165.2 48 171.8 47.9 187.6 47.6 208.5 38.8 224.4 31.7 256.2 17.6 295.7 0 344 0H346.8C389.6 0 440.2 0.4 460.6 29.7 469 41.8 471.1 56.8 466.8 74.4 483.1 91.4 491.8 123.2 483.1 149.1 500.7 172.6 502.3 205.3 492.5 228.6L492.6 228.7C504.5 240.7 512.1 260 512 277.9 511.8 308.3 485.8 336 452.4 336H350.7C358 364.3 384 388.1 384 430.5 384 504 336 512 312 512z"}]}}),H.register({"thumbs-up":{width:512,height:512,paths:[{d:"M104 224H24C10.7 224 0 234.7 0 248V488C0 501.3 10.7 512 24 512H104C117.3 512 128 501.3 128 488V248C128 234.7 117.3 224 104 224zM64 472C50.7 472 40 461.3 40 448S50.7 424 64 424 88 434.7 88 448 77.3 472 64 472zM384 81.5C384 123.9 358 147.7 350.7 176H452.4C485.8 176 511.8 203.7 512 234.1 512.1 252 504.5 271.3 492.6 283.3L492.4 283.4C502.3 306.7 500.7 339.4 483.1 362.9 491.8 388.8 483.1 420.6 466.8 437.6 471.1 455.2 469 470.2 460.6 482.3 440.2 511.6 389.6 512 346.8 512L344 512C295.7 512 256.2 494.4 224.4 480.3 208.5 473.2 187.6 464.4 171.8 464.1 165.2 464 160 458.6 160 452.1V238.3C160 235.1 161.3 232.1 163.6 229.8 203.2 190.7 220.2 149.2 252.7 116.7 267.5 101.9 272.9 79.5 278.1 57.8 282.5 39.3 291.8 0 312 0 336 0 384 8 384 81.5z"}]}}),H.register({thumbtack:{width:384,height:512,paths:[{d:"M298 214.3L285.8 96H328C341.3 96 352 85.3 352 72V24C352 10.7 341.3 0 328 0H56C42.7 0 32 10.7 32 24V72C32 85.3 42.7 96 56 96H98.2L86 214.3C37.5 236.8 0 277.3 0 328 0 341.3 10.7 352 24 352H160V456C160 457.2 160.3 458.5 160.8 459.6L184.8 507.6C187.8 513.5 196.2 513.5 199.2 507.6L223.2 459.6A8-8 0 0 1 224 456V352H360C373.3 352 384 341.3 384 328 384 276.8 346 236.6 298 214.3z"}]}}),H.register({"ticket-alt":{width:576,height:512,paths:[{d:"M128 160H448V352H128V160zM528 256C528 282.5 549.5 304 576 304V400C576 426.5 554.5 448 528 448H48C21.5 448 0 426.5 0 400V304C26.5 304 48 282.5 48 256S26.5 208 0 208V112C0 85.5 21.5 64 48 64H528C554.5 64 576 85.5 576 112V208C549.5 208 528 229.5 528 256zM480 152C480 138.7 469.3 128 456 128H120C106.7 128 96 138.7 96 152V360C96 373.3 106.7 384 120 384H456C469.3 384 480 373.3 480 360V152z"}]}}),H.register({"times-circle":{width:512,height:512,paths:[{d:"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM377.6 321.1C382.3 325.8 382.3 333.4 377.6 338.1L338 377.6C333.3 382.3 325.7 382.3 321 377.6L256 312 190.9 377.6C186.2 382.3 178.6 382.3 173.9 377.6L134.4 338C129.7 333.3 129.7 325.7 134.4 321L200 256 134.4 190.9C129.7 186.2 129.7 178.6 134.4 173.9L174 134.3C178.7 129.6 186.3 129.6 191 134.3L256 200 321.1 134.4C325.8 129.7 333.4 129.7 338.1 134.4L377.7 174C382.4 178.7 382.4 186.3 377.7 191L312 256 377.6 321.1z"}]}}),H.register({times:{width:384,height:512,paths:[{d:"M323.1 441L377 387.1C386.4 377.7 386.4 362.6 377 353.2L279.8 256 377 158.8C386.4 149.4 386.4 134.3 377 124.9L323.1 71C313.7 61.6 298.6 61.6 289.2 71L192 168.2 94.8 71C85.4 61.6 70.3 61.6 60.9 71L7 124.9C-2.4 134.3-2.4 149.4 7 158.8L104.2 256 7 353.2C-2.4 362.6-2.4 377.7 7 387.1L60.9 441C70.3 450.4 85.4 450.4 94.8 441L192 343.8 289.2 441C298.5 450.3 313.7 450.3 323.1 441z"}]}}),H.register({tint:{width:384,height:512,paths:[{d:"M192 512C93.6 512 13.9 432.3 13.9 333.9 13.9 222.7 115.1 179.8 162.4 22.1 171.5-8 213.5-6.7 221.6 22.1 269.1 180.6 370.1 222.2 370.1 333.9 370.1 432.3 290.4 512 192 512zM149.5 340.2C148 334.6 140 334.6 138.5 340.2 129.3 369.6 110.6 377.8 110.6 398.6 110.6 417.1 125.5 432 144 432S177.4 417.1 177.4 398.6C177.4 377.8 158.7 369.7 149.5 340.2z"}]}}),H.register({"toggle-off":{width:576,height:512,paths:[{d:"M384 64H192C86 64 0 150 0 256S86 448 192 448H384C490 448 576 362 576 256S490 64 384 64zM64 256C64 185.3 121.2 128 192 128 262.7 128 320 185.2 320 256 320 326.7 262.8 384 192 384 121.3 384 64 326.8 64 256zM384 384H335.1C400.3 311.1 400.3 200.9 335.1 128H384C454.7 128 512 185.2 512 256 512 326.7 454.8 384 384 384z"}]}}),H.register({"toggle-on":{width:576,height:512,paths:[{d:"M576 256C576 362 490 448 384 448H192C86 448 0 362 0 256S86 64 192 64H384C490 64 576 150 576 256zM384 128C313.3 128 256 185.2 256 256 256 326.7 313.2 384 384 384 454.7 384 512 326.8 512 256 512 185.3 454.8 128 384 128"}]}}),H.register({trademark:{width:640,height:512,paths:[{d:"M97.1 163.1H12C5.4 163.1 0 157.8 0 151.1V108C0 101.4 5.4 96 12 96H260.6C267.2 96 272.6 101.4 272.6 108V151.1C272.6 157.8 267.2 163.1 260.6 163.1H175.4V404C175.4 410.6 170.1 416 163.4 416H109.1C102.5 416 97.1 410.6 97.1 404V163.1zM329.8 96H395.3A12-12 0 0 0 406.6 104.1L450.4 231.2C457.5 251.7 466.5 284 466.5 284H467.4S476.3 251.7 483.5 231.2L527.2 104.1A12-12 0 0 0 538.6 96H604A12-12 0 0 0 615.9 107L640 403C640.5 410 635 416 628 416H573.9A12-12 0 0 0 561.9 404.8L552.8 271.9C551.1 247.7 552.8 218.2 552.8 218.2H551.9S541.2 251.7 534 271.9L503.3 356.6A12-12 0 0 0 492.1 364.5H441.8A12-12 0 0 0 430.5 356.6L399.8 271.9C392.6 251.7 381.9 218.2 381.9 218.2H381S382.8 247.7 381 271.9L371.9 404.8C371.5 411.1 366.2 416 359.9 416H305.4C298.4 416 292.9 410 293.4 403L317.9 107A12-12 0 0 0 329.8 96z"}]}}),H.register({train:{width:448,height:512,paths:[{d:"M448 96V352C448 403.8 386.4 448 318 448L381 497.7C386.9 502.4 383.6 512 376 512H72C64.4 512 61.1 502.4 67 497.7L130 448C61.8 448 0 404 0 352V96C0 43 64 0 128 0H320C385 0 448 43 448 96zM400 232V120C400 106.7 389.3 96 376 96H72C58.7 96 48 106.7 48 120V232C48 245.3 58.7 256 72 256H376C389.3 256 400 245.3 400 232zM224 296C193.1 296 168 321.1 168 352S193.1 408 224 408 280 382.9 280 352 254.9 296 224 296z"}]}}),H.register({"transgender-alt":{width:480,height:512,paths:[{d:"M468 0H389C378.3 0 373 12.9 380.5 20.5L397.4 37.4 316.7 118.1C294.5 104.1 268.2 96 240 96 211.8 96 185.5 104.1 163.3 118.1L146.8 101.6 166.6 81.8C171.3 77.1 171.3 69.5 166.6 64.8L138.3 36.5C133.6 31.8 126 31.8 121.3 36.5L101.5 56.3 82.5 37.3 99.4 20.4C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12V91C0 101.7 12.9 107 20.5 99.5L37.4 82.6 56.4 101.6 36.6 121.4C31.9 126.1 31.9 133.7 36.6 138.4L64.9 166.7C69.6 171.4 77.2 171.4 81.9 166.7L101.7 146.9 118.2 163.4C104.1 185.5 96 211.8 96 240 96 308.5 143.9 365.9 208 380.4V408H172C165.4 408 160 413.4 160 420V460C160 466.6 165.4 472 172 472H208V500C208 506.6 213.4 512 220 512H260C266.6 512 272 506.6 272 500V472H308C314.6 472 320 466.6 320 460V420C320 413.4 314.6 408 308 408H272V380.4C336.1 365.8 384 308.5 384 240 384 211.8 375.9 185.5 361.9 163.3L442.6 82.6 459.5 99.5C467.1 107.1 480 101.7 480 91V12C480 5.4 474.6 0 468 0zM240 320C195.9 320 160 284.1 160 240S195.9 160 240 160 320 195.9 320 240 284.1 320 240 320z"}]}}),H.register({transgender:{width:384,height:512,paths:[{d:"M372 0H293C282.3 0 277 12.9 284.5 20.5L301.4 37.4 220.7 118.1C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240 0 308.5 47.9 365.9 112 380.4V408H76C69.4 408 64 413.4 64 420V460C64 466.6 69.4 472 76 472H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V472H212C218.6 472 224 466.6 224 460V420C224 413.4 218.6 408 212 408H176V380.4C240.1 365.8 288 308.5 288 240 288 211.8 279.9 185.5 265.9 163.3L346.6 82.6 363.5 99.5C371.1 107.1 384 101.7 384 91V12C384 5.4 378.6 0 372 0zM144 320C99.9 320 64 284.1 64 240S99.9 160 144 160 224 195.9 224 240 188.1 320 144 320z"}]}}),H.register({"trash-alt":{width:448,height:512,paths:[{d:"M0 84V56C0 42.7 10.7 32 24 32H136L145.4 13.3C149.4 5.1 157.7 0 166.8 0H281.1C290.2 0 298.5 5.1 302.6 13.3L312 32H424C437.3 32 448 42.7 448 56V84C448 90.6 442.6 96 436 96H12C5.4 96 0 90.6 0 84zM416 140V464C416 490.5 394.5 512 368 512H80C53.5 512 32 490.5 32 464V140C32 133.4 37.4 128 44 128H404C410.6 128 416 133.4 416 140zM144 208C144 199.2 136.8 192 128 192S112 199.2 112 208V432C112 440.8 119.2 448 128 448S144 440.8 144 432V208zM240 208C240 199.2 232.8 192 224 192S208 199.2 208 208V432C208 440.8 215.2 448 224 448S240 440.8 240 432V208zM336 208C336 199.2 328.8 192 320 192S304 199.2 304 208V432C304 440.8 311.2 448 320 448S336 440.8 336 432V208z"}]}}),H.register({trash:{width:448,height:512,paths:[{d:"M0 84V56C0 42.7 10.7 32 24 32H136L145.4 13.3C149.4 5.1 157.7 0 166.8 0H281.1C290.2 0 298.5 5.1 302.6 13.3L312 32H424C437.3 32 448 42.7 448 56V84C448 90.6 442.6 96 436 96H12C5.4 96 0 90.6 0 84zM415.2 140.7L394.8 467C393.2 492.3 372.2 512 346.9 512H101.1C75.8 512 54.8 492.3 53.2 467L32.8 140.7C32.4 133.8 37.9 128 44.8 128H403.3C410.1 128 415.6 133.8 415.2 140.7z"}]}}),H.register({tree:{width:384,height:512,paths:[{d:"M377.3 375.4L293.9 288H328C349 288 359.9 262.8 345.4 247.5L262.8 160H296C316.9 160 327.9 135 313.6 119.7L209.6 7.7C200.1-2.5 183.9-2.6 174.4 7.7L70.4 119.7C56.2 135 67 160 88 160H121.2L38.6 247.5C24.1 262.8 35 288 56 288H90.1L6.7 375.4C-7.9 390.7 2.9 416 24 416H144C144 448.8 132.8 465.3 110 483.5 98.2 492.9 104.9 512 120 512H264C279.1 512 285.8 492.9 274 483.5 254.2 467.7 240 451.8 240 416V416H360C381 416 391.9 390.7 377.3 375.4z"}]}}),H.register({trophy:{width:576,height:512,paths:[{d:"M552 64H448V24C448 10.7 437.3 0 424 0H152C138.7 0 128 10.7 128 24V64H24C10.7 64 0 74.7 0 88V144C0 179.7 22.5 216.4 61.9 244.7 93.4 267.4 131.7 281.8 171.9 286.4 203.3 338.5 240 360 240 360V432H192C156.7 432 128 452.7 128 488V500C128 506.6 133.4 512 140 512H436C442.6 512 448 506.6 448 500V488C448 452.7 419.3 432 384 432H336V360S372.7 338.5 404.1 286.4C444.4 281.8 482.7 267.4 514.1 244.7 553.4 216.4 576 179.7 576 144V88C576 74.7 565.3 64 552 64zM99.3 192.8C74.9 175.2 64 155.6 64 144V128H128.2C129.2 160.6 134 189.2 141 214.2 125.9 209 111.8 201.8 99.3 192.8zM512 144C512 160.1 494.3 180.1 476.7 192.8 464.2 201.8 450 209 434.9 214.2 441.9 189.2 446.7 160.6 447.7 128H512V144z"}]}}),H.register({"truck-loading":{width:640,height:512,paths:[{d:"M50.2 375.6C52.5 384.1 61.3 389.2 69.8 386.9L286.2 328.9C294.7 326.6 299.8 317.8 297.5 309.3L247.8 123.8C245.5 115.3 236.7 110.2 228.2 112.5L151 133.3 175.8 226 114 242.5 89.2 149.8 11.9 170.5C3.4 172.8-1.7 181.6 0.6 190.1L50.2 375.6zM384 0C366.3 0 352 14.3 352 32V355.6L5.9 450C1.6 451.2-0.9 455.6 0.3 459.8L12.9 506.1C14.1 510.4 18.5 512.9 22.7 511.7L416.4 404.3C418.8 464.1 467.6 512 528 512 589.9 512 640 461.9 640 400V0H384zM528 448C501.5 448 480 426.5 480 400S501.5 352 528 352 576 373.5 576 400 554.5 448 528 448z"}]}}),H.register({"truck-moving":{width:640,height:512,paths:[{d:"M621.3 237.3L562.8 178.8C550.8 166.8 534.5 160.1 517.5 160.1H480V64C480 46.3 465.7 32 448 32H32C14.3 32 0 46.3 0 64V400C0 444.2 35.8 480 80 480 106.3 480 129.4 467.1 144 447.6 158.6 467.2 181.7 480 208 480 252.2 480 288 444.2 288 400 288 394.5 287.4 389.2 286.4 384H449.6C448.5 389.2 448 394.5 448 400 448 444.2 483.8 480 528 480S608 444.2 608 400C608 394.5 607.4 389.2 606.4 384H624C632.8 384 640 376.8 640 368V282.5C640 265.5 633.3 249.3 621.3 237.3zM80 432C62.4 432 48 417.6 48 400S62.4 368 80 368 112 382.4 112 400 97.6 432 80 432zM208 432C190.4 432 176 417.6 176 400S190.4 368 208 368 240 382.4 240 400 225.6 432 208 432zM480 208H517.5C521.8 208 525.8 209.7 528.8 212.7L572.1 256H480V208zM528 432C510.4 432 496 417.6 496 400S510.4 368 528 368 560 382.4 560 400 545.6 432 528 432z"}]}}),H.register({truck:{width:640,height:512,paths:[{d:"M624 352H608V243.9C608 231.2 602.9 219 593.9 210L494 110.1C485 101.1 472.8 96 460.1 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H64C64 469 107 512 160 512S256 469 256 416H384C384 469 427 512 480 512S576 469 576 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM160 464C133.5 464 112 442.5 112 416S133.5 368 160 368 208 389.5 208 416 186.5 464 160 464zM480 464C453.5 464 432 442.5 432 416S453.5 368 480 368 528 389.5 528 416 506.5 464 480 464zM560 256H416V144H460.1L560 243.9V256z"}]}}),H.register({tty:{width:512,height:512,paths:[{d:"M5.4 103.8C143.9-34.7 368.3-34.5 506.6 103.8 512.7 109.9 513.7 119.3 509.2 126.5L466 195.6A18.3-18.3 0 0 0 443.6 202.9L357.2 168.4A18.3-18.3 0 0 0 345.8 149.5L351.7 90C289.6 67.5 221.1 68 160.3 90L166.2 149.5A18.3-18.3 0 0 0 154.8 168.4L68.4 202.9A18.3-18.3 0 0 0 46 195.6L2.8 126.5A18.3-18.3 0 0 0 5.4 103.8zM96 308V268C96 261.4 90.6 256 84 256H44C37.4 256 32 261.4 32 268V308C32 314.6 37.4 320 44 320H84C90.6 320 96 314.6 96 308zM192 308V268C192 261.4 186.6 256 180 256H140C133.4 256 128 261.4 128 268V308C128 314.6 133.4 320 140 320H180C186.6 320 192 314.6 192 308zM288 308V268C288 261.4 282.6 256 276 256H236C229.4 256 224 261.4 224 268V308C224 314.6 229.4 320 236 320H276C282.6 320 288 314.6 288 308zM384 308V268C384 261.4 378.6 256 372 256H332C325.4 256 320 261.4 320 268V308C320 314.6 325.4 320 332 320H372C378.6 320 384 314.6 384 308zM480 308V268C480 261.4 474.6 256 468 256H428C421.4 256 416 261.4 416 268V308C416 314.6 421.4 320 428 320H468C474.6 320 480 314.6 480 308zM144 404V364C144 357.4 138.6 352 132 352H92C85.4 352 80 357.4 80 364V404C80 410.6 85.4 416 92 416H132C138.6 416 144 410.6 144 404zM240 404V364C240 357.4 234.6 352 228 352H188C181.4 352 176 357.4 176 364V404C176 410.6 181.4 416 188 416H228C234.6 416 240 410.6 240 404zM336 404V364C336 357.4 330.6 352 324 352H284C277.4 352 272 357.4 272 364V404C272 410.6 277.4 416 284 416H324C330.6 416 336 410.6 336 404zM432 404V364C432 357.4 426.6 352 420 352H380C373.4 352 368 357.4 368 364V404C368 410.6 373.4 416 380 416H420C426.6 416 432 410.6 432 404zM96 500V460C96 453.4 90.6 448 84 448H44C37.4 448 32 453.4 32 460V500C32 506.6 37.4 512 44 512H84C90.6 512 96 506.6 96 500zM384 500V460C384 453.4 378.6 448 372 448H140C133.4 448 128 453.4 128 460V500C128 506.6 133.4 512 140 512H372C378.6 512 384 506.6 384 500zM480 500V460C480 453.4 474.6 448 468 448H428C421.4 448 416 453.4 416 460V500C416 506.6 421.4 512 428 512H468C474.6 512 480 506.6 480 500z"}]}}),H.register({tv:{width:640,height:512,paths:[{d:"M592 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H293.1V448H133.1C115.4 448 101.1 462.3 101.1 480S115.4 512 133.1 512H517.1C534.8 512 549.1 497.7 549.1 480S534.8 448 517.1 448H357.1V416H592C618.5 416 640 394.5 640 368V48C640 21.5 618.5 0 592 0zM576 352H64V64H576V352z"}]}}),H.register({umbrella:{width:576,height:512,paths:[{d:"M557 267.6C505.6 222.4 449.4 223.9 398.4 298.4 393.1 306.2 383.5 305.5 378.7 298.4 376.2 294.7 346.5 237.6 288 237.6 242.2 237.6 217.5 268.9 197.3 298.4 192.5 305.5 182.9 306.2 177.6 298.4 126.7 224.1 70.9 222 19 267.6 8.8 275.9-1.9 266.5 0.3 258.1 32.1 134.6 158.5 64.6 288 64.6 416.8 64.6 544.5 134.6 575.7 258.1 577.9 266.5 567.3 275.9 557 267.6zM256 261V416C256 433.6 241.6 448 224 448S192 433.6 192 416C192 398.3 177.7 384 160 384S128 398.3 128 416C128 468.9 171.1 512 224 512S320 468.9 320 416V261.3C298.2 250.5 274.6 251.6 256 261zM320 50V32C320 14.3 305.7 0 288 0S256 14.3 256 32V50A372.1-372.1 0 0 0 320 50z"}]}}),H.register({underline:{width:448,height:512,paths:[{d:"M224.3 388.2C132.6 388.2 67.7 337.1 67.7 236.8V64H39.4C30.5 64 23.4 56.8 23.4 48V16C23.4 7.2 30.5 0 39.4 0H176.8C185.6 0 192.8 7.2 192.8 16V48C192.8 56.8 185.6 64 176.8 64H147.9V236.8C147.9 290.5 176.3 316.3 224.3 316.3 271.2 316.3 300.1 290.9 300.1 236.3V64H271.8C262.9 64 255.8 56.8 255.8 48V16C255.8 7.2 262.9 0 271.8 0H408.6C417.5 0 424.6 7.2 424.6 16V48C424.6 56.8 417.5 64 408.6 64H380.3V236.8C380.3 336.3 315.5 388.2 224.3 388.2zM16 448H432C440.8 448 448 455.2 448 464V496C448 504.8 440.8 512 432 512H16C7.2 512 0 504.8 0 496V464C0 455.2 7.2 448 16 448z"}]}}),H.register({"undo-alt":{width:512,height:512,paths:[{d:"M255.5 8C189.3 8.1 129.1 34.2 84.7 76.7L49 41C33.9 25.9 8 36.6 8 57.9V192C8 205.3 18.7 216 32 216H166.1C187.4 216 198.1 190.1 183 175L141.3 133.3C172.1 104.4 212.1 88.4 254.5 88 346.9 87.2 424.8 162 424 257.4 423.2 348 349.8 424 256 424 214.9 424 176 409.3 145.4 382.4 140.6 378.3 133.5 378.5 129 383L89.3 422.7C84.5 427.5 84.7 435.5 89.8 440.1 133.8 479.8 192.1 504 256 504 393 504 504 393 504 256 504 119.2 392.4 7.8 255.5 8z"}]}}),H.register({undo:{width:512,height:512,paths:[{d:"M212.3 224.3H12C5.4 224.3 0 219 0 212.3V12C0 5.4 5.4 0 12 0H60C66.6 0 72 5.4 72 12V90.1C117.8 39.3 184.3 7.5 258.2 8 395.1 9 504.6 119.6 504.3 256.5 504 393.3 393.1 504 256.3 504 192.2 504 133.8 479.7 89.8 439.8 84.7 435.2 84.5 427.2 89.4 422.4L123.3 388.4C127.8 383.9 135 383.7 139.7 387.9 170.8 415.3 211.6 432 256.3 432 353.6 432 432.3 353.3 432.3 256 432.3 158.7 353.6 80 256.3 80 197.8 80 146.1 108.5 114.1 152.3H212.3C219 152.3 224.3 157.7 224.3 164.3V212.3C224.3 219 219 224.3 212.3 224.3z"}]}}),H.register({"universal-access":{width:512,height:512,paths:[{d:"M256 48C371 48 464 141 464 256 464 371 371 464 256 464 141 464 48 371 48 256 48 141 141 48 256 48M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 64C150 64 64 150 64 256S150 448 256 448 448 362 448 256 362 64 256 64zM256 108C275.9 108 292 124.1 292 144S275.9 180 256 180 220 163.9 220 144 236.1 108 256 108zM373.7 206C345 212.8 318.2 218.8 291.6 221.8 292.5 322.9 303.9 344.9 316.6 377.5 320.3 386.7 315.7 397.1 306.4 400.8 297.2 404.4 286.7 399.8 283.1 390.5 274.4 368.2 266 349.9 260.8 312H251.2C246 349.9 237.6 368.2 228.9 390.5 225.3 399.8 214.8 404.4 205.6 400.8 196.3 397.1 191.7 386.7 195.4 377.5 208.1 344.9 219.5 322.9 220.4 221.8 193.8 218.8 167 212.8 138.3 206 129.7 204 124.3 195.4 126.4 186.8S137 172.8 145.6 174.9C242.3 197.7 269.9 197.7 366.4 174.9 375 172.8 383.6 178.2 385.6 186.8 387.7 195.4 382.3 204 373.7 206z"}]}}),H.register({university:{width:512,height:512,paths:[{d:"M496 128V144A8-8 0 0 0 488 152H464V164C464 170.6 458.6 176 452 176H60C53.4 176 48 170.6 48 164V152H24A8-8 0 0 0 16 144V128A8-8 0 0 0 20.9 120.6L252.9 32.6A8-8 0 0 0 259.1 32.6L491.1 120.6A8-8 0 0 0 496 128zM472 432H40C26.7 432 16 442.7 16 456V472A8-8 0 0 1 24 480H488A8-8 0 0 1 496 472V456C496 442.7 485.3 432 472 432zM96 192V384H60C53.4 384 48 389.4 48 396V416H464V396C464 389.4 458.6 384 452 384H416V192H352V384H288V192H224V384H160V192H96z"}]}}),H.register({unlink:{width:512,height:512,paths:[{d:"M304.1 405.9C308.8 410.6 308.8 418.2 304.1 422.9L259.4 467.6C200.1 526.8 103.7 526.8 44.4 467.6-14.8 408.3-14.8 311.9 44.4 252.6L89.1 207.9C93.8 203.2 101.4 203.2 106.1 207.9L145.7 247.5C150.4 252.2 150.4 259.8 145.7 264.5L101 309.2C72.9 337.2 72.9 382.9 101 411 129.1 439.1 174.8 439.1 202.8 411L247.5 366.3C252.2 361.6 259.8 361.6 264.5 366.3L304.1 405.9zM247.5 145.7C252.2 150.4 259.8 150.4 264.5 145.7L309.2 101C337.2 72.9 382.9 72.9 411 101 439.1 129.1 439.1 174.8 411 202.8L366.3 247.5C361.6 252.2 361.6 259.8 366.3 264.5L405.9 304.1C410.6 308.8 418.2 308.8 422.9 304.1L467.6 259.4C526.8 200.1 526.8 103.7 467.6 44.4 408.3-14.8 311.9-14.8 252.6 44.4L207.9 89.1C203.2 93.8 203.2 101.4 207.9 106.1L247.5 145.7zM482.3 505L505 482.3C514.3 473 514.3 457.8 505 448.4L63.6 7C54.2-2.3 39-2.3 29.7 7L7 29.7C-2.3 39-2.3 54.2 7 63.6L448.4 505C457.8 514.3 473 514.3 482.3 505z"}]}}),H.register({"unlock-alt":{width:448,height:512,paths:[{d:"M400 256H152V152.9C152 113.3 183.7 80.4 223.3 80 263.3 79.6 296 112.1 296 152V168C296 181.3 306.7 192 320 192H352C365.3 192 376 181.3 376 168V152C376 68 307.5-0.3 223.5 0 139.5 0.3 72 69.5 72 153.5V256H48C21.5 256 0 277.5 0 304V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V304C448 277.5 426.5 256 400 256zM264 408C264 430.1 246.1 448 224 448S184 430.1 184 408V360C184 337.9 201.9 320 224 320S264 337.9 264 360V408z"}]}}),H.register({unlock:{width:448,height:512,paths:[{d:"M400 256H152V152.9C152 113.3 183.7 80.4 223.3 80 263.3 79.6 296 112.1 296 152V168C296 181.3 306.7 192 320 192H352C365.3 192 376 181.3 376 168V152C376 68 307.5-0.3 223.5 0 139.5 0.3 72 69.5 72 153.5V256H48C21.5 256 0 277.5 0 304V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V304C448 277.5 426.5 256 400 256z"}]}}),H.register({upload:{width:512,height:512,paths:[{d:"M296 384H216C202.7 384 192 373.3 192 360V192H104.3C86.5 192 77.6 170.5 90.2 157.9L242.3 5.7C249.8-1.8 262.1-1.8 269.6 5.7L421.8 157.9C434.4 170.5 425.5 192 407.7 192H320V360C320 373.3 309.3 384 296 384zM512 376V488C512 501.3 501.3 512 488 512H24C10.7 512 0 501.3 0 488V376C0 362.7 10.7 352 24 352H160V360C160 390.9 185.1 416 216 416H296C326.9 416 352 390.9 352 360V352H488C501.3 352 512 362.7 512 376zM388 464C388 453 379 444 368 444S348 453 348 464 357 484 368 484 388 475 388 464zM452 464C452 453 443 444 432 444S412 453 412 464 421 484 432 484 452 475 452 464z"}]}}),H.register({"user-circle":{width:512,height:512,paths:[{d:"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM80.5 381.9C119.7 436.4 183.7 472 256 472S392.3 436.4 431.5 381.9C428.4 354.9 408.9 332.2 382 325.5L349.6 317.4C323.6 339.8 290.7 352 256 352S188.4 339.8 162.4 317.4L130 325.5C103.1 332.2 83.6 354.9 80.5 381.9zM144 208C144 269.9 194.1 320 256 320S368 269.9 368 208 317.9 96 256 96 144 146.1 144 208z"}]}}),H.register({"user-md":{width:448,height:512,paths:[{d:"M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM104 424C104 437.3 114.7 448 128 448S152 437.3 152 424 141.3 400 128 400 104 410.7 104 424zM354.4 272.4L320 266.7V321.7C356.5 329.1 384 361.5 384 400.1V456.1C384 463.7 378.6 470.3 371.1 471.8L338.9 478.2C334.6 479.1 330.4 476.3 329.5 471.9L326.4 456.2C325.5 451.9 328.3 447.6 332.7 446.8L352 442.9V400C352 370.4 325.1 347 294.4 352.9 271.6 357.3 256 378.7 256 401.9V442.9L275.3 446.8C279.6 447.7 282.4 451.9 281.6 456.2L278.5 471.9C277.6 476.2 273.4 479 269.1 478.2L237.9 474C230 472.9 224.1 466.2 224.1 458.1V400.1C224.1 361.5 251.6 329.2 288.1 321.7V274.5C268.5 283.1 246.9 288.1 224.1 288.1 194.8 288.1 167.7 279.6 144.1 265.8V370.7C167.2 377.6 184.1 398.8 184.1 424.1 184.1 455 159 480.1 128.1 480.1S72.1 455 72.1 424.1C72.1 398.8 89 377.6 112.1 370.7V269.3L93.7 272.4C39.7 281.4 0.1 328.1 0.1 382.9V480C0.1 497.7 14.4 512 32.1 512H416.1C433.8 512 448.1 497.7 448.1 480V382.9C448 328.1 408.4 281.4 354.4 272.4z"}]}}),H.register({"user-plus":{width:640,height:512,paths:[{d:"M224 32C301.3 32 364 94.7 364 172S301.3 312 224 312 84 249.3 84 172 146.7 32 224 32zM384.4 324.1L322 308.5C256.4 355.6 177 345.1 126 308.5L63.6 324.1C26.2 333.4 0 367 0 405.6V438C0 461.2 18.8 480 42 480H406C429.2 480 448 461.2 448 438V405.6C448 367 421.8 333.4 384.4 324.1zM628 224.9H559.1V156C559.1 149.4 553.7 144 547.1 144H508.9C502.3 144 496.9 149.4 496.9 156L496.9 224.9 428 224.9C421.4 224.9 416 230.3 416 236.9V275.1C416 281.7 421.4 287.1 428 287.1L496.9 287.1 496.9 356C496.9 362.6 502.3 368 508.9 368H547.1C553.7 368 559.1 362.6 559.1 356L559.1 287.1 628 287.1C634.6 287.1 640 281.7 640 275.1V236.9C640 230.3 634.6 224.9 628 224.9z"}]}}),H.register({"user-secret":{width:448,height:512,paths:[{d:"M388.8 295.3L409.8 240.3C412.8 232.4 407 224 398.6 224H340.4C347.8 207.8 352 189.7 352 170.7 352 167 351.8 163.4 351.5 159.9 391.1 152.1 416 140.7 416 128 416 114.7 388.8 102.9 346.1 95.1 336.9 62.3 318.9 29.3 305.3 12.2 295.9 0.3 279.5-3.4 265.9 3.4L238.3 17.2A32-32 0 0 0 209.7 17.2L182.1 3.4C168.5-3.4 152.1 0.3 142.7 12.2 129.1 29.3 111.1 62.3 101.9 95.1 59.2 102.9 32 114.7 32 128 32 140.7 56.9 152.1 96.5 159.9A129.4-129.4 0 0 1 96 170.7C96 189.7 100.2 207.8 107.6 224H50.2C41.6 224 35.8 232.8 39.2 240.7L62.1 294.2C25.8 307.9 0 342.9 0 384V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V384C448 344 423.6 309.8 388.8 295.3zM184 488L136 296 184 320 208 360 184 488zM264 488L240 360 264 320 312 296 264 488zM318.8 184.3C318.8 184.3 314.5 187.5 313.7 190 309.8 201.9 306.6 214.6 297.1 223.4 287.1 232.7 249.2 245.8 233.1 198.4 230.3 190 217.7 190 214.9 198.4 197.9 248.5 158.8 230.8 150.9 223.4 141.4 214.6 138.2 201.9 134.3 190 133.5 187.5 129.2 184.3 129.2 184.3 128.7 181.3 128.2 178.4 128 175.4 127.7 171.6 138.1 171.7 139.1 171.7 165.4 169.3 191.4 171.1 217.1 177.2 219.7 177.8 228.7 177.7 230.9 177.2 256.6 171.1 282.6 169.3 308.9 171.7 309.9 171.7 320.3 171.6 320 175.4 319.8 178.4 319.3 181.3 318.8 184.3z"}]}}),H.register({"user-times":{width:640,height:512,paths:[{d:"M224 32C301.3 32 364 94.7 364 172S301.3 312 224 312 84 249.3 84 172 146.7 32 224 32zM384.4 324.1L322 308.5C256.4 355.6 177 345.1 126 308.5L63.6 324.1C26.2 333.4 0 367 0 405.6V438C0 461.2 18.8 480 42 480H406C429.2 480 448 461.2 448 438V405.6C448 367 421.8 333.4 384.4 324.1zM587.9 256L636.5 207.4C641.2 202.7 641.2 195.1 636.5 190.5L609.5 163.5C604.9 158.8 597.3 158.8 592.6 163.5L544 212.1 495.4 163.5C490.7 158.8 483.1 158.8 478.5 163.5L451.5 190.5C446.8 195.1 446.8 202.7 451.5 207.4L500.1 256 451.5 304.6C446.8 309.3 446.8 316.9 451.5 321.5L478.5 348.5C483.1 353.2 490.7 353.2 495.4 348.5L544 299.9 592.6 348.5C597.3 353.2 604.9 353.2 609.5 348.5L636.5 321.5C641.2 316.9 641.2 309.3 636.5 304.6L587.9 256z"}]}}),H.register({user:{width:512,height:512,paths:[{d:"M256 0C344.4 0 416 71.6 416 160S344.4 320 256 320 96 248.4 96 160 167.6 0 256 0zM439.3 333.8L368 316C293 369.9 202.2 357.9 144 316L72.7 333.8C30 344.5 0 382.9 0 427V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V427C512 382.9 482 344.5 439.3 333.8z"}]}}),H.register({users:{width:640,height:512,paths:[{d:"M320 64C378 64 425 111 425 169S378 274 320 274 215 227 215 169 262 64 320 64zM433.5 281.4L393.5 271.4C344.3 306.7 284.7 298.8 246.5 271.4L206.5 281.4C174.5 289.4 152 318.2 152 351.2V412C152 431.9 168.1 448 188 448H452C471.9 448 488 431.9 488 412V351.2C488 318.2 465.5 289.4 433.5 281.4zM528 300C566.7 300 598 268.7 598 230S566.7 160 528 160 458 191.3 458 230 489.3 300 528 300zM112 300C150.7 300 182 268.7 182 230S150.7 160 112 160 42 191.3 42 230 73.3 300 112 300zM136 412V351.2C136 334.7 140.6 319 148.7 305.6 118.7 320.3 85.4 314.3 63 298.2L36.4 304.9C15 310.3 0 329.5 0 351.5V392C0 405.3 10.7 416 24 416H136.2A52.4-52.4 0 0 0 136 412zM603.6 304.9L577 298.2C549.1 318.3 516.1 317.5 491.2 305.5 499.4 318.9 504 334.6 504 351.2V412C504 413.3 503.9 414.7 503.8 416H616C629.3 416 640 405.3 640 392V351.5C640 329.5 625 310.3 603.6 304.9z"}]}}),H.register({"utensil-spoon":{width:512,height:512,paths:[{d:"M480.1 31.9C425.1-23.2 315.2-2.6 252.3 60.4 203 109.7 197.2 170.4 223.5 220.8L9 413.2C-2.6 423.7-3.1 441.7 8 452.7L59.3 504C70.3 515 88.4 514.5 98.8 502.9L291.2 288.5C341.6 314.8 402.3 309 451.6 259.7 514.6 196.8 535.2 86.9 480.1 31.9z"}]}}),H.register({utensils:{width:416,height:512,paths:[{d:"M207.9 15.2C208.7 19.9 224 109.7 224 144 224 196.3 196.2 233.6 155.1 248.6L168 486.7C168.7 500.4 157.8 512 144 512H80C66.3 512 55.3 500.5 56 486.7L68.9 248.6C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3V157.5C65.3 160.9 79.1 160.7 80 157.5 81.4 132.2 87.9 18.3 88 15.7 91.3-5.1 132.7-5.1 135.9 15.7 136.1 18.4 142.5 132.2 143.9 157.5 144.8 160.7 158.7 160.9 159.9 157.5V16.3C162.5-5.3 204.7-5.1 207.9 15.2zM327.1 300.9L312.1 486C310.9 500 322 512 336 512H392C405.3 512 416 501.3 416 488V24C416 10.8 405.3 0 392 0 309.5 0 170.6 178.5 327.1 300.9z"}]}}),H.register({"venus-double":{width:512,height:512,paths:[{d:"M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V368H76C69.4 368 64 373.4 64 380V420C64 426.6 69.4 432 76 432H112V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V432H212C218.6 432 224 426.6 224 420V380C224 373.4 218.6 368 212 368H176V316.4C240.1 301.9 288 244.5 288 176zM64 176C64 131.9 99.9 96 144 96S224 131.9 224 176 188.1 256 144 256 64 220.1 64 176zM400 316.4V368H436C442.6 368 448 373.4 448 380V420C448 426.6 442.6 432 436 432H400V468C400 474.6 394.6 480 388 480H348C341.4 480 336 474.6 336 468V432H300C293.4 432 288 426.6 288 420V380C288 373.4 293.4 368 300 368H336V316.4C314.8 311.6 295.4 302.1 278.8 289.1 292.8 272.4 303.8 253.1 310.9 232 325.4 246.8 345.6 256 368 256 412.1 256 448 220.1 448 176S412.1 96 368 96C345.7 96 325.4 105.2 310.9 120 303.8 98.9 292.9 79.6 278.8 62.9 303.4 43.6 334.3 32 368 32 447.5 32 512 96.5 512 176 512 244.5 464.1 301.9 400 316.4z"}]}}),H.register({"venus-mars":{width:576,height:512,paths:[{d:"M564 0H485C474.3 0 469 12.9 476.5 20.5L493.4 37.4 444.7 86.1C422.5 72.1 396.2 64 368 64 334.3 64 303.4 75.6 278.8 94.9 292.8 111.6 303.8 130.9 310.9 152 325.4 137.2 345.6 128 368 128 412.1 128 448 163.9 448 208S412.1 288 368 288C345.7 288 325.4 278.8 310.9 264 303.8 285.1 292.9 304.4 278.8 321.1 303.3 340.5 334.3 352 368 352 447.5 352 512 287.5 512 208 512 179.8 503.9 153.5 489.9 131.3L538.6 82.6 555.5 99.5C557.9 101.9 560.9 103 563.9 103 570.1 103 576 98.2 576 91V12C576 5.4 570.6 0 564 0zM144 64C64.5 64 0 128.5 0 208 0 276.5 47.9 333.9 112 348.4V400H76C69.4 400 64 405.4 64 412V452C64 458.6 69.4 464 76 464H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V464H212C218.6 464 224 458.6 224 452V412C224 405.4 218.6 400 212 400H176V348.4C240.1 333.8 288 276.5 288 208 288 128.5 223.5 64 144 64zM144 288C99.9 288 64 252.1 64 208S99.9 128 144 128 224 163.9 224 208 188.1 288 144 288z"}]}}),H.register({venus:{width:288,height:512,paths:[{d:"M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V368H76C69.4 368 64 373.4 64 380V420C64 426.6 69.4 432 76 432H112V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V432H212C218.6 432 224 426.6 224 420V380C224 373.4 218.6 368 212 368H176V316.4C240.1 301.9 288 244.5 288 176zM64 176C64 131.9 99.9 96 144 96S224 131.9 224 176 188.1 256 144 256 64 220.1 64 176z"}]}}),H.register({vial:{width:480,height:512,paths:[{d:"M477.7 186.1L309.5 18.3C306.4 15.2 301.3 15.2 298.2 18.3L264.2 52.2C261.1 55.3 261.1 60.4 264.2 63.5L275.4 74.6 33 316.5C-5.8 355.2-12.1 418.5 23.6 460 44.2 484 73.1 496 102 495.9 128.4 495.9 154.8 485.9 174.9 465.8L421.2 220.1 432.4 231.2C435.5 234.3 440.6 234.3 443.7 231.2L477.7 197.3C480.8 194.3 480.8 189.2 477.7 186.1zM318 256H161L309 108.3 387.5 186.6 318 256z"}]}}),H.register({vials:{width:640,height:512,paths:[{d:"M72 64H96V304C96 348.1 131.9 384 176 384S256 348.1 256 304V64H280C284.4 64 288 60.4 288 56V8C288 3.6 284.4 0 280 0H72C67.6 0 64 3.6 64 8V56C64 60.4 67.6 64 72 64zM144 64H208V160H144V64zM624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM360 64H384V304C384 348.1 419.9 384 464 384S544 348.1 544 304V64H568C572.4 64 576 60.4 576 56V8C576 3.6 572.4 0 568 0H360C355.6 0 352 3.6 352 8V56C352 60.4 355.6 64 360 64zM432 64H496V160H432V64z"}]}}),H.register({"video-slash":{width:640,height:512,paths:[{d:"M633.8 458.1L578.8 415.6C594.2 414.2 608 401.9 608 384.5V127.5C608 102 578.9 87.1 557.6 101.7L448 177.3V314.5L416 289.8V111.8C416 85.4 394.6 64 368.2 64H123.9L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L42.7 82 416 370.6 594.5 508.6C601.5 514 611.5 512.8 617 505.8L636.6 480.5C642.1 473.6 640.8 463.5 633.8 458.1zM32 400.2C32 426.6 53.4 448 79.8 448H368.2C379.4 448 389.6 444 397.8 437.5L32 154.7V400.2z"}]}}),H.register({video:{width:576,height:512,paths:[{d:"M336.2 64H47.8C21.4 64 0 85.4 0 111.8V400.2C0 426.6 21.4 448 47.8 448H336.2C362.6 448 384 426.6 384 400.2V111.8C384 85.4 362.6 64 336.2 64zM525.6 101.7L416 177.3V334.7L525.6 410.2C546.8 424.8 576 409.9 576 384.4V127.5C576 102.1 546.9 87.1 525.6 101.7z"}]}}),H.register({"volleyball-ball":{width:495,height:512,paths:[{d:"M223.3 243.4C222.4 206.4 214.7 170.6 200.6 137.7 109.8 180.1 43.1 260.1 20.3 354.5 33.7 385.3 53.2 412.8 77.2 435.6 99.9 356.4 151.4 287.8 223.3 243.4zM186.4 109C171.4 82.6 151.9 58.9 129 38.3 38 88.1-15.8 191.2 4 300.5 37.4 217.4 102.4 148.5 186.4 109zM374 274.1C382.6 174.3 346.7 76.6 276.5 9.7 261.8 8 224.9 4.2 177.6 18.2 234.9 77.5 268.6 156.4 271.1 240.9 303.6 258.6 338.4 269.9 374 274.1zM249.3 283.6C217.7 302.9 190.6 327.5 169.1 356.2 251.1 413.5 353.6 431.3 446.6 404 466.3 377.6 480.8 347.2 488.8 314.1 462.2 320.7 435.1 324.5 407.9 324.5 353.3 324.4 299 310.4 249.3 283.6zM151 383.3C135.8 409.3 125.3 437.7 118.9 467.5 156.5 490.5 200.6 504 248 504 309 504 364.7 481.9 407.9 445.4 295 461.5 204.6 420.6 151 383.3zM331.3 22.7C386.6 93.1 413.8 183.9 405.9 276.3 436.2 276.5 466.4 271.5 495.6 262.1 495.6 260.1 495.9 258.1 495.9 256.1 495.9 148.3 427.2 57 331.3 22.7z"}]}}),H.register({"volume-down":{width:384,height:512,paths:[{d:"M256 88V424C256 445.4 230.1 456 215 441L126.1 352H24C10.7 352 0 341.3 0 328V184C0 170.7 10.7 160 24 160H126.1L215 71C230 56 256 66.6 256 88zM384 256C384 222.3 366.8 191.6 338 174.1 322.9 164.8 303.3 169.6 294 184.7S289.6 219.4 304.7 228.7C314.3 234.5 320 244.8 320 256A32.1-32.1 0 0 0 306.2 282.3C291.7 292.4 288.1 312.3 298.1 326.9 308.2 341.4 328.1 345 342.7 334.9 368.5 317 384 287.5 384 256z"}]}}),H.register({"volume-off":{width:256,height:512,paths:[{d:"M256 88V424C256 445.4 230.1 456 215 441L126.1 352H24C10.7 352 0 341.3 0 328V184C0 170.7 10.7 160 24 160H126.1L215 71C230 56 256 66.6 256 88z"}]}}),H.register({"volume-up":{width:576,height:512,paths:[{d:"M256 88V424C256 445.4 230.1 456 215 441L126.1 352H24C10.7 352 0 341.3 0 328V184C0 170.7 10.7 160 24 160H126.1L215 71C230 56 256 66.6 256 88zM438.1 10.1C423 0.9 403.3 5.7 394.1 20.7 384.8 35.8 389.6 55.5 404.7 64.7 469 104.1 512 175 512 256 512 329.4 475.9 398.3 415.5 440.2 401 450.3 397.4 470.2 407.4 484.7 417.5 499.3 437.5 502.9 452 492.8 529.6 438.9 576 350.4 576 256 576 152.8 521.4 61.1 438.1 10.1zM480 256C480 187.5 443.9 126.2 388 92.1 373 82.9 353.3 87.6 344 102.7 334.8 117.8 339.6 137.5 354.7 146.7 393.1 170.2 416 211 416 256 416 298 395.4 337.3 360.8 361.3 346.3 371.3 342.7 391.3 352.8 405.8 359 414.8 369 419.6 379.1 419.6A31.9-31.9 0 0 1 397.3 413.9C449.1 378 480 318.9 480 256zM384 256C384 222.3 366.8 191.6 338 174.1 322.9 164.8 303.3 169.6 294 184.7S289.6 219.4 304.7 228.7C314.3 234.5 320 244.8 320 256A32.1-32.1 0 0 0 306.2 282.3C291.7 292.4 288.1 312.3 298.1 326.9 308.2 341.4 328.1 345 342.7 334.9 368.5 317 384 287.5 384 256z"}]}}),H.register({warehouse:{width:640,height:512,paths:[{d:"M504 352H136.4C132 352 128.4 355.6 128.4 360L128.3 408C128.3 412.4 131.9 416 136.3 416H504C508.4 416 512 412.4 512 408V360C512 355.6 508.4 352 504 352zM504 448H136.1C131.7 448 128.1 451.6 128.1 456L128 504C128 508.4 131.6 512 136 512H504C508.4 512 512 508.4 512 504V456C512 451.6 508.4 448 504 448zM504 256H136.6C132.2 256 128.6 259.6 128.6 264L128.5 312C128.5 316.4 132.1 320 136.5 320H504C508.4 320 512 316.4 512 312V264C512 259.6 508.4 256 504 256zM610.5 117L338.4 3.7A48.1-48.1 0 0 1 301.5 3.7L29.5 117C11.7 124.5 0 141.9 0 161.3V504C0 508.4 3.6 512 8 512H88C92.4 512 96 508.4 96 504V256C96 238.4 110.6 224 128.6 224H511.4C529.4 224 544 238.4 544 256V504C544 508.4 547.6 512 552 512H632C636.4 512 640 508.4 640 504V161.3C640 141.9 628.3 124.5 610.5 117z"}]}}),H.register({weight:{width:512,height:512,paths:[{d:"M448 64H422C438.4 92.3 448 125 448 160 448 265.9 361.9 352 256 352S64 265.9 64 160C64 125 73.6 92.3 90 64H64C28.7 64 0 92.7 0 128V448C0 483.3 28.7 512 64 512H448C483.3 512 512 483.3 512 448V128C512 92.7 483.3 64 448 64zM256 320C344.4 320 416 248.4 416 160S344.4 0 256 0 96 71.6 96 160 167.6 320 256 320zM255.7 168.1L289.3 89.7C292.8 81.5 302.2 77.8 310.3 81.3S322.2 94.2 318.7 102.3L285 180.9C291.7 188 295.9 197.5 295.9 208 295.9 230.1 278 248 255.9 248S215.9 230.1 215.9 208C216 186 233.8 168.2 255.7 168.1z"}]}}),H.register({wheelchair:{width:512,height:512,paths:[{d:"M496.1 385.7L510.3 414.3C514.3 422.2 511 431.8 503.1 435.8L437.6 468.7C421.6 476.6 402.1 469.9 394.5 453.6L331.7 320H192C176.1 320 162.6 308.3 160.3 292.5 126.4 55.3 128.4 70 128 64 128 27.6 158.3-1.6 195.1 0.1 228.3 1.6 255.1 29 256 62.3 256.8 95.2 232.8 122.7 201.4 127.3L206 160H336C344.8 160 352 167.2 352 176V208C352 216.8 344.8 224 336 224H215.2L219.8 256H352A32-32 0 0 0 381 274.4L438.5 396.8 474.7 378.5C482.6 374.5 492.2 377.8 496.1 385.7zM311.4 352H286.9C279.1 406.2 232.3 448 176 448 114.2 448 64 397.8 64 336 64 294.5 86.7 258.2 120.3 238.8 116.6 212.9 113.5 191 110.8 172.5 46 198.5 0 262 0 336 0 433 79 512 176 512 247.9 512 309.8 468.7 337.1 406.8L311.4 352z"}]}}),H.register({wifi:{width:640,height:512,paths:[{d:"M384 416C384 451.3 355.3 480 320 480S256 451.3 256 416C256 380.7 284.7 352 320 352S384 380.7 384 416zM520.7 291.6C527.1 285.1 526.9 274.5 520.1 268.4 406.3 166.4 233.6 166.5 119.9 268.4 113.1 274.5 112.9 285.1 119.3 291.6L153.3 325.6C159.3 331.5 168.8 331.9 175.1 326.4 258 253.8 382.2 253.9 464.9 326.4 471.2 331.9 480.7 331.5 486.7 325.6L520.7 291.6zM632.8 177.8C639.2 171.5 639 161 632.4 154.9 456.7-9 183.3-8.9 7.6 154.9 1 161 0.8 171.5 7.2 177.8L41.2 211.8C47.3 217.9 57.1 218 63.4 212.2 208.2 78.5 431.8 78.5 576.6 212.2 582.9 218 592.7 217.9 598.8 211.8L632.8 177.8z"}]}}),H.register({"window-close":{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM380.4 322.5C385.2 327.3 385.2 335.1 380.4 339.9L339.9 380.4C335.1 385.2 327.3 385.2 322.5 380.4L256 313.3 189.5 380.4C184.7 385.2 176.9 385.2 172.1 380.4L131.6 339.9C126.8 335.1 126.8 327.3 131.6 322.5L198.7 256 131.6 189.5C126.8 184.7 126.8 176.9 131.6 172.1L172.1 131.6C176.9 126.8 184.7 126.8 189.5 131.6L256 198.7 322.5 131.6C327.3 126.8 335.1 126.8 339.9 131.6L380.4 172.1C385.2 176.9 385.2 184.7 380.4 189.5L313.3 256 380.4 322.5z"}]}}),H.register({"window-maximize":{width:512,height:512,paths:[{d:"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM448 192H64V108C64 101.4 69.4 96 76 96H436C442.6 96 448 101.4 448 108V192z"}]}}),H.register({"window-minimize":{width:512,height:512,paths:[{d:"M464 352H48C21.5 352 0 373.5 0 400V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V400C512 373.5 490.5 352 464 352z"}]}}),H.register({"window-restore":{width:512,height:512,paths:[{d:"M512 48V336C512 362.5 490.5 384 464 384H416V176C416 131.9 380.1 96 336 96H128V48C128 21.5 149.5 0 176 0H464C490.5 0 512 21.5 512 48zM384 176V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V176C0 149.5 21.5 128 48 128H336C362.5 128 384 149.5 384 176zM316 204C316 197.4 310.6 192 304 192H76C69.4 192 64 197.4 64 204V256H316V204z"}]}}),H.register({"wine-glass":{width:288,height:512,paths:[{d:"M287.4 192.7L271.4 14.6C270.7 6.3 263.9 0 255.7 0H32.3C24.1 0 17.3 6.3 16.6 14.6L0.6 192.7C-6.6 272.7 51.3 341.6 128 350.3V480H74.1C49.6 480 40.9 512 54.1 512H233.9C247 512 238.4 480 213.9 480H160V350.3C236.7 341.5 294.6 272.7 287.4 192.7zM226.2 48L233.4 128H54.6L61.8 48H226.2z"}]}}),H.register({"won-sign":{width:576,height:512,paths:[{d:"M564 192C570.6 192 576 186.6 576 180V140C576 133.4 570.6 128 564 128H516L534.5 47.4C536.3 39.9 530.6 32.7 522.9 32.7H476.7A12-12 0 0 1 465 42.2L450.7 128H340.8L321.1 42A12-12 0 0 1 309.4 32.7H265.4A12-12 0 0 1 253.7 42L233.7 128H125L107.5 42.3A12-12 0 0 1 95.7 32.7H53.6C45.9 32.7 40.2 39.8 41.9 47.3L60 128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H74.3L81.5 224H12C5.4 224 0 229.4 0 236V276C0 282.6 5.4 288 12 288H95.9L136.8 470.6A12-12 0 0 1 148.5 480H205.3C210.8 480 215.7 476.1 216.9 470.7L259.3 288H314.4L356.8 470.7A12-12 0 0 1 368.5 480H425.3A12-12 0 0 1 437 470.7L479.1 288H564C570.6 288 576 282.6 576 276V236C576 229.4 570.6 224 564 224H493.9L501.2 192H564zM138 192H218.8L211.3 224H144.5L138 192zM183.8 342C177.6 367.9 177.1 389.3 176.5 389.3H175.4S173.7 367.2 168.6 342L157.6 288H196.4L183.8 342zM274.2 224L276.2 215.4C278 207.4 279.6 199.4 281 192H292.8C294.1 199.4 295.7 207.4 297.6 215.4L299.6 224H274.2zM405.1 342C400.1 367.2 398.4 389.3 398.4 389.3H397.3C396.7 389.3 396.1 367.9 389.9 342L377.5 288H416.6L405.1 342zM430.3 224H362.9L355.5 192H437.1L430.3 224z"}]}}),H.register({wrench:{width:512,height:512,paths:[{d:"M481.2 200C490.5 200 496.3 210.2 491.5 218.1 466.3 260 420.4 288 368 288 288.8 288 224.5 224 224 144.9 223.5 65.5 288.5 0 368 0 420.4 0 466.2 27.9 491.4 69.7 496.2 77.8 490.5 88 481.2 88H376L336 144 376 200H481.2zM309.5 293L109.3 493.3C84.3 518.2 43.7 518.2 18.7 493.3-6.2 468.3-6.2 427.7 18.7 402.7L219 202.5C235.2 243.7 268.3 276.8 309.5 293zM104 432C104 418.7 93.3 408 80 408S56 418.7 56 432 66.7 456 80 456 104 445.3 104 432z"}]}}),H.register({"x-ray":{width:640,height:512,paths:[{d:"M240 384C231.2 384 224 391.2 224 400S231.2 416 240 416 256 408.8 256 400 248.8 384 240 384zM400 416C408.8 416 416 408.8 416 400S408.8 384 400 384 384 391.2 384 400 391.2 416 400 416zM624 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H624C632.8 64 640 56.8 640 48V16C640 7.2 632.8 0 624 0zM624 448H576V96H64V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM480 248C480 252.4 476.4 256 472 256H336V288H440C444.4 288 448 291.6 448 296V312C448 316.4 444.4 320 440 320H336V352H400C426.5 352 448 373.5 448 400S426.5 448 400 448 352 426.5 352 400V384H288V400C288 426.5 266.5 448 240 448S192 426.5 192 400 213.5 352 240 352H304V320H200C195.6 320 192 316.4 192 312V296C192 291.6 195.6 288 200 288H304V256H168C163.6 256 160 252.4 160 248V232C160 227.6 163.6 224 168 224H304V192H200C195.6 192 192 188.4 192 184V168C192 163.6 195.6 160 200 160H304V136C304 131.6 307.6 128 312 128H328C332.4 128 336 131.6 336 136V160H440C444.4 160 448 163.6 448 168V184C448 188.4 444.4 192 440 192H336V224H472C476.4 224 480 227.6 480 232V248z"}]}}),H.register({"yen-sign":{width:384,height:512,paths:[{d:"M351.2 32H285.9A12-12 0 0 1 275.2 38.7L219.8 151.9C205.3 186.6 192.6 223.8 192.6 223.8H191.4S178.7 186.6 164.2 151.9L108.8 38.7A12-12 0 0 1 98.1 32H32.8C23.7 32 17.9 41.6 22.2 49.6L102.3 200H44C37.4 200 32 205.4 32 212V244C32 250.6 37.4 256 44 256H132.2L152 293.2V320H44C37.4 320 32 325.4 32 332V364C32 370.6 37.4 376 44 376H152V468C152 474.6 157.4 480 164 480H220C226.6 480 232 474.6 232 468V376H340C346.6 376 352 370.6 352 364V332C352 325.4 346.6 320 340 320H232V293.2L251.8 256H340C346.6 256 352 250.6 352 244V212C352 205.4 346.6 200 340 200H281.7L361.8 49.6C366.1 41.6 360.3 32 351.2 32z"}]}}),H});

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(476);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(120)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css", function() {
			var newContent = require("!!../css-loader/index.js!../postcss-loader/index.js!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(30)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}", ""]);

// exports


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios_mock_adapter__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios_mock_adapter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios_mock_adapter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_request__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__role__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__item__ = __webpack_require__(485);













__WEBPACK_IMPORTED_MODULE_7__api_request__["a" /* default */].interceptors.request.use(function (req) {
  var method = req.method.toUpperCase();
  var query = __WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(req.params || {}).map(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return encodeURIComponent(k) + '=' + encodeURIComponent(v);
  }).join('&');
  console.log('%c[Mock] %c' + method + ' %c' + req.url + (query ? '?' + query : ''), 'font-weight: bold; color: green', 'font-weight: bold', 'font-weight: normal; text-decoration: underline');
  if (method === 'POST' || method === 'PUT') {
    console.log('%c[Mock] %cREQUEST BODY', 'font-weight: bold; color: green', req.data);
  }
  return req;
});

__WEBPACK_IMPORTED_MODULE_7__api_request__["a" /* default */].interceptors.response.use(function (res) {
  console.log('%c[Mock] %cRESPONSE BODY', 'font-weight: bold; color: green', 'font-weight: bold', res);
  return res;
});

var getList = function getList(resource) {
  return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, resource.list, {
    list: [].concat(__WEBPACK_IMPORTED_MODULE_2__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_toConsumableArray___default()(resource.list.list.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_3__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_extends___default()({}, item);
    })))
  });
};

var getOne = function getOne(list, params) {
  return __WEBPACK_IMPORTED_MODULE_1__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_assign___default()({}, list.find(function (t) {
    if (!t) {
      return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5__Users_fjywan_code_sls_seed_node_modules_babel_runtime_core_js_object_entries___default()(params)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref3 = _step.value;

        var _ref4 = __WEBPACK_IMPORTED_MODULE_4__Users_fjywan_code_sls_seed_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

        var key = _ref4[0];
        var value = _ref4[1];

        // eslint-disable-line eqeqeq
        if (t[key] != value) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  }) || {});
};

var success = function success(data) {
  return { retcode: 0, message: 'Success', data: data };
};
var failed = function failed(data) {
  return { retcode: 1, message: 'Failed', data: data };
};

var server = new __WEBPACK_IMPORTED_MODULE_6_axios_mock_adapter___default.a(__WEBPACK_IMPORTED_MODULE_7__api_request__["a" /* default */]);

server.onGet('/api/user/list').reply(200, success(getList(__WEBPACK_IMPORTED_MODULE_8__user__["a" /* default */])));
server.onGet('/api/user/details').reply(function (c) {
  return [200, success(getOne(__WEBPACK_IMPORTED_MODULE_8__user__["a" /* default */].list.list, c.params))];
});

server.onGet('/api/role/list').reply(200, success(getList(__WEBPACK_IMPORTED_MODULE_9__role__["a" /* default */])));
server.onGet('/api/role/details').reply(function (c) {
  return [200, success(getOne(__WEBPACK_IMPORTED_MODULE_9__role__["a" /* default */].list.list, c.params))];
});

server.onGet('/api/item/list').reply(200, success(getList(__WEBPACK_IMPORTED_MODULE_10__item__["a" /* default */])));
server.onGet('/api/item/details').reply(function (c) {
  return [200, success(getOne(__WEBPACK_IMPORTED_MODULE_10__item__["a" /* default */].list.list, c.params))];
});

server.onAny().reply(200, function (c) {
  console.log('Unhandled url: ' + c.url);
  return success();
});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deepEqual = __webpack_require__(198);

var handleRequest = __webpack_require__(481);

var VERBS = ['get', 'post', 'head', 'delete', 'patch', 'put', 'options'];

function adapter() {
  return function(config) {
    var mockAdapter = this;
    // axios >= 0.13.0 only passes the config and expects a promise to be
    // returned. axios < 0.13.0 passes (config, resolve, reject).
    if (arguments.length === 3) {
      handleRequest(mockAdapter, arguments[0], arguments[1], arguments[2]);
    } else {
      return new Promise(function(resolve, reject) {
        handleRequest(mockAdapter, resolve, reject, config);
      });
    }
  }.bind(this);
}

function getVerbObject() {
  return VERBS.reduce(function(accumulator, verb) {
    accumulator[verb] = [];
    return accumulator;
  }, {});
}

function reset() {
  resetHandlers.call(this);
  resetHistory.call(this);
}

function resetHandlers() {
  this.handlers = getVerbObject();
}

function resetHistory() {
  this.history = getVerbObject();
}

function MockAdapter(axiosInstance, options) {
  reset.call(this);

  if (axiosInstance) {
    this.axiosInstance = axiosInstance;
    this.originalAdapter = axiosInstance.defaults.adapter;
    this.delayResponse = options && options.delayResponse > 0 ? options.delayResponse : null;
    axiosInstance.defaults.adapter = this.adapter.call(this);
  }
}

MockAdapter.prototype.adapter = adapter;

MockAdapter.prototype.restore = function restore() {
  if (this.axiosInstance) {
    this.axiosInstance.defaults.adapter = this.originalAdapter;
  }
};

MockAdapter.prototype.reset = reset;
MockAdapter.prototype.resetHandlers = resetHandlers;
MockAdapter.prototype.resetHistory = resetHistory;

VERBS.concat('any').forEach(function(method) {
  var methodName = 'on' + method.charAt(0).toUpperCase() + method.slice(1);
  MockAdapter.prototype[methodName] = function(matcher, body, requestHeaders) {
    var _this = this;
    var matcher = matcher === undefined ? /.*/ : matcher;

    function reply(code, response, headers) {
      var handler = [matcher, body, requestHeaders, code, response, headers];
      addHandler(method, _this.handlers, handler);
      return _this;
    }

    return {
      reply: reply,

      replyOnce: function replyOnce(code, response, headers) {
        var handler = [matcher, body, requestHeaders, code, response, headers, true];
        addHandler(method, _this.handlers, handler);
        return _this;
      },

      passThrough: function passThrough() {
        var handler = [matcher, body];
        addHandler(method, _this.handlers, handler);
        return _this;
      },

      networkError: function() {
        reply(function(config) {
          var error = new Error('Network Error');
          error.config = config;
          return Promise.reject(error);
        });
      },

      timeout: function() {
        reply(function(config) {
          var error = new Error('timeout of ' + config.timeout + 'ms exceeded');
          error.config = config;
          error.code = 'ECONNABORTED';
          return Promise.reject(error);
        });
      }
    };
  };
});

function findInHandlers(method, handlers, handler) {
  var index = -1;
  for (var i = 0; i < handlers[method].length; i += 1) {
    var item = handlers[method][i];
    var isReplyOnce = item.length === 7;
    var comparePaths = item[0] instanceof RegExp && handler[0] instanceof RegExp
      ? String(item[0]) === String(handler[0])
      : item[0] === handler[0];
    var isSame = (
      comparePaths &&
      deepEqual(item[1], handler[1], { strict: true }) &&
      deepEqual(item[2], handler[2], { strict: true })
    );
    if (isSame && !isReplyOnce) {
      index =  i;
    }
  }
  return index;
}

function addHandler(method, handlers, handler) {
  if (method === 'any') {
    VERBS.forEach(function(verb) {
      handlers[verb].push(handler);
    });
  } else {
    var indexOfExistingHandler = findInHandlers(method, handlers, handler);
    if (indexOfExistingHandler > -1 && handler.length < 7) {
      handlers[method].splice(indexOfExistingHandler, 1, handler);
    } else {
      handlers[method].push(handler);
    }
  }
}

module.exports = MockAdapter;
module.exports.default = MockAdapter;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 480 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(482);

function makeResponse(result, config) {
  return {
    status: result[0],
    data: utils.isSimpleObject(result[1]) ? JSON.parse(JSON.stringify(result[1])) : result[1],
    headers: result[2],
    config: config
  };
}

function handleRequest(mockAdapter, resolve, reject, config) {
  if (config.baseURL && config.url.substr(0, config.baseURL.length) === config.baseURL) {
    config.url = config.url.slice(config.baseURL ? config.baseURL.length : 0);
  }

  delete config.adapter;
  mockAdapter.history[config.method].push(config);

  var handler = utils.findHandler(
    mockAdapter.handlers,
    config.method,
    config.url,
    config.data,
    config.params,
    config.headers,
    config.baseURL
  );

  if (handler) {
    if (handler.length === 7) {
      utils.purgeIfReplyOnce(mockAdapter, handler);
    }

    if (handler.length === 2) {
      // passThrough handler
      // tell axios to use the original adapter instead of our mock, fixes #35
      config.adapter = mockAdapter.originalAdapter;
      mockAdapter.axiosInstance.request(config).then(resolve, reject);
    } else if (!(handler[3] instanceof Function)) {
      utils.settle(
        resolve,
        reject,
        makeResponse(handler.slice(3), config),
        mockAdapter.delayResponse
      );
    } else {
      var result = handler[3](config);
      // TODO throw a sane exception when return value is incorrect
      if (!(result.then instanceof Function)) {
        utils.settle(resolve, reject, makeResponse(result, config), mockAdapter.delayResponse);
      } else {
        result.then(
          function(result) {
            utils.settle(resolve, reject, makeResponse(result, config), mockAdapter.delayResponse);
          },
          function(error) {
            if (mockAdapter.delayResponse > 0) {
              setTimeout(function() {
                reject(error);
              }, mockAdapter.delayResponse);
            } else {
              reject(error);
            }
          }
        );
      }
    }
  } else {
    // handler not found
    utils.settle(
      resolve,
      reject,
      {
        status: 404,
        config: config
      },
      mockAdapter.delayResponse
    );
  }
}

module.exports = handleRequest;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var axios = __webpack_require__(157);
var deepEqual = __webpack_require__(198);

function isEqual(a, b) {
  return deepEqual(a, b, { strict: true });
}

// < 0.13.0 will not have default headers set on a custom instance
var rejectWithError = !!axios.create().defaults.headers;

function find(array, predicate) {
  var length = array.length;
  for (var i = 0; i < length; i++) {
    var value = array[i];
    if (predicate(value)) return value;
  }
}

function combineUrls(baseURL, url) {
  if (baseURL) {
    return baseURL.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
  }

  return url;
}

function findHandler(handlers, method, url, body, parameters, headers, baseURL) {
  return find(handlers[method.toLowerCase()], function(handler) {
    if (typeof handler[0] === 'string') {
      return (isUrlMatching(url, handler[0]) || isUrlMatching(combineUrls(baseURL, url), handler[0])) && isBodyOrParametersMatching(method, body, parameters, handler[1])  && isRequestHeadersMatching(headers, handler[2]);
    } else if (handler[0] instanceof RegExp) {
      return (handler[0].test(url) || handler[0].test(combineUrls(baseURL, url))) && isBodyOrParametersMatching(method, body, parameters, handler[1]) && isRequestHeadersMatching(headers, handler[2]);
    }
  });
}

function isUrlMatching(url, required) {
  var noSlashUrl = url[0] === '/' ? url.substr(1) : url;
  var noSlashRequired = required[0] === '/' ? required.substr(1) : required;
  return (noSlashUrl === noSlashRequired);
}

function isRequestHeadersMatching(requestHeaders, required) {
  if (required === undefined) return true;
  return isEqual(requestHeaders, required);
}

function isBodyOrParametersMatching(method, body, parameters, required) {
  var allowedParamsMethods = ['delete', 'get', 'head', 'options'];
  if (allowedParamsMethods.indexOf(method.toLowerCase()) >= 0 ) {
    var params = required ? required.params : undefined;
    return isParametersMatching(parameters, params);
  } else {
    return isBodyMatching(body, required);
  }
}

function isParametersMatching(parameters, required) {
  if (required === undefined) return true;

  return isEqual(parameters, required);
}

function isBodyMatching(body, requiredBody) {
  if (requiredBody === undefined) {
    return true;
  }
  var parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (e) { }
  return parsedBody ? isEqual(parsedBody, requiredBody) : isEqual(body, requiredBody);
}

function purgeIfReplyOnce(mock, handler) {
  Object.keys(mock.handlers).forEach(function(key) {
    var index = mock.handlers[key].indexOf(handler);
    if (index > -1) {
      mock.handlers[key].splice(index, 1);
    }
  });
}

function settle(resolve, reject, response, delay) {
  if (delay > 0) {
    setTimeout(function() {
      settle(resolve, reject, response);
    }, delay);
    return;
  }

  if (response.config && response.config.validateStatus) {
    response.config.validateStatus(response.status)
      ? resolve(response)
      : reject(createErrorResponse(
        'Request failed with status code ' + response.status,
        response.config,
        response
      ));
    return;
  }

  // Support for axios < 0.11
  if (response.status >= 200 && response.status < 300) {
    resolve(response);
  } else {
    reject(response);
  }
}

function createErrorResponse(message, config, response) {
  // Support for axios < 0.13.0
  if (!rejectWithError) return response;

  var error = new Error(message);
  error.config = config;
  error.response = response;
  return error;
}

function isSimpleObject(value) {
  return value !== null && value !== undefined && value.toString() === '[object Object]';
}

module.exports = {
  find: find,
  findHandler: findHandler,
  isSimpleObject: isSimpleObject,
  purgeIfReplyOnce: purgeIfReplyOnce,
  settle: settle
};


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var permission = {
  tree: [{
    id: 100,
    label: 'Lists',
    children: [{
      id: 110,
      label: 'Normal'
    }, {
      id: 120,
      label: 'Nested'
    }, {
      id: 130,
      label: 'Parallel'
    }]
  }]
};

var list = {
  total: 4,
  list: [{
    id: 1,
    email: 'a@example.com',
    phone: '16612345678',
    status: 0,
    flag: 1,
    ctime: 1.5e9,
    last_login: 1.5e9,
    role_list: [1, 2, 3, 4],
    role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
  }, {
    id: 2,
    email: 'b@example.com',
    phone: '16623456781',
    status: 0,
    flag: 1,
    ctime: 1.5e9,
    last_login: 1.5e9,
    role_list: [1, 2, 3, 4],
    role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
  }, {
    id: 3,
    email: 'c@example.com',
    phone: '16634567812',
    status: 1,
    flag: 1,
    ctime: 1.5e9,
    last_login: 1.5e9,
    role_list: [1, 2, 3, 4],
    role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
  }, {
    id: 4,
    email: 'd@example.com',
    phone: '16645678123',
    status: 0,
    flag: 0,
    ctime: 1.5e9,
    last_login: 1.5e9,
    role_list: [1, 2, 3, 4],
    role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({ permission: permission, list: list });

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = {
  total: 4,
  list: [{
    id: 1,
    status: 0,
    name: 'All Permission',
    permission_list: [100, 110, 120, 130],
    permission_name_list: ['Lists', 'Normal', 'Nested', 'Parallel'],
    ctime: 1.5e9,
    mtime: 1.5e9
  }, {
    id: 2,
    status: 0,
    name: 'Normal',
    permission_list: [100, 110],
    permission_name_list: ['Lists', 'Normal'],
    ctime: 1.5e9,
    mtime: 1.5e9
  }, {
    id: 3,
    status: 0,
    name: 'Nested',
    permission_list: [100, 120],
    permission_name_list: ['Lists', 'Nested'],
    ctime: 1.5e9,
    mtime: 1.5e9
  }, {
    id: 4,
    status: 0,
    name: 'Parallel',
    permission_list: [100, 130],
    permission_name_list: ['Lists', 'Parallel'],
    ctime: 1.5e9,
    mtime: 1.5e9
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({ list: list });

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = {
  total: 4,
  list: [{
    id: 1,
    a: 1,
    b: 5,
    c: 6,
    country: 'china',
    province: 'guangzhou',
    city: 'shenzhen'
  }, {
    id: 2,
    a: 4,
    b: 7,
    c: 11,
    country: 'china',
    province: 'shandong',
    city: 'jinan'
  }, {
    id: 3,
    a: 2,
    b: 3,
    c: 5,
    country: 'japan',
    province: 'fukushima',
    city: 'fukushima-shi'
  }, {
    id: 4,
    a: 10,
    b: 2,
    c: 12,
    country: 'china',
    province: 'guangzhou',
    city: 'shenzhen'
  }, {
    id: 5,
    a: 8,
    b: 3,
    c: 11,
    country: 'japan',
    province: 'kumamoto',
    city: 'yatsushiro-shi'
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({ list: list });

/***/ })
],[199]);


// WEBPACK FOOTER //
// index.js?5a45aa1df6c6d4b42438